var nhe = Object.defineProperty;
var rhe = (e, t, n) => t in e ? nhe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Un = (e, t, n) => rhe(e, typeof t != "symbol" ? t + "" : t, n);
import * as $ from "react";
import it, { createContext as hg, forwardRef as YA, useContext as Qi, Component as vJ, createElement as Ou, PureComponent as oU, useState as Bn, useEffect as ln, useMemo as Ui, useRef as an, useCallback as Yn, isValidElement as X0, cloneElement as jd, Children as aU, createRef as yJ, useId as uo, useInsertionEffect as ihe, useLayoutEffect as bJ, memo as ohe, Suspense as sU, lazy as gg, Fragment as L2, useReducer as ahe } from "react";
import * as she from "react-dom";
import Pd, { unstable_batchedUpdates as lhe, flushSync as xJ } from "react-dom";
import { useTranslation as Ct, initReactI18next as che, I18nextProvider as uhe, withTranslation as XA } from "react-i18next";
import { useTranslation as Xmt, withTranslation as Zmt } from "react-i18next";
import { unstable_createGetCssVar as dhe, createSpacing as fhe, useTheme as phe, GlobalStyles as hhe, unstable_memoTheme as ghe, ThemeProvider as mhe, unstable_createCssVarsProvider as vhe, keyframes as Hv, css as ZA, shouldForwardProp as yhe, alpha as _u, StyledEngineProvider as bhe, createBox as xhe, unstable_resolveBreakpointValues as KA, handleBreakpoints as lU, createStack as She, darken as whe, lighten as The } from "@mui/system";
import Ehe from "@emotion/styled";
import { ThemeContext as _he, CacheProvider as Che } from "@emotion/react";
import $4 from "video.js";
import { createTheme as Rhe, ThemeProvider as Ohe, Dialog as cU, DialogTitle as uU, Typography as Zh, Button as G4, Link as Ahe, Chip as Y4, MenuList as tA, MenuItem as JE, DialogActions as dU, DialogContent as Dhe, ListItemIcon as Ihe, ListItemText as Phe, DialogContentText as Nhe, Card as X4, CardContent as Z4, TextField as Mhe } from "@mui/material";
var TR = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Hn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function SJ(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var ER = { exports: {} }, GT = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var K4;
function jhe() {
  if (K4) return GT;
  K4 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, o) {
    var s = null;
    if (o !== void 0 && (s = "" + o), i.key !== void 0 && (s = "" + i.key), "key" in i) {
      o = {};
      for (var u in i)
        u !== "key" && (o[u] = i[u]);
    } else o = i;
    return i = o.ref, {
      $$typeof: e,
      type: r,
      key: s,
      ref: i !== void 0 ? i : null,
      props: o
    };
  }
  return GT.Fragment = t, GT.jsx = n, GT.jsxs = n, GT;
}
var YT = {}, Q4;
function Lhe() {
  if (Q4) return YT;
  Q4 = 1;
  var e = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(ne) {
      if (ne == null) return null;
      if (typeof ne == "function")
        return ne.$$typeof === V ? null : ne.displayName || ne.name || null;
      if (typeof ne == "string") return ne;
      switch (ne) {
        case _:
          return "Fragment";
        case D:
          return "Profiler";
        case O:
          return "StrictMode";
        case k:
          return "Suspense";
        case U:
          return "SuspenseList";
        case z:
          return "Activity";
      }
      if (typeof ne == "object")
        switch (typeof ne.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), ne.$$typeof) {
          case w:
            return "Portal";
          case M:
            return (ne.displayName || "Context") + ".Provider";
          case P:
            return (ne._context.displayName || "Context") + ".Consumer";
          case N:
            var ae = ne.render;
            return ne = ne.displayName, ne || (ne = ae.displayName || ae.name || "", ne = ne !== "" ? "ForwardRef(" + ne + ")" : "ForwardRef"), ne;
          case H:
            return ae = ne.displayName || null, ae !== null ? ae : t(ne.type) || "Memo";
          case Y:
            ae = ne._payload, ne = ne._init;
            try {
              return t(ne(ae));
            } catch {
            }
        }
      return null;
    }
    function n(ne) {
      return "" + ne;
    }
    function r(ne) {
      try {
        n(ne);
        var ae = !1;
      } catch {
        ae = !0;
      }
      if (ae) {
        ae = console;
        var ie = ae.error, he = typeof Symbol == "function" && Symbol.toStringTag && ne[Symbol.toStringTag] || ne.constructor.name || "Object";
        return ie.call(
          ae,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          he
        ), n(ne);
      }
    }
    function i(ne) {
      if (ne === _) return "<>";
      if (typeof ne == "object" && ne !== null && ne.$$typeof === Y)
        return "<...>";
      try {
        var ae = t(ne);
        return ae ? "<" + ae + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var ne = F.A;
      return ne === null ? null : ne.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function u(ne) {
      if (X.call(ne, "key")) {
        var ae = Object.getOwnPropertyDescriptor(ne, "key").get;
        if (ae && ae.isReactWarning) return !1;
      }
      return ne.key !== void 0;
    }
    function f(ne, ae) {
      function ie() {
        Z || (Z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          ae
        ));
      }
      ie.isReactWarning = !0, Object.defineProperty(ne, "key", {
        get: ie,
        configurable: !0
      });
    }
    function p() {
      var ne = t(this.type);
      return ee[ne] || (ee[ne] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), ne = this.props.ref, ne !== void 0 ? ne : null;
    }
    function m(ne, ae, ie, he, pe, me, Ee, Ie) {
      return ie = me.ref, ne = {
        $$typeof: E,
        type: ne,
        key: ae,
        props: me,
        _owner: pe
      }, (ie !== void 0 ? ie : null) !== null ? Object.defineProperty(ne, "ref", {
        enumerable: !1,
        get: p
      }) : Object.defineProperty(ne, "ref", { enumerable: !1, value: null }), ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(ne, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(ne, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ee
      }), Object.defineProperty(ne, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ie
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    }
    function v(ne, ae, ie, he, pe, me, Ee, Ie) {
      var Pe = ae.children;
      if (Pe !== void 0)
        if (he)
          if (oe(Pe)) {
            for (he = 0; he < Pe.length; he++)
              y(Pe[he]);
            Object.freeze && Object.freeze(Pe);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else y(Pe);
      if (X.call(ae, "key")) {
        Pe = t(ne);
        var De = Object.keys(ae).filter(function(Ue) {
          return Ue !== "key";
        });
        he = 0 < De.length ? "{key: someKey, " + De.join(": ..., ") + ": ...}" : "{key: someKey}", be[Pe + he] || (De = 0 < De.length ? "{" + De.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          he,
          Pe,
          De,
          Pe
        ), be[Pe + he] = !0);
      }
      if (Pe = null, ie !== void 0 && (r(ie), Pe = "" + ie), u(ae) && (r(ae.key), Pe = "" + ae.key), "key" in ae) {
        ie = {};
        for (var Ye in ae)
          Ye !== "key" && (ie[Ye] = ae[Ye]);
      } else ie = ae;
      return Pe && f(
        ie,
        typeof ne == "function" ? ne.displayName || ne.name || "Unknown" : ne
      ), m(
        ne,
        Pe,
        me,
        pe,
        o(),
        ie,
        Ee,
        Ie
      );
    }
    function y(ne) {
      typeof ne == "object" && ne !== null && ne.$$typeof === E && ne._store && (ne._store.validated = 1);
    }
    var S = it, E = Symbol.for("react.transitional.element"), w = Symbol.for("react.portal"), _ = Symbol.for("react.fragment"), O = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), P = Symbol.for("react.consumer"), M = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), U = Symbol.for("react.suspense_list"), H = Symbol.for("react.memo"), Y = Symbol.for("react.lazy"), z = Symbol.for("react.activity"), V = Symbol.for("react.client.reference"), F = S.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = Object.prototype.hasOwnProperty, oe = Array.isArray, re = console.createTask ? console.createTask : function() {
      return null;
    };
    S = {
      react_stack_bottom_frame: function(ne) {
        return ne();
      }
    };
    var Z, ee = {}, J = S.react_stack_bottom_frame.bind(
      S,
      s
    )(), le = re(i(s)), be = {};
    YT.Fragment = _, YT.jsx = function(ne, ae, ie, he, pe) {
      var me = 1e4 > F.recentlyCreatedOwnerStacks++;
      return v(
        ne,
        ae,
        ie,
        !1,
        he,
        pe,
        me ? Error("react-stack-top-frame") : J,
        me ? re(i(ne)) : le
      );
    }, YT.jsxs = function(ne, ae, ie, he, pe) {
      var me = 1e4 > F.recentlyCreatedOwnerStacks++;
      return v(
        ne,
        ae,
        ie,
        !0,
        he,
        pe,
        me ? Error("react-stack-top-frame") : J,
        me ? re(i(ne)) : le
      );
    };
  })(), YT;
}
var J4;
function khe() {
  if (J4) return ER.exports;
  J4 = 1;
  var e = {};
  return e.NODE_ENV === "production" ? ER.exports = jhe() : ER.exports = Lhe(), ER.exports;
}
var T = khe(), _R = { exports: {} }, XT = {}, CR = { exports: {} }, UN = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eq;
function zhe() {
  return eq || (eq = 1, (function(e) {
    function t(Z, ee) {
      var J = Z.length;
      Z.push(ee);
      e: for (; 0 < J; ) {
        var le = J - 1 >>> 1, be = Z[le];
        if (0 < i(be, ee))
          Z[le] = ee, Z[J] = be, J = le;
        else break e;
      }
    }
    function n(Z) {
      return Z.length === 0 ? null : Z[0];
    }
    function r(Z) {
      if (Z.length === 0) return null;
      var ee = Z[0], J = Z.pop();
      if (J !== ee) {
        Z[0] = J;
        e: for (var le = 0, be = Z.length, ne = be >>> 1; le < ne; ) {
          var ae = 2 * (le + 1) - 1, ie = Z[ae], he = ae + 1, pe = Z[he];
          if (0 > i(ie, J))
            he < be && 0 > i(pe, ie) ? (Z[le] = pe, Z[he] = J, le = he) : (Z[le] = ie, Z[ae] = J, le = ae);
          else if (he < be && 0 > i(pe, J))
            Z[le] = pe, Z[he] = J, le = he;
          else break e;
        }
      }
      return ee;
    }
    function i(Z, ee) {
      var J = Z.sortIndex - ee.sortIndex;
      return J !== 0 ? J : Z.id - ee.id;
    }
    if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var o = performance;
      e.unstable_now = function() {
        return o.now();
      };
    } else {
      var s = Date, u = s.now();
      e.unstable_now = function() {
        return s.now() - u;
      };
    }
    var f = [], p = [], m = 1, v = null, y = 3, S = !1, E = !1, w = !1, _ = !1, O = typeof setTimeout == "function" ? setTimeout : null, D = typeof clearTimeout == "function" ? clearTimeout : null, P = typeof setImmediate < "u" ? setImmediate : null;
    function M(Z) {
      for (var ee = n(p); ee !== null; ) {
        if (ee.callback === null) r(p);
        else if (ee.startTime <= Z)
          r(p), ee.sortIndex = ee.expirationTime, t(f, ee);
        else break;
        ee = n(p);
      }
    }
    function N(Z) {
      if (w = !1, M(Z), !E)
        if (n(f) !== null)
          E = !0, k || (k = !0, F());
        else {
          var ee = n(p);
          ee !== null && re(N, ee.startTime - Z);
        }
    }
    var k = !1, U = -1, H = 5, Y = -1;
    function z() {
      return _ ? !0 : !(e.unstable_now() - Y < H);
    }
    function V() {
      if (_ = !1, k) {
        var Z = e.unstable_now();
        Y = Z;
        var ee = !0;
        try {
          e: {
            E = !1, w && (w = !1, D(U), U = -1), S = !0;
            var J = y;
            try {
              t: {
                for (M(Z), v = n(f); v !== null && !(v.expirationTime > Z && z()); ) {
                  var le = v.callback;
                  if (typeof le == "function") {
                    v.callback = null, y = v.priorityLevel;
                    var be = le(
                      v.expirationTime <= Z
                    );
                    if (Z = e.unstable_now(), typeof be == "function") {
                      v.callback = be, M(Z), ee = !0;
                      break t;
                    }
                    v === n(f) && r(f), M(Z);
                  } else r(f);
                  v = n(f);
                }
                if (v !== null) ee = !0;
                else {
                  var ne = n(p);
                  ne !== null && re(
                    N,
                    ne.startTime - Z
                  ), ee = !1;
                }
              }
              break e;
            } finally {
              v = null, y = J, S = !1;
            }
            ee = void 0;
          }
        } finally {
          ee ? F() : k = !1;
        }
      }
    }
    var F;
    if (typeof P == "function")
      F = function() {
        P(V);
      };
    else if (typeof MessageChannel < "u") {
      var X = new MessageChannel(), oe = X.port2;
      X.port1.onmessage = V, F = function() {
        oe.postMessage(null);
      };
    } else
      F = function() {
        O(V, 0);
      };
    function re(Z, ee) {
      U = O(function() {
        Z(e.unstable_now());
      }, ee);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(Z) {
      Z.callback = null;
    }, e.unstable_forceFrameRate = function(Z) {
      0 > Z || 125 < Z ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : H = 0 < Z ? Math.floor(1e3 / Z) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return y;
    }, e.unstable_next = function(Z) {
      switch (y) {
        case 1:
        case 2:
        case 3:
          var ee = 3;
          break;
        default:
          ee = y;
      }
      var J = y;
      y = ee;
      try {
        return Z();
      } finally {
        y = J;
      }
    }, e.unstable_requestPaint = function() {
      _ = !0;
    }, e.unstable_runWithPriority = function(Z, ee) {
      switch (Z) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Z = 3;
      }
      var J = y;
      y = Z;
      try {
        return ee();
      } finally {
        y = J;
      }
    }, e.unstable_scheduleCallback = function(Z, ee, J) {
      var le = e.unstable_now();
      switch (typeof J == "object" && J !== null ? (J = J.delay, J = typeof J == "number" && 0 < J ? le + J : le) : J = le, Z) {
        case 1:
          var be = -1;
          break;
        case 2:
          be = 250;
          break;
        case 5:
          be = 1073741823;
          break;
        case 4:
          be = 1e4;
          break;
        default:
          be = 5e3;
      }
      return be = J + be, Z = {
        id: m++,
        callback: ee,
        priorityLevel: Z,
        startTime: J,
        expirationTime: be,
        sortIndex: -1
      }, J > le ? (Z.sortIndex = J, t(p, Z), n(f) === null && Z === n(p) && (w ? (D(U), U = -1) : w = !0, re(N, J - le))) : (Z.sortIndex = be, t(f, Z), E || S || (E = !0, k || (k = !0, F()))), Z;
    }, e.unstable_shouldYield = z, e.unstable_wrapCallback = function(Z) {
      var ee = y;
      return function() {
        var J = y;
        y = ee;
        try {
          return Z.apply(this, arguments);
        } finally {
          y = J;
        }
      };
    };
  })(UN)), UN;
}
var FN = {}, tq;
function Bhe() {
  return tq || (tq = 1, (function(e) {
    var t = {};
    /**
     * @license React
     * scheduler.development.js
     *
     * Copyright (c) Meta Platforms, Inc. and affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    t.NODE_ENV !== "production" && (function() {
      function n() {
        if (k = !1, z) {
          var ee = e.unstable_now();
          X = ee;
          var J = !0;
          try {
            e: {
              M = !1, N && (N = !1, H(V), V = -1), P = !0;
              var le = D;
              try {
                t: {
                  for (u(ee), O = i(E); O !== null && !(O.expirationTime > ee && p()); ) {
                    var be = O.callback;
                    if (typeof be == "function") {
                      O.callback = null, D = O.priorityLevel;
                      var ne = be(
                        O.expirationTime <= ee
                      );
                      if (ee = e.unstable_now(), typeof ne == "function") {
                        O.callback = ne, u(ee), J = !0;
                        break t;
                      }
                      O === i(E) && o(E), u(ee);
                    } else o(E);
                    O = i(E);
                  }
                  if (O !== null) J = !0;
                  else {
                    var ae = i(w);
                    ae !== null && m(
                      f,
                      ae.startTime - ee
                    ), J = !1;
                  }
                }
                break e;
              } finally {
                O = null, D = le, P = !1;
              }
              J = void 0;
            }
          } finally {
            J ? oe() : z = !1;
          }
        }
      }
      function r(ee, J) {
        var le = ee.length;
        ee.push(J);
        e: for (; 0 < le; ) {
          var be = le - 1 >>> 1, ne = ee[be];
          if (0 < s(ne, J))
            ee[be] = J, ee[le] = ne, le = be;
          else break e;
        }
      }
      function i(ee) {
        return ee.length === 0 ? null : ee[0];
      }
      function o(ee) {
        if (ee.length === 0) return null;
        var J = ee[0], le = ee.pop();
        if (le !== J) {
          ee[0] = le;
          e: for (var be = 0, ne = ee.length, ae = ne >>> 1; be < ae; ) {
            var ie = 2 * (be + 1) - 1, he = ee[ie], pe = ie + 1, me = ee[pe];
            if (0 > s(he, le))
              pe < ne && 0 > s(me, he) ? (ee[be] = me, ee[pe] = le, be = pe) : (ee[be] = he, ee[ie] = le, be = ie);
            else if (pe < ne && 0 > s(me, le))
              ee[be] = me, ee[pe] = le, be = pe;
            else break e;
          }
        }
        return J;
      }
      function s(ee, J) {
        var le = ee.sortIndex - J.sortIndex;
        return le !== 0 ? le : ee.id - J.id;
      }
      function u(ee) {
        for (var J = i(w); J !== null; ) {
          if (J.callback === null) o(w);
          else if (J.startTime <= ee)
            o(w), J.sortIndex = J.expirationTime, r(E, J);
          else break;
          J = i(w);
        }
      }
      function f(ee) {
        if (N = !1, u(ee), !M)
          if (i(E) !== null)
            M = !0, z || (z = !0, oe());
          else {
            var J = i(w);
            J !== null && m(
              f,
              J.startTime - ee
            );
          }
      }
      function p() {
        return k ? !0 : !(e.unstable_now() - X < F);
      }
      function m(ee, J) {
        V = U(function() {
          ee(e.unstable_now());
        }, J);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var v = performance;
        e.unstable_now = function() {
          return v.now();
        };
      } else {
        var y = Date, S = y.now();
        e.unstable_now = function() {
          return y.now() - S;
        };
      }
      var E = [], w = [], _ = 1, O = null, D = 3, P = !1, M = !1, N = !1, k = !1, U = typeof setTimeout == "function" ? setTimeout : null, H = typeof clearTimeout == "function" ? clearTimeout : null, Y = typeof setImmediate < "u" ? setImmediate : null, z = !1, V = -1, F = 5, X = -1;
      if (typeof Y == "function")
        var oe = function() {
          Y(n);
        };
      else if (typeof MessageChannel < "u") {
        var re = new MessageChannel(), Z = re.port2;
        re.port1.onmessage = n, oe = function() {
          Z.postMessage(null);
        };
      } else
        oe = function() {
          U(n, 0);
        };
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(ee) {
        ee.callback = null;
      }, e.unstable_forceFrameRate = function(ee) {
        0 > ee || 125 < ee ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : F = 0 < ee ? Math.floor(1e3 / ee) : 5;
      }, e.unstable_getCurrentPriorityLevel = function() {
        return D;
      }, e.unstable_next = function(ee) {
        switch (D) {
          case 1:
          case 2:
          case 3:
            var J = 3;
            break;
          default:
            J = D;
        }
        var le = D;
        D = J;
        try {
          return ee();
        } finally {
          D = le;
        }
      }, e.unstable_requestPaint = function() {
        k = !0;
      }, e.unstable_runWithPriority = function(ee, J) {
        switch (ee) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            ee = 3;
        }
        var le = D;
        D = ee;
        try {
          return J();
        } finally {
          D = le;
        }
      }, e.unstable_scheduleCallback = function(ee, J, le) {
        var be = e.unstable_now();
        switch (typeof le == "object" && le !== null ? (le = le.delay, le = typeof le == "number" && 0 < le ? be + le : be) : le = be, ee) {
          case 1:
            var ne = -1;
            break;
          case 2:
            ne = 250;
            break;
          case 5:
            ne = 1073741823;
            break;
          case 4:
            ne = 1e4;
            break;
          default:
            ne = 5e3;
        }
        return ne = le + ne, ee = {
          id: _++,
          callback: J,
          priorityLevel: ee,
          startTime: le,
          expirationTime: ne,
          sortIndex: -1
        }, le > be ? (ee.sortIndex = le, r(w, ee), i(E) === null && ee === i(w) && (N ? (H(V), V = -1) : N = !0, m(f, le - be))) : (ee.sortIndex = ne, r(E, ee), M || P || (M = !0, z || (z = !0, oe()))), ee;
      }, e.unstable_shouldYield = p, e.unstable_wrapCallback = function(ee) {
        var J = D;
        return function() {
          var le = D;
          D = J;
          try {
            return ee.apply(this, arguments);
          } finally {
            D = le;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(FN)), FN;
}
var nq;
function wJ() {
  if (nq) return CR.exports;
  nq = 1;
  var e = {};
  return e.NODE_ENV === "production" ? CR.exports = zhe() : CR.exports = Bhe(), CR.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rq;
function Vhe() {
  if (rq) return XT;
  rq = 1;
  var e = wJ(), t = it, n = Pd;
  function r(d) {
    var g = "https://react.dev/errors/" + d;
    if (1 < arguments.length) {
      g += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var b = 2; b < arguments.length; b++)
        g += "&args[]=" + encodeURIComponent(arguments[b]);
    }
    return "Minified React error #" + d + "; visit " + g + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function i(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11);
  }
  function o(d) {
    var g = d, b = d;
    if (d.alternate) for (; g.return; ) g = g.return;
    else {
      d = g;
      do
        g = d, (g.flags & 4098) !== 0 && (b = g.return), d = g.return;
      while (d);
    }
    return g.tag === 3 ? b : null;
  }
  function s(d) {
    if (d.tag === 13) {
      var g = d.memoizedState;
      if (g === null && (d = d.alternate, d !== null && (g = d.memoizedState)), g !== null) return g.dehydrated;
    }
    return null;
  }
  function u(d) {
    if (o(d) !== d)
      throw Error(r(188));
  }
  function f(d) {
    var g = d.alternate;
    if (!g) {
      if (g = o(d), g === null) throw Error(r(188));
      return g !== d ? null : d;
    }
    for (var b = d, C = g; ; ) {
      var I = b.return;
      if (I === null) break;
      var j = I.alternate;
      if (j === null) {
        if (C = I.return, C !== null) {
          b = C;
          continue;
        }
        break;
      }
      if (I.child === j.child) {
        for (j = I.child; j; ) {
          if (j === b) return u(I), d;
          if (j === C) return u(I), g;
          j = j.sibling;
        }
        throw Error(r(188));
      }
      if (b.return !== C.return) b = I, C = j;
      else {
        for (var K = !1, se = I.child; se; ) {
          if (se === b) {
            K = !0, b = I, C = j;
            break;
          }
          if (se === C) {
            K = !0, C = I, b = j;
            break;
          }
          se = se.sibling;
        }
        if (!K) {
          for (se = j.child; se; ) {
            if (se === b) {
              K = !0, b = j, C = I;
              break;
            }
            if (se === C) {
              K = !0, C = j, b = I;
              break;
            }
            se = se.sibling;
          }
          if (!K) throw Error(r(189));
        }
      }
      if (b.alternate !== C) throw Error(r(190));
    }
    if (b.tag !== 3) throw Error(r(188));
    return b.stateNode.current === b ? d : g;
  }
  function p(d) {
    var g = d.tag;
    if (g === 5 || g === 26 || g === 27 || g === 6) return d;
    for (d = d.child; d !== null; ) {
      if (g = p(d), g !== null) return g;
      d = d.sibling;
    }
    return null;
  }
  var m = Object.assign, v = Symbol.for("react.element"), y = Symbol.for("react.transitional.element"), S = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), _ = Symbol.for("react.profiler"), O = Symbol.for("react.provider"), D = Symbol.for("react.consumer"), P = Symbol.for("react.context"), M = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), U = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), Y = Symbol.for("react.activity"), z = Symbol.for("react.memo_cache_sentinel"), V = Symbol.iterator;
  function F(d) {
    return d === null || typeof d != "object" ? null : (d = V && d[V] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var X = Symbol.for("react.client.reference");
  function oe(d) {
    if (d == null) return null;
    if (typeof d == "function")
      return d.$$typeof === X ? null : d.displayName || d.name || null;
    if (typeof d == "string") return d;
    switch (d) {
      case E:
        return "Fragment";
      case _:
        return "Profiler";
      case w:
        return "StrictMode";
      case N:
        return "Suspense";
      case k:
        return "SuspenseList";
      case Y:
        return "Activity";
    }
    if (typeof d == "object")
      switch (d.$$typeof) {
        case S:
          return "Portal";
        case P:
          return (d.displayName || "Context") + ".Provider";
        case D:
          return (d._context.displayName || "Context") + ".Consumer";
        case M:
          var g = d.render;
          return d = d.displayName, d || (d = g.displayName || g.name || "", d = d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef"), d;
        case U:
          return g = d.displayName || null, g !== null ? g : oe(d.type) || "Memo";
        case H:
          g = d._payload, d = d._init;
          try {
            return oe(d(g));
          } catch {
          }
      }
    return null;
  }
  var re = Array.isArray, Z = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ee = n.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, J = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, le = [], be = -1;
  function ne(d) {
    return { current: d };
  }
  function ae(d) {
    0 > be || (d.current = le[be], le[be] = null, be--);
  }
  function ie(d, g) {
    be++, le[be] = d.current, d.current = g;
  }
  var he = ne(null), pe = ne(null), me = ne(null), Ee = ne(null);
  function Ie(d, g) {
    switch (ie(me, g), ie(pe, d), ie(he, null), g.nodeType) {
      case 9:
      case 11:
        d = (d = g.documentElement) && (d = d.namespaceURI) ? Xl(d) : 0;
        break;
      default:
        if (d = g.tagName, g = g.namespaceURI)
          g = Xl(g), d = fu(g, d);
        else
          switch (d) {
            case "svg":
              d = 1;
              break;
            case "math":
              d = 2;
              break;
            default:
              d = 0;
          }
    }
    ae(he), ie(he, d);
  }
  function Pe() {
    ae(he), ae(pe), ae(me);
  }
  function De(d) {
    d.memoizedState !== null && ie(Ee, d);
    var g = he.current, b = fu(g, d.type);
    g !== b && (ie(pe, d), ie(he, b));
  }
  function Ye(d) {
    pe.current === d && (ae(he), ae(pe)), Ee.current === d && (ae(Ee), To._currentValue = J);
  }
  var Ue = Object.prototype.hasOwnProperty, ve = e.unstable_scheduleCallback, rt = e.unstable_cancelCallback, Te = e.unstable_shouldYield, Je = e.unstable_requestPaint, L = e.unstable_now, te = e.unstable_getCurrentPriorityLevel, ge = e.unstable_ImmediatePriority, ke = e.unstable_UserBlockingPriority, We = e.unstable_NormalPriority, Be = e.unstable_LowPriority, je = e.unstable_IdlePriority, mt = e.log, qe = e.unstable_setDisableYieldValue, at = null, et = null;
  function bt(d) {
    if (typeof mt == "function" && qe(d), et && typeof et.setStrictMode == "function")
      try {
        et.setStrictMode(at, d);
      } catch {
      }
  }
  var q = Math.clz32 ? Math.clz32 : ce, W = Math.log, Q = Math.LN2;
  function ce(d) {
    return d >>>= 0, d === 0 ? 32 : 31 - (W(d) / Q | 0) | 0;
  }
  var _e = 256, Fe = 4194304;
  function gt(d) {
    var g = d & 42;
    if (g !== 0) return g;
    switch (d & -d) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return d & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return d & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return d;
    }
  }
  function ct(d, g, b) {
    var C = d.pendingLanes;
    if (C === 0) return 0;
    var I = 0, j = d.suspendedLanes, K = d.pingedLanes;
    d = d.warmLanes;
    var se = C & 134217727;
    return se !== 0 ? (C = se & ~j, C !== 0 ? I = gt(C) : (K &= se, K !== 0 ? I = gt(K) : b || (b = se & ~d, b !== 0 && (I = gt(b))))) : (se = C & ~j, se !== 0 ? I = gt(se) : K !== 0 ? I = gt(K) : b || (b = C & ~d, b !== 0 && (I = gt(b)))), I === 0 ? 0 : g !== 0 && g !== I && (g & j) === 0 && (j = I & -I, b = g & -g, j >= b || j === 32 && (b & 4194048) !== 0) ? g : I;
  }
  function ht(d, g) {
    return (d.pendingLanes & ~(d.suspendedLanes & ~d.pingedLanes) & g) === 0;
  }
  function Yt(d, g) {
    switch (d) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return g + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return g + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Rt() {
    var d = _e;
    return _e <<= 1, (_e & 4194048) === 0 && (_e = 256), d;
  }
  function cn() {
    var d = Fe;
    return Fe <<= 1, (Fe & 62914560) === 0 && (Fe = 4194304), d;
  }
  function Kt(d) {
    for (var g = [], b = 0; 31 > b; b++) g.push(d);
    return g;
  }
  function Zt(d, g) {
    d.pendingLanes |= g, g !== 268435456 && (d.suspendedLanes = 0, d.pingedLanes = 0, d.warmLanes = 0);
  }
  function dn(d, g, b, C, I, j) {
    var K = d.pendingLanes;
    d.pendingLanes = b, d.suspendedLanes = 0, d.pingedLanes = 0, d.warmLanes = 0, d.expiredLanes &= b, d.entangledLanes &= b, d.errorRecoveryDisabledLanes &= b, d.shellSuspendCounter = 0;
    var se = d.entanglements, xe = d.expirationTimes, ze = d.hiddenUpdates;
    for (b = K & ~b; 0 < b; ) {
      var ut = 31 - q(b), pt = 1 << ut;
      se[ut] = 0, xe[ut] = -1;
      var He = ze[ut];
      if (He !== null)
        for (ze[ut] = null, ut = 0; ut < He.length; ut++) {
          var Ze = He[ut];
          Ze !== null && (Ze.lane &= -536870913);
        }
      b &= ~pt;
    }
    C !== 0 && xr(d, C, 0), j !== 0 && I === 0 && d.tag !== 0 && (d.suspendedLanes |= j & ~(K & ~g));
  }
  function xr(d, g, b) {
    d.pendingLanes |= g, d.suspendedLanes &= ~g;
    var C = 31 - q(g);
    d.entangledLanes |= g, d.entanglements[C] = d.entanglements[C] | 1073741824 | b & 4194090;
  }
  function Hr(d, g) {
    var b = d.entangledLanes |= g;
    for (d = d.entanglements; b; ) {
      var C = 31 - q(b), I = 1 << C;
      I & g | d[C] & g && (d[C] |= g), b &= ~I;
    }
  }
  function jr(d) {
    switch (d) {
      case 2:
        d = 1;
        break;
      case 8:
        d = 4;
        break;
      case 32:
        d = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        d = 128;
        break;
      case 268435456:
        d = 134217728;
        break;
      default:
        d = 0;
    }
    return d;
  }
  function Ut(d) {
    return d &= -d, 2 < d ? 8 < d ? (d & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function ei() {
    var d = ee.p;
    return d !== 0 ? d : (d = window.event, d === void 0 ? 32 : zC(d.type));
  }
  function It(d, g) {
    var b = ee.p;
    try {
      return ee.p = d, g();
    } finally {
      ee.p = b;
    }
  }
  var Et = Math.random().toString(36).slice(2), jt = "__reactFiber$" + Et, Jt = "__reactProps$" + Et, Nn = "__reactContainer$" + Et, Ai = "__reactEvents$" + Et, ho = "__reactListeners$" + Et, gi = "__reactHandles$" + Et, go = "__reactResources$" + Et, gr = "__reactMarker$" + Et;
  function _t(d) {
    delete d[jt], delete d[Jt], delete d[Ai], delete d[ho], delete d[gi];
  }
  function mi(d) {
    var g = d[jt];
    if (g) return g;
    for (var b = d.parentNode; b; ) {
      if (g = b[Nn] || b[jt]) {
        if (b = g.alternate, g.child !== null || b !== null && b.child !== null)
          for (d = Mf(d); d !== null; ) {
            if (b = d[jt]) return b;
            d = Mf(d);
          }
        return g;
      }
      d = b, b = d.parentNode;
    }
    return null;
  }
  function ti(d) {
    if (d = d[jt] || d[Nn]) {
      var g = d.tag;
      if (g === 5 || g === 6 || g === 13 || g === 26 || g === 27 || g === 3)
        return d;
    }
    return null;
  }
  function Le(d) {
    var g = d.tag;
    if (g === 5 || g === 26 || g === 27 || g === 6) return d.stateNode;
    throw Error(r(33));
  }
  function de(d) {
    var g = d[go];
    return g || (g = d[go] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), g;
  }
  function Ne(d) {
    d[gr] = !0;
  }
  var vt = /* @__PURE__ */ new Set(), kt = {};
  function zt(d, g) {
    fn(d, g), fn(d + "Capture", g);
  }
  function fn(d, g) {
    for (kt[d] = g, d = 0; d < g.length; d++)
      vt.add(g[d]);
  }
  var Xn = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), mo = {}, ys = {};
  function Di(d) {
    return Ue.call(ys, d) ? !0 : Ue.call(mo, d) ? !1 : Xn.test(d) ? ys[d] = !0 : (mo[d] = !0, !1);
  }
  function qa(d, g, b) {
    if (Di(g))
      if (b === null) d.removeAttribute(g);
      else {
        switch (typeof b) {
          case "undefined":
          case "function":
          case "symbol":
            d.removeAttribute(g);
            return;
          case "boolean":
            var C = g.toLowerCase().slice(0, 5);
            if (C !== "data-" && C !== "aria-") {
              d.removeAttribute(g);
              return;
            }
        }
        d.setAttribute(g, "" + b);
      }
  }
  function vo(d, g, b) {
    if (b === null) d.removeAttribute(g);
    else {
      switch (typeof b) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          d.removeAttribute(g);
          return;
      }
      d.setAttribute(g, "" + b);
    }
  }
  function yn(d, g, b, C) {
    if (C === null) d.removeAttribute(b);
    else {
      switch (typeof C) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          d.removeAttribute(b);
          return;
      }
      d.setAttributeNS(g, b, "" + C);
    }
  }
  var Xo, bs;
  function $a(d) {
    if (Xo === void 0)
      try {
        throw Error();
      } catch (b) {
        var g = b.stack.trim().match(/\n( *(at )?)/);
        Xo = g && g[1] || "", bs = -1 < b.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < b.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Xo + d + bs;
  }
  var vp = !1;
  function Zo(d, g) {
    if (!d || vp) return "";
    vp = !0;
    var b = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var C = {
        DetermineComponentFrameRoot: function() {
          try {
            if (g) {
              var pt = function() {
                throw Error();
              };
              if (Object.defineProperty(pt.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(pt, []);
                } catch (Ze) {
                  var He = Ze;
                }
                Reflect.construct(d, [], pt);
              } else {
                try {
                  pt.call();
                } catch (Ze) {
                  He = Ze;
                }
                d.call(pt.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Ze) {
                He = Ze;
              }
              (pt = d()) && typeof pt.catch == "function" && pt.catch(function() {
              });
            }
          } catch (Ze) {
            if (Ze && He && typeof Ze.stack == "string")
              return [Ze.stack, He.stack];
          }
          return [null, null];
        }
      };
      C.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var I = Object.getOwnPropertyDescriptor(
        C.DetermineComponentFrameRoot,
        "name"
      );
      I && I.configurable && Object.defineProperty(
        C.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var j = C.DetermineComponentFrameRoot(), K = j[0], se = j[1];
      if (K && se) {
        var xe = K.split(`
`), ze = se.split(`
`);
        for (I = C = 0; C < xe.length && !xe[C].includes("DetermineComponentFrameRoot"); )
          C++;
        for (; I < ze.length && !ze[I].includes(
          "DetermineComponentFrameRoot"
        ); )
          I++;
        if (C === xe.length || I === ze.length)
          for (C = xe.length - 1, I = ze.length - 1; 1 <= C && 0 <= I && xe[C] !== ze[I]; )
            I--;
        for (; 1 <= C && 0 <= I; C--, I--)
          if (xe[C] !== ze[I]) {
            if (C !== 1 || I !== 1)
              do
                if (C--, I--, 0 > I || xe[C] !== ze[I]) {
                  var ut = `
` + xe[C].replace(" at new ", " at ");
                  return d.displayName && ut.includes("<anonymous>") && (ut = ut.replace("<anonymous>", d.displayName)), ut;
                }
              while (1 <= C && 0 <= I);
            break;
          }
      }
    } finally {
      vp = !1, Error.prepareStackTrace = b;
    }
    return (b = d ? d.displayName || d.name : "") ? $a(b) : "";
  }
  function yp(d) {
    switch (d.tag) {
      case 26:
      case 27:
      case 5:
        return $a(d.type);
      case 16:
        return $a("Lazy");
      case 13:
        return $a("Suspense");
      case 19:
        return $a("SuspenseList");
      case 0:
      case 15:
        return Zo(d.type, !1);
      case 11:
        return Zo(d.type.render, !1);
      case 1:
        return Zo(d.type, !0);
      case 31:
        return $a("Activity");
      default:
        return "";
    }
  }
  function Uu(d) {
    try {
      var g = "";
      do
        g += yp(d), d = d.return;
      while (d);
      return g;
    } catch (b) {
      return `
Error generating stack: ` + b.message + `
` + b.stack;
    }
  }
  function Ga(d) {
    switch (typeof d) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return d;
      case "object":
        return d;
      default:
        return "";
    }
  }
  function bp(d) {
    var g = d.type;
    return (d = d.nodeName) && d.toLowerCase() === "input" && (g === "checkbox" || g === "radio");
  }
  function uy(d) {
    var g = bp(d) ? "checked" : "value", b = Object.getOwnPropertyDescriptor(
      d.constructor.prototype,
      g
    ), C = "" + d[g];
    if (!d.hasOwnProperty(g) && typeof b < "u" && typeof b.get == "function" && typeof b.set == "function") {
      var I = b.get, j = b.set;
      return Object.defineProperty(d, g, {
        configurable: !0,
        get: function() {
          return I.call(this);
        },
        set: function(K) {
          C = "" + K, j.call(this, K);
        }
      }), Object.defineProperty(d, g, {
        enumerable: b.enumerable
      }), {
        getValue: function() {
          return C;
        },
        setValue: function(K) {
          C = "" + K;
        },
        stopTracking: function() {
          d._valueTracker = null, delete d[g];
        }
      };
    }
  }
  function xp(d) {
    d._valueTracker || (d._valueTracker = uy(d));
  }
  function Sp(d) {
    if (!d) return !1;
    var g = d._valueTracker;
    if (!g) return !0;
    var b = g.getValue(), C = "";
    return d && (C = bp(d) ? d.checked ? "true" : "false" : d.value), d = C, d !== b ? (g.setValue(d), !0) : !1;
  }
  function Uc(d) {
    if (d = d || (typeof document < "u" ? document : void 0), typeof d > "u") return null;
    try {
      return d.activeElement || d.body;
    } catch {
      return d.body;
    }
  }
  var aS = /[\n"\\]/g;
  function xs(d) {
    return d.replace(
      aS,
      function(g) {
        return "\\" + g.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function sS(d, g, b, C, I, j, K, se) {
    d.name = "", K != null && typeof K != "function" && typeof K != "symbol" && typeof K != "boolean" ? d.type = K : d.removeAttribute("type"), g != null ? K === "number" ? (g === 0 && d.value === "" || d.value != g) && (d.value = "" + Ga(g)) : d.value !== "" + Ga(g) && (d.value = "" + Ga(g)) : K !== "submit" && K !== "reset" || d.removeAttribute("value"), g != null ? Dg(d, K, Ga(g)) : b != null ? Dg(d, K, Ga(b)) : C != null && d.removeAttribute("value"), I == null && j != null && (d.defaultChecked = !!j), I != null && (d.checked = I && typeof I != "function" && typeof I != "symbol"), se != null && typeof se != "function" && typeof se != "symbol" && typeof se != "boolean" ? d.name = "" + Ga(se) : d.removeAttribute("name");
  }
  function lS(d, g, b, C, I, j, K, se) {
    if (j != null && typeof j != "function" && typeof j != "symbol" && typeof j != "boolean" && (d.type = j), g != null || b != null) {
      if (!(j !== "submit" && j !== "reset" || g != null))
        return;
      b = b != null ? "" + Ga(b) : "", g = g != null ? "" + Ga(g) : b, se || g === d.value || (d.value = g), d.defaultValue = g;
    }
    C = C ?? I, C = typeof C != "function" && typeof C != "symbol" && !!C, d.checked = se ? d.checked : !!C, d.defaultChecked = !!C, K != null && typeof K != "function" && typeof K != "symbol" && typeof K != "boolean" && (d.name = K);
  }
  function Dg(d, g, b) {
    g === "number" && Uc(d.ownerDocument) === d || d.defaultValue === "" + b || (d.defaultValue = "" + b);
  }
  function Fu(d, g, b, C) {
    if (d = d.options, g) {
      g = {};
      for (var I = 0; I < b.length; I++)
        g["$" + b[I]] = !0;
      for (b = 0; b < d.length; b++)
        I = g.hasOwnProperty("$" + d[b].value), d[b].selected !== I && (d[b].selected = I), I && C && (d[b].defaultSelected = !0);
    } else {
      for (b = "" + Ga(b), g = null, I = 0; I < d.length; I++) {
        if (d[I].value === b) {
          d[I].selected = !0, C && (d[I].defaultSelected = !0);
          return;
        }
        g !== null || d[I].disabled || (g = d[I]);
      }
      g !== null && (g.selected = !0);
    }
  }
  function cS(d, g, b) {
    if (g != null && (g = "" + Ga(g), g !== d.value && (d.value = g), b == null)) {
      d.defaultValue !== g && (d.defaultValue = g);
      return;
    }
    d.defaultValue = b != null ? "" + Ga(b) : "";
  }
  function uS(d, g, b, C) {
    if (g == null) {
      if (C != null) {
        if (b != null) throw Error(r(92));
        if (re(C)) {
          if (1 < C.length) throw Error(r(93));
          C = C[0];
        }
        b = C;
      }
      b == null && (b = ""), g = b;
    }
    b = Ga(g), d.defaultValue = b, C = d.textContent, C === b && C !== "" && C !== null && (d.value = C);
  }
  function Jd(d, g) {
    if (g) {
      var b = d.firstChild;
      if (b && b === d.lastChild && b.nodeType === 3) {
        b.nodeValue = g;
        return;
      }
    }
    d.textContent = g;
  }
  var wP = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function dS(d, g, b) {
    var C = g.indexOf("--") === 0;
    b == null || typeof b == "boolean" || b === "" ? C ? d.setProperty(g, "") : g === "float" ? d.cssFloat = "" : d[g] = "" : C ? d.setProperty(g, b) : typeof b != "number" || b === 0 || wP.has(g) ? g === "float" ? d.cssFloat = b : d[g] = ("" + b).trim() : d[g] = b + "px";
  }
  function dy(d, g, b) {
    if (g != null && typeof g != "object")
      throw Error(r(62));
    if (d = d.style, b != null) {
      for (var C in b)
        !b.hasOwnProperty(C) || g != null && g.hasOwnProperty(C) || (C.indexOf("--") === 0 ? d.setProperty(C, "") : C === "float" ? d.cssFloat = "" : d[C] = "");
      for (var I in g)
        C = g[I], g.hasOwnProperty(I) && b[I] !== C && dS(d, I, C);
    } else
      for (var j in g)
        g.hasOwnProperty(j) && dS(d, j, g[j]);
  }
  function wp(d) {
    if (d.indexOf("-") === -1) return !1;
    switch (d) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ig = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), TP = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Pg(d) {
    return TP.test("" + d) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : d;
  }
  var fy = null;
  function ef(d) {
    return d = d.target || d.srcElement || window, d.correspondingUseElement && (d = d.correspondingUseElement), d.nodeType === 3 ? d.parentNode : d;
  }
  var tf = null, Tp = null;
  function L_(d) {
    var g = ti(d);
    if (g && (d = g.stateNode)) {
      var b = d[Jt] || null;
      e: switch (d = g.stateNode, g.type) {
        case "input":
          if (sS(
            d,
            b.value,
            b.defaultValue,
            b.defaultValue,
            b.checked,
            b.defaultChecked,
            b.type,
            b.name
          ), g = b.name, b.type === "radio" && g != null) {
            for (b = d; b.parentNode; ) b = b.parentNode;
            for (b = b.querySelectorAll(
              'input[name="' + xs(
                "" + g
              ) + '"][type="radio"]'
            ), g = 0; g < b.length; g++) {
              var C = b[g];
              if (C !== d && C.form === d.form) {
                var I = C[Jt] || null;
                if (!I) throw Error(r(90));
                sS(
                  C,
                  I.value,
                  I.defaultValue,
                  I.defaultValue,
                  I.checked,
                  I.defaultChecked,
                  I.type,
                  I.name
                );
              }
            }
            for (g = 0; g < b.length; g++)
              C = b[g], C.form === d.form && Sp(C);
          }
          break e;
        case "textarea":
          cS(d, b.value, b.defaultValue);
          break e;
        case "select":
          g = b.value, g != null && Fu(d, !!b.multiple, g, !1);
      }
    }
  }
  var fS = !1;
  function k_(d, g, b) {
    if (fS) return d(g, b);
    fS = !0;
    try {
      var C = d(g);
      return C;
    } finally {
      if (fS = !1, (tf !== null || Tp !== null) && (Tm(), tf && (g = tf, d = Tp, Tp = tf = null, L_(g), d)))
        for (g = 0; g < d.length; g++) L_(d[g]);
    }
  }
  function Fc(d, g) {
    var b = d.stateNode;
    if (b === null) return null;
    var C = b[Jt] || null;
    if (C === null) return null;
    b = C[g];
    e: switch (g) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (C = !C.disabled) || (d = d.type, C = !(d === "button" || d === "input" || d === "select" || d === "textarea")), d = !C;
        break e;
      default:
        d = !1;
    }
    if (d) return null;
    if (b && typeof b != "function")
      throw Error(
        r(231, g, typeof b)
      );
    return b;
  }
  var Gs = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), py = !1;
  if (Gs)
    try {
      var Ep = {};
      Object.defineProperty(Ep, "passive", {
        get: function() {
          py = !0;
        }
      }), window.addEventListener("test", Ep, Ep), window.removeEventListener("test", Ep, Ep);
    } catch {
      py = !1;
    }
  var Ss = null, hy = null, nf = null;
  function Ng() {
    if (nf) return nf;
    var d, g = hy, b = g.length, C, I = "value" in Ss ? Ss.value : Ss.textContent, j = I.length;
    for (d = 0; d < b && g[d] === I[d]; d++) ;
    var K = b - d;
    for (C = 1; C <= K && g[b - C] === I[j - C]; C++) ;
    return nf = I.slice(d, 1 < C ? 1 - C : void 0);
  }
  function Mg(d) {
    var g = d.keyCode;
    return "charCode" in d ? (d = d.charCode, d === 0 && g === 13 && (d = 13)) : d = g, d === 10 && (d = 13), 32 <= d || d === 13 ? d : 0;
  }
  function yo() {
    return !0;
  }
  function z_() {
    return !1;
  }
  function Mo(d) {
    function g(b, C, I, j, K) {
      this._reactName = b, this._targetInst = I, this.type = C, this.nativeEvent = j, this.target = K, this.currentTarget = null;
      for (var se in d)
        d.hasOwnProperty(se) && (b = d[se], this[se] = b ? b(j) : j[se]);
      return this.isDefaultPrevented = (j.defaultPrevented != null ? j.defaultPrevented : j.returnValue === !1) ? yo : z_, this.isPropagationStopped = z_, this;
    }
    return m(g.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var b = this.nativeEvent;
        b && (b.preventDefault ? b.preventDefault() : typeof b.returnValue != "unknown" && (b.returnValue = !1), this.isDefaultPrevented = yo);
      },
      stopPropagation: function() {
        var b = this.nativeEvent;
        b && (b.stopPropagation ? b.stopPropagation() : typeof b.cancelBubble != "unknown" && (b.cancelBubble = !0), this.isPropagationStopped = yo);
      },
      persist: function() {
      },
      isPersistent: yo
    }), g;
  }
  var Wu = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(d) {
      return d.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, jg = Mo(Wu), Lg = m({}, Wu, { view: 0, detail: 0 }), EP = Mo(Lg), gy, pS, _p, my = m({}, Lg, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: vy,
    button: 0,
    buttons: 0,
    relatedTarget: function(d) {
      return d.relatedTarget === void 0 ? d.fromElement === d.srcElement ? d.toElement : d.fromElement : d.relatedTarget;
    },
    movementX: function(d) {
      return "movementX" in d ? d.movementX : (d !== _p && (_p && d.type === "mousemove" ? (gy = d.screenX - _p.screenX, pS = d.screenY - _p.screenY) : pS = gy = 0, _p = d), gy);
    },
    movementY: function(d) {
      return "movementY" in d ? d.movementY : pS;
    }
  }), kg = Mo(my), B_ = m({}, my, { dataTransfer: 0 }), V_ = Mo(B_), U_ = m({}, Lg, { relatedTarget: 0 }), hS = Mo(U_), _P = m({}, Wu, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), CP = Mo(_P), RP = m({}, Wu, {
    clipboardData: function(d) {
      return "clipboardData" in d ? d.clipboardData : window.clipboardData;
    }
  }), OP = Mo(RP), zg = m({}, Wu, { data: 0 }), gS = Mo(zg), F_ = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, W_ = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, H_ = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function mS(d) {
    var g = this.nativeEvent;
    return g.getModifierState ? g.getModifierState(d) : (d = H_[d]) ? !!g[d] : !1;
  }
  function vy() {
    return mS;
  }
  var rf = m({}, Lg, {
    key: function(d) {
      if (d.key) {
        var g = F_[d.key] || d.key;
        if (g !== "Unidentified") return g;
      }
      return d.type === "keypress" ? (d = Mg(d), d === 13 ? "Enter" : String.fromCharCode(d)) : d.type === "keydown" || d.type === "keyup" ? W_[d.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: vy,
    charCode: function(d) {
      return d.type === "keypress" ? Mg(d) : 0;
    },
    keyCode: function(d) {
      return d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
    },
    which: function(d) {
      return d.type === "keypress" ? Mg(d) : d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
    }
  }), of = Mo(rf), Ys = m({}, my, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), ga = Mo(Ys), yy = m({}, Lg, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: vy
  }), by = Mo(yy), vS = m({}, Wu, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), ma = Mo(vS), q_ = m({}, my, {
    deltaX: function(d) {
      return "deltaX" in d ? d.deltaX : "wheelDeltaX" in d ? -d.wheelDeltaX : 0;
    },
    deltaY: function(d) {
      return "deltaY" in d ? d.deltaY : "wheelDeltaY" in d ? -d.wheelDeltaY : "wheelDelta" in d ? -d.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), xy = Mo(q_), af = m({}, Wu, {
    newState: 0,
    oldState: 0
  }), yS = Mo(af), $_ = [9, 13, 27, 32], Sy = Gs && "CompositionEvent" in window, sf = null;
  Gs && "documentMode" in document && (sf = document.documentMode);
  var AP = Gs && "TextEvent" in window && !sf, wy = Gs && (!Sy || sf && 8 < sf && 11 >= sf), Fl = " ", bS = !1;
  function Ty(d, g) {
    switch (d) {
      case "keyup":
        return $_.indexOf(g.keyCode) !== -1;
      case "keydown":
        return g.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Bg(d) {
    return d = d.detail, typeof d == "object" && "data" in d ? d.data : null;
  }
  var ws = !1;
  function xS(d, g) {
    switch (d) {
      case "compositionend":
        return Bg(g);
      case "keypress":
        return g.which !== 32 ? null : (bS = !0, Fl);
      case "textInput":
        return d = g.data, d === Fl && bS ? null : d;
      default:
        return null;
    }
  }
  function SS(d, g) {
    if (ws)
      return d === "compositionend" || !Sy && Ty(d, g) ? (d = Ng(), nf = hy = Ss = null, ws = !1, d) : null;
    switch (d) {
      case "paste":
        return null;
      case "keypress":
        if (!(g.ctrlKey || g.altKey || g.metaKey) || g.ctrlKey && g.altKey) {
          if (g.char && 1 < g.char.length)
            return g.char;
          if (g.which) return String.fromCharCode(g.which);
        }
        return null;
      case "compositionend":
        return wy && g.locale !== "ko" ? null : g.data;
      default:
        return null;
    }
  }
  var lf = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function wS(d) {
    var g = d && d.nodeName && d.nodeName.toLowerCase();
    return g === "input" ? !!lf[d.type] : g === "textarea";
  }
  function Ey(d, g, b, C) {
    tf ? Tp ? Tp.push(C) : Tp = [C] : tf = C, g = vd(g, "onChange"), 0 < g.length && (b = new jg(
      "onChange",
      "change",
      null,
      b,
      C
    ), d.push({ event: b, listeners: g }));
  }
  var cf = null, Xs = null;
  function uf(d) {
    du(d, 0);
  }
  function Cp(d) {
    var g = Le(d);
    if (Sp(g)) return d;
  }
  function Hu(d, g) {
    if (d === "change") return g;
  }
  var TS = !1;
  if (Gs) {
    var _y;
    if (Gs) {
      var df = "oninput" in document;
      if (!df) {
        var Rp = document.createElement("div");
        Rp.setAttribute("oninput", "return;"), df = typeof Rp.oninput == "function";
      }
      _y = df;
    } else _y = !1;
    TS = _y && (!document.documentMode || 9 < document.documentMode);
  }
  function ES() {
    cf && (cf.detachEvent("onpropertychange", Op), Xs = cf = null);
  }
  function Op(d) {
    if (d.propertyName === "value" && Cp(Xs)) {
      var g = [];
      Ey(
        g,
        Xs,
        d,
        ef(d)
      ), k_(uf, g);
    }
  }
  function G_(d, g, b) {
    d === "focusin" ? (ES(), cf = g, Xs = b, cf.attachEvent("onpropertychange", Op)) : d === "focusout" && ES();
  }
  function Cy(d) {
    if (d === "selectionchange" || d === "keyup" || d === "keydown")
      return Cp(Xs);
  }
  function qu(d, g) {
    if (d === "click") return Cp(g);
  }
  function Wc(d, g) {
    if (d === "input" || d === "change")
      return Cp(g);
  }
  function _S(d, g) {
    return d === g && (d !== 0 || 1 / d === 1 / g) || d !== d && g !== g;
  }
  var Ko = typeof Object.is == "function" ? Object.is : _S;
  function Hc(d, g) {
    if (Ko(d, g)) return !0;
    if (typeof d != "object" || d === null || typeof g != "object" || g === null)
      return !1;
    var b = Object.keys(d), C = Object.keys(g);
    if (b.length !== C.length) return !1;
    for (C = 0; C < b.length; C++) {
      var I = b[C];
      if (!Ue.call(g, I) || !Ko(d[I], g[I]))
        return !1;
    }
    return !0;
  }
  function Vg(d) {
    for (; d && d.firstChild; ) d = d.firstChild;
    return d;
  }
  function $u(d, g) {
    var b = Vg(d);
    d = 0;
    for (var C; b; ) {
      if (b.nodeType === 3) {
        if (C = d + b.textContent.length, d <= g && C >= g)
          return { node: b, offset: g - d };
        d = C;
      }
      e: {
        for (; b; ) {
          if (b.nextSibling) {
            b = b.nextSibling;
            break e;
          }
          b = b.parentNode;
        }
        b = void 0;
      }
      b = Vg(b);
    }
  }
  function qr(d, g) {
    return d && g ? d === g ? !0 : d && d.nodeType === 3 ? !1 : g && g.nodeType === 3 ? qr(d, g.parentNode) : "contains" in d ? d.contains(g) : d.compareDocumentPosition ? !!(d.compareDocumentPosition(g) & 16) : !1 : !1;
  }
  function Ug(d) {
    d = d != null && d.ownerDocument != null && d.ownerDocument.defaultView != null ? d.ownerDocument.defaultView : window;
    for (var g = Uc(d.document); g instanceof d.HTMLIFrameElement; ) {
      try {
        var b = typeof g.contentWindow.location.href == "string";
      } catch {
        b = !1;
      }
      if (b) d = g.contentWindow;
      else break;
      g = Uc(d.document);
    }
    return g;
  }
  function Ry(d) {
    var g = d && d.nodeName && d.nodeName.toLowerCase();
    return g && (g === "input" && (d.type === "text" || d.type === "search" || d.type === "tel" || d.type === "url" || d.type === "password") || g === "textarea" || d.contentEditable === "true");
  }
  var CS = Gs && "documentMode" in document && 11 >= document.documentMode, Ts = null, ff = null, Ya = null, Ap = !1;
  function Dp(d, g, b) {
    var C = b.window === b ? b.document : b.nodeType === 9 ? b : b.ownerDocument;
    Ap || Ts == null || Ts !== Uc(C) || (C = Ts, "selectionStart" in C && Ry(C) ? C = { start: C.selectionStart, end: C.selectionEnd } : (C = (C.ownerDocument && C.ownerDocument.defaultView || window).getSelection(), C = {
      anchorNode: C.anchorNode,
      anchorOffset: C.anchorOffset,
      focusNode: C.focusNode,
      focusOffset: C.focusOffset
    }), Ya && Hc(Ya, C) || (Ya = C, C = vd(ff, "onSelect"), 0 < C.length && (g = new jg(
      "onSelect",
      "select",
      null,
      g,
      b
    ), d.push({ event: g, listeners: C }), g.target = Ts)));
  }
  function qc(d, g) {
    var b = {};
    return b[d.toLowerCase()] = g.toLowerCase(), b["Webkit" + d] = "webkit" + g, b["Moz" + d] = "moz" + g, b;
  }
  var Gu = {
    animationend: qc("Animation", "AnimationEnd"),
    animationiteration: qc("Animation", "AnimationIteration"),
    animationstart: qc("Animation", "AnimationStart"),
    transitionrun: qc("Transition", "TransitionRun"),
    transitionstart: qc("Transition", "TransitionStart"),
    transitioncancel: qc("Transition", "TransitionCancel"),
    transitionend: qc("Transition", "TransitionEnd")
  }, Oy = {}, Zs = {};
  Gs && (Zs = document.createElement("div").style, "AnimationEvent" in window || (delete Gu.animationend.animation, delete Gu.animationiteration.animation, delete Gu.animationstart.animation), "TransitionEvent" in window || delete Gu.transitionend.transition);
  function jo(d) {
    if (Oy[d]) return Oy[d];
    if (!Gu[d]) return d;
    var g = Gu[d], b;
    for (b in g)
      if (g.hasOwnProperty(b) && b in Zs)
        return Oy[d] = g[b];
    return d;
  }
  var Fg = jo("animationend"), Y_ = jo("animationiteration"), RS = jo("animationstart"), DP = jo("transitionrun"), OS = jo("transitionstart"), Ay = jo("transitioncancel"), AS = jo("transitionend"), DS = /* @__PURE__ */ new Map(), Dy = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Dy.push("scrollEnd");
  function va(d, g) {
    DS.set(d, g), zt(g, [d]);
  }
  var IS = /* @__PURE__ */ new WeakMap();
  function Xa(d, g) {
    if (typeof d == "object" && d !== null) {
      var b = IS.get(d);
      return b !== void 0 ? b : (g = {
        value: d,
        source: g,
        stack: Uu(g)
      }, IS.set(d, g), g);
    }
    return {
      value: d,
      source: g,
      stack: Uu(g)
    };
  }
  var Za = [], Yu = 0, Wg = 0;
  function Ks() {
    for (var d = Yu, g = Wg = Yu = 0; g < d; ) {
      var b = Za[g];
      Za[g++] = null;
      var C = Za[g];
      Za[g++] = null;
      var I = Za[g];
      Za[g++] = null;
      var j = Za[g];
      if (Za[g++] = null, C !== null && I !== null) {
        var K = C.pending;
        K === null ? I.next = I : (I.next = K.next, K.next = I), C.pending = I;
      }
      j !== 0 && Ip(b, I, j);
    }
  }
  function Qs(d, g, b, C) {
    Za[Yu++] = d, Za[Yu++] = g, Za[Yu++] = b, Za[Yu++] = C, Wg |= C, d.lanes |= C, d = d.alternate, d !== null && (d.lanes |= C);
  }
  function pf(d, g, b, C) {
    return Qs(d, g, b, C), Xu(d);
  }
  function $c(d, g) {
    return Qs(d, null, null, g), Xu(d);
  }
  function Ip(d, g, b) {
    d.lanes |= b;
    var C = d.alternate;
    C !== null && (C.lanes |= b);
    for (var I = !1, j = d.return; j !== null; )
      j.childLanes |= b, C = j.alternate, C !== null && (C.childLanes |= b), j.tag === 22 && (d = j.stateNode, d === null || d._visibility & 1 || (I = !0)), d = j, j = j.return;
    return d.tag === 3 ? (j = d.stateNode, I && g !== null && (I = 31 - q(b), d = j.hiddenUpdates, C = d[I], C === null ? d[I] = [g] : C.push(g), g.lane = b | 536870912), j) : null;
  }
  function Xu(d) {
    if (50 < uh)
      throw uh = 0, vb = null, Error(r(185));
    for (var g = d.return; g !== null; )
      d = g, g = d.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var hf = {};
  function IP(d, g, b, C) {
    this.tag = d, this.key = b, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = g, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = C, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ya(d, g, b, C) {
    return new IP(d, g, b, C);
  }
  function Iy(d) {
    return d = d.prototype, !(!d || !d.isReactComponent);
  }
  function Js(d, g) {
    var b = d.alternate;
    return b === null ? (b = ya(
      d.tag,
      g,
      d.key,
      d.mode
    ), b.elementType = d.elementType, b.type = d.type, b.stateNode = d.stateNode, b.alternate = d, d.alternate = b) : (b.pendingProps = g, b.type = d.type, b.flags = 0, b.subtreeFlags = 0, b.deletions = null), b.flags = d.flags & 65011712, b.childLanes = d.childLanes, b.lanes = d.lanes, b.child = d.child, b.memoizedProps = d.memoizedProps, b.memoizedState = d.memoizedState, b.updateQueue = d.updateQueue, g = d.dependencies, b.dependencies = g === null ? null : { lanes: g.lanes, firstContext: g.firstContext }, b.sibling = d.sibling, b.index = d.index, b.ref = d.ref, b.refCleanup = d.refCleanup, b;
  }
  function Py(d, g) {
    d.flags &= 65011714;
    var b = d.alternate;
    return b === null ? (d.childLanes = 0, d.lanes = g, d.child = null, d.subtreeFlags = 0, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null) : (d.childLanes = b.childLanes, d.lanes = b.lanes, d.child = b.child, d.subtreeFlags = 0, d.deletions = null, d.memoizedProps = b.memoizedProps, d.memoizedState = b.memoizedState, d.updateQueue = b.updateQueue, d.type = b.type, g = b.dependencies, d.dependencies = g === null ? null : {
      lanes: g.lanes,
      firstContext: g.firstContext
    }), d;
  }
  function wn(d, g, b, C, I, j) {
    var K = 0;
    if (C = d, typeof d == "function") Iy(d) && (K = 1);
    else if (typeof d == "string")
      K = IC(
        d,
        b,
        he.current
      ) ? 26 : d === "html" || d === "head" || d === "body" ? 27 : 5;
    else
      e: switch (d) {
        case Y:
          return d = ya(31, b, g, I), d.elementType = Y, d.lanes = j, d;
        case E:
          return xt(b.children, I, j, g);
        case w:
          K = 8, I |= 24;
          break;
        case _:
          return d = ya(12, b, g, I | 2), d.elementType = _, d.lanes = j, d;
        case N:
          return d = ya(13, b, g, I), d.elementType = N, d.lanes = j, d;
        case k:
          return d = ya(19, b, g, I), d.elementType = k, d.lanes = j, d;
        default:
          if (typeof d == "object" && d !== null)
            switch (d.$$typeof) {
              case O:
              case P:
                K = 10;
                break e;
              case D:
                K = 9;
                break e;
              case M:
                K = 11;
                break e;
              case U:
                K = 14;
                break e;
              case H:
                K = 16, C = null;
                break e;
            }
          K = 29, b = Error(
            r(130, d === null ? "null" : typeof d, "")
          ), C = null;
      }
    return g = ya(K, b, g, I), g.elementType = d, g.type = C, g.lanes = j, g;
  }
  function xt(d, g, b, C) {
    return d = ya(7, d, C, g), d.lanes = b, d;
  }
  function Zu(d, g, b) {
    return d = ya(6, d, null, g), d.lanes = b, d;
  }
  function Pp(d, g, b) {
    return g = ya(
      4,
      d.children !== null ? d.children : [],
      d.key,
      g
    ), g.lanes = b, g.stateNode = {
      containerInfo: d.containerInfo,
      pendingChildren: null,
      implementation: d.implementation
    }, g;
  }
  var zr = [], Ku = 0, Np = null, Hg = 0, ba = [], Es = 0, Gc = null, el = 1, tl = "";
  function Ii(d, g) {
    zr[Ku++] = Hg, zr[Ku++] = Np, Np = d, Hg = g;
  }
  function dr(d, g, b) {
    ba[Es++] = el, ba[Es++] = tl, ba[Es++] = Gc, Gc = d;
    var C = el;
    d = tl;
    var I = 32 - q(C) - 1;
    C &= ~(1 << I), b += 1;
    var j = 32 - q(g) + I;
    if (30 < j) {
      var K = I - I % 5;
      j = (C & (1 << K) - 1).toString(32), C >>= K, I -= K, el = 1 << 32 - q(g) + I | b << I | C, tl = j + d;
    } else
      el = 1 << j | b << I | C, tl = d;
  }
  function qg(d) {
    d.return !== null && (Ii(d, 1), dr(d, 1, 0));
  }
  function gf(d) {
    for (; d === Np; )
      Np = zr[--Ku], zr[Ku] = null, Hg = zr[--Ku], zr[Ku] = null;
    for (; d === Gc; )
      Gc = ba[--Es], ba[Es] = null, tl = ba[--Es], ba[Es] = null, el = ba[--Es], ba[Es] = null;
  }
  var vi = null, Sr = null, Tn = !1, Yc = null, Qo = !1, $g = Error(r(519));
  function nl(d) {
    var g = Error(r(418, ""));
    throw Lp(Xa(g, d)), $g;
  }
  function Ny(d) {
    var g = d.stateNode, b = d.type, C = d.memoizedProps;
    switch (g[jt] = d, g[Jt] = C, b) {
      case "dialog":
        bn("cancel", g), bn("close", g);
        break;
      case "iframe":
      case "object":
      case "embed":
        bn("load", g);
        break;
      case "video":
      case "audio":
        for (b = 0; b < pn.length; b++)
          bn(pn[b], g);
        break;
      case "source":
        bn("error", g);
        break;
      case "img":
      case "image":
      case "link":
        bn("error", g), bn("load", g);
        break;
      case "details":
        bn("toggle", g);
        break;
      case "input":
        bn("invalid", g), lS(
          g,
          C.value,
          C.defaultValue,
          C.checked,
          C.defaultChecked,
          C.type,
          C.name,
          !0
        ), xp(g);
        break;
      case "select":
        bn("invalid", g);
        break;
      case "textarea":
        bn("invalid", g), uS(g, C.value, C.defaultValue, C.children), xp(g);
    }
    b = C.children, typeof b != "string" && typeof b != "number" && typeof b != "bigint" || g.textContent === "" + b || C.suppressHydrationWarning === !0 || OC(g.textContent, b) ? (C.popover != null && (bn("beforetoggle", g), bn("toggle", g)), C.onScroll != null && bn("scroll", g), C.onScrollEnd != null && bn("scrollend", g), C.onClick != null && (g.onclick = Im), g = !0) : g = !1, g || nl(d);
  }
  function Gg(d) {
    for (vi = d.return; vi; )
      switch (vi.tag) {
        case 5:
        case 13:
          Qo = !1;
          return;
        case 27:
        case 3:
          Qo = !0;
          return;
        default:
          vi = vi.return;
      }
  }
  function Mp(d) {
    if (d !== vi) return !1;
    if (!Tn) return Gg(d), Tn = !0, !1;
    var g = d.tag, b;
    if ((b = g !== 3 && g !== 27) && ((b = g === 5) && (b = d.type, b = !(b !== "form" && b !== "button") || Nf(d.type, d.memoizedProps)), b = !b), b && Sr && nl(d), Gg(d), g === 13) {
      if (d = d.memoizedState, d = d !== null ? d.dehydrated : null, !d) throw Error(r(317));
      e: {
        for (d = d.nextSibling, g = 0; d; ) {
          if (d.nodeType === 8)
            if (b = d.data, b === "/$") {
              if (g === 0) {
                Sr = gl(d.nextSibling);
                break e;
              }
              g--;
            } else
              b !== "$" && b !== "$!" && b !== "$?" || g++;
          d = d.nextSibling;
        }
        Sr = null;
      }
    } else
      g === 27 ? (g = Sr, So(d.type) ? (d = Kw, Kw = null, Sr = d) : Sr = g) : Sr = vi ? gl(d.stateNode.nextSibling) : null;
    return !0;
  }
  function jp() {
    Sr = vi = null, Tn = !1;
  }
  function PS() {
    var d = Yc;
    return d !== null && (ea === null ? ea = d : ea.push.apply(
      ea,
      d
    ), Yc = null), d;
  }
  function Lp(d) {
    Yc === null ? Yc = [d] : Yc.push(d);
  }
  var My = ne(null), Xc = null, rl = null;
  function Wl(d, g, b) {
    ie(My, g._currentValue), g._currentValue = b;
  }
  function Hl(d) {
    d._currentValue = My.current, ae(My);
  }
  function jy(d, g, b) {
    for (; d !== null; ) {
      var C = d.alternate;
      if ((d.childLanes & g) !== g ? (d.childLanes |= g, C !== null && (C.childLanes |= g)) : C !== null && (C.childLanes & g) !== g && (C.childLanes |= g), d === b) break;
      d = d.return;
    }
  }
  function Ly(d, g, b, C) {
    var I = d.child;
    for (I !== null && (I.return = d); I !== null; ) {
      var j = I.dependencies;
      if (j !== null) {
        var K = I.child;
        j = j.firstContext;
        e: for (; j !== null; ) {
          var se = j;
          j = I;
          for (var xe = 0; xe < g.length; xe++)
            if (se.context === g[xe]) {
              j.lanes |= b, se = j.alternate, se !== null && (se.lanes |= b), jy(
                j.return,
                b,
                d
              ), C || (K = null);
              break e;
            }
          j = se.next;
        }
      } else if (I.tag === 18) {
        if (K = I.return, K === null) throw Error(r(341));
        K.lanes |= b, j = K.alternate, j !== null && (j.lanes |= b), jy(K, b, d), K = null;
      } else K = I.child;
      if (K !== null) K.return = I;
      else
        for (K = I; K !== null; ) {
          if (K === d) {
            K = null;
            break;
          }
          if (I = K.sibling, I !== null) {
            I.return = K.return, K = I;
            break;
          }
          K = K.return;
        }
      I = K;
    }
  }
  function Yg(d, g, b, C) {
    d = null;
    for (var I = g, j = !1; I !== null; ) {
      if (!j) {
        if ((I.flags & 524288) !== 0) j = !0;
        else if ((I.flags & 262144) !== 0) break;
      }
      if (I.tag === 10) {
        var K = I.alternate;
        if (K === null) throw Error(r(387));
        if (K = K.memoizedProps, K !== null) {
          var se = I.type;
          Ko(I.pendingProps.value, K.value) || (d !== null ? d.push(se) : d = [se]);
        }
      } else if (I === Ee.current) {
        if (K = I.alternate, K === null) throw Error(r(387));
        K.memoizedState.memoizedState !== I.memoizedState.memoizedState && (d !== null ? d.push(To) : d = [To]);
      }
      I = I.return;
    }
    d !== null && Ly(
      g,
      d,
      b,
      C
    ), g.flags |= 262144;
  }
  function Xg(d) {
    for (d = d.firstContext; d !== null; ) {
      if (!Ko(
        d.context._currentValue,
        d.memoizedValue
      ))
        return !0;
      d = d.next;
    }
    return !1;
  }
  function Qu(d) {
    Xc = d, rl = null, d = d.dependencies, d !== null && (d.firstContext = null);
  }
  function bo(d) {
    return NS(Xc, d);
  }
  function kp(d, g) {
    return Xc === null && Qu(d), NS(d, g);
  }
  function NS(d, g) {
    var b = g._currentValue;
    if (g = { context: g, memoizedValue: b, next: null }, rl === null) {
      if (d === null) throw Error(r(308));
      rl = g, d.dependencies = { lanes: 0, firstContext: g }, d.flags |= 524288;
    } else rl = rl.next = g;
    return b;
  }
  var X_ = typeof AbortController < "u" ? AbortController : function() {
    var d = [], g = this.signal = {
      aborted: !1,
      addEventListener: function(b, C) {
        d.push(C);
      }
    };
    this.abort = function() {
      g.aborted = !0, d.forEach(function(b) {
        return b();
      });
    };
  }, zp = e.unstable_scheduleCallback, ky = e.unstable_NormalPriority, Pi = {
    $$typeof: P,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function MS() {
    return {
      controller: new X_(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Ju(d) {
    d.refCount--, d.refCount === 0 && zp(ky, function() {
      d.controller.abort();
    });
  }
  var ql = null, Bp = 0, ed = 0, _s = null;
  function xa(d, g) {
    if (ql === null) {
      var b = ql = [];
      Bp = 0, ed = Rb(), _s = {
        status: "pending",
        value: void 0,
        then: function(C) {
          b.push(C);
        }
      };
    }
    return Bp++, g.then(Zg, Zg), g;
  }
  function Zg() {
    if (--Bp === 0 && ql !== null) {
      _s !== null && (_s.status = "fulfilled");
      var d = ql;
      ql = null, ed = 0, _s = null;
      for (var g = 0; g < d.length; g++) (0, d[g])();
    }
  }
  function jS(d, g) {
    var b = [], C = {
      status: "pending",
      value: null,
      reason: null,
      then: function(I) {
        b.push(I);
      }
    };
    return d.then(
      function() {
        C.status = "fulfilled", C.value = g;
        for (var I = 0; I < b.length; I++) (0, b[I])(g);
      },
      function(I) {
        for (C.status = "rejected", C.reason = I, I = 0; I < b.length; I++)
          (0, b[I])(void 0);
      }
    ), C;
  }
  var LS = Z.S;
  Z.S = function(d, g) {
    typeof g == "object" && g !== null && typeof g.then == "function" && xa(d, g), LS !== null && LS(d, g);
  };
  var Zc = ne(null);
  function Vp() {
    var d = Zc.current;
    return d !== null ? d : Tr.pooledCache;
  }
  function Up(d, g) {
    g === null ? ie(Zc, Zc.current) : ie(Zc, g.pool);
  }
  function Kg() {
    var d = Vp();
    return d === null ? null : { parent: Pi._currentValue, pool: d };
  }
  var mf = Error(r(460)), Qg = Error(r(474)), Fp = Error(r(542)), zy = { then: function() {
  } };
  function kS(d) {
    return d = d.status, d === "fulfilled" || d === "rejected";
  }
  function Wp() {
  }
  function zS(d, g, b) {
    switch (b = d[b], b === void 0 ? d.push(g) : b !== g && (g.then(Wp, Wp), g = b), g.status) {
      case "fulfilled":
        return g.value;
      case "rejected":
        throw d = g.reason, BS(d), d;
      default:
        if (typeof g.status == "string") g.then(Wp, Wp);
        else {
          if (d = Tr, d !== null && 100 < d.shellSuspendCounter)
            throw Error(r(482));
          d = g, d.status = "pending", d.then(
            function(C) {
              if (g.status === "pending") {
                var I = g;
                I.status = "fulfilled", I.value = C;
              }
            },
            function(C) {
              if (g.status === "pending") {
                var I = g;
                I.status = "rejected", I.reason = C;
              }
            }
          );
        }
        switch (g.status) {
          case "fulfilled":
            return g.value;
          case "rejected":
            throw d = g.reason, BS(d), d;
        }
        throw Hp = g, mf;
    }
  }
  var Hp = null;
  function By() {
    if (Hp === null) throw Error(r(459));
    var d = Hp;
    return Hp = null, d;
  }
  function BS(d) {
    if (d === mf || d === Fp)
      throw Error(r(483));
  }
  var Kc = !1;
  function Jg(d) {
    d.updateQueue = {
      baseState: d.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Vy(d, g) {
    d = d.updateQueue, g.updateQueue === d && (g.updateQueue = {
      baseState: d.baseState,
      firstBaseUpdate: d.firstBaseUpdate,
      lastBaseUpdate: d.lastBaseUpdate,
      shared: d.shared,
      callbacks: null
    });
  }
  function Qc(d) {
    return { lane: d, tag: 0, payload: null, callback: null, next: null };
  }
  function Sa(d, g, b) {
    var C = d.updateQueue;
    if (C === null) return null;
    if (C = C.shared, (fr & 2) !== 0) {
      var I = C.pending;
      return I === null ? g.next = g : (g.next = I.next, I.next = g), C.pending = g, g = Xu(d), Ip(d, null, b), g;
    }
    return Qs(d, C, g, b), Xu(d);
  }
  function vf(d, g, b) {
    if (g = g.updateQueue, g !== null && (g = g.shared, (b & 4194048) !== 0)) {
      var C = g.lanes;
      C &= d.pendingLanes, b |= C, g.lanes = b, Hr(d, b);
    }
  }
  function em(d, g) {
    var b = d.updateQueue, C = d.alternate;
    if (C !== null && (C = C.updateQueue, b === C)) {
      var I = null, j = null;
      if (b = b.firstBaseUpdate, b !== null) {
        do {
          var K = {
            lane: b.lane,
            tag: b.tag,
            payload: b.payload,
            callback: null,
            next: null
          };
          j === null ? I = j = K : j = j.next = K, b = b.next;
        } while (b !== null);
        j === null ? I = j = g : j = j.next = g;
      } else I = j = g;
      b = {
        baseState: C.baseState,
        firstBaseUpdate: I,
        lastBaseUpdate: j,
        shared: C.shared,
        callbacks: C.callbacks
      }, d.updateQueue = b;
      return;
    }
    d = b.lastBaseUpdate, d === null ? b.firstBaseUpdate = g : d.next = g, b.lastBaseUpdate = g;
  }
  var VS = !1;
  function tm() {
    if (VS) {
      var d = _s;
      if (d !== null) throw d;
    }
  }
  function qp(d, g, b, C) {
    VS = !1;
    var I = d.updateQueue;
    Kc = !1;
    var j = I.firstBaseUpdate, K = I.lastBaseUpdate, se = I.shared.pending;
    if (se !== null) {
      I.shared.pending = null;
      var xe = se, ze = xe.next;
      xe.next = null, K === null ? j = ze : K.next = ze, K = xe;
      var ut = d.alternate;
      ut !== null && (ut = ut.updateQueue, se = ut.lastBaseUpdate, se !== K && (se === null ? ut.firstBaseUpdate = ze : se.next = ze, ut.lastBaseUpdate = xe));
    }
    if (j !== null) {
      var pt = I.baseState;
      K = 0, ut = ze = xe = null, se = j;
      do {
        var He = se.lane & -536870913, Ze = He !== se.lane;
        if (Ze ? (Zn & He) === He : (C & He) === He) {
          He !== 0 && He === ed && (VS = !0), ut !== null && (ut = ut.next = {
            lane: 0,
            tag: se.tag,
            payload: se.payload,
            callback: null,
            next: null
          });
          e: {
            var on = d, en = se;
            He = g;
            var cr = b;
            switch (en.tag) {
              case 1:
                if (on = en.payload, typeof on == "function") {
                  pt = on.call(cr, pt, He);
                  break e;
                }
                pt = on;
                break e;
              case 3:
                on.flags = on.flags & -65537 | 128;
              case 0:
                if (on = en.payload, He = typeof on == "function" ? on.call(cr, pt, He) : on, He == null) break e;
                pt = m({}, pt, He);
                break e;
              case 2:
                Kc = !0;
            }
          }
          He = se.callback, He !== null && (d.flags |= 64, Ze && (d.flags |= 8192), Ze = I.callbacks, Ze === null ? I.callbacks = [He] : Ze.push(He));
        } else
          Ze = {
            lane: He,
            tag: se.tag,
            payload: se.payload,
            callback: se.callback,
            next: null
          }, ut === null ? (ze = ut = Ze, xe = pt) : ut = ut.next = Ze, K |= He;
        if (se = se.next, se === null) {
          if (se = I.shared.pending, se === null)
            break;
          Ze = se, se = Ze.next, Ze.next = null, I.lastBaseUpdate = Ze, I.shared.pending = null;
        }
      } while (!0);
      ut === null && (xe = pt), I.baseState = xe, I.firstBaseUpdate = ze, I.lastBaseUpdate = ut, j === null && (I.shared.lanes = 0), ud |= K, d.lanes = K, d.memoizedState = pt;
    }
  }
  function $p(d, g) {
    if (typeof d != "function")
      throw Error(r(191, d));
    d.call(g);
  }
  function Uy(d, g) {
    var b = d.callbacks;
    if (b !== null)
      for (d.callbacks = null, d = 0; d < b.length; d++)
        $p(b[d], g);
  }
  var Jc = ne(null), nm = ne(0);
  function US(d, g) {
    d = lu, ie(nm, d), ie(Jc, g), lu = d | g.baseLanes;
  }
  function Fi() {
    ie(nm, lu), ie(Jc, Jc.current);
  }
  function Gp() {
    lu = nm.current, ae(Jc), ae(nm);
  }
  var il = 0, mn = null, sr = null, li = null, yf = !1, bf = !1, wa = !1, rm = 0, Cs = 0, Ta = null, Fy = 0;
  function ci() {
    throw Error(r(321));
  }
  function im(d, g) {
    if (g === null) return !1;
    for (var b = 0; b < g.length && b < d.length; b++)
      if (!Ko(d[b], g[b])) return !1;
    return !0;
  }
  function Wy(d, g, b, C, I, j) {
    return il = j, mn = g, g.memoizedState = null, g.updateQueue = null, g.lanes = 0, Z.H = d === null || d.memoizedState === null ? rC : aw, wa = !1, j = b(C, I), wa = !1, bf && (j = td(
      g,
      b,
      C,
      I
    )), FS(d), j;
  }
  function FS(d) {
    Z.H = hm;
    var g = sr !== null && sr.next !== null;
    if (il = 0, li = sr = mn = null, yf = !1, Cs = 0, Ta = null, g) throw Error(r(300));
    d === null || Mn || (d = d.dependencies, d !== null && Xg(d) && (Mn = !0));
  }
  function td(d, g, b, C) {
    mn = d;
    var I = 0;
    do {
      if (bf && (Ta = null), Cs = 0, bf = !1, 25 <= I) throw Error(r(301));
      if (I += 1, li = sr = null, d.updateQueue != null) {
        var j = d.updateQueue;
        j.lastEffect = null, j.events = null, j.stores = null, j.memoCache != null && (j.memoCache.index = 0);
      }
      Z.H = iC, j = g(b, C);
    } while (bf);
    return j;
  }
  function Z_() {
    var d = Z.H, g = d.useState()[0];
    return g = typeof g.then == "function" ? xf(g) : g, d = d.useState()[0], (sr !== null ? sr.memoizedState : null) !== d && (mn.flags |= 1024), g;
  }
  function Hy() {
    var d = rm !== 0;
    return rm = 0, d;
  }
  function qy(d, g, b) {
    g.updateQueue = d.updateQueue, g.flags &= -2053, d.lanes &= ~b;
  }
  function Yp(d) {
    if (yf) {
      for (d = d.memoizedState; d !== null; ) {
        var g = d.queue;
        g !== null && (g.pending = null), d = d.next;
      }
      yf = !1;
    }
    il = 0, li = sr = mn = null, bf = !1, Cs = rm = 0, Ta = null;
  }
  function Jo() {
    var d = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return li === null ? mn.memoizedState = li = d : li = li.next = d, li;
  }
  function yi() {
    if (sr === null) {
      var d = mn.alternate;
      d = d !== null ? d.memoizedState : null;
    } else d = sr.next;
    var g = li === null ? mn.memoizedState : li.next;
    if (g !== null)
      li = g, sr = d;
    else {
      if (d === null)
        throw mn.alternate === null ? Error(r(467)) : Error(r(310));
      sr = d, d = {
        memoizedState: sr.memoizedState,
        baseState: sr.baseState,
        baseQueue: sr.baseQueue,
        queue: sr.queue,
        next: null
      }, li === null ? mn.memoizedState = li = d : li = li.next = d;
    }
    return li;
  }
  function om() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function xf(d) {
    var g = Cs;
    return Cs += 1, Ta === null && (Ta = []), d = zS(Ta, d, g), g = mn, (li === null ? g.memoizedState : li.next) === null && (g = g.alternate, Z.H = g === null || g.memoizedState === null ? rC : aw), d;
  }
  function $y(d) {
    if (d !== null && typeof d == "object") {
      if (typeof d.then == "function") return xf(d);
      if (d.$$typeof === P) return bo(d);
    }
    throw Error(r(438, String(d)));
  }
  function Wi(d) {
    var g = null, b = mn.updateQueue;
    if (b !== null && (g = b.memoCache), g == null) {
      var C = mn.alternate;
      C !== null && (C = C.updateQueue, C !== null && (C = C.memoCache, C != null && (g = {
        data: C.data.map(function(I) {
          return I.slice();
        }),
        index: 0
      })));
    }
    if (g == null && (g = { data: [], index: 0 }), b === null && (b = om(), mn.updateQueue = b), b.memoCache = g, b = g.data[g.index], b === void 0)
      for (b = g.data[g.index] = Array(d), C = 0; C < d; C++)
        b[C] = z;
    return g.index++, b;
  }
  function $l(d, g) {
    return typeof g == "function" ? g(d) : g;
  }
  function am(d) {
    var g = yi();
    return Gy(g, sr, d);
  }
  function Gy(d, g, b) {
    var C = d.queue;
    if (C === null) throw Error(r(311));
    C.lastRenderedReducer = b;
    var I = d.baseQueue, j = C.pending;
    if (j !== null) {
      if (I !== null) {
        var K = I.next;
        I.next = j.next, j.next = K;
      }
      g.baseQueue = I = j, C.pending = null;
    }
    if (j = d.baseState, I === null) d.memoizedState = j;
    else {
      g = I.next;
      var se = K = null, xe = null, ze = g, ut = !1;
      do {
        var pt = ze.lane & -536870913;
        if (pt !== ze.lane ? (Zn & pt) === pt : (il & pt) === pt) {
          var He = ze.revertLane;
          if (He === 0)
            xe !== null && (xe = xe.next = {
              lane: 0,
              revertLane: 0,
              action: ze.action,
              hasEagerState: ze.hasEagerState,
              eagerState: ze.eagerState,
              next: null
            }), pt === ed && (ut = !0);
          else if ((il & He) === He) {
            ze = ze.next, He === ed && (ut = !0);
            continue;
          } else
            pt = {
              lane: 0,
              revertLane: ze.revertLane,
              action: ze.action,
              hasEagerState: ze.hasEagerState,
              eagerState: ze.eagerState,
              next: null
            }, xe === null ? (se = xe = pt, K = j) : xe = xe.next = pt, mn.lanes |= He, ud |= He;
          pt = ze.action, wa && b(j, pt), j = ze.hasEagerState ? ze.eagerState : b(j, pt);
        } else
          He = {
            lane: pt,
            revertLane: ze.revertLane,
            action: ze.action,
            hasEagerState: ze.hasEagerState,
            eagerState: ze.eagerState,
            next: null
          }, xe === null ? (se = xe = He, K = j) : xe = xe.next = He, mn.lanes |= pt, ud |= pt;
        ze = ze.next;
      } while (ze !== null && ze !== g);
      if (xe === null ? K = j : xe.next = se, !Ko(j, d.memoizedState) && (Mn = !0, ut && (b = _s, b !== null)))
        throw b;
      d.memoizedState = j, d.baseState = K, d.baseQueue = xe, C.lastRenderedState = j;
    }
    return I === null && (C.lanes = 0), [d.memoizedState, C.dispatch];
  }
  function Yy(d) {
    var g = yi(), b = g.queue;
    if (b === null) throw Error(r(311));
    b.lastRenderedReducer = d;
    var C = b.dispatch, I = b.pending, j = g.memoizedState;
    if (I !== null) {
      b.pending = null;
      var K = I = I.next;
      do
        j = d(j, K.action), K = K.next;
      while (K !== I);
      Ko(j, g.memoizedState) || (Mn = !0), g.memoizedState = j, g.baseQueue === null && (g.baseState = j), b.lastRenderedState = j;
    }
    return [j, C];
  }
  function WS(d, g, b) {
    var C = mn, I = yi(), j = Tn;
    if (j) {
      if (b === void 0) throw Error(r(407));
      b = b();
    } else b = g();
    var K = !Ko(
      (sr || I).memoizedState,
      b
    );
    K && (I.memoizedState = b, Mn = !0), I = I.queue;
    var se = HS.bind(null, C, I, d);
    if (eu(2048, 8, se, [d]), I.getSnapshot !== g || K || li !== null && li.memoizedState.tag & 1) {
      if (C.flags |= 2048, nd(
        9,
        Rs(),
        Xy.bind(
          null,
          C,
          I,
          b,
          g
        ),
        null
      ), Tr === null) throw Error(r(349));
      j || (il & 124) !== 0 || sm(C, g, b);
    }
    return b;
  }
  function sm(d, g, b) {
    d.flags |= 16384, d = { getSnapshot: g, value: b }, g = mn.updateQueue, g === null ? (g = om(), mn.updateQueue = g, g.stores = [d]) : (b = g.stores, b === null ? g.stores = [d] : b.push(d));
  }
  function Xy(d, g, b, C) {
    g.value = b, g.getSnapshot = C, qS(g) && $S(d);
  }
  function HS(d, g, b) {
    return b(function() {
      qS(g) && $S(d);
    });
  }
  function qS(d) {
    var g = d.getSnapshot;
    d = d.value;
    try {
      var b = g();
      return !Ko(d, b);
    } catch {
      return !0;
    }
  }
  function $S(d) {
    var g = $c(d, 2);
    g !== null && Ia(g, d, 2);
  }
  function lm(d) {
    var g = Jo();
    if (typeof d == "function") {
      var b = d;
      if (d = b(), wa) {
        bt(!0);
        try {
          b();
        } finally {
          bt(!1);
        }
      }
    }
    return g.memoizedState = g.baseState = d, g.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: $l,
      lastRenderedState: d
    }, g;
  }
  function Zy(d, g, b, C) {
    return d.baseState = b, Gy(
      d,
      sr,
      typeof C == "function" ? C : $l
    );
  }
  function GS(d, g, b, C, I) {
    if (Kp(d)) throw Error(r(485));
    if (d = g.action, d !== null) {
      var j = {
        payload: I,
        action: d,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(K) {
          j.listeners.push(K);
        }
      };
      Z.T !== null ? b(!0) : j.isTransition = !1, C(j), b = g.pending, b === null ? (j.next = g.pending = j, YS(g, j)) : (j.next = b.next, g.pending = b.next = j);
    }
  }
  function YS(d, g) {
    var b = g.action, C = g.payload, I = d.state;
    if (g.isTransition) {
      var j = Z.T, K = {};
      Z.T = K;
      try {
        var se = b(I, C), xe = Z.S;
        xe !== null && xe(K, se), Ky(d, g, se);
      } catch (ze) {
        um(d, g, ze);
      } finally {
        Z.T = j;
      }
    } else
      try {
        j = b(I, C), Ky(d, g, j);
      } catch (ze) {
        um(d, g, ze);
      }
  }
  function Ky(d, g, b) {
    b !== null && typeof b == "object" && typeof b.then == "function" ? b.then(
      function(C) {
        cm(d, g, C);
      },
      function(C) {
        return um(d, g, C);
      }
    ) : cm(d, g, b);
  }
  function cm(d, g, b) {
    g.status = "fulfilled", g.value = b, XS(g), d.state = b, g = d.pending, g !== null && (b = g.next, b === g ? d.pending = null : (b = b.next, g.next = b, YS(d, b)));
  }
  function um(d, g, b) {
    var C = d.pending;
    if (d.pending = null, C !== null) {
      C = C.next;
      do
        g.status = "rejected", g.reason = b, XS(g), g = g.next;
      while (g !== C);
    }
    d.action = null;
  }
  function XS(d) {
    d = d.listeners;
    for (var g = 0; g < d.length; g++) (0, d[g])();
  }
  function ZS(d, g) {
    return g;
  }
  function Qy(d, g) {
    if (Tn) {
      var b = Tr.formState;
      if (b !== null) {
        e: {
          var C = mn;
          if (Tn) {
            if (Sr) {
              t: {
                for (var I = Sr, j = Qo; I.nodeType !== 8; ) {
                  if (!j) {
                    I = null;
                    break t;
                  }
                  if (I = gl(
                    I.nextSibling
                  ), I === null) {
                    I = null;
                    break t;
                  }
                }
                j = I.data, I = j === "F!" || j === "F" ? I : null;
              }
              if (I) {
                Sr = gl(
                  I.nextSibling
                ), C = I.data === "F!";
                break e;
              }
            }
            nl(C);
          }
          C = !1;
        }
        C && (g = b[0]);
      }
    }
    return b = Jo(), b.memoizedState = b.baseState = g, C = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: ZS,
      lastRenderedState: g
    }, b.queue = C, b = tb.bind(
      null,
      mn,
      C
    ), C.dispatch = b, C = lm(!1), j = fm.bind(
      null,
      mn,
      !1,
      C.queue
    ), C = Jo(), I = {
      state: g,
      dispatch: null,
      action: d,
      pending: null
    }, C.queue = I, b = GS.bind(
      null,
      mn,
      I,
      j,
      b
    ), I.dispatch = b, C.memoizedState = d, [g, b, !1];
  }
  function KS(d) {
    var g = yi();
    return Gl(g, sr, d);
  }
  function Gl(d, g, b) {
    if (g = Gy(
      d,
      g,
      ZS
    )[0], d = am($l)[0], typeof g == "object" && g !== null && typeof g.then == "function")
      try {
        var C = xf(g);
      } catch (K) {
        throw K === mf ? Fp : K;
      }
    else C = g;
    g = yi();
    var I = g.queue, j = I.dispatch;
    return b !== g.memoizedState && (mn.flags |= 2048, nd(
      9,
      Rs(),
      QS.bind(null, I, b),
      null
    )), [C, j, d];
  }
  function QS(d, g) {
    d.action = g;
  }
  function K_(d) {
    var g = yi(), b = sr;
    if (b !== null)
      return Gl(g, b, d);
    yi(), g = g.memoizedState, b = yi();
    var C = b.queue.dispatch;
    return b.memoizedState = d, [g, C, !1];
  }
  function nd(d, g, b, C) {
    return d = { tag: d, create: b, deps: C, inst: g, next: null }, g = mn.updateQueue, g === null && (g = om(), mn.updateQueue = g), b = g.lastEffect, b === null ? g.lastEffect = d.next = d : (C = b.next, b.next = d, d.next = C, g.lastEffect = d), d;
  }
  function Rs() {
    return { destroy: void 0, resource: void 0 };
  }
  function JS() {
    return yi().memoizedState;
  }
  function Sf(d, g, b, C) {
    var I = Jo();
    C = C === void 0 ? null : C, mn.flags |= d, I.memoizedState = nd(
      1 | g,
      Rs(),
      b,
      C
    );
  }
  function eu(d, g, b, C) {
    var I = yi();
    C = C === void 0 ? null : C;
    var j = I.memoizedState.inst;
    sr !== null && C !== null && im(C, sr.memoizedState.deps) ? I.memoizedState = nd(g, j, b, C) : (mn.flags |= d, I.memoizedState = nd(
      1 | g,
      j,
      b,
      C
    ));
  }
  function $r(d, g) {
    Sf(8390656, 8, d, g);
  }
  function Q_(d, g) {
    eu(2048, 8, d, g);
  }
  function J_(d, g) {
    return eu(4, 2, d, g);
  }
  function ew(d, g) {
    return eu(4, 4, d, g);
  }
  function ol(d, g) {
    if (typeof g == "function") {
      d = d();
      var b = g(d);
      return function() {
        typeof b == "function" ? b() : g(null);
      };
    }
    if (g != null)
      return d = d(), g.current = d, function() {
        g.current = null;
      };
  }
  function tw(d, g, b) {
    b = b != null ? b.concat([d]) : null, eu(4, 4, ol.bind(null, g, d), b);
  }
  function dm() {
  }
  function Xp(d, g) {
    var b = yi();
    g = g === void 0 ? null : g;
    var C = b.memoizedState;
    return g !== null && im(g, C[1]) ? C[0] : (b.memoizedState = [d, g], d);
  }
  function wf(d, g) {
    var b = yi();
    g = g === void 0 ? null : g;
    var C = b.memoizedState;
    if (g !== null && im(g, C[1]))
      return C[0];
    if (C = d(), wa) {
      bt(!0);
      try {
        d();
      } finally {
        bt(!1);
      }
    }
    return b.memoizedState = [C, g], C;
  }
  function Jy(d, g, b) {
    return b === void 0 || (il & 1073741824) !== 0 ? d.memoizedState = g : (d.memoizedState = b, d = mC(), mn.lanes |= d, ud |= d, b);
  }
  function eb(d, g, b, C) {
    return Ko(b, g) ? b : Jc.current !== null ? (d = Jy(d, b, C), Ko(d, g) || (Mn = !0), d) : (il & 42) === 0 ? (Mn = !0, d.memoizedState = b) : (d = mC(), mn.lanes |= d, ud |= d, g);
  }
  function nw(d, g, b, C, I) {
    var j = ee.p;
    ee.p = j !== 0 && 8 > j ? j : 8;
    var K = Z.T, se = {};
    Z.T = se, fm(d, !1, g, b);
    try {
      var xe = I(), ze = Z.S;
      if (ze !== null && ze(se, xe), xe !== null && typeof xe == "object" && typeof xe.then == "function") {
        var ut = jS(
          xe,
          C
        );
        Zp(
          d,
          g,
          ut,
          ts(d)
        );
      } else
        Zp(
          d,
          g,
          C,
          ts(d)
        );
    } catch (pt) {
      Zp(
        d,
        g,
        { then: function() {
        }, status: "rejected", reason: pt },
        ts()
      );
    } finally {
      ee.p = j, Z.T = K;
    }
  }
  function PP() {
  }
  function rw(d, g, b, C) {
    if (d.tag !== 5) throw Error(r(476));
    var I = iw(d).queue;
    nw(
      d,
      I,
      g,
      J,
      b === null ? PP : function() {
        return eC(d), b(C);
      }
    );
  }
  function iw(d) {
    var g = d.memoizedState;
    if (g !== null) return g;
    g = {
      memoizedState: J,
      baseState: J,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $l,
        lastRenderedState: J
      },
      next: null
    };
    var b = {};
    return g.next = {
      memoizedState: b,
      baseState: b,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $l,
        lastRenderedState: b
      },
      next: null
    }, d.memoizedState = g, d = d.alternate, d !== null && (d.memoizedState = g), g;
  }
  function eC(d) {
    var g = iw(d).next.queue;
    Zp(d, g, {}, ts());
  }
  function Tf() {
    return bo(To);
  }
  function al() {
    return yi().memoizedState;
  }
  function ow() {
    return yi().memoizedState;
  }
  function NP(d) {
    for (var g = d.return; g !== null; ) {
      switch (g.tag) {
        case 24:
        case 3:
          var b = ts();
          d = Qc(b);
          var C = Sa(g, d, b);
          C !== null && (Ia(C, g, b), vf(C, g, b)), g = { cache: MS() }, d.payload = g;
          return;
      }
      g = g.return;
    }
  }
  function tC(d, g, b) {
    var C = ts();
    b = {
      lane: C,
      revertLane: 0,
      action: b,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Kp(d) ? pm(g, b) : (b = pf(d, g, b, C), b !== null && (Ia(b, d, C), nC(b, g, C)));
  }
  function tb(d, g, b) {
    var C = ts();
    Zp(d, g, b, C);
  }
  function Zp(d, g, b, C) {
    var I = {
      lane: C,
      revertLane: 0,
      action: b,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Kp(d)) pm(g, I);
    else {
      var j = d.alternate;
      if (d.lanes === 0 && (j === null || j.lanes === 0) && (j = g.lastRenderedReducer, j !== null))
        try {
          var K = g.lastRenderedState, se = j(K, b);
          if (I.hasEagerState = !0, I.eagerState = se, Ko(se, K))
            return Qs(d, g, I, 0), Tr === null && Ks(), !1;
        } catch {
        } finally {
        }
      if (b = pf(d, g, I, C), b !== null)
        return Ia(b, d, C), nC(b, g, C), !0;
    }
    return !1;
  }
  function fm(d, g, b, C) {
    if (C = {
      lane: 2,
      revertLane: Rb(),
      action: C,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Kp(d)) {
      if (g) throw Error(r(479));
    } else
      g = pf(
        d,
        b,
        C,
        2
      ), g !== null && Ia(g, d, 2);
  }
  function Kp(d) {
    var g = d.alternate;
    return d === mn || g !== null && g === mn;
  }
  function pm(d, g) {
    bf = yf = !0;
    var b = d.pending;
    b === null ? g.next = g : (g.next = b.next, b.next = g), d.pending = g;
  }
  function nC(d, g, b) {
    if ((b & 4194048) !== 0) {
      var C = g.lanes;
      C &= d.pendingLanes, b |= C, g.lanes = b, Hr(d, b);
    }
  }
  var hm = {
    readContext: bo,
    use: $y,
    useCallback: ci,
    useContext: ci,
    useEffect: ci,
    useImperativeHandle: ci,
    useLayoutEffect: ci,
    useInsertionEffect: ci,
    useMemo: ci,
    useReducer: ci,
    useRef: ci,
    useState: ci,
    useDebugValue: ci,
    useDeferredValue: ci,
    useTransition: ci,
    useSyncExternalStore: ci,
    useId: ci,
    useHostTransitionStatus: ci,
    useFormState: ci,
    useActionState: ci,
    useOptimistic: ci,
    useMemoCache: ci,
    useCacheRefresh: ci
  }, rC = {
    readContext: bo,
    use: $y,
    useCallback: function(d, g) {
      return Jo().memoizedState = [
        d,
        g === void 0 ? null : g
      ], d;
    },
    useContext: bo,
    useEffect: $r,
    useImperativeHandle: function(d, g, b) {
      b = b != null ? b.concat([d]) : null, Sf(
        4194308,
        4,
        ol.bind(null, g, d),
        b
      );
    },
    useLayoutEffect: function(d, g) {
      return Sf(4194308, 4, d, g);
    },
    useInsertionEffect: function(d, g) {
      Sf(4, 2, d, g);
    },
    useMemo: function(d, g) {
      var b = Jo();
      g = g === void 0 ? null : g;
      var C = d();
      if (wa) {
        bt(!0);
        try {
          d();
        } finally {
          bt(!1);
        }
      }
      return b.memoizedState = [C, g], C;
    },
    useReducer: function(d, g, b) {
      var C = Jo();
      if (b !== void 0) {
        var I = b(g);
        if (wa) {
          bt(!0);
          try {
            b(g);
          } finally {
            bt(!1);
          }
        }
      } else I = g;
      return C.memoizedState = C.baseState = I, d = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: d,
        lastRenderedState: I
      }, C.queue = d, d = d.dispatch = tC.bind(
        null,
        mn,
        d
      ), [C.memoizedState, d];
    },
    useRef: function(d) {
      var g = Jo();
      return d = { current: d }, g.memoizedState = d;
    },
    useState: function(d) {
      d = lm(d);
      var g = d.queue, b = tb.bind(null, mn, g);
      return g.dispatch = b, [d.memoizedState, b];
    },
    useDebugValue: dm,
    useDeferredValue: function(d, g) {
      var b = Jo();
      return Jy(b, d, g);
    },
    useTransition: function() {
      var d = lm(!1);
      return d = nw.bind(
        null,
        mn,
        d.queue,
        !0,
        !1
      ), Jo().memoizedState = d, [!1, d];
    },
    useSyncExternalStore: function(d, g, b) {
      var C = mn, I = Jo();
      if (Tn) {
        if (b === void 0)
          throw Error(r(407));
        b = b();
      } else {
        if (b = g(), Tr === null)
          throw Error(r(349));
        (Zn & 124) !== 0 || sm(C, g, b);
      }
      I.memoizedState = b;
      var j = { value: b, getSnapshot: g };
      return I.queue = j, $r(HS.bind(null, C, j, d), [
        d
      ]), C.flags |= 2048, nd(
        9,
        Rs(),
        Xy.bind(
          null,
          C,
          j,
          b,
          g
        ),
        null
      ), b;
    },
    useId: function() {
      var d = Jo(), g = Tr.identifierPrefix;
      if (Tn) {
        var b = tl, C = el;
        b = (C & ~(1 << 32 - q(C) - 1)).toString(32) + b, g = "«" + g + "R" + b, b = rm++, 0 < b && (g += "H" + b.toString(32)), g += "»";
      } else
        b = Fy++, g = "«" + g + "r" + b.toString(32) + "»";
      return d.memoizedState = g;
    },
    useHostTransitionStatus: Tf,
    useFormState: Qy,
    useActionState: Qy,
    useOptimistic: function(d) {
      var g = Jo();
      g.memoizedState = g.baseState = d;
      var b = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return g.queue = b, g = fm.bind(
        null,
        mn,
        !0,
        b
      ), b.dispatch = g, [d, g];
    },
    useMemoCache: Wi,
    useCacheRefresh: function() {
      return Jo().memoizedState = NP.bind(
        null,
        mn
      );
    }
  }, aw = {
    readContext: bo,
    use: $y,
    useCallback: Xp,
    useContext: bo,
    useEffect: Q_,
    useImperativeHandle: tw,
    useInsertionEffect: J_,
    useLayoutEffect: ew,
    useMemo: wf,
    useReducer: am,
    useRef: JS,
    useState: function() {
      return am($l);
    },
    useDebugValue: dm,
    useDeferredValue: function(d, g) {
      var b = yi();
      return eb(
        b,
        sr.memoizedState,
        d,
        g
      );
    },
    useTransition: function() {
      var d = am($l)[0], g = yi().memoizedState;
      return [
        typeof d == "boolean" ? d : xf(d),
        g
      ];
    },
    useSyncExternalStore: WS,
    useId: al,
    useHostTransitionStatus: Tf,
    useFormState: KS,
    useActionState: KS,
    useOptimistic: function(d, g) {
      var b = yi();
      return Zy(b, sr, d, g);
    },
    useMemoCache: Wi,
    useCacheRefresh: ow
  }, iC = {
    readContext: bo,
    use: $y,
    useCallback: Xp,
    useContext: bo,
    useEffect: Q_,
    useImperativeHandle: tw,
    useInsertionEffect: J_,
    useLayoutEffect: ew,
    useMemo: wf,
    useReducer: Yy,
    useRef: JS,
    useState: function() {
      return Yy($l);
    },
    useDebugValue: dm,
    useDeferredValue: function(d, g) {
      var b = yi();
      return sr === null ? Jy(b, d, g) : eb(
        b,
        sr.memoizedState,
        d,
        g
      );
    },
    useTransition: function() {
      var d = Yy($l)[0], g = yi().memoizedState;
      return [
        typeof d == "boolean" ? d : xf(d),
        g
      ];
    },
    useSyncExternalStore: WS,
    useId: al,
    useHostTransitionStatus: Tf,
    useFormState: K_,
    useActionState: K_,
    useOptimistic: function(d, g) {
      var b = yi();
      return sr !== null ? Zy(b, sr, d, g) : (b.baseState = d, [d, b.queue.dispatch]);
    },
    useMemoCache: Wi,
    useCacheRefresh: ow
  }, Ea = null, Qp = 0;
  function gm(d) {
    var g = Qp;
    return Qp += 1, Ea === null && (Ea = []), zS(Ea, d, g);
  }
  function mm(d, g) {
    g = g.props.ref, d.ref = g !== void 0 ? g : null;
  }
  function Jp(d, g) {
    throw g.$$typeof === v ? Error(r(525)) : (d = Object.prototype.toString.call(g), Error(
      r(
        31,
        d === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : d
      )
    ));
  }
  function _a(d) {
    var g = d._init;
    return g(d._payload);
  }
  function sw(d) {
    function g(Me, Oe) {
      if (d) {
        var Ve = Me.deletions;
        Ve === null ? (Me.deletions = [Oe], Me.flags |= 16) : Ve.push(Oe);
      }
    }
    function b(Me, Oe) {
      if (!d) return null;
      for (; Oe !== null; )
        g(Me, Oe), Oe = Oe.sibling;
      return null;
    }
    function C(Me) {
      for (var Oe = /* @__PURE__ */ new Map(); Me !== null; )
        Me.key !== null ? Oe.set(Me.key, Me) : Oe.set(Me.index, Me), Me = Me.sibling;
      return Oe;
    }
    function I(Me, Oe) {
      return Me = Js(Me, Oe), Me.index = 0, Me.sibling = null, Me;
    }
    function j(Me, Oe, Ve) {
      return Me.index = Ve, d ? (Ve = Me.alternate, Ve !== null ? (Ve = Ve.index, Ve < Oe ? (Me.flags |= 67108866, Oe) : Ve) : (Me.flags |= 67108866, Oe)) : (Me.flags |= 1048576, Oe);
    }
    function K(Me) {
      return d && Me.alternate === null && (Me.flags |= 67108866), Me;
    }
    function se(Me, Oe, Ve, ft) {
      return Oe === null || Oe.tag !== 6 ? (Oe = Zu(Ve, Me.mode, ft), Oe.return = Me, Oe) : (Oe = I(Oe, Ve), Oe.return = Me, Oe);
    }
    function xe(Me, Oe, Ve, ft) {
      var Bt = Ve.type;
      return Bt === E ? ut(
        Me,
        Oe,
        Ve.props.children,
        ft,
        Ve.key
      ) : Oe !== null && (Oe.elementType === Bt || typeof Bt == "object" && Bt !== null && Bt.$$typeof === H && _a(Bt) === Oe.type) ? (Oe = I(Oe, Ve.props), mm(Oe, Ve), Oe.return = Me, Oe) : (Oe = wn(
        Ve.type,
        Ve.key,
        Ve.props,
        null,
        Me.mode,
        ft
      ), mm(Oe, Ve), Oe.return = Me, Oe);
    }
    function ze(Me, Oe, Ve, ft) {
      return Oe === null || Oe.tag !== 4 || Oe.stateNode.containerInfo !== Ve.containerInfo || Oe.stateNode.implementation !== Ve.implementation ? (Oe = Pp(Ve, Me.mode, ft), Oe.return = Me, Oe) : (Oe = I(Oe, Ve.children || []), Oe.return = Me, Oe);
    }
    function ut(Me, Oe, Ve, ft, Bt) {
      return Oe === null || Oe.tag !== 7 ? (Oe = xt(
        Ve,
        Me.mode,
        ft,
        Bt
      ), Oe.return = Me, Oe) : (Oe = I(Oe, Ve), Oe.return = Me, Oe);
    }
    function pt(Me, Oe, Ve) {
      if (typeof Oe == "string" && Oe !== "" || typeof Oe == "number" || typeof Oe == "bigint")
        return Oe = Zu(
          "" + Oe,
          Me.mode,
          Ve
        ), Oe.return = Me, Oe;
      if (typeof Oe == "object" && Oe !== null) {
        switch (Oe.$$typeof) {
          case y:
            return Ve = wn(
              Oe.type,
              Oe.key,
              Oe.props,
              null,
              Me.mode,
              Ve
            ), mm(Ve, Oe), Ve.return = Me, Ve;
          case S:
            return Oe = Pp(
              Oe,
              Me.mode,
              Ve
            ), Oe.return = Me, Oe;
          case H:
            var ft = Oe._init;
            return Oe = ft(Oe._payload), pt(Me, Oe, Ve);
        }
        if (re(Oe) || F(Oe))
          return Oe = xt(
            Oe,
            Me.mode,
            Ve,
            null
          ), Oe.return = Me, Oe;
        if (typeof Oe.then == "function")
          return pt(Me, gm(Oe), Ve);
        if (Oe.$$typeof === P)
          return pt(
            Me,
            kp(Me, Oe),
            Ve
          );
        Jp(Me, Oe);
      }
      return null;
    }
    function He(Me, Oe, Ve, ft) {
      var Bt = Oe !== null ? Oe.key : null;
      if (typeof Ve == "string" && Ve !== "" || typeof Ve == "number" || typeof Ve == "bigint")
        return Bt !== null ? null : se(Me, Oe, "" + Ve, ft);
      if (typeof Ve == "object" && Ve !== null) {
        switch (Ve.$$typeof) {
          case y:
            return Ve.key === Bt ? xe(Me, Oe, Ve, ft) : null;
          case S:
            return Ve.key === Bt ? ze(Me, Oe, Ve, ft) : null;
          case H:
            return Bt = Ve._init, Ve = Bt(Ve._payload), He(Me, Oe, Ve, ft);
        }
        if (re(Ve) || F(Ve))
          return Bt !== null ? null : ut(Me, Oe, Ve, ft, null);
        if (typeof Ve.then == "function")
          return He(
            Me,
            Oe,
            gm(Ve),
            ft
          );
        if (Ve.$$typeof === P)
          return He(
            Me,
            Oe,
            kp(Me, Ve),
            ft
          );
        Jp(Me, Ve);
      }
      return null;
    }
    function Ze(Me, Oe, Ve, ft, Bt) {
      if (typeof ft == "string" && ft !== "" || typeof ft == "number" || typeof ft == "bigint")
        return Me = Me.get(Ve) || null, se(Oe, Me, "" + ft, Bt);
      if (typeof ft == "object" && ft !== null) {
        switch (ft.$$typeof) {
          case y:
            return Me = Me.get(
              ft.key === null ? Ve : ft.key
            ) || null, xe(Oe, Me, ft, Bt);
          case S:
            return Me = Me.get(
              ft.key === null ? Ve : ft.key
            ) || null, ze(Oe, Me, ft, Bt);
          case H:
            var En = ft._init;
            return ft = En(ft._payload), Ze(
              Me,
              Oe,
              Ve,
              ft,
              Bt
            );
        }
        if (re(ft) || F(ft))
          return Me = Me.get(Ve) || null, ut(Oe, Me, ft, Bt, null);
        if (typeof ft.then == "function")
          return Ze(
            Me,
            Oe,
            Ve,
            gm(ft),
            Bt
          );
        if (ft.$$typeof === P)
          return Ze(
            Me,
            Oe,
            Ve,
            kp(Oe, ft),
            Bt
          );
        Jp(Oe, ft);
      }
      return null;
    }
    function on(Me, Oe, Ve, ft) {
      for (var Bt = null, En = null, Qt = Oe, sn = Oe = 0, oo = null; Qt !== null && sn < Ve.length; sn++) {
        Qt.index > sn ? (oo = Qt, Qt = null) : oo = Qt.sibling;
        var or = He(
          Me,
          Qt,
          Ve[sn],
          ft
        );
        if (or === null) {
          Qt === null && (Qt = oo);
          break;
        }
        d && Qt && or.alternate === null && g(Me, Qt), Oe = j(or, Oe, sn), En === null ? Bt = or : En.sibling = or, En = or, Qt = oo;
      }
      if (sn === Ve.length)
        return b(Me, Qt), Tn && Ii(Me, sn), Bt;
      if (Qt === null) {
        for (; sn < Ve.length; sn++)
          Qt = pt(Me, Ve[sn], ft), Qt !== null && (Oe = j(
            Qt,
            Oe,
            sn
          ), En === null ? Bt = Qt : En.sibling = Qt, En = Qt);
        return Tn && Ii(Me, sn), Bt;
      }
      for (Qt = C(Qt); sn < Ve.length; sn++)
        oo = Ze(
          Qt,
          Me,
          sn,
          Ve[sn],
          ft
        ), oo !== null && (d && oo.alternate !== null && Qt.delete(
          oo.key === null ? sn : oo.key
        ), Oe = j(
          oo,
          Oe,
          sn
        ), En === null ? Bt = oo : En.sibling = oo, En = oo);
      return d && Qt.forEach(function(nc) {
        return g(Me, nc);
      }), Tn && Ii(Me, sn), Bt;
    }
    function en(Me, Oe, Ve, ft) {
      if (Ve == null) throw Error(r(151));
      for (var Bt = null, En = null, Qt = Oe, sn = Oe = 0, oo = null, or = Ve.next(); Qt !== null && !or.done; sn++, or = Ve.next()) {
        Qt.index > sn ? (oo = Qt, Qt = null) : oo = Qt.sibling;
        var nc = He(Me, Qt, or.value, ft);
        if (nc === null) {
          Qt === null && (Qt = oo);
          break;
        }
        d && Qt && nc.alternate === null && g(Me, Qt), Oe = j(nc, Oe, sn), En === null ? Bt = nc : En.sibling = nc, En = nc, Qt = oo;
      }
      if (or.done)
        return b(Me, Qt), Tn && Ii(Me, sn), Bt;
      if (Qt === null) {
        for (; !or.done; sn++, or = Ve.next())
          or = pt(Me, or.value, ft), or !== null && (Oe = j(or, Oe, sn), En === null ? Bt = or : En.sibling = or, En = or);
        return Tn && Ii(Me, sn), Bt;
      }
      for (Qt = C(Qt); !or.done; sn++, or = Ve.next())
        or = Ze(Qt, Me, sn, or.value, ft), or !== null && (d && or.alternate !== null && Qt.delete(or.key === null ? sn : or.key), Oe = j(or, Oe, sn), En === null ? Bt = or : En.sibling = or, En = or);
      return d && Qt.forEach(function(WP) {
        return g(Me, WP);
      }), Tn && Ii(Me, sn), Bt;
    }
    function cr(Me, Oe, Ve, ft) {
      if (typeof Ve == "object" && Ve !== null && Ve.type === E && Ve.key === null && (Ve = Ve.props.children), typeof Ve == "object" && Ve !== null) {
        switch (Ve.$$typeof) {
          case y:
            e: {
              for (var Bt = Ve.key; Oe !== null; ) {
                if (Oe.key === Bt) {
                  if (Bt = Ve.type, Bt === E) {
                    if (Oe.tag === 7) {
                      b(
                        Me,
                        Oe.sibling
                      ), ft = I(
                        Oe,
                        Ve.props.children
                      ), ft.return = Me, Me = ft;
                      break e;
                    }
                  } else if (Oe.elementType === Bt || typeof Bt == "object" && Bt !== null && Bt.$$typeof === H && _a(Bt) === Oe.type) {
                    b(
                      Me,
                      Oe.sibling
                    ), ft = I(Oe, Ve.props), mm(ft, Ve), ft.return = Me, Me = ft;
                    break e;
                  }
                  b(Me, Oe);
                  break;
                } else g(Me, Oe);
                Oe = Oe.sibling;
              }
              Ve.type === E ? (ft = xt(
                Ve.props.children,
                Me.mode,
                ft,
                Ve.key
              ), ft.return = Me, Me = ft) : (ft = wn(
                Ve.type,
                Ve.key,
                Ve.props,
                null,
                Me.mode,
                ft
              ), mm(ft, Ve), ft.return = Me, Me = ft);
            }
            return K(Me);
          case S:
            e: {
              for (Bt = Ve.key; Oe !== null; ) {
                if (Oe.key === Bt)
                  if (Oe.tag === 4 && Oe.stateNode.containerInfo === Ve.containerInfo && Oe.stateNode.implementation === Ve.implementation) {
                    b(
                      Me,
                      Oe.sibling
                    ), ft = I(Oe, Ve.children || []), ft.return = Me, Me = ft;
                    break e;
                  } else {
                    b(Me, Oe);
                    break;
                  }
                else g(Me, Oe);
                Oe = Oe.sibling;
              }
              ft = Pp(Ve, Me.mode, ft), ft.return = Me, Me = ft;
            }
            return K(Me);
          case H:
            return Bt = Ve._init, Ve = Bt(Ve._payload), cr(
              Me,
              Oe,
              Ve,
              ft
            );
        }
        if (re(Ve))
          return on(
            Me,
            Oe,
            Ve,
            ft
          );
        if (F(Ve)) {
          if (Bt = F(Ve), typeof Bt != "function") throw Error(r(150));
          return Ve = Bt.call(Ve), en(
            Me,
            Oe,
            Ve,
            ft
          );
        }
        if (typeof Ve.then == "function")
          return cr(
            Me,
            Oe,
            gm(Ve),
            ft
          );
        if (Ve.$$typeof === P)
          return cr(
            Me,
            Oe,
            kp(Me, Ve),
            ft
          );
        Jp(Me, Ve);
      }
      return typeof Ve == "string" && Ve !== "" || typeof Ve == "number" || typeof Ve == "bigint" ? (Ve = "" + Ve, Oe !== null && Oe.tag === 6 ? (b(Me, Oe.sibling), ft = I(Oe, Ve), ft.return = Me, Me = ft) : (b(Me, Oe), ft = Zu(Ve, Me.mode, ft), ft.return = Me, Me = ft), K(Me)) : b(Me, Oe);
    }
    return function(Me, Oe, Ve, ft) {
      try {
        Qp = 0;
        var Bt = cr(
          Me,
          Oe,
          Ve,
          ft
        );
        return Ea = null, Bt;
      } catch (Qt) {
        if (Qt === mf || Qt === Fp) throw Qt;
        var En = ya(29, Qt, null, Me.mode);
        return En.lanes = ft, En.return = Me, En;
      } finally {
      }
    };
  }
  var eo = sw(!0), lw = sw(!1), Ni = ne(null), sl = null;
  function Ca(d) {
    var g = d.alternate;
    ie(_i, _i.current & 1), ie(Ni, d), sl === null && (g === null || Jc.current !== null || g.memoizedState !== null) && (sl = d);
  }
  function cw(d) {
    if (d.tag === 22) {
      if (ie(_i, _i.current), ie(Ni, d), sl === null) {
        var g = d.alternate;
        g !== null && g.memoizedState !== null && (sl = d);
      }
    } else Lo();
  }
  function Lo() {
    ie(_i, _i.current), ie(Ni, Ni.current);
  }
  function ll(d) {
    ae(Ni), sl === d && (sl = null), ae(_i);
  }
  var _i = ne(0);
  function Ka(d) {
    for (var g = d; g !== null; ) {
      if (g.tag === 13) {
        var b = g.memoizedState;
        if (b !== null && (b = b.dehydrated, b === null || b.data === "$?" || Xw(b)))
          return g;
      } else if (g.tag === 19 && g.memoizedProps.revealOrder !== void 0) {
        if ((g.flags & 128) !== 0) return g;
      } else if (g.child !== null) {
        g.child.return = g, g = g.child;
        continue;
      }
      if (g === d) break;
      for (; g.sibling === null; ) {
        if (g.return === null || g.return === d) return null;
        g = g.return;
      }
      g.sibling.return = g.return, g = g.sibling;
    }
    return null;
  }
  function nb(d, g, b, C) {
    g = d.memoizedState, b = b(C, g), b = b == null ? g : m({}, g, b), d.memoizedState = b, d.lanes === 0 && (d.updateQueue.baseState = b);
  }
  var rd = {
    enqueueSetState: function(d, g, b) {
      d = d._reactInternals;
      var C = ts(), I = Qc(C);
      I.payload = g, b != null && (I.callback = b), g = Sa(d, I, C), g !== null && (Ia(g, d, C), vf(g, d, C));
    },
    enqueueReplaceState: function(d, g, b) {
      d = d._reactInternals;
      var C = ts(), I = Qc(C);
      I.tag = 1, I.payload = g, b != null && (I.callback = b), g = Sa(d, I, C), g !== null && (Ia(g, d, C), vf(g, d, C));
    },
    enqueueForceUpdate: function(d, g) {
      d = d._reactInternals;
      var b = ts(), C = Qc(b);
      C.tag = 2, g != null && (C.callback = g), g = Sa(d, C, b), g !== null && (Ia(g, d, b), vf(g, d, b));
    }
  };
  function uw(d, g, b, C, I, j, K) {
    return d = d.stateNode, typeof d.shouldComponentUpdate == "function" ? d.shouldComponentUpdate(C, j, K) : g.prototype && g.prototype.isPureReactComponent ? !Hc(b, C) || !Hc(I, j) : !0;
  }
  function eh(d, g, b, C) {
    d = g.state, typeof g.componentWillReceiveProps == "function" && g.componentWillReceiveProps(b, C), typeof g.UNSAFE_componentWillReceiveProps == "function" && g.UNSAFE_componentWillReceiveProps(b, C), g.state !== d && rd.enqueueReplaceState(g, g.state, null);
  }
  function Os(d, g) {
    var b = g;
    if ("ref" in g) {
      b = {};
      for (var C in g)
        C !== "ref" && (b[C] = g[C]);
    }
    if (d = d.defaultProps) {
      b === g && (b = m({}, b));
      for (var I in d)
        b[I] === void 0 && (b[I] = d[I]);
    }
    return b;
  }
  var vm = typeof reportError == "function" ? reportError : function(d) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var g = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof d == "object" && d !== null && typeof d.message == "string" ? String(d.message) : String(d),
        error: d
      });
      if (!window.dispatchEvent(g)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", d);
      return;
    }
    console.error(d);
  };
  function dw(d) {
    vm(d);
  }
  function th(d) {
    console.error(d);
  }
  function fw(d) {
    vm(d);
  }
  function Ef(d, g) {
    try {
      var b = d.onUncaughtError;
      b(g.value, { componentStack: g.stack });
    } catch (C) {
      setTimeout(function() {
        throw C;
      });
    }
  }
  function pw(d, g, b) {
    try {
      var C = d.onCaughtError;
      C(b.value, {
        componentStack: b.stack,
        errorBoundary: g.tag === 1 ? g.stateNode : null
      });
    } catch (I) {
      setTimeout(function() {
        throw I;
      });
    }
  }
  function rb(d, g, b) {
    return b = Qc(b), b.tag = 3, b.payload = { element: null }, b.callback = function() {
      Ef(d, g);
    }, b;
  }
  function oC(d) {
    return d = Qc(d), d.tag = 3, d;
  }
  function hw(d, g, b, C) {
    var I = b.type.getDerivedStateFromError;
    if (typeof I == "function") {
      var j = C.value;
      d.payload = function() {
        return I(j);
      }, d.callback = function() {
        pw(g, b, C);
      };
    }
    var K = b.stateNode;
    K !== null && typeof K.componentDidCatch == "function" && (d.callback = function() {
      pw(g, b, C), typeof I != "function" && (Yl === null ? Yl = /* @__PURE__ */ new Set([this]) : Yl.add(this));
      var se = C.stack;
      this.componentDidCatch(C.value, {
        componentStack: se !== null ? se : ""
      });
    });
  }
  function Qa(d, g, b, C, I) {
    if (b.flags |= 32768, C !== null && typeof C == "object" && typeof C.then == "function") {
      if (g = b.alternate, g !== null && Yg(
        g,
        b,
        I,
        !0
      ), b = Ni.current, b !== null) {
        switch (b.tag) {
          case 13:
            return sl === null ? hd() : b.alternate === null && xi === 0 && (xi = 3), b.flags &= -257, b.flags |= 65536, b.lanes = I, C === zy ? b.flags |= 16384 : (g = b.updateQueue, g === null ? b.updateQueue = /* @__PURE__ */ new Set([C]) : g.add(C), _m(d, C, I)), !1;
          case 22:
            return b.flags |= 65536, C === zy ? b.flags |= 16384 : (g = b.updateQueue, g === null ? (g = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([C])
            }, b.updateQueue = g) : (b = g.retryQueue, b === null ? g.retryQueue = /* @__PURE__ */ new Set([C]) : b.add(C)), _m(d, C, I)), !1;
        }
        throw Error(r(435, b.tag));
      }
      return _m(d, C, I), hd(), !1;
    }
    if (Tn)
      return g = Ni.current, g !== null ? ((g.flags & 65536) === 0 && (g.flags |= 256), g.flags |= 65536, g.lanes = I, C !== $g && (d = Error(r(422), { cause: C }), Lp(Xa(d, b)))) : (C !== $g && (g = Error(r(423), {
        cause: C
      }), Lp(
        Xa(g, b)
      )), d = d.current.alternate, d.flags |= 65536, I &= -I, d.lanes |= I, C = Xa(C, b), I = rb(
        d.stateNode,
        C,
        I
      ), em(d, I), xi !== 4 && (xi = 2)), !1;
    var j = Error(r(520), { cause: C });
    if (j = Xa(j, b), wm === null ? wm = [j] : wm.push(j), xi !== 4 && (xi = 2), g === null) return !0;
    C = Xa(C, b), b = g;
    do {
      switch (b.tag) {
        case 3:
          return b.flags |= 65536, d = I & -I, b.lanes |= d, d = rb(b.stateNode, C, d), em(b, d), !1;
        case 1:
          if (g = b.type, j = b.stateNode, (b.flags & 128) === 0 && (typeof g.getDerivedStateFromError == "function" || j !== null && typeof j.componentDidCatch == "function" && (Yl === null || !Yl.has(j))))
            return b.flags |= 65536, I &= -I, b.lanes |= I, I = oC(I), hw(
              I,
              d,
              b,
              C
            ), em(b, I), !1;
      }
      b = b.return;
    } while (b !== null);
    return !1;
  }
  var gw = Error(r(461)), Mn = !1;
  function to(d, g, b, C) {
    g.child = d === null ? lw(g, null, b, C) : eo(
      g,
      d.child,
      b,
      C
    );
  }
  function mw(d, g, b, C, I) {
    b = b.render;
    var j = g.ref;
    if ("ref" in C) {
      var K = {};
      for (var se in C)
        se !== "ref" && (K[se] = C[se]);
    } else K = C;
    return Qu(g), C = Wy(
      d,
      g,
      b,
      K,
      j,
      I
    ), se = Hy(), d !== null && !Mn ? (qy(d, g, I), cl(d, g, I)) : (Tn && se && qg(g), g.flags |= 1, to(d, g, C, I), g.child);
  }
  function aC(d, g, b, C, I) {
    if (d === null) {
      var j = b.type;
      return typeof j == "function" && !Iy(j) && j.defaultProps === void 0 && b.compare === null ? (g.tag = 15, g.type = j, tu(
        d,
        g,
        j,
        C,
        I
      )) : (d = wn(
        b.type,
        null,
        C,
        g,
        g.mode,
        I
      ), d.ref = g.ref, d.return = g, g.child = d);
    }
    if (j = d.child, !cb(d, I)) {
      var K = j.memoizedProps;
      if (b = b.compare, b = b !== null ? b : Hc, b(K, C) && d.ref === g.ref)
        return cl(d, g, I);
    }
    return g.flags |= 1, d = Js(j, C), d.ref = g.ref, d.return = g, g.child = d;
  }
  function tu(d, g, b, C, I) {
    if (d !== null) {
      var j = d.memoizedProps;
      if (Hc(j, C) && d.ref === g.ref)
        if (Mn = !1, g.pendingProps = C = j, cb(d, I))
          (d.flags & 131072) !== 0 && (Mn = !0);
        else
          return g.lanes = d.lanes, cl(d, g, I);
    }
    return ob(
      d,
      g,
      b,
      C,
      I
    );
  }
  function _f(d, g, b) {
    var C = g.pendingProps, I = C.children, j = d !== null ? d.memoizedState : null;
    if (C.mode === "hidden") {
      if ((g.flags & 128) !== 0) {
        if (C = j !== null ? j.baseLanes | b : b, d !== null) {
          for (I = g.child = d.child, j = 0; I !== null; )
            j = j | I.lanes | I.childLanes, I = I.sibling;
          g.childLanes = j & ~C;
        } else g.childLanes = 0, g.child = null;
        return ib(
          d,
          g,
          C,
          b
        );
      }
      if ((b & 536870912) !== 0)
        g.memoizedState = { baseLanes: 0, cachePool: null }, d !== null && Up(
          g,
          j !== null ? j.cachePool : null
        ), j !== null ? US(g, j) : Fi(), cw(g);
      else
        return g.lanes = g.childLanes = 536870912, ib(
          d,
          g,
          j !== null ? j.baseLanes | b : b,
          b
        );
    } else
      j !== null ? (Up(g, j.cachePool), US(g, j), Lo(), g.memoizedState = null) : (d !== null && Up(g, null), Fi(), Lo());
    return to(d, g, I, b), g.child;
  }
  function ib(d, g, b, C) {
    var I = Vp();
    return I = I === null ? null : { parent: Pi._currentValue, pool: I }, g.memoizedState = {
      baseLanes: b,
      cachePool: I
    }, d !== null && Up(g, null), Fi(), cw(g), d !== null && Yg(d, g, C, !0), null;
  }
  function nu(d, g) {
    var b = g.ref;
    if (b === null)
      d !== null && d.ref !== null && (g.flags |= 4194816);
    else {
      if (typeof b != "function" && typeof b != "object")
        throw Error(r(284));
      (d === null || d.ref !== b) && (g.flags |= 4194816);
    }
  }
  function ob(d, g, b, C, I) {
    return Qu(g), b = Wy(
      d,
      g,
      b,
      C,
      void 0,
      I
    ), C = Hy(), d !== null && !Mn ? (qy(d, g, I), cl(d, g, I)) : (Tn && C && qg(g), g.flags |= 1, to(d, g, b, I), g.child);
  }
  function vw(d, g, b, C, I, j) {
    return Qu(g), g.updateQueue = null, b = td(
      g,
      C,
      b,
      I
    ), FS(d), C = Hy(), d !== null && !Mn ? (qy(d, g, j), cl(d, g, j)) : (Tn && C && qg(g), g.flags |= 1, to(d, g, b, j), g.child);
  }
  function yw(d, g, b, C, I) {
    if (Qu(g), g.stateNode === null) {
      var j = hf, K = b.contextType;
      typeof K == "object" && K !== null && (j = bo(K)), j = new b(C, j), g.memoizedState = j.state !== null && j.state !== void 0 ? j.state : null, j.updater = rd, g.stateNode = j, j._reactInternals = g, j = g.stateNode, j.props = C, j.state = g.memoizedState, j.refs = {}, Jg(g), K = b.contextType, j.context = typeof K == "object" && K !== null ? bo(K) : hf, j.state = g.memoizedState, K = b.getDerivedStateFromProps, typeof K == "function" && (nb(
        g,
        b,
        K,
        C
      ), j.state = g.memoizedState), typeof b.getDerivedStateFromProps == "function" || typeof j.getSnapshotBeforeUpdate == "function" || typeof j.UNSAFE_componentWillMount != "function" && typeof j.componentWillMount != "function" || (K = j.state, typeof j.componentWillMount == "function" && j.componentWillMount(), typeof j.UNSAFE_componentWillMount == "function" && j.UNSAFE_componentWillMount(), K !== j.state && rd.enqueueReplaceState(j, j.state, null), qp(g, C, j, I), tm(), j.state = g.memoizedState), typeof j.componentDidMount == "function" && (g.flags |= 4194308), C = !0;
    } else if (d === null) {
      j = g.stateNode;
      var se = g.memoizedProps, xe = Os(b, se);
      j.props = xe;
      var ze = j.context, ut = b.contextType;
      K = hf, typeof ut == "object" && ut !== null && (K = bo(ut));
      var pt = b.getDerivedStateFromProps;
      ut = typeof pt == "function" || typeof j.getSnapshotBeforeUpdate == "function", se = g.pendingProps !== se, ut || typeof j.UNSAFE_componentWillReceiveProps != "function" && typeof j.componentWillReceiveProps != "function" || (se || ze !== K) && eh(
        g,
        j,
        C,
        K
      ), Kc = !1;
      var He = g.memoizedState;
      j.state = He, qp(g, C, j, I), tm(), ze = g.memoizedState, se || He !== ze || Kc ? (typeof pt == "function" && (nb(
        g,
        b,
        pt,
        C
      ), ze = g.memoizedState), (xe = Kc || uw(
        g,
        b,
        xe,
        C,
        He,
        ze,
        K
      )) ? (ut || typeof j.UNSAFE_componentWillMount != "function" && typeof j.componentWillMount != "function" || (typeof j.componentWillMount == "function" && j.componentWillMount(), typeof j.UNSAFE_componentWillMount == "function" && j.UNSAFE_componentWillMount()), typeof j.componentDidMount == "function" && (g.flags |= 4194308)) : (typeof j.componentDidMount == "function" && (g.flags |= 4194308), g.memoizedProps = C, g.memoizedState = ze), j.props = C, j.state = ze, j.context = K, C = xe) : (typeof j.componentDidMount == "function" && (g.flags |= 4194308), C = !1);
    } else {
      j = g.stateNode, Vy(d, g), K = g.memoizedProps, ut = Os(b, K), j.props = ut, pt = g.pendingProps, He = j.context, ze = b.contextType, xe = hf, typeof ze == "object" && ze !== null && (xe = bo(ze)), se = b.getDerivedStateFromProps, (ze = typeof se == "function" || typeof j.getSnapshotBeforeUpdate == "function") || typeof j.UNSAFE_componentWillReceiveProps != "function" && typeof j.componentWillReceiveProps != "function" || (K !== pt || He !== xe) && eh(
        g,
        j,
        C,
        xe
      ), Kc = !1, He = g.memoizedState, j.state = He, qp(g, C, j, I), tm();
      var Ze = g.memoizedState;
      K !== pt || He !== Ze || Kc || d !== null && d.dependencies !== null && Xg(d.dependencies) ? (typeof se == "function" && (nb(
        g,
        b,
        se,
        C
      ), Ze = g.memoizedState), (ut = Kc || uw(
        g,
        b,
        ut,
        C,
        He,
        Ze,
        xe
      ) || d !== null && d.dependencies !== null && Xg(d.dependencies)) ? (ze || typeof j.UNSAFE_componentWillUpdate != "function" && typeof j.componentWillUpdate != "function" || (typeof j.componentWillUpdate == "function" && j.componentWillUpdate(C, Ze, xe), typeof j.UNSAFE_componentWillUpdate == "function" && j.UNSAFE_componentWillUpdate(
        C,
        Ze,
        xe
      )), typeof j.componentDidUpdate == "function" && (g.flags |= 4), typeof j.getSnapshotBeforeUpdate == "function" && (g.flags |= 1024)) : (typeof j.componentDidUpdate != "function" || K === d.memoizedProps && He === d.memoizedState || (g.flags |= 4), typeof j.getSnapshotBeforeUpdate != "function" || K === d.memoizedProps && He === d.memoizedState || (g.flags |= 1024), g.memoizedProps = C, g.memoizedState = Ze), j.props = C, j.state = Ze, j.context = xe, C = ut) : (typeof j.componentDidUpdate != "function" || K === d.memoizedProps && He === d.memoizedState || (g.flags |= 4), typeof j.getSnapshotBeforeUpdate != "function" || K === d.memoizedProps && He === d.memoizedState || (g.flags |= 1024), C = !1);
    }
    return j = C, nu(d, g), C = (g.flags & 128) !== 0, j || C ? (j = g.stateNode, b = C && typeof b.getDerivedStateFromError != "function" ? null : j.render(), g.flags |= 1, d !== null && C ? (g.child = eo(
      g,
      d.child,
      null,
      I
    ), g.child = eo(
      g,
      null,
      b,
      I
    )) : to(d, g, b, I), g.memoizedState = j.state, d = g.child) : d = cl(
      d,
      g,
      I
    ), d;
  }
  function ab(d, g, b, C) {
    return jp(), g.flags |= 256, to(d, g, b, C), g.child;
  }
  var ym = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function sb(d) {
    return { baseLanes: d, cachePool: Kg() };
  }
  function bw(d, g, b) {
    return d = d !== null ? d.childLanes & ~b : 0, g && (d |= Hi), d;
  }
  function sC(d, g, b) {
    var C = g.pendingProps, I = !1, j = (g.flags & 128) !== 0, K;
    if ((K = j) || (K = d !== null && d.memoizedState === null ? !1 : (_i.current & 2) !== 0), K && (I = !0, g.flags &= -129), K = (g.flags & 32) !== 0, g.flags &= -33, d === null) {
      if (Tn) {
        if (I ? Ca(g) : Lo(), Tn) {
          var se = Sr, xe;
          if (xe = se) {
            e: {
              for (xe = se, se = Qo; xe.nodeType !== 8; ) {
                if (!se) {
                  se = null;
                  break e;
                }
                if (xe = gl(
                  xe.nextSibling
                ), xe === null) {
                  se = null;
                  break e;
                }
              }
              se = xe;
            }
            se !== null ? (g.memoizedState = {
              dehydrated: se,
              treeContext: Gc !== null ? { id: el, overflow: tl } : null,
              retryLane: 536870912,
              hydrationErrors: null
            }, xe = ya(
              18,
              null,
              null,
              0
            ), xe.stateNode = se, xe.return = g, g.child = xe, vi = g, Sr = null, xe = !0) : xe = !1;
          }
          xe || nl(g);
        }
        if (se = g.memoizedState, se !== null && (se = se.dehydrated, se !== null))
          return Xw(se) ? g.lanes = 32 : g.lanes = 536870912, null;
        ll(g);
      }
      return se = C.children, C = C.fallback, I ? (Lo(), I = g.mode, se = bm(
        { mode: "hidden", children: se },
        I
      ), C = xt(
        C,
        I,
        b,
        null
      ), se.return = g, C.return = g, se.sibling = C, g.child = se, I = g.child, I.memoizedState = sb(b), I.childLanes = bw(
        d,
        K,
        b
      ), g.memoizedState = ym, C) : (Ca(g), lb(g, se));
    }
    if (xe = d.memoizedState, xe !== null && (se = xe.dehydrated, se !== null)) {
      if (j)
        g.flags & 256 ? (Ca(g), g.flags &= -257, g = xw(
          d,
          g,
          b
        )) : g.memoizedState !== null ? (Lo(), g.child = d.child, g.flags |= 128, g = null) : (Lo(), I = C.fallback, se = g.mode, C = bm(
          { mode: "visible", children: C.children },
          se
        ), I = xt(
          I,
          se,
          b,
          null
        ), I.flags |= 2, C.return = g, I.return = g, C.sibling = I, g.child = C, eo(
          g,
          d.child,
          null,
          b
        ), C = g.child, C.memoizedState = sb(b), C.childLanes = bw(
          d,
          K,
          b
        ), g.memoizedState = ym, g = I);
      else if (Ca(g), Xw(se)) {
        if (K = se.nextSibling && se.nextSibling.dataset, K) var ze = K.dgst;
        K = ze, C = Error(r(419)), C.stack = "", C.digest = K, Lp({ value: C, source: null, stack: null }), g = xw(
          d,
          g,
          b
        );
      } else if (Mn || Yg(d, g, b, !1), K = (b & d.childLanes) !== 0, Mn || K) {
        if (K = Tr, K !== null && (C = b & -b, C = (C & 42) !== 0 ? 1 : jr(C), C = (C & (K.suspendedLanes | b)) !== 0 ? 0 : C, C !== 0 && C !== xe.retryLane))
          throw xe.retryLane = C, $c(d, C), Ia(K, d, C), gw;
        se.data === "$?" || hd(), g = xw(
          d,
          g,
          b
        );
      } else
        se.data === "$?" ? (g.flags |= 192, g.child = d.child, g = null) : (d = xe.treeContext, Sr = gl(
          se.nextSibling
        ), vi = g, Tn = !0, Yc = null, Qo = !1, d !== null && (ba[Es++] = el, ba[Es++] = tl, ba[Es++] = Gc, el = d.id, tl = d.overflow, Gc = g), g = lb(
          g,
          C.children
        ), g.flags |= 4096);
      return g;
    }
    return I ? (Lo(), I = C.fallback, se = g.mode, xe = d.child, ze = xe.sibling, C = Js(xe, {
      mode: "hidden",
      children: C.children
    }), C.subtreeFlags = xe.subtreeFlags & 65011712, ze !== null ? I = Js(ze, I) : (I = xt(
      I,
      se,
      b,
      null
    ), I.flags |= 2), I.return = g, C.return = g, C.sibling = I, g.child = C, C = I, I = g.child, se = d.child.memoizedState, se === null ? se = sb(b) : (xe = se.cachePool, xe !== null ? (ze = Pi._currentValue, xe = xe.parent !== ze ? { parent: ze, pool: ze } : xe) : xe = Kg(), se = {
      baseLanes: se.baseLanes | b,
      cachePool: xe
    }), I.memoizedState = se, I.childLanes = bw(
      d,
      K,
      b
    ), g.memoizedState = ym, C) : (Ca(g), b = d.child, d = b.sibling, b = Js(b, {
      mode: "visible",
      children: C.children
    }), b.return = g, b.sibling = null, d !== null && (K = g.deletions, K === null ? (g.deletions = [d], g.flags |= 16) : K.push(d)), g.child = b, g.memoizedState = null, b);
  }
  function lb(d, g) {
    return g = bm(
      { mode: "visible", children: g },
      d.mode
    ), g.return = d, d.child = g;
  }
  function bm(d, g) {
    return d = ya(22, d, null, g), d.lanes = 0, d.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }, d;
  }
  function xw(d, g, b) {
    return eo(g, d.child, null, b), d = lb(
      g,
      g.pendingProps.children
    ), d.flags |= 2, g.memoizedState = null, d;
  }
  function Cf(d, g, b) {
    d.lanes |= g;
    var C = d.alternate;
    C !== null && (C.lanes |= g), jy(d.return, g, b);
  }
  function nh(d, g, b, C, I) {
    var j = d.memoizedState;
    j === null ? d.memoizedState = {
      isBackwards: g,
      rendering: null,
      renderingStartTime: 0,
      last: C,
      tail: b,
      tailMode: I
    } : (j.isBackwards = g, j.rendering = null, j.renderingStartTime = 0, j.last = C, j.tail = b, j.tailMode = I);
  }
  function Sw(d, g, b) {
    var C = g.pendingProps, I = C.revealOrder, j = C.tail;
    if (to(d, g, C.children, b), C = _i.current, (C & 2) !== 0)
      C = C & 1 | 2, g.flags |= 128;
    else {
      if (d !== null && (d.flags & 128) !== 0)
        e: for (d = g.child; d !== null; ) {
          if (d.tag === 13)
            d.memoizedState !== null && Cf(d, b, g);
          else if (d.tag === 19)
            Cf(d, b, g);
          else if (d.child !== null) {
            d.child.return = d, d = d.child;
            continue;
          }
          if (d === g) break e;
          for (; d.sibling === null; ) {
            if (d.return === null || d.return === g)
              break e;
            d = d.return;
          }
          d.sibling.return = d.return, d = d.sibling;
        }
      C &= 1;
    }
    switch (ie(_i, C), I) {
      case "forwards":
        for (b = g.child, I = null; b !== null; )
          d = b.alternate, d !== null && Ka(d) === null && (I = b), b = b.sibling;
        b = I, b === null ? (I = g.child, g.child = null) : (I = b.sibling, b.sibling = null), nh(
          g,
          !1,
          I,
          b,
          j
        );
        break;
      case "backwards":
        for (b = null, I = g.child, g.child = null; I !== null; ) {
          if (d = I.alternate, d !== null && Ka(d) === null) {
            g.child = I;
            break;
          }
          d = I.sibling, I.sibling = b, b = I, I = d;
        }
        nh(
          g,
          !0,
          b,
          null,
          j
        );
        break;
      case "together":
        nh(g, !1, null, null, void 0);
        break;
      default:
        g.memoizedState = null;
    }
    return g.child;
  }
  function cl(d, g, b) {
    if (d !== null && (g.dependencies = d.dependencies), ud |= g.lanes, (b & g.childLanes) === 0)
      if (d !== null) {
        if (Yg(
          d,
          g,
          b,
          !1
        ), (b & g.childLanes) === 0)
          return null;
      } else return null;
    if (d !== null && g.child !== d.child)
      throw Error(r(153));
    if (g.child !== null) {
      for (d = g.child, b = Js(d, d.pendingProps), g.child = b, b.return = g; d.sibling !== null; )
        d = d.sibling, b = b.sibling = Js(d, d.pendingProps), b.return = g;
      b.sibling = null;
    }
    return g.child;
  }
  function cb(d, g) {
    return (d.lanes & g) !== 0 ? !0 : (d = d.dependencies, !!(d !== null && Xg(d)));
  }
  function lC(d, g, b) {
    switch (g.tag) {
      case 3:
        Ie(g, g.stateNode.containerInfo), Wl(g, Pi, d.memoizedState.cache), jp();
        break;
      case 27:
      case 5:
        De(g);
        break;
      case 4:
        Ie(g, g.stateNode.containerInfo);
        break;
      case 10:
        Wl(
          g,
          g.type,
          g.memoizedProps.value
        );
        break;
      case 13:
        var C = g.memoizedState;
        if (C !== null)
          return C.dehydrated !== null ? (Ca(g), g.flags |= 128, null) : (b & g.child.childLanes) !== 0 ? sC(d, g, b) : (Ca(g), d = cl(
            d,
            g,
            b
          ), d !== null ? d.sibling : null);
        Ca(g);
        break;
      case 19:
        var I = (d.flags & 128) !== 0;
        if (C = (b & g.childLanes) !== 0, C || (Yg(
          d,
          g,
          b,
          !1
        ), C = (b & g.childLanes) !== 0), I) {
          if (C)
            return Sw(
              d,
              g,
              b
            );
          g.flags |= 128;
        }
        if (I = g.memoizedState, I !== null && (I.rendering = null, I.tail = null, I.lastEffect = null), ie(_i, _i.current), C) break;
        return null;
      case 22:
      case 23:
        return g.lanes = 0, _f(d, g, b);
      case 24:
        Wl(g, Pi, d.memoizedState.cache);
    }
    return cl(d, g, b);
  }
  function ww(d, g, b) {
    if (d !== null)
      if (d.memoizedProps !== g.pendingProps)
        Mn = !0;
      else {
        if (!cb(d, b) && (g.flags & 128) === 0)
          return Mn = !1, lC(
            d,
            g,
            b
          );
        Mn = (d.flags & 131072) !== 0;
      }
    else
      Mn = !1, Tn && (g.flags & 1048576) !== 0 && dr(g, Hg, g.index);
    switch (g.lanes = 0, g.tag) {
      case 16:
        e: {
          d = g.pendingProps;
          var C = g.elementType, I = C._init;
          if (C = I(C._payload), g.type = C, typeof C == "function")
            Iy(C) ? (d = Os(C, d), g.tag = 1, g = yw(
              null,
              g,
              C,
              d,
              b
            )) : (g.tag = 0, g = ob(
              null,
              g,
              C,
              d,
              b
            ));
          else {
            if (C != null) {
              if (I = C.$$typeof, I === M) {
                g.tag = 11, g = mw(
                  null,
                  g,
                  C,
                  d,
                  b
                );
                break e;
              } else if (I === U) {
                g.tag = 14, g = aC(
                  null,
                  g,
                  C,
                  d,
                  b
                );
                break e;
              }
            }
            throw g = oe(C) || C, Error(r(306, g, ""));
          }
        }
        return g;
      case 0:
        return ob(
          d,
          g,
          g.type,
          g.pendingProps,
          b
        );
      case 1:
        return C = g.type, I = Os(
          C,
          g.pendingProps
        ), yw(
          d,
          g,
          C,
          I,
          b
        );
      case 3:
        e: {
          if (Ie(
            g,
            g.stateNode.containerInfo
          ), d === null) throw Error(r(387));
          C = g.pendingProps;
          var j = g.memoizedState;
          I = j.element, Vy(d, g), qp(g, C, null, b);
          var K = g.memoizedState;
          if (C = K.cache, Wl(g, Pi, C), C !== j.cache && Ly(
            g,
            [Pi],
            b,
            !0
          ), tm(), C = K.element, j.isDehydrated)
            if (j = {
              element: C,
              isDehydrated: !1,
              cache: K.cache
            }, g.updateQueue.baseState = j, g.memoizedState = j, g.flags & 256) {
              g = ab(
                d,
                g,
                C,
                b
              );
              break e;
            } else if (C !== I) {
              I = Xa(
                Error(r(424)),
                g
              ), Lp(I), g = ab(
                d,
                g,
                C,
                b
              );
              break e;
            } else {
              switch (d = g.stateNode.containerInfo, d.nodeType) {
                case 9:
                  d = d.body;
                  break;
                default:
                  d = d.nodeName === "HTML" ? d.ownerDocument.body : d;
              }
              for (Sr = gl(d.firstChild), vi = g, Tn = !0, Yc = null, Qo = !0, b = lw(
                g,
                null,
                C,
                b
              ), g.child = b; b; )
                b.flags = b.flags & -3 | 4096, b = b.sibling;
            }
          else {
            if (jp(), C === I) {
              g = cl(
                d,
                g,
                b
              );
              break e;
            }
            to(
              d,
              g,
              C,
              b
            );
          }
          g = g.child;
        }
        return g;
      case 26:
        return nu(d, g), d === null ? (b = kb(
          g.type,
          null,
          g.pendingProps,
          null
        )) ? g.memoizedState = b : Tn || (b = g.type, d = g.pendingProps, C = vh(
          me.current
        ).createElement(b), C[jt] = g, C[Jt] = d, Ge(C, b, d), Ne(C), g.stateNode = C) : g.memoizedState = kb(
          g.type,
          d.memoizedProps,
          g.pendingProps,
          d.memoizedState
        ), null;
      case 27:
        return De(g), d === null && Tn && (C = g.stateNode = wo(
          g.type,
          g.pendingProps,
          me.current
        ), vi = g, Qo = !0, I = Sr, So(g.type) ? (Kw = I, Sr = gl(
          C.firstChild
        )) : Sr = I), to(
          d,
          g,
          g.pendingProps.children,
          b
        ), nu(d, g), d === null && (g.flags |= 4194304), g.child;
      case 5:
        return d === null && Tn && ((I = C = Sr) && (C = Yw(
          C,
          g.type,
          g.pendingProps,
          Qo
        ), C !== null ? (g.stateNode = C, vi = g, Sr = gl(
          C.firstChild
        ), Qo = !1, I = !0) : I = !1), I || nl(g)), De(g), I = g.type, j = g.pendingProps, K = d !== null ? d.memoizedProps : null, C = j.children, Nf(I, j) ? C = null : K !== null && Nf(I, K) && (g.flags |= 32), g.memoizedState !== null && (I = Wy(
          d,
          g,
          Z_,
          null,
          null,
          b
        ), To._currentValue = I), nu(d, g), to(d, g, C, b), g.child;
      case 6:
        return d === null && Tn && ((d = b = Sr) && (b = yh(
          b,
          g.pendingProps,
          Qo
        ), b !== null ? (g.stateNode = b, vi = g, Sr = null, d = !0) : d = !1), d || nl(g)), null;
      case 13:
        return sC(d, g, b);
      case 4:
        return Ie(
          g,
          g.stateNode.containerInfo
        ), C = g.pendingProps, d === null ? g.child = eo(
          g,
          null,
          C,
          b
        ) : to(
          d,
          g,
          C,
          b
        ), g.child;
      case 11:
        return mw(
          d,
          g,
          g.type,
          g.pendingProps,
          b
        );
      case 7:
        return to(
          d,
          g,
          g.pendingProps,
          b
        ), g.child;
      case 8:
        return to(
          d,
          g,
          g.pendingProps.children,
          b
        ), g.child;
      case 12:
        return to(
          d,
          g,
          g.pendingProps.children,
          b
        ), g.child;
      case 10:
        return C = g.pendingProps, Wl(g, g.type, C.value), to(
          d,
          g,
          C.children,
          b
        ), g.child;
      case 9:
        return I = g.type._context, C = g.pendingProps.children, Qu(g), I = bo(I), C = C(I), g.flags |= 1, to(d, g, C, b), g.child;
      case 14:
        return aC(
          d,
          g,
          g.type,
          g.pendingProps,
          b
        );
      case 15:
        return tu(
          d,
          g,
          g.type,
          g.pendingProps,
          b
        );
      case 19:
        return Sw(d, g, b);
      case 31:
        return C = g.pendingProps, b = g.mode, C = {
          mode: C.mode,
          children: C.children
        }, d === null ? (b = bm(
          C,
          b
        ), b.ref = g.ref, g.child = b, b.return = g, g = b) : (b = Js(d.child, C), b.ref = g.ref, g.child = b, b.return = g, g = b), g;
      case 22:
        return _f(d, g, b);
      case 24:
        return Qu(g), C = bo(Pi), d === null ? (I = Vp(), I === null && (I = Tr, j = MS(), I.pooledCache = j, j.refCount++, j !== null && (I.pooledCacheLanes |= b), I = j), g.memoizedState = {
          parent: C,
          cache: I
        }, Jg(g), Wl(g, Pi, I)) : ((d.lanes & b) !== 0 && (Vy(d, g), qp(g, null, null, b), tm()), I = d.memoizedState, j = g.memoizedState, I.parent !== C ? (I = { parent: C, cache: C }, g.memoizedState = I, g.lanes === 0 && (g.memoizedState = g.updateQueue.baseState = I), Wl(g, Pi, C)) : (C = j.cache, Wl(g, Pi, C), C !== I.cache && Ly(
          g,
          [Pi],
          b,
          !0
        ))), to(
          d,
          g,
          g.pendingProps.children,
          b
        ), g.child;
      case 29:
        throw g.pendingProps;
    }
    throw Error(r(156, g.tag));
  }
  function ru(d) {
    d.flags |= 4;
  }
  function Tw(d, g) {
    if (g.type !== "stylesheet" || (g.state.loading & 4) !== 0)
      d.flags &= -16777217;
    else if (d.flags |= 16777216, !tT(g)) {
      if (g = Ni.current, g !== null && ((Zn & 4194048) === Zn ? sl !== null : (Zn & 62914560) !== Zn && (Zn & 536870912) === 0 || g !== sl))
        throw Hp = zy, Qg;
      d.flags |= 8192;
    }
  }
  function id(d, g) {
    g !== null && (d.flags |= 4), d.flags & 16384 && (g = d.tag !== 22 ? cn() : 536870912, d.lanes |= g, lh |= g);
  }
  function rh(d, g) {
    if (!Tn)
      switch (d.tailMode) {
        case "hidden":
          g = d.tail;
          for (var b = null; g !== null; )
            g.alternate !== null && (b = g), g = g.sibling;
          b === null ? d.tail = null : b.sibling = null;
          break;
        case "collapsed":
          b = d.tail;
          for (var C = null; b !== null; )
            b.alternate !== null && (C = b), b = b.sibling;
          C === null ? g || d.tail === null ? d.tail = null : d.tail.sibling = null : C.sibling = null;
      }
  }
  function ni(d) {
    var g = d.alternate !== null && d.alternate.child === d.child, b = 0, C = 0;
    if (g)
      for (var I = d.child; I !== null; )
        b |= I.lanes | I.childLanes, C |= I.subtreeFlags & 65011712, C |= I.flags & 65011712, I.return = d, I = I.sibling;
    else
      for (I = d.child; I !== null; )
        b |= I.lanes | I.childLanes, C |= I.subtreeFlags, C |= I.flags, I.return = d, I = I.sibling;
    return d.subtreeFlags |= C, d.childLanes = b, g;
  }
  function wr(d, g, b) {
    var C = g.pendingProps;
    switch (gf(g), g.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ni(g), null;
      case 1:
        return ni(g), null;
      case 3:
        return b = g.stateNode, C = null, d !== null && (C = d.memoizedState.cache), g.memoizedState.cache !== C && (g.flags |= 2048), Hl(Pi), Pe(), b.pendingContext && (b.context = b.pendingContext, b.pendingContext = null), (d === null || d.child === null) && (Mp(g) ? ru(g) : d === null || d.memoizedState.isDehydrated && (g.flags & 256) === 0 || (g.flags |= 1024, PS())), ni(g), null;
      case 26:
        return b = g.memoizedState, d === null ? (ru(g), b !== null ? (ni(g), Tw(g, b)) : (ni(g), g.flags &= -16777217)) : b ? b !== d.memoizedState ? (ru(g), ni(g), Tw(g, b)) : (ni(g), g.flags &= -16777217) : (d.memoizedProps !== C && ru(g), ni(g), g.flags &= -16777217), null;
      case 27:
        Ye(g), b = me.current;
        var I = g.type;
        if (d !== null && g.stateNode != null)
          d.memoizedProps !== C && ru(g);
        else {
          if (!C) {
            if (g.stateNode === null)
              throw Error(r(166));
            return ni(g), null;
          }
          d = he.current, Mp(g) ? Ny(g) : (d = wo(I, C, b), g.stateNode = d, ru(g));
        }
        return ni(g), null;
      case 5:
        if (Ye(g), b = g.type, d !== null && g.stateNode != null)
          d.memoizedProps !== C && ru(g);
        else {
          if (!C) {
            if (g.stateNode === null)
              throw Error(r(166));
            return ni(g), null;
          }
          if (d = he.current, Mp(g))
            Ny(g);
          else {
            switch (I = vh(
              me.current
            ), d) {
              case 1:
                d = I.createElementNS(
                  "http://www.w3.org/2000/svg",
                  b
                );
                break;
              case 2:
                d = I.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  b
                );
                break;
              default:
                switch (b) {
                  case "svg":
                    d = I.createElementNS(
                      "http://www.w3.org/2000/svg",
                      b
                    );
                    break;
                  case "math":
                    d = I.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      b
                    );
                    break;
                  case "script":
                    d = I.createElement("div"), d.innerHTML = "<script><\/script>", d = d.removeChild(d.firstChild);
                    break;
                  case "select":
                    d = typeof C.is == "string" ? I.createElement("select", { is: C.is }) : I.createElement("select"), C.multiple ? d.multiple = !0 : C.size && (d.size = C.size);
                    break;
                  default:
                    d = typeof C.is == "string" ? I.createElement(b, { is: C.is }) : I.createElement(b);
                }
            }
            d[jt] = g, d[Jt] = C;
            e: for (I = g.child; I !== null; ) {
              if (I.tag === 5 || I.tag === 6)
                d.appendChild(I.stateNode);
              else if (I.tag !== 4 && I.tag !== 27 && I.child !== null) {
                I.child.return = I, I = I.child;
                continue;
              }
              if (I === g) break e;
              for (; I.sibling === null; ) {
                if (I.return === null || I.return === g)
                  break e;
                I = I.return;
              }
              I.sibling.return = I.return, I = I.sibling;
            }
            g.stateNode = d;
            e: switch (Ge(d, b, C), b) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                d = !!C.autoFocus;
                break e;
              case "img":
                d = !0;
                break e;
              default:
                d = !1;
            }
            d && ru(g);
          }
        }
        return ni(g), g.flags &= -16777217, null;
      case 6:
        if (d && g.stateNode != null)
          d.memoizedProps !== C && ru(g);
        else {
          if (typeof C != "string" && g.stateNode === null)
            throw Error(r(166));
          if (d = me.current, Mp(g)) {
            if (d = g.stateNode, b = g.memoizedProps, C = null, I = vi, I !== null)
              switch (I.tag) {
                case 27:
                case 5:
                  C = I.memoizedProps;
              }
            d[jt] = g, d = !!(d.nodeValue === b || C !== null && C.suppressHydrationWarning === !0 || OC(d.nodeValue, b)), d || nl(g);
          } else
            d = vh(d).createTextNode(
              C
            ), d[jt] = g, g.stateNode = d;
        }
        return ni(g), null;
      case 13:
        if (C = g.memoizedState, d === null || d.memoizedState !== null && d.memoizedState.dehydrated !== null) {
          if (I = Mp(g), C !== null && C.dehydrated !== null) {
            if (d === null) {
              if (!I) throw Error(r(318));
              if (I = g.memoizedState, I = I !== null ? I.dehydrated : null, !I) throw Error(r(317));
              I[jt] = g;
            } else
              jp(), (g.flags & 128) === 0 && (g.memoizedState = null), g.flags |= 4;
            ni(g), I = !1;
          } else
            I = PS(), d !== null && d.memoizedState !== null && (d.memoizedState.hydrationErrors = I), I = !0;
          if (!I)
            return g.flags & 256 ? (ll(g), g) : (ll(g), null);
        }
        if (ll(g), (g.flags & 128) !== 0)
          return g.lanes = b, g;
        if (b = C !== null, d = d !== null && d.memoizedState !== null, b) {
          C = g.child, I = null, C.alternate !== null && C.alternate.memoizedState !== null && C.alternate.memoizedState.cachePool !== null && (I = C.alternate.memoizedState.cachePool.pool);
          var j = null;
          C.memoizedState !== null && C.memoizedState.cachePool !== null && (j = C.memoizedState.cachePool.pool), j !== I && (C.flags |= 2048);
        }
        return b !== d && b && (g.child.flags |= 8192), id(g, g.updateQueue), ni(g), null;
      case 4:
        return Pe(), d === null && Am(g.stateNode.containerInfo), ni(g), null;
      case 10:
        return Hl(g.type), ni(g), null;
      case 19:
        if (ae(_i), I = g.memoizedState, I === null) return ni(g), null;
        if (C = (g.flags & 128) !== 0, j = I.rendering, j === null)
          if (C) rh(I, !1);
          else {
            if (xi !== 0 || d !== null && (d.flags & 128) !== 0)
              for (d = g.child; d !== null; ) {
                if (j = Ka(d), j !== null) {
                  for (g.flags |= 128, rh(I, !1), d = j.updateQueue, g.updateQueue = d, id(g, d), g.subtreeFlags = 0, d = b, b = g.child; b !== null; )
                    Py(b, d), b = b.sibling;
                  return ie(
                    _i,
                    _i.current & 1 | 2
                  ), g.child;
                }
                d = d.sibling;
              }
            I.tail !== null && L() > hb && (g.flags |= 128, C = !0, rh(I, !1), g.lanes = 4194304);
          }
        else {
          if (!C)
            if (d = Ka(j), d !== null) {
              if (g.flags |= 128, C = !0, d = d.updateQueue, g.updateQueue = d, id(g, d), rh(I, !0), I.tail === null && I.tailMode === "hidden" && !j.alternate && !Tn)
                return ni(g), null;
            } else
              2 * L() - I.renderingStartTime > hb && b !== 536870912 && (g.flags |= 128, C = !0, rh(I, !1), g.lanes = 4194304);
          I.isBackwards ? (j.sibling = g.child, g.child = j) : (d = I.last, d !== null ? d.sibling = j : g.child = j, I.last = j);
        }
        return I.tail !== null ? (g = I.tail, I.rendering = g, I.tail = g.sibling, I.renderingStartTime = L(), g.sibling = null, d = _i.current, ie(_i, C ? d & 1 | 2 : d & 1), g) : (ni(g), null);
      case 22:
      case 23:
        return ll(g), Gp(), C = g.memoizedState !== null, d !== null ? d.memoizedState !== null !== C && (g.flags |= 8192) : C && (g.flags |= 8192), C ? (b & 536870912) !== 0 && (g.flags & 128) === 0 && (ni(g), g.subtreeFlags & 6 && (g.flags |= 8192)) : ni(g), b = g.updateQueue, b !== null && id(g, b.retryQueue), b = null, d !== null && d.memoizedState !== null && d.memoizedState.cachePool !== null && (b = d.memoizedState.cachePool.pool), C = null, g.memoizedState !== null && g.memoizedState.cachePool !== null && (C = g.memoizedState.cachePool.pool), C !== b && (g.flags |= 2048), d !== null && ae(Zc), null;
      case 24:
        return b = null, d !== null && (b = d.memoizedState.cache), g.memoizedState.cache !== b && (g.flags |= 2048), Hl(Pi), ni(g), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(r(156, g.tag));
  }
  function Ew(d, g) {
    switch (gf(g), g.tag) {
      case 1:
        return d = g.flags, d & 65536 ? (g.flags = d & -65537 | 128, g) : null;
      case 3:
        return Hl(Pi), Pe(), d = g.flags, (d & 65536) !== 0 && (d & 128) === 0 ? (g.flags = d & -65537 | 128, g) : null;
      case 26:
      case 27:
      case 5:
        return Ye(g), null;
      case 13:
        if (ll(g), d = g.memoizedState, d !== null && d.dehydrated !== null) {
          if (g.alternate === null)
            throw Error(r(340));
          jp();
        }
        return d = g.flags, d & 65536 ? (g.flags = d & -65537 | 128, g) : null;
      case 19:
        return ae(_i), null;
      case 4:
        return Pe(), null;
      case 10:
        return Hl(g.type), null;
      case 22:
      case 23:
        return ll(g), Gp(), d !== null && ae(Zc), d = g.flags, d & 65536 ? (g.flags = d & -65537 | 128, g) : null;
      case 24:
        return Hl(Pi), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function cC(d, g) {
    switch (gf(g), g.tag) {
      case 3:
        Hl(Pi), Pe();
        break;
      case 26:
      case 27:
      case 5:
        Ye(g);
        break;
      case 4:
        Pe();
        break;
      case 13:
        ll(g);
        break;
      case 19:
        ae(_i);
        break;
      case 10:
        Hl(g.type);
        break;
      case 22:
      case 23:
        ll(g), Gp(), d !== null && ae(Zc);
        break;
      case 24:
        Hl(Pi);
    }
  }
  function ih(d, g) {
    try {
      var b = g.updateQueue, C = b !== null ? b.lastEffect : null;
      if (C !== null) {
        var I = C.next;
        b = I;
        do {
          if ((b.tag & d) === d) {
            C = void 0;
            var j = b.create, K = b.inst;
            C = j(), K.destroy = C;
          }
          b = b.next;
        } while (b !== I);
      }
    } catch (se) {
      Er(g, g.return, se);
    }
  }
  function od(d, g, b) {
    try {
      var C = g.updateQueue, I = C !== null ? C.lastEffect : null;
      if (I !== null) {
        var j = I.next;
        C = j;
        do {
          if ((C.tag & d) === d) {
            var K = C.inst, se = K.destroy;
            if (se !== void 0) {
              K.destroy = void 0, I = g;
              var xe = b, ze = se;
              try {
                ze();
              } catch (ut) {
                Er(
                  I,
                  xe,
                  ut
                );
              }
            }
          }
          C = C.next;
        } while (C !== j);
      }
    } catch (ut) {
      Er(g, g.return, ut);
    }
  }
  function uC(d) {
    var g = d.updateQueue;
    if (g !== null) {
      var b = d.stateNode;
      try {
        Uy(g, b);
      } catch (C) {
        Er(d, d.return, C);
      }
    }
  }
  function ub(d, g, b) {
    b.props = Os(
      d.type,
      d.memoizedProps
    ), b.state = d.memoizedState;
    try {
      b.componentWillUnmount();
    } catch (C) {
      Er(d, g, C);
    }
  }
  function oh(d, g) {
    try {
      var b = d.ref;
      if (b !== null) {
        switch (d.tag) {
          case 26:
          case 27:
          case 5:
            var C = d.stateNode;
            break;
          case 30:
            C = d.stateNode;
            break;
          default:
            C = d.stateNode;
        }
        typeof b == "function" ? d.refCleanup = b(C) : b.current = C;
      }
    } catch (I) {
      Er(d, g, I);
    }
  }
  function ul(d, g) {
    var b = d.ref, C = d.refCleanup;
    if (b !== null)
      if (typeof C == "function")
        try {
          C();
        } catch (I) {
          Er(d, g, I);
        } finally {
          d.refCleanup = null, d = d.alternate, d != null && (d.refCleanup = null);
        }
      else if (typeof b == "function")
        try {
          b(null);
        } catch (I) {
          Er(d, g, I);
        }
      else b.current = null;
  }
  function _w(d) {
    var g = d.type, b = d.memoizedProps, C = d.stateNode;
    try {
      e: switch (g) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          b.autoFocus && C.focus();
          break e;
        case "img":
          b.src ? C.src = b.src : b.srcSet && (C.srcset = b.srcSet);
      }
    } catch (I) {
      Er(d, d.return, I);
    }
  }
  function Rf(d, g, b) {
    try {
      var C = d.stateNode;
      lr(C, d.type, b, g), C[Jt] = g;
    } catch (I) {
      Er(d, d.return, I);
    }
  }
  function dC(d) {
    return d.tag === 5 || d.tag === 3 || d.tag === 26 || d.tag === 27 && So(d.type) || d.tag === 4;
  }
  function Cw(d) {
    e: for (; ; ) {
      for (; d.sibling === null; ) {
        if (d.return === null || dC(d.return)) return null;
        d = d.return;
      }
      for (d.sibling.return = d.return, d = d.sibling; d.tag !== 5 && d.tag !== 6 && d.tag !== 18; ) {
        if (d.tag === 27 && So(d.type) || d.flags & 2 || d.child === null || d.tag === 4) continue e;
        d.child.return = d, d = d.child;
      }
      if (!(d.flags & 2)) return d.stateNode;
    }
  }
  function As(d, g, b) {
    var C = d.tag;
    if (C === 5 || C === 6)
      d = d.stateNode, g ? (b.nodeType === 9 ? b.body : b.nodeName === "HTML" ? b.ownerDocument.body : b).insertBefore(d, g) : (g = b.nodeType === 9 ? b.body : b.nodeName === "HTML" ? b.ownerDocument.body : b, g.appendChild(d), b = b._reactRootContainer, b != null || g.onclick !== null || (g.onclick = Im));
    else if (C !== 4 && (C === 27 && So(d.type) && (b = d.stateNode, g = null), d = d.child, d !== null))
      for (As(d, g, b), d = d.sibling; d !== null; )
        As(d, g, b), d = d.sibling;
  }
  function ad(d, g, b) {
    var C = d.tag;
    if (C === 5 || C === 6)
      d = d.stateNode, g ? b.insertBefore(d, g) : b.appendChild(d);
    else if (C !== 4 && (C === 27 && So(d.type) && (b = d.stateNode), d = d.child, d !== null))
      for (ad(d, g, b), d = d.sibling; d !== null; )
        ad(d, g, b), d = d.sibling;
  }
  function fC(d) {
    var g = d.stateNode, b = d.memoizedProps;
    try {
      for (var C = d.type, I = g.attributes; I.length; )
        g.removeAttributeNode(I[0]);
      Ge(g, C, b), g[jt] = d, g[Jt] = b;
    } catch (j) {
      Er(d, d.return, j);
    }
  }
  var dl = !1, bi = !1, db = !1, Rw = typeof WeakSet == "function" ? WeakSet : Set, Mi = null;
  function pC(d, g) {
    if (d = d.containerInfo, $w = Bm, d = Ug(d), Ry(d)) {
      if ("selectionStart" in d)
        var b = {
          start: d.selectionStart,
          end: d.selectionEnd
        };
      else
        e: {
          b = (b = d.ownerDocument) && b.defaultView || window;
          var C = b.getSelection && b.getSelection();
          if (C && C.rangeCount !== 0) {
            b = C.anchorNode;
            var I = C.anchorOffset, j = C.focusNode;
            C = C.focusOffset;
            try {
              b.nodeType, j.nodeType;
            } catch {
              b = null;
              break e;
            }
            var K = 0, se = -1, xe = -1, ze = 0, ut = 0, pt = d, He = null;
            t: for (; ; ) {
              for (var Ze; pt !== b || I !== 0 && pt.nodeType !== 3 || (se = K + I), pt !== j || C !== 0 && pt.nodeType !== 3 || (xe = K + C), pt.nodeType === 3 && (K += pt.nodeValue.length), (Ze = pt.firstChild) !== null; )
                He = pt, pt = Ze;
              for (; ; ) {
                if (pt === d) break t;
                if (He === b && ++ze === I && (se = K), He === j && ++ut === C && (xe = K), (Ze = pt.nextSibling) !== null) break;
                pt = He, He = pt.parentNode;
              }
              pt = Ze;
            }
            b = se === -1 || xe === -1 ? null : { start: se, end: xe };
          } else b = null;
        }
      b = b || { start: 0, end: 0 };
    } else b = null;
    for (Pm = { focusedElem: d, selectionRange: b }, Bm = !1, Mi = g; Mi !== null; )
      if (g = Mi, d = g.child, (g.subtreeFlags & 1024) !== 0 && d !== null)
        d.return = g, Mi = d;
      else
        for (; Mi !== null; ) {
          switch (g = Mi, j = g.alternate, d = g.flags, g.tag) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((d & 1024) !== 0 && j !== null) {
                d = void 0, b = g, I = j.memoizedProps, j = j.memoizedState, C = b.stateNode;
                try {
                  var on = Os(
                    b.type,
                    I,
                    b.elementType === b.type
                  );
                  d = C.getSnapshotBeforeUpdate(
                    on,
                    j
                  ), C.__reactInternalSnapshotBeforeUpdate = d;
                } catch (en) {
                  Er(
                    b,
                    b.return,
                    en
                  );
                }
              }
              break;
            case 3:
              if ((d & 1024) !== 0) {
                if (d = g.stateNode.containerInfo, b = d.nodeType, b === 9)
                  Nm(d);
                else if (b === 1)
                  switch (d.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Nm(d);
                      break;
                    default:
                      d.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((d & 1024) !== 0) throw Error(r(163));
          }
          if (d = g.sibling, d !== null) {
            d.return = g.return, Mi = d;
            break;
          }
          Mi = g.return;
        }
  }
  function fb(d, g, b) {
    var C = b.flags;
    switch (b.tag) {
      case 0:
      case 11:
      case 15:
        iu(d, b), C & 4 && ih(5, b);
        break;
      case 1:
        if (iu(d, b), C & 4)
          if (d = b.stateNode, g === null)
            try {
              d.componentDidMount();
            } catch (K) {
              Er(b, b.return, K);
            }
          else {
            var I = Os(
              b.type,
              g.memoizedProps
            );
            g = g.memoizedState;
            try {
              d.componentDidUpdate(
                I,
                g,
                d.__reactInternalSnapshotBeforeUpdate
              );
            } catch (K) {
              Er(
                b,
                b.return,
                K
              );
            }
          }
        C & 64 && uC(b), C & 512 && oh(b, b.return);
        break;
      case 3:
        if (iu(d, b), C & 64 && (d = b.updateQueue, d !== null)) {
          if (g = null, b.child !== null)
            switch (b.child.tag) {
              case 27:
              case 5:
                g = b.child.stateNode;
                break;
              case 1:
                g = b.child.stateNode;
            }
          try {
            Uy(d, g);
          } catch (K) {
            Er(b, b.return, K);
          }
        }
        break;
      case 27:
        g === null && C & 4 && fC(b);
      case 26:
      case 5:
        iu(d, b), g === null && C & 4 && _w(b), C & 512 && oh(b, b.return);
        break;
      case 12:
        iu(d, b);
        break;
      case 13:
        iu(d, b), C & 4 && jn(d, b), C & 64 && (d = b.memoizedState, d !== null && (d = d.dehydrated, d !== null && (b = _C.bind(
          null,
          b
        ), Zw(d, b))));
        break;
      case 22:
        if (C = b.memoizedState !== null || dl, !C) {
          g = g !== null && g.memoizedState !== null || bi, I = dl;
          var j = bi;
          dl = C, (bi = g) && !j ? Yr(
            d,
            b,
            (b.subtreeFlags & 8772) !== 0
          ) : iu(d, b), dl = I, bi = j;
        }
        break;
      case 30:
        break;
      default:
        iu(d, b);
    }
  }
  function Ow(d) {
    var g = d.alternate;
    g !== null && (d.alternate = null, Ow(g)), d.child = null, d.deletions = null, d.sibling = null, d.tag === 5 && (g = d.stateNode, g !== null && _t(g)), d.stateNode = null, d.return = null, d.dependencies = null, d.memoizedProps = null, d.memoizedState = null, d.pendingProps = null, d.stateNode = null, d.updateQueue = null;
  }
  var Gr = null, Ra = !1;
  function Ds(d, g, b) {
    for (b = b.child; b !== null; )
      Aw(d, g, b), b = b.sibling;
  }
  function Aw(d, g, b) {
    if (et && typeof et.onCommitFiberUnmount == "function")
      try {
        et.onCommitFiberUnmount(at, b);
      } catch {
      }
    switch (b.tag) {
      case 26:
        bi || ul(b, g), Ds(
          d,
          g,
          b
        ), b.memoizedState ? b.memoizedState.count-- : b.stateNode && (b = b.stateNode, b.parentNode.removeChild(b));
        break;
      case 27:
        bi || ul(b, g);
        var C = Gr, I = Ra;
        So(b.type) && (Gr = b.stateNode, Ra = !1), Ds(
          d,
          g,
          b
        ), Pt(b.stateNode), Gr = C, Ra = I;
        break;
      case 5:
        bi || ul(b, g);
      case 6:
        if (C = Gr, I = Ra, Gr = null, Ds(
          d,
          g,
          b
        ), Gr = C, Ra = I, Gr !== null)
          if (Ra)
            try {
              (Gr.nodeType === 9 ? Gr.body : Gr.nodeName === "HTML" ? Gr.ownerDocument.body : Gr).removeChild(b.stateNode);
            } catch (j) {
              Er(
                b,
                g,
                j
              );
            }
          else
            try {
              Gr.removeChild(b.stateNode);
            } catch (j) {
              Er(
                b,
                g,
                j
              );
            }
        break;
      case 18:
        Gr !== null && (Ra ? (d = Gr, DC(
          d.nodeType === 9 ? d.body : d.nodeName === "HTML" ? d.ownerDocument.body : d,
          b.stateNode
        ), Eh(d)) : DC(Gr, b.stateNode));
        break;
      case 4:
        C = Gr, I = Ra, Gr = b.stateNode.containerInfo, Ra = !0, Ds(
          d,
          g,
          b
        ), Gr = C, Ra = I;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        bi || od(2, b, g), bi || od(4, b, g), Ds(
          d,
          g,
          b
        );
        break;
      case 1:
        bi || (ul(b, g), C = b.stateNode, typeof C.componentWillUnmount == "function" && ub(
          b,
          g,
          C
        )), Ds(
          d,
          g,
          b
        );
        break;
      case 21:
        Ds(
          d,
          g,
          b
        );
        break;
      case 22:
        bi = (C = bi) || b.memoizedState !== null, Ds(
          d,
          g,
          b
        ), bi = C;
        break;
      default:
        Ds(
          d,
          g,
          b
        );
    }
  }
  function jn(d, g) {
    if (g.memoizedState === null && (d = g.alternate, d !== null && (d = d.memoizedState, d !== null && (d = d.dehydrated, d !== null))))
      try {
        Eh(d);
      } catch (b) {
        Er(g, g.return, b);
      }
  }
  function Dw(d) {
    switch (d.tag) {
      case 13:
      case 19:
        var g = d.stateNode;
        return g === null && (g = d.stateNode = new Rw()), g;
      case 22:
        return d = d.stateNode, g = d._retryCache, g === null && (g = d._retryCache = new Rw()), g;
      default:
        throw Error(r(435, d.tag));
    }
  }
  function xm(d, g) {
    var b = Dw(d);
    g.forEach(function(C) {
      var I = MP.bind(null, d, C);
      b.has(C) || (b.add(C), C.then(I, I));
    });
  }
  function Oa(d, g) {
    var b = g.deletions;
    if (b !== null)
      for (var C = 0; C < b.length; C++) {
        var I = b[C], j = d, K = g, se = K;
        e: for (; se !== null; ) {
          switch (se.tag) {
            case 27:
              if (So(se.type)) {
                Gr = se.stateNode, Ra = !1;
                break e;
              }
              break;
            case 5:
              Gr = se.stateNode, Ra = !1;
              break e;
            case 3:
            case 4:
              Gr = se.stateNode.containerInfo, Ra = !0;
              break e;
          }
          se = se.return;
        }
        if (Gr === null) throw Error(r(160));
        Aw(j, K, I), Gr = null, Ra = !1, j = I.alternate, j !== null && (j.return = null), I.return = null;
      }
    if (g.subtreeFlags & 13878)
      for (g = g.child; g !== null; )
        ah(g, d), g = g.sibling;
  }
  var Ja = null;
  function ah(d, g) {
    var b = d.alternate, C = d.flags;
    switch (d.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Oa(g, d), ko(d), C & 4 && (od(3, d, d.return), ih(3, d), od(5, d, d.return));
        break;
      case 1:
        Oa(g, d), ko(d), C & 512 && (bi || b === null || ul(b, b.return)), C & 64 && dl && (d = d.updateQueue, d !== null && (C = d.callbacks, C !== null && (b = d.shared.hiddenCallbacks, d.shared.hiddenCallbacks = b === null ? C : b.concat(C))));
        break;
      case 26:
        var I = Ja;
        if (Oa(g, d), ko(d), C & 512 && (bi || b === null || ul(b, b.return)), C & 4) {
          var j = b !== null ? b.memoizedState : null;
          if (C = d.memoizedState, b === null)
            if (C === null)
              if (d.stateNode === null) {
                e: {
                  C = d.type, b = d.memoizedProps, I = I.ownerDocument || I;
                  t: switch (C) {
                    case "title":
                      j = I.getElementsByTagName("title")[0], (!j || j[gr] || j[jt] || j.namespaceURI === "http://www.w3.org/2000/svg" || j.hasAttribute("itemprop")) && (j = I.createElement(C), I.head.insertBefore(
                        j,
                        I.querySelector("head > title")
                      )), Ge(j, C, b), j[jt] = d, Ne(j), C = j;
                      break e;
                    case "link":
                      var K = xh(
                        "link",
                        "href",
                        I
                      ).get(C + (b.href || ""));
                      if (K) {
                        for (var se = 0; se < K.length; se++)
                          if (j = K[se], j.getAttribute("href") === (b.href == null || b.href === "" ? null : b.href) && j.getAttribute("rel") === (b.rel == null ? null : b.rel) && j.getAttribute("title") === (b.title == null ? null : b.title) && j.getAttribute("crossorigin") === (b.crossOrigin == null ? null : b.crossOrigin)) {
                            K.splice(se, 1);
                            break t;
                          }
                      }
                      j = I.createElement(C), Ge(j, C, b), I.head.appendChild(j);
                      break;
                    case "meta":
                      if (K = xh(
                        "meta",
                        "content",
                        I
                      ).get(C + (b.content || ""))) {
                        for (se = 0; se < K.length; se++)
                          if (j = K[se], j.getAttribute("content") === (b.content == null ? null : "" + b.content) && j.getAttribute("name") === (b.name == null ? null : b.name) && j.getAttribute("property") === (b.property == null ? null : b.property) && j.getAttribute("http-equiv") === (b.httpEquiv == null ? null : b.httpEquiv) && j.getAttribute("charset") === (b.charSet == null ? null : b.charSet)) {
                            K.splice(se, 1);
                            break t;
                          }
                      }
                      j = I.createElement(C), Ge(j, C, b), I.head.appendChild(j);
                      break;
                    default:
                      throw Error(r(468, C));
                  }
                  j[jt] = d, Ne(j), C = j;
                }
                d.stateNode = C;
              } else
                eT(
                  I,
                  d.type,
                  d.stateNode
                );
            else
              d.stateNode = zb(
                I,
                C,
                d.memoizedProps
              );
          else
            j !== C ? (j === null ? b.stateNode !== null && (b = b.stateNode, b.parentNode.removeChild(b)) : j.count--, C === null ? eT(
              I,
              d.type,
              d.stateNode
            ) : zb(
              I,
              C,
              d.memoizedProps
            )) : C === null && d.stateNode !== null && Rf(
              d,
              d.memoizedProps,
              b.memoizedProps
            );
        }
        break;
      case 27:
        Oa(g, d), ko(d), C & 512 && (bi || b === null || ul(b, b.return)), b !== null && C & 4 && Rf(
          d,
          d.memoizedProps,
          b.memoizedProps
        );
        break;
      case 5:
        if (Oa(g, d), ko(d), C & 512 && (bi || b === null || ul(b, b.return)), d.flags & 32) {
          I = d.stateNode;
          try {
            Jd(I, "");
          } catch (Ze) {
            Er(d, d.return, Ze);
          }
        }
        C & 4 && d.stateNode != null && (I = d.memoizedProps, Rf(
          d,
          I,
          b !== null ? b.memoizedProps : I
        )), C & 1024 && (db = !0);
        break;
      case 6:
        if (Oa(g, d), ko(d), C & 4) {
          if (d.stateNode === null)
            throw Error(r(162));
          C = d.memoizedProps, b = d.stateNode;
          try {
            b.nodeValue = C;
          } catch (Ze) {
            Er(d, d.return, Ze);
          }
        }
        break;
      case 3:
        if (Lm = null, I = Ja, Ja = ro(g.containerInfo), Oa(g, d), Ja = I, ko(d), C & 4 && b !== null && b.memoizedState.isDehydrated)
          try {
            Eh(g.containerInfo);
          } catch (Ze) {
            Er(d, d.return, Ze);
          }
        db && (db = !1, Of(d));
        break;
      case 4:
        C = Ja, Ja = ro(
          d.stateNode.containerInfo
        ), Oa(g, d), ko(d), Ja = C;
        break;
      case 12:
        Oa(g, d), ko(d);
        break;
      case 13:
        Oa(g, d), ko(d), d.child.flags & 8192 && d.memoizedState !== null != (b !== null && b.memoizedState !== null) && (Lw = L()), C & 4 && (C = d.updateQueue, C !== null && (d.updateQueue = null, xm(d, C)));
        break;
      case 22:
        I = d.memoizedState !== null;
        var xe = b !== null && b.memoizedState !== null, ze = dl, ut = bi;
        if (dl = ze || I, bi = ut || xe, Oa(g, d), bi = ut, dl = ze, ko(d), C & 8192)
          e: for (g = d.stateNode, g._visibility = I ? g._visibility & -2 : g._visibility | 1, I && (b === null || xe || dl || bi || ou(d)), b = null, g = d; ; ) {
            if (g.tag === 5 || g.tag === 26) {
              if (b === null) {
                xe = b = g;
                try {
                  if (j = xe.stateNode, I)
                    K = j.style, typeof K.setProperty == "function" ? K.setProperty("display", "none", "important") : K.display = "none";
                  else {
                    se = xe.stateNode;
                    var pt = xe.memoizedProps.style, He = pt != null && pt.hasOwnProperty("display") ? pt.display : null;
                    se.style.display = He == null || typeof He == "boolean" ? "" : ("" + He).trim();
                  }
                } catch (Ze) {
                  Er(xe, xe.return, Ze);
                }
              }
            } else if (g.tag === 6) {
              if (b === null) {
                xe = g;
                try {
                  xe.stateNode.nodeValue = I ? "" : xe.memoizedProps;
                } catch (Ze) {
                  Er(xe, xe.return, Ze);
                }
              }
            } else if ((g.tag !== 22 && g.tag !== 23 || g.memoizedState === null || g === d) && g.child !== null) {
              g.child.return = g, g = g.child;
              continue;
            }
            if (g === d) break e;
            for (; g.sibling === null; ) {
              if (g.return === null || g.return === d) break e;
              b === g && (b = null), g = g.return;
            }
            b === g && (b = null), g.sibling.return = g.return, g = g.sibling;
          }
        C & 4 && (C = d.updateQueue, C !== null && (b = C.retryQueue, b !== null && (C.retryQueue = null, xm(d, b))));
        break;
      case 19:
        Oa(g, d), ko(d), C & 4 && (C = d.updateQueue, C !== null && (d.updateQueue = null, xm(d, C)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Oa(g, d), ko(d);
    }
  }
  function ko(d) {
    var g = d.flags;
    if (g & 2) {
      try {
        for (var b, C = d.return; C !== null; ) {
          if (dC(C)) {
            b = C;
            break;
          }
          C = C.return;
        }
        if (b == null) throw Error(r(160));
        switch (b.tag) {
          case 27:
            var I = b.stateNode, j = Cw(d);
            ad(d, j, I);
            break;
          case 5:
            var K = b.stateNode;
            b.flags & 32 && (Jd(K, ""), b.flags &= -33);
            var se = Cw(d);
            ad(d, se, K);
            break;
          case 3:
          case 4:
            var xe = b.stateNode.containerInfo, ze = Cw(d);
            As(
              d,
              ze,
              xe
            );
            break;
          default:
            throw Error(r(161));
        }
      } catch (ut) {
        Er(d, d.return, ut);
      }
      d.flags &= -3;
    }
    g & 4096 && (d.flags &= -4097);
  }
  function Of(d) {
    if (d.subtreeFlags & 1024)
      for (d = d.child; d !== null; ) {
        var g = d;
        Of(g), g.tag === 5 && g.flags & 1024 && g.stateNode.reset(), d = d.sibling;
      }
  }
  function iu(d, g) {
    if (g.subtreeFlags & 8772)
      for (g = g.child; g !== null; )
        fb(d, g.alternate, g), g = g.sibling;
  }
  function ou(d) {
    for (d = d.child; d !== null; ) {
      var g = d;
      switch (g.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          od(4, g, g.return), ou(g);
          break;
        case 1:
          ul(g, g.return);
          var b = g.stateNode;
          typeof b.componentWillUnmount == "function" && ub(
            g,
            g.return,
            b
          ), ou(g);
          break;
        case 27:
          Pt(g.stateNode);
        case 26:
        case 5:
          ul(g, g.return), ou(g);
          break;
        case 22:
          g.memoizedState === null && ou(g);
          break;
        case 30:
          ou(g);
          break;
        default:
          ou(g);
      }
      d = d.sibling;
    }
  }
  function Yr(d, g, b) {
    for (b = b && (g.subtreeFlags & 8772) !== 0, g = g.child; g !== null; ) {
      var C = g.alternate, I = d, j = g, K = j.flags;
      switch (j.tag) {
        case 0:
        case 11:
        case 15:
          Yr(
            I,
            j,
            b
          ), ih(4, j);
          break;
        case 1:
          if (Yr(
            I,
            j,
            b
          ), C = j, I = C.stateNode, typeof I.componentDidMount == "function")
            try {
              I.componentDidMount();
            } catch (ze) {
              Er(C, C.return, ze);
            }
          if (C = j, I = C.updateQueue, I !== null) {
            var se = C.stateNode;
            try {
              var xe = I.shared.hiddenCallbacks;
              if (xe !== null)
                for (I.shared.hiddenCallbacks = null, I = 0; I < xe.length; I++)
                  $p(xe[I], se);
            } catch (ze) {
              Er(C, C.return, ze);
            }
          }
          b && K & 64 && uC(j), oh(j, j.return);
          break;
        case 27:
          fC(j);
        case 26:
        case 5:
          Yr(
            I,
            j,
            b
          ), b && C === null && K & 4 && _w(j), oh(j, j.return);
          break;
        case 12:
          Yr(
            I,
            j,
            b
          );
          break;
        case 13:
          Yr(
            I,
            j,
            b
          ), b && K & 4 && jn(I, j);
          break;
        case 22:
          j.memoizedState === null && Yr(
            I,
            j,
            b
          ), oh(j, j.return);
          break;
        case 30:
          break;
        default:
          Yr(
            I,
            j,
            b
          );
      }
      g = g.sibling;
    }
  }
  function Iw(d, g) {
    var b = null;
    d !== null && d.memoizedState !== null && d.memoizedState.cachePool !== null && (b = d.memoizedState.cachePool.pool), d = null, g.memoizedState !== null && g.memoizedState.cachePool !== null && (d = g.memoizedState.cachePool.pool), d !== b && (d != null && d.refCount++, b != null && Ju(b));
  }
  function Is(d, g) {
    d = null, g.alternate !== null && (d = g.alternate.memoizedState.cache), g = g.memoizedState.cache, g !== d && (g.refCount++, d != null && Ju(d));
  }
  function fl(d, g, b, C) {
    if (g.subtreeFlags & 10256)
      for (g = g.child; g !== null; )
        au(
          d,
          g,
          b,
          C
        ), g = g.sibling;
  }
  function au(d, g, b, C) {
    var I = g.flags;
    switch (g.tag) {
      case 0:
      case 11:
      case 15:
        fl(
          d,
          g,
          b,
          C
        ), I & 2048 && ih(9, g);
        break;
      case 1:
        fl(
          d,
          g,
          b,
          C
        );
        break;
      case 3:
        fl(
          d,
          g,
          b,
          C
        ), I & 2048 && (d = null, g.alternate !== null && (d = g.alternate.memoizedState.cache), g = g.memoizedState.cache, g !== d && (g.refCount++, d != null && Ju(d)));
        break;
      case 12:
        if (I & 2048) {
          fl(
            d,
            g,
            b,
            C
          ), d = g.stateNode;
          try {
            var j = g.memoizedProps, K = j.id, se = j.onPostCommit;
            typeof se == "function" && se(
              K,
              g.alternate === null ? "mount" : "update",
              d.passiveEffectDuration,
              -0
            );
          } catch (xe) {
            Er(g, g.return, xe);
          }
        } else
          fl(
            d,
            g,
            b,
            C
          );
        break;
      case 13:
        fl(
          d,
          g,
          b,
          C
        );
        break;
      case 23:
        break;
      case 22:
        j = g.stateNode, K = g.alternate, g.memoizedState !== null ? j._visibility & 2 ? fl(
          d,
          g,
          b,
          C
        ) : sd(d, g) : j._visibility & 2 ? fl(
          d,
          g,
          b,
          C
        ) : (j._visibility |= 2, Af(
          d,
          g,
          b,
          C,
          (g.subtreeFlags & 10256) !== 0
        )), I & 2048 && Iw(K, g);
        break;
      case 24:
        fl(
          d,
          g,
          b,
          C
        ), I & 2048 && Is(g.alternate, g);
        break;
      default:
        fl(
          d,
          g,
          b,
          C
        );
    }
  }
  function Af(d, g, b, C, I) {
    for (I = I && (g.subtreeFlags & 10256) !== 0, g = g.child; g !== null; ) {
      var j = d, K = g, se = b, xe = C, ze = K.flags;
      switch (K.tag) {
        case 0:
        case 11:
        case 15:
          Af(
            j,
            K,
            se,
            xe,
            I
          ), ih(8, K);
          break;
        case 23:
          break;
        case 22:
          var ut = K.stateNode;
          K.memoizedState !== null ? ut._visibility & 2 ? Af(
            j,
            K,
            se,
            xe,
            I
          ) : sd(
            j,
            K
          ) : (ut._visibility |= 2, Af(
            j,
            K,
            se,
            xe,
            I
          )), I && ze & 2048 && Iw(
            K.alternate,
            K
          );
          break;
        case 24:
          Af(
            j,
            K,
            se,
            xe,
            I
          ), I && ze & 2048 && Is(K.alternate, K);
          break;
        default:
          Af(
            j,
            K,
            se,
            xe,
            I
          );
      }
      g = g.sibling;
    }
  }
  function sd(d, g) {
    if (g.subtreeFlags & 10256)
      for (g = g.child; g !== null; ) {
        var b = d, C = g, I = C.flags;
        switch (C.tag) {
          case 22:
            sd(b, C), I & 2048 && Iw(
              C.alternate,
              C
            );
            break;
          case 24:
            sd(b, C), I & 2048 && Is(C.alternate, C);
            break;
          default:
            sd(b, C);
        }
        g = g.sibling;
      }
  }
  var rr = 8192;
  function ld(d) {
    if (d.subtreeFlags & rr)
      for (d = d.child; d !== null; )
        no(d), d = d.sibling;
  }
  function no(d) {
    switch (d.tag) {
      case 26:
        ld(d), d.flags & rr && d.memoizedState !== null && NC(
          Ja,
          d.memoizedState,
          d.memoizedProps
        );
        break;
      case 5:
        ld(d);
        break;
      case 3:
      case 4:
        var g = Ja;
        Ja = ro(d.stateNode.containerInfo), ld(d), Ja = g;
        break;
      case 22:
        d.memoizedState === null && (g = d.alternate, g !== null && g.memoizedState !== null ? (g = rr, rr = 16777216, ld(d), rr = g) : ld(d));
        break;
      default:
        ld(d);
    }
  }
  function hC(d) {
    var g = d.alternate;
    if (g !== null && (d = g.child, d !== null)) {
      g.child = null;
      do
        g = d.sibling, d.sibling = null, d = g;
      while (d !== null);
    }
  }
  function sh(d) {
    var g = d.deletions;
    if ((d.flags & 16) !== 0) {
      if (g !== null)
        for (var b = 0; b < g.length; b++) {
          var C = g[b];
          Mi = C, es(
            C,
            d
          );
        }
      hC(d);
    }
    if (d.subtreeFlags & 10256)
      for (d = d.child; d !== null; )
        pb(d), d = d.sibling;
  }
  function pb(d) {
    switch (d.tag) {
      case 0:
      case 11:
      case 15:
        sh(d), d.flags & 2048 && od(9, d, d.return);
        break;
      case 3:
        sh(d);
        break;
      case 12:
        sh(d);
        break;
      case 22:
        var g = d.stateNode;
        d.memoizedState !== null && g._visibility & 2 && (d.return === null || d.return.tag !== 13) ? (g._visibility &= -3, Sm(d)) : sh(d);
        break;
      default:
        sh(d);
    }
  }
  function Sm(d) {
    var g = d.deletions;
    if ((d.flags & 16) !== 0) {
      if (g !== null)
        for (var b = 0; b < g.length; b++) {
          var C = g[b];
          Mi = C, es(
            C,
            d
          );
        }
      hC(d);
    }
    for (d = d.child; d !== null; ) {
      switch (g = d, g.tag) {
        case 0:
        case 11:
        case 15:
          od(8, g, g.return), Sm(g);
          break;
        case 22:
          b = g.stateNode, b._visibility & 2 && (b._visibility &= -3, Sm(g));
          break;
        default:
          Sm(g);
      }
      d = d.sibling;
    }
  }
  function es(d, g) {
    for (; Mi !== null; ) {
      var b = Mi;
      switch (b.tag) {
        case 0:
        case 11:
        case 15:
          od(8, b, g);
          break;
        case 23:
        case 22:
          if (b.memoizedState !== null && b.memoizedState.cachePool !== null) {
            var C = b.memoizedState.cachePool.pool;
            C != null && C.refCount++;
          }
          break;
        case 24:
          Ju(b.memoizedState.cache);
      }
      if (C = b.child, C !== null) C.return = b, Mi = C;
      else
        e: for (b = d; Mi !== null; ) {
          C = Mi;
          var I = C.sibling, j = C.return;
          if (Ow(C), C === b) {
            Mi = null;
            break e;
          }
          if (I !== null) {
            I.return = j, Mi = I;
            break e;
          }
          Mi = j;
        }
    }
  }
  var gC = {
    getCacheForType: function(d) {
      var g = bo(Pi), b = g.data.get(d);
      return b === void 0 && (b = d(), g.data.set(d, b)), b;
    }
  }, Pw = typeof WeakMap == "function" ? WeakMap : Map, fr = 0, Tr = null, Ln = null, Zn = 0, ir = 0, Aa = null, su = !1, cd = !1, Nw = !1, lu = 0, xi = 0, ud = 0, dd = 0, Mw = 0, Hi = 0, lh = 0, wm = null, ea = null, jw = !1, Lw = 0, hb = 1 / 0, gb = null, Yl = null, xo = 0, fd = null, pd = null, ch = 0, Da = 0, mb = null, kw = null, uh = 0, vb = null;
  function ts() {
    if ((fr & 2) !== 0 && Zn !== 0)
      return Zn & -Zn;
    if (Z.T !== null) {
      var d = ed;
      return d !== 0 ? d : Rb();
    }
    return ei();
  }
  function mC() {
    Hi === 0 && (Hi = (Zn & 536870912) === 0 || Tn ? Rt() : 536870912);
    var d = Ni.current;
    return d !== null && (d.flags |= 32), Hi;
  }
  function Ia(d, g, b) {
    (d === Tr && (ir === 2 || ir === 9) || d.cancelPendingCommit !== null) && (pl(d, 0), cu(
      d,
      Zn,
      Hi,
      !1
    )), Zt(d, b), ((fr & 2) === 0 || d !== Tr) && (d === Tr && ((fr & 2) === 0 && (dd |= b), xi === 4 && cu(
      d,
      Zn,
      Hi,
      !1
    )), hl(d));
  }
  function vC(d, g, b) {
    if ((fr & 6) !== 0) throw Error(r(327));
    var C = !b && (g & 124) === 0 && (g & d.expiredLanes) === 0 || ht(d, g), I = C ? bb(d, g) : Df(d, g, !0), j = C;
    do {
      if (I === 0) {
        cd && !C && cu(d, g, 0, !1);
        break;
      } else {
        if (b = d.current.alternate, j && !yb(b)) {
          I = Df(d, g, !1), j = !1;
          continue;
        }
        if (I === 2) {
          if (j = g, d.errorRecoveryDisabledLanes & j)
            var K = 0;
          else
            K = d.pendingLanes & -536870913, K = K !== 0 ? K : K & 536870912 ? 536870912 : 0;
          if (K !== 0) {
            g = K;
            e: {
              var se = d;
              I = wm;
              var xe = se.current.memoizedState.isDehydrated;
              if (xe && (pl(se, K).flags |= 256), K = Df(
                se,
                K,
                !1
              ), K !== 2) {
                if (Nw && !xe) {
                  se.errorRecoveryDisabledLanes |= j, dd |= j, I = 4;
                  break e;
                }
                j = ea, ea = I, j !== null && (ea === null ? ea = j : ea.push.apply(
                  ea,
                  j
                ));
              }
              I = K;
            }
            if (j = !1, I !== 2) continue;
          }
        }
        if (I === 1) {
          pl(d, 0), cu(d, g, 0, !0);
          break;
        }
        e: {
          switch (C = d, j = I, j) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((g & 4194048) !== g) break;
            case 6:
              cu(
                C,
                g,
                Hi,
                !su
              );
              break e;
            case 2:
              ea = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if ((g & 62914560) === g && (I = Lw + 300 - L(), 10 < I)) {
            if (cu(
              C,
              g,
              Hi,
              !su
            ), ct(C, 0, !0) !== 0) break e;
            C.timeoutHandle = Kl(
              dh.bind(
                null,
                C,
                b,
                ea,
                gb,
                jw,
                g,
                Hi,
                dd,
                lh,
                su,
                j,
                2,
                -0,
                0
              ),
              I
            );
            break e;
          }
          dh(
            C,
            b,
            ea,
            gb,
            jw,
            g,
            Hi,
            dd,
            lh,
            su,
            j,
            0,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    hl(d);
  }
  function dh(d, g, b, C, I, j, K, se, xe, ze, ut, pt, He, Ze) {
    if (d.timeoutHandle = -1, pt = g.subtreeFlags, (pt & 8192 || (pt & 16785408) === 16785408) && (Sh = { stylesheets: null, count: 0, unsuspend: PC }, no(g), pt = MC(), pt !== null)) {
      d.cancelPendingCommit = pt(
        xC.bind(
          null,
          d,
          g,
          j,
          b,
          C,
          I,
          K,
          se,
          xe,
          ut,
          1,
          He,
          Ze
        )
      ), cu(d, j, K, !ze);
      return;
    }
    xC(
      d,
      g,
      j,
      b,
      C,
      I,
      K,
      se,
      xe
    );
  }
  function yb(d) {
    for (var g = d; ; ) {
      var b = g.tag;
      if ((b === 0 || b === 11 || b === 15) && g.flags & 16384 && (b = g.updateQueue, b !== null && (b = b.stores, b !== null)))
        for (var C = 0; C < b.length; C++) {
          var I = b[C], j = I.getSnapshot;
          I = I.value;
          try {
            if (!Ko(j(), I)) return !1;
          } catch {
            return !1;
          }
        }
      if (b = g.child, g.subtreeFlags & 16384 && b !== null)
        b.return = g, g = b;
      else {
        if (g === d) break;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === d) return !0;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }
    return !0;
  }
  function cu(d, g, b, C) {
    g &= ~Mw, g &= ~dd, d.suspendedLanes |= g, d.pingedLanes &= ~g, C && (d.warmLanes |= g), C = d.expirationTimes;
    for (var I = g; 0 < I; ) {
      var j = 31 - q(I), K = 1 << j;
      C[j] = -1, I &= ~K;
    }
    b !== 0 && xr(d, b, g);
  }
  function Tm() {
    return (fr & 6) === 0 ? (uu(0), !1) : !0;
  }
  function fh() {
    if (Ln !== null) {
      if (ir === 0)
        var d = Ln.return;
      else
        d = Ln, rl = Xc = null, Yp(d), Ea = null, Qp = 0, d = Ln;
      for (; d !== null; )
        cC(d.alternate, d), d = d.return;
      Ln = null;
    }
  }
  function pl(d, g) {
    var b = d.timeoutHandle;
    b !== -1 && (d.timeoutHandle = -1, Gw(b)), b = d.cancelPendingCommit, b !== null && (d.cancelPendingCommit = null, b()), fh(), Tr = d, Ln = b = Js(d.current, null), Zn = g, ir = 0, Aa = null, su = !1, cd = ht(d, g), Nw = !1, lh = Hi = Mw = dd = ud = xi = 0, ea = wm = null, jw = !1, (g & 8) !== 0 && (g |= g & 32);
    var C = d.entangledLanes;
    if (C !== 0)
      for (d = d.entanglements, C &= g; 0 < C; ) {
        var I = 31 - q(C), j = 1 << I;
        g |= d[I], C &= ~j;
      }
    return lu = g, Ks(), b;
  }
  function ph(d, g) {
    mn = null, Z.H = hm, g === mf || g === Fp ? (g = By(), ir = 3) : g === Qg ? (g = By(), ir = 4) : ir = g === gw ? 8 : g !== null && typeof g == "object" && typeof g.then == "function" ? 6 : 1, Aa = g, Ln === null && (xi = 1, Ef(
      d,
      Xa(g, d.current)
    ));
  }
  function zw() {
    var d = Z.H;
    return Z.H = hm, d === null ? hm : d;
  }
  function yC() {
    var d = Z.A;
    return Z.A = gC, d;
  }
  function hd() {
    xi = 4, su || (Zn & 4194048) !== Zn && Ni.current !== null || (cd = !0), (ud & 134217727) === 0 && (dd & 134217727) === 0 || Tr === null || cu(
      Tr,
      Zn,
      Hi,
      !1
    );
  }
  function Df(d, g, b) {
    var C = fr;
    fr |= 2;
    var I = zw(), j = yC();
    (Tr !== d || Zn !== g) && (gb = null, pl(d, g)), g = !1;
    var K = xi;
    e: do
      try {
        if (ir !== 0 && Ln !== null) {
          var se = Ln, xe = Aa;
          switch (ir) {
            case 8:
              fh(), K = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              Ni.current === null && (g = !0);
              var ze = ir;
              if (ir = 0, Aa = null, If(d, se, xe, ze), b && cd) {
                K = 0;
                break e;
              }
              break;
            default:
              ze = ir, ir = 0, Aa = null, If(d, se, xe, ze);
          }
        }
        bC(), K = xi;
        break;
      } catch (ut) {
        ph(d, ut);
      }
    while (!0);
    return g && d.shellSuspendCounter++, rl = Xc = null, fr = C, Z.H = I, Z.A = j, Ln === null && (Tr = null, Zn = 0, Ks()), K;
  }
  function bC() {
    for (; Ln !== null; ) xb(Ln);
  }
  function bb(d, g) {
    var b = fr;
    fr |= 2;
    var C = zw(), I = yC();
    Tr !== d || Zn !== g ? (gb = null, hb = L() + 500, pl(d, g)) : cd = ht(
      d,
      g
    );
    e: do
      try {
        if (ir !== 0 && Ln !== null) {
          g = Ln;
          var j = Aa;
          t: switch (ir) {
            case 1:
              ir = 0, Aa = null, If(d, g, j, 1);
              break;
            case 2:
            case 9:
              if (kS(j)) {
                ir = 0, Aa = null, Vw(g);
                break;
              }
              g = function() {
                ir !== 2 && ir !== 9 || Tr !== d || (ir = 7), hl(d);
              }, j.then(g, g);
              break e;
            case 3:
              ir = 7;
              break e;
            case 4:
              ir = 5;
              break e;
            case 7:
              kS(j) ? (ir = 0, Aa = null, Vw(g)) : (ir = 0, Aa = null, If(d, g, j, 7));
              break;
            case 5:
              var K = null;
              switch (Ln.tag) {
                case 26:
                  K = Ln.memoizedState;
                case 5:
                case 27:
                  var se = Ln;
                  if (!K || tT(K)) {
                    ir = 0, Aa = null;
                    var xe = se.sibling;
                    if (xe !== null) Ln = xe;
                    else {
                      var ze = se.return;
                      ze !== null ? (Ln = ze, Sb(ze)) : Ln = null;
                    }
                    break t;
                  }
              }
              ir = 0, Aa = null, If(d, g, j, 5);
              break;
            case 6:
              ir = 0, Aa = null, If(d, g, j, 6);
              break;
            case 8:
              fh(), xi = 6;
              break e;
            default:
              throw Error(r(462));
          }
        }
        Bw();
        break;
      } catch (ut) {
        ph(d, ut);
      }
    while (!0);
    return rl = Xc = null, Z.H = C, Z.A = I, fr = b, Ln !== null ? 0 : (Tr = null, Zn = 0, Ks(), xi);
  }
  function Bw() {
    for (; Ln !== null && !Te(); )
      xb(Ln);
  }
  function xb(d) {
    var g = ww(d.alternate, d, lu);
    d.memoizedProps = d.pendingProps, g === null ? Sb(d) : Ln = g;
  }
  function Vw(d) {
    var g = d, b = g.alternate;
    switch (g.tag) {
      case 15:
      case 0:
        g = vw(
          b,
          g,
          g.pendingProps,
          g.type,
          void 0,
          Zn
        );
        break;
      case 11:
        g = vw(
          b,
          g,
          g.pendingProps,
          g.type.render,
          g.ref,
          Zn
        );
        break;
      case 5:
        Yp(g);
      default:
        cC(b, g), g = Ln = Py(g, lu), g = ww(b, g, lu);
    }
    d.memoizedProps = d.pendingProps, g === null ? Sb(d) : Ln = g;
  }
  function If(d, g, b, C) {
    rl = Xc = null, Yp(g), Ea = null, Qp = 0;
    var I = g.return;
    try {
      if (Qa(
        d,
        I,
        g,
        b,
        Zn
      )) {
        xi = 1, Ef(
          d,
          Xa(b, d.current)
        ), Ln = null;
        return;
      }
    } catch (j) {
      if (I !== null) throw Ln = I, j;
      xi = 1, Ef(
        d,
        Xa(b, d.current)
      ), Ln = null;
      return;
    }
    g.flags & 32768 ? (Tn || C === 1 ? d = !0 : cd || (Zn & 536870912) !== 0 ? d = !1 : (su = d = !0, (C === 2 || C === 9 || C === 3 || C === 6) && (C = Ni.current, C !== null && C.tag === 13 && (C.flags |= 16384))), Uw(g, d)) : Sb(g);
  }
  function Sb(d) {
    var g = d;
    do {
      if ((g.flags & 32768) !== 0) {
        Uw(
          g,
          su
        );
        return;
      }
      d = g.return;
      var b = wr(
        g.alternate,
        g,
        lu
      );
      if (b !== null) {
        Ln = b;
        return;
      }
      if (g = g.sibling, g !== null) {
        Ln = g;
        return;
      }
      Ln = g = d;
    } while (g !== null);
    xi === 0 && (xi = 5);
  }
  function Uw(d, g) {
    do {
      var b = Ew(d.alternate, d);
      if (b !== null) {
        b.flags &= 32767, Ln = b;
        return;
      }
      if (b = d.return, b !== null && (b.flags |= 32768, b.subtreeFlags = 0, b.deletions = null), !g && (d = d.sibling, d !== null)) {
        Ln = d;
        return;
      }
      Ln = d = b;
    } while (d !== null);
    xi = 6, Ln = null;
  }
  function xC(d, g, b, C, I, j, K, se, xe) {
    d.cancelPendingCommit = null;
    do
      Tb();
    while (xo !== 0);
    if ((fr & 6) !== 0) throw Error(r(327));
    if (g !== null) {
      if (g === d.current) throw Error(r(177));
      if (j = g.lanes | g.childLanes, j |= Wg, dn(
        d,
        b,
        j,
        K,
        se,
        xe
      ), d === Tr && (Ln = Tr = null, Zn = 0), pd = g, fd = d, ch = b, Da = j, mb = I, kw = C, (g.subtreeFlags & 10256) !== 0 || (g.flags & 10256) !== 0 ? (d.callbackNode = null, d.callbackPriority = 0, jP(We, function() {
        return TC(), null;
      })) : (d.callbackNode = null, d.callbackPriority = 0), C = (g.flags & 13878) !== 0, (g.subtreeFlags & 13878) !== 0 || C) {
        C = Z.T, Z.T = null, I = ee.p, ee.p = 2, K = fr, fr |= 4;
        try {
          pC(d, g, b);
        } finally {
          fr = K, ee.p = I, Z.T = C;
        }
      }
      xo = 1, SC(), wC(), Em();
    }
  }
  function SC() {
    if (xo === 1) {
      xo = 0;
      var d = fd, g = pd, b = (g.flags & 13878) !== 0;
      if ((g.subtreeFlags & 13878) !== 0 || b) {
        b = Z.T, Z.T = null;
        var C = ee.p;
        ee.p = 2;
        var I = fr;
        fr |= 4;
        try {
          ah(g, d);
          var j = Pm, K = Ug(d.containerInfo), se = j.focusedElem, xe = j.selectionRange;
          if (K !== se && se && se.ownerDocument && qr(
            se.ownerDocument.documentElement,
            se
          )) {
            if (xe !== null && Ry(se)) {
              var ze = xe.start, ut = xe.end;
              if (ut === void 0 && (ut = ze), "selectionStart" in se)
                se.selectionStart = ze, se.selectionEnd = Math.min(
                  ut,
                  se.value.length
                );
              else {
                var pt = se.ownerDocument || document, He = pt && pt.defaultView || window;
                if (He.getSelection) {
                  var Ze = He.getSelection(), on = se.textContent.length, en = Math.min(xe.start, on), cr = xe.end === void 0 ? en : Math.min(xe.end, on);
                  !Ze.extend && en > cr && (K = cr, cr = en, en = K);
                  var Me = $u(
                    se,
                    en
                  ), Oe = $u(
                    se,
                    cr
                  );
                  if (Me && Oe && (Ze.rangeCount !== 1 || Ze.anchorNode !== Me.node || Ze.anchorOffset !== Me.offset || Ze.focusNode !== Oe.node || Ze.focusOffset !== Oe.offset)) {
                    var Ve = pt.createRange();
                    Ve.setStart(Me.node, Me.offset), Ze.removeAllRanges(), en > cr ? (Ze.addRange(Ve), Ze.extend(Oe.node, Oe.offset)) : (Ve.setEnd(Oe.node, Oe.offset), Ze.addRange(Ve));
                  }
                }
              }
            }
            for (pt = [], Ze = se; Ze = Ze.parentNode; )
              Ze.nodeType === 1 && pt.push({
                element: Ze,
                left: Ze.scrollLeft,
                top: Ze.scrollTop
              });
            for (typeof se.focus == "function" && se.focus(), se = 0; se < pt.length; se++) {
              var ft = pt[se];
              ft.element.scrollLeft = ft.left, ft.element.scrollTop = ft.top;
            }
          }
          Bm = !!$w, Pm = $w = null;
        } finally {
          fr = I, ee.p = C, Z.T = b;
        }
      }
      d.current = g, xo = 2;
    }
  }
  function wC() {
    if (xo === 2) {
      xo = 0;
      var d = fd, g = pd, b = (g.flags & 8772) !== 0;
      if ((g.subtreeFlags & 8772) !== 0 || b) {
        b = Z.T, Z.T = null;
        var C = ee.p;
        ee.p = 2;
        var I = fr;
        fr |= 4;
        try {
          fb(d, g.alternate, g);
        } finally {
          fr = I, ee.p = C, Z.T = b;
        }
      }
      xo = 3;
    }
  }
  function Em() {
    if (xo === 4 || xo === 3) {
      xo = 0, Je();
      var d = fd, g = pd, b = ch, C = kw;
      (g.subtreeFlags & 10256) !== 0 || (g.flags & 10256) !== 0 ? xo = 5 : (xo = 0, pd = fd = null, wb(d, d.pendingLanes));
      var I = d.pendingLanes;
      if (I === 0 && (Yl = null), Ut(b), g = g.stateNode, et && typeof et.onCommitFiberRoot == "function")
        try {
          et.onCommitFiberRoot(
            at,
            g,
            void 0,
            (g.current.flags & 128) === 128
          );
        } catch {
        }
      if (C !== null) {
        g = Z.T, I = ee.p, ee.p = 2, Z.T = null;
        try {
          for (var j = d.onRecoverableError, K = 0; K < C.length; K++) {
            var se = C[K];
            j(se.value, {
              componentStack: se.stack
            });
          }
        } finally {
          Z.T = g, ee.p = I;
        }
      }
      (ch & 3) !== 0 && Tb(), hl(d), I = d.pendingLanes, (b & 4194090) !== 0 && (I & 42) !== 0 ? d === vb ? uh++ : (uh = 0, vb = d) : uh = 0, uu(0);
    }
  }
  function wb(d, g) {
    (d.pooledCacheLanes &= g) === 0 && (g = d.pooledCache, g != null && (d.pooledCache = null, Ju(g)));
  }
  function Tb(d) {
    return SC(), wC(), Em(), TC();
  }
  function TC() {
    if (xo !== 5) return !1;
    var d = fd, g = Da;
    Da = 0;
    var b = Ut(ch), C = Z.T, I = ee.p;
    try {
      ee.p = 32 > b ? 32 : b, Z.T = null, b = mb, mb = null;
      var j = fd, K = ch;
      if (xo = 0, pd = fd = null, ch = 0, (fr & 6) !== 0) throw Error(r(331));
      var se = fr;
      if (fr |= 4, pb(j.current), au(
        j,
        j.current,
        K,
        b
      ), fr = se, uu(0, !1), et && typeof et.onPostCommitFiberRoot == "function")
        try {
          et.onPostCommitFiberRoot(at, j);
        } catch {
        }
      return !0;
    } finally {
      ee.p = I, Z.T = C, wb(d, g);
    }
  }
  function Fw(d, g, b) {
    g = Xa(b, g), g = rb(d.stateNode, g, 2), d = Sa(d, g, 2), d !== null && (Zt(d, 2), hl(d));
  }
  function Er(d, g, b) {
    if (d.tag === 3)
      Fw(d, d, b);
    else
      for (; g !== null; ) {
        if (g.tag === 3) {
          Fw(
            g,
            d,
            b
          );
          break;
        } else if (g.tag === 1) {
          var C = g.stateNode;
          if (typeof g.type.getDerivedStateFromError == "function" || typeof C.componentDidCatch == "function" && (Yl === null || !Yl.has(C))) {
            d = Xa(b, d), b = oC(2), C = Sa(g, b, 2), C !== null && (hw(
              b,
              C,
              g,
              d
            ), Zt(C, 2), hl(C));
            break;
          }
        }
        g = g.return;
      }
  }
  function _m(d, g, b) {
    var C = d.pingCache;
    if (C === null) {
      C = d.pingCache = new Pw();
      var I = /* @__PURE__ */ new Set();
      C.set(g, I);
    } else
      I = C.get(g), I === void 0 && (I = /* @__PURE__ */ new Set(), C.set(g, I));
    I.has(b) || (Nw = !0, I.add(b), d = EC.bind(null, d, g, b), g.then(d, d));
  }
  function EC(d, g, b) {
    var C = d.pingCache;
    C !== null && C.delete(g), d.pingedLanes |= d.suspendedLanes & b, d.warmLanes &= ~b, Tr === d && (Zn & b) === b && (xi === 4 || xi === 3 && (Zn & 62914560) === Zn && 300 > L() - Lw ? (fr & 2) === 0 && pl(d, 0) : Mw |= b, lh === Zn && (lh = 0)), hl(d);
  }
  function Eb(d, g) {
    g === 0 && (g = cn()), d = $c(d, g), d !== null && (Zt(d, g), hl(d));
  }
  function _C(d) {
    var g = d.memoizedState, b = 0;
    g !== null && (b = g.retryLane), Eb(d, b);
  }
  function MP(d, g) {
    var b = 0;
    switch (d.tag) {
      case 13:
        var C = d.stateNode, I = d.memoizedState;
        I !== null && (b = I.retryLane);
        break;
      case 19:
        C = d.stateNode;
        break;
      case 22:
        C = d.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    C !== null && C.delete(g), Eb(d, b);
  }
  function jP(d, g) {
    return ve(d, g);
  }
  var _b = null, hh = null, Cm = !1, gh = !1, Rm = !1, gd = 0;
  function hl(d) {
    d !== hh && d.next === null && (hh === null ? _b = hh = d : hh = hh.next = d), gh = !0, Cm || (Cm = !0, Cb());
  }
  function uu(d, g) {
    if (!Rm && gh) {
      Rm = !0;
      do
        for (var b = !1, C = _b; C !== null; ) {
          if (d !== 0) {
            var I = C.pendingLanes;
            if (I === 0) var j = 0;
            else {
              var K = C.suspendedLanes, se = C.pingedLanes;
              j = (1 << 31 - q(42 | d) + 1) - 1, j &= I & ~(K & ~se), j = j & 201326741 ? j & 201326741 | 1 : j ? j | 2 : 0;
            }
            j !== 0 && (b = !0, CC(C, j));
          } else
            j = Zn, j = ct(
              C,
              C === Tr ? j : 0,
              C.cancelPendingCommit !== null || C.timeoutHandle !== -1
            ), (j & 3) === 0 || ht(C, j) || (b = !0, CC(C, j));
          C = C.next;
        }
      while (b);
      Rm = !1;
    }
  }
  function LP() {
    Ww();
  }
  function Ww() {
    gh = Cm = !1;
    var d = 0;
    gd !== 0 && (Mb() && (d = gd), gd = 0);
    for (var g = L(), b = null, C = _b; C !== null; ) {
      var I = C.next, j = Om(C, g);
      j === 0 ? (C.next = null, b === null ? _b = I : b.next = I, I === null && (hh = b)) : (b = C, (d !== 0 || (j & 3) !== 0) && (gh = !0)), C = I;
    }
    uu(d);
  }
  function Om(d, g) {
    for (var b = d.suspendedLanes, C = d.pingedLanes, I = d.expirationTimes, j = d.pendingLanes & -62914561; 0 < j; ) {
      var K = 31 - q(j), se = 1 << K, xe = I[K];
      xe === -1 ? ((se & b) === 0 || (se & C) !== 0) && (I[K] = Yt(se, g)) : xe <= g && (d.expiredLanes |= se), j &= ~se;
    }
    if (g = Tr, b = Zn, b = ct(
      d,
      d === g ? b : 0,
      d.cancelPendingCommit !== null || d.timeoutHandle !== -1
    ), C = d.callbackNode, b === 0 || d === g && (ir === 2 || ir === 9) || d.cancelPendingCommit !== null)
      return C !== null && C !== null && rt(C), d.callbackNode = null, d.callbackPriority = 0;
    if ((b & 3) === 0 || ht(d, b)) {
      if (g = b & -b, g === d.callbackPriority) return g;
      switch (C !== null && rt(C), Ut(b)) {
        case 2:
        case 8:
          b = ke;
          break;
        case 32:
          b = We;
          break;
        case 268435456:
          b = je;
          break;
        default:
          b = We;
      }
      return C = Hw.bind(null, d), b = ve(b, C), d.callbackPriority = g, d.callbackNode = b, g;
    }
    return C !== null && C !== null && rt(C), d.callbackPriority = 2, d.callbackNode = null, 2;
  }
  function Hw(d, g) {
    if (xo !== 0 && xo !== 5)
      return d.callbackNode = null, d.callbackPriority = 0, null;
    var b = d.callbackNode;
    if (Tb() && d.callbackNode !== b)
      return null;
    var C = Zn;
    return C = ct(
      d,
      d === Tr ? C : 0,
      d.cancelPendingCommit !== null || d.timeoutHandle !== -1
    ), C === 0 ? null : (vC(d, C, g), Om(d, L()), d.callbackNode != null && d.callbackNode === b ? Hw.bind(null, d) : null);
  }
  function CC(d, g) {
    if (Tb()) return null;
    vC(d, g, !0);
  }
  function Cb() {
    BP(function() {
      (fr & 6) !== 0 ? ve(
        ge,
        LP
      ) : Ww();
    });
  }
  function Rb() {
    return gd === 0 && (gd = Rt()), gd;
  }
  function mh(d) {
    return d == null || typeof d == "symbol" || typeof d == "boolean" ? null : typeof d == "function" ? d : Pg("" + d);
  }
  function Ob(d, g) {
    var b = g.ownerDocument.createElement("input");
    return b.name = g.name, b.value = g.value, d.id && b.setAttribute("form", d.id), g.parentNode.insertBefore(b, g), d = new FormData(d), b.parentNode.removeChild(b), d;
  }
  function Ab(d, g, b, C, I) {
    if (g === "submit" && b && b.stateNode === I) {
      var j = mh(
        (I[Jt] || null).action
      ), K = C.submitter;
      K && (g = (g = K[Jt] || null) ? mh(g.formAction) : K.getAttribute("formAction"), g !== null && (j = g, K = null));
      var se = new jg(
        "action",
        "action",
        null,
        C,
        I
      );
      d.push({
        event: se,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (C.defaultPrevented) {
                if (gd !== 0) {
                  var xe = K ? Ob(I, K) : new FormData(I);
                  rw(
                    b,
                    {
                      pending: !0,
                      data: xe,
                      method: I.method,
                      action: j
                    },
                    null,
                    xe
                  );
                }
              } else
                typeof j == "function" && (se.preventDefault(), xe = K ? Ob(I, K) : new FormData(I), rw(
                  b,
                  {
                    pending: !0,
                    data: xe,
                    method: I.method,
                    action: j
                  },
                  j,
                  xe
                ));
            },
            currentTarget: I
          }
        ]
      });
    }
  }
  for (var Db = 0; Db < Dy.length; Db++) {
    var Si = Dy[Db], qw = Si.toLowerCase(), kP = Si[0].toUpperCase() + Si.slice(1);
    va(
      qw,
      "on" + kP
    );
  }
  va(Fg, "onAnimationEnd"), va(Y_, "onAnimationIteration"), va(RS, "onAnimationStart"), va("dblclick", "onDoubleClick"), va("focusin", "onFocus"), va("focusout", "onBlur"), va(DP, "onTransitionRun"), va(OS, "onTransitionStart"), va(Ay, "onTransitionCancel"), va(AS, "onTransitionEnd"), fn("onMouseEnter", ["mouseout", "mouseover"]), fn("onMouseLeave", ["mouseout", "mouseover"]), fn("onPointerEnter", ["pointerout", "pointerover"]), fn("onPointerLeave", ["pointerout", "pointerover"]), zt(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), zt(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), zt("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), zt(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), zt(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), zt(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var pn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), zP = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(pn)
  );
  function du(d, g) {
    g = (g & 4) !== 0;
    for (var b = 0; b < d.length; b++) {
      var C = d[b], I = C.event;
      C = C.listeners;
      e: {
        var j = void 0;
        if (g)
          for (var K = C.length - 1; 0 <= K; K--) {
            var se = C[K], xe = se.instance, ze = se.currentTarget;
            if (se = se.listener, xe !== j && I.isPropagationStopped())
              break e;
            j = se, I.currentTarget = ze;
            try {
              j(I);
            } catch (ut) {
              vm(ut);
            }
            I.currentTarget = null, j = xe;
          }
        else
          for (K = 0; K < C.length; K++) {
            if (se = C[K], xe = se.instance, ze = se.currentTarget, se = se.listener, xe !== j && I.isPropagationStopped())
              break e;
            j = se, I.currentTarget = ze;
            try {
              j(I);
            } catch (ut) {
              vm(ut);
            }
            I.currentTarget = null, j = xe;
          }
      }
    }
  }
  function bn(d, g) {
    var b = g[Ai];
    b === void 0 && (b = g[Ai] = /* @__PURE__ */ new Set());
    var C = d + "__bubble";
    b.has(C) || (RC(g, d, 2, !1), b.add(C));
  }
  function md(d, g, b) {
    var C = 0;
    g && (C |= 4), RC(
      b,
      d,
      C,
      g
    );
  }
  var Pf = "_reactListening" + Math.random().toString(36).slice(2);
  function Am(d) {
    if (!d[Pf]) {
      d[Pf] = !0, vt.forEach(function(b) {
        b !== "selectionchange" && (zP.has(b) || md(b, !1, d), md(b, !0, d));
      });
      var g = d.nodeType === 9 ? d : d.ownerDocument;
      g === null || g[Pf] || (g[Pf] = !0, md("selectionchange", !1, g));
    }
  }
  function RC(d, g, b, C) {
    switch (zC(g)) {
      case 2:
        var I = LC;
        break;
      case 8:
        I = kC;
        break;
      default:
        I = Fb;
    }
    b = I.bind(
      null,
      g,
      b,
      d
    ), I = void 0, !py || g !== "touchstart" && g !== "touchmove" && g !== "wheel" || (I = !0), C ? I !== void 0 ? d.addEventListener(g, b, {
      capture: !0,
      passive: I
    }) : d.addEventListener(g, b, !0) : I !== void 0 ? d.addEventListener(g, b, {
      passive: I
    }) : d.addEventListener(g, b, !1);
  }
  function Dm(d, g, b, C, I) {
    var j = C;
    if ((g & 1) === 0 && (g & 2) === 0 && C !== null)
      e: for (; ; ) {
        if (C === null) return;
        var K = C.tag;
        if (K === 3 || K === 4) {
          var se = C.stateNode.containerInfo;
          if (se === I) break;
          if (K === 4)
            for (K = C.return; K !== null; ) {
              var xe = K.tag;
              if ((xe === 3 || xe === 4) && K.stateNode.containerInfo === I)
                return;
              K = K.return;
            }
          for (; se !== null; ) {
            if (K = mi(se), K === null) return;
            if (xe = K.tag, xe === 5 || xe === 6 || xe === 26 || xe === 27) {
              C = j = K;
              continue e;
            }
            se = se.parentNode;
          }
        }
        C = C.return;
      }
    k_(function() {
      var ze = j, ut = ef(b), pt = [];
      e: {
        var He = DS.get(d);
        if (He !== void 0) {
          var Ze = jg, on = d;
          switch (d) {
            case "keypress":
              if (Mg(b) === 0) break e;
            case "keydown":
            case "keyup":
              Ze = of;
              break;
            case "focusin":
              on = "focus", Ze = hS;
              break;
            case "focusout":
              on = "blur", Ze = hS;
              break;
            case "beforeblur":
            case "afterblur":
              Ze = hS;
              break;
            case "click":
              if (b.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ze = kg;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ze = V_;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ze = by;
              break;
            case Fg:
            case Y_:
            case RS:
              Ze = CP;
              break;
            case AS:
              Ze = ma;
              break;
            case "scroll":
            case "scrollend":
              Ze = EP;
              break;
            case "wheel":
              Ze = xy;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ze = OP;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ze = ga;
              break;
            case "toggle":
            case "beforetoggle":
              Ze = yS;
          }
          var en = (g & 4) !== 0, cr = !en && (d === "scroll" || d === "scrollend"), Me = en ? He !== null ? He + "Capture" : null : He;
          en = [];
          for (var Oe = ze, Ve; Oe !== null; ) {
            var ft = Oe;
            if (Ve = ft.stateNode, ft = ft.tag, ft !== 5 && ft !== 26 && ft !== 27 || Ve === null || Me === null || (ft = Fc(Oe, Me), ft != null && en.push(
              Pa(Oe, ft, Ve)
            )), cr) break;
            Oe = Oe.return;
          }
          0 < en.length && (He = new Ze(
            He,
            on,
            null,
            b,
            ut
          ), pt.push({ event: He, listeners: en }));
        }
      }
      if ((g & 7) === 0) {
        e: {
          if (He = d === "mouseover" || d === "pointerover", Ze = d === "mouseout" || d === "pointerout", He && b !== fy && (on = b.relatedTarget || b.fromElement) && (mi(on) || on[Nn]))
            break e;
          if ((Ze || He) && (He = ut.window === ut ? ut : (He = ut.ownerDocument) ? He.defaultView || He.parentWindow : window, Ze ? (on = b.relatedTarget || b.toElement, Ze = ze, on = on ? mi(on) : null, on !== null && (cr = o(on), en = on.tag, on !== cr || en !== 5 && en !== 27 && en !== 6) && (on = null)) : (Ze = null, on = ze), Ze !== on)) {
            if (en = kg, ft = "onMouseLeave", Me = "onMouseEnter", Oe = "mouse", (d === "pointerout" || d === "pointerover") && (en = ga, ft = "onPointerLeave", Me = "onPointerEnter", Oe = "pointer"), cr = Ze == null ? He : Le(Ze), Ve = on == null ? He : Le(on), He = new en(
              ft,
              Oe + "leave",
              Ze,
              b,
              ut
            ), He.target = cr, He.relatedTarget = Ve, ft = null, mi(ut) === ze && (en = new en(
              Me,
              Oe + "enter",
              on,
              b,
              ut
            ), en.target = Ve, en.relatedTarget = cr, ft = en), cr = ft, Ze && on)
              t: {
                for (en = Ze, Me = on, Oe = 0, Ve = en; Ve; Ve = yd(Ve))
                  Oe++;
                for (Ve = 0, ft = Me; ft; ft = yd(ft))
                  Ve++;
                for (; 0 < Oe - Ve; )
                  en = yd(en), Oe--;
                for (; 0 < Ve - Oe; )
                  Me = yd(Me), Ve--;
                for (; Oe--; ) {
                  if (en === Me || Me !== null && en === Me.alternate)
                    break t;
                  en = yd(en), Me = yd(Me);
                }
                en = null;
              }
            else en = null;
            Ze !== null && Ib(
              pt,
              He,
              Ze,
              en,
              !1
            ), on !== null && cr !== null && Ib(
              pt,
              cr,
              on,
              en,
              !0
            );
          }
        }
        e: {
          if (He = ze ? Le(ze) : window, Ze = He.nodeName && He.nodeName.toLowerCase(), Ze === "select" || Ze === "input" && He.type === "file")
            var Bt = Hu;
          else if (wS(He))
            if (TS)
              Bt = Wc;
            else {
              Bt = Cy;
              var En = G_;
            }
          else
            Ze = He.nodeName, !Ze || Ze.toLowerCase() !== "input" || He.type !== "checkbox" && He.type !== "radio" ? ze && wp(ze.elementType) && (Bt = Hu) : Bt = qu;
          if (Bt && (Bt = Bt(d, ze))) {
            Ey(
              pt,
              Bt,
              b,
              ut
            );
            break e;
          }
          En && En(d, He, ze), d === "focusout" && ze && He.type === "number" && ze.memoizedProps.value != null && Dg(He, "number", He.value);
        }
        switch (En = ze ? Le(ze) : window, d) {
          case "focusin":
            (wS(En) || En.contentEditable === "true") && (Ts = En, ff = ze, Ya = null);
            break;
          case "focusout":
            Ya = ff = Ts = null;
            break;
          case "mousedown":
            Ap = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Ap = !1, Dp(pt, b, ut);
            break;
          case "selectionchange":
            if (CS) break;
          case "keydown":
          case "keyup":
            Dp(pt, b, ut);
        }
        var Qt;
        if (Sy)
          e: {
            switch (d) {
              case "compositionstart":
                var sn = "onCompositionStart";
                break e;
              case "compositionend":
                sn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                sn = "onCompositionUpdate";
                break e;
            }
            sn = void 0;
          }
        else
          ws ? Ty(d, b) && (sn = "onCompositionEnd") : d === "keydown" && b.keyCode === 229 && (sn = "onCompositionStart");
        sn && (wy && b.locale !== "ko" && (ws || sn !== "onCompositionStart" ? sn === "onCompositionEnd" && ws && (Qt = Ng()) : (Ss = ut, hy = "value" in Ss ? Ss.value : Ss.textContent, ws = !0)), En = vd(ze, sn), 0 < En.length && (sn = new gS(
          sn,
          d,
          null,
          b,
          ut
        ), pt.push({ event: sn, listeners: En }), Qt ? sn.data = Qt : (Qt = Bg(b), Qt !== null && (sn.data = Qt)))), (Qt = AP ? xS(d, b) : SS(d, b)) && (sn = vd(ze, "onBeforeInput"), 0 < sn.length && (En = new gS(
          "onBeforeInput",
          "beforeinput",
          null,
          b,
          ut
        ), pt.push({
          event: En,
          listeners: sn
        }), En.data = Qt)), Ab(
          pt,
          d,
          ze,
          b,
          ut
        );
      }
      du(pt, g);
    });
  }
  function Pa(d, g, b) {
    return {
      instance: d,
      listener: g,
      currentTarget: b
    };
  }
  function vd(d, g) {
    for (var b = g + "Capture", C = []; d !== null; ) {
      var I = d, j = I.stateNode;
      if (I = I.tag, I !== 5 && I !== 26 && I !== 27 || j === null || (I = Fc(d, b), I != null && C.unshift(
        Pa(d, I, j)
      ), I = Fc(d, g), I != null && C.push(
        Pa(d, I, j)
      )), d.tag === 3) return C;
      d = d.return;
    }
    return [];
  }
  function yd(d) {
    if (d === null) return null;
    do
      d = d.return;
    while (d && d.tag !== 5 && d.tag !== 27);
    return d || null;
  }
  function Ib(d, g, b, C, I) {
    for (var j = g._reactName, K = []; b !== null && b !== C; ) {
      var se = b, xe = se.alternate, ze = se.stateNode;
      if (se = se.tag, xe !== null && xe === C) break;
      se !== 5 && se !== 26 && se !== 27 || ze === null || (xe = ze, I ? (ze = Fc(b, j), ze != null && K.unshift(
        Pa(b, ze, xe)
      )) : I || (ze = Fc(b, j), ze != null && K.push(
        Pa(b, ze, xe)
      ))), b = b.return;
    }
    K.length !== 0 && d.push({ event: g, listeners: K });
  }
  var Pb = /\r\n?/g, ns = /\u0000|\uFFFD/g;
  function Nb(d) {
    return (typeof d == "string" ? d : "" + d).replace(Pb, `
`).replace(ns, "");
  }
  function OC(d, g) {
    return g = Nb(g), Nb(d) === g;
  }
  function Im() {
  }
  function _r(d, g, b, C, I, j) {
    switch (b) {
      case "children":
        typeof C == "string" ? g === "body" || g === "textarea" && C === "" || Jd(d, C) : (typeof C == "number" || typeof C == "bigint") && g !== "body" && Jd(d, "" + C);
        break;
      case "className":
        vo(d, "class", C);
        break;
      case "tabIndex":
        vo(d, "tabindex", C);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        vo(d, b, C);
        break;
      case "style":
        dy(d, C, j);
        break;
      case "data":
        if (g !== "object") {
          vo(d, "data", C);
          break;
        }
      case "src":
      case "href":
        if (C === "" && (g !== "a" || b !== "href")) {
          d.removeAttribute(b);
          break;
        }
        if (C == null || typeof C == "function" || typeof C == "symbol" || typeof C == "boolean") {
          d.removeAttribute(b);
          break;
        }
        C = Pg("" + C), d.setAttribute(b, C);
        break;
      case "action":
      case "formAction":
        if (typeof C == "function") {
          d.setAttribute(
            b,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof j == "function" && (b === "formAction" ? (g !== "input" && _r(d, g, "name", I.name, I, null), _r(
            d,
            g,
            "formEncType",
            I.formEncType,
            I,
            null
          ), _r(
            d,
            g,
            "formMethod",
            I.formMethod,
            I,
            null
          ), _r(
            d,
            g,
            "formTarget",
            I.formTarget,
            I,
            null
          )) : (_r(d, g, "encType", I.encType, I, null), _r(d, g, "method", I.method, I, null), _r(d, g, "target", I.target, I, null)));
        if (C == null || typeof C == "symbol" || typeof C == "boolean") {
          d.removeAttribute(b);
          break;
        }
        C = Pg("" + C), d.setAttribute(b, C);
        break;
      case "onClick":
        C != null && (d.onclick = Im);
        break;
      case "onScroll":
        C != null && bn("scroll", d);
        break;
      case "onScrollEnd":
        C != null && bn("scrollend", d);
        break;
      case "dangerouslySetInnerHTML":
        if (C != null) {
          if (typeof C != "object" || !("__html" in C))
            throw Error(r(61));
          if (b = C.__html, b != null) {
            if (I.children != null) throw Error(r(60));
            d.innerHTML = b;
          }
        }
        break;
      case "multiple":
        d.multiple = C && typeof C != "function" && typeof C != "symbol";
        break;
      case "muted":
        d.muted = C && typeof C != "function" && typeof C != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (C == null || typeof C == "function" || typeof C == "boolean" || typeof C == "symbol") {
          d.removeAttribute("xlink:href");
          break;
        }
        b = Pg("" + C), d.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          b
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        C != null && typeof C != "function" && typeof C != "symbol" ? d.setAttribute(b, "" + C) : d.removeAttribute(b);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        C && typeof C != "function" && typeof C != "symbol" ? d.setAttribute(b, "") : d.removeAttribute(b);
        break;
      case "capture":
      case "download":
        C === !0 ? d.setAttribute(b, "") : C !== !1 && C != null && typeof C != "function" && typeof C != "symbol" ? d.setAttribute(b, C) : d.removeAttribute(b);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        C != null && typeof C != "function" && typeof C != "symbol" && !isNaN(C) && 1 <= C ? d.setAttribute(b, C) : d.removeAttribute(b);
        break;
      case "rowSpan":
      case "start":
        C == null || typeof C == "function" || typeof C == "symbol" || isNaN(C) ? d.removeAttribute(b) : d.setAttribute(b, C);
        break;
      case "popover":
        bn("beforetoggle", d), bn("toggle", d), qa(d, "popover", C);
        break;
      case "xlinkActuate":
        yn(
          d,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          C
        );
        break;
      case "xlinkArcrole":
        yn(
          d,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          C
        );
        break;
      case "xlinkRole":
        yn(
          d,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          C
        );
        break;
      case "xlinkShow":
        yn(
          d,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          C
        );
        break;
      case "xlinkTitle":
        yn(
          d,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          C
        );
        break;
      case "xlinkType":
        yn(
          d,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          C
        );
        break;
      case "xmlBase":
        yn(
          d,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          C
        );
        break;
      case "xmlLang":
        yn(
          d,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          C
        );
        break;
      case "xmlSpace":
        yn(
          d,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          C
        );
        break;
      case "is":
        qa(d, "is", C);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < b.length) || b[0] !== "o" && b[0] !== "O" || b[1] !== "n" && b[1] !== "N") && (b = Ig.get(b) || b, qa(d, b, C));
    }
  }
  function qi(d, g, b, C, I, j) {
    switch (b) {
      case "style":
        dy(d, C, j);
        break;
      case "dangerouslySetInnerHTML":
        if (C != null) {
          if (typeof C != "object" || !("__html" in C))
            throw Error(r(61));
          if (b = C.__html, b != null) {
            if (I.children != null) throw Error(r(60));
            d.innerHTML = b;
          }
        }
        break;
      case "children":
        typeof C == "string" ? Jd(d, C) : (typeof C == "number" || typeof C == "bigint") && Jd(d, "" + C);
        break;
      case "onScroll":
        C != null && bn("scroll", d);
        break;
      case "onScrollEnd":
        C != null && bn("scrollend", d);
        break;
      case "onClick":
        C != null && (d.onclick = Im);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!kt.hasOwnProperty(b))
          e: {
            if (b[0] === "o" && b[1] === "n" && (I = b.endsWith("Capture"), g = b.slice(2, I ? b.length - 7 : void 0), j = d[Jt] || null, j = j != null ? j[b] : null, typeof j == "function" && d.removeEventListener(g, j, I), typeof C == "function")) {
              typeof j != "function" && j !== null && (b in d ? d[b] = null : d.hasAttribute(b) && d.removeAttribute(b)), d.addEventListener(g, C, I);
              break e;
            }
            b in d ? d[b] = C : C === !0 ? d.setAttribute(b, "") : qa(d, b, C);
          }
    }
  }
  function Ge(d, g, b) {
    switch (g) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        bn("error", d), bn("load", d);
        var C = !1, I = !1, j;
        for (j in b)
          if (b.hasOwnProperty(j)) {
            var K = b[j];
            if (K != null)
              switch (j) {
                case "src":
                  C = !0;
                  break;
                case "srcSet":
                  I = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(r(137, g));
                default:
                  _r(d, g, j, K, b, null);
              }
          }
        I && _r(d, g, "srcSet", b.srcSet, b, null), C && _r(d, g, "src", b.src, b, null);
        return;
      case "input":
        bn("invalid", d);
        var se = j = K = I = null, xe = null, ze = null;
        for (C in b)
          if (b.hasOwnProperty(C)) {
            var ut = b[C];
            if (ut != null)
              switch (C) {
                case "name":
                  I = ut;
                  break;
                case "type":
                  K = ut;
                  break;
                case "checked":
                  xe = ut;
                  break;
                case "defaultChecked":
                  ze = ut;
                  break;
                case "value":
                  j = ut;
                  break;
                case "defaultValue":
                  se = ut;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (ut != null)
                    throw Error(r(137, g));
                  break;
                default:
                  _r(d, g, C, ut, b, null);
              }
          }
        lS(
          d,
          j,
          se,
          xe,
          ze,
          K,
          I,
          !1
        ), xp(d);
        return;
      case "select":
        bn("invalid", d), C = K = j = null;
        for (I in b)
          if (b.hasOwnProperty(I) && (se = b[I], se != null))
            switch (I) {
              case "value":
                j = se;
                break;
              case "defaultValue":
                K = se;
                break;
              case "multiple":
                C = se;
              default:
                _r(d, g, I, se, b, null);
            }
        g = j, b = K, d.multiple = !!C, g != null ? Fu(d, !!C, g, !1) : b != null && Fu(d, !!C, b, !0);
        return;
      case "textarea":
        bn("invalid", d), j = I = C = null;
        for (K in b)
          if (b.hasOwnProperty(K) && (se = b[K], se != null))
            switch (K) {
              case "value":
                C = se;
                break;
              case "defaultValue":
                I = se;
                break;
              case "children":
                j = se;
                break;
              case "dangerouslySetInnerHTML":
                if (se != null) throw Error(r(91));
                break;
              default:
                _r(d, g, K, se, b, null);
            }
        uS(d, C, I, j), xp(d);
        return;
      case "option":
        for (xe in b)
          if (b.hasOwnProperty(xe) && (C = b[xe], C != null))
            switch (xe) {
              case "selected":
                d.selected = C && typeof C != "function" && typeof C != "symbol";
                break;
              default:
                _r(d, g, xe, C, b, null);
            }
        return;
      case "dialog":
        bn("beforetoggle", d), bn("toggle", d), bn("cancel", d), bn("close", d);
        break;
      case "iframe":
      case "object":
        bn("load", d);
        break;
      case "video":
      case "audio":
        for (C = 0; C < pn.length; C++)
          bn(pn[C], d);
        break;
      case "image":
        bn("error", d), bn("load", d);
        break;
      case "details":
        bn("toggle", d);
        break;
      case "embed":
      case "source":
      case "link":
        bn("error", d), bn("load", d);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (ze in b)
          if (b.hasOwnProperty(ze) && (C = b[ze], C != null))
            switch (ze) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(137, g));
              default:
                _r(d, g, ze, C, b, null);
            }
        return;
      default:
        if (wp(g)) {
          for (ut in b)
            b.hasOwnProperty(ut) && (C = b[ut], C !== void 0 && qi(
              d,
              g,
              ut,
              C,
              b,
              void 0
            ));
          return;
        }
    }
    for (se in b)
      b.hasOwnProperty(se) && (C = b[se], C != null && _r(d, g, se, C, b, null));
  }
  function lr(d, g, b, C) {
    switch (g) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var I = null, j = null, K = null, se = null, xe = null, ze = null, ut = null;
        for (Ze in b) {
          var pt = b[Ze];
          if (b.hasOwnProperty(Ze) && pt != null)
            switch (Ze) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                xe = pt;
              default:
                C.hasOwnProperty(Ze) || _r(d, g, Ze, null, C, pt);
            }
        }
        for (var He in C) {
          var Ze = C[He];
          if (pt = b[He], C.hasOwnProperty(He) && (Ze != null || pt != null))
            switch (He) {
              case "type":
                j = Ze;
                break;
              case "name":
                I = Ze;
                break;
              case "checked":
                ze = Ze;
                break;
              case "defaultChecked":
                ut = Ze;
                break;
              case "value":
                K = Ze;
                break;
              case "defaultValue":
                se = Ze;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (Ze != null)
                  throw Error(r(137, g));
                break;
              default:
                Ze !== pt && _r(
                  d,
                  g,
                  He,
                  Ze,
                  C,
                  pt
                );
            }
        }
        sS(
          d,
          K,
          se,
          xe,
          ze,
          ut,
          j,
          I
        );
        return;
      case "select":
        Ze = K = se = He = null;
        for (j in b)
          if (xe = b[j], b.hasOwnProperty(j) && xe != null)
            switch (j) {
              case "value":
                break;
              case "multiple":
                Ze = xe;
              default:
                C.hasOwnProperty(j) || _r(
                  d,
                  g,
                  j,
                  null,
                  C,
                  xe
                );
            }
        for (I in C)
          if (j = C[I], xe = b[I], C.hasOwnProperty(I) && (j != null || xe != null))
            switch (I) {
              case "value":
                He = j;
                break;
              case "defaultValue":
                se = j;
                break;
              case "multiple":
                K = j;
              default:
                j !== xe && _r(
                  d,
                  g,
                  I,
                  j,
                  C,
                  xe
                );
            }
        g = se, b = K, C = Ze, He != null ? Fu(d, !!b, He, !1) : !!C != !!b && (g != null ? Fu(d, !!b, g, !0) : Fu(d, !!b, b ? [] : "", !1));
        return;
      case "textarea":
        Ze = He = null;
        for (se in b)
          if (I = b[se], b.hasOwnProperty(se) && I != null && !C.hasOwnProperty(se))
            switch (se) {
              case "value":
                break;
              case "children":
                break;
              default:
                _r(d, g, se, null, C, I);
            }
        for (K in C)
          if (I = C[K], j = b[K], C.hasOwnProperty(K) && (I != null || j != null))
            switch (K) {
              case "value":
                He = I;
                break;
              case "defaultValue":
                Ze = I;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (I != null) throw Error(r(91));
                break;
              default:
                I !== j && _r(d, g, K, I, C, j);
            }
        cS(d, He, Ze);
        return;
      case "option":
        for (var on in b)
          if (He = b[on], b.hasOwnProperty(on) && He != null && !C.hasOwnProperty(on))
            switch (on) {
              case "selected":
                d.selected = !1;
                break;
              default:
                _r(
                  d,
                  g,
                  on,
                  null,
                  C,
                  He
                );
            }
        for (xe in C)
          if (He = C[xe], Ze = b[xe], C.hasOwnProperty(xe) && He !== Ze && (He != null || Ze != null))
            switch (xe) {
              case "selected":
                d.selected = He && typeof He != "function" && typeof He != "symbol";
                break;
              default:
                _r(
                  d,
                  g,
                  xe,
                  He,
                  C,
                  Ze
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var en in b)
          He = b[en], b.hasOwnProperty(en) && He != null && !C.hasOwnProperty(en) && _r(d, g, en, null, C, He);
        for (ze in C)
          if (He = C[ze], Ze = b[ze], C.hasOwnProperty(ze) && He !== Ze && (He != null || Ze != null))
            switch (ze) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (He != null)
                  throw Error(r(137, g));
                break;
              default:
                _r(
                  d,
                  g,
                  ze,
                  He,
                  C,
                  Ze
                );
            }
        return;
      default:
        if (wp(g)) {
          for (var cr in b)
            He = b[cr], b.hasOwnProperty(cr) && He !== void 0 && !C.hasOwnProperty(cr) && qi(
              d,
              g,
              cr,
              void 0,
              C,
              He
            );
          for (ut in C)
            He = C[ut], Ze = b[ut], !C.hasOwnProperty(ut) || He === Ze || He === void 0 && Ze === void 0 || qi(
              d,
              g,
              ut,
              He,
              C,
              Ze
            );
          return;
        }
    }
    for (var Me in b)
      He = b[Me], b.hasOwnProperty(Me) && He != null && !C.hasOwnProperty(Me) && _r(d, g, Me, null, C, He);
    for (pt in C)
      He = C[pt], Ze = b[pt], !C.hasOwnProperty(pt) || He === Ze || He == null && Ze == null || _r(d, g, pt, He, C, Ze);
  }
  var $w = null, Pm = null;
  function vh(d) {
    return d.nodeType === 9 ? d : d.ownerDocument;
  }
  function Xl(d) {
    switch (d) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function fu(d, g) {
    if (d === 0)
      switch (g) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return d === 1 && g === "foreignObject" ? 0 : d;
  }
  function Nf(d, g) {
    return d === "textarea" || d === "noscript" || typeof g.children == "string" || typeof g.children == "number" || typeof g.children == "bigint" || typeof g.dangerouslySetInnerHTML == "object" && g.dangerouslySetInnerHTML !== null && g.dangerouslySetInnerHTML.__html != null;
  }
  var Zl = null;
  function Mb() {
    var d = window.event;
    return d && d.type === "popstate" ? d === Zl ? !1 : (Zl = d, !0) : (Zl = null, !1);
  }
  var Kl = typeof setTimeout == "function" ? setTimeout : void 0, Gw = typeof clearTimeout == "function" ? clearTimeout : void 0, AC = typeof Promise == "function" ? Promise : void 0, BP = typeof queueMicrotask == "function" ? queueMicrotask : typeof AC < "u" ? function(d) {
    return AC.resolve(null).then(d).catch(VP);
  } : Kl;
  function VP(d) {
    setTimeout(function() {
      throw d;
    });
  }
  function So(d) {
    return d === "head";
  }
  function DC(d, g) {
    var b = g, C = 0, I = 0;
    do {
      var j = b.nextSibling;
      if (d.removeChild(b), j && j.nodeType === 8)
        if (b = j.data, b === "/$") {
          if (0 < C && 8 > C) {
            b = C;
            var K = d.ownerDocument;
            if (b & 1 && Pt(K.documentElement), b & 2 && Pt(K.body), b & 4)
              for (b = K.head, Pt(b), K = b.firstChild; K; ) {
                var se = K.nextSibling, xe = K.nodeName;
                K[gr] || xe === "SCRIPT" || xe === "STYLE" || xe === "LINK" && K.rel.toLowerCase() === "stylesheet" || b.removeChild(K), K = se;
              }
          }
          if (I === 0) {
            d.removeChild(j), Eh(g);
            return;
          }
          I--;
        } else
          b === "$" || b === "$?" || b === "$!" ? I++ : C = b.charCodeAt(0) - 48;
      else C = 0;
      b = j;
    } while (b);
    Eh(g);
  }
  function Nm(d) {
    var g = d.firstChild;
    for (g && g.nodeType === 10 && (g = g.nextSibling); g; ) {
      var b = g;
      switch (g = g.nextSibling, b.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Nm(b), _t(b);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (b.rel.toLowerCase() === "stylesheet") continue;
      }
      d.removeChild(b);
    }
  }
  function Yw(d, g, b, C) {
    for (; d.nodeType === 1; ) {
      var I = b;
      if (d.nodeName.toLowerCase() !== g.toLowerCase()) {
        if (!C && (d.nodeName !== "INPUT" || d.type !== "hidden"))
          break;
      } else if (C) {
        if (!d[gr])
          switch (g) {
            case "meta":
              if (!d.hasAttribute("itemprop")) break;
              return d;
            case "link":
              if (j = d.getAttribute("rel"), j === "stylesheet" && d.hasAttribute("data-precedence"))
                break;
              if (j !== I.rel || d.getAttribute("href") !== (I.href == null || I.href === "" ? null : I.href) || d.getAttribute("crossorigin") !== (I.crossOrigin == null ? null : I.crossOrigin) || d.getAttribute("title") !== (I.title == null ? null : I.title))
                break;
              return d;
            case "style":
              if (d.hasAttribute("data-precedence")) break;
              return d;
            case "script":
              if (j = d.getAttribute("src"), (j !== (I.src == null ? null : I.src) || d.getAttribute("type") !== (I.type == null ? null : I.type) || d.getAttribute("crossorigin") !== (I.crossOrigin == null ? null : I.crossOrigin)) && j && d.hasAttribute("async") && !d.hasAttribute("itemprop"))
                break;
              return d;
            default:
              return d;
          }
      } else if (g === "input" && d.type === "hidden") {
        var j = I.name == null ? null : "" + I.name;
        if (I.type === "hidden" && d.getAttribute("name") === j)
          return d;
      } else return d;
      if (d = gl(d.nextSibling), d === null) break;
    }
    return null;
  }
  function yh(d, g, b) {
    if (g === "") return null;
    for (; d.nodeType !== 3; )
      if ((d.nodeType !== 1 || d.nodeName !== "INPUT" || d.type !== "hidden") && !b || (d = gl(d.nextSibling), d === null)) return null;
    return d;
  }
  function Xw(d) {
    return d.data === "$!" || d.data === "$?" && d.ownerDocument.readyState === "complete";
  }
  function Zw(d, g) {
    var b = d.ownerDocument;
    if (d.data !== "$?" || b.readyState === "complete")
      g();
    else {
      var C = function() {
        g(), b.removeEventListener("DOMContentLoaded", C);
      };
      b.addEventListener("DOMContentLoaded", C), d._reactRetry = C;
    }
  }
  function gl(d) {
    for (; d != null; d = d.nextSibling) {
      var g = d.nodeType;
      if (g === 1 || g === 3) break;
      if (g === 8) {
        if (g = d.data, g === "$" || g === "$!" || g === "$?" || g === "F!" || g === "F")
          break;
        if (g === "/$") return null;
      }
    }
    return d;
  }
  var Kw = null;
  function Mf(d) {
    d = d.previousSibling;
    for (var g = 0; d; ) {
      if (d.nodeType === 8) {
        var b = d.data;
        if (b === "$" || b === "$!" || b === "$?") {
          if (g === 0) return d;
          g--;
        } else b === "/$" && g++;
      }
      d = d.previousSibling;
    }
    return null;
  }
  function wo(d, g, b) {
    switch (g = vh(b), d) {
      case "html":
        if (d = g.documentElement, !d) throw Error(r(452));
        return d;
      case "head":
        if (d = g.head, !d) throw Error(r(453));
        return d;
      case "body":
        if (d = g.body, !d) throw Error(r(454));
        return d;
      default:
        throw Error(r(451));
    }
  }
  function Pt(d) {
    for (var g = d.attributes; g.length; )
      d.removeAttributeNode(g[0]);
    _t(d);
  }
  var Ci = /* @__PURE__ */ new Map(), Ps = /* @__PURE__ */ new Set();
  function ro(d) {
    return typeof d.getRootNode == "function" ? d.getRootNode() : d.nodeType === 9 ? d : d.ownerDocument;
  }
  var pu = ee.d;
  ee.d = {
    f: UP,
    r: jb,
    D: Ql,
    C: gu,
    L: Lb,
    m: bd,
    X: Na,
    S: zo,
    M: xd
  };
  function UP() {
    var d = pu.f(), g = Tm();
    return d || g;
  }
  function jb(d) {
    var g = ti(d);
    g !== null && g.tag === 5 && g.type === "form" ? eC(g) : pu.r(d);
  }
  var hu = typeof document > "u" ? null : document;
  function rs(d, g, b) {
    var C = hu;
    if (C && typeof g == "string" && g) {
      var I = xs(g);
      I = 'link[rel="' + d + '"][href="' + I + '"]', typeof b == "string" && (I += '[crossorigin="' + b + '"]'), Ps.has(I) || (Ps.add(I), d = { rel: d, crossOrigin: b, href: g }, C.querySelector(I) === null && (g = C.createElement("link"), Ge(g, "link", d), Ne(g), C.head.appendChild(g)));
    }
  }
  function Ql(d) {
    pu.D(d), rs("dns-prefetch", d, null);
  }
  function gu(d, g) {
    pu.C(d, g), rs("preconnect", d, g);
  }
  function Lb(d, g, b) {
    pu.L(d, g, b);
    var C = hu;
    if (C && d && g) {
      var I = 'link[rel="preload"][as="' + xs(g) + '"]';
      g === "image" && b && b.imageSrcSet ? (I += '[imagesrcset="' + xs(
        b.imageSrcSet
      ) + '"]', typeof b.imageSizes == "string" && (I += '[imagesizes="' + xs(
        b.imageSizes
      ) + '"]')) : I += '[href="' + xs(d) + '"]';
      var j = I;
      switch (g) {
        case "style":
          j = bh(d);
          break;
        case "script":
          j = jf(d);
      }
      Ci.has(j) || (d = m(
        {
          rel: "preload",
          href: g === "image" && b && b.imageSrcSet ? void 0 : d,
          as: g
        },
        b
      ), Ci.set(j, d), C.querySelector(I) !== null || g === "style" && C.querySelector(Mm(j)) || g === "script" && C.querySelector(ml(j)) || (g = C.createElement("link"), Ge(g, "link", d), Ne(g), C.head.appendChild(g)));
    }
  }
  function bd(d, g) {
    pu.m(d, g);
    var b = hu;
    if (b && d) {
      var C = g && typeof g.as == "string" ? g.as : "script", I = 'link[rel="modulepreload"][as="' + xs(C) + '"][href="' + xs(d) + '"]', j = I;
      switch (C) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          j = jf(d);
      }
      if (!Ci.has(j) && (d = m({ rel: "modulepreload", href: d }, g), Ci.set(j, d), b.querySelector(I) === null)) {
        switch (C) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (b.querySelector(ml(j)))
              return;
        }
        C = b.createElement("link"), Ge(C, "link", d), Ne(C), b.head.appendChild(C);
      }
    }
  }
  function zo(d, g, b) {
    pu.S(d, g, b);
    var C = hu;
    if (C && d) {
      var I = de(C).hoistableStyles, j = bh(d);
      g = g || "default";
      var K = I.get(j);
      if (!K) {
        var se = { loading: 0, preload: null };
        if (K = C.querySelector(
          Mm(j)
        ))
          se.loading = 5;
        else {
          d = m(
            { rel: "stylesheet", href: d, "data-precedence": g },
            b
          ), (b = Ci.get(j)) && Jw(d, b);
          var xe = K = C.createElement("link");
          Ne(xe), Ge(xe, "link", d), xe._p = new Promise(function(ze, ut) {
            xe.onload = ze, xe.onerror = ut;
          }), xe.addEventListener("load", function() {
            se.loading |= 1;
          }), xe.addEventListener("error", function() {
            se.loading |= 2;
          }), se.loading |= 4, Bb(K, g, C);
        }
        K = {
          type: "stylesheet",
          instance: K,
          count: 1,
          state: se
        }, I.set(j, K);
      }
    }
  }
  function Na(d, g) {
    pu.X(d, g);
    var b = hu;
    if (b && d) {
      var C = de(b).hoistableScripts, I = jf(d), j = C.get(I);
      j || (j = b.querySelector(ml(I)), j || (d = m({ src: d, async: !0 }, g), (g = Ci.get(I)) && Vb(d, g), j = b.createElement("script"), Ne(j), Ge(j, "link", d), b.head.appendChild(j)), j = {
        type: "script",
        instance: j,
        count: 1,
        state: null
      }, C.set(I, j));
    }
  }
  function xd(d, g) {
    pu.M(d, g);
    var b = hu;
    if (b && d) {
      var C = de(b).hoistableScripts, I = jf(d), j = C.get(I);
      j || (j = b.querySelector(ml(I)), j || (d = m({ src: d, async: !0, type: "module" }, g), (g = Ci.get(I)) && Vb(d, g), j = b.createElement("script"), Ne(j), Ge(j, "link", d), b.head.appendChild(j)), j = {
        type: "script",
        instance: j,
        count: 1,
        state: null
      }, C.set(I, j));
    }
  }
  function kb(d, g, b, C) {
    var I = (I = me.current) ? ro(I) : null;
    if (!I) throw Error(r(446));
    switch (d) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof b.precedence == "string" && typeof b.href == "string" ? (g = bh(b.href), b = de(
          I
        ).hoistableStyles, C = b.get(g), C || (C = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, b.set(g, C)), C) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (b.rel === "stylesheet" && typeof b.href == "string" && typeof b.precedence == "string") {
          d = bh(b.href);
          var j = de(
            I
          ).hoistableStyles, K = j.get(d);
          if (K || (I = I.ownerDocument || I, K = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, j.set(d, K), (j = I.querySelector(
            Mm(d)
          )) && !j._p && (K.instance = j, K.state.loading = 5), Ci.has(d) || (b = {
            rel: "preload",
            as: "style",
            href: b.href,
            crossOrigin: b.crossOrigin,
            integrity: b.integrity,
            media: b.media,
            hrefLang: b.hrefLang,
            referrerPolicy: b.referrerPolicy
          }, Ci.set(d, b), j || jm(
            I,
            d,
            b,
            K.state
          ))), g && C === null)
            throw Error(r(528, ""));
          return K;
        }
        if (g && C !== null)
          throw Error(r(529, ""));
        return null;
      case "script":
        return g = b.async, b = b.src, typeof b == "string" && g && typeof g != "function" && typeof g != "symbol" ? (g = jf(b), b = de(
          I
        ).hoistableScripts, C = b.get(g), C || (C = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, b.set(g, C)), C) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(r(444, d));
    }
  }
  function bh(d) {
    return 'href="' + xs(d) + '"';
  }
  function Mm(d) {
    return 'link[rel="stylesheet"][' + d + "]";
  }
  function Qw(d) {
    return m({}, d, {
      "data-precedence": d.precedence,
      precedence: null
    });
  }
  function jm(d, g, b, C) {
    d.querySelector('link[rel="preload"][as="style"][' + g + "]") ? C.loading = 1 : (g = d.createElement("link"), C.preload = g, g.addEventListener("load", function() {
      return C.loading |= 1;
    }), g.addEventListener("error", function() {
      return C.loading |= 2;
    }), Ge(g, "link", b), Ne(g), d.head.appendChild(g));
  }
  function jf(d) {
    return '[src="' + xs(d) + '"]';
  }
  function ml(d) {
    return "script[async]" + d;
  }
  function zb(d, g, b) {
    if (g.count++, g.instance === null)
      switch (g.type) {
        case "style":
          var C = d.querySelector(
            'style[data-href~="' + xs(b.href) + '"]'
          );
          if (C)
            return g.instance = C, Ne(C), C;
          var I = m({}, b, {
            "data-href": b.href,
            "data-precedence": b.precedence,
            href: null,
            precedence: null
          });
          return C = (d.ownerDocument || d).createElement(
            "style"
          ), Ne(C), Ge(C, "style", I), Bb(C, b.precedence, d), g.instance = C;
        case "stylesheet":
          I = bh(b.href);
          var j = d.querySelector(
            Mm(I)
          );
          if (j)
            return g.state.loading |= 4, g.instance = j, Ne(j), j;
          C = Qw(b), (I = Ci.get(I)) && Jw(C, I), j = (d.ownerDocument || d).createElement("link"), Ne(j);
          var K = j;
          return K._p = new Promise(function(se, xe) {
            K.onload = se, K.onerror = xe;
          }), Ge(j, "link", C), g.state.loading |= 4, Bb(j, b.precedence, d), g.instance = j;
        case "script":
          return j = jf(b.src), (I = d.querySelector(
            ml(j)
          )) ? (g.instance = I, Ne(I), I) : (C = b, (I = Ci.get(j)) && (C = m({}, b), Vb(C, I)), d = d.ownerDocument || d, I = d.createElement("script"), Ne(I), Ge(I, "link", C), d.head.appendChild(I), g.instance = I);
        case "void":
          return null;
        default:
          throw Error(r(443, g.type));
      }
    else
      g.type === "stylesheet" && (g.state.loading & 4) === 0 && (C = g.instance, g.state.loading |= 4, Bb(C, b.precedence, d));
    return g.instance;
  }
  function Bb(d, g, b) {
    for (var C = b.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), I = C.length ? C[C.length - 1] : null, j = I, K = 0; K < C.length; K++) {
      var se = C[K];
      if (se.dataset.precedence === g) j = se;
      else if (j !== I) break;
    }
    j ? j.parentNode.insertBefore(d, j.nextSibling) : (g = b.nodeType === 9 ? b.head : b, g.insertBefore(d, g.firstChild));
  }
  function Jw(d, g) {
    d.crossOrigin == null && (d.crossOrigin = g.crossOrigin), d.referrerPolicy == null && (d.referrerPolicy = g.referrerPolicy), d.title == null && (d.title = g.title);
  }
  function Vb(d, g) {
    d.crossOrigin == null && (d.crossOrigin = g.crossOrigin), d.referrerPolicy == null && (d.referrerPolicy = g.referrerPolicy), d.integrity == null && (d.integrity = g.integrity);
  }
  var Lm = null;
  function xh(d, g, b) {
    if (Lm === null) {
      var C = /* @__PURE__ */ new Map(), I = Lm = /* @__PURE__ */ new Map();
      I.set(b, C);
    } else
      I = Lm, C = I.get(b), C || (C = /* @__PURE__ */ new Map(), I.set(b, C));
    if (C.has(d)) return C;
    for (C.set(d, null), b = b.getElementsByTagName(d), I = 0; I < b.length; I++) {
      var j = b[I];
      if (!(j[gr] || j[jt] || d === "link" && j.getAttribute("rel") === "stylesheet") && j.namespaceURI !== "http://www.w3.org/2000/svg") {
        var K = j.getAttribute(g) || "";
        K = d + K;
        var se = C.get(K);
        se ? se.push(j) : C.set(K, [j]);
      }
    }
    return C;
  }
  function eT(d, g, b) {
    d = d.ownerDocument || d, d.head.insertBefore(
      b,
      g === "title" ? d.querySelector("head > title") : null
    );
  }
  function IC(d, g, b) {
    if (b === 1 || g.itemProp != null) return !1;
    switch (d) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof g.precedence != "string" || typeof g.href != "string" || g.href === "")
          break;
        return !0;
      case "link":
        if (typeof g.rel != "string" || typeof g.href != "string" || g.href === "" || g.onLoad || g.onError)
          break;
        switch (g.rel) {
          case "stylesheet":
            return d = g.disabled, typeof g.precedence == "string" && d == null;
          default:
            return !0;
        }
      case "script":
        if (g.async && typeof g.async != "function" && typeof g.async != "symbol" && !g.onLoad && !g.onError && g.src && typeof g.src == "string")
          return !0;
    }
    return !1;
  }
  function tT(d) {
    return !(d.type === "stylesheet" && (d.state.loading & 3) === 0);
  }
  var Sh = null;
  function PC() {
  }
  function NC(d, g, b) {
    if (Sh === null) throw Error(r(475));
    var C = Sh;
    if (g.type === "stylesheet" && (typeof b.media != "string" || matchMedia(b.media).matches !== !1) && (g.state.loading & 4) === 0) {
      if (g.instance === null) {
        var I = bh(b.href), j = d.querySelector(
          Mm(I)
        );
        if (j) {
          d = j._p, d !== null && typeof d == "object" && typeof d.then == "function" && (C.count++, C = wh.bind(C), d.then(C, C)), g.state.loading |= 4, g.instance = j, Ne(j);
          return;
        }
        j = d.ownerDocument || d, b = Qw(b), (I = Ci.get(I)) && Jw(b, I), j = j.createElement("link"), Ne(j);
        var K = j;
        K._p = new Promise(function(se, xe) {
          K.onload = se, K.onerror = xe;
        }), Ge(j, "link", b), g.instance = j;
      }
      C.stylesheets === null && (C.stylesheets = /* @__PURE__ */ new Map()), C.stylesheets.set(g, d), (d = g.state.preload) && (g.state.loading & 3) === 0 && (C.count++, g = wh.bind(C), d.addEventListener("load", g), d.addEventListener("error", g));
    }
  }
  function MC() {
    if (Sh === null) throw Error(r(475));
    var d = Sh;
    return d.stylesheets && d.count === 0 && zm(d, d.stylesheets), 0 < d.count ? function(g) {
      var b = setTimeout(function() {
        if (d.stylesheets && zm(d, d.stylesheets), d.unsuspend) {
          var C = d.unsuspend;
          d.unsuspend = null, C();
        }
      }, 6e4);
      return d.unsuspend = g, function() {
        d.unsuspend = null, clearTimeout(b);
      };
    } : null;
  }
  function wh() {
    if (this.count--, this.count === 0) {
      if (this.stylesheets) zm(this, this.stylesheets);
      else if (this.unsuspend) {
        var d = this.unsuspend;
        this.unsuspend = null, d();
      }
    }
  }
  var km = null;
  function zm(d, g) {
    d.stylesheets = null, d.unsuspend !== null && (d.count++, km = /* @__PURE__ */ new Map(), g.forEach(nT, d), km = null, wh.call(d));
  }
  function nT(d, g) {
    if (!(g.state.loading & 4)) {
      var b = km.get(d);
      if (b) var C = b.get(null);
      else {
        b = /* @__PURE__ */ new Map(), km.set(d, b);
        for (var I = d.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), j = 0; j < I.length; j++) {
          var K = I[j];
          (K.nodeName === "LINK" || K.getAttribute("media") !== "not all") && (b.set(K.dataset.precedence, K), C = K);
        }
        C && b.set(null, C);
      }
      I = g.instance, K = I.getAttribute("data-precedence"), j = b.get(K) || C, j === C && b.set(null, I), b.set(K, I), this.count++, C = wh.bind(this), I.addEventListener("load", C), I.addEventListener("error", C), j ? j.parentNode.insertBefore(I, j.nextSibling) : (d = d.nodeType === 9 ? d.head : d, d.insertBefore(I, d.firstChild)), g.state.loading |= 4;
    }
  }
  var To = {
    $$typeof: P,
    Provider: null,
    Consumer: null,
    _currentValue: J,
    _currentValue2: J,
    _threadCount: 0
  };
  function Jl(d, g, b, C, I, j, K, se) {
    this.tag = 1, this.containerInfo = d, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Kt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kt(0), this.hiddenUpdates = Kt(null), this.identifierPrefix = C, this.onUncaughtError = I, this.onCaughtError = j, this.onRecoverableError = K, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = se, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function jC(d, g, b, C, I, j, K, se, xe, ze, ut, pt) {
    return d = new Jl(
      d,
      g,
      b,
      K,
      se,
      xe,
      ze,
      pt
    ), g = 1, j === !0 && (g |= 24), j = ya(3, null, null, g), d.current = j, j.stateNode = d, g = MS(), g.refCount++, d.pooledCache = g, g.refCount++, j.memoizedState = {
      element: C,
      isDehydrated: b,
      cache: g
    }, Jg(j), d;
  }
  function rT(d) {
    return d ? (d = hf, d) : hf;
  }
  function iT(d, g, b, C, I, j) {
    I = rT(I), C.context === null ? C.context = I : C.pendingContext = I, C = Qc(g), C.payload = { element: b }, j = j === void 0 ? null : j, j !== null && (C.callback = j), b = Sa(d, C, g), b !== null && (Ia(b, d, g), vf(b, d, g));
  }
  function oT(d, g) {
    if (d = d.memoizedState, d !== null && d.dehydrated !== null) {
      var b = d.retryLane;
      d.retryLane = b !== 0 && b < g ? b : g;
    }
  }
  function Ub(d, g) {
    oT(d, g), (d = d.alternate) && oT(d, g);
  }
  function aT(d) {
    if (d.tag === 13) {
      var g = $c(d, 67108864);
      g !== null && Ia(g, d, 67108864), Ub(d, 67108864);
    }
  }
  var Bm = !0;
  function LC(d, g, b, C) {
    var I = Z.T;
    Z.T = null;
    var j = ee.p;
    try {
      ee.p = 2, Fb(d, g, b, C);
    } finally {
      ee.p = j, Z.T = I;
    }
  }
  function kC(d, g, b, C) {
    var I = Z.T;
    Z.T = null;
    var j = ee.p;
    try {
      ee.p = 8, Fb(d, g, b, C);
    } finally {
      ee.p = j, Z.T = I;
    }
  }
  function Fb(d, g, b, C) {
    if (Bm) {
      var I = sT(C);
      if (I === null)
        Dm(
          d,
          g,
          C,
          Vm,
          b
        ), cT(d, C);
      else if (uT(
        I,
        d,
        g,
        b,
        C
      ))
        C.stopPropagation();
      else if (cT(d, C), g & 4 && -1 < FP.indexOf(d)) {
        for (; I !== null; ) {
          var j = ti(I);
          if (j !== null)
            switch (j.tag) {
              case 3:
                if (j = j.stateNode, j.current.memoizedState.isDehydrated) {
                  var K = gt(j.pendingLanes);
                  if (K !== 0) {
                    var se = j;
                    for (se.pendingLanes |= 2, se.entangledLanes |= 2; K; ) {
                      var xe = 1 << 31 - q(K);
                      se.entanglements[1] |= xe, K &= ~xe;
                    }
                    hl(j), (fr & 6) === 0 && (hb = L() + 500, uu(0));
                  }
                }
                break;
              case 13:
                se = $c(j, 2), se !== null && Ia(se, j, 2), Tm(), Ub(j, 2);
            }
          if (j = sT(C), j === null && Dm(
            d,
            g,
            C,
            Vm,
            b
          ), j === I) break;
          I = j;
        }
        I !== null && C.stopPropagation();
      } else
        Dm(
          d,
          g,
          C,
          null,
          b
        );
    }
  }
  function sT(d) {
    return d = ef(d), lT(d);
  }
  var Vm = null;
  function lT(d) {
    if (Vm = null, d = mi(d), d !== null) {
      var g = o(d);
      if (g === null) d = null;
      else {
        var b = g.tag;
        if (b === 13) {
          if (d = s(g), d !== null) return d;
          d = null;
        } else if (b === 3) {
          if (g.stateNode.current.memoizedState.isDehydrated)
            return g.tag === 3 ? g.stateNode.containerInfo : null;
          d = null;
        } else g !== d && (d = null);
      }
    }
    return Vm = d, null;
  }
  function zC(d) {
    switch (d) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (te()) {
          case ge:
            return 2;
          case ke:
            return 8;
          case We:
          case Be:
            return 32;
          case je:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Wb = !1, vl = null, ec = null, mu = null, Th = /* @__PURE__ */ new Map(), Um = /* @__PURE__ */ new Map(), Sd = [], FP = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function cT(d, g) {
    switch (d) {
      case "focusin":
      case "focusout":
        vl = null;
        break;
      case "dragenter":
      case "dragleave":
        ec = null;
        break;
      case "mouseover":
      case "mouseout":
        mu = null;
        break;
      case "pointerover":
      case "pointerout":
        Th.delete(g.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Um.delete(g.pointerId);
    }
  }
  function tc(d, g, b, C, I, j) {
    return d === null || d.nativeEvent !== j ? (d = {
      blockedOn: g,
      domEventName: b,
      eventSystemFlags: C,
      nativeEvent: j,
      targetContainers: [I]
    }, g !== null && (g = ti(g), g !== null && aT(g)), d) : (d.eventSystemFlags |= C, g = d.targetContainers, I !== null && g.indexOf(I) === -1 && g.push(I), d);
  }
  function uT(d, g, b, C, I) {
    switch (g) {
      case "focusin":
        return vl = tc(
          vl,
          d,
          g,
          b,
          C,
          I
        ), !0;
      case "dragenter":
        return ec = tc(
          ec,
          d,
          g,
          b,
          C,
          I
        ), !0;
      case "mouseover":
        return mu = tc(
          mu,
          d,
          g,
          b,
          C,
          I
        ), !0;
      case "pointerover":
        var j = I.pointerId;
        return Th.set(
          j,
          tc(
            Th.get(j) || null,
            d,
            g,
            b,
            C,
            I
          )
        ), !0;
      case "gotpointercapture":
        return j = I.pointerId, Um.set(
          j,
          tc(
            Um.get(j) || null,
            d,
            g,
            b,
            C,
            I
          )
        ), !0;
    }
    return !1;
  }
  function dT(d) {
    var g = mi(d.target);
    if (g !== null) {
      var b = o(g);
      if (b !== null) {
        if (g = b.tag, g === 13) {
          if (g = s(b), g !== null) {
            d.blockedOn = g, It(d.priority, function() {
              if (b.tag === 13) {
                var C = ts();
                C = jr(C);
                var I = $c(b, C);
                I !== null && Ia(I, b, C), Ub(b, C);
              }
            });
            return;
          }
        } else if (g === 3 && b.stateNode.current.memoizedState.isDehydrated) {
          d.blockedOn = b.tag === 3 ? b.stateNode.containerInfo : null;
          return;
        }
      }
    }
    d.blockedOn = null;
  }
  function Fm(d) {
    if (d.blockedOn !== null) return !1;
    for (var g = d.targetContainers; 0 < g.length; ) {
      var b = sT(d.nativeEvent);
      if (b === null) {
        b = d.nativeEvent;
        var C = new b.constructor(
          b.type,
          b
        );
        fy = C, b.target.dispatchEvent(C), fy = null;
      } else
        return g = ti(b), g !== null && aT(g), d.blockedOn = b, !1;
      g.shift();
    }
    return !0;
  }
  function fT(d, g, b) {
    Fm(d) && b.delete(g);
  }
  function Hb() {
    Wb = !1, vl !== null && Fm(vl) && (vl = null), ec !== null && Fm(ec) && (ec = null), mu !== null && Fm(mu) && (mu = null), Th.forEach(fT), Um.forEach(fT);
  }
  function vu(d, g) {
    d.blockedOn === g && (d.blockedOn = null, Wb || (Wb = !0, e.unstable_scheduleCallback(
      e.unstable_NormalPriority,
      Hb
    )));
  }
  var qb = null;
  function Wm(d) {
    qb !== d && (qb = d, e.unstable_scheduleCallback(
      e.unstable_NormalPriority,
      function() {
        qb === d && (qb = null);
        for (var g = 0; g < d.length; g += 3) {
          var b = d[g], C = d[g + 1], I = d[g + 2];
          if (typeof C != "function") {
            if (lT(C || b) === null)
              continue;
            break;
          }
          var j = ti(b);
          j !== null && (d.splice(g, 3), g -= 3, rw(
            j,
            {
              pending: !0,
              data: I,
              method: b.method,
              action: C
            },
            C,
            I
          ));
        }
      }
    ));
  }
  function Eh(d) {
    function g(xe) {
      return vu(xe, d);
    }
    vl !== null && vu(vl, d), ec !== null && vu(ec, d), mu !== null && vu(mu, d), Th.forEach(g), Um.forEach(g);
    for (var b = 0; b < Sd.length; b++) {
      var C = Sd[b];
      C.blockedOn === d && (C.blockedOn = null);
    }
    for (; 0 < Sd.length && (b = Sd[0], b.blockedOn === null); )
      dT(b), b.blockedOn === null && Sd.shift();
    if (b = (d.ownerDocument || d).$$reactFormReplay, b != null)
      for (C = 0; C < b.length; C += 3) {
        var I = b[C], j = b[C + 1], K = I[Jt] || null;
        if (typeof j == "function")
          K || Wm(b);
        else if (K) {
          var se = null;
          if (j && j.hasAttribute("formAction")) {
            if (I = j, K = j[Jt] || null)
              se = K.formAction;
            else if (lT(I) !== null) continue;
          } else se = K.action;
          typeof se == "function" ? b[C + 1] = se : (b.splice(C, 3), C -= 3), Wm(b);
        }
      }
  }
  function wd(d) {
    this._internalRoot = d;
  }
  $b.prototype.render = wd.prototype.render = function(d) {
    var g = this._internalRoot;
    if (g === null) throw Error(r(409));
    var b = g.current, C = ts();
    iT(b, C, d, g, null, null);
  }, $b.prototype.unmount = wd.prototype.unmount = function() {
    var d = this._internalRoot;
    if (d !== null) {
      this._internalRoot = null;
      var g = d.containerInfo;
      iT(d.current, 2, null, d, null, null), Tm(), g[Nn] = null;
    }
  };
  function $b(d) {
    this._internalRoot = d;
  }
  $b.prototype.unstable_scheduleHydration = function(d) {
    if (d) {
      var g = ei();
      d = { blockedOn: null, target: d, priority: g };
      for (var b = 0; b < Sd.length && g !== 0 && g < Sd[b].priority; b++) ;
      Sd.splice(b, 0, d), b === 0 && dT(d);
    }
  };
  var BC = t.version;
  if (BC !== "19.1.1")
    throw Error(
      r(
        527,
        BC,
        "19.1.1"
      )
    );
  ee.findDOMNode = function(d) {
    var g = d._reactInternals;
    if (g === void 0)
      throw typeof d.render == "function" ? Error(r(188)) : (d = Object.keys(d).join(","), Error(r(268, d)));
    return d = f(g), d = d !== null ? p(d) : null, d = d === null ? null : d.stateNode, d;
  };
  var VC = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: Z,
    reconcilerVersion: "19.1.1"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var io = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!io.isDisabled && io.supportsFiber)
      try {
        at = io.inject(
          VC
        ), et = io;
      } catch {
      }
  }
  return XT.createRoot = function(d, g) {
    if (!i(d)) throw Error(r(299));
    var b = !1, C = "", I = dw, j = th, K = fw, se = null;
    return g != null && (g.unstable_strictMode === !0 && (b = !0), g.identifierPrefix !== void 0 && (C = g.identifierPrefix), g.onUncaughtError !== void 0 && (I = g.onUncaughtError), g.onCaughtError !== void 0 && (j = g.onCaughtError), g.onRecoverableError !== void 0 && (K = g.onRecoverableError), g.unstable_transitionCallbacks !== void 0 && (se = g.unstable_transitionCallbacks)), g = jC(
      d,
      1,
      !1,
      null,
      null,
      b,
      C,
      I,
      j,
      K,
      se,
      null
    ), d[Nn] = g.current, Am(d), new wd(g);
  }, XT.hydrateRoot = function(d, g, b) {
    if (!i(d)) throw Error(r(299));
    var C = !1, I = "", j = dw, K = th, se = fw, xe = null, ze = null;
    return b != null && (b.unstable_strictMode === !0 && (C = !0), b.identifierPrefix !== void 0 && (I = b.identifierPrefix), b.onUncaughtError !== void 0 && (j = b.onUncaughtError), b.onCaughtError !== void 0 && (K = b.onCaughtError), b.onRecoverableError !== void 0 && (se = b.onRecoverableError), b.unstable_transitionCallbacks !== void 0 && (xe = b.unstable_transitionCallbacks), b.formState !== void 0 && (ze = b.formState)), g = jC(
      d,
      1,
      !0,
      g,
      b ?? null,
      C,
      I,
      j,
      K,
      se,
      xe,
      ze
    ), g.context = rT(null), b = g.current, C = ts(), C = jr(C), I = Qc(C), I.callback = null, Sa(b, I, C), b = C, g.current.lanes = b, Zt(g, b), hl(g), d[Nn] = g.current, Am(d), new $b(g);
  }, XT.version = "19.1.1", XT;
}
var ZT = {}, iq;
function Uhe() {
  if (iq) return ZT;
  iq = 1;
  var e = {};
  /**
   * @license React
   * react-dom-client.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(a, l) {
      for (a = a.memoizedState; a !== null && 0 < l; )
        a = a.next, l--;
      return a;
    }
    function n(a, l, h, x) {
      if (h >= l.length) return x;
      var R = l[h], A = qi(a) ? a.slice() : pn({}, a);
      return A[R] = n(a[R], l, h + 1, x), A;
    }
    function r(a, l, h) {
      if (l.length !== h.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var x = 0; x < h.length - 1; x++)
          if (l[x] !== h[x]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return i(a, l, h, 0);
      }
    }
    function i(a, l, h, x) {
      var R = l[x], A = qi(a) ? a.slice() : pn({}, a);
      return x + 1 === l.length ? (A[h[x]] = A[R], qi(A) ? A.splice(R, 1) : delete A[R]) : A[R] = i(
        a[R],
        l,
        h,
        x + 1
      ), A;
    }
    function o(a, l, h) {
      var x = l[h], R = qi(a) ? a.slice() : pn({}, a);
      return h + 1 === l.length ? (qi(R) ? R.splice(x, 1) : delete R[x], R) : (R[x] = o(a[x], l, h + 1), R);
    }
    function s() {
      return !1;
    }
    function u() {
      return null;
    }
    function f() {
    }
    function p() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function m() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function v() {
    }
    function y(a) {
      var l = [];
      return a.forEach(function(h) {
        l.push(h);
      }), l.sort().join(", ");
    }
    function S(a, l, h, x) {
      return new AP(a, l, h, x);
    }
    function E(a, l) {
      a.context === _h && (_m(a.current, 2, l, a, null, null), _f());
    }
    function w(a, l) {
      if (ic !== null) {
        var h = l.staleFamilies;
        l = l.updatedFamilies, id(), sf(
          a.current,
          l,
          h
        ), _f();
      }
    }
    function _(a) {
      ic = a;
    }
    function O(a) {
      return !(!a || a.nodeType !== 1 && a.nodeType !== 9 && a.nodeType !== 11);
    }
    function D(a) {
      var l = a, h = a;
      if (a.alternate) for (; l.return; ) l = l.return;
      else {
        a = l;
        do
          l = a, (l.flags & 4098) !== 0 && (h = l.return), a = l.return;
        while (a);
      }
      return l.tag === 3 ? h : null;
    }
    function P(a) {
      if (a.tag === 13) {
        var l = a.memoizedState;
        if (l === null && (a = a.alternate, a !== null && (l = a.memoizedState)), l !== null) return l.dehydrated;
      }
      return null;
    }
    function M(a) {
      if (D(a) !== a)
        throw Error("Unable to find node on an unmounted component.");
    }
    function N(a) {
      var l = a.alternate;
      if (!l) {
        if (l = D(a), l === null)
          throw Error("Unable to find node on an unmounted component.");
        return l !== a ? null : a;
      }
      for (var h = a, x = l; ; ) {
        var R = h.return;
        if (R === null) break;
        var A = R.alternate;
        if (A === null) {
          if (x = R.return, x !== null) {
            h = x;
            continue;
          }
          break;
        }
        if (R.child === A.child) {
          for (A = R.child; A; ) {
            if (A === h) return M(R), a;
            if (A === x) return M(R), l;
            A = A.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (h.return !== x.return) h = R, x = A;
        else {
          for (var B = !1, G = R.child; G; ) {
            if (G === h) {
              B = !0, h = R, x = A;
              break;
            }
            if (G === x) {
              B = !0, x = R, h = A;
              break;
            }
            G = G.sibling;
          }
          if (!B) {
            for (G = A.child; G; ) {
              if (G === h) {
                B = !0, h = A, x = R;
                break;
              }
              if (G === x) {
                B = !0, x = A, h = R;
                break;
              }
              G = G.sibling;
            }
            if (!B)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (h.alternate !== x)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (h.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return h.stateNode.current === h ? a : l;
    }
    function k(a) {
      var l = a.tag;
      if (l === 5 || l === 26 || l === 27 || l === 6) return a;
      for (a = a.child; a !== null; ) {
        if (l = k(a), l !== null) return l;
        a = a.sibling;
      }
      return null;
    }
    function U(a) {
      return a === null || typeof a != "object" ? null : (a = Im && a[Im] || a["@@iterator"], typeof a == "function" ? a : null);
    }
    function H(a) {
      if (a == null) return null;
      if (typeof a == "function")
        return a.$$typeof === _r ? null : a.displayName || a.name || null;
      if (typeof a == "string") return a;
      switch (a) {
        case md:
          return "Fragment";
        case Am:
          return "Profiler";
        case Pf:
          return "StrictMode";
        case yd:
          return "Suspense";
        case Ib:
          return "SuspenseList";
        case Nb:
          return "Activity";
      }
      if (typeof a == "object")
        switch (typeof a.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), a.$$typeof) {
          case bn:
            return "Portal";
          case Pa:
            return (a.displayName || "Context") + ".Provider";
          case Dm:
            return (a._context.displayName || "Context") + ".Consumer";
          case vd:
            var l = a.render;
            return a = a.displayName, a || (a = l.displayName || l.name || "", a = a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef"), a;
          case Pb:
            return l = a.displayName || null, l !== null ? l : H(a.type) || "Memo";
          case ns:
            l = a._payload, a = a._init;
            try {
              return H(a(l));
            } catch {
            }
        }
      return null;
    }
    function Y(a) {
      return typeof a.tag == "number" ? z(a) : typeof a.name == "string" ? a.name : null;
    }
    function z(a) {
      var l = a.type;
      switch (a.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (l._context.displayName || "Context") + ".Consumer";
        case 10:
          return (l.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return a = l.render, a = a.displayName || a.name || "", l.displayName || (a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return l;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return H(l);
        case 8:
          return l === Pf ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof l == "function")
            return l.displayName || l.name || null;
          if (typeof l == "string") return l;
          break;
        case 29:
          if (l = a._debugInfo, l != null) {
            for (var h = l.length - 1; 0 <= h; h--)
              if (typeof l[h].name == "string") return l[h].name;
          }
          if (a.return !== null)
            return z(a.return);
      }
      return null;
    }
    function V(a) {
      return { current: a };
    }
    function F(a, l) {
      0 > Xl ? console.error("Unexpected pop.") : (l !== vh[Xl] && console.error("Unexpected Fiber popped."), a.current = Pm[Xl], Pm[Xl] = null, vh[Xl] = null, Xl--);
    }
    function X(a, l, h) {
      Xl++, Pm[Xl] = a.current, vh[Xl] = h, a.current = l;
    }
    function oe(a) {
      return a === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), a;
    }
    function re(a, l) {
      X(Zl, l, a), X(Nf, a, a), X(fu, null, a);
      var h = l.nodeType;
      switch (h) {
        case 9:
        case 11:
          h = h === 9 ? "#document" : "#fragment", l = (l = l.documentElement) && (l = l.namespaceURI) ? Aa(l) : qf;
          break;
        default:
          if (h = l.tagName, l = l.namespaceURI)
            l = Aa(l), l = su(
              l,
              h
            );
          else
            switch (h) {
              case "svg":
                l = x0;
                break;
              case "math":
                l = mR;
                break;
              default:
                l = qf;
            }
      }
      h = h.toLowerCase(), h = uS(null, h), h = {
        context: l,
        ancestorInfo: h
      }, F(fu, a), X(fu, h, a);
    }
    function Z(a) {
      F(fu, a), F(Nf, a), F(Zl, a);
    }
    function ee() {
      return oe(fu.current);
    }
    function J(a) {
      a.memoizedState !== null && X(Mb, a, a);
      var l = oe(fu.current), h = a.type, x = su(l.context, h);
      h = uS(l.ancestorInfo, h), x = { context: x, ancestorInfo: h }, l !== x && (X(Nf, a, a), X(fu, x, a));
    }
    function le(a) {
      Nf.current === a && (F(fu, a), F(Nf, a)), Mb.current === a && (F(Mb, a), HT._currentValue = sv);
    }
    function be(a) {
      return typeof Symbol == "function" && Symbol.toStringTag && a[Symbol.toStringTag] || a.constructor.name || "Object";
    }
    function ne(a) {
      try {
        return ae(a), !1;
      } catch {
        return !0;
      }
    }
    function ae(a) {
      return "" + a;
    }
    function ie(a, l) {
      if (ne(a))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          l,
          be(a)
        ), ae(a);
    }
    function he(a, l) {
      if (ne(a))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          l,
          be(a)
        ), ae(a);
    }
    function pe(a) {
      if (ne(a))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          be(a)
        ), ae(a);
    }
    function me(a) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var l = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (l.isDisabled) return !0;
      if (!l.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        Mf = l.inject(a), wo = l;
      } catch (h) {
        console.error("React instrumentation encountered an error: %s.", h);
      }
      return !!l.checkDCE;
    }
    function Ee(a) {
      if (typeof gl == "function" && Kw(a), wo && typeof wo.setStrictMode == "function")
        try {
          wo.setStrictMode(Mf, a);
        } catch (l) {
          Ci || (Ci = !0, console.error(
            "React instrumentation encountered an error: %s",
            l
          ));
        }
    }
    function Ie(a) {
      Pt = a;
    }
    function Pe() {
      Pt !== null && typeof Pt.markCommitStopped == "function" && Pt.markCommitStopped();
    }
    function De(a) {
      Pt !== null && typeof Pt.markComponentRenderStarted == "function" && Pt.markComponentRenderStarted(a);
    }
    function Ye() {
      Pt !== null && typeof Pt.markComponentRenderStopped == "function" && Pt.markComponentRenderStopped();
    }
    function Ue(a) {
      Pt !== null && typeof Pt.markRenderStarted == "function" && Pt.markRenderStarted(a);
    }
    function ve() {
      Pt !== null && typeof Pt.markRenderStopped == "function" && Pt.markRenderStopped();
    }
    function rt(a, l) {
      Pt !== null && typeof Pt.markStateUpdateScheduled == "function" && Pt.markStateUpdateScheduled(a, l);
    }
    function Te(a) {
      return a >>>= 0, a === 0 ? 32 : 31 - (pu(a) / UP | 0) | 0;
    }
    function Je(a) {
      if (a & 1) return "SyncHydrationLane";
      if (a & 2) return "Sync";
      if (a & 4) return "InputContinuousHydration";
      if (a & 8) return "InputContinuous";
      if (a & 16) return "DefaultHydration";
      if (a & 32) return "Default";
      if (a & 128) return "TransitionHydration";
      if (a & 4194048) return "Transition";
      if (a & 62914560) return "Retry";
      if (a & 67108864) return "SelectiveHydration";
      if (a & 134217728) return "IdleHydration";
      if (a & 268435456) return "Idle";
      if (a & 536870912) return "Offscreen";
      if (a & 1073741824) return "Deferred";
    }
    function L(a) {
      var l = a & 42;
      if (l !== 0) return l;
      switch (a & -a) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return a & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return a & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), a;
      }
    }
    function te(a, l, h) {
      var x = a.pendingLanes;
      if (x === 0) return 0;
      var R = 0, A = a.suspendedLanes, B = a.pingedLanes;
      a = a.warmLanes;
      var G = x & 134217727;
      return G !== 0 ? (x = G & ~A, x !== 0 ? R = L(x) : (B &= G, B !== 0 ? R = L(B) : h || (h = G & ~a, h !== 0 && (R = L(h))))) : (G = x & ~A, G !== 0 ? R = L(G) : B !== 0 ? R = L(B) : h || (h = x & ~a, h !== 0 && (R = L(h)))), R === 0 ? 0 : l !== 0 && l !== R && (l & A) === 0 && (A = R & -R, h = l & -l, A >= h || A === 32 && (h & 4194048) !== 0) ? l : R;
    }
    function ge(a, l) {
      return (a.pendingLanes & ~(a.suspendedLanes & ~a.pingedLanes) & l) === 0;
    }
    function ke(a, l) {
      switch (a) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return l + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return l + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function We() {
      var a = jb;
      return jb <<= 1, (jb & 4194048) === 0 && (jb = 256), a;
    }
    function Be() {
      var a = hu;
      return hu <<= 1, (hu & 62914560) === 0 && (hu = 4194304), a;
    }
    function je(a) {
      for (var l = [], h = 0; 31 > h; h++) l.push(a);
      return l;
    }
    function mt(a, l) {
      a.pendingLanes |= l, l !== 268435456 && (a.suspendedLanes = 0, a.pingedLanes = 0, a.warmLanes = 0);
    }
    function qe(a, l, h, x, R, A) {
      var B = a.pendingLanes;
      a.pendingLanes = h, a.suspendedLanes = 0, a.pingedLanes = 0, a.warmLanes = 0, a.expiredLanes &= h, a.entangledLanes &= h, a.errorRecoveryDisabledLanes &= h, a.shellSuspendCounter = 0;
      var G = a.entanglements, ue = a.expirationTimes, fe = a.hiddenUpdates;
      for (h = B & ~h; 0 < h; ) {
        var Xe = 31 - ro(h), nt = 1 << Xe;
        G[Xe] = 0, ue[Xe] = -1;
        var $e = fe[Xe];
        if ($e !== null)
          for (fe[Xe] = null, Xe = 0; Xe < $e.length; Xe++) {
            var st = $e[Xe];
            st !== null && (st.lane &= -536870913);
          }
        h &= ~nt;
      }
      x !== 0 && at(a, x, 0), A !== 0 && R === 0 && a.tag !== 0 && (a.suspendedLanes |= A & ~(B & ~l));
    }
    function at(a, l, h) {
      a.pendingLanes |= l, a.suspendedLanes &= ~l;
      var x = 31 - ro(l);
      a.entangledLanes |= l, a.entanglements[x] = a.entanglements[x] | 1073741824 | h & 4194090;
    }
    function et(a, l) {
      var h = a.entangledLanes |= l;
      for (a = a.entanglements; h; ) {
        var x = 31 - ro(h), R = 1 << x;
        R & l | a[x] & l && (a[x] |= l), h &= ~R;
      }
    }
    function bt(a) {
      switch (a) {
        case 2:
          a = 1;
          break;
        case 8:
          a = 4;
          break;
        case 32:
          a = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          a = 128;
          break;
        case 268435456:
          a = 134217728;
          break;
        default:
          a = 0;
      }
      return a;
    }
    function q(a, l, h) {
      if (Ps)
        for (a = a.pendingUpdatersLaneMap; 0 < h; ) {
          var x = 31 - ro(h), R = 1 << x;
          a[x].add(l), h &= ~R;
        }
    }
    function W(a, l) {
      if (Ps)
        for (var h = a.pendingUpdatersLaneMap, x = a.memoizedUpdaters; 0 < l; ) {
          var R = 31 - ro(l);
          a = 1 << R, R = h[R], 0 < R.size && (R.forEach(function(A) {
            var B = A.alternate;
            B !== null && x.has(B) || x.add(A);
          }), R.clear()), l &= ~a;
        }
    }
    function Q(a) {
      return a &= -a, rs < a ? Ql < a ? (a & 134217727) !== 0 ? gu : Lb : Ql : rs;
    }
    function ce() {
      var a = lr.p;
      return a !== 0 ? a : (a = window.event, a === void 0 ? gu : gd(a.type));
    }
    function _e(a, l) {
      var h = lr.p;
      try {
        return lr.p = a, l();
      } finally {
        lr.p = h;
      }
    }
    function Fe(a) {
      delete a[zo], delete a[Na], delete a[kb], delete a[bh], delete a[Mm];
    }
    function gt(a) {
      var l = a[zo];
      if (l) return l;
      for (var h = a.parentNode; h; ) {
        if (l = h[xd] || h[zo]) {
          if (h = l.alternate, l.child !== null || h !== null && h.child !== null)
            for (a = vb(a); a !== null; ) {
              if (h = a[zo])
                return h;
              a = vb(a);
            }
          return l;
        }
        a = h, h = a.parentNode;
      }
      return null;
    }
    function ct(a) {
      if (a = a[zo] || a[xd]) {
        var l = a.tag;
        if (l === 5 || l === 6 || l === 13 || l === 26 || l === 27 || l === 3)
          return a;
      }
      return null;
    }
    function ht(a) {
      var l = a.tag;
      if (l === 5 || l === 26 || l === 27 || l === 6)
        return a.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function Yt(a) {
      var l = a[Qw];
      return l || (l = a[Qw] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), l;
    }
    function Rt(a) {
      a[jm] = !0;
    }
    function cn(a, l) {
      Kt(a, l), Kt(a + "Capture", l);
    }
    function Kt(a, l) {
      ml[a] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        a
      ), ml[a] = l;
      var h = a.toLowerCase();
      for (zb[h] = a, a === "onDoubleClick" && (zb.ondblclick = a), a = 0; a < l.length; a++)
        jf.add(l[a]);
    }
    function Zt(a, l) {
      Bb[l.type] || l.onChange || l.onInput || l.readOnly || l.disabled || l.value == null || console.error(
        a === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), l.onChange || l.readOnly || l.disabled || l.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function dn(a) {
      return Kl.call(Lm, a) ? !0 : Kl.call(Vb, a) ? !1 : Jw.test(a) ? Lm[a] = !0 : (Vb[a] = !0, console.error("Invalid attribute name: `%s`", a), !1);
    }
    function xr(a, l, h) {
      if (dn(l)) {
        if (!a.hasAttribute(l)) {
          switch (typeof h) {
            case "symbol":
            case "object":
              return h;
            case "function":
              return h;
            case "boolean":
              if (h === !1) return h;
          }
          return h === void 0 ? void 0 : null;
        }
        return a = a.getAttribute(l), a === "" && h === !0 ? !0 : (ie(h, l), a === "" + h ? h : a);
      }
    }
    function Hr(a, l, h) {
      if (dn(l))
        if (h === null) a.removeAttribute(l);
        else {
          switch (typeof h) {
            case "undefined":
            case "function":
            case "symbol":
              a.removeAttribute(l);
              return;
            case "boolean":
              var x = l.toLowerCase().slice(0, 5);
              if (x !== "data-" && x !== "aria-") {
                a.removeAttribute(l);
                return;
              }
          }
          ie(h, l), a.setAttribute(l, "" + h);
        }
    }
    function jr(a, l, h) {
      if (h === null) a.removeAttribute(l);
      else {
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            a.removeAttribute(l);
            return;
        }
        ie(h, l), a.setAttribute(l, "" + h);
      }
    }
    function Ut(a, l, h, x) {
      if (x === null) a.removeAttribute(h);
      else {
        switch (typeof x) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            a.removeAttribute(h);
            return;
        }
        ie(x, h), a.setAttributeNS(l, h, "" + x);
      }
    }
    function ei() {
    }
    function It() {
      if (xh === 0) {
        eT = console.log, IC = console.info, tT = console.warn, Sh = console.error, PC = console.group, NC = console.groupCollapsed, MC = console.groupEnd;
        var a = {
          configurable: !0,
          enumerable: !0,
          value: ei,
          writable: !0
        };
        Object.defineProperties(console, {
          info: a,
          log: a,
          warn: a,
          error: a,
          group: a,
          groupCollapsed: a,
          groupEnd: a
        });
      }
      xh++;
    }
    function Et() {
      if (xh--, xh === 0) {
        var a = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: pn({}, a, { value: eT }),
          info: pn({}, a, { value: IC }),
          warn: pn({}, a, { value: tT }),
          error: pn({}, a, { value: Sh }),
          group: pn({}, a, { value: PC }),
          groupCollapsed: pn({}, a, { value: NC }),
          groupEnd: pn({}, a, { value: MC })
        });
      }
      0 > xh && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function jt(a) {
      if (wh === void 0)
        try {
          throw Error();
        } catch (h) {
          var l = h.stack.trim().match(/\n( *(at )?)/);
          wh = l && l[1] || "", km = -1 < h.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < h.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + wh + a + km;
    }
    function Jt(a, l) {
      if (!a || zm) return "";
      var h = nT.get(a);
      if (h !== void 0) return h;
      zm = !0, h = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var x = null;
      x = Ge.H, Ge.H = null, It();
      try {
        var R = {
          DetermineComponentFrameRoot: function() {
            try {
              if (l) {
                var $e = function() {
                  throw Error();
                };
                if (Object.defineProperty($e.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct($e, []);
                  } catch (Ht) {
                    var st = Ht;
                  }
                  Reflect.construct(a, [], $e);
                } else {
                  try {
                    $e.call();
                  } catch (Ht) {
                    st = Ht;
                  }
                  a.call($e.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Ht) {
                  st = Ht;
                }
                ($e = a()) && typeof $e.catch == "function" && $e.catch(function() {
                });
              }
            } catch (Ht) {
              if (Ht && st && typeof Ht.stack == "string")
                return [Ht.stack, st.stack];
            }
            return [null, null];
          }
        };
        R.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var A = Object.getOwnPropertyDescriptor(
          R.DetermineComponentFrameRoot,
          "name"
        );
        A && A.configurable && Object.defineProperty(
          R.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var B = R.DetermineComponentFrameRoot(), G = B[0], ue = B[1];
        if (G && ue) {
          var fe = G.split(`
`), Xe = ue.split(`
`);
          for (B = A = 0; A < fe.length && !fe[A].includes(
            "DetermineComponentFrameRoot"
          ); )
            A++;
          for (; B < Xe.length && !Xe[B].includes(
            "DetermineComponentFrameRoot"
          ); )
            B++;
          if (A === fe.length || B === Xe.length)
            for (A = fe.length - 1, B = Xe.length - 1; 1 <= A && 0 <= B && fe[A] !== Xe[B]; )
              B--;
          for (; 1 <= A && 0 <= B; A--, B--)
            if (fe[A] !== Xe[B]) {
              if (A !== 1 || B !== 1)
                do
                  if (A--, B--, 0 > B || fe[A] !== Xe[B]) {
                    var nt = `
` + fe[A].replace(
                      " at new ",
                      " at "
                    );
                    return a.displayName && nt.includes("<anonymous>") && (nt = nt.replace("<anonymous>", a.displayName)), typeof a == "function" && nT.set(a, nt), nt;
                  }
                while (1 <= A && 0 <= B);
              break;
            }
        }
      } finally {
        zm = !1, Ge.H = x, Et(), Error.prepareStackTrace = h;
      }
      return fe = (fe = a ? a.displayName || a.name : "") ? jt(fe) : "", typeof a == "function" && nT.set(a, fe), fe;
    }
    function Nn(a) {
      var l = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, a = a.stack, Error.prepareStackTrace = l, a.startsWith(`Error: react-stack-top-frame
`) && (a = a.slice(29)), l = a.indexOf(`
`), l !== -1 && (a = a.slice(l + 1)), l = a.indexOf("react_stack_bottom_frame"), l !== -1 && (l = a.lastIndexOf(
        `
`,
        l
      )), l !== -1)
        a = a.slice(0, l);
      else return "";
      return a;
    }
    function Ai(a) {
      switch (a.tag) {
        case 26:
        case 27:
        case 5:
          return jt(a.type);
        case 16:
          return jt("Lazy");
        case 13:
          return jt("Suspense");
        case 19:
          return jt("SuspenseList");
        case 0:
        case 15:
          return Jt(a.type, !1);
        case 11:
          return Jt(a.type.render, !1);
        case 1:
          return Jt(a.type, !0);
        case 31:
          return jt("Activity");
        default:
          return "";
      }
    }
    function ho(a) {
      try {
        var l = "";
        do {
          l += Ai(a);
          var h = a._debugInfo;
          if (h)
            for (var x = h.length - 1; 0 <= x; x--) {
              var R = h[x];
              if (typeof R.name == "string") {
                var A = l, B = R.env, G = jt(
                  R.name + (B ? " [" + B + "]" : "")
                );
                l = A + G;
              }
            }
          a = a.return;
        } while (a);
        return l;
      } catch (ue) {
        return `
Error generating stack: ` + ue.message + `
` + ue.stack;
      }
    }
    function gi(a) {
      return (a = a ? a.displayName || a.name : "") ? jt(a) : "";
    }
    function go() {
      if (To === null) return null;
      var a = To._debugOwner;
      return a != null ? Y(a) : null;
    }
    function gr() {
      if (To === null) return "";
      var a = To;
      try {
        var l = "";
        switch (a.tag === 6 && (a = a.return), a.tag) {
          case 26:
          case 27:
          case 5:
            l += jt(a.type);
            break;
          case 13:
            l += jt("Suspense");
            break;
          case 19:
            l += jt("SuspenseList");
            break;
          case 31:
            l += jt("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            a._debugOwner || l !== "" || (l += gi(
              a.type
            ));
            break;
          case 11:
            a._debugOwner || l !== "" || (l += gi(
              a.type.render
            ));
        }
        for (; a; )
          if (typeof a.tag == "number") {
            var h = a;
            a = h._debugOwner;
            var x = h._debugStack;
            a && x && (typeof x != "string" && (h._debugStack = x = Nn(x)), x !== "" && (l += `
` + x));
          } else if (a.debugStack != null) {
            var R = a.debugStack;
            (a = a.owner) && R && (l += `
` + Nn(R));
          } else break;
        var A = l;
      } catch (B) {
        A = `
Error generating stack: ` + B.message + `
` + B.stack;
      }
      return A;
    }
    function _t(a, l, h, x, R, A, B) {
      var G = To;
      mi(a);
      try {
        return a !== null && a._debugTask ? a._debugTask.run(
          l.bind(null, h, x, R, A, B)
        ) : l(h, x, R, A, B);
      } finally {
        mi(G);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function mi(a) {
      Ge.getCurrentStack = a === null ? null : gr, Jl = !1, To = a;
    }
    function ti(a) {
      switch (typeof a) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return a;
        case "object":
          return pe(a), a;
        default:
          return "";
      }
    }
    function Le(a) {
      var l = a.type;
      return (a = a.nodeName) && a.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
    }
    function de(a) {
      var l = Le(a) ? "checked" : "value", h = Object.getOwnPropertyDescriptor(
        a.constructor.prototype,
        l
      );
      pe(a[l]);
      var x = "" + a[l];
      if (!a.hasOwnProperty(l) && typeof h < "u" && typeof h.get == "function" && typeof h.set == "function") {
        var R = h.get, A = h.set;
        return Object.defineProperty(a, l, {
          configurable: !0,
          get: function() {
            return R.call(this);
          },
          set: function(B) {
            pe(B), x = "" + B, A.call(this, B);
          }
        }), Object.defineProperty(a, l, {
          enumerable: h.enumerable
        }), {
          getValue: function() {
            return x;
          },
          setValue: function(B) {
            pe(B), x = "" + B;
          },
          stopTracking: function() {
            a._valueTracker = null, delete a[l];
          }
        };
      }
    }
    function Ne(a) {
      a._valueTracker || (a._valueTracker = de(a));
    }
    function vt(a) {
      if (!a) return !1;
      var l = a._valueTracker;
      if (!l) return !0;
      var h = l.getValue(), x = "";
      return a && (x = Le(a) ? a.checked ? "true" : "false" : a.value), a = x, a !== h ? (l.setValue(a), !0) : !1;
    }
    function kt(a) {
      if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u") return null;
      try {
        return a.activeElement || a.body;
      } catch {
        return a.body;
      }
    }
    function zt(a) {
      return a.replace(
        jC,
        function(l) {
          return "\\" + l.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function fn(a, l) {
      l.checked === void 0 || l.defaultChecked === void 0 || iT || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        go() || "A component",
        l.type
      ), iT = !0), l.value === void 0 || l.defaultValue === void 0 || rT || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        go() || "A component",
        l.type
      ), rT = !0);
    }
    function Xn(a, l, h, x, R, A, B, G) {
      a.name = "", B != null && typeof B != "function" && typeof B != "symbol" && typeof B != "boolean" ? (ie(B, "type"), a.type = B) : a.removeAttribute("type"), l != null ? B === "number" ? (l === 0 && a.value === "" || a.value != l) && (a.value = "" + ti(l)) : a.value !== "" + ti(l) && (a.value = "" + ti(l)) : B !== "submit" && B !== "reset" || a.removeAttribute("value"), l != null ? ys(a, B, ti(l)) : h != null ? ys(a, B, ti(h)) : x != null && a.removeAttribute("value"), R == null && A != null && (a.defaultChecked = !!A), R != null && (a.checked = R && typeof R != "function" && typeof R != "symbol"), G != null && typeof G != "function" && typeof G != "symbol" && typeof G != "boolean" ? (ie(G, "name"), a.name = "" + ti(G)) : a.removeAttribute("name");
    }
    function mo(a, l, h, x, R, A, B, G) {
      if (A != null && typeof A != "function" && typeof A != "symbol" && typeof A != "boolean" && (ie(A, "type"), a.type = A), l != null || h != null) {
        if (!(A !== "submit" && A !== "reset" || l != null))
          return;
        h = h != null ? "" + ti(h) : "", l = l != null ? "" + ti(l) : h, G || l === a.value || (a.value = l), a.defaultValue = l;
      }
      x = x ?? R, x = typeof x != "function" && typeof x != "symbol" && !!x, a.checked = G ? a.checked : !!x, a.defaultChecked = !!x, B != null && typeof B != "function" && typeof B != "symbol" && typeof B != "boolean" && (ie(B, "name"), a.name = B);
    }
    function ys(a, l, h) {
      l === "number" && kt(a.ownerDocument) === a || a.defaultValue === "" + h || (a.defaultValue = "" + h);
    }
    function Di(a, l) {
      l.value == null && (typeof l.children == "object" && l.children !== null ? qw.Children.forEach(l.children, function(h) {
        h == null || typeof h == "string" || typeof h == "number" || typeof h == "bigint" || Ub || (Ub = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : l.dangerouslySetInnerHTML == null || aT || (aT = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), l.selected == null || oT || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), oT = !0);
    }
    function qa() {
      var a = go();
      return a ? `

Check the render method of \`` + a + "`." : "";
    }
    function vo(a, l, h, x) {
      if (a = a.options, l) {
        l = {};
        for (var R = 0; R < h.length; R++)
          l["$" + h[R]] = !0;
        for (h = 0; h < a.length; h++)
          R = l.hasOwnProperty("$" + a[h].value), a[h].selected !== R && (a[h].selected = R), R && x && (a[h].defaultSelected = !0);
      } else {
        for (h = "" + ti(h), l = null, R = 0; R < a.length; R++) {
          if (a[R].value === h) {
            a[R].selected = !0, x && (a[R].defaultSelected = !0);
            return;
          }
          l !== null || a[R].disabled || (l = a[R]);
        }
        l !== null && (l.selected = !0);
      }
    }
    function yn(a, l) {
      for (a = 0; a < LC.length; a++) {
        var h = LC[a];
        if (l[h] != null) {
          var x = qi(l[h]);
          l.multiple && !x ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            h,
            qa()
          ) : !l.multiple && x && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            h,
            qa()
          );
        }
      }
      l.value === void 0 || l.defaultValue === void 0 || Bm || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), Bm = !0);
    }
    function Xo(a, l) {
      l.value === void 0 || l.defaultValue === void 0 || kC || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        go() || "A component"
      ), kC = !0), l.children != null && l.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function bs(a, l, h) {
      if (l != null && (l = "" + ti(l), l !== a.value && (a.value = l), h == null)) {
        a.defaultValue !== l && (a.defaultValue = l);
        return;
      }
      a.defaultValue = h != null ? "" + ti(h) : "";
    }
    function $a(a, l, h, x) {
      if (l == null) {
        if (x != null) {
          if (h != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (qi(x)) {
            if (1 < x.length)
              throw Error("<textarea> can only have at most one child.");
            x = x[0];
          }
          h = x;
        }
        h == null && (h = ""), l = h;
      }
      h = ti(l), a.defaultValue = h, x = a.textContent, x === h && x !== "" && x !== null && (a.value = x);
    }
    function vp(a, l) {
      return a.serverProps === void 0 && a.serverTail.length === 0 && a.children.length === 1 && 3 < a.distanceFromLeaf && a.distanceFromLeaf > 15 - l ? vp(a.children[0], l) : a;
    }
    function Zo(a) {
      return "  " + "  ".repeat(a);
    }
    function yp(a) {
      return "+ " + "  ".repeat(a);
    }
    function Uu(a) {
      return "- " + "  ".repeat(a);
    }
    function Ga(a) {
      switch (a.tag) {
        case 26:
        case 27:
        case 5:
          return a.type;
        case 16:
          return "Lazy";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return a = a.type, a.displayName || a.name || null;
        case 11:
          return a = a.type.render, a.displayName || a.name || null;
        case 1:
          return a = a.type, a.displayName || a.name || null;
        default:
          return null;
      }
    }
    function bp(a, l) {
      return Fb.test(a) ? (a = JSON.stringify(a), a.length > l - 2 ? 8 > l ? '{"..."}' : "{" + a.slice(0, l - 7) + '..."}' : "{" + a + "}") : a.length > l ? 5 > l ? '{"..."}' : a.slice(0, l - 3) + "..." : a;
    }
    function uy(a, l, h) {
      var x = 120 - 2 * h;
      if (l === null)
        return yp(h) + bp(a, x) + `
`;
      if (typeof l == "string") {
        for (var R = 0; R < l.length && R < a.length && l.charCodeAt(R) === a.charCodeAt(R); R++) ;
        return R > x - 8 && 10 < R && (a = "..." + a.slice(R - 8), l = "..." + l.slice(R - 8)), yp(h) + bp(a, x) + `
` + Uu(h) + bp(l, x) + `
`;
      }
      return Zo(h) + bp(a, x) + `
`;
    }
    function xp(a) {
      return Object.prototype.toString.call(a).replace(/^\[object (.*)\]$/, function(l, h) {
        return h;
      });
    }
    function Sp(a, l) {
      switch (typeof a) {
        case "string":
          return a = JSON.stringify(a), a.length > l ? 5 > l ? '"..."' : a.slice(0, l - 4) + '..."' : a;
        case "object":
          if (a === null) return "null";
          if (qi(a)) return "[...]";
          if (a.$$typeof === du)
            return (l = H(a.type)) ? "<" + l + ">" : "<...>";
          var h = xp(a);
          if (h === "Object") {
            h = "", l -= 2;
            for (var x in a)
              if (a.hasOwnProperty(x)) {
                var R = JSON.stringify(x);
                if (R !== '"' + x + '"' && (x = R), l -= x.length - 2, R = Sp(
                  a[x],
                  15 > l ? l : 15
                ), l -= R.length, 0 > l) {
                  h += h === "" ? "..." : ", ...";
                  break;
                }
                h += (h === "" ? "" : ",") + x + ":" + R;
              }
            return "{" + h + "}";
          }
          return h;
        case "function":
          return (l = a.displayName || a.name) ? "function " + l : "function";
        default:
          return String(a);
      }
    }
    function Uc(a, l) {
      return typeof a != "string" || Fb.test(a) ? "{" + Sp(a, l - 2) + "}" : a.length > l - 2 ? 5 > l ? '"..."' : '"' + a.slice(0, l - 5) + '..."' : '"' + a + '"';
    }
    function aS(a, l, h) {
      var x = 120 - h.length - a.length, R = [], A;
      for (A in l)
        if (l.hasOwnProperty(A) && A !== "children") {
          var B = Uc(
            l[A],
            120 - h.length - A.length - 1
          );
          x -= A.length + B.length + 2, R.push(A + "=" + B);
        }
      return R.length === 0 ? h + "<" + a + `>
` : 0 < x ? h + "<" + a + " " + R.join(" ") + `>
` : h + "<" + a + `
` + h + "  " + R.join(`
` + h + "  ") + `
` + h + `>
`;
    }
    function xs(a, l, h) {
      var x = "", R = pn({}, l), A;
      for (A in a)
        if (a.hasOwnProperty(A)) {
          delete R[A];
          var B = 120 - 2 * h - A.length - 2, G = Sp(a[A], B);
          l.hasOwnProperty(A) ? (B = Sp(l[A], B), x += yp(h) + A + ": " + G + `
`, x += Uu(h) + A + ": " + B + `
`) : x += yp(h) + A + ": " + G + `
`;
        }
      for (var ue in R)
        R.hasOwnProperty(ue) && (a = Sp(
          R[ue],
          120 - 2 * h - ue.length - 2
        ), x += Uu(h) + ue + ": " + a + `
`);
      return x;
    }
    function sS(a, l, h, x) {
      var R = "", A = /* @__PURE__ */ new Map();
      for (fe in h)
        h.hasOwnProperty(fe) && A.set(
          fe.toLowerCase(),
          fe
        );
      if (A.size === 1 && A.has("children"))
        R += aS(
          a,
          l,
          Zo(x)
        );
      else {
        for (var B in l)
          if (l.hasOwnProperty(B) && B !== "children") {
            var G = 120 - 2 * (x + 1) - B.length - 1, ue = A.get(B.toLowerCase());
            if (ue !== void 0) {
              A.delete(B.toLowerCase());
              var fe = l[B];
              ue = h[ue];
              var Xe = Uc(
                fe,
                G
              );
              G = Uc(
                ue,
                G
              ), typeof fe == "object" && fe !== null && typeof ue == "object" && ue !== null && xp(fe) === "Object" && xp(ue) === "Object" && (2 < Object.keys(fe).length || 2 < Object.keys(ue).length || -1 < Xe.indexOf("...") || -1 < G.indexOf("...")) ? R += Zo(x + 1) + B + `={{
` + xs(
                fe,
                ue,
                x + 2
              ) + Zo(x + 1) + `}}
` : (R += yp(x + 1) + B + "=" + Xe + `
`, R += Uu(x + 1) + B + "=" + G + `
`);
            } else
              R += Zo(x + 1) + B + "=" + Uc(l[B], G) + `
`;
          }
        A.forEach(function(nt) {
          if (nt !== "children") {
            var $e = 120 - 2 * (x + 1) - nt.length - 1;
            R += Uu(x + 1) + nt + "=" + Uc(h[nt], $e) + `
`;
          }
        }), R = R === "" ? Zo(x) + "<" + a + `>
` : Zo(x) + "<" + a + `
` + R + Zo(x) + `>
`;
      }
      return a = h.children, l = l.children, typeof a == "string" || typeof a == "number" || typeof a == "bigint" ? (A = "", (typeof l == "string" || typeof l == "number" || typeof l == "bigint") && (A = "" + l), R += uy(A, "" + a, x + 1)) : (typeof l == "string" || typeof l == "number" || typeof l == "bigint") && (R = a == null ? R + uy("" + l, null, x + 1) : R + uy("" + l, void 0, x + 1)), R;
    }
    function lS(a, l) {
      var h = Ga(a);
      if (h === null) {
        for (h = "", a = a.child; a; )
          h += lS(a, l), a = a.sibling;
        return h;
      }
      return Zo(l) + "<" + h + `>
`;
    }
    function Dg(a, l) {
      var h = vp(a, l);
      if (h !== a && (a.children.length !== 1 || a.children[0] !== h))
        return Zo(l) + `...
` + Dg(h, l + 1);
      h = "";
      var x = a.fiber._debugInfo;
      if (x)
        for (var R = 0; R < x.length; R++) {
          var A = x[R].name;
          typeof A == "string" && (h += Zo(l) + "<" + A + `>
`, l++);
        }
      if (x = "", R = a.fiber.pendingProps, a.fiber.tag === 6)
        x = uy(R, a.serverProps, l), l++;
      else if (A = Ga(a.fiber), A !== null)
        if (a.serverProps === void 0) {
          x = l;
          var B = 120 - 2 * x - A.length - 2, G = "";
          for (fe in R)
            if (R.hasOwnProperty(fe) && fe !== "children") {
              var ue = Uc(R[fe], 15);
              if (B -= fe.length + ue.length + 2, 0 > B) {
                G += " ...";
                break;
              }
              G += " " + fe + "=" + ue;
            }
          x = Zo(x) + "<" + A + G + `>
`, l++;
        } else
          a.serverProps === null ? (x = aS(
            A,
            R,
            yp(l)
          ), l++) : typeof a.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (x = sS(
            A,
            R,
            a.serverProps,
            l
          ), l++);
      var fe = "";
      for (R = a.fiber.child, A = 0; R && A < a.children.length; )
        B = a.children[A], B.fiber === R ? (fe += Dg(B, l), A++) : fe += lS(R, l), R = R.sibling;
      for (R && 0 < a.children.length && (fe += Zo(l) + `...
`), R = a.serverTail, a.serverProps === null && l--, a = 0; a < R.length; a++)
        A = R[a], fe = typeof A == "string" ? fe + (Uu(l) + bp(A, 120 - 2 * l) + `
`) : fe + aS(
          A.type,
          A.props,
          Uu(l)
        );
      return h + x + fe;
    }
    function Fu(a) {
      try {
        return `

` + Dg(a, 0);
      } catch {
        return "";
      }
    }
    function cS(a, l, h) {
      for (var x = l, R = null, A = 0; x; )
        x === a && (A = 0), R = {
          fiber: x,
          children: R !== null ? [R] : [],
          serverProps: x === l ? h : x === a ? null : void 0,
          serverTail: [],
          distanceFromLeaf: A
        }, A++, x = x.return;
      return R !== null ? Fu(R).replaceAll(/^[+-]/gm, ">") : "";
    }
    function uS(a, l) {
      var h = pn({}, a || Wb), x = { tag: l };
      return Vm.indexOf(l) !== -1 && (h.aTagInScope = null, h.buttonTagInScope = null, h.nobrTagInScope = null), lT.indexOf(l) !== -1 && (h.pTagInButtonScope = null), sT.indexOf(l) !== -1 && l !== "address" && l !== "div" && l !== "p" && (h.listItemTagAutoclosing = null, h.dlItemTagAutoclosing = null), h.current = x, l === "form" && (h.formTag = x), l === "a" && (h.aTagInScope = x), l === "button" && (h.buttonTagInScope = x), l === "nobr" && (h.nobrTagInScope = x), l === "p" && (h.pTagInButtonScope = x), l === "li" && (h.listItemTagAutoclosing = x), (l === "dd" || l === "dt") && (h.dlItemTagAutoclosing = x), l === "#document" || l === "html" ? h.containerTagInScope = null : h.containerTagInScope || (h.containerTagInScope = x), a !== null || l !== "#document" && l !== "html" && l !== "body" ? h.implicitRootScope === !0 && (h.implicitRootScope = !1) : h.implicitRootScope = !0, h;
    }
    function Jd(a, l, h) {
      switch (l) {
        case "select":
          return a === "hr" || a === "option" || a === "optgroup" || a === "script" || a === "template" || a === "#text";
        case "optgroup":
          return a === "option" || a === "#text";
        case "option":
          return a === "#text";
        case "tr":
          return a === "th" || a === "td" || a === "style" || a === "script" || a === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return a === "tr" || a === "style" || a === "script" || a === "template";
        case "colgroup":
          return a === "col" || a === "template";
        case "table":
          return a === "caption" || a === "colgroup" || a === "tbody" || a === "tfoot" || a === "thead" || a === "style" || a === "script" || a === "template";
        case "head":
          return a === "base" || a === "basefont" || a === "bgsound" || a === "link" || a === "meta" || a === "title" || a === "noscript" || a === "noframes" || a === "style" || a === "script" || a === "template";
        case "html":
          if (h) break;
          return a === "head" || a === "body" || a === "frameset";
        case "frameset":
          return a === "frame";
        case "#document":
          if (!h) return a === "html";
      }
      switch (a) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return l !== "h1" && l !== "h2" && l !== "h3" && l !== "h4" && l !== "h5" && l !== "h6";
        case "rp":
        case "rt":
          return zC.indexOf(l) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return l == null;
        case "head":
          return h || l === null;
        case "html":
          return h && l === "#document" || l === null;
        case "body":
          return h && (l === "#document" || l === "html") || l === null;
      }
      return !0;
    }
    function wP(a, l) {
      switch (a) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return l.pTagInButtonScope;
        case "form":
          return l.formTag || l.pTagInButtonScope;
        case "li":
          return l.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return l.dlItemTagAutoclosing;
        case "button":
          return l.buttonTagInScope;
        case "a":
          return l.aTagInScope;
        case "nobr":
          return l.nobrTagInScope;
      }
      return null;
    }
    function dS(a, l) {
      for (; a; ) {
        switch (a.tag) {
          case 5:
          case 26:
          case 27:
            if (a.type === l) return a;
        }
        a = a.return;
      }
      return null;
    }
    function dy(a, l) {
      l = l || Wb;
      var h = l.current;
      if (l = (h = Jd(
        a,
        h && h.tag,
        l.implicitRootScope
      ) ? null : h) ? null : wP(a, l), l = h || l, !l) return !0;
      var x = l.tag;
      if (l = String(!!h) + "|" + a + "|" + x, vl[l]) return !1;
      vl[l] = !0;
      var R = (l = To) ? dS(l.return, x) : null, A = l !== null && R !== null ? cS(R, l, null) : "", B = "<" + a + ">";
      return h ? (h = "", x === "table" && a === "tr" && (h += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        B,
        x,
        h,
        A
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        B,
        x,
        A
      ), l && (a = l.return, R === null || a === null || R === a && a._debugOwner === l._debugOwner || _t(R, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          x,
          B
        );
      })), !1;
    }
    function wp(a, l, h) {
      if (h || Jd("#text", l, !1))
        return !0;
      if (h = "#text|" + l, vl[h]) return !1;
      vl[h] = !0;
      var x = (h = To) ? dS(h, l) : null;
      return h = h !== null && x !== null ? cS(
        x,
        h,
        h.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(a) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        l,
        h
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        l,
        h
      ), !1;
    }
    function Ig(a, l) {
      if (l) {
        var h = a.firstChild;
        if (h && h === a.lastChild && h.nodeType === 3) {
          h.nodeValue = l;
          return;
        }
      }
      a.textContent = l;
    }
    function TP(a) {
      return a.replace(FP, function(l, h) {
        return h.toUpperCase();
      });
    }
    function Pg(a, l, h) {
      var x = l.indexOf("--") === 0;
      x || (-1 < l.indexOf("-") ? tc.hasOwnProperty(l) && tc[l] || (tc[l] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        l,
        TP(l.replace(Sd, "ms-"))
      )) : Um.test(l) ? tc.hasOwnProperty(l) && tc[l] || (tc[l] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        l,
        l.charAt(0).toUpperCase() + l.slice(1)
      )) : !cT.test(h) || uT.hasOwnProperty(h) && uT[h] || (uT[h] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        l,
        h.replace(cT, "")
      )), typeof h == "number" && (isNaN(h) ? dT || (dT = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        l
      )) : isFinite(h) || Fm || (Fm = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        l
      )))), h == null || typeof h == "boolean" || h === "" ? x ? a.setProperty(l, "") : l === "float" ? a.cssFloat = "" : a[l] = "" : x ? a.setProperty(l, h) : typeof h != "number" || h === 0 || fT.has(l) ? l === "float" ? a.cssFloat = h : (he(h, l), a[l] = ("" + h).trim()) : a[l] = h + "px";
    }
    function fy(a, l, h) {
      if (l != null && typeof l != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (l && Object.freeze(l), a = a.style, h != null) {
        if (l) {
          var x = {};
          if (h) {
            for (var R in h)
              if (h.hasOwnProperty(R) && !l.hasOwnProperty(R))
                for (var A = ec[R] || [R], B = 0; B < A.length; B++)
                  x[A[B]] = R;
          }
          for (var G in l)
            if (l.hasOwnProperty(G) && (!h || h[G] !== l[G]))
              for (R = ec[G] || [G], A = 0; A < R.length; A++)
                x[R[A]] = G;
          G = {};
          for (var ue in l)
            for (R = ec[ue] || [ue], A = 0; A < R.length; A++)
              G[R[A]] = ue;
          ue = {};
          for (var fe in x)
            if (R = x[fe], (A = G[fe]) && R !== A && (B = R + "," + A, !ue[B])) {
              ue[B] = !0, B = console;
              var Xe = l[R];
              B.error.call(
                B,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                Xe == null || typeof Xe == "boolean" || Xe === "" ? "Removing" : "Updating",
                R,
                A
              );
            }
        }
        for (var nt in h)
          !h.hasOwnProperty(nt) || l != null && l.hasOwnProperty(nt) || (nt.indexOf("--") === 0 ? a.setProperty(nt, "") : nt === "float" ? a.cssFloat = "" : a[nt] = "");
        for (var $e in l)
          fe = l[$e], l.hasOwnProperty($e) && h[$e] !== fe && Pg(a, $e, fe);
      } else
        for (x in l)
          l.hasOwnProperty(x) && Pg(a, x, l[x]);
    }
    function ef(a) {
      if (a.indexOf("-") === -1) return !1;
      switch (a) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function tf(a) {
      return qb.get(a) || a;
    }
    function Tp(a, l) {
      if (Kl.call(wd, l) && wd[l])
        return !0;
      if (BC.test(l)) {
        if (a = "aria-" + l.slice(4).toLowerCase(), a = Eh.hasOwnProperty(a) ? a : null, a == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            l
          ), wd[l] = !0;
        if (l !== a)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            l,
            a
          ), wd[l] = !0;
      }
      if ($b.test(l)) {
        if (a = l.toLowerCase(), a = Eh.hasOwnProperty(a) ? a : null, a == null) return wd[l] = !0, !1;
        l !== a && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          l,
          a
        ), wd[l] = !0);
      }
      return !0;
    }
    function L_(a, l) {
      var h = [], x;
      for (x in l)
        Tp(a, x) || h.push(x);
      l = h.map(function(R) {
        return "`" + R + "`";
      }).join(", "), h.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        l,
        a
      ) : 1 < h.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        l,
        a
      );
    }
    function fS(a, l, h, x) {
      if (Kl.call(io, l) && io[l])
        return !0;
      var R = l.toLowerCase();
      if (R === "onfocusin" || R === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), io[l] = !0;
      if (typeof h == "function" && (a === "form" && l === "action" || a === "input" && l === "formAction" || a === "button" && l === "formAction"))
        return !0;
      if (x != null) {
        if (a = x.possibleRegistrationNames, x.registrationNameDependencies.hasOwnProperty(l))
          return !0;
        if (x = a.hasOwnProperty(R) ? a[R] : null, x != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            l,
            x
          ), io[l] = !0;
        if (d.test(l))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            l
          ), io[l] = !0;
      } else if (d.test(l))
        return g.test(l) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          l
        ), io[l] = !0;
      if (b.test(l) || C.test(l)) return !0;
      if (R === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), io[l] = !0;
      if (R === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), io[l] = !0;
      if (R === "is" && h !== null && h !== void 0 && typeof h != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof h
        ), io[l] = !0;
      if (typeof h == "number" && isNaN(h))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          l
        ), io[l] = !0;
      if (Wm.hasOwnProperty(R)) {
        if (R = Wm[R], R !== l)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            l,
            R
          ), io[l] = !0;
      } else if (l !== R)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          l,
          R
        ), io[l] = !0;
      switch (l) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof h) {
        case "boolean":
          switch (l) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return R = l.toLowerCase().slice(0, 5), R === "data-" || R === "aria-" ? !0 : (h ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                h,
                l,
                l,
                h,
                l
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                h,
                l,
                l,
                h,
                l,
                l,
                l
              ), io[l] = !0);
          }
        case "function":
        case "symbol":
          return io[l] = !0, !1;
        case "string":
          if (h === "false" || h === "true") {
            switch (l) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              h,
              l,
              h === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              l,
              h
            ), io[l] = !0;
          }
      }
      return !0;
    }
    function k_(a, l, h) {
      var x = [], R;
      for (R in l)
        fS(a, R, l[R], h) || x.push(R);
      l = x.map(function(A) {
        return "`" + A + "`";
      }).join(", "), x.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        l,
        a
      ) : 1 < x.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        l,
        a
      );
    }
    function Fc(a) {
      return I.test("" + a) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : a;
    }
    function Gs(a) {
      return a = a.target || a.srcElement || window, a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === 3 ? a.parentNode : a;
    }
    function py(a) {
      var l = ct(a);
      if (l && (a = l.stateNode)) {
        var h = a[Na] || null;
        e: switch (a = l.stateNode, l.type) {
          case "input":
            if (Xn(
              a,
              h.value,
              h.defaultValue,
              h.defaultValue,
              h.checked,
              h.defaultChecked,
              h.type,
              h.name
            ), l = h.name, h.type === "radio" && l != null) {
              for (h = a; h.parentNode; ) h = h.parentNode;
              for (ie(l, "name"), h = h.querySelectorAll(
                'input[name="' + zt(
                  "" + l
                ) + '"][type="radio"]'
              ), l = 0; l < h.length; l++) {
                var x = h[l];
                if (x !== a && x.form === a.form) {
                  var R = x[Na] || null;
                  if (!R)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  Xn(
                    x,
                    R.value,
                    R.defaultValue,
                    R.defaultValue,
                    R.checked,
                    R.defaultChecked,
                    R.type,
                    R.name
                  );
                }
              }
              for (l = 0; l < h.length; l++)
                x = h[l], x.form === a.form && vt(x);
            }
            break e;
          case "textarea":
            bs(a, h.value, h.defaultValue);
            break e;
          case "select":
            l = h.value, l != null && vo(a, !!h.multiple, l, !1);
        }
      }
    }
    function Ep(a, l, h) {
      if (xe) return a(l, h);
      xe = !0;
      try {
        var x = a(l);
        return x;
      } finally {
        if (xe = !1, (K !== null || se !== null) && (_f(), K && (l = K, a = se, se = K = null, py(l), a)))
          for (l = 0; l < a.length; l++) py(a[l]);
      }
    }
    function Ss(a, l) {
      var h = a.stateNode;
      if (h === null) return null;
      var x = h[Na] || null;
      if (x === null) return null;
      h = x[l];
      e: switch (l) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (x = !x.disabled) || (a = a.type, x = !(a === "button" || a === "input" || a === "select" || a === "textarea")), a = !x;
          break e;
        default:
          a = !1;
      }
      if (a) return null;
      if (h && typeof h != "function")
        throw Error(
          "Expected `" + l + "` listener to be a function, instead got a value of `" + typeof h + "` type."
        );
      return h;
    }
    function hy() {
      if (on) return on;
      var a, l = Ze, h = l.length, x, R = "value" in He ? He.value : He.textContent, A = R.length;
      for (a = 0; a < h && l[a] === R[a]; a++) ;
      var B = h - a;
      for (x = 1; x <= B && l[h - x] === R[A - x]; x++) ;
      return on = R.slice(a, 1 < x ? 1 - x : void 0);
    }
    function nf(a) {
      var l = a.keyCode;
      return "charCode" in a ? (a = a.charCode, a === 0 && l === 13 && (a = 13)) : a = l, a === 10 && (a = 13), 32 <= a || a === 13 ? a : 0;
    }
    function Ng() {
      return !0;
    }
    function Mg() {
      return !1;
    }
    function yo(a) {
      function l(h, x, R, A, B) {
        this._reactName = h, this._targetInst = R, this.type = x, this.nativeEvent = A, this.target = B, this.currentTarget = null;
        for (var G in a)
          a.hasOwnProperty(G) && (h = a[G], this[G] = h ? h(A) : A[G]);
        return this.isDefaultPrevented = (A.defaultPrevented != null ? A.defaultPrevented : A.returnValue === !1) ? Ng : Mg, this.isPropagationStopped = Mg, this;
      }
      return pn(l.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var h = this.nativeEvent;
          h && (h.preventDefault ? h.preventDefault() : typeof h.returnValue != "unknown" && (h.returnValue = !1), this.isDefaultPrevented = Ng);
        },
        stopPropagation: function() {
          var h = this.nativeEvent;
          h && (h.stopPropagation ? h.stopPropagation() : typeof h.cancelBubble != "unknown" && (h.cancelBubble = !0), this.isPropagationStopped = Ng);
        },
        persist: function() {
        },
        isPersistent: Ng
      }), l;
    }
    function z_(a) {
      var l = this.nativeEvent;
      return l.getModifierState ? l.getModifierState(a) : (a = rpe[a]) ? !!l[a] : !1;
    }
    function Mo() {
      return z_;
    }
    function Wu(a, l) {
      switch (a) {
        case "keyup":
          return gpe.indexOf(l.keyCode) !== -1;
        case "keydown":
          return l.keyCode !== ZH;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function jg(a) {
      return a = a.detail, typeof a == "object" && "data" in a ? a.data : null;
    }
    function Lg(a, l) {
      switch (a) {
        case "compositionend":
          return jg(l);
        case "keypress":
          return l.which !== QH ? null : (e5 = !0, JH);
        case "textInput":
          return a = l.data, a === JH && e5 ? null : a;
        default:
          return null;
      }
    }
    function EP(a, l) {
      if (Gb)
        return a === "compositionend" || !HP && Wu(a, l) ? (a = hy(), on = Ze = He = null, Gb = !1, a) : null;
      switch (a) {
        case "paste":
          return null;
        case "keypress":
          if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
            if (l.char && 1 < l.char.length)
              return l.char;
            if (l.which)
              return String.fromCharCode(l.which);
          }
          return null;
        case "compositionend":
          return KH && l.locale !== "ko" ? null : l.data;
        default:
          return null;
      }
    }
    function gy(a) {
      var l = a && a.nodeName && a.nodeName.toLowerCase();
      return l === "input" ? !!vpe[a.type] : l === "textarea";
    }
    function pS(a) {
      if (!ze) return !1;
      a = "on" + a;
      var l = a in document;
      return l || (l = document.createElement("div"), l.setAttribute(a, "return;"), l = typeof l[a] == "function"), l;
    }
    function _p(a, l, h, x) {
      K ? se ? se.push(x) : se = [x] : K = x, l = ko(l, "onChange"), 0 < l.length && (h = new cr(
        "onChange",
        "change",
        null,
        h,
        x
      ), a.push({ event: h, listeners: l }));
    }
    function my(a) {
      Aw(a, 0);
    }
    function kg(a) {
      var l = ht(a);
      if (vt(l)) return a;
    }
    function B_(a, l) {
      if (a === "change") return l;
    }
    function V_() {
      hT && (hT.detachEvent("onpropertychange", U_), gT = hT = null);
    }
    function U_(a) {
      if (a.propertyName === "value" && kg(gT)) {
        var l = [];
        _p(
          l,
          gT,
          a,
          Gs(a)
        ), Ep(my, l);
      }
    }
    function hS(a, l, h) {
      a === "focusin" ? (V_(), hT = l, gT = h, hT.attachEvent("onpropertychange", U_)) : a === "focusout" && V_();
    }
    function _P(a) {
      if (a === "selectionchange" || a === "keyup" || a === "keydown")
        return kg(gT);
    }
    function CP(a, l) {
      if (a === "click") return kg(l);
    }
    function RP(a, l) {
      if (a === "input" || a === "change")
        return kg(l);
    }
    function OP(a, l) {
      return a === l && (a !== 0 || 1 / a === 1 / l) || a !== a && l !== l;
    }
    function zg(a, l) {
      if (is(a, l)) return !0;
      if (typeof a != "object" || a === null || typeof l != "object" || l === null)
        return !1;
      var h = Object.keys(a), x = Object.keys(l);
      if (h.length !== x.length) return !1;
      for (x = 0; x < h.length; x++) {
        var R = h[x];
        if (!Kl.call(l, R) || !is(a[R], l[R]))
          return !1;
      }
      return !0;
    }
    function gS(a) {
      for (; a && a.firstChild; ) a = a.firstChild;
      return a;
    }
    function F_(a, l) {
      var h = gS(a);
      a = 0;
      for (var x; h; ) {
        if (h.nodeType === 3) {
          if (x = a + h.textContent.length, a <= l && x >= l)
            return { node: h, offset: l - a };
          a = x;
        }
        e: {
          for (; h; ) {
            if (h.nextSibling) {
              h = h.nextSibling;
              break e;
            }
            h = h.parentNode;
          }
          h = void 0;
        }
        h = gS(h);
      }
    }
    function W_(a, l) {
      return a && l ? a === l ? !0 : a && a.nodeType === 3 ? !1 : l && l.nodeType === 3 ? W_(a, l.parentNode) : "contains" in a ? a.contains(l) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(l) & 16) : !1 : !1;
    }
    function H_(a) {
      a = a != null && a.ownerDocument != null && a.ownerDocument.defaultView != null ? a.ownerDocument.defaultView : window;
      for (var l = kt(a.document); l instanceof a.HTMLIFrameElement; ) {
        try {
          var h = typeof l.contentWindow.location.href == "string";
        } catch {
          h = !1;
        }
        if (h) a = l.contentWindow;
        else break;
        l = kt(a.document);
      }
      return l;
    }
    function mS(a) {
      var l = a && a.nodeName && a.nodeName.toLowerCase();
      return l && (l === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || l === "textarea" || a.contentEditable === "true");
    }
    function vy(a, l, h) {
      var x = h.window === h ? h.document : h.nodeType === 9 ? h : h.ownerDocument;
      $P || Yb == null || Yb !== kt(x) || (x = Yb, "selectionStart" in x && mS(x) ? x = { start: x.selectionStart, end: x.selectionEnd } : (x = (x.ownerDocument && x.ownerDocument.defaultView || window).getSelection(), x = {
        anchorNode: x.anchorNode,
        anchorOffset: x.anchorOffset,
        focusNode: x.focusNode,
        focusOffset: x.focusOffset
      }), mT && zg(mT, x) || (mT = x, x = ko(qP, "onSelect"), 0 < x.length && (l = new cr(
        "onSelect",
        "select",
        null,
        l,
        h
      ), a.push({ event: l, listeners: x }), l.target = Yb)));
    }
    function rf(a, l) {
      var h = {};
      return h[a.toLowerCase()] = l.toLowerCase(), h["Webkit" + a] = "webkit" + l, h["Moz" + a] = "moz" + l, h;
    }
    function of(a) {
      if (GP[a]) return GP[a];
      if (!Xb[a]) return a;
      var l = Xb[a], h;
      for (h in l)
        if (l.hasOwnProperty(h) && h in n5)
          return GP[a] = l[h];
      return a;
    }
    function Ys(a, l) {
      s5.set(a, l), cn(l, [a]);
    }
    function ga(a, l) {
      if (typeof a == "object" && a !== null) {
        var h = XP.get(a);
        return h !== void 0 ? h : (l = {
          value: a,
          source: l,
          stack: ho(l)
        }, XP.set(a, l), l);
      }
      return {
        value: a,
        source: l,
        stack: ho(l)
      };
    }
    function yy() {
      for (var a = Zb, l = ZP = Zb = 0; l < a; ) {
        var h = rc[l];
        rc[l++] = null;
        var x = rc[l];
        rc[l++] = null;
        var R = rc[l];
        rc[l++] = null;
        var A = rc[l];
        if (rc[l++] = null, x !== null && R !== null) {
          var B = x.pending;
          B === null ? R.next = R : (R.next = B.next, B.next = R), x.pending = R;
        }
        A !== 0 && q_(h, R, A);
      }
    }
    function by(a, l, h, x) {
      rc[Zb++] = a, rc[Zb++] = l, rc[Zb++] = h, rc[Zb++] = x, ZP |= x, a.lanes |= x, a = a.alternate, a !== null && (a.lanes |= x);
    }
    function vS(a, l, h, x) {
      return by(a, l, h, x), xy(a);
    }
    function ma(a, l) {
      return by(a, null, null, l), xy(a);
    }
    function q_(a, l, h) {
      a.lanes |= h;
      var x = a.alternate;
      x !== null && (x.lanes |= h);
      for (var R = !1, A = a.return; A !== null; )
        A.childLanes |= h, x = A.alternate, x !== null && (x.childLanes |= h), A.tag === 22 && (a = A.stateNode, a === null || a._visibility & UC || (R = !0)), a = A, A = A.return;
      return a.tag === 3 ? (A = a.stateNode, R && l !== null && (R = 31 - ro(h), a = A.hiddenUpdates, x = a[R], x === null ? a[R] = [l] : x.push(l), l.lane = h | 536870912), A) : null;
    }
    function xy(a) {
      if (zT > Vpe)
        throw nv = zT = 0, BT = CN = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      nv > Upe && (nv = 0, BT = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), a.alternate === null && (a.flags & 4098) !== 0 && _w(a);
      for (var l = a, h = l.return; h !== null; )
        l.alternate === null && (l.flags & 4098) !== 0 && _w(a), l = h, h = l.return;
      return l.tag === 3 ? l.stateNode : null;
    }
    function af(a) {
      if (ic === null) return a;
      var l = ic(a);
      return l === void 0 ? a : l.current;
    }
    function yS(a) {
      if (ic === null) return a;
      var l = ic(a);
      return l === void 0 ? a != null && typeof a.render == "function" && (l = af(a.render), a.render !== l) ? (l = { $$typeof: vd, render: l }, a.displayName !== void 0 && (l.displayName = a.displayName), l) : a : l.current;
    }
    function $_(a, l) {
      if (ic === null) return !1;
      var h = a.elementType;
      l = l.type;
      var x = !1, R = typeof l == "object" && l !== null ? l.$$typeof : null;
      switch (a.tag) {
        case 1:
          typeof l == "function" && (x = !0);
          break;
        case 0:
          (typeof l == "function" || R === ns) && (x = !0);
          break;
        case 11:
          (R === vd || R === ns) && (x = !0);
          break;
        case 14:
        case 15:
          (R === Pb || R === ns) && (x = !0);
          break;
        default:
          return !1;
      }
      return !!(x && (a = ic(h), a !== void 0 && a === ic(l)));
    }
    function Sy(a) {
      ic !== null && typeof WeakSet == "function" && (Kb === null && (Kb = /* @__PURE__ */ new WeakSet()), Kb.add(a));
    }
    function sf(a, l, h) {
      var x = a.alternate, R = a.child, A = a.sibling, B = a.tag, G = a.type, ue = null;
      switch (B) {
        case 0:
        case 15:
        case 1:
          ue = G;
          break;
        case 11:
          ue = G.render;
      }
      if (ic === null)
        throw Error("Expected resolveFamily to be set during hot reload.");
      var fe = !1;
      G = !1, ue !== null && (ue = ic(ue), ue !== void 0 && (h.has(ue) ? G = !0 : l.has(ue) && (B === 1 ? G = !0 : fe = !0))), Kb !== null && (Kb.has(a) || x !== null && Kb.has(x)) && (G = !0), G && (a._debugNeedsRemount = !0), (G || fe) && (x = ma(a, 2), x !== null && Mn(x, a, 2)), R === null || G || sf(
        R,
        l,
        h
      ), A !== null && sf(
        A,
        l,
        h
      );
    }
    function AP(a, l, h, x) {
      this.tag = a, this.key = h, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = x, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, c5 || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function wy(a) {
      return a = a.prototype, !(!a || !a.isReactComponent);
    }
    function Fl(a, l) {
      var h = a.alternate;
      switch (h === null ? (h = S(
        a.tag,
        l,
        a.key,
        a.mode
      ), h.elementType = a.elementType, h.type = a.type, h.stateNode = a.stateNode, h._debugOwner = a._debugOwner, h._debugStack = a._debugStack, h._debugTask = a._debugTask, h._debugHookTypes = a._debugHookTypes, h.alternate = a, a.alternate = h) : (h.pendingProps = l, h.type = a.type, h.flags = 0, h.subtreeFlags = 0, h.deletions = null, h.actualDuration = -0, h.actualStartTime = -1.1), h.flags = a.flags & 65011712, h.childLanes = a.childLanes, h.lanes = a.lanes, h.child = a.child, h.memoizedProps = a.memoizedProps, h.memoizedState = a.memoizedState, h.updateQueue = a.updateQueue, l = a.dependencies, h.dependencies = l === null ? null : {
        lanes: l.lanes,
        firstContext: l.firstContext,
        _debugThenableState: l._debugThenableState
      }, h.sibling = a.sibling, h.index = a.index, h.ref = a.ref, h.refCleanup = a.refCleanup, h.selfBaseDuration = a.selfBaseDuration, h.treeBaseDuration = a.treeBaseDuration, h._debugInfo = a._debugInfo, h._debugNeedsRemount = a._debugNeedsRemount, h.tag) {
        case 0:
        case 15:
          h.type = af(a.type);
          break;
        case 1:
          h.type = af(a.type);
          break;
        case 11:
          h.type = yS(a.type);
      }
      return h;
    }
    function bS(a, l) {
      a.flags &= 65011714;
      var h = a.alternate;
      return h === null ? (a.childLanes = 0, a.lanes = l, a.child = null, a.subtreeFlags = 0, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null, a.selfBaseDuration = 0, a.treeBaseDuration = 0) : (a.childLanes = h.childLanes, a.lanes = h.lanes, a.child = h.child, a.subtreeFlags = 0, a.deletions = null, a.memoizedProps = h.memoizedProps, a.memoizedState = h.memoizedState, a.updateQueue = h.updateQueue, a.type = h.type, l = h.dependencies, a.dependencies = l === null ? null : {
        lanes: l.lanes,
        firstContext: l.firstContext,
        _debugThenableState: l._debugThenableState
      }, a.selfBaseDuration = h.selfBaseDuration, a.treeBaseDuration = h.treeBaseDuration), a;
    }
    function Ty(a, l, h, x, R, A) {
      var B = 0, G = a;
      if (typeof a == "function")
        wy(a) && (B = 1), G = af(G);
      else if (typeof a == "string")
        B = ee(), B = Sb(a, h, B) ? 26 : a === "html" || a === "head" || a === "body" ? 27 : 5;
      else
        e: switch (a) {
          case Nb:
            return l = S(31, h, l, R), l.elementType = Nb, l.lanes = A, l;
          case md:
            return ws(
              h.children,
              R,
              A,
              l
            );
          case Pf:
            B = 8, R |= Ma, R |= yu;
            break;
          case Am:
            return a = h, x = R, typeof a.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof a.id
            ), l = S(12, a, l, x | ta), l.elementType = Am, l.lanes = A, l.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, l;
          case yd:
            return l = S(13, h, l, R), l.elementType = yd, l.lanes = A, l;
          case Ib:
            return l = S(19, h, l, R), l.elementType = Ib, l.lanes = A, l;
          default:
            if (typeof a == "object" && a !== null)
              switch (a.$$typeof) {
                case RC:
                case Pa:
                  B = 10;
                  break e;
                case Dm:
                  B = 9;
                  break e;
                case vd:
                  B = 11, G = yS(G);
                  break e;
                case Pb:
                  B = 14;
                  break e;
                case ns:
                  B = 16, G = null;
                  break e;
              }
            G = "", (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), a === null ? h = "null" : qi(a) ? h = "array" : a !== void 0 && a.$$typeof === du ? (h = "<" + (H(a.type) || "Unknown") + " />", G = " Did you accidentally export a JSX literal instead of a component?") : h = typeof a, (B = x ? Y(x) : null) && (G += `

Check the render method of \`` + B + "`."), B = 29, h = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (h + "." + G)
            ), G = null;
        }
      return l = S(B, h, l, R), l.elementType = a, l.type = G, l.lanes = A, l._debugOwner = x, l;
    }
    function Bg(a, l, h) {
      return l = Ty(
        a.type,
        a.key,
        a.props,
        a._owner,
        l,
        h
      ), l._debugOwner = a._owner, l._debugStack = a._debugStack, l._debugTask = a._debugTask, l;
    }
    function ws(a, l, h, x) {
      return a = S(7, a, x, l), a.lanes = h, a;
    }
    function xS(a, l, h) {
      return a = S(6, a, null, l), a.lanes = h, a;
    }
    function SS(a, l, h) {
      return l = S(
        4,
        a.children !== null ? a.children : [],
        a.key,
        l
      ), l.lanes = h, l.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
      }, l;
    }
    function lf(a, l) {
      Xs(), Qb[Jb++] = WC, Qb[Jb++] = FC, FC = a, WC = l;
    }
    function wS(a, l, h) {
      Xs(), oc[ac++] = kf, oc[ac++] = zf, oc[ac++] = Hm, Hm = a;
      var x = kf;
      a = zf;
      var R = 32 - ro(x) - 1;
      x &= ~(1 << R), h += 1;
      var A = 32 - ro(l) + R;
      if (30 < A) {
        var B = R - R % 5;
        A = (x & (1 << B) - 1).toString(32), x >>= B, R -= B, kf = 1 << 32 - ro(l) + R | h << R | x, zf = A + a;
      } else
        kf = 1 << A | h << R | x, zf = a;
    }
    function Ey(a) {
      Xs(), a.return !== null && (lf(a, 1), wS(a, 1, 0));
    }
    function cf(a) {
      for (; a === FC; )
        FC = Qb[--Jb], Qb[Jb] = null, WC = Qb[--Jb], Qb[Jb] = null;
      for (; a === Hm; )
        Hm = oc[--ac], oc[ac] = null, zf = oc[--ac], oc[ac] = null, kf = oc[--ac], oc[ac] = null;
    }
    function Xs() {
      ar || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function uf(a, l) {
      if (a.return === null) {
        if (sc === null)
          sc = {
            fiber: a,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: l
          };
        else {
          if (sc.fiber !== a)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          sc.distanceFromLeaf > l && (sc.distanceFromLeaf = l);
        }
        return sc;
      }
      var h = uf(
        a.return,
        l + 1
      ).children;
      return 0 < h.length && h[h.length - 1].fiber === a ? (h = h[h.length - 1], h.distanceFromLeaf > l && (h.distanceFromLeaf = l), h) : (l = {
        fiber: a,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: l
      }, h.push(l), l);
    }
    function Cp(a, l) {
      Bf || (a = uf(a, 0), a.serverProps = null, l !== null && (l = mb(l), a.serverTail.push(l)));
    }
    function Hu(a) {
      var l = "", h = sc;
      throw h !== null && (sc = null, l = Fu(h)), Op(
        ga(
          Error(
            `Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + l
          ),
          a
        )
      ), KP;
    }
    function TS(a) {
      var l = a.stateNode, h = a.type, x = a.memoizedProps;
      switch (l[zo] = a, l[Na] = x, ou(h, x), h) {
        case "dialog":
          jn("cancel", l), jn("close", l);
          break;
        case "iframe":
        case "object":
        case "embed":
          jn("load", l);
          break;
        case "video":
        case "audio":
          for (h = 0; h < VT.length; h++)
            jn(VT[h], l);
          break;
        case "source":
          jn("error", l);
          break;
        case "img":
        case "image":
        case "link":
          jn("error", l), jn("load", l);
          break;
        case "details":
          jn("toggle", l);
          break;
        case "input":
          Zt("input", x), jn("invalid", l), fn(l, x), mo(
            l,
            x.value,
            x.defaultValue,
            x.checked,
            x.defaultChecked,
            x.type,
            x.name,
            !0
          ), Ne(l);
          break;
        case "option":
          Di(l, x);
          break;
        case "select":
          Zt("select", x), jn("invalid", l), yn(l, x);
          break;
        case "textarea":
          Zt("textarea", x), jn("invalid", l), Xo(l, x), $a(
            l,
            x.value,
            x.defaultValue,
            x.children
          ), Ne(l);
      }
      h = x.children, typeof h != "string" && typeof h != "number" && typeof h != "bigint" || l.textContent === "" + h || x.suppressHydrationWarning === !0 || Af(l.textContent, h) ? (x.popover != null && (jn("beforetoggle", l), jn("toggle", l)), x.onScroll != null && jn("scroll", l), x.onScrollEnd != null && jn("scrollend", l), x.onClick != null && (l.onclick = sd), l = !0) : l = !1, l || Hu(a);
    }
    function _y(a) {
      for (os = a.return; os; )
        switch (os.tag) {
          case 5:
          case 13:
            Td = !1;
            return;
          case 27:
          case 3:
            Td = !0;
            return;
          default:
            os = os.return;
        }
    }
    function df(a) {
      if (a !== os) return !1;
      if (!ar)
        return _y(a), ar = !0, !1;
      var l = a.tag, h;
      if ((h = l !== 3 && l !== 27) && ((h = l === 5) && (h = a.type, h = !(h !== "form" && h !== "button") || cd(a.type, a.memoizedProps)), h = !h), h && ji) {
        for (h = ji; h; ) {
          var x = uf(a, 0), R = mb(h);
          x.serverTail.push(R), h = R.type === "Suspense" ? uh(h) : Da(h.nextSibling);
        }
        Hu(a);
      }
      if (_y(a), l === 13) {
        if (a = a.memoizedState, a = a !== null ? a.dehydrated : null, !a)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        ji = uh(a);
      } else
        l === 27 ? (l = ji, Hi(a.type) ? (a = zN, zN = null, ji = a) : ji = l) : ji = os ? Da(a.stateNode.nextSibling) : null;
      return !0;
    }
    function Rp() {
      ji = os = null, Bf = ar = !1;
    }
    function ES() {
      var a = qm;
      return a !== null && (ls === null ? ls = a : ls.push.apply(
        ls,
        a
      ), qm = null), a;
    }
    function Op(a) {
      qm === null ? qm = [a] : qm.push(a);
    }
    function G_() {
      var a = sc;
      if (a !== null) {
        sc = null;
        for (var l = Fu(a); 0 < a.children.length; )
          a = a.children[0];
        _t(a.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            l
          );
        });
      }
    }
    function Cy() {
      e0 = HC = null, t0 = !1;
    }
    function qu(a, l, h) {
      X(QP, l._currentValue, a), l._currentValue = h, X(JP, l._currentRenderer, a), l._currentRenderer !== void 0 && l._currentRenderer !== null && l._currentRenderer !== p5 && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), l._currentRenderer = p5;
    }
    function Wc(a, l) {
      a._currentValue = QP.current;
      var h = JP.current;
      F(JP, l), a._currentRenderer = h, F(QP, l);
    }
    function _S(a, l, h) {
      for (; a !== null; ) {
        var x = a.alternate;
        if ((a.childLanes & l) !== l ? (a.childLanes |= l, x !== null && (x.childLanes |= l)) : x !== null && (x.childLanes & l) !== l && (x.childLanes |= l), a === h) break;
        a = a.return;
      }
      a !== h && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Ko(a, l, h, x) {
      var R = a.child;
      for (R !== null && (R.return = a); R !== null; ) {
        var A = R.dependencies;
        if (A !== null) {
          var B = R.child;
          A = A.firstContext;
          e: for (; A !== null; ) {
            var G = A;
            A = R;
            for (var ue = 0; ue < l.length; ue++)
              if (G.context === l[ue]) {
                A.lanes |= h, G = A.alternate, G !== null && (G.lanes |= h), _S(
                  A.return,
                  h,
                  a
                ), x || (B = null);
                break e;
              }
            A = G.next;
          }
        } else if (R.tag === 18) {
          if (B = R.return, B === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          B.lanes |= h, A = B.alternate, A !== null && (A.lanes |= h), _S(
            B,
            h,
            a
          ), B = null;
        } else B = R.child;
        if (B !== null) B.return = R;
        else
          for (B = R; B !== null; ) {
            if (B === a) {
              B = null;
              break;
            }
            if (R = B.sibling, R !== null) {
              R.return = B.return, B = R;
              break;
            }
            B = B.return;
          }
        R = B;
      }
    }
    function Hc(a, l, h, x) {
      a = null;
      for (var R = l, A = !1; R !== null; ) {
        if (!A) {
          if ((R.flags & 524288) !== 0) A = !0;
          else if ((R.flags & 262144) !== 0) break;
        }
        if (R.tag === 10) {
          var B = R.alternate;
          if (B === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (B = B.memoizedProps, B !== null) {
            var G = R.type;
            is(R.pendingProps.value, B.value) || (a !== null ? a.push(G) : a = [G]);
          }
        } else if (R === Mb.current) {
          if (B = R.alternate, B === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          B.memoizedState.memoizedState !== R.memoizedState.memoizedState && (a !== null ? a.push(HT) : a = [HT]);
        }
        R = R.return;
      }
      a !== null && Ko(
        l,
        a,
        h,
        x
      ), l.flags |= 262144;
    }
    function Vg(a) {
      for (a = a.firstContext; a !== null; ) {
        if (!is(
          a.context._currentValue,
          a.memoizedValue
        ))
          return !0;
        a = a.next;
      }
      return !1;
    }
    function $u(a) {
      HC = a, e0 = null, a = a.dependencies, a !== null && (a.firstContext = null);
    }
    function qr(a) {
      return t0 && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), Ry(HC, a);
    }
    function Ug(a, l) {
      return HC === null && $u(a), Ry(a, l);
    }
    function Ry(a, l) {
      var h = l._currentValue;
      if (l = { context: l, memoizedValue: h, next: null }, e0 === null) {
        if (a === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        e0 = l, a.dependencies = {
          lanes: 0,
          firstContext: l,
          _debugThenableState: null
        }, a.flags |= 524288;
      } else e0 = e0.next = l;
      return h;
    }
    function CS() {
      return {
        controller: new _pe(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function Ts(a) {
      a.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      ), a.refCount++;
    }
    function ff(a) {
      a.refCount--, 0 > a.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      ), a.refCount === 0 && Cpe(Rpe, function() {
        a.controller.abort();
      });
    }
    function Ya() {
      var a = $m;
      return $m = 0, a;
    }
    function Ap(a) {
      var l = $m;
      return $m = a, l;
    }
    function Dp(a) {
      var l = $m;
      return $m += a, l;
    }
    function qc(a) {
      Ns = n0(), 0 > a.actualStartTime && (a.actualStartTime = Ns);
    }
    function Gu(a) {
      if (0 <= Ns) {
        var l = n0() - Ns;
        a.actualDuration += l, a.selfBaseDuration = l, Ns = -1;
      }
    }
    function Oy(a) {
      if (0 <= Ns) {
        var l = n0() - Ns;
        a.actualDuration += l, Ns = -1;
      }
    }
    function Zs() {
      if (0 <= Ns) {
        var a = n0() - Ns;
        Ns = -1, $m += a;
      }
    }
    function jo() {
      Ns = n0();
    }
    function Fg(a) {
      for (var l = a.child; l; )
        a.actualDuration += l.actualDuration, l = l.sibling;
    }
    function Y_(a, l) {
      if (vT === null) {
        var h = vT = [];
        eN = 0, Gm = fb(), r0 = {
          status: "pending",
          value: void 0,
          then: function(x) {
            h.push(x);
          }
        };
      }
      return eN++, l.then(RS, RS), l;
    }
    function RS() {
      if (--eN === 0 && vT !== null) {
        r0 !== null && (r0.status = "fulfilled");
        var a = vT;
        vT = null, Gm = 0, r0 = null;
        for (var l = 0; l < a.length; l++) (0, a[l])();
      }
    }
    function DP(a, l) {
      var h = [], x = {
        status: "pending",
        value: null,
        reason: null,
        then: function(R) {
          h.push(R);
        }
      };
      return a.then(
        function() {
          x.status = "fulfilled", x.value = l;
          for (var R = 0; R < h.length; R++) (0, h[R])(l);
        },
        function(R) {
          for (x.status = "rejected", x.reason = R, R = 0; R < h.length; R++)
            (0, h[R])(void 0);
        }
      ), x;
    }
    function OS() {
      var a = Ym.current;
      return a !== null ? a : Xr.pooledCache;
    }
    function Ay(a, l) {
      l === null ? X(Ym, Ym.current, a) : X(Ym, l.pool, a);
    }
    function AS() {
      var a = OS();
      return a === null ? null : { parent: Eo._currentValue, pool: a };
    }
    function DS() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function Dy(a) {
      return a = a.status, a === "fulfilled" || a === "rejected";
    }
    function va() {
    }
    function IS(a, l, h) {
      Ge.actQueue !== null && (Ge.didUsePromise = !0);
      var x = a.thenables;
      switch (h = x[h], h === void 0 ? x.push(l) : h !== l && (a.didWarnAboutUncachedPromise || (a.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), l.then(va, va), l = h), l.status) {
        case "fulfilled":
          return l.value;
        case "rejected":
          throw a = l.reason, Za(a), a;
        default:
          if (typeof l.status == "string")
            l.then(va, va);
          else {
            if (a = Xr, a !== null && 100 < a.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            a = l, a.status = "pending", a.then(
              function(R) {
                if (l.status === "pending") {
                  var A = l;
                  A.status = "fulfilled", A.value = R;
                }
              },
              function(R) {
                if (l.status === "pending") {
                  var A = l;
                  A.status = "rejected", A.reason = R;
                }
              }
            );
          }
          switch (l.status) {
            case "fulfilled":
              return l.value;
            case "rejected":
              throw a = l.reason, Za(a), a;
          }
          throw _T = l, ZC = !0, ET;
      }
    }
    function Xa() {
      if (_T === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var a = _T;
      return _T = null, ZC = !1, a;
    }
    function Za(a) {
      if (a === ET || a === XC)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function Yu(a) {
      a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function Wg(a, l) {
      a = a.updateQueue, l.updateQueue === a && (l.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        callbacks: null
      });
    }
    function Ks(a) {
      return {
        lane: a,
        tag: y5,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Qs(a, l, h) {
      var x = a.updateQueue;
      if (x === null) return null;
      if (x = x.shared, rN === x && !S5) {
        var R = z(a);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          R
        ), S5 = !0;
      }
      return (mr & ss) !== yl ? (R = x.pending, R === null ? l.next = l : (l.next = R.next, R.next = l), x.pending = l, l = xy(a), q_(a, null, h), l) : (by(a, x, l, h), xy(a));
    }
    function pf(a, l, h) {
      if (l = l.updateQueue, l !== null && (l = l.shared, (h & 4194048) !== 0)) {
        var x = l.lanes;
        x &= a.pendingLanes, h |= x, l.lanes = h, et(a, h);
      }
    }
    function $c(a, l) {
      var h = a.updateQueue, x = a.alternate;
      if (x !== null && (x = x.updateQueue, h === x)) {
        var R = null, A = null;
        if (h = h.firstBaseUpdate, h !== null) {
          do {
            var B = {
              lane: h.lane,
              tag: h.tag,
              payload: h.payload,
              callback: null,
              next: null
            };
            A === null ? R = A = B : A = A.next = B, h = h.next;
          } while (h !== null);
          A === null ? R = A = l : A = A.next = l;
        } else R = A = l;
        h = {
          baseState: x.baseState,
          firstBaseUpdate: R,
          lastBaseUpdate: A,
          shared: x.shared,
          callbacks: x.callbacks
        }, a.updateQueue = h;
        return;
      }
      a = h.lastBaseUpdate, a === null ? h.firstBaseUpdate = l : a.next = l, h.lastBaseUpdate = l;
    }
    function Ip() {
      if (iN) {
        var a = r0;
        if (a !== null) throw a;
      }
    }
    function Xu(a, l, h, x) {
      iN = !1;
      var R = a.updateQueue;
      Ch = !1, rN = R.shared;
      var A = R.firstBaseUpdate, B = R.lastBaseUpdate, G = R.shared.pending;
      if (G !== null) {
        R.shared.pending = null;
        var ue = G, fe = ue.next;
        ue.next = null, B === null ? A = fe : B.next = fe, B = ue;
        var Xe = a.alternate;
        Xe !== null && (Xe = Xe.updateQueue, G = Xe.lastBaseUpdate, G !== B && (G === null ? Xe.firstBaseUpdate = fe : G.next = fe, Xe.lastBaseUpdate = ue));
      }
      if (A !== null) {
        var nt = R.baseState;
        B = 0, Xe = fe = ue = null, G = A;
        do {
          var $e = G.lane & -536870913, st = $e !== G.lane;
          if (st ? (Fn & $e) === $e : (x & $e) === $e) {
            $e !== 0 && $e === Gm && (iN = !0), Xe !== null && (Xe = Xe.next = {
              lane: 0,
              tag: G.tag,
              payload: G.payload,
              callback: null,
              next: null
            });
            e: {
              $e = a;
              var Ht = G, un = l, Zr = h;
              switch (Ht.tag) {
                case b5:
                  if (Ht = Ht.payload, typeof Ht == "function") {
                    t0 = !0;
                    var qn = Ht.call(
                      Zr,
                      nt,
                      un
                    );
                    if ($e.mode & Ma) {
                      Ee(!0);
                      try {
                        Ht.call(Zr, nt, un);
                      } finally {
                        Ee(!1);
                      }
                    }
                    t0 = !1, nt = qn;
                    break e;
                  }
                  nt = Ht;
                  break e;
                case nN:
                  $e.flags = $e.flags & -65537 | 128;
                case y5:
                  if (qn = Ht.payload, typeof qn == "function") {
                    if (t0 = !0, Ht = qn.call(
                      Zr,
                      nt,
                      un
                    ), $e.mode & Ma) {
                      Ee(!0);
                      try {
                        qn.call(Zr, nt, un);
                      } finally {
                        Ee(!1);
                      }
                    }
                    t0 = !1;
                  } else Ht = qn;
                  if (Ht == null) break e;
                  nt = pn({}, nt, Ht);
                  break e;
                case x5:
                  Ch = !0;
              }
            }
            $e = G.callback, $e !== null && (a.flags |= 64, st && (a.flags |= 8192), st = R.callbacks, st === null ? R.callbacks = [$e] : st.push($e));
          } else
            st = {
              lane: $e,
              tag: G.tag,
              payload: G.payload,
              callback: G.callback,
              next: null
            }, Xe === null ? (fe = Xe = st, ue = nt) : Xe = Xe.next = st, B |= $e;
          if (G = G.next, G === null) {
            if (G = R.shared.pending, G === null)
              break;
            st = G, G = st.next, st.next = null, R.lastBaseUpdate = st, R.shared.pending = null;
          }
        } while (!0);
        Xe === null && (ue = nt), R.baseState = ue, R.firstBaseUpdate = fe, R.lastBaseUpdate = Xe, A === null && (R.shared.lanes = 0), Dh |= B, a.lanes = B, a.memoizedState = nt;
      }
      rN = null;
    }
    function hf(a, l) {
      if (typeof a != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + a
        );
      a.call(l);
    }
    function IP(a, l) {
      var h = a.shared.hiddenCallbacks;
      if (h !== null)
        for (a.shared.hiddenCallbacks = null, a = 0; a < h.length; a++)
          hf(h[a], l);
    }
    function ya(a, l) {
      var h = a.callbacks;
      if (h !== null)
        for (a.callbacks = null, a = 0; a < h.length; a++)
          hf(h[a], l);
    }
    function Iy(a, l) {
      var h = Cd;
      X(KC, h, a), X(i0, l, a), Cd = h | l.baseLanes;
    }
    function Js(a) {
      X(KC, Cd, a), X(
        i0,
        i0.current,
        a
      );
    }
    function Py(a) {
      Cd = KC.current, F(i0, a), F(KC, a);
    }
    function wn() {
      var a = tt;
      uc === null ? uc = [a] : uc.push(a);
    }
    function xt() {
      var a = tt;
      if (uc !== null && (Uf++, uc[Uf] !== a)) {
        var l = z(hn);
        if (!w5.has(l) && (w5.add(l), uc !== null)) {
          for (var h = "", x = 0; x <= Uf; x++) {
            var R = uc[x], A = x === Uf ? a : R;
            for (R = x + 1 + ". " + R; 30 > R.length; )
              R += " ";
            R += A + `
`, h += R;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            l,
            h
          );
        }
      }
    }
    function Zu(a) {
      a == null || qi(a) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        tt,
        typeof a
      );
    }
    function Pp() {
      var a = z(hn);
      E5.has(a) || (E5.add(a), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        a
      ));
    }
    function zr() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function Ku(a, l) {
      if (RT) return !1;
      if (l === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          tt
        ), !1;
      a.length !== l.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        tt,
        "[" + l.join(", ") + "]",
        "[" + a.join(", ") + "]"
      );
      for (var h = 0; h < l.length && h < a.length; h++)
        if (!is(a[h], l[h])) return !1;
      return !0;
    }
    function Np(a, l, h, x, R, A) {
      Rh = A, hn = l, uc = a !== null ? a._debugHookTypes : null, Uf = -1, RT = a !== null && a.type !== l.type, (Object.prototype.toString.call(h) === "[object AsyncFunction]" || Object.prototype.toString.call(h) === "[object AsyncGeneratorFunction]") && (A = z(hn), oN.has(A) || (oN.add(A), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        A === null ? "An unknown Component" : "<" + A + ">"
      ))), l.memoizedState = null, l.updateQueue = null, l.lanes = 0, Ge.H = a !== null && a.memoizedState !== null ? sN : uc !== null ? _5 : aN, Zm = A = (l.mode & Ma) !== ri;
      var B = lN(h, x, R);
      if (Zm = !1, a0 && (B = ba(
        l,
        h,
        x,
        R
      )), A) {
        Ee(!0);
        try {
          B = ba(
            l,
            h,
            x,
            R
          );
        } finally {
          Ee(!1);
        }
      }
      return Hg(a, l), B;
    }
    function Hg(a, l) {
      l._debugHookTypes = uc, l.dependencies === null ? Vf !== null && (l.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: Vf
      }) : l.dependencies._debugThenableState = Vf, Ge.H = eR;
      var h = Br !== null && Br.next !== null;
      if (Rh = 0, uc = tt = ao = Br = hn = null, Uf = -1, a !== null && (a.flags & 65011712) !== (l.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), QC = !1, CT = 0, Vf = null, h)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      a === null || Bo || (a = a.dependencies, a !== null && Vg(a) && (Bo = !0)), ZC ? (ZC = !1, a = !0) : a = !1, a && (l = z(l) || "Unknown", T5.has(l) || oN.has(l) || (T5.add(l), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function ba(a, l, h, x) {
      hn = a;
      var R = 0;
      do {
        if (a0 && (Vf = null), CT = 0, a0 = !1, R >= Ape)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (R += 1, RT = !1, ao = Br = null, a.updateQueue != null) {
          var A = a.updateQueue;
          A.lastEffect = null, A.events = null, A.stores = null, A.memoCache != null && (A.memoCache.index = 0);
        }
        Uf = -1, Ge.H = C5, A = lN(l, h, x);
      } while (a0);
      return A;
    }
    function Es() {
      var a = Ge.H, l = a.useState()[0];
      return l = typeof l.then == "function" ? gf(l) : l, a = a.useState()[0], (Br !== null ? Br.memoizedState : null) !== a && (hn.flags |= 1024), l;
    }
    function Gc() {
      var a = JC !== 0;
      return JC = 0, a;
    }
    function el(a, l, h) {
      l.updateQueue = a.updateQueue, l.flags = (l.mode & yu) !== ri ? l.flags & -402655237 : l.flags & -2053, a.lanes &= ~h;
    }
    function tl(a) {
      if (QC) {
        for (a = a.memoizedState; a !== null; ) {
          var l = a.queue;
          l !== null && (l.pending = null), a = a.next;
        }
        QC = !1;
      }
      Rh = 0, uc = ao = Br = hn = null, Uf = -1, tt = null, a0 = !1, CT = JC = 0, Vf = null;
    }
    function Ii() {
      var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return ao === null ? hn.memoizedState = ao = a : ao = ao.next = a, ao;
    }
    function dr() {
      if (Br === null) {
        var a = hn.alternate;
        a = a !== null ? a.memoizedState : null;
      } else a = Br.next;
      var l = ao === null ? hn.memoizedState : ao.next;
      if (l !== null)
        ao = l, Br = a;
      else {
        if (a === null)
          throw hn.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        Br = a, a = {
          memoizedState: Br.memoizedState,
          baseState: Br.baseState,
          baseQueue: Br.baseQueue,
          queue: Br.queue,
          next: null
        }, ao === null ? hn.memoizedState = ao = a : ao = ao.next = a;
      }
      return ao;
    }
    function qg() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function gf(a) {
      var l = CT;
      return CT += 1, Vf === null && (Vf = DS()), a = IS(Vf, a, l), l = hn, (ao === null ? l.memoizedState : ao.next) === null && (l = l.alternate, Ge.H = l !== null && l.memoizedState !== null ? sN : aN), a;
    }
    function vi(a) {
      if (a !== null && typeof a == "object") {
        if (typeof a.then == "function") return gf(a);
        if (a.$$typeof === Pa) return qr(a);
      }
      throw Error("An unsupported type was passed to use(): " + String(a));
    }
    function Sr(a) {
      var l = null, h = hn.updateQueue;
      if (h !== null && (l = h.memoCache), l == null) {
        var x = hn.alternate;
        x !== null && (x = x.updateQueue, x !== null && (x = x.memoCache, x != null && (l = {
          data: x.data.map(function(R) {
            return R.slice();
          }),
          index: 0
        })));
      }
      if (l == null && (l = { data: [], index: 0 }), h === null && (h = qg(), hn.updateQueue = h), h.memoCache = l, h = l.data[l.index], h === void 0 || RT)
        for (h = l.data[l.index] = Array(a), x = 0; x < a; x++)
          h[x] = OC;
      else
        h.length !== a && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          h.length,
          a
        );
      return l.index++, h;
    }
    function Tn(a, l) {
      return typeof l == "function" ? l(a) : l;
    }
    function Yc(a, l, h) {
      var x = Ii();
      if (h !== void 0) {
        var R = h(l);
        if (Zm) {
          Ee(!0);
          try {
            h(l);
          } finally {
            Ee(!1);
          }
        }
      } else R = l;
      return x.memoizedState = x.baseState = R, a = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: R
      }, x.queue = a, a = a.dispatch = tm.bind(
        null,
        hn,
        a
      ), [x.memoizedState, a];
    }
    function Qo(a) {
      var l = dr();
      return $g(l, Br, a);
    }
    function $g(a, l, h) {
      var x = a.queue;
      if (x === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      x.lastRenderedReducer = h;
      var R = a.baseQueue, A = x.pending;
      if (A !== null) {
        if (R !== null) {
          var B = R.next;
          R.next = A.next, A.next = B;
        }
        l.baseQueue !== R && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), l.baseQueue = R = A, x.pending = null;
      }
      if (A = a.baseState, R === null) a.memoizedState = A;
      else {
        l = R.next;
        var G = B = null, ue = null, fe = l, Xe = !1;
        do {
          var nt = fe.lane & -536870913;
          if (nt !== fe.lane ? (Fn & nt) === nt : (Rh & nt) === nt) {
            var $e = fe.revertLane;
            if ($e === 0)
              ue !== null && (ue = ue.next = {
                lane: 0,
                revertLane: 0,
                action: fe.action,
                hasEagerState: fe.hasEagerState,
                eagerState: fe.eagerState,
                next: null
              }), nt === Gm && (Xe = !0);
            else if ((Rh & $e) === $e) {
              fe = fe.next, $e === Gm && (Xe = !0);
              continue;
            } else
              nt = {
                lane: 0,
                revertLane: fe.revertLane,
                action: fe.action,
                hasEagerState: fe.hasEagerState,
                eagerState: fe.eagerState,
                next: null
              }, ue === null ? (G = ue = nt, B = A) : ue = ue.next = nt, hn.lanes |= $e, Dh |= $e;
            nt = fe.action, Zm && h(A, nt), A = fe.hasEagerState ? fe.eagerState : h(A, nt);
          } else
            $e = {
              lane: nt,
              revertLane: fe.revertLane,
              action: fe.action,
              hasEagerState: fe.hasEagerState,
              eagerState: fe.eagerState,
              next: null
            }, ue === null ? (G = ue = $e, B = A) : ue = ue.next = $e, hn.lanes |= nt, Dh |= nt;
          fe = fe.next;
        } while (fe !== null && fe !== l);
        if (ue === null ? B = A : ue.next = G, !is(A, a.memoizedState) && (Bo = !0, Xe && (h = r0, h !== null)))
          throw h;
        a.memoizedState = A, a.baseState = B, a.baseQueue = ue, x.lastRenderedState = A;
      }
      return R === null && (x.lanes = 0), [a.memoizedState, x.dispatch];
    }
    function nl(a) {
      var l = dr(), h = l.queue;
      if (h === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      h.lastRenderedReducer = a;
      var x = h.dispatch, R = h.pending, A = l.memoizedState;
      if (R !== null) {
        h.pending = null;
        var B = R = R.next;
        do
          A = a(A, B.action), B = B.next;
        while (B !== R);
        is(A, l.memoizedState) || (Bo = !0), l.memoizedState = A, l.baseQueue === null && (l.baseState = A), h.lastRenderedState = A;
      }
      return [A, x];
    }
    function Ny(a, l, h) {
      var x = hn, R = Ii();
      if (ar) {
        if (h === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var A = h();
        o0 || A === h() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), o0 = !0);
      } else {
        if (A = l(), o0 || (h = l(), is(A, h) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), o0 = !0)), Xr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        (Fn & 124) !== 0 || Mp(x, l, A);
      }
      return R.memoizedState = A, h = { value: A, getSnapshot: l }, R.queue = h, Zg(
        PS.bind(null, x, h, a),
        [a]
      ), x.flags |= 2048, ql(
        cc | _o,
        Bp(),
        jp.bind(
          null,
          x,
          h,
          A,
          l
        ),
        null
      ), A;
    }
    function Gg(a, l, h) {
      var x = hn, R = dr(), A = ar;
      if (A) {
        if (h === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        h = h();
      } else if (h = l(), !o0) {
        var B = l();
        is(h, B) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), o0 = !0);
      }
      (B = !is(
        (Br || R).memoizedState,
        h
      )) && (R.memoizedState = h, Bo = !0), R = R.queue;
      var G = PS.bind(null, x, R, a);
      if (xa(2048, _o, G, [a]), R.getSnapshot !== l || B || ao !== null && ao.memoizedState.tag & cc) {
        if (x.flags |= 2048, ql(
          cc | _o,
          Bp(),
          jp.bind(
            null,
            x,
            R,
            h,
            l
          ),
          null
        ), Xr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        A || (Rh & 124) !== 0 || Mp(x, l, h);
      }
      return h;
    }
    function Mp(a, l, h) {
      a.flags |= 16384, a = { getSnapshot: l, value: h }, l = hn.updateQueue, l === null ? (l = qg(), hn.updateQueue = l, l.stores = [a]) : (h = l.stores, h === null ? l.stores = [a] : h.push(a));
    }
    function jp(a, l, h, x) {
      l.value = h, l.getSnapshot = x, Lp(l) && My(a);
    }
    function PS(a, l, h) {
      return h(function() {
        Lp(l) && My(a);
      });
    }
    function Lp(a) {
      var l = a.getSnapshot;
      a = a.value;
      try {
        var h = l();
        return !is(a, h);
      } catch {
        return !0;
      }
    }
    function My(a) {
      var l = ma(a, 2);
      l !== null && Mn(l, a, 2);
    }
    function Xc(a) {
      var l = Ii();
      if (typeof a == "function") {
        var h = a;
        if (a = h(), Zm) {
          Ee(!0);
          try {
            h();
          } finally {
            Ee(!1);
          }
        }
      }
      return l.memoizedState = l.baseState = a, l.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Tn,
        lastRenderedState: a
      }, l;
    }
    function rl(a) {
      a = Xc(a);
      var l = a.queue, h = qp.bind(null, hn, l);
      return l.dispatch = h, [a.memoizedState, h];
    }
    function Wl(a) {
      var l = Ii();
      l.memoizedState = l.baseState = a;
      var h = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return l.queue = h, l = Uy.bind(
        null,
        hn,
        !0,
        h
      ), h.dispatch = l, [a, l];
    }
    function Hl(a, l) {
      var h = dr();
      return jy(h, Br, a, l);
    }
    function jy(a, l, h, x) {
      return a.baseState = h, $g(
        a,
        Br,
        typeof x == "function" ? x : Tn
      );
    }
    function Ly(a, l) {
      var h = dr();
      return Br !== null ? jy(h, Br, a, l) : (h.baseState = a, [a, h.queue.dispatch]);
    }
    function Yg(a, l, h, x, R) {
      if (Jc(a))
        throw Error("Cannot update form state while rendering.");
      if (a = l.action, a !== null) {
        var A = {
          payload: R,
          action: a,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(B) {
            A.listeners.push(B);
          }
        };
        Ge.T !== null ? h(!0) : A.isTransition = !1, x(A), h = l.pending, h === null ? (A.next = l.pending = A, Xg(l, A)) : (A.next = h.next, l.pending = h.next = A);
      }
    }
    function Xg(a, l) {
      var h = l.action, x = l.payload, R = a.state;
      if (l.isTransition) {
        var A = Ge.T, B = {};
        Ge.T = B, Ge.T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var G = h(R, x), ue = Ge.S;
          ue !== null && ue(B, G), Qu(a, l, G);
        } catch (fe) {
          kp(a, l, fe);
        } finally {
          Ge.T = A, A === null && B._updatedFibers && (a = B._updatedFibers.size, B._updatedFibers.clear(), 10 < a && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          B = h(R, x), Qu(a, l, B);
        } catch (fe) {
          kp(a, l, fe);
        }
    }
    function Qu(a, l, h) {
      h !== null && typeof h == "object" && typeof h.then == "function" ? (h.then(
        function(x) {
          bo(a, l, x);
        },
        function(x) {
          return kp(a, l, x);
        }
      ), l.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : bo(a, l, h);
    }
    function bo(a, l, h) {
      l.status = "fulfilled", l.value = h, NS(l), a.state = h, l = a.pending, l !== null && (h = l.next, h === l ? a.pending = null : (h = h.next, l.next = h, Xg(a, h)));
    }
    function kp(a, l, h) {
      var x = a.pending;
      if (a.pending = null, x !== null) {
        x = x.next;
        do
          l.status = "rejected", l.reason = h, NS(l), l = l.next;
        while (l !== x);
      }
      a.action = null;
    }
    function NS(a) {
      a = a.listeners;
      for (var l = 0; l < a.length; l++) (0, a[l])();
    }
    function X_(a, l) {
      return l;
    }
    function zp(a, l) {
      if (ar) {
        var h = Xr.formState;
        if (h !== null) {
          e: {
            var x = hn;
            if (ar) {
              if (ji) {
                t: {
                  for (var R = ji, A = Td; R.nodeType !== 8; ) {
                    if (!A) {
                      R = null;
                      break t;
                    }
                    if (R = Da(
                      R.nextSibling
                    ), R === null) {
                      R = null;
                      break t;
                    }
                  }
                  A = R.data, R = A === MN || A === E4 ? R : null;
                }
                if (R) {
                  ji = Da(
                    R.nextSibling
                  ), x = R.data === MN;
                  break e;
                }
              }
              Hu(x);
            }
            x = !1;
          }
          x && (l = h[0]);
        }
      }
      return h = Ii(), h.memoizedState = h.baseState = l, x = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: X_,
        lastRenderedState: l
      }, h.queue = x, h = qp.bind(
        null,
        hn,
        x
      ), x.dispatch = h, x = Xc(!1), A = Uy.bind(
        null,
        hn,
        !1,
        x.queue
      ), x = Ii(), R = {
        state: l,
        dispatch: null,
        action: a,
        pending: null
      }, x.queue = R, h = Yg.bind(
        null,
        hn,
        R,
        A,
        h
      ), R.dispatch = h, x.memoizedState = a, [l, h, !1];
    }
    function ky(a) {
      var l = dr();
      return Pi(l, Br, a);
    }
    function Pi(a, l, h) {
      if (l = $g(
        a,
        l,
        X_
      )[0], a = Qo(Tn)[0], typeof l == "object" && l !== null && typeof l.then == "function")
        try {
          var x = gf(l);
        } catch (B) {
          throw B === ET ? XC : B;
        }
      else x = l;
      l = dr();
      var R = l.queue, A = R.dispatch;
      return h !== l.memoizedState && (hn.flags |= 2048, ql(
        cc | _o,
        Bp(),
        MS.bind(null, R, h),
        null
      )), [x, A, a];
    }
    function MS(a, l) {
      a.action = l;
    }
    function Ju(a) {
      var l = dr(), h = Br;
      if (h !== null)
        return Pi(l, h, a);
      dr(), l = l.memoizedState, h = dr();
      var x = h.queue.dispatch;
      return h.memoizedState = a, [l, x, !1];
    }
    function ql(a, l, h, x) {
      return a = {
        tag: a,
        create: h,
        deps: x,
        inst: l,
        next: null
      }, l = hn.updateQueue, l === null && (l = qg(), hn.updateQueue = l), h = l.lastEffect, h === null ? l.lastEffect = a.next = a : (x = h.next, h.next = a, a.next = x, l.lastEffect = a), a;
    }
    function Bp() {
      return { destroy: void 0, resource: void 0 };
    }
    function ed(a) {
      var l = Ii();
      return a = { current: a }, l.memoizedState = a;
    }
    function _s(a, l, h, x) {
      var R = Ii();
      x = x === void 0 ? null : x, hn.flags |= a, R.memoizedState = ql(
        cc | l,
        Bp(),
        h,
        x
      );
    }
    function xa(a, l, h, x) {
      var R = dr();
      x = x === void 0 ? null : x;
      var A = R.memoizedState.inst;
      Br !== null && x !== null && Ku(x, Br.memoizedState.deps) ? R.memoizedState = ql(l, A, h, x) : (hn.flags |= a, R.memoizedState = ql(
        cc | l,
        A,
        h,
        x
      ));
    }
    function Zg(a, l) {
      (hn.mode & yu) !== ri && (hn.mode & l5) === ri ? _s(276826112, _o, a, l) : _s(8390656, _o, a, l);
    }
    function jS(a, l) {
      var h = 4194308;
      return (hn.mode & yu) !== ri && (h |= 134217728), _s(h, na, a, l);
    }
    function LS(a, l) {
      if (typeof l == "function") {
        a = a();
        var h = l(a);
        return function() {
          typeof h == "function" ? h() : l(null);
        };
      }
      if (l != null)
        return l.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(l).join(", ") + "}"
        ), a = a(), l.current = a, function() {
          l.current = null;
        };
    }
    function Zc(a, l, h) {
      typeof l != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        l !== null ? typeof l : "null"
      ), h = h != null ? h.concat([a]) : null;
      var x = 4194308;
      (hn.mode & yu) !== ri && (x |= 134217728), _s(
        x,
        na,
        LS.bind(null, l, a),
        h
      );
    }
    function Vp(a, l, h) {
      typeof l != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        l !== null ? typeof l : "null"
      ), h = h != null ? h.concat([a]) : null, xa(
        4,
        na,
        LS.bind(null, l, a),
        h
      );
    }
    function Up(a, l) {
      return Ii().memoizedState = [
        a,
        l === void 0 ? null : l
      ], a;
    }
    function Kg(a, l) {
      var h = dr();
      l = l === void 0 ? null : l;
      var x = h.memoizedState;
      return l !== null && Ku(l, x[1]) ? x[0] : (h.memoizedState = [a, l], a);
    }
    function mf(a, l) {
      var h = Ii();
      l = l === void 0 ? null : l;
      var x = a();
      if (Zm) {
        Ee(!0);
        try {
          a();
        } finally {
          Ee(!1);
        }
      }
      return h.memoizedState = [x, l], x;
    }
    function Qg(a, l) {
      var h = dr();
      l = l === void 0 ? null : l;
      var x = h.memoizedState;
      if (l !== null && Ku(l, x[1]))
        return x[0];
      if (x = a(), Zm) {
        Ee(!0);
        try {
          a();
        } finally {
          Ee(!1);
        }
      }
      return h.memoizedState = [x, l], x;
    }
    function Fp(a, l) {
      var h = Ii();
      return Wp(h, a, l);
    }
    function zy(a, l) {
      var h = dr();
      return zS(
        h,
        Br.memoizedState,
        a,
        l
      );
    }
    function kS(a, l) {
      var h = dr();
      return Br === null ? Wp(h, a, l) : zS(
        h,
        Br.memoizedState,
        a,
        l
      );
    }
    function Wp(a, l, h) {
      return h === void 0 || (Rh & 1073741824) !== 0 ? a.memoizedState = l : (a.memoizedState = h, a = gw(), hn.lanes |= a, Dh |= a, h);
    }
    function zS(a, l, h, x) {
      return is(h, l) ? h : i0.current !== null ? (a = Wp(a, h, x), is(a, l) || (Bo = !0), a) : (Rh & 42) === 0 ? (Bo = !0, a.memoizedState = h) : (a = gw(), hn.lanes |= a, Dh |= a, l);
    }
    function Hp(a, l, h, x, R) {
      var A = lr.p;
      lr.p = A !== 0 && A < Ql ? A : Ql;
      var B = Ge.T, G = {};
      Ge.T = G, Uy(a, !1, l, h), G._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var ue = R(), fe = Ge.S;
        if (fe !== null && fe(G, ue), ue !== null && typeof ue == "object" && typeof ue.then == "function") {
          var Xe = DP(
            ue,
            x
          );
          $p(
            a,
            l,
            Xe,
            Qa(a)
          );
        } else
          $p(
            a,
            l,
            x,
            Qa(a)
          );
      } catch (nt) {
        $p(
          a,
          l,
          { then: function() {
          }, status: "rejected", reason: nt },
          Qa(a)
        );
      } finally {
        lr.p = A, Ge.T = B, B === null && G._updatedFibers && (a = G._updatedFibers.size, G._updatedFibers.clear(), 10 < a && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function By(a, l, h, x) {
      if (a.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var R = BS(a).queue;
      Hp(
        a,
        R,
        l,
        sv,
        h === null ? v : function() {
          return Kc(a), h(x);
        }
      );
    }
    function BS(a) {
      var l = a.memoizedState;
      if (l !== null) return l;
      l = {
        memoizedState: sv,
        baseState: sv,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Tn,
          lastRenderedState: sv
        },
        next: null
      };
      var h = {};
      return l.next = {
        memoizedState: h,
        baseState: h,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Tn,
          lastRenderedState: h
        },
        next: null
      }, a.memoizedState = l, a = a.alternate, a !== null && (a.memoizedState = l), l;
    }
    function Kc(a) {
      Ge.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var l = BS(a).next.queue;
      $p(
        a,
        l,
        {},
        Qa(a)
      );
    }
    function Jg() {
      var a = Xc(!1);
      return a = Hp.bind(
        null,
        hn,
        a.queue,
        !0,
        !1
      ), Ii().memoizedState = a, [!1, a];
    }
    function Vy() {
      var a = Qo(Tn)[0], l = dr().memoizedState;
      return [
        typeof a == "boolean" ? a : gf(a),
        l
      ];
    }
    function Qc() {
      var a = nl(Tn)[0], l = dr().memoizedState;
      return [
        typeof a == "boolean" ? a : gf(a),
        l
      ];
    }
    function Sa() {
      return qr(HT);
    }
    function vf() {
      var a = Ii(), l = Xr.identifierPrefix;
      if (ar) {
        var h = zf, x = kf;
        h = (x & ~(1 << 32 - ro(x) - 1)).toString(32) + h, l = "«" + l + "R" + h, h = JC++, 0 < h && (l += "H" + h.toString(32)), l += "»";
      } else
        h = Ope++, l = "«" + l + "r" + h.toString(32) + "»";
      return a.memoizedState = l;
    }
    function em() {
      return Ii().memoizedState = VS.bind(
        null,
        hn
      );
    }
    function VS(a, l) {
      for (var h = a.return; h !== null; ) {
        switch (h.tag) {
          case 24:
          case 3:
            var x = Qa(h);
            a = Ks(x);
            var R = Qs(h, a, x);
            R !== null && (Mn(R, h, x), pf(R, h, x)), h = CS(), l != null && R !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), a.payload = { cache: h };
            return;
        }
        h = h.return;
      }
    }
    function tm(a, l, h) {
      var x = arguments;
      typeof x[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), x = Qa(a);
      var R = {
        lane: x,
        revertLane: 0,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      Jc(a) ? nm(l, R) : (R = vS(a, l, R, x), R !== null && (Mn(R, a, x), US(R, l, x))), rt(a, x);
    }
    function qp(a, l, h) {
      var x = arguments;
      typeof x[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), x = Qa(a), $p(a, l, h, x), rt(a, x);
    }
    function $p(a, l, h, x) {
      var R = {
        lane: x,
        revertLane: 0,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Jc(a)) nm(l, R);
      else {
        var A = a.alternate;
        if (a.lanes === 0 && (A === null || A.lanes === 0) && (A = l.lastRenderedReducer, A !== null)) {
          var B = Ge.H;
          Ge.H = xu;
          try {
            var G = l.lastRenderedState, ue = A(G, h);
            if (R.hasEagerState = !0, R.eagerState = ue, is(ue, G))
              return by(a, l, R, 0), Xr === null && yy(), !1;
          } catch {
          } finally {
            Ge.H = B;
          }
        }
        if (h = vS(a, l, R, x), h !== null)
          return Mn(h, a, x), US(h, l, x), !0;
      }
      return !1;
    }
    function Uy(a, l, h, x) {
      if (Ge.T === null && Gm === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), x = {
        lane: 2,
        revertLane: fb(),
        action: x,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Jc(a)) {
        if (l)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        l = vS(
          a,
          h,
          x,
          2
        ), l !== null && Mn(l, a, 2);
      rt(a, 2);
    }
    function Jc(a) {
      var l = a.alternate;
      return a === hn || l !== null && l === hn;
    }
    function nm(a, l) {
      a0 = QC = !0;
      var h = a.pending;
      h === null ? l.next = l : (l.next = h.next, h.next = l), a.pending = l;
    }
    function US(a, l, h) {
      if ((h & 4194048) !== 0) {
        var x = l.lanes;
        x &= a.pendingLanes, h |= x, l.lanes = h, et(a, h);
      }
    }
    function Fi(a) {
      var l = In;
      return a != null && (In = l === null ? a : l.concat(a)), l;
    }
    function Gp(a, l, h) {
      for (var x = Object.keys(a.props), R = 0; R < x.length; R++) {
        var A = x[R];
        if (A !== "children" && A !== "key") {
          l === null && (l = Bg(a, h.mode, 0), l._debugInfo = In, l.return = h), _t(
            l,
            function(B) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                B
              );
            },
            A
          );
          break;
        }
      }
    }
    function il(a) {
      var l = OT;
      return OT += 1, s0 === null && (s0 = DS()), IS(s0, a, l);
    }
    function mn(a, l) {
      l = l.props.ref, a.ref = l !== void 0 ? l : null;
    }
    function sr(a, l) {
      throw l.$$typeof === zP ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (a = Object.prototype.toString.call(l), Error(
        "Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function li(a, l) {
      var h = z(a) || "Component";
      U5[h] || (U5[h] = !0, l = l.displayName || l.name || "Component", a.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        l,
        l,
        l
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        l,
        l,
        h,
        l,
        h
      ));
    }
    function yf(a, l) {
      var h = z(a) || "Component";
      F5[h] || (F5[h] = !0, l = String(l), a.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        l
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        h,
        l,
        h
      ));
    }
    function bf(a) {
      function l(Se, we) {
        if (a) {
          var Re = Se.deletions;
          Re === null ? (Se.deletions = [we], Se.flags |= 16) : Re.push(we);
        }
      }
      function h(Se, we) {
        if (!a) return null;
        for (; we !== null; )
          l(Se, we), we = we.sibling;
        return null;
      }
      function x(Se) {
        for (var we = /* @__PURE__ */ new Map(); Se !== null; )
          Se.key !== null ? we.set(Se.key, Se) : we.set(Se.index, Se), Se = Se.sibling;
        return we;
      }
      function R(Se, we) {
        return Se = Fl(Se, we), Se.index = 0, Se.sibling = null, Se;
      }
      function A(Se, we, Re) {
        return Se.index = Re, a ? (Re = Se.alternate, Re !== null ? (Re = Re.index, Re < we ? (Se.flags |= 67108866, we) : Re) : (Se.flags |= 67108866, we)) : (Se.flags |= 1048576, we);
      }
      function B(Se) {
        return a && Se.alternate === null && (Se.flags |= 67108866), Se;
      }
      function G(Se, we, Re, lt) {
        return we === null || we.tag !== 6 ? (we = xS(
          Re,
          Se.mode,
          lt
        ), we.return = Se, we._debugOwner = Se, we._debugTask = Se._debugTask, we._debugInfo = In, we) : (we = R(we, Re), we.return = Se, we._debugInfo = In, we);
      }
      function ue(Se, we, Re, lt) {
        var Ot = Re.type;
        return Ot === md ? (we = Xe(
          Se,
          we,
          Re.props.children,
          lt,
          Re.key
        ), Gp(Re, we, Se), we) : we !== null && (we.elementType === Ot || $_(we, Re) || typeof Ot == "object" && Ot !== null && Ot.$$typeof === ns && Oh(Ot) === we.type) ? (we = R(we, Re.props), mn(we, Re), we.return = Se, we._debugOwner = Re._owner, we._debugInfo = In, we) : (we = Bg(Re, Se.mode, lt), mn(we, Re), we.return = Se, we._debugInfo = In, we);
      }
      function fe(Se, we, Re, lt) {
        return we === null || we.tag !== 4 || we.stateNode.containerInfo !== Re.containerInfo || we.stateNode.implementation !== Re.implementation ? (we = SS(Re, Se.mode, lt), we.return = Se, we._debugInfo = In, we) : (we = R(we, Re.children || []), we.return = Se, we._debugInfo = In, we);
      }
      function Xe(Se, we, Re, lt, Ot) {
        return we === null || we.tag !== 7 ? (we = ws(
          Re,
          Se.mode,
          lt,
          Ot
        ), we.return = Se, we._debugOwner = Se, we._debugTask = Se._debugTask, we._debugInfo = In, we) : (we = R(we, Re), we.return = Se, we._debugInfo = In, we);
      }
      function nt(Se, we, Re) {
        if (typeof we == "string" && we !== "" || typeof we == "number" || typeof we == "bigint")
          return we = xS(
            "" + we,
            Se.mode,
            Re
          ), we.return = Se, we._debugOwner = Se, we._debugTask = Se._debugTask, we._debugInfo = In, we;
        if (typeof we == "object" && we !== null) {
          switch (we.$$typeof) {
            case du:
              return Re = Bg(
                we,
                Se.mode,
                Re
              ), mn(Re, we), Re.return = Se, Se = Fi(we._debugInfo), Re._debugInfo = In, In = Se, Re;
            case bn:
              return we = SS(
                we,
                Se.mode,
                Re
              ), we.return = Se, we._debugInfo = In, we;
            case ns:
              var lt = Fi(we._debugInfo);
              return we = Oh(we), Se = nt(Se, we, Re), In = lt, Se;
          }
          if (qi(we) || U(we))
            return Re = ws(
              we,
              Se.mode,
              Re,
              null
            ), Re.return = Se, Re._debugOwner = Se, Re._debugTask = Se._debugTask, Se = Fi(we._debugInfo), Re._debugInfo = In, In = Se, Re;
          if (typeof we.then == "function")
            return lt = Fi(we._debugInfo), Se = nt(
              Se,
              il(we),
              Re
            ), In = lt, Se;
          if (we.$$typeof === Pa)
            return nt(
              Se,
              Ug(Se, we),
              Re
            );
          sr(Se, we);
        }
        return typeof we == "function" && li(Se, we), typeof we == "symbol" && yf(Se, we), null;
      }
      function $e(Se, we, Re, lt) {
        var Ot = we !== null ? we.key : null;
        if (typeof Re == "string" && Re !== "" || typeof Re == "number" || typeof Re == "bigint")
          return Ot !== null ? null : G(Se, we, "" + Re, lt);
        if (typeof Re == "object" && Re !== null) {
          switch (Re.$$typeof) {
            case du:
              return Re.key === Ot ? (Ot = Fi(Re._debugInfo), Se = ue(
                Se,
                we,
                Re,
                lt
              ), In = Ot, Se) : null;
            case bn:
              return Re.key === Ot ? fe(Se, we, Re, lt) : null;
            case ns:
              return Ot = Fi(Re._debugInfo), Re = Oh(Re), Se = $e(
                Se,
                we,
                Re,
                lt
              ), In = Ot, Se;
          }
          if (qi(Re) || U(Re))
            return Ot !== null ? null : (Ot = Fi(Re._debugInfo), Se = Xe(
              Se,
              we,
              Re,
              lt,
              null
            ), In = Ot, Se);
          if (typeof Re.then == "function")
            return Ot = Fi(Re._debugInfo), Se = $e(
              Se,
              we,
              il(Re),
              lt
            ), In = Ot, Se;
          if (Re.$$typeof === Pa)
            return $e(
              Se,
              we,
              Ug(Se, Re),
              lt
            );
          sr(Se, Re);
        }
        return typeof Re == "function" && li(Se, Re), typeof Re == "symbol" && yf(Se, Re), null;
      }
      function st(Se, we, Re, lt, Ot) {
        if (typeof lt == "string" && lt !== "" || typeof lt == "number" || typeof lt == "bigint")
          return Se = Se.get(Re) || null, G(we, Se, "" + lt, Ot);
        if (typeof lt == "object" && lt !== null) {
          switch (lt.$$typeof) {
            case du:
              return Re = Se.get(
                lt.key === null ? Re : lt.key
              ) || null, Se = Fi(lt._debugInfo), we = ue(
                we,
                Re,
                lt,
                Ot
              ), In = Se, we;
            case bn:
              return Se = Se.get(
                lt.key === null ? Re : lt.key
              ) || null, fe(we, Se, lt, Ot);
            case ns:
              var xn = Fi(lt._debugInfo);
              return lt = Oh(lt), we = st(
                Se,
                we,
                Re,
                lt,
                Ot
              ), In = xn, we;
          }
          if (qi(lt) || U(lt))
            return Re = Se.get(Re) || null, Se = Fi(lt._debugInfo), we = Xe(
              we,
              Re,
              lt,
              Ot,
              null
            ), In = Se, we;
          if (typeof lt.then == "function")
            return xn = Fi(lt._debugInfo), we = st(
              Se,
              we,
              Re,
              il(lt),
              Ot
            ), In = xn, we;
          if (lt.$$typeof === Pa)
            return st(
              Se,
              we,
              Re,
              Ug(we, lt),
              Ot
            );
          sr(we, lt);
        }
        return typeof lt == "function" && li(we, lt), typeof lt == "symbol" && yf(we, lt), null;
      }
      function Ht(Se, we, Re, lt) {
        if (typeof Re != "object" || Re === null) return lt;
        switch (Re.$$typeof) {
          case du:
          case bn:
            f(Se, we, Re);
            var Ot = Re.key;
            if (typeof Ot != "string") break;
            if (lt === null) {
              lt = /* @__PURE__ */ new Set(), lt.add(Ot);
              break;
            }
            if (!lt.has(Ot)) {
              lt.add(Ot);
              break;
            }
            _t(we, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                Ot
              );
            });
            break;
          case ns:
            Re = Oh(Re), Ht(Se, we, Re, lt);
        }
        return lt;
      }
      function un(Se, we, Re, lt) {
        for (var Ot = null, xn = null, qt = null, Sn = we, _n = we = 0, ii = null; Sn !== null && _n < Re.length; _n++) {
          Sn.index > _n ? (ii = Sn, Sn = null) : ii = Sn.sibling;
          var Gi = $e(
            Se,
            Sn,
            Re[_n],
            lt
          );
          if (Gi === null) {
            Sn === null && (Sn = ii);
            break;
          }
          Ot = Ht(
            Se,
            Gi,
            Re[_n],
            Ot
          ), a && Sn && Gi.alternate === null && l(Se, Sn), we = A(Gi, we, _n), qt === null ? xn = Gi : qt.sibling = Gi, qt = Gi, Sn = ii;
        }
        if (_n === Re.length)
          return h(Se, Sn), ar && lf(Se, _n), xn;
        if (Sn === null) {
          for (; _n < Re.length; _n++)
            Sn = nt(Se, Re[_n], lt), Sn !== null && (Ot = Ht(
              Se,
              Sn,
              Re[_n],
              Ot
            ), we = A(
              Sn,
              we,
              _n
            ), qt === null ? xn = Sn : qt.sibling = Sn, qt = Sn);
          return ar && lf(Se, _n), xn;
        }
        for (Sn = x(Sn); _n < Re.length; _n++)
          ii = st(
            Sn,
            Se,
            _n,
            Re[_n],
            lt
          ), ii !== null && (Ot = Ht(
            Se,
            ii,
            Re[_n],
            Ot
          ), a && ii.alternate !== null && Sn.delete(
            ii.key === null ? _n : ii.key
          ), we = A(
            ii,
            we,
            _n
          ), qt === null ? xn = ii : qt.sibling = ii, qt = ii);
        return a && Sn.forEach(function(Gf) {
          return l(Se, Gf);
        }), ar && lf(Se, _n), xn;
      }
      function Zr(Se, we, Re, lt) {
        if (Re == null)
          throw Error("An iterable object provided no iterator.");
        for (var Ot = null, xn = null, qt = we, Sn = we = 0, _n = null, ii = null, Gi = Re.next(); qt !== null && !Gi.done; Sn++, Gi = Re.next()) {
          qt.index > Sn ? (_n = qt, qt = null) : _n = qt.sibling;
          var Gf = $e(Se, qt, Gi.value, lt);
          if (Gf === null) {
            qt === null && (qt = _n);
            break;
          }
          ii = Ht(
            Se,
            Gf,
            Gi.value,
            ii
          ), a && qt && Gf.alternate === null && l(Se, qt), we = A(Gf, we, Sn), xn === null ? Ot = Gf : xn.sibling = Gf, xn = Gf, qt = _n;
        }
        if (Gi.done)
          return h(Se, qt), ar && lf(Se, Sn), Ot;
        if (qt === null) {
          for (; !Gi.done; Sn++, Gi = Re.next())
            qt = nt(Se, Gi.value, lt), qt !== null && (ii = Ht(
              Se,
              qt,
              Gi.value,
              ii
            ), we = A(
              qt,
              we,
              Sn
            ), xn === null ? Ot = qt : xn.sibling = qt, xn = qt);
          return ar && lf(Se, Sn), Ot;
        }
        for (qt = x(qt); !Gi.done; Sn++, Gi = Re.next())
          _n = st(
            qt,
            Se,
            Sn,
            Gi.value,
            lt
          ), _n !== null && (ii = Ht(
            Se,
            _n,
            Gi.value,
            ii
          ), a && _n.alternate !== null && qt.delete(
            _n.key === null ? Sn : _n.key
          ), we = A(
            _n,
            we,
            Sn
          ), xn === null ? Ot = _n : xn.sibling = _n, xn = _n);
        return a && qt.forEach(function(the) {
          return l(Se, the);
        }), ar && lf(Se, Sn), Ot;
      }
      function qn(Se, we, Re, lt) {
        if (typeof Re == "object" && Re !== null && Re.type === md && Re.key === null && (Gp(Re, null, Se), Re = Re.props.children), typeof Re == "object" && Re !== null) {
          switch (Re.$$typeof) {
            case du:
              var Ot = Fi(Re._debugInfo);
              e: {
                for (var xn = Re.key; we !== null; ) {
                  if (we.key === xn) {
                    if (xn = Re.type, xn === md) {
                      if (we.tag === 7) {
                        h(
                          Se,
                          we.sibling
                        ), lt = R(
                          we,
                          Re.props.children
                        ), lt.return = Se, lt._debugOwner = Re._owner, lt._debugInfo = In, Gp(Re, lt, Se), Se = lt;
                        break e;
                      }
                    } else if (we.elementType === xn || $_(
                      we,
                      Re
                    ) || typeof xn == "object" && xn !== null && xn.$$typeof === ns && Oh(xn) === we.type) {
                      h(
                        Se,
                        we.sibling
                      ), lt = R(we, Re.props), mn(lt, Re), lt.return = Se, lt._debugOwner = Re._owner, lt._debugInfo = In, Se = lt;
                      break e;
                    }
                    h(Se, we);
                    break;
                  } else l(Se, we);
                  we = we.sibling;
                }
                Re.type === md ? (lt = ws(
                  Re.props.children,
                  Se.mode,
                  lt,
                  Re.key
                ), lt.return = Se, lt._debugOwner = Se, lt._debugTask = Se._debugTask, lt._debugInfo = In, Gp(Re, lt, Se), Se = lt) : (lt = Bg(
                  Re,
                  Se.mode,
                  lt
                ), mn(lt, Re), lt.return = Se, lt._debugInfo = In, Se = lt);
              }
              return Se = B(Se), In = Ot, Se;
            case bn:
              e: {
                for (Ot = Re, Re = Ot.key; we !== null; ) {
                  if (we.key === Re)
                    if (we.tag === 4 && we.stateNode.containerInfo === Ot.containerInfo && we.stateNode.implementation === Ot.implementation) {
                      h(
                        Se,
                        we.sibling
                      ), lt = R(
                        we,
                        Ot.children || []
                      ), lt.return = Se, Se = lt;
                      break e;
                    } else {
                      h(Se, we);
                      break;
                    }
                  else l(Se, we);
                  we = we.sibling;
                }
                lt = SS(
                  Ot,
                  Se.mode,
                  lt
                ), lt.return = Se, Se = lt;
              }
              return B(Se);
            case ns:
              return Ot = Fi(Re._debugInfo), Re = Oh(Re), Se = qn(
                Se,
                we,
                Re,
                lt
              ), In = Ot, Se;
          }
          if (qi(Re))
            return Ot = Fi(Re._debugInfo), Se = un(
              Se,
              we,
              Re,
              lt
            ), In = Ot, Se;
          if (U(Re)) {
            if (Ot = Fi(Re._debugInfo), xn = U(Re), typeof xn != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var qt = xn.call(Re);
            return qt === Re ? (Se.tag !== 0 || Object.prototype.toString.call(Se.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(qt) !== "[object Generator]") && (B5 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), B5 = !0) : Re.entries !== xn || uN || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), uN = !0), Se = Zr(
              Se,
              we,
              qt,
              lt
            ), In = Ot, Se;
          }
          if (typeof Re.then == "function")
            return Ot = Fi(Re._debugInfo), Se = qn(
              Se,
              we,
              il(Re),
              lt
            ), In = Ot, Se;
          if (Re.$$typeof === Pa)
            return qn(
              Se,
              we,
              Ug(Se, Re),
              lt
            );
          sr(Se, Re);
        }
        return typeof Re == "string" && Re !== "" || typeof Re == "number" || typeof Re == "bigint" ? (Ot = "" + Re, we !== null && we.tag === 6 ? (h(
          Se,
          we.sibling
        ), lt = R(we, Ot), lt.return = Se, Se = lt) : (h(Se, we), lt = xS(
          Ot,
          Se.mode,
          lt
        ), lt.return = Se, lt._debugOwner = Se, lt._debugTask = Se._debugTask, lt._debugInfo = In, Se = lt), B(Se)) : (typeof Re == "function" && li(Se, Re), typeof Re == "symbol" && yf(Se, Re), h(Se, we));
      }
      return function(Se, we, Re, lt) {
        var Ot = In;
        In = null;
        try {
          OT = 0;
          var xn = qn(
            Se,
            we,
            Re,
            lt
          );
          return s0 = null, xn;
        } catch (ii) {
          if (ii === ET || ii === XC) throw ii;
          var qt = S(29, ii, null, Se.mode);
          qt.lanes = lt, qt.return = Se;
          var Sn = qt._debugInfo = In;
          if (qt._debugOwner = Se._debugOwner, qt._debugTask = Se._debugTask, Sn != null) {
            for (var _n = Sn.length - 1; 0 <= _n; _n--)
              if (typeof Sn[_n].stack == "string") {
                qt._debugOwner = Sn[_n], qt._debugTask = Sn[_n].debugTask;
                break;
              }
          }
          return qt;
        } finally {
          In = Ot;
        }
      };
    }
    function wa(a) {
      var l = a.alternate;
      X(
        Co,
        Co.current & c0,
        a
      ), X(dc, a, a), _d === null && (l === null || i0.current !== null || l.memoizedState !== null) && (_d = a);
    }
    function rm(a) {
      if (a.tag === 22) {
        if (X(Co, Co.current, a), X(dc, a, a), _d === null) {
          var l = a.alternate;
          l !== null && l.memoizedState !== null && (_d = a);
        }
      } else Cs(a);
    }
    function Cs(a) {
      X(Co, Co.current, a), X(
        dc,
        dc.current,
        a
      );
    }
    function Ta(a) {
      F(dc, a), _d === a && (_d = null), F(Co, a);
    }
    function Fy(a) {
      for (var l = a; l !== null; ) {
        if (l.tag === 13) {
          var h = l.memoizedState;
          if (h !== null && (h = h.dehydrated, h === null || h.data === Hf || pd(h)))
            return l;
        } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
          if ((l.flags & 128) !== 0) return l;
        } else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === a) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === a) return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    function ci(a) {
      if (a !== null && typeof a != "function") {
        var l = String(a);
        e4.has(l) || (e4.add(l), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          a
        ));
      }
    }
    function im(a, l, h, x) {
      var R = a.memoizedState, A = h(x, R);
      if (a.mode & Ma) {
        Ee(!0);
        try {
          A = h(x, R);
        } finally {
          Ee(!1);
        }
      }
      A === void 0 && (l = H(l) || "Component", Z5.has(l) || (Z5.add(l), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        l
      ))), R = A == null ? R : pn({}, R, A), a.memoizedState = R, a.lanes === 0 && (a.updateQueue.baseState = R);
    }
    function Wy(a, l, h, x, R, A, B) {
      var G = a.stateNode;
      if (typeof G.shouldComponentUpdate == "function") {
        if (h = G.shouldComponentUpdate(
          x,
          A,
          B
        ), a.mode & Ma) {
          Ee(!0);
          try {
            h = G.shouldComponentUpdate(
              x,
              A,
              B
            );
          } finally {
            Ee(!1);
          }
        }
        return h === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          H(l) || "Component"
        ), h;
      }
      return l.prototype && l.prototype.isPureReactComponent ? !zg(h, x) || !zg(R, A) : !0;
    }
    function FS(a, l, h, x) {
      var R = l.state;
      typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(h, x), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(h, x), l.state !== R && (a = z(a) || "Component", q5.has(a) || (q5.add(a), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        a
      )), dN.enqueueReplaceState(
        l,
        l.state,
        null
      ));
    }
    function td(a, l) {
      var h = l;
      if ("ref" in l) {
        h = {};
        for (var x in l)
          x !== "ref" && (h[x] = l[x]);
      }
      if (a = a.defaultProps) {
        h === l && (h = pn({}, h));
        for (var R in a)
          h[R] === void 0 && (h[R] = a[R]);
      }
      return h;
    }
    function Z_(a) {
      fN(a), console.warn(
        `%s

%s
`,
        u0 ? "An error occurred in the <" + u0 + "> component." : "An error occurred in one of your React components.",
        `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
      );
    }
    function Hy(a) {
      var l = u0 ? "The above error occurred in the <" + u0 + "> component." : "The above error occurred in one of your React components.", h = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((pN || "Anonymous") + ".");
      if (typeof a == "object" && a !== null && typeof a.environmentName == "string") {
        var x = a.environmentName;
        a = [
          `%o

%s

%s
`,
          a,
          l,
          h
        ].slice(0), typeof a[0] == "string" ? a.splice(
          0,
          1,
          P4 + a[0],
          N4,
          bR + x + bR,
          M4
        ) : a.splice(
          0,
          0,
          P4,
          N4,
          bR + x + bR,
          M4
        ), a.unshift(console), x = Jpe.apply(console.error, a), x();
      } else
        console.error(
          `%o

%s

%s
`,
          a,
          l,
          h
        );
    }
    function qy(a) {
      fN(a);
    }
    function Yp(a, l) {
      try {
        u0 = l.source ? z(l.source) : null, pN = null;
        var h = l.value;
        if (Ge.actQueue !== null)
          Ge.thrownErrors.push(h);
        else {
          var x = a.onUncaughtError;
          x(h, { componentStack: l.stack });
        }
      } catch (R) {
        setTimeout(function() {
          throw R;
        });
      }
    }
    function Jo(a, l, h) {
      try {
        u0 = h.source ? z(h.source) : null, pN = z(l);
        var x = a.onCaughtError;
        x(h.value, {
          componentStack: h.stack,
          errorBoundary: l.tag === 1 ? l.stateNode : null
        });
      } catch (R) {
        setTimeout(function() {
          throw R;
        });
      }
    }
    function yi(a, l, h) {
      return h = Ks(h), h.tag = nN, h.payload = { element: null }, h.callback = function() {
        _t(l.source, Yp, a, l);
      }, h;
    }
    function om(a) {
      return a = Ks(a), a.tag = nN, a;
    }
    function xf(a, l, h, x) {
      var R = h.type.getDerivedStateFromError;
      if (typeof R == "function") {
        var A = x.value;
        a.payload = function() {
          return R(A);
        }, a.callback = function() {
          Sy(h), _t(
            x.source,
            Jo,
            l,
            h,
            x
          );
        };
      }
      var B = h.stateNode;
      B !== null && typeof B.componentDidCatch == "function" && (a.callback = function() {
        Sy(h), _t(
          x.source,
          Jo,
          l,
          h,
          x
        ), typeof R != "function" && (Ph === null ? Ph = /* @__PURE__ */ new Set([this]) : Ph.add(this)), Dpe(this, x), typeof R == "function" || (h.lanes & 2) === 0 && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          z(h) || "Unknown"
        );
      });
    }
    function $y(a, l, h, x, R) {
      if (h.flags |= 32768, Ps && Rf(a, R), x !== null && typeof x == "object" && typeof x.then == "function") {
        if (l = h.alternate, l !== null && Hc(
          l,
          h,
          R,
          !0
        ), ar && (Bf = !0), h = dc.current, h !== null) {
          switch (h.tag) {
            case 13:
              return _d === null ? ab() : h.alternate === null && Li === Wf && (Li = vN), h.flags &= -257, h.flags |= 65536, h.lanes = R, x === tN ? h.flags |= 16384 : (l = h.updateQueue, l === null ? h.updateQueue = /* @__PURE__ */ new Set([x]) : l.add(x), Ew(a, x, R)), !1;
            case 22:
              return h.flags |= 65536, x === tN ? h.flags |= 16384 : (l = h.updateQueue, l === null ? (l = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([x])
              }, h.updateQueue = l) : (h = l.retryQueue, h === null ? l.retryQueue = /* @__PURE__ */ new Set([x]) : h.add(x)), Ew(a, x, R)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + h.tag + "). This is a bug in React."
          );
        }
        return Ew(a, x, R), ab(), !1;
      }
      if (ar)
        return Bf = !0, l = dc.current, l !== null ? ((l.flags & 65536) === 0 && (l.flags |= 256), l.flags |= 65536, l.lanes = R, x !== KP && Op(
          ga(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: x }
            ),
            h
          )
        )) : (x !== KP && Op(
          ga(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: x }
            ),
            h
          )
        ), a = a.current.alternate, a.flags |= 65536, R &= -R, a.lanes |= R, x = ga(x, h), R = yi(
          a.stateNode,
          x,
          R
        ), $c(a, R), Li !== Km && (Li = h0)), !1;
      var A = ga(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: x }
        ),
        h
      );
      if (LT === null ? LT = [A] : LT.push(A), Li !== Km && (Li = h0), l === null) return !0;
      x = ga(x, h), h = l;
      do {
        switch (h.tag) {
          case 3:
            return h.flags |= 65536, a = R & -R, h.lanes |= a, a = yi(
              h.stateNode,
              x,
              a
            ), $c(h, a), !1;
          case 1:
            if (l = h.type, A = h.stateNode, (h.flags & 128) === 0 && (typeof l.getDerivedStateFromError == "function" || A !== null && typeof A.componentDidCatch == "function" && (Ph === null || !Ph.has(A))))
              return h.flags |= 65536, R &= -R, h.lanes |= R, R = om(R), xf(
                R,
                a,
                h,
                x
              ), $c(h, R), !1;
        }
        h = h.return;
      } while (h !== null);
      return !1;
    }
    function Wi(a, l, h, x) {
      l.child = a === null ? W5(l, null, h, x) : l0(
        l,
        a.child,
        h,
        x
      );
    }
    function $l(a, l, h, x, R) {
      h = h.render;
      var A = l.ref;
      if ("ref" in x) {
        var B = {};
        for (var G in x)
          G !== "ref" && (B[G] = x[G]);
      } else B = x;
      return $u(l), De(l), x = Np(
        a,
        l,
        h,
        B,
        A,
        R
      ), G = Gc(), Ye(), a !== null && !Bo ? (el(a, l, R), Gl(a, l, R)) : (ar && G && Ey(l), l.flags |= 1, Wi(a, l, x, R), l.child);
    }
    function am(a, l, h, x, R) {
      if (a === null) {
        var A = h.type;
        return typeof A == "function" && !wy(A) && A.defaultProps === void 0 && h.compare === null ? (h = af(A), l.tag = 15, l.type = h, lm(l, A), Gy(
          a,
          l,
          h,
          x,
          R
        )) : (a = Ty(
          h.type,
          null,
          x,
          l,
          l.mode,
          R
        ), a.ref = l.ref, a.return = l, l.child = a);
      }
      if (A = a.child, !QS(a, R)) {
        var B = A.memoizedProps;
        if (h = h.compare, h = h !== null ? h : zg, h(B, x) && a.ref === l.ref)
          return Gl(
            a,
            l,
            R
          );
      }
      return l.flags |= 1, a = Fl(A, x), a.ref = l.ref, a.return = l, l.child = a;
    }
    function Gy(a, l, h, x, R) {
      if (a !== null) {
        var A = a.memoizedProps;
        if (zg(A, x) && a.ref === l.ref && l.type === a.type)
          if (Bo = !1, l.pendingProps = x = A, QS(a, R))
            (a.flags & 131072) !== 0 && (Bo = !0);
          else
            return l.lanes = a.lanes, Gl(a, l, R);
      }
      return Xy(
        a,
        l,
        h,
        x,
        R
      );
    }
    function Yy(a, l, h) {
      var x = l.pendingProps, R = x.children, A = a !== null ? a.memoizedState : null;
      if (x.mode === "hidden") {
        if ((l.flags & 128) !== 0) {
          if (x = A !== null ? A.baseLanes | h : h, a !== null) {
            for (R = l.child = a.child, A = 0; R !== null; )
              A = A | R.lanes | R.childLanes, R = R.sibling;
            l.childLanes = A & ~x;
          } else l.childLanes = 0, l.child = null;
          return WS(
            a,
            l,
            x,
            h
          );
        }
        if ((h & 536870912) !== 0)
          l.memoizedState = { baseLanes: 0, cachePool: null }, a !== null && Ay(
            l,
            A !== null ? A.cachePool : null
          ), A !== null ? Iy(l, A) : Js(l), rm(l);
        else
          return l.lanes = l.childLanes = 536870912, WS(
            a,
            l,
            A !== null ? A.baseLanes | h : h,
            h
          );
      } else
        A !== null ? (Ay(l, A.cachePool), Iy(l, A), Cs(l), l.memoizedState = null) : (a !== null && Ay(l, null), Js(l), Cs(l));
      return Wi(a, l, R, h), l.child;
    }
    function WS(a, l, h, x) {
      var R = OS();
      return R = R === null ? null : {
        parent: Eo._currentValue,
        pool: R
      }, l.memoizedState = {
        baseLanes: h,
        cachePool: R
      }, a !== null && Ay(l, null), Js(l), rm(l), a !== null && Hc(a, l, x, !0), null;
    }
    function sm(a, l) {
      var h = l.ref;
      if (h === null)
        a !== null && a.ref !== null && (l.flags |= 4194816);
      else {
        if (typeof h != "function" && typeof h != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (a === null || a.ref !== h) && (l.flags |= 4194816);
      }
    }
    function Xy(a, l, h, x, R) {
      if (h.prototype && typeof h.prototype.render == "function") {
        var A = H(h) || "Unknown";
        n4[A] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          A,
          A
        ), n4[A] = !0);
      }
      return l.mode & Ma && bu.recordLegacyContextWarning(
        l,
        null
      ), a === null && (lm(l, l.type), h.contextTypes && (A = H(h) || "Unknown", i4[A] || (i4[A] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        A
      )))), $u(l), De(l), h = Np(
        a,
        l,
        h,
        x,
        void 0,
        R
      ), x = Gc(), Ye(), a !== null && !Bo ? (el(a, l, R), Gl(a, l, R)) : (ar && x && Ey(l), l.flags |= 1, Wi(a, l, h, R), l.child);
    }
    function HS(a, l, h, x, R, A) {
      return $u(l), De(l), Uf = -1, RT = a !== null && a.type !== l.type, l.updateQueue = null, h = ba(
        l,
        x,
        h,
        R
      ), Hg(a, l), x = Gc(), Ye(), a !== null && !Bo ? (el(a, l, A), Gl(a, l, A)) : (ar && x && Ey(l), l.flags |= 1, Wi(a, l, h, A), l.child);
    }
    function qS(a, l, h, x, R) {
      switch (u(l)) {
        case !1:
          var A = l.stateNode, B = new l.type(
            l.memoizedProps,
            A.context
          ).state;
          A.updater.enqueueSetState(A, B, null);
          break;
        case !0:
          l.flags |= 128, l.flags |= 65536, A = Error("Simulated error coming from DevTools");
          var G = R & -R;
          if (l.lanes |= G, B = Xr, B === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          G = om(G), xf(
            G,
            B,
            l,
            ga(A, l)
          ), $c(l, G);
      }
      if ($u(l), l.stateNode === null) {
        if (B = _h, A = h.contextType, "contextType" in h && A !== null && (A === void 0 || A.$$typeof !== Pa) && !J5.has(h) && (J5.add(h), G = A === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof A != "object" ? " However, it is set to a " + typeof A + "." : A.$$typeof === Dm ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(A).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          H(h) || "Component",
          G
        )), typeof A == "object" && A !== null && (B = qr(A)), A = new h(x, B), l.mode & Ma) {
          Ee(!0);
          try {
            A = new h(x, B);
          } finally {
            Ee(!1);
          }
        }
        if (B = l.memoizedState = A.state !== null && A.state !== void 0 ? A.state : null, A.updater = dN, l.stateNode = A, A._reactInternals = l, A._reactInternalInstance = H5, typeof h.getDerivedStateFromProps == "function" && B === null && (B = H(h) || "Component", $5.has(B) || ($5.add(B), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          B,
          A.state === null ? "null" : "undefined",
          B
        ))), typeof h.getDerivedStateFromProps == "function" || typeof A.getSnapshotBeforeUpdate == "function") {
          var ue = G = B = null;
          if (typeof A.componentWillMount == "function" && A.componentWillMount.__suppressDeprecationWarning !== !0 ? B = "componentWillMount" : typeof A.UNSAFE_componentWillMount == "function" && (B = "UNSAFE_componentWillMount"), typeof A.componentWillReceiveProps == "function" && A.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? G = "componentWillReceiveProps" : typeof A.UNSAFE_componentWillReceiveProps == "function" && (G = "UNSAFE_componentWillReceiveProps"), typeof A.componentWillUpdate == "function" && A.componentWillUpdate.__suppressDeprecationWarning !== !0 ? ue = "componentWillUpdate" : typeof A.UNSAFE_componentWillUpdate == "function" && (ue = "UNSAFE_componentWillUpdate"), B !== null || G !== null || ue !== null) {
            A = H(h) || "Component";
            var fe = typeof h.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Y5.has(A) || (Y5.add(A), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              A,
              fe,
              B !== null ? `
  ` + B : "",
              G !== null ? `
  ` + G : "",
              ue !== null ? `
  ` + ue : ""
            ));
          }
        }
        A = l.stateNode, B = H(h) || "Component", A.render || (h.prototype && typeof h.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          B
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          B
        )), !A.getInitialState || A.getInitialState.isReactClassApproved || A.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          B
        ), A.getDefaultProps && !A.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          B
        ), A.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          B
        ), h.childContextTypes && !Q5.has(h) && (Q5.add(h), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          B
        )), h.contextTypes && !K5.has(h) && (K5.add(h), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          B
        )), typeof A.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          B
        ), h.prototype && h.prototype.isPureReactComponent && typeof A.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          H(h) || "A pure component"
        ), typeof A.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          B
        ), typeof A.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          B
        ), typeof A.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          B
        ), typeof A.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          B
        ), G = A.props !== x, A.props !== void 0 && G && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          B
        ), A.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          B,
          B
        ), typeof A.getSnapshotBeforeUpdate != "function" || typeof A.componentDidUpdate == "function" || G5.has(h) || (G5.add(h), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          H(h)
        )), typeof A.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          B
        ), typeof A.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          B
        ), typeof h.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          B
        ), (G = A.state) && (typeof G != "object" || qi(G)) && console.error("%s.state: must be set to an object or null", B), typeof A.getChildContext == "function" && typeof h.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          B
        ), A = l.stateNode, A.props = x, A.state = l.memoizedState, A.refs = {}, Yu(l), B = h.contextType, A.context = typeof B == "object" && B !== null ? qr(B) : _h, A.state === x && (B = H(h) || "Component", X5.has(B) || (X5.add(B), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          B
        ))), l.mode & Ma && bu.recordLegacyContextWarning(
          l,
          A
        ), bu.recordUnsafeLifecycleWarnings(
          l,
          A
        ), A.state = l.memoizedState, B = h.getDerivedStateFromProps, typeof B == "function" && (im(
          l,
          h,
          B,
          x
        ), A.state = l.memoizedState), typeof h.getDerivedStateFromProps == "function" || typeof A.getSnapshotBeforeUpdate == "function" || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (B = A.state, typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount(), B !== A.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          z(l) || "Component"
        ), dN.enqueueReplaceState(
          A,
          A.state,
          null
        )), Xu(l, x, A, R), Ip(), A.state = l.memoizedState), typeof A.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & yu) !== ri && (l.flags |= 134217728), A = !0;
      } else if (a === null) {
        A = l.stateNode;
        var Xe = l.memoizedProps;
        G = td(h, Xe), A.props = G;
        var nt = A.context;
        ue = h.contextType, B = _h, typeof ue == "object" && ue !== null && (B = qr(ue)), fe = h.getDerivedStateFromProps, ue = typeof fe == "function" || typeof A.getSnapshotBeforeUpdate == "function", Xe = l.pendingProps !== Xe, ue || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (Xe || nt !== B) && FS(
          l,
          A,
          x,
          B
        ), Ch = !1;
        var $e = l.memoizedState;
        A.state = $e, Xu(l, x, A, R), Ip(), nt = l.memoizedState, Xe || $e !== nt || Ch ? (typeof fe == "function" && (im(
          l,
          h,
          fe,
          x
        ), nt = l.memoizedState), (G = Ch || Wy(
          l,
          h,
          G,
          x,
          $e,
          nt,
          B
        )) ? (ue || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & yu) !== ri && (l.flags |= 134217728)) : (typeof A.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & yu) !== ri && (l.flags |= 134217728), l.memoizedProps = x, l.memoizedState = nt), A.props = x, A.state = nt, A.context = B, A = G) : (typeof A.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & yu) !== ri && (l.flags |= 134217728), A = !1);
      } else {
        A = l.stateNode, Wg(a, l), B = l.memoizedProps, ue = td(h, B), A.props = ue, fe = l.pendingProps, $e = A.context, nt = h.contextType, G = _h, typeof nt == "object" && nt !== null && (G = qr(nt)), Xe = h.getDerivedStateFromProps, (nt = typeof Xe == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (B !== fe || $e !== G) && FS(
          l,
          A,
          x,
          G
        ), Ch = !1, $e = l.memoizedState, A.state = $e, Xu(l, x, A, R), Ip();
        var st = l.memoizedState;
        B !== fe || $e !== st || Ch || a !== null && a.dependencies !== null && Vg(a.dependencies) ? (typeof Xe == "function" && (im(
          l,
          h,
          Xe,
          x
        ), st = l.memoizedState), (ue = Ch || Wy(
          l,
          h,
          ue,
          x,
          $e,
          st,
          G
        ) || a !== null && a.dependencies !== null && Vg(a.dependencies)) ? (nt || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(x, st, G), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(
          x,
          st,
          G
        )), typeof A.componentDidUpdate == "function" && (l.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || B === a.memoizedProps && $e === a.memoizedState || (l.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || B === a.memoizedProps && $e === a.memoizedState || (l.flags |= 1024), l.memoizedProps = x, l.memoizedState = st), A.props = x, A.state = st, A.context = G, A = ue) : (typeof A.componentDidUpdate != "function" || B === a.memoizedProps && $e === a.memoizedState || (l.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || B === a.memoizedProps && $e === a.memoizedState || (l.flags |= 1024), A = !1);
      }
      if (G = A, sm(a, l), B = (l.flags & 128) !== 0, G || B) {
        if (G = l.stateNode, mi(l), B && typeof h.getDerivedStateFromError != "function")
          h = null, Ns = -1;
        else {
          if (De(l), h = A5(G), l.mode & Ma) {
            Ee(!0);
            try {
              A5(G);
            } finally {
              Ee(!1);
            }
          }
          Ye();
        }
        l.flags |= 1, a !== null && B ? (l.child = l0(
          l,
          a.child,
          null,
          R
        ), l.child = l0(
          l,
          null,
          h,
          R
        )) : Wi(a, l, h, R), l.memoizedState = G.state, a = l.child;
      } else
        a = Gl(
          a,
          l,
          R
        );
      return R = l.stateNode, A && R.props !== x && (d0 || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        z(l) || "a component"
      ), d0 = !0), a;
    }
    function $S(a, l, h, x) {
      return Rp(), l.flags |= 256, Wi(a, l, h, x), l.child;
    }
    function lm(a, l) {
      l && l.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        l.displayName || l.name || "Component"
      ), typeof l.getDerivedStateFromProps == "function" && (a = H(l) || "Unknown", o4[a] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        a
      ), o4[a] = !0)), typeof l.contextType == "object" && l.contextType !== null && (l = H(l) || "Unknown", r4[l] || (console.error(
        "%s: Function components do not support contextType.",
        l
      ), r4[l] = !0));
    }
    function Zy(a) {
      return { baseLanes: a, cachePool: AS() };
    }
    function GS(a, l, h) {
      return a = a !== null ? a.childLanes & ~h : 0, l && (a |= xl), a;
    }
    function YS(a, l, h) {
      var x, R = l.pendingProps;
      s(l) && (l.flags |= 128);
      var A = !1, B = (l.flags & 128) !== 0;
      if ((x = B) || (x = a !== null && a.memoizedState === null ? !1 : (Co.current & AT) !== 0), x && (A = !0, l.flags &= -129), x = (l.flags & 32) !== 0, l.flags &= -33, a === null) {
        if (ar) {
          if (A ? wa(l) : Cs(l), ar) {
            var G = ji, ue;
            if (!(ue = !G)) {
              e: {
                var fe = G;
                for (ue = Td; fe.nodeType !== 8; ) {
                  if (!ue) {
                    ue = null;
                    break e;
                  }
                  if (fe = Da(fe.nextSibling), fe === null) {
                    ue = null;
                    break e;
                  }
                }
                ue = fe;
              }
              ue !== null ? (Xs(), l.memoizedState = {
                dehydrated: ue,
                treeContext: Hm !== null ? { id: kf, overflow: zf } : null,
                retryLane: 536870912,
                hydrationErrors: null
              }, fe = S(18, null, null, ri), fe.stateNode = ue, fe.return = l, l.child = fe, os = l, ji = null, ue = !0) : ue = !1, ue = !ue;
            }
            ue && (Cp(
              l,
              G
            ), Hu(l));
          }
          if (G = l.memoizedState, G !== null && (G = G.dehydrated, G !== null))
            return pd(G) ? l.lanes = 32 : l.lanes = 536870912, null;
          Ta(l);
        }
        return G = R.children, R = R.fallback, A ? (Cs(l), A = l.mode, G = cm(
          {
            mode: "hidden",
            children: G
          },
          A
        ), R = ws(
          R,
          A,
          h,
          null
        ), G.return = l, R.return = l, G.sibling = R, l.child = G, A = l.child, A.memoizedState = Zy(h), A.childLanes = GS(
          a,
          x,
          h
        ), l.memoizedState = gN, R) : (wa(l), Ky(
          l,
          G
        ));
      }
      var Xe = a.memoizedState;
      if (Xe !== null && (G = Xe.dehydrated, G !== null)) {
        if (B)
          l.flags & 256 ? (wa(l), l.flags &= -257, l = um(
            a,
            l,
            h
          )) : l.memoizedState !== null ? (Cs(l), l.child = a.child, l.flags |= 128, l = null) : (Cs(l), A = R.fallback, G = l.mode, R = cm(
            {
              mode: "visible",
              children: R.children
            },
            G
          ), A = ws(
            A,
            G,
            h,
            null
          ), A.flags |= 2, R.return = l, A.return = l, R.sibling = A, l.child = R, l0(
            l,
            a.child,
            null,
            h
          ), R = l.child, R.memoizedState = Zy(h), R.childLanes = GS(
            a,
            x,
            h
          ), l.memoizedState = gN, l = A);
        else if (wa(l), ar && console.error(
          "We should not be hydrating here. This is a bug in React. Please file a bug."
        ), pd(G)) {
          if (x = G.nextSibling && G.nextSibling.dataset, x) {
            ue = x.dgst;
            var nt = x.msg;
            fe = x.stck;
            var $e = x.cstck;
          }
          G = nt, x = ue, R = fe, ue = A = $e, A = Error(G || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), A.stack = R || "", A.digest = x, x = ue === void 0 ? null : ue, R = {
            value: A,
            source: null,
            stack: x
          }, typeof x == "string" && XP.set(
            A,
            R
          ), Op(R), l = um(
            a,
            l,
            h
          );
        } else if (Bo || Hc(
          a,
          l,
          h,
          !1
        ), x = (h & a.childLanes) !== 0, Bo || x) {
          if (x = Xr, x !== null && (R = h & -h, R = (R & 42) !== 0 ? 1 : bt(
            R
          ), R = (R & (x.suspendedLanes | h)) !== 0 ? 0 : R, R !== 0 && R !== Xe.retryLane))
            throw Xe.retryLane = R, ma(
              a,
              R
            ), Mn(
              x,
              a,
              R
            ), t4;
          G.data === Hf || ab(), l = um(
            a,
            l,
            h
          );
        } else
          G.data === Hf ? (l.flags |= 192, l.child = a.child, l = null) : (a = Xe.treeContext, ji = Da(
            G.nextSibling
          ), os = l, ar = !0, qm = null, Bf = !1, sc = null, Td = !1, a !== null && (Xs(), oc[ac++] = kf, oc[ac++] = zf, oc[ac++] = Hm, kf = a.id, zf = a.overflow, Hm = l), l = Ky(
            l,
            R.children
          ), l.flags |= 4096);
        return l;
      }
      return A ? (Cs(l), A = R.fallback, G = l.mode, ue = a.child, fe = ue.sibling, R = Fl(
        ue,
        {
          mode: "hidden",
          children: R.children
        }
      ), R.subtreeFlags = ue.subtreeFlags & 65011712, fe !== null ? A = Fl(
        fe,
        A
      ) : (A = ws(
        A,
        G,
        h,
        null
      ), A.flags |= 2), A.return = l, R.return = l, R.sibling = A, l.child = R, R = A, A = l.child, G = a.child.memoizedState, G === null ? G = Zy(h) : (ue = G.cachePool, ue !== null ? (fe = Eo._currentValue, ue = ue.parent !== fe ? { parent: fe, pool: fe } : ue) : ue = AS(), G = {
        baseLanes: G.baseLanes | h,
        cachePool: ue
      }), A.memoizedState = G, A.childLanes = GS(
        a,
        x,
        h
      ), l.memoizedState = gN, R) : (wa(l), h = a.child, a = h.sibling, h = Fl(h, {
        mode: "visible",
        children: R.children
      }), h.return = l, h.sibling = null, a !== null && (x = l.deletions, x === null ? (l.deletions = [a], l.flags |= 16) : x.push(a)), l.child = h, l.memoizedState = null, h);
    }
    function Ky(a, l) {
      return l = cm(
        { mode: "visible", children: l },
        a.mode
      ), l.return = a, a.child = l;
    }
    function cm(a, l) {
      return a = S(22, a, null, l), a.lanes = 0, a.stateNode = {
        _visibility: UC,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }, a;
    }
    function um(a, l, h) {
      return l0(l, a.child, null, h), a = Ky(
        l,
        l.pendingProps.children
      ), a.flags |= 2, l.memoizedState = null, a;
    }
    function XS(a, l, h) {
      a.lanes |= l;
      var x = a.alternate;
      x !== null && (x.lanes |= l), _S(
        a.return,
        l,
        h
      );
    }
    function ZS(a, l) {
      var h = qi(a);
      return a = !h && typeof U(a) == "function", h || a ? (h = h ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        h,
        l,
        h
      ), !1) : !0;
    }
    function Qy(a, l, h, x, R) {
      var A = a.memoizedState;
      A === null ? a.memoizedState = {
        isBackwards: l,
        rendering: null,
        renderingStartTime: 0,
        last: x,
        tail: h,
        tailMode: R
      } : (A.isBackwards = l, A.rendering = null, A.renderingStartTime = 0, A.last = x, A.tail = h, A.tailMode = R);
    }
    function KS(a, l, h) {
      var x = l.pendingProps, R = x.revealOrder, A = x.tail;
      if (x = x.children, R !== void 0 && R !== "forwards" && R !== "backwards" && R !== "together" && !a4[R])
        if (a4[R] = !0, typeof R == "string")
          switch (R.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                R,
                R.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                R,
                R.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                R
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
            R
          );
      A === void 0 || hN[A] || (A !== "collapsed" && A !== "hidden" ? (hN[A] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
        A
      )) : R !== "forwards" && R !== "backwards" && (hN[A] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        A
      )));
      e: if ((R === "forwards" || R === "backwards") && x !== void 0 && x !== null && x !== !1)
        if (qi(x)) {
          for (var B = 0; B < x.length; B++)
            if (!ZS(x[B], B)) break e;
        } else if (B = U(x), typeof B == "function") {
          if (B = B.call(x))
            for (var G = B.next(), ue = 0; !G.done; G = B.next()) {
              if (!ZS(G.value, ue)) break e;
              ue++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            R
          );
      if (Wi(a, l, x, h), x = Co.current, (x & AT) !== 0)
        x = x & c0 | AT, l.flags |= 128;
      else {
        if (a !== null && (a.flags & 128) !== 0)
          e: for (a = l.child; a !== null; ) {
            if (a.tag === 13)
              a.memoizedState !== null && XS(
                a,
                h,
                l
              );
            else if (a.tag === 19)
              XS(a, h, l);
            else if (a.child !== null) {
              a.child.return = a, a = a.child;
              continue;
            }
            if (a === l) break e;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === l)
                break e;
              a = a.return;
            }
            a.sibling.return = a.return, a = a.sibling;
          }
        x &= c0;
      }
      switch (X(Co, x, l), R) {
        case "forwards":
          for (h = l.child, R = null; h !== null; )
            a = h.alternate, a !== null && Fy(a) === null && (R = h), h = h.sibling;
          h = R, h === null ? (R = l.child, l.child = null) : (R = h.sibling, h.sibling = null), Qy(
            l,
            !1,
            R,
            h,
            A
          );
          break;
        case "backwards":
          for (h = null, R = l.child, l.child = null; R !== null; ) {
            if (a = R.alternate, a !== null && Fy(a) === null) {
              l.child = R;
              break;
            }
            a = R.sibling, R.sibling = h, h = R, R = a;
          }
          Qy(
            l,
            !0,
            h,
            null,
            A
          );
          break;
        case "together":
          Qy(l, !1, null, null, void 0);
          break;
        default:
          l.memoizedState = null;
      }
      return l.child;
    }
    function Gl(a, l, h) {
      if (a !== null && (l.dependencies = a.dependencies), Ns = -1, Dh |= l.lanes, (h & l.childLanes) === 0)
        if (a !== null) {
          if (Hc(
            a,
            l,
            h,
            !1
          ), (h & l.childLanes) === 0)
            return null;
        } else return null;
      if (a !== null && l.child !== a.child)
        throw Error("Resuming work not yet implemented.");
      if (l.child !== null) {
        for (a = l.child, h = Fl(a, a.pendingProps), l.child = h, h.return = l; a.sibling !== null; )
          a = a.sibling, h = h.sibling = Fl(a, a.pendingProps), h.return = l;
        h.sibling = null;
      }
      return l.child;
    }
    function QS(a, l) {
      return (a.lanes & l) !== 0 ? !0 : (a = a.dependencies, !!(a !== null && Vg(a)));
    }
    function K_(a, l, h) {
      switch (l.tag) {
        case 3:
          re(
            l,
            l.stateNode.containerInfo
          ), qu(
            l,
            Eo,
            a.memoizedState.cache
          ), Rp();
          break;
        case 27:
        case 5:
          J(l);
          break;
        case 4:
          re(
            l,
            l.stateNode.containerInfo
          );
          break;
        case 10:
          qu(
            l,
            l.type,
            l.memoizedProps.value
          );
          break;
        case 12:
          (h & l.childLanes) !== 0 && (l.flags |= 4), l.flags |= 2048;
          var x = l.stateNode;
          x.effectDuration = -0, x.passiveEffectDuration = -0;
          break;
        case 13:
          if (x = l.memoizedState, x !== null)
            return x.dehydrated !== null ? (wa(l), l.flags |= 128, null) : (h & l.child.childLanes) !== 0 ? YS(
              a,
              l,
              h
            ) : (wa(l), a = Gl(
              a,
              l,
              h
            ), a !== null ? a.sibling : null);
          wa(l);
          break;
        case 19:
          var R = (a.flags & 128) !== 0;
          if (x = (h & l.childLanes) !== 0, x || (Hc(
            a,
            l,
            h,
            !1
          ), x = (h & l.childLanes) !== 0), R) {
            if (x)
              return KS(
                a,
                l,
                h
              );
            l.flags |= 128;
          }
          if (R = l.memoizedState, R !== null && (R.rendering = null, R.tail = null, R.lastEffect = null), X(
            Co,
            Co.current,
            l
          ), x) break;
          return null;
        case 22:
        case 23:
          return l.lanes = 0, Yy(a, l, h);
        case 24:
          qu(
            l,
            Eo,
            a.memoizedState.cache
          );
      }
      return Gl(a, l, h);
    }
    function nd(a, l, h) {
      if (l._debugNeedsRemount && a !== null) {
        h = Ty(
          l.type,
          l.key,
          l.pendingProps,
          l._debugOwner || null,
          l.mode,
          l.lanes
        ), h._debugStack = l._debugStack, h._debugTask = l._debugTask;
        var x = l.return;
        if (x === null) throw Error("Cannot swap the root fiber.");
        if (a.alternate = null, l.alternate = null, h.index = l.index, h.sibling = l.sibling, h.return = l.return, h.ref = l.ref, h._debugInfo = l._debugInfo, l === x.child)
          x.child = h;
        else {
          var R = x.child;
          if (R === null)
            throw Error("Expected parent to have a child.");
          for (; R.sibling !== l; )
            if (R = R.sibling, R === null)
              throw Error("Expected to find the previous sibling.");
          R.sibling = h;
        }
        return l = x.deletions, l === null ? (x.deletions = [a], x.flags |= 16) : l.push(a), h.flags |= 2, h;
      }
      if (a !== null)
        if (a.memoizedProps !== l.pendingProps || l.type !== a.type)
          Bo = !0;
        else {
          if (!QS(a, h) && (l.flags & 128) === 0)
            return Bo = !1, K_(
              a,
              l,
              h
            );
          Bo = (a.flags & 131072) !== 0;
        }
      else
        Bo = !1, (x = ar) && (Xs(), x = (l.flags & 1048576) !== 0), x && (x = l.index, Xs(), wS(l, WC, x));
      switch (l.lanes = 0, l.tag) {
        case 16:
          e: if (x = l.pendingProps, a = Oh(l.elementType), l.type = a, typeof a == "function")
            wy(a) ? (x = td(
              a,
              x
            ), l.tag = 1, l.type = a = af(a), l = qS(
              null,
              l,
              a,
              x,
              h
            )) : (l.tag = 0, lm(l, a), l.type = a = af(a), l = Xy(
              null,
              l,
              a,
              x,
              h
            ));
          else {
            if (a != null) {
              if (R = a.$$typeof, R === vd) {
                l.tag = 11, l.type = a = yS(a), l = $l(
                  null,
                  l,
                  a,
                  x,
                  h
                );
                break e;
              } else if (R === Pb) {
                l.tag = 14, l = am(
                  null,
                  l,
                  a,
                  x,
                  h
                );
                break e;
              }
            }
            throw l = "", a !== null && typeof a == "object" && a.$$typeof === ns && (l = " Did you wrap a component in React.lazy() more than once?"), a = H(a) || a, Error(
              "Element type is invalid. Received a promise that resolves to: " + a + ". Lazy element type must resolve to a class or function." + l
            );
          }
          return l;
        case 0:
          return Xy(
            a,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 1:
          return x = l.type, R = td(
            x,
            l.pendingProps
          ), qS(
            a,
            l,
            x,
            R,
            h
          );
        case 3:
          e: {
            if (re(
              l,
              l.stateNode.containerInfo
            ), a === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            x = l.pendingProps;
            var A = l.memoizedState;
            R = A.element, Wg(a, l), Xu(l, x, null, h);
            var B = l.memoizedState;
            if (x = B.cache, qu(l, Eo, x), x !== A.cache && Ko(
              l,
              [Eo],
              h,
              !0
            ), Ip(), x = B.element, A.isDehydrated)
              if (A = {
                element: x,
                isDehydrated: !1,
                cache: B.cache
              }, l.updateQueue.baseState = A, l.memoizedState = A, l.flags & 256) {
                l = $S(
                  a,
                  l,
                  x,
                  h
                );
                break e;
              } else if (x !== R) {
                R = ga(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  l
                ), Op(R), l = $S(
                  a,
                  l,
                  x,
                  h
                );
                break e;
              } else {
                switch (a = l.stateNode.containerInfo, a.nodeType) {
                  case 9:
                    a = a.body;
                    break;
                  default:
                    a = a.nodeName === "HTML" ? a.ownerDocument.body : a;
                }
                for (ji = Da(a.firstChild), os = l, ar = !0, qm = null, Bf = !1, sc = null, Td = !0, a = W5(
                  l,
                  null,
                  x,
                  h
                ), l.child = a; a; )
                  a.flags = a.flags & -3 | 4096, a = a.sibling;
              }
            else {
              if (Rp(), x === R) {
                l = Gl(
                  a,
                  l,
                  h
                );
                break e;
              }
              Wi(
                a,
                l,
                x,
                h
              );
            }
            l = l.child;
          }
          return l;
        case 26:
          return sm(a, l), a === null ? (a = Tm(
            l.type,
            null,
            l.pendingProps,
            null
          )) ? l.memoizedState = a : ar || (a = l.type, h = l.pendingProps, x = oe(
            Zl.current
          ), x = ir(
            x
          ).createElement(a), x[zo] = l, x[Na] = h, no(x, a, h), Rt(x), l.stateNode = x) : l.memoizedState = Tm(
            l.type,
            a.memoizedProps,
            l.pendingProps,
            a.memoizedState
          ), null;
        case 27:
          return J(l), a === null && ar && (x = oe(Zl.current), R = ee(), x = l.stateNode = Ia(
            l.type,
            l.pendingProps,
            x,
            R,
            !1
          ), Bf || (R = Ln(
            x,
            l.type,
            l.pendingProps,
            R
          ), R !== null && (uf(l, 0).serverProps = R)), os = l, Td = !0, R = ji, Hi(l.type) ? (zN = R, ji = Da(
            x.firstChild
          )) : ji = R), Wi(
            a,
            l,
            l.pendingProps.children,
            h
          ), sm(a, l), a === null && (l.flags |= 4194304), l.child;
        case 5:
          return a === null && ar && (A = ee(), x = dy(
            l.type,
            A.ancestorInfo
          ), R = ji, (B = !R) || (B = xo(
            R,
            l.type,
            l.pendingProps,
            Td
          ), B !== null ? (l.stateNode = B, Bf || (A = Ln(
            B,
            l.type,
            l.pendingProps,
            A
          ), A !== null && (uf(l, 0).serverProps = A)), os = l, ji = Da(
            B.firstChild
          ), Td = !1, A = !0) : A = !1, B = !A), B && (x && Cp(l, R), Hu(l))), J(l), R = l.type, A = l.pendingProps, B = a !== null ? a.memoizedProps : null, x = A.children, cd(R, A) ? x = null : B !== null && cd(R, B) && (l.flags |= 32), l.memoizedState !== null && (R = Np(
            a,
            l,
            Es,
            null,
            null,
            h
          ), HT._currentValue = R), sm(a, l), Wi(
            a,
            l,
            x,
            h
          ), l.child;
        case 6:
          return a === null && ar && (a = l.pendingProps, h = ee(), x = h.ancestorInfo.current, a = x != null ? wp(
            a,
            x.tag,
            h.ancestorInfo.implicitRootScope
          ) : !0, h = ji, (x = !h) || (x = fd(
            h,
            l.pendingProps,
            Td
          ), x !== null ? (l.stateNode = x, os = l, ji = null, x = !0) : x = !1, x = !x), x && (a && Cp(l, h), Hu(l))), null;
        case 13:
          return YS(a, l, h);
        case 4:
          return re(
            l,
            l.stateNode.containerInfo
          ), x = l.pendingProps, a === null ? l.child = l0(
            l,
            null,
            x,
            h
          ) : Wi(
            a,
            l,
            x,
            h
          ), l.child;
        case 11:
          return $l(
            a,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 7:
          return Wi(
            a,
            l,
            l.pendingProps,
            h
          ), l.child;
        case 8:
          return Wi(
            a,
            l,
            l.pendingProps.children,
            h
          ), l.child;
        case 12:
          return l.flags |= 4, l.flags |= 2048, x = l.stateNode, x.effectDuration = -0, x.passiveEffectDuration = -0, Wi(
            a,
            l,
            l.pendingProps.children,
            h
          ), l.child;
        case 10:
          return x = l.type, R = l.pendingProps, A = R.value, "value" in R || s4 || (s4 = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), qu(l, x, A), Wi(
            a,
            l,
            R.children,
            h
          ), l.child;
        case 9:
          return R = l.type._context, x = l.pendingProps.children, typeof x != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), $u(l), R = qr(R), De(l), x = lN(
            x,
            R,
            void 0
          ), Ye(), l.flags |= 1, Wi(
            a,
            l,
            x,
            h
          ), l.child;
        case 14:
          return am(
            a,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 15:
          return Gy(
            a,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 19:
          return KS(
            a,
            l,
            h
          );
        case 31:
          return x = l.pendingProps, h = l.mode, x = {
            mode: x.mode,
            children: x.children
          }, a === null ? (a = cm(
            x,
            h
          ), a.ref = l.ref, l.child = a, a.return = l, l = a) : (a = Fl(a.child, x), a.ref = l.ref, l.child = a, a.return = l, l = a), l;
        case 22:
          return Yy(a, l, h);
        case 24:
          return $u(l), x = qr(Eo), a === null ? (R = OS(), R === null && (R = Xr, A = CS(), R.pooledCache = A, Ts(A), A !== null && (R.pooledCacheLanes |= h), R = A), l.memoizedState = {
            parent: x,
            cache: R
          }, Yu(l), qu(l, Eo, R)) : ((a.lanes & h) !== 0 && (Wg(a, l), Xu(l, null, null, h), Ip()), R = a.memoizedState, A = l.memoizedState, R.parent !== x ? (R = {
            parent: x,
            cache: x
          }, l.memoizedState = R, l.lanes === 0 && (l.memoizedState = l.updateQueue.baseState = R), qu(l, Eo, x)) : (x = A.cache, qu(l, Eo, x), x !== R.cache && Ko(
            l,
            [Eo],
            h,
            !0
          ))), Wi(
            a,
            l,
            l.pendingProps.children,
            h
          ), l.child;
        case 29:
          throw l.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Rs(a) {
      a.flags |= 4;
    }
    function JS(a, l) {
      if (l.type !== "stylesheet" || (l.state.loading & fc) !== av)
        a.flags &= -16777217;
      else if (a.flags |= 16777216, !Uw(l)) {
        if (l = dc.current, l !== null && ((Fn & 4194048) === Fn ? _d !== null : (Fn & 62914560) !== Fn && (Fn & 536870912) === 0 || l !== _d))
          throw _T = tN, v5;
        a.flags |= 8192;
      }
    }
    function Sf(a, l) {
      l !== null && (a.flags |= 4), a.flags & 16384 && (l = a.tag !== 22 ? Be() : 536870912, a.lanes |= l, ev |= l);
    }
    function eu(a, l) {
      if (!ar)
        switch (a.tailMode) {
          case "hidden":
            l = a.tail;
            for (var h = null; l !== null; )
              l.alternate !== null && (h = l), l = l.sibling;
            h === null ? a.tail = null : h.sibling = null;
            break;
          case "collapsed":
            h = a.tail;
            for (var x = null; h !== null; )
              h.alternate !== null && (x = h), h = h.sibling;
            x === null ? l || a.tail === null ? a.tail = null : a.tail.sibling = null : x.sibling = null;
        }
    }
    function $r(a) {
      var l = a.alternate !== null && a.alternate.child === a.child, h = 0, x = 0;
      if (l)
        if ((a.mode & ta) !== ri) {
          for (var R = a.selfBaseDuration, A = a.child; A !== null; )
            h |= A.lanes | A.childLanes, x |= A.subtreeFlags & 65011712, x |= A.flags & 65011712, R += A.treeBaseDuration, A = A.sibling;
          a.treeBaseDuration = R;
        } else
          for (R = a.child; R !== null; )
            h |= R.lanes | R.childLanes, x |= R.subtreeFlags & 65011712, x |= R.flags & 65011712, R.return = a, R = R.sibling;
      else if ((a.mode & ta) !== ri) {
        R = a.actualDuration, A = a.selfBaseDuration;
        for (var B = a.child; B !== null; )
          h |= B.lanes | B.childLanes, x |= B.subtreeFlags, x |= B.flags, R += B.actualDuration, A += B.treeBaseDuration, B = B.sibling;
        a.actualDuration = R, a.treeBaseDuration = A;
      } else
        for (R = a.child; R !== null; )
          h |= R.lanes | R.childLanes, x |= R.subtreeFlags, x |= R.flags, R.return = a, R = R.sibling;
      return a.subtreeFlags |= x, a.childLanes = h, l;
    }
    function Q_(a, l, h) {
      var x = l.pendingProps;
      switch (cf(l), l.tag) {
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return $r(l), null;
        case 1:
          return $r(l), null;
        case 3:
          return h = l.stateNode, x = null, a !== null && (x = a.memoizedState.cache), l.memoizedState.cache !== x && (l.flags |= 2048), Wc(Eo, l), Z(l), h.pendingContext && (h.context = h.pendingContext, h.pendingContext = null), (a === null || a.child === null) && (df(l) ? (G_(), Rs(l)) : a === null || a.memoizedState.isDehydrated && (l.flags & 256) === 0 || (l.flags |= 1024, ES())), $r(l), null;
        case 26:
          return h = l.memoizedState, a === null ? (Rs(l), h !== null ? ($r(l), JS(
            l,
            h
          )) : ($r(l), l.flags &= -16777217)) : h ? h !== a.memoizedState ? (Rs(l), $r(l), JS(
            l,
            h
          )) : ($r(l), l.flags &= -16777217) : (a.memoizedProps !== x && Rs(l), $r(l), l.flags &= -16777217), null;
        case 27:
          le(l), h = oe(Zl.current);
          var R = l.type;
          if (a !== null && l.stateNode != null)
            a.memoizedProps !== x && Rs(l);
          else {
            if (!x) {
              if (l.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return $r(l), null;
            }
            a = ee(), df(l) ? TS(l) : (a = Ia(
              R,
              x,
              h,
              a,
              !0
            ), l.stateNode = a, Rs(l));
          }
          return $r(l), null;
        case 5:
          if (le(l), h = l.type, a !== null && l.stateNode != null)
            a.memoizedProps !== x && Rs(l);
          else {
            if (!x) {
              if (l.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return $r(l), null;
            }
            if (R = ee(), df(l))
              TS(l);
            else {
              switch (a = oe(Zl.current), dy(h, R.ancestorInfo), R = R.context, a = ir(a), R) {
                case x0:
                  a = a.createElementNS(vu, h);
                  break;
                case mR:
                  a = a.createElementNS(
                    Hb,
                    h
                  );
                  break;
                default:
                  switch (h) {
                    case "svg":
                      a = a.createElementNS(
                        vu,
                        h
                      );
                      break;
                    case "math":
                      a = a.createElementNS(
                        Hb,
                        h
                      );
                      break;
                    case "script":
                      a = a.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild);
                      break;
                    case "select":
                      a = typeof x.is == "string" ? a.createElement("select", { is: x.is }) : a.createElement("select"), x.multiple ? a.multiple = !0 : x.size && (a.size = x.size);
                      break;
                    default:
                      a = typeof x.is == "string" ? a.createElement(h, {
                        is: x.is
                      }) : a.createElement(h), h.indexOf("-") === -1 && (h !== h.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        h
                      ), Object.prototype.toString.call(a) !== "[object HTMLUnknownElement]" || Kl.call(
                        C4,
                        h
                      ) || (C4[h] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        h
                      )));
                  }
              }
              a[zo] = l, a[Na] = x;
              e: for (R = l.child; R !== null; ) {
                if (R.tag === 5 || R.tag === 6)
                  a.appendChild(R.stateNode);
                else if (R.tag !== 4 && R.tag !== 27 && R.child !== null) {
                  R.child.return = R, R = R.child;
                  continue;
                }
                if (R === l) break e;
                for (; R.sibling === null; ) {
                  if (R.return === null || R.return === l)
                    break e;
                  R = R.return;
                }
                R.sibling.return = R.return, R = R.sibling;
              }
              l.stateNode = a;
              e: switch (no(a, h, x), h) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  a = !!x.autoFocus;
                  break e;
                case "img":
                  a = !0;
                  break e;
                default:
                  a = !1;
              }
              a && Rs(l);
            }
          }
          return $r(l), l.flags &= -16777217, null;
        case 6:
          if (a && l.stateNode != null)
            a.memoizedProps !== x && Rs(l);
          else {
            if (typeof x != "string" && l.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (a = oe(Zl.current), h = ee(), df(l)) {
              a = l.stateNode, h = l.memoizedProps, R = !Bf, x = null;
              var A = os;
              if (A !== null)
                switch (A.tag) {
                  case 3:
                    R && (R = kw(
                      a,
                      h,
                      x
                    ), R !== null && (uf(l, 0).serverProps = R));
                    break;
                  case 27:
                  case 5:
                    x = A.memoizedProps, R && (R = kw(
                      a,
                      h,
                      x
                    ), R !== null && (uf(
                      l,
                      0
                    ).serverProps = R));
                }
              a[zo] = l, a = !!(a.nodeValue === h || x !== null && x.suppressHydrationWarning === !0 || Af(a.nodeValue, h)), a || Hu(l);
            } else
              R = h.ancestorInfo.current, R != null && wp(
                x,
                R.tag,
                h.ancestorInfo.implicitRootScope
              ), a = ir(a).createTextNode(
                x
              ), a[zo] = l, l.stateNode = a;
          }
          return $r(l), null;
        case 13:
          if (x = l.memoizedState, a === null || a.memoizedState !== null && a.memoizedState.dehydrated !== null) {
            if (R = df(l), x !== null && x.dehydrated !== null) {
              if (a === null) {
                if (!R)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (R = l.memoizedState, R = R !== null ? R.dehydrated : null, !R)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                R[zo] = l, $r(l), (l.mode & ta) !== ri && x !== null && (R = l.child, R !== null && (l.treeBaseDuration -= R.treeBaseDuration));
              } else
                G_(), Rp(), (l.flags & 128) === 0 && (l.memoizedState = null), l.flags |= 4, $r(l), (l.mode & ta) !== ri && x !== null && (R = l.child, R !== null && (l.treeBaseDuration -= R.treeBaseDuration));
              R = !1;
            } else
              R = ES(), a !== null && a.memoizedState !== null && (a.memoizedState.hydrationErrors = R), R = !0;
            if (!R)
              return l.flags & 256 ? (Ta(l), l) : (Ta(l), null);
          }
          return Ta(l), (l.flags & 128) !== 0 ? (l.lanes = h, (l.mode & ta) !== ri && Fg(l), l) : (h = x !== null, a = a !== null && a.memoizedState !== null, h && (x = l.child, R = null, x.alternate !== null && x.alternate.memoizedState !== null && x.alternate.memoizedState.cachePool !== null && (R = x.alternate.memoizedState.cachePool.pool), A = null, x.memoizedState !== null && x.memoizedState.cachePool !== null && (A = x.memoizedState.cachePool.pool), A !== R && (x.flags |= 2048)), h !== a && h && (l.child.flags |= 8192), Sf(l, l.updateQueue), $r(l), (l.mode & ta) !== ri && h && (a = l.child, a !== null && (l.treeBaseDuration -= a.treeBaseDuration)), null);
        case 4:
          return Z(l), a === null && xm(
            l.stateNode.containerInfo
          ), $r(l), null;
        case 10:
          return Wc(l.type, l), $r(l), null;
        case 19:
          if (F(Co, l), R = l.memoizedState, R === null) return $r(l), null;
          if (x = (l.flags & 128) !== 0, A = R.rendering, A === null)
            if (x) eu(R, !1);
            else {
              if (Li !== Wf || a !== null && (a.flags & 128) !== 0)
                for (a = l.child; a !== null; ) {
                  if (A = Fy(a), A !== null) {
                    for (l.flags |= 128, eu(R, !1), a = A.updateQueue, l.updateQueue = a, Sf(l, a), l.subtreeFlags = 0, a = h, h = l.child; h !== null; )
                      bS(h, a), h = h.sibling;
                    return X(
                      Co,
                      Co.current & c0 | AT,
                      l
                    ), l.child;
                  }
                  a = a.sibling;
                }
              R.tail !== null && So() > iR && (l.flags |= 128, x = !0, eu(R, !1), l.lanes = 4194304);
            }
          else {
            if (!x)
              if (a = Fy(A), a !== null) {
                if (l.flags |= 128, x = !0, a = a.updateQueue, l.updateQueue = a, Sf(l, a), eu(R, !0), R.tail === null && R.tailMode === "hidden" && !A.alternate && !ar)
                  return $r(l), null;
              } else
                2 * So() - R.renderingStartTime > iR && h !== 536870912 && (l.flags |= 128, x = !0, eu(R, !1), l.lanes = 4194304);
            R.isBackwards ? (A.sibling = l.child, l.child = A) : (a = R.last, a !== null ? a.sibling = A : l.child = A, R.last = A);
          }
          return R.tail !== null ? (a = R.tail, R.rendering = a, R.tail = a.sibling, R.renderingStartTime = So(), a.sibling = null, h = Co.current, h = x ? h & c0 | AT : h & c0, X(Co, h, l), a) : ($r(l), null);
        case 22:
        case 23:
          return Ta(l), Py(l), x = l.memoizedState !== null, a !== null ? a.memoizedState !== null !== x && (l.flags |= 8192) : x && (l.flags |= 8192), x ? (h & 536870912) !== 0 && (l.flags & 128) === 0 && ($r(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : $r(l), h = l.updateQueue, h !== null && Sf(l, h.retryQueue), h = null, a !== null && a.memoizedState !== null && a.memoizedState.cachePool !== null && (h = a.memoizedState.cachePool.pool), x = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (x = l.memoizedState.cachePool.pool), x !== h && (l.flags |= 2048), a !== null && F(Ym, l), null;
        case 24:
          return h = null, a !== null && (h = a.memoizedState.cache), l.memoizedState.cache !== h && (l.flags |= 2048), Wc(Eo, l), $r(l), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function J_(a, l) {
      switch (cf(l), l.tag) {
        case 1:
          return a = l.flags, a & 65536 ? (l.flags = a & -65537 | 128, (l.mode & ta) !== ri && Fg(l), l) : null;
        case 3:
          return Wc(Eo, l), Z(l), a = l.flags, (a & 65536) !== 0 && (a & 128) === 0 ? (l.flags = a & -65537 | 128, l) : null;
        case 26:
        case 27:
        case 5:
          return le(l), null;
        case 13:
          if (Ta(l), a = l.memoizedState, a !== null && a.dehydrated !== null) {
            if (l.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            Rp();
          }
          return a = l.flags, a & 65536 ? (l.flags = a & -65537 | 128, (l.mode & ta) !== ri && Fg(l), l) : null;
        case 19:
          return F(Co, l), null;
        case 4:
          return Z(l), null;
        case 10:
          return Wc(l.type, l), null;
        case 22:
        case 23:
          return Ta(l), Py(l), a !== null && F(Ym, l), a = l.flags, a & 65536 ? (l.flags = a & -65537 | 128, (l.mode & ta) !== ri && Fg(l), l) : null;
        case 24:
          return Wc(Eo, l), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function ew(a, l) {
      switch (cf(l), l.tag) {
        case 3:
          Wc(Eo, l), Z(l);
          break;
        case 26:
        case 27:
        case 5:
          le(l);
          break;
        case 4:
          Z(l);
          break;
        case 13:
          Ta(l);
          break;
        case 19:
          F(Co, l);
          break;
        case 10:
          Wc(l.type, l);
          break;
        case 22:
        case 23:
          Ta(l), Py(l), a !== null && F(Ym, l);
          break;
        case 24:
          Wc(Eo, l);
      }
    }
    function ol(a) {
      return (a.mode & ta) !== ri;
    }
    function tw(a, l) {
      ol(a) ? (jo(), Xp(l, a), Zs()) : Xp(l, a);
    }
    function dm(a, l, h) {
      ol(a) ? (jo(), wf(
        h,
        a,
        l
      ), Zs()) : wf(
        h,
        a,
        l
      );
    }
    function Xp(a, l) {
      try {
        var h = l.updateQueue, x = h !== null ? h.lastEffect : null;
        if (x !== null) {
          var R = x.next;
          h = R;
          do {
            if ((h.tag & a) === a && ((a & _o) !== lc ? Pt !== null && typeof Pt.markComponentPassiveEffectMountStarted == "function" && Pt.markComponentPassiveEffectMountStarted(
              l
            ) : (a & na) !== lc && Pt !== null && typeof Pt.markComponentLayoutEffectMountStarted == "function" && Pt.markComponentLayoutEffectMountStarted(
              l
            ), x = void 0, (a & as) !== lc && (y0 = !0), x = _t(
              l,
              Ipe,
              h
            ), (a & as) !== lc && (y0 = !1), (a & _o) !== lc ? Pt !== null && typeof Pt.markComponentPassiveEffectMountStopped == "function" && Pt.markComponentPassiveEffectMountStopped() : (a & na) !== lc && Pt !== null && typeof Pt.markComponentLayoutEffectMountStopped == "function" && Pt.markComponentLayoutEffectMountStopped(), x !== void 0 && typeof x != "function")) {
              var A = void 0;
              A = (h.tag & na) !== 0 ? "useLayoutEffect" : (h.tag & as) !== 0 ? "useInsertionEffect" : "useEffect";
              var B = void 0;
              B = x === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof x.then == "function" ? `

It looks like you wrote ` + A + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + A + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + x, _t(
                l,
                function(G, ue) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    G,
                    ue
                  );
                },
                A,
                B
              );
            }
            h = h.next;
          } while (h !== R);
        }
      } catch (G) {
        wr(l, l.return, G);
      }
    }
    function wf(a, l, h) {
      try {
        var x = l.updateQueue, R = x !== null ? x.lastEffect : null;
        if (R !== null) {
          var A = R.next;
          x = A;
          do {
            if ((x.tag & a) === a) {
              var B = x.inst, G = B.destroy;
              G !== void 0 && (B.destroy = void 0, (a & _o) !== lc ? Pt !== null && typeof Pt.markComponentPassiveEffectUnmountStarted == "function" && Pt.markComponentPassiveEffectUnmountStarted(
                l
              ) : (a & na) !== lc && Pt !== null && typeof Pt.markComponentLayoutEffectUnmountStarted == "function" && Pt.markComponentLayoutEffectUnmountStarted(
                l
              ), (a & as) !== lc && (y0 = !0), R = l, _t(
                R,
                Ppe,
                R,
                h,
                G
              ), (a & as) !== lc && (y0 = !1), (a & _o) !== lc ? Pt !== null && typeof Pt.markComponentPassiveEffectUnmountStopped == "function" && Pt.markComponentPassiveEffectUnmountStopped() : (a & na) !== lc && Pt !== null && typeof Pt.markComponentLayoutEffectUnmountStopped == "function" && Pt.markComponentLayoutEffectUnmountStopped());
            }
            x = x.next;
          } while (x !== A);
        }
      } catch (ue) {
        wr(l, l.return, ue);
      }
    }
    function Jy(a, l) {
      ol(a) ? (jo(), Xp(l, a), Zs()) : Xp(l, a);
    }
    function eb(a, l, h) {
      ol(a) ? (jo(), wf(
        h,
        a,
        l
      ), Zs()) : wf(
        h,
        a,
        l
      );
    }
    function nw(a) {
      var l = a.updateQueue;
      if (l !== null) {
        var h = a.stateNode;
        a.type.defaultProps || "ref" in a.memoizedProps || d0 || (h.props !== a.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          z(a) || "instance"
        ), h.state !== a.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          z(a) || "instance"
        ));
        try {
          _t(
            a,
            ya,
            l,
            h
          );
        } catch (x) {
          wr(a, a.return, x);
        }
      }
    }
    function PP(a, l, h) {
      return a.getSnapshotBeforeUpdate(l, h);
    }
    function rw(a, l) {
      var h = l.memoizedProps, x = l.memoizedState;
      l = a.stateNode, a.type.defaultProps || "ref" in a.memoizedProps || d0 || (l.props !== a.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        z(a) || "instance"
      ), l.state !== a.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        z(a) || "instance"
      ));
      try {
        var R = td(
          a.type,
          h,
          a.elementType === a.type
        ), A = _t(
          a,
          PP,
          l,
          R,
          x
        );
        h = l4, A !== void 0 || h.has(a.type) || (h.add(a.type), _t(a, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            z(a)
          );
        })), l.__reactInternalSnapshotBeforeUpdate = A;
      } catch (B) {
        wr(a, a.return, B);
      }
    }
    function iw(a, l, h) {
      h.props = td(
        a.type,
        a.memoizedProps
      ), h.state = a.memoizedState, ol(a) ? (jo(), _t(
        a,
        j5,
        a,
        l,
        h
      ), Zs()) : _t(
        a,
        j5,
        a,
        l,
        h
      );
    }
    function eC(a) {
      var l = a.ref;
      if (l !== null) {
        switch (a.tag) {
          case 26:
          case 27:
          case 5:
            var h = a.stateNode;
            break;
          case 30:
            h = a.stateNode;
            break;
          default:
            h = a.stateNode;
        }
        if (typeof l == "function")
          if (ol(a))
            try {
              jo(), a.refCleanup = l(h);
            } finally {
              Zs();
            }
          else a.refCleanup = l(h);
        else
          typeof l == "string" ? console.error("String refs are no longer supported.") : l.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            z(a)
          ), l.current = h;
      }
    }
    function Tf(a, l) {
      try {
        _t(a, eC, a);
      } catch (h) {
        wr(a, l, h);
      }
    }
    function al(a, l) {
      var h = a.ref, x = a.refCleanup;
      if (h !== null)
        if (typeof x == "function")
          try {
            if (ol(a))
              try {
                jo(), _t(a, x);
              } finally {
                Zs(a);
              }
            else _t(a, x);
          } catch (R) {
            wr(a, l, R);
          } finally {
            a.refCleanup = null, a = a.alternate, a != null && (a.refCleanup = null);
          }
        else if (typeof h == "function")
          try {
            if (ol(a))
              try {
                jo(), _t(a, h, null);
              } finally {
                Zs(a);
              }
            else _t(a, h, null);
          } catch (R) {
            wr(a, l, R);
          }
        else h.current = null;
    }
    function ow(a, l, h, x) {
      var R = a.memoizedProps, A = R.id, B = R.onCommit;
      R = R.onRender, l = l === null ? "mount" : "update", $C && (l = "nested-update"), typeof R == "function" && R(
        A,
        l,
        a.actualDuration,
        a.treeBaseDuration,
        a.actualStartTime,
        h
      ), typeof B == "function" && B(
        a.memoizedProps.id,
        l,
        x,
        h
      );
    }
    function NP(a, l, h, x) {
      var R = a.memoizedProps;
      a = R.id, R = R.onPostCommit, l = l === null ? "mount" : "update", $C && (l = "nested-update"), typeof R == "function" && R(
        a,
        l,
        x,
        h
      );
    }
    function tC(a) {
      var l = a.type, h = a.memoizedProps, x = a.stateNode;
      try {
        _t(
          a,
          xi,
          x,
          l,
          h,
          a
        );
      } catch (R) {
        wr(a, a.return, R);
      }
    }
    function tb(a, l, h) {
      try {
        _t(
          a,
          ud,
          a.stateNode,
          a.type,
          h,
          l,
          a
        );
      } catch (x) {
        wr(a, a.return, x);
      }
    }
    function Zp(a) {
      return a.tag === 5 || a.tag === 3 || a.tag === 26 || a.tag === 27 && Hi(a.type) || a.tag === 4;
    }
    function fm(a) {
      e: for (; ; ) {
        for (; a.sibling === null; ) {
          if (a.return === null || Zp(a.return)) return null;
          a = a.return;
        }
        for (a.sibling.return = a.return, a = a.sibling; a.tag !== 5 && a.tag !== 6 && a.tag !== 18; ) {
          if (a.tag === 27 && Hi(a.type) || a.flags & 2 || a.child === null || a.tag === 4) continue e;
          a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
      }
    }
    function Kp(a, l, h) {
      var x = a.tag;
      if (x === 5 || x === 6)
        a = a.stateNode, l ? (h.nodeType === 9 ? h.body : h.nodeName === "HTML" ? h.ownerDocument.body : h).insertBefore(a, l) : (l = h.nodeType === 9 ? h.body : h.nodeName === "HTML" ? h.ownerDocument.body : h, l.appendChild(a), h = h._reactRootContainer, h != null || l.onclick !== null || (l.onclick = sd));
      else if (x !== 4 && (x === 27 && Hi(a.type) && (h = a.stateNode, l = null), a = a.child, a !== null))
        for (Kp(a, l, h), a = a.sibling; a !== null; )
          Kp(a, l, h), a = a.sibling;
    }
    function pm(a, l, h) {
      var x = a.tag;
      if (x === 5 || x === 6)
        a = a.stateNode, l ? h.insertBefore(a, l) : h.appendChild(a);
      else if (x !== 4 && (x === 27 && Hi(a.type) && (h = a.stateNode), a = a.child, a !== null))
        for (pm(a, l, h), a = a.sibling; a !== null; )
          pm(a, l, h), a = a.sibling;
    }
    function nC(a) {
      for (var l, h = a.return; h !== null; ) {
        if (Zp(h)) {
          l = h;
          break;
        }
        h = h.return;
      }
      if (l == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (l.tag) {
        case 27:
          l = l.stateNode, h = fm(a), pm(
            a,
            h,
            l
          );
          break;
        case 5:
          h = l.stateNode, l.flags & 32 && (dd(h), l.flags &= -33), l = fm(a), pm(
            a,
            l,
            h
          );
          break;
        case 3:
        case 4:
          l = l.stateNode.containerInfo, h = fm(a), Kp(
            a,
            h,
            l
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function hm(a) {
      var l = a.stateNode, h = a.memoizedProps;
      try {
        _t(
          a,
          vC,
          a.type,
          h,
          l,
          a
        );
      } catch (x) {
        wr(a, a.return, x);
      }
    }
    function rC(a, l) {
      if (a = a.containerInfo, jN = xR, a = H_(a), mS(a)) {
        if ("selectionStart" in a)
          var h = {
            start: a.selectionStart,
            end: a.selectionEnd
          };
        else
          e: {
            h = (h = a.ownerDocument) && h.defaultView || window;
            var x = h.getSelection && h.getSelection();
            if (x && x.rangeCount !== 0) {
              h = x.anchorNode;
              var R = x.anchorOffset, A = x.focusNode;
              x = x.focusOffset;
              try {
                h.nodeType, A.nodeType;
              } catch {
                h = null;
                break e;
              }
              var B = 0, G = -1, ue = -1, fe = 0, Xe = 0, nt = a, $e = null;
              t: for (; ; ) {
                for (var st; nt !== h || R !== 0 && nt.nodeType !== 3 || (G = B + R), nt !== A || x !== 0 && nt.nodeType !== 3 || (ue = B + x), nt.nodeType === 3 && (B += nt.nodeValue.length), (st = nt.firstChild) !== null; )
                  $e = nt, nt = st;
                for (; ; ) {
                  if (nt === a) break t;
                  if ($e === h && ++fe === R && (G = B), $e === A && ++Xe === x && (ue = B), (st = nt.nextSibling) !== null) break;
                  nt = $e, $e = nt.parentNode;
                }
                nt = st;
              }
              h = G === -1 || ue === -1 ? null : { start: G, end: ue };
            } else h = null;
          }
        h = h || { start: 0, end: 0 };
      } else h = null;
      for (LN = {
        focusedElem: a,
        selectionRange: h
      }, xR = !1, Vo = l; Vo !== null; )
        if (l = Vo, a = l.child, (l.subtreeFlags & 1024) !== 0 && a !== null)
          a.return = l, Vo = a;
        else
          for (; Vo !== null; ) {
            switch (a = l = Vo, h = a.alternate, R = a.flags, a.tag) {
              case 0:
                break;
              case 11:
              case 15:
                break;
              case 1:
                (R & 1024) !== 0 && h !== null && rw(a, h);
                break;
              case 3:
                if ((R & 1024) !== 0) {
                  if (a = a.stateNode.containerInfo, h = a.nodeType, h === 9)
                    Yl(a);
                  else if (h === 1)
                    switch (a.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Yl(a);
                        break;
                      default:
                        a.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((R & 1024) !== 0)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (a = l.sibling, a !== null) {
              a.return = l.return, Vo = a;
              break;
            }
            Vo = l.return;
          }
    }
    function aw(a, l, h) {
      var x = h.flags;
      switch (h.tag) {
        case 0:
        case 11:
        case 15:
          Ni(a, h), x & 4 && tw(h, na | cc);
          break;
        case 1:
          if (Ni(a, h), x & 4)
            if (a = h.stateNode, l === null)
              h.type.defaultProps || "ref" in h.memoizedProps || d0 || (a.props !== h.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                z(h) || "instance"
              ), a.state !== h.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                z(h) || "instance"
              )), ol(h) ? (jo(), _t(
                h,
                cN,
                h,
                a
              ), Zs()) : _t(
                h,
                cN,
                h,
                a
              );
            else {
              var R = td(
                h.type,
                l.memoizedProps
              );
              l = l.memoizedState, h.type.defaultProps || "ref" in h.memoizedProps || d0 || (a.props !== h.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                z(h) || "instance"
              ), a.state !== h.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                z(h) || "instance"
              )), ol(h) ? (jo(), _t(
                h,
                P5,
                h,
                a,
                R,
                l,
                a.__reactInternalSnapshotBeforeUpdate
              ), Zs()) : _t(
                h,
                P5,
                h,
                a,
                R,
                l,
                a.__reactInternalSnapshotBeforeUpdate
              );
            }
          x & 64 && nw(h), x & 512 && Tf(h, h.return);
          break;
        case 3:
          if (l = Ya(), Ni(a, h), x & 64 && (x = h.updateQueue, x !== null)) {
            if (R = null, h.child !== null)
              switch (h.child.tag) {
                case 27:
                case 5:
                  R = h.child.stateNode;
                  break;
                case 1:
                  R = h.child.stateNode;
              }
            try {
              _t(
                h,
                ya,
                x,
                R
              );
            } catch (B) {
              wr(h, h.return, B);
            }
          }
          a.effectDuration += Ap(l);
          break;
        case 27:
          l === null && x & 4 && hm(h);
        case 26:
        case 5:
          Ni(a, h), l === null && x & 4 && tC(h), x & 512 && Tf(h, h.return);
          break;
        case 12:
          if (x & 4) {
            x = Ya(), Ni(a, h), a = h.stateNode, a.effectDuration += Dp(x);
            try {
              _t(
                h,
                ow,
                h,
                l,
                qC,
                a.effectDuration
              );
            } catch (B) {
              wr(h, h.return, B);
            }
          } else Ni(a, h);
          break;
        case 13:
          Ni(a, h), x & 4 && gm(a, h), x & 64 && (a = h.memoizedState, a !== null && (a = a.dehydrated, a !== null && (h = od.bind(
            null,
            h
          ), ch(a, h))));
          break;
        case 22:
          if (x = h.memoizedState !== null || Ff, !x) {
            l = l !== null && l.memoizedState !== null || $i, R = Ff;
            var A = $i;
            Ff = x, ($i = l) && !A ? Lo(
              a,
              h,
              (h.subtreeFlags & 8772) !== 0
            ) : Ni(a, h), Ff = R, $i = A;
          }
          break;
        case 30:
          break;
        default:
          Ni(a, h);
      }
    }
    function iC(a) {
      var l = a.alternate;
      l !== null && (a.alternate = null, iC(l)), a.child = null, a.deletions = null, a.sibling = null, a.tag === 5 && (l = a.stateNode, l !== null && Fe(l)), a.stateNode = null, a._debugOwner = null, a.return = null, a.dependencies = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.stateNode = null, a.updateQueue = null;
    }
    function Ea(a, l, h) {
      for (h = h.child; h !== null; )
        Qp(
          a,
          l,
          h
        ), h = h.sibling;
    }
    function Qp(a, l, h) {
      if (wo && typeof wo.onCommitFiberUnmount == "function")
        try {
          wo.onCommitFiberUnmount(Mf, h);
        } catch (A) {
          Ci || (Ci = !0, console.error(
            "React instrumentation encountered an error: %s",
            A
          ));
        }
      switch (h.tag) {
        case 26:
          $i || al(h, l), Ea(
            a,
            l,
            h
          ), h.memoizedState ? h.memoizedState.count-- : h.stateNode && (h = h.stateNode, h.parentNode.removeChild(h));
          break;
        case 27:
          $i || al(h, l);
          var x = so, R = Ms;
          Hi(h.type) && (so = h.stateNode, Ms = !1), Ea(
            a,
            l,
            h
          ), _t(
            h,
            dh,
            h.stateNode
          ), so = x, Ms = R;
          break;
        case 5:
          $i || al(h, l);
        case 6:
          if (x = so, R = Ms, so = null, Ea(
            a,
            l,
            h
          ), so = x, Ms = R, so !== null)
            if (Ms)
              try {
                _t(
                  h,
                  wm,
                  so,
                  h.stateNode
                );
              } catch (A) {
                wr(
                  h,
                  l,
                  A
                );
              }
            else
              try {
                _t(
                  h,
                  lh,
                  so,
                  h.stateNode
                );
              } catch (A) {
                wr(
                  h,
                  l,
                  A
                );
              }
          break;
        case 18:
          so !== null && (Ms ? (a = so, ea(
            a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a,
            h.stateNode
          ), mh(a)) : ea(so, h.stateNode));
          break;
        case 4:
          x = so, R = Ms, so = h.stateNode.containerInfo, Ms = !0, Ea(
            a,
            l,
            h
          ), so = x, Ms = R;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          $i || wf(
            as,
            h,
            l
          ), $i || dm(
            h,
            l,
            na
          ), Ea(
            a,
            l,
            h
          );
          break;
        case 1:
          $i || (al(h, l), x = h.stateNode, typeof x.componentWillUnmount == "function" && iw(
            h,
            l,
            x
          )), Ea(
            a,
            l,
            h
          );
          break;
        case 21:
          Ea(
            a,
            l,
            h
          );
          break;
        case 22:
          $i = (x = $i) || h.memoizedState !== null, Ea(
            a,
            l,
            h
          ), $i = x;
          break;
        default:
          Ea(
            a,
            l,
            h
          );
      }
    }
    function gm(a, l) {
      if (l.memoizedState === null && (a = l.alternate, a !== null && (a = a.memoizedState, a !== null && (a = a.dehydrated, a !== null))))
        try {
          _t(
            l,
            mC,
            a
          );
        } catch (h) {
          wr(l, l.return, h);
        }
    }
    function mm(a) {
      switch (a.tag) {
        case 13:
        case 19:
          var l = a.stateNode;
          return l === null && (l = a.stateNode = new c4()), l;
        case 22:
          return a = a.stateNode, l = a._retryCache, l === null && (l = a._retryCache = new c4()), l;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + a.tag + "). This is a bug in React."
          );
      }
    }
    function Jp(a, l) {
      var h = mm(a);
      l.forEach(function(x) {
        var R = uC.bind(null, a, x);
        if (!h.has(x)) {
          if (h.add(x), Ps)
            if (f0 !== null && p0 !== null)
              Rf(p0, f0);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          x.then(R, R);
        }
      });
    }
    function _a(a, l) {
      var h = l.deletions;
      if (h !== null)
        for (var x = 0; x < h.length; x++) {
          var R = a, A = l, B = h[x], G = A;
          e: for (; G !== null; ) {
            switch (G.tag) {
              case 27:
                if (Hi(G.type)) {
                  so = G.stateNode, Ms = !1;
                  break e;
                }
                break;
              case 5:
                so = G.stateNode, Ms = !1;
                break e;
              case 3:
              case 4:
                so = G.stateNode.containerInfo, Ms = !0;
                break e;
            }
            G = G.return;
          }
          if (so === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          Qp(R, A, B), so = null, Ms = !1, R = B, A = R.alternate, A !== null && (A.return = null), R.return = null;
        }
      if (l.subtreeFlags & 13878)
        for (l = l.child; l !== null; )
          sw(l, a), l = l.sibling;
    }
    function sw(a, l) {
      var h = a.alternate, x = a.flags;
      switch (a.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          _a(l, a), eo(a), x & 4 && (wf(
            as | cc,
            a,
            a.return
          ), Xp(as | cc, a), dm(
            a,
            a.return,
            na | cc
          ));
          break;
        case 1:
          _a(l, a), eo(a), x & 512 && ($i || h === null || al(h, h.return)), x & 64 && Ff && (a = a.updateQueue, a !== null && (x = a.callbacks, x !== null && (h = a.shared.hiddenCallbacks, a.shared.hiddenCallbacks = h === null ? x : h.concat(x))));
          break;
        case 26:
          var R = Su;
          if (_a(l, a), eo(a), x & 512 && ($i || h === null || al(h, h.return)), x & 4)
            if (l = h !== null ? h.memoizedState : null, x = a.memoizedState, h === null)
              if (x === null)
                if (a.stateNode === null) {
                  e: {
                    x = a.type, h = a.memoizedProps, l = R.ownerDocument || R;
                    t: switch (x) {
                      case "title":
                        R = l.getElementsByTagName("title")[0], (!R || R[jm] || R[zo] || R.namespaceURI === vu || R.hasAttribute("itemprop")) && (R = l.createElement(x), l.head.insertBefore(
                          R,
                          l.querySelector("head > title")
                        )), no(R, x, h), R[zo] = a, Rt(R), x = R;
                        break e;
                      case "link":
                        var A = Vw(
                          "link",
                          "href",
                          l
                        ).get(x + (h.href || ""));
                        if (A) {
                          for (var B = 0; B < A.length; B++)
                            if (R = A[B], R.getAttribute("href") === (h.href == null || h.href === "" ? null : h.href) && R.getAttribute("rel") === (h.rel == null ? null : h.rel) && R.getAttribute("title") === (h.title == null ? null : h.title) && R.getAttribute("crossorigin") === (h.crossOrigin == null ? null : h.crossOrigin)) {
                              A.splice(B, 1);
                              break t;
                            }
                        }
                        R = l.createElement(x), no(R, x, h), l.head.appendChild(R);
                        break;
                      case "meta":
                        if (A = Vw(
                          "meta",
                          "content",
                          l
                        ).get(x + (h.content || ""))) {
                          for (B = 0; B < A.length; B++)
                            if (R = A[B], ie(
                              h.content,
                              "content"
                            ), R.getAttribute("content") === (h.content == null ? null : "" + h.content) && R.getAttribute("name") === (h.name == null ? null : h.name) && R.getAttribute("property") === (h.property == null ? null : h.property) && R.getAttribute("http-equiv") === (h.httpEquiv == null ? null : h.httpEquiv) && R.getAttribute("charset") === (h.charSet == null ? null : h.charSet)) {
                              A.splice(B, 1);
                              break t;
                            }
                        }
                        R = l.createElement(x), no(R, x, h), l.head.appendChild(R);
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + x + '". This is a bug in React.'
                        );
                    }
                    R[zo] = a, Rt(R), x = R;
                  }
                  a.stateNode = x;
                } else
                  If(
                    R,
                    a.type,
                    a.stateNode
                  );
              else
                a.stateNode = bC(
                  R,
                  x,
                  a.memoizedProps
                );
            else
              l !== x ? (l === null ? h.stateNode !== null && (h = h.stateNode, h.parentNode.removeChild(h)) : l.count--, x === null ? If(
                R,
                a.type,
                a.stateNode
              ) : bC(
                R,
                x,
                a.memoizedProps
              )) : x === null && a.stateNode !== null && tb(
                a,
                a.memoizedProps,
                h.memoizedProps
              );
          break;
        case 27:
          _a(l, a), eo(a), x & 512 && ($i || h === null || al(h, h.return)), h !== null && x & 4 && tb(
            a,
            a.memoizedProps,
            h.memoizedProps
          );
          break;
        case 5:
          if (_a(l, a), eo(a), x & 512 && ($i || h === null || al(h, h.return)), a.flags & 32) {
            l = a.stateNode;
            try {
              _t(a, dd, l);
            } catch (Xe) {
              wr(a, a.return, Xe);
            }
          }
          x & 4 && a.stateNode != null && (l = a.memoizedProps, tb(
            a,
            l,
            h !== null ? h.memoizedProps : l
          )), x & 1024 && (mN = !0, a.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (_a(l, a), eo(a), x & 4) {
            if (a.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            x = a.memoizedProps, h = h !== null ? h.memoizedProps : x, l = a.stateNode;
            try {
              _t(
                a,
                Mw,
                l,
                h,
                x
              );
            } catch (Xe) {
              wr(a, a.return, Xe);
            }
          }
          break;
        case 3:
          if (R = Ya(), vR = null, A = Su, Su = yb(l.containerInfo), _a(l, a), Su = A, eo(a), x & 4 && h !== null && h.memoizedState.isDehydrated)
            try {
              _t(
                a,
                ts,
                l.containerInfo
              );
            } catch (Xe) {
              wr(a, a.return, Xe);
            }
          mN && (mN = !1, lw(a)), l.effectDuration += Ap(R);
          break;
        case 4:
          x = Su, Su = yb(
            a.stateNode.containerInfo
          ), _a(l, a), eo(a), Su = x;
          break;
        case 12:
          x = Ya(), _a(l, a), eo(a), a.stateNode.effectDuration += Dp(x);
          break;
        case 13:
          _a(l, a), eo(a), a.child.flags & 8192 && a.memoizedState !== null != (h !== null && h.memoizedState !== null) && (wN = So()), x & 4 && (x = a.updateQueue, x !== null && (a.updateQueue = null, Jp(a, x)));
          break;
        case 22:
          R = a.memoizedState !== null;
          var G = h !== null && h.memoizedState !== null, ue = Ff, fe = $i;
          if (Ff = ue || R, $i = fe || G, _a(l, a), $i = fe, Ff = ue, eo(a), x & 8192)
            e: for (l = a.stateNode, l._visibility = R ? l._visibility & ~UC : l._visibility | UC, R && (h === null || G || Ff || $i || Ca(a)), h = null, l = a; ; ) {
              if (l.tag === 5 || l.tag === 26) {
                if (h === null) {
                  G = h = l;
                  try {
                    A = G.stateNode, R ? _t(G, jw, A) : _t(
                      G,
                      hb,
                      G.stateNode,
                      G.memoizedProps
                    );
                  } catch (Xe) {
                    wr(G, G.return, Xe);
                  }
                }
              } else if (l.tag === 6) {
                if (h === null) {
                  G = l;
                  try {
                    B = G.stateNode, R ? _t(G, Lw, B) : _t(
                      G,
                      gb,
                      B,
                      G.memoizedProps
                    );
                  } catch (Xe) {
                    wr(G, G.return, Xe);
                  }
                }
              } else if ((l.tag !== 22 && l.tag !== 23 || l.memoizedState === null || l === a) && l.child !== null) {
                l.child.return = l, l = l.child;
                continue;
              }
              if (l === a) break e;
              for (; l.sibling === null; ) {
                if (l.return === null || l.return === a)
                  break e;
                h === l && (h = null), l = l.return;
              }
              h === l && (h = null), l.sibling.return = l.return, l = l.sibling;
            }
          x & 4 && (x = a.updateQueue, x !== null && (h = x.retryQueue, h !== null && (x.retryQueue = null, Jp(a, h))));
          break;
        case 19:
          _a(l, a), eo(a), x & 4 && (x = a.updateQueue, x !== null && (a.updateQueue = null, Jp(a, x)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          _a(l, a), eo(a);
      }
    }
    function eo(a) {
      var l = a.flags;
      if (l & 2) {
        try {
          _t(a, nC, a);
        } catch (h) {
          wr(a, a.return, h);
        }
        a.flags &= -3;
      }
      l & 4096 && (a.flags &= -4097);
    }
    function lw(a) {
      if (a.subtreeFlags & 1024)
        for (a = a.child; a !== null; ) {
          var l = a;
          lw(l), l.tag === 5 && l.flags & 1024 && l.stateNode.reset(), a = a.sibling;
        }
    }
    function Ni(a, l) {
      if (l.subtreeFlags & 8772)
        for (l = l.child; l !== null; )
          aw(a, l.alternate, l), l = l.sibling;
    }
    function sl(a) {
      switch (a.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          dm(
            a,
            a.return,
            na
          ), Ca(a);
          break;
        case 1:
          al(a, a.return);
          var l = a.stateNode;
          typeof l.componentWillUnmount == "function" && iw(
            a,
            a.return,
            l
          ), Ca(a);
          break;
        case 27:
          _t(
            a,
            dh,
            a.stateNode
          );
        case 26:
        case 5:
          al(a, a.return), Ca(a);
          break;
        case 22:
          a.memoizedState === null && Ca(a);
          break;
        case 30:
          Ca(a);
          break;
        default:
          Ca(a);
      }
    }
    function Ca(a) {
      for (a = a.child; a !== null; )
        sl(a), a = a.sibling;
    }
    function cw(a, l, h, x) {
      var R = h.flags;
      switch (h.tag) {
        case 0:
        case 11:
        case 15:
          Lo(
            a,
            h,
            x
          ), tw(h, na);
          break;
        case 1:
          if (Lo(
            a,
            h,
            x
          ), l = h.stateNode, typeof l.componentDidMount == "function" && _t(
            h,
            cN,
            h,
            l
          ), l = h.updateQueue, l !== null) {
            a = h.stateNode;
            try {
              _t(
                h,
                IP,
                l,
                a
              );
            } catch (A) {
              wr(h, h.return, A);
            }
          }
          x && R & 64 && nw(h), Tf(h, h.return);
          break;
        case 27:
          hm(h);
        case 26:
        case 5:
          Lo(
            a,
            h,
            x
          ), x && l === null && R & 4 && tC(h), Tf(h, h.return);
          break;
        case 12:
          if (x && R & 4) {
            R = Ya(), Lo(
              a,
              h,
              x
            ), x = h.stateNode, x.effectDuration += Dp(R);
            try {
              _t(
                h,
                ow,
                h,
                l,
                qC,
                x.effectDuration
              );
            } catch (A) {
              wr(h, h.return, A);
            }
          } else
            Lo(
              a,
              h,
              x
            );
          break;
        case 13:
          Lo(
            a,
            h,
            x
          ), x && R & 4 && gm(a, h);
          break;
        case 22:
          h.memoizedState === null && Lo(
            a,
            h,
            x
          ), Tf(h, h.return);
          break;
        case 30:
          break;
        default:
          Lo(
            a,
            h,
            x
          );
      }
    }
    function Lo(a, l, h) {
      for (h = h && (l.subtreeFlags & 8772) !== 0, l = l.child; l !== null; )
        cw(
          a,
          l.alternate,
          l,
          h
        ), l = l.sibling;
    }
    function ll(a, l) {
      var h = null;
      a !== null && a.memoizedState !== null && a.memoizedState.cachePool !== null && (h = a.memoizedState.cachePool.pool), a = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (a = l.memoizedState.cachePool.pool), a !== h && (a != null && Ts(a), h != null && ff(h));
    }
    function _i(a, l) {
      a = null, l.alternate !== null && (a = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== a && (Ts(l), a != null && ff(a));
    }
    function Ka(a, l, h, x) {
      if (l.subtreeFlags & 10256)
        for (l = l.child; l !== null; )
          nb(
            a,
            l,
            h,
            x
          ), l = l.sibling;
    }
    function nb(a, l, h, x) {
      var R = l.flags;
      switch (l.tag) {
        case 0:
        case 11:
        case 15:
          Ka(
            a,
            l,
            h,
            x
          ), R & 2048 && Jy(l, _o | cc);
          break;
        case 1:
          Ka(
            a,
            l,
            h,
            x
          );
          break;
        case 3:
          var A = Ya();
          Ka(
            a,
            l,
            h,
            x
          ), R & 2048 && (h = null, l.alternate !== null && (h = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== h && (Ts(l), h != null && ff(h))), a.passiveEffectDuration += Ap(A);
          break;
        case 12:
          if (R & 2048) {
            R = Ya(), Ka(
              a,
              l,
              h,
              x
            ), a = l.stateNode, a.passiveEffectDuration += Dp(R);
            try {
              _t(
                l,
                NP,
                l,
                l.alternate,
                qC,
                a.passiveEffectDuration
              );
            } catch (G) {
              wr(l, l.return, G);
            }
          } else
            Ka(
              a,
              l,
              h,
              x
            );
          break;
        case 13:
          Ka(
            a,
            l,
            h,
            x
          );
          break;
        case 23:
          break;
        case 22:
          A = l.stateNode;
          var B = l.alternate;
          l.memoizedState !== null ? A._visibility & Lf ? Ka(
            a,
            l,
            h,
            x
          ) : eh(
            a,
            l
          ) : A._visibility & Lf ? Ka(
            a,
            l,
            h,
            x
          ) : (A._visibility |= Lf, rd(
            a,
            l,
            h,
            x,
            (l.subtreeFlags & 10256) !== 0
          )), R & 2048 && ll(B, l);
          break;
        case 24:
          Ka(
            a,
            l,
            h,
            x
          ), R & 2048 && _i(l.alternate, l);
          break;
        default:
          Ka(
            a,
            l,
            h,
            x
          );
      }
    }
    function rd(a, l, h, x, R) {
      for (R = R && (l.subtreeFlags & 10256) !== 0, l = l.child; l !== null; )
        uw(
          a,
          l,
          h,
          x,
          R
        ), l = l.sibling;
    }
    function uw(a, l, h, x, R) {
      var A = l.flags;
      switch (l.tag) {
        case 0:
        case 11:
        case 15:
          rd(
            a,
            l,
            h,
            x,
            R
          ), Jy(l, _o);
          break;
        case 23:
          break;
        case 22:
          var B = l.stateNode;
          l.memoizedState !== null ? B._visibility & Lf ? rd(
            a,
            l,
            h,
            x,
            R
          ) : eh(
            a,
            l
          ) : (B._visibility |= Lf, rd(
            a,
            l,
            h,
            x,
            R
          )), R && A & 2048 && ll(
            l.alternate,
            l
          );
          break;
        case 24:
          rd(
            a,
            l,
            h,
            x,
            R
          ), R && A & 2048 && _i(l.alternate, l);
          break;
        default:
          rd(
            a,
            l,
            h,
            x,
            R
          );
      }
    }
    function eh(a, l) {
      if (l.subtreeFlags & 10256)
        for (l = l.child; l !== null; ) {
          var h = a, x = l, R = x.flags;
          switch (x.tag) {
            case 22:
              eh(
                h,
                x
              ), R & 2048 && ll(
                x.alternate,
                x
              );
              break;
            case 24:
              eh(
                h,
                x
              ), R & 2048 && _i(
                x.alternate,
                x
              );
              break;
            default:
              eh(
                h,
                x
              );
          }
          l = l.sibling;
        }
    }
    function Os(a) {
      if (a.subtreeFlags & DT)
        for (a = a.child; a !== null; )
          vm(a), a = a.sibling;
    }
    function vm(a) {
      switch (a.tag) {
        case 26:
          Os(a), a.flags & DT && a.memoizedState !== null && SC(
            Su,
            a.memoizedState,
            a.memoizedProps
          );
          break;
        case 5:
          Os(a);
          break;
        case 3:
        case 4:
          var l = Su;
          Su = yb(
            a.stateNode.containerInfo
          ), Os(a), Su = l;
          break;
        case 22:
          a.memoizedState === null && (l = a.alternate, l !== null && l.memoizedState !== null ? (l = DT, DT = 16777216, Os(a), DT = l) : Os(a));
          break;
        default:
          Os(a);
      }
    }
    function dw(a) {
      var l = a.alternate;
      if (l !== null && (a = l.child, a !== null)) {
        l.child = null;
        do
          l = a.sibling, a.sibling = null, a = l;
        while (a !== null);
      }
    }
    function th(a) {
      var l = a.deletions;
      if ((a.flags & 16) !== 0) {
        if (l !== null)
          for (var h = 0; h < l.length; h++) {
            var x = l[h];
            Vo = x, rb(
              x,
              a
            );
          }
        dw(a);
      }
      if (a.subtreeFlags & 10256)
        for (a = a.child; a !== null; )
          fw(a), a = a.sibling;
    }
    function fw(a) {
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          th(a), a.flags & 2048 && eb(
            a,
            a.return,
            _o | cc
          );
          break;
        case 3:
          var l = Ya();
          th(a), a.stateNode.passiveEffectDuration += Ap(l);
          break;
        case 12:
          l = Ya(), th(a), a.stateNode.passiveEffectDuration += Dp(l);
          break;
        case 22:
          l = a.stateNode, a.memoizedState !== null && l._visibility & Lf && (a.return === null || a.return.tag !== 13) ? (l._visibility &= ~Lf, Ef(a)) : th(a);
          break;
        default:
          th(a);
      }
    }
    function Ef(a) {
      var l = a.deletions;
      if ((a.flags & 16) !== 0) {
        if (l !== null)
          for (var h = 0; h < l.length; h++) {
            var x = l[h];
            Vo = x, rb(
              x,
              a
            );
          }
        dw(a);
      }
      for (a = a.child; a !== null; )
        pw(a), a = a.sibling;
    }
    function pw(a) {
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          eb(
            a,
            a.return,
            _o
          ), Ef(a);
          break;
        case 22:
          var l = a.stateNode;
          l._visibility & Lf && (l._visibility &= ~Lf, Ef(a));
          break;
        default:
          Ef(a);
      }
    }
    function rb(a, l) {
      for (; Vo !== null; ) {
        var h = Vo, x = h;
        switch (x.tag) {
          case 0:
          case 11:
          case 15:
            eb(
              x,
              l,
              _o
            );
            break;
          case 23:
          case 22:
            x.memoizedState !== null && x.memoizedState.cachePool !== null && (x = x.memoizedState.cachePool.pool, x != null && Ts(x));
            break;
          case 24:
            ff(x.memoizedState.cache);
        }
        if (x = h.child, x !== null) x.return = h, Vo = x;
        else
          e: for (h = a; Vo !== null; ) {
            x = Vo;
            var R = x.sibling, A = x.return;
            if (iC(x), x === h) {
              Vo = null;
              break e;
            }
            if (R !== null) {
              R.return = A, Vo = R;
              break e;
            }
            Vo = A;
          }
      }
    }
    function oC() {
      Mpe.forEach(function(a) {
        return a();
      });
    }
    function hw() {
      var a = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return a || Ge.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), a;
    }
    function Qa(a) {
      if ((mr & ss) !== yl && Fn !== 0)
        return Fn & -Fn;
      var l = Ge.T;
      return l !== null ? (l._updatedFibers || (l._updatedFibers = /* @__PURE__ */ new Set()), l._updatedFibers.add(a), a = Gm, a !== 0 ? a : fb()) : ce();
    }
    function gw() {
      xl === 0 && (xl = (Fn & 536870912) === 0 || ar ? We() : 536870912);
      var a = dc.current;
      return a !== null && (a.flags |= 32), xl;
    }
    function Mn(a, l, h) {
      if (y0 && console.error("useInsertionEffect must not schedule updates."), RN && (oR = !0), (a === Xr && (Cr === Qm || Cr === Jm) || a.cancelPendingCommit !== null) && (nu(a, 0), tu(
        a,
        Fn,
        xl,
        !1
      )), mt(a, h), (mr & ss) !== 0 && a === Xr) {
        if (Jl)
          switch (l.tag) {
            case 0:
            case 11:
            case 15:
              a = Vn && z(Vn) || "Unknown", b4.has(a) || (b4.add(a), l = z(l) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                l,
                a,
                a
              ));
              break;
            case 1:
              y4 || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), y4 = !0);
          }
      } else
        Ps && q(a, l, h), Cw(l), a === Xr && ((mr & ss) === yl && (Ih |= h), Li === Km && tu(
          a,
          Fn,
          xl,
          !1
        )), As(a);
    }
    function to(a, l, h) {
      if ((mr & (ss | wu)) !== yl)
        throw Error("Should not already be working.");
      var x = !h && (l & 124) === 0 && (l & a.expiredLanes) === 0 || ge(a, l), R = x ? bw(a, l) : ym(a, l, !0), A = x;
      do {
        if (R === Wf) {
          m0 && !x && tu(a, l, 0, !1);
          break;
        } else {
          if (h = a.current.alternate, A && !aC(h)) {
            R = ym(a, l, !1), A = !1;
            continue;
          }
          if (R === h0) {
            if (A = l, a.errorRecoveryDisabledLanes & A)
              var B = 0;
            else
              B = a.pendingLanes & -536870913, B = B !== 0 ? B : B & 536870912 ? 536870912 : 0;
            if (B !== 0) {
              l = B;
              e: {
                R = a;
                var G = B;
                B = LT;
                var ue = R.current.memoizedState.isDehydrated;
                if (ue && (nu(
                  R,
                  G
                ).flags |= 256), G = ym(
                  R,
                  G,
                  !1
                ), G !== h0) {
                  if (xN && !ue) {
                    R.errorRecoveryDisabledLanes |= A, Ih |= A, R = Km;
                    break e;
                  }
                  R = ls, ls = B, R !== null && (ls === null ? ls = R : ls.push.apply(
                    ls,
                    R
                  ));
                }
                R = G;
              }
              if (A = !1, R !== h0) continue;
            }
          }
          if (R === PT) {
            nu(a, 0), tu(a, l, 0, !0);
            break;
          }
          e: {
            switch (x = a, R) {
              case Wf:
              case PT:
                throw Error("Root did not complete. This is a bug in React.");
              case Km:
                if ((l & 4194048) !== l) break;
              case nR:
                tu(
                  x,
                  l,
                  xl,
                  !Ah
                );
                break e;
              case h0:
                ls = null;
                break;
              case vN:
              case u4:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (Ge.actQueue !== null)
              cl(
                x,
                h,
                l,
                ls,
                kT,
                rR,
                xl,
                Ih,
                ev
              );
            else {
              if ((l & 62914560) === l && (A = wN + f4 - So(), 10 < A)) {
                if (tu(
                  x,
                  l,
                  xl,
                  !Ah
                ), te(x, 0, !0) !== 0) break e;
                x.timeoutHandle = R4(
                  mw.bind(
                    null,
                    x,
                    h,
                    ls,
                    kT,
                    rR,
                    l,
                    xl,
                    Ih,
                    ev,
                    Ah,
                    R,
                    zpe,
                    h5,
                    0
                  ),
                  A
                );
                break e;
              }
              mw(
                x,
                h,
                ls,
                kT,
                rR,
                l,
                xl,
                Ih,
                ev,
                Ah,
                R,
                Lpe,
                h5,
                0
              );
            }
          }
        }
        break;
      } while (!0);
      As(a);
    }
    function mw(a, l, h, x, R, A, B, G, ue, fe, Xe, nt, $e, st) {
      if (a.timeoutHandle = ov, nt = l.subtreeFlags, (nt & 8192 || (nt & 16785408) === 16785408) && (WT = { stylesheets: null, count: 0, unsuspend: xC }, vm(l), nt = wC(), nt !== null)) {
        a.cancelPendingCommit = nt(
          cl.bind(
            null,
            a,
            l,
            A,
            h,
            x,
            R,
            B,
            G,
            ue,
            Xe,
            kpe,
            $e,
            st
          )
        ), tu(
          a,
          A,
          B,
          !fe
        );
        return;
      }
      cl(
        a,
        l,
        A,
        h,
        x,
        R,
        B,
        G,
        ue
      );
    }
    function aC(a) {
      for (var l = a; ; ) {
        var h = l.tag;
        if ((h === 0 || h === 11 || h === 15) && l.flags & 16384 && (h = l.updateQueue, h !== null && (h = h.stores, h !== null)))
          for (var x = 0; x < h.length; x++) {
            var R = h[x], A = R.getSnapshot;
            R = R.value;
            try {
              if (!is(A(), R)) return !1;
            } catch {
              return !1;
            }
          }
        if (h = l.child, l.subtreeFlags & 16384 && h !== null)
          h.return = l, l = h;
        else {
          if (l === a) break;
          for (; l.sibling === null; ) {
            if (l.return === null || l.return === a) return !0;
            l = l.return;
          }
          l.sibling.return = l.return, l = l.sibling;
        }
      }
      return !0;
    }
    function tu(a, l, h, x) {
      l &= ~SN, l &= ~Ih, a.suspendedLanes |= l, a.pingedLanes &= ~l, x && (a.warmLanes |= l), x = a.expirationTimes;
      for (var R = l; 0 < R; ) {
        var A = 31 - ro(R), B = 1 << A;
        x[A] = -1, R &= ~B;
      }
      h !== 0 && at(a, h, l);
    }
    function _f() {
      return (mr & (ss | wu)) === yl ? (ad(0), !1) : !0;
    }
    function ib() {
      if (Vn !== null) {
        if (Cr === js)
          var a = Vn.return;
        else
          a = Vn, Cy(), tl(a), s0 = null, OT = 0, a = Vn;
        for (; a !== null; )
          ew(a.alternate, a), a = a.return;
        Vn = null;
      }
    }
    function nu(a, l) {
      var h = a.timeoutHandle;
      h !== ov && (a.timeoutHandle = ov, Kpe(h)), h = a.cancelPendingCommit, h !== null && (a.cancelPendingCommit = null, h()), ib(), Xr = a, Vn = h = Fl(a.current, null), Fn = l, Cr = js, bl = null, Ah = !1, m0 = ge(a, l), xN = !1, Li = Wf, ev = xl = SN = Ih = Dh = 0, ls = LT = null, rR = !1, (l & 8) !== 0 && (l |= l & 32);
      var x = a.entangledLanes;
      if (x !== 0)
        for (a = a.entanglements, x &= l; 0 < x; ) {
          var R = 31 - ro(x), A = 1 << R;
          l |= a[R], x &= ~A;
        }
      return Cd = l, yy(), l = f5(), 1e3 < l - d5 && (Ge.recentlyCreatedOwnerStacks = 0, d5 = l), bu.discardPendingWarnings(), h;
    }
    function ob(a, l) {
      hn = null, Ge.H = eR, Ge.getCurrentStack = null, Jl = !1, To = null, l === ET || l === XC ? (l = Xa(), Cr = MT) : l === v5 ? (l = Xa(), Cr = d4) : Cr = l === t4 ? bN : l !== null && typeof l == "object" && typeof l.then == "function" ? g0 : NT, bl = l;
      var h = Vn;
      if (h === null)
        Li = PT, Yp(
          a,
          ga(l, a.current)
        );
      else
        switch (h.mode & ta && Gu(h), Ye(), Cr) {
          case NT:
            Pt !== null && typeof Pt.markComponentErrored == "function" && Pt.markComponentErrored(
              h,
              l,
              Fn
            );
            break;
          case Qm:
          case Jm:
          case MT:
          case g0:
          case jT:
            Pt !== null && typeof Pt.markComponentSuspended == "function" && Pt.markComponentSuspended(
              h,
              l,
              Fn
            );
        }
    }
    function vw() {
      var a = Ge.H;
      return Ge.H = eR, a === null ? eR : a;
    }
    function yw() {
      var a = Ge.A;
      return Ge.A = Npe, a;
    }
    function ab() {
      Li = Km, Ah || (Fn & 4194048) !== Fn && dc.current !== null || (m0 = !0), (Dh & 134217727) === 0 && (Ih & 134217727) === 0 || Xr === null || tu(
        Xr,
        Fn,
        xl,
        !1
      );
    }
    function ym(a, l, h) {
      var x = mr;
      mr |= ss;
      var R = vw(), A = yw();
      if (Xr !== a || Fn !== l) {
        if (Ps) {
          var B = a.memoizedUpdaters;
          0 < B.size && (Rf(a, Fn), B.clear()), W(a, l);
        }
        kT = null, nu(a, l);
      }
      Ue(l), l = !1, B = Li;
      e: do
        try {
          if (Cr !== js && Vn !== null) {
            var G = Vn, ue = bl;
            switch (Cr) {
              case bN:
                ib(), B = nR;
                break e;
              case MT:
              case Qm:
              case Jm:
              case g0:
                dc.current === null && (l = !0);
                var fe = Cr;
                if (Cr = js, bl = null, Cf(a, G, ue, fe), h && m0) {
                  B = Wf;
                  break e;
                }
                break;
              default:
                fe = Cr, Cr = js, bl = null, Cf(a, G, ue, fe);
            }
          }
          sb(), B = Li;
          break;
        } catch (Xe) {
          ob(a, Xe);
        }
      while (!0);
      return l && a.shellSuspendCounter++, Cy(), mr = x, Ge.H = R, Ge.A = A, ve(), Vn === null && (Xr = null, Fn = 0, yy()), B;
    }
    function sb() {
      for (; Vn !== null; ) lb(Vn);
    }
    function bw(a, l) {
      var h = mr;
      mr |= ss;
      var x = vw(), R = yw();
      if (Xr !== a || Fn !== l) {
        if (Ps) {
          var A = a.memoizedUpdaters;
          0 < A.size && (Rf(a, Fn), A.clear()), W(a, l);
        }
        kT = null, iR = So() + p4, nu(a, l);
      } else
        m0 = ge(
          a,
          l
        );
      Ue(l);
      e: do
        try {
          if (Cr !== js && Vn !== null)
            t: switch (l = Vn, A = bl, Cr) {
              case NT:
                Cr = js, bl = null, Cf(
                  a,
                  l,
                  A,
                  NT
                );
                break;
              case Qm:
              case Jm:
                if (Dy(A)) {
                  Cr = js, bl = null, bm(l);
                  break;
                }
                l = function() {
                  Cr !== Qm && Cr !== Jm || Xr !== a || (Cr = jT), As(a);
                }, A.then(l, l);
                break e;
              case MT:
                Cr = jT;
                break e;
              case d4:
                Cr = yN;
                break e;
              case jT:
                Dy(A) ? (Cr = js, bl = null, bm(l)) : (Cr = js, bl = null, Cf(
                  a,
                  l,
                  A,
                  jT
                ));
                break;
              case yN:
                var B = null;
                switch (Vn.tag) {
                  case 26:
                    B = Vn.memoizedState;
                  case 5:
                  case 27:
                    var G = Vn;
                    if (!B || Uw(B)) {
                      Cr = js, bl = null;
                      var ue = G.sibling;
                      if (ue !== null) Vn = ue;
                      else {
                        var fe = G.return;
                        fe !== null ? (Vn = fe, nh(fe)) : Vn = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                Cr = js, bl = null, Cf(
                  a,
                  l,
                  A,
                  yN
                );
                break;
              case g0:
                Cr = js, bl = null, Cf(
                  a,
                  l,
                  A,
                  g0
                );
                break;
              case bN:
                ib(), Li = nR;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          Ge.actQueue !== null ? sb() : sC();
          break;
        } catch (Xe) {
          ob(a, Xe);
        }
      while (!0);
      return Cy(), Ge.H = x, Ge.A = R, mr = h, Vn !== null ? (Pt !== null && typeof Pt.markRenderYielded == "function" && Pt.markRenderYielded(), Wf) : (ve(), Xr = null, Fn = 0, yy(), Li);
    }
    function sC() {
      for (; Vn !== null && !BP(); )
        lb(Vn);
    }
    function lb(a) {
      var l = a.alternate;
      (a.mode & ta) !== ri ? (qc(a), l = _t(
        a,
        nd,
        l,
        a,
        Cd
      ), Gu(a)) : l = _t(
        a,
        nd,
        l,
        a,
        Cd
      ), a.memoizedProps = a.pendingProps, l === null ? nh(a) : Vn = l;
    }
    function bm(a) {
      var l = _t(a, xw, a);
      a.memoizedProps = a.pendingProps, l === null ? nh(a) : Vn = l;
    }
    function xw(a) {
      var l = a.alternate, h = (a.mode & ta) !== ri;
      switch (h && qc(a), a.tag) {
        case 15:
        case 0:
          l = HS(
            l,
            a,
            a.pendingProps,
            a.type,
            void 0,
            Fn
          );
          break;
        case 11:
          l = HS(
            l,
            a,
            a.pendingProps,
            a.type.render,
            a.ref,
            Fn
          );
          break;
        case 5:
          tl(a);
        default:
          ew(l, a), a = Vn = bS(a, Cd), l = nd(l, a, Cd);
      }
      return h && Gu(a), l;
    }
    function Cf(a, l, h, x) {
      Cy(), tl(l), s0 = null, OT = 0;
      var R = l.return;
      try {
        if ($y(
          a,
          R,
          l,
          h,
          Fn
        )) {
          Li = PT, Yp(
            a,
            ga(h, a.current)
          ), Vn = null;
          return;
        }
      } catch (A) {
        if (R !== null) throw Vn = R, A;
        Li = PT, Yp(
          a,
          ga(h, a.current)
        ), Vn = null;
        return;
      }
      l.flags & 32768 ? (ar || x === NT ? a = !0 : m0 || (Fn & 536870912) !== 0 ? a = !1 : (Ah = a = !0, (x === Qm || x === Jm || x === MT || x === g0) && (x = dc.current, x !== null && x.tag === 13 && (x.flags |= 16384))), Sw(l, a)) : nh(l);
    }
    function nh(a) {
      var l = a;
      do {
        if ((l.flags & 32768) !== 0) {
          Sw(
            l,
            Ah
          );
          return;
        }
        var h = l.alternate;
        if (a = l.return, qc(l), h = _t(
          l,
          Q_,
          h,
          l,
          Cd
        ), (l.mode & ta) !== ri && Oy(l), h !== null) {
          Vn = h;
          return;
        }
        if (l = l.sibling, l !== null) {
          Vn = l;
          return;
        }
        Vn = l = a;
      } while (l !== null);
      Li === Wf && (Li = u4);
    }
    function Sw(a, l) {
      do {
        var h = J_(a.alternate, a);
        if (h !== null) {
          h.flags &= 32767, Vn = h;
          return;
        }
        if ((a.mode & ta) !== ri) {
          Oy(a), h = a.actualDuration;
          for (var x = a.child; x !== null; )
            h += x.actualDuration, x = x.sibling;
          a.actualDuration = h;
        }
        if (h = a.return, h !== null && (h.flags |= 32768, h.subtreeFlags = 0, h.deletions = null), !l && (a = a.sibling, a !== null)) {
          Vn = a;
          return;
        }
        Vn = a = h;
      } while (a !== null);
      Li = nR, Vn = null;
    }
    function cl(a, l, h, x, R, A, B, G, ue) {
      a.cancelPendingCommit = null;
      do
        id();
      while (ra !== tv);
      if (bu.flushLegacyContextWarning(), bu.flushPendingUnsafeLifecycleWarnings(), (mr & (ss | wu)) !== yl)
        throw Error("Should not already be working.");
      if (Pt !== null && typeof Pt.markCommitStarted == "function" && Pt.markCommitStarted(h), l === null) Pe();
      else {
        if (h === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), l === a.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (A = l.lanes | l.childLanes, A |= ZP, qe(
          a,
          h,
          A,
          B,
          G,
          ue
        ), a === Xr && (Vn = Xr = null, Fn = 0), v0 = l, Nh = a, Mh = h, EN = A, _N = R, v4 = x, (l.subtreeFlags & 10256) !== 0 || (l.flags & 10256) !== 0 ? (a.callbackNode = null, a.callbackPriority = 0, dC(yh, function() {
          return rh(), null;
        })) : (a.callbackNode = null, a.callbackPriority = 0), qC = n0(), x = (l.flags & 13878) !== 0, (l.subtreeFlags & 13878) !== 0 || x) {
          x = Ge.T, Ge.T = null, R = lr.p, lr.p = rs, B = mr, mr |= wu;
          try {
            rC(a, l, h);
          } finally {
            mr = B, lr.p = R, Ge.T = x;
          }
        }
        ra = h4, cb(), lC(), ww();
      }
    }
    function cb() {
      if (ra === h4) {
        ra = tv;
        var a = Nh, l = v0, h = Mh, x = (l.flags & 13878) !== 0;
        if ((l.subtreeFlags & 13878) !== 0 || x) {
          x = Ge.T, Ge.T = null;
          var R = lr.p;
          lr.p = rs;
          var A = mr;
          mr |= wu;
          try {
            f0 = h, p0 = a, sw(l, a), p0 = f0 = null, h = LN;
            var B = H_(a.containerInfo), G = h.focusedElem, ue = h.selectionRange;
            if (B !== G && G && G.ownerDocument && W_(
              G.ownerDocument.documentElement,
              G
            )) {
              if (ue !== null && mS(G)) {
                var fe = ue.start, Xe = ue.end;
                if (Xe === void 0 && (Xe = fe), "selectionStart" in G)
                  G.selectionStart = fe, G.selectionEnd = Math.min(
                    Xe,
                    G.value.length
                  );
                else {
                  var nt = G.ownerDocument || document, $e = nt && nt.defaultView || window;
                  if ($e.getSelection) {
                    var st = $e.getSelection(), Ht = G.textContent.length, un = Math.min(
                      ue.start,
                      Ht
                    ), Zr = ue.end === void 0 ? un : Math.min(ue.end, Ht);
                    !st.extend && un > Zr && (B = Zr, Zr = un, un = B);
                    var qn = F_(
                      G,
                      un
                    ), Se = F_(
                      G,
                      Zr
                    );
                    if (qn && Se && (st.rangeCount !== 1 || st.anchorNode !== qn.node || st.anchorOffset !== qn.offset || st.focusNode !== Se.node || st.focusOffset !== Se.offset)) {
                      var we = nt.createRange();
                      we.setStart(qn.node, qn.offset), st.removeAllRanges(), un > Zr ? (st.addRange(we), st.extend(Se.node, Se.offset)) : (we.setEnd(Se.node, Se.offset), st.addRange(we));
                    }
                  }
                }
              }
              for (nt = [], st = G; st = st.parentNode; )
                st.nodeType === 1 && nt.push({
                  element: st,
                  left: st.scrollLeft,
                  top: st.scrollTop
                });
              for (typeof G.focus == "function" && G.focus(), G = 0; G < nt.length; G++) {
                var Re = nt[G];
                Re.element.scrollLeft = Re.left, Re.element.scrollTop = Re.top;
              }
            }
            xR = !!jN, LN = jN = null;
          } finally {
            mr = A, lr.p = R, Ge.T = x;
          }
        }
        a.current = l, ra = g4;
      }
    }
    function lC() {
      if (ra === g4) {
        ra = tv;
        var a = Nh, l = v0, h = Mh, x = (l.flags & 8772) !== 0;
        if ((l.subtreeFlags & 8772) !== 0 || x) {
          x = Ge.T, Ge.T = null;
          var R = lr.p;
          lr.p = rs;
          var A = mr;
          mr |= wu;
          try {
            Pt !== null && typeof Pt.markLayoutEffectsStarted == "function" && Pt.markLayoutEffectsStarted(h), f0 = h, p0 = a, aw(
              a,
              l.alternate,
              l
            ), p0 = f0 = null, Pt !== null && typeof Pt.markLayoutEffectsStopped == "function" && Pt.markLayoutEffectsStopped();
          } finally {
            mr = A, lr.p = R, Ge.T = x;
          }
        }
        ra = m4;
      }
    }
    function ww() {
      if (ra === Bpe || ra === m4) {
        ra = tv, VP();
        var a = Nh, l = v0, h = Mh, x = v4, R = (l.subtreeFlags & 10256) !== 0 || (l.flags & 10256) !== 0;
        R ? ra = TN : (ra = tv, v0 = Nh = null, Tw(a, a.pendingLanes), nv = 0, BT = null);
        var A = a.pendingLanes;
        if (A === 0 && (Ph = null), R || ul(a), R = Q(h), l = l.stateNode, wo && typeof wo.onCommitFiberRoot == "function")
          try {
            var B = (l.current.flags & 128) === 128;
            switch (R) {
              case rs:
                var G = Nm;
                break;
              case Ql:
                G = Yw;
                break;
              case gu:
                G = yh;
                break;
              case Lb:
                G = Zw;
                break;
              default:
                G = yh;
            }
            wo.onCommitFiberRoot(
              Mf,
              l,
              G,
              B
            );
          } catch (nt) {
            Ci || (Ci = !0, console.error(
              "React instrumentation encountered an error: %s",
              nt
            ));
          }
        if (Ps && a.memoizedUpdaters.clear(), oC(), x !== null) {
          B = Ge.T, G = lr.p, lr.p = rs, Ge.T = null;
          try {
            var ue = a.onRecoverableError;
            for (l = 0; l < x.length; l++) {
              var fe = x[l], Xe = ru(fe.stack);
              _t(
                fe.source,
                ue,
                fe.value,
                Xe
              );
            }
          } finally {
            Ge.T = B, lr.p = G;
          }
        }
        (Mh & 3) !== 0 && id(), As(a), A = a.pendingLanes, (h & 4194090) !== 0 && (A & 42) !== 0 ? (GC = !0, a === CN ? zT++ : (zT = 0, CN = a)) : zT = 0, ad(0), Pe();
      }
    }
    function ru(a) {
      return a = { componentStack: a }, Object.defineProperty(a, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), a;
    }
    function Tw(a, l) {
      (a.pooledCacheLanes &= l) === 0 && (l = a.pooledCache, l != null && (a.pooledCache = null, ff(l)));
    }
    function id(a) {
      return cb(), lC(), ww(), rh();
    }
    function rh() {
      if (ra !== TN) return !1;
      var a = Nh, l = EN;
      EN = 0;
      var h = Q(Mh), x = gu > h ? gu : h;
      h = Ge.T;
      var R = lr.p;
      try {
        lr.p = x, Ge.T = null, x = _N, _N = null;
        var A = Nh, B = Mh;
        if (ra = tv, v0 = Nh = null, Mh = 0, (mr & (ss | wu)) !== yl)
          throw Error("Cannot flush passive effects while already rendering.");
        RN = !0, oR = !1, Pt !== null && typeof Pt.markPassiveEffectsStarted == "function" && Pt.markPassiveEffectsStarted(B);
        var G = mr;
        if (mr |= wu, fw(A.current), nb(
          A,
          A.current,
          B,
          x
        ), Pt !== null && typeof Pt.markPassiveEffectsStopped == "function" && Pt.markPassiveEffectsStopped(), ul(A), mr = G, ad(0, !1), oR ? A === BT ? nv++ : (nv = 0, BT = A) : nv = 0, oR = RN = !1, wo && typeof wo.onPostCommitFiberRoot == "function")
          try {
            wo.onPostCommitFiberRoot(Mf, A);
          } catch (fe) {
            Ci || (Ci = !0, console.error(
              "React instrumentation encountered an error: %s",
              fe
            ));
          }
        var ue = A.current.stateNode;
        return ue.effectDuration = 0, ue.passiveEffectDuration = 0, !0;
      } finally {
        lr.p = R, Ge.T = h, Tw(a, l);
      }
    }
    function ni(a, l, h) {
      l = ga(h, l), l = yi(a.stateNode, l, 2), a = Qs(a, l, 2), a !== null && (mt(a, 2), As(a));
    }
    function wr(a, l, h) {
      if (y0 = !1, a.tag === 3)
        ni(a, a, h);
      else {
        for (; l !== null; ) {
          if (l.tag === 3) {
            ni(
              l,
              a,
              h
            );
            return;
          }
          if (l.tag === 1) {
            var x = l.stateNode;
            if (typeof l.type.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && (Ph === null || !Ph.has(x))) {
              a = ga(h, a), h = om(2), x = Qs(l, h, 2), x !== null && (xf(
                h,
                x,
                l,
                a
              ), mt(x, 2), As(x));
              return;
            }
          }
          l = l.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          h
        );
      }
    }
    function Ew(a, l, h) {
      var x = a.pingCache;
      if (x === null) {
        x = a.pingCache = new jpe();
        var R = /* @__PURE__ */ new Set();
        x.set(l, R);
      } else
        R = x.get(l), R === void 0 && (R = /* @__PURE__ */ new Set(), x.set(l, R));
      R.has(h) || (xN = !0, R.add(h), x = cC.bind(null, a, l, h), Ps && Rf(a, h), l.then(x, x));
    }
    function cC(a, l, h) {
      var x = a.pingCache;
      x !== null && x.delete(l), a.pingedLanes |= a.suspendedLanes & h, a.warmLanes &= ~h, hw() && Ge.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), Xr === a && (Fn & h) === h && (Li === Km || Li === vN && (Fn & 62914560) === Fn && So() - wN < f4 ? (mr & ss) === yl && nu(a, 0) : SN |= h, ev === Fn && (ev = 0)), As(a);
    }
    function ih(a, l) {
      l === 0 && (l = Be()), a = ma(a, l), a !== null && (mt(a, l), As(a));
    }
    function od(a) {
      var l = a.memoizedState, h = 0;
      l !== null && (h = l.retryLane), ih(a, h);
    }
    function uC(a, l) {
      var h = 0;
      switch (a.tag) {
        case 13:
          var x = a.stateNode, R = a.memoizedState;
          R !== null && (h = R.retryLane);
          break;
        case 19:
          x = a.stateNode;
          break;
        case 22:
          x = a.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      x !== null && x.delete(l), ih(a, h);
    }
    function ub(a, l, h) {
      if ((l.subtreeFlags & 67117056) !== 0)
        for (l = l.child; l !== null; ) {
          var x = a, R = l, A = R.type === Pf;
          A = h || A, R.tag !== 22 ? R.flags & 67108864 ? A && _t(
            R,
            oh,
            x,
            R,
            (R.mode & l5) === ri
          ) : ub(
            x,
            R,
            A
          ) : R.memoizedState === null && (A && R.flags & 8192 ? _t(
            R,
            oh,
            x,
            R
          ) : R.subtreeFlags & 67108864 && _t(
            R,
            ub,
            x,
            R,
            A
          )), l = l.sibling;
        }
    }
    function oh(a, l) {
      var h = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : !0;
      Ee(!0);
      try {
        sl(l), h && pw(l), cw(a, l.alternate, l, !1), h && uw(a, l, 0, null, !1, 0);
      } finally {
        Ee(!1);
      }
    }
    function ul(a) {
      var l = !0;
      a.current.mode & (Ma | yu) || (l = !1), ub(
        a,
        a.current,
        l
      );
    }
    function _w(a) {
      if ((mr & ss) === yl) {
        var l = a.tag;
        if (l === 3 || l === 1 || l === 0 || l === 11 || l === 14 || l === 15) {
          if (l = z(a) || "ReactComponent", aR !== null) {
            if (aR.has(l)) return;
            aR.add(l);
          } else aR = /* @__PURE__ */ new Set([l]);
          _t(a, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Rf(a, l) {
      Ps && a.memoizedUpdaters.forEach(function(h) {
        q(a, h, l);
      });
    }
    function dC(a, l) {
      var h = Ge.actQueue;
      return h !== null ? (h.push(l), Fpe) : Gw(a, l);
    }
    function Cw(a) {
      hw() && Ge.actQueue === null && _t(a, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          z(a)
        );
      });
    }
    function As(a) {
      a !== b0 && a.next === null && (b0 === null ? sR = b0 = a : b0 = b0.next = a), lR = !0, Ge.actQueue !== null ? AN || (AN = !0, pC()) : ON || (ON = !0, pC());
    }
    function ad(a, l) {
      if (!DN && lR) {
        DN = !0;
        do
          for (var h = !1, x = sR; x !== null; ) {
            if (a !== 0) {
              var R = x.pendingLanes;
              if (R === 0) var A = 0;
              else {
                var B = x.suspendedLanes, G = x.pingedLanes;
                A = (1 << 31 - ro(42 | a) + 1) - 1, A &= R & ~(B & ~G), A = A & 201326741 ? A & 201326741 | 1 : A ? A | 2 : 0;
              }
              A !== 0 && (h = !0, Rw(x, A));
            } else
              A = Fn, A = te(
                x,
                x === Xr ? A : 0,
                x.cancelPendingCommit !== null || x.timeoutHandle !== ov
              ), (A & 3) === 0 || ge(x, A) || (h = !0, Rw(x, A));
            x = x.next;
          }
        while (h);
        DN = !1;
      }
    }
    function fC() {
      dl();
    }
    function dl() {
      lR = AN = ON = !1;
      var a = 0;
      rv !== 0 && (Nw() && (a = rv), rv = 0);
      for (var l = So(), h = null, x = sR; x !== null; ) {
        var R = x.next, A = bi(x, l);
        A === 0 ? (x.next = null, h === null ? sR = R : h.next = R, R === null && (b0 = h)) : (h = x, (a !== 0 || (A & 3) !== 0) && (lR = !0)), x = R;
      }
      ad(a);
    }
    function bi(a, l) {
      for (var h = a.suspendedLanes, x = a.pingedLanes, R = a.expirationTimes, A = a.pendingLanes & -62914561; 0 < A; ) {
        var B = 31 - ro(A), G = 1 << B, ue = R[B];
        ue === -1 ? ((G & h) === 0 || (G & x) !== 0) && (R[B] = ke(G, l)) : ue <= l && (a.expiredLanes |= G), A &= ~G;
      }
      if (l = Xr, h = Fn, h = te(
        a,
        a === l ? h : 0,
        a.cancelPendingCommit !== null || a.timeoutHandle !== ov
      ), x = a.callbackNode, h === 0 || a === l && (Cr === Qm || Cr === Jm) || a.cancelPendingCommit !== null)
        return x !== null && Mi(x), a.callbackNode = null, a.callbackPriority = 0;
      if ((h & 3) === 0 || ge(a, h)) {
        if (l = h & -h, l !== a.callbackPriority || Ge.actQueue !== null && x !== IN)
          Mi(x);
        else return l;
        switch (Q(h)) {
          case rs:
          case Ql:
            h = Yw;
            break;
          case gu:
            h = yh;
            break;
          case Lb:
            h = Zw;
            break;
          default:
            h = yh;
        }
        return x = db.bind(null, a), Ge.actQueue !== null ? (Ge.actQueue.push(x), h = IN) : h = Gw(h, x), a.callbackPriority = l, a.callbackNode = h, l;
      }
      return x !== null && Mi(x), a.callbackPriority = 2, a.callbackNode = null, 2;
    }
    function db(a, l) {
      if (GC = $C = !1, ra !== tv && ra !== TN)
        return a.callbackNode = null, a.callbackPriority = 0, null;
      var h = a.callbackNode;
      if (id() && a.callbackNode !== h)
        return null;
      var x = Fn;
      return x = te(
        a,
        a === Xr ? x : 0,
        a.cancelPendingCommit !== null || a.timeoutHandle !== ov
      ), x === 0 ? null : (to(
        a,
        x,
        l
      ), bi(a, So()), a.callbackNode != null && a.callbackNode === h ? db.bind(null, a) : null);
    }
    function Rw(a, l) {
      if (id()) return null;
      $C = GC, GC = !1, to(a, l, !0);
    }
    function Mi(a) {
      a !== IN && a !== null && AC(a);
    }
    function pC() {
      Ge.actQueue !== null && Ge.actQueue.push(function() {
        return dl(), null;
      }), Qpe(function() {
        (mr & (ss | wu)) !== yl ? Gw(
          Nm,
          fC
        ) : dl();
      });
    }
    function fb() {
      return rv === 0 && (rv = We()), rv;
    }
    function Ow(a) {
      return a == null || typeof a == "symbol" || typeof a == "boolean" ? null : typeof a == "function" ? a : (ie(a, "action"), Fc("" + a));
    }
    function Gr(a, l) {
      var h = l.ownerDocument.createElement("input");
      return h.name = l.name, h.value = l.value, a.id && h.setAttribute("form", a.id), l.parentNode.insertBefore(h, l), a = new FormData(a), h.parentNode.removeChild(h), a;
    }
    function Ra(a, l, h, x, R) {
      if (l === "submit" && h && h.stateNode === R) {
        var A = Ow(
          (R[Na] || null).action
        ), B = x.submitter;
        B && (l = (l = B[Na] || null) ? Ow(l.formAction) : B.getAttribute("formAction"), l !== null && (A = l, B = null));
        var G = new cr(
          "action",
          "action",
          null,
          x,
          R
        );
        a.push({
          event: G,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (x.defaultPrevented) {
                  if (rv !== 0) {
                    var ue = B ? Gr(
                      R,
                      B
                    ) : new FormData(R), fe = {
                      pending: !0,
                      data: ue,
                      method: R.method,
                      action: A
                    };
                    Object.freeze(fe), By(
                      h,
                      fe,
                      null,
                      ue
                    );
                  }
                } else
                  typeof A == "function" && (G.preventDefault(), ue = B ? Gr(
                    R,
                    B
                  ) : new FormData(R), fe = {
                    pending: !0,
                    data: ue,
                    method: R.method,
                    action: A
                  }, Object.freeze(fe), By(
                    h,
                    fe,
                    A,
                    ue
                  ));
              },
              currentTarget: R
            }
          ]
        });
      }
    }
    function Ds(a, l, h) {
      a.currentTarget = h;
      try {
        l(a);
      } catch (x) {
        fN(x);
      }
      a.currentTarget = null;
    }
    function Aw(a, l) {
      l = (l & 4) !== 0;
      for (var h = 0; h < a.length; h++) {
        var x = a[h];
        e: {
          var R = void 0, A = x.event;
          if (x = x.listeners, l)
            for (var B = x.length - 1; 0 <= B; B--) {
              var G = x[B], ue = G.instance, fe = G.currentTarget;
              if (G = G.listener, ue !== R && A.isPropagationStopped())
                break e;
              ue !== null ? _t(
                ue,
                Ds,
                A,
                G,
                fe
              ) : Ds(A, G, fe), R = ue;
            }
          else
            for (B = 0; B < x.length; B++) {
              if (G = x[B], ue = G.instance, fe = G.currentTarget, G = G.listener, ue !== R && A.isPropagationStopped())
                break e;
              ue !== null ? _t(
                ue,
                Ds,
                A,
                G,
                fe
              ) : Ds(A, G, fe), R = ue;
            }
        }
      }
    }
    function jn(a, l) {
      PN.has(a) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        a
      );
      var h = l[kb];
      h === void 0 && (h = l[kb] = /* @__PURE__ */ new Set());
      var x = a + "__bubble";
      h.has(x) || (Oa(l, a, 2, !1), h.add(x));
    }
    function Dw(a, l, h) {
      PN.has(a) && !l && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        a
      );
      var x = 0;
      l && (x |= 4), Oa(
        h,
        a,
        x,
        l
      );
    }
    function xm(a) {
      if (!a[cR]) {
        a[cR] = !0, jf.forEach(function(h) {
          h !== "selectionchange" && (PN.has(h) || Dw(h, !1, a), Dw(h, !0, a));
        });
        var l = a.nodeType === 9 ? a : a.ownerDocument;
        l === null || l[cR] || (l[cR] = !0, Dw("selectionchange", !1, l));
      }
    }
    function Oa(a, l, h, x) {
      switch (gd(l)) {
        case rs:
          var R = _b;
          break;
        case Ql:
          R = hh;
          break;
        default:
          R = Cm;
      }
      h = R.bind(
        null,
        l,
        h,
        a
      ), R = void 0, !ut || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (R = !0), x ? R !== void 0 ? a.addEventListener(l, h, {
        capture: !0,
        passive: R
      }) : a.addEventListener(l, h, !0) : R !== void 0 ? a.addEventListener(l, h, {
        passive: R
      }) : a.addEventListener(
        l,
        h,
        !1
      );
    }
    function Ja(a, l, h, x, R) {
      var A = x;
      if ((l & 1) === 0 && (l & 2) === 0 && x !== null)
        e: for (; ; ) {
          if (x === null) return;
          var B = x.tag;
          if (B === 3 || B === 4) {
            var G = x.stateNode.containerInfo;
            if (G === R) break;
            if (B === 4)
              for (B = x.return; B !== null; ) {
                var ue = B.tag;
                if ((ue === 3 || ue === 4) && B.stateNode.containerInfo === R)
                  return;
                B = B.return;
              }
            for (; G !== null; ) {
              if (B = gt(G), B === null) return;
              if (ue = B.tag, ue === 5 || ue === 6 || ue === 26 || ue === 27) {
                x = A = B;
                continue e;
              }
              G = G.parentNode;
            }
          }
          x = x.return;
        }
      Ep(function() {
        var fe = A, Xe = Gs(h), nt = [];
        e: {
          var $e = s5.get(a);
          if ($e !== void 0) {
            var st = cr, Ht = a;
            switch (a) {
              case "keypress":
                if (nf(h) === 0) break e;
              case "keydown":
              case "keyup":
                st = ope;
                break;
              case "focusin":
                Ht = "focus", st = nc;
                break;
              case "focusout":
                Ht = "blur", st = nc;
                break;
              case "beforeblur":
              case "afterblur":
                st = nc;
                break;
              case "click":
                if (h.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                st = Qt;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                st = oo;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                st = lpe;
                break;
              case r5:
              case i5:
              case o5:
                st = Zfe;
                break;
              case a5:
                st = upe;
                break;
              case "scroll":
              case "scrollend":
                st = Oe;
                break;
              case "wheel":
                st = fpe;
                break;
              case "copy":
              case "cut":
              case "paste":
                st = Qfe;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                st = XH;
                break;
              case "toggle":
              case "beforetoggle":
                st = hpe;
            }
            var un = (l & 4) !== 0, Zr = !un && (a === "scroll" || a === "scrollend"), qn = un ? $e !== null ? $e + "Capture" : null : $e;
            un = [];
            for (var Se = fe, we; Se !== null; ) {
              var Re = Se;
              if (we = Re.stateNode, Re = Re.tag, Re !== 5 && Re !== 26 && Re !== 27 || we === null || qn === null || (Re = Ss(Se, qn), Re != null && un.push(
                ah(
                  Se,
                  Re,
                  we
                )
              )), Zr) break;
              Se = Se.return;
            }
            0 < un.length && ($e = new st(
              $e,
              Ht,
              null,
              h,
              Xe
            ), nt.push({
              event: $e,
              listeners: un
            }));
          }
        }
        if ((l & 7) === 0) {
          e: {
            if ($e = a === "mouseover" || a === "pointerover", st = a === "mouseout" || a === "pointerout", $e && h !== j && (Ht = h.relatedTarget || h.fromElement) && (gt(Ht) || Ht[xd]))
              break e;
            if ((st || $e) && ($e = Xe.window === Xe ? Xe : ($e = Xe.ownerDocument) ? $e.defaultView || $e.parentWindow : window, st ? (Ht = h.relatedTarget || h.toElement, st = fe, Ht = Ht ? gt(Ht) : null, Ht !== null && (Zr = D(Ht), un = Ht.tag, Ht !== Zr || un !== 5 && un !== 27 && un !== 6) && (Ht = null)) : (st = null, Ht = fe), st !== Ht)) {
              if (un = Qt, Re = "onMouseLeave", qn = "onMouseEnter", Se = "mouse", (a === "pointerout" || a === "pointerover") && (un = XH, Re = "onPointerLeave", qn = "onPointerEnter", Se = "pointer"), Zr = st == null ? $e : ht(st), we = Ht == null ? $e : ht(Ht), $e = new un(
                Re,
                Se + "leave",
                st,
                h,
                Xe
              ), $e.target = Zr, $e.relatedTarget = we, Re = null, gt(Xe) === fe && (un = new un(
                qn,
                Se + "enter",
                Ht,
                h,
                Xe
              ), un.target = we, un.relatedTarget = Zr, Re = un), Zr = Re, st && Ht)
                t: {
                  for (un = st, qn = Ht, Se = 0, we = un; we; we = Of(we))
                    Se++;
                  for (we = 0, Re = qn; Re; Re = Of(Re))
                    we++;
                  for (; 0 < Se - we; )
                    un = Of(un), Se--;
                  for (; 0 < we - Se; )
                    qn = Of(qn), we--;
                  for (; Se--; ) {
                    if (un === qn || qn !== null && un === qn.alternate)
                      break t;
                    un = Of(un), qn = Of(qn);
                  }
                  un = null;
                }
              else un = null;
              st !== null && iu(
                nt,
                $e,
                st,
                un,
                !1
              ), Ht !== null && Zr !== null && iu(
                nt,
                Zr,
                Ht,
                un,
                !0
              );
            }
          }
          e: {
            if ($e = fe ? ht(fe) : window, st = $e.nodeName && $e.nodeName.toLowerCase(), st === "select" || st === "input" && $e.type === "file")
              var lt = B_;
            else if (gy($e))
              if (t5)
                lt = RP;
              else {
                lt = _P;
                var Ot = hS;
              }
            else
              st = $e.nodeName, !st || st.toLowerCase() !== "input" || $e.type !== "checkbox" && $e.type !== "radio" ? fe && ef(fe.elementType) && (lt = B_) : lt = CP;
            if (lt && (lt = lt(a, fe))) {
              _p(
                nt,
                lt,
                h,
                Xe
              );
              break e;
            }
            Ot && Ot(a, $e, fe), a === "focusout" && fe && $e.type === "number" && fe.memoizedProps.value != null && ys($e, "number", $e.value);
          }
          switch (Ot = fe ? ht(fe) : window, a) {
            case "focusin":
              (gy(Ot) || Ot.contentEditable === "true") && (Yb = Ot, qP = fe, mT = null);
              break;
            case "focusout":
              mT = qP = Yb = null;
              break;
            case "mousedown":
              $P = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              $P = !1, vy(
                nt,
                h,
                Xe
              );
              break;
            case "selectionchange":
              if (ype) break;
            case "keydown":
            case "keyup":
              vy(
                nt,
                h,
                Xe
              );
          }
          var xn;
          if (HP)
            e: {
              switch (a) {
                case "compositionstart":
                  var qt = "onCompositionStart";
                  break e;
                case "compositionend":
                  qt = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  qt = "onCompositionUpdate";
                  break e;
              }
              qt = void 0;
            }
          else
            Gb ? Wu(a, h) && (qt = "onCompositionEnd") : a === "keydown" && h.keyCode === ZH && (qt = "onCompositionStart");
          qt && (KH && h.locale !== "ko" && (Gb || qt !== "onCompositionStart" ? qt === "onCompositionEnd" && Gb && (xn = hy()) : (He = Xe, Ze = "value" in He ? He.value : He.textContent, Gb = !0)), Ot = ko(
            fe,
            qt
          ), 0 < Ot.length && (qt = new YH(
            qt,
            a,
            null,
            h,
            Xe
          ), nt.push({
            event: qt,
            listeners: Ot
          }), xn ? qt.data = xn : (xn = jg(h), xn !== null && (qt.data = xn)))), (xn = mpe ? Lg(a, h) : EP(a, h)) && (qt = ko(
            fe,
            "onBeforeInput"
          ), 0 < qt.length && (Ot = new epe(
            "onBeforeInput",
            "beforeinput",
            null,
            h,
            Xe
          ), nt.push({
            event: Ot,
            listeners: qt
          }), Ot.data = xn)), Ra(
            nt,
            a,
            fe,
            h,
            Xe
          );
        }
        Aw(nt, l);
      });
    }
    function ah(a, l, h) {
      return {
        instance: a,
        listener: l,
        currentTarget: h
      };
    }
    function ko(a, l) {
      for (var h = l + "Capture", x = []; a !== null; ) {
        var R = a, A = R.stateNode;
        if (R = R.tag, R !== 5 && R !== 26 && R !== 27 || A === null || (R = Ss(a, h), R != null && x.unshift(
          ah(a, R, A)
        ), R = Ss(a, l), R != null && x.push(
          ah(a, R, A)
        )), a.tag === 3) return x;
        a = a.return;
      }
      return [];
    }
    function Of(a) {
      if (a === null) return null;
      do
        a = a.return;
      while (a && a.tag !== 5 && a.tag !== 27);
      return a || null;
    }
    function iu(a, l, h, x, R) {
      for (var A = l._reactName, B = []; h !== null && h !== x; ) {
        var G = h, ue = G.alternate, fe = G.stateNode;
        if (G = G.tag, ue !== null && ue === x) break;
        G !== 5 && G !== 26 && G !== 27 || fe === null || (ue = fe, R ? (fe = Ss(h, A), fe != null && B.unshift(
          ah(h, fe, ue)
        )) : R || (fe = Ss(h, A), fe != null && B.push(
          ah(h, fe, ue)
        ))), h = h.return;
      }
      B.length !== 0 && a.push({ event: l, listeners: B });
    }
    function ou(a, l) {
      L_(a, l), a !== "input" && a !== "textarea" && a !== "select" || l == null || l.value !== null || VC || (VC = !0, a === "select" && l.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        a
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        a
      ));
      var h = {
        registrationNameDependencies: ml,
        possibleRegistrationNames: zb
      };
      ef(a) || typeof l.is == "string" || k_(a, l, h), l.contentEditable && !l.suppressContentEditableWarning && l.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function Yr(a, l, h, x) {
      l !== h && (h = au(h), au(l) !== h && (x[a] = l));
    }
    function Iw(a, l, h) {
      l.forEach(function(x) {
        h[sh(x)] = x === "style" ? pb(a) : a.getAttribute(x);
      });
    }
    function Is(a, l) {
      l === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        a,
        a,
        a
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        a,
        typeof l
      );
    }
    function fl(a, l) {
      return a = a.namespaceURI === Hb || a.namespaceURI === vu ? a.ownerDocument.createElementNS(
        a.namespaceURI,
        a.tagName
      ) : a.ownerDocument.createElement(a.tagName), a.innerHTML = l, a.innerHTML;
    }
    function au(a) {
      return ne(a) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        be(a)
      ), ae(a)), (typeof a == "string" ? a : "" + a).replace(Wpe, `
`).replace(Hpe, "");
    }
    function Af(a, l) {
      return l = au(l), au(a) === l;
    }
    function sd() {
    }
    function rr(a, l, h, x, R, A) {
      switch (h) {
        case "children":
          typeof x == "string" ? (wp(x, l, !1), l === "body" || l === "textarea" && x === "" || Ig(a, x)) : (typeof x == "number" || typeof x == "bigint") && (wp("" + x, l, !1), l !== "body" && Ig(a, "" + x));
          break;
        case "className":
          jr(a, "class", x);
          break;
        case "tabIndex":
          jr(a, "tabindex", x);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          jr(a, h, x);
          break;
        case "style":
          fy(a, x, A);
          break;
        case "data":
          if (l !== "object") {
            jr(a, "data", x);
            break;
          }
        case "src":
        case "href":
          if (x === "" && (l !== "a" || h !== "href")) {
            console.error(
              h === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              h,
              h
            ), a.removeAttribute(h);
            break;
          }
          if (x == null || typeof x == "function" || typeof x == "symbol" || typeof x == "boolean") {
            a.removeAttribute(h);
            break;
          }
          ie(x, h), x = Fc("" + x), a.setAttribute(h, x);
          break;
        case "action":
        case "formAction":
          if (x != null && (l === "form" ? h === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof x == "function" && (R.encType == null && R.method == null || fR || (fR = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), R.target == null || dR || (dR = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : l === "input" || l === "button" ? h === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : l !== "input" || R.type === "submit" || R.type === "image" || uR ? l !== "button" || R.type == null || R.type === "submit" || uR ? typeof x == "function" && (R.name == null || w4 || (w4 = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), R.formEncType == null && R.formMethod == null || fR || (fR = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), R.formTarget == null || dR || (dR = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (uR = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (uR = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            h === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof x == "function") {
            a.setAttribute(
              h,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof A == "function" && (h === "formAction" ? (l !== "input" && rr(a, l, "name", R.name, R, null), rr(
              a,
              l,
              "formEncType",
              R.formEncType,
              R,
              null
            ), rr(
              a,
              l,
              "formMethod",
              R.formMethod,
              R,
              null
            ), rr(
              a,
              l,
              "formTarget",
              R.formTarget,
              R,
              null
            )) : (rr(
              a,
              l,
              "encType",
              R.encType,
              R,
              null
            ), rr(a, l, "method", R.method, R, null), rr(
              a,
              l,
              "target",
              R.target,
              R,
              null
            )));
          if (x == null || typeof x == "symbol" || typeof x == "boolean") {
            a.removeAttribute(h);
            break;
          }
          ie(x, h), x = Fc("" + x), a.setAttribute(h, x);
          break;
        case "onClick":
          x != null && (typeof x != "function" && Is(h, x), a.onclick = sd);
          break;
        case "onScroll":
          x != null && (typeof x != "function" && Is(h, x), jn("scroll", a));
          break;
        case "onScrollEnd":
          x != null && (typeof x != "function" && Is(h, x), jn("scrollend", a));
          break;
        case "dangerouslySetInnerHTML":
          if (x != null) {
            if (typeof x != "object" || !("__html" in x))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (h = x.__html, h != null) {
              if (R.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              a.innerHTML = h;
            }
          }
          break;
        case "multiple":
          a.multiple = x && typeof x != "function" && typeof x != "symbol";
          break;
        case "muted":
          a.muted = x && typeof x != "function" && typeof x != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (x == null || typeof x == "function" || typeof x == "boolean" || typeof x == "symbol") {
            a.removeAttribute("xlink:href");
            break;
          }
          ie(x, h), h = Fc("" + x), a.setAttributeNS(iv, "xlink:href", h);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          x != null && typeof x != "function" && typeof x != "symbol" ? (ie(x, h), a.setAttribute(h, "" + x)) : a.removeAttribute(h);
          break;
        case "inert":
          x !== "" || pR[h] || (pR[h] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            h
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          x && typeof x != "function" && typeof x != "symbol" ? a.setAttribute(h, "") : a.removeAttribute(h);
          break;
        case "capture":
        case "download":
          x === !0 ? a.setAttribute(h, "") : x !== !1 && x != null && typeof x != "function" && typeof x != "symbol" ? (ie(x, h), a.setAttribute(h, x)) : a.removeAttribute(h);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          x != null && typeof x != "function" && typeof x != "symbol" && !isNaN(x) && 1 <= x ? (ie(x, h), a.setAttribute(h, x)) : a.removeAttribute(h);
          break;
        case "rowSpan":
        case "start":
          x == null || typeof x == "function" || typeof x == "symbol" || isNaN(x) ? a.removeAttribute(h) : (ie(x, h), a.setAttribute(h, x));
          break;
        case "popover":
          jn("beforetoggle", a), jn("toggle", a), Hr(a, "popover", x);
          break;
        case "xlinkActuate":
          Ut(
            a,
            iv,
            "xlink:actuate",
            x
          );
          break;
        case "xlinkArcrole":
          Ut(
            a,
            iv,
            "xlink:arcrole",
            x
          );
          break;
        case "xlinkRole":
          Ut(
            a,
            iv,
            "xlink:role",
            x
          );
          break;
        case "xlinkShow":
          Ut(
            a,
            iv,
            "xlink:show",
            x
          );
          break;
        case "xlinkTitle":
          Ut(
            a,
            iv,
            "xlink:title",
            x
          );
          break;
        case "xlinkType":
          Ut(
            a,
            iv,
            "xlink:type",
            x
          );
          break;
        case "xmlBase":
          Ut(
            a,
            NN,
            "xml:base",
            x
          );
          break;
        case "xmlLang":
          Ut(
            a,
            NN,
            "xml:lang",
            x
          );
          break;
        case "xmlSpace":
          Ut(
            a,
            NN,
            "xml:space",
            x
          );
          break;
        case "is":
          A != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), Hr(a, "is", x);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          T4 || x == null || typeof x != "object" || (T4 = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            x
          ));
        default:
          !(2 < h.length) || h[0] !== "o" && h[0] !== "O" || h[1] !== "n" && h[1] !== "N" ? (h = tf(h), Hr(a, h, x)) : ml.hasOwnProperty(h) && x != null && typeof x != "function" && Is(h, x);
      }
    }
    function ld(a, l, h, x, R, A) {
      switch (h) {
        case "style":
          fy(a, x, A);
          break;
        case "dangerouslySetInnerHTML":
          if (x != null) {
            if (typeof x != "object" || !("__html" in x))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (h = x.__html, h != null) {
              if (R.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              a.innerHTML = h;
            }
          }
          break;
        case "children":
          typeof x == "string" ? Ig(a, x) : (typeof x == "number" || typeof x == "bigint") && Ig(a, "" + x);
          break;
        case "onScroll":
          x != null && (typeof x != "function" && Is(h, x), jn("scroll", a));
          break;
        case "onScrollEnd":
          x != null && (typeof x != "function" && Is(h, x), jn("scrollend", a));
          break;
        case "onClick":
          x != null && (typeof x != "function" && Is(h, x), a.onclick = sd);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (ml.hasOwnProperty(h))
            x != null && typeof x != "function" && Is(h, x);
          else
            e: {
              if (h[0] === "o" && h[1] === "n" && (R = h.endsWith("Capture"), l = h.slice(2, R ? h.length - 7 : void 0), A = a[Na] || null, A = A != null ? A[h] : null, typeof A == "function" && a.removeEventListener(l, A, R), typeof x == "function")) {
                typeof A != "function" && A !== null && (h in a ? a[h] = null : a.hasAttribute(h) && a.removeAttribute(h)), a.addEventListener(l, x, R);
                break e;
              }
              h in a ? a[h] = x : x === !0 ? a.setAttribute(h, "") : Hr(a, h, x);
            }
      }
    }
    function no(a, l, h) {
      switch (ou(l, h), l) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          jn("error", a), jn("load", a);
          var x = !1, R = !1, A;
          for (A in h)
            if (h.hasOwnProperty(A)) {
              var B = h[A];
              if (B != null)
                switch (A) {
                  case "src":
                    x = !0;
                    break;
                  case "srcSet":
                    R = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    rr(a, l, A, B, h, null);
                }
            }
          R && rr(a, l, "srcSet", h.srcSet, h, null), x && rr(a, l, "src", h.src, h, null);
          return;
        case "input":
          Zt("input", h), jn("invalid", a);
          var G = A = B = R = null, ue = null, fe = null;
          for (x in h)
            if (h.hasOwnProperty(x)) {
              var Xe = h[x];
              if (Xe != null)
                switch (x) {
                  case "name":
                    R = Xe;
                    break;
                  case "type":
                    B = Xe;
                    break;
                  case "checked":
                    ue = Xe;
                    break;
                  case "defaultChecked":
                    fe = Xe;
                    break;
                  case "value":
                    A = Xe;
                    break;
                  case "defaultValue":
                    G = Xe;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (Xe != null)
                      throw Error(
                        l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    rr(a, l, x, Xe, h, null);
                }
            }
          fn(a, h), mo(
            a,
            A,
            G,
            ue,
            fe,
            B,
            R,
            !1
          ), Ne(a);
          return;
        case "select":
          Zt("select", h), jn("invalid", a), x = B = A = null;
          for (R in h)
            if (h.hasOwnProperty(R) && (G = h[R], G != null))
              switch (R) {
                case "value":
                  A = G;
                  break;
                case "defaultValue":
                  B = G;
                  break;
                case "multiple":
                  x = G;
                default:
                  rr(
                    a,
                    l,
                    R,
                    G,
                    h,
                    null
                  );
              }
          yn(a, h), l = A, h = B, a.multiple = !!x, l != null ? vo(a, !!x, l, !1) : h != null && vo(a, !!x, h, !0);
          return;
        case "textarea":
          Zt("textarea", h), jn("invalid", a), A = R = x = null;
          for (B in h)
            if (h.hasOwnProperty(B) && (G = h[B], G != null))
              switch (B) {
                case "value":
                  x = G;
                  break;
                case "defaultValue":
                  R = G;
                  break;
                case "children":
                  A = G;
                  break;
                case "dangerouslySetInnerHTML":
                  if (G != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  rr(
                    a,
                    l,
                    B,
                    G,
                    h,
                    null
                  );
              }
          Xo(a, h), $a(a, x, R, A), Ne(a);
          return;
        case "option":
          Di(a, h);
          for (ue in h)
            if (h.hasOwnProperty(ue) && (x = h[ue], x != null))
              switch (ue) {
                case "selected":
                  a.selected = x && typeof x != "function" && typeof x != "symbol";
                  break;
                default:
                  rr(a, l, ue, x, h, null);
              }
          return;
        case "dialog":
          jn("beforetoggle", a), jn("toggle", a), jn("cancel", a), jn("close", a);
          break;
        case "iframe":
        case "object":
          jn("load", a);
          break;
        case "video":
        case "audio":
          for (x = 0; x < VT.length; x++)
            jn(VT[x], a);
          break;
        case "image":
          jn("error", a), jn("load", a);
          break;
        case "details":
          jn("toggle", a);
          break;
        case "embed":
        case "source":
        case "link":
          jn("error", a), jn("load", a);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (fe in h)
            if (h.hasOwnProperty(fe) && (x = h[fe], x != null))
              switch (fe) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  rr(a, l, fe, x, h, null);
              }
          return;
        default:
          if (ef(l)) {
            for (Xe in h)
              h.hasOwnProperty(Xe) && (x = h[Xe], x !== void 0 && ld(
                a,
                l,
                Xe,
                x,
                h,
                void 0
              ));
            return;
          }
      }
      for (G in h)
        h.hasOwnProperty(G) && (x = h[G], x != null && rr(a, l, G, x, h, null));
    }
    function hC(a, l, h, x) {
      switch (ou(l, x), l) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var R = null, A = null, B = null, G = null, ue = null, fe = null, Xe = null;
          for (st in h) {
            var nt = h[st];
            if (h.hasOwnProperty(st) && nt != null)
              switch (st) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  ue = nt;
                default:
                  x.hasOwnProperty(st) || rr(
                    a,
                    l,
                    st,
                    null,
                    x,
                    nt
                  );
              }
          }
          for (var $e in x) {
            var st = x[$e];
            if (nt = h[$e], x.hasOwnProperty($e) && (st != null || nt != null))
              switch ($e) {
                case "type":
                  A = st;
                  break;
                case "name":
                  R = st;
                  break;
                case "checked":
                  fe = st;
                  break;
                case "defaultChecked":
                  Xe = st;
                  break;
                case "value":
                  B = st;
                  break;
                case "defaultValue":
                  G = st;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (st != null)
                    throw Error(
                      l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  st !== nt && rr(
                    a,
                    l,
                    $e,
                    st,
                    x,
                    nt
                  );
              }
          }
          l = h.type === "checkbox" || h.type === "radio" ? h.checked != null : h.value != null, x = x.type === "checkbox" || x.type === "radio" ? x.checked != null : x.value != null, l || !x || S4 || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), S4 = !0), !l || x || x4 || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), x4 = !0), Xn(
            a,
            B,
            G,
            ue,
            fe,
            Xe,
            A,
            R
          );
          return;
        case "select":
          st = B = G = $e = null;
          for (A in h)
            if (ue = h[A], h.hasOwnProperty(A) && ue != null)
              switch (A) {
                case "value":
                  break;
                case "multiple":
                  st = ue;
                default:
                  x.hasOwnProperty(A) || rr(
                    a,
                    l,
                    A,
                    null,
                    x,
                    ue
                  );
              }
          for (R in x)
            if (A = x[R], ue = h[R], x.hasOwnProperty(R) && (A != null || ue != null))
              switch (R) {
                case "value":
                  $e = A;
                  break;
                case "defaultValue":
                  G = A;
                  break;
                case "multiple":
                  B = A;
                default:
                  A !== ue && rr(
                    a,
                    l,
                    R,
                    A,
                    x,
                    ue
                  );
              }
          x = G, l = B, h = st, $e != null ? vo(a, !!l, $e, !1) : !!h != !!l && (x != null ? vo(a, !!l, x, !0) : vo(a, !!l, l ? [] : "", !1));
          return;
        case "textarea":
          st = $e = null;
          for (G in h)
            if (R = h[G], h.hasOwnProperty(G) && R != null && !x.hasOwnProperty(G))
              switch (G) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  rr(a, l, G, null, x, R);
              }
          for (B in x)
            if (R = x[B], A = h[B], x.hasOwnProperty(B) && (R != null || A != null))
              switch (B) {
                case "value":
                  $e = R;
                  break;
                case "defaultValue":
                  st = R;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (R != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  R !== A && rr(a, l, B, R, x, A);
              }
          bs(a, $e, st);
          return;
        case "option":
          for (var Ht in h)
            if ($e = h[Ht], h.hasOwnProperty(Ht) && $e != null && !x.hasOwnProperty(Ht))
              switch (Ht) {
                case "selected":
                  a.selected = !1;
                  break;
                default:
                  rr(
                    a,
                    l,
                    Ht,
                    null,
                    x,
                    $e
                  );
              }
          for (ue in x)
            if ($e = x[ue], st = h[ue], x.hasOwnProperty(ue) && $e !== st && ($e != null || st != null))
              switch (ue) {
                case "selected":
                  a.selected = $e && typeof $e != "function" && typeof $e != "symbol";
                  break;
                default:
                  rr(
                    a,
                    l,
                    ue,
                    $e,
                    x,
                    st
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var un in h)
            $e = h[un], h.hasOwnProperty(un) && $e != null && !x.hasOwnProperty(un) && rr(
              a,
              l,
              un,
              null,
              x,
              $e
            );
          for (fe in x)
            if ($e = x[fe], st = h[fe], x.hasOwnProperty(fe) && $e !== st && ($e != null || st != null))
              switch (fe) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if ($e != null)
                    throw Error(
                      l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  rr(
                    a,
                    l,
                    fe,
                    $e,
                    x,
                    st
                  );
              }
          return;
        default:
          if (ef(l)) {
            for (var Zr in h)
              $e = h[Zr], h.hasOwnProperty(Zr) && $e !== void 0 && !x.hasOwnProperty(Zr) && ld(
                a,
                l,
                Zr,
                void 0,
                x,
                $e
              );
            for (Xe in x)
              $e = x[Xe], st = h[Xe], !x.hasOwnProperty(Xe) || $e === st || $e === void 0 && st === void 0 || ld(
                a,
                l,
                Xe,
                $e,
                x,
                st
              );
            return;
          }
      }
      for (var qn in h)
        $e = h[qn], h.hasOwnProperty(qn) && $e != null && !x.hasOwnProperty(qn) && rr(a, l, qn, null, x, $e);
      for (nt in x)
        $e = x[nt], st = h[nt], !x.hasOwnProperty(nt) || $e === st || $e == null && st == null || rr(a, l, nt, $e, x, st);
    }
    function sh(a) {
      switch (a) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return a;
      }
    }
    function pb(a) {
      var l = {};
      a = a.style;
      for (var h = 0; h < a.length; h++) {
        var x = a[h];
        l[x] = a.getPropertyValue(x);
      }
      return l;
    }
    function Sm(a, l, h) {
      if (l != null && typeof l != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var x, R = x = "", A;
        for (A in l)
          if (l.hasOwnProperty(A)) {
            var B = l[A];
            B != null && typeof B != "boolean" && B !== "" && (A.indexOf("--") === 0 ? (he(B, A), x += R + A + ":" + ("" + B).trim()) : typeof B != "number" || B === 0 || fT.has(A) ? (he(B, A), x += R + A.replace(mu, "-$1").toLowerCase().replace(Th, "-ms-") + ":" + ("" + B).trim()) : x += R + A.replace(mu, "-$1").toLowerCase().replace(Th, "-ms-") + ":" + B + "px", R = ";");
          }
        x = x || null, l = a.getAttribute("style"), l !== x && (x = au(x), au(l) !== x && (h.style = pb(a)));
      }
    }
    function es(a, l, h, x, R, A) {
      if (R.delete(h), a = a.getAttribute(h), a === null)
        switch (typeof x) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (x != null)
        switch (typeof x) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (ie(x, l), a === "" + x)
              return;
        }
      Yr(l, a, x, A);
    }
    function gC(a, l, h, x, R, A) {
      if (R.delete(h), a = a.getAttribute(h), a === null) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
        }
        if (!x) return;
      } else
        switch (typeof x) {
          case "function":
          case "symbol":
            break;
          default:
            if (x) return;
        }
      Yr(l, a, x, A);
    }
    function Pw(a, l, h, x, R, A) {
      if (R.delete(h), a = a.getAttribute(h), a === null)
        switch (typeof x) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (x != null)
        switch (typeof x) {
          case "function":
          case "symbol":
            break;
          default:
            if (ie(x, h), a === "" + x)
              return;
        }
      Yr(l, a, x, A);
    }
    function fr(a, l, h, x, R, A) {
      if (R.delete(h), a = a.getAttribute(h), a === null)
        switch (typeof x) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(x)) return;
        }
      else if (x != null)
        switch (typeof x) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(x) && (ie(x, l), a === "" + x))
              return;
        }
      Yr(l, a, x, A);
    }
    function Tr(a, l, h, x, R, A) {
      if (R.delete(h), a = a.getAttribute(h), a === null)
        switch (typeof x) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (x != null)
        switch (typeof x) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (ie(x, l), h = Fc("" + x), a === h)
              return;
        }
      Yr(l, a, x, A);
    }
    function Ln(a, l, h, x) {
      for (var R = {}, A = /* @__PURE__ */ new Set(), B = a.attributes, G = 0; G < B.length; G++)
        switch (B[G].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            A.add(B[G].name);
        }
      if (ef(l)) {
        for (var ue in h)
          if (h.hasOwnProperty(ue)) {
            var fe = h[ue];
            if (fe != null) {
              if (ml.hasOwnProperty(ue))
                typeof fe != "function" && Is(ue, fe);
              else if (h.suppressHydrationWarning !== !0)
                switch (ue) {
                  case "children":
                    typeof fe != "string" && typeof fe != "number" || Yr(
                      "children",
                      a.textContent,
                      fe,
                      R
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    B = a.innerHTML, fe = fe ? fe.__html : void 0, fe != null && (fe = fl(a, fe), Yr(
                      ue,
                      B,
                      fe,
                      R
                    ));
                    continue;
                  case "style":
                    A.delete(ue), Sm(a, fe, R);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    A.delete(ue.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      ue
                    );
                    continue;
                  case "className":
                    A.delete("class"), B = xr(
                      a,
                      "class",
                      fe
                    ), Yr(
                      "className",
                      B,
                      fe,
                      R
                    );
                    continue;
                  default:
                    x.context === qf && l !== "svg" && l !== "math" ? A.delete(ue.toLowerCase()) : A.delete(ue), B = xr(
                      a,
                      ue,
                      fe
                    ), Yr(
                      ue,
                      B,
                      fe,
                      R
                    );
                }
            }
          }
      } else
        for (fe in h)
          if (h.hasOwnProperty(fe) && (ue = h[fe], ue != null)) {
            if (ml.hasOwnProperty(fe))
              typeof ue != "function" && Is(fe, ue);
            else if (h.suppressHydrationWarning !== !0)
              switch (fe) {
                case "children":
                  typeof ue != "string" && typeof ue != "number" || Yr(
                    "children",
                    a.textContent,
                    ue,
                    R
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  B = a.innerHTML, ue = ue ? ue.__html : void 0, ue != null && (ue = fl(a, ue), B !== ue && (R[fe] = { __html: B }));
                  continue;
                case "className":
                  es(
                    a,
                    fe,
                    "class",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "tabIndex":
                  es(
                    a,
                    fe,
                    "tabindex",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "style":
                  A.delete(fe), Sm(a, ue, R);
                  continue;
                case "multiple":
                  A.delete(fe), Yr(
                    fe,
                    a.multiple,
                    ue,
                    R
                  );
                  continue;
                case "muted":
                  A.delete(fe), Yr(
                    fe,
                    a.muted,
                    ue,
                    R
                  );
                  continue;
                case "autoFocus":
                  A.delete("autofocus"), Yr(
                    fe,
                    a.autofocus,
                    ue,
                    R
                  );
                  continue;
                case "data":
                  if (l !== "object") {
                    A.delete(fe), B = a.getAttribute("data"), Yr(
                      fe,
                      B,
                      ue,
                      R
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(ue !== "" || l === "a" && fe === "href" || l === "object" && fe === "data")) {
                    console.error(
                      fe === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      fe,
                      fe
                    );
                    continue;
                  }
                  Tr(
                    a,
                    fe,
                    fe,
                    ue,
                    A,
                    R
                  );
                  continue;
                case "action":
                case "formAction":
                  if (B = a.getAttribute(fe), typeof ue == "function") {
                    A.delete(fe.toLowerCase()), fe === "formAction" ? (A.delete("name"), A.delete("formenctype"), A.delete("formmethod"), A.delete("formtarget")) : (A.delete("enctype"), A.delete("method"), A.delete("target"));
                    continue;
                  } else if (B === qpe) {
                    A.delete(fe.toLowerCase()), Yr(
                      fe,
                      "function",
                      ue,
                      R
                    );
                    continue;
                  }
                  Tr(
                    a,
                    fe,
                    fe.toLowerCase(),
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkHref":
                  Tr(
                    a,
                    fe,
                    "xlink:href",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "contentEditable":
                  Pw(
                    a,
                    fe,
                    "contenteditable",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "spellCheck":
                  Pw(
                    a,
                    fe,
                    "spellcheck",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  Pw(
                    a,
                    fe,
                    fe,
                    ue,
                    A,
                    R
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  gC(
                    a,
                    fe,
                    fe.toLowerCase(),
                    ue,
                    A,
                    R
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    G = a;
                    var Xe = B = fe, nt = R;
                    if (A.delete(Xe), G = G.getAttribute(Xe), G === null)
                      switch (typeof ue) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (ue === !1) break e;
                      }
                    else if (ue != null)
                      switch (typeof ue) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (ue === !0 && G === "") break e;
                          break;
                        default:
                          if (ie(ue, B), G === "" + ue)
                            break e;
                      }
                    Yr(
                      B,
                      G,
                      ue,
                      nt
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (G = a, Xe = B = fe, nt = R, A.delete(Xe), G = G.getAttribute(Xe), G === null)
                      switch (typeof ue) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(ue) || 1 > ue) break e;
                      }
                    else if (ue != null)
                      switch (typeof ue) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(ue) || 1 > ue) && (ie(ue, B), G === "" + ue))
                            break e;
                      }
                    Yr(
                      B,
                      G,
                      ue,
                      nt
                    );
                  }
                  continue;
                case "rowSpan":
                  fr(
                    a,
                    fe,
                    "rowspan",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "start":
                  fr(
                    a,
                    fe,
                    fe,
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xHeight":
                  es(
                    a,
                    fe,
                    "x-height",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkActuate":
                  es(
                    a,
                    fe,
                    "xlink:actuate",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkArcrole":
                  es(
                    a,
                    fe,
                    "xlink:arcrole",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkRole":
                  es(
                    a,
                    fe,
                    "xlink:role",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkShow":
                  es(
                    a,
                    fe,
                    "xlink:show",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkTitle":
                  es(
                    a,
                    fe,
                    "xlink:title",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xlinkType":
                  es(
                    a,
                    fe,
                    "xlink:type",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xmlBase":
                  es(
                    a,
                    fe,
                    "xml:base",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xmlLang":
                  es(
                    a,
                    fe,
                    "xml:lang",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "xmlSpace":
                  es(
                    a,
                    fe,
                    "xml:space",
                    ue,
                    A,
                    R
                  );
                  continue;
                case "inert":
                  ue !== "" || pR[fe] || (pR[fe] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    fe
                  )), gC(
                    a,
                    fe,
                    fe,
                    ue,
                    A,
                    R
                  );
                  continue;
                default:
                  if (!(2 < fe.length) || fe[0] !== "o" && fe[0] !== "O" || fe[1] !== "n" && fe[1] !== "N") {
                    G = tf(fe), B = !1, x.context === qf && l !== "svg" && l !== "math" ? A.delete(G.toLowerCase()) : (Xe = fe.toLowerCase(), Xe = Wm.hasOwnProperty(
                      Xe
                    ) && Wm[Xe] || null, Xe !== null && Xe !== fe && (B = !0, A.delete(Xe)), A.delete(G));
                    e: if (Xe = a, nt = G, G = ue, dn(nt))
                      if (Xe.hasAttribute(nt))
                        Xe = Xe.getAttribute(
                          nt
                        ), ie(
                          G,
                          nt
                        ), G = Xe === "" + G ? G : Xe;
                      else {
                        switch (typeof G) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (Xe = nt.toLowerCase().slice(0, 5), Xe !== "data-" && Xe !== "aria-")
                              break e;
                        }
                        G = G === void 0 ? void 0 : null;
                      }
                    else G = void 0;
                    B || Yr(
                      fe,
                      G,
                      ue,
                      R
                    );
                  }
              }
          }
      return 0 < A.size && h.suppressHydrationWarning !== !0 && Iw(a, A, R), Object.keys(R).length === 0 ? null : R;
    }
    function Zn(a, l) {
      switch (a.length) {
        case 0:
          return "";
        case 1:
          return a[0];
        case 2:
          return a[0] + " " + l + " " + a[1];
        default:
          return a.slice(0, -1).join(", ") + ", " + l + " " + a[a.length - 1];
      }
    }
    function ir(a) {
      return a.nodeType === 9 ? a : a.ownerDocument;
    }
    function Aa(a) {
      switch (a) {
        case vu:
          return x0;
        case Hb:
          return mR;
        default:
          return qf;
      }
    }
    function su(a, l) {
      if (a === qf)
        switch (l) {
          case "svg":
            return x0;
          case "math":
            return mR;
          default:
            return qf;
        }
      return a === x0 && l === "foreignObject" ? qf : a;
    }
    function cd(a, l) {
      return a === "textarea" || a === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.children == "bigint" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
    }
    function Nw() {
      var a = window.event;
      return a && a.type === "popstate" ? a === kN ? !1 : (kN = a, !0) : (kN = null, !1);
    }
    function lu(a) {
      setTimeout(function() {
        throw a;
      });
    }
    function xi(a, l, h) {
      switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          h.autoFocus && a.focus();
          break;
        case "img":
          h.src ? a.src = h.src : h.srcSet && (a.srcset = h.srcSet);
      }
    }
    function ud(a, l, h, x) {
      hC(a, l, h, x), a[Na] = x;
    }
    function dd(a) {
      Ig(a, "");
    }
    function Mw(a, l, h) {
      a.nodeValue = h;
    }
    function Hi(a) {
      return a === "head";
    }
    function lh(a, l) {
      a.removeChild(l);
    }
    function wm(a, l) {
      (a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a).removeChild(l);
    }
    function ea(a, l) {
      var h = l, x = 0, R = 0;
      do {
        var A = h.nextSibling;
        if (a.removeChild(h), A && A.nodeType === 8)
          if (h = A.data, h === gR) {
            if (0 < x && 8 > x) {
              h = x;
              var B = a.ownerDocument;
              if (h & Gpe && dh(B.documentElement), h & Ype && dh(B.body), h & Xpe)
                for (h = B.head, dh(h), B = h.firstChild; B; ) {
                  var G = B.nextSibling, ue = B.nodeName;
                  B[jm] || ue === "SCRIPT" || ue === "STYLE" || ue === "LINK" && B.rel.toLowerCase() === "stylesheet" || h.removeChild(B), B = G;
                }
            }
            if (R === 0) {
              a.removeChild(A), mh(l);
              return;
            }
            R--;
          } else
            h === hR || h === Hf || h === UT ? R++ : x = h.charCodeAt(0) - 48;
        else x = 0;
        h = A;
      } while (h);
      mh(l);
    }
    function jw(a) {
      a = a.style, typeof a.setProperty == "function" ? a.setProperty("display", "none", "important") : a.display = "none";
    }
    function Lw(a) {
      a.nodeValue = "";
    }
    function hb(a, l) {
      l = l[Zpe], l = l != null && l.hasOwnProperty("display") ? l.display : null, a.style.display = l == null || typeof l == "boolean" ? "" : ("" + l).trim();
    }
    function gb(a, l) {
      a.nodeValue = l;
    }
    function Yl(a) {
      var l = a.firstChild;
      for (l && l.nodeType === 10 && (l = l.nextSibling); l; ) {
        var h = l;
        switch (l = l.nextSibling, h.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Yl(h), Fe(h);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (h.rel.toLowerCase() === "stylesheet") continue;
        }
        a.removeChild(h);
      }
    }
    function xo(a, l, h, x) {
      for (; a.nodeType === 1; ) {
        var R = h;
        if (a.nodeName.toLowerCase() !== l.toLowerCase()) {
          if (!x && (a.nodeName !== "INPUT" || a.type !== "hidden"))
            break;
        } else if (x) {
          if (!a[jm])
            switch (l) {
              case "meta":
                if (!a.hasAttribute("itemprop")) break;
                return a;
              case "link":
                if (A = a.getAttribute("rel"), A === "stylesheet" && a.hasAttribute("data-precedence"))
                  break;
                if (A !== R.rel || a.getAttribute("href") !== (R.href == null || R.href === "" ? null : R.href) || a.getAttribute("crossorigin") !== (R.crossOrigin == null ? null : R.crossOrigin) || a.getAttribute("title") !== (R.title == null ? null : R.title))
                  break;
                return a;
              case "style":
                if (a.hasAttribute("data-precedence")) break;
                return a;
              case "script":
                if (A = a.getAttribute("src"), (A !== (R.src == null ? null : R.src) || a.getAttribute("type") !== (R.type == null ? null : R.type) || a.getAttribute("crossorigin") !== (R.crossOrigin == null ? null : R.crossOrigin)) && A && a.hasAttribute("async") && !a.hasAttribute("itemprop"))
                  break;
                return a;
              default:
                return a;
            }
        } else if (l === "input" && a.type === "hidden") {
          ie(R.name, "name");
          var A = R.name == null ? null : "" + R.name;
          if (R.type === "hidden" && a.getAttribute("name") === A)
            return a;
        } else return a;
        if (a = Da(a.nextSibling), a === null) break;
      }
      return null;
    }
    function fd(a, l, h) {
      if (l === "") return null;
      for (; a.nodeType !== 3; )
        if ((a.nodeType !== 1 || a.nodeName !== "INPUT" || a.type !== "hidden") && !h || (a = Da(a.nextSibling), a === null)) return null;
      return a;
    }
    function pd(a) {
      return a.data === UT || a.data === Hf && a.ownerDocument.readyState === _4;
    }
    function ch(a, l) {
      var h = a.ownerDocument;
      if (a.data !== Hf || h.readyState === _4)
        l();
      else {
        var x = function() {
          l(), h.removeEventListener("DOMContentLoaded", x);
        };
        h.addEventListener("DOMContentLoaded", x), a._reactRetry = x;
      }
    }
    function Da(a) {
      for (; a != null; a = a.nextSibling) {
        var l = a.nodeType;
        if (l === 1 || l === 3) break;
        if (l === 8) {
          if (l = a.data, l === hR || l === UT || l === Hf || l === MN || l === E4)
            break;
          if (l === gR) return null;
        }
      }
      return a;
    }
    function mb(a) {
      if (a.nodeType === 1) {
        for (var l = a.nodeName.toLowerCase(), h = {}, x = a.attributes, R = 0; R < x.length; R++) {
          var A = x[R];
          h[sh(A.name)] = A.name.toLowerCase() === "style" ? pb(a) : A.value;
        }
        return { type: l, props: h };
      }
      return a.nodeType === 8 ? { type: "Suspense", props: {} } : a.nodeValue;
    }
    function kw(a, l, h) {
      return h === null || h[$pe] !== !0 ? (a.nodeValue === l ? a = null : (l = au(l), a = au(a.nodeValue) === l ? null : a.nodeValue), a) : null;
    }
    function uh(a) {
      a = a.nextSibling;
      for (var l = 0; a; ) {
        if (a.nodeType === 8) {
          var h = a.data;
          if (h === gR) {
            if (l === 0)
              return Da(a.nextSibling);
            l--;
          } else
            h !== hR && h !== UT && h !== Hf || l++;
        }
        a = a.nextSibling;
      }
      return null;
    }
    function vb(a) {
      a = a.previousSibling;
      for (var l = 0; a; ) {
        if (a.nodeType === 8) {
          var h = a.data;
          if (h === hR || h === UT || h === Hf) {
            if (l === 0) return a;
            l--;
          } else h === gR && l++;
        }
        a = a.previousSibling;
      }
      return null;
    }
    function ts(a) {
      mh(a);
    }
    function mC(a) {
      mh(a);
    }
    function Ia(a, l, h, x, R) {
      switch (R && dy(a, x.ancestorInfo), l = ir(h), a) {
        case "html":
          if (a = l.documentElement, !a)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return a;
        case "head":
          if (a = l.head, !a)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return a;
        case "body":
          if (a = l.body, !a)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return a;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function vC(a, l, h, x) {
      if (!h[xd] && ct(h)) {
        var R = h.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          R,
          R,
          R
        );
      }
      switch (a) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (R = h.attributes; R.length; )
        h.removeAttributeNode(R[0]);
      no(h, a, l), h[zo] = x, h[Na] = l;
    }
    function dh(a) {
      for (var l = a.attributes; l.length; )
        a.removeAttributeNode(l[0]);
      Fe(a);
    }
    function yb(a) {
      return typeof a.getRootNode == "function" ? a.getRootNode() : a.nodeType === 9 ? a : a.ownerDocument;
    }
    function cu(a, l, h) {
      var x = S0;
      if (x && typeof l == "string" && l) {
        var R = zt(l);
        R = 'link[rel="' + a + '"][href="' + R + '"]', typeof h == "string" && (R += '[crossorigin="' + h + '"]'), I4.has(R) || (I4.add(R), a = { rel: a, crossOrigin: h, href: l }, x.querySelector(R) === null && (l = x.createElement("link"), no(l, "link", a), Rt(l), x.head.appendChild(l)));
      }
    }
    function Tm(a, l, h, x) {
      var R = (R = Zl.current) ? yb(R) : null;
      if (!R)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (a) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof h.precedence == "string" && typeof h.href == "string" ? (h = pl(h.href), l = Yt(R).hoistableStyles, x = l.get(h), x || (x = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, l.set(h, x)), x) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (h.rel === "stylesheet" && typeof h.href == "string" && typeof h.precedence == "string") {
            a = pl(h.href);
            var A = Yt(R).hoistableStyles, B = A.get(a);
            if (!B && (R = R.ownerDocument || R, B = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: av, preload: null }
            }, A.set(a, B), (A = R.querySelector(
              ph(a)
            )) && !A._p && (B.instance = A, B.state.loading = FT | fc), !pc.has(a))) {
              var G = {
                rel: "preload",
                as: "style",
                href: h.href,
                crossOrigin: h.crossOrigin,
                integrity: h.integrity,
                media: h.media,
                hrefLang: h.hrefLang,
                referrerPolicy: h.referrerPolicy
              };
              pc.set(a, G), A || yC(
                R,
                a,
                G,
                B.state
              );
            }
            if (l && x === null)
              throw h = `

  - ` + fh(l) + `
  + ` + fh(h), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + h
              );
            return B;
          }
          if (l && x !== null)
            throw h = `

  - ` + fh(l) + `
  + ` + fh(h), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + h
            );
          return null;
        case "script":
          return l = h.async, h = h.src, typeof h == "string" && l && typeof l != "function" && typeof l != "symbol" ? (h = hd(h), l = Yt(R).hoistableScripts, x = l.get(h), x || (x = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, l.set(h, x)), x) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + a + '". this is a bug in React.'
          );
      }
    }
    function fh(a) {
      var l = 0, h = "<link";
      return typeof a.rel == "string" ? (l++, h += ' rel="' + a.rel + '"') : Kl.call(a, "rel") && (l++, h += ' rel="' + (a.rel === null ? "null" : "invalid type " + typeof a.rel) + '"'), typeof a.href == "string" ? (l++, h += ' href="' + a.href + '"') : Kl.call(a, "href") && (l++, h += ' href="' + (a.href === null ? "null" : "invalid type " + typeof a.href) + '"'), typeof a.precedence == "string" ? (l++, h += ' precedence="' + a.precedence + '"') : Kl.call(a, "precedence") && (l++, h += " precedence={" + (a.precedence === null ? "null" : "invalid type " + typeof a.precedence) + "}"), Object.getOwnPropertyNames(a).length > l && (h += " ..."), h + " />";
    }
    function pl(a) {
      return 'href="' + zt(a) + '"';
    }
    function ph(a) {
      return 'link[rel="stylesheet"][' + a + "]";
    }
    function zw(a) {
      return pn({}, a, {
        "data-precedence": a.precedence,
        precedence: null
      });
    }
    function yC(a, l, h, x) {
      a.querySelector(
        'link[rel="preload"][as="style"][' + l + "]"
      ) ? x.loading = FT : (l = a.createElement("link"), x.preload = l, l.addEventListener("load", function() {
        return x.loading |= FT;
      }), l.addEventListener("error", function() {
        return x.loading |= A4;
      }), no(l, "link", h), Rt(l), a.head.appendChild(l));
    }
    function hd(a) {
      return '[src="' + zt(a) + '"]';
    }
    function Df(a) {
      return "script[async]" + a;
    }
    function bC(a, l, h) {
      if (l.count++, l.instance === null)
        switch (l.type) {
          case "style":
            var x = a.querySelector(
              'style[data-href~="' + zt(h.href) + '"]'
            );
            if (x)
              return l.instance = x, Rt(x), x;
            var R = pn({}, h, {
              "data-href": h.href,
              "data-precedence": h.precedence,
              href: null,
              precedence: null
            });
            return x = (a.ownerDocument || a).createElement("style"), Rt(x), no(x, "style", R), bb(x, h.precedence, a), l.instance = x;
          case "stylesheet":
            R = pl(h.href);
            var A = a.querySelector(
              ph(R)
            );
            if (A)
              return l.state.loading |= fc, l.instance = A, Rt(A), A;
            x = zw(h), (R = pc.get(R)) && Bw(x, R), A = (a.ownerDocument || a).createElement("link"), Rt(A);
            var B = A;
            return B._p = new Promise(function(G, ue) {
              B.onload = G, B.onerror = ue;
            }), no(A, "link", x), l.state.loading |= fc, bb(A, h.precedence, a), l.instance = A;
          case "script":
            return A = hd(h.src), (R = a.querySelector(
              Df(A)
            )) ? (l.instance = R, Rt(R), R) : (x = h, (R = pc.get(A)) && (x = pn({}, h), xb(x, R)), a = a.ownerDocument || a, R = a.createElement("script"), Rt(R), no(R, "link", x), a.head.appendChild(R), l.instance = R);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + l.type + '". this is a bug in React.'
            );
        }
      else
        l.type === "stylesheet" && (l.state.loading & fc) === av && (x = l.instance, l.state.loading |= fc, bb(x, h.precedence, a));
      return l.instance;
    }
    function bb(a, l, h) {
      for (var x = h.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), R = x.length ? x[x.length - 1] : null, A = R, B = 0; B < x.length; B++) {
        var G = x[B];
        if (G.dataset.precedence === l) A = G;
        else if (A !== R) break;
      }
      A ? A.parentNode.insertBefore(a, A.nextSibling) : (l = h.nodeType === 9 ? h.head : h, l.insertBefore(a, l.firstChild));
    }
    function Bw(a, l) {
      a.crossOrigin == null && (a.crossOrigin = l.crossOrigin), a.referrerPolicy == null && (a.referrerPolicy = l.referrerPolicy), a.title == null && (a.title = l.title);
    }
    function xb(a, l) {
      a.crossOrigin == null && (a.crossOrigin = l.crossOrigin), a.referrerPolicy == null && (a.referrerPolicy = l.referrerPolicy), a.integrity == null && (a.integrity = l.integrity);
    }
    function Vw(a, l, h) {
      if (vR === null) {
        var x = /* @__PURE__ */ new Map(), R = vR = /* @__PURE__ */ new Map();
        R.set(h, x);
      } else
        R = vR, x = R.get(h), x || (x = /* @__PURE__ */ new Map(), R.set(h, x));
      if (x.has(a)) return x;
      for (x.set(a, null), h = h.getElementsByTagName(a), R = 0; R < h.length; R++) {
        var A = h[R];
        if (!(A[jm] || A[zo] || a === "link" && A.getAttribute("rel") === "stylesheet") && A.namespaceURI !== vu) {
          var B = A.getAttribute(l) || "";
          B = a + B;
          var G = x.get(B);
          G ? G.push(A) : x.set(B, [A]);
        }
      }
      return x;
    }
    function If(a, l, h) {
      a = a.ownerDocument || a, a.head.insertBefore(
        h,
        l === "title" ? a.querySelector("head > title") : null
      );
    }
    function Sb(a, l, h) {
      var x = !h.ancestorInfo.containerTagInScope;
      if (h.context === x0 || l.itemProp != null)
        return !x || l.itemProp == null || a !== "meta" && a !== "title" && a !== "style" && a !== "link" && a !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          a,
          a
        ), !1;
      switch (a) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof l.precedence != "string" || typeof l.href != "string" || l.href === "") {
            x && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof l.rel != "string" || typeof l.href != "string" || l.href === "" || l.onLoad || l.onError) {
            if (l.rel === "stylesheet" && typeof l.precedence == "string") {
              a = l.href;
              var R = l.onError, A = l.disabled;
              h = [], l.onLoad && h.push("`onLoad`"), R && h.push("`onError`"), A != null && h.push("`disabled`"), R = Zn(h, "and"), R += h.length === 1 ? " prop" : " props", A = h.length === 1 ? "an " + R : "the " + R, h.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                a,
                A,
                R
              );
            }
            x && (typeof l.rel != "string" || typeof l.href != "string" || l.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (l.onError || l.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (l.rel) {
            case "stylesheet":
              return a = l.precedence, l = l.disabled, typeof a != "string" && x && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof a == "string" && l == null;
            default:
              return !0;
          }
        case "script":
          if (a = l.async && typeof l.async != "function" && typeof l.async != "symbol", !a || l.onLoad || l.onError || !l.src || typeof l.src != "string") {
            x && (a ? l.onLoad || l.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          x && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            a
          );
      }
      return !1;
    }
    function Uw(a) {
      return !(a.type === "stylesheet" && (a.state.loading & D4) === av);
    }
    function xC() {
    }
    function SC(a, l, h) {
      if (WT === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var x = WT;
      if (l.type === "stylesheet" && (typeof h.media != "string" || matchMedia(h.media).matches !== !1) && (l.state.loading & fc) === av) {
        if (l.instance === null) {
          var R = pl(h.href), A = a.querySelector(
            ph(R)
          );
          if (A) {
            a = A._p, a !== null && typeof a == "object" && typeof a.then == "function" && (x.count++, x = Em.bind(x), a.then(x, x)), l.state.loading |= fc, l.instance = A, Rt(A);
            return;
          }
          A = a.ownerDocument || a, h = zw(h), (R = pc.get(R)) && Bw(h, R), A = A.createElement("link"), Rt(A);
          var B = A;
          B._p = new Promise(function(G, ue) {
            B.onload = G, B.onerror = ue;
          }), no(A, "link", h), l.instance = A;
        }
        x.stylesheets === null && (x.stylesheets = /* @__PURE__ */ new Map()), x.stylesheets.set(l, a), (a = l.state.preload) && (l.state.loading & D4) === av && (x.count++, l = Em.bind(x), a.addEventListener("load", l), a.addEventListener("error", l));
      }
    }
    function wC() {
      if (WT === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var a = WT;
      return a.stylesheets && a.count === 0 && wb(a, a.stylesheets), 0 < a.count ? function(l) {
        var h = setTimeout(function() {
          if (a.stylesheets && wb(a, a.stylesheets), a.unsuspend) {
            var x = a.unsuspend;
            a.unsuspend = null, x();
          }
        }, 6e4);
        return a.unsuspend = l, function() {
          a.unsuspend = null, clearTimeout(h);
        };
      } : null;
    }
    function Em() {
      if (this.count--, this.count === 0) {
        if (this.stylesheets)
          wb(this, this.stylesheets);
        else if (this.unsuspend) {
          var a = this.unsuspend;
          this.unsuspend = null, a();
        }
      }
    }
    function wb(a, l) {
      a.stylesheets = null, a.unsuspend !== null && (a.count++, yR = /* @__PURE__ */ new Map(), l.forEach(Tb, a), yR = null, Em.call(a));
    }
    function Tb(a, l) {
      if (!(l.state.loading & fc)) {
        var h = yR.get(a);
        if (h) var x = h.get(BN);
        else {
          h = /* @__PURE__ */ new Map(), yR.set(a, h);
          for (var R = a.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), A = 0; A < R.length; A++) {
            var B = R[A];
            (B.nodeName === "LINK" || B.getAttribute("media") !== "not all") && (h.set(B.dataset.precedence, B), x = B);
          }
          x && h.set(BN, x);
        }
        R = l.instance, B = R.getAttribute("data-precedence"), A = h.get(B) || x, A === x && h.set(BN, R), h.set(B, R), this.count++, x = Em.bind(this), R.addEventListener("load", x), R.addEventListener("error", x), A ? A.parentNode.insertBefore(R, A.nextSibling) : (a = a.nodeType === 9 ? a.head : a, a.insertBefore(R, a.firstChild)), l.state.loading |= fc;
      }
    }
    function TC(a, l, h, x, R, A, B, G) {
      for (this.tag = 1, this.containerInfo = a, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = ov, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = je(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = je(0), this.hiddenUpdates = je(null), this.identifierPrefix = x, this.onUncaughtError = R, this.onCaughtError = A, this.onRecoverableError = B, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = G, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), a = this.pendingUpdatersLaneMap = [], l = 0; 31 > l; l++) a.push(/* @__PURE__ */ new Set());
      this._debugRootType = h ? "hydrateRoot()" : "createRoot()";
    }
    function Fw(a, l, h, x, R, A, B, G, ue, fe, Xe, nt) {
      return a = new TC(
        a,
        l,
        h,
        B,
        G,
        ue,
        fe,
        nt
      ), l = wpe, A === !0 && (l |= Ma | yu), Ps && (l |= ta), A = S(3, null, null, l), a.current = A, A.stateNode = a, l = CS(), Ts(l), a.pooledCache = l, Ts(l), A.memoizedState = {
        element: x,
        isDehydrated: h,
        cache: l
      }, Yu(A), a;
    }
    function Er(a) {
      return a ? (a = _h, a) : _h;
    }
    function _m(a, l, h, x, R, A) {
      if (wo && typeof wo.onScheduleFiberRoot == "function")
        try {
          wo.onScheduleFiberRoot(Mf, x, h);
        } catch (B) {
          Ci || (Ci = !0, console.error(
            "React instrumentation encountered an error: %s",
            B
          ));
        }
      Pt !== null && typeof Pt.markRenderScheduled == "function" && Pt.markRenderScheduled(l), R = Er(R), x.context === null ? x.context = R : x.pendingContext = R, Jl && To !== null && !j4 && (j4 = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        z(To) || "Unknown"
      )), x = Ks(l), x.payload = { element: h }, A = A === void 0 ? null : A, A !== null && (typeof A != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        A
      ), x.callback = A), h = Qs(a, x, l), h !== null && (Mn(h, a, l), pf(h, a, l));
    }
    function EC(a, l) {
      if (a = a.memoizedState, a !== null && a.dehydrated !== null) {
        var h = a.retryLane;
        a.retryLane = h !== 0 && h < l ? h : l;
      }
    }
    function Eb(a, l) {
      EC(a, l), (a = a.alternate) && EC(a, l);
    }
    function _C(a) {
      if (a.tag === 13) {
        var l = ma(a, 67108864);
        l !== null && Mn(l, a, 67108864), Eb(a, 67108864);
      }
    }
    function MP() {
      return To;
    }
    function jP() {
      for (var a = /* @__PURE__ */ new Map(), l = 1, h = 0; 31 > h; h++) {
        var x = Je(l);
        a.set(l, x), l *= 2;
      }
      return a;
    }
    function _b(a, l, h, x) {
      var R = Ge.T;
      Ge.T = null;
      var A = lr.p;
      try {
        lr.p = rs, Cm(a, l, h, x);
      } finally {
        lr.p = A, Ge.T = R;
      }
    }
    function hh(a, l, h, x) {
      var R = Ge.T;
      Ge.T = null;
      var A = lr.p;
      try {
        lr.p = Ql, Cm(a, l, h, x);
      } finally {
        lr.p = A, Ge.T = R;
      }
    }
    function Cm(a, l, h, x) {
      if (xR) {
        var R = gh(x);
        if (R === null)
          Ja(
            a,
            l,
            x,
            SR,
            h
          ), hl(a, x);
        else if (LP(
          R,
          a,
          l,
          h,
          x
        ))
          x.stopPropagation();
        else if (hl(a, x), l & 4 && -1 < ehe.indexOf(a)) {
          for (; R !== null; ) {
            var A = ct(R);
            if (A !== null)
              switch (A.tag) {
                case 3:
                  if (A = A.stateNode, A.current.memoizedState.isDehydrated) {
                    var B = L(A.pendingLanes);
                    if (B !== 0) {
                      var G = A;
                      for (G.pendingLanes |= 2, G.entangledLanes |= 2; B; ) {
                        var ue = 1 << 31 - ro(B);
                        G.entanglements[1] |= ue, B &= ~ue;
                      }
                      As(A), (mr & (ss | wu)) === yl && (iR = So() + p4, ad(0));
                    }
                  }
                  break;
                case 13:
                  G = ma(A, 2), G !== null && Mn(G, A, 2), _f(), Eb(A, 2);
              }
            if (A = gh(x), A === null && Ja(
              a,
              l,
              x,
              SR,
              h
            ), A === R) break;
            R = A;
          }
          R !== null && x.stopPropagation();
        } else
          Ja(
            a,
            l,
            x,
            null,
            h
          );
      }
    }
    function gh(a) {
      return a = Gs(a), Rm(a);
    }
    function Rm(a) {
      if (SR = null, a = gt(a), a !== null) {
        var l = D(a);
        if (l === null) a = null;
        else {
          var h = l.tag;
          if (h === 13) {
            if (a = P(l), a !== null) return a;
            a = null;
          } else if (h === 3) {
            if (l.stateNode.current.memoizedState.isDehydrated)
              return l.tag === 3 ? l.stateNode.containerInfo : null;
            a = null;
          } else l !== a && (a = null);
        }
      }
      return SR = a, null;
    }
    function gd(a) {
      switch (a) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return rs;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ql;
        case "message":
          switch (DC()) {
            case Nm:
              return rs;
            case Yw:
              return Ql;
            case yh:
            case Xw:
              return gu;
            case Zw:
              return Lb;
            default:
              return gu;
          }
        default:
          return gu;
      }
    }
    function hl(a, l) {
      switch (a) {
        case "focusin":
        case "focusout":
          jh = null;
          break;
        case "dragenter":
        case "dragleave":
          Lh = null;
          break;
        case "mouseover":
        case "mouseout":
          kh = null;
          break;
        case "pointerover":
        case "pointerout":
          qT.delete(l.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          $T.delete(l.pointerId);
      }
    }
    function uu(a, l, h, x, R, A) {
      return a === null || a.nativeEvent !== A ? (a = {
        blockedOn: l,
        domEventName: h,
        eventSystemFlags: x,
        nativeEvent: A,
        targetContainers: [R]
      }, l !== null && (l = ct(l), l !== null && _C(l)), a) : (a.eventSystemFlags |= x, l = a.targetContainers, R !== null && l.indexOf(R) === -1 && l.push(R), a);
    }
    function LP(a, l, h, x, R) {
      switch (l) {
        case "focusin":
          return jh = uu(
            jh,
            a,
            l,
            h,
            x,
            R
          ), !0;
        case "dragenter":
          return Lh = uu(
            Lh,
            a,
            l,
            h,
            x,
            R
          ), !0;
        case "mouseover":
          return kh = uu(
            kh,
            a,
            l,
            h,
            x,
            R
          ), !0;
        case "pointerover":
          var A = R.pointerId;
          return qT.set(
            A,
            uu(
              qT.get(A) || null,
              a,
              l,
              h,
              x,
              R
            )
          ), !0;
        case "gotpointercapture":
          return A = R.pointerId, $T.set(
            A,
            uu(
              $T.get(A) || null,
              a,
              l,
              h,
              x,
              R
            )
          ), !0;
      }
      return !1;
    }
    function Ww(a) {
      var l = gt(a.target);
      if (l !== null) {
        var h = D(l);
        if (h !== null) {
          if (l = h.tag, l === 13) {
            if (l = P(h), l !== null) {
              a.blockedOn = l, _e(a.priority, function() {
                if (h.tag === 13) {
                  var x = Qa(h);
                  x = bt(x);
                  var R = ma(
                    h,
                    x
                  );
                  R !== null && Mn(R, h, x), Eb(h, x);
                }
              });
              return;
            }
          } else if (l === 3 && h.stateNode.current.memoizedState.isDehydrated) {
            a.blockedOn = h.tag === 3 ? h.stateNode.containerInfo : null;
            return;
          }
        }
      }
      a.blockedOn = null;
    }
    function Om(a) {
      if (a.blockedOn !== null) return !1;
      for (var l = a.targetContainers; 0 < l.length; ) {
        var h = gh(a.nativeEvent);
        if (h === null) {
          h = a.nativeEvent;
          var x = new h.constructor(
            h.type,
            h
          ), R = x;
          j !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), j = R, h.target.dispatchEvent(x), j === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), j = null;
        } else
          return l = ct(h), l !== null && _C(l), a.blockedOn = h, !1;
        l.shift();
      }
      return !0;
    }
    function Hw(a, l, h) {
      Om(a) && h.delete(l);
    }
    function CC() {
      VN = !1, jh !== null && Om(jh) && (jh = null), Lh !== null && Om(Lh) && (Lh = null), kh !== null && Om(kh) && (kh = null), qT.forEach(Hw), $T.forEach(Hw);
    }
    function Cb(a, l) {
      a.blockedOn === l && (a.blockedOn = null, VN || (VN = !0, Si.unstable_scheduleCallback(
        Si.unstable_NormalPriority,
        CC
      )));
    }
    function Rb(a) {
      wR !== a && (wR = a, Si.unstable_scheduleCallback(
        Si.unstable_NormalPriority,
        function() {
          wR === a && (wR = null);
          for (var l = 0; l < a.length; l += 3) {
            var h = a[l], x = a[l + 1], R = a[l + 2];
            if (typeof x != "function") {
              if (Rm(x || h) === null)
                continue;
              break;
            }
            var A = ct(h);
            A !== null && (a.splice(l, 3), l -= 3, h = {
              pending: !0,
              data: R,
              method: h.method,
              action: x
            }, Object.freeze(h), By(
              A,
              h,
              x,
              R
            ));
          }
        }
      ));
    }
    function mh(a) {
      function l(ue) {
        return Cb(ue, a);
      }
      jh !== null && Cb(jh, a), Lh !== null && Cb(Lh, a), kh !== null && Cb(kh, a), qT.forEach(l), $T.forEach(l);
      for (var h = 0; h < zh.length; h++) {
        var x = zh[h];
        x.blockedOn === a && (x.blockedOn = null);
      }
      for (; 0 < zh.length && (h = zh[0], h.blockedOn === null); )
        Ww(h), h.blockedOn === null && zh.shift();
      if (h = (a.ownerDocument || a).$$reactFormReplay, h != null)
        for (x = 0; x < h.length; x += 3) {
          var R = h[x], A = h[x + 1], B = R[Na] || null;
          if (typeof A == "function")
            B || Rb(h);
          else if (B) {
            var G = null;
            if (A && A.hasAttribute("formAction")) {
              if (R = A, B = A[Na] || null)
                G = B.formAction;
              else if (Rm(R) !== null) continue;
            } else G = B.action;
            typeof G == "function" ? h[x + 1] = G : (h.splice(x, 3), x -= 3), Rb(h);
          }
        }
    }
    function Ob(a) {
      this._internalRoot = a;
    }
    function Ab(a) {
      this._internalRoot = a;
    }
    function Db(a) {
      a[xd] && (a._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Si = wJ(), qw = it, kP = Pd, pn = Object.assign, zP = Symbol.for("react.element"), du = Symbol.for("react.transitional.element"), bn = Symbol.for("react.portal"), md = Symbol.for("react.fragment"), Pf = Symbol.for("react.strict_mode"), Am = Symbol.for("react.profiler"), RC = Symbol.for("react.provider"), Dm = Symbol.for("react.consumer"), Pa = Symbol.for("react.context"), vd = Symbol.for("react.forward_ref"), yd = Symbol.for("react.suspense"), Ib = Symbol.for("react.suspense_list"), Pb = Symbol.for("react.memo"), ns = Symbol.for("react.lazy"), Nb = Symbol.for("react.activity"), OC = Symbol.for("react.memo_cache_sentinel"), Im = Symbol.iterator, _r = Symbol.for("react.client.reference"), qi = Array.isArray, Ge = qw.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, lr = kP.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $w = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), Pm = [], vh = [], Xl = -1, fu = V(null), Nf = V(null), Zl = V(null), Mb = V(null), Kl = Object.prototype.hasOwnProperty, Gw = Si.unstable_scheduleCallback, AC = Si.unstable_cancelCallback, BP = Si.unstable_shouldYield, VP = Si.unstable_requestPaint, So = Si.unstable_now, DC = Si.unstable_getCurrentPriorityLevel, Nm = Si.unstable_ImmediatePriority, Yw = Si.unstable_UserBlockingPriority, yh = Si.unstable_NormalPriority, Xw = Si.unstable_LowPriority, Zw = Si.unstable_IdlePriority, gl = Si.log, Kw = Si.unstable_setDisableYieldValue, Mf = null, wo = null, Pt = null, Ci = !1, Ps = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", ro = Math.clz32 ? Math.clz32 : Te, pu = Math.log, UP = Math.LN2, jb = 256, hu = 4194304, rs = 2, Ql = 8, gu = 32, Lb = 268435456, bd = Math.random().toString(36).slice(2), zo = "__reactFiber$" + bd, Na = "__reactProps$" + bd, xd = "__reactContainer$" + bd, kb = "__reactEvents$" + bd, bh = "__reactListeners$" + bd, Mm = "__reactHandles$" + bd, Qw = "__reactResources$" + bd, jm = "__reactMarker$" + bd, jf = /* @__PURE__ */ new Set(), ml = {}, zb = {}, Bb = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, Jw = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Vb = {}, Lm = {}, xh = 0, eT, IC, tT, Sh, PC, NC, MC;
    ei.__reactDisabledLog = !0;
    var wh, km, zm = !1, nT = new (typeof WeakMap == "function" ? WeakMap : Map)(), To = null, Jl = !1, jC = /[\n"\\]/g, rT = !1, iT = !1, oT = !1, Ub = !1, aT = !1, Bm = !1, LC = ["value", "defaultValue"], kC = !1, Fb = /["'&<>\n\t]|^\s|\s$/, sT = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), Vm = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), lT = Vm.concat(["button"]), zC = "dd dt li option optgroup p rp rt".split(" "), Wb = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, vl = {}, ec = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, mu = /([A-Z])/g, Th = /^ms-/, Um = /^(?:webkit|moz|o)[A-Z]/, Sd = /^-ms-/, FP = /-(.)/g, cT = /;\s*$/, tc = {}, uT = {}, dT = !1, Fm = !1, fT = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), Hb = "http://www.w3.org/1998/Math/MathML", vu = "http://www.w3.org/2000/svg", qb = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Wm = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Eh = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, wd = {}, $b = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), BC = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), VC = !1, io = {}, d = /^on./, g = /^on[^A-Z]/, b = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), C = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), I = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, j = null, K = null, se = null, xe = !1, ze = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), ut = !1;
    if (ze)
      try {
        var pt = {};
        Object.defineProperty(pt, "passive", {
          get: function() {
            ut = !0;
          }
        }), window.addEventListener("test", pt, pt), window.removeEventListener("test", pt, pt);
      } catch {
        ut = !1;
      }
    var He = null, Ze = null, on = null, en = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(a) {
        return a.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, cr = yo(en), Me = pn({}, en, { view: 0, detail: 0 }), Oe = yo(Me), Ve, ft, Bt, En = pn({}, Me, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Mo,
      button: 0,
      buttons: 0,
      relatedTarget: function(a) {
        return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
      },
      movementX: function(a) {
        return "movementX" in a ? a.movementX : (a !== Bt && (Bt && a.type === "mousemove" ? (Ve = a.screenX - Bt.screenX, ft = a.screenY - Bt.screenY) : ft = Ve = 0, Bt = a), Ve);
      },
      movementY: function(a) {
        return "movementY" in a ? a.movementY : ft;
      }
    }), Qt = yo(En), sn = pn({}, En, { dataTransfer: 0 }), oo = yo(sn), or = pn({}, Me, { relatedTarget: 0 }), nc = yo(or), WP = pn({}, en, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Zfe = yo(WP), Kfe = pn({}, en, {
      clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
      }
    }), Qfe = yo(Kfe), Jfe = pn({}, en, { data: 0 }), YH = yo(
      Jfe
    ), epe = YH, tpe = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, npe = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, rpe = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, ipe = pn({}, Me, {
      key: function(a) {
        if (a.key) {
          var l = tpe[a.key] || a.key;
          if (l !== "Unidentified") return l;
        }
        return a.type === "keypress" ? (a = nf(a), a === 13 ? "Enter" : String.fromCharCode(a)) : a.type === "keydown" || a.type === "keyup" ? npe[a.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Mo,
      charCode: function(a) {
        return a.type === "keypress" ? nf(a) : 0;
      },
      keyCode: function(a) {
        return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      },
      which: function(a) {
        return a.type === "keypress" ? nf(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      }
    }), ope = yo(ipe), ape = pn({}, En, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), XH = yo(ape), spe = pn({}, Me, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Mo
    }), lpe = yo(spe), cpe = pn({}, en, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), upe = yo(cpe), dpe = pn({}, En, {
      deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
      },
      deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), fpe = yo(dpe), ppe = pn({}, en, {
      newState: 0,
      oldState: 0
    }), hpe = yo(ppe), gpe = [9, 13, 27, 32], ZH = 229, HP = ze && "CompositionEvent" in window, pT = null;
    ze && "documentMode" in document && (pT = document.documentMode);
    var mpe = ze && "TextEvent" in window && !pT, KH = ze && (!HP || pT && 8 < pT && 11 >= pT), QH = 32, JH = String.fromCharCode(QH), e5 = !1, Gb = !1, vpe = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, hT = null, gT = null, t5 = !1;
    ze && (t5 = pS("input") && (!document.documentMode || 9 < document.documentMode));
    var is = typeof Object.is == "function" ? Object.is : OP, ype = ze && "documentMode" in document && 11 >= document.documentMode, Yb = null, qP = null, mT = null, $P = !1, Xb = {
      animationend: rf("Animation", "AnimationEnd"),
      animationiteration: rf("Animation", "AnimationIteration"),
      animationstart: rf("Animation", "AnimationStart"),
      transitionrun: rf("Transition", "TransitionRun"),
      transitionstart: rf("Transition", "TransitionStart"),
      transitioncancel: rf("Transition", "TransitionCancel"),
      transitionend: rf("Transition", "TransitionEnd")
    }, GP = {}, n5 = {};
    ze && (n5 = document.createElement("div").style, "AnimationEvent" in window || (delete Xb.animationend.animation, delete Xb.animationiteration.animation, delete Xb.animationstart.animation), "TransitionEvent" in window || delete Xb.transitionend.transition);
    var r5 = of("animationend"), i5 = of("animationiteration"), o5 = of("animationstart"), bpe = of("transitionrun"), xpe = of("transitionstart"), Spe = of("transitioncancel"), a5 = of("transitionend"), s5 = /* @__PURE__ */ new Map(), YP = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    YP.push("scrollEnd");
    var XP = /* @__PURE__ */ new WeakMap(), UC = 1, Lf = 2, rc = [], Zb = 0, ZP = 0, _h = {};
    Object.freeze(_h);
    var ic = null, Kb = null, ri = 0, wpe = 1, ta = 2, Ma = 8, yu = 16, l5 = 64, c5 = !1;
    try {
      var u5 = Object.preventExtensions({});
    } catch {
      c5 = !0;
    }
    var Qb = [], Jb = 0, FC = null, WC = 0, oc = [], ac = 0, Hm = null, kf = 1, zf = "", os = null, ji = null, ar = !1, Bf = !1, sc = null, qm = null, Td = !1, KP = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), d5 = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var Tpe = performance, f5 = function() {
        return Tpe.now();
      };
    else {
      var Epe = Date;
      f5 = function() {
        return Epe.now();
      };
    }
    var QP = V(null), JP = V(null), p5 = {}, HC = null, e0 = null, t0 = !1, _pe = typeof AbortController < "u" ? AbortController : function() {
      var a = [], l = this.signal = {
        aborted: !1,
        addEventListener: function(h, x) {
          a.push(x);
        }
      };
      this.abort = function() {
        l.aborted = !0, a.forEach(function(h) {
          return h();
        });
      };
    }, Cpe = Si.unstable_scheduleCallback, Rpe = Si.unstable_NormalPriority, Eo = {
      $$typeof: Pa,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, n0 = Si.unstable_now, h5 = -0, qC = -0, Ns = -1.1, $m = -0, $C = !1, GC = !1, vT = null, eN = 0, Gm = 0, r0 = null, g5 = Ge.S;
    Ge.S = function(a, l) {
      typeof l == "object" && l !== null && typeof l.then == "function" && Y_(a, l), g5 !== null && g5(a, l);
    };
    var Ym = V(null), bu = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, yT = [], bT = [], xT = [], ST = [], wT = [], TT = [], Xm = /* @__PURE__ */ new Set();
    bu.recordUnsafeLifecycleWarnings = function(a, l) {
      Xm.has(a.type) || (typeof l.componentWillMount == "function" && l.componentWillMount.__suppressDeprecationWarning !== !0 && yT.push(a), a.mode & Ma && typeof l.UNSAFE_componentWillMount == "function" && bT.push(a), typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && xT.push(a), a.mode & Ma && typeof l.UNSAFE_componentWillReceiveProps == "function" && ST.push(a), typeof l.componentWillUpdate == "function" && l.componentWillUpdate.__suppressDeprecationWarning !== !0 && wT.push(a), a.mode & Ma && typeof l.UNSAFE_componentWillUpdate == "function" && TT.push(a));
    }, bu.flushPendingUnsafeLifecycleWarnings = function() {
      var a = /* @__PURE__ */ new Set();
      0 < yT.length && (yT.forEach(function(G) {
        a.add(
          z(G) || "Component"
        ), Xm.add(G.type);
      }), yT = []);
      var l = /* @__PURE__ */ new Set();
      0 < bT.length && (bT.forEach(function(G) {
        l.add(
          z(G) || "Component"
        ), Xm.add(G.type);
      }), bT = []);
      var h = /* @__PURE__ */ new Set();
      0 < xT.length && (xT.forEach(function(G) {
        h.add(
          z(G) || "Component"
        ), Xm.add(G.type);
      }), xT = []);
      var x = /* @__PURE__ */ new Set();
      0 < ST.length && (ST.forEach(
        function(G) {
          x.add(
            z(G) || "Component"
          ), Xm.add(G.type);
        }
      ), ST = []);
      var R = /* @__PURE__ */ new Set();
      0 < wT.length && (wT.forEach(function(G) {
        R.add(
          z(G) || "Component"
        ), Xm.add(G.type);
      }), wT = []);
      var A = /* @__PURE__ */ new Set();
      if (0 < TT.length && (TT.forEach(function(G) {
        A.add(
          z(G) || "Component"
        ), Xm.add(G.type);
      }), TT = []), 0 < l.size) {
        var B = y(
          l
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          B
        );
      }
      0 < x.size && (B = y(
        x
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        B
      )), 0 < A.size && (B = y(
        A
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        B
      )), 0 < a.size && (B = y(a), console.warn(
        `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        B
      )), 0 < h.size && (B = y(
        h
      ), console.warn(
        `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        B
      )), 0 < R.size && (B = y(R), console.warn(
        `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        B
      ));
    };
    var YC = /* @__PURE__ */ new Map(), m5 = /* @__PURE__ */ new Set();
    bu.recordLegacyContextWarning = function(a, l) {
      for (var h = null, x = a; x !== null; )
        x.mode & Ma && (h = x), x = x.return;
      h === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !m5.has(a.type) && (x = YC.get(h), a.type.contextTypes != null || a.type.childContextTypes != null || l !== null && typeof l.getChildContext == "function") && (x === void 0 && (x = [], YC.set(h, x)), x.push(a));
    }, bu.flushLegacyContextWarning = function() {
      YC.forEach(function(a) {
        if (a.length !== 0) {
          var l = a[0], h = /* @__PURE__ */ new Set();
          a.forEach(function(R) {
            h.add(z(R) || "Component"), m5.add(R.type);
          });
          var x = y(h);
          _t(l, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              x
            );
          });
        }
      });
    }, bu.discardPendingWarnings = function() {
      yT = [], bT = [], xT = [], ST = [], wT = [], TT = [], YC = /* @__PURE__ */ new Map();
    };
    var ET = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), v5 = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), XC = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), tN = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, _T = null, ZC = !1, lc = 0, cc = 1, as = 2, na = 4, _o = 8, y5 = 0, b5 = 1, x5 = 2, nN = 3, Ch = !1, S5 = !1, rN = null, iN = !1, i0 = V(null), KC = V(0), o0, w5 = /* @__PURE__ */ new Set(), T5 = /* @__PURE__ */ new Set(), oN = /* @__PURE__ */ new Set(), E5 = /* @__PURE__ */ new Set(), Rh = 0, hn = null, Br = null, ao = null, QC = !1, a0 = !1, Zm = !1, JC = 0, CT = 0, Vf = null, Ope = 0, Ape = 25, tt = null, uc = null, Uf = -1, RT = !1, eR = {
      readContext: qr,
      use: vi,
      useCallback: zr,
      useContext: zr,
      useEffect: zr,
      useImperativeHandle: zr,
      useLayoutEffect: zr,
      useInsertionEffect: zr,
      useMemo: zr,
      useReducer: zr,
      useRef: zr,
      useState: zr,
      useDebugValue: zr,
      useDeferredValue: zr,
      useTransition: zr,
      useSyncExternalStore: zr,
      useId: zr,
      useHostTransitionStatus: zr,
      useFormState: zr,
      useActionState: zr,
      useOptimistic: zr,
      useMemoCache: zr,
      useCacheRefresh: zr
    }, aN = null, _5 = null, sN = null, C5 = null, Ed = null, xu = null, tR = null;
    aN = {
      readContext: function(a) {
        return qr(a);
      },
      use: vi,
      useCallback: function(a, l) {
        return tt = "useCallback", wn(), Zu(l), Up(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", wn(), qr(a);
      },
      useEffect: function(a, l) {
        return tt = "useEffect", wn(), Zu(l), Zg(a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", wn(), Zu(h), Zc(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        tt = "useInsertionEffect", wn(), Zu(l), _s(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", wn(), Zu(l), jS(a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", wn(), Zu(l);
        var h = Ge.H;
        Ge.H = Ed;
        try {
          return mf(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", wn();
        var x = Ge.H;
        Ge.H = Ed;
        try {
          return Yc(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function(a) {
        return tt = "useRef", wn(), ed(a);
      },
      useState: function(a) {
        tt = "useState", wn();
        var l = Ge.H;
        Ge.H = Ed;
        try {
          return rl(a);
        } finally {
          Ge.H = l;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", wn();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", wn(), Fp(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", wn(), Jg();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", wn(), Ny(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", wn(), vf();
      },
      useFormState: function(a, l) {
        return tt = "useFormState", wn(), Pp(), zp(a, l);
      },
      useActionState: function(a, l) {
        return tt = "useActionState", wn(), zp(a, l);
      },
      useOptimistic: function(a) {
        return tt = "useOptimistic", wn(), Wl(a);
      },
      useHostTransitionStatus: Sa,
      useMemoCache: Sr,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", wn(), em();
      }
    }, _5 = {
      readContext: function(a) {
        return qr(a);
      },
      use: vi,
      useCallback: function(a, l) {
        return tt = "useCallback", xt(), Up(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", xt(), qr(a);
      },
      useEffect: function(a, l) {
        return tt = "useEffect", xt(), Zg(a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", xt(), Zc(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        tt = "useInsertionEffect", xt(), _s(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", xt(), jS(a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", xt();
        var h = Ge.H;
        Ge.H = Ed;
        try {
          return mf(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", xt();
        var x = Ge.H;
        Ge.H = Ed;
        try {
          return Yc(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function(a) {
        return tt = "useRef", xt(), ed(a);
      },
      useState: function(a) {
        tt = "useState", xt();
        var l = Ge.H;
        Ge.H = Ed;
        try {
          return rl(a);
        } finally {
          Ge.H = l;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", xt();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", xt(), Fp(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", xt(), Jg();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", xt(), Ny(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", xt(), vf();
      },
      useActionState: function(a, l) {
        return tt = "useActionState", xt(), zp(a, l);
      },
      useFormState: function(a, l) {
        return tt = "useFormState", xt(), Pp(), zp(a, l);
      },
      useOptimistic: function(a) {
        return tt = "useOptimistic", xt(), Wl(a);
      },
      useHostTransitionStatus: Sa,
      useMemoCache: Sr,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", xt(), em();
      }
    }, sN = {
      readContext: function(a) {
        return qr(a);
      },
      use: vi,
      useCallback: function(a, l) {
        return tt = "useCallback", xt(), Kg(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", xt(), qr(a);
      },
      useEffect: function(a, l) {
        tt = "useEffect", xt(), xa(2048, _o, a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", xt(), Vp(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        return tt = "useInsertionEffect", xt(), xa(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", xt(), xa(4, na, a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", xt();
        var h = Ge.H;
        Ge.H = xu;
        try {
          return Qg(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", xt();
        var x = Ge.H;
        Ge.H = xu;
        try {
          return Qo(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function() {
        return tt = "useRef", xt(), dr().memoizedState;
      },
      useState: function() {
        tt = "useState", xt();
        var a = Ge.H;
        Ge.H = xu;
        try {
          return Qo(Tn);
        } finally {
          Ge.H = a;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", xt();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", xt(), zy(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", xt(), Vy();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", xt(), Gg(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", xt(), dr().memoizedState;
      },
      useFormState: function(a) {
        return tt = "useFormState", xt(), Pp(), ky(a);
      },
      useActionState: function(a) {
        return tt = "useActionState", xt(), ky(a);
      },
      useOptimistic: function(a, l) {
        return tt = "useOptimistic", xt(), Hl(a, l);
      },
      useHostTransitionStatus: Sa,
      useMemoCache: Sr,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", xt(), dr().memoizedState;
      }
    }, C5 = {
      readContext: function(a) {
        return qr(a);
      },
      use: vi,
      useCallback: function(a, l) {
        return tt = "useCallback", xt(), Kg(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", xt(), qr(a);
      },
      useEffect: function(a, l) {
        tt = "useEffect", xt(), xa(2048, _o, a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", xt(), Vp(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        return tt = "useInsertionEffect", xt(), xa(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", xt(), xa(4, na, a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", xt();
        var h = Ge.H;
        Ge.H = tR;
        try {
          return Qg(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", xt();
        var x = Ge.H;
        Ge.H = tR;
        try {
          return nl(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function() {
        return tt = "useRef", xt(), dr().memoizedState;
      },
      useState: function() {
        tt = "useState", xt();
        var a = Ge.H;
        Ge.H = tR;
        try {
          return nl(Tn);
        } finally {
          Ge.H = a;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", xt();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", xt(), kS(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", xt(), Qc();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", xt(), Gg(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", xt(), dr().memoizedState;
      },
      useFormState: function(a) {
        return tt = "useFormState", xt(), Pp(), Ju(a);
      },
      useActionState: function(a) {
        return tt = "useActionState", xt(), Ju(a);
      },
      useOptimistic: function(a, l) {
        return tt = "useOptimistic", xt(), Ly(a, l);
      },
      useHostTransitionStatus: Sa,
      useMemoCache: Sr,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", xt(), dr().memoizedState;
      }
    }, Ed = {
      readContext: function(a) {
        return m(), qr(a);
      },
      use: function(a) {
        return p(), vi(a);
      },
      useCallback: function(a, l) {
        return tt = "useCallback", p(), wn(), Up(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", p(), wn(), qr(a);
      },
      useEffect: function(a, l) {
        return tt = "useEffect", p(), wn(), Zg(a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", p(), wn(), Zc(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        tt = "useInsertionEffect", p(), wn(), _s(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", p(), wn(), jS(a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", p(), wn();
        var h = Ge.H;
        Ge.H = Ed;
        try {
          return mf(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", p(), wn();
        var x = Ge.H;
        Ge.H = Ed;
        try {
          return Yc(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function(a) {
        return tt = "useRef", p(), wn(), ed(a);
      },
      useState: function(a) {
        tt = "useState", p(), wn();
        var l = Ge.H;
        Ge.H = Ed;
        try {
          return rl(a);
        } finally {
          Ge.H = l;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", p(), wn();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", p(), wn(), Fp(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", p(), wn(), Jg();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", p(), wn(), Ny(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", p(), wn(), vf();
      },
      useFormState: function(a, l) {
        return tt = "useFormState", p(), wn(), zp(a, l);
      },
      useActionState: function(a, l) {
        return tt = "useActionState", p(), wn(), zp(a, l);
      },
      useOptimistic: function(a) {
        return tt = "useOptimistic", p(), wn(), Wl(a);
      },
      useMemoCache: function(a) {
        return p(), Sr(a);
      },
      useHostTransitionStatus: Sa,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", wn(), em();
      }
    }, xu = {
      readContext: function(a) {
        return m(), qr(a);
      },
      use: function(a) {
        return p(), vi(a);
      },
      useCallback: function(a, l) {
        return tt = "useCallback", p(), xt(), Kg(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", p(), xt(), qr(a);
      },
      useEffect: function(a, l) {
        tt = "useEffect", p(), xt(), xa(2048, _o, a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", p(), xt(), Vp(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        return tt = "useInsertionEffect", p(), xt(), xa(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", p(), xt(), xa(4, na, a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", p(), xt();
        var h = Ge.H;
        Ge.H = xu;
        try {
          return Qg(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", p(), xt();
        var x = Ge.H;
        Ge.H = xu;
        try {
          return Qo(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function() {
        return tt = "useRef", p(), xt(), dr().memoizedState;
      },
      useState: function() {
        tt = "useState", p(), xt();
        var a = Ge.H;
        Ge.H = xu;
        try {
          return Qo(Tn);
        } finally {
          Ge.H = a;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", p(), xt();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", p(), xt(), zy(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", p(), xt(), Vy();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", p(), xt(), Gg(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", p(), xt(), dr().memoizedState;
      },
      useFormState: function(a) {
        return tt = "useFormState", p(), xt(), ky(a);
      },
      useActionState: function(a) {
        return tt = "useActionState", p(), xt(), ky(a);
      },
      useOptimistic: function(a, l) {
        return tt = "useOptimistic", p(), xt(), Hl(a, l);
      },
      useMemoCache: function(a) {
        return p(), Sr(a);
      },
      useHostTransitionStatus: Sa,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", xt(), dr().memoizedState;
      }
    }, tR = {
      readContext: function(a) {
        return m(), qr(a);
      },
      use: function(a) {
        return p(), vi(a);
      },
      useCallback: function(a, l) {
        return tt = "useCallback", p(), xt(), Kg(a, l);
      },
      useContext: function(a) {
        return tt = "useContext", p(), xt(), qr(a);
      },
      useEffect: function(a, l) {
        tt = "useEffect", p(), xt(), xa(2048, _o, a, l);
      },
      useImperativeHandle: function(a, l, h) {
        return tt = "useImperativeHandle", p(), xt(), Vp(a, l, h);
      },
      useInsertionEffect: function(a, l) {
        return tt = "useInsertionEffect", p(), xt(), xa(4, as, a, l);
      },
      useLayoutEffect: function(a, l) {
        return tt = "useLayoutEffect", p(), xt(), xa(4, na, a, l);
      },
      useMemo: function(a, l) {
        tt = "useMemo", p(), xt();
        var h = Ge.H;
        Ge.H = xu;
        try {
          return Qg(a, l);
        } finally {
          Ge.H = h;
        }
      },
      useReducer: function(a, l, h) {
        tt = "useReducer", p(), xt();
        var x = Ge.H;
        Ge.H = xu;
        try {
          return nl(a, l, h);
        } finally {
          Ge.H = x;
        }
      },
      useRef: function() {
        return tt = "useRef", p(), xt(), dr().memoizedState;
      },
      useState: function() {
        tt = "useState", p(), xt();
        var a = Ge.H;
        Ge.H = xu;
        try {
          return nl(Tn);
        } finally {
          Ge.H = a;
        }
      },
      useDebugValue: function() {
        tt = "useDebugValue", p(), xt();
      },
      useDeferredValue: function(a, l) {
        return tt = "useDeferredValue", p(), xt(), kS(a, l);
      },
      useTransition: function() {
        return tt = "useTransition", p(), xt(), Qc();
      },
      useSyncExternalStore: function(a, l, h) {
        return tt = "useSyncExternalStore", p(), xt(), Gg(
          a,
          l,
          h
        );
      },
      useId: function() {
        return tt = "useId", p(), xt(), dr().memoizedState;
      },
      useFormState: function(a) {
        return tt = "useFormState", p(), xt(), Ju(a);
      },
      useActionState: function(a) {
        return tt = "useActionState", p(), xt(), Ju(a);
      },
      useOptimistic: function(a, l) {
        return tt = "useOptimistic", p(), xt(), Ly(a, l);
      },
      useMemoCache: function(a) {
        return p(), Sr(a);
      },
      useHostTransitionStatus: Sa,
      useCacheRefresh: function() {
        return tt = "useCacheRefresh", xt(), dr().memoizedState;
      }
    };
    var R5 = {
      react_stack_bottom_frame: function(a, l, h) {
        var x = Jl;
        Jl = !0;
        try {
          return a(l, h);
        } finally {
          Jl = x;
        }
      }
    }, lN = R5.react_stack_bottom_frame.bind(R5), O5 = {
      react_stack_bottom_frame: function(a) {
        var l = Jl;
        Jl = !0;
        try {
          return a.render();
        } finally {
          Jl = l;
        }
      }
    }, A5 = O5.react_stack_bottom_frame.bind(O5), D5 = {
      react_stack_bottom_frame: function(a, l) {
        try {
          l.componentDidMount();
        } catch (h) {
          wr(a, a.return, h);
        }
      }
    }, cN = D5.react_stack_bottom_frame.bind(
      D5
    ), I5 = {
      react_stack_bottom_frame: function(a, l, h, x, R) {
        try {
          l.componentDidUpdate(h, x, R);
        } catch (A) {
          wr(a, a.return, A);
        }
      }
    }, P5 = I5.react_stack_bottom_frame.bind(
      I5
    ), N5 = {
      react_stack_bottom_frame: function(a, l) {
        var h = l.stack;
        a.componentDidCatch(l.value, {
          componentStack: h !== null ? h : ""
        });
      }
    }, Dpe = N5.react_stack_bottom_frame.bind(
      N5
    ), M5 = {
      react_stack_bottom_frame: function(a, l, h) {
        try {
          h.componentWillUnmount();
        } catch (x) {
          wr(a, l, x);
        }
      }
    }, j5 = M5.react_stack_bottom_frame.bind(
      M5
    ), L5 = {
      react_stack_bottom_frame: function(a) {
        a.resourceKind != null && console.error(
          "Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s",
          a.resourceKind
        );
        var l = a.create;
        return a = a.inst, l = l(), a.destroy = l;
      }
    }, Ipe = L5.react_stack_bottom_frame.bind(L5), k5 = {
      react_stack_bottom_frame: function(a, l, h) {
        try {
          h();
        } catch (x) {
          wr(a, l, x);
        }
      }
    }, Ppe = k5.react_stack_bottom_frame.bind(k5), z5 = {
      react_stack_bottom_frame: function(a) {
        var l = a._init;
        return l(a._payload);
      }
    }, Oh = z5.react_stack_bottom_frame.bind(z5), s0 = null, OT = 0, In = null, uN, B5 = uN = !1, V5 = {}, U5 = {}, F5 = {};
    f = function(a, l, h) {
      if (h !== null && typeof h == "object" && h._store && (!h._store.validated && h.key == null || h._store.validated === 2)) {
        if (typeof h._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        h._store.validated = 1;
        var x = z(a), R = x || "null";
        if (!V5[R]) {
          V5[R] = !0, h = h._owner, a = a._debugOwner;
          var A = "";
          a && typeof a.tag == "number" && (R = z(a)) && (A = `

Check the render method of \`` + R + "`."), A || x && (A = `

Check the top-level render call using <` + x + ">.");
          var B = "";
          h != null && a !== h && (x = null, typeof h.tag == "number" ? x = z(h) : typeof h.name == "string" && (x = h.name), x && (B = " It was passed a child from " + x + ".")), _t(l, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              A,
              B
            );
          });
        }
      }
    };
    var l0 = bf(!0), W5 = bf(!1), dc = V(null), _d = null, c0 = 1, AT = 2, Co = V(0), H5 = {}, q5 = /* @__PURE__ */ new Set(), $5 = /* @__PURE__ */ new Set(), G5 = /* @__PURE__ */ new Set(), Y5 = /* @__PURE__ */ new Set(), X5 = /* @__PURE__ */ new Set(), Z5 = /* @__PURE__ */ new Set(), K5 = /* @__PURE__ */ new Set(), Q5 = /* @__PURE__ */ new Set(), J5 = /* @__PURE__ */ new Set(), e4 = /* @__PURE__ */ new Set();
    Object.freeze(H5);
    var dN = {
      enqueueSetState: function(a, l, h) {
        a = a._reactInternals;
        var x = Qa(a), R = Ks(x);
        R.payload = l, h != null && (ci(h), R.callback = h), l = Qs(a, R, x), l !== null && (Mn(l, a, x), pf(l, a, x)), rt(a, x);
      },
      enqueueReplaceState: function(a, l, h) {
        a = a._reactInternals;
        var x = Qa(a), R = Ks(x);
        R.tag = b5, R.payload = l, h != null && (ci(h), R.callback = h), l = Qs(a, R, x), l !== null && (Mn(l, a, x), pf(l, a, x)), rt(a, x);
      },
      enqueueForceUpdate: function(a, l) {
        a = a._reactInternals;
        var h = Qa(a), x = Ks(h);
        x.tag = x5, l != null && (ci(l), x.callback = l), l = Qs(a, x, h), l !== null && (Mn(l, a, h), pf(l, a, h)), Pt !== null && typeof Pt.markForceUpdateScheduled == "function" && Pt.markForceUpdateScheduled(a, h);
      }
    }, fN = typeof reportError == "function" ? reportError : function(a) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var l = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof a == "object" && a !== null && typeof a.message == "string" ? String(a.message) : String(a),
          error: a
        });
        if (!window.dispatchEvent(l)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", a);
        return;
      }
      console.error(a);
    }, u0 = null, pN = null, t4 = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), Bo = !1, n4 = {}, r4 = {}, i4 = {}, o4 = {}, d0 = !1, a4 = {}, hN = {}, gN = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, s4 = !1, l4 = null;
    l4 = /* @__PURE__ */ new Set();
    var Ff = !1, $i = !1, mN = !1, c4 = typeof WeakSet == "function" ? WeakSet : Set, Vo = null, f0 = null, p0 = null, so = null, Ms = !1, Su = null, DT = 8192, Npe = {
      getCacheForType: function(a) {
        var l = qr(Eo), h = l.data.get(a);
        return h === void 0 && (h = a(), l.data.set(a, h)), h;
      },
      getOwner: function() {
        return To;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var IT = Symbol.for;
      IT("selector.component"), IT("selector.has_pseudo_class"), IT("selector.role"), IT("selector.test_id"), IT("selector.text");
    }
    var Mpe = [], jpe = typeof WeakMap == "function" ? WeakMap : Map, yl = 0, ss = 2, wu = 4, Wf = 0, PT = 1, h0 = 2, vN = 3, Km = 4, nR = 6, u4 = 5, mr = yl, Xr = null, Vn = null, Fn = 0, js = 0, NT = 1, Qm = 2, MT = 3, d4 = 4, yN = 5, g0 = 6, jT = 7, bN = 8, Jm = 9, Cr = js, bl = null, Ah = !1, m0 = !1, xN = !1, Cd = 0, Li = Wf, Dh = 0, Ih = 0, SN = 0, xl = 0, ev = 0, LT = null, ls = null, rR = !1, wN = 0, f4 = 300, iR = 1 / 0, p4 = 500, kT = null, Ph = null, Lpe = 0, kpe = 1, zpe = 2, tv = 0, h4 = 1, g4 = 2, m4 = 3, Bpe = 4, TN = 5, ra = 0, Nh = null, v0 = null, Mh = 0, EN = 0, _N = null, v4 = null, Vpe = 50, zT = 0, CN = null, RN = !1, oR = !1, Upe = 50, nv = 0, BT = null, y0 = !1, aR = null, y4 = !1, b4 = /* @__PURE__ */ new Set(), Fpe = {}, sR = null, b0 = null, ON = !1, AN = !1, lR = !1, DN = !1, rv = 0, IN = {};
    (function() {
      for (var a = 0; a < YP.length; a++) {
        var l = YP[a], h = l.toLowerCase();
        l = l[0].toUpperCase() + l.slice(1), Ys(h, "on" + l);
      }
      Ys(r5, "onAnimationEnd"), Ys(i5, "onAnimationIteration"), Ys(o5, "onAnimationStart"), Ys("dblclick", "onDoubleClick"), Ys("focusin", "onFocus"), Ys("focusout", "onBlur"), Ys(bpe, "onTransitionRun"), Ys(xpe, "onTransitionStart"), Ys(Spe, "onTransitionCancel"), Ys(a5, "onTransitionEnd");
    })(), Kt("onMouseEnter", ["mouseout", "mouseover"]), Kt("onMouseLeave", ["mouseout", "mouseover"]), Kt("onPointerEnter", ["pointerout", "pointerover"]), Kt("onPointerLeave", ["pointerout", "pointerover"]), cn(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), cn(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), cn("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), cn(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), cn(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), cn(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var VT = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), PN = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(VT)
    ), cR = "_reactListening" + Math.random().toString(36).slice(2), x4 = !1, S4 = !1, uR = !1, w4 = !1, dR = !1, fR = !1, T4 = !1, pR = {}, Wpe = /\r\n?/g, Hpe = /\u0000|\uFFFD/g, iv = "http://www.w3.org/1999/xlink", NN = "http://www.w3.org/XML/1998/namespace", qpe = "javascript:throw new Error('React form unexpectedly submitted.')", $pe = "suppressHydrationWarning", hR = "$", gR = "/$", Hf = "$?", UT = "$!", Gpe = 1, Ype = 2, Xpe = 4, MN = "F!", E4 = "F", _4 = "complete", Zpe = "style", qf = 0, x0 = 1, mR = 2, jN = null, LN = null, C4 = { dialog: !0, webview: !0 }, kN = null, R4 = typeof setTimeout == "function" ? setTimeout : void 0, Kpe = typeof clearTimeout == "function" ? clearTimeout : void 0, ov = -1, O4 = typeof Promise == "function" ? Promise : void 0, Qpe = typeof queueMicrotask == "function" ? queueMicrotask : typeof O4 < "u" ? function(a) {
      return O4.resolve(null).then(a).catch(lu);
    } : R4, zN = null, av = 0, FT = 1, A4 = 2, D4 = 3, fc = 4, pc = /* @__PURE__ */ new Map(), I4 = /* @__PURE__ */ new Set(), $f = lr.d;
    lr.d = {
      f: function() {
        var a = $f.f(), l = _f();
        return a || l;
      },
      r: function(a) {
        var l = ct(a);
        l !== null && l.tag === 5 && l.type === "form" ? Kc(l) : $f.r(a);
      },
      D: function(a) {
        $f.D(a), cu("dns-prefetch", a, null);
      },
      C: function(a, l) {
        $f.C(a, l), cu("preconnect", a, l);
      },
      L: function(a, l, h) {
        $f.L(a, l, h);
        var x = S0;
        if (x && a && l) {
          var R = 'link[rel="preload"][as="' + zt(l) + '"]';
          l === "image" && h && h.imageSrcSet ? (R += '[imagesrcset="' + zt(
            h.imageSrcSet
          ) + '"]', typeof h.imageSizes == "string" && (R += '[imagesizes="' + zt(
            h.imageSizes
          ) + '"]')) : R += '[href="' + zt(a) + '"]';
          var A = R;
          switch (l) {
            case "style":
              A = pl(a);
              break;
            case "script":
              A = hd(a);
          }
          pc.has(A) || (a = pn(
            {
              rel: "preload",
              href: l === "image" && h && h.imageSrcSet ? void 0 : a,
              as: l
            },
            h
          ), pc.set(A, a), x.querySelector(R) !== null || l === "style" && x.querySelector(
            ph(A)
          ) || l === "script" && x.querySelector(Df(A)) || (l = x.createElement("link"), no(l, "link", a), Rt(l), x.head.appendChild(l)));
        }
      },
      m: function(a, l) {
        $f.m(a, l);
        var h = S0;
        if (h && a) {
          var x = l && typeof l.as == "string" ? l.as : "script", R = 'link[rel="modulepreload"][as="' + zt(x) + '"][href="' + zt(a) + '"]', A = R;
          switch (x) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              A = hd(a);
          }
          if (!pc.has(A) && (a = pn({ rel: "modulepreload", href: a }, l), pc.set(A, a), h.querySelector(R) === null)) {
            switch (x) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (h.querySelector(Df(A)))
                  return;
            }
            x = h.createElement("link"), no(x, "link", a), Rt(x), h.head.appendChild(x);
          }
        }
      },
      X: function(a, l) {
        $f.X(a, l);
        var h = S0;
        if (h && a) {
          var x = Yt(h).hoistableScripts, R = hd(a), A = x.get(R);
          A || (A = h.querySelector(
            Df(R)
          ), A || (a = pn({ src: a, async: !0 }, l), (l = pc.get(R)) && xb(a, l), A = h.createElement("script"), Rt(A), no(A, "link", a), h.head.appendChild(A)), A = {
            type: "script",
            instance: A,
            count: 1,
            state: null
          }, x.set(R, A));
        }
      },
      S: function(a, l, h) {
        $f.S(a, l, h);
        var x = S0;
        if (x && a) {
          var R = Yt(x).hoistableStyles, A = pl(a);
          l = l || "default";
          var B = R.get(A);
          if (!B) {
            var G = { loading: av, preload: null };
            if (B = x.querySelector(
              ph(A)
            ))
              G.loading = FT | fc;
            else {
              a = pn(
                {
                  rel: "stylesheet",
                  href: a,
                  "data-precedence": l
                },
                h
              ), (h = pc.get(A)) && Bw(a, h);
              var ue = B = x.createElement("link");
              Rt(ue), no(ue, "link", a), ue._p = new Promise(function(fe, Xe) {
                ue.onload = fe, ue.onerror = Xe;
              }), ue.addEventListener("load", function() {
                G.loading |= FT;
              }), ue.addEventListener("error", function() {
                G.loading |= A4;
              }), G.loading |= fc, bb(B, l, x);
            }
            B = {
              type: "stylesheet",
              instance: B,
              count: 1,
              state: G
            }, R.set(A, B);
          }
        }
      },
      M: function(a, l) {
        $f.M(a, l);
        var h = S0;
        if (h && a) {
          var x = Yt(h).hoistableScripts, R = hd(a), A = x.get(R);
          A || (A = h.querySelector(
            Df(R)
          ), A || (a = pn({ src: a, async: !0, type: "module" }, l), (l = pc.get(R)) && xb(a, l), A = h.createElement("script"), Rt(A), no(A, "link", a), h.head.appendChild(A)), A = {
            type: "script",
            instance: A,
            count: 1,
            state: null
          }, x.set(R, A));
        }
      }
    };
    var S0 = typeof document > "u" ? null : document, vR = null, WT = null, BN = null, yR = null, sv = $w, HT = {
      $$typeof: Pa,
      Provider: null,
      Consumer: null,
      _currentValue: sv,
      _currentValue2: sv,
      _threadCount: 0
    }, P4 = "%c%s%c ", N4 = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", M4 = "", bR = " ", Jpe = Function.prototype.bind, j4 = !1, L4 = null, k4 = null, z4 = null, B4 = null, V4 = null, U4 = null, F4 = null, W4 = null, H4 = null;
    L4 = function(a, l, h, x) {
      l = t(a, l), l !== null && (h = n(l.memoizedState, h, 0, x), l.memoizedState = h, l.baseState = h, a.memoizedProps = pn({}, a.memoizedProps), h = ma(a, 2), h !== null && Mn(h, a, 2));
    }, k4 = function(a, l, h) {
      l = t(a, l), l !== null && (h = o(l.memoizedState, h, 0), l.memoizedState = h, l.baseState = h, a.memoizedProps = pn({}, a.memoizedProps), h = ma(a, 2), h !== null && Mn(h, a, 2));
    }, z4 = function(a, l, h, x) {
      l = t(a, l), l !== null && (h = r(l.memoizedState, h, x), l.memoizedState = h, l.baseState = h, a.memoizedProps = pn({}, a.memoizedProps), h = ma(a, 2), h !== null && Mn(h, a, 2));
    }, B4 = function(a, l, h) {
      a.pendingProps = n(a.memoizedProps, l, 0, h), a.alternate && (a.alternate.pendingProps = a.pendingProps), l = ma(a, 2), l !== null && Mn(l, a, 2);
    }, V4 = function(a, l) {
      a.pendingProps = o(a.memoizedProps, l, 0), a.alternate && (a.alternate.pendingProps = a.pendingProps), l = ma(a, 2), l !== null && Mn(l, a, 2);
    }, U4 = function(a, l, h) {
      a.pendingProps = r(
        a.memoizedProps,
        l,
        h
      ), a.alternate && (a.alternate.pendingProps = a.pendingProps), l = ma(a, 2), l !== null && Mn(l, a, 2);
    }, F4 = function(a) {
      var l = ma(a, 2);
      l !== null && Mn(l, a, 2);
    }, W4 = function(a) {
      u = a;
    }, H4 = function(a) {
      s = a;
    };
    var xR = !0, SR = null, VN = !1, jh = null, Lh = null, kh = null, qT = /* @__PURE__ */ new Map(), $T = /* @__PURE__ */ new Map(), zh = [], ehe = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), wR = null;
    if (Ab.prototype.render = Ob.prototype.render = function(a) {
      var l = this._internalRoot;
      if (l === null) throw Error("Cannot update an unmounted root.");
      var h = arguments;
      typeof h[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : O(h[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof h[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), h = a;
      var x = l.current, R = Qa(x);
      _m(x, R, h, l, null, null);
    }, Ab.prototype.unmount = Ob.prototype.unmount = function() {
      var a = arguments;
      if (typeof a[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), a = this._internalRoot, a !== null) {
        this._internalRoot = null;
        var l = a.containerInfo;
        (mr & (ss | wu)) !== yl && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), _m(a.current, 2, null, a, null, null), _f(), l[xd] = null;
      }
    }, Ab.prototype.unstable_scheduleHydration = function(a) {
      if (a) {
        var l = ce();
        a = { blockedOn: null, target: a, priority: l };
        for (var h = 0; h < zh.length && l !== 0 && l < zh[h].priority; h++) ;
        zh.splice(h, 0, a), h === 0 && Ww(a);
      }
    }, (function() {
      var a = qw.version;
      if (a !== "19.1.1")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (a + `
  - react-dom:  19.1.1
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    })(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), lr.findDOMNode = function(a) {
      var l = a._reactInternals;
      if (l === void 0)
        throw typeof a.render == "function" ? Error("Unable to find node on an unmounted component.") : (a = Object.keys(a).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + a
        ));
      return a = N(l), a = a !== null ? k(a) : null, a = a === null ? null : a.stateNode, a;
    }, !(function() {
      var a = {
        bundleType: 1,
        version: "19.1.1",
        rendererPackageName: "react-dom",
        currentDispatcherRef: Ge,
        reconcilerVersion: "19.1.1"
      };
      return a.overrideHookState = L4, a.overrideHookStateDeletePath = k4, a.overrideHookStateRenamePath = z4, a.overrideProps = B4, a.overridePropsDeletePath = V4, a.overridePropsRenamePath = U4, a.scheduleUpdate = F4, a.setErrorHandler = W4, a.setSuspenseHandler = H4, a.scheduleRefresh = w, a.scheduleRoot = E, a.setRefreshHandler = _, a.getCurrentFiber = MP, a.getLaneLabelMap = jP, a.injectProfilingHooks = Ie, me(a);
    })() && ze && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var q4 = window.location.protocol;
      /^(https?|file):$/.test(q4) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (q4 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""),
        "font-weight:bold"
      );
    }
    ZT.createRoot = function(a, l) {
      if (!O(a))
        throw Error("Target container is not a DOM element.");
      Db(a);
      var h = !1, x = "", R = Z_, A = Hy, B = qy, G = null;
      return l != null && (l.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : typeof l == "object" && l !== null && l.$$typeof === du && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), l.unstable_strictMode === !0 && (h = !0), l.identifierPrefix !== void 0 && (x = l.identifierPrefix), l.onUncaughtError !== void 0 && (R = l.onUncaughtError), l.onCaughtError !== void 0 && (A = l.onCaughtError), l.onRecoverableError !== void 0 && (B = l.onRecoverableError), l.unstable_transitionCallbacks !== void 0 && (G = l.unstable_transitionCallbacks)), l = Fw(
        a,
        1,
        !1,
        null,
        null,
        h,
        x,
        R,
        A,
        B,
        G,
        null
      ), a[xd] = l.current, xm(a), new Ob(l);
    }, ZT.hydrateRoot = function(a, l, h) {
      if (!O(a))
        throw Error("Target container is not a DOM element.");
      Db(a), l === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var x = !1, R = "", A = Z_, B = Hy, G = qy, ue = null, fe = null;
      return h != null && (h.unstable_strictMode === !0 && (x = !0), h.identifierPrefix !== void 0 && (R = h.identifierPrefix), h.onUncaughtError !== void 0 && (A = h.onUncaughtError), h.onCaughtError !== void 0 && (B = h.onCaughtError), h.onRecoverableError !== void 0 && (G = h.onRecoverableError), h.unstable_transitionCallbacks !== void 0 && (ue = h.unstable_transitionCallbacks), h.formState !== void 0 && (fe = h.formState)), l = Fw(
        a,
        1,
        !0,
        l,
        h ?? null,
        x,
        R,
        A,
        B,
        G,
        ue,
        fe
      ), l.context = Er(null), h = l.current, x = Qa(h), x = bt(x), R = Ks(x), R.callback = null, Qs(h, R, x), h = x, l.current.lanes = h, mt(l, h), As(l), a[xd] = l.current, xm(a), new Ab(l);
    }, ZT.version = "19.1.1", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })(), ZT;
}
var oq;
function Fhe() {
  if (oq) return _R.exports;
  oq = 1;
  var e = {};
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (e.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (n) {
        console.error(n);
      }
    }
  }
  return e.NODE_ENV === "production" ? (t(), _R.exports = Vhe()) : _R.exports = Uhe(), _R.exports;
}
var Whe = Fhe(), RR = { exports: {} }, WN = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aq;
function Hhe() {
  if (aq) return WN;
  aq = 1;
  var e = it;
  function t(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, i = e.useRef, o = e.useEffect, s = e.useMemo, u = e.useDebugValue;
  return WN.useSyncExternalStoreWithSelector = function(f, p, m, v, y) {
    var S = i(null);
    if (S.current === null) {
      var E = { hasValue: !1, value: null };
      S.current = E;
    } else E = S.current;
    S = s(
      function() {
        function _(N) {
          if (!O) {
            if (O = !0, D = N, N = v(N), y !== void 0 && E.hasValue) {
              var k = E.value;
              if (y(k, N))
                return P = k;
            }
            return P = N;
          }
          if (k = P, n(D, N)) return k;
          var U = v(N);
          return y !== void 0 && y(k, U) ? (D = N, k) : (D = N, P = U);
        }
        var O = !1, D, P, M = m === void 0 ? null : m;
        return [
          function() {
            return _(p());
          },
          M === null ? void 0 : function() {
            return _(M());
          }
        ];
      },
      [p, m, v, y]
    );
    var w = r(f, S[0], S[1]);
    return o(
      function() {
        E.hasValue = !0, E.value = w;
      },
      [w]
    ), u(w), w;
  }, WN;
}
var HN = {}, sq;
function qhe() {
  if (sq) return HN;
  sq = 1;
  var e = {};
  /**
   * @license React
   * use-sync-external-store-with-selector.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(p, m) {
      return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var n = it, r = typeof Object.is == "function" ? Object.is : t, i = n.useSyncExternalStore, o = n.useRef, s = n.useEffect, u = n.useMemo, f = n.useDebugValue;
    HN.useSyncExternalStoreWithSelector = function(p, m, v, y, S) {
      var E = o(null);
      if (E.current === null) {
        var w = { hasValue: !1, value: null };
        E.current = w;
      } else w = E.current;
      E = u(
        function() {
          function O(k) {
            if (!D) {
              if (D = !0, P = k, k = y(k), S !== void 0 && w.hasValue) {
                var U = w.value;
                if (S(U, k))
                  return M = U;
              }
              return M = k;
            }
            if (U = M, r(P, k))
              return U;
            var H = y(k);
            return S !== void 0 && S(U, H) ? (P = k, U) : (P = k, M = H);
          }
          var D = !1, P, M, N = v === void 0 ? null : v;
          return [
            function() {
              return O(m());
            },
            N === null ? void 0 : function() {
              return O(N());
            }
          ];
        },
        [m, v, y, S]
      );
      var _ = i(p, E[0], E[1]);
      return s(
        function() {
          w.hasValue = !0, w.value = _;
        },
        [_]
      ), f(_), _;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })(), HN;
}
var lq;
function $he() {
  if (lq) return RR.exports;
  lq = 1;
  var e = {};
  return e.NODE_ENV === "production" ? RR.exports = Hhe() : RR.exports = qhe(), RR.exports;
}
var Ghe = $he(), Cu = {}, Kn = (
  // prettier-ignore
  // @ts-ignore
  "default" in $ ? $.default : $
), cq = Symbol.for("react-redux-context"), uq = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Yhe() {
  if (!Kn.createContext)
    return {};
  const e = uq[cq] ?? (uq[cq] = /* @__PURE__ */ new Map());
  let t = e.get(Kn.createContext);
  return t || (t = Kn.createContext(
    null
  ), Cu.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(Kn.createContext, t)), t;
}
var lp = /* @__PURE__ */ Yhe(), TJ = () => {
  throw new Error("uSES not initialized!");
};
function fU(e = lp) {
  return function() {
    const n = Kn.useContext(e);
    if (Cu.NODE_ENV !== "production" && !n)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return n;
  };
}
var EJ = /* @__PURE__ */ fU(), _J = TJ, Xhe = (e) => {
  _J = e;
}, Zhe = (e, t) => e === t;
function Khe(e = lp) {
  const t = e === lp ? EJ : fU(e), n = (r, i = {}) => {
    const { equalityFn: o = Zhe, devModeChecks: s = {} } = typeof i == "function" ? { equalityFn: i } : i;
    if (Cu.NODE_ENV !== "production") {
      if (!r)
        throw new Error("You must pass a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof o != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const {
      store: u,
      subscription: f,
      getServerState: p,
      stabilityCheck: m,
      identityFunctionCheck: v
    } = t(), y = Kn.useRef(!0), S = Kn.useCallback(
      {
        [r.name](w) {
          const _ = r(w);
          if (Cu.NODE_ENV !== "production") {
            const {
              identityFunctionCheck: O,
              stabilityCheck: D
            } = {
              stabilityCheck: m,
              identityFunctionCheck: v,
              ...s
            };
            if (D === "always" || D === "once" && y.current) {
              const P = r(w);
              if (!o(_, P)) {
                let M;
                try {
                  throw new Error();
                } catch (N) {
                  ({ stack: M } = N);
                }
                console.warn(
                  "Selector " + (r.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: w,
                    selected: _,
                    selected2: P,
                    stack: M
                  }
                );
              }
            }
            if ((O === "always" || O === "once" && y.current) && _ === w) {
              let P;
              try {
                throw new Error();
              } catch (M) {
                ({ stack: P } = M);
              }
              console.warn(
                "Selector " + (r.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: P }
              );
            }
            y.current && (y.current = !1);
          }
          return _;
        }
      }[r.name],
      [r, m, s.stabilityCheck]
    ), E = _J(
      f.addNestedSub,
      u.getState,
      p || u.getState,
      S,
      o
    );
    return Kn.useDebugValue(E), E;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Ba = /* @__PURE__ */ Khe(), Qhe = Symbol.for("react.element"), Jhe = Symbol.for("react.portal"), CJ = Symbol.for("react.fragment"), RJ = Symbol.for("react.strict_mode"), OJ = Symbol.for("react.profiler"), AJ = Symbol.for("react.provider"), pU = Symbol.for("react.context"), ege = Symbol.for("react.server_context"), hU = Symbol.for("react.forward_ref"), DJ = Symbol.for("react.suspense"), IJ = Symbol.for("react.suspense_list"), QA = Symbol.for("react.memo"), PJ = Symbol.for("react.lazy"), tge = Symbol.for("react.offscreen"), nge = Symbol.for("react.client.reference"), rge = hU, ige = QA;
function oge(e) {
  return typeof e == "string" || typeof e == "function" || e === CJ || e === OJ || e === RJ || e === DJ || e === IJ || e === tge || typeof e == "object" && e !== null && (e.$$typeof === PJ || e.$$typeof === QA || e.$$typeof === AJ || e.$$typeof === pU || e.$$typeof === hU || // This needs to include all possible module reference object
  // types supported by any Flight configuration anywhere since
  // we don't know which Flight build this will end up being used
  // with.
  e.$$typeof === nge || e.getModuleId !== void 0);
}
function NJ(e) {
  if (typeof e == "object" && e !== null) {
    const t = e.$$typeof;
    switch (t) {
      case Qhe: {
        const n = e.type;
        switch (n) {
          case CJ:
          case OJ:
          case RJ:
          case DJ:
          case IJ:
            return n;
          default: {
            const r = n && n.$$typeof;
            switch (r) {
              case ege:
              case pU:
              case hU:
              case PJ:
              case QA:
              case AJ:
                return r;
              default:
                return t;
            }
          }
        }
      }
      case Jhe:
        return t;
    }
  }
}
function age(e) {
  return NJ(e) === pU;
}
function sge(e) {
  return NJ(e) === QA;
}
function gU(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function qN(e, t) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || gU(
      `The selector for ${t} of connect did not specify a value for dependsOnOwnProps.`
    ));
  else throw new Error(`Unexpected value for ${t} in connect.`);
}
function lge(e, t, n) {
  qN(e, "mapStateToProps"), qN(t, "mapDispatchToProps"), qN(n, "mergeProps");
}
function cge(e, t, n, r, {
  areStatesEqual: i,
  areOwnPropsEqual: o,
  areStatePropsEqual: s
}) {
  let u = !1, f, p, m, v, y;
  function S(D, P) {
    return f = D, p = P, m = e(f, p), v = t(r, p), y = n(m, v, p), u = !0, y;
  }
  function E() {
    return m = e(f, p), t.dependsOnOwnProps && (v = t(r, p)), y = n(m, v, p), y;
  }
  function w() {
    return e.dependsOnOwnProps && (m = e(f, p)), t.dependsOnOwnProps && (v = t(r, p)), y = n(m, v, p), y;
  }
  function _() {
    const D = e(f, p), P = !s(D, m);
    return m = D, P && (y = n(m, v, p)), y;
  }
  function O(D, P) {
    const M = !o(P, p), N = !i(
      D,
      f,
      P,
      p
    );
    return f = D, p = P, M && N ? E() : M ? w() : N ? _() : y;
  }
  return function(P, M) {
    return u ? O(P, M) : S(P, M);
  };
}
function uge(e, {
  initMapStateToProps: t,
  initMapDispatchToProps: n,
  initMergeProps: r,
  ...i
}) {
  const o = t(e, i), s = n(e, i), u = r(e, i);
  return Cu.NODE_ENV !== "production" && lge(o, s, u), cge(o, s, u, e, i);
}
function dge(e, t) {
  const n = {};
  for (const r in e) {
    const i = e[r];
    typeof i == "function" && (n[r] = (...o) => t(i(...o)));
  }
  return n;
}
function fge(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  let n = t;
  for (; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function MJ(e, t, n) {
  fge(e) || gU(
    `${n}() in ${t} must return a plain object. Instead received ${e}.`
  );
}
function k2(e) {
  return function(n) {
    const r = e(n);
    function i() {
      return r;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function dq(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function jJ(e, t) {
  return function(r, { displayName: i }) {
    const o = function(u, f) {
      return o.dependsOnOwnProps ? o.mapToProps(u, f) : o.mapToProps(u, void 0);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(u, f) {
      o.mapToProps = e, o.dependsOnOwnProps = dq(e);
      let p = o(u, f);
      return typeof p == "function" && (o.mapToProps = p, o.dependsOnOwnProps = dq(p), p = o(u, f)), Cu.NODE_ENV !== "production" && MJ(p, i, t), p;
    }, o;
  };
}
function mU(e, t) {
  return (n, r) => {
    throw new Error(
      `Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`
    );
  };
}
function pge(e) {
  return e && typeof e == "object" ? k2(
    (t) => (
      // @ts-ignore
      dge(e, t)
    )
  ) : e ? typeof e == "function" ? (
    // @ts-ignore
    jJ(e, "mapDispatchToProps")
  ) : mU(e, "mapDispatchToProps") : k2((t) => ({
    dispatch: t
  }));
}
function hge(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    jJ(e, "mapStateToProps")
  ) : mU(e, "mapStateToProps") : k2(() => ({}));
}
function gge(e, t, n) {
  return { ...n, ...e, ...t };
}
function mge(e) {
  return function(n, { displayName: r, areMergedPropsEqual: i }) {
    let o = !1, s;
    return function(f, p, m) {
      const v = e(f, p, m);
      return o ? i(v, s) || (s = v) : (o = !0, s = v, Cu.NODE_ENV !== "production" && MJ(s, r, "mergeProps")), s;
    };
  };
}
function vge(e) {
  return e ? typeof e == "function" ? mge(e) : mU(e, "mergeProps") : () => gge;
}
function yge(e) {
  e();
}
function bge() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      yge(() => {
        let n = e;
        for (; n; )
          n.callback(), n = n.next;
      });
    },
    get() {
      const n = [];
      let r = e;
      for (; r; )
        n.push(r), r = r.next;
      return n;
    },
    subscribe(n) {
      let r = !0;
      const i = t = {
        callback: n,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : e = i, function() {
        !r || e === null || (r = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : e = i.next);
      };
    }
  };
}
var fq = {
  notify() {
  },
  get: () => []
};
function LJ(e, t) {
  let n, r = fq, i = 0, o = !1;
  function s(w) {
    m();
    const _ = r.subscribe(w);
    let O = !1;
    return () => {
      O || (O = !0, _(), v());
    };
  }
  function u() {
    r.notify();
  }
  function f() {
    E.onStateChange && E.onStateChange();
  }
  function p() {
    return o;
  }
  function m() {
    i++, n || (n = t ? t.addNestedSub(f) : e.subscribe(f), r = bge());
  }
  function v() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = fq);
  }
  function y() {
    o || (o = !0, m());
  }
  function S() {
    o && (o = !1, v());
  }
  const E = {
    addNestedSub: s,
    notifyNestedSubs: u,
    handleChangeWrapper: f,
    isSubscribed: p,
    trySubscribe: y,
    tryUnsubscribe: S,
    getListeners: () => r
  };
  return E;
}
var xge = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", nA = xge ? Kn.useLayoutEffect : Kn.useEffect;
function pq(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Nd(e, t) {
  if (pq(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (let i = 0; i < n.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, n[i]) || !pq(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
var Sge = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, wge = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Tge = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, kJ = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ege = {
  [rge]: Tge,
  [ige]: kJ
};
function hq(e) {
  return sge(e) ? kJ : Ege[e.$$typeof] || Sge;
}
var _ge = Object.defineProperty, Cge = Object.getOwnPropertyNames, gq = Object.getOwnPropertySymbols, Rge = Object.getOwnPropertyDescriptor, Oge = Object.getPrototypeOf, mq = Object.prototype;
function z2(e, t) {
  if (typeof t != "string") {
    if (mq) {
      const o = Oge(t);
      o && o !== mq && z2(e, o);
    }
    let n = Cge(t);
    gq && (n = n.concat(gq(t)));
    const r = hq(e), i = hq(t);
    for (let o = 0; o < n.length; ++o) {
      const s = n[o];
      if (!wge[s] && !(i && i[s]) && !(r && r[s])) {
        const u = Rge(t, s);
        try {
          _ge(e, s, u);
        } catch {
        }
      }
    }
  }
  return e;
}
var zJ = TJ, Age = (e) => {
  zJ = e;
}, Dge = [null, null], Ige = (e) => {
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
};
function Pge(e, t, n) {
  nA(() => e(...t), n);
}
function Nge(e, t, n, r, i, o) {
  e.current = r, n.current = !1, i.current && (i.current = null, o());
}
function Mge(e, t, n, r, i, o, s, u, f, p, m) {
  if (!e)
    return () => {
    };
  let v = !1, y = null;
  const S = () => {
    if (v || !u.current)
      return;
    const w = t.getState();
    let _, O;
    try {
      _ = r(
        w,
        i.current
      );
    } catch (D) {
      O = D, y = D;
    }
    O || (y = null), _ === o.current ? s.current || p() : (o.current = _, f.current = _, s.current = !0, m());
  };
  return n.onStateChange = S, n.trySubscribe(), S(), () => {
    if (v = !0, n.tryUnsubscribe(), n.onStateChange = null, y)
      throw y;
  };
}
function jge(e, t) {
  return e === t;
}
var vq = !1;
function Lge(e, t, n, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: r,
  areStatesEqual: i = jge,
  areOwnPropsEqual: o = Nd,
  areStatePropsEqual: s = Nd,
  areMergedPropsEqual: u = Nd,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: f = !1,
  // the context consumer to use
  context: p = lp
} = {}) {
  Cu.NODE_ENV !== "production" && r !== void 0 && !vq && (vq = !0, gU(
    'The `pure` option has been removed. `connect` is now always a "pure/memoized" component'
  ));
  const m = p, v = hge(e), y = pge(t), S = vge(n), E = !!e;
  return (_) => {
    if (Cu.NODE_ENV !== "production" && !/* @__PURE__ */ oge(_))
      throw new Error(
        `You must pass a component to the function returned by connect. Instead received ${Ige(
          _
        )}`
      );
    const O = _.displayName || _.name || "Component", D = `Connect(${O})`, P = {
      shouldHandleStateChanges: E,
      displayName: D,
      wrappedComponentName: O,
      WrappedComponent: _,
      // @ts-ignore
      initMapStateToProps: v,
      // @ts-ignore
      initMapDispatchToProps: y,
      initMergeProps: S,
      areStatesEqual: i,
      areStatePropsEqual: s,
      areOwnPropsEqual: o,
      areMergedPropsEqual: u
    };
    function M(U) {
      const [H, Y, z] = Kn.useMemo(() => {
        const { reactReduxForwardedRef: Ue, ...ve } = U;
        return [U.context, Ue, ve];
      }, [U]), V = Kn.useMemo(() => {
        let Ue = m;
        if (H != null && H.Consumer && Cu.NODE_ENV !== "production") {
          if (!/* @__PURE__ */ age(
            // @ts-ignore
            /* @__PURE__ */ Kn.createElement(H.Consumer, null)
          ))
            throw new Error(
              "You must pass a valid React context consumer as `props.context`"
            );
          Ue = H;
        }
        return Ue;
      }, [H, m]), F = Kn.useContext(V), X = !!U.store && !!U.store.getState && !!U.store.dispatch, oe = !!F && !!F.store;
      if (Cu.NODE_ENV !== "production" && !X && !oe)
        throw new Error(
          `Could not find "store" in the context of "${D}". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ${D} in connect options.`
        );
      const re = X ? U.store : F.store, Z = oe ? F.getServerState : re.getState, ee = Kn.useMemo(() => uge(re.dispatch, P), [re]), [J, le] = Kn.useMemo(() => {
        if (!E)
          return Dge;
        const Ue = LJ(
          re,
          X ? void 0 : F.subscription
        ), ve = Ue.notifyNestedSubs.bind(Ue);
        return [Ue, ve];
      }, [re, X, F]), be = Kn.useMemo(() => X ? F : {
        ...F,
        subscription: J
      }, [X, F, J]), ne = Kn.useRef(), ae = Kn.useRef(z), ie = Kn.useRef(), he = Kn.useRef(!1);
      Kn.useRef(!1);
      const pe = Kn.useRef(!1), me = Kn.useRef();
      nA(() => (pe.current = !0, () => {
        pe.current = !1;
      }), []);
      const Ee = Kn.useMemo(() => () => ie.current && z === ae.current ? ie.current : ee(re.getState(), z), [re, z]), Ie = Kn.useMemo(() => (ve) => J ? Mge(
        E,
        re,
        J,
        // @ts-ignore
        ee,
        ae,
        ne,
        he,
        pe,
        ie,
        le,
        ve
      ) : () => {
      }, [J]);
      Pge(Nge, [
        ae,
        ne,
        he,
        z,
        ie,
        le
      ]);
      let Pe;
      try {
        Pe = zJ(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          Ie,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          Ee,
          Z ? () => ee(Z(), z) : Ee
        );
      } catch (Ue) {
        throw me.current && (Ue.message += `
The error may be correlated with this previous error:
${me.current.stack}

`), Ue;
      }
      nA(() => {
        me.current = void 0, ie.current = void 0, ne.current = Pe;
      });
      const De = Kn.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ Kn.createElement(
          _,
          {
            ...Pe,
            ref: Y
          }
        )
      ), [Y, _, Pe]);
      return Kn.useMemo(() => E ? /* @__PURE__ */ Kn.createElement(V.Provider, { value: be }, De) : De, [V, De, be]);
    }
    const k = Kn.memo(M);
    if (k.WrappedComponent = _, k.displayName = M.displayName = D, f) {
      const H = Kn.forwardRef(function(z, V) {
        return /* @__PURE__ */ Kn.createElement(k, { ...z, reactReduxForwardedRef: V });
      });
      return H.displayName = D, H.WrappedComponent = _, /* @__PURE__ */ z2(H, _);
    }
    return /* @__PURE__ */ z2(k, _);
  };
}
var At = Lge;
function kge({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: i = "once",
  identityFunctionCheck: o = "once"
}) {
  const s = Kn.useMemo(() => {
    const p = LJ(e);
    return {
      store: e,
      subscription: p,
      getServerState: r ? () => r : void 0,
      stabilityCheck: i,
      identityFunctionCheck: o
    };
  }, [e, r, i, o]), u = Kn.useMemo(() => e.getState(), [e]);
  nA(() => {
    const { subscription: p } = s;
    return p.onStateChange = p.notifyNestedSubs, p.trySubscribe(), u !== e.getState() && p.notifyNestedSubs(), () => {
      p.tryUnsubscribe(), p.onStateChange = void 0;
    };
  }, [s, u]);
  const f = t || lp;
  return /* @__PURE__ */ Kn.createElement(f.Provider, { value: s }, n);
}
var zge = kge;
function BJ(e = lp) {
  const t = e === lp ? EJ : (
    // @ts-ignore
    fU(e)
  ), n = () => {
    const { store: r } = t();
    return r;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Bge = /* @__PURE__ */ BJ();
function Vge(e = lp) {
  const t = e === lp ? Bge : BJ(e), n = () => t().dispatch;
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Uge = /* @__PURE__ */ Vge();
Xhe(Ghe.useSyncExternalStoreWithSelector);
Age($.useSyncExternalStore);
var OR = { exports: {} }, AR = { exports: {} }, Rr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yq;
function Fge() {
  if (yq) return Rr;
  yq = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function P(N) {
    if (typeof N == "object" && N !== null) {
      var k = N.$$typeof;
      switch (k) {
        case t:
          switch (N = N.type, N) {
            case f:
            case p:
            case r:
            case o:
            case i:
            case v:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case u:
                case m:
                case E:
                case S:
                case s:
                  return N;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function M(N) {
    return P(N) === p;
  }
  return Rr.AsyncMode = f, Rr.ConcurrentMode = p, Rr.ContextConsumer = u, Rr.ContextProvider = s, Rr.Element = t, Rr.ForwardRef = m, Rr.Fragment = r, Rr.Lazy = E, Rr.Memo = S, Rr.Portal = n, Rr.Profiler = o, Rr.StrictMode = i, Rr.Suspense = v, Rr.isAsyncMode = function(N) {
    return M(N) || P(N) === f;
  }, Rr.isConcurrentMode = M, Rr.isContextConsumer = function(N) {
    return P(N) === u;
  }, Rr.isContextProvider = function(N) {
    return P(N) === s;
  }, Rr.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === t;
  }, Rr.isForwardRef = function(N) {
    return P(N) === m;
  }, Rr.isFragment = function(N) {
    return P(N) === r;
  }, Rr.isLazy = function(N) {
    return P(N) === E;
  }, Rr.isMemo = function(N) {
    return P(N) === S;
  }, Rr.isPortal = function(N) {
    return P(N) === n;
  }, Rr.isProfiler = function(N) {
    return P(N) === o;
  }, Rr.isStrictMode = function(N) {
    return P(N) === i;
  }, Rr.isSuspense = function(N) {
    return P(N) === v;
  }, Rr.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === r || N === p || N === o || N === i || N === v || N === y || typeof N == "object" && N !== null && (N.$$typeof === E || N.$$typeof === S || N.$$typeof === s || N.$$typeof === u || N.$$typeof === m || N.$$typeof === _ || N.$$typeof === O || N.$$typeof === D || N.$$typeof === w);
  }, Rr.typeOf = P, Rr;
}
var Or = {}, bq;
function Wge() {
  if (bq) return Or;
  bq = 1;
  var e = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, f = t ? Symbol.for("react.context") : 60110, p = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, v = t ? Symbol.for("react.forward_ref") : 60112, y = t ? Symbol.for("react.suspense") : 60113, S = t ? Symbol.for("react.suspense_list") : 60120, E = t ? Symbol.for("react.memo") : 60115, w = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, O = t ? Symbol.for("react.fundamental") : 60117, D = t ? Symbol.for("react.responder") : 60118, P = t ? Symbol.for("react.scope") : 60119;
    function M(ve) {
      return typeof ve == "string" || typeof ve == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ve === i || ve === m || ve === s || ve === o || ve === y || ve === S || typeof ve == "object" && ve !== null && (ve.$$typeof === w || ve.$$typeof === E || ve.$$typeof === u || ve.$$typeof === f || ve.$$typeof === v || ve.$$typeof === O || ve.$$typeof === D || ve.$$typeof === P || ve.$$typeof === _);
    }
    function N(ve) {
      if (typeof ve == "object" && ve !== null) {
        var rt = ve.$$typeof;
        switch (rt) {
          case n:
            var Te = ve.type;
            switch (Te) {
              case p:
              case m:
              case i:
              case s:
              case o:
              case y:
                return Te;
              default:
                var Je = Te && Te.$$typeof;
                switch (Je) {
                  case f:
                  case v:
                  case w:
                  case E:
                  case u:
                    return Je;
                  default:
                    return rt;
                }
            }
          case r:
            return rt;
        }
      }
    }
    var k = p, U = m, H = f, Y = u, z = n, V = v, F = i, X = w, oe = E, re = r, Z = s, ee = o, J = y, le = !1;
    function be(ve) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ne(ve) || N(ve) === p;
    }
    function ne(ve) {
      return N(ve) === m;
    }
    function ae(ve) {
      return N(ve) === f;
    }
    function ie(ve) {
      return N(ve) === u;
    }
    function he(ve) {
      return typeof ve == "object" && ve !== null && ve.$$typeof === n;
    }
    function pe(ve) {
      return N(ve) === v;
    }
    function me(ve) {
      return N(ve) === i;
    }
    function Ee(ve) {
      return N(ve) === w;
    }
    function Ie(ve) {
      return N(ve) === E;
    }
    function Pe(ve) {
      return N(ve) === r;
    }
    function De(ve) {
      return N(ve) === s;
    }
    function Ye(ve) {
      return N(ve) === o;
    }
    function Ue(ve) {
      return N(ve) === y;
    }
    Or.AsyncMode = k, Or.ConcurrentMode = U, Or.ContextConsumer = H, Or.ContextProvider = Y, Or.Element = z, Or.ForwardRef = V, Or.Fragment = F, Or.Lazy = X, Or.Memo = oe, Or.Portal = re, Or.Profiler = Z, Or.StrictMode = ee, Or.Suspense = J, Or.isAsyncMode = be, Or.isConcurrentMode = ne, Or.isContextConsumer = ae, Or.isContextProvider = ie, Or.isElement = he, Or.isForwardRef = pe, Or.isFragment = me, Or.isLazy = Ee, Or.isMemo = Ie, Or.isPortal = Pe, Or.isProfiler = De, Or.isStrictMode = Ye, Or.isSuspense = Ue, Or.isValidElementType = M, Or.typeOf = N;
  })(), Or;
}
var xq;
function VJ() {
  if (xq) return AR.exports;
  xq = 1;
  var e = {};
  return e.NODE_ENV === "production" ? AR.exports = Fge() : AR.exports = Wge(), AR.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var $N, Sq;
function Hge() {
  if (Sq) return $N;
  Sq = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var f = Object.getOwnPropertyNames(s).map(function(m) {
        return s[m];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return $N = i() ? Object.assign : function(o, s) {
    for (var u, f = r(o), p, m = 1; m < arguments.length; m++) {
      u = Object(arguments[m]);
      for (var v in u)
        t.call(u, v) && (f[v] = u[v]);
      if (e) {
        p = e(u);
        for (var y = 0; y < p.length; y++)
          n.call(u, p[y]) && (f[p[y]] = u[p[y]]);
      }
    }
    return f;
  }, $N;
}
var GN, wq;
function vU() {
  if (wq) return GN;
  wq = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return GN = e, GN;
}
var YN, Tq;
function UJ() {
  return Tq || (Tq = 1, YN = Function.call.bind(Object.prototype.hasOwnProperty)), YN;
}
var XN, Eq;
function qge() {
  if (Eq) return XN;
  Eq = 1;
  var e = {}, t = function() {
  };
  if (e.NODE_ENV !== "production") {
    var n = /* @__PURE__ */ vU(), r = {}, i = /* @__PURE__ */ UJ();
    t = function(s) {
      var u = "Warning: " + s;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function o(s, u, f, p, m) {
    if (e.NODE_ENV !== "production") {
      for (var v in s)
        if (i(s, v)) {
          var y;
          try {
            if (typeof s[v] != "function") {
              var S = Error(
                (p || "React class") + ": " + f + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw S.name = "Invariant Violation", S;
            }
            y = s[v](u, v, p, f, null, n);
          } catch (w) {
            y = w;
          }
          if (y && !(y instanceof Error) && t(
            (p || "React class") + ": type specification of " + f + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), y instanceof Error && !(y.message in r)) {
            r[y.message] = !0;
            var E = m ? m() : "";
            t(
              "Failed " + f + " type: " + y.message + (E ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    e.NODE_ENV !== "production" && (r = {});
  }, XN = o, XN;
}
var ZN, _q;
function $ge() {
  if (_q) return ZN;
  _q = 1;
  var e = {}, t = VJ(), n = Hge(), r = /* @__PURE__ */ vU(), i = /* @__PURE__ */ UJ(), o = /* @__PURE__ */ qge(), s = function() {
  };
  e.NODE_ENV !== "production" && (s = function(f) {
    var p = "Warning: " + f;
    typeof console < "u" && console.error(p);
    try {
      throw new Error(p);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return ZN = function(f, p) {
    var m = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function y(ne) {
      var ae = ne && (m && ne[m] || ne[v]);
      if (typeof ae == "function")
        return ae;
    }
    var S = "<<anonymous>>", E = {
      array: D("array"),
      bigint: D("bigint"),
      bool: D("boolean"),
      func: D("function"),
      number: D("number"),
      object: D("object"),
      string: D("string"),
      symbol: D("symbol"),
      any: P(),
      arrayOf: M,
      element: N(),
      elementType: k(),
      instanceOf: U,
      node: V(),
      objectOf: Y,
      oneOf: H,
      oneOfType: z,
      shape: X,
      exact: oe
    };
    function w(ne, ae) {
      return ne === ae ? ne !== 0 || 1 / ne === 1 / ae : ne !== ne && ae !== ae;
    }
    function _(ne, ae) {
      this.message = ne, this.data = ae && typeof ae == "object" ? ae : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function O(ne) {
      if (e.NODE_ENV !== "production")
        var ae = {}, ie = 0;
      function he(me, Ee, Ie, Pe, De, Ye, Ue) {
        if (Pe = Pe || S, Ye = Ye || Ie, Ue !== r) {
          if (p) {
            var ve = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ve.name = "Invariant Violation", ve;
          } else if (e.NODE_ENV !== "production" && typeof console < "u") {
            var rt = Pe + ":" + Ie;
            !ae[rt] && // Avoid spamming the console because they are often not actionable except for lib authors
            ie < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + Ye + "` prop on `" + Pe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ae[rt] = !0, ie++);
          }
        }
        return Ee[Ie] == null ? me ? Ee[Ie] === null ? new _("The " + De + " `" + Ye + "` is marked as required " + ("in `" + Pe + "`, but its value is `null`.")) : new _("The " + De + " `" + Ye + "` is marked as required in " + ("`" + Pe + "`, but its value is `undefined`.")) : null : ne(Ee, Ie, Pe, De, Ye);
      }
      var pe = he.bind(null, !1);
      return pe.isRequired = he.bind(null, !0), pe;
    }
    function D(ne) {
      function ae(ie, he, pe, me, Ee, Ie) {
        var Pe = ie[he], De = ee(Pe);
        if (De !== ne) {
          var Ye = J(Pe);
          return new _(
            "Invalid " + me + " `" + Ee + "` of type " + ("`" + Ye + "` supplied to `" + pe + "`, expected ") + ("`" + ne + "`."),
            { expectedType: ne }
          );
        }
        return null;
      }
      return O(ae);
    }
    function P() {
      return O(u);
    }
    function M(ne) {
      function ae(ie, he, pe, me, Ee) {
        if (typeof ne != "function")
          return new _("Property `" + Ee + "` of component `" + pe + "` has invalid PropType notation inside arrayOf.");
        var Ie = ie[he];
        if (!Array.isArray(Ie)) {
          var Pe = ee(Ie);
          return new _("Invalid " + me + " `" + Ee + "` of type " + ("`" + Pe + "` supplied to `" + pe + "`, expected an array."));
        }
        for (var De = 0; De < Ie.length; De++) {
          var Ye = ne(Ie, De, pe, me, Ee + "[" + De + "]", r);
          if (Ye instanceof Error)
            return Ye;
        }
        return null;
      }
      return O(ae);
    }
    function N() {
      function ne(ae, ie, he, pe, me) {
        var Ee = ae[ie];
        if (!f(Ee)) {
          var Ie = ee(Ee);
          return new _("Invalid " + pe + " `" + me + "` of type " + ("`" + Ie + "` supplied to `" + he + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(ne);
    }
    function k() {
      function ne(ae, ie, he, pe, me) {
        var Ee = ae[ie];
        if (!t.isValidElementType(Ee)) {
          var Ie = ee(Ee);
          return new _("Invalid " + pe + " `" + me + "` of type " + ("`" + Ie + "` supplied to `" + he + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(ne);
    }
    function U(ne) {
      function ae(ie, he, pe, me, Ee) {
        if (!(ie[he] instanceof ne)) {
          var Ie = ne.name || S, Pe = be(ie[he]);
          return new _("Invalid " + me + " `" + Ee + "` of type " + ("`" + Pe + "` supplied to `" + pe + "`, expected ") + ("instance of `" + Ie + "`."));
        }
        return null;
      }
      return O(ae);
    }
    function H(ne) {
      if (!Array.isArray(ne))
        return e.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), u;
      function ae(ie, he, pe, me, Ee) {
        for (var Ie = ie[he], Pe = 0; Pe < ne.length; Pe++)
          if (w(Ie, ne[Pe]))
            return null;
        var De = JSON.stringify(ne, function(Ue, ve) {
          var rt = J(ve);
          return rt === "symbol" ? String(ve) : ve;
        });
        return new _("Invalid " + me + " `" + Ee + "` of value `" + String(Ie) + "` " + ("supplied to `" + pe + "`, expected one of " + De + "."));
      }
      return O(ae);
    }
    function Y(ne) {
      function ae(ie, he, pe, me, Ee) {
        if (typeof ne != "function")
          return new _("Property `" + Ee + "` of component `" + pe + "` has invalid PropType notation inside objectOf.");
        var Ie = ie[he], Pe = ee(Ie);
        if (Pe !== "object")
          return new _("Invalid " + me + " `" + Ee + "` of type " + ("`" + Pe + "` supplied to `" + pe + "`, expected an object."));
        for (var De in Ie)
          if (i(Ie, De)) {
            var Ye = ne(Ie, De, pe, me, Ee + "." + De, r);
            if (Ye instanceof Error)
              return Ye;
          }
        return null;
      }
      return O(ae);
    }
    function z(ne) {
      if (!Array.isArray(ne))
        return e.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var ae = 0; ae < ne.length; ae++) {
        var ie = ne[ae];
        if (typeof ie != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + le(ie) + " at index " + ae + "."
          ), u;
      }
      function he(pe, me, Ee, Ie, Pe) {
        for (var De = [], Ye = 0; Ye < ne.length; Ye++) {
          var Ue = ne[Ye], ve = Ue(pe, me, Ee, Ie, Pe, r);
          if (ve == null)
            return null;
          ve.data && i(ve.data, "expectedType") && De.push(ve.data.expectedType);
        }
        var rt = De.length > 0 ? ", expected one of type [" + De.join(", ") + "]" : "";
        return new _("Invalid " + Ie + " `" + Pe + "` supplied to " + ("`" + Ee + "`" + rt + "."));
      }
      return O(he);
    }
    function V() {
      function ne(ae, ie, he, pe, me) {
        return re(ae[ie]) ? null : new _("Invalid " + pe + " `" + me + "` supplied to " + ("`" + he + "`, expected a ReactNode."));
      }
      return O(ne);
    }
    function F(ne, ae, ie, he, pe) {
      return new _(
        (ne || "React class") + ": " + ae + " type `" + ie + "." + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + pe + "`."
      );
    }
    function X(ne) {
      function ae(ie, he, pe, me, Ee) {
        var Ie = ie[he], Pe = ee(Ie);
        if (Pe !== "object")
          return new _("Invalid " + me + " `" + Ee + "` of type `" + Pe + "` " + ("supplied to `" + pe + "`, expected `object`."));
        for (var De in ne) {
          var Ye = ne[De];
          if (typeof Ye != "function")
            return F(pe, me, Ee, De, J(Ye));
          var Ue = Ye(Ie, De, pe, me, Ee + "." + De, r);
          if (Ue)
            return Ue;
        }
        return null;
      }
      return O(ae);
    }
    function oe(ne) {
      function ae(ie, he, pe, me, Ee) {
        var Ie = ie[he], Pe = ee(Ie);
        if (Pe !== "object")
          return new _("Invalid " + me + " `" + Ee + "` of type `" + Pe + "` " + ("supplied to `" + pe + "`, expected `object`."));
        var De = n({}, ie[he], ne);
        for (var Ye in De) {
          var Ue = ne[Ye];
          if (i(ne, Ye) && typeof Ue != "function")
            return F(pe, me, Ee, Ye, J(Ue));
          if (!Ue)
            return new _(
              "Invalid " + me + " `" + Ee + "` key `" + Ye + "` supplied to `" + pe + "`.\nBad object: " + JSON.stringify(ie[he], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ne), null, "  ")
            );
          var ve = Ue(Ie, Ye, pe, me, Ee + "." + Ye, r);
          if (ve)
            return ve;
        }
        return null;
      }
      return O(ae);
    }
    function re(ne) {
      switch (typeof ne) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ne;
        case "object":
          if (Array.isArray(ne))
            return ne.every(re);
          if (ne === null || f(ne))
            return !0;
          var ae = y(ne);
          if (ae) {
            var ie = ae.call(ne), he;
            if (ae !== ne.entries) {
              for (; !(he = ie.next()).done; )
                if (!re(he.value))
                  return !1;
            } else
              for (; !(he = ie.next()).done; ) {
                var pe = he.value;
                if (pe && !re(pe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Z(ne, ae) {
      return ne === "symbol" ? !0 : ae ? ae["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ae instanceof Symbol : !1;
    }
    function ee(ne) {
      var ae = typeof ne;
      return Array.isArray(ne) ? "array" : ne instanceof RegExp ? "object" : Z(ae, ne) ? "symbol" : ae;
    }
    function J(ne) {
      if (typeof ne > "u" || ne === null)
        return "" + ne;
      var ae = ee(ne);
      if (ae === "object") {
        if (ne instanceof Date)
          return "date";
        if (ne instanceof RegExp)
          return "regexp";
      }
      return ae;
    }
    function le(ne) {
      var ae = J(ne);
      switch (ae) {
        case "array":
        case "object":
          return "an " + ae;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ae;
        default:
          return ae;
      }
    }
    function be(ne) {
      return !ne.constructor || !ne.constructor.name ? S : ne.constructor.name;
    }
    return E.checkPropTypes = o, E.resetWarningCache = o.resetWarningCache, E.PropTypes = E, E;
  }, ZN;
}
var KN, Cq;
function Gge() {
  if (Cq) return KN;
  Cq = 1;
  var e = /* @__PURE__ */ vU();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, KN = function() {
    function r(s, u, f, p, m, v) {
      if (v !== e) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, KN;
}
var Rq;
function yU() {
  if (Rq) return OR.exports;
  Rq = 1;
  var e = {};
  if (e.NODE_ENV !== "production") {
    var t = VJ(), n = !0;
    OR.exports = /* @__PURE__ */ $ge()(t.isElement, n);
  } else
    OR.exports = /* @__PURE__ */ Gge()();
  return OR.exports;
}
var Yge = /* @__PURE__ */ yU();
const c = /* @__PURE__ */ Hn(Yge), bU = hg();
var QN, Oq;
function Yo() {
  if (Oq) return QN;
  Oq = 1;
  var e = Array.isArray;
  return QN = e, QN;
}
var JN, Aq;
function FJ() {
  if (Aq) return JN;
  Aq = 1;
  var e = typeof TR == "object" && TR && TR.Object === Object && TR;
  return JN = e, JN;
}
var eM, Dq;
function Hs() {
  if (Dq) return eM;
  Dq = 1;
  var e = FJ(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return eM = n, eM;
}
var tM, Iq;
function Sx() {
  if (Iq) return tM;
  Iq = 1;
  var e = Hs(), t = e.Symbol;
  return tM = t, tM;
}
var nM, Pq;
function Xge() {
  if (Pq) return nM;
  Pq = 1;
  var e = Sx(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function o(s) {
    var u = n.call(s, i), f = s[i];
    try {
      s[i] = void 0;
      var p = !0;
    } catch {
    }
    var m = r.call(s);
    return p && (u ? s[i] = f : delete s[i]), m;
  }
  return nM = o, nM;
}
var rM, Nq;
function Zge() {
  if (Nq) return rM;
  Nq = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return rM = n, rM;
}
var iM, Mq;
function mg() {
  if (Mq) return iM;
  Mq = 1;
  var e = Sx(), t = Xge(), n = Zge(), r = "[object Null]", i = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(u) {
    return u == null ? u === void 0 ? i : r : o && o in Object(u) ? t(u) : n(u);
  }
  return iM = s, iM;
}
var oM, jq;
function Bl() {
  if (jq) return oM;
  jq = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return oM = e, oM;
}
var aM, Lq;
function wx() {
  if (Lq) return aM;
  Lq = 1;
  var e = mg(), t = Bl(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || t(i) && e(i) == n;
  }
  return aM = r, aM;
}
var sM, kq;
function xU() {
  if (kq) return sM;
  kq = 1;
  var e = Yo(), t = wx(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(o, s) {
    if (e(o))
      return !1;
    var u = typeof o;
    return u == "number" || u == "symbol" || u == "boolean" || o == null || t(o) ? !0 : r.test(o) || !n.test(o) || s != null && o in Object(s);
  }
  return sM = i, sM;
}
var lM, zq;
function Mu() {
  if (zq) return lM;
  zq = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return lM = e, lM;
}
var cM, Bq;
function JA() {
  if (Bq) return cM;
  Bq = 1;
  var e = mg(), t = Mu(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(u) {
    if (!t(u))
      return !1;
    var f = e(u);
    return f == r || f == i || f == n || f == o;
  }
  return cM = s, cM;
}
var uM, Vq;
function Kge() {
  if (Vq) return uM;
  Vq = 1;
  var e = Hs(), t = e["__core-js_shared__"];
  return uM = t, uM;
}
var dM, Uq;
function Qge() {
  if (Uq) return dM;
  Uq = 1;
  var e = Kge(), t = (function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  })();
  function n(r) {
    return !!t && t in r;
  }
  return dM = n, dM;
}
var fM, Fq;
function WJ() {
  if (Fq) return fM;
  Fq = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return fM = n, fM;
}
var pM, Wq;
function Jge() {
  if (Wq) return pM;
  Wq = 1;
  var e = JA(), t = Qge(), n = Mu(), r = WJ(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, u = Object.prototype, f = s.toString, p = u.hasOwnProperty, m = RegExp(
    "^" + f.call(p).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function v(y) {
    if (!n(y) || t(y))
      return !1;
    var S = e(y) ? m : o;
    return S.test(r(y));
  }
  return pM = v, pM;
}
var hM, Hq;
function eme() {
  if (Hq) return hM;
  Hq = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return hM = e, hM;
}
var gM, qq;
function qv() {
  if (qq) return gM;
  qq = 1;
  var e = Jge(), t = eme();
  function n(r, i) {
    var o = t(r, i);
    return e(o) ? o : void 0;
  }
  return gM = n, gM;
}
var mM, $q;
function eD() {
  if ($q) return mM;
  $q = 1;
  var e = qv(), t = e(Object, "create");
  return mM = t, mM;
}
var vM, Gq;
function tme() {
  if (Gq) return vM;
  Gq = 1;
  var e = eD();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return vM = t, vM;
}
var yM, Yq;
function nme() {
  if (Yq) return yM;
  Yq = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return yM = e, yM;
}
var bM, Xq;
function rme() {
  if (Xq) return bM;
  Xq = 1;
  var e = eD(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    var s = this.__data__;
    if (e) {
      var u = s[o];
      return u === t ? void 0 : u;
    }
    return r.call(s, o) ? s[o] : void 0;
  }
  return bM = i, bM;
}
var xM, Zq;
function ime() {
  if (Zq) return xM;
  Zq = 1;
  var e = eD(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var o = this.__data__;
    return e ? o[i] !== void 0 : n.call(o, i);
  }
  return xM = r, xM;
}
var SM, Kq;
function ome() {
  if (Kq) return SM;
  Kq = 1;
  var e = eD(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var o = this.__data__;
    return this.size += this.has(r) ? 0 : 1, o[r] = e && i === void 0 ? t : i, this;
  }
  return SM = n, SM;
}
var wM, Qq;
function ame() {
  if (Qq) return wM;
  Qq = 1;
  var e = tme(), t = nme(), n = rme(), r = ime(), i = ome();
  function o(s) {
    var u = -1, f = s == null ? 0 : s.length;
    for (this.clear(); ++u < f; ) {
      var p = s[u];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, wM = o, wM;
}
var TM, Jq;
function sme() {
  if (Jq) return TM;
  Jq = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return TM = e, TM;
}
var EM, e6;
function tD() {
  if (e6) return EM;
  e6 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return EM = e, EM;
}
var _M, t6;
function nD() {
  if (t6) return _M;
  t6 = 1;
  var e = tD();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return _M = t, _M;
}
var CM, n6;
function lme() {
  if (n6) return CM;
  n6 = 1;
  var e = nD(), t = Array.prototype, n = t.splice;
  function r(i) {
    var o = this.__data__, s = e(o, i);
    if (s < 0)
      return !1;
    var u = o.length - 1;
    return s == u ? o.pop() : n.call(o, s, 1), --this.size, !0;
  }
  return CM = r, CM;
}
var RM, r6;
function cme() {
  if (r6) return RM;
  r6 = 1;
  var e = nD();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return RM = t, RM;
}
var OM, i6;
function ume() {
  if (i6) return OM;
  i6 = 1;
  var e = nD();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return OM = t, OM;
}
var AM, o6;
function dme() {
  if (o6) return AM;
  o6 = 1;
  var e = nD();
  function t(n, r) {
    var i = this.__data__, o = e(i, n);
    return o < 0 ? (++this.size, i.push([n, r])) : i[o][1] = r, this;
  }
  return AM = t, AM;
}
var DM, a6;
function rD() {
  if (a6) return DM;
  a6 = 1;
  var e = sme(), t = lme(), n = cme(), r = ume(), i = dme();
  function o(s) {
    var u = -1, f = s == null ? 0 : s.length;
    for (this.clear(); ++u < f; ) {
      var p = s[u];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, DM = o, DM;
}
var IM, s6;
function SU() {
  if (s6) return IM;
  s6 = 1;
  var e = qv(), t = Hs(), n = e(t, "Map");
  return IM = n, IM;
}
var PM, l6;
function fme() {
  if (l6) return PM;
  l6 = 1;
  var e = ame(), t = rD(), n = SU();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return PM = r, PM;
}
var NM, c6;
function pme() {
  if (c6) return NM;
  c6 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return NM = e, NM;
}
var MM, u6;
function iD() {
  if (u6) return MM;
  u6 = 1;
  var e = pme();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return MM = t, MM;
}
var jM, d6;
function hme() {
  if (d6) return jM;
  d6 = 1;
  var e = iD();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return jM = t, jM;
}
var LM, f6;
function gme() {
  if (f6) return LM;
  f6 = 1;
  var e = iD();
  function t(n) {
    return e(this, n).get(n);
  }
  return LM = t, LM;
}
var kM, p6;
function mme() {
  if (p6) return kM;
  p6 = 1;
  var e = iD();
  function t(n) {
    return e(this, n).has(n);
  }
  return kM = t, kM;
}
var zM, h6;
function vme() {
  if (h6) return zM;
  h6 = 1;
  var e = iD();
  function t(n, r) {
    var i = e(this, n), o = i.size;
    return i.set(n, r), this.size += i.size == o ? 0 : 1, this;
  }
  return zM = t, zM;
}
var BM, g6;
function wU() {
  if (g6) return BM;
  g6 = 1;
  var e = fme(), t = hme(), n = gme(), r = mme(), i = vme();
  function o(s) {
    var u = -1, f = s == null ? 0 : s.length;
    for (this.clear(); ++u < f; ) {
      var p = s[u];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, BM = o, BM;
}
var VM, m6;
function yme() {
  if (m6) return VM;
  m6 = 1;
  var e = wU(), t = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var o = function() {
      var s = arguments, u = i ? i.apply(this, s) : s[0], f = o.cache;
      if (f.has(u))
        return f.get(u);
      var p = r.apply(this, s);
      return o.cache = f.set(u, p) || f, p;
    };
    return o.cache = new (n.Cache || e)(), o;
  }
  return n.Cache = e, VM = n, VM;
}
var UM, v6;
function bme() {
  if (v6) return UM;
  v6 = 1;
  var e = yme(), t = 500;
  function n(r) {
    var i = e(r, function(s) {
      return o.size === t && o.clear(), s;
    }), o = i.cache;
    return i;
  }
  return UM = n, UM;
}
var FM, y6;
function HJ() {
  if (y6) return FM;
  y6 = 1;
  var e = bme(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(t, function(s, u, f, p) {
      o.push(f ? p.replace(n, "$1") : u || s);
    }), o;
  });
  return FM = r, FM;
}
var WM, b6;
function Tx() {
  if (b6) return WM;
  b6 = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, o = Array(i); ++r < i; )
      o[r] = n(t[r], r, t);
    return o;
  }
  return WM = e, WM;
}
var HM, x6;
function xme() {
  if (x6) return HM;
  x6 = 1;
  var e = Sx(), t = Tx(), n = Yo(), r = wx(), i = e ? e.prototype : void 0, o = i ? i.toString : void 0;
  function s(u) {
    if (typeof u == "string")
      return u;
    if (n(u))
      return t(u, s) + "";
    if (r(u))
      return o ? o.call(u) : "";
    var f = u + "";
    return f == "0" && 1 / u == -1 / 0 ? "-0" : f;
  }
  return HM = s, HM;
}
var qM, S6;
function TU() {
  if (S6) return qM;
  S6 = 1;
  var e = xme();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return qM = t, qM;
}
var $M, w6;
function I1() {
  if (w6) return $M;
  w6 = 1;
  var e = Yo(), t = xU(), n = HJ(), r = TU();
  function i(o, s) {
    return e(o) ? o : t(o, s) ? [o] : n(r(o));
  }
  return $M = i, $M;
}
var GM, T6;
function $v() {
  if (T6) return GM;
  T6 = 1;
  var e = wx();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return GM = t, GM;
}
var YM, E6;
function P1() {
  if (E6) return YM;
  E6 = 1;
  var e = I1(), t = $v();
  function n(r, i) {
    i = e(i, r);
    for (var o = 0, s = i.length; r != null && o < s; )
      r = r[t(i[o++])];
    return o && o == s ? r : void 0;
  }
  return YM = n, YM;
}
var XM, _6;
function qJ() {
  if (_6) return XM;
  _6 = 1;
  var e = qv(), t = (function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  })();
  return XM = t, XM;
}
var ZM, C6;
function oD() {
  if (C6) return ZM;
  C6 = 1;
  var e = qJ();
  function t(n, r, i) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : n[r] = i;
  }
  return ZM = t, ZM;
}
var KM, R6;
function EU() {
  if (R6) return KM;
  R6 = 1;
  var e = oD(), t = tD(), n = Object.prototype, r = n.hasOwnProperty;
  function i(o, s, u) {
    var f = o[s];
    (!(r.call(o, s) && t(f, u)) || u === void 0 && !(s in o)) && e(o, s, u);
  }
  return KM = i, KM;
}
var QM, O6;
function N1() {
  if (O6) return QM;
  O6 = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, i) {
    var o = typeof r;
    return i = i ?? e, !!i && (o == "number" || o != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return QM = n, QM;
}
var JM, A6;
function $J() {
  if (A6) return JM;
  A6 = 1;
  var e = EU(), t = I1(), n = N1(), r = Mu(), i = $v();
  function o(s, u, f, p) {
    if (!r(s))
      return s;
    u = t(u, s);
    for (var m = -1, v = u.length, y = v - 1, S = s; S != null && ++m < v; ) {
      var E = i(u[m]), w = f;
      if (E === "__proto__" || E === "constructor" || E === "prototype")
        return s;
      if (m != y) {
        var _ = S[E];
        w = p ? p(_, E, S) : void 0, w === void 0 && (w = r(_) ? _ : n(u[m + 1]) ? [] : {});
      }
      e(S, E, w), S = S[E];
    }
    return s;
  }
  return JM = o, JM;
}
var ej, D6;
function Sme() {
  if (D6) return ej;
  D6 = 1;
  var e = P1(), t = $J();
  function n(r, i, o, s) {
    return t(r, i, o(e(r, i)), s);
  }
  return ej = n, ej;
}
var tj, I6;
function Ex() {
  if (I6) return tj;
  I6 = 1;
  function e(t) {
    return t;
  }
  return tj = e, tj;
}
var nj, P6;
function wme() {
  if (P6) return nj;
  P6 = 1;
  var e = Ex();
  function t(n) {
    return typeof n == "function" ? n : e;
  }
  return nj = t, nj;
}
var rj, N6;
function GJ() {
  if (N6) return rj;
  N6 = 1;
  var e = Sme(), t = wme();
  function n(r, i, o) {
    return r == null ? r : e(r, i, t(o));
  }
  return rj = n, rj;
}
var Tme = GJ();
const Eme = /* @__PURE__ */ Hn(Tme);
var Zi = {};
function sa(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var _me = typeof Symbol == "function" && Symbol.observable || "@@observable", M6 = _me, ij = () => Math.random().toString(36).substring(7).split("").join("."), Cme = {
  INIT: `@@redux/INIT${/* @__PURE__ */ ij()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ ij()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${ij()}`
}, Ov = Cme;
function YJ(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function Rme(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (Dme(e))
    return "date";
  if (Ame(e))
    return "error";
  const n = Ome(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function Ome(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Ame(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function Dme(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Wh(e) {
  let t = typeof e;
  return Zi.NODE_ENV !== "production" && (t = Rme(e)), t;
}
function XJ(e, t, n) {
  if (typeof e != "function")
    throw new Error(Zi.NODE_ENV === "production" ? sa(2) : `Expected the root reducer to be a function. Instead, received: '${Wh(e)}'`);
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(Zi.NODE_ENV === "production" ? sa(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(Zi.NODE_ENV === "production" ? sa(1) : `Expected the enhancer to be a function. Instead, received: '${Wh(n)}'`);
    return n(XJ)(e, t);
  }
  let r = e, i = t, o = /* @__PURE__ */ new Map(), s = o, u = 0, f = !1;
  function p() {
    s === o && (s = /* @__PURE__ */ new Map(), o.forEach((_, O) => {
      s.set(O, _);
    }));
  }
  function m() {
    if (f)
      throw new Error(Zi.NODE_ENV === "production" ? sa(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function v(_) {
    if (typeof _ != "function")
      throw new Error(Zi.NODE_ENV === "production" ? sa(4) : `Expected the listener to be a function. Instead, received: '${Wh(_)}'`);
    if (f)
      throw new Error(Zi.NODE_ENV === "production" ? sa(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let O = !0;
    p();
    const D = u++;
    return s.set(D, _), function() {
      if (O) {
        if (f)
          throw new Error(Zi.NODE_ENV === "production" ? sa(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        O = !1, p(), s.delete(D), o = null;
      }
    };
  }
  function y(_) {
    if (!YJ(_))
      throw new Error(Zi.NODE_ENV === "production" ? sa(7) : `Actions must be plain objects. Instead, the actual type was: '${Wh(_)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof _.type > "u")
      throw new Error(Zi.NODE_ENV === "production" ? sa(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof _.type != "string")
      throw new Error(Zi.NODE_ENV === "production" ? sa(17) : `Action "type" property must be a string. Instead, the actual type was: '${Wh(_.type)}'. Value was: '${_.type}' (stringified)`);
    if (f)
      throw new Error(Zi.NODE_ENV === "production" ? sa(9) : "Reducers may not dispatch actions.");
    try {
      f = !0, i = r(i, _);
    } finally {
      f = !1;
    }
    return (o = s).forEach((D) => {
      D();
    }), _;
  }
  function S(_) {
    if (typeof _ != "function")
      throw new Error(Zi.NODE_ENV === "production" ? sa(10) : `Expected the nextReducer to be a function. Instead, received: '${Wh(_)}`);
    r = _, y({
      type: Ov.REPLACE
    });
  }
  function E() {
    const _ = v;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(O) {
        if (typeof O != "object" || O === null)
          throw new Error(Zi.NODE_ENV === "production" ? sa(11) : `Expected the observer to be an object. Instead, received: '${Wh(O)}'`);
        function D() {
          const M = O;
          M.next && M.next(m());
        }
        return D(), {
          unsubscribe: _(D)
        };
      },
      [M6]() {
        return this;
      }
    };
  }
  return y({
    type: Ov.INIT
  }), {
    dispatch: y,
    subscribe: v,
    getState: m,
    replaceReducer: S,
    [M6]: E
  };
}
function j6(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Ime(e, t, n, r) {
  const i = Object.keys(t), o = n && n.type === Ov.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!YJ(e))
    return `The ${o} has unexpected type of "${Wh(e)}". Expected argument to be an object with the following keys: "${i.join('", "')}"`;
  const s = Object.keys(e).filter((u) => !t.hasOwnProperty(u) && !r[u]);
  if (s.forEach((u) => {
    r[u] = !0;
  }), !(n && n.type === Ov.REPLACE) && s.length > 0)
    return `Unexpected ${s.length > 1 ? "keys" : "key"} "${s.join('", "')}" found in ${o}. Expected to find one of the known reducer keys instead: "${i.join('", "')}". Unexpected keys will be ignored.`;
}
function Pme(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: Ov.INIT
    }) > "u")
      throw new Error(Zi.NODE_ENV === "production" ? sa(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: Ov.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(Zi.NODE_ENV === "production" ? sa(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${Ov.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function ZJ(e) {
  const t = Object.keys(e), n = {};
  for (let s = 0; s < t.length; s++) {
    const u = t[s];
    Zi.NODE_ENV !== "production" && typeof e[u] > "u" && j6(`No reducer provided for key "${u}"`), typeof e[u] == "function" && (n[u] = e[u]);
  }
  const r = Object.keys(n);
  let i;
  Zi.NODE_ENV !== "production" && (i = {});
  let o;
  try {
    Pme(n);
  } catch (s) {
    o = s;
  }
  return function(u = {}, f) {
    if (o)
      throw o;
    if (Zi.NODE_ENV !== "production") {
      const v = Ime(u, n, f, i);
      v && j6(v);
    }
    let p = !1;
    const m = {};
    for (let v = 0; v < r.length; v++) {
      const y = r[v], S = n[y], E = u[y], w = S(E, f);
      if (typeof w > "u") {
        const _ = f && f.type;
        throw new Error(Zi.NODE_ENV === "production" ? sa(14) : `When called with an action of type ${_ ? `"${String(_)}"` : "(unknown type)"}, the slice reducer for key "${y}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      m[y] = w, p = p || w !== E;
    }
    return p = p || r.length !== Object.keys(u).length, p ? m : u;
  };
}
function wt(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, n) => (...r) => t(n(...r)));
}
function Nme(...e) {
  return (t) => (n, r) => {
    const i = t(n, r);
    let o = () => {
      throw new Error(Zi.NODE_ENV === "production" ? sa(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const s = {
      getState: i.getState,
      dispatch: (f, ...p) => o(f, ...p)
    }, u = e.map((f) => f(s));
    return o = wt(...u)(i.dispatch), {
      ...i,
      dispatch: o
    };
  };
}
var oj, L6;
function KJ() {
  if (L6) return oj;
  L6 = 1;
  var e = qv(), t = Hs(), n = e(t, "WeakMap");
  return oj = n, oj;
}
var aj, k6;
function QJ() {
  if (k6) return aj;
  k6 = 1;
  var e = KJ(), t = e && new e();
  return aj = t, aj;
}
var sj, z6;
function JJ() {
  if (z6) return sj;
  z6 = 1;
  var e = Ex(), t = QJ(), n = t ? function(r, i) {
    return t.set(r, i), r;
  } : e;
  return sj = n, sj;
}
var lj, B6;
function aD() {
  if (B6) return lj;
  B6 = 1;
  var e = Mu(), t = Object.create, n = /* @__PURE__ */ (function() {
    function r() {
    }
    return function(i) {
      if (!e(i))
        return {};
      if (t)
        return t(i);
      r.prototype = i;
      var o = new r();
      return r.prototype = void 0, o;
    };
  })();
  return lj = n, lj;
}
var cj, V6;
function sD() {
  if (V6) return cj;
  V6 = 1;
  var e = aD(), t = Mu();
  function n(r) {
    return function() {
      var i = arguments;
      switch (i.length) {
        case 0:
          return new r();
        case 1:
          return new r(i[0]);
        case 2:
          return new r(i[0], i[1]);
        case 3:
          return new r(i[0], i[1], i[2]);
        case 4:
          return new r(i[0], i[1], i[2], i[3]);
        case 5:
          return new r(i[0], i[1], i[2], i[3], i[4]);
        case 6:
          return new r(i[0], i[1], i[2], i[3], i[4], i[5]);
        case 7:
          return new r(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
      }
      var o = e(r.prototype), s = r.apply(o, i);
      return t(s) ? s : o;
    };
  }
  return cj = n, cj;
}
var uj, U6;
function Mme() {
  if (U6) return uj;
  U6 = 1;
  var e = sD(), t = Hs(), n = 1;
  function r(i, o, s) {
    var u = o & n, f = e(i);
    function p() {
      var m = this && this !== t && this instanceof p ? f : i;
      return m.apply(u ? s : this, arguments);
    }
    return p;
  }
  return uj = r, uj;
}
var dj, F6;
function _U() {
  if (F6) return dj;
  F6 = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return dj = e, dj;
}
var fj, W6;
function eee() {
  if (W6) return fj;
  W6 = 1;
  var e = Math.max;
  function t(n, r, i, o) {
    for (var s = -1, u = n.length, f = i.length, p = -1, m = r.length, v = e(u - f, 0), y = Array(m + v), S = !o; ++p < m; )
      y[p] = r[p];
    for (; ++s < f; )
      (S || s < u) && (y[i[s]] = n[s]);
    for (; v--; )
      y[p++] = n[s++];
    return y;
  }
  return fj = t, fj;
}
var pj, H6;
function tee() {
  if (H6) return pj;
  H6 = 1;
  var e = Math.max;
  function t(n, r, i, o) {
    for (var s = -1, u = n.length, f = -1, p = i.length, m = -1, v = r.length, y = e(u - p, 0), S = Array(y + v), E = !o; ++s < y; )
      S[s] = n[s];
    for (var w = s; ++m < v; )
      S[w + m] = r[m];
    for (; ++f < p; )
      (E || s < u) && (S[w + i[f]] = n[s++]);
    return S;
  }
  return pj = t, pj;
}
var hj, q6;
function jme() {
  if (q6) return hj;
  q6 = 1;
  function e(t, n) {
    for (var r = t.length, i = 0; r--; )
      t[r] === n && ++i;
    return i;
  }
  return hj = e, hj;
}
var gj, $6;
function CU() {
  if ($6) return gj;
  $6 = 1;
  function e() {
  }
  return gj = e, gj;
}
var mj, G6;
function RU() {
  if (G6) return mj;
  G6 = 1;
  var e = aD(), t = CU(), n = 4294967295;
  function r(i) {
    this.__wrapped__ = i, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = n, this.__views__ = [];
  }
  return r.prototype = e(t.prototype), r.prototype.constructor = r, mj = r, mj;
}
var vj, Y6;
function nee() {
  if (Y6) return vj;
  Y6 = 1;
  function e() {
  }
  return vj = e, vj;
}
var yj, X6;
function ree() {
  if (X6) return yj;
  X6 = 1;
  var e = QJ(), t = nee(), n = e ? function(r) {
    return e.get(r);
  } : t;
  return yj = n, yj;
}
var bj, Z6;
function Lme() {
  if (Z6) return bj;
  Z6 = 1;
  var e = {};
  return bj = e, bj;
}
var xj, K6;
function kme() {
  if (K6) return xj;
  K6 = 1;
  var e = Lme(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    for (var o = i.name + "", s = e[o], u = n.call(e, o) ? s.length : 0; u--; ) {
      var f = s[u], p = f.func;
      if (p == null || p == i)
        return f.name;
    }
    return o;
  }
  return xj = r, xj;
}
var Sj, Q6;
function iee() {
  if (Q6) return Sj;
  Q6 = 1;
  var e = aD(), t = CU();
  function n(r, i) {
    this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = void 0;
  }
  return n.prototype = e(t.prototype), n.prototype.constructor = n, Sj = n, Sj;
}
var wj, J6;
function lD() {
  if (J6) return wj;
  J6 = 1;
  function e(t, n) {
    var r = -1, i = t.length;
    for (n || (n = Array(i)); ++r < i; )
      n[r] = t[r];
    return n;
  }
  return wj = e, wj;
}
var Tj, e$;
function zme() {
  if (e$) return Tj;
  e$ = 1;
  var e = RU(), t = iee(), n = lD();
  function r(i) {
    if (i instanceof e)
      return i.clone();
    var o = new t(i.__wrapped__, i.__chain__);
    return o.__actions__ = n(i.__actions__), o.__index__ = i.__index__, o.__values__ = i.__values__, o;
  }
  return Tj = r, Tj;
}
var Ej, t$;
function Bme() {
  if (t$) return Ej;
  t$ = 1;
  var e = RU(), t = iee(), n = CU(), r = Yo(), i = Bl(), o = zme(), s = Object.prototype, u = s.hasOwnProperty;
  function f(p) {
    if (i(p) && !r(p) && !(p instanceof e)) {
      if (p instanceof t)
        return p;
      if (u.call(p, "__wrapped__"))
        return o(p);
    }
    return new t(p);
  }
  return f.prototype = n.prototype, f.prototype.constructor = f, Ej = f, Ej;
}
var _j, n$;
function Vme() {
  if (n$) return _j;
  n$ = 1;
  var e = RU(), t = ree(), n = kme(), r = Bme();
  function i(o) {
    var s = n(o), u = r[s];
    if (typeof u != "function" || !(s in e.prototype))
      return !1;
    if (o === u)
      return !0;
    var f = t(u);
    return !!f && o === f[0];
  }
  return _j = i, _j;
}
var Cj, r$;
function oee() {
  if (r$) return Cj;
  r$ = 1;
  var e = 800, t = 16, n = Date.now;
  function r(i) {
    var o = 0, s = 0;
    return function() {
      var u = n(), f = t - (u - s);
      if (s = u, f > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return i.apply(void 0, arguments);
    };
  }
  return Cj = r, Cj;
}
var Rj, i$;
function aee() {
  if (i$) return Rj;
  i$ = 1;
  var e = JJ(), t = oee(), n = t(e);
  return Rj = n, Rj;
}
var Oj, o$;
function Ume() {
  if (o$) return Oj;
  o$ = 1;
  var e = /\{\n\/\* \[wrapped with (.+)\] \*/, t = /,? & /;
  function n(r) {
    var i = r.match(e);
    return i ? i[1].split(t) : [];
  }
  return Oj = n, Oj;
}
var Aj, a$;
function Fme() {
  if (a$) return Aj;
  a$ = 1;
  var e = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
  function t(n, r) {
    var i = r.length;
    if (!i)
      return n;
    var o = i - 1;
    return r[o] = (i > 1 ? "& " : "") + r[o], r = r.join(i > 2 ? ", " : " "), n.replace(e, `{
/* [wrapped with ` + r + `] */
`);
  }
  return Aj = t, Aj;
}
var Dj, s$;
function Wme() {
  if (s$) return Dj;
  s$ = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Dj = e, Dj;
}
var Ij, l$;
function Hme() {
  if (l$) return Ij;
  l$ = 1;
  var e = Wme(), t = qJ(), n = Ex(), r = t ? function(i, o) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : n;
  return Ij = r, Ij;
}
var Pj, c$;
function OU() {
  if (c$) return Pj;
  c$ = 1;
  var e = Hme(), t = oee(), n = t(e);
  return Pj = n, Pj;
}
var Nj, u$;
function AU() {
  if (u$) return Nj;
  u$ = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return Nj = e, Nj;
}
var Mj, d$;
function qme() {
  if (d$) return Mj;
  d$ = 1;
  function e(t, n, r, i) {
    for (var o = t.length, s = r + (i ? 1 : -1); i ? s-- : ++s < o; )
      if (n(t[s], s, t))
        return s;
    return -1;
  }
  return Mj = e, Mj;
}
var jj, f$;
function $me() {
  if (f$) return jj;
  f$ = 1;
  function e(t) {
    return t !== t;
  }
  return jj = e, jj;
}
var Lj, p$;
function Gme() {
  if (p$) return Lj;
  p$ = 1;
  function e(t, n, r) {
    for (var i = r - 1, o = t.length; ++i < o; )
      if (t[i] === n)
        return i;
    return -1;
  }
  return Lj = e, Lj;
}
var kj, h$;
function Yme() {
  if (h$) return kj;
  h$ = 1;
  var e = qme(), t = $me(), n = Gme();
  function r(i, o, s) {
    return o === o ? n(i, o, s) : e(i, t, s);
  }
  return kj = r, kj;
}
var zj, g$;
function DU() {
  if (g$) return zj;
  g$ = 1;
  var e = Yme();
  function t(n, r) {
    var i = n == null ? 0 : n.length;
    return !!i && e(n, r, 0) > -1;
  }
  return zj = t, zj;
}
var Bj, m$;
function Xme() {
  if (m$) return Bj;
  m$ = 1;
  var e = AU(), t = DU(), n = 1, r = 2, i = 8, o = 16, s = 32, u = 64, f = 128, p = 256, m = 512, v = [
    ["ary", f],
    ["bind", n],
    ["bindKey", r],
    ["curry", i],
    ["curryRight", o],
    ["flip", m],
    ["partial", s],
    ["partialRight", u],
    ["rearg", p]
  ];
  function y(S, E) {
    return e(v, function(w) {
      var _ = "_." + w[0];
      E & w[1] && !t(S, _) && S.push(_);
    }), S.sort();
  }
  return Bj = y, Bj;
}
var Vj, v$;
function see() {
  if (v$) return Vj;
  v$ = 1;
  var e = Ume(), t = Fme(), n = OU(), r = Xme();
  function i(o, s, u) {
    var f = s + "";
    return n(o, t(f, r(e(f), u)));
  }
  return Vj = i, Vj;
}
var Uj, y$;
function lee() {
  if (y$) return Uj;
  y$ = 1;
  var e = Vme(), t = aee(), n = see(), r = 4, i = 8, o = 32, s = 64;
  function u(f, p, m, v, y, S, E, w, _, O) {
    var D = p & i, P = D ? E : void 0, M = D ? void 0 : E, N = D ? S : void 0, k = D ? void 0 : S;
    p |= D ? o : s, p &= ~(D ? s : o), p & r || (p &= -4);
    var U = [
      f,
      p,
      y,
      N,
      P,
      k,
      M,
      w,
      _,
      O
    ], H = m.apply(void 0, U);
    return e(f) && t(H, U), H.placeholder = v, n(H, f, p);
  }
  return Uj = u, Uj;
}
var Fj, b$;
function cee() {
  if (b$) return Fj;
  b$ = 1;
  function e(t) {
    var n = t;
    return n.placeholder;
  }
  return Fj = e, Fj;
}
var Wj, x$;
function Zme() {
  if (x$) return Wj;
  x$ = 1;
  var e = lD(), t = N1(), n = Math.min;
  function r(i, o) {
    for (var s = i.length, u = n(o.length, s), f = e(i); u--; ) {
      var p = o[u];
      i[u] = t(p, s) ? f[p] : void 0;
    }
    return i;
  }
  return Wj = r, Wj;
}
var Hj, S$;
function IU() {
  if (S$) return Hj;
  S$ = 1;
  var e = "__lodash_placeholder__";
  function t(n, r) {
    for (var i = -1, o = n.length, s = 0, u = []; ++i < o; ) {
      var f = n[i];
      (f === r || f === e) && (n[i] = e, u[s++] = i);
    }
    return u;
  }
  return Hj = t, Hj;
}
var qj, w$;
function uee() {
  if (w$) return qj;
  w$ = 1;
  var e = eee(), t = tee(), n = jme(), r = sD(), i = lee(), o = cee(), s = Zme(), u = IU(), f = Hs(), p = 1, m = 2, v = 8, y = 16, S = 128, E = 512;
  function w(_, O, D, P, M, N, k, U, H, Y) {
    var z = O & S, V = O & p, F = O & m, X = O & (v | y), oe = O & E, re = F ? void 0 : r(_);
    function Z() {
      for (var ee = arguments.length, J = Array(ee), le = ee; le--; )
        J[le] = arguments[le];
      if (X)
        var be = o(Z), ne = n(J, be);
      if (P && (J = e(J, P, M, X)), N && (J = t(J, N, k, X)), ee -= ne, X && ee < Y) {
        var ae = u(J, be);
        return i(
          _,
          O,
          w,
          Z.placeholder,
          D,
          J,
          ae,
          U,
          H,
          Y - ee
        );
      }
      var ie = V ? D : this, he = F ? ie[_] : _;
      return ee = J.length, U ? J = s(J, U) : oe && ee > 1 && J.reverse(), z && H < ee && (J.length = H), this && this !== f && this instanceof Z && (he = re || r(he)), he.apply(ie, J);
    }
    return Z;
  }
  return qj = w, qj;
}
var $j, T$;
function Kme() {
  if (T$) return $j;
  T$ = 1;
  var e = _U(), t = sD(), n = uee(), r = lee(), i = cee(), o = IU(), s = Hs();
  function u(f, p, m) {
    var v = t(f);
    function y() {
      for (var S = arguments.length, E = Array(S), w = S, _ = i(y); w--; )
        E[w] = arguments[w];
      var O = S < 3 && E[0] !== _ && E[S - 1] !== _ ? [] : o(E, _);
      if (S -= O.length, S < m)
        return r(
          f,
          p,
          n,
          y.placeholder,
          void 0,
          E,
          O,
          void 0,
          void 0,
          m - S
        );
      var D = this && this !== s && this instanceof y ? v : f;
      return e(D, this, E);
    }
    return y;
  }
  return $j = u, $j;
}
var Gj, E$;
function Qme() {
  if (E$) return Gj;
  E$ = 1;
  var e = _U(), t = sD(), n = Hs(), r = 1;
  function i(o, s, u, f) {
    var p = s & r, m = t(o);
    function v() {
      for (var y = -1, S = arguments.length, E = -1, w = f.length, _ = Array(w + S), O = this && this !== n && this instanceof v ? m : o; ++E < w; )
        _[E] = f[E];
      for (; S--; )
        _[E++] = arguments[++y];
      return e(O, p ? u : this, _);
    }
    return v;
  }
  return Gj = i, Gj;
}
var Yj, _$;
function Jme() {
  if (_$) return Yj;
  _$ = 1;
  var e = eee(), t = tee(), n = IU(), r = "__lodash_placeholder__", i = 1, o = 2, s = 4, u = 8, f = 128, p = 256, m = Math.min;
  function v(y, S) {
    var E = y[1], w = S[1], _ = E | w, O = _ < (i | o | f), D = w == f && E == u || w == f && E == p && y[7].length <= S[8] || w == (f | p) && S[7].length <= S[8] && E == u;
    if (!(O || D))
      return y;
    w & i && (y[2] = S[2], _ |= E & i ? 0 : s);
    var P = S[3];
    if (P) {
      var M = y[3];
      y[3] = M ? e(M, P, S[4]) : P, y[4] = M ? n(y[3], r) : S[4];
    }
    return P = S[5], P && (M = y[5], y[5] = M ? t(M, P, S[6]) : P, y[6] = M ? n(y[5], r) : S[6]), P = S[7], P && (y[7] = P), w & f && (y[8] = y[8] == null ? S[8] : m(y[8], S[8])), y[9] == null && (y[9] = S[9]), y[0] = S[0], y[1] = _, y;
  }
  return Yj = v, Yj;
}
var Xj, C$;
function eve() {
  if (C$) return Xj;
  C$ = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return Xj = t, Xj;
}
var Zj, R$;
function tve() {
  if (R$) return Zj;
  R$ = 1;
  var e = eve(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return Zj = n, Zj;
}
var Kj, O$;
function nve() {
  if (O$) return Kj;
  O$ = 1;
  var e = tve(), t = Mu(), n = wx(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, u = parseInt;
  function f(p) {
    if (typeof p == "number")
      return p;
    if (n(p))
      return r;
    if (t(p)) {
      var m = typeof p.valueOf == "function" ? p.valueOf() : p;
      p = t(m) ? m + "" : m;
    }
    if (typeof p != "string")
      return p === 0 ? p : +p;
    p = e(p);
    var v = o.test(p);
    return v || s.test(p) ? u(p.slice(2), v ? 2 : 8) : i.test(p) ? r : +p;
  }
  return Kj = f, Kj;
}
var Qj, A$;
function rve() {
  if (A$) return Qj;
  A$ = 1;
  var e = nve(), t = 1 / 0, n = 17976931348623157e292;
  function r(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -t) {
      var o = i < 0 ? -1 : 1;
      return o * n;
    }
    return i === i ? i : 0;
  }
  return Qj = r, Qj;
}
var Jj, D$;
function PU() {
  if (D$) return Jj;
  D$ = 1;
  var e = rve();
  function t(n) {
    var r = e(n), i = r % 1;
    return r === r ? i ? r - i : r : 0;
  }
  return Jj = t, Jj;
}
var eL, I$;
function NU() {
  if (I$) return eL;
  I$ = 1;
  var e = JJ(), t = Mme(), n = Kme(), r = uee(), i = Qme(), o = ree(), s = Jme(), u = aee(), f = see(), p = PU(), m = "Expected a function", v = 1, y = 2, S = 8, E = 16, w = 32, _ = 64, O = Math.max;
  function D(P, M, N, k, U, H, Y, z) {
    var V = M & y;
    if (!V && typeof P != "function")
      throw new TypeError(m);
    var F = k ? k.length : 0;
    if (F || (M &= -97, k = U = void 0), Y = Y === void 0 ? Y : O(p(Y), 0), z = z === void 0 ? z : p(z), F -= U ? U.length : 0, M & _) {
      var X = k, oe = U;
      k = U = void 0;
    }
    var re = V ? void 0 : o(P), Z = [
      P,
      M,
      N,
      k,
      U,
      X,
      oe,
      H,
      Y,
      z
    ];
    if (re && s(Z, re), P = Z[0], M = Z[1], N = Z[2], k = Z[3], U = Z[4], z = Z[9] = Z[9] === void 0 ? V ? 0 : P.length : O(Z[9] - F, 0), !z && M & (S | E) && (M &= -25), !M || M == v)
      var ee = t(P, M, N);
    else M == S || M == E ? ee = n(P, M, z) : (M == w || M == (v | w)) && !U.length ? ee = i(P, M, N, k) : ee = r.apply(void 0, Z);
    var J = re ? e : u;
    return f(J(ee, Z), P, M);
  }
  return eL = D, eL;
}
var tL, P$;
function dee() {
  if (P$) return tL;
  P$ = 1;
  var e = NU(), t = 8;
  function n(r, i, o) {
    i = o ? void 0 : i;
    var s = e(r, t, void 0, void 0, void 0, void 0, void 0, i);
    return s.placeholder = n.placeholder, s;
  }
  return n.placeholder = {}, tL = n, tL;
}
var ive = dee();
const ove = /* @__PURE__ */ Hn(ive);
var nL, N$;
function cD() {
  if (N$) return nL;
  N$ = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, i = typeof r == "function" && r.prototype || e;
    return n === i;
  }
  return nL = t, nL;
}
var rL, M$;
function fee() {
  if (M$) return rL;
  M$ = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return rL = e, rL;
}
var iL, j$;
function ave() {
  if (j$) return iL;
  j$ = 1;
  var e = fee(), t = e(Object.keys, Object);
  return iL = t, iL;
}
var oL, L$;
function MU() {
  if (L$) return oL;
  L$ = 1;
  var e = cD(), t = ave(), n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    if (!e(o))
      return t(o);
    var s = [];
    for (var u in Object(o))
      r.call(o, u) && u != "constructor" && s.push(u);
    return s;
  }
  return oL = i, oL;
}
var aL, k$;
function sve() {
  if (k$) return aL;
  k$ = 1;
  var e = qv(), t = Hs(), n = e(t, "DataView");
  return aL = n, aL;
}
var sL, z$;
function lve() {
  if (z$) return sL;
  z$ = 1;
  var e = qv(), t = Hs(), n = e(t, "Promise");
  return sL = n, sL;
}
var lL, B$;
function pee() {
  if (B$) return lL;
  B$ = 1;
  var e = qv(), t = Hs(), n = e(t, "Set");
  return lL = n, lL;
}
var cL, V$;
function _x() {
  if (V$) return cL;
  V$ = 1;
  var e = sve(), t = SU(), n = lve(), r = pee(), i = KJ(), o = mg(), s = WJ(), u = "[object Map]", f = "[object Object]", p = "[object Promise]", m = "[object Set]", v = "[object WeakMap]", y = "[object DataView]", S = s(e), E = s(t), w = s(n), _ = s(r), O = s(i), D = o;
  return (e && D(new e(new ArrayBuffer(1))) != y || t && D(new t()) != u || n && D(n.resolve()) != p || r && D(new r()) != m || i && D(new i()) != v) && (D = function(P) {
    var M = o(P), N = M == f ? P.constructor : void 0, k = N ? s(N) : "";
    if (k)
      switch (k) {
        case S:
          return y;
        case E:
          return u;
        case w:
          return p;
        case _:
          return m;
        case O:
          return v;
      }
    return M;
  }), cL = D, cL;
}
var uL, U$;
function cve() {
  if (U$) return uL;
  U$ = 1;
  var e = mg(), t = Bl(), n = "[object Arguments]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return uL = r, uL;
}
var dL, F$;
function uD() {
  if (F$) return dL;
  F$ = 1;
  var e = cve(), t = Bl(), n = Object.prototype, r = n.hasOwnProperty, i = n.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return t(s) && r.call(s, "callee") && !i.call(s, "callee");
  };
  return dL = o, dL;
}
var fL, W$;
function jU() {
  if (W$) return fL;
  W$ = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return fL = t, fL;
}
var pL, H$;
function Gv() {
  if (H$) return pL;
  H$ = 1;
  var e = JA(), t = jU();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return pL = n, pL;
}
var TE = { exports: {} }, hL, q$;
function uve() {
  if (q$) return hL;
  q$ = 1;
  function e() {
    return !1;
  }
  return hL = e, hL;
}
TE.exports;
var $$;
function dD() {
  return $$ || ($$ = 1, (function(e, t) {
    var n = Hs(), r = uve(), i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, s = o && o.exports === i, u = s ? n.Buffer : void 0, f = u ? u.isBuffer : void 0, p = f || r;
    e.exports = p;
  })(TE, TE.exports)), TE.exports;
}
var gL, G$;
function dve() {
  if (G$) return gL;
  G$ = 1;
  var e = mg(), t = jU(), n = Bl(), r = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", s = "[object Date]", u = "[object Error]", f = "[object Function]", p = "[object Map]", m = "[object Number]", v = "[object Object]", y = "[object RegExp]", S = "[object Set]", E = "[object String]", w = "[object WeakMap]", _ = "[object ArrayBuffer]", O = "[object DataView]", D = "[object Float32Array]", P = "[object Float64Array]", M = "[object Int8Array]", N = "[object Int16Array]", k = "[object Int32Array]", U = "[object Uint8Array]", H = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", z = "[object Uint32Array]", V = {};
  V[D] = V[P] = V[M] = V[N] = V[k] = V[U] = V[H] = V[Y] = V[z] = !0, V[r] = V[i] = V[_] = V[o] = V[O] = V[s] = V[u] = V[f] = V[p] = V[m] = V[v] = V[y] = V[S] = V[E] = V[w] = !1;
  function F(X) {
    return n(X) && t(X.length) && !!V[e(X)];
  }
  return gL = F, gL;
}
var mL, Y$;
function M1() {
  if (Y$) return mL;
  Y$ = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return mL = e, mL;
}
var EE = { exports: {} };
EE.exports;
var X$;
function LU() {
  return X$ || (X$ = 1, (function(e, t) {
    var n = FJ(), r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, s = o && n.process, u = (function() {
      try {
        var f = i && i.require && i.require("util").types;
        return f || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = u;
  })(EE, EE.exports)), EE.exports;
}
var vL, Z$;
function kU() {
  if (Z$) return vL;
  Z$ = 1;
  var e = dve(), t = M1(), n = LU(), r = n && n.isTypedArray, i = r ? t(r) : e;
  return vL = i, vL;
}
var yL, K$;
function fve() {
  if (K$) return yL;
  K$ = 1;
  var e = MU(), t = _x(), n = uD(), r = Yo(), i = Gv(), o = dD(), s = cD(), u = kU(), f = "[object Map]", p = "[object Set]", m = Object.prototype, v = m.hasOwnProperty;
  function y(S) {
    if (S == null)
      return !0;
    if (i(S) && (r(S) || typeof S == "string" || typeof S.splice == "function" || o(S) || u(S) || n(S)))
      return !S.length;
    var E = t(S);
    if (E == f || E == p)
      return !S.size;
    if (s(S))
      return !e(S).length;
    for (var w in S)
      if (v.call(S, w))
        return !1;
    return !0;
  }
  return yL = y, yL;
}
var pve = fve();
const B2 = /* @__PURE__ */ Hn(pve);
function hve(e, t) {
  function n(i, o) {
    const s = Qi(bU), u = {
      ...i,
      ...o ? { ref: o } : {}
    }, f = (s || {})[e];
    if (B2(f) || B2(f.wrap))
      return /* @__PURE__ */ T.jsx(t, { ...u });
    const p = (m, v) => {
      const y = v.component;
      return /* @__PURE__ */ T.jsx(
        y,
        {
          targetProps: u,
          ...u,
          TargetComponent: t,
          children: m
        }
      );
    };
    return f.wrap.slice().reverse().reduce(p, /* @__PURE__ */ T.jsx(t, { ...u }));
  }
  const r = YA(n);
  return r.displayName = `WithPlugins(${e})`, r;
}
const Tt = ove(hve);
let DR;
const gve = new Uint8Array(16);
function mve() {
  if (!DR && (DR = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !DR))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return DR(gve);
}
const oa = [];
for (let e = 0; e < 256; ++e)
  oa.push((e + 256).toString(16).slice(1));
function vve(e, t = 0) {
  return oa[e[t + 0]] + oa[e[t + 1]] + oa[e[t + 2]] + oa[e[t + 3]] + "-" + oa[e[t + 4]] + oa[e[t + 5]] + "-" + oa[e[t + 6]] + oa[e[t + 7]] + "-" + oa[e[t + 8]] + oa[e[t + 9]] + "-" + oa[e[t + 10]] + oa[e[t + 11]] + oa[e[t + 12]] + oa[e[t + 13]] + oa[e[t + 14]] + oa[e[t + 15]];
}
const yve = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Q$ = {
  randomUUID: yve
};
function zs(e, t, n) {
  if (Q$.randomUUID && !e)
    return Q$.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || mve)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, vve(r);
}
const Ce = {
  ADD_COMPANION_WINDOW: "mirador/ADD_COMPANION_WINDOW",
  UPDATE_COMPANION_WINDOW: "mirador/UPDATE_COMPANION_WINDOW",
  REMOVE_COMPANION_WINDOW: "mirador/REMOVE_COMPANION_WINDOW",
  TOGGLE_TOC_NODE: "mirador/TOGGLE_TOC_NODE",
  UPDATE_WINDOW: "mirador/UPDATE_WINDOW",
  REQUEST_CANVAS_ANNOTATIONS: "mirador/REQUEST_CANVAS_ANNOTATIONS",
  HOVER_ANNOTATION: "mirador/HOVER_ANNOTATION",
  REQUEST_ANNOTATION: "mirador/REQUEST_ANNOTATION",
  RECEIVE_ANNOTATION: "mirador/RECEIVE_ANNOTATION",
  RECEIVE_ANNOTATION_FAILURE: "mirador/RECEIVE_ANNOTATION_FAILURE",
  DESELECT_ANNOTATION: "mirador/DESELECT_ANNOTATION",
  SELECT_ANNOTATION: "mirador/SELECT_ANNOTATION",
  TOGGLE_ANNOTATION_DISPLAY: "mirador/TOGGLE_ANNOTATION_DISPLAY",
  FOCUS_WINDOW: "mirador/FOCUS_WINDOW",
  SET_WORKSPACE_FULLSCREEN: "mirador/SET_WORKSPACE_FULLSCREEN",
  SET_WORKSPACE_VIEWPORT_POSITION: "mirador/SET_WORKSPACE_VIEWPORT_POSITION",
  ADD_MANIFEST: "mirador/ADD_MANIFEST",
  ADD_WINDOW: "mirador/ADD_WINDOW",
  ADD_ERROR: "mirador/ADD_ERROR",
  IMPORT_CONFIG: "mirador/IMPORT_CONFIG",
  IMPORT_MIRADOR_STATE: "mirador/IMPORT_MIRADOR_STATE",
  SET_CANVAS: "mirador/SET_CANVAS",
  MAXIMIZE_WINDOW: "mirador/MAXIMIZE_WINDOW",
  MINIMIZE_WINDOW: "mirador/MINIMIZE_WINDOW",
  UPDATE_WINDOW_POSITION: "mirador/UPDATE_WINDOW_POSITION",
  SET_WINDOW_SIZE: "mirador/SET_WINDOW_SIZE",
  REMOVE_WINDOW: "mirador/REMOVE_WINDOW",
  PICK_WINDOWING_SYSTEM: "mirador/PICK_WINDOWING_SYSTEM",
  REQUEST_MANIFEST: "mirador/REQUEST_MANIFEST",
  RECEIVE_MANIFEST: "mirador/RECEIVE_MANIFEST",
  RECEIVE_MANIFEST_FAILURE: "mirador/RECEIVE_MANIFEST_FAILURE",
  REMOVE_ERROR: "mirador/REMOVE_ERROR",
  SET_CONFIG: "mirador/SET_CONFIG",
  UPDATE_WORKSPACE: "mirador/UPDATE_WORKSPACE",
  SET_WINDOW_THUMBNAIL_POSITION: "mirador/SET_WINDOW_THUMBNAIL_POSITION",
  SET_WINDOW_VIEW_TYPE: "mirador/SET_WINDOW_VIEW_TYPE",
  SET_WORKSPACE_ADD_VISIBILITY: "mirador/SET_WORKSPACE_ADD_VISIBILITY",
  TOGGLE_WINDOW_SIDE_BAR: "mirador/TOGGLE_WINDOW_SIDE_BAR",
  TOGGLE_DRAGGING: "mirador/TOGGLE_DRAGGING",
  TOGGLE_ZOOM_CONTROLS: "mirador/TOGGLE_ZOOM_CONTROLS",
  UPDATE_CONFIG: "mirador/UPDATE_CONFIG",
  REMOVE_MANIFEST: "mirador/REMOVE_MANIFEST",
  REQUEST_INFO_RESPONSE: "mirador/REQUEST_INFO_RESPONSE",
  RECEIVE_INFO_RESPONSE: "mirador/RECEIVE_INFO_RESPONSE",
  RECEIVE_DEGRADED_INFO_RESPONSE: "mirador/RECEIVE_DEGRADED_INFO_RESPONSE",
  RECEIVE_INFO_RESPONSE_FAILURE: "mirador/RECEIVE_INFO_RESPONSE_FAILURE",
  REMOVE_INFO_RESPONSE: "mirador/REMOVE_INFO_RESPONSE",
  REQUEST_PROBE_RESPONSE: "mirador/REQUEST_PROBE_RESPONSE",
  RECEIVE_PROBE_RESPONSE: "mirador/RECEIVE_PROBE_RESPONSE",
  RECEIVE_DEGRADED_PROBE_RESPONSE: "mirador/RECEIVE_DEGRADED_PROBE_RESPONSE",
  RECEIVE_PROBE_RESPONSE_FAILURE: "mirador/RECEIVE_PROBE_RESPONSE_FAILURE",
  REMOVE_PROBE_RESPONSE: "mirador/REMOVE_PROBE_RESPONSE",
  UPDATE_WORKSPACE_MOSAIC_LAYOUT: "mirador/UPDATE_WORKSPACE_MOSAIC_LAYOUT",
  UPDATE_VIEWPORT: "mirador/UPDATE_VIEWPORT",
  UPDATE_ELASTIC_WINDOW_LAYOUT: "mirador/UPDATE_ELASTIC_WINDOW_LAYOUT",
  ADD_AUTHENTICATION_REQUEST: "mirador/ADD_AUTHENTICATION_REQUEST",
  RESOLVE_AUTHENTICATION_REQUEST: "mirador/RESOLVE_AUTHENTICATION_REQUEST",
  REQUEST_ACCESS_TOKEN: "mirador/REQUEST_ACCESS_TOKEN",
  RECEIVE_ACCESS_TOKEN: "mirador/RECEIVE_ACCESS_TOKEN",
  RECEIVE_ACCESS_TOKEN_FAILURE: "mirador/RECEIVE_ACCESS_TOKEN_FAILURE",
  RESET_AUTHENTICATION_STATE: "mirador/RESET_AUTHENTICATION_STATE",
  CLEAR_ACCESS_TOKEN_QUEUE: "mirador/CLEAR_ACCESS_TOKEN_QUEUE",
  REQUEST_SEARCH: "mirador/REQUEST_SEARCH",
  RECEIVE_SEARCH: "mirador/RECEIVE_SEARCH",
  RECEIVE_SEARCH_FAILURE: "mirador/RECEIVE_SEARCH_FAILURE",
  REMOVE_SEARCH: "mirador/REMOVE_SEARCH",
  SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS: "mirador/SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS",
  UPDATE_LAYERS: "mirador/UPDATE_LAYERS",
  ADD_RESOURCE: "mirador/ADD_RESOURCE",
  REMOVE_RESOURCE: "mirador/REMOVE_RESOURCE",
  SHOW_COLLECTION_DIALOG: "mirador/SHOW_COLLECTION_DIALOG",
  HIDE_COLLECTION_DIALOG: "mirador/HIDE_COLLECTION_DIALOG"
};
var bve = {}, xve = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let r = !1;
    try {
      const i = {};
      e(i) === i && (r = !0);
    } catch {
    }
    if (r) {
      let i;
      try {
        throw new Error();
      } catch (o) {
        ({ stack: i } = o);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, Sve = (e, t, n) => {
  const { memoize: r, memoizeOptions: i } = t, { inputSelectorResults: o, inputSelectorResultsCopy: s } = e, u = r(() => ({}), ...i);
  if (!(u.apply(null, o) === u.apply(null, s))) {
    let p;
    try {
      throw new Error();
    } catch (m) {
      ({ stack: p } = m);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: o,
        secondInputs: s,
        stack: p
      }
    );
  }
}, wve = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function Tve(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Eve(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function _ve(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var J$ = (e) => Array.isArray(e) ? e : [e];
function Cve(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return _ve(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function e8(e, t) {
  const n = [], { length: r } = e;
  for (let i = 0; i < r; i++)
    n.push(e[i].apply(null, t));
  return n;
}
var Rve = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: r } = {
    ...wve,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: xve
    },
    inputStabilityCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: Sve
    }
  };
}, Ove = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Ave = typeof WeakRef < "u" ? WeakRef : Ove, Dve = 0, t8 = 1;
function IR() {
  return {
    s: Dve,
    v: void 0,
    o: null,
    p: null
  };
}
function hee(e, t = {}) {
  let n = IR();
  const { resultEqualityCheck: r } = t;
  let i, o = 0;
  function s() {
    var v;
    let u = n;
    const { length: f } = arguments;
    for (let y = 0, S = f; y < S; y++) {
      const E = arguments[y];
      if (typeof E == "function" || typeof E == "object" && E !== null) {
        let w = u.o;
        w === null && (u.o = w = /* @__PURE__ */ new WeakMap());
        const _ = w.get(E);
        _ === void 0 ? (u = IR(), w.set(E, u)) : u = _;
      } else {
        let w = u.p;
        w === null && (u.p = w = /* @__PURE__ */ new Map());
        const _ = w.get(E);
        _ === void 0 ? (u = IR(), w.set(E, u)) : u = _;
      }
    }
    const p = u;
    let m;
    if (u.s === t8 ? m = u.v : (m = e.apply(null, arguments), o++), p.s = t8, r) {
      const y = ((v = i == null ? void 0 : i.deref) == null ? void 0 : v.call(i)) ?? i;
      y != null && r(y, m) && (m = y, o !== 0 && o--), i = typeof m == "object" && m !== null || typeof m == "function" ? new Ave(m) : m;
    }
    return p.v = m, m;
  }
  return s.clearCache = () => {
    n = IR(), s.resetResultsCount();
  }, s.resultsCount = () => o, s.resetResultsCount = () => {
    o = 0;
  }, s;
}
function Ive(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...i) => {
    let o = 0, s = 0, u, f = {}, p = i.pop();
    typeof p == "object" && (f = p, p = i.pop()), Tve(
      p,
      `createSelector expects an output function after the inputs, but received: [${typeof p}]`
    );
    const m = {
      ...n,
      ...f
    }, {
      memoize: v,
      memoizeOptions: y = [],
      argsMemoize: S = hee,
      argsMemoizeOptions: E = [],
      devModeChecks: w = {}
    } = m, _ = J$(y), O = J$(E), D = Cve(i), P = v(function() {
      return o++, p.apply(
        null,
        arguments
      );
    }, ..._);
    let M = !0;
    const N = S(function() {
      s++;
      const U = e8(
        D,
        arguments
      );
      if (u = P.apply(null, U), bve.NODE_ENV !== "production") {
        const { identityFunctionCheck: H, inputStabilityCheck: Y } = Rve(M, w);
        if (H.shouldRun && H.run(
          p,
          U,
          u
        ), Y.shouldRun) {
          const z = e8(
            D,
            arguments
          );
          Y.run(
            { inputSelectorResults: U, inputSelectorResultsCopy: z },
            { memoize: v, memoizeOptions: _ },
            arguments
          );
        }
        M && (M = !1);
      }
      return u;
    }, ...O);
    return Object.assign(N, {
      resultFunc: p,
      memoizedResultFunc: P,
      dependencies: D,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => u,
      recomputations: () => o,
      resetRecomputations: () => {
        o = 0;
      },
      memoize: v,
      argsMemoize: S
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var Qe = /* @__PURE__ */ Ive(hee), Pve = Object.assign(
  (e, t = Qe) => {
    Eve(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (o) => e[o]
    );
    return t(
      r,
      (...o) => o.reduce((s, u, f) => (s[n[f]] = u, s), {})
    );
  },
  { withTypes: () => Pve }
), bL, n8;
function zU() {
  if (n8) return bL;
  n8 = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, o = 0, s = []; ++r < i; ) {
      var u = t[r];
      n(u, r, t) && (s[o++] = u);
    }
    return s;
  }
  return bL = e, bL;
}
var xL, r8;
function Nve() {
  if (r8) return xL;
  r8 = 1;
  function e(t) {
    return function(n, r, i) {
      for (var o = -1, s = Object(n), u = i(n), f = u.length; f--; ) {
        var p = u[t ? f : ++o];
        if (r(s[p], p, s) === !1)
          break;
      }
      return n;
    };
  }
  return xL = e, xL;
}
var SL, i8;
function Mve() {
  if (i8) return SL;
  i8 = 1;
  var e = Nve(), t = e();
  return SL = t, SL;
}
var wL, o8;
function jve() {
  if (o8) return wL;
  o8 = 1;
  function e(t, n) {
    for (var r = -1, i = Array(t); ++r < t; )
      i[r] = n(r);
    return i;
  }
  return wL = e, wL;
}
var TL, a8;
function gee() {
  if (a8) return TL;
  a8 = 1;
  var e = jve(), t = uD(), n = Yo(), r = dD(), i = N1(), o = kU(), s = Object.prototype, u = s.hasOwnProperty;
  function f(p, m) {
    var v = n(p), y = !v && t(p), S = !v && !y && r(p), E = !v && !y && !S && o(p), w = v || y || S || E, _ = w ? e(p.length, String) : [], O = _.length;
    for (var D in p)
      (m || u.call(p, D)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (D == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      S && (D == "offset" || D == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      E && (D == "buffer" || D == "byteLength" || D == "byteOffset") || // Skip index properties.
      i(D, O))) && _.push(D);
    return _;
  }
  return TL = f, TL;
}
var EL, s8;
function Cx() {
  if (s8) return EL;
  s8 = 1;
  var e = gee(), t = MU(), n = Gv();
  function r(i) {
    return n(i) ? e(i) : t(i);
  }
  return EL = r, EL;
}
var _L, l8;
function Lve() {
  if (l8) return _L;
  l8 = 1;
  var e = Mve(), t = Cx();
  function n(r, i) {
    return r && e(r, i, t);
  }
  return _L = n, _L;
}
var CL, c8;
function kve() {
  if (c8) return CL;
  c8 = 1;
  var e = Gv();
  function t(n, r) {
    return function(i, o) {
      if (i == null)
        return i;
      if (!e(i))
        return n(i, o);
      for (var s = i.length, u = r ? s : -1, f = Object(i); (r ? u-- : ++u < s) && o(f[u], u, f) !== !1; )
        ;
      return i;
    };
  }
  return CL = t, CL;
}
var RL, u8;
function BU() {
  if (u8) return RL;
  u8 = 1;
  var e = Lve(), t = kve(), n = t(e);
  return RL = n, RL;
}
var OL, d8;
function zve() {
  if (d8) return OL;
  d8 = 1;
  var e = BU();
  function t(n, r) {
    var i = [];
    return e(n, function(o, s, u) {
      r(o, s, u) && i.push(o);
    }), i;
  }
  return OL = t, OL;
}
var AL, f8;
function Bve() {
  if (f8) return AL;
  f8 = 1;
  var e = rD();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return AL = t, AL;
}
var DL, p8;
function Vve() {
  if (p8) return DL;
  p8 = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return DL = e, DL;
}
var IL, h8;
function Uve() {
  if (h8) return IL;
  h8 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return IL = e, IL;
}
var PL, g8;
function Fve() {
  if (g8) return PL;
  g8 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return PL = e, PL;
}
var NL, m8;
function Wve() {
  if (m8) return NL;
  m8 = 1;
  var e = rD(), t = SU(), n = wU(), r = 200;
  function i(o, s) {
    var u = this.__data__;
    if (u instanceof e) {
      var f = u.__data__;
      if (!t || f.length < r - 1)
        return f.push([o, s]), this.size = ++u.size, this;
      u = this.__data__ = new n(f);
    }
    return u.set(o, s), this.size = u.size, this;
  }
  return NL = i, NL;
}
var ML, v8;
function VU() {
  if (v8) return ML;
  v8 = 1;
  var e = rD(), t = Bve(), n = Vve(), r = Uve(), i = Fve(), o = Wve();
  function s(u) {
    var f = this.__data__ = new e(u);
    this.size = f.size;
  }
  return s.prototype.clear = t, s.prototype.delete = n, s.prototype.get = r, s.prototype.has = i, s.prototype.set = o, ML = s, ML;
}
var jL, y8;
function Hve() {
  if (y8) return jL;
  y8 = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return jL = t, jL;
}
var LL, b8;
function qve() {
  if (b8) return LL;
  b8 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return LL = e, LL;
}
var kL, x8;
function UU() {
  if (x8) return kL;
  x8 = 1;
  var e = wU(), t = Hve(), n = qve();
  function r(i) {
    var o = -1, s = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++o < s; )
      this.add(i[o]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, kL = r, kL;
}
var zL, S8;
function $ve() {
  if (S8) return zL;
  S8 = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return zL = e, zL;
}
var BL, w8;
function FU() {
  if (w8) return BL;
  w8 = 1;
  function e(t, n) {
    return t.has(n);
  }
  return BL = e, BL;
}
var VL, T8;
function mee() {
  if (T8) return VL;
  T8 = 1;
  var e = UU(), t = $ve(), n = FU(), r = 1, i = 2;
  function o(s, u, f, p, m, v) {
    var y = f & r, S = s.length, E = u.length;
    if (S != E && !(y && E > S))
      return !1;
    var w = v.get(s), _ = v.get(u);
    if (w && _)
      return w == u && _ == s;
    var O = -1, D = !0, P = f & i ? new e() : void 0;
    for (v.set(s, u), v.set(u, s); ++O < S; ) {
      var M = s[O], N = u[O];
      if (p)
        var k = y ? p(N, M, O, u, s, v) : p(M, N, O, s, u, v);
      if (k !== void 0) {
        if (k)
          continue;
        D = !1;
        break;
      }
      if (P) {
        if (!t(u, function(U, H) {
          if (!n(P, H) && (M === U || m(M, U, f, p, v)))
            return P.push(H);
        })) {
          D = !1;
          break;
        }
      } else if (!(M === N || m(M, N, f, p, v))) {
        D = !1;
        break;
      }
    }
    return v.delete(s), v.delete(u), D;
  }
  return VL = o, VL;
}
var UL, E8;
function vee() {
  if (E8) return UL;
  E8 = 1;
  var e = Hs(), t = e.Uint8Array;
  return UL = t, UL;
}
var FL, _8;
function Gve() {
  if (_8) return FL;
  _8 = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i, o) {
      r[++n] = [o, i];
    }), r;
  }
  return FL = e, FL;
}
var WL, C8;
function WU() {
  if (C8) return WL;
  C8 = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i) {
      r[++n] = i;
    }), r;
  }
  return WL = e, WL;
}
var HL, R8;
function Yve() {
  if (R8) return HL;
  R8 = 1;
  var e = Sx(), t = vee(), n = tD(), r = mee(), i = Gve(), o = WU(), s = 1, u = 2, f = "[object Boolean]", p = "[object Date]", m = "[object Error]", v = "[object Map]", y = "[object Number]", S = "[object RegExp]", E = "[object Set]", w = "[object String]", _ = "[object Symbol]", O = "[object ArrayBuffer]", D = "[object DataView]", P = e ? e.prototype : void 0, M = P ? P.valueOf : void 0;
  function N(k, U, H, Y, z, V, F) {
    switch (H) {
      case D:
        if (k.byteLength != U.byteLength || k.byteOffset != U.byteOffset)
          return !1;
        k = k.buffer, U = U.buffer;
      case O:
        return !(k.byteLength != U.byteLength || !V(new t(k), new t(U)));
      case f:
      case p:
      case y:
        return n(+k, +U);
      case m:
        return k.name == U.name && k.message == U.message;
      case S:
      case w:
        return k == U + "";
      case v:
        var X = i;
      case E:
        var oe = Y & s;
        if (X || (X = o), k.size != U.size && !oe)
          return !1;
        var re = F.get(k);
        if (re)
          return re == U;
        Y |= u, F.set(k, U);
        var Z = r(X(k), X(U), Y, z, V, F);
        return F.delete(k), Z;
      case _:
        if (M)
          return M.call(k) == M.call(U);
    }
    return !1;
  }
  return HL = N, HL;
}
var qL, O8;
function HU() {
  if (O8) return qL;
  O8 = 1;
  function e(t, n) {
    for (var r = -1, i = n.length, o = t.length; ++r < i; )
      t[o + r] = n[r];
    return t;
  }
  return qL = e, qL;
}
var $L, A8;
function yee() {
  if (A8) return $L;
  A8 = 1;
  var e = HU(), t = Yo();
  function n(r, i, o) {
    var s = i(r);
    return t(r) ? s : e(s, o(r));
  }
  return $L = n, $L;
}
var GL, D8;
function bee() {
  if (D8) return GL;
  D8 = 1;
  function e() {
    return [];
  }
  return GL = e, GL;
}
var YL, I8;
function qU() {
  if (I8) return YL;
  I8 = 1;
  var e = zU(), t = bee(), n = Object.prototype, r = n.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(s) {
    return s == null ? [] : (s = Object(s), e(i(s), function(u) {
      return r.call(s, u);
    }));
  } : t;
  return YL = o, YL;
}
var XL, P8;
function xee() {
  if (P8) return XL;
  P8 = 1;
  var e = yee(), t = qU(), n = Cx();
  function r(i) {
    return e(i, n, t);
  }
  return XL = r, XL;
}
var ZL, N8;
function Xve() {
  if (N8) return ZL;
  N8 = 1;
  var e = xee(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function i(o, s, u, f, p, m) {
    var v = u & t, y = e(o), S = y.length, E = e(s), w = E.length;
    if (S != w && !v)
      return !1;
    for (var _ = S; _--; ) {
      var O = y[_];
      if (!(v ? O in s : r.call(s, O)))
        return !1;
    }
    var D = m.get(o), P = m.get(s);
    if (D && P)
      return D == s && P == o;
    var M = !0;
    m.set(o, s), m.set(s, o);
    for (var N = v; ++_ < S; ) {
      O = y[_];
      var k = o[O], U = s[O];
      if (f)
        var H = v ? f(U, k, O, s, o, m) : f(k, U, O, o, s, m);
      if (!(H === void 0 ? k === U || p(k, U, u, f, m) : H)) {
        M = !1;
        break;
      }
      N || (N = O == "constructor");
    }
    if (M && !N) {
      var Y = o.constructor, z = s.constructor;
      Y != z && "constructor" in o && "constructor" in s && !(typeof Y == "function" && Y instanceof Y && typeof z == "function" && z instanceof z) && (M = !1);
    }
    return m.delete(o), m.delete(s), M;
  }
  return ZL = i, ZL;
}
var KL, M8;
function Zve() {
  if (M8) return KL;
  M8 = 1;
  var e = VU(), t = mee(), n = Yve(), r = Xve(), i = _x(), o = Yo(), s = dD(), u = kU(), f = 1, p = "[object Arguments]", m = "[object Array]", v = "[object Object]", y = Object.prototype, S = y.hasOwnProperty;
  function E(w, _, O, D, P, M) {
    var N = o(w), k = o(_), U = N ? m : i(w), H = k ? m : i(_);
    U = U == p ? v : U, H = H == p ? v : H;
    var Y = U == v, z = H == v, V = U == H;
    if (V && s(w)) {
      if (!s(_))
        return !1;
      N = !0, Y = !1;
    }
    if (V && !Y)
      return M || (M = new e()), N || u(w) ? t(w, _, O, D, P, M) : n(w, _, U, O, D, P, M);
    if (!(O & f)) {
      var F = Y && S.call(w, "__wrapped__"), X = z && S.call(_, "__wrapped__");
      if (F || X) {
        var oe = F ? w.value() : w, re = X ? _.value() : _;
        return M || (M = new e()), P(oe, re, O, D, M);
      }
    }
    return V ? (M || (M = new e()), r(w, _, O, D, P, M)) : !1;
  }
  return KL = E, KL;
}
var QL, j8;
function $U() {
  if (j8) return QL;
  j8 = 1;
  var e = Zve(), t = Bl();
  function n(r, i, o, s, u) {
    return r === i ? !0 : r == null || i == null || !t(r) && !t(i) ? r !== r && i !== i : e(r, i, o, s, n, u);
  }
  return QL = n, QL;
}
var JL, L8;
function Kve() {
  if (L8) return JL;
  L8 = 1;
  var e = VU(), t = $U(), n = 1, r = 2;
  function i(o, s, u, f) {
    var p = u.length, m = p, v = !f;
    if (o == null)
      return !m;
    for (o = Object(o); p--; ) {
      var y = u[p];
      if (v && y[2] ? y[1] !== o[y[0]] : !(y[0] in o))
        return !1;
    }
    for (; ++p < m; ) {
      y = u[p];
      var S = y[0], E = o[S], w = y[1];
      if (v && y[2]) {
        if (E === void 0 && !(S in o))
          return !1;
      } else {
        var _ = new e();
        if (f)
          var O = f(E, w, S, o, s, _);
        if (!(O === void 0 ? t(w, E, n | r, f, _) : O))
          return !1;
      }
    }
    return !0;
  }
  return JL = i, JL;
}
var ek, k8;
function See() {
  if (k8) return ek;
  k8 = 1;
  var e = Mu();
  function t(n) {
    return n === n && !e(n);
  }
  return ek = t, ek;
}
var tk, z8;
function Qve() {
  if (z8) return tk;
  z8 = 1;
  var e = See(), t = Cx();
  function n(r) {
    for (var i = t(r), o = i.length; o--; ) {
      var s = i[o], u = r[s];
      i[o] = [s, u, e(u)];
    }
    return i;
  }
  return tk = n, tk;
}
var nk, B8;
function wee() {
  if (B8) return nk;
  B8 = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return nk = e, nk;
}
var rk, V8;
function Jve() {
  if (V8) return rk;
  V8 = 1;
  var e = Kve(), t = Qve(), n = wee();
  function r(i) {
    var o = t(i);
    return o.length == 1 && o[0][2] ? n(o[0][0], o[0][1]) : function(s) {
      return s === i || e(s, i, o);
    };
  }
  return rk = r, rk;
}
var ik, U8;
function eye() {
  if (U8) return ik;
  U8 = 1;
  var e = P1();
  function t(n, r, i) {
    var o = n == null ? void 0 : e(n, r);
    return o === void 0 ? i : o;
  }
  return ik = t, ik;
}
var ok, F8;
function tye() {
  if (F8) return ok;
  F8 = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return ok = e, ok;
}
var ak, W8;
function nye() {
  if (W8) return ak;
  W8 = 1;
  var e = I1(), t = uD(), n = Yo(), r = N1(), i = jU(), o = $v();
  function s(u, f, p) {
    f = e(f, u);
    for (var m = -1, v = f.length, y = !1; ++m < v; ) {
      var S = o(f[m]);
      if (!(y = u != null && p(u, S)))
        break;
      u = u[S];
    }
    return y || ++m != v ? y : (v = u == null ? 0 : u.length, !!v && i(v) && r(S, v) && (n(u) || t(u)));
  }
  return ak = s, ak;
}
var sk, H8;
function rye() {
  if (H8) return sk;
  H8 = 1;
  var e = tye(), t = nye();
  function n(r, i) {
    return r != null && t(r, i, e);
  }
  return sk = n, sk;
}
var lk, q8;
function iye() {
  if (q8) return lk;
  q8 = 1;
  var e = $U(), t = eye(), n = rye(), r = xU(), i = See(), o = wee(), s = $v(), u = 1, f = 2;
  function p(m, v) {
    return r(m) && i(v) ? o(s(m), v) : function(y) {
      var S = t(y, m);
      return S === void 0 && S === v ? n(y, m) : e(v, S, u | f);
    };
  }
  return lk = p, lk;
}
var ck, $8;
function oye() {
  if ($8) return ck;
  $8 = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return ck = e, ck;
}
var uk, G8;
function aye() {
  if (G8) return uk;
  G8 = 1;
  var e = P1();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return uk = t, uk;
}
var dk, Y8;
function sye() {
  if (Y8) return dk;
  Y8 = 1;
  var e = oye(), t = aye(), n = xU(), r = $v();
  function i(o) {
    return n(o) ? e(r(o)) : t(o);
  }
  return dk = i, dk;
}
var fk, X8;
function fD() {
  if (X8) return fk;
  X8 = 1;
  var e = Jve(), t = iye(), n = Ex(), r = Yo(), i = sye();
  function o(s) {
    return typeof s == "function" ? s : s == null ? n : typeof s == "object" ? r(s) ? t(s[0], s[1]) : e(s) : i(s);
  }
  return fk = o, fk;
}
var pk, Z8;
function lye() {
  if (Z8) return pk;
  Z8 = 1;
  var e = zU(), t = zve(), n = fD(), r = Yo();
  function i(o, s) {
    var u = r(o) ? e : t;
    return u(o, n(s, 3));
  }
  return pk = i, pk;
}
var cye = lye();
const pD = /* @__PURE__ */ Hn(cye);
var hk, K8;
function uye() {
  if (K8) return hk;
  K8 = 1;
  var e = Sx(), t = uD(), n = Yo(), r = e ? e.isConcatSpreadable : void 0;
  function i(o) {
    return n(o) || t(o) || !!(r && o && o[r]);
  }
  return hk = i, hk;
}
var gk, Q8;
function Rx() {
  if (Q8) return gk;
  Q8 = 1;
  var e = HU(), t = uye();
  function n(r, i, o, s, u) {
    var f = -1, p = r.length;
    for (o || (o = t), u || (u = []); ++f < p; ) {
      var m = r[f];
      i > 0 && o(m) ? i > 1 ? n(m, i - 1, o, s, u) : e(u, m) : s || (u[u.length] = m);
    }
    return u;
  }
  return gk = n, gk;
}
var mk, J8;
function Tee() {
  if (J8) return mk;
  J8 = 1;
  var e = Rx();
  function t(n) {
    var r = n == null ? 0 : n.length;
    return r ? e(n, 1) : [];
  }
  return mk = t, mk;
}
var dye = Tee();
const vn = /* @__PURE__ */ Hn(dye);
var vk, eG;
function fye() {
  if (eG) return vk;
  eG = 1;
  function e(t) {
    for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
      var s = t[n];
      s && (o[i++] = s);
    }
    return o;
  }
  return vk = e, vk;
}
var pye = fye();
const Sv = /* @__PURE__ */ Hn(pye);
class hye {
  /** */
  constructor(t = {}) {
    this.resource = t;
  }
  /** */
  isOnlyTag() {
    return this.motivations.length === 1 && this.motivations[0] === "oa:tagging";
  }
  /** */
  get id() {
    return this._id = this._id || this.resource["@id"] || this.resources[0] && this.resources[0]["@id"] || zs(), this._id;
  }
  /** */
  get targetId() {
    const t = this.on[0];
    switch (typeof t) {
      case "string":
        return t.replace(/#?xywh=(.*)$/, "");
      case "object":
        return t.full.replace(/#?xywh=(.*)$/, "");
      default:
        return null;
    }
  }
  /**
   * @return {[Array]}
   */
  get motivations() {
    return vn(Sv(new Array(this.resource.motivation)));
  }
  /** */
  get resources() {
    return vn(Sv(new Array(this.resource.resource)));
  }
  /** */
  get on() {
    return vn(Sv(new Array(this.resource.on)));
  }
  /** */
  get tags() {
    return this.isOnlyTag() ? this.resources.map((t) => t.chars) : this.resources.filter((t) => t["@type"] === "oa:Tag").map((t) => t.chars);
  }
  /** */
  get chars() {
    return this.resources.filter((t) => t["@type"] !== "oa:Tag").map((t) => t.chars).join(" ");
  }
  /** */
  get selector() {
    const t = this.on[0];
    switch (typeof t) {
      case "string":
        return t;
      case "object":
        return t.selector["@type"] === "oa:Choice" ? t.selector.default : t.selector;
      default:
        return null;
    }
  }
  /** */
  get svgSelector() {
    const t = this.on[0];
    switch (typeof t) {
      case "string":
        return null;
      case "object":
        return t.selector && t.selector.item && t.selector.item["@type"] === "oa:SvgSelector" ? t.selector.item : null;
      default:
        return null;
    }
  }
  /** */
  get fragmentSelector() {
    const { selector: t } = this;
    let n;
    switch (typeof t) {
      case "string":
        n = t.match(/xywh=(.*)$/);
        break;
      case "object":
        n = t.value.match(/xywh=(.*)$/);
        break;
      default:
        return null;
    }
    return n && n[1].split(",").map((r) => parseInt(r, 10));
  }
}
let Eee = class {
  /** */
  constructor(t, n) {
    this.json = t, this.target = n;
  }
  /** */
  get id() {
    return this.json["@id"];
  }
  /** */
  present() {
    return this.resources && this.resources.length > 0;
  }
  /** */
  get resources() {
    return this._resources = this._resources || (!this.json || !this.json.resources ? [] : vn([this.json.resources]).map((t) => new hye(t))), this._resources;
  }
};
class gye {
  /** */
  constructor(t = {}) {
    this.resource = t;
  }
  /** */
  isOnlyTag() {
    return this.motivations.length === 1 && this.motivations[0] === "tagging";
  }
  /** */
  get id() {
    return this._id = this._id || this.resource.id || zs(), this._id;
  }
  /** */
  get targetId() {
    const t = this.target[0];
    switch (typeof t) {
      case "string":
        return t.replace(/#?xywh=(.*)$/, "");
      case "object":
        return t.source && t.source.id || t.source || t.id;
      default:
        return null;
    }
  }
  /**
   * @return {[Array]}
   */
  get motivations() {
    return vn(Sv(new Array(this.resource.motivation)));
  }
  /** */
  get body() {
    return vn(Sv(new Array(this.resource.body)));
  }
  /** */
  get resources() {
    return this.body;
  }
  /** */
  get tags() {
    return this.isOnlyTag() ? this.body.map((t) => t.value) : this.body.filter((t) => t.purpose === "tagging").map((t) => t.value);
  }
  /** */
  get target() {
    return vn(Sv(new Array(this.resource.target)));
  }
  /** */
  get chars() {
    return this.isOnlyTag() ? null : this.body.filter((t) => t.purpose !== "tagging").map((t) => t.value).join(" ");
  }
  /** */
  get selector() {
    const t = this.target[0];
    switch (typeof t) {
      case "string":
        return t;
      case "object":
        return vn(Sv(new Array(t.selector)));
      default:
        return null;
    }
  }
  /** */
  get svgSelector() {
    const { selector: t } = this;
    switch (typeof t) {
      case "string":
        return null;
      case "object":
        return t.find((n) => n.type && n.type === "SvgSelector");
      default:
        return null;
    }
  }
  /** */
  get fragmentSelector() {
    const { selector: t } = this;
    let n, r;
    switch (typeof t) {
      case "string":
        n = t.match(/xywh=(.*)$/);
        break;
      case "object":
        r = t.find((i) => i.type && i.type === "FragmentSelector"), n = r && r.value.match(/xywh=(.*)$/);
        break;
      default:
        return null;
    }
    return n && n[1].split(",").map((i) => parseInt(i, 10));
  }
}
let mye = class {
  /** */
  constructor(t, n) {
    this.json = t, this.target = n;
  }
  /** */
  get id() {
    return this.json.id;
  }
  /** */
  present() {
    return this.items && this.items.length > 0;
  }
  /** */
  get items() {
    return this._items = this._items || (!this.json || !this.json.items ? [] : vn([this.json.items]).map((t) => new gye(t))), this._items;
  }
  /**
   * Alias to items for compatibility for right now.
   */
  get resources() {
    return this.items;
  }
};
class _ee {
  /** */
  static determineAnnotation(t, n) {
    return t ? t.type === "AnnotationPage" ? new mye(t, n) : new Eee(t, n) : null;
  }
}
const Pv = {
  state: {
    // slice: 'mirador' // Configure the top-level slice of state for mirador selectors
  },
  canvasNavigation: {
    // Set the height and width of canvas thumbnails in the  CanvasNavigation companion window
    height: 50,
    width: 50
  },
  selectedTheme: "light",
  // dark also available
  themes: {
    dark: {
      palette: {
        mode: "dark",
        primary: {
          main: "#4db6ac"
        },
        secondary: {
          main: "#4db6ac"
        },
        shades: {
          dark: "#000000",
          main: "#424242",
          light: "#616161"
        }
      }
    },
    light: {
      palette: {
        mode: "light"
      }
    }
  },
  theme: {
    // Sets up a MaterialUI theme. See https://material-ui.com/customization/default-theme/
    palette: {
      mode: "light",
      primary: {
        main: "#1967d2"
        // Controls the color of the Add button and current window indicator
      },
      secondary: {
        main: "#1967d2"
        // Controls the color of Selects and FormControls
      },
      shades: {
        // Shades that can be used to offset color areas of the Workspace / Window
        dark: "#eeeeee",
        main: "#ffffff",
        light: "#f5f5f5"
      },
      error: {
        main: "#b00020"
      },
      notification: {
        // Color used in MUI Badge dots
        main: "#ffa224"
      },
      hitCounter: {
        default: "#bdbdbd"
      },
      highlights: {
        primary: "#ffff00",
        secondary: "#00BFFF"
      },
      section_divider: "rgba(0, 0, 0, 0.25)",
      annotations: {
        chipBackground: "#e0e0e0",
        hidden: { globalAlpha: 0 },
        default: { strokeStyle: "#00BFFF", globalAlpha: 1 },
        hovered: { strokeStyle: "#BF00FF", globalAlpha: 1 },
        selected: { strokeStyle: "#ffff00", globalAlpha: 1 }
      },
      search: {
        default: { fillStyle: "#00BFFF", globalAlpha: 0.3 },
        hovered: { fillStyle: "#00FFFF", globalAlpha: 0.3 },
        selected: { fillStyle: "#ffff00", globalAlpha: 0.3 }
      }
    },
    typography: {
      body1: {
        fontSize: "1rem",
        letterSpacing: "0em",
        lineHeight: "1.6em"
      },
      body2: {
        fontSize: "0.878rem",
        letterSpacing: "0.015em",
        lineHeight: "1.6em"
      },
      button: {
        fontSize: "0.878rem",
        letterSpacing: "0.09em",
        lineHeight: "2.25rem",
        textTransform: "uppercase"
      },
      caption: {
        fontSize: "0.772rem",
        letterSpacing: "0.033em",
        lineHeight: "1.6rem"
      },
      body1Next: {
        fontSize: "1rem",
        letterSpacing: "0em",
        lineHeight: "1.6em"
      },
      body2Next: {
        fontSize: "0.878rem",
        letterSpacing: "0.015em",
        lineHeight: "1.6em"
      },
      buttonNext: {
        fontSize: "0.878rem",
        letterSpacing: "0.09em",
        lineHeight: "2.25rem"
      },
      captionNext: {
        fontSize: "0.772rem",
        letterSpacing: "0.33em",
        lineHeight: "1.6rem"
      },
      overline: {
        fontSize: "0.678rem",
        fontWeight: 500,
        letterSpacing: "0.166em",
        lineHeight: "2em",
        textTransform: "uppercase"
      },
      h1: {
        fontSize: "2.822rem",
        letterSpacing: "-0.015em",
        lineHeight: "1.2em"
      },
      h2: {
        fontSize: "1.575rem",
        letterSpacing: "0em",
        lineHeight: "1.33em"
      },
      h3: {
        fontSize: "1.383rem",
        fontWeight: 300,
        letterSpacing: "0em",
        lineHeight: "1.33em"
      },
      h4: {
        fontSize: "1.215rem",
        letterSpacing: "0.007em",
        lineHeight: "1.45em"
      },
      h5: {
        fontSize: "1.138rem",
        letterSpacing: "0.005em",
        lineHeight: "1.55em"
      },
      h6: {
        fontSize: "1.067rem",
        fontWeight: 400,
        letterSpacing: "0.01em",
        lineHeight: "1.6em"
      },
      subtitle1: {
        fontSize: "0.937rem",
        letterSpacing: "0.015em",
        lineHeight: "1.6em",
        fontWeight: 300
      },
      subtitle2: {
        fontSize: "0.878rem",
        fontWeight: 500,
        letterSpacing: "0.02em",
        lineHeight: "1.75em"
      },
      useNextVariants: !0
      // set so that console deprecation warning is removed
    },
    components: {
      MuiMenuItem: {
        variants: [
          {
            props: { variant: "multiline" },
            style: { whiteSpace: "normal" }
          }
        ]
      },
      CompanionWindow: {
        styleOverrides: {
          closeButton: {
            order: 4
          },
          contents: {
            overflowY: "auto",
            wordBreak: "break-word"
          },
          controls: ({ ownerState: e }) => ({
            alignItems: "center",
            display: "flex",
            flexFlow: "row wrap",
            flexGrow: 1,
            justifyContent: (e == null ? void 0 : e.position) === "bottom" || (e == null ? void 0 : e.position) === "far-bottom" ? "flex-end" : "flex-start",
            minHeight: 48,
            order: 3
          }),
          positionButton: {
            marginLeft: -16,
            order: -100,
            width: 24
          },
          resize: ({ ownerState: e }) => ({
            display: "flex",
            flexDirection: "column",
            minHeight: 50,
            minWidth: (e == null ? void 0 : e.position) === "left" ? 235 : 100,
            position: "relative"
          }),
          root: ({ ownerState: e }) => ({
            boxShadow: "none",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            ...(e == null ? void 0 : e.position) === "right" && {
              borderLeft: "0.5px solid rgba(0, 0, 0, 0.125)"
            },
            ...(e == null ? void 0 : e.position) === "left" && {
              borderRight: "0.5px solid rgba(0, 0, 0, 0.125)"
            },
            ...(e == null ? void 0 : e.position) === "bottom" && {
              borderTop: "0.5px solid rgba(0, 0, 0, 0.125)"
            }
          }),
          title: ({ theme: e }) => ({
            ...e.typography.subtitle1,
            alignSelf: "center",
            flexGrow: 1,
            width: 160
          }),
          toolbar: ({ theme: e }) => ({
            alignItems: "flex-start",
            backgroundColor: e.palette.shades.light,
            flexWrap: "wrap",
            justifyContent: "space-between",
            minHeight: "max-content",
            paddingInlineStart: "1rem"
          })
        }
      },
      CompanionWindowSection: {
        styleOverrides: {
          root: {
            borderBlockEnd: ".5px solid rgba(0, 0, 0, 0.25)"
          }
        }
      },
      IIIFHtmlContent: {
        styleOverrides: {
          root: ({ theme: e }) => ({
            "& a": {
              color: e.palette.primary.main,
              textDecoration: "underline"
            }
          })
        }
      },
      IIIFThumbnail: {
        styleOverrides: {
          root: ({ ownerState: e }) => ({
            ...(e == null ? void 0 : e.variant) === "inside" && {
              display: "inline-block",
              height: "inherit",
              position: "relative"
            }
          }),
          label: ({ ownerState: e }) => ({
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.5em",
            wordBreak: "break-word",
            ...(e == null ? void 0 : e.variant) === "inside" && {
              color: "#ffffff",
              WebkitLineClamp: 1,
              whiteSpace: "nowrap"
            },
            ...(e == null ? void 0 : e.variant) === "outside" && {
              display: "-webkit-box",
              maxHeight: "3em",
              MozBoxOrient: "vertical",
              WebkitLineClamp: 2
            },
            ...(e == null ? void 0 : e.variant) === "inside" && {
              background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
              bottom: "5px",
              boxSizing: "border-box",
              left: "0px",
              padding: "4px",
              position: "absolute",
              width: "100%"
            }
          }),
          image: ({ ownerState: e }) => ({
            ...(e == null ? void 0 : e.border) && {
              border: "1px solid rgba(0, 0, 0, 0.125)"
            }
          })
        }
      },
      ThemeIcon: {
        styleOverrides: {
          icon: ({ ownerState: e }) => ({
            color: (e == null ? void 0 : e.value) === "dark" ? "#000000" : void 0
          })
        }
      },
      MuiAccordion: {
        variants: [
          {
            props: { variant: "compact" },
            style: {
              "& .MuiAccordionSummary-root": {
                minHeight: "unset",
                padding: 0
              },
              "& .MuiAccordionSummary-content": {
                margin: 0
              },
              "& .MuiAccordionDetails-root": {
                padding: 0
              }
            }
          }
        ]
      },
      MuiButton: {
        styleOverrides: {
          inlineText: {
            lineHeight: "1.5em",
            padding: 0,
            textAlign: "inherit",
            textTransform: "none"
          },
          inlineTextSecondary: ({ theme: e }) => ({
            color: e.palette.secondary.main
          })
        }
      },
      MuiButtonBase: {
        defaultProps: {
          disableTouchRipple: !0
        }
      },
      MuiDialog: {
        variants: [
          {
            props: { variant: "contained" },
            style: {
              position: "absolute",
              "& .MuiBackdrop-root": {
                position: "absolute"
              }
            }
          }
        ]
      },
      MuiFab: {
        styleOverrides: {
          root: {
            transition: "none"
          }
        }
      },
      MuiLink: {
        defaultProps: {
          underline: "always"
        }
      },
      MuiListSubheader: {
        styleOverrides: {
          root: {
            '&[role="presentation"]:focus': {
              outline: 0
            }
          }
        }
      },
      MuiTooltip: {
        // Overridden from https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Tooltip/Tooltip.js#L40-L70
        styleOverrides: {
          tooltipPlacementLeft: {
            "@media (min-width:600px)": {
              margin: "0 !important"
            }
          },
          tooltipPlacementRight: {
            "@media (min-width:600px)": {
              margin: "0 !important"
            }
          },
          tooltipPlacementTop: {
            "@media (min-width:600px)": {
              margin: "0 !important"
            }
          },
          tooltipPlacementBottom: {
            "@media (min-width:600px)": {
              margin: "0 !important"
            }
          }
        }
      },
      MuiTouchRipple: {
        styleOverrides: {
          childPulsate: {
            animation: "none"
          },
          rippleVisible: {
            animation: "none"
          }
        }
      }
    }
  },
  language: "en",
  // The default language set in the application
  availableLanguages: {
    // All the languages available in the language switcher
    ar: "العربية",
    de: "Deutsch",
    en: "English",
    et: "Eesti",
    fa: "فارسی",
    fr: "Français",
    hr: "Hrvatski",
    ja: "日本語",
    kr: "한국어",
    lt: "Lietuvių",
    nl: "Nederlands",
    "nb-NO": "Norwegian Bokmål",
    pl: "Polski",
    "pt-BR": "Português do Brasil",
    vi: "Tiếng Việt",
    "zh-CN": "中文(简体)",
    "zh-TW": "中文(繁體)",
    it: "Italiano",
    sr: "Српски",
    sv: "Svenska",
    bg: "Български"
  },
  annotations: {
    htmlSanitizationRuleSet: "iiif",
    // See src/lib/htmlRules.js for acceptable values
    filteredMotivations: ["oa:commenting", "oa:tagging", "sc:painting", "commenting", "tagging"]
  },
  createGenerateClassNameOptions: {
    // Options passed directly to createGenerateClassName in Material-UI https://material-ui.com/styles/api/#creategenerateclassname-options-class-name-generator
    productionPrefix: "mirador"
  },
  requests: {
    preprocessors: [
      // Functions that receive HTTP requests and manipulate them (e.g. to add headers)
      // (url, options) => (url.match('info.json') && { ...options, myCustomThing: 'blah' })
    ],
    postprocessors: [
      // Functions that receive HTTP responses and manipulates them before adding to store
      // An example of manipulating the response for an annotation request
      // (url, action) => {
      //   if (action.annotationId) {
      //     action.annotationJson = {};
      //   }
      // }
    ]
  },
  translations: {
    // Translations can be added to inject new languages or override existing labels
  },
  window: {
    //global window defaults
    allowClose: !0,
    // Configure if windows can be closed or not
    allowFullscreen: !1,
    // Configure to show a "fullscreen" button in the WindowTopBar
    allowMaximize: !0,
    // Configure if windows can be maximized or not
    allowTopMenuButton: !0,
    // Configure if window view and thumbnail display menu are visible or not
    allowWindowSideBar: !0,
    // Configure if side bar menu is visible or not
    authNewWindowCenter: "parent",
    // Configure how to center a new window created by the authentication flow. Options: parent, screen
    sideBarPanel: "info",
    // Configure which sidebar is selected by default. Options: info, attribution, canvas, annotations, search
    defaultSidebarPanelHeight: 201,
    // Configure default sidebar height in pixels
    defaultSidebarPanelWidth: 235,
    // Configure default sidebar width in pixels
    defaultView: "single",
    // Configure which viewing mode (e.g. single, book, gallery) for windows to be opened in
    forceDrawAnnotations: !1,
    hideWindowTitle: !1,
    // Configure if the window title is shown in the window title bar or not
    highlightAllAnnotations: !1,
    // Configure whether to display annotations on the canvas by default
    showLocalePicker: !1,
    // Configure locale picker for multi-lingual metadata
    sideBarOpen: !1,
    // Configure if the sidebar (and its content panel) is open by default
    switchCanvasOnSearch: !0,
    // Configure if Mirador should automatically switch to the canvas of the first search result
    panels: {
      // Configure which panels are visible in WindowSideBarButtons
      info: !0,
      attribution: !0,
      canvas: !0,
      annotations: !0,
      search: !0,
      layers: !0
    },
    views: [
      { key: "single", behaviors: ["individuals"] },
      { key: "book", behaviors: ["paged"] },
      { key: "scroll", behaviors: ["continuous"] },
      { key: "gallery" }
    ],
    elastic: {
      height: 400,
      width: 480
    }
  },
  windows: [
    // Array of windows to be open when mirador initializes (each object should at least provide a manifestId key with the value of the IIIF presentation manifest to load)
    /**
    Example Window:
    {
      manifestId: 'https://iiif.harvardartmuseums.org/manifests/object/299843',
      canvasId: 'https://iiif.harvardartmuseums.org/manifests/object/299843/page_2',
      thumbnailNavigationPosition: 'far-bottom',
      maximized: false,
    }
    // ../state/actions/window.js `defaultOptions`
    // ../lib/MiradorViewer.js `windowAction`
    */
  ],
  thumbnails: {
    preferredFormats: ["jpg", "png", "webp", "tif"]
  },
  thumbnailNavigation: {
    defaultPosition: "off",
    // Which position for the thumbnail navigation to be be displayed. Other possible values are "far-bottom" or "far-right"
    displaySettings: !0,
    // Display the settings for this in WindowTopMenu
    height: 130,
    // height of entire ThumbnailNavigation area when position is "far-bottom"
    showThumbnailLabels: !0,
    // Configure if thumbnail labels should be displayed
    width: 100
    // width of one canvas (doubled for book view) in ThumbnailNavigation area when position is "far-right"
  },
  workspace: {
    allowNewWindows: !0,
    draggingEnabled: !0,
    exposeModeOn: !1,
    // unused?
    height: 5e3,
    // height of the elastic mode's virtual canvas
    id: zs(),
    isWorkspaceAddVisible: !1,
    // Catalog/Workspace add window feature visible by default
    showZoomControls: !0,
    // Configure if zoom controls should be displayed by default
    type: "mosaic",
    // Which workspace type to load by default. Other possible values are "elastic". If "mosaic" or "elastic" are not selected no workspace type will be used.
    viewportPosition: {
      // center coordinates for the elastic mode workspace
      x: 0,
      y: 0
    },
    width: 5e3
    // width of the elastic mode's virtual canvas
  },
  workspaceControlPanel: {
    enabled: !0
    // Configure if the control panel should be rendered.  Useful if you want to lock the viewer down to only the configured manifests
  },
  galleryView: {
    height: 120,
    // height of gallery view thumbnails
    width: null
    // width of gallery view thumbnails (or null, to auto-calculate an aspect-ratio appropriate size)
  },
  osdConfig: {
    // Default config used for OpenSeadragon
    alwaysBlend: !1,
    blendTime: 0.1,
    preserveImageSizeOnResize: !0,
    preserveViewport: !0,
    showNavigationControl: !1,
    zoomPerClick: 1,
    // disable zoom-to-click
    zoomPerDoubleClick: 2
  },
  export: {
    catalog: !0,
    companionWindows: !0,
    config: !0,
    elasticLayout: !0,
    layers: !0,
    // filter out anything re-retrievable:
    manifests: { filter: ([e, t]) => !e.startsWith("http") },
    viewers: !0,
    windows: !0,
    workspace: !0
  },
  audioOptions: {
    // Additional props passed to <audio> element
    controls: !0,
    crossOrigin: "anonymous"
  },
  videoOptions: {
    // Additional props passed to <audio> element
    controls: !0,
    crossOrigin: "anonymous"
  },
  auth: {
    serviceProfiles: [
      { profile: "http://iiif.io/api/auth/1/external", external: !0 },
      { profile: "http://iiif.io/api/auth/1/kiosk", kiosk: !0 },
      { profile: "http://iiif.io/api/auth/1/clickthrough" },
      { profile: "http://iiif.io/api/auth/1/login" },
      { profile: "http://iiif.io/api/auth/0/external", external: !0 },
      { profile: "http://iiif.io/api/auth/0/kiosk", kiosk: !0 },
      { profile: "http://iiif.io/api/auth/0/clickthrough" },
      { profile: "http://iiif.io/api/auth/0/login" },
      { profile: "external", external: !0 },
      { profile: "kiosk", kiosk: !0 },
      { profile: "active" }
    ]
  }
};
function fo(e) {
  return Pv.state.slice ? e[Pv.state.slice] : e;
}
const Io = Object.freeze([]), qs = Object.freeze({});
var Cee = (
  /** @class */
  (function() {
    function e(t) {
      this.__jsonld = t, this.context = this.getProperty("context"), this.id = this.getProperty("id");
    }
    return e.prototype.getProperty = function(t) {
      var n = null;
      return this.__jsonld && (n = this.__jsonld[t], n || (n = this.__jsonld["@" + t])), n;
    }, e;
  })()
), yk = {}, tG;
function vye() {
  return tG || (tG = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), (function(t) {
      t.BOOKMARKING = "oa:bookmarking", t.CLASSIFYING = "oa:classifying", t.COMMENTING = "oa:commenting", t.DESCRIBING = "oa:describing", t.EDITING = "oa:editing", t.HIGHLIGHTING = "oa:highlighting", t.IDENTIFYING = "oa:identifying", t.LINKING = "oa:linking", t.MODERATING = "oa:moderating", t.PAINTING = "sc:painting", t.QUESTIONING = "oa:questioning", t.REPLYING = "oa:replying", t.TAGGING = "oa:tagging", t.TRANSCRIBING = "oad:transcribing";
    })(e.AnnotationMotivation || (e.AnnotationMotivation = {})), (function(t) {
      t.AUTO_ADVANCE = "auto-advance", t.CONTINUOUS = "continuous", t.FACING_PAGES = "facing-pages", t.HIDDEN = "hidden", t.INDIVIDUALS = "individuals", t.MULTI_PART = "multi-part", t.NO_NAV = "no-nav", t.NON_PAGED = "non-paged", t.PAGED = "paged", t.REPEAT = "repeat", t.SEQUENCE = "sequence", t.THUMBNAIL_NAV = "thumbnail-nav", t.TOGETHER = "together", t.UNORDERED = "unordered";
    })(e.Behavior || (e.Behavior = {})), (function(t) {
      t.CANVAS = "canvas", t.CHOICE = "choice", t.OA_CHOICE = "oa:choice", t.CONTENT_AS_TEXT = "contentastext", t.DATASET = "dataset", t.DOCUMENT = "document", t.IMAGE = "image", t.MODEL = "model", t.MOVING_IMAGE = "movingimage", t.PDF = "pdf", t.PHYSICAL_OBJECT = "physicalobject", t.SOUND = "sound", t.TEXT = "text", t.TEXTUALBODY = "textualbody", t.VIDEO = "video";
    })(e.ExternalResourceType || (e.ExternalResourceType = {})), (function(t) {
      t.ANNOTATION = "annotation", t.CANVAS = "canvas", t.COLLECTION = "collection", t.MANIFEST = "manifest", t.RANGE = "range", t.SEQUENCE = "sequence";
    })(e.IIIFResourceType || (e.IIIFResourceType = {})), (function(t) {
      t.AUDIO_MP4 = "audio/mp4", t.CORTO = "application/corto", t.DICOM = "application/dicom", t.DRACO = "application/draco", t.EPUB = "application/epub+zip", t.GIRDER = "image/vnd.kitware.girder", t.GLB = "model/gltf-binary", t.GLTF = "model/gltf+json", t.IIIF_PRESENTATION_2 = 'application/ld+json;profile="http://iiif.io/api/presentation/2/context.json"', t.IIIF_PRESENTATION_3 = 'application/ld+json;profile="http://iiif.io/api/presentation/3/context.json"', t.JPG = "image/jpeg", t.M3U8 = "application/vnd.apple.mpegurl", t.MP3 = "audio/mp3", t.MPEG_DASH = "application/dash+xml", t.OBJ = "text/plain", t.OPF = "application/oebps-package+xml", t.PDF = "application/pdf", t.PLY = "application/ply", t.THREEJS = "application/vnd.threejs+json", t.USDZ = "model/vnd.usd+zip", t.VIDEO_MP4 = "video/mp4", t.WAV = "audio/wav", t.WEBM = "video/webm";
    })(e.MediaType || (e.MediaType = {})), (function(t) {
      t.DOC = "application/msword", t.DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", t.PDF = "application/pdf";
    })(e.RenderingFormat || (e.RenderingFormat = {})), (function(t) {
      t.IMAGE_0_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", t.IMAGE_0_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", t.IMAGE_0_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", t.IMAGE_0_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", t.IMAGE_0_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", t.IMAGE_0_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", t.IMAGE_1_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", t.IMAGE_1_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", t.IMAGE_1_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", t.IMAGE_1_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", t.IMAGE_1_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", t.IMAGE_1_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", t.IMAGE_1_LEVEL_0 = "http://iiif.io/api/image/1/level0.json", t.IMAGE_1_PROFILE_LEVEL_0 = "http://iiif.io/api/image/1/profiles/level0.json", t.IMAGE_1_LEVEL_1 = "http://iiif.io/api/image/1/level1.json", t.IMAGE_1_PROFILE_LEVEL_1 = "http://iiif.io/api/image/1/profiles/level1.json", t.IMAGE_1_LEVEL_2 = "http://iiif.io/api/image/1/level2.json", t.IMAGE_1_PROFILE_LEVEL_2 = "http://iiif.io/api/image/1/profiles/level2.json", t.IMAGE_2_LEVEL_0 = "http://iiif.io/api/image/2/level0.json", t.IMAGE_2_PROFILE_LEVEL_0 = "http://iiif.io/api/image/2/profiles/level0.json", t.IMAGE_2_LEVEL_1 = "http://iiif.io/api/image/2/level1.json", t.IMAGE_2_PROFILE_LEVEL_1 = "http://iiif.io/api/image/2/profiles/level1.json", t.IMAGE_2_LEVEL_2 = "http://iiif.io/api/image/2/level2.json", t.IMAGE_2_PROFILE_LEVEL_2 = "http://iiif.io/api/image/2/profiles/level2.json", t.AUTH_0_CLICK_THROUGH = "http://iiif.io/api/auth/0/login/clickthrough", t.AUTH_0_LOGIN = "http://iiif.io/api/auth/0/login", t.AUTH_0_LOGOUT = "http://iiif.io/api/auth/0/logout", t.AUTH_0_RESTRICTED = "http://iiif.io/api/auth/0/login/restricted", t.AUTH_0_TOKEN = "http://iiif.io/api/auth/0/token", t.AUTH_1_CLICK_THROUGH = "http://iiif.io/api/auth/1/clickthrough", t.AUTH_1_EXTERNAL = "http://iiif.io/api/auth/1/external", t.AUTH_1_KIOSK = "http://iiif.io/api/auth/1/kiosk", t.AUTH_1_LOGIN = "http://iiif.io/api/auth/1/login", t.AUTH_1_LOGOUT = "http://iiif.io/api/auth/1/logout", t.AUTH_1_PROBE = "http://iiif.io/api/auth/1/probe", t.AUTH_1_TOKEN = "http://iiif.io/api/auth/1/token", t.SEARCH_0 = "http://iiif.io/api/search/0/search", t.SEARCH_0_AUTO_COMPLETE = "http://iiif.io/api/search/0/autocomplete", t.SEARCH_1 = "http://iiif.io/api/search/1/search", t.SEARCH_1_AUTO_COMPLETE = "http://iiif.io/api/search/1/autocomplete", t.TRACKING_EXTENSIONS = "http://universalviewer.io/tracking-extensions-profile", t.UI_EXTENSIONS = "http://universalviewer.io/ui-extensions-profile", t.PRINT_EXTENSIONS = "http://universalviewer.io/print-extensions-profile", t.SHARE_EXTENSIONS = "http://universalviewer.io/share-extensions-profile", t.DOWNLOAD_EXTENSIONS = "http://universalviewer.io/download-extensions-profile", t.OTHER_MANIFESTATIONS = "http://iiif.io/api/otherManifestations.json", t.IXIF = "http://wellcomelibrary.org/ld/ixif/0/alpha.json";
    })(e.ServiceProfile || (e.ServiceProfile = {})), (function(t) {
      t.IMAGE_SERVICE_2 = "ImageService2", t.IMAGE_SERVICE_3 = "ImageService3";
    })(e.ServiceType || (e.ServiceType = {})), (function(t) {
      t.BOTTOM_TO_TOP = "bottom-to-top", t.LEFT_TO_RIGHT = "left-to-right", t.RIGHT_TO_LEFT = "right-to-left", t.TOP_TO_BOTTOM = "top-to-bottom";
    })(e.ViewingDirection || (e.ViewingDirection = {})), (function(t) {
      t.CONTINUOUS = "continuous", t.INDIVIDUALS = "individuals", t.NON_PAGED = "non-paged", t.PAGED = "paged", t.TOP = "top";
    })(e.ViewingHint || (e.ViewingHint = {}));
  })(yk)), yk;
}
var Dt = vye(), yye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), fp = (
  /** @class */
  (function(e) {
    yye(t, e);
    function t(n, r) {
      var i = e.call(this, n) || this;
      return i.options = r, i;
    }
    return t.prototype.getIIIFResourceType = function() {
      return nn.normaliseType(this.getProperty("type"));
    }, t.prototype.getLabel = function() {
      var n = this.getProperty("label");
      return n ? Ti.parse(n, this.options.locale) : new Ti([], this.options.locale);
    }, t.prototype.getDefaultLabel = function() {
      return this.getLabel().getValue(this.options.locale);
    }, t.prototype.getMetadata = function() {
      var n = this.getProperty("metadata"), r = [];
      if (!n)
        return r;
      for (var i = 0; i < n.length; i++) {
        var o = n[i], s = new t1(this.options.locale);
        s.parse(o), r.push(s);
      }
      return r;
    }, t.prototype.getRendering = function(n) {
      for (var r = this.getRenderings(), i = 0; i < r.length; i++) {
        var o = r[i];
        if (o.getFormat() === n)
          return o;
      }
      return null;
    }, t.prototype.getRenderings = function() {
      var n;
      this.__jsonld ? n = this.__jsonld.rendering : n = this.rendering;
      var r = [];
      if (!n)
        return r;
      Array.isArray(n) || (n = [n]);
      for (var i = 0; i < n.length; i++) {
        var o = n[i];
        r.push(new Wye(o, this.options));
      }
      return r;
    }, t.prototype.getRequiredStatement = function() {
      var n = null, r = this.getProperty("requiredStatement");
      return r && (n = new t1(this.options.locale), n.parse(r)), n;
    }, t.prototype.getService = function(n) {
      return nn.getService(this, n);
    }, t.prototype.getServices = function() {
      return nn.getServices(this);
    }, t.prototype.getThumbnail = function() {
      var n = this.getProperty("thumbnail");
      return Array.isArray(n) && (n = n[0]), n ? new Xye(n, this.options) : null;
    }, t.prototype.isAnnotation = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.ANNOTATION;
    }, t.prototype.isCanvas = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.CANVAS;
    }, t.prototype.isCollection = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.COLLECTION;
    }, t.prototype.isManifest = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.MANIFEST;
    }, t.prototype.isRange = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.RANGE;
    }, t.prototype.isSequence = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.SEQUENCE;
    }, t;
  })(Cee)
), bye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), j1 = (
  /** @class */
  (function(e) {
    bye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getFormat = function() {
      var n = this.getProperty("format");
      return n ? n.toLowerCase() : null;
    }, t.prototype.getResources = function() {
      var n = [];
      if (!this.__jsonld.resources)
        return n;
      for (var r = 0; r < this.__jsonld.resources.length; r++) {
        var i = this.__jsonld.resources[r], o = new e1(i, this.options);
        n.push(o);
      }
      return n;
    }, t.prototype.getType = function() {
      var n = this.getProperty("type");
      return n ? nn.normaliseType(n) : null;
    }, t.prototype.getWidth = function() {
      return this.getProperty("width");
    }, t.prototype.getHeight = function() {
      return this.getProperty("height");
    }, t.prototype.getMaxWidth = function() {
      return this.getProperty("maxWidth");
    }, t.prototype.getMaxHeight = function() {
      var n = this.getProperty("maxHeight");
      return n ? null : this.getMaxWidth();
    }, t;
  })(fp)
), xye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Ree = (
  /** @class */
  (function(e) {
    xye(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      i.index = -1, i.isLoaded = !1;
      var o = {
        defaultLabel: "-",
        locale: "en-GB",
        resource: i,
        pessimisticAccessControl: !1
      };
      return i.options = Object.assign(o, r), i;
    }
    return t.prototype.getAttribution = function() {
      var n = this.getProperty("attribution");
      return n ? Ti.parse(n, this.options.locale) : new Ti([], this.options.locale);
    }, t.prototype.getDescription = function() {
      var n = this.getProperty("description");
      return n ? Ti.parse(n, this.options.locale) : new Ti([], this.options.locale);
    }, t.prototype.getHomepage = function() {
      var n = this.getProperty("homepage");
      return n ? typeof n == "string" ? n : (Array.isArray(n) && n.length && (n = n[0]), n["@id"] || n.id) : null;
    }, t.prototype.getIIIFResourceType = function() {
      return nn.normaliseType(this.getProperty("type"));
    }, t.prototype.getLogo = function() {
      var n = this.getProperty("logo");
      if (!n) {
        var r = this.getProperty("provider");
        if (!r)
          return null;
        n = r.logo;
      }
      return n ? typeof n == "string" ? n : (Array.isArray(n) && n.length && (n = n[0]), n["@id"] || n.id) : null;
    }, t.prototype.getLicense = function() {
      return nn.getLocalisedValue(this.getProperty("license"), this.options.locale);
    }, t.prototype.getNavDate = function() {
      return new Date(this.getProperty("navDate"));
    }, t.prototype.getRelated = function() {
      return this.getProperty("related");
    }, t.prototype.getSeeAlso = function() {
      return this.getProperty("seeAlso");
    }, t.prototype.getTrackingLabel = function() {
      var n = this.getService(Dt.ServiceProfile.TRACKING_EXTENSIONS);
      return n ? n.getProperty("trackingLabel") : "";
    }, t.prototype.getDefaultTree = function() {
      return this.defaultTree = new rA("root"), this.defaultTree.data = this, this.defaultTree;
    }, t.prototype.getRequiredStatement = function() {
      var n = null, r = this.getProperty("requiredStatement");
      if (r)
        n = new t1(this.options.locale), n.parse(r);
      else {
        var i = this.getAttribution();
        i && (n = new t1(this.options.locale), n.value = i);
      }
      return n;
    }, t.prototype.isCollection = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.COLLECTION;
    }, t.prototype.isManifest = function() {
      return this.getIIIFResourceType() === Dt.IIIFResourceType.MANIFEST;
    }, t.prototype.load = function() {
      var n = this;
      return new Promise(function(r) {
        if (n.isLoaded)
          r(n);
        else {
          var i = n.options;
          i.navDate = n.getNavDate();
          var o = n.__jsonld.id;
          o || (o = n.__jsonld["@id"]), nn.loadManifest(o).then(function(s) {
            n.parentLabel = n.getLabel().getValue(i.locale);
            var u = Aee.parse(s, i);
            n = Object.assign(n, u), n.index = i.index, r(n);
          });
        }
      });
    }, t;
  })(fp)
), Sye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), e1 = (
  /** @class */
  (function(e) {
    Sye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getBody = function() {
      var n = [], r = this.getProperty("body");
      if (r)
        if (Array.isArray(r))
          for (var i = 0; i < r.length; i++) {
            var o = r[i];
            if (o.items)
              for (var s = 0; s < o.items.length; s++) {
                var u = o.items[s];
                n.push(new PR(u, this.options));
              }
            else
              n.push(new PR(o, this.options));
          }
        else if (r.items)
          for (var i = 0; i < r.items.length; i++) {
            var o = r.items[i];
            n.push(new PR(o, this.options));
          }
        else
          n.push(new PR(r, this.options));
      return n;
    }, t.prototype.getMotivation = function() {
      var n = this.getProperty("motivation");
      return n || null;
    }, t.prototype.getOn = function() {
      return this.getProperty("on");
    }, t.prototype.getTarget = function() {
      return this.getProperty("target");
    }, t.prototype.getResource = function() {
      return new j1(this.getProperty("resource"), this.options);
    }, t;
  })(fp)
), wye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), PR = (
  /** @class */
  (function(e) {
    wye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getFormat = function() {
      var n = this.getProperty("format");
      return n ? nn.getMediaType(n) : null;
    }, t.prototype.getType = function() {
      var n = this.getProperty("type");
      return n ? nn.normaliseType(this.getProperty("type")) : null;
    }, t.prototype.getWidth = function() {
      return this.getProperty("width");
    }, t.prototype.getHeight = function() {
      return this.getProperty("height");
    }, t;
  })(fp)
), Tye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Eye = (
  /** @class */
  (function(e) {
    Tye(t, e);
    function t(n, r, i) {
      var o = e.call(this, r) || this;
      return o.label = n, o.options = i, o;
    }
    return t.prototype.getIIIFResourceType = function() {
      return nn.normaliseType(this.getProperty("type"));
    }, t.prototype.getLabel = function() {
      return this.label;
    }, t.prototype.getResources = function() {
      var n = this, r = this.getProperty("resources");
      return r.map(function(i) {
        return new e1(i, n.options);
      });
    }, t.prototype.load = function() {
      var n = this;
      return new Promise(function(r, i) {
        if (n.isLoaded)
          r(n);
        else {
          var o = n.__jsonld.id;
          o || (o = n.__jsonld["@id"]), nn.loadManifest(o).then(function(s) {
            n.__jsonld = s, n.context = n.getProperty("context"), n.id = n.getProperty("id"), n.isLoaded = !0, r(n);
          }).catch(i);
        }
      });
    }, t;
  })(Cee)
), _ye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Oee = (
  /** @class */
  (function(e) {
    _ye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getItems = function() {
      return this.getProperty("items");
    }, t;
  })(fp)
), bk, nG;
function Cye() {
  if (nG) return bk;
  nG = 1;
  var e = Rx(), t = 1 / 0;
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, t) : [];
  }
  return bk = n, bk;
}
var Rye = Cye();
const yv = /* @__PURE__ */ Hn(Rye);
var Oye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), ix = (
  /** @class */
  (function(e) {
    Oye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getCanonicalImageUri = function(n) {
      var r = null, i = "full", o = 0, s = "default", u = n, f;
      if (this.externalResource && this.externalResource.data && this.externalResource.data["@id"])
        r = this.externalResource.data["@id"], u || (u = this.externalResource.data.width), this.externalResource.data["@context"] && (this.externalResource.data["@context"].indexOf("/1.0/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1.1/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1/context.json") > -1) && (s = "native");
      else {
        var p = void 0;
        if (p = this.getImages(), p && p.length) {
          var m = p[0], v = m.getResource(), y = v.getServices();
          u || (u = v.getWidth());
          var S = y ? y.find(function(D) {
            return nn.isImageProfile(D.getProfile()) || nn.isImageServiceType(D.getIIIFResourceType());
          }) : null;
          if (S)
            r = S.id, s = nn.getImageQuality(S.getProfile());
          else if (u === v.getWidth())
            return v.id;
        }
        if (p = this.getContent(), p && p.length) {
          var m = p[0], E = m.getBody(), w = E[0], y = w.getServices();
          u || (u = w.getWidth());
          var S = y ? y.find(function(N) {
            return nn.isImageServiceType(N.getIIIFResourceType());
          }) : null;
          if (S)
            r = S.id, s = nn.getImageQuality(S.getProfile());
          else if (u === w.getWidth())
            return w.id;
        }
        if (!r) {
          var _ = this.getProperty("thumbnail");
          if (_) {
            if (typeof _ == "string")
              return _;
            if (_["@id"])
              return _["@id"];
            if (_.length)
              return _[0].id;
          }
        }
      }
      f = u + ",", r && r.endsWith("/") && (r = r.substr(0, r.length - 1));
      var O = [r, i, f, o, s + ".jpg"].join("/");
      return O;
    }, t.prototype.getMaxDimensions = function() {
      var n = null, r;
      return this.externalResource && this.externalResource.data && this.externalResource.data.profile && (r = this.externalResource.data.profile, Array.isArray(r) && (r = r.filter(function(i) {
        return i.maxWidth;
      })[0], r && (n = new $ye(r.maxWidth, r.maxHeight ? r.maxHeight : r.maxWidth)))), n;
    }, t.prototype.getContent = function() {
      var n = [], r = this.__jsonld.items || this.__jsonld.content;
      if (!r)
        return n;
      var i = null;
      if (r.length && (i = new Oee(r[0], this.options)), !i)
        return n;
      for (var o = i.getItems(), s = 0; s < o.length; s++) {
        var u = o[s], f = new e1(u, this.options);
        n.push(f);
      }
      return n;
    }, t.prototype.getDuration = function() {
      return this.getProperty("duration");
    }, t.prototype.getImages = function() {
      var n = [];
      if (!this.__jsonld.images)
        return n;
      for (var r = 0; r < this.__jsonld.images.length; r++) {
        var i = this.__jsonld.images[r], o = new e1(i, this.options);
        n.push(o);
      }
      return n;
    }, t.prototype.getIndex = function() {
      return this.getProperty("index");
    }, t.prototype.getOtherContent = function() {
      var n = this, r = Array.isArray(this.getProperty("otherContent")) ? this.getProperty("otherContent") : [this.getProperty("otherContent")], i = function(s, u) {
        return typeof s != "string" ? !1 : s.toLowerCase() === s.toLowerCase();
      }, o = r.filter(function(s) {
        return s && i(s["@type"]);
      }).map(function(s, u) {
        return new Eye(s.label || "Annotation list " + u, s, n.options);
      }).map(function(s) {
        return s.load();
      });
      return Promise.all(o);
    }, t.prototype.getWidth = function() {
      return this.getProperty("width");
    }, t.prototype.getHeight = function() {
      return this.getProperty("height");
    }, t.prototype.getViewingHint = function() {
      return this.getProperty("viewingHint");
    }, Object.defineProperty(t.prototype, "imageResources", {
      get: function() {
        var n = this, r = yv([
          this.getImages().map(function(i) {
            return i.getResource();
          }),
          this.getContent().map(function(i) {
            return i.getBody();
          })
        ]);
        return vn(r.map(function(i) {
          switch (i.getProperty("type").toLowerCase()) {
            case Dt.ExternalResourceType.CHOICE:
            case Dt.ExternalResourceType.OA_CHOICE:
              return new t({
                images: vn([
                  i.getProperty("default"),
                  i.getProperty("item")
                ]).map(function(o) {
                  return { resource: o };
                })
              }, n.options).getImages().map(function(o) {
                return o.getResource();
              });
            default:
              return i;
          }
        }));
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "resourceAnnotations", {
      get: function() {
        return yv([this.getImages(), this.getContent()]);
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.resourceAnnotation = function(n) {
      return this.resourceAnnotations.find(function(r) {
        return r.getResource().id === n || vn(new Array(r.getBody())).some(function(i) {
          return i.id === n;
        });
      });
    }, t.prototype.onFragment = function(n) {
      var r = this.resourceAnnotation(n);
      if (r) {
        var i = r.getProperty("on"), o = r.getProperty("target");
        if (!(!i || !o)) {
          var s = (i || o).match(/xywh=(.*)$/);
          if (s)
            return s[1].split(",").map(function(u) {
              return parseInt(u, 10);
            });
        }
      }
    }, Object.defineProperty(t.prototype, "iiifImageResources", {
      get: function() {
        return this.imageResources.filter(function(n) {
          return n && n.getServices()[0] && n.getServices()[0].id;
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "imageServiceIds", {
      get: function() {
        return this.iiifImageResources.map(function(n) {
          return n.getServices()[0].id;
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "aspectRatio", {
      get: function() {
        return this.getWidth() / this.getHeight();
      },
      enumerable: !0,
      configurable: !0
    }), t;
  })(j1)
), Aye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Dye = (
  /** @class */
  (function(e) {
    Aye(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      return i.items = [], i._collections = null, i._manifests = null, n.__collection = i, i;
    }
    return t.prototype.getCollections = function() {
      return this._collections ? this._collections : this._collections = this.items.filter(function(n) {
        return n.isCollection();
      });
    }, t.prototype.getManifests = function() {
      return this._manifests ? this._manifests : this._manifests = this.items.filter(function(n) {
        return n.isManifest();
      });
    }, t.prototype.getCollectionByIndex = function(n) {
      for (var r = this.getCollections(), i, o = 0; o < r.length; o++) {
        var s = r[o];
        s.index === n && (i = s);
      }
      if (i)
        return i.options.index = n, i.load();
      throw new Error("Collection index not found");
    }, t.prototype.getManifestByIndex = function(n) {
      for (var r = this.getManifests(), i, o = 0; o < r.length; o++) {
        var s = r[o];
        s.index === n && (i = s);
      }
      if (i)
        return i.options.index = n, i.load();
      throw new Error("Manifest index not found");
    }, t.prototype.getTotalCollections = function() {
      return this.getCollections().length;
    }, t.prototype.getTotalManifests = function() {
      return this.getManifests().length;
    }, t.prototype.getTotalItems = function() {
      return this.items.length;
    }, t.prototype.getViewingDirection = function() {
      return this.getProperty("viewingDirection") ? this.getProperty("viewingDirection") : Dt.ViewingDirection.LEFT_TO_RIGHT;
    }, t.prototype.getBehavior = function() {
      var n = this.getProperty("behavior");
      return Array.isArray(n) && (n = n[0]), n || null;
    }, t.prototype.getViewingHint = function() {
      return this.getProperty("viewingHint");
    }, t.prototype.getDefaultTree = function() {
      return e.prototype.getDefaultTree.call(this), this.defaultTree.data.type = nn.normaliseType(Ld.COLLECTION), this._parseManifests(this), this._parseCollections(this), nn.generateTreeNodeIds(this.defaultTree), this.defaultTree;
    }, t.prototype._parseManifests = function(n) {
      if (n.getManifests() && n.getManifests().length)
        for (var r = 0; r < n.getManifests().length; r++) {
          var i = n.getManifests()[r], o = i.getDefaultTree();
          o.label = i.parentLabel || i.getLabel().getValue(this.options.locale) || "manifest " + (r + 1), o.navDate = i.getNavDate(), o.data.id = i.id, o.data.type = nn.normaliseType(Ld.MANIFEST), n.defaultTree.addNode(o);
        }
    }, t.prototype._parseCollections = function(n) {
      if (n.getCollections() && n.getCollections().length)
        for (var r = 0; r < n.getCollections().length; r++) {
          var i = n.getCollections()[r], o = i.getDefaultTree();
          o.label = i.parentLabel || i.getLabel().getValue(this.options.locale) || "collection " + (r + 1), o.navDate = i.getNavDate(), o.data.id = i.id, o.data.type = nn.normaliseType(Ld.COLLECTION), n.defaultTree.addNode(o);
        }
    }, t;
  })(Ree)
), xk = (
  /** @class */
  (function() {
    function e(t, n) {
      this.start = t, this.end = n;
    }
    return e.prototype.getLength = function() {
      return this.end - this.start;
    }, e;
  })()
), t1 = (
  /** @class */
  (function() {
    function e(t) {
      this.defaultLocale = t;
    }
    return e.prototype.parse = function(t) {
      this.resource = t, this.label = Ti.parse(this.resource.label, this.defaultLocale), this.value = Ti.parse(this.resource.value, this.defaultLocale);
    }, e.prototype.getLabel = function(t) {
      return this.label === null ? null : (Array.isArray(t) && !t.length && (t = void 0), this.label.getValue(t || this.defaultLocale));
    }, e.prototype.setLabel = function(t) {
      this.label === null && (this.label = new Ti([])), this.label.setValue(t, this.defaultLocale);
    }, e.prototype.getValue = function(t, n) {
      return n === void 0 && (n = "<br/>"), this.value === null ? null : (Array.isArray(t) && !t.length && (t = void 0), this.value.getValue(t || this.defaultLocale, n));
    }, e.prototype.getValues = function(t) {
      return this.value === null ? [] : (Array.isArray(t) && !t.length && (t = void 0), this.value.getValues(t || this.defaultLocale));
    }, e.prototype.setValue = function(t) {
      this.value === null && (this.value = new Ti([])), this.value.setValue(t, this.defaultLocale);
    }, e;
  })()
), Iye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})();
(function(e) {
  Iye(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.getValue = function(n, r) {
    return n.getValue(r, "<br/>");
  }, t.getValues = function(n, r) {
    return n.getValues(r);
  }, t;
})(Array);
var tn = {}, rG;
function Pye() {
  return rG || (rG = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.CONTINUE = 100, tn.SWITCHING_PROTOCOLS = 101, tn.PROCESSING = 102, tn.OK = 200, tn.CREATED = 201, tn.ACCEPTED = 202, tn.NON_AUTHORITATIVE_INFORMATION = 203, tn.NO_CONTENT = 204, tn.RESET_CONTENT = 205, tn.PARTIAL_CONTENT = 206, tn.MULTI_STATUS = 207, tn.MULTIPLE_CHOICES = 300, tn.MOVED_PERMANENTLY = 301, tn.MOVED_TEMPORARILY = 302, tn.SEE_OTHER = 303, tn.NOT_MODIFIED = 304, tn.USE_PROXY = 305, tn.TEMPORARY_REDIRECT = 307, tn.BAD_REQUEST = 400, tn.UNAUTHORIZED = 401, tn.PAYMENT_REQUIRED = 402, tn.FORBIDDEN = 403, tn.NOT_FOUND = 404, tn.METHOD_NOT_ALLOWED = 405, tn.NOT_ACCEPTABLE = 406, tn.PROXY_AUTHENTICATION_REQUIRED = 407, tn.REQUEST_TIME_OUT = 408, tn.CONFLICT = 409, tn.GONE = 410, tn.LENGTH_REQUIRED = 411, tn.PRECONDITION_FAILED = 412, tn.REQUEST_ENTITY_TOO_LARGE = 413, tn.REQUEST_URI_TOO_LARGE = 414, tn.UNSUPPORTED_MEDIA_TYPE = 415, tn.REQUESTED_RANGE_NOT_SATISFIABLE = 416, tn.EXPECTATION_FAILED = 417, tn.IM_A_TEAPOT = 418, tn.UNPROCESSABLE_ENTITY = 422, tn.LOCKED = 423, tn.FAILED_DEPENDENCY = 424, tn.UNORDERED_COLLECTION = 425, tn.UPGRADE_REQUIRED = 426, tn.PRECONDITION_REQUIRED = 428, tn.TOO_MANY_REQUESTS = 429, tn.REQUEST_HEADER_FIELDS_TOO_LARGE = 431, tn.INTERNAL_SERVER_ERROR = 500, tn.NOT_IMPLEMENTED = 501, tn.BAD_GATEWAY = 502, tn.SERVICE_UNAVAILABLE = 503, tn.GATEWAY_TIME_OUT = 504, tn.HTTP_VERSION_NOT_SUPPORTED = 505, tn.VARIANT_ALSO_NEGOTIATES = 506, tn.INSUFFICIENT_STORAGE = 507, tn.BANDWIDTH_LIMIT_EXCEEDED = 509, tn.NOT_EXTENDED = 510, tn.NETWORK_AUTHENTICATION_REQUIRED = 511), tn;
}
var hc = Pye();
function Nye(e, t) {
  return t = t || {}, new Promise(function(n, r) {
    var i = new XMLHttpRequest(), o = [], s = [], u = {}, f = function() {
      return { ok: (i.status / 100 | 0) == 2, statusText: i.statusText, status: i.status, url: i.responseURL, text: function() {
        return Promise.resolve(i.responseText);
      }, json: function() {
        return Promise.resolve(i.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([i.response]));
      }, clone: f, headers: { keys: function() {
        return o;
      }, entries: function() {
        return s;
      }, get: function(m) {
        return u[m.toLowerCase()];
      }, has: function(m) {
        return m.toLowerCase() in u;
      } } };
    };
    for (var p in i.open(t.method || "get", e, !0), i.onload = function() {
      i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(m, v, y) {
        o.push(v = v.toLowerCase()), s.push([v, y]), u[v] = u[v] ? u[v] + "," + y : y;
      }), n(f());
    }, i.onerror = r, i.withCredentials = t.credentials == "include", t.headers) i.setRequestHeader(p, t.headers[p]);
    i.send(t.body || null);
  });
}
const Mye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nye
}, Symbol.toStringTag, { value: "Module" })), iG = /* @__PURE__ */ SJ(Mye);
var Sk, oG;
function jye() {
  return oG || (oG = 1, Sk = self.fetch || (self.fetch = iG.default || iG)), Sk;
}
jye();
var wk = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function u(m) {
      try {
        p(r.next(m));
      } catch (v) {
        s(v);
      }
    }
    function f(m) {
      try {
        p(r.throw(m));
      } catch (v) {
        s(v);
      }
    }
    function p(m) {
      m.done ? o(m.value) : i(m.value).then(u, f);
    }
    p((r = r.apply(e, t || [])).next());
  });
}, Tk = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s;
  return s = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function u(p) {
    return function(m) {
      return f([p, m]);
    };
  }
  function f(p) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = p[0] & 2 ? i.return : p[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, p[1])).done) return o;
      switch (i = 0, o && (p = [p[0] & 2, o.value]), p[0]) {
        case 0:
        case 1:
          o = p;
          break;
        case 4:
          return n.label++, { value: p[1], done: !1 };
        case 5:
          n.label++, i = p[1], p = [0];
          continue;
        case 7:
          p = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (p[0] === 6 || p[0] === 2)) {
            n = 0;
            continue;
          }
          if (p[0] === 3 && (!o || p[1] > o[0] && p[1] < o[3])) {
            n.label = p[1];
            break;
          }
          if (p[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = p;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(p);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      p = t.call(e, n);
    } catch (m) {
      p = [6, m], i = 0;
    } finally {
      r = o = 0;
    }
    if (p[0] & 5) throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}, nn = (
  /** @class */
  (function() {
    function e() {
    }
    return e.getMediaType = function(t) {
      return t = t.toLowerCase(), t = t.split(";")[0], t.trim();
    }, e.getImageQuality = function(t) {
      return t === Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1 || t === Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2 || t === Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1 || t === Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2 || t === Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1 || t === Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2 || t === Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1 || t === Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2 || t === Dt.ServiceProfile.IMAGE_1_LEVEL_1 || t === Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1 || t === Dt.ServiceProfile.IMAGE_1_LEVEL_2 || t === Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2 ? "native" : "default";
    }, e.getInexactLocale = function(t) {
      return t.indexOf("-") !== -1 ? t.substr(0, t.indexOf("-")) : t;
    }, e.getLocalisedValue = function(t, n) {
      if (!Array.isArray(t))
        return t;
      for (var r = 0; r < t.length; r++) {
        var i = t[r], o = i["@language"];
        if (n === o)
          return i["@value"];
      }
      for (var s = n.substr(0, n.indexOf("-")), r = 0; r < t.length; r++) {
        var u = t[r], f = u["@language"];
        if (f === s)
          return u["@value"];
      }
      return null;
    }, e.generateTreeNodeIds = function(t, n) {
      n === void 0 && (n = 0);
      var r;
      t.parentNode ? r = t.parentNode.id + "-" + n : r = "0", t.id = r;
      for (var i = 0; i < t.nodes.length; i++) {
        var o = t.nodes[i];
        e.generateTreeNodeIds(o, i);
      }
    }, e.normaliseType = function(t) {
      if (t = (t || "").toLowerCase(), t.indexOf(":") !== -1) {
        var n = t.split(":");
        return n[1];
      }
      return t;
    }, e.normaliseUrl = function(t) {
      return t = t.substr(t.indexOf("://")), t.indexOf("#") !== -1 && (t = t.split("#")[0]), t;
    }, e.normalisedUrlsMatch = function(t, n) {
      return e.normaliseUrl(t) === e.normaliseUrl(n);
    }, e.isImageProfile = function(t) {
      return !!(e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2));
    }, e.isImageServiceType = function(t) {
      return t !== null && t.toLowerCase() === Dt.ServiceType.IMAGE_SERVICE_2.toLowerCase() || t === Dt.ServiceType.IMAGE_SERVICE_3.toLowerCase();
    }, e.isLevel0ImageProfile = function(t) {
      return !!(e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_LEVEL_0) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0));
    }, e.isLevel1ImageProfile = function(t) {
      return !!(e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_LEVEL_1) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1));
    }, e.isLevel2ImageProfile = function(t) {
      return !!(e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_LEVEL_2) || e.normalisedUrlsMatch(t, Dt.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2));
    }, e.parseManifest = function(t, n) {
      return Aee.parse(t, n);
    }, e.checkStatus = function(t) {
      if (t.ok)
        return t;
      var n = new Error(t.statusText);
      return n.response = t, Promise.reject(n);
    }, e.loadManifest = function(t) {
      return new Promise(function(n, r) {
        fetch(t).then(e.checkStatus).then(function(i) {
          return i.json();
        }).then(function(i) {
          n(i);
        }).catch(function(i) {
          r();
        });
      });
    }, e.loadExternalResourcesAuth1 = function(t, n, r, i, o, s, u, f) {
      return new Promise(function(p, m) {
        var v = t.map(function(y) {
          return e.loadExternalResourceAuth1(y, n, r, i, o, s, u, f);
        });
        Promise.all(v).then(function() {
          p(t);
        }).catch(function(y) {
          m(y);
        });
      });
    }, e.loadExternalResourceAuth1 = function(t, n, r, i, o, s, u, f) {
      return wk(this, void 0, void 0, function() {
        var p;
        return Tk(this, function(m) {
          switch (m.label) {
            case 0:
              return [4, i(t)];
            case 1:
              return p = m.sent(), p ? [4, t.getData(p)] : [3, 6];
            case 2:
              return m.sent(), t.status !== hc.OK ? [3, 3] : [2, t];
            case 3:
              return [4, e.doAuthChain(t, n, r, o, s, u, f)];
            case 4:
              m.sent(), m.label = 5;
            case 5:
              if (t.status === hc.OK || t.status === hc.MOVED_TEMPORARILY)
                return [2, t];
              throw e.createAuthorizationFailedError();
            case 6:
              return [4, t.getData()];
            case 7:
              return m.sent(), t.status === hc.MOVED_TEMPORARILY || t.status === hc.UNAUTHORIZED ? [4, e.doAuthChain(t, n, r, o, s, u, f)] : [3, 9];
            case 8:
              m.sent(), m.label = 9;
            case 9:
              if (t.status === hc.OK || t.status === hc.MOVED_TEMPORARILY)
                return [2, t];
              throw e.createAuthorizationFailedError();
          }
        });
      });
    }, e.doAuthChain = function(t, n, r, i, o, s, u) {
      return wk(this, void 0, void 0, function() {
        var f, p, m, v, y, S, E, w, w;
        return Tk(this, function(_) {
          switch (_.label) {
            case 0:
              return t.isAccessControlled() ? (f = t.externalService, f && (f.options = t.options), p = t.kioskService, p && (p.options = t.options), m = t.clickThroughService, m && (m.options = t.options), v = t.loginService, v && (v.options = t.options), !t.isResponseHandled && t.status === hc.MOVED_TEMPORARILY ? [4, s(t)] : [3, 2]) : [2, t];
            case 1:
              return _.sent(), [2, t];
            case 2:
              return y = null, S = null, y = f, y ? (S = y, [4, e.attemptResourceWithToken(t, r, y)]) : [3, 4];
            case 3:
              return _.sent(), [2, t];
            case 4:
              return y = p, y ? (S = y, E = n(y), E ? [4, i(E)] : [3, 7]) : [3, 7];
            case 5:
              return _.sent(), [4, e.attemptResourceWithToken(t, r, y)];
            case 6:
              return _.sent(), [2, t];
            case 7:
              return y = m, y ? (S = y, [4, o(t, y)]) : [3, 11];
            case 8:
              return w = _.sent(), w ? [4, i(w)] : [3, 11];
            case 9:
              return _.sent(), [4, e.attemptResourceWithToken(t, r, y)];
            case 10:
              return _.sent(), [2, t];
            case 11:
              return y = v, y ? (S = y, [4, o(t, y)]) : [3, 15];
            case 12:
              return w = _.sent(), w ? [4, i(w)] : [3, 15];
            case 13:
              return _.sent(), [4, e.attemptResourceWithToken(t, r, y)];
            case 14:
              return _.sent(), [2, t];
            case 15:
              return S && u(t, S), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.attemptResourceWithToken = function(t, n, r) {
      return wk(this, void 0, void 0, function() {
        var i, o;
        return Tk(this, function(s) {
          switch (s.label) {
            case 0:
              return i = r.getService(Dt.ServiceProfile.AUTH_1_TOKEN), i ? [4, n(t, i)] : [3, 3];
            case 1:
              return o = s.sent(), o && o.accessToken ? [4, t.getData(o)] : [3, 3];
            case 2:
              return s.sent(), [2, t];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.loadExternalResourcesAuth09 = function(t, n, r, i, o, s, u, f, p, m) {
      return new Promise(function(v, y) {
        var S = t.map(function(E) {
          return e.loadExternalResourceAuth09(E, n, r, i, o, s, u, f, p, m);
        });
        Promise.all(S).then(function() {
          v(t);
        }).catch(function(E) {
          y(E);
        });
      });
    }, e.loadExternalResourceAuth09 = function(t, n, r, i, o, s, u, f, p, m) {
      return new Promise(function(v, y) {
        m && m.pessimisticAccessControl ? t.getData().then(function() {
          t.isAccessControlled() ? t.clickThroughService ? (v(r(t)), v(i(t))) : o(t).then(function() {
            s(t, !0).then(function(S) {
              t.getData(S).then(function() {
                v(p(t));
              }).catch(function(E) {
                y(e.createInternalServerError(E));
              });
            }).catch(function(S) {
              y(e.createInternalServerError(S));
            });
          }).catch(function(S) {
            y(e.createInternalServerError(S));
          }) : v(t);
        }).catch(function(S) {
          y(e.createInternalServerError(S));
        }) : f(t, n).then(function(S) {
          S ? t.getData(S).then(function() {
            t.status === hc.OK ? v(p(t)) : e.authorize(t, n, r, i, o, s, u, f).then(function() {
              v(p(t));
            }).catch(function(E) {
              y(e.createAuthorizationFailedError());
            });
          }).catch(function(E) {
            y(e.createAuthorizationFailedError());
          }) : e.authorize(t, n, r, i, o, s, u, f).then(function() {
            v(p(t));
          }).catch(function(E) {
            y(e.createAuthorizationFailedError());
          });
        }).catch(function(S) {
          y(e.createAuthorizationFailedError());
        });
      });
    }, e.createError = function(t, n) {
      var r = new Error();
      return r.message = n, r.name = String(t), r;
    }, e.createAuthorizationFailedError = function() {
      return e.createError(jE.AUTHORIZATION_FAILED, "Authorization failed");
    }, e.createRestrictedError = function() {
      return e.createError(jE.RESTRICTED, "Restricted");
    }, e.createInternalServerError = function(t) {
      return e.createError(jE.INTERNAL_SERVER_ERROR, t);
    }, e.authorize = function(t, n, r, i, o, s, u, f) {
      return new Promise(function(p, m) {
        t.getData().then(function() {
          t.isAccessControlled() ? f(t, n).then(function(v) {
            v ? t.getData(v).then(function() {
              t.status === hc.OK ? p(t) : e.showAuthInteraction(t, n, r, i, o, s, u, p, m);
            }).catch(function(y) {
              m(e.createInternalServerError(y));
            }) : s(t, !1).then(function(y) {
              y ? u(t, y, n).then(function() {
                t.getData(y).then(function() {
                  t.status === hc.OK ? p(t) : e.showAuthInteraction(t, n, r, i, o, s, u, p, m);
                }).catch(function(S) {
                  m(e.createInternalServerError(S));
                });
              }).catch(function(S) {
                m(e.createInternalServerError(S));
              }) : e.showAuthInteraction(t, n, r, i, o, s, u, p, m);
            });
          }).catch(function(v) {
            m(e.createInternalServerError(v));
          }) : p(t);
        });
      });
    }, e.showAuthInteraction = function(t, n, r, i, o, s, u, f, p) {
      t.status === hc.MOVED_TEMPORARILY && !t.isResponseHandled ? f(t) : t.clickThroughService && !t.isResponseHandled ? r(t).then(function() {
        s(t, !0).then(function(m) {
          u(t, m, n).then(function() {
            t.getData(m).then(function() {
              f(t);
            }).catch(function(v) {
              p(e.createInternalServerError(v));
            });
          }).catch(function(v) {
            p(e.createInternalServerError(v));
          });
        }).catch(function(m) {
          p(e.createInternalServerError(m));
        });
      }) : o(t).then(function() {
        s(t, !0).then(function(m) {
          u(t, m, n).then(function() {
            t.getData(m).then(function() {
              f(t);
            }).catch(function(v) {
              p(e.createInternalServerError(v));
            });
          }).catch(function(v) {
            p(e.createInternalServerError(v));
          });
        }).catch(function(m) {
          p(e.createInternalServerError(m));
        });
      });
    }, e.getService = function(t, n) {
      for (var r = this.getServices(t), i = 0; i < r.length; i++) {
        var o = r[i];
        if (o.getProfile() === n)
          return o;
      }
      return null;
    }, e.getResourceById = function(t, n) {
      return e.traverseAndFind(t.__jsonld, "@id", n);
    }, e.traverseAndFind = function(t, n, r) {
      if (t.hasOwnProperty(n) && t[n] === r)
        return t;
      for (var i = 0; i < Object.keys(t).length; i++)
        if (typeof t[Object.keys(t)[i]] == "object") {
          var o = e.traverseAndFind(t[Object.keys(t)[i]], n, r);
          if (o != null)
            return o;
        }
    }, e.getServices = function(t, n) {
      var r = n === void 0 ? {} : n, i = r.onlyService, o = i === void 0 ? !1 : i, s = r.onlyServices, u = s === void 0 ? !1 : s, f = r.skipParentResources, p = f === void 0 ? !1 : f, m = [];
      !p && t && t.options && t.options.resource && t.options.resource !== t && m.push.apply(m, e.getServices(t.options.resource, { onlyServices: !0 }));
      var v = u ? [] : (t.__jsonld || t).service || [];
      if (Array.isArray(v) || (v = [v]), o || v.push.apply(v, (t.__jsonld || t).services || []), v.length === 0)
        return m;
      for (var y = 0; y < v.length; y++) {
        var S = v[y];
        if (typeof S == "string") {
          var E = this.getResourceById(t.options.resource, S);
          E && m.push(new sG(E.__jsonld || E, t.options));
        } else
          m.push(new sG(S, t.options));
      }
      return m;
    }, e.getTemporalComponent = function(t) {
      var n = /t=([^&]+)/g.exec(t), r = null;
      return n && n[1] && (r = n[1].split(",")), r;
    }, e;
  })()
), Lye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), kye = function() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var o = arguments[t], s = 0, u = o.length; s < u; s++, i++)
      r[i] = o[s];
  return r;
}, w0 = (
  /** @class */
  (function() {
    function e(t, n, r) {
      r === void 0 && (r = "none"), Array.isArray(t) && t.length === 1 ? this._value = t[0] : this._value = t, (n === "none" || n === "@none") && (n = void 0), this._locale = n, this._defaultLocale = r;
    }
    return e.parseV2Value = function(t, n) {
      return typeof t == "string" ? new e(t, void 0, n) : t["@value"] ? new e(t["@value"], t["@language"], n) : null;
    }, Object.defineProperty(e.prototype, "value", {
      /*** @deprecated Use PropertyValue#getValue instead */
      get: function() {
        return Array.isArray(this._value) ? this._value.join("<br/>") : this._value;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "locale", {
      /*** @deprecated Don't use, only used for backwards compatibility reasons */
      get: function() {
        return this._locale === void 0 ? this._defaultLocale : this._locale;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.addValue = function(t) {
      Array.isArray(this._value) || (this._value = [this._value]), Array.isArray(t) ? this._value = this._value.concat(t) : this._value.push(t);
    }, e;
  })()
), Ti = (
  /** @class */
  (function(e) {
    Lye(t, e);
    function t(n, r) {
      n === void 0 && (n = []);
      var i = e.apply(this, n) || this;
      return i.__proto__ = t.prototype, i._defaultLocale = r, i;
    }
    return t.parse = function(n, r) {
      if (!n)
        return new t([], r);
      if (Array.isArray(n)) {
        var i = n.map(function(s) {
          return w0.parseV2Value(s, r);
        }).filter(function(s) {
          return s !== null;
        }), o = i.reduce(function(s, u) {
          var f = u._locale;
          return f || (f = "none"), s[f] ? s[f].addValue(u._value) : s[f] = u, s;
        }, {});
        return new t(Object.values(o), r);
      } else {
        if (typeof n == "string")
          return new t([new w0(n, void 0, r)], r);
        if (n["@language"]) {
          var i = w0.parseV2Value(n);
          return new t(i !== null ? [i] : [], r);
        } else if (n["@value"]) {
          var i = w0.parseV2Value(n);
          return new t(i !== null ? [i] : [], r);
        } else
          return new t(Object.keys(n).map(function(s) {
            var u = n[s];
            if (!Array.isArray(u))
              throw new Error("A IIIF v3 localized property value must have an array as the value for a given language.");
            return new w0(u, s, r);
          }), r);
      }
    }, t.prototype.getSuitableLocale = function(n) {
      for (var r = kye(this).map(function(S) {
        return S._locale;
      }).filter(function(S) {
        return S !== void 0;
      }), i = function(S) {
        var E = r.find(function(w) {
          return w === S;
        });
        if (E)
          return { value: E };
      }, o = 0, s = n; o < s.length; o++) {
        var u = s[o], f = i(u);
        if (typeof f == "object")
          return f.value;
      }
      for (var p = function(S) {
        var E = r.find(function(w) {
          return nn.getInexactLocale(w) === nn.getInexactLocale(S);
        });
        if (E)
          return { value: E };
      }, m = 0, v = n; m < v.length; m++) {
        var u = v[m], y = p(u);
        if (typeof y == "object")
          return y.value;
      }
    }, t.prototype.setValue = function(n, r) {
      var i = void 0;
      if (!r)
        i = this.find(function(s) {
          return s._locale === void 0;
        });
      else {
        var o = this.getSuitableLocale([r]);
        o && (i = this.find(function(s) {
          return s._locale === o;
        }));
      }
      i ? i._value = n : this.push(new w0(n, r, this._defaultLocale));
    }, t.prototype.getValue = function(n, r) {
      var i = this.getValues(n);
      return i.length === 0 ? null : r ? i.join(r) : i[0];
    }, t.prototype.getValues = function(n) {
      if (!this.length)
        return [];
      var r;
      if (n ? Array.isArray(n) ? r = n : r = [n] : r = [], this.length === 1 && this[0]._locale === void 0) {
        var i = this[0]._value;
        return Array.isArray(i) ? i : [i];
      }
      var o = this.getSuitableLocale(r);
      if (o) {
        var i = this.find(function(p) {
          return p._locale === o;
        })._value;
        return Array.isArray(i) ? i : [i];
      }
      var s = !this.find(function(f) {
        return f._locale === void 0;
      });
      if (s) {
        var i = this[0]._value;
        return Array.isArray(i) ? i : [i];
      }
      var u = this.find(function(f) {
        return f._locale === void 0;
      });
      return u ? Array.isArray(u._value) ? u._value : [u._value] : [];
    }, t;
  })(Array)
), zye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Bye = (
  /** @class */
  (function(e) {
    zye(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      if (i.index = 0, i._allRanges = null, i.items = [], i._topRanges = [], i.__jsonld.structures && i.__jsonld.structures.length)
        for (var o = i._getTopRanges(), s = 0; s < o.length; s++) {
          var u = o[s];
          i._parseRanges(u, String(s));
        }
      return i;
    }
    return t.prototype.getPosterCanvas = function() {
      var n = this.getProperty("posterCanvas");
      return n && (n = new ix(n, this.options)), n;
    }, t.prototype.getAccompanyingCanvas = function() {
      var n = this.getProperty("accompanyingCanvas");
      return n && (n = new ix(n, this.options)), n;
    }, t.prototype.getBehavior = function() {
      var n = this.getProperty("behavior");
      return Array.isArray(n) && (n = n[0]), n || null;
    }, t.prototype.getDefaultTree = function() {
      if (e.prototype.getDefaultTree.call(this), this.defaultTree.data.type = nn.normaliseType(Ld.MANIFEST), !this.isLoaded)
        return this.defaultTree;
      var n = this.getTopRanges();
      return n.length && n[0].getTree(this.defaultTree), nn.generateTreeNodeIds(this.defaultTree), this.defaultTree;
    }, t.prototype._getTopRanges = function() {
      var n = [];
      if (this.__jsonld.structures && this.__jsonld.structures.length) {
        for (var r = 0; r < this.__jsonld.structures.length; r++) {
          var i = this.__jsonld.structures[r];
          i.viewingHint === Dt.ViewingHint.TOP && n.push(i);
        }
        if (!n.length) {
          var o = {};
          o.ranges = this.__jsonld.structures, n.push(o);
        }
      }
      return n;
    }, t.prototype.getTopRanges = function() {
      return this._topRanges;
    }, t.prototype._getRangeById = function(n) {
      if (this.__jsonld.structures && this.__jsonld.structures.length)
        for (var r = 0; r < this.__jsonld.structures.length; r++) {
          var i = this.__jsonld.structures[r];
          if (i["@id"] === n || i.id === n)
            return i;
        }
      return null;
    }, t.prototype._parseRanges = function(n, r, i) {
      var o, s = null;
      if (typeof n == "string" && (s = n, n = this._getRangeById(s)), !n) {
        console.warn("Range:", s, "does not exist");
        return;
      }
      o = new Uye(n, this.options), o.parentRange = i, o.path = r, i ? i.items.push(o) : this._topRanges.push(o);
      var u = n.items || n.members;
      if (u)
        for (var f = 0; f < u.length; f++) {
          var p = u[f];
          if (p["@type"] && p["@type"].toLowerCase() === "sc:range" || p.type && p.type.toLowerCase() === "range")
            this._parseRanges(p, r + "/" + f, o);
          else if (p["@type"] && p["@type"].toLowerCase() === "sc:canvas" || p.type && p.type.toLowerCase() === "canvas") {
            o.canvases || (o.canvases = []);
            var m = p.id || p["@id"];
            o.canvases.push(m);
          }
        }
      else if (n.ranges)
        for (var f = 0; f < n.ranges.length; f++)
          this._parseRanges(n.ranges[f], r + "/" + f, o);
    }, t.prototype.getAllRanges = function() {
      if (this._allRanges != null)
        return this._allRanges;
      this._allRanges = [];
      for (var n = this.getTopRanges(), r = function(s) {
        var u = n[s];
        u.id && i._allRanges.push(u);
        var f = function(m, v) {
          m.add(v);
          var y = v.getRanges();
          return y.length ? y.reduce(f, m) : m;
        }, p = Array.from(u.getRanges().reduce(f, /* @__PURE__ */ new Set()));
        i._allRanges = i._allRanges.concat(p);
      }, i = this, o = 0; o < n.length; o++)
        r(o);
      return this._allRanges;
    }, t.prototype.getRangeById = function(n) {
      for (var r = this.getAllRanges(), i = 0; i < r.length; i++) {
        var o = r[i];
        if (o.id === n)
          return o;
      }
      return null;
    }, t.prototype.getRangeByPath = function(n) {
      for (var r = this.getAllRanges(), i = 0; i < r.length; i++) {
        var o = r[i];
        if (o.path === n)
          return o;
      }
      return null;
    }, t.prototype.getSequences = function() {
      if (this.items.length)
        return this.items;
      var n = this.__jsonld.mediaSequences || this.__jsonld.sequences;
      if (n)
        for (var r = 0; r < n.length; r++) {
          var i = n[r], o = new aG(i, this.options);
          this.items.push(o);
        }
      else if (this.__jsonld.items) {
        var o = new aG(this.__jsonld.items, this.options);
        this.items.push(o);
      }
      return this.items;
    }, t.prototype.getSequenceByIndex = function(n) {
      return this.getSequences()[n];
    }, t.prototype.getTotalSequences = function() {
      return this.getSequences().length;
    }, t.prototype.getManifestType = function() {
      var n = this.getService(Dt.ServiceProfile.UI_EXTENSIONS);
      return n ? n.getProperty("manifestType") : V2.EMPTY;
    }, t.prototype.isMultiSequence = function() {
      return this.getTotalSequences() > 1;
    }, t.prototype.isPagingEnabled = function() {
      var n = this.getViewingHint();
      if (n)
        return n === Dt.ViewingHint.PAGED;
      var r = this.getBehavior();
      return r ? r === Dt.Behavior.PAGED : !1;
    }, t.prototype.getViewingDirection = function() {
      return this.getProperty("viewingDirection");
    }, t.prototype.getViewingHint = function() {
      return this.getProperty("viewingHint");
    }, t;
  })(Ree)
), V2;
(function(e) {
  e.EMPTY = "", e.MANUSCRIPT = "manuscript", e.MONOGRAPH = "monograph";
})(V2 || (V2 = {}));
var Vye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Uye = (
  /** @class */
  (function(e) {
    Vye(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      return i._ranges = null, i.canvases = null, i.items = [], i;
    }
    return t.prototype.getCanvasIds = function() {
      return this.__jsonld.canvases ? this.__jsonld.canvases : this.canvases ? this.canvases : [];
    }, t.prototype.getDuration = function() {
      if (this.canvases && this.canvases.length) {
        for (var n = [], r = [], i = 0, o = this.canvases; i < o.length; i++) {
          var s = o[i];
          if (s) {
            var u = s.match(/(.*)#t=([0-9.]+),?([0-9.]+)?/) || [void 0, s], f = u[1], p = u[2], m = u[3];
            f && (n.push(parseFloat(p)), r.push(parseFloat(m)));
          }
        }
        if (n.length && r.length)
          return new xk(Math.min.apply(Math, n), Math.max.apply(Math, r));
      } else {
        for (var v = this.getRanges(), n = [], r = [], y = 0, S = v; y < S.length; y++) {
          var E = S[y], w = E.getDuration();
          w && (n.push(w.start), r.push(w.end));
        }
        if (n.length && r.length)
          return new xk(Math.min.apply(Math, n), Math.max.apply(Math, r));
      }
      var _, O;
      if (this.canvases && this.canvases.length)
        for (var D = 0; D < this.canvases.length; D++) {
          var s = this.canvases[D], P = nn.getTemporalComponent(s);
          P && P.length > 1 && (D === 0 && (_ = Number(P[0])), D === this.canvases.length - 1 && (O = Number(P[1])));
        }
      else
        for (var v = this.getRanges(), D = 0; D < v.length; D++) {
          var E = v[D], w = E.getDuration();
          w && (D === 0 && (_ = w.start), D === v.length - 1 && (O = w.end));
        }
      if (_ !== void 0 && O !== void 0)
        return new xk(_, O);
    }, t.prototype.getRanges = function() {
      return this._ranges ? this._ranges : this._ranges = this.items.filter(function(n) {
        return n.isRange();
      });
    }, t.prototype.getBehavior = function() {
      var n = this.getProperty("behavior");
      return Array.isArray(n) && (n = n[0]), n || null;
    }, t.prototype.getViewingDirection = function() {
      return this.getProperty("viewingDirection");
    }, t.prototype.getViewingHint = function() {
      return this.getProperty("viewingHint");
    }, t.prototype.getTree = function(n) {
      n.data = this, this.treeNode = n;
      var r = this.getRanges();
      if (r && r.length)
        for (var i = 0; i < r.length; i++) {
          var o = r[i], s = new rA();
          n.addNode(s), this._parseTreeNode(s, o);
        }
      return nn.generateTreeNodeIds(n), n;
    }, t.prototype.spansTime = function(n) {
      var r = this.getDuration();
      return !!(r && n >= r.start && n <= r.end);
    }, t.prototype._parseTreeNode = function(n, r) {
      n.label = r.getLabel().getValue(this.options.locale), n.data = r, n.data.type = nn.normaliseType(Ld.RANGE), r.treeNode = n;
      var i = r.getRanges();
      if (i && i.length)
        for (var o = 0; o < i.length; o++) {
          var s = i[o], u = s.getBehavior();
          if (u !== Dt.Behavior.NO_NAV) {
            var f = new rA();
            n.addNode(f), this._parseTreeNode(f, s);
          }
        }
    }, t;
  })(fp)
), Fye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Wye = (
  /** @class */
  (function(e) {
    Fye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getFormat = function() {
      return this.getProperty("format");
    }, t;
  })(fp)
), Hye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), aG = (
  /** @class */
  (function(e) {
    Hye(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      return i.items = [], i._thumbnails = null, i;
    }
    return t.prototype.getCanvases = function() {
      if (this.items.length)
        return this.items;
      var n = this.__jsonld.canvases || this.__jsonld.elements;
      if (n)
        for (var r = 0; r < n.length; r++) {
          var i = n[r], o = new ix(i, this.options);
          o.index = r, this.items.push(o);
        }
      else if (this.__jsonld)
        for (var r = 0; r < this.__jsonld.length; r++) {
          var i = this.__jsonld[r], o = new ix(i, this.options);
          o.index = r, this.items.push(o);
        }
      return this.items;
    }, t.prototype.getCanvasById = function(n) {
      for (var r = 0; r < this.getTotalCanvases(); r++) {
        var i = this.getCanvasByIndex(r), o = nn.normaliseUrl(i.id);
        if (nn.normaliseUrl(n) === o)
          return i;
      }
      return null;
    }, t.prototype.getCanvasByIndex = function(n) {
      return this.getCanvases()[n];
    }, t.prototype.getCanvasIndexById = function(n) {
      for (var r = 0; r < this.getTotalCanvases(); r++) {
        var i = this.getCanvasByIndex(r);
        if (i.id === n)
          return r;
      }
      return null;
    }, t.prototype.getCanvasIndexByLabel = function(n, r) {
      n = n.trim(), isNaN(n) || (n = parseInt(n, 10).toString(), r && (n += "r"));
      for (var i = /(\d*)\D+(\d*)/, o, s, u, f, p, m = 0; m < this.getTotalCanvases(); m++) {
        var v = this.getCanvasByIndex(m);
        if (v.getLabel().getValue(this.options.locale) === n)
          return m;
        if (o = i.exec(n), !!o && (f = o[1], p = o[2], !!p && (u = "^" + f + "\\D+" + p + "$", s = new RegExp(u), s.test(v.getLabel().toString()))))
          return m;
      }
      return -1;
    }, t.prototype.getLastCanvasLabel = function(n) {
      for (var r = this.getTotalCanvases() - 1; r >= 0; r--) {
        var i = this.getCanvasByIndex(r), o = i.getLabel().getValue(this.options.locale);
        if (n) {
          var s = /^[a-zA-Z0-9]*$/;
          if (s.test(o))
            return o;
        } else if (o)
          return o;
      }
      return this.options.defaultLabel;
    }, t.prototype.getLastPageIndex = function() {
      return this.getTotalCanvases() - 1;
    }, t.prototype.getNextPageIndex = function(n, r) {
      var i;
      if (r) {
        var o = this.getPagedIndices(n), s = this.getViewingDirection();
        s && s === Dt.ViewingDirection.RIGHT_TO_LEFT ? i = o[0] + 1 : i = o[o.length - 1] + 1;
      } else
        i = n + 1;
      return i > this.getLastPageIndex() ? -1 : i;
    }, t.prototype.getPagedIndices = function(n, r) {
      var i = [];
      if (!r)
        i.push(n);
      else {
        this.isFirstCanvas(n) || this.isLastCanvas(n) ? i = [n] : n % 2 ? i = [n, n + 1] : i = [n - 1, n];
        var o = this.getViewingDirection();
        o && o === Dt.ViewingDirection.RIGHT_TO_LEFT && (i = i.reverse());
      }
      return i;
    }, t.prototype.getPrevPageIndex = function(n, r) {
      var i;
      if (r) {
        var o = this.getPagedIndices(n), s = this.getViewingDirection();
        s && s === Dt.ViewingDirection.RIGHT_TO_LEFT ? i = o[o.length - 1] - 1 : i = o[0] - 1;
      } else
        i = n - 1;
      return i;
    }, t.prototype.getStartCanvasIndex = function() {
      var n = this.getStartCanvas();
      if (n)
        for (var r = 0; r < this.getTotalCanvases(); r++) {
          var i = this.getCanvasByIndex(r);
          if (i.id === n)
            return r;
        }
      return 0;
    }, t.prototype.getThumbs = function(n, r) {
      for (var i = [], o = this.getTotalCanvases(), s = 0; s < o; s++) {
        var u = this.getCanvasByIndex(s), f = new Gye(n, u);
        i.push(f);
      }
      return i;
    }, t.prototype.getThumbnails = function() {
      if (this._thumbnails != null)
        return this._thumbnails;
      this._thumbnails = [];
      for (var n = this.getCanvases(), r = 0; r < n.length; r++) {
        var i = n[r].getThumbnail();
        i && this._thumbnails.push(i);
      }
      return this._thumbnails;
    }, t.prototype.getStartCanvas = function() {
      return this.getProperty("startCanvas");
    }, t.prototype.getTotalCanvases = function() {
      return this.getCanvases().length;
    }, t.prototype.getViewingDirection = function() {
      return this.getProperty("viewingDirection") ? this.getProperty("viewingDirection") : this.options.resource.getViewingDirection ? this.options.resource.getViewingDirection() : null;
    }, t.prototype.getViewingHint = function() {
      return this.getProperty("viewingHint");
    }, t.prototype.isCanvasIndexOutOfRange = function(n) {
      return n > this.getTotalCanvases() - 1;
    }, t.prototype.isFirstCanvas = function(n) {
      return n === 0;
    }, t.prototype.isLastCanvas = function(n) {
      return n === this.getTotalCanvases() - 1;
    }, t.prototype.isMultiCanvas = function() {
      return this.getTotalCanvases() > 1;
    }, t.prototype.isPagingEnabled = function() {
      var n = this.getViewingHint();
      return n ? n === Dt.ViewingHint.PAGED : !1;
    }, t.prototype.isTotalCanvasesEven = function() {
      return this.getTotalCanvases() % 2 === 0;
    }, t;
  })(fp)
), Aee = (
  /** @class */
  (function() {
    function e() {
    }
    return e.parse = function(t, n) {
      return typeof t == "string" && (t = JSON.parse(t)), this.parseJson(t, n);
    }, e.parseJson = function(t, n) {
      var r;
      if (n && n.navDate && !isNaN(n.navDate.getTime()) && (t.navDate = n.navDate.toString()), t["@type"])
        switch (t["@type"]) {
          case "sc:Collection":
            r = this.parseCollection(t, n);
            break;
          case "sc:Manifest":
            r = this.parseManifest(t, n);
            break;
          default:
            return null;
        }
      else
        switch (t.type) {
          case "Collection":
            r = this.parseCollection(t, n);
            break;
          case "Manifest":
            r = this.parseManifest(t, n);
            break;
          default:
            return null;
        }
      return r.isLoaded = !0, r;
    }, e.parseCollection = function(t, n) {
      var r = new Dye(t, n);
      return n ? (r.index = n.index || 0, n.resource && (r.parentCollection = n.resource.parentCollection)) : r.index = 0, this.parseCollections(r, n), this.parseManifests(r, n), this.parseItems(r, n), r;
    }, e.parseCollections = function(t, n) {
      var r;
      if (t.__jsonld.collections ? r = t.__jsonld.collections : t.__jsonld.items && (r = t.__jsonld.items.filter(function(s) {
        return s.type.toLowerCase() === "collection";
      })), r)
        for (var i = 0; i < r.length; i++) {
          n && (n.index = i);
          var o = this.parseCollection(r[i], n);
          o.index = i, o.parentCollection = t, t.items.push(o);
        }
    }, e.parseManifest = function(t, n) {
      var r = new Bye(t, n);
      return r;
    }, e.parseManifests = function(t, n) {
      var r;
      if (t.__jsonld.manifests ? r = t.__jsonld.manifests : t.__jsonld.items && (r = t.__jsonld.items.filter(function(s) {
        return s.type.toLowerCase() === "manifest";
      })), r)
        for (var i = 0; i < r.length; i++) {
          var o = this.parseManifest(r[i], n);
          o.index = i, o.parentCollection = t, t.items.push(o);
        }
    }, e.parseItem = function(t, n) {
      if (t["@type"]) {
        if (t["@type"].toLowerCase() === "sc:manifest")
          return this.parseManifest(t, n);
        if (t["@type"].toLowerCase() === "sc:collection")
          return this.parseCollection(t, n);
      } else if (t.type) {
        if (t.type.toLowerCase() === "manifest")
          return this.parseManifest(t, n);
        if (t.type.toLowerCase() === "collection")
          return this.parseCollection(t, n);
      }
      return null;
    }, e.parseItems = function(t, n) {
      var r = t.__jsonld.members || t.__jsonld.items;
      if (r)
        for (var i = function(f) {
          n && (n.index = f);
          var p = o.parseItem(r[f], n);
          if (!p)
            return { value: void 0 };
          if (t.items.filter(function(m) {
            return m.id === p.id;
          })[0])
            return "continue";
          p.index = f, p.parentCollection = t, t.items.push(p);
        }, o = this, s = 0; s < r.length; s++) {
          var u = i(s);
          if (typeof u == "object")
            return u.value;
        }
    }, e;
  })()
), qye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), sG = (
  /** @class */
  (function(e) {
    qye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t.prototype.getProfile = function() {
      var n = this.getProperty("profile");
      return n || (n = this.getProperty("dcterms:conformsTo")), Array.isArray(n) ? n[0] : n;
    }, t.prototype.getConfirmLabel = function() {
      return nn.getLocalisedValue(this.getProperty("confirmLabel"), this.options.locale);
    }, t.prototype.getDescription = function() {
      return nn.getLocalisedValue(this.getProperty("description"), this.options.locale);
    }, t.prototype.getFailureDescription = function() {
      return nn.getLocalisedValue(this.getProperty("failureDescription"), this.options.locale);
    }, t.prototype.getFailureHeader = function() {
      return nn.getLocalisedValue(this.getProperty("failureHeader"), this.options.locale);
    }, t.prototype.getHeader = function() {
      return nn.getLocalisedValue(this.getProperty("header"), this.options.locale);
    }, t.prototype.getServiceLabel = function() {
      return nn.getLocalisedValue(this.getProperty("label"), this.options.locale);
    }, t.prototype.getInfoUri = function() {
      var n = this.id;
      return n.endsWith("/") || (n += "/"), n += "info.json", n;
    }, t;
  })(fp)
), $ye = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, n) {
      this.width = t, this.height = n;
    }
    return e;
  })()
), jE;
(function(e) {
  e[e.AUTHORIZATION_FAILED = 1] = "AUTHORIZATION_FAILED", e[e.FORBIDDEN = 2] = "FORBIDDEN", e[e.INTERNAL_SERVER_ERROR = 3] = "INTERNAL_SERVER_ERROR", e[e.RESTRICTED = 4] = "RESTRICTED";
})(jE || (jE = {}));
var Gye = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, n) {
      this.data = n, this.index = n.index, this.width = t;
      var r = n.getHeight() / n.getWidth();
      r ? this.height = Math.floor(this.width * r) : this.height = t, this.uri = n.getCanonicalImageUri(t), this.label = n.getLabel().getValue(), this.viewingHint = n.getViewingHint();
    }
    return e;
  })()
), Yye = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) i.hasOwnProperty(o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Xye = (
  /** @class */
  (function(e) {
    Yye(t, e);
    function t(n, r) {
      return e.call(this, n, r) || this;
    }
    return t;
  })(j1)
), rA = (
  /** @class */
  (function() {
    function e(t, n) {
      this.label = t, this.data = n || {}, this.nodes = [];
    }
    return e.prototype.addNode = function(t) {
      this.nodes.push(t), t.parentNode = this;
    }, e.prototype.isCollection = function() {
      return this.data.type === nn.normaliseType(Ld.COLLECTION);
    }, e.prototype.isManifest = function() {
      return this.data.type === nn.normaliseType(Ld.MANIFEST);
    }, e.prototype.isRange = function() {
      return this.data.type === nn.normaliseType(Ld.RANGE);
    }, e;
  })()
), Ld;
(function(e) {
  e.COLLECTION = "collection", e.MANIFEST = "manifest", e.RANGE = "range";
})(Ld || (Ld = {}));
class Zye {
  /**
   */
  constructor(t, n = "single") {
    this.canvases = t, this.viewType = n, this._groupings = null;
  }
  /**
   */
  getCanvases(t) {
    switch (this.viewType) {
      case "book":
        return this.groupings()[Math.ceil(t / 2)];
      default:
        return this.groupings()[t];
    }
  }
  /**
   * Groups a set of canvases based on the view type. Single, is just an array
   * of canvases, while book view creates pairs.
   */
  groupings() {
    if (this._groupings)
      return this._groupings;
    if (this.viewType === "scroll")
      return [this.canvases];
    if (this.viewType !== "book")
      return this.canvases.map((n) => [n]);
    const t = [];
    return this.canvases.forEach((n, r) => {
      if (r === 0) {
        t.push([n]);
        return;
      }
      r % 2 !== 0 ? t.push([n]) : t[Math.ceil(r / 2)].push(n);
    }), this._groupings = t, t;
  }
}
const Kye = ["Image", "StillImage", "dctypes:Image", "dctypes:StillImage"], Qye = ["Audio", "Sound", "dctypes:Audio", "dctypes:Sound"], Jye = ["Document", "Text", "dctypes:Document", "dctypes:Text"], ebe = ["Video", "MovingImage", "dctypes:Video", "dctypes:MovingImage"], Kh = {
  audioTypes: Qye,
  imageTypes: Kye,
  textTypes: Jye,
  videoTypes: ebe
}, tbe = [
  "level2",
  "level1",
  "level0",
  "http://iiif.io/api/image/2/level2.json",
  "http://iiif.io/api/image/2/level1.json",
  "http://iiif.io/api/image/2/level0.json"
], nbe = {
  iiifImageProfiles: tbe
};
function rbe(e, t) {
  return !t || !e ? [] : Array.isArray(t) ? e.filter((n) => t.includes(n.getProperty("profile"))) : e.filter((n) => t === n.getProperty("profile"));
}
function Yv(e, t) {
  return !t || !e ? [] : Array.isArray(t) ? e.filter((n) => t.includes(n.getProperty("type"))) : e.filter((n) => t === n.getProperty("type"));
}
function ibe(e) {
  return Yv(e, Kh.audioTypes);
}
function GU(e) {
  return rbe(e, nbe.iiifImageProfiles);
}
function Dee(e) {
  const t = GU(e ? e.getServices() : []);
  return t[0] && t[0].id;
}
function YU(e) {
  return obe(e).filter((t) => Dee(t));
}
function obe(e) {
  return Yv(e, Kh.imageTypes);
}
function abe(e) {
  return Yv(e, Kh.textTypes);
}
function sbe(e) {
  return Yv(e, Kh.videoTypes);
}
let Ox = class {
  /**
   * @param {MiradorCanvas} canvas
   */
  constructor(t) {
    this.canvas = t;
  }
  /** */
  get id() {
    return this.canvas.id;
  }
  /** */
  getWidth() {
    return this.canvas.getWidth();
  }
  /** */
  getHeight() {
    return this.canvas.getHeight();
  }
  /**
   */
  get aspectRatio() {
    return this.canvas.getWidth() / this.canvas.getHeight();
  }
  /**
   * Fetches AnnotationList URIs from canvas's otherContent property
   *
   * Supported otherContent types:
   * - Objects having @type property of "sc:AnnotationList" and URI in @id
   * - Strings being the URIs
   */
  get annotationListUris() {
    return vn(
      new Array(this.canvas.__jsonld.otherContent)
      // eslint-disable-line no-underscore-dangle
    ).filter((t) => t && (typeof t == "string" || t["@type"] === "sc:AnnotationList")).map((t) => typeof t == "string" ? t : t["@id"]);
  }
  /** */
  get canvasAnnotationPages() {
    return vn(
      new Array(this.canvas.__jsonld.annotations)
      // eslint-disable-line no-underscore-dangle
    ).filter((t) => t && t.type === "AnnotationPage");
  }
  /**
   * Will negotiate a v2 or v3 type of resource
   */
  get imageResource() {
    return this.imageResources[0];
  }
  /** Despite name, this method returns paintable resources, not just images */
  get imageResources() {
    const t = yv([
      this.canvas.getImages().map((n) => n.getResource()),
      this.canvas.getContent().map((n) => n.__jsonld.body.type === "Choice" ? n.__jsonld.body : n.getBody())
    ]);
    return vn(t.map((n) => {
      switch (n.type || n.getProperty("type")) {
        case "Choice":
          return new ix({ images: n.items.map((i) => ({ resource: i })) }, this.canvas.options).getImages().map((i, o) => {
            const s = i.getResource();
            return s && (s.preferred = !o), s;
          });
        case "oa:Choice":
          return new ix({ images: yv([n.getProperty("default"), n.getProperty("item")]).map((i) => ({ resource: i })) }, this.canvas.options).getImages().map((i, o) => {
            const s = i.getResource();
            return s && (s.preferred = !o), s;
          });
        default: {
          const i = n;
          return i.preferred = !0, i;
        }
      }
    }));
  }
  /** */
  get contentBodies() {
    return yv([
      this.canvas.getContent().map((t) => t.getBody())
    ]);
  }
  /** */
  get textResources() {
    return vn(abe(this.contentBodies));
  }
  /** */
  get videoResources() {
    return vn(sbe(this.contentBodies));
  }
  /** */
  get audioResources() {
    return vn(ibe(this.contentBodies));
  }
  /** */
  get v2VttContent() {
    const t = this.contentBodies;
    return vn(t.filter((n) => n.getProperty("format") === "text/vtt"));
  }
  /** IIIF v3 captions are stored as 'supplementing' Annotations rather than in the resource content itself */
  get v3VttContent() {
    const t = yv(this.canvasAnnotationPages.map((n) => new Oee(n, this.canvas.options).getItems().map((i) => new e1(i, this.canvas.options).getBody())));
    return vn(t.filter((n) => n.getProperty("format") === "text/vtt"));
  }
  /** */
  get resourceAnnotations() {
    return yv([
      this.canvas.getImages(),
      this.canvas.getContent()
    ]);
  }
  /**
   * Returns a given resource Annotation, based on a contained resource or body
   * id
   */
  resourceAnnotation(t) {
    return this.resourceAnnotations.find(
      (n) => n.getResource().id === t || vn(
        new Array(n.getBody())
      ).some((r) => r.id === t)
    );
  }
  /**
   * Returns the fragment placement values if a resourceAnnotation is placed on
   * a canvas somewhere besides the full extent
   */
  onFragment(t) {
    const n = this.resourceAnnotation(t);
    if (!n) return;
    const r = n.getProperty("on"), i = n.getProperty("target"), o = (r || i).match(/xywh=(.*)$/);
    if (o)
      return o[1].split(",").map((s) => parseInt(s, 10));
  }
  /** */
  get iiifImageResources() {
    return YU(this.imageResources);
  }
  /** */
  get imageServiceIds() {
    return this.iiifImageResources.map(Dee);
  }
  /**
   * Get the canvas service
   */
  get service() {
    return this.canvas.__jsonld.service;
  }
  /**
   * Get the canvas label
   */
  getLabel(t = void 0) {
    return this.canvas.getLabel().length > 0 ? this.canvas.getLabel().getValue(t) : String(this.canvas.index + 1);
  }
};
class Iee {
  /** */
  constructor(t) {
    this.manifest = t;
  }
  /**
   * Returns the starting canvas specified in the manifest
   * @param {object} manifest manifesto instance
   * @param {number} canvasIndexFromState
   * @return {Canvas}
   */
  get startCanvas() {
    let t;
    const n = this.manifest.getSequences()[0];
    if (n) {
      if (t = n.getProperty("startCanvas"), !t) {
        const r = this.manifest.getProperty("start") || n.getProperty("start");
        t = r && (r.id || r.source);
      }
      return t && n.getCanvasById(t) || void 0;
    }
  }
  /** */
  canvasAt(t) {
    const n = this.manifest.getSequences()[0], r = n && n.getCanvases();
    return r && r[t];
  }
}
const Ho = Qe(
  [],
  (e, t) => ((n) => n && new Ox(n))
), XU = Qe(
  [],
  (e) => ((t) => t && new Iee(t))
);
function ZU(e) {
  return Object.values(fo(e).windows).map((t) => t.manifestId);
}
function vg(e) {
  return fo(e).windows || qs;
}
function Wn(e, { windowId: t }) {
  return vg(e)[t];
}
const hD = Qe(
  [
    (e) => fo(e).viewers,
    (e, { windowId: t }) => t
  ],
  (e, t) => e[t]
);
function Do(e) {
  return fo(e).workspace;
}
const Xv = Qe(
  [Do],
  ({ windowIds: e }) => e || Io
);
function L1(e) {
  return fo(e).manifests || qs;
}
function Va(e, { manifestId: t, windowId: n }) {
  const r = L1(e);
  return r && r[t || n && (Wn(e, { windowId: n }) || qs).manifestId];
}
function Pee(e) {
  return fo(e).catalog || qs;
}
function hs(e) {
  return e === void 0 ? [] : Array.isArray(e) ? e : [e];
}
var Ek, lG;
function lbe() {
  if (lG) return Ek;
  lG = 1;
  function e(t, n, r, i) {
    for (var o = -1, s = t == null ? 0 : t.length; ++o < s; ) {
      var u = t[o];
      n(i, u, r(u), t);
    }
    return i;
  }
  return Ek = e, Ek;
}
var _k, cG;
function cbe() {
  if (cG) return _k;
  cG = 1;
  var e = BU();
  function t(n, r, i, o) {
    return e(n, function(s, u, f) {
      r(o, s, i(s), f);
    }), o;
  }
  return _k = t, _k;
}
var Ck, uG;
function Nee() {
  if (uG) return Ck;
  uG = 1;
  var e = lbe(), t = cbe(), n = fD(), r = Yo();
  function i(o, s) {
    return function(u, f) {
      var p = r(u) ? e : t, m = s ? s() : {};
      return p(u, o, n(f, 2), m);
    };
  }
  return Ck = i, Ck;
}
var Rk, dG;
function ube() {
  if (dG) return Rk;
  dG = 1;
  var e = oD(), t = Nee(), n = Object.prototype, r = n.hasOwnProperty, i = t(function(o, s, u) {
    r.call(o, u) ? o[u].push(s) : e(o, u, [s]);
  });
  return Rk = i, Rk;
}
var dbe = ube();
const Mee = /* @__PURE__ */ Hn(dbe);
function k1(e) {
  return fo(e).companionWindows || qs;
}
const ju = Qe(
  [
    k1,
    (e, { companionWindowId: t }) => t
  ],
  (e, t) => t && e[t]
), KU = Qe(
  [ju],
  (e) => e && e.locale
), QU = Qe(
  [
    Wn,
    k1
  ],
  (e, t) => e && t[e.thumbnailNavigationId] && t[e.thumbnailNavigationId].position
), fbe = Qe(
  [vg, k1],
  (e, t) => (Object.keys(e) || []).reduce((n, r) => ({
    ...n,
    [r]: Mee(
      e[r].companionWindowIds,
      (i) => t[i] && t[i].position
    )
  }), {})
), pbe = Qe(
  [vg, k1],
  (e, t) => (Object.keys(e) || []).reduce((n, r) => ({
    ...n,
    [r]: Mee(
      (e[r].companionWindowIds || []).map((i) => t[i]),
      (i) => i.position
    )
  }), {})
), JU = Qe(
  [(e, { windowId: t }) => t, pbe],
  (e, t) => t[e] || qs
), hbe = Qe(
  [(e, { windowId: t }) => t, fbe],
  (e, t) => t[e] || qs
), e3 = Qe(
  [
    JU,
    (e, { position: t }) => t
  ],
  (e, t) => e[t] || Io
), ox = Qe(
  [
    JU,
    (e, { content: t }) => t
  ],
  (e, t) => [].concat(...Object.values(e)).filter((n) => n.content === t)
), gD = Qe(
  [
    hbe,
    (e, { position: t }) => t
  ],
  (e, t) => e[t] || Io
), jee = Qe(
  [
    (e, { position: t }) => t,
    Wn
  ],
  (e, t) => {
    if (!t) return !1;
    const { companionAreaOpen: n, sideBarOpen: r } = t;
    return e !== "left" ? !0 : !!(n && r);
  }
), Lee = Qe(
  [JU],
  (e) => {
    let t = 0, n = 0;
    return [].concat(...Object.values(e)).forEach((r) => {
      r.position.match(/right/) && (t += 235), r.position.match(/bottom/) && (n += 201);
    }), { height: n, width: t };
  }
);
var Ok, fG;
function gbe() {
  if (fG) return Ok;
  fG = 1;
  var e = function(D) {
    return t(D) && !n(D);
  };
  function t(O) {
    return !!O && typeof O == "object";
  }
  function n(O) {
    var D = Object.prototype.toString.call(O);
    return D === "[object RegExp]" || D === "[object Date]" || o(O);
  }
  var r = typeof Symbol == "function" && Symbol.for, i = r ? Symbol.for("react.element") : 60103;
  function o(O) {
    return O.$$typeof === i;
  }
  function s(O) {
    return Array.isArray(O) ? [] : {};
  }
  function u(O, D) {
    return D.clone !== !1 && D.isMergeableObject(O) ? w(s(O), O, D) : O;
  }
  function f(O, D, P) {
    return O.concat(D).map(function(M) {
      return u(M, P);
    });
  }
  function p(O, D) {
    if (!D.customMerge)
      return w;
    var P = D.customMerge(O);
    return typeof P == "function" ? P : w;
  }
  function m(O) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(O).filter(function(D) {
      return Object.propertyIsEnumerable.call(O, D);
    }) : [];
  }
  function v(O) {
    return Object.keys(O).concat(m(O));
  }
  function y(O, D) {
    try {
      return D in O;
    } catch {
      return !1;
    }
  }
  function S(O, D) {
    return y(O, D) && !(Object.hasOwnProperty.call(O, D) && Object.propertyIsEnumerable.call(O, D));
  }
  function E(O, D, P) {
    var M = {};
    return P.isMergeableObject(O) && v(O).forEach(function(N) {
      M[N] = u(O[N], P);
    }), v(D).forEach(function(N) {
      S(O, N) || (y(O, N) && P.isMergeableObject(D[N]) ? M[N] = p(N, P)(O[N], D[N], P) : M[N] = u(D[N], P));
    }), M;
  }
  function w(O, D, P) {
    P = P || {}, P.arrayMerge = P.arrayMerge || f, P.isMergeableObject = P.isMergeableObject || e, P.cloneUnlessOtherwiseSpecified = u;
    var M = Array.isArray(D), N = Array.isArray(O), k = M === N;
    return k ? M ? P.arrayMerge(O, D, P) : E(O, D, P) : u(D, P);
  }
  w.all = function(D, P) {
    if (!Array.isArray(D))
      throw new Error("first argument should be an array");
    return D.reduce(function(M, N) {
      return w(M, N, P);
    }, {});
  };
  var _ = w;
  return Ok = _, Ok;
}
var mbe = gbe();
const tp = /* @__PURE__ */ Hn(mbe);
function Dn(e) {
  return fo(e || {}).config || qs;
}
function kee(e) {
  const t = Dn(e).export;
  return Object.entries(t).reduce(
    (n, [r, i]) => (i === !0 ? n[r] = e[r] : i.filter && (n[r] = Object.entries(e[r]).filter(i.filter).reduce(
      (o, [s, u]) => (o[s] = u, o),
      {}
    )), n),
    {}
  );
}
const t3 = Qe(
  [Dn],
  ({ availableLanguages: e, language: t }) => Object.keys(e).map((n) => ({
    current: n === t,
    label: e[n],
    locale: n
  }))
), n3 = Qe(
  [
    Do,
    Dn
  ],
  (e, t) => e.showZoomControls === void 0 ? t.workspace.showZoomControls : e.showZoomControls
), r3 = Qe(
  [Dn],
  ({ theme: e, themes: t, selectedTheme: n }) => tp(e, t[n] || {})
), i3 = Qe(
  [Dn],
  ({ themes: e }) => Object.keys(e)
), Du = Qe(
  [Dn],
  ({ id: e }) => e
), Ax = Qe(
  [Dn],
  ({ theme: e }) => e.direction || "ltr"
), zee = Qe(
  [Dn],
  ({ requests: e }) => e || qs
), Bee = Qe(
  [Dn],
  ({ thumbnails: e }) => e || qs
);
function vbe(e) {
  const t = e.getProfile();
  return t.endsWith("#level1") || t.endsWith("#level2") ? !1 : t === "level0" ? !0 : nn.isLevel0ImageProfile(t);
}
function ybe(e) {
  const t = e.getProfile();
  return t.endsWith("#level0") || t.endsWith("#level1") ? !1 : t === "level2" ? !0 : nn.isLevel2ImageProfile(t);
}
function bbe(e) {
  const t = e.getProperty("type") || [];
  return hs(t).some((n) => n.startsWith("ImageService"));
}
function Ak(e) {
  const t = e && e.getServices().find((n) => bbe(n) || nn.isImageProfile(n.getProfile()));
  if (t)
    return t;
}
class wv {
  /** */
  constructor(t = {}, { getMiradorCanvas: n, getMiradorManifest: r }) {
    this.iiifOpts = t, this.getMiradorCanvas = n, this.getMiradorManifest = r;
  }
  /** */
  static staticImageUrl(t) {
    return { height: t.getProperty("height"), url: t.id, width: t.getProperty("width") };
  }
  /**
   * Selects the image resource that is representative of the given canvas.
   * @param {Object} canvas A Manifesto Canvas
   * @return {Object} A Manifesto Image Resource
   */
  static getPreferredImage(t) {
    return t.iiifImageResources[0] || t.imageResource;
  }
  /**
   * Chooses the best available image size based on a target area (w x h) value.
   * @param {Object} service A IIIF Image API service that has a `sizes` array
   * @param {Number} targetArea The target area value to compare potential sizes against
   * @return {Object|undefined} The best size, or undefined if none are acceptable
   */
  static selectBestImageSize(t, n) {
    const r = hs(t.getProperty("sizes"));
    let i = {
      default: !0,
      height: t.getProperty("height") || Number.MAX_SAFE_INTEGER,
      width: t.getProperty("width") || Number.MAX_SAFE_INTEGER
    };
    const o = (s) => s.width * s.height - n;
    if (i = r.reduce((s, u) => {
      const f = o(u);
      return f < 0 ? s : Math.abs(f) < Math.abs(o(s)) ? u : s;
    }, i), i.width * i.height > n * 6 && (i = r.reduce((s, u) => Math.abs(o(u)) < Math.abs(o(s)) ? u : s, i)), !i.default)
      return i;
  }
  /**
   * Determines the appropriate thumbnail to use to represent an Image Resource.
   * @param {Object} resource The Image Resource from which to derive a thumbnail
   * @return {Object} The thumbnail URL and any spatial dimensions that can be determined
   */
  iiifThumbnailUrl(t) {
    let n, r, i, s = 120, u = 120;
    const { maxHeight: f, maxWidth: p } = this.iiifOpts;
    f && (s = Math.max(f, 120)), p && (u = Math.max(p, 120));
    const m = Ak(t);
    if (!m) return wv.staticImageUrl(t);
    const v = t.getWidth() && t.getHeight() && t.getWidth() / t.getHeight(), y = p && f ? p * f : s * u, S = wv.selectBestImageSize(m, y);
    if (S)
      r = S.width, i = S.height, n = `${r},${i}`;
    else if (vbe(m)) {
      if (!m.getProperty("height") && !m.getProperty("width"))
        return wv.staticImageUrl(t);
    } else f && p ? ybe(m) ? (n = `!${u},${s}`, r = u, i = s, v && v > 1 && (i = Math.round(u / v)), v && v < 1 && (r = Math.round(s * v))) : u / s < v ? (n = `${u},`, r = u, v && (i = Math.round(u / v))) : (n = `,${s}`, i = s, v && (r = Math.round(s * v))) : f && !p ? (n = `,${s}`, i = s, v && (r = Math.round(s * v))) : !f && p ? (n = `${u},`, r = u, v && (i = Math.round(u / v))) : (n = ",120", i = 120, v && (r = Math.round(i * v)));
    const E = "full", w = nn.getImageQuality(m.getProfile()), _ = m.id.replace(/\/+$/, ""), O = this.getFormat(m);
    return {
      height: i,
      url: [_, E, n, 0, `${w}.${O}`].join("/"),
      width: r
    };
  }
  /**
   * Figure out what format thumbnail to use by looking at the preferred formats
   * on offer, and selecting a format shared in common with the application's
   * preferred format list.
   *
   * Fall back to jpg, which is required to work for all IIIF services.
   */
  getFormat(t) {
    const { preferredFormats: n = [] } = this.iiifOpts, r = t.getProperty("preferredFormats");
    if (!r) return "jpg";
    const i = r.filter(
      (o) => n.includes(o)
    );
    return i[0] ? i[0] : !r.includes("jpg") && n.includes("jpg") ? "jpg" : r[0] ? r[0] : "jpg";
  }
  /**
   * Determines the content resource from which to derive a thumbnail to represent a given resource.
   * This method is recursive.
   * @param {Object} resource A IIIF resource to derive a thumbnail from
   * @return {Object|undefined} The Image Resource to derive a thumbnail from, or undefined
   * if no appropriate resource exists
   */
  getSourceContentResource(t) {
    const n = t.getThumbnail();
    if (n)
      return typeof n.__jsonld == "string" ? n.__jsonld : !t.isCollection() && !t.isManifest() && !t.isCanvas() && t.getType() === "image" && Ak(t) && !Ak(n) ? t : n;
    if (t.isCollection()) {
      const r = t.getManifests()[0];
      return r ? this.getSourceContentResource(r) : void 0;
    }
    if (t.isManifest()) {
      const r = this.getMiradorManifest(t), i = r.startCanvas || r.canvasAt(0);
      return i ? this.getSourceContentResource(i) : void 0;
    }
    if (t.isCanvas()) {
      const r = wv.getPreferredImage(this.getMiradorCanvas(t));
      return r ? this.getSourceContentResource(r) : void 0;
    }
    if (t.getType() === "image")
      return t;
  }
  /**
   * Gets a thumbnail representing the resource.
   * @return {Object|undefined} A thumbnail representing the resource, or undefined if none could
   * be determined
   */
  get(t) {
    if (!t) return;
    const n = this.getSourceContentResource(t);
    if (n)
      return typeof n == "string" ? { url: n } : this.iiifThumbnailUrl(n);
  }
}
function xbe(e, t = {}) {
  return new wv(
    t,
    {
      getMiradorCanvas: (n) => new Ox(n),
      getMiradorManifest: (n) => new Iee(n)
    }
  ).get(e);
}
const Vee = Qe(
  [Bee, (e, t, n) => t, (e, t, n) => n],
  (e, t, n) => ({ maxHeight: t, maxWidth: n, preferredFormats: e.preferredFormats })
), mD = Qe(
  [Vee, Ho, XU],
  (e, t, n) => new wv(
    e,
    { getMiradorCanvas: t, getMiradorManifest: n }
  )
);
function Uee(e, t) {
  if (!e) return;
  const n = nn.parseManifest(structuredClone(e), t ? { locale: t } : void 0);
  if (n)
    return typeof n.getSequences != "function" && (n.getSequences = () => []), n;
}
const z1 = Qe(
  [
    KU,
    Dn,
    (e, { locale: t }) => t
  ],
  (e, t = {}, n) => n || e || t.language || t.fallbackLanguages
), Sbe = Object.freeze({ missing: !0 }), ax = Qe(
  [Va],
  (e) => e || Sbe
), Fee = Qe(
  [Va],
  (e) => e && e.error
), wbe = Qe(
  Va,
  (e) => e && Uee(e.json)
), nr = Qe(
  wbe,
  (e, { json: t }) => t,
  (e, t) => t && Uee(t, locale) || e
), Oi = Qe(
  [nr, z1],
  (e, t) => t ?? (e && e.options && e.options.locale && e.options.locale.replace(/-.*$/, ""))
);
function ag(e) {
  return Qe(
    [nr],
    (t) => t && t.getProperty(e)
  );
}
const Wee = Qe(
  [
    ag("provider"),
    Oi
  ],
  (e, t) => e && e[0].label && Ti.parse(e[0].label).getValue(t)
), Tbe = Object.freeze({}), Hee = Qe(
  [
    ag("provider"),
    (e) => mD(e, Tbe)
  ],
  (e, t) => {
    var r;
    const n = e && e[0] && e[0].logo && e[0].logo[0];
    return n ? (r = t.get(new j1(n))) == null ? void 0 : r.url : null;
  }
), o3 = Qe(
  [nr, Hee],
  (e, t) => t || e && e.getLogo()
), qee = Qe(
  [
    ag("homepage"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => ({
    label: Ti.parse(n.label).getValue(t),
    value: n.id || n["@id"]
  }))
), $ee = Qe(
  [nr, Oi],
  (e, t) => e && e.getRenderings().map((n) => ({
    label: n.getLabel().getValue(t),
    value: n.id
  }))
), a3 = Qe(
  [
    ag("seeAlso"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => ({
    format: n.format,
    label: Ti.parse(n.label).getValue(t),
    value: n.id || n["@id"]
  }))
), Ebe = a3, Gee = Qe(
  [
    ag("related"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => typeof n == "string" ? {
    value: n
  } : {
    format: n.format,
    label: Ti.parse(n.label).getValue(t),
    value: n.id || n["@id"]
  })
), Yee = Qe(
  [nr, Oi],
  (e, t) => e && hs(e.getRequiredStatement()).filter((n) => n && n.getValues().some((r) => r)).map((n) => ({
    label: n.label && n.label.getValue(t) || null,
    values: n.getValues(t)
  }))
), s3 = Qe(
  [
    ag("rights"),
    ag("license"),
    Oi
  ],
  (e, t, n) => {
    const r = e || t;
    return hs(Ti.parse(r).getValues(n));
  }
);
function Xee(e, t) {
  const n = nr(e, t), r = mD(e, 80, 120);
  if (!n) return;
  const i = r.get(n);
  return i && i.url;
}
const Lu = Qe(
  [nr, Oi],
  (e, t) => e && e.getLabel().getValue(t)
), Zee = Qe(
  [z1, nr],
  (e, t) => t && t.getDescription().getValue(e)
), Kee = Qe(
  [
    ag("summary"),
    Oi
  ],
  (e, t) => e && Ti.parse(e).getValue(t)
), B1 = Qe(
  [nr],
  (e) => e && e.id
);
function l3(e, t = void 0) {
  return e && e.getMetadata().map((n) => ({
    label: n.getLabel(t),
    values: n.getValues(t)
  }));
}
const Qee = Qe(
  [nr, Oi],
  (e, t) => e && l3(e, t)
);
function pG(e) {
  const t = /* @__PURE__ */ new Set([]), n = (r) => {
    if (r && typeof r == "object") {
      if (r["@language"] && r["@value"]) {
        t.add(r["@language"]);
        return;
      }
      Object.keys(r).forEach((i) => {
        t.add(i);
      });
    }
  };
  return Array.isArray(e) ? e.forEach((r) => n(r)) : n(e), [...t];
}
function _be(e) {
  if (!e) return [];
  const t = e.getProperty("metadata") || [], n = {};
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    pG(i.label).forEach((o) => {
      n[o] = !0;
    }), pG(i.value).forEach((o) => {
      n[o] = !0;
    });
  }
  return Object.keys(n);
}
const Jee = Qe(
  [nr],
  (e) => _be(e)
), Dx = Qe(
  [nr],
  (e) => {
    if (!e) return null;
    const t = e.getService("http://iiif.io/api/search/0/search") || e.getService("http://iiif.io/api/search/1/search");
    return t || null;
  }
), ete = Qe(
  [Dx],
  (e) => {
    const t = e && (e.getService("http://iiif.io/api/search/0/autocomplete") || e.getService("http://iiif.io/api/search/1/autocomplete"));
    return t && t;
  }
), c3 = Qe(
  [nr],
  (e) => {
    if (!e || !e.getTopRanges) return null;
    const t = e.getTopRanges(), n = t.filter((o) => o.getProperty("viewingHint") === "top");
    let r = [];
    return n.length === 0 && t.length === 1 && (r = t[0].getRanges().filter((o) => o.getBehavior() === "sequence")), [].concat(
      // v2: multi-sequence manifests, or v3: items
      e.getSequences(),
      // v3: all top-level ranges with behavior=sequence
      r
    );
  }
), Gd = Qe(
  [
    c3,
    Wn,
    (e, { sequenceId: t }) => t
  ],
  (e, t, n) => {
    if (!e) return null;
    if (n || t && t.sequenceId) {
      const r = e.find((i) => i.id === (n || t.sequenceId));
      if (r) return r;
    }
    return e[0];
  }
), u3 = Qe(
  [
    Wn,
    Gd
  ],
  (e, t) => (t && e && e.canvasId && t.getCanvasById(e.canvasId) || {}).index || 0
), d3 = Qe(
  [Gd, nr],
  (e, t) => {
    if (!t) return null;
    const n = e && e.getViewingHint() || t.getViewingHint();
    return n || null;
  }
), Ix = Qe(
  [Wn, Gd, nr],
  (e, t, n) => {
    const r = e && e.viewingDirection || t && t.getViewingDirection() || n && n.getViewingDirection();
    return r || null;
  }
), V1 = Qe(
  [Gd, nr],
  (e, t) => {
    if (!t || !e) return [];
    const n = e && e.getProperty("behavior");
    if (n)
      return Array.isArray(n) ? n : [n];
    const r = t.getProperty("behavior");
    return r ? Array.isArray(r) ? r : [r] : [];
  }
), U1 = Qe(
  [Gd, nr],
  (e, t) => e && e.getProperty("type") && e.isRange() ? e.getTree(new rA("root")) : t && t.getDefaultTree()
);
function vD(e) {
  return fo(e).elasticLayout;
}
const Cbe = Qe(
  [Do],
  (e) => e.isFullscreenEnabled
);
function tte(e) {
  const [t] = fo(e).errors.items;
  return fo(e).errors[t];
}
const F1 = Qe(
  [Do],
  ({ type: e }) => e
), f3 = Qe(
  [Do],
  ({ focusedWindowId: e }) => e
), p3 = (e, { windowId: t }) => f3(e) === t, fa = Qe(
  [Dn, Wn],
  ({ window: e }, t = {}) => ({ ...e, ...t })
);
function nte(e) {
  const t = {};
  return Object.keys(vg(e)).forEach((n) => {
    t[n] = Lu(e, { windowId: n });
  }), t;
}
const rte = Qe(
  [vg],
  (e) => Object.values(e).filter((t) => t.maximized === !0).map((t) => t.id)
), Nv = Qe(
  [
    Wn,
    fa,
    d3,
    V1
  ],
  (e, { views: t = [], defaultView: n }, r, i) => {
    if (e && e.view) return e.view;
    const o = (t || []).find((s) => s.behaviors && s.behaviors.some((u) => r === u || i.includes(u)));
    return o && o.key || n;
  }
), ite = Qe(
  [
    d3,
    V1,
    fa
  ],
  (e, t, { views: n = [], defaultView: r }) => (n || []).reduce((i, o) => ((o.key === r || !o.behaviors || o.behaviors.some((s) => e === s || t.includes(s))) && i.push(o.key), i), [])
), ote = Qe(
  [
    F1,
    Wn,
    (e) => Xv(e).length > 1
  ],
  (e, t, n) => e === "elastic" ? !0 : n && t && t.maximized === !1
);
function ate(e) {
  return e && nn.getServices(e).filter((t) => {
    var n;
    return t.getProfile() && t.getProfile().match(/http:\/\/iiif.io\/api\/auth\//) || ((n = t.getProperty("type")) == null ? void 0 : n.match(/^Auth.*Service2$/));
  });
}
function ste(e) {
  return e && nn.getServices(e).filter((t) => t.getProfile() === "http://iiif.io/api/auth/1/probe" || t.getProperty("type") === "AuthProbeService2");
}
function rp(e) {
  return e && ste(e)[0];
}
function Rbe(e) {
  return e && (nn.getService(e, "http://iiif.io/api/auth/1/token") || nn.getService(e, "http://iiif.io/api/auth/0/token") || Yv(nn.getServices(e), "AuthAccessTokenService2")[0]);
}
function h3(e) {
  const t = Rbe(e);
  if (t) return [t];
  const n = e && Yv(nn.getServices(e), "AuthAccessTokenService2");
  if (n && n[0]) return n;
  if (e) {
    const r = ate(e);
    if (r[0]) return vn(r.map((i) => h3(i)));
  }
  return [];
}
function W1(e) {
  return h3(e)[0];
}
function Obe(e) {
  return e && (nn.getService(e, "http://iiif.io/api/auth/1/logout") || nn.getService(e, "http://iiif.io/api/auth/0/logout") || Yv(nn.getServices(e), "AuthLogoutService2")[0]);
}
const Px = (e) => fo(e).infoResponses, Zv = (e) => fo(e).probeResponses, Fa = Qe(
  [Gd],
  (e) => e && e.getCanvases() || Io
), Yd = Qe(
  [
    Gd,
    (e, { canvasId: t }) => t
  ],
  (e, t) => {
    if (!(!e || !t))
      return e.getCanvasById(t);
  }
), Vl = Qe(
  [
    Gd,
    Wn
  ],
  (e, t) => {
    if (!(!e || !t))
      return t.canvasId ? e.getCanvasById(t.canvasId) : e.getCanvasByIndex(0);
  }
), ku = Qe(
  [Wn],
  (e) => e && (e.visibleCanvases || e.canvasId && [e.canvasId]) || Io
), Ul = Qe(
  [ku, Fa],
  (e, t) => (t || []).filter((n) => e.includes(n.id))
), H1 = Qe(
  [
    Fa,
    Nv
  ],
  (e, t) => e && new Zye(
    e,
    t
  ).groupings()
), g3 = Qe(
  [
    H1,
    (e, { canvasId: t }) => t
  ],
  (e, t) => e && e.find((n) => n.some((r) => r.id === t)) || Io
), q1 = Qe(
  [
    H1,
    Vl
  ],
  (e, t, n) => {
    if (!e || !t) return;
    const r = e.findIndex((o) => o.some((s) => s.id === t.id));
    return r < 0 || r + 1 >= e.length ? void 0 : e[r + 1];
  }
), $1 = Qe(
  [
    H1,
    Vl
  ],
  (e, t, n) => {
    if (!e || !t) return;
    const r = e.findIndex((o) => o.some((s) => s.id === t.id));
    return r < 1 ? void 0 : e[r - 1];
  }
), yg = Qe(
  [Yd, Oi],
  (e, t) => e && (e.getLabel().length > 0 ? e.getLabel().getValue(t) : String(e.index + 1))
), lte = Qe(
  [Yd],
  (e) => e && e.getProperty("description")
), m3 = (e, t) => t ? e.map((n) => {
  const r = rp(n), i = r && r.id, o = i && t[i];
  if (!o || o.isFetching) return n;
  const s = o.json && (o.json.location || o.json.substitute), u = {};
  return s && (u.id = s, o.json.format && (u.format = o.json.format)), new j1({ ...n.__jsonld, ...u }, n.options);
}) : e, cte = Qe(
  [
    Ul,
    Ho
  ],
  (e, t) => vn(e.map((n) => t(n).imageResources)).filter((n) => GU(n.getServices()).length < 1)
), yD = Qe(
  [
    Ul,
    Ho,
    Zv
  ],
  (e, t, n) => vn(e.map((r) => m3(t(r).textResources, n)))
), bD = Qe(
  [
    Ul,
    Ho,
    Zv
  ],
  (e, t, n) => vn(e.map((r) => m3(t(r).videoResources, n)))
), G1 = Qe(
  [
    Ul,
    Ho
  ],
  (e, t) => vn(e.map((n) => {
    const r = t(n);
    return r.v3VttContent.length ? r.v3VttContent : r.v2VttContent;
  }))
), xD = Qe(
  [
    Ul,
    Ho,
    Zv
  ],
  (e, t, n) => vn(e.map((r) => m3(t(r).audioResources, n)))
), v3 = Qe(
  [
    (e, { infoId: t }) => t,
    Yd,
    Ho,
    Px
  ],
  (e, t, n, r) => {
    let i = e;
    if (!e) {
      if (!t) return;
      const o = n(t).iiifImageResources[0];
      i = o && o.getServices()[0].id;
    }
    return i && r[i] && !r[i].isFetching && r[i];
  }
), ute = Qe(
  [
    (e, { probeId: t }) => t,
    Yd,
    Zv
  ],
  (e, t, n) => {
    let r = e;
    if (!r) {
      if (!t) return;
      const o = new MiradorCanvas(t).imageResources[0], s = rp(o);
      r = s && s.id;
    }
    return r && n[r] && !n[r].isFetching && n[r];
  }
), SD = (e) => fo(e).annotations, dte = Qe(
  [
    Dn,
    (e, { motivations: t }) => t
  ],
  (e, t) => t || e.annotations.filteredMotivations
), Abe = Qe(
  [
    Yd,
    SD
  ],
  (e, t) => !t || !e ? [] : t[e.id] ? vn(Object.values(t[e.id])) : []
), Dbe = Qe(
  [
    Abe
  ],
  (e) => pD(
    Object.values(e).map((t) => t && _ee.determineAnnotation(t.json)),
    (t) => t && t.present()
  )
), Ibe = Qe(
  [
    (e, { canvasId: t, ...n }) => t ? [t] : ku(e, n),
    SD
  ],
  (e, t) => !t || e.length === 0 ? [] : vn(
    e.map(
      (n) => t[n] && Object.values(t[n])
    )
  )
), Y1 = Qe(
  [
    Ibe
  ],
  (e) => pD(
    Object.values(e).map((t) => t && _ee.determineAnnotation(t.json)),
    (t) => t && t.present()
  )
), fte = Qe(
  [
    Dbe,
    dte
  ],
  (e, t) => pD(
    vn(e.map((n) => n.resources)),
    (n) => n.motivations.some(
      (r) => t.includes(r)
    )
  )
), wD = Qe(
  [
    Y1,
    dte
  ],
  (e, t) => pD(
    vn(e.map((n) => n.resources)),
    (n) => n.motivations.some(
      (r) => t.includes(r)
    )
  )
), X1 = Qe(
  [
    Wn
  ],
  ({ selectedAnnotationId: e }) => e
), Pbe = Qe(
  [
    Y1,
    X1
  ],
  (e, t) => e.map((n) => ({
    id: n["@id"] || n.id,
    resources: n.resources.filter(
      (r) => t === r.id
    )
  })).filter((n) => n.resources.length > 0)
), Nbe = (e) => fo(e).searches, TD = Qe(
  [
    (e, { windowId: t }) => t,
    Nbe
  ],
  (e, t) => !e || !t ? qs : t[e]
), Z1 = Qe(
  [
    TD,
    (e, { companionWindowId: t }) => t
  ],
  (e, t) => {
    if (!(!e || !t))
      return e[t];
  }
), y3 = Qe(
  [
    Z1
  ],
  (e) => e ? Object.values(e.data) : Io
), K1 = Qe(
  [
    Z1
  ],
  (e) => e && e.query
), b3 = Qe(
  [
    y3
  ],
  (e) => e.some((t) => t.isFetching)
), x3 = Qe(
  [
    Z1
  ],
  (e) => {
    var n, r;
    if (!e || !e.data) return;
    const t = Object.values(e.data).find((i) => !i.isFetching && i.json && i.json.within);
    return (r = (n = t == null ? void 0 : t.json) == null ? void 0 : n.within) == null ? void 0 : r.total;
  }
), pte = Qe(
  [
    Z1
  ],
  (e) => {
    if (!e || !e.data) return;
    const t = Object.values(e.data).find((n) => !n.isFetching && n.json && n.json.next && !e.data[n.json.next]);
    return t && t.json && t.json.next;
  }
), Mbe = Qe(
  [
    y3
  ],
  (e) => vn(e.map((t) => !t || !t.json || t.isFetching || !t.json.hits ? Io : t.json.hits))
), Q1 = Qe(
  [
    y3
  ],
  (e) => e && hte(e)
), S3 = Qe(
  [
    Mbe,
    Fa,
    Q1
  ],
  (e, t, n) => {
    if (!t || t.length === 0 || !e || e.length === 0) return Io;
    const r = t.map((i) => i.id);
    return [].concat(e).sort((i, o) => {
      const s = n.resources.find(
        (f) => f.id === i.annotations[0]
      ), u = n.resources.find(
        (f) => f.id === o.annotations[0]
      );
      return r.indexOf(s.targetId) - r.indexOf(u.targetId);
    });
  }
), hte = (e) => {
  const t = e.map((n) => {
    if (!n || !n.json || n.isFetching || !n.json.resources) return;
    const r = new Eee(n.json);
    return {
      id: r.id,
      resources: r.resources
    };
  }).filter(Boolean);
  return {
    id: (t.find((n) => n.id) || {}).id,
    resources: vn(t.map((n) => n.resources))
  };
};
function gte(e, t) {
  if (!e || !e.resources || e.length === 0 || !t || t.length === 0) return Io;
  const n = t.map((r) => r.id);
  return [].concat(e.resources).sort(
    (r, i) => n.indexOf(r.targetId) - n.indexOf(i.targetId)
  );
}
const w3 = Qe(
  [
    Q1,
    Fa
  ],
  (e, t) => gte(e, t)
), ED = Qe(
  [
    TD
  ],
  (e) => e ? Object.values(e).map((n) => Object.values(n.data)).map((n) => hte(n)).filter((n) => n.resources.length > 0) : Io
), _D = Qe(
  [
    Wn,
    Z1
  ],
  (e, t) => t && t.selectedContentSearchAnnotationIds || []
), T3 = Qe(
  [
    Q1,
    (e, { annotationUri: t }) => t
  ],
  (e, t) => e.resources.find(
    (n) => n.id === t
  )
), mte = Qe(
  [
    T3,
    Oi
  ],
  (e, t) => e && e.resource && e.resource.label ? Ti.parse(e.resource.label).getValues(t) : Io
), jbe = Qe(
  [
    ED,
    (e, { annotationId: t }) => t
  ],
  (e, t) => vn(e.map((r) => r.resources)).find((r) => r.id === t)
), vte = Qe(
  [
    jbe,
    (e, { windowId: t }) => (n) => Yd(e, { canvasId: n, windowId: t })
  ],
  (e, t) => {
    const n = e && e.targetId;
    return n && t(n);
  }
);
var Dk, hG;
function yte() {
  if (hG) return Dk;
  hG = 1;
  var e = _U(), t = Math.max;
  function n(r, i, o) {
    return i = t(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var s = arguments, u = -1, f = t(s.length - i, 0), p = Array(f); ++u < f; )
        p[u] = s[i + u];
      u = -1;
      for (var m = Array(i + 1); ++u < i; )
        m[u] = s[u];
      return m[i] = o(p), e(r, this, m);
    };
  }
  return Dk = n, Dk;
}
var Ik, gG;
function J1() {
  if (gG) return Ik;
  gG = 1;
  var e = Ex(), t = yte(), n = OU();
  function r(i, o) {
    return n(t(i, o, e), i + "");
  }
  return Ik = r, Ik;
}
var Pk, mG;
function bte() {
  if (mG) return Pk;
  mG = 1;
  function e(t, n, r) {
    for (var i = -1, o = t == null ? 0 : t.length; ++i < o; )
      if (r(n, t[i]))
        return !0;
    return !1;
  }
  return Pk = e, Pk;
}
var Nk, vG;
function Lbe() {
  if (vG) return Nk;
  vG = 1;
  var e = pee(), t = nee(), n = WU(), r = 1 / 0, i = e && 1 / n(new e([, -0]))[1] == r ? function(o) {
    return new e(o);
  } : t;
  return Nk = i, Nk;
}
var Mk, yG;
function xte() {
  if (yG) return Mk;
  yG = 1;
  var e = UU(), t = DU(), n = bte(), r = FU(), i = Lbe(), o = WU(), s = 200;
  function u(f, p, m) {
    var v = -1, y = t, S = f.length, E = !0, w = [], _ = w;
    if (m)
      E = !1, y = n;
    else if (S >= s) {
      var O = p ? null : i(f);
      if (O)
        return o(O);
      E = !1, y = r, _ = new e();
    } else
      _ = p ? [] : w;
    e:
      for (; ++v < S; ) {
        var D = f[v], P = p ? p(D) : D;
        if (D = m || D !== 0 ? D : 0, E && P === P) {
          for (var M = _.length; M--; )
            if (_[M] === P)
              continue e;
          p && _.push(P), w.push(D);
        } else y(_, P, m) || (_ !== w && _.push(P), w.push(D));
      }
    return w;
  }
  return Mk = u, Mk;
}
var jk, bG;
function CD() {
  if (bG) return jk;
  bG = 1;
  var e = Gv(), t = Bl();
  function n(r) {
    return t(r) && e(r);
  }
  return jk = n, jk;
}
var Lk, xG;
function kbe() {
  if (xG) return Lk;
  xG = 1;
  var e = Rx(), t = J1(), n = xte(), r = CD(), i = t(function(o) {
    return n(e(o, 1, r, !0));
  });
  return Lk = i, Lk;
}
var zbe = kbe();
const Bbe = /* @__PURE__ */ Hn(zbe);
var kk, SG;
function E3() {
  if (SG) return kk;
  SG = 1;
  var e = UU(), t = DU(), n = bte(), r = Tx(), i = M1(), o = FU(), s = 200;
  function u(f, p, m, v) {
    var y = -1, S = t, E = !0, w = f.length, _ = [], O = p.length;
    if (!w)
      return _;
    m && (p = r(p, i(m))), v ? (S = n, E = !1) : p.length >= s && (S = o, E = !1, p = new e(p));
    e:
      for (; ++y < w; ) {
        var D = f[y], P = m == null ? D : m(D);
        if (D = v || D !== 0 ? D : 0, E && P === P) {
          for (var M = O; M--; )
            if (p[M] === P)
              continue e;
          _.push(D);
        } else S(p, P, v) || _.push(D);
      }
    return _;
  }
  return kk = u, kk;
}
var zk, wG;
function Vbe() {
  if (wG) return zk;
  wG = 1;
  var e = E3(), t = J1(), n = CD(), r = t(function(i, o) {
    return n(i) ? e(i, o) : [];
  });
  return zk = r, zk;
}
var Ube = Vbe();
const Ste = /* @__PURE__ */ Hn(Ube);
function Fbe(e, t) {
  const n = e.getCanvasIds();
  for (let r = 0; r < n.length; r += 1)
    if (nn.normalisedUrlsMatch(n[r], t))
      return !0;
  return !1;
}
function wte(e) {
  return e.parentNode === void 0 ? [] : e.parentNode.parentNode === void 0 ? [e.parentNode.id] : [...wte(e.parentNode), e.parentNode.id];
}
function Tte(e, t) {
  return e.reduce((n, r) => {
    const i = [];
    i.push(...n);
    const o = t.reduce(
      (u, f) => u || Fbe(r.data, f),
      !1
    ), s = r.nodes.length > 0 ? Tte(r.nodes, t) : [];
    return i.push(...s), (o || s.length > 0) && i.push({
      containsVisibleCanvas: o,
      descendantsContainVisibleCanvas: s.length > 0,
      id: r.id,
      leaf: r.nodes.length === 0,
      parentIds: wte(r)
    }), i;
  }, []);
}
const _3 = Qe(
  [
    U1,
    ku
  ],
  (e, t) => t.length === 0 || !e ? [] : Tte(e.nodes, t)
), C3 = Qe(
  [
    _3
  ],
  (e) => e.map((t) => t.id)
), Wbe = Qe(
  [
    _3
  ],
  (e) => e.reduce(
    (t, n) => n.leaf || !n.descendantsContainVisibleCanvas ? t : [...t, n.id],
    []
  )
), Hbe = Qe(
  [
    _3
  ],
  (e) => e.reduce(
    (t, n) => n.containsVisibleCanvas ? [...t, n] : t,
    []
  )
);
function Mv(e, { companionWindowId: t }, n) {
  const r = ju(e, { companionWindowId: t });
  return r.tocNodes ? Object.keys(r.tocNodes).reduce(
    (i, o) => r.tocNodes[o].expanded === n ? [...i, o] : i,
    []
  ) : [];
}
function Ete(e, { companionWindowId: t, windowId: n }) {
  const r = Wbe(e, { companionWindowId: t, windowId: n }), i = Mv(e, { companionWindowId: t }, !0), o = Mv(e, { companionWindowId: t }, !1);
  return Ste(Bbe(i, r), ...o);
}
function _te(e, { ...t }) {
  const n = Hbe(e, { ...t }), r = Mv(e, t, !1);
  if (n && n.length > 0) {
    for (let i = 0; i < n[0].parentIds.length; i += 1)
      if (r.indexOf(n[0].parentIds[i]) !== -1)
        return n[0].parentIds[i];
    return n[0].id;
  }
  return null;
}
const R3 = Qe(
  [
    U1
  ],
  (e) => e && e.nodes && e.nodes.length > 0 ? "tableOfContents" : "item"
), Cte = Qe(
  [
    Yd,
    Ho
  ],
  (e, t) => e ? t(e).imageResources : []
), O3 = Qe(
  [
    (e) => fo(e).layers,
    (e, { windowId: t }) => t
  ],
  (e, t) => e && e[t] || Io
), A3 = Qe(
  [
    O3,
    (e, { canvasId: t }) => t
  ],
  (e, t) => e[t]
), Rte = Qe(
  [
    Cte,
    A3
  ],
  (e, t) => t ? e.sort((r, i) => t[r.id] && t[r.id].index !== void 0 && t[i.id] && t[i.id].index !== void 0 ? t[r.id].index - t[i.id].index : t[r.id] && t[r.id].index !== void 0 ? -1 : t[i.id] && t[i.id].index !== void 0 ? 1 : 0) : e
), Ote = Qe(
  [
    ku,
    O3
  ],
  (e, t) => e.reduce((n, r) => (n[r] = t[r], n), {})
), RD = Qe(
  [
    Dn
  ],
  ({ auth: { serviceProfiles: e = [] } = {} }) => e
), e_ = (e) => fo(e).accessTokens || qs, t_ = (e) => fo(e).auth || qs, Ate = Qe(
  [
    Ul,
    Px,
    Zv,
    RD,
    t_,
    Ho,
    (e, { iiifResources: t }) => t
  ],
  (e, t = {}, n = {}, r, i, o, s) => {
    let u = s;
    if ((!u || u.length === 0) && !e || (e && (u = vn(e.map((p) => {
      const m = o(p), v = m.imageResources;
      return YU(v).map((S) => {
        const E = GU(S.getServices())[0], w = t[E.id];
        if (w && w.json)
          return { ...w.json, options: {} };
        const _ = n[E.id];
        return _ && _.json ? { ..._.json, options: {} } : E;
      }).concat(m.videoResources).concat(m.audioResources).concat(m.textResources);
    }))), !u || u.length == 0)) return Io;
    const f = u.map((p) => {
      let m;
      const v = nn.getServices(p), y = ste(p), S = vn(y.map((w) => nn.getServices(w))), E = v.concat(S);
      for (const w of r) {
        const _ = E.filter(
          (O) => w.profile === O.getProfile()
        );
        for (const O of _) {
          m = O;
          const D = w.external ? "external" : O == null ? void 0 : O.id;
          if (!i[D] || i[D].isFetching || i[D].ok)
            return O;
        }
      }
      return m;
    });
    return Object.values(f.reduce((p, m) => {
      if (!m) return p;
      const y = r.filter((S) => S.external).find((S) => S.profile === m.getProfile()) ? "external" : m.id;
      return p[y] || (p[y] = m), p;
    }, {}));
  }
), qbe = "text/plain", $be = "us-ascii", Bk = (e, t) => t.some((n) => n instanceof RegExp ? n.test(e) : n === e), Gbe = /* @__PURE__ */ new Set([
  "https:",
  "http:",
  "file:"
]), Ybe = (e) => {
  try {
    const { protocol: t } = new URL(e);
    return t.endsWith(":") && !t.includes(".") && !Gbe.has(t);
  } catch {
    return !1;
  }
}, Xbe = (e, { stripHash: t }) => {
  var v;
  const n = /^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$/.exec(e);
  if (!n)
    throw new Error(`Invalid URL: ${e}`);
  let { type: r, data: i, hash: o } = n.groups;
  const s = r.split(";");
  o = t ? "" : o;
  let u = !1;
  s[s.length - 1] === "base64" && (s.pop(), u = !0);
  const f = ((v = s.shift()) == null ? void 0 : v.toLowerCase()) ?? "", m = [
    ...s.map((y) => {
      let [S, E = ""] = y.split("=").map((w) => w.trim());
      return S === "charset" && (E = E.toLowerCase(), E === $be) ? "" : `${S}${E ? `=${E}` : ""}`;
    }).filter(Boolean)
  ];
  return u && m.push("base64"), (m.length > 0 || f && f !== qbe) && m.unshift(f), `data:${m.join(";")},${u ? i.trim() : i}${o ? `#${o}` : ""}`;
};
function W0(e, t) {
  if (t = {
    defaultProtocol: "http",
    normalizeProtocol: !0,
    forceHttp: !1,
    forceHttps: !1,
    stripAuthentication: !0,
    stripHash: !1,
    stripTextFragment: !0,
    stripWWW: !0,
    removeQueryParameters: [/^utm_\w+/i],
    removeTrailingSlash: !0,
    removeSingleSlash: !0,
    removeDirectoryIndex: !1,
    removeExplicitPort: !1,
    sortQueryParameters: !0,
    ...t
  }, typeof t.defaultProtocol == "string" && !t.defaultProtocol.endsWith(":") && (t.defaultProtocol = `${t.defaultProtocol}:`), e = e.trim(), /^data:/i.test(e))
    return Xbe(e, t);
  if (Ybe(e))
    return e;
  const n = e.startsWith("//");
  !n && /^\.*\//.test(e) || (e = e.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, t.defaultProtocol));
  const i = new URL(e);
  if (t.forceHttp && t.forceHttps)
    throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
  if (t.forceHttp && i.protocol === "https:" && (i.protocol = "http:"), t.forceHttps && i.protocol === "http:" && (i.protocol = "https:"), t.stripAuthentication && (i.username = "", i.password = ""), t.stripHash ? i.hash = "" : t.stripTextFragment && (i.hash = i.hash.replace(/#?:~:text.*?$/i, "")), i.pathname) {
    const s = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g;
    let u = 0, f = "";
    for (; ; ) {
      const m = s.exec(i.pathname);
      if (!m)
        break;
      const v = m[0], y = m.index, S = i.pathname.slice(u, y);
      f += S.replace(/\/{2,}/g, "/"), f += v, u = y + v.length;
    }
    const p = i.pathname.slice(u, i.pathname.length);
    f += p.replace(/\/{2,}/g, "/"), i.pathname = f;
  }
  if (i.pathname)
    try {
      i.pathname = decodeURI(i.pathname).replace(/\\/g, "%5C");
    } catch {
    }
  if (t.removeDirectoryIndex === !0 && (t.removeDirectoryIndex = [/^index\.[a-z]+$/]), Array.isArray(t.removeDirectoryIndex) && t.removeDirectoryIndex.length > 0) {
    let s = i.pathname.split("/");
    const u = s[s.length - 1];
    Bk(u, t.removeDirectoryIndex) && (s = s.slice(0, -1), i.pathname = s.slice(1).join("/") + "/");
  }
  if (i.hostname && (i.hostname = i.hostname.replace(/\.$/, ""), t.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(i.hostname) && (i.hostname = i.hostname.replace(/^www\./, ""))), Array.isArray(t.removeQueryParameters))
    for (const s of [...i.searchParams.keys()])
      Bk(s, t.removeQueryParameters) && i.searchParams.delete(s);
  if (!Array.isArray(t.keepQueryParameters) && t.removeQueryParameters === !0 && (i.search = ""), Array.isArray(t.keepQueryParameters) && t.keepQueryParameters.length > 0)
    for (const s of [...i.searchParams.keys()])
      Bk(s, t.keepQueryParameters) || i.searchParams.delete(s);
  if (t.sortQueryParameters) {
    i.searchParams.sort();
    try {
      i.search = decodeURIComponent(i.search);
    } catch {
    }
  }
  t.removeTrailingSlash && (i.pathname = i.pathname.replace(/\/$/, "")), t.removeExplicitPort && i.port && (i.port = "");
  const o = e;
  return e = i.toString(), !t.removeSingleSlash && i.pathname === "/" && !o.endsWith("/") && i.hash === "" && (e = e.replace(/\/$/, "")), (t.removeTrailingSlash || i.pathname === "/") && i.hash === "" && t.removeSingleSlash && (e = e.replace(/\/$/, "")), n && !t.normalizeProtocol && (e = e.replace(/^http:\/\//, "//")), t.stripProtocol && (e = e.replace(/^(?:https?:)?\/\//, "")), e;
}
class OD {
  /**
   * @param {Array} canvases - Array of Manifesto:Canvas objects to create a
   * world from.
   */
  constructor(t, n, r = "left-to-right") {
    this.canvases = t, this.layers = n, this.viewingDirection = r, this._canvasDimensions = null;
  }
  /** */
  get canvasIds() {
    return this.canvases.map((t) => t.id);
  }
  /** */
  get canvasDimensions() {
    if (this._canvasDimensions)
      return this._canvasDimensions;
    const [t, n] = this.canvasDirection, r = Math.min(...n === 0 ? this.canvases.map((p) => p.getHeight()) : this.canvases.map((p) => p.getWidth()));
    let i = 0, o = 0;
    const s = this.canvases.reduce((p, m) => {
      let v = 0, y = 0;
      return Number.isNaN(m.aspectRatio) || (n === 0 ? (v = r, y = Math.floor(r * m.aspectRatio)) : (y = r, v = Math.floor(r * (1 / m.aspectRatio)))), p.push({
        canvas: m,
        height: v,
        width: y,
        x: i,
        y: o
      }), i += t * y, o += n * v, p;
    }, []), u = n === 0 ? r : Math.abs(o), f = t === 0 ? r : Math.abs(i);
    return this._canvasDimensions = s.reduce((p, m) => (p.push({
      ...m,
      x: t === -1 ? m.x + f - m.width : m.x,
      y: n === -1 ? m.y + u - m.height : m.y
    }), p), []), this._canvasDimensions;
  }
  /**
   * contentResourceToWorldCoordinates - calculates the contentResource coordinates
   * respective to the world.
   */
  contentResourceToWorldCoordinates(t) {
    const n = this.canvases.findIndex((p) => p.imageResources.find((m) => m.id === t.id)), r = this.canvases[n];
    if (!r) return [];
    const [i, o, s, u] = this.canvasToWorldCoordinates(r.id), f = r.onFragment(t.id);
    return f ? [
      i + f[0],
      o + f[1],
      f[2],
      f[3]
    ] : [
      i,
      o,
      s,
      u
    ];
  }
  /** */
  canvasToWorldCoordinates(t) {
    const n = this.canvasDimensions.find((r) => r.canvas.id === t);
    return [
      n.x,
      n.y,
      n.width,
      n.height
    ];
  }
  /** */
  get canvasDirection() {
    switch (this.viewingDirection) {
      case "left-to-right":
        return [1, 0];
      case "right-to-left":
        return [-1, 0];
      case "top-to-bottom":
        return [0, 1];
      case "bottom-to-top":
        return [0, -1];
      default:
        return [1, 0];
    }
  }
  /** Get the IIIF content resource for an image */
  contentResource(t) {
    const n = this.canvases.find((r) => r.imageServiceIds.some((i) => i && t && W0(i, { stripAuthentication: !1 }) === W0(t, { stripAuthentication: !1 })));
    if (n)
      return n.imageResources.find((r) => W0(r.getServices()[0].id, { stripAuthentication: !1 }) === W0(t, { stripAuthentication: !1 }));
  }
  /** @private */
  getLayerMetadata(t) {
    const n = this.canvases.find((u) => u.imageResources.find((f) => f.id === t.id));
    if (!n) return;
    const r = n.imageResources.findIndex((u) => u.id === t.id), i = n.imageResources.find((u) => u.id === t.id), o = this.layers && this.layers[n.canvas.id], s = o && o[t.id] || {};
    return {
      index: r,
      opacity: 1,
      total: n.imageResources.length,
      visibility: !!i.preferred,
      ...s
    };
  }
  /** */
  layerOpacityOfImageResource(t) {
    const n = this.getLayerMetadata(t);
    return n ? n.visibility ? n.opacity : 0 : 1;
  }
  /** */
  layerIndexOfImageResource(t) {
    const n = this.getLayerMetadata(t);
    if (n)
      return n.index;
  }
  /**
   * offsetByCanvas - calculates the offset for a given canvas target. Currently
   * assumes a horrizontal only layout.
   */
  offsetByCanvas(t) {
    const n = this.canvasToWorldCoordinates(t);
    return {
      x: n[0],
      y: n[1]
    };
  }
  /** */
  hasDimensions() {
    return this.canvasDimensions.length > 0;
  }
  /**
   * worldBounds - calculates the "World" bounds. World in this case is canvases
   * lined up horizontally starting from left to right.
   */
  worldBounds() {
    const t = Math.max(0, ...this.canvasDimensions.map((r) => r.x + r.width)), n = Math.max(0, ...this.canvasDimensions.map((r) => r.y + r.height));
    return [
      0,
      0,
      t,
      n
    ];
  }
  /** */
  canvasAtPoint(t) {
    const n = this.canvasDimensions.find((r) => r.x <= t.x && t.x <= r.x + r.width && r.y <= t.y && t.y <= r.y + r.height);
    return n && n.canvas;
  }
}
const D3 = Qe(
  [
    Ul,
    Ote,
    Ix,
    Ho
  ],
  (e, t, n, r) => new OD(
    e.map(r),
    t,
    n
  )
), Zbe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EMPTY_ARRAY: Io,
  EMPTY_OBJECT: qs,
  getAccessTokens: e_,
  getAllowedWindowViewTypes: ite,
  getAnnotationResourcesByMotivation: wD,
  getAnnotationResourcesByMotivationForCanvas: fte,
  getAnnotations: SD,
  getAuth: t_,
  getAuthProfiles: RD,
  getCanvas: Yd,
  getCanvasDescription: lte,
  getCanvasForAnnotation: vte,
  getCanvasGrouping: g3,
  getCanvasGroupings: H1,
  getCanvasIndex: u3,
  getCanvasLabel: yg,
  getCanvasLayers: Cte,
  getCanvases: Fa,
  getCatalog: Pee,
  getCompanionAreaVisibility: jee,
  getCompanionWindow: ju,
  getCompanionWindowIdsForPosition: gD,
  getCompanionWindowLocale: KU,
  getCompanionWindows: k1,
  getCompanionWindowsForContent: ox,
  getCompanionWindowsForPosition: e3,
  getConfig: Dn,
  getContainerId: Du,
  getCurrentCanvas: Vl,
  getCurrentCanvasWorld: D3,
  getDefaultSidebarVariant: R3,
  getDestructuredMetadata: l3,
  getElasticLayout: vD,
  getExpandedNodeIds: Ete,
  getExportableState: kee,
  getFocusedWindowId: f3,
  getFullScreenEnabled: Cbe,
  getIiifThumbnailOpts: Vee,
  getLanguagesFromConfigWithCurrent: t3,
  getLatestError: tte,
  getLayers: A3,
  getLayersForVisibleCanvases: Ote,
  getLayersForWindow: O3,
  getLocale: z1,
  getManifest: Va,
  getManifestAutocompleteService: ete,
  getManifestDescription: Zee,
  getManifestError: Fee,
  getManifestHomepage: qee,
  getManifestLocale: Oi,
  getManifestLogo: o3,
  getManifestMetadata: Qee,
  getManifestProviderName: Wee,
  getManifestRelated: Gee,
  getManifestRelatedContent: Ebe,
  getManifestRenderings: $ee,
  getManifestSearchService: Dx,
  getManifestSeeAlso: a3,
  getManifestStatus: ax,
  getManifestSummary: Kee,
  getManifestThumbnail: Xee,
  getManifestTitle: Lu,
  getManifestUrl: B1,
  getManifestoInstance: nr,
  getManifests: L1,
  getManuallyExpandedNodeIds: Mv,
  getMaximizedWindowsIds: rte,
  getMetadataLocales: Jee,
  getMiradorCanvasWrapper: Ho,
  getMiradorManifestWrapper: XU,
  getNextCanvasGrouping: q1,
  getNextSearchId: pte,
  getNodeIdToScrollTo: _te,
  getPresentAnnotationsOnSelectedCanvases: Y1,
  getPreviousCanvasGrouping: $1,
  getProviderLogo: Hee,
  getRequestsConfig: zee,
  getRequiredStatement: Yee,
  getResourceAnnotationForSearchHit: T3,
  getResourceAnnotationLabel: mte,
  getRights: s3,
  getSearchAnnotationsForCompanionWindow: Q1,
  getSearchAnnotationsForWindow: ED,
  getSearchForWindow: TD,
  getSearchIsFetching: b3,
  getSearchNumTotal: x3,
  getSearchQuery: K1,
  getSelectedAnnotationId: X1,
  getSelectedAnnotationsOnCanvases: Pbe,
  getSelectedContentSearchAnnotationIds: _D,
  getSequence: Gd,
  getSequenceBehaviors: V1,
  getSequenceTreeStructure: U1,
  getSequenceViewingDirection: Ix,
  getSequenceViewingHint: d3,
  getSequences: c3,
  getShowZoomControlsConfig: n3,
  getSortedLayers: Rte,
  getSortedSearchAnnotationsForCompanionWindow: w3,
  getSortedSearchHitsForCompanionWindow: S3,
  getTheme: r3,
  getThemeDirection: Ax,
  getThemeIds: i3,
  getThumbnailFactory: mD,
  getThumbnailNavigationPosition: QU,
  getThumbnailsConfig: Bee,
  getViewer: hD,
  getVisibleCanvasAudioResources: xD,
  getVisibleCanvasCaptions: G1,
  getVisibleCanvasIds: ku,
  getVisibleCanvasNonTiledResources: cte,
  getVisibleCanvasTextResources: yD,
  getVisibleCanvasVideoResources: bD,
  getVisibleCanvases: Ul,
  getVisibleNodeIds: C3,
  getWindow: Wn,
  getWindowConfig: fa,
  getWindowDraggability: ote,
  getWindowIds: Xv,
  getWindowManifests: ZU,
  getWindowTitles: nte,
  getWindowViewType: Nv,
  getWindows: vg,
  getWorkspace: Do,
  getWorkspaceType: F1,
  isFocused: p3,
  miradorSlice: fo,
  selectCompanionWindowDimensions: Lee,
  selectCurrentAuthServices: Ate,
  selectInfoResponse: v3,
  selectInfoResponses: Px,
  selectProbeResponse: ute,
  selectProbeResponses: Zv,
  sortSearchAnnotationsByCanvasOrder: gte
}, Symbol.toStringTag, { value: "Module" })), Dte = {
  content: null,
  position: null
};
function Ite(e, t, n = Dte) {
  const r = `cw-${zs()}`;
  return {
    id: r,
    payload: {
      ...n,
      ...t,
      id: r,
      windowId: e
    },
    type: Ce.ADD_COMPANION_WINDOW,
    windowId: e
  };
}
function I3(e, t, n = Dte) {
  return (r, i) => {
    const o = i(), { position: s } = t, u = s === "left" && gD(o, { position: s, windowId: e })[0];
    r(u ? Nx(e, u, t) : Ite(e, t, n));
  };
}
function Nx(e, t, n) {
  return {
    id: t,
    payload: n,
    type: Ce.UPDATE_COMPANION_WINDOW,
    windowId: e
  };
}
function Pte(e, t) {
  return {
    id: t,
    type: Ce.REMOVE_COMPANION_WINDOW,
    windowId: e
  };
}
function Nte(e, t, n) {
  return (r, i) => {
    const o = i(), s = Mv(o, { companionWindowId: t }, !1), u = Mv(o, { companionWindowId: t }, !0), f = C3(o, { id: t, windowId: e }), p = s.indexOf(n) !== -1 || u.indexOf(n) === -1 && f.indexOf(n) === -1;
    return r({
      id: t,
      payload: {
        [n]: {
          expanded: p
        }
      },
      type: Ce.TOGGLE_TOC_NODE,
      windowId: e
    });
  };
}
function Mte(e, t, n) {
  return (r, i) => {
    const o = i(), s = Mv(o, { companionWindowId: t }, !0), u = {};
    return s.forEach((f) => {
      u[f] = { expanded: !1 };
    }), n.forEach((f) => {
      u[f] = { expanded: !0 };
    }), r({
      id: t,
      payload: u,
      type: Ce.TOGGLE_TOC_NODE,
      windowId: e
    });
  };
}
function jte(e) {
  return { config: e, type: Ce.IMPORT_CONFIG };
}
function Kbe(e) {
  return { config: e, type: Ce.SET_CONFIG };
}
function P3(e) {
  return { config: e, type: Ce.UPDATE_CONFIG };
}
function Lte(e) {
  return { state: {
    ...e,
    workspace: {
      ...e.workspace,
      id: zs()
    }
  }, type: Ce.IMPORT_MIRADOR_STATE };
}
function kte(e) {
  return {
    id: `error-${zs()}`,
    message: e,
    type: Ce.ADD_ERROR
  };
}
function zte(e) {
  return { id: e, type: Ce.REMOVE_ERROR };
}
function n_(e, t = !1) {
  return {
    pan: t,
    type: Ce.FOCUS_WINDOW,
    windowId: e
  };
}
function r_({ companionWindows: e, manifest: t, ...n }) {
  return (r, i) => {
    const { config: o, workspace: { windowIds: s = [] } } = fo(i()), u = s.length, f = n.id || `window-${zs()}`, p = `cw-${zs()}`, m = [
      {
        content: "thumbnailNavigation",
        default: !0,
        id: p,
        position: n.thumbnailNavigationPosition || o.thumbnailNavigation.defaultPosition,
        windowId: f
      },
      ...(e || []).map((S, E) => ({ ...S, id: `cw-${zs()}` }))
    ];
    (n.sideBarPanel || o.window.defaultSideBarPanel || o.window.sideBarPanel) && m.unshift(
      {
        content: n.sideBarPanel || n.defaultSearchQuery && "search" || o.window.defaultSideBarPanel || o.window.sideBarPanel,
        default: !0,
        id: `cw-${zs()}`,
        position: "left",
        windowId: f
      }
    );
    const v = {
      canvasId: void 0,
      collectionIndex: 0,
      companionAreaOpen: !0,
      companionWindowIds: m.map((S) => S.id),
      draggingEnabled: !0,
      highlightAllAnnotations: o.window.highlightAllAnnotations || !1,
      id: f,
      manifestId: null,
      maximized: !1,
      rangeId: null,
      rotation: null,
      selectedAnnotations: {},
      sideBarOpen: o.window.sideBarOpenByDefault !== void 0 ? o.window.sideBarOpenByDefault || !!n.defaultSearchQuery : o.window.sideBarOpen || !!n.defaultSearchQuery,
      sideBarPanel: n.sideBarPanel || o.window.defaultSideBarPanel || o.window.sideBarPanel,
      thumbnailNavigationId: p
    }, y = {
      ...o.window.elastic || { height: 400, width: 480 },
      x: 200 + (Math.floor(u / 10) * 50 + u * 30 % 300),
      y: 200 + u * 50 % 300
    };
    r({
      companionWindows: m,
      elasticLayout: y,
      manifest: t,
      type: Ce.ADD_WINDOW,
      window: { ...v, ...n }
    });
  };
}
function Po(e, t) {
  return {
    id: e,
    payload: t,
    type: Ce.UPDATE_WINDOW
  };
}
function Bte(e) {
  return { type: Ce.MAXIMIZE_WINDOW, windowId: e };
}
function Vte(e) {
  return { type: Ce.MINIMIZE_WINDOW, windowId: e };
}
function Ute(e, t) {
  return {
    id: e,
    payload: { companionAreaOpen: t },
    type: Ce.UPDATE_WINDOW
  };
}
function N3(e) {
  return {
    type: Ce.REMOVE_WINDOW,
    windowId: e
  };
}
function Fte(e) {
  return { type: Ce.TOGGLE_WINDOW_SIDE_BAR, windowId: e };
}
function Wte(e, t) {
  return (n, r) => {
    const { windows: i } = r(), { thumbnailNavigationId: o } = i[e];
    n({
      id: o,
      payload: { position: t },
      type: Ce.UPDATE_COMPANION_WINDOW
    });
  };
}
function M3(e, t) {
  return {
    type: Ce.SET_WINDOW_VIEW_TYPE,
    viewType: t,
    windowId: e
  };
}
function i_(e, t = [], n) {
  return {
    collectionPath: t,
    manifestId: e,
    type: Ce.SHOW_COLLECTION_DIALOG,
    windowId: n
  };
}
function Hte(e) {
  return {
    type: Ce.HIDE_COLLECTION_DIALOG,
    windowId: e
  };
}
function qte(e, t) {
  return {
    manifestId: e,
    properties: t,
    type: Ce.REQUEST_MANIFEST
  };
}
function AD(e, t) {
  return {
    manifestId: e,
    manifestJson: t,
    type: Ce.RECEIVE_MANIFEST
  };
}
function $te(e, t) {
  return {
    error: t,
    manifestId: e,
    type: Ce.RECEIVE_MANIFEST_FAILURE
  };
}
function DD(e, t) {
  return qte(e, { ...t, isFetching: !0 });
}
function Qbe(e) {
  return { manifestId: e, type: Ce.REMOVE_MANIFEST };
}
function Gte(e, t, n) {
  return {
    imageResource: t,
    infoId: e,
    type: Ce.REQUEST_INFO_RESPONSE,
    windowId: n
  };
}
function Yte(e, t, n, r) {
  return {
    infoId: e,
    infoJson: t,
    ok: n,
    tokenServiceId: r,
    type: Ce.RECEIVE_INFO_RESPONSE
  };
}
function Xte(e, t, n, r, i) {
  return {
    infoId: e,
    infoJson: t,
    ok: n,
    tokenServiceId: r,
    type: Ce.RECEIVE_DEGRADED_INFO_RESPONSE,
    windowId: i
  };
}
function Zte(e, t, n) {
  return {
    error: t,
    infoId: e,
    tokenServiceId: n,
    type: Ce.RECEIVE_INFO_RESPONSE_FAILURE
  };
}
function Kte({ imageId: e, imageResource: t, windowId: n }) {
  const r = t && t.getServices()[0], i = e || r.id;
  return Gte(i, r, n);
}
function Jbe(e) {
  return { infoId: e, type: Ce.REMOVE_INFO_RESPONSE };
}
function Iu(e, t, n = void 0, r = {}) {
  return ((i, o) => {
    const s = o(), { preserveViewport: u } = Dn(s).osdConfig;
    let f = n;
    f || (f = (g3(s, { canvasId: t, windowId: e }) || []).map((m) => m.id)), i({
      ...r,
      canvasId: t,
      preserveViewport: u,
      type: Ce.SET_CANVAS,
      visibleCanvases: f,
      windowId: e
    });
  });
}
function ID(e) {
  return ((t, n) => {
    const r = n(), i = q1(r, { windowId: e }), o = (i || []).map((s) => s.id);
    i && t(Iu(e, o[0], o));
  });
}
function PD(e) {
  return ((t, n) => {
    const r = n(), i = $1(r, { windowId: e }), o = (i || []).map((s) => s.id);
    i && t(Iu(e, o[0], o));
  });
}
function j3(e, t) {
  return {
    payload: t,
    type: Ce.UPDATE_VIEWPORT,
    windowId: e
  };
}
function Qte(e) {
  return { config: e, type: Ce.UPDATE_WORKSPACE };
}
function Jte(e) {
  return { showZoomControls: e, type: Ce.TOGGLE_ZOOM_CONTROLS };
}
function ene(e) {
  return { layout: e, type: Ce.UPDATE_WORKSPACE_MOSAIC_LAYOUT };
}
function ND(e) {
  return { isWorkspaceAddVisible: e, type: Ce.SET_WORKSPACE_ADD_VISIBILITY };
}
function L3({ x: e, y: t }) {
  return {
    payload: {
      position: {
        x: e,
        y: t
      }
    },
    type: Ce.SET_WORKSPACE_VIEWPORT_POSITION
  };
}
function tne({ width: e, height: t }) {
  return {
    payload: {
      position: {
        height: t,
        width: e
      }
    },
    type: Ce.SET_WORKSPACE_VIEWPORT_POSITION
  };
}
function nne() {
  return {
    type: Ce.TOGGLE_DRAGGING
  };
}
function k3(e, t) {
  return {
    canvasId: t,
    type: Ce.REQUEST_CANVAS_ANNOTATIONS,
    windowId: e
  };
}
function U2(e, t) {
  return {
    annotationId: t,
    targetId: e,
    type: Ce.REQUEST_ANNOTATION
  };
}
function z3(e, t, n) {
  return {
    annotationId: t,
    annotationJson: n,
    targetId: e,
    type: Ce.RECEIVE_ANNOTATION
  };
}
function rne(e, t, n) {
  return {
    annotationId: t,
    error: n,
    targetId: e,
    type: Ce.RECEIVE_ANNOTATION_FAILURE
  };
}
function Kv(e, t) {
  return {
    annotationId: t,
    type: Ce.SELECT_ANNOTATION,
    windowId: e
  };
}
function B3(e, t) {
  return {
    annotationId: t,
    type: Ce.DESELECT_ANNOTATION,
    windowId: e
  };
}
function ine(e) {
  return {
    type: Ce.TOGGLE_ANNOTATION_DISPLAY,
    windowId: e
  };
}
function V3(e, t) {
  return {
    annotationIds: t,
    type: Ce.HOVER_ANNOTATION,
    windowId: e
  };
}
function U3(e, t, n = void 0) {
  return {
    id: t,
    profile: n,
    type: Ce.ADD_AUTHENTICATION_REQUEST,
    windowId: e
  };
}
function MD(e, t, n) {
  return {
    id: e,
    tokenServiceId: t,
    type: Ce.RESOLVE_AUTHENTICATION_REQUEST,
    ...n
  };
}
function F3(e, t) {
  return {
    authId: t,
    serviceId: e,
    type: Ce.REQUEST_ACCESS_TOKEN
  };
}
function one(e, t, n) {
  return {
    authId: e,
    json: n,
    serviceId: t,
    type: Ce.RECEIVE_ACCESS_TOKEN
  };
}
function ane(e, t, n) {
  return {
    authId: e,
    error: n,
    serviceId: t,
    type: Ce.RECEIVE_ACCESS_TOKEN_FAILURE
  };
}
function sne(e, t, n) {
  return n.accessToken ? one(e, t, n) : ane(e, t, n);
}
function W3({ authServiceId: e, tokenServiceId: t }) {
  return {
    id: e,
    tokenServiceId: t,
    type: Ce.RESET_AUTHENTICATION_STATE
  };
}
function H3(e, t) {
  return {
    payload: t,
    type: Ce.UPDATE_ELASTIC_WINDOW_LAYOUT,
    windowId: e
  };
}
function lne(e, t, n, r) {
  return {
    companionWindowId: t,
    query: r,
    searchId: n,
    type: Ce.REQUEST_SEARCH,
    windowId: e
  };
}
function cne(e, t, n, r) {
  return {
    companionWindowId: t,
    searchId: n,
    searchJson: r,
    type: Ce.RECEIVE_SEARCH,
    windowId: e
  };
}
function une(e, t, n, r) {
  return {
    companionWindowId: t,
    error: r,
    searchId: n,
    type: Ce.RECEIVE_SEARCH_FAILURE,
    windowId: e
  };
}
function dne(e, t) {
  return {
    companionWindowId: t,
    type: Ce.REMOVE_SEARCH,
    windowId: e
  };
}
function o_(e, t, n, r) {
  return lne(e, t, n, r);
}
function fne(e, t, n) {
  return {
    annotationIds: n,
    companionWindowId: t,
    type: Ce.SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS,
    windowId: e
  };
}
function pne(e, t, n) {
  return {
    canvasId: t,
    payload: n,
    type: Ce.UPDATE_LAYERS,
    windowId: e
  };
}
function q3(e, t = void 0, n) {
  return {
    manifestId: e,
    manifestJson: t,
    payload: n,
    type: Ce.ADD_RESOURCE
  };
}
function hne(e) {
  return {
    manifestId: e,
    type: Ce.REMOVE_RESOURCE
  };
}
function gne(e, t, n) {
  return {
    probeId: e,
    resource: t,
    type: Ce.REQUEST_PROBE_RESPONSE,
    windowId: n
  };
}
function mne(e, t, n, r) {
  return {
    ok: n && t.status < 400,
    probeId: e,
    probeJson: t,
    tokenServiceId: r,
    type: Ce.RECEIVE_PROBE_RESPONSE
  };
}
function vne(e, t, n, r, i) {
  return {
    ok: n,
    probeId: e,
    probeJson: t,
    tokenServiceId: r,
    type: Ce.RECEIVE_DEGRADED_PROBE_RESPONSE,
    windowId: i
  };
}
function yne(e, t, n) {
  return {
    error: t,
    probeId: e,
    tokenServiceId: n,
    type: Ce.RECEIVE_PROBE_RESPONSE_FAILURE
  };
}
function bne({ resource: e, resourceId: t, windowId: n }) {
  const r = e && rp(e), i = t || r.id;
  return gne(i, e, n);
}
function e0e(e) {
  return { probeId: e, type: Ce.REMOVE_PROBE_RESPONSE };
}
const t0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionTypes: Ce,
  addAuthenticationRequest: U3,
  addCompanionWindow: Ite,
  addError: kte,
  addOrUpdateCompanionWindow: I3,
  addResource: q3,
  addWindow: r_,
  deselectAnnotation: B3,
  expandNodes: Mte,
  fetchInfoResponse: Kte,
  fetchManifest: DD,
  fetchProbeResponse: bne,
  fetchSearch: o_,
  focusWindow: n_,
  hideCollectionDialog: Hte,
  hoverAnnotation: V3,
  importConfig: jte,
  importMiradorState: Lte,
  maximizeWindow: Bte,
  minimizeWindow: Vte,
  receiveAccessToken: one,
  receiveAccessTokenFailure: ane,
  receiveAnnotation: z3,
  receiveAnnotationFailure: rne,
  receiveDegradedInfoResponse: Xte,
  receiveDegradedProbeResponse: vne,
  receiveInfoResponse: Yte,
  receiveInfoResponseFailure: Zte,
  receiveManifest: AD,
  receiveManifestFailure: $te,
  receiveProbeResponse: mne,
  receiveProbeResponseFailure: yne,
  receiveSearch: cne,
  receiveSearchFailure: une,
  removeCompanionWindow: Pte,
  removeError: zte,
  removeInfoResponse: Jbe,
  removeManifest: Qbe,
  removeProbeResponse: e0e,
  removeResource: hne,
  removeSearch: dne,
  removeWindow: N3,
  requestAccessToken: F3,
  requestAnnotation: U2,
  requestCanvasAnnotations: k3,
  requestInfoResponse: Gte,
  requestManifest: qte,
  requestProbeResponse: gne,
  requestSearch: lne,
  resetAuthenticationState: W3,
  resolveAccessTokenRequest: sne,
  resolveAuthenticationRequest: MD,
  selectAnnotation: Kv,
  setCanvas: Iu,
  setCompanionAreaOpen: Ute,
  setConfig: Kbe,
  setContentSearchCurrentAnnotation: fne,
  setNextCanvas: ID,
  setPreviousCanvas: PD,
  setWindowThumbnailPosition: Wte,
  setWindowViewType: M3,
  setWorkspaceAddVisibility: ND,
  setWorkspaceViewportDimensions: tne,
  setWorkspaceViewportPosition: L3,
  showCollectionDialog: i_,
  toggleAnnotationDisplay: ine,
  toggleDraggingEnabled: nne,
  toggleNode: Nte,
  toggleWindowSideBar: Fte,
  toggleZoomControls: Jte,
  updateCompanionWindow: Nx,
  updateConfig: P3,
  updateElasticWindowLayout: H3,
  updateLayers: pne,
  updateViewport: j3,
  updateWindow: Po,
  updateWorkspace: Qte,
  updateWorkspaceMosaicLayout: ene
}, Symbol.toStringTag, { value: "Module" }));
function xne(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = xne(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function yt() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = xne(e)) && (r && (r += " "), r += t);
  return r;
}
var n0e = {};
function r0e(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function Sne(e, t, n, r) {
  const i = e[t];
  if (i == null || !Number.isInteger(i)) {
    const o = r0e(i);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${o}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function wne(e, t, ...n) {
  return e[t] === void 0 ? null : Sne(e, t, ...n);
}
function F2() {
  return null;
}
wne.isRequired = Sne;
F2.isRequired = F2;
const jD = n0e.NODE_ENV === "production" ? F2 : wne;
var i0e = {};
function Wa(e, t) {
  return i0e.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function Ft(e, t, n = void 0) {
  const r = {};
  for (const i in e) {
    const o = e[i];
    let s = "", u = !0;
    for (let f = 0; f < o.length; f += 1) {
      const p = o[f];
      p && (s += (u === !0 ? "" : " ") + t(p), u = !1, n && n[p] && (s += " " + n[p]));
    }
    r[i] = s;
  }
  return r;
}
function Ud(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function z0(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
var n1 = {};
function $3(e, t = 0, n = 1) {
  return n1.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), z0(e, t, n);
}
function o0e(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n1.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function sg(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return sg(o0e(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(n1.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Ud(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(n1.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Ud(10, i));
  } else
    r = r.split(",");
  return r = r.map((o) => parseFloat(o)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const a0e = (e) => {
  const t = sg(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, _E = (e, t) => {
  try {
    return a0e(e);
  } catch {
    return t && n1.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function LD(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, o) => o < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function Tne(e) {
  e = sg(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, o = r * Math.min(i, 1 - i), s = (p, m = (p + n / 30) % 12) => i - o * Math.max(Math.min(m - 3, 9 - m, 1), -1);
  let u = "rgb";
  const f = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (u += "a", f.push(t[3])), LD({
    type: u,
    values: f
  });
}
function W2(e) {
  e = sg(e);
  let t = e.type === "hsl" || e.type === "hsla" ? sg(Tne(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function TG(e, t) {
  const n = W2(e), r = W2(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Cn(e, t) {
  return e = sg(e), t = $3(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, LD(e);
}
function NR(e, t, n) {
  try {
    return Cn(e, t);
  } catch {
    return e;
  }
}
function jv(e, t) {
  if (e = sg(e), t = $3(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return LD(e);
}
function Kr(e, t, n) {
  try {
    return jv(e, t);
  } catch {
    return e;
  }
}
function Lv(e, t) {
  if (e = sg(e), t = $3(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return LD(e);
}
function Qr(e, t, n) {
  try {
    return Lv(e, t);
  } catch {
    return e;
  }
}
function Ene(e, t = 0.15) {
  return W2(e) > 0.5 ? jv(e, t) : Lv(e, t);
}
function MR(e, t, n) {
  try {
    return Ene(e, t);
  } catch {
    return e;
  }
}
var s0e = {};
function Ke(e) {
  if (typeof e != "string")
    throw new Error(s0e.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Ud(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var jR = { exports: {} }, Vr = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EG;
function l0e() {
  if (EG) return Vr;
  EG = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.view_transition"), S = Symbol.for("react.client.reference");
  function E(w) {
    if (typeof w == "object" && w !== null) {
      var _ = w.$$typeof;
      switch (_) {
        case e:
          switch (w = w.type, w) {
            case n:
            case i:
            case r:
            case f:
            case p:
            case y:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case v:
                case m:
                  return w;
                case o:
                  return w;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return Vr.ContextConsumer = o, Vr.ContextProvider = s, Vr.Element = e, Vr.ForwardRef = u, Vr.Fragment = n, Vr.Lazy = v, Vr.Memo = m, Vr.Portal = t, Vr.Profiler = i, Vr.StrictMode = r, Vr.Suspense = f, Vr.SuspenseList = p, Vr.isContextConsumer = function(w) {
    return E(w) === o;
  }, Vr.isContextProvider = function(w) {
    return E(w) === s;
  }, Vr.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, Vr.isForwardRef = function(w) {
    return E(w) === u;
  }, Vr.isFragment = function(w) {
    return E(w) === n;
  }, Vr.isLazy = function(w) {
    return E(w) === v;
  }, Vr.isMemo = function(w) {
    return E(w) === m;
  }, Vr.isPortal = function(w) {
    return E(w) === t;
  }, Vr.isProfiler = function(w) {
    return E(w) === i;
  }, Vr.isStrictMode = function(w) {
    return E(w) === r;
  }, Vr.isSuspense = function(w) {
    return E(w) === f;
  }, Vr.isSuspenseList = function(w) {
    return E(w) === p;
  }, Vr.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === i || w === r || w === f || w === p || typeof w == "object" && w !== null && (w.$$typeof === v || w.$$typeof === m || w.$$typeof === s || w.$$typeof === o || w.$$typeof === u || w.$$typeof === S || w.getModuleId !== void 0);
  }, Vr.typeOf = E, Vr;
}
var Ur = {}, _G;
function c0e() {
  if (_G) return Ur;
  _G = 1;
  var e = {};
  /**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(_) {
      if (typeof _ == "object" && _ !== null) {
        var O = _.$$typeof;
        switch (O) {
          case n:
            switch (_ = _.type, _) {
              case i:
              case s:
              case o:
              case m:
              case v:
              case E:
                return _;
              default:
                switch (_ = _ && _.$$typeof, _) {
                  case f:
                  case p:
                  case S:
                  case y:
                    return _;
                  case u:
                    return _;
                  default:
                    return O;
                }
            }
          case r:
            return O;
        }
      }
    }
    var n = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), u = Symbol.for("react.consumer"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), E = Symbol.for("react.view_transition"), w = Symbol.for("react.client.reference");
    Ur.ContextConsumer = u, Ur.ContextProvider = f, Ur.Element = n, Ur.ForwardRef = p, Ur.Fragment = i, Ur.Lazy = S, Ur.Memo = y, Ur.Portal = r, Ur.Profiler = s, Ur.StrictMode = o, Ur.Suspense = m, Ur.SuspenseList = v, Ur.isContextConsumer = function(_) {
      return t(_) === u;
    }, Ur.isContextProvider = function(_) {
      return t(_) === f;
    }, Ur.isElement = function(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === n;
    }, Ur.isForwardRef = function(_) {
      return t(_) === p;
    }, Ur.isFragment = function(_) {
      return t(_) === i;
    }, Ur.isLazy = function(_) {
      return t(_) === S;
    }, Ur.isMemo = function(_) {
      return t(_) === y;
    }, Ur.isPortal = function(_) {
      return t(_) === r;
    }, Ur.isProfiler = function(_) {
      return t(_) === s;
    }, Ur.isStrictMode = function(_) {
      return t(_) === o;
    }, Ur.isSuspense = function(_) {
      return t(_) === m;
    }, Ur.isSuspenseList = function(_) {
      return t(_) === v;
    }, Ur.isValidElementType = function(_) {
      return typeof _ == "string" || typeof _ == "function" || _ === i || _ === s || _ === o || _ === m || _ === v || typeof _ == "object" && _ !== null && (_.$$typeof === S || _.$$typeof === y || _.$$typeof === f || _.$$typeof === u || _.$$typeof === p || _.$$typeof === w || _.getModuleId !== void 0);
    }, Ur.typeOf = t;
  })(), Ur;
}
var CG;
function u0e() {
  if (CG) return jR.exports;
  CG = 1;
  var e = {};
  return e.NODE_ENV === "production" ? jR.exports = /* @__PURE__ */ l0e() : jR.exports = /* @__PURE__ */ c0e(), jR.exports;
}
var iA = /* @__PURE__ */ u0e();
function Id(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function _ne(e) {
  if (/* @__PURE__ */ $.isValidElement(e) || iA.isValidElementType(e) || !Id(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = _ne(e[n]);
  }), t;
}
function Ua(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Id(e) && Id(t) && Object.keys(t).forEach((i) => {
    /* @__PURE__ */ $.isValidElement(t[i]) || iA.isValidElementType(t[i]) ? r[i] = t[i] : Id(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Id(e[i]) ? r[i] = Ua(e[i], t[i], n) : n.clone ? r[i] = Id(t[i]) ? _ne(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
function LE(e, t) {
  return t ? Ua(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
var d0e = {};
const bg = d0e.NODE_ENV !== "production" ? c.oneOfType([c.number, c.string, c.object, c.array]) : {};
var RG = {};
function OG(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var s, u;
    const o = /min-width:\s*([0-9.]+)/;
    return +(((s = r.match(o)) == null ? void 0 : s[1]) || 0) - +(((u = i.match(o)) == null ? void 0 : u[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const o = t[i];
    return delete r[i], r[i] = o, r;
  }, {
    ...t
  }) : t;
}
function f0e(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function p0e(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (RG.NODE_ENV !== "production")
      throw new Error(RG.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : Ud(18, `(${t})`));
    return null;
  }
  const [, r, i] = n, o = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(o);
}
function h0e(e) {
  const t = (o, s) => o.replace("@media", s ? `@container ${s}` : "@container");
  function n(o, s) {
    o.up = (...u) => t(e.breakpoints.up(...u), s), o.down = (...u) => t(e.breakpoints.down(...u), s), o.between = (...u) => t(e.breakpoints.between(...u), s), o.only = (...u) => t(e.breakpoints.only(...u), s), o.not = (...u) => {
      const f = t(e.breakpoints.not(...u), s);
      return f.includes("not all and") ? f.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : f;
    };
  }
  const r = {}, i = (o) => (n(r, o), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const kD = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, AG = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${kD[e]}px)`
}, g0e = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : kD[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function cp(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const o = r.breakpoints || AG;
    return t.reduce((s, u, f) => (s[o.up(o.keys[f])] = n(t[f]), s), {});
  }
  if (typeof t == "object") {
    const o = r.breakpoints || AG;
    return Object.keys(t).reduce((s, u) => {
      if (f0e(o.keys, u)) {
        const f = p0e(r.containerQueries ? r : g0e, u);
        f && (s[f] = n(t[u], u));
      } else if (Object.keys(o.values || kD).includes(u)) {
        const f = o.up(u);
        s[f] = n(t[u], u);
      } else {
        const f = u;
        s[f] = t[f];
      }
      return s;
    }, {});
  }
  return n(t);
}
function m0e(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const o = e.up(i);
    return r[o] = {}, r;
  }, {})) || {};
}
function DG(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
var v0e = {};
function Qh(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, o) => i && i[o] ? i[o] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function oA(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = Qh(e, n) || r, t && (i = t(i, r, e)), i;
}
function Ji(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, o = (s) => {
    if (s[t] == null)
      return null;
    const u = s[t], f = s.theme, p = Qh(f, r) || {};
    return cp(s, u, (v) => {
      let y = oA(p, i, v);
      return v === y && typeof v == "string" && (y = oA(p, i, `${t}${v === "default" ? "" : Ke(v)}`, v)), n === !1 ? y : {
        [n]: y
      };
    });
  };
  return o.propTypes = v0e.NODE_ENV !== "production" ? {
    [t]: bg
  } : {}, o.filterProps = [t], o;
}
function y0e(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
var Z0 = {};
const b0e = {
  m: "margin",
  p: "padding"
}, x0e = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, IG = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, S0e = y0e((e) => {
  if (e.length > 2)
    if (IG[e])
      e = IG[e];
    else
      return [e];
  const [t, n] = e.split(""), r = b0e[t], i = x0e[n] || "";
  return Array.isArray(i) ? i.map((o) => r + o) : [r + i];
}), zD = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], BD = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], w0e = [...zD, ...BD];
function a_(e, t, n, r) {
  const i = Qh(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (o) => typeof o == "string" ? o : (Z0.NODE_ENV !== "production" && typeof o != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${o}.`), typeof i == "string" ? `calc(${o} * ${i})` : i * o) : Array.isArray(i) ? (o) => {
    if (typeof o == "string")
      return o;
    const s = Math.abs(o);
    Z0.NODE_ENV !== "production" && (Number.isInteger(s) ? s > i.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${s} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const u = i[s];
    return o >= 0 ? u : typeof u == "number" ? -u : `-${u}`;
  } : typeof i == "function" ? i : (Z0.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function G3(e) {
  return a_(e, "spacing", 8, "spacing");
}
function s_(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function T0e(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = s_(t, n), r), {});
}
function E0e(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = S0e(n), o = T0e(i, r), s = e[n];
  return cp(e, s, o);
}
function Cne(e, t) {
  const n = G3(e.theme);
  return Object.keys(e).map((r) => E0e(e, t, r, n)).reduce(LE, {});
}
function ki(e) {
  return Cne(e, zD);
}
ki.propTypes = Z0.NODE_ENV !== "production" ? zD.reduce((e, t) => (e[t] = bg, e), {}) : {};
ki.filterProps = zD;
function zi(e) {
  return Cne(e, BD);
}
zi.propTypes = Z0.NODE_ENV !== "production" ? BD.reduce((e, t) => (e[t] = bg, e), {}) : {};
zi.filterProps = BD;
Z0.NODE_ENV !== "production" && w0e.reduce((e, t) => (e[t] = bg, e), {});
var _0e = {};
function VD(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((o) => {
    r[o] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, o) => t[o] ? LE(i, t[o](r)) : i, {});
  return n.propTypes = _0e.NODE_ENV !== "production" ? e.reduce((r, i) => Object.assign(r, i.propTypes), {}) : {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
var C0e = {};
function wc(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Bc(e, t) {
  return Ji({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const R0e = Bc("border", wc), O0e = Bc("borderTop", wc), A0e = Bc("borderRight", wc), D0e = Bc("borderBottom", wc), I0e = Bc("borderLeft", wc), P0e = Bc("borderColor"), N0e = Bc("borderTopColor"), M0e = Bc("borderRightColor"), j0e = Bc("borderBottomColor"), L0e = Bc("borderLeftColor"), k0e = Bc("outline", wc), z0e = Bc("outlineColor"), UD = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = a_(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: s_(t, r)
    });
    return cp(e, e.borderRadius, n);
  }
  return null;
};
UD.propTypes = C0e.NODE_ENV !== "production" ? {
  borderRadius: bg
} : {};
UD.filterProps = ["borderRadius"];
VD(R0e, O0e, A0e, D0e, I0e, P0e, N0e, M0e, j0e, L0e, UD, k0e, z0e);
var Y3 = {};
const FD = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = a_(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: s_(t, r)
    });
    return cp(e, e.gap, n);
  }
  return null;
};
FD.propTypes = Y3.NODE_ENV !== "production" ? {
  gap: bg
} : {};
FD.filterProps = ["gap"];
const WD = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = a_(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: s_(t, r)
    });
    return cp(e, e.columnGap, n);
  }
  return null;
};
WD.propTypes = Y3.NODE_ENV !== "production" ? {
  columnGap: bg
} : {};
WD.filterProps = ["columnGap"];
const HD = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = a_(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: s_(t, r)
    });
    return cp(e, e.rowGap, n);
  }
  return null;
};
HD.propTypes = Y3.NODE_ENV !== "production" ? {
  rowGap: bg
} : {};
HD.filterProps = ["rowGap"];
const B0e = Ji({
  prop: "gridColumn"
}), V0e = Ji({
  prop: "gridRow"
}), U0e = Ji({
  prop: "gridAutoFlow"
}), F0e = Ji({
  prop: "gridAutoColumns"
}), W0e = Ji({
  prop: "gridAutoRows"
}), H0e = Ji({
  prop: "gridTemplateColumns"
}), q0e = Ji({
  prop: "gridTemplateRows"
}), $0e = Ji({
  prop: "gridTemplateAreas"
}), G0e = Ji({
  prop: "gridArea"
});
VD(FD, WD, HD, B0e, V0e, U0e, F0e, W0e, H0e, q0e, $0e, G0e);
function K0(e, t) {
  return t === "grey" ? t : e;
}
const Y0e = Ji({
  prop: "color",
  themeKey: "palette",
  transform: K0
}), X0e = Ji({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: K0
}), Z0e = Ji({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: K0
});
VD(Y0e, X0e, Z0e);
function Al(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const K0e = Ji({
  prop: "width",
  transform: Al
}), X3 = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, o, s, u, f;
      const r = ((s = (o = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : o.values) == null ? void 0 : s[n]) || kD[n];
      return r ? ((f = (u = e.theme) == null ? void 0 : u.breakpoints) == null ? void 0 : f.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: Al(n)
      };
    };
    return cp(e, e.maxWidth, t);
  }
  return null;
};
X3.filterProps = ["maxWidth"];
const Q0e = Ji({
  prop: "minWidth",
  transform: Al
}), J0e = Ji({
  prop: "height",
  transform: Al
}), exe = Ji({
  prop: "maxHeight",
  transform: Al
}), txe = Ji({
  prop: "minHeight",
  transform: Al
});
Ji({
  prop: "size",
  cssProperty: "width",
  transform: Al
});
Ji({
  prop: "size",
  cssProperty: "height",
  transform: Al
});
const nxe = Ji({
  prop: "boxSizing"
});
VD(K0e, X3, Q0e, J0e, exe, txe, nxe);
const l_ = {
  // borders
  border: {
    themeKey: "borders",
    transform: wc
  },
  borderTop: {
    themeKey: "borders",
    transform: wc
  },
  borderRight: {
    themeKey: "borders",
    transform: wc
  },
  borderBottom: {
    themeKey: "borders",
    transform: wc
  },
  borderLeft: {
    themeKey: "borders",
    transform: wc
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: wc
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: UD
  },
  // palette
  color: {
    themeKey: "palette",
    transform: K0
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: K0
  },
  backgroundColor: {
    themeKey: "palette",
    transform: K0
  },
  // spacing
  p: {
    style: zi
  },
  pt: {
    style: zi
  },
  pr: {
    style: zi
  },
  pb: {
    style: zi
  },
  pl: {
    style: zi
  },
  px: {
    style: zi
  },
  py: {
    style: zi
  },
  padding: {
    style: zi
  },
  paddingTop: {
    style: zi
  },
  paddingRight: {
    style: zi
  },
  paddingBottom: {
    style: zi
  },
  paddingLeft: {
    style: zi
  },
  paddingX: {
    style: zi
  },
  paddingY: {
    style: zi
  },
  paddingInline: {
    style: zi
  },
  paddingInlineStart: {
    style: zi
  },
  paddingInlineEnd: {
    style: zi
  },
  paddingBlock: {
    style: zi
  },
  paddingBlockStart: {
    style: zi
  },
  paddingBlockEnd: {
    style: zi
  },
  m: {
    style: ki
  },
  mt: {
    style: ki
  },
  mr: {
    style: ki
  },
  mb: {
    style: ki
  },
  ml: {
    style: ki
  },
  mx: {
    style: ki
  },
  my: {
    style: ki
  },
  margin: {
    style: ki
  },
  marginTop: {
    style: ki
  },
  marginRight: {
    style: ki
  },
  marginBottom: {
    style: ki
  },
  marginLeft: {
    style: ki
  },
  marginX: {
    style: ki
  },
  marginY: {
    style: ki
  },
  marginInline: {
    style: ki
  },
  marginInlineStart: {
    style: ki
  },
  marginInlineEnd: {
    style: ki
  },
  marginBlock: {
    style: ki
  },
  marginBlockStart: {
    style: ki
  },
  marginBlockEnd: {
    style: ki
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: FD
  },
  rowGap: {
    style: HD
  },
  columnGap: {
    style: WD
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Al
  },
  maxWidth: {
    style: X3
  },
  minWidth: {
    transform: Al
  },
  height: {
    transform: Al
  },
  maxHeight: {
    transform: Al
  },
  minHeight: {
    transform: Al
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function rxe(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function ixe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function oxe() {
  function e(n, r, i, o) {
    const s = {
      [n]: r,
      theme: i
    }, u = o[n];
    if (!u)
      return {
        [n]: r
      };
    const {
      cssProperty: f = n,
      themeKey: p,
      transform: m,
      style: v
    } = u;
    if (r == null)
      return null;
    if (p === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const y = Qh(i, p) || {};
    return v ? v(s) : cp(s, r, (E) => {
      let w = oA(y, m, E);
      return E === w && typeof E == "string" && (w = oA(y, m, `${n}${E === "default" ? "" : Ke(E)}`, E)), f === !1 ? w : {
        [f]: w
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {},
      nested: o
    } = n || {};
    if (!r)
      return null;
    const s = i.unstable_sxConfig ?? l_;
    function u(f) {
      let p = f;
      if (typeof f == "function")
        p = f(i);
      else if (typeof f != "object")
        return f;
      if (!p)
        return null;
      const m = m0e(i.breakpoints), v = Object.keys(m);
      let y = m;
      return Object.keys(p).forEach((S) => {
        const E = ixe(p[S], i);
        if (E != null)
          if (typeof E == "object")
            if (s[S])
              y = LE(y, e(S, E, i, s));
            else {
              const w = cp({
                theme: i
              }, E, (_) => ({
                [S]: _
              }));
              rxe(w, E) ? y[S] = t({
                sx: E,
                theme: i,
                nested: !0
              }) : y = LE(y, w);
            }
          else
            y = LE(y, e(S, E, i, s));
      }), !o && i.modularCssLayers ? {
        "@layer sx": OG(i, DG(v, y))
      } : OG(i, DG(v, y));
    }
    return Array.isArray(r) ? r.map(u) : u(r);
  }
  return t;
}
const kv = oxe();
kv.filterProps = ["sx"];
const axe = (e) => {
  var r;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) ?? l_;
  return Object.keys(e).forEach((i) => {
    n[i] ? t.systemProps[i] = e[i] : t.otherProps[i] = e[i];
  }), t;
};
function Z3(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: i
  } = axe(n);
  let o;
  return Array.isArray(t) ? o = [r, ...t] : typeof t == "function" ? o = (...s) => {
    const u = t(...s);
    return Id(u) ? {
      ...r,
      ...u
    } : r;
  } : o = {
    ...r,
    ...t
  }, {
    ...i,
    sx: o
  };
}
const r1 = {
  black: "#000",
  white: "#fff"
}, Rne = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, T0 = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, E0 = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, KT = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, _0 = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, C0 = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, R0 = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
var LR = {};
function One() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: r1.white,
      default: r1.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const sxe = One();
function Ane() {
  return {
    text: {
      primary: r1.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: r1.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const PG = Ane();
function NG(e, t, n, r) {
  const i = r.light || r, o = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Lv(e.main, i) : t === "dark" && (e.dark = jv(e.main, o)));
}
function lxe(e = "light") {
  return e === "dark" ? {
    main: _0[200],
    light: _0[50],
    dark: _0[400]
  } : {
    main: _0[700],
    light: _0[400],
    dark: _0[800]
  };
}
function cxe(e = "light") {
  return e === "dark" ? {
    main: T0[200],
    light: T0[50],
    dark: T0[400]
  } : {
    main: T0[500],
    light: T0[300],
    dark: T0[700]
  };
}
function uxe(e = "light") {
  return e === "dark" ? {
    main: E0[500],
    light: E0[300],
    dark: E0[700]
  } : {
    main: E0[700],
    light: E0[400],
    dark: E0[800]
  };
}
function dxe(e = "light") {
  return e === "dark" ? {
    main: C0[400],
    light: C0[300],
    dark: C0[700]
  } : {
    main: C0[700],
    light: C0[500],
    dark: C0[900]
  };
}
function fxe(e = "light") {
  return e === "dark" ? {
    main: R0[400],
    light: R0[300],
    dark: R0[700]
  } : {
    main: R0[800],
    light: R0[500],
    dark: R0[900]
  };
}
function pxe(e = "light") {
  return e === "dark" ? {
    main: KT[400],
    light: KT[300],
    dark: KT[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: KT[500],
    dark: KT[900]
  };
}
function K3(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, o = e.primary || lxe(t), s = e.secondary || cxe(t), u = e.error || uxe(t), f = e.info || dxe(t), p = e.success || fxe(t), m = e.warning || pxe(t);
  function v(w) {
    const _ = TG(w, PG.text.primary) >= n ? PG.text.primary : sxe.text.primary;
    if (LR.NODE_ENV !== "production") {
      const O = TG(w, _);
      O < 3 && console.error([`MUI: The contrast ratio of ${O}:1 for ${_} on ${w}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return _;
  }
  const y = ({
    color: w,
    name: _,
    mainShade: O = 500,
    lightShade: D = 300,
    darkShade: P = 700
  }) => {
    if (w = {
      ...w
    }, !w.main && w[O] && (w.main = w[O]), !w.hasOwnProperty("main"))
      throw new Error(LR.NODE_ENV !== "production" ? `MUI: The color${_ ? ` (${_})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${O}\` property.` : Ud(11, _ ? ` (${_})` : "", O));
    if (typeof w.main != "string")
      throw new Error(LR.NODE_ENV !== "production" ? `MUI: The color${_ ? ` (${_})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(w.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Ud(12, _ ? ` (${_})` : "", JSON.stringify(w.main)));
    return NG(w, "light", D, r), NG(w, "dark", P, r), w.contrastText || (w.contrastText = v(w.main)), w;
  };
  let S;
  return t === "light" ? S = One() : t === "dark" && (S = Ane()), LR.NODE_ENV !== "production" && (S || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Ua({
    // A collection of common colors.
    common: {
      ...r1
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: y({
      color: o,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: y({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: y({
      color: u,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: y({
      color: m,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: y({
      color: f,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: y({
      color: p,
      name: "success"
    }),
    // The grey colors.
    grey: Rne,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: v,
    // Generate a rich color object.
    augmentColor: y,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...S
  }, i);
}
function hxe(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var gxe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function mxe(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var vxe = /[A-Z]|^ms/g, yxe = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Dne = function(t) {
  return t.charCodeAt(1) === 45;
}, MG = function(t) {
  return t != null && typeof t != "boolean";
}, Vk = /* @__PURE__ */ mxe(function(e) {
  return Dne(e) ? e : e.replace(vxe, "-$&").toLowerCase();
}), jG = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(yxe, function(r, i, o) {
          return Jh = {
            name: i,
            styles: o,
            next: Jh
          }, i;
        });
  }
  return gxe[t] !== 1 && !Dne(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function aA(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Jh = {
          name: i.name,
          styles: i.styles,
          next: Jh
        }, i.name;
      var o = n;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Jh = {
              name: s.name,
              styles: s.styles,
              next: Jh
            }, s = s.next;
        var u = o.styles + ";";
        return u;
      }
      return bxe(e, t, n);
    }
  }
  var f = n;
  return f;
}
function bxe(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += aA(e, t, n[i]) + ";";
  else
    for (var o in n) {
      var s = n[o];
      if (typeof s != "object") {
        var u = s;
        MG(u) && (r += Vk(o) + ":" + jG(o, u) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && t == null)
        for (var f = 0; f < s.length; f++)
          MG(s[f]) && (r += Vk(o) + ":" + jG(o, s[f]) + ";");
      else {
        var p = aA(e, t, s);
        switch (o) {
          case "animation":
          case "animationName": {
            r += Vk(o) + ":" + p + ";";
            break;
          }
          default:
            r += o + "{" + p + "}";
        }
      }
    }
  return r;
}
var LG = /label:\s*([^\s;{]+)\s*(;|$)/g, Jh;
function xxe(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Jh = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    r = !1, i += aA(n, t, o);
  else {
    var s = o;
    i += s[0];
  }
  for (var u = 1; u < e.length; u++)
    if (i += aA(n, t, e[u]), r) {
      var f = o;
      i += f[u];
    }
  LG.lastIndex = 0;
  for (var p = "", m; (m = LG.exec(i)) !== null; )
    p += "-" + m[1];
  var v = hxe(i) + p;
  return {
    name: v,
    styles: i,
    next: Jh
  };
}
function Sxe(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function wxe(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Txe = /* @__PURE__ */ (function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var o;
      r.tags.length === 0 ? r.insertionPoint ? o = r.insertionPoint.nextSibling : r.prepend ? o = r.container.firstChild : o = r.before : o = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, o), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(wxe(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = Sxe(i);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
})(), ja = "-ms-", sA = "-moz-", vr = "-webkit-", Ine = "comm", Q3 = "rule", J3 = "decl", Exe = "@import", Pne = "@keyframes", _xe = "@layer", Cxe = Math.abs, qD = String.fromCharCode, Rxe = Object.assign;
function Oxe(e, t) {
  return la(e, 0) ^ 45 ? (((t << 2 ^ la(e, 0)) << 2 ^ la(e, 1)) << 2 ^ la(e, 2)) << 2 ^ la(e, 3) : 0;
}
function Nne(e) {
  return e.trim();
}
function Axe(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function yr(e, t, n) {
  return e.replace(t, n);
}
function H2(e, t) {
  return e.indexOf(t);
}
function la(e, t) {
  return e.charCodeAt(t) | 0;
}
function i1(e, t, n) {
  return e.slice(t, n);
}
function Dd(e) {
  return e.length;
}
function eF(e) {
  return e.length;
}
function kR(e, t) {
  return t.push(e), e;
}
function Dxe(e, t) {
  return e.map(t).join("");
}
var $D = 1, sx = 1, Mne = 0, Fs = 0, lo = 0, Mx = "";
function GD(e, t, n, r, i, o, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: $D, column: sx, length: s, return: "" };
}
function QT(e, t) {
  return Rxe(GD("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Ixe() {
  return lo;
}
function Pxe() {
  return lo = Fs > 0 ? la(Mx, --Fs) : 0, sx--, lo === 10 && (sx = 1, $D--), lo;
}
function Pl() {
  return lo = Fs < Mne ? la(Mx, Fs++) : 0, sx++, lo === 10 && (sx = 1, $D++), lo;
}
function kd() {
  return la(Mx, Fs);
}
function RO() {
  return Fs;
}
function c_(e, t) {
  return i1(Mx, e, t);
}
function o1(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function jne(e) {
  return $D = sx = 1, Mne = Dd(Mx = e), Fs = 0, [];
}
function Lne(e) {
  return Mx = "", e;
}
function OO(e) {
  return Nne(c_(Fs - 1, q2(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Nxe(e) {
  for (; (lo = kd()) && lo < 33; )
    Pl();
  return o1(e) > 2 || o1(lo) > 3 ? "" : " ";
}
function Mxe(e, t) {
  for (; --t && Pl() && !(lo < 48 || lo > 102 || lo > 57 && lo < 65 || lo > 70 && lo < 97); )
    ;
  return c_(e, RO() + (t < 6 && kd() == 32 && Pl() == 32));
}
function q2(e) {
  for (; Pl(); )
    switch (lo) {
      // ] ) " '
      case e:
        return Fs;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && q2(lo);
        break;
      // (
      case 40:
        e === 41 && q2(e);
        break;
      // \
      case 92:
        Pl();
        break;
    }
  return Fs;
}
function jxe(e, t) {
  for (; Pl() && e + lo !== 57; )
    if (e + lo === 84 && kd() === 47)
      break;
  return "/*" + c_(t, Fs - 1) + "*" + qD(e === 47 ? e : Pl());
}
function Lxe(e) {
  for (; !o1(kd()); )
    Pl();
  return c_(e, Fs);
}
function kxe(e) {
  return Lne(AO("", null, null, null, [""], e = jne(e), 0, [0], e));
}
function AO(e, t, n, r, i, o, s, u, f) {
  for (var p = 0, m = 0, v = s, y = 0, S = 0, E = 0, w = 1, _ = 1, O = 1, D = 0, P = "", M = i, N = o, k = r, U = P; _; )
    switch (E = D, D = Pl()) {
      // (
      case 40:
        if (E != 108 && la(U, v - 1) == 58) {
          H2(U += yr(OO(D), "&", "&\f"), "&\f") != -1 && (O = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        U += OO(D);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        U += Nxe(E);
        break;
      // \
      case 92:
        U += Mxe(RO() - 1, 7);
        continue;
      // /
      case 47:
        switch (kd()) {
          case 42:
          case 47:
            kR(zxe(jxe(Pl(), RO()), t, n), f);
            break;
          default:
            U += "/";
        }
        break;
      // {
      case 123 * w:
        u[p++] = Dd(U) * O;
      // } ; \0
      case 125 * w:
      case 59:
      case 0:
        switch (D) {
          // \0 }
          case 0:
          case 125:
            _ = 0;
          // ;
          case 59 + m:
            O == -1 && (U = yr(U, /\f/g, "")), S > 0 && Dd(U) - v && kR(S > 32 ? zG(U + ";", r, n, v - 1) : zG(yr(U, " ", "") + ";", r, n, v - 2), f);
            break;
          // @ ;
          case 59:
            U += ";";
          // { rule/at-rule
          default:
            if (kR(k = kG(U, t, n, p, m, i, u, P, M = [], N = [], v), o), D === 123)
              if (m === 0)
                AO(U, t, k, k, M, o, v, u, N);
              else
                switch (y === 99 && la(U, 3) === 110 ? 100 : y) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    AO(e, k, k, r && kR(kG(e, k, k, 0, 0, i, u, P, i, M = [], v), N), i, N, v, u, r ? M : N);
                    break;
                  default:
                    AO(U, k, k, k, [""], N, 0, u, N);
                }
        }
        p = m = S = 0, w = O = 1, P = U = "", v = s;
        break;
      // :
      case 58:
        v = 1 + Dd(U), S = E;
      default:
        if (w < 1) {
          if (D == 123)
            --w;
          else if (D == 125 && w++ == 0 && Pxe() == 125)
            continue;
        }
        switch (U += qD(D), D * w) {
          // &
          case 38:
            O = m > 0 ? 1 : (U += "\f", -1);
            break;
          // ,
          case 44:
            u[p++] = (Dd(U) - 1) * O, O = 1;
            break;
          // @
          case 64:
            kd() === 45 && (U += OO(Pl())), y = kd(), m = v = Dd(P = U += Lxe(RO())), D++;
            break;
          // -
          case 45:
            E === 45 && Dd(U) == 2 && (w = 0);
        }
    }
  return o;
}
function kG(e, t, n, r, i, o, s, u, f, p, m) {
  for (var v = i - 1, y = i === 0 ? o : [""], S = eF(y), E = 0, w = 0, _ = 0; E < r; ++E)
    for (var O = 0, D = i1(e, v + 1, v = Cxe(w = s[E])), P = e; O < S; ++O)
      (P = Nne(w > 0 ? y[O] + " " + D : yr(D, /&\f/g, y[O]))) && (f[_++] = P);
  return GD(e, t, n, i === 0 ? Q3 : u, f, p, m);
}
function zxe(e, t, n) {
  return GD(e, t, n, Ine, qD(Ixe()), i1(e, 2, -2), 0);
}
function zG(e, t, n, r) {
  return GD(e, t, n, J3, i1(e, 0, r), i1(e, r + 1, -1), r);
}
function Q0(e, t) {
  for (var n = "", r = eF(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function Bxe(e, t, n, r) {
  switch (e.type) {
    case _xe:
      if (e.children.length) break;
    case Exe:
    case J3:
      return e.return = e.return || e.value;
    case Ine:
      return "";
    case Pne:
      return e.return = e.value + "{" + Q0(e.children, r) + "}";
    case Q3:
      e.value = e.props.join(",");
  }
  return Dd(n = Q0(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function Vxe(e) {
  var t = eF(e);
  return function(n, r, i, o) {
    for (var s = "", u = 0; u < t; u++)
      s += e[u](n, r, i, o) || "";
    return s;
  };
}
function Uxe(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var Fxe = function(t, n, r) {
  for (var i = 0, o = 0; i = o, o = kd(), i === 38 && o === 12 && (n[r] = 1), !o1(o); )
    Pl();
  return c_(t, Fs);
}, Wxe = function(t, n) {
  var r = -1, i = 44;
  do
    switch (o1(i)) {
      case 0:
        i === 38 && kd() === 12 && (n[r] = 1), t[r] += Fxe(Fs - 1, n, r);
        break;
      case 2:
        t[r] += OO(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = kd() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      // fallthrough
      default:
        t[r] += qD(i);
    }
  while (i = Pl());
  return t;
}, Hxe = function(t, n) {
  return Lne(Wxe(jne(t), n));
}, BG = /* @__PURE__ */ new WeakMap(), qxe = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !BG.get(r)) && !i) {
      BG.set(t, !0);
      for (var o = [], s = Hxe(n, o), u = r.props, f = 0, p = 0; f < s.length; f++)
        for (var m = 0; m < u.length; m++, p++)
          t.props[p] = o[f] ? s[f].replace(/&\f/g, u[m]) : u[m] + " " + s[f];
    }
  }
}, $xe = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function kne(e, t) {
  switch (Oxe(e, t)) {
    // color-adjust
    case 5103:
      return vr + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return vr + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return vr + e + sA + e + ja + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return vr + e + ja + e + e;
    // order
    case 6165:
      return vr + e + ja + "flex-" + e + e;
    // align-items
    case 5187:
      return vr + e + yr(e, /(\w+).+(:[^]+)/, vr + "box-$1$2" + ja + "flex-$1$2") + e;
    // align-self
    case 5443:
      return vr + e + ja + "flex-item-" + yr(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return vr + e + ja + "flex-line-pack" + yr(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return vr + e + ja + yr(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return vr + e + ja + yr(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return vr + "box-" + yr(e, "-grow", "") + vr + e + ja + yr(e, "grow", "positive") + e;
    // transition
    case 4554:
      return vr + yr(e, /([^-])(transform)/g, "$1" + vr + "$2") + e;
    // cursor
    case 6187:
      return yr(yr(yr(e, /(zoom-|grab)/, vr + "$1"), /(image-set)/, vr + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return yr(e, /(image-set\([^]*)/, vr + "$1$`$1");
    // justify-content
    case 4968:
      return yr(yr(e, /(.+:)(flex-)?(.*)/, vr + "box-pack:$3" + ja + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + vr + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return yr(e, /(.+)-inline(.+)/, vr + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Dd(e) - 1 - t > 6) switch (la(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (la(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return yr(e, /(.+:)(.+)-([^]+)/, "$1" + vr + "$2-$3$1" + sA + (la(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~H2(e, "stretch") ? kne(yr(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (la(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (la(e, Dd(e) - 3 - (~H2(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return yr(e, ":", ":" + vr) + e;
        // (inline-)?fl(e)x
        case 101:
          return yr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + vr + (la(e, 14) === 45 ? "inline-" : "") + "box$3$1" + vr + "$2$3$1" + ja + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (la(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return vr + e + ja + yr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return vr + e + ja + yr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return vr + e + ja + yr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return vr + e + ja + e + e;
  }
  return e;
}
var Gxe = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case J3:
      t.return = kne(t.value, t.length);
      break;
    case Pne:
      return Q0([QT(t, {
        value: yr(t.value, "@", "@" + vr)
      })], i);
    case Q3:
      if (t.length) return Dxe(t.props, function(o) {
        switch (Axe(o, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return Q0([QT(t, {
              props: [yr(o, /:(read-\w+)/, ":" + sA + "$1")]
            })], i);
          // :placeholder
          case "::placeholder":
            return Q0([QT(t, {
              props: [yr(o, /:(plac\w+)/, ":" + vr + "input-$1")]
            }), QT(t, {
              props: [yr(o, /:(plac\w+)/, ":" + sA + "$1")]
            }), QT(t, {
              props: [yr(o, /:(plac\w+)/, ja + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, Yxe = [Gxe], zne = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(w) {
      var _ = w.getAttribute("data-emotion");
      _.indexOf(" ") !== -1 && (document.head.appendChild(w), w.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || Yxe, o = {}, s, u = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(w) {
      for (var _ = w.getAttribute("data-emotion").split(" "), O = 1; O < _.length; O++)
        o[_[O]] = !0;
      u.push(w);
    }
  );
  var f, p = [qxe, $xe];
  {
    var m, v = [Bxe, Uxe(function(w) {
      m.insert(w);
    })], y = Vxe(p.concat(i, v)), S = function(_) {
      return Q0(kxe(_), y);
    };
    f = function(_, O, D, P) {
      m = D, S(_ ? _ + "{" + O.styles + "}" : O.styles), P && (E.inserted[O.name] = !0);
    };
  }
  var E = {
    key: n,
    sheet: new Txe({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: f
  };
  return E.sheet.hydrate(u), E;
}, Xxe = {};
function Zxe(e, t) {
  const n = Ehe(e, t);
  return Xxe.NODE_ENV !== "production" ? (...r) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((o) => o === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function Kxe(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const VG = [];
function Av(e) {
  return VG[0] = e, xxe(VG);
}
function Qxe(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Bne(e, t, n, r, i) {
  const o = e[t], s = i || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let u;
  const f = o.type;
  return typeof f == "function" && !Qxe(f) && (u = "Did you accidentally use a plain function component for an element instead?"), u !== void 0 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${u} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const xg = Wa(c.element, Bne);
xg.isRequired = Wa(c.element.isRequired, Bne);
function Jxe(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function eSe(e, t, n, r, i) {
  const o = e[t], s = i || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let u;
  return typeof o == "function" && !Jxe(o) && (u = "Did you accidentally provide a plain function component instead?"), u !== void 0 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${u} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Qv = Wa(c.elementType, eSe);
var tSe = {};
const nSe = "exact-prop: ​";
function tF(e) {
  return tSe.NODE_ENV === "production" ? e : {
    ...e,
    [nSe]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function Vne(e, t = "") {
  return e.displayName || e.name || t;
}
function UG(e, t, n) {
  const r = Vne(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function rSe(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Vne(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case iA.ForwardRef:
          return UG(e, e.render, "ForwardRef");
        case iA.Memo:
          return UG(e, e.type, "memo");
        default:
          return;
      }
  }
}
var iSe = {};
function Fd(e, t, n, r, i) {
  if (iSe.NODE_ENV === "production")
    return null;
  const o = e[t], s = i || t;
  return o == null ? null : o && o.nodeType !== 1 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const $s = c.oneOfType([c.func, c.object]);
function FG(...e) {
  return e.reduce((t, n) => n == null ? t : function(...i) {
    t.apply(this, i), n.apply(this, i);
  }, () => {
  });
}
function u_(e, t = 166) {
  let n;
  function r(...i) {
    const o = () => {
      e.apply(this, i);
    };
    clearTimeout(n), n = setTimeout(o, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function J0(e, t) {
  var n, r, i;
  return /* @__PURE__ */ $.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((i = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : i.muiName)
  ) !== -1;
}
function Vi(e) {
  return e && e.ownerDocument || document;
}
function jl(e) {
  return Vi(e).defaultView || window;
}
var oSe = {};
function Une(e, t) {
  if (oSe.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (i) => (o, s, u, f, p, ...m) => {
    const v = p || s, y = n == null ? void 0 : n[v];
    if (y) {
      const S = y(o, s, u, f, p, ...m);
      if (S)
        return S;
    }
    return typeof o[s] < "u" && !o[i] ? new Error(`The prop \`${v}\` of \`${e}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
function $2(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const gs = typeof window < "u" ? $.useLayoutEffect : $.useEffect;
let WG = 0;
function aSe(e) {
  const [t, n] = $.useState(e), r = e || t;
  return $.useEffect(() => {
    t == null && (WG += 1, n(`mui-${WG}`));
  }, [t]), r;
}
const sSe = {
  ...$
}, HG = sSe.useId;
function Jv(e) {
  if (HG !== void 0) {
    const t = HG();
    return e ?? t;
  }
  return aSe(e);
}
var lSe = {};
function nF(e, t, n, r, i) {
  if (lSe.NODE_ENV === "production")
    return null;
  const o = i || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${o}\` is not supported. Please remove it.`) : null;
}
var cSe = {};
function ip({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: i
  } = $.useRef(e !== void 0), [o, s] = $.useState(t), u = i ? e : o;
  if (cSe.NODE_ENV !== "production") {
    $.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: p
    } = $.useRef(t);
    $.useEffect(() => {
      !i && !Object.is(p, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const f = $.useCallback((p) => {
    i || s(p);
  }, []);
  return [u, f];
}
function Mr(e) {
  const t = $.useRef(e);
  return gs(() => {
    t.current = e;
  }), $.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function kr(...e) {
  const t = $.useRef(void 0), n = $.useCallback((r) => {
    const i = e.map((o) => {
      if (o == null)
        return null;
      if (typeof o == "function") {
        const s = o, u = s(r);
        return typeof u == "function" ? u : () => {
          s(null);
        };
      }
      return o.current = r, () => {
        o.current = null;
      };
    });
    return () => {
      i.forEach((o) => o == null ? void 0 : o());
    };
  }, e);
  return $.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const qG = {};
function Fne(e, t) {
  const n = $.useRef(qG);
  return n.current === qG && (n.current = e(t)), n;
}
const uSe = [];
function dSe(e) {
  $.useEffect(e, uSe);
}
class YD {
  constructor() {
    Un(this, "currentId", null);
    Un(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Un(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new YD();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function eg() {
  const e = Fne(YD.create).current;
  return dSe(e.disposeEffect), e;
}
var fSe = {};
function lg(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    fSe.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function Wne(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const rF = (e) => {
  const t = $.useRef({});
  return $.useEffect(() => {
    t.current = e;
  }), t.current;
};
function pSe(e) {
  return $.Children.toArray(e).filter((t) => /* @__PURE__ */ $.isValidElement(t));
}
const XD = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function a1(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const i = r;
      if (i === "components" || i === "slots")
        n[i] = {
          ...e[i],
          ...n[i]
        };
      else if (i === "componentsProps" || i === "slotProps") {
        const o = e[i], s = t[i];
        if (!s)
          n[i] = o || {};
        else if (!o)
          n[i] = s;
        else {
          n[i] = {
            ...s
          };
          for (const u in o)
            if (Object.prototype.hasOwnProperty.call(o, u)) {
              const f = u;
              n[i][f] = a1(o[f], s[f]);
            }
        }
      } else n[i] === void 0 && (n[i] = e[i]);
    }
  return n;
}
const $G = (e) => e, hSe = () => {
  let e = $G;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = $G;
    }
  };
}, Hne = hSe(), gSe = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Vt(e, t, n = "Mui") {
  const r = gSe[t];
  return r ? `${n}-${r}` : `${Hne.generate(e)}-${t}`;
}
function Wt(e, t, n = "Mui") {
  const r = {};
  return t.forEach((i) => {
    r[i] = Vt(e, i, n);
  }), r;
}
function mSe(e) {
  return typeof e == "string";
}
function qne(e, t, n) {
  return e === void 0 || mSe(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function op(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function GG(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function $ne(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: o
  } = e;
  if (!t) {
    const S = yt(n == null ? void 0 : n.className, o, i == null ? void 0 : i.className, r == null ? void 0 : r.className), E = {
      ...n == null ? void 0 : n.style,
      ...i == null ? void 0 : i.style,
      ...r == null ? void 0 : r.style
    }, w = {
      ...n,
      ...i,
      ...r
    };
    return S.length > 0 && (w.className = S), Object.keys(E).length > 0 && (w.style = E), {
      props: w,
      internalRef: void 0
    };
  }
  const s = op({
    ...i,
    ...r
  }), u = GG(r), f = GG(i), p = t(s), m = yt(p == null ? void 0 : p.className, n == null ? void 0 : n.className, o, i == null ? void 0 : i.className, r == null ? void 0 : r.className), v = {
    ...p == null ? void 0 : p.style,
    ...n == null ? void 0 : n.style,
    ...i == null ? void 0 : i.style,
    ...r == null ? void 0 : r.style
  }, y = {
    ...p,
    ...n,
    ...f,
    ...u
  };
  return m.length > 0 && (y.className = m), Object.keys(v).length > 0 && (y.style = v), {
    props: y,
    internalRef: p.ref
  };
}
function Yh(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Oo(e) {
  var v;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: i = !1,
    ...o
  } = e, s = i ? {} : Yh(n, r), {
    props: u,
    internalRef: f
  } = $ne({
    ...o,
    externalSlotProps: s
  }), p = kr(f, s == null ? void 0 : s.ref, (v = e.additionalProps) == null ? void 0 : v.ref);
  return qne(t, {
    ...u,
    ref: p
  }, r);
}
function Sg(e) {
  var t;
  return parseInt($.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
function vSe(e) {
  return Object.keys(e).length === 0;
}
function Gne(e = null) {
  const t = $.useContext(_he);
  return !t || vSe(t) ? e : t;
}
var ySe = {};
const bSe = /* @__PURE__ */ $.createContext();
ySe.NODE_ENV !== "production" && (c.node, c.bool);
const wg = () => $.useContext(bSe) ?? !1;
var xSe = {};
const SSe = /* @__PURE__ */ $.createContext(void 0);
xSe.NODE_ENV !== "production" && (c.node, c.object);
function wSe(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const i = t.components[n];
  return i.defaultProps ? a1(i.defaultProps, r) : !i.styleOverrides && !i.variants ? a1(i, r) : r;
}
function TSe({
  props: e,
  name: t
}) {
  const n = $.useContext(SSe);
  return wSe({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const ESe = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function _Se(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, o = ESe(t), s = Object.keys(o);
  function u(y) {
    return `@media (min-width:${typeof t[y] == "number" ? t[y] : y}${n})`;
  }
  function f(y) {
    return `@media (max-width:${(typeof t[y] == "number" ? t[y] : y) - r / 100}${n})`;
  }
  function p(y, S) {
    const E = s.indexOf(S);
    return `@media (min-width:${typeof t[y] == "number" ? t[y] : y}${n}) and (max-width:${(E !== -1 && typeof t[s[E]] == "number" ? t[s[E]] : S) - r / 100}${n})`;
  }
  function m(y) {
    return s.indexOf(y) + 1 < s.length ? p(y, s[s.indexOf(y) + 1]) : u(y);
  }
  function v(y) {
    const S = s.indexOf(y);
    return S === 0 ? u(s[1]) : S === s.length - 1 ? f(s[S]) : p(y, s[s.indexOf(y) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: o,
    up: u,
    down: f,
    between: p,
    only: m,
    not: v,
    unit: n,
    ...i
  };
}
const CSe = {
  borderRadius: 4
};
var RSe = {};
function OSe(e = 8, t = G3({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (RSe.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((o) => {
    const s = t(o);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function ASe(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function ZD(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: o = {},
    ...s
  } = e, u = _Se(n), f = OSe(i);
  let p = Ua({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: f,
    shape: {
      ...CSe,
      ...o
    }
  }, s);
  return p = h0e(p), p.applyStyles = ASe, p = t.reduce((m, v) => Ua(m, v), p), p.unstable_sxConfig = {
    ...l_,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, p.unstable_sx = function(v) {
    return kv({
      sx: v,
      theme: this
    });
  }, p;
}
const DSe = ZD();
function Yne(e = DSe) {
  return Gne(e);
}
const YG = (e, t, n, r = []) => {
  let i = e;
  t.forEach((o, s) => {
    s === t.length - 1 ? Array.isArray(i) ? i[Number(o)] = n : i && typeof i == "object" && (i[o] = n) : i && typeof i == "object" && (i[o] || (i[o] = r.includes(o) ? [] : {}), i = i[o]);
  });
}, ISe = (e, t, n) => {
  function r(i, o = [], s = []) {
    Object.entries(i).forEach(([u, f]) => {
      (!n || n && !n([...o, u])) && f != null && (typeof f == "object" && Object.keys(f).length > 0 ? r(f, [...o, u], Array.isArray(f) ? [...s, u] : s) : t([...o, u], f, s));
    });
  }
  r(e);
}, PSe = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Uk(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, o = {}, s = {};
  return ISe(
    e,
    (u, f, p) => {
      if ((typeof f == "string" || typeof f == "number") && (!r || !r(u, f))) {
        const m = `--${n ? `${n}-` : ""}${u.join("-")}`, v = PSe(u, f);
        Object.assign(i, {
          [m]: v
        }), YG(o, u, `var(${m})`, p), YG(s, u, `var(${m}, ${v})`, p);
      }
    },
    (u) => u[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: o,
    varsWithDefaults: s
  };
}
function NSe(e, t = {}) {
  const {
    getSelector: n = _,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: o = {},
    components: s,
    defaultColorScheme: u = "light",
    ...f
  } = e, {
    vars: p,
    css: m,
    varsWithDefaults: v
  } = Uk(f, t);
  let y = v;
  const S = {}, {
    [u]: E,
    ...w
  } = o;
  if (Object.entries(w || {}).forEach(([P, M]) => {
    const {
      vars: N,
      css: k,
      varsWithDefaults: U
    } = Uk(M, t);
    y = Ua(y, U), S[P] = {
      css: k,
      vars: N
    };
  }), E) {
    const {
      css: P,
      vars: M,
      varsWithDefaults: N
    } = Uk(E, t);
    y = Ua(y, N), S[u] = {
      css: P,
      vars: M
    };
  }
  function _(P, M) {
    var k, U;
    let N = i;
    if (i === "class" && (N = ".%s"), i === "data" && (N = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (N = `[${i}="%s"]`), P) {
      if (N === "media")
        return e.defaultColorScheme === P ? ":root" : {
          [`@media (prefers-color-scheme: ${((U = (k = o[P]) == null ? void 0 : k.palette) == null ? void 0 : U.mode) || P})`]: {
            ":root": M
          }
        };
      if (N)
        return e.defaultColorScheme === P ? `:root, ${N.replace("%s", String(P))}` : N.replace("%s", String(P));
    }
    return ":root";
  }
  return {
    vars: y,
    generateThemeVars: () => {
      let P = {
        ...p
      };
      return Object.entries(S).forEach(([, {
        vars: M
      }]) => {
        P = Ua(P, M);
      }), P;
    },
    generateStyleSheets: () => {
      var H, Y;
      const P = [], M = e.defaultColorScheme || "light";
      function N(z, V) {
        Object.keys(V).length && P.push(typeof z == "string" ? {
          [z]: {
            ...V
          }
        } : z);
      }
      N(n(void 0, {
        ...m
      }), m);
      const {
        [M]: k,
        ...U
      } = S;
      if (k) {
        const {
          css: z
        } = k, V = (Y = (H = o[M]) == null ? void 0 : H.palette) == null ? void 0 : Y.mode, F = !r && V ? {
          colorScheme: V,
          ...z
        } : {
          ...z
        };
        N(n(M, {
          ...F
        }), F);
      }
      return Object.entries(U).forEach(([z, {
        css: V
      }]) => {
        var oe, re;
        const F = (re = (oe = o[z]) == null ? void 0 : oe.palette) == null ? void 0 : re.mode, X = !r && F ? {
          colorScheme: F,
          ...V
        } : {
          ...V
        };
        N(n(z, {
          ...X
        }), X);
      }), P;
    }
  };
}
function MSe(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, o] = r;
    typeof o == "object" && (t[i] = `${o.fontStyle ? `${o.fontStyle} ` : ""}${o.fontVariant ? `${o.fontVariant} ` : ""}${o.fontWeight ? `${o.fontWeight} ` : ""}${o.fontStretch ? `${o.fontStretch} ` : ""}${o.fontSize || ""}${o.lineHeight ? `/${o.lineHeight} ` : ""}${o.fontFamily || ""}`);
  }), t;
}
var jSe = {};
function LSe(e) {
  return function(n) {
    return e === "media" ? (jSe.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
function kSe(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
var zSe = {};
function BSe(e) {
  return Math.round(e * 1e5) / 1e5;
}
const XG = {
  textTransform: "uppercase"
}, ZG = '"Roboto", "Helvetica", "Arial", sans-serif';
function Xne(e, t) {
  const {
    fontFamily: n = ZG,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: o = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: f = 16,
    // Apply the CSS properties to all the variants.
    allVariants: p,
    pxToRem: m,
    ...v
  } = typeof t == "function" ? t(e) : t;
  zSe.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof f != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const y = r / 14, S = m || ((_) => `${_ / f * y}rem`), E = (_, O, D, P, M) => ({
    fontFamily: n,
    fontWeight: _,
    fontSize: S(O),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: D,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === ZG ? {
      letterSpacing: `${BSe(P / O)}em`
    } : {},
    ...M,
    ...p
  }), w = {
    h1: E(i, 96, 1.167, -1.5),
    h2: E(i, 60, 1.2, -0.5),
    h3: E(o, 48, 1.167, 0),
    h4: E(o, 34, 1.235, 0.25),
    h5: E(o, 24, 1.334, 0),
    h6: E(s, 20, 1.6, 0.15),
    subtitle1: E(o, 16, 1.75, 0.15),
    subtitle2: E(s, 14, 1.57, 0.1),
    body1: E(o, 16, 1.5, 0.15),
    body2: E(o, 14, 1.43, 0.15),
    button: E(s, 14, 1.75, 0.4, XG),
    caption: E(o, 12, 1.66, 0.4),
    overline: E(o, 12, 2.66, 1, XG),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Ua({
    htmlFontSize: f,
    pxToRem: S,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: o,
    fontWeightMedium: s,
    fontWeightBold: u,
    ...w
  }, v, {
    clone: !1
    // No need to clone deep
  });
}
const VSe = 0.2, USe = 0.14, FSe = 0.12;
function wi(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${VSe})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${USe})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${FSe})`].join(",");
}
const WSe = ["none", wi(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), wi(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), wi(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), wi(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), wi(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), wi(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), wi(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), wi(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), wi(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), wi(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), wi(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), wi(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), wi(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), wi(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), wi(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), wi(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), wi(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), wi(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), wi(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), wi(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), wi(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), wi(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), wi(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), wi(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var HSe = {};
const qSe = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Zne = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function KG(e) {
  return `${Math.round(e)}ms`;
}
function $Se(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function GSe(e) {
  const t = {
    ...qSe,
    ...e.easing
  }, n = {
    ...Zne,
    ...e.duration
  };
  return {
    getAutoHeightDuration: $Se,
    create: (i = ["all"], o = {}) => {
      const {
        duration: s = n.standard,
        easing: u = t.easeInOut,
        delay: f = 0,
        ...p
      } = o;
      if (HSe.NODE_ENV !== "production") {
        const m = (y) => typeof y == "string", v = (y) => !Number.isNaN(parseFloat(y));
        !m(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !v(s) && !m(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), m(u) || console.error('MUI: Argument "easing" must be a string.'), !v(f) && !m(f) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof o != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(p).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(p).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((m) => `${m} ${typeof s == "string" ? s : KG(s)} ${u} ${typeof f == "string" ? f : KG(f)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const YSe = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function XSe(e) {
  return Id(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Kne(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let o = 0; o < i.length; o++) {
      const [s, u] = i[o];
      !XSe(u) || s.startsWith("unstable_") ? delete r[s] : Id(u) && (r[s] = {
        ...u
      }, n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
var Fk = {};
function G2(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: o = {},
    transitions: s = {},
    typography: u = {},
    shape: f,
    ...p
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(Fk.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : Ud(20));
  const m = K3(o), v = ZD(e);
  let y = Ua(v, {
    mixins: kSe(v.breakpoints, r),
    palette: m,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: WSe.slice(),
    typography: Xne(m, u),
    transitions: GSe(s),
    zIndex: {
      ...YSe
    }
  });
  if (y = Ua(y, p), y = t.reduce((S, E) => Ua(S, E), y), Fk.NODE_ENV !== "production") {
    const S = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], E = (w, _) => {
      let O;
      for (O in w) {
        const D = w[O];
        if (S.includes(O) && Object.keys(D).length > 0) {
          if (Fk.NODE_ENV !== "production") {
            const P = Vt("", O);
            console.error([`MUI: The \`${_}\` component increases the CSS specificity of the \`${O}\` internal state.`, "You can not override it like this: ", JSON.stringify(w, null, 2), "", `Instead, you need to use the '&.${P}' syntax:`, JSON.stringify({
              root: {
                [`&.${P}`]: D
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          w[O] = {};
        }
      }
    };
    Object.keys(y.components).forEach((w) => {
      const _ = y.components[w].styleOverrides;
      _ && w.startsWith("Mui") && E(_, w);
    });
  }
  return y.unstable_sxConfig = {
    ...l_,
    ...p == null ? void 0 : p.unstable_sxConfig
  }, y.unstable_sx = function(E) {
    return kv({
      sx: E,
      theme: this
    });
  }, y.toRuntimeSource = Kne, y;
}
function Y2(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const ZSe = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Y2(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Qne(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Jne(e) {
  return e === "dark" ? ZSe : [];
}
function KSe(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, o = K3(t);
  return {
    palette: o,
    opacity: {
      ...Qne(o.mode),
      ...n
    },
    overlays: r || Jne(o.mode),
    ...i
  };
}
function QSe(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const JSe = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], ewe = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let o = i;
  if (i === "class" && (o = ".%s"), i === "data" && (o = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (o = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return JSe(e.cssVarPrefix).forEach((u) => {
        s[u] = n[u], delete n[u];
      }), o === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : o ? {
        [o.replace("%s", t)]: s,
        [`${r}, ${o.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (o && o !== "media")
      return `${r}, ${o.replace("%s", String(t))}`;
  } else if (t) {
    if (o === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (o)
      return o.replace("%s", String(t));
  }
  return r;
};
var twe = {};
function nwe(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function dt(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function CE(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Tne(e);
}
function Yf(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = _E(CE(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function rwe(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Rd = (e) => {
  try {
    return e();
  } catch {
  }
}, iwe = (e = "mui") => dhe(e);
function Wk(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = KSe({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: o,
    ...s
  } = G2({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: o,
    opacity: {
      ...Qne(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Jne(i)
  }, s;
}
function owe(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: o = "mui",
    shouldSkipGeneratingVar: s = QSe,
    colorSchemeSelector: u = n.light && n.dark ? "media" : void 0,
    rootSelector: f = ":root",
    ...p
  } = e, m = Object.keys(n)[0], v = r || (n.light && m !== "light" ? "light" : m), y = iwe(o), {
    [v]: S,
    light: E,
    dark: w,
    ..._
  } = n, O = {
    ..._
  };
  let D = S;
  if ((v === "dark" && !("dark" in n) || v === "light" && !("light" in n)) && (D = !0), !D)
    throw new Error(twe.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${v}\` option is either missing or invalid.` : Ud(21, v));
  const P = Wk(O, D, p, v);
  E && !O.light && Wk(O, E, void 0, "light"), w && !O.dark && Wk(O, w, void 0, "dark");
  let M = {
    defaultColorScheme: v,
    ...P,
    cssVarPrefix: o,
    colorSchemeSelector: u,
    rootSelector: f,
    getCssVar: y,
    colorSchemes: O,
    font: {
      ...MSe(P.typography),
      ...P.font
    },
    spacing: rwe(p.spacing)
  };
  Object.keys(M.colorSchemes).forEach((Y) => {
    const z = M.colorSchemes[Y].palette, V = (F) => {
      const X = F.split("-"), oe = X[1], re = X[2];
      return y(F, z[oe][re]);
    };
    if (z.mode === "light" && (dt(z.common, "background", "#fff"), dt(z.common, "onBackground", "#000")), z.mode === "dark" && (dt(z.common, "background", "#000"), dt(z.common, "onBackground", "#fff")), nwe(z, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), z.mode === "light") {
      dt(z.Alert, "errorColor", Kr(z.error.light, 0.6)), dt(z.Alert, "infoColor", Kr(z.info.light, 0.6)), dt(z.Alert, "successColor", Kr(z.success.light, 0.6)), dt(z.Alert, "warningColor", Kr(z.warning.light, 0.6)), dt(z.Alert, "errorFilledBg", V("palette-error-main")), dt(z.Alert, "infoFilledBg", V("palette-info-main")), dt(z.Alert, "successFilledBg", V("palette-success-main")), dt(z.Alert, "warningFilledBg", V("palette-warning-main")), dt(z.Alert, "errorFilledColor", Rd(() => z.getContrastText(z.error.main))), dt(z.Alert, "infoFilledColor", Rd(() => z.getContrastText(z.info.main))), dt(z.Alert, "successFilledColor", Rd(() => z.getContrastText(z.success.main))), dt(z.Alert, "warningFilledColor", Rd(() => z.getContrastText(z.warning.main))), dt(z.Alert, "errorStandardBg", Qr(z.error.light, 0.9)), dt(z.Alert, "infoStandardBg", Qr(z.info.light, 0.9)), dt(z.Alert, "successStandardBg", Qr(z.success.light, 0.9)), dt(z.Alert, "warningStandardBg", Qr(z.warning.light, 0.9)), dt(z.Alert, "errorIconColor", V("palette-error-main")), dt(z.Alert, "infoIconColor", V("palette-info-main")), dt(z.Alert, "successIconColor", V("palette-success-main")), dt(z.Alert, "warningIconColor", V("palette-warning-main")), dt(z.AppBar, "defaultBg", V("palette-grey-100")), dt(z.Avatar, "defaultBg", V("palette-grey-400")), dt(z.Button, "inheritContainedBg", V("palette-grey-300")), dt(z.Button, "inheritContainedHoverBg", V("palette-grey-A100")), dt(z.Chip, "defaultBorder", V("palette-grey-400")), dt(z.Chip, "defaultAvatarColor", V("palette-grey-700")), dt(z.Chip, "defaultIconColor", V("palette-grey-700")), dt(z.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), dt(z.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), dt(z.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), dt(z.LinearProgress, "primaryBg", Qr(z.primary.main, 0.62)), dt(z.LinearProgress, "secondaryBg", Qr(z.secondary.main, 0.62)), dt(z.LinearProgress, "errorBg", Qr(z.error.main, 0.62)), dt(z.LinearProgress, "infoBg", Qr(z.info.main, 0.62)), dt(z.LinearProgress, "successBg", Qr(z.success.main, 0.62)), dt(z.LinearProgress, "warningBg", Qr(z.warning.main, 0.62)), dt(z.Skeleton, "bg", `rgba(${V("palette-text-primaryChannel")} / 0.11)`), dt(z.Slider, "primaryTrack", Qr(z.primary.main, 0.62)), dt(z.Slider, "secondaryTrack", Qr(z.secondary.main, 0.62)), dt(z.Slider, "errorTrack", Qr(z.error.main, 0.62)), dt(z.Slider, "infoTrack", Qr(z.info.main, 0.62)), dt(z.Slider, "successTrack", Qr(z.success.main, 0.62)), dt(z.Slider, "warningTrack", Qr(z.warning.main, 0.62));
      const F = MR(z.background.default, 0.8);
      dt(z.SnackbarContent, "bg", F), dt(z.SnackbarContent, "color", Rd(() => z.getContrastText(F))), dt(z.SpeedDialAction, "fabHoverBg", MR(z.background.paper, 0.15)), dt(z.StepConnector, "border", V("palette-grey-400")), dt(z.StepContent, "border", V("palette-grey-400")), dt(z.Switch, "defaultColor", V("palette-common-white")), dt(z.Switch, "defaultDisabledColor", V("palette-grey-100")), dt(z.Switch, "primaryDisabledColor", Qr(z.primary.main, 0.62)), dt(z.Switch, "secondaryDisabledColor", Qr(z.secondary.main, 0.62)), dt(z.Switch, "errorDisabledColor", Qr(z.error.main, 0.62)), dt(z.Switch, "infoDisabledColor", Qr(z.info.main, 0.62)), dt(z.Switch, "successDisabledColor", Qr(z.success.main, 0.62)), dt(z.Switch, "warningDisabledColor", Qr(z.warning.main, 0.62)), dt(z.TableCell, "border", Qr(NR(z.divider, 1), 0.88)), dt(z.Tooltip, "bg", NR(z.grey[700], 0.92));
    }
    if (z.mode === "dark") {
      dt(z.Alert, "errorColor", Qr(z.error.light, 0.6)), dt(z.Alert, "infoColor", Qr(z.info.light, 0.6)), dt(z.Alert, "successColor", Qr(z.success.light, 0.6)), dt(z.Alert, "warningColor", Qr(z.warning.light, 0.6)), dt(z.Alert, "errorFilledBg", V("palette-error-dark")), dt(z.Alert, "infoFilledBg", V("palette-info-dark")), dt(z.Alert, "successFilledBg", V("palette-success-dark")), dt(z.Alert, "warningFilledBg", V("palette-warning-dark")), dt(z.Alert, "errorFilledColor", Rd(() => z.getContrastText(z.error.dark))), dt(z.Alert, "infoFilledColor", Rd(() => z.getContrastText(z.info.dark))), dt(z.Alert, "successFilledColor", Rd(() => z.getContrastText(z.success.dark))), dt(z.Alert, "warningFilledColor", Rd(() => z.getContrastText(z.warning.dark))), dt(z.Alert, "errorStandardBg", Kr(z.error.light, 0.9)), dt(z.Alert, "infoStandardBg", Kr(z.info.light, 0.9)), dt(z.Alert, "successStandardBg", Kr(z.success.light, 0.9)), dt(z.Alert, "warningStandardBg", Kr(z.warning.light, 0.9)), dt(z.Alert, "errorIconColor", V("palette-error-main")), dt(z.Alert, "infoIconColor", V("palette-info-main")), dt(z.Alert, "successIconColor", V("palette-success-main")), dt(z.Alert, "warningIconColor", V("palette-warning-main")), dt(z.AppBar, "defaultBg", V("palette-grey-900")), dt(z.AppBar, "darkBg", V("palette-background-paper")), dt(z.AppBar, "darkColor", V("palette-text-primary")), dt(z.Avatar, "defaultBg", V("palette-grey-600")), dt(z.Button, "inheritContainedBg", V("palette-grey-800")), dt(z.Button, "inheritContainedHoverBg", V("palette-grey-700")), dt(z.Chip, "defaultBorder", V("palette-grey-700")), dt(z.Chip, "defaultAvatarColor", V("palette-grey-300")), dt(z.Chip, "defaultIconColor", V("palette-grey-300")), dt(z.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), dt(z.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), dt(z.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), dt(z.LinearProgress, "primaryBg", Kr(z.primary.main, 0.5)), dt(z.LinearProgress, "secondaryBg", Kr(z.secondary.main, 0.5)), dt(z.LinearProgress, "errorBg", Kr(z.error.main, 0.5)), dt(z.LinearProgress, "infoBg", Kr(z.info.main, 0.5)), dt(z.LinearProgress, "successBg", Kr(z.success.main, 0.5)), dt(z.LinearProgress, "warningBg", Kr(z.warning.main, 0.5)), dt(z.Skeleton, "bg", `rgba(${V("palette-text-primaryChannel")} / 0.13)`), dt(z.Slider, "primaryTrack", Kr(z.primary.main, 0.5)), dt(z.Slider, "secondaryTrack", Kr(z.secondary.main, 0.5)), dt(z.Slider, "errorTrack", Kr(z.error.main, 0.5)), dt(z.Slider, "infoTrack", Kr(z.info.main, 0.5)), dt(z.Slider, "successTrack", Kr(z.success.main, 0.5)), dt(z.Slider, "warningTrack", Kr(z.warning.main, 0.5));
      const F = MR(z.background.default, 0.98);
      dt(z.SnackbarContent, "bg", F), dt(z.SnackbarContent, "color", Rd(() => z.getContrastText(F))), dt(z.SpeedDialAction, "fabHoverBg", MR(z.background.paper, 0.15)), dt(z.StepConnector, "border", V("palette-grey-600")), dt(z.StepContent, "border", V("palette-grey-600")), dt(z.Switch, "defaultColor", V("palette-grey-300")), dt(z.Switch, "defaultDisabledColor", V("palette-grey-600")), dt(z.Switch, "primaryDisabledColor", Kr(z.primary.main, 0.55)), dt(z.Switch, "secondaryDisabledColor", Kr(z.secondary.main, 0.55)), dt(z.Switch, "errorDisabledColor", Kr(z.error.main, 0.55)), dt(z.Switch, "infoDisabledColor", Kr(z.info.main, 0.55)), dt(z.Switch, "successDisabledColor", Kr(z.success.main, 0.55)), dt(z.Switch, "warningDisabledColor", Kr(z.warning.main, 0.55)), dt(z.TableCell, "border", Kr(NR(z.divider, 1), 0.68)), dt(z.Tooltip, "bg", NR(z.grey[700], 0.92));
    }
    Yf(z.background, "default"), Yf(z.background, "paper"), Yf(z.common, "background"), Yf(z.common, "onBackground"), Yf(z, "divider"), Object.keys(z).forEach((F) => {
      const X = z[F];
      F !== "tonalOffset" && X && typeof X == "object" && (X.main && dt(z[F], "mainChannel", _E(CE(X.main))), X.light && dt(z[F], "lightChannel", _E(CE(X.light))), X.dark && dt(z[F], "darkChannel", _E(CE(X.dark))), X.contrastText && dt(z[F], "contrastTextChannel", _E(CE(X.contrastText))), F === "text" && (Yf(z[F], "primary"), Yf(z[F], "secondary")), F === "action" && (X.active && Yf(z[F], "active"), X.selected && Yf(z[F], "selected")));
    });
  }), M = t.reduce((Y, z) => Ua(Y, z), M);
  const N = {
    prefix: o,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: s,
    getSelector: ewe(M)
  }, {
    vars: k,
    generateThemeVars: U,
    generateStyleSheets: H
  } = NSe(M, N);
  return M.vars = k, Object.entries(M.colorSchemes[M.defaultColorScheme]).forEach(([Y, z]) => {
    M[Y] = z;
  }), M.generateThemeVars = U, M.generateStyleSheets = H, M.generateSpacing = function() {
    return fhe(p.spacing, G3(this));
  }, M.getColorSchemeSelector = LSe(u), M.spacing = M.generateSpacing(), M.shouldSkipGeneratingVar = s, M.unstable_sxConfig = {
    ...l_,
    ...p == null ? void 0 : p.unstable_sxConfig
  }, M.unstable_sx = function(z) {
    return kv({
      sx: z,
      theme: this
    });
  }, M.toRuntimeSource = Kne, M;
}
function QG(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: K3({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function d_(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: o = n == null ? void 0 : n.mode,
    ...s
  } = e, u = o || "light", f = i == null ? void 0 : i[u], p = {
    ...i,
    ...n ? {
      [u]: {
        ...typeof f != "boolean" && f,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return G2(e, ...t);
    let m = n;
    "palette" in e || p[u] && (p[u] !== !0 ? m = p[u].palette : u === "dark" && (m = {
      mode: "dark"
    }));
    const v = G2({
      ...e,
      palette: m
    }, ...t);
    return v.defaultColorScheme = u, v.colorSchemes = p, v.palette.mode === "light" && (v.colorSchemes.light = {
      ...p.light !== !0 && p.light,
      palette: v.palette
    }, QG(v, "dark", p.dark)), v.palette.mode === "dark" && (v.colorSchemes.dark = {
      ...p.dark !== !0 && p.dark,
      palette: v.palette
    }, QG(v, "light", p.light)), v;
  }
  return !n && !("light" in p) && u === "light" && (p.light = !0), owe({
    ...s,
    colorSchemes: p,
    defaultColorScheme: u,
    ...typeof r != "boolean" && r
  }, ...t);
}
const KD = d_(), Ac = "$$material";
var awe = {};
function pa() {
  const e = phe(KD);
  return awe.NODE_ENV !== "production" && $.useDebugValue(e), e[Ac] || e;
}
var swe = {};
function iF(e) {
  return /* @__PURE__ */ T.jsx(hhe, {
    ...e,
    defaultTheme: KD,
    themeId: Ac
  });
}
swe.NODE_ENV !== "production" && (iF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: c.oneOfType([c.array, c.func, c.number, c.object, c.string, c.bool])
});
function lwe(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: Av(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((i) => {
    typeof i.style != "function" && (i.style = Av(i.style));
  }), r;
}
var ere = {};
const cwe = ZD();
function kE(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function Tv(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
function uwe(e) {
  return e ? (t, n) => n[e] : null;
}
function dwe(e, t, n) {
  e.theme = hwe(e.theme) ? n : e.theme[t] || e.theme;
}
function DO(e, t, n) {
  const r = typeof t == "function" ? t(e) : t;
  if (Array.isArray(r))
    return r.flatMap((i) => DO(e, i, n));
  if (Array.isArray(r == null ? void 0 : r.variants)) {
    let i;
    if (r.isProcessed)
      i = n ? Tv(r.style, n) : r.style;
    else {
      const {
        variants: o,
        ...s
      } = r;
      i = n ? Tv(Av(s), n) : s;
    }
    return tre(e, r.variants, [i], n);
  }
  return r != null && r.isProcessed ? n ? Tv(Av(r.style), n) : r.style : n ? Tv(Av(r), n) : r;
}
function tre(e, t, n = [], r = void 0) {
  var o;
  let i;
  e: for (let s = 0; s < t.length; s += 1) {
    const u = t[s];
    if (typeof u.props == "function") {
      if (i ?? (i = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !u.props(i))
        continue;
    } else
      for (const f in u.props)
        if (e[f] !== u.props[f] && ((o = e.ownerState) == null ? void 0 : o[f]) !== u.props[f])
          continue e;
    typeof u.style == "function" ? (i ?? (i = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(r ? Tv(Av(u.style(i)), r) : u.style(i))) : n.push(r ? Tv(Av(u.style), r) : u.style);
  }
  return n;
}
function nre(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = cwe,
    rootShouldForwardProp: r = kE,
    slotShouldForwardProp: i = kE
  } = e;
  function o(u) {
    dwe(u, t, n);
  }
  return (u, f = {}) => {
    Kxe(u, (k) => k.filter((U) => U !== kv));
    const {
      name: p,
      slot: m,
      skipVariantsResolver: v,
      skipSx: y,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: S = uwe(rre(m)),
      ...E
    } = f, w = p && p.startsWith("Mui") || m ? "components" : "custom", _ = v !== void 0 ? v : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      m && m !== "Root" && m !== "root" || !1
    ), O = y || !1;
    let D = kE;
    m === "Root" || m === "root" ? D = r : m ? D = i : gwe(u) && (D = void 0);
    const P = Zxe(u, {
      shouldForwardProp: D,
      label: pwe(p, m),
      ...E
    }), M = (k) => {
      if (k.__emotion_real === k)
        return k;
      if (typeof k == "function")
        return function(H) {
          return DO(H, k, H.theme.modularCssLayers ? w : void 0);
        };
      if (Id(k)) {
        const U = lwe(k);
        return function(Y) {
          return U.variants ? DO(Y, U, Y.theme.modularCssLayers ? w : void 0) : Y.theme.modularCssLayers ? Tv(U.style, w) : U.style;
        };
      }
      return k;
    }, N = (...k) => {
      const U = [], H = k.map(M), Y = [];
      if (U.push(o), p && S && Y.push(function(X) {
        var ee, J;
        const re = (J = (ee = X.theme.components) == null ? void 0 : ee[p]) == null ? void 0 : J.styleOverrides;
        if (!re)
          return null;
        const Z = {};
        for (const le in re)
          Z[le] = DO(X, re[le], X.theme.modularCssLayers ? "theme" : void 0);
        return S(X, Z);
      }), p && !_ && Y.push(function(X) {
        var Z, ee;
        const oe = X.theme, re = (ee = (Z = oe == null ? void 0 : oe.components) == null ? void 0 : Z[p]) == null ? void 0 : ee.variants;
        return re ? tre(X, re, [], X.theme.modularCssLayers ? "theme" : void 0) : null;
      }), O || Y.push(kv), Array.isArray(H[0])) {
        const F = H.shift(), X = new Array(U.length).fill(""), oe = new Array(Y.length).fill("");
        let re;
        re = [...X, ...F, ...oe], re.raw = [...X, ...F.raw, ...oe], U.unshift(re);
      }
      const z = [...U, ...H, ...Y], V = P(...z);
      return u.muiName && (V.muiName = u.muiName), ere.NODE_ENV !== "production" && (V.displayName = fwe(p, m, u)), V;
    };
    return P.withConfig && (N.withConfig = P.withConfig), N;
  };
}
function fwe(e, t, n) {
  return e ? `${e}${Ke(t || "")}` : `Styled(${rSe(n)})`;
}
function pwe(e, t) {
  let n;
  return ere.NODE_ENV !== "production" && e && (n = `${e}-${rre(t || "Root")}`), n;
}
function hwe(e) {
  for (const t in e)
    return !1;
  return !0;
}
function gwe(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function rre(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function QD(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ha = (e) => QD(e) && e !== "classes", ye = nre({
  themeId: Ac,
  defaultTheme: KD,
  rootShouldForwardProp: ha
});
function mwe(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ T.jsx(iF, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...n
        }) : e
      })
    );
  };
}
function vwe() {
  return Z3;
}
const Lt = ghe;
var ywe = {};
ywe.NODE_ENV !== "production" && (c.node, c.object.isRequired);
function Gt(e) {
  return TSe(e);
}
function bwe(e) {
  return Vt("MuiPaper", e);
}
Wt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
var ire = {};
const xwe = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: i
  } = e, o = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Ft(o, bwe, i);
}, Swe = ye("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(Lt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Ei = /* @__PURE__ */ $.forwardRef(function(t, n) {
  var S;
  const r = Gt({
    props: t,
    name: "MuiPaper"
  }), i = pa(), {
    className: o,
    component: s = "div",
    elevation: u = 1,
    square: f = !1,
    variant: p = "elevation",
    ...m
  } = r, v = {
    ...r,
    component: s,
    elevation: u,
    square: f,
    variant: p
  }, y = xwe(v);
  return ire.NODE_ENV !== "production" && i.shadows[u] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${u}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${u}]\` is defined.`].join(`
`)), /* @__PURE__ */ T.jsx(Swe, {
    as: s,
    ownerState: v,
    className: yt(y.root, o),
    ref: n,
    ...m,
    style: {
      ...p === "elevation" && {
        "--Paper-shadow": (i.vars || i).shadows[u],
        ...i.vars && {
          "--Paper-overlay": (S = i.vars.overlays) == null ? void 0 : S[u]
        },
        ...!i.vars && i.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Cn("#fff", Y2(u))}, ${Cn("#fff", Y2(u))})`
        }
      },
      ...m.style
    }
  });
});
ire.NODE_ENV !== "production" && (Ei.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Wa(jD, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: c.bool,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: c.oneOfType([c.oneOf(["elevation", "outlined"]), c.string])
});
let Dc;
typeof window < "u" ? Dc = window : typeof self < "u" ? Dc = self : Dc = global;
let X2 = null, Z2 = null;
const JG = 20, Hk = Dc.clearTimeout, e9 = Dc.setTimeout, qk = Dc.cancelAnimationFrame || Dc.mozCancelAnimationFrame || Dc.webkitCancelAnimationFrame, t9 = Dc.requestAnimationFrame || Dc.mozRequestAnimationFrame || Dc.webkitRequestAnimationFrame;
qk == null || t9 == null ? (X2 = Hk, Z2 = function(t) {
  return e9(t, JG);
}) : (X2 = function([t, n]) {
  qk(t), Hk(n);
}, Z2 = function(t) {
  const n = t9(function() {
    Hk(r), t();
  }), r = e9(function() {
    qk(n), t();
  }, JG);
  return [n, r];
});
function wwe(e) {
  let t, n, r, i, o, s, u;
  const f = typeof document < "u" && document.attachEvent;
  if (!f) {
    s = function(O) {
      const D = O.__resizeTriggers__, P = D.firstElementChild, M = D.lastElementChild, N = P.firstElementChild;
      M.scrollLeft = M.scrollWidth, M.scrollTop = M.scrollHeight, N.style.width = P.offsetWidth + 1 + "px", N.style.height = P.offsetHeight + 1 + "px", P.scrollLeft = P.scrollWidth, P.scrollTop = P.scrollHeight;
    }, o = function(O) {
      return O.offsetWidth !== O.__resizeLast__.width || O.offsetHeight !== O.__resizeLast__.height;
    }, u = function(O) {
      if (O.target.className && typeof O.target.className.indexOf == "function" && O.target.className.indexOf("contract-trigger") < 0 && O.target.className.indexOf("expand-trigger") < 0)
        return;
      const D = this;
      s(this), this.__resizeRAF__ && X2(this.__resizeRAF__), this.__resizeRAF__ = Z2(function() {
        o(D) && (D.__resizeLast__.width = D.offsetWidth, D.__resizeLast__.height = D.offsetHeight, D.__resizeListeners__.forEach(function(N) {
          N.call(D, O);
        }));
      });
    };
    let y = !1, S = "";
    r = "animationstart";
    const E = "Webkit Moz O ms".split(" ");
    let w = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), _ = "";
    {
      const O = document.createElement("fakeelement");
      if (O.style.animationName !== void 0 && (y = !0), y === !1) {
        for (let D = 0; D < E.length; D++)
          if (O.style[E[D] + "AnimationName"] !== void 0) {
            _ = E[D], S = "-" + _.toLowerCase() + "-", r = w[D], y = !0;
            break;
          }
      }
    }
    n = "resizeanim", t = "@" + S + "keyframes " + n + " { from { opacity: 0; } to { opacity: 0; } } ", i = S + "animation: 1ms " + n + "; ";
  }
  const p = function(y) {
    if (!y.getElementById("detectElementResize")) {
      const S = (t || "") + ".resize-triggers { " + (i || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', E = y.head || y.getElementsByTagName("head")[0], w = y.createElement("style");
      w.id = "detectElementResize", w.type = "text/css", e != null && w.setAttribute("nonce", e), w.styleSheet ? w.styleSheet.cssText = S : w.appendChild(y.createTextNode(S)), E.appendChild(w);
    }
  };
  return {
    addResizeListener: function(y, S) {
      if (f)
        y.attachEvent("onresize", S);
      else {
        if (!y.__resizeTriggers__) {
          const E = y.ownerDocument, w = Dc.getComputedStyle(y);
          w && w.position === "static" && (y.style.position = "relative"), p(E), y.__resizeLast__ = {}, y.__resizeListeners__ = [], (y.__resizeTriggers__ = E.createElement("div")).className = "resize-triggers";
          const _ = E.createElement("div");
          _.className = "expand-trigger", _.appendChild(E.createElement("div"));
          const O = E.createElement("div");
          O.className = "contract-trigger", y.__resizeTriggers__.appendChild(_), y.__resizeTriggers__.appendChild(O), y.appendChild(y.__resizeTriggers__), s(y), y.addEventListener("scroll", u, !0), r && (y.__resizeTriggers__.__animationListener__ = function(P) {
            P.animationName === n && s(y);
          }, y.__resizeTriggers__.addEventListener(r, y.__resizeTriggers__.__animationListener__));
        }
        y.__resizeListeners__.push(S);
      }
    },
    removeResizeListener: function(y, S) {
      if (f)
        y.detachEvent("onresize", S);
      else if (y.__resizeListeners__.splice(y.__resizeListeners__.indexOf(S), 1), !y.__resizeListeners__.length) {
        y.removeEventListener("scroll", u, !0), y.__resizeTriggers__.__animationListener__ && (y.__resizeTriggers__.removeEventListener(r, y.__resizeTriggers__.__animationListener__), y.__resizeTriggers__.__animationListener__ = null);
        try {
          y.__resizeTriggers__ = !y.removeChild(y.__resizeTriggers__);
        } catch {
        }
      }
    }
  };
}
class Twe extends vJ {
  constructor(...t) {
    super(...t), this.state = {
      height: this.props.defaultHeight || 0,
      scaledHeight: this.props.defaultHeight || 0,
      scaledWidth: this.props.defaultWidth || 0,
      width: this.props.defaultWidth || 0
    }, this._autoSizer = null, this._detectElementResize = null, this._parentNode = null, this._resizeObserver = null, this._timeoutId = null, this._onResize = () => {
      this._timeoutId = null;
      const {
        disableHeight: n,
        disableWidth: r,
        onResize: i
      } = this.props;
      if (this._parentNode) {
        const o = window.getComputedStyle(this._parentNode) || {}, s = parseFloat(o.paddingLeft || "0"), u = parseFloat(o.paddingRight || "0"), f = parseFloat(o.paddingTop || "0"), p = parseFloat(o.paddingBottom || "0"), m = this._parentNode.getBoundingClientRect(), v = m.height - f - p, y = m.width - s - u, S = this._parentNode.offsetHeight - f - p, E = this._parentNode.offsetWidth - s - u;
        (!n && (this.state.height !== S || this.state.scaledHeight !== v) || !r && (this.state.width !== E || this.state.scaledWidth !== y)) && (this.setState({
          height: S,
          width: E,
          scaledHeight: v,
          scaledWidth: y
        }), typeof i == "function" && i({
          height: S,
          scaledHeight: v,
          scaledWidth: y,
          width: E
        }));
      }
    }, this._setRef = (n) => {
      this._autoSizer = n;
    };
  }
  componentDidMount() {
    const {
      nonce: t
    } = this.props, n = this._autoSizer ? this._autoSizer.parentNode : null;
    if (n != null && n.ownerDocument && n.ownerDocument.defaultView && n instanceof n.ownerDocument.defaultView.HTMLElement) {
      this._parentNode = n;
      const r = n.ownerDocument.defaultView.ResizeObserver;
      r != null ? (this._resizeObserver = new r(() => {
        this._timeoutId = setTimeout(this._onResize, 0);
      }), this._resizeObserver.observe(n)) : (this._detectElementResize = wwe(t), this._detectElementResize.addResizeListener(n, this._onResize)), this._onResize();
    }
  }
  componentWillUnmount() {
    this._parentNode && (this._detectElementResize && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize), this._timeoutId !== null && clearTimeout(this._timeoutId), this._resizeObserver && this._resizeObserver.disconnect());
  }
  render() {
    const {
      children: t,
      defaultHeight: n,
      defaultWidth: r,
      disableHeight: i = !1,
      disableWidth: o = !1,
      nonce: s,
      onResize: u,
      style: f = {},
      tagName: p = "div",
      ...m
    } = this.props, {
      height: v,
      scaledHeight: y,
      scaledWidth: S,
      width: E
    } = this.state, w = {
      overflow: "visible"
    }, _ = {};
    let O = !1;
    return i || (v === 0 && (O = !0), w.height = 0, _.height = v, _.scaledHeight = y), o || (E === 0 && (O = !0), w.width = 0, _.width = E, _.scaledWidth = S), Ou(p, {
      ref: this._setRef,
      style: {
        ...w,
        ...f
      },
      ...m
    }, !O && t(_));
  }
}
function $t() {
  return $t = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $t.apply(null, arguments);
}
function K2(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Q2(e, t) {
  return Q2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Q2(e, t);
}
function oF(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Q2(e, t);
}
var n9 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Ewe(e, t) {
  return !!(e === t || n9(e) && n9(t));
}
function _we(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Ewe(e[n], t[n]))
      return !1;
  return !0;
}
function $k(e, t) {
  t === void 0 && (t = _we);
  var n, r = [], i, o = !1;
  function s() {
    for (var u = [], f = 0; f < arguments.length; f++)
      u[f] = arguments[f];
    return o && n === this && t(u, r) || (i = e.apply(this, u), o = !0, n = this, r = u), i;
  }
  return s;
}
function Dl(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var aF = {}, Cwe = typeof performance == "object" && typeof performance.now == "function", r9 = Cwe ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function i9(e) {
  cancelAnimationFrame(e.id);
}
function Rwe(e, t) {
  var n = r9();
  function r() {
    r9() - n >= t ? e.call(null) : i.id = requestAnimationFrame(r);
  }
  var i = {
    id: requestAnimationFrame(r)
  };
  return i;
}
var Gk = -1;
function o9(e) {
  if (e === void 0 && (e = !1), Gk === -1 || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(t), Gk = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return Gk;
}
var O0 = null;
function a9(e) {
  if (e === void 0 && (e = !1), O0 === null || e) {
    var t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var r = document.createElement("div"), i = r.style;
    return i.width = "100px", i.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? O0 = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? O0 = "negative" : O0 = "positive-ascending"), document.body.removeChild(t), O0;
  }
  return O0;
}
var Owe = 150, Awe = function(t, n) {
  return t;
}, IO = null, PO = null;
aF.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (IO = /* @__PURE__ */ new WeakSet(), PO = /* @__PURE__ */ new WeakSet());
function Dwe(e) {
  var t, n = e.getItemOffset, r = e.getEstimatedTotalSize, i = e.getItemSize, o = e.getOffsetForIndexAndAlignment, s = e.getStartIndexForOffset, u = e.getStopIndexForStartIndex, f = e.initInstanceProps, p = e.shouldResetStyleCacheOnItemSizeChange, m = e.validateProps;
  return t = /* @__PURE__ */ (function(v) {
    oF(y, v);
    function y(E) {
      var w;
      return w = v.call(this, E) || this, w._instanceProps = f(w.props, K2(w)), w._outerRef = void 0, w._resetIsScrollingTimeoutId = null, w.state = {
        instance: K2(w),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof w.props.initialScrollOffset == "number" ? w.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, w._callOnItemsRendered = void 0, w._callOnItemsRendered = $k(function(_, O, D, P) {
        return w.props.onItemsRendered({
          overscanStartIndex: _,
          overscanStopIndex: O,
          visibleStartIndex: D,
          visibleStopIndex: P
        });
      }), w._callOnScroll = void 0, w._callOnScroll = $k(function(_, O, D) {
        return w.props.onScroll({
          scrollDirection: _,
          scrollOffset: O,
          scrollUpdateWasRequested: D
        });
      }), w._getItemStyle = void 0, w._getItemStyle = function(_) {
        var O = w.props, D = O.direction, P = O.itemSize, M = O.layout, N = w._getItemStyleCache(p && P, p && M, p && D), k;
        if (N.hasOwnProperty(_))
          k = N[_];
        else {
          var U = n(w.props, _, w._instanceProps), H = i(w.props, _, w._instanceProps), Y = D === "horizontal" || M === "horizontal", z = D === "rtl", V = Y ? U : 0;
          N[_] = k = {
            position: "absolute",
            left: z ? void 0 : V,
            right: z ? V : void 0,
            top: Y ? 0 : U,
            height: Y ? "100%" : H,
            width: Y ? H : "100%"
          };
        }
        return k;
      }, w._getItemStyleCache = void 0, w._getItemStyleCache = $k(function(_, O, D) {
        return {};
      }), w._onScrollHorizontal = function(_) {
        var O = _.currentTarget, D = O.clientWidth, P = O.scrollLeft, M = O.scrollWidth;
        w.setState(function(N) {
          if (N.scrollOffset === P)
            return null;
          var k = w.props.direction, U = P;
          if (k === "rtl")
            switch (a9()) {
              case "negative":
                U = -P;
                break;
              case "positive-descending":
                U = M - D - P;
                break;
            }
          return U = Math.max(0, Math.min(U, M - D)), {
            isScrolling: !0,
            scrollDirection: N.scrollOffset < U ? "forward" : "backward",
            scrollOffset: U,
            scrollUpdateWasRequested: !1
          };
        }, w._resetIsScrollingDebounced);
      }, w._onScrollVertical = function(_) {
        var O = _.currentTarget, D = O.clientHeight, P = O.scrollHeight, M = O.scrollTop;
        w.setState(function(N) {
          if (N.scrollOffset === M)
            return null;
          var k = Math.max(0, Math.min(M, P - D));
          return {
            isScrolling: !0,
            scrollDirection: N.scrollOffset < k ? "forward" : "backward",
            scrollOffset: k,
            scrollUpdateWasRequested: !1
          };
        }, w._resetIsScrollingDebounced);
      }, w._outerRefSetter = function(_) {
        var O = w.props.outerRef;
        w._outerRef = _, typeof O == "function" ? O(_) : O != null && typeof O == "object" && O.hasOwnProperty("current") && (O.current = _);
      }, w._resetIsScrollingDebounced = function() {
        w._resetIsScrollingTimeoutId !== null && i9(w._resetIsScrollingTimeoutId), w._resetIsScrollingTimeoutId = Rwe(w._resetIsScrolling, Owe);
      }, w._resetIsScrolling = function() {
        w._resetIsScrollingTimeoutId = null, w.setState({
          isScrolling: !1
        }, function() {
          w._getItemStyleCache(-1, null);
        });
      }, w;
    }
    y.getDerivedStateFromProps = function(w, _) {
      return Iwe(w, _), m(w), null;
    };
    var S = y.prototype;
    return S.scrollTo = function(w) {
      w = Math.max(0, w), this.setState(function(_) {
        return _.scrollOffset === w ? null : {
          scrollDirection: _.scrollOffset < w ? "forward" : "backward",
          scrollOffset: w,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, S.scrollToItem = function(w, _) {
      _ === void 0 && (_ = "auto");
      var O = this.props, D = O.itemCount, P = O.layout, M = this.state.scrollOffset;
      w = Math.max(0, Math.min(w, D - 1));
      var N = 0;
      if (this._outerRef) {
        var k = this._outerRef;
        P === "vertical" ? N = k.scrollWidth > k.clientWidth ? o9() : 0 : N = k.scrollHeight > k.clientHeight ? o9() : 0;
      }
      this.scrollTo(o(this.props, w, _, M, this._instanceProps, N));
    }, S.componentDidMount = function() {
      var w = this.props, _ = w.direction, O = w.initialScrollOffset, D = w.layout;
      if (typeof O == "number" && this._outerRef != null) {
        var P = this._outerRef;
        _ === "horizontal" || D === "horizontal" ? P.scrollLeft = O : P.scrollTop = O;
      }
      this._callPropsCallbacks();
    }, S.componentDidUpdate = function() {
      var w = this.props, _ = w.direction, O = w.layout, D = this.state, P = D.scrollOffset, M = D.scrollUpdateWasRequested;
      if (M && this._outerRef != null) {
        var N = this._outerRef;
        if (_ === "horizontal" || O === "horizontal")
          if (_ === "rtl")
            switch (a9()) {
              case "negative":
                N.scrollLeft = -P;
                break;
              case "positive-ascending":
                N.scrollLeft = P;
                break;
              default:
                var k = N.clientWidth, U = N.scrollWidth;
                N.scrollLeft = U - k - P;
                break;
            }
          else
            N.scrollLeft = P;
        else
          N.scrollTop = P;
      }
      this._callPropsCallbacks();
    }, S.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && i9(this._resetIsScrollingTimeoutId);
    }, S.render = function() {
      var w = this.props, _ = w.children, O = w.className, D = w.direction, P = w.height, M = w.innerRef, N = w.innerElementType, k = w.innerTagName, U = w.itemCount, H = w.itemData, Y = w.itemKey, z = Y === void 0 ? Awe : Y, V = w.layout, F = w.outerElementType, X = w.outerTagName, oe = w.style, re = w.useIsScrolling, Z = w.width, ee = this.state.isScrolling, J = D === "horizontal" || V === "horizontal", le = J ? this._onScrollHorizontal : this._onScrollVertical, be = this._getRangeToRender(), ne = be[0], ae = be[1], ie = [];
      if (U > 0)
        for (var he = ne; he <= ae; he++)
          ie.push(Ou(_, {
            data: H,
            key: z(he, H),
            index: he,
            isScrolling: re ? ee : void 0,
            style: this._getItemStyle(he)
          }));
      var pe = r(this.props, this._instanceProps);
      return Ou(F || X || "div", {
        className: O,
        onScroll: le,
        ref: this._outerRefSetter,
        style: $t({
          position: "relative",
          height: P,
          width: Z,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: D
        }, oe)
      }, Ou(N || k || "div", {
        children: ie,
        ref: M,
        style: {
          height: J ? "100%" : pe,
          pointerEvents: ee ? "none" : void 0,
          width: J ? pe : "100%"
        }
      }));
    }, S._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var w = this.props.itemCount;
        if (w > 0) {
          var _ = this._getRangeToRender(), O = _[0], D = _[1], P = _[2], M = _[3];
          this._callOnItemsRendered(O, D, P, M);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var N = this.state, k = N.scrollDirection, U = N.scrollOffset, H = N.scrollUpdateWasRequested;
        this._callOnScroll(k, U, H);
      }
    }, S._getRangeToRender = function() {
      var w = this.props, _ = w.itemCount, O = w.overscanCount, D = this.state, P = D.isScrolling, M = D.scrollDirection, N = D.scrollOffset;
      if (_ === 0)
        return [0, 0, 0, 0];
      var k = s(this.props, N, this._instanceProps), U = u(this.props, k, N, this._instanceProps), H = !P || M === "backward" ? Math.max(1, O) : 1, Y = !P || M === "forward" ? Math.max(1, O) : 1;
      return [Math.max(0, k - H), Math.max(0, Math.min(_ - 1, U + Y)), k, U];
    }, y;
  })(oU), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var Iwe = function(t, n) {
  var r = t.children, i = t.direction, o = t.height, s = t.layout, u = t.innerTagName, f = t.outerTagName, p = t.width, m = n.instance;
  if (aF.NODE_ENV !== "production") {
    (u != null || f != null) && PO && !PO.has(m) && (PO.add(m), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var v = i === "horizontal" || s === "horizontal";
    switch (i) {
      case "horizontal":
      case "vertical":
        IO && !IO.has(m) && (IO.add(m), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + i + '" was specified.'));
    }
    switch (s) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + s + '" was specified.'));
    }
    if (r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    if (v && typeof p != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (p === null ? "null" : typeof p) + '" was specified.'));
    if (!v && typeof o != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (o === null ? "null" : typeof o) + '" was specified.'));
  }
}, Pwe = 50, H0 = function(t, n, r) {
  var i = t, o = i.itemSize, s = r.itemMetadataMap, u = r.lastMeasuredIndex;
  if (n > u) {
    var f = 0;
    if (u >= 0) {
      var p = s[u];
      f = p.offset + p.size;
    }
    for (var m = u + 1; m <= n; m++) {
      var v = o(m);
      s[m] = {
        offset: f,
        size: v
      }, f += v;
    }
    r.lastMeasuredIndex = n;
  }
  return s[n];
}, Nwe = function(t, n, r) {
  var i = n.itemMetadataMap, o = n.lastMeasuredIndex, s = o > 0 ? i[o].offset : 0;
  return s >= r ? ore(t, n, o, 0, r) : Mwe(t, n, Math.max(0, o), r);
}, ore = function(t, n, r, i, o) {
  for (; i <= r; ) {
    var s = i + Math.floor((r - i) / 2), u = H0(t, s, n).offset;
    if (u === o)
      return s;
    u < o ? i = s + 1 : u > o && (r = s - 1);
  }
  return i > 0 ? i - 1 : 0;
}, Mwe = function(t, n, r, i) {
  for (var o = t.itemCount, s = 1; r < o && H0(t, r, n).offset < i; )
    r += s, s *= 2;
  return ore(t, n, Math.min(r, o - 1), Math.floor(r / 2), i);
}, s9 = function(t, n) {
  var r = t.itemCount, i = n.itemMetadataMap, o = n.estimatedItemSize, s = n.lastMeasuredIndex, u = 0;
  if (s >= r && (s = r - 1), s >= 0) {
    var f = i[s];
    u = f.offset + f.size;
  }
  var p = r - s - 1, m = p * o;
  return u + m;
}, jwe = /* @__PURE__ */ Dwe({
  getItemOffset: function(t, n, r) {
    return H0(t, n, r).offset;
  },
  getItemSize: function(t, n, r) {
    return r.itemMetadataMap[n].size;
  },
  getEstimatedTotalSize: s9,
  getOffsetForIndexAndAlignment: function(t, n, r, i, o, s) {
    var u = t.direction, f = t.height, p = t.layout, m = t.width, v = u === "horizontal" || p === "horizontal", y = v ? m : f, S = H0(t, n, o), E = s9(t, o), w = Math.max(0, Math.min(E - y, S.offset)), _ = Math.max(0, S.offset - y + S.size + s);
    switch (r === "smart" && (i >= _ - y && i <= w + y ? r = "auto" : r = "center"), r) {
      case "start":
        return w;
      case "end":
        return _;
      case "center":
        return Math.round(_ + (w - _) / 2);
      case "auto":
      default:
        return i >= _ && i <= w ? i : i < _ ? _ : w;
    }
  },
  getStartIndexForOffset: function(t, n, r) {
    return Nwe(t, r, n);
  },
  getStopIndexForStartIndex: function(t, n, r, i) {
    for (var o = t.direction, s = t.height, u = t.itemCount, f = t.layout, p = t.width, m = o === "horizontal" || f === "horizontal", v = m ? p : s, y = H0(t, n, i), S = r + v, E = y.offset + y.size, w = n; w < u - 1 && E < S; )
      w++, E += H0(t, w, i).size;
    return w;
  },
  initInstanceProps: function(t, n) {
    var r = t, i = r.estimatedItemSize, o = {
      itemMetadataMap: {},
      estimatedItemSize: i || Pwe,
      lastMeasuredIndex: -1
    };
    return n.resetAfterIndex = function(s, u) {
      u === void 0 && (u = !0), o.lastMeasuredIndex = Math.min(o.lastMeasuredIndex, s - 1), n._getItemStyleCache(-1), u && n.forceUpdate();
    }, o;
  },
  shouldResetStyleCacheOnItemSizeChange: !1,
  validateProps: function(t) {
    var n = t.itemSize;
    if (aF.NODE_ENV !== "production" && typeof n != "function")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a function. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
}), Yk = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var l9;
function Lwe() {
  return l9 || (l9 = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var o = "", s = 0; s < arguments.length; s++) {
          var u = arguments[s];
          u && (o = i(o, r(u)));
        }
        return o;
      }
      function r(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return n.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var s = "";
        for (var u in o)
          t.call(o, u) && o[u] && (s = i(s, u));
        return s;
      }
      function i(o, s) {
        return s ? o ? o + " " + s : o + s : o;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(Yk)), Yk.exports;
}
var kwe = Lwe();
const On = /* @__PURE__ */ Hn(kwe);
function zwe() {
  const e = Ba(Ho);
  return { get: (t) => t && new OD(t.map(e)) };
}
function Bwe(e, t) {
  return Ba((n) => mD(n, e, t), [e, t]);
}
function Vwe(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Uwe(e) {
  return parseFloat(e);
}
function are(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : a1(t.components[n].defaultProps, r);
}
function sre({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let i = Yne(n);
  return r && (i = i[r] || i), are({
    theme: i,
    name: t,
    props: e
  });
}
function Fwe({
  props: e,
  name: t
}) {
  return sre({
    props: e,
    name: t,
    defaultTheme: KD,
    themeId: Ac
  });
}
function Wwe({
  theme: e,
  ...t
}) {
  const n = Ac in e ? e[Ac] : void 0;
  return /* @__PURE__ */ T.jsx(mhe, {
    ...t,
    themeId: n ? Ac : void 0,
    theme: n || e
  });
}
const zR = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: Hwe,
  useColorScheme: zmt,
  getInitColorSchemeScript: Bmt
} = vhe({
  themeId: Ac,
  // @ts-ignore ignore module augmentation tests
  theme: () => d_({
    cssVariables: !0
  }),
  colorSchemeStorageKey: zR.colorSchemeStorageKey,
  modeStorageKey: zR.modeStorageKey,
  defaultColorScheme: {
    light: zR.defaultLightColorScheme,
    dark: zR.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: Xne(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return kv({
        sx: r,
        theme: this
      });
    }, t;
  }
}), qwe = Hwe;
function $we({
  theme: e,
  ...t
}) {
  const n = $.useMemo(() => {
    if (typeof e == "function")
      return e;
    const r = Ac in e ? e[Ac] : e;
    return "colorSchemes" in r ? null : "vars" in r ? e : {
      ...e,
      vars: null
    };
  }, [e]);
  return n ? /* @__PURE__ */ T.jsx(Wwe, {
    theme: n,
    ...t
  }) : /* @__PURE__ */ T.jsx(qwe, {
    theme: e,
    ...t
  });
}
var Gwe = Object.defineProperty, Ywe = (e, t, n) => t in e ? Gwe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, BR = (e, t, n) => (Ywe(e, typeof t != "symbol" ? t + "" : t, n), n), J2 = /* @__PURE__ */ new Map(), VR = /* @__PURE__ */ new WeakMap(), c9 = 0, Xwe = void 0;
function Zwe(e) {
  return e ? (VR.has(e) || (c9 += 1, VR.set(e, c9.toString())), VR.get(e)) : "0";
}
function Kwe(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? Zwe(e.root) : e[t]}`).toString();
}
function Qwe(e) {
  const t = Kwe(e);
  let n = J2.get(t);
  if (!n) {
    const r = /* @__PURE__ */ new Map();
    let i;
    const o = new IntersectionObserver((s) => {
      s.forEach((u) => {
        var f;
        const p = u.isIntersecting && i.some((m) => u.intersectionRatio >= m);
        e.trackVisibility && typeof u.isVisible > "u" && (u.isVisible = p), (f = r.get(u.target)) == null || f.forEach((m) => {
          m(p, u);
        });
      });
    }, e);
    i = o.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: o,
      elements: r
    }, J2.set(t, n);
  }
  return n;
}
function lre(e, t, n = {}, r = Xwe) {
  if (typeof window.IntersectionObserver > "u" && r !== void 0) {
    const f = e.getBoundingClientRect();
    return t(r, {
      isIntersecting: r,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: f,
      intersectionRect: f,
      rootBounds: f
    }), () => {
    };
  }
  const { id: i, observer: o, elements: s } = Qwe(n), u = s.get(e) || [];
  return s.has(e) || s.set(e, u), u.push(t), o.observe(e), function() {
    u.splice(u.indexOf(t), 1), u.length === 0 && (s.delete(e), o.unobserve(e)), s.size === 0 && (o.disconnect(), J2.delete(i));
  };
}
function Jwe(e) {
  return typeof e.children != "function";
}
var eTe = class extends $.Component {
  constructor(e) {
    super(e), BR(this, "node", null), BR(this, "_unobserveCb", null), BR(this, "handleNode", (t) => {
      this.node && (this.unobserve(), !t && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = t || null, this.observeNode();
    }), BR(this, "handleChange", (t, n) => {
      t && this.props.triggerOnce && this.unobserve(), Jwe(this.props) || this.setState({ inView: t, entry: n }), this.props.onChange && this.props.onChange(t, n);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold: e,
      root: t,
      rootMargin: n,
      trackVisibility: r,
      delay: i,
      fallbackInView: o
    } = this.props;
    this._unobserveCb = lre(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: t,
        rootMargin: n,
        // @ts-ignore
        trackVisibility: r,
        // @ts-ignore
        delay: i
      },
      o
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: S, entry: E } = this.state;
      return e({ inView: S, entry: E, ref: this.handleNode });
    }
    const {
      as: t,
      triggerOnce: n,
      threshold: r,
      root: i,
      rootMargin: o,
      onChange: s,
      skip: u,
      trackVisibility: f,
      delay: p,
      initialInView: m,
      fallbackInView: v,
      ...y
    } = this.props;
    return $.createElement(
      t || "div",
      { ref: this.handleNode, ...y },
      e
    );
  }
};
function tTe({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: r,
  root: i,
  triggerOnce: o,
  skip: s,
  initialInView: u,
  fallbackInView: f,
  onChange: p
} = {}) {
  var m;
  const [v, y] = $.useState(null), S = $.useRef(), [E, w] = $.useState({
    inView: !!u,
    entry: void 0
  });
  S.current = p, $.useEffect(
    () => {
      if (s || !v)
        return;
      let P;
      return P = lre(
        v,
        (M, N) => {
          w({
            inView: M,
            entry: N
          }), S.current && S.current(M, N), N.isIntersecting && o && P && (P(), P = void 0);
        },
        {
          root: i,
          rootMargin: r,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        f
      ), () => {
        P && P();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      v,
      i,
      r,
      o,
      s,
      n,
      f,
      t
    ]
  );
  const _ = (m = E.entry) == null ? void 0 : m.target, O = $.useRef();
  !v && _ && !o && !s && O.current !== _ && (O.current = _, w({
    inView: !!u,
    entry: void 0
  }));
  const D = [y, E.inView, E.entry];
  return D.ref = D[0], D.inView = D[1], D.entry = D[2], D;
}
const JD = hg();
function Cc({ fallback: e, resource: t }) {
  const n = Qi(JD), r = Ba((o) => z1(o, {}));
  if (!t) return e;
  const i = t.getLabel();
  return i ? i.getValue(n || r || "") ?? (e || t.id) : e;
}
Cc.propTypes = {
  fallback: c.string,
  resource: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const nTe = ye("div", { name: "IIIFThumbnail", slot: "root" })({}), rTe = ye("span", { name: "IIIFThumbnail", slot: "label" })(({ theme: e }) => ({
  ...e.typography.caption
})), iTe = ye("img", { name: "IIIFThumbnail", slot: "image" })(() => ({
  height: "auto",
  width: "auto"
})), cre = ({
  border: e = !1,
  placeholder: t,
  style: n = {},
  thumbnail: r = null,
  resource: i,
  maxHeight: o = null,
  maxWidth: s = null,
  ...u
}) => {
  const { ref: f, inView: p } = tTe(), [m, v] = Bn(!1), y = Bwe(o, s);
  ln(() => {
    m || !p || v(!0);
  }, [p, m]);
  const S = Ui(() => {
    if (r) return r;
    const _ = y.get(i);
    if (_ && _.url) return _;
  }, [i, r, y]), E = Ui(() => {
    const _ = {
      height: void 0,
      maxHeight: void 0,
      maxWidth: void 0,
      width: void 0
    };
    if (!S) return { ...n, height: o, width: s };
    const { height: O, width: D } = S;
    if (O && D)
      if (o && O > o || s && D > s) {
        const P = D / O;
        o && s ? s / o < P ? (_.height = Math.round(s / P), _.width = s) : (_.height = o, _.width = Math.round(o * P)) : o ? (_.height = o, _.maxWidth = Math.round(o * P)) : s && (_.width = s, _.maxHeight = Math.round(s / P));
      } else
        _.width = D, _.height = O;
    else O && !D ? _.height = o : !O && D ? _.width = s : (_.width = s, _.height = o);
    return {
      ..._,
      ...n
    };
  }, [S, s, o, n]), { url: w = t } = m && (r || S) || {};
  return /* @__PURE__ */ T.jsx(
    iTe,
    {
      ownerState: { border: e },
      ref: f,
      alt: "",
      role: "presentation",
      src: w,
      style: E,
      ...u
    }
  );
};
cre.propTypes = {
  border: c.bool,
  maxHeight: c.number,
  maxWidth: c.number,
  placeholder: c.string.isRequired,
  resource: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  style: c.object,
  // eslint-disable-line react/forbid-prop-types
  thumbnail: c.shape({
    height: c.number,
    url: c.string.isRequired,
    width: c.number
  })
};
const oTe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMMDQmtBwADgwF/Op8FmAAAAABJRU5ErkJggg==";
function ure({
  border: e = !1,
  children: t = null,
  imagePlaceholder: n = oTe,
  label: r = void 0,
  labelled: i = !1,
  maxHeight: o = null,
  maxWidth: s = null,
  resource: u,
  style: f = {},
  thumbnail: p = null
}) {
  const m = arguments[0];
  return /* @__PURE__ */ T.jsxs(nTe, { ownerState: m, children: [
    /* @__PURE__ */ T.jsx(
      cre,
      {
        placeholder: n,
        thumbnail: p,
        resource: u,
        maxHeight: o,
        maxWidth: s,
        style: f,
        border: e
      }
    ),
    i && /* @__PURE__ */ T.jsx(rTe, { ownerState: m, children: r || /* @__PURE__ */ T.jsx(Cc, { resource: u }) }),
    t
  ] });
}
ure.propTypes = {
  border: c.bool,
  children: c.node,
  imagePlaceholder: c.string,
  label: c.string,
  labelled: c.bool,
  maxHeight: c.number,
  maxWidth: c.number,
  resource: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  style: c.object,
  // eslint-disable-line react/forbid-prop-types
  thumbnail: c.shape({
    height: c.number,
    url: c.string.isRequired,
    width: c.number
  }),
  variant: c.oneOf(["inside", "outside"])
  // eslint-disable-line react/no-unused-prop-types
};
const aTe = (e) => ({
  thumbnailsConfig: Dn(e).thumbnails
}), sTe = wt(
  At(aTe),
  Tt("IIIFThumbnail")
), jx = sTe(ure), Nt = (e) => vn([e]).map(
  (t) => [
    Pv.createGenerateClassNameOptions.productionPrefix,
    t
  ].join("-")
).join(" "), lTe = ye("div")(({ theme: e }) => ({
  boxSizing: "border-box",
  color: e.palette.common.white,
  cursor: "pointer",
  display: "inline-block",
  whiteSpace: "nowrap"
}));
let dre = class extends oU {
  /** */
  constructor(t) {
    super(t), this.setCanvas = this.setCanvas.bind(this);
  }
  /** */
  setCanvas(t) {
    const { setCanvas: n } = this.props;
    n(t.currentTarget.dataset.canvasId);
  }
  /**
   * Determines whether the current index is the rendered canvas, providing
   * a useful class.
   */
  currentCanvasClass(t) {
    const { index: n } = this.props;
    return t.includes(n) ? "current-canvas-grouping" : "";
  }
  /** */
  render() {
    const {
      index: t,
      style: n,
      data: r,
      currentCanvasId: i,
      showThumbnailLabels: o
    } = this.props, {
      canvasGroupings: s,
      position: u,
      height: f
    } = r, p = s[t], m = 8;
    return /* @__PURE__ */ T.jsx(
      "div",
      {
        style: {
          ...n,
          boxSizing: "content-box",
          height: Number.isInteger(n.height) ? n.height - m : null,
          left: Number.isInteger(n.left) ? n.left + m : null,
          top: n.top + m,
          width: Number.isInteger(n.width) ? n.width - m : null
        },
        className: Nt("thumbnail-nav-container"),
        role: "gridcell",
        "aria-colindex": t + 1,
        children: /* @__PURE__ */ T.jsx(
          lTe,
          {
            role: "button",
            "data-canvas-id": p[0].id,
            "data-canvas-index": p[0].index,
            onKeyUp: this.setCanvas,
            onClick: this.setCanvas,
            tabIndex: -1,
            sx: (v) => ({
              "&:hover": {
                outline: `9px solid ${v.palette.action.hover}`,
                outlineOffset: "-2px"
              },
              height: u === "far-right" ? "auto" : `${f - m}px`,
              outline: p.map((y) => y.id).includes(i) ? `2px solid ${v.palette.primary.main}` : 0,
              ...p.map((y) => y.id).includes(i) && {
                outlineOffset: "3px"
              },
              width: u === "far-bottom" ? "auto" : `${n.width}px`
            }),
            className: On(
              Nt(["thumbnail-nav-canvas", `thumbnail-nav-canvas-${t}`, this.currentCanvasClass(p.map((v) => v.index))])
            ),
            children: p.map((v, y) => /* @__PURE__ */ T.jsx(
              jx,
              {
                resource: v,
                labelled: o,
                maxHeight: u === "far-right" ? n.height - 1.5 * m : f - 1.5 * m,
                variant: "inside"
              },
              v.id
            ))
          }
        )
      }
    );
  }
};
dre.propTypes = {
  currentCanvasId: c.string.isRequired,
  data: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  index: c.number.isRequired,
  setCanvas: c.func.isRequired,
  showThumbnailLabels: c.bool.isRequired,
  style: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const cTe = (e, { data: t }) => ({
  setCanvas: (...n) => e(Iu(t.windowId, ...n))
}), uTe = (e, { data: t }) => ({
  currentCanvasId: (Vl(e, { windowId: t.windowId }) || {}).id,
  showThumbnailLabels: Dn(e).thumbnailNavigation.showThumbnailLabels
}), dTe = wt(
  At(uTe, cTe),
  Tt("ThumbnailCanvasGrouping")
), fTe = dTe(dre);
function fre({
  canvasGroupings: e,
  canvasIndex: t,
  hasNextCanvas: n = !1,
  hasPreviousCanvas: r = !1,
  position: i,
  setNextCanvas: o = () => {
  },
  setPreviousCanvas: s = () => {
  },
  thumbnailNavigation: u,
  view: f = void 0,
  viewingDirection: p = "",
  windowId: m
}) {
  const { t: v } = Ct(), y = 15, S = 8, E = an(), w = an(f), _ = zwe();
  ln(() => {
    var V;
    w.current !== f && i !== "off" && (w.current = f, (V = E.current) == null || V.resetAfterIndex(0));
  }, [f, i]), ln(() => {
    var F;
    let V = t;
    f === "book" && (V = Math.ceil(V / 2)), (F = E.current) == null || F.scrollToItem(V, "center");
  }, [t, f]);
  const O = (V) => {
    let F = "ArrowRight", X = "ArrowLeft";
    switch (i === "far-right" && (F = "ArrowDown", X = "ArrowUp"), V.key) {
      case F:
        U();
        break;
      case X:
        H();
        break;
    }
  }, D = (V) => {
    const F = e[V];
    if (!F) return u.width + S;
    const oe = _.get(F).worldBounds();
    switch (i) {
      case "far-right": {
        const re = Math.floor(
          P(F.length) * oe[3] / oe[2]
        );
        return Number.isInteger(re) ? re + S : u.width + S;
      }
      // Default case bottom
      default:
        return oe[3] === 0 ? u.width + S : Math.ceil(
          (u.height - y - S - 4) * oe[2] / oe[3]
        );
    }
  }, P = (V) => V === 1 ? u.width : u.width * 2, M = Yn(() => {
    const V = f === "book" ? u.width * 2 : u.width;
    switch (i) {
      case "far-right":
        return {
          height: "100%",
          minHeight: 0,
          width: `${V + y + S}px`
        };
      // Default case bottom
      default:
        return {
          height: `${u.height}px`,
          width: "100%"
        };
    }
  }, [i, u, f]), N = (V) => {
    switch (i) {
      case "far-right":
        return V;
      // Default case bottom
      default:
        return u.height;
    }
  }, k = () => e.length, U = () => {
    n && o();
  }, H = () => {
    r && s();
  };
  if (i === "off")
    return null;
  const Y = p === "right-to-left" ? "rtl" : "ltr", z = {
    canvasGroupings: e,
    height: u.height - S - y,
    position: i,
    windowId: m
  };
  return /* @__PURE__ */ T.jsx(
    Ei,
    {
      className: On(
        Nt("thumb-navigation")
      ),
      sx: {
        "&:focus": {
          boxShadow: 0,
          outline: 0
        }
      },
      "aria-label": v("thumbnailNavigation"),
      square: !0,
      elevation: 0,
      style: M(),
      tabIndex: 0,
      onKeyDown: O,
      role: "grid",
      children: /* @__PURE__ */ T.jsx("div", { role: "row", style: { height: "100%", width: "100%" }, children: e.length > 0 && /* @__PURE__ */ T.jsx(
        Twe,
        {
          defaultHeight: 100,
          defaultWidth: 400,
          children: ({ height: V, width: F }) => /* @__PURE__ */ T.jsx(
            jwe,
            {
              direction: Y,
              height: N(V),
              itemCount: k(),
              itemSize: D,
              width: F,
              layout: i === "far-bottom" ? "horizontal" : "vertical",
              itemData: z,
              ref: E,
              children: fTe
            }
          )
        }
      ) })
    }
  );
}
fre.propTypes = {
  canvasGroupings: c.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  canvasIndex: c.number.isRequired,
  hasNextCanvas: c.bool,
  hasPreviousCanvas: c.bool,
  position: c.string.isRequired,
  setNextCanvas: c.func,
  setPreviousCanvas: c.func,
  thumbnailNavigation: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  view: c.string,
  viewingDirection: c.string,
  windowId: c.string.isRequired
};
const pTe = (e, { windowId: t }) => ({
  canvasGroupings: H1(e, { windowId: t }),
  canvasIndex: u3(e, { windowId: t }),
  hasNextCanvas: !!q1(e, { windowId: t }),
  hasPreviousCanvas: !!$1(e, { windowId: t }),
  position: ju(e, {
    companionWindowId: Wn(e, { windowId: t }).thumbnailNavigationId
  }).position,
  thumbnailNavigation: Dn(e).thumbnailNavigation,
  view: Nv(e, { windowId: t }),
  viewingDirection: Ix(e, { windowId: t })
}), hTe = (e, { windowId: t }) => ({
  setNextCanvas: (...n) => e(ID(t)),
  setPreviousCanvas: (...n) => e(PD(t))
}), gTe = wt(
  At(pTe, hTe),
  Tt("ThumbnailNavigation")
), mTe = gTe(fre);
function vTe(e) {
  return typeof e.main == "string";
}
function yTe(e, t = []) {
  if (!vTe(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function Jr(e = []) {
  return ([, t]) => t && yTe(t, e);
}
function bTe(e) {
  return Vt("MuiTypography", e);
}
const u9 = Wt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
var xTe = {};
const STe = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, wTe = vwe(), TTe = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: i,
    variant: o,
    classes: s
  } = e, u = {
    root: ["root", o, e.align !== "inherit" && `align${Ke(t)}`, n && "gutterBottom", r && "noWrap", i && "paragraph"]
  };
  return Ft(u, bTe, s);
}, ETe = ye("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${Ke(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(Lt(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(Jr()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${Ke(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), d9 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, St = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    color: r,
    ...i
  } = Gt({
    props: t,
    name: "MuiTypography"
  }), o = !STe[r], s = wTe({
    ...i,
    ...o && {
      color: r
    }
  }), {
    align: u = "inherit",
    className: f,
    component: p,
    gutterBottom: m = !1,
    noWrap: v = !1,
    paragraph: y = !1,
    variant: S = "body1",
    variantMapping: E = d9,
    ...w
  } = s, _ = {
    ...s,
    align: u,
    color: r,
    className: f,
    component: p,
    gutterBottom: m,
    noWrap: v,
    paragraph: y,
    variant: S,
    variantMapping: E
  }, O = p || (y ? "p" : E[S] || d9[S]) || "span", D = TTe(_);
  return /* @__PURE__ */ T.jsx(ETe, {
    as: O,
    ref: n,
    className: yt(D.root, f),
    ...w,
    ownerState: _,
    style: {
      ...u !== "inherit" && {
        "--Typography-textAlign": u
      },
      ...w.style
    }
  });
});
xTe.NODE_ENV !== "production" && (St.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: c.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: c.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: c.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: c.bool,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: c.oneOfType([c.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), c.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: c.object
});
function _Te(e) {
  return Vt("MuiSvgIcon", e);
}
Wt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
var CTe = {};
const RTe = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, i = {
    root: ["root", t !== "inherit" && `color${Ke(t)}`, `fontSize${Ke(n)}`]
  };
  return Ft(i, _Te, r);
}, OTe = ye("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Ke(n.color)}`], t[`fontSize${Ke(n.fontSize)}`]];
  }
})(Lt(({
  theme: e
}) => {
  var t, n, r, i, o, s, u, f, p, m, v, y, S, E;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (i = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : i.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (w) => !w.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((s = (o = e.typography) == null ? void 0 : o.pxToRem) == null ? void 0 : s.call(o, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((f = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : f.call(u, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((m = (p = e.typography) == null ? void 0 : p.pxToRem) == null ? void 0 : m.call(p, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, w]) => w && w.main).map(([w]) => {
        var _, O;
        return {
          props: {
            color: w
          },
          style: {
            color: (O = (_ = (e.vars ?? e).palette) == null ? void 0 : _[w]) == null ? void 0 : O.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (y = (v = (e.vars ?? e).palette) == null ? void 0 : v.action) == null ? void 0 : y.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (E = (S = (e.vars ?? e).palette) == null ? void 0 : S.action) == null ? void 0 : E.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Ha = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: o,
    color: s = "inherit",
    component: u = "svg",
    fontSize: f = "medium",
    htmlColor: p,
    inheritViewBox: m = !1,
    titleAccess: v,
    viewBox: y = "0 0 24 24",
    ...S
  } = r, E = /* @__PURE__ */ $.isValidElement(i) && i.type === "svg", w = {
    ...r,
    color: s,
    component: u,
    fontSize: f,
    instanceFontSize: t.fontSize,
    inheritViewBox: m,
    viewBox: y,
    hasSvgAsChild: E
  }, _ = {};
  m || (_.viewBox = y);
  const O = RTe(w);
  return /* @__PURE__ */ T.jsxs(OTe, {
    as: u,
    className: yt(O.root, o),
    focusable: "false",
    color: p,
    "aria-hidden": v ? void 0 : !0,
    role: v ? "img" : void 0,
    ref: n,
    ..._,
    ...S,
    ...E && i.props,
    ownerState: w,
    children: [E ? i.props.children : i, v ? /* @__PURE__ */ T.jsx("title", {
      children: v
    }) : null]
  });
});
CTe.NODE_ENV !== "production" && (Ha.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: c.oneOfType([c.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: c.oneOfType([c.oneOf(["inherit", "large", "medium", "small"]), c.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: c.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: c.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: c.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: c.string
});
Ha.muiName = "SvgIcon";
var ATe = {};
function Mt(e, t) {
  function n(r, i) {
    return /* @__PURE__ */ T.jsx(Ha, {
      "data-testid": `${t}Icon`,
      ref: i,
      ...r,
      children: e
    });
  }
  return ATe.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Ha.muiName, /* @__PURE__ */ $.memo(/* @__PURE__ */ $.forwardRef(n));
}
function sF(e, t) {
  if (!e)
    return t;
  if (typeof e == "function" || typeof t == "function")
    return (i) => {
      const o = typeof t == "function" ? t(i) : t, s = typeof e == "function" ? e({
        ...i,
        ...o
      }) : e, u = yt(i == null ? void 0 : i.className, o == null ? void 0 : o.className, s == null ? void 0 : s.className);
      return {
        ...o,
        ...s,
        ...!!u && {
          className: u
        },
        ...(o == null ? void 0 : o.style) && (s == null ? void 0 : s.style) && {
          style: {
            ...o.style,
            ...s.style
          }
        },
        ...(o == null ? void 0 : o.sx) && (s == null ? void 0 : s.sx) && {
          sx: [...Array.isArray(o.sx) ? o.sx : [o.sx], ...Array.isArray(s.sx) ? s.sx : [s.sx]]
        }
      };
    };
  const n = t, r = yt(n == null ? void 0 : n.className, e == null ? void 0 : e.className);
  return {
    ...t,
    ...e,
    ...!!r && {
      className: r
    },
    ...(n == null ? void 0 : n.style) && (e == null ? void 0 : e.style) && {
      style: {
        ...n.style,
        ...e.style
      }
    },
    ...(n == null ? void 0 : n.sx) && (e == null ? void 0 : e.sx) && {
      sx: [...Array.isArray(n.sx) ? n.sx : [n.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
const pre = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "VisibilitySharp"), hre = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 6.5c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24M3.42 2.45 2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.97-.3 4.31-.82l3.43 3.43 1.41-1.41zM12 16.5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5m2.97-5.33c-.15-1.4-1.25-2.49-2.64-2.64z"
}), "VisibilityOffSharp");
function DTe(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: r = 99,
    showZero: i = !1
  } = e, o = rF({
    badgeContent: t,
    max: r
  });
  let s = n;
  n === !1 && t === 0 && !i && (s = !0);
  const {
    badgeContent: u,
    max: f = r
  } = s ? o : e, p = u && Number(u) > f ? `${f}+` : u;
  return {
    badgeContent: u,
    invisible: s,
    max: f,
    displayValue: p
  };
}
function ITe(e) {
  return Vt("MuiBadge", e);
}
const Bh = Wt("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]);
function Xt(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: i,
    externalForwardedProps: o,
    internalForwardedProps: s,
    shouldForwardComponentProp: u = !1,
    ...f
  } = t, {
    component: p,
    slots: m = {
      [e]: void 0
    },
    slotProps: v = {
      [e]: void 0
    },
    ...y
  } = o, S = m[e] || r, E = Yh(v[e], i), {
    props: {
      component: w,
      ..._
    },
    internalRef: O
  } = $ne({
    className: n,
    ...f,
    externalForwardedProps: e === "root" ? y : void 0,
    externalSlotProps: E
  }), D = kr(O, E == null ? void 0 : E.ref, t.ref), P = e === "root" ? w || p : w, M = qne(S, {
    ...e === "root" && !p && !m[e] && s,
    ...e !== "root" && !m[e] && s,
    ..._,
    ...P && !u && {
      as: P
    },
    ...P && u && {
      component: P
    },
    ref: D
  }, i);
  return [S, M];
}
var PTe = {};
const Xk = 10, Zk = 4, NTe = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: r,
    overlap: i,
    variant: o,
    classes: s = {}
  } = e, u = {
    root: ["root"],
    badge: ["badge", o, r && "invisible", `anchorOrigin${Ke(n.vertical)}${Ke(n.horizontal)}`, `anchorOrigin${Ke(n.vertical)}${Ke(n.horizontal)}${Ke(i)}`, `overlap${Ke(i)}`, t !== "default" && `color${Ke(t)}`]
  };
  return Ft(u, ITe, s);
}, MTe = ye("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), jTe = ye("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${Ke(n.anchorOrigin.vertical)}${Ke(n.anchorOrigin.horizontal)}${Ke(n.overlap)}`], n.color !== "default" && t[`color${Ke(n.color)}`], n.invisible && t.invisible];
  }
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: Xk * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: Xk * 2,
  borderRadius: Xk,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter(Jr(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: Zk,
      height: Zk * 2,
      minWidth: Zk * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Bh.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function f9(e) {
  return {
    vertical: (e == null ? void 0 : e.vertical) ?? "top",
    horizontal: (e == null ? void 0 : e.horizontal) ?? "right"
  };
}
const _c = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: i,
    className: o,
    classes: s,
    component: u,
    components: f = {},
    componentsProps: p = {},
    children: m,
    overlap: v = "rectangular",
    color: y = "default",
    invisible: S = !1,
    max: E = 99,
    badgeContent: w,
    slots: _,
    slotProps: O,
    showZero: D = !1,
    variant: P = "standard",
    ...M
  } = r, {
    badgeContent: N,
    invisible: k,
    max: U,
    displayValue: H
  } = DTe({
    max: E,
    invisible: S,
    badgeContent: w,
    showZero: D
  }), Y = rF({
    anchorOrigin: f9(i),
    color: y,
    overlap: v,
    variant: P,
    badgeContent: w
  }), z = k || N == null && P !== "dot", {
    color: V = y,
    overlap: F = v,
    anchorOrigin: X,
    variant: oe = P
  } = z ? Y : r, re = f9(X), Z = oe !== "dot" ? H : void 0, ee = {
    ...r,
    badgeContent: N,
    invisible: z,
    max: U,
    displayValue: Z,
    showZero: D,
    anchorOrigin: re,
    color: V,
    overlap: F,
    variant: oe
  }, J = NTe(ee), le = {
    slots: {
      root: (_ == null ? void 0 : _.root) ?? f.Root,
      badge: (_ == null ? void 0 : _.badge) ?? f.Badge
    },
    slotProps: {
      root: (O == null ? void 0 : O.root) ?? p.root,
      badge: (O == null ? void 0 : O.badge) ?? p.badge
    }
  }, [be, ne] = Xt("root", {
    elementType: MTe,
    externalForwardedProps: {
      ...le,
      ...M
    },
    ownerState: ee,
    className: yt(J.root, o),
    ref: n,
    additionalProps: {
      as: u
    }
  }), [ae, ie] = Xt("badge", {
    elementType: jTe,
    externalForwardedProps: le,
    ownerState: ee,
    className: J.badge
  });
  return /* @__PURE__ */ T.jsxs(be, {
    ...ne,
    children: [m, /* @__PURE__ */ T.jsx(ae, {
      ...ie,
      children: Z
    })]
  });
});
PTe.NODE_ENV !== "production" && (_c.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: c.shape({
    horizontal: c.oneOf(["left", "right"]),
    vertical: c.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: c.node,
  /**
   * The badge will be added relative to this node.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Badge: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    badge: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: c.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: c.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: c.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: c.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    badge: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    badge: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: c.oneOfType([c.oneOf(["dot", "standard"]), c.string])
});
class lA {
  constructor() {
    Un(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new lA();
  }
  static use() {
    const t = Fne(lA.create).current, [n, r] = $.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, $.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = kTe(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function LTe() {
  return lA.use();
}
function kTe() {
  let e, t;
  const n = new Promise((r, i) => {
    e = r, t = i;
  });
  return n.resolve = e, n.reject = t, n;
}
const p9 = {
  disabled: !1
};
var gre = {}, zTe = gre.NODE_ENV !== "production" ? c.oneOfType([c.number, c.shape({
  enter: c.number,
  exit: c.number,
  appear: c.number
}).isRequired]) : null;
gre.NODE_ENV !== "production" && c.oneOfType([c.string, c.shape({
  enter: c.string,
  exit: c.string,
  active: c.string
}), c.shape({
  enter: c.string,
  enterDone: c.string,
  enterActive: c.string,
  exit: c.string,
  exitDone: c.string,
  exitActive: c.string
})]);
const cA = it.createContext(null);
var BTe = function(t) {
  return t.scrollTop;
}, VTe = {}, RE = "unmounted", uv = "exited", dv = "entering", B0 = "entered", eV = "exiting", Vc = /* @__PURE__ */ (function(e) {
  oF(t, e);
  function t(r, i) {
    var o;
    o = e.call(this, r, i) || this;
    var s = i, u = s && !s.isMounting ? r.enter : r.appear, f;
    return o.appearStatus = null, r.in ? u ? (f = uv, o.appearStatus = dv) : f = B0 : r.unmountOnExit || r.mountOnEnter ? f = RE : f = uv, o.state = {
      status: f
    }, o.nextCallback = null, o;
  }
  t.getDerivedStateFromProps = function(i, o) {
    var s = i.in;
    return s && o.status === RE ? {
      status: uv
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var o = null;
    if (i !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== dv && s !== B0 && (o = dv) : (s === dv || s === B0) && (o = eV);
    }
    this.updateStatus(!1, o);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, o, s, u;
    return o = s = u = i, i != null && typeof i != "number" && (o = i.exit, s = i.enter, u = i.appear !== void 0 ? i.appear : s), {
      exit: o,
      enter: s,
      appear: u
    };
  }, n.updateStatus = function(i, o) {
    if (i === void 0 && (i = !1), o !== null)
      if (this.cancelNextCallback(), o === dv) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : Pd.findDOMNode(this);
          s && BTe(s);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === uv && this.setState({
      status: RE
    });
  }, n.performEnter = function(i) {
    var o = this, s = this.props.enter, u = this.context ? this.context.isMounting : i, f = this.props.nodeRef ? [u] : [Pd.findDOMNode(this), u], p = f[0], m = f[1], v = this.getTimeouts(), y = u ? v.appear : v.enter;
    if (!i && !s || p9.disabled) {
      this.safeSetState({
        status: B0
      }, function() {
        o.props.onEntered(p);
      });
      return;
    }
    this.props.onEnter(p, m), this.safeSetState({
      status: dv
    }, function() {
      o.props.onEntering(p, m), o.onTransitionEnd(y, function() {
        o.safeSetState({
          status: B0
        }, function() {
          o.props.onEntered(p, m);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, o = this.props.exit, s = this.getTimeouts(), u = this.props.nodeRef ? void 0 : Pd.findDOMNode(this);
    if (!o || p9.disabled) {
      this.safeSetState({
        status: uv
      }, function() {
        i.props.onExited(u);
      });
      return;
    }
    this.props.onExit(u), this.safeSetState({
      status: eV
    }, function() {
      i.props.onExiting(u), i.onTransitionEnd(s.exit, function() {
        i.safeSetState({
          status: uv
        }, function() {
          i.props.onExited(u);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, o) {
    o = this.setNextCallback(o), this.setState(i, o);
  }, n.setNextCallback = function(i) {
    var o = this, s = !0;
    return this.nextCallback = function(u) {
      s && (s = !1, o.nextCallback = null, i(u));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, o) {
    this.setNextCallback(o);
    var s = this.props.nodeRef ? this.props.nodeRef.current : Pd.findDOMNode(this), u = i == null && !this.props.addEndListener;
    if (!s || u) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var f = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], p = f[0], m = f[1];
      this.props.addEndListener(p, m);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === RE)
      return null;
    var o = this.props, s = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var u = Dl(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ it.createElement(cA.Provider, {
        value: null
      }, typeof s == "function" ? s(i, u) : it.cloneElement(it.Children.only(s), u))
    );
  }, t;
})(it.Component);
Vc.contextType = cA;
Vc.propTypes = VTe.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: c.shape({
    current: typeof Element > "u" ? c.any : function(e, t, n, r, i, o) {
      var s = e[t];
      return c.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: c.oneOfType([c.func.isRequired, c.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: c.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: c.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: c.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: c.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: c.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: c.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = zTe;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return n.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: c.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: c.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: c.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: c.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: c.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: c.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: c.func
} : {};
function A0() {
}
Vc.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: A0,
  onEntering: A0,
  onEntered: A0,
  onExit: A0,
  onExiting: A0,
  onExited: A0
};
Vc.UNMOUNTED = RE;
Vc.EXITED = uv;
Vc.ENTERING = dv;
Vc.ENTERED = B0;
Vc.EXITING = eV;
function lF(e, t) {
  var n = function(o) {
    return t && X0(o) ? t(o) : o;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && aU.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    r[i.key] = n(i);
  }), r;
}
function UTe(e, t) {
  e = e || {}, t = t || {};
  function n(m) {
    return m in t ? t[m] : e[m];
  }
  var r = /* @__PURE__ */ Object.create(null), i = [];
  for (var o in e)
    o in t ? i.length && (r[o] = i, i = []) : i.push(o);
  var s, u = {};
  for (var f in t) {
    if (r[f])
      for (s = 0; s < r[f].length; s++) {
        var p = r[f][s];
        u[r[f][s]] = n(p);
      }
    u[f] = n(f);
  }
  for (s = 0; s < i.length; s++)
    u[i[s]] = n(i[s]);
  return u;
}
function Ev(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function FTe(e, t) {
  return lF(e.children, function(n) {
    return jd(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Ev(n, "appear", e),
      enter: Ev(n, "enter", e),
      exit: Ev(n, "exit", e)
    });
  });
}
function WTe(e, t, n) {
  var r = lF(e.children), i = UTe(t, r);
  return Object.keys(i).forEach(function(o) {
    var s = i[o];
    if (X0(s)) {
      var u = o in t, f = o in r, p = t[o], m = X0(p) && !p.props.in;
      f && (!u || m) ? i[o] = jd(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: Ev(s, "exit", e),
        enter: Ev(s, "enter", e)
      }) : !f && u && !m ? i[o] = jd(s, {
        in: !1
      }) : f && u && X0(p) && (i[o] = jd(s, {
        onExited: n.bind(null, s),
        in: p.props.in,
        exit: Ev(s, "exit", e),
        enter: Ev(s, "enter", e)
      }));
    }
  }), i;
}
var HTe = {}, qTe = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, $Te = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, cF = /* @__PURE__ */ (function(e) {
  oF(t, e);
  function t(r, i) {
    var o;
    o = e.call(this, r, i) || this;
    var s = o.handleExited.bind(K2(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, o;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, o) {
    var s = o.children, u = o.handleExited, f = o.firstRender;
    return {
      children: f ? FTe(i, u) : WTe(i, s, u),
      firstRender: !1
    };
  }, n.handleExited = function(i, o) {
    var s = lF(this.props.children);
    i.key in s || (i.props.onExited && i.props.onExited(o), this.mounted && this.setState(function(u) {
      var f = $t({}, u.children);
      return delete f[i.key], {
        children: f
      };
    }));
  }, n.render = function() {
    var i = this.props, o = i.component, s = i.childFactory, u = Dl(i, ["component", "childFactory"]), f = this.state.contextValue, p = qTe(this.state.children).map(s);
    return delete u.appear, delete u.enter, delete u.exit, o === null ? /* @__PURE__ */ it.createElement(cA.Provider, {
      value: f
    }, p) : /* @__PURE__ */ it.createElement(cA.Provider, {
      value: f
    }, /* @__PURE__ */ it.createElement(o, u, p));
  }, t;
})(it.Component);
cF.propTypes = HTe.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: c.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: c.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: c.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: c.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: c.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: c.func
} : {};
cF.defaultProps = $Te;
var GTe = {};
function mre(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: i,
    rippleY: o,
    rippleSize: s,
    in: u,
    onExited: f,
    timeout: p
  } = e, [m, v] = $.useState(!1), y = yt(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), S = {
    width: s,
    height: s,
    top: -(s / 2) + o,
    left: -(s / 2) + i
  }, E = yt(n.child, m && n.childLeaving, r && n.childPulsate);
  return !u && !m && v(!0), $.useEffect(() => {
    if (!u && f != null) {
      const w = setTimeout(f, p);
      return () => {
        clearTimeout(w);
      };
    }
  }, [f, u, p]), /* @__PURE__ */ T.jsx("span", {
    className: y,
    style: S,
    children: /* @__PURE__ */ T.jsx("span", {
      className: E
    })
  });
}
GTe.NODE_ENV !== "production" && (mre.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object.isRequired,
  className: c.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: c.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: c.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: c.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: c.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: c.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: c.number,
  /**
   * exit delay
   */
  timeout: c.number.isRequired
});
const Sc = Wt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
var YTe = {};
const tV = 550, XTe = 80, ZTe = Hv`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, KTe = Hv`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, QTe = Hv`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, JTe = ye("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), eEe = ye(mre, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${Sc.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${ZTe};
    animation-duration: ${tV}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${Sc.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${Sc.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${Sc.childLeaving} {
    opacity: 0;
    animation-name: ${KTe};
    animation-duration: ${tV}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${Sc.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${QTe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, vre = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: o = {},
    className: s,
    ...u
  } = r, [f, p] = $.useState([]), m = $.useRef(0), v = $.useRef(null);
  $.useEffect(() => {
    v.current && (v.current(), v.current = null);
  }, [f]);
  const y = $.useRef(!1), S = eg(), E = $.useRef(null), w = $.useRef(null), _ = $.useCallback((M) => {
    const {
      pulsate: N,
      rippleX: k,
      rippleY: U,
      rippleSize: H,
      cb: Y
    } = M;
    p((z) => [...z, /* @__PURE__ */ T.jsx(eEe, {
      classes: {
        ripple: yt(o.ripple, Sc.ripple),
        rippleVisible: yt(o.rippleVisible, Sc.rippleVisible),
        ripplePulsate: yt(o.ripplePulsate, Sc.ripplePulsate),
        child: yt(o.child, Sc.child),
        childLeaving: yt(o.childLeaving, Sc.childLeaving),
        childPulsate: yt(o.childPulsate, Sc.childPulsate)
      },
      timeout: tV,
      pulsate: N,
      rippleX: k,
      rippleY: U,
      rippleSize: H
    }, m.current)]), m.current += 1, v.current = Y;
  }, [o]), O = $.useCallback((M = {}, N = {}, k = () => {
  }) => {
    const {
      pulsate: U = !1,
      center: H = i || N.pulsate,
      fakeElement: Y = !1
      // For test purposes
    } = N;
    if ((M == null ? void 0 : M.type) === "mousedown" && y.current) {
      y.current = !1;
      return;
    }
    (M == null ? void 0 : M.type) === "touchstart" && (y.current = !0);
    const z = Y ? null : w.current, V = z ? z.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let F, X, oe;
    if (H || M === void 0 || M.clientX === 0 && M.clientY === 0 || !M.clientX && !M.touches)
      F = Math.round(V.width / 2), X = Math.round(V.height / 2);
    else {
      const {
        clientX: re,
        clientY: Z
      } = M.touches && M.touches.length > 0 ? M.touches[0] : M;
      F = Math.round(re - V.left), X = Math.round(Z - V.top);
    }
    if (H)
      oe = Math.sqrt((2 * V.width ** 2 + V.height ** 2) / 3), oe % 2 === 0 && (oe += 1);
    else {
      const re = Math.max(Math.abs((z ? z.clientWidth : 0) - F), F) * 2 + 2, Z = Math.max(Math.abs((z ? z.clientHeight : 0) - X), X) * 2 + 2;
      oe = Math.sqrt(re ** 2 + Z ** 2);
    }
    M != null && M.touches ? E.current === null && (E.current = () => {
      _({
        pulsate: U,
        rippleX: F,
        rippleY: X,
        rippleSize: oe,
        cb: k
      });
    }, S.start(XTe, () => {
      E.current && (E.current(), E.current = null);
    })) : _({
      pulsate: U,
      rippleX: F,
      rippleY: X,
      rippleSize: oe,
      cb: k
    });
  }, [i, _, S]), D = $.useCallback(() => {
    O({}, {
      pulsate: !0
    });
  }, [O]), P = $.useCallback((M, N) => {
    if (S.clear(), (M == null ? void 0 : M.type) === "touchend" && E.current) {
      E.current(), E.current = null, S.start(0, () => {
        P(M, N);
      });
      return;
    }
    E.current = null, p((k) => k.length > 0 ? k.slice(1) : k), v.current = N;
  }, [S]);
  return $.useImperativeHandle(n, () => ({
    pulsate: D,
    start: O,
    stop: P
  }), [D, O, P]), /* @__PURE__ */ T.jsx(JTe, {
    className: yt(Sc.root, o.root, s),
    ref: w,
    ...u,
    children: /* @__PURE__ */ T.jsx(cF, {
      component: null,
      exit: !0,
      children: f
    })
  });
});
YTe.NODE_ENV !== "production" && (vre.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string
});
function tEe(e) {
  return Vt("MuiButtonBase", e);
}
const nEe = Wt("MuiButtonBase", ["root", "disabled", "focusVisible"]);
var rEe = {};
const iEe = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: i
  } = e, s = Ft({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, tEe, i);
  return n && r && (s.root += ` ${r}`), s;
}, oEe = ye("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${nEe.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Ws = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: o = !1,
    children: s,
    className: u,
    component: f = "button",
    disabled: p = !1,
    disableRipple: m = !1,
    disableTouchRipple: v = !1,
    focusRipple: y = !1,
    focusVisibleClassName: S,
    LinkComponent: E = "a",
    onBlur: w,
    onClick: _,
    onContextMenu: O,
    onDragLeave: D,
    onFocus: P,
    onFocusVisible: M,
    onKeyDown: N,
    onKeyUp: k,
    onMouseDown: U,
    onMouseLeave: H,
    onMouseUp: Y,
    onTouchEnd: z,
    onTouchMove: V,
    onTouchStart: F,
    tabIndex: X = 0,
    TouchRippleProps: oe,
    touchRippleRef: re,
    type: Z,
    ...ee
  } = r, J = $.useRef(null), le = LTe(), be = kr(le.ref, re), [ne, ae] = $.useState(!1);
  p && ne && ae(!1), $.useImperativeHandle(i, () => ({
    focusVisible: () => {
      ae(!0), J.current.focus();
    }
  }), []);
  const ie = le.shouldMount && !m && !p;
  $.useEffect(() => {
    ne && y && !m && le.pulsate();
  }, [m, y, ne, le]);
  const he = Xf(le, "start", U, v), pe = Xf(le, "stop", O, v), me = Xf(le, "stop", D, v), Ee = Xf(le, "stop", Y, v), Ie = Xf(le, "stop", (Be) => {
    ne && Be.preventDefault(), H && H(Be);
  }, v), Pe = Xf(le, "start", F, v), De = Xf(le, "stop", z, v), Ye = Xf(le, "stop", V, v), Ue = Xf(le, "stop", (Be) => {
    lg(Be.target) || ae(!1), w && w(Be);
  }, !1), ve = Mr((Be) => {
    J.current || (J.current = Be.currentTarget), lg(Be.target) && (ae(!0), M && M(Be)), P && P(Be);
  }), rt = () => {
    const Be = J.current;
    return f && f !== "button" && !(Be.tagName === "A" && Be.href);
  }, Te = Mr((Be) => {
    y && !Be.repeat && ne && Be.key === " " && le.stop(Be, () => {
      le.start(Be);
    }), Be.target === Be.currentTarget && rt() && Be.key === " " && Be.preventDefault(), N && N(Be), Be.target === Be.currentTarget && rt() && Be.key === "Enter" && !p && (Be.preventDefault(), _ && _(Be));
  }), Je = Mr((Be) => {
    y && Be.key === " " && ne && !Be.defaultPrevented && le.stop(Be, () => {
      le.pulsate(Be);
    }), k && k(Be), _ && Be.target === Be.currentTarget && rt() && Be.key === " " && !Be.defaultPrevented && _(Be);
  });
  let L = f;
  L === "button" && (ee.href || ee.to) && (L = E);
  const te = {};
  L === "button" ? (te.type = Z === void 0 ? "button" : Z, te.disabled = p) : (!ee.href && !ee.to && (te.role = "button"), p && (te["aria-disabled"] = p));
  const ge = kr(n, J), ke = {
    ...r,
    centerRipple: o,
    component: f,
    disabled: p,
    disableRipple: m,
    disableTouchRipple: v,
    focusRipple: y,
    tabIndex: X,
    focusVisible: ne
  }, We = iEe(ke);
  return /* @__PURE__ */ T.jsxs(oEe, {
    as: L,
    className: yt(We.root, u),
    ownerState: ke,
    onBlur: Ue,
    onClick: _,
    onContextMenu: pe,
    onFocus: ve,
    onKeyDown: Te,
    onKeyUp: Je,
    onMouseDown: he,
    onMouseLeave: Ie,
    onMouseUp: Ee,
    onDragLeave: me,
    onTouchEnd: De,
    onTouchMove: Ye,
    onTouchStart: Pe,
    ref: ge,
    tabIndex: p ? -1 : X,
    type: Z,
    ...te,
    ...ee,
    children: [s, ie ? /* @__PURE__ */ T.jsx(vre, {
      ref: be,
      center: o,
      ...oe
    }) : null]
  });
});
function Xf(e, t, n, r = !1) {
  return Mr((i) => (n && n(i), r || e[t](i), !0));
}
rEe.NODE_ENV !== "production" && (Ws.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: $s,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Qv,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: c.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  href: c.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: c.elementType,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onContextMenu: c.func,
  /**
   * @ignore
   */
  onDragLeave: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * @ignore
   */
  onMouseDown: c.func,
  /**
   * @ignore
   */
  onMouseLeave: c.func,
  /**
   * @ignore
   */
  onMouseUp: c.func,
  /**
   * @ignore
   */
  onTouchEnd: c.func,
  /**
   * @ignore
   */
  onTouchMove: c.func,
  /**
   * @ignore
   */
  onTouchStart: c.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @default 0
   */
  tabIndex: c.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: c.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: c.oneOfType([c.func, c.shape({
    current: c.shape({
      pulsate: c.func.isRequired,
      start: c.func.isRequired,
      stop: c.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: c.oneOfType([c.oneOf(["button", "reset", "submit"]), c.string])
});
function aEe(e) {
  return Vt("MuiCircularProgress", e);
}
Wt("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
var sEe = {};
const Vh = 44, nV = Hv`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, rV = Hv`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, lEe = typeof nV != "string" ? ZA`
        animation: ${nV} 1.4s linear infinite;
      ` : null, cEe = typeof rV != "string" ? ZA`
        animation: ${rV} 1.4s ease-in-out infinite;
      ` : null, uEe = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: i
  } = e, o = {
    root: ["root", n, `color${Ke(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Ke(n)}`, i && "circleDisableShrink"]
  };
  return Ft(o, aEe, t);
}, dEe = ye("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${Ke(n.color)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: lEe || {
      animation: `${nV} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), fEe = ye("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), pEe = ye("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${Ke(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(Lt(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: cEe || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${rV} 1.4s ease-in-out infinite`
    }
  }]
}))), eI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: i,
    color: o = "primary",
    disableShrink: s = !1,
    size: u = 40,
    style: f,
    thickness: p = 3.6,
    value: m = 0,
    variant: v = "indeterminate",
    ...y
  } = r, S = {
    ...r,
    color: o,
    disableShrink: s,
    size: u,
    thickness: p,
    value: m,
    variant: v
  }, E = uEe(S), w = {}, _ = {}, O = {};
  if (v === "determinate") {
    const D = 2 * Math.PI * ((Vh - p) / 2);
    w.strokeDasharray = D.toFixed(3), O["aria-valuenow"] = Math.round(m), w.strokeDashoffset = `${((100 - m) / 100 * D).toFixed(3)}px`, _.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ T.jsx(dEe, {
    className: yt(E.root, i),
    style: {
      width: u,
      height: u,
      ..._,
      ...f
    },
    ownerState: S,
    ref: n,
    role: "progressbar",
    ...O,
    ...y,
    children: /* @__PURE__ */ T.jsx(fEe, {
      className: E.svg,
      ownerState: S,
      viewBox: `${Vh / 2} ${Vh / 2} ${Vh} ${Vh}`,
      children: /* @__PURE__ */ T.jsx(pEe, {
        className: E.circle,
        style: w,
        ownerState: S,
        cx: Vh,
        cy: Vh,
        r: (Vh - p) / 2,
        fill: "none",
        strokeWidth: p
      })
    })
  });
});
sEe.NODE_ENV !== "production" && (eI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Wa(c.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: c.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: c.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: c.oneOf(["determinate", "indeterminate"])
});
function hEe(e) {
  return Vt("MuiIconButton", e);
}
const h9 = Wt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]);
var gEe = {};
const mEe = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: i,
    size: o,
    loading: s
  } = e, u = {
    root: ["root", s && "loading", n && "disabled", r !== "default" && `color${Ke(r)}`, i && `edge${Ke(i)}`, `size${Ke(o)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Ft(u, hEe, t);
}, vEe = ye(Ws, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.loading && t.loading, n.color !== "default" && t[`color${Ke(n.color)}`], n.edge && t[`edge${Ke(n.edge)}`], t[`size${Ke(n.size)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), Lt(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${h9.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${h9.loading}`]: {
    color: "transparent"
  }
}))), yEe = ye("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), ey = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: i = !1,
    children: o,
    className: s,
    color: u = "default",
    disabled: f = !1,
    disableFocusRipple: p = !1,
    size: m = "medium",
    id: v,
    loading: y = null,
    loadingIndicator: S,
    ...E
  } = r, w = Jv(v), _ = S ?? /* @__PURE__ */ T.jsx(eI, {
    "aria-labelledby": w,
    color: "inherit",
    size: 16
  }), O = {
    ...r,
    edge: i,
    color: u,
    disabled: f,
    disableFocusRipple: p,
    loading: y,
    loadingIndicator: _,
    size: m
  }, D = mEe(O);
  return /* @__PURE__ */ T.jsxs(vEe, {
    id: y ? w : v,
    className: yt(D.root, s),
    centerRipple: !0,
    focusRipple: !p,
    disabled: f || y,
    ref: n,
    ...E,
    ownerState: O,
    children: [typeof y == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ T.jsx("span", {
      className: D.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ T.jsx(yEe, {
        className: D.loadingIndicator,
        ownerState: O,
        children: y && _
      })
    }), o]
  });
});
gEe.NODE_ENV !== "production" && (ey.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Wa(c.node, (e) => $.Children.toArray(e.children).some((n) => /* @__PURE__ */ $.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: c.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: c.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: c.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: c.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const uF = (e) => e.scrollTop;
function cg(e, t) {
  const {
    timeout: n,
    easing: r,
    style: i = {}
  } = e;
  return {
    duration: i.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: i.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: i.transitionDelay
  };
}
var bEe = {};
function iV(e) {
  return `scale(${e}, ${e ** 2})`;
}
const xEe = {
  entering: {
    opacity: 1,
    transform: iV(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Kk = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), lx = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: i = !0,
    children: o,
    easing: s,
    in: u,
    onEnter: f,
    onEntered: p,
    onEntering: m,
    onExit: v,
    onExited: y,
    onExiting: S,
    style: E,
    timeout: w = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: _ = Vc,
    ...O
  } = t, D = eg(), P = $.useRef(), M = pa(), N = $.useRef(null), k = kr(N, Sg(o), n), U = (re) => (Z) => {
    if (re) {
      const ee = N.current;
      Z === void 0 ? re(ee) : re(ee, Z);
    }
  }, H = U(m), Y = U((re, Z) => {
    uF(re);
    const {
      duration: ee,
      delay: J,
      easing: le
    } = cg({
      style: E,
      timeout: w,
      easing: s
    }, {
      mode: "enter"
    });
    let be;
    w === "auto" ? (be = M.transitions.getAutoHeightDuration(re.clientHeight), P.current = be) : be = ee, re.style.transition = [M.transitions.create("opacity", {
      duration: be,
      delay: J
    }), M.transitions.create("transform", {
      duration: Kk ? be : be * 0.666,
      delay: J,
      easing: le
    })].join(","), f && f(re, Z);
  }), z = U(p), V = U(S), F = U((re) => {
    const {
      duration: Z,
      delay: ee,
      easing: J
    } = cg({
      style: E,
      timeout: w,
      easing: s
    }, {
      mode: "exit"
    });
    let le;
    w === "auto" ? (le = M.transitions.getAutoHeightDuration(re.clientHeight), P.current = le) : le = Z, re.style.transition = [M.transitions.create("opacity", {
      duration: le,
      delay: ee
    }), M.transitions.create("transform", {
      duration: Kk ? le : le * 0.666,
      delay: Kk ? ee : ee || le * 0.333,
      easing: J
    })].join(","), re.style.opacity = 0, re.style.transform = iV(0.75), v && v(re);
  }), X = U(y), oe = (re) => {
    w === "auto" && D.start(P.current || 0, re), r && r(N.current, re);
  };
  return /* @__PURE__ */ T.jsx(_, {
    appear: i,
    in: u,
    nodeRef: N,
    onEnter: Y,
    onEntered: z,
    onEntering: H,
    onExit: F,
    onExited: X,
    onExiting: V,
    addEndListener: oe,
    timeout: w === "auto" ? null : w,
    ...O,
    children: (re, {
      ownerState: Z,
      ...ee
    }) => /* @__PURE__ */ $.cloneElement(o, {
      style: {
        opacity: 0,
        transform: iV(0.75),
        visibility: re === "exited" && !u ? "hidden" : void 0,
        ...xEe[re],
        ...E,
        ...o.props.style
      },
      ref: k,
      ...ee
    })
  });
});
bEe.NODE_ENV !== "production" && (lx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: xg.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
lx && (lx.muiSupportAuto = !0);
var Vs = "top", Mc = "bottom", jc = "right", Us = "left", dF = "auto", f_ = [Vs, Mc, jc, Us], cx = "start", s1 = "end", SEe = "clippingParents", yre = "viewport", JT = "popper", wEe = "reference", g9 = /* @__PURE__ */ f_.reduce(function(e, t) {
  return e.concat([t + "-" + cx, t + "-" + s1]);
}, []), bre = /* @__PURE__ */ [].concat(f_, [dF]).reduce(function(e, t) {
  return e.concat([t, t + "-" + cx, t + "-" + s1]);
}, []), TEe = "beforeRead", EEe = "read", _Ee = "afterRead", CEe = "beforeMain", REe = "main", OEe = "afterMain", AEe = "beforeWrite", DEe = "write", IEe = "afterWrite", PEe = [TEe, EEe, _Ee, CEe, REe, OEe, AEe, DEe, IEe];
function Wd(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ll(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function zv(e) {
  var t = Ll(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ic(e) {
  var t = Ll(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function fF(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ll(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function NEe(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, o = t.elements[n];
    !Ic(o) || !Wd(o) || (Object.assign(o.style, r), Object.keys(i).forEach(function(s) {
      var u = i[s];
      u === !1 ? o.removeAttribute(s) : o.setAttribute(s, u === !0 ? "" : u);
    }));
  });
}
function MEe(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], o = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), u = s.reduce(function(f, p) {
        return f[p] = "", f;
      }, {});
      !Ic(i) || !Wd(i) || (Object.assign(i.style, u), Object.keys(o).forEach(function(f) {
        i.removeAttribute(f);
      }));
    });
  };
}
const jEe = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: NEe,
  effect: MEe,
  requires: ["computeStyles"]
};
function zd(e) {
  return e.split("-")[0];
}
var Dv = Math.max, uA = Math.min, ux = Math.round;
function oV() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function xre() {
  return !/^((?!chrome|android).)*safari/i.test(oV());
}
function dx(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, o = 1;
  t && Ic(e) && (i = e.offsetWidth > 0 && ux(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && ux(r.height) / e.offsetHeight || 1);
  var s = zv(e) ? Ll(e) : window, u = s.visualViewport, f = !xre() && n, p = (r.left + (f && u ? u.offsetLeft : 0)) / i, m = (r.top + (f && u ? u.offsetTop : 0)) / o, v = r.width / i, y = r.height / o;
  return {
    width: v,
    height: y,
    top: m,
    right: p + v,
    bottom: m + y,
    left: p,
    x: p,
    y: m
  };
}
function pF(e) {
  var t = dx(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Sre(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && fF(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function up(e) {
  return Ll(e).getComputedStyle(e);
}
function LEe(e) {
  return ["table", "td", "th"].indexOf(Wd(e)) >= 0;
}
function Tg(e) {
  return ((zv(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function tI(e) {
  return Wd(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (fF(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Tg(e)
  );
}
function m9(e) {
  return !Ic(e) || // https://github.com/popperjs/popper-core/issues/837
  up(e).position === "fixed" ? null : e.offsetParent;
}
function kEe(e) {
  var t = /firefox/i.test(oV()), n = /Trident/i.test(oV());
  if (n && Ic(e)) {
    var r = up(e);
    if (r.position === "fixed")
      return null;
  }
  var i = tI(e);
  for (fF(i) && (i = i.host); Ic(i) && ["html", "body"].indexOf(Wd(i)) < 0; ) {
    var o = up(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function p_(e) {
  for (var t = Ll(e), n = m9(e); n && LEe(n) && up(n).position === "static"; )
    n = m9(n);
  return n && (Wd(n) === "html" || Wd(n) === "body" && up(n).position === "static") ? t : n || kEe(e) || t;
}
function hF(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function zE(e, t, n) {
  return Dv(e, uA(t, n));
}
function zEe(e, t, n) {
  var r = zE(e, t, n);
  return r > n ? n : r;
}
function wre() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Tre(e) {
  return Object.assign({}, wre(), e);
}
function Ere(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var BEe = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Tre(typeof t != "number" ? t : Ere(t, f_));
};
function VEe(e) {
  var t, n = e.state, r = e.name, i = e.options, o = n.elements.arrow, s = n.modifiersData.popperOffsets, u = zd(n.placement), f = hF(u), p = [Us, jc].indexOf(u) >= 0, m = p ? "height" : "width";
  if (!(!o || !s)) {
    var v = BEe(i.padding, n), y = pF(o), S = f === "y" ? Vs : Us, E = f === "y" ? Mc : jc, w = n.rects.reference[m] + n.rects.reference[f] - s[f] - n.rects.popper[m], _ = s[f] - n.rects.reference[f], O = p_(o), D = O ? f === "y" ? O.clientHeight || 0 : O.clientWidth || 0 : 0, P = w / 2 - _ / 2, M = v[S], N = D - y[m] - v[E], k = D / 2 - y[m] / 2 + P, U = zE(M, k, N), H = f;
    n.modifiersData[r] = (t = {}, t[H] = U, t.centerOffset = U - k, t);
  }
}
function UEe(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || Sre(t.elements.popper, i) && (t.elements.arrow = i));
}
const FEe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: VEe,
  effect: UEe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function fx(e) {
  return e.split("-")[1];
}
var WEe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function HEe(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: ux(n * i) / i || 0,
    y: ux(r * i) / i || 0
  };
}
function v9(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, o = e.variation, s = e.offsets, u = e.position, f = e.gpuAcceleration, p = e.adaptive, m = e.roundOffsets, v = e.isFixed, y = s.x, S = y === void 0 ? 0 : y, E = s.y, w = E === void 0 ? 0 : E, _ = typeof m == "function" ? m({
    x: S,
    y: w
  }) : {
    x: S,
    y: w
  };
  S = _.x, w = _.y;
  var O = s.hasOwnProperty("x"), D = s.hasOwnProperty("y"), P = Us, M = Vs, N = window;
  if (p) {
    var k = p_(n), U = "clientHeight", H = "clientWidth";
    if (k === Ll(n) && (k = Tg(n), up(k).position !== "static" && u === "absolute" && (U = "scrollHeight", H = "scrollWidth")), k = k, i === Vs || (i === Us || i === jc) && o === s1) {
      M = Mc;
      var Y = v && k === N && N.visualViewport ? N.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[U]
      );
      w -= Y - r.height, w *= f ? 1 : -1;
    }
    if (i === Us || (i === Vs || i === Mc) && o === s1) {
      P = jc;
      var z = v && k === N && N.visualViewport ? N.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[H]
      );
      S -= z - r.width, S *= f ? 1 : -1;
    }
  }
  var V = Object.assign({
    position: u
  }, p && WEe), F = m === !0 ? HEe({
    x: S,
    y: w
  }, Ll(n)) : {
    x: S,
    y: w
  };
  if (S = F.x, w = F.y, f) {
    var X;
    return Object.assign({}, V, (X = {}, X[M] = D ? "0" : "", X[P] = O ? "0" : "", X.transform = (N.devicePixelRatio || 1) <= 1 ? "translate(" + S + "px, " + w + "px)" : "translate3d(" + S + "px, " + w + "px, 0)", X));
  }
  return Object.assign({}, V, (t = {}, t[M] = D ? w + "px" : "", t[P] = O ? S + "px" : "", t.transform = "", t));
}
function qEe(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, o = n.adaptive, s = o === void 0 ? !0 : o, u = n.roundOffsets, f = u === void 0 ? !0 : u, p = {
    placement: zd(t.placement),
    variation: fx(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, v9(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: f
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, v9(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: f
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const $Ee = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: qEe,
  data: {}
};
var UR = {
  passive: !0
};
function GEe(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, o = i === void 0 ? !0 : i, s = r.resize, u = s === void 0 ? !0 : s, f = Ll(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && p.forEach(function(m) {
    m.addEventListener("scroll", n.update, UR);
  }), u && f.addEventListener("resize", n.update, UR), function() {
    o && p.forEach(function(m) {
      m.removeEventListener("scroll", n.update, UR);
    }), u && f.removeEventListener("resize", n.update, UR);
  };
}
const YEe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: GEe,
  data: {}
};
var XEe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function NO(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return XEe[t];
  });
}
var ZEe = {
  start: "end",
  end: "start"
};
function y9(e) {
  return e.replace(/start|end/g, function(t) {
    return ZEe[t];
  });
}
function gF(e) {
  var t = Ll(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function mF(e) {
  return dx(Tg(e)).left + gF(e).scrollLeft;
}
function KEe(e, t) {
  var n = Ll(e), r = Tg(e), i = n.visualViewport, o = r.clientWidth, s = r.clientHeight, u = 0, f = 0;
  if (i) {
    o = i.width, s = i.height;
    var p = xre();
    (p || !p && t === "fixed") && (u = i.offsetLeft, f = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: u + mF(e),
    y: f
  };
}
function QEe(e) {
  var t, n = Tg(e), r = gF(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = Dv(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Dv(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), u = -r.scrollLeft + mF(e), f = -r.scrollTop;
  return up(i || n).direction === "rtl" && (u += Dv(n.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: u,
    y: f
  };
}
function vF(e) {
  var t = up(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function _re(e) {
  return ["html", "body", "#document"].indexOf(Wd(e)) >= 0 ? e.ownerDocument.body : Ic(e) && vF(e) ? e : _re(tI(e));
}
function BE(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = _re(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = Ll(r), s = i ? [o].concat(o.visualViewport || [], vF(r) ? r : []) : r, u = t.concat(s);
  return i ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(BE(tI(s)))
  );
}
function aV(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function JEe(e, t) {
  var n = dx(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function b9(e, t, n) {
  return t === yre ? aV(KEe(e, n)) : zv(t) ? JEe(t, n) : aV(QEe(Tg(e)));
}
function e1e(e) {
  var t = BE(tI(e)), n = ["absolute", "fixed"].indexOf(up(e).position) >= 0, r = n && Ic(e) ? p_(e) : e;
  return zv(r) ? t.filter(function(i) {
    return zv(i) && Sre(i, r) && Wd(i) !== "body";
  }) : [];
}
function t1e(e, t, n, r) {
  var i = t === "clippingParents" ? e1e(e) : [].concat(t), o = [].concat(i, [n]), s = o[0], u = o.reduce(function(f, p) {
    var m = b9(e, p, r);
    return f.top = Dv(m.top, f.top), f.right = uA(m.right, f.right), f.bottom = uA(m.bottom, f.bottom), f.left = Dv(m.left, f.left), f;
  }, b9(e, s, r));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function Cre(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? zd(r) : null, o = r ? fx(r) : null, s = t.x + t.width / 2 - n.width / 2, u = t.y + t.height / 2 - n.height / 2, f;
  switch (i) {
    case Vs:
      f = {
        x: s,
        y: t.y - n.height
      };
      break;
    case Mc:
      f = {
        x: s,
        y: t.y + t.height
      };
      break;
    case jc:
      f = {
        x: t.x + t.width,
        y: u
      };
      break;
    case Us:
      f = {
        x: t.x - n.width,
        y: u
      };
      break;
    default:
      f = {
        x: t.x,
        y: t.y
      };
  }
  var p = i ? hF(i) : null;
  if (p != null) {
    var m = p === "y" ? "height" : "width";
    switch (o) {
      case cx:
        f[p] = f[p] - (t[m] / 2 - n[m] / 2);
        break;
      case s1:
        f[p] = f[p] + (t[m] / 2 - n[m] / 2);
        break;
    }
  }
  return f;
}
function l1(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, o = n.strategy, s = o === void 0 ? e.strategy : o, u = n.boundary, f = u === void 0 ? SEe : u, p = n.rootBoundary, m = p === void 0 ? yre : p, v = n.elementContext, y = v === void 0 ? JT : v, S = n.altBoundary, E = S === void 0 ? !1 : S, w = n.padding, _ = w === void 0 ? 0 : w, O = Tre(typeof _ != "number" ? _ : Ere(_, f_)), D = y === JT ? wEe : JT, P = e.rects.popper, M = e.elements[E ? D : y], N = t1e(zv(M) ? M : M.contextElement || Tg(e.elements.popper), f, m, s), k = dx(e.elements.reference), U = Cre({
    reference: k,
    element: P,
    placement: i
  }), H = aV(Object.assign({}, P, U)), Y = y === JT ? H : k, z = {
    top: N.top - Y.top + O.top,
    bottom: Y.bottom - N.bottom + O.bottom,
    left: N.left - Y.left + O.left,
    right: Y.right - N.right + O.right
  }, V = e.modifiersData.offset;
  if (y === JT && V) {
    var F = V[i];
    Object.keys(z).forEach(function(X) {
      var oe = [jc, Mc].indexOf(X) >= 0 ? 1 : -1, re = [Vs, Mc].indexOf(X) >= 0 ? "y" : "x";
      z[X] += F[re] * oe;
    });
  }
  return z;
}
function n1e(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, o = n.rootBoundary, s = n.padding, u = n.flipVariations, f = n.allowedAutoPlacements, p = f === void 0 ? bre : f, m = fx(r), v = m ? u ? g9 : g9.filter(function(E) {
    return fx(E) === m;
  }) : f_, y = v.filter(function(E) {
    return p.indexOf(E) >= 0;
  });
  y.length === 0 && (y = v);
  var S = y.reduce(function(E, w) {
    return E[w] = l1(e, {
      placement: w,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[zd(w)], E;
  }, {});
  return Object.keys(S).sort(function(E, w) {
    return S[E] - S[w];
  });
}
function r1e(e) {
  if (zd(e) === dF)
    return [];
  var t = NO(e);
  return [y9(e), t, y9(t)];
}
function i1e(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, u = s === void 0 ? !0 : s, f = n.fallbackPlacements, p = n.padding, m = n.boundary, v = n.rootBoundary, y = n.altBoundary, S = n.flipVariations, E = S === void 0 ? !0 : S, w = n.allowedAutoPlacements, _ = t.options.placement, O = zd(_), D = O === _, P = f || (D || !E ? [NO(_)] : r1e(_)), M = [_].concat(P).reduce(function(he, pe) {
      return he.concat(zd(pe) === dF ? n1e(t, {
        placement: pe,
        boundary: m,
        rootBoundary: v,
        padding: p,
        flipVariations: E,
        allowedAutoPlacements: w
      }) : pe);
    }, []), N = t.rects.reference, k = t.rects.popper, U = /* @__PURE__ */ new Map(), H = !0, Y = M[0], z = 0; z < M.length; z++) {
      var V = M[z], F = zd(V), X = fx(V) === cx, oe = [Vs, Mc].indexOf(F) >= 0, re = oe ? "width" : "height", Z = l1(t, {
        placement: V,
        boundary: m,
        rootBoundary: v,
        altBoundary: y,
        padding: p
      }), ee = oe ? X ? jc : Us : X ? Mc : Vs;
      N[re] > k[re] && (ee = NO(ee));
      var J = NO(ee), le = [];
      if (o && le.push(Z[F] <= 0), u && le.push(Z[ee] <= 0, Z[J] <= 0), le.every(function(he) {
        return he;
      })) {
        Y = V, H = !1;
        break;
      }
      U.set(V, le);
    }
    if (H)
      for (var be = E ? 3 : 1, ne = function(pe) {
        var me = M.find(function(Ee) {
          var Ie = U.get(Ee);
          if (Ie)
            return Ie.slice(0, pe).every(function(Pe) {
              return Pe;
            });
        });
        if (me)
          return Y = me, "break";
      }, ae = be; ae > 0; ae--) {
        var ie = ne(ae);
        if (ie === "break") break;
      }
    t.placement !== Y && (t.modifiersData[r]._skip = !0, t.placement = Y, t.reset = !0);
  }
}
const o1e = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: i1e,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function x9(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function S9(e) {
  return [Vs, jc, Mc, Us].some(function(t) {
    return e[t] >= 0;
  });
}
function a1e(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, s = l1(t, {
    elementContext: "reference"
  }), u = l1(t, {
    altBoundary: !0
  }), f = x9(s, r), p = x9(u, i, o), m = S9(f), v = S9(p);
  t.modifiersData[n] = {
    referenceClippingOffsets: f,
    popperEscapeOffsets: p,
    isReferenceHidden: m,
    hasPopperEscaped: v
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": m,
    "data-popper-escaped": v
  });
}
const s1e = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: a1e
};
function l1e(e, t, n) {
  var r = zd(e), i = [Us, Vs].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = o[0], u = o[1];
  return s = s || 0, u = (u || 0) * i, [Us, jc].indexOf(r) >= 0 ? {
    x: u,
    y: s
  } : {
    x: s,
    y: u
  };
}
function c1e(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, o = i === void 0 ? [0, 0] : i, s = bre.reduce(function(m, v) {
    return m[v] = l1e(v, t.rects, o), m;
  }, {}), u = s[t.placement], f = u.x, p = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += f, t.modifiersData.popperOffsets.y += p), t.modifiersData[r] = s;
}
const u1e = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: c1e
};
function d1e(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Cre({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const f1e = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: d1e,
  data: {}
};
function p1e(e) {
  return e === "x" ? "y" : "x";
}
function h1e(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, u = s === void 0 ? !1 : s, f = n.boundary, p = n.rootBoundary, m = n.altBoundary, v = n.padding, y = n.tether, S = y === void 0 ? !0 : y, E = n.tetherOffset, w = E === void 0 ? 0 : E, _ = l1(t, {
    boundary: f,
    rootBoundary: p,
    padding: v,
    altBoundary: m
  }), O = zd(t.placement), D = fx(t.placement), P = !D, M = hF(O), N = p1e(M), k = t.modifiersData.popperOffsets, U = t.rects.reference, H = t.rects.popper, Y = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, z = typeof Y == "number" ? {
    mainAxis: Y,
    altAxis: Y
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Y), V = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (k) {
    if (o) {
      var X, oe = M === "y" ? Vs : Us, re = M === "y" ? Mc : jc, Z = M === "y" ? "height" : "width", ee = k[M], J = ee + _[oe], le = ee - _[re], be = S ? -H[Z] / 2 : 0, ne = D === cx ? U[Z] : H[Z], ae = D === cx ? -H[Z] : -U[Z], ie = t.elements.arrow, he = S && ie ? pF(ie) : {
        width: 0,
        height: 0
      }, pe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : wre(), me = pe[oe], Ee = pe[re], Ie = zE(0, U[Z], he[Z]), Pe = P ? U[Z] / 2 - be - Ie - me - z.mainAxis : ne - Ie - me - z.mainAxis, De = P ? -U[Z] / 2 + be + Ie + Ee + z.mainAxis : ae + Ie + Ee + z.mainAxis, Ye = t.elements.arrow && p_(t.elements.arrow), Ue = Ye ? M === "y" ? Ye.clientTop || 0 : Ye.clientLeft || 0 : 0, ve = (X = V == null ? void 0 : V[M]) != null ? X : 0, rt = ee + Pe - ve - Ue, Te = ee + De - ve, Je = zE(S ? uA(J, rt) : J, ee, S ? Dv(le, Te) : le);
      k[M] = Je, F[M] = Je - ee;
    }
    if (u) {
      var L, te = M === "x" ? Vs : Us, ge = M === "x" ? Mc : jc, ke = k[N], We = N === "y" ? "height" : "width", Be = ke + _[te], je = ke - _[ge], mt = [Vs, Us].indexOf(O) !== -1, qe = (L = V == null ? void 0 : V[N]) != null ? L : 0, at = mt ? Be : ke - U[We] - H[We] - qe + z.altAxis, et = mt ? ke + U[We] + H[We] - qe - z.altAxis : je, bt = S && mt ? zEe(at, ke, et) : zE(S ? at : Be, ke, S ? et : je);
      k[N] = bt, F[N] = bt - ke;
    }
    t.modifiersData[r] = F;
  }
}
const g1e = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: h1e,
  requiresIfExists: ["offset"]
};
function m1e(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function v1e(e) {
  return e === Ll(e) || !Ic(e) ? gF(e) : m1e(e);
}
function y1e(e) {
  var t = e.getBoundingClientRect(), n = ux(t.width) / e.offsetWidth || 1, r = ux(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function b1e(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ic(t), i = Ic(t) && y1e(t), o = Tg(t), s = dx(e, i, n), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Wd(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  vF(o)) && (u = v1e(t)), Ic(t) ? (f = dx(t, !0), f.x += t.clientLeft, f.y += t.clientTop) : o && (f.x = mF(o))), {
    x: s.left + u.scrollLeft - f.x,
    y: s.top + u.scrollTop - f.y,
    width: s.width,
    height: s.height
  };
}
function x1e(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    n.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(u) {
      if (!n.has(u)) {
        var f = t.get(u);
        f && i(f);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || i(o);
  }), r;
}
function S1e(e) {
  var t = x1e(e);
  return PEe.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function w1e(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function T1e(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var w9 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function T9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function E1e(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, o = i === void 0 ? w9 : i;
  return function(u, f, p) {
    p === void 0 && (p = o);
    var m = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, w9, o),
      modifiersData: {},
      elements: {
        reference: u,
        popper: f
      },
      attributes: {},
      styles: {}
    }, v = [], y = !1, S = {
      state: m,
      setOptions: function(O) {
        var D = typeof O == "function" ? O(m.options) : O;
        w(), m.options = Object.assign({}, o, m.options, D), m.scrollParents = {
          reference: zv(u) ? BE(u) : u.contextElement ? BE(u.contextElement) : [],
          popper: BE(f)
        };
        var P = S1e(T1e([].concat(r, m.options.modifiers)));
        return m.orderedModifiers = P.filter(function(M) {
          return M.enabled;
        }), E(), S.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!y) {
          var O = m.elements, D = O.reference, P = O.popper;
          if (T9(D, P)) {
            m.rects = {
              reference: b1e(D, p_(P), m.options.strategy === "fixed"),
              popper: pF(P)
            }, m.reset = !1, m.placement = m.options.placement, m.orderedModifiers.forEach(function(z) {
              return m.modifiersData[z.name] = Object.assign({}, z.data);
            });
            for (var M = 0; M < m.orderedModifiers.length; M++) {
              if (m.reset === !0) {
                m.reset = !1, M = -1;
                continue;
              }
              var N = m.orderedModifiers[M], k = N.fn, U = N.options, H = U === void 0 ? {} : U, Y = N.name;
              typeof k == "function" && (m = k({
                state: m,
                options: H,
                name: Y,
                instance: S
              }) || m);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: w1e(function() {
        return new Promise(function(_) {
          S.forceUpdate(), _(m);
        });
      }),
      destroy: function() {
        w(), y = !0;
      }
    };
    if (!T9(u, f))
      return S;
    S.setOptions(p).then(function(_) {
      !y && p.onFirstUpdate && p.onFirstUpdate(_);
    });
    function E() {
      m.orderedModifiers.forEach(function(_) {
        var O = _.name, D = _.options, P = D === void 0 ? {} : D, M = _.effect;
        if (typeof M == "function") {
          var N = M({
            state: m,
            name: O,
            instance: S,
            options: P
          }), k = function() {
          };
          v.push(N || k);
        }
      });
    }
    function w() {
      v.forEach(function(_) {
        return _();
      }), v = [];
    }
    return S;
  };
}
var _1e = [YEe, f1e, $Ee, jEe, u1e, o1e, g1e, FEe, s1e], C1e = /* @__PURE__ */ E1e({
  defaultModifiers: _1e
}), Rre = {};
function R1e(e) {
  return typeof e == "function" ? e() : e;
}
const c1 = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    children: r,
    container: i,
    disablePortal: o = !1
  } = t, [s, u] = $.useState(null), f = kr(/* @__PURE__ */ $.isValidElement(r) ? Sg(r) : null, n);
  if (gs(() => {
    o || u(R1e(i) || document.body);
  }, [i, o]), gs(() => {
    if (s && !o)
      return $2(n, s), () => {
        $2(n, null);
      };
  }, [n, s, o]), o) {
    if (/* @__PURE__ */ $.isValidElement(r)) {
      const p = {
        ref: f
      };
      return /* @__PURE__ */ $.cloneElement(r, p);
    }
    return r;
  }
  return s && /* @__PURE__ */ she.createPortal(r, s);
});
Rre.NODE_ENV !== "production" && (c1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: c.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Fd, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool
});
Rre.NODE_ENV !== "production" && (c1.propTypes = tF(c1.propTypes));
function O1e(e) {
  return Vt("MuiPopper", e);
}
Wt("MuiPopper", ["root"]);
var dA = {};
function A1e(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function fA(e) {
  return typeof e == "function" ? e() : e;
}
function nI(e) {
  return e.nodeType !== void 0;
}
function D1e(e) {
  return !nI(e);
}
const I1e = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, O1e, t);
}, P1e = {}, N1e = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    direction: o,
    disablePortal: s,
    modifiers: u,
    open: f,
    placement: p,
    popperOptions: m,
    popperRef: v,
    slotProps: y = {},
    slots: S = {},
    TransitionProps: E,
    // @ts-ignore internal logic
    ownerState: w,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ..._
  } = t, O = $.useRef(null), D = kr(O, n), P = $.useRef(null), M = kr(P, v), N = $.useRef(M);
  gs(() => {
    N.current = M;
  }, [M]), $.useImperativeHandle(v, () => P.current, []);
  const k = A1e(p, o), [U, H] = $.useState(k), [Y, z] = $.useState(fA(r));
  $.useEffect(() => {
    P.current && P.current.forceUpdate();
  }), $.useEffect(() => {
    r && z(fA(r));
  }, [r]), gs(() => {
    if (!Y || !f)
      return;
    const re = (J) => {
      H(J.placement);
    };
    if (dA.NODE_ENV !== "production" && Y && nI(Y) && Y.nodeType === 1) {
      const J = Y.getBoundingClientRect();
      dA.NODE_ENV !== "test" && J.top === 0 && J.left === 0 && J.right === 0 && J.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let Z = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: J
      }) => {
        re(J);
      }
    }];
    u != null && (Z = Z.concat(u)), m && m.modifiers != null && (Z = Z.concat(m.modifiers));
    const ee = C1e(Y, O.current, {
      placement: k,
      ...m,
      modifiers: Z
    });
    return N.current(ee), () => {
      ee.destroy(), N.current(null);
    };
  }, [Y, s, u, f, m, k]);
  const V = {
    placement: U
  };
  E !== null && (V.TransitionProps = E);
  const F = I1e(t), X = S.root ?? "div", oe = Oo({
    elementType: X,
    externalSlotProps: y.root,
    externalForwardedProps: _,
    additionalProps: {
      role: "tooltip",
      ref: D
    },
    ownerState: t,
    className: F.root
  });
  return /* @__PURE__ */ T.jsx(X, {
    ...oe,
    children: typeof i == "function" ? i(V) : i
  });
}), Ore = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    container: o,
    direction: s = "ltr",
    disablePortal: u = !1,
    keepMounted: f = !1,
    modifiers: p,
    open: m,
    placement: v = "bottom",
    popperOptions: y = P1e,
    popperRef: S,
    style: E,
    transition: w = !1,
    slotProps: _ = {},
    slots: O = {},
    ...D
  } = t, [P, M] = $.useState(!0), N = () => {
    M(!1);
  }, k = () => {
    M(!0);
  };
  if (!f && !m && (!w || P))
    return null;
  let U;
  if (o)
    U = o;
  else if (r) {
    const z = fA(r);
    U = z && nI(z) ? Vi(z).body : Vi(null).body;
  }
  const H = !m && f && (!w || P) ? "none" : void 0, Y = w ? {
    in: m,
    onEnter: N,
    onExited: k
  } : void 0;
  return /* @__PURE__ */ T.jsx(c1, {
    disablePortal: u,
    container: U,
    children: /* @__PURE__ */ T.jsx(N1e, {
      anchorEl: r,
      direction: s,
      disablePortal: u,
      modifiers: p,
      ref: n,
      open: w ? !P : m,
      placement: v,
      popperOptions: y,
      popperRef: S,
      slotProps: _,
      slots: O,
      ...D,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: H,
        ...E
      },
      TransitionProps: Y,
      children: i
    })
  });
});
dA.NODE_ENV !== "production" && (Ore.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Wa(c.oneOfType([Fd, c.object, c.func]), (e) => {
    if (e.open) {
      const t = fA(e.anchorEl);
      if (t && nI(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (dA.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || D1e(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Fd, c.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: c.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: $s,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
var M1e = {};
const j1e = ye(Ore, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), h_ = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = wg(), i = Gt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: o,
    component: s,
    components: u,
    componentsProps: f,
    container: p,
    disablePortal: m,
    keepMounted: v,
    modifiers: y,
    open: S,
    placement: E,
    popperOptions: w,
    popperRef: _,
    transition: O,
    slots: D,
    slotProps: P,
    ...M
  } = i, N = (D == null ? void 0 : D.root) ?? (u == null ? void 0 : u.Root), k = {
    anchorEl: o,
    container: p,
    disablePortal: m,
    keepMounted: v,
    modifiers: y,
    open: S,
    placement: E,
    popperOptions: w,
    popperRef: _,
    transition: O,
    ...M
  };
  return /* @__PURE__ */ T.jsx(j1e, {
    as: s,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: N
    },
    slotProps: P ?? f,
    ...k,
    ref: n
  });
});
M1e.NODE_ENV !== "production" && (h_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: c.oneOfType([Fd, c.object, c.func]),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Fd, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: $s,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
function L1e(e) {
  return Vt("MuiTooltip", e);
}
const Bi = Wt("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
var MO = {};
function k1e(e) {
  return Math.round(e * 1e5) / 1e5;
}
const z1e = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: i,
    placement: o
  } = e, s = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", i && "touch", `tooltipPlacement${Ke(o.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Ft(s, L1e, t);
}, B1e = ye(h_, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(Lt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${Bi.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${Bi.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${Bi.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${Bi.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${Bi.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${Bi.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${Bi.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${Bi.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), V1e = ye("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${Ke(n.placement.split("-")[0])}`]];
  }
})(Lt(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Cn(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${Bi.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${Bi.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${Bi.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${Bi.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${k1e(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${Bi.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${Bi.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${Bi.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${Bi.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${Bi.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${Bi.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${Bi.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${Bi.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${Bi.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${Bi.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), U1e = ye("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(Lt(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Cn(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let FR = !1;
const E9 = new YD();
let eE = {
  x: 0,
  y: 0
};
function WR(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const Bd = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: i = !1,
    children: o,
    classes: s,
    components: u = {},
    componentsProps: f = {},
    describeChild: p = !1,
    disableFocusListener: m = !1,
    disableHoverListener: v = !1,
    disableInteractive: y = !1,
    disableTouchListener: S = !1,
    enterDelay: E = 100,
    enterNextDelay: w = 0,
    enterTouchDelay: _ = 700,
    followCursor: O = !1,
    id: D,
    leaveDelay: P = 0,
    leaveTouchDelay: M = 1500,
    onClose: N,
    onOpen: k,
    open: U,
    placement: H = "bottom",
    PopperComponent: Y,
    PopperProps: z = {},
    slotProps: V = {},
    slots: F = {},
    title: X,
    TransitionComponent: oe,
    TransitionProps: re,
    ...Z
  } = r, ee = /* @__PURE__ */ $.isValidElement(o) ? o : /* @__PURE__ */ T.jsx("span", {
    children: o
  }), J = pa(), le = wg(), [be, ne] = $.useState(), [ae, ie] = $.useState(null), he = $.useRef(!1), pe = y || O, me = eg(), Ee = eg(), Ie = eg(), Pe = eg(), [De, Ye] = ip({
    controlled: U,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Ue = De;
  if (MO.NODE_ENV !== "production") {
    const {
      current: Ut
    } = $.useRef(U !== void 0);
    $.useEffect(() => {
      be && be.disabled && !Ut && X !== "" && be.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [X, be, Ut]);
  }
  const ve = Jv(D), rt = $.useRef(), Te = Mr(() => {
    rt.current !== void 0 && (document.body.style.WebkitUserSelect = rt.current, rt.current = void 0), Pe.clear();
  });
  $.useEffect(() => Te, [Te]);
  const Je = (Ut) => {
    E9.clear(), FR = !0, Ye(!0), k && !Ue && k(Ut);
  }, L = Mr(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ut) => {
      E9.start(800 + P, () => {
        FR = !1;
      }), Ye(!1), N && Ue && N(Ut), me.start(J.transitions.duration.shortest, () => {
        he.current = !1;
      });
    }
  ), te = (Ut) => {
    he.current && Ut.type !== "touchstart" || (be && be.removeAttribute("title"), Ee.clear(), Ie.clear(), E || FR && w ? Ee.start(FR ? w : E, () => {
      Je(Ut);
    }) : Je(Ut));
  }, ge = (Ut) => {
    Ee.clear(), Ie.start(P, () => {
      L(Ut);
    });
  }, [, ke] = $.useState(!1), We = (Ut) => {
    lg(Ut.target) || (ke(!1), ge(Ut));
  }, Be = (Ut) => {
    be || ne(Ut.currentTarget), lg(Ut.target) && (ke(!0), te(Ut));
  }, je = (Ut) => {
    he.current = !0;
    const ei = ee.props;
    ei.onTouchStart && ei.onTouchStart(Ut);
  }, mt = (Ut) => {
    je(Ut), Ie.clear(), me.clear(), Te(), rt.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Pe.start(_, () => {
      document.body.style.WebkitUserSelect = rt.current, te(Ut);
    });
  }, qe = (Ut) => {
    ee.props.onTouchEnd && ee.props.onTouchEnd(Ut), Te(), Ie.start(M, () => {
      L(Ut);
    });
  };
  $.useEffect(() => {
    if (!Ue)
      return;
    function Ut(ei) {
      ei.key === "Escape" && L(ei);
    }
    return document.addEventListener("keydown", Ut), () => {
      document.removeEventListener("keydown", Ut);
    };
  }, [L, Ue]);
  const at = kr(Sg(ee), ne, n);
  !X && X !== 0 && (Ue = !1);
  const et = $.useRef(), bt = (Ut) => {
    const ei = ee.props;
    ei.onMouseMove && ei.onMouseMove(Ut), eE = {
      x: Ut.clientX,
      y: Ut.clientY
    }, et.current && et.current.update();
  }, q = {}, W = typeof X == "string";
  p ? (q.title = !Ue && W && !v ? X : null, q["aria-describedby"] = Ue ? ve : null) : (q["aria-label"] = W ? X : null, q["aria-labelledby"] = Ue && !W ? ve : null);
  const Q = {
    ...q,
    ...Z,
    ...ee.props,
    className: yt(Z.className, ee.props.className),
    onTouchStart: je,
    ref: at,
    ...O ? {
      onMouseMove: bt
    } : {}
  };
  MO.NODE_ENV !== "production" && (Q["data-mui-internal-clone-element"] = !0, $.useEffect(() => {
    be && !be.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [be]));
  const ce = {};
  S || (Q.onTouchStart = mt, Q.onTouchEnd = qe), v || (Q.onMouseOver = WR(te, Q.onMouseOver), Q.onMouseLeave = WR(ge, Q.onMouseLeave), pe || (ce.onMouseOver = te, ce.onMouseLeave = ge)), m || (Q.onFocus = WR(Be, Q.onFocus), Q.onBlur = WR(We, Q.onBlur), pe || (ce.onFocus = Be, ce.onBlur = We)), MO.NODE_ENV !== "production" && ee.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${ee.props.title}\` or the Tooltip component.`].join(`
`));
  const _e = {
    ...r,
    isRtl: le,
    arrow: i,
    disableInteractive: pe,
    placement: H,
    PopperComponentProp: Y,
    touch: he.current
  }, Fe = typeof V.popper == "function" ? V.popper(_e) : V.popper, gt = $.useMemo(() => {
    var ei, It;
    let Ut = [{
      name: "arrow",
      enabled: !!ae,
      options: {
        element: ae,
        padding: 4
      }
    }];
    return (ei = z.popperOptions) != null && ei.modifiers && (Ut = Ut.concat(z.popperOptions.modifiers)), (It = Fe == null ? void 0 : Fe.popperOptions) != null && It.modifiers && (Ut = Ut.concat(Fe.popperOptions.modifiers)), {
      ...z.popperOptions,
      ...Fe == null ? void 0 : Fe.popperOptions,
      modifiers: Ut
    };
  }, [ae, z.popperOptions, Fe == null ? void 0 : Fe.popperOptions]), ct = z1e(_e), ht = typeof V.transition == "function" ? V.transition(_e) : V.transition, Yt = {
    slots: {
      popper: u.Popper,
      transition: u.Transition ?? oe,
      tooltip: u.Tooltip,
      arrow: u.Arrow,
      ...F
    },
    slotProps: {
      arrow: V.arrow ?? f.arrow,
      popper: {
        ...z,
        ...Fe ?? f.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: V.tooltip ?? f.tooltip,
      transition: {
        ...re,
        ...ht ?? f.transition
      }
    }
  }, [Rt, cn] = Xt("popper", {
    elementType: B1e,
    externalForwardedProps: Yt,
    ownerState: _e,
    className: yt(ct.popper, z == null ? void 0 : z.className)
  }), [Kt, Zt] = Xt("transition", {
    elementType: lx,
    externalForwardedProps: Yt,
    ownerState: _e
  }), [dn, xr] = Xt("tooltip", {
    elementType: V1e,
    className: ct.tooltip,
    externalForwardedProps: Yt,
    ownerState: _e
  }), [Hr, jr] = Xt("arrow", {
    elementType: U1e,
    className: ct.arrow,
    externalForwardedProps: Yt,
    ownerState: _e,
    ref: ie
  });
  return /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [/* @__PURE__ */ $.cloneElement(ee, Q), /* @__PURE__ */ T.jsx(Rt, {
      as: Y ?? h_,
      placement: H,
      anchorEl: O ? {
        getBoundingClientRect: () => ({
          top: eE.y,
          left: eE.x,
          right: eE.x,
          bottom: eE.y,
          width: 0,
          height: 0
        })
      } : be,
      popperRef: et,
      open: be ? Ue : !1,
      id: ve,
      transition: !0,
      ...ce,
      ...cn,
      popperOptions: gt,
      children: ({
        TransitionProps: Ut
      }) => /* @__PURE__ */ T.jsx(Kt, {
        timeout: J.transitions.duration.shorter,
        ...Ut,
        ...Zt,
        children: /* @__PURE__ */ T.jsxs(dn, {
          ...xr,
          children: [X, i ? /* @__PURE__ */ T.jsx(Hr, {
            ...jr
          }) : null]
        })
      })
    })]
  });
});
MO.NODE_ENV !== "production" && (Bd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: c.bool,
  /**
   * Tooltip reference element.
   */
  children: xg.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Arrow: c.elementType,
    Popper: c.elementType,
    Tooltip: c.elementType,
    Transition: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    arrow: c.object,
    popper: c.object,
    tooltip: c.object,
    transition: c.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: c.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: c.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: c.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: c.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: c.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: c.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: c.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: c.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: c.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: c.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: c.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: c.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: c.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: c.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    arrow: c.oneOfType([c.func, c.object]),
    popper: c.oneOfType([c.func, c.object]),
    tooltip: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    arrow: c.elementType,
    popper: c.elementType,
    tooltip: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: c.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: c.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object
});
const Eg = hg({ current: document.body }), F1e = ye(ey, { name: "MiradorMenuButton", slot: "root" })(({ selected: e, theme: t }) => ({
  fill: "currentcolor",
  ...e && {
    backgroundColor: t.palette.action.selected
  }
}));
function Lx({
  "aria-label": e,
  badge: t = !1,
  children: n,
  dispatch: r = () => {
  },
  selected: i = !1,
  BadgeProps: o = {},
  TooltipProps: s = {},
  sx: u = {},
  ...f
}) {
  const p = Qi(Eg), m = /* @__PURE__ */ T.jsx(
    F1e,
    {
      selected: i,
      "aria-label": e,
      ...f,
      sx: u,
      size: "large",
      children: t ? /* @__PURE__ */ T.jsx(
        _c,
        {
          overlap: "rectangular",
          ...o,
          children: n
        }
      ) : n
    }
  );
  return f.disabled ? m : /* @__PURE__ */ T.jsx(
    Bd,
    {
      PopperProps: {
        container: p == null ? void 0 : p.current
      },
      title: e,
      ...s,
      children: m
    }
  );
}
Lx.propTypes = {
  "aria-label": c.string.isRequired,
  badge: c.bool,
  BadgeProps: c.object,
  // eslint-disable-line react/forbid-prop-types
  children: c.element.isRequired,
  dispatch: c.func,
  selected: c.bool,
  sx: c.object,
  // eslint-disable-line react/forbid-prop-types
  TooltipProps: c.object
  // eslint-disable-line react/forbid-prop-types
};
const W1e = wt(
  Tt("MiradorMenuButton")
), Jn = W1e(Lx);
function Are({
  displayAll: e,
  displayAllDisabled: t,
  toggleAnnotationDisplay: n
}) {
  const { t: r } = Ct();
  return /* @__PURE__ */ T.jsx(
    Jn,
    {
      "aria-label": r(e ? "displayNoAnnotations" : "highlightAllAnnotations"),
      onClick: n,
      disabled: t,
      size: "small",
      children: e ? /* @__PURE__ */ T.jsx(pre, {}) : /* @__PURE__ */ T.jsx(hre, {})
    }
  );
}
Are.propTypes = {
  displayAll: c.bool.isRequired,
  displayAllDisabled: c.bool.isRequired,
  toggleAnnotationDisplay: c.func.isRequired,
  windowId: c.string.isRequired
  // eslint-disable-line react/no-unused-prop-types
};
const H1e = (e, { windowId: t }) => ({
  displayAll: Wn(e, { windowId: t }).highlightAllAnnotations,
  displayAllDisabled: wD(
    e,
    { windowId: t }
  ).length < 2
}), q1e = (e, { windowId: t }) => ({
  toggleAnnotationDisplay: () => {
    e(ine(t));
  }
}), $1e = wt(
  At(H1e, q1e),
  Tt("AnnotationSettings")
), G1e = $1e(Are), Y1e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function X1e(e) {
  return Vt("MuiChip", e);
}
const $n = Wt("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]);
var Dre = {};
const Z1e = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: i,
    iconColor: o,
    onDelete: s,
    clickable: u,
    variant: f
  } = e, p = {
    root: ["root", f, n && "disabled", `size${Ke(r)}`, `color${Ke(i)}`, u && "clickable", u && `clickableColor${Ke(i)}`, s && "deletable", s && `deletableColor${Ke(i)}`, `${f}${Ke(i)}`],
    label: ["label", `label${Ke(r)}`],
    avatar: ["avatar", `avatar${Ke(r)}`, `avatarColor${Ke(i)}`],
    icon: ["icon", `icon${Ke(r)}`, `iconColor${Ke(o)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Ke(r)}`, `deleteIconColor${Ke(i)}`, `deleteIcon${Ke(f)}Color${Ke(i)}`]
  };
  return Ft(p, X1e, t);
}, K1e = ye("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: i,
      clickable: o,
      onDelete: s,
      size: u,
      variant: f
    } = n;
    return [{
      [`& .${$n.avatar}`]: t.avatar
    }, {
      [`& .${$n.avatar}`]: t[`avatar${Ke(u)}`]
    }, {
      [`& .${$n.avatar}`]: t[`avatarColor${Ke(r)}`]
    }, {
      [`& .${$n.icon}`]: t.icon
    }, {
      [`& .${$n.icon}`]: t[`icon${Ke(u)}`]
    }, {
      [`& .${$n.icon}`]: t[`iconColor${Ke(i)}`]
    }, {
      [`& .${$n.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${$n.deleteIcon}`]: t[`deleteIcon${Ke(u)}`]
    }, {
      [`& .${$n.deleteIcon}`]: t[`deleteIconColor${Ke(r)}`]
    }, {
      [`& .${$n.deleteIcon}`]: t[`deleteIcon${Ke(f)}Color${Ke(r)}`]
    }, t.root, t[`size${Ke(u)}`], t[`color${Ke(r)}`], o && t.clickable, o && r !== "default" && t[`clickableColor${Ke(r)})`], s && t.deletable, s && r !== "default" && t[`deletableColor${Ke(r)}`], t[f], t[`${f}${Ke(r)}`]];
  }
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${$n.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${$n.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${$n.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${$n.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${$n.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${$n.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${$n.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Cn(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Cn(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${$n.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${$n.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(Jr(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${$n.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : Cn(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${$n.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${$n.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${$n.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Cn(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(Jr(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${$n.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Cn(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${$n.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Cn(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(Jr(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${$n.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${$n.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${$n.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${$n.avatar}`]: {
          marginLeft: 4
        },
        [`& .${$n.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${$n.icon}`]: {
          marginLeft: 4
        },
        [`& .${$n.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${$n.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${$n.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(Jr()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : Cn(e.palette[n].main, 0.7)}`,
        [`&.${$n.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${$n.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Cn(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${$n.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : Cn(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), Q1e = ye("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${Ke(r)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function _9(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const kx = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiChip"
  }), {
    avatar: i,
    className: o,
    clickable: s,
    color: u = "default",
    component: f,
    deleteIcon: p,
    disabled: m = !1,
    icon: v,
    label: y,
    onClick: S,
    onDelete: E,
    onKeyDown: w,
    onKeyUp: _,
    size: O = "medium",
    variant: D = "filled",
    tabIndex: P,
    skipFocusWhenDisabled: M = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...N
  } = r, k = $.useRef(null), U = kr(k, n), H = (le) => {
    le.stopPropagation(), E && E(le);
  }, Y = (le) => {
    le.currentTarget === le.target && _9(le) && le.preventDefault(), w && w(le);
  }, z = (le) => {
    le.currentTarget === le.target && E && _9(le) && E(le), _ && _(le);
  }, V = s !== !1 && S ? !0 : s, F = V || E ? Ws : f || "div", X = {
    ...r,
    component: F,
    disabled: m,
    size: O,
    color: u,
    iconColor: /* @__PURE__ */ $.isValidElement(v) && v.props.color || u,
    onDelete: !!E,
    clickable: V,
    variant: D
  }, oe = Z1e(X), re = F === Ws ? {
    component: f || "div",
    focusVisibleClassName: oe.focusVisible,
    ...E && {
      disableRipple: !0
    }
  } : {};
  let Z = null;
  E && (Z = p && /* @__PURE__ */ $.isValidElement(p) ? /* @__PURE__ */ $.cloneElement(p, {
    className: yt(p.props.className, oe.deleteIcon),
    onClick: H
  }) : /* @__PURE__ */ T.jsx(Y1e, {
    className: yt(oe.deleteIcon),
    onClick: H
  }));
  let ee = null;
  i && /* @__PURE__ */ $.isValidElement(i) && (ee = /* @__PURE__ */ $.cloneElement(i, {
    className: yt(oe.avatar, i.props.className)
  }));
  let J = null;
  return v && /* @__PURE__ */ $.isValidElement(v) && (J = /* @__PURE__ */ $.cloneElement(v, {
    className: yt(oe.icon, v.props.className)
  })), Dre.NODE_ENV !== "production" && ee && J && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ T.jsxs(K1e, {
    as: F,
    className: yt(oe.root, o),
    disabled: V && m ? !0 : void 0,
    onClick: S,
    onKeyDown: Y,
    onKeyUp: z,
    ref: U,
    tabIndex: M && m ? -1 : P,
    ownerState: X,
    ...re,
    ...N,
    children: [ee || J, /* @__PURE__ */ T.jsx(Q1e, {
      className: yt(oe.label),
      ownerState: X,
      children: y
    }), Z]
  });
});
Dre.NODE_ENV !== "production" && (kx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: c.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: nF,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: c.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: c.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Icon element.
   */
  icon: c.element,
  /**
   * The content of the component.
   */
  label: c.node,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @ignore
   */
  tabIndex: c.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: c.oneOfType([c.oneOf(["filled", "outlined"]), c.string])
});
var HR = { exports: {} }, Fr = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C9;
function J1e() {
  if (C9) return Fr;
  C9 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.view_transition"), S = Symbol.for("react.client.reference");
  function E(w) {
    if (typeof w == "object" && w !== null) {
      var _ = w.$$typeof;
      switch (_) {
        case e:
          switch (w = w.type, w) {
            case n:
            case i:
            case r:
            case f:
            case p:
            case y:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case v:
                case m:
                  return w;
                case o:
                  return w;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return Fr.ContextConsumer = o, Fr.ContextProvider = s, Fr.Element = e, Fr.ForwardRef = u, Fr.Fragment = n, Fr.Lazy = v, Fr.Memo = m, Fr.Portal = t, Fr.Profiler = i, Fr.StrictMode = r, Fr.Suspense = f, Fr.SuspenseList = p, Fr.isContextConsumer = function(w) {
    return E(w) === o;
  }, Fr.isContextProvider = function(w) {
    return E(w) === s;
  }, Fr.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, Fr.isForwardRef = function(w) {
    return E(w) === u;
  }, Fr.isFragment = function(w) {
    return E(w) === n;
  }, Fr.isLazy = function(w) {
    return E(w) === v;
  }, Fr.isMemo = function(w) {
    return E(w) === m;
  }, Fr.isPortal = function(w) {
    return E(w) === t;
  }, Fr.isProfiler = function(w) {
    return E(w) === i;
  }, Fr.isStrictMode = function(w) {
    return E(w) === r;
  }, Fr.isSuspense = function(w) {
    return E(w) === f;
  }, Fr.isSuspenseList = function(w) {
    return E(w) === p;
  }, Fr.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === i || w === r || w === f || w === p || typeof w == "object" && w !== null && (w.$$typeof === v || w.$$typeof === m || w.$$typeof === s || w.$$typeof === o || w.$$typeof === u || w.$$typeof === S || w.getModuleId !== void 0);
  }, Fr.typeOf = E, Fr;
}
var Wr = {}, R9;
function e_e() {
  if (R9) return Wr;
  R9 = 1;
  var e = {};
  /**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(_) {
      if (typeof _ == "object" && _ !== null) {
        var O = _.$$typeof;
        switch (O) {
          case n:
            switch (_ = _.type, _) {
              case i:
              case s:
              case o:
              case m:
              case v:
              case E:
                return _;
              default:
                switch (_ = _ && _.$$typeof, _) {
                  case f:
                  case p:
                  case S:
                  case y:
                    return _;
                  case u:
                    return _;
                  default:
                    return O;
                }
            }
          case r:
            return O;
        }
      }
    }
    var n = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), u = Symbol.for("react.consumer"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), E = Symbol.for("react.view_transition"), w = Symbol.for("react.client.reference");
    Wr.ContextConsumer = u, Wr.ContextProvider = f, Wr.Element = n, Wr.ForwardRef = p, Wr.Fragment = i, Wr.Lazy = S, Wr.Memo = y, Wr.Portal = r, Wr.Profiler = s, Wr.StrictMode = o, Wr.Suspense = m, Wr.SuspenseList = v, Wr.isContextConsumer = function(_) {
      return t(_) === u;
    }, Wr.isContextProvider = function(_) {
      return t(_) === f;
    }, Wr.isElement = function(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === n;
    }, Wr.isForwardRef = function(_) {
      return t(_) === p;
    }, Wr.isFragment = function(_) {
      return t(_) === i;
    }, Wr.isLazy = function(_) {
      return t(_) === S;
    }, Wr.isMemo = function(_) {
      return t(_) === y;
    }, Wr.isPortal = function(_) {
      return t(_) === r;
    }, Wr.isProfiler = function(_) {
      return t(_) === s;
    }, Wr.isStrictMode = function(_) {
      return t(_) === o;
    }, Wr.isSuspense = function(_) {
      return t(_) === m;
    }, Wr.isSuspenseList = function(_) {
      return t(_) === v;
    }, Wr.isValidElementType = function(_) {
      return typeof _ == "string" || typeof _ == "function" || _ === i || _ === s || _ === o || _ === m || _ === v || typeof _ == "object" && _ !== null && (_.$$typeof === S || _.$$typeof === y || _.$$typeof === f || _.$$typeof === u || _.$$typeof === p || _.$$typeof === w || _.getModuleId !== void 0);
    }, Wr.typeOf = t;
  })(), Wr;
}
var O9;
function t_e() {
  if (O9) return HR.exports;
  O9 = 1;
  var e = {};
  return e.NODE_ENV === "production" ? HR.exports = /* @__PURE__ */ J1e() : HR.exports = /* @__PURE__ */ e_e(), HR.exports;
}
var g_ = /* @__PURE__ */ t_e(), n_e = {};
const Pc = /* @__PURE__ */ $.createContext({});
n_e.NODE_ENV !== "production" && (Pc.displayName = "ListContext");
function r_e(e) {
  return Vt("MuiList", e);
}
Wt("MuiList", ["root", "padding", "dense", "subheader"]);
var i_e = {};
const o_e = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: i
  } = e;
  return Ft({
    root: ["root", !n && "padding", r && "dense", i && "subheader"]
  }, r_e, t);
}, a_e = ye("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), Xd = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiList"
  }), {
    children: i,
    className: o,
    component: s = "ul",
    dense: u = !1,
    disablePadding: f = !1,
    subheader: p,
    ...m
  } = r, v = $.useMemo(() => ({
    dense: u
  }), [u]), y = {
    ...r,
    component: s,
    dense: u,
    disablePadding: f
  }, S = o_e(y);
  return /* @__PURE__ */ T.jsx(Pc.Provider, {
    value: v,
    children: /* @__PURE__ */ T.jsxs(a_e, {
      as: s,
      className: yt(S.root, o),
      ref: n,
      ownerState: y,
      ...m,
      children: [p, i]
    })
  });
});
i_e.NODE_ENV !== "production" && (Xd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: c.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: c.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
var Ire = {};
function Qk(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function A9(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function Pre(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function tE(e, t, n, r, i, o) {
  let s = !1, u = i(e, t, t ? n : !1);
  for (; u; ) {
    if (u === e.firstChild) {
      if (s)
        return !1;
      s = !0;
    }
    const f = r ? !1 : u.disabled || u.getAttribute("aria-disabled") === "true";
    if (!u.hasAttribute("tabindex") || !Pre(u, o) || f)
      u = i(e, u, n);
    else
      return u.focus(), !0;
  }
  return !1;
}
const ty = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: i = !1,
    autoFocusItem: o = !1,
    children: s,
    className: u,
    disabledItemsFocusable: f = !1,
    disableListWrap: p = !1,
    onKeyDown: m,
    variant: v = "selectedMenu",
    ...y
  } = t, S = $.useRef(null), E = $.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  gs(() => {
    i && S.current.focus();
  }, [i]), $.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (P, {
      direction: M
    }) => {
      const N = !S.current.style.width;
      if (P.clientHeight < S.current.clientHeight && N) {
        const k = `${Wne(jl(P))}px`;
        S.current.style[M === "rtl" ? "paddingLeft" : "paddingRight"] = k, S.current.style.width = `calc(100% + ${k})`;
      }
      return S.current;
    }
  }), []);
  const w = (P) => {
    const M = S.current, N = P.key;
    if (P.ctrlKey || P.metaKey || P.altKey) {
      m && m(P);
      return;
    }
    const U = Vi(M).activeElement;
    if (N === "ArrowDown")
      P.preventDefault(), tE(M, U, p, f, Qk);
    else if (N === "ArrowUp")
      P.preventDefault(), tE(M, U, p, f, A9);
    else if (N === "Home")
      P.preventDefault(), tE(M, null, p, f, Qk);
    else if (N === "End")
      P.preventDefault(), tE(M, null, p, f, A9);
    else if (N.length === 1) {
      const H = E.current, Y = N.toLowerCase(), z = performance.now();
      H.keys.length > 0 && (z - H.lastTime > 500 ? (H.keys = [], H.repeating = !0, H.previousKeyMatched = !0) : H.repeating && Y !== H.keys[0] && (H.repeating = !1)), H.lastTime = z, H.keys.push(Y);
      const V = U && !H.repeating && Pre(U, H);
      H.previousKeyMatched && (V || tE(M, U, !1, f, Qk, H)) ? P.preventDefault() : H.previousKeyMatched = !1;
    }
    m && m(P);
  }, _ = kr(S, n);
  let O = -1;
  $.Children.forEach(s, (P, M) => {
    if (!/* @__PURE__ */ $.isValidElement(P)) {
      O === M && (O += 1, O >= s.length && (O = -1));
      return;
    }
    Ire.NODE_ENV !== "production" && g_.isFragment(P) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), P.props.disabled || (v === "selectedMenu" && P.props.selected || O === -1) && (O = M), O === M && (P.props.disabled || P.props.muiSkipListHighlight || P.type.muiSkipListHighlight) && (O += 1, O >= s.length && (O = -1));
  });
  const D = $.Children.map(s, (P, M) => {
    if (M === O) {
      const N = {};
      return o && (N.autoFocus = !0), P.props.tabIndex === void 0 && v === "selectedMenu" && (N.tabIndex = 0), /* @__PURE__ */ $.cloneElement(P, N);
    }
    return P;
  });
  return /* @__PURE__ */ T.jsx(Xd, {
    role: "menu",
    ref: _,
    className: u,
    onKeyDown: w,
    tabIndex: i ? 0 : -1,
    ...y,
    children: D
  });
});
Ire.NODE_ENV !== "production" && (ty.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: c.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: c.node,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: c.bool,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: c.oneOf(["menu", "selectedMenu"])
});
function s_e(e) {
  return Vt("MuiDivider", e);
}
const D9 = Wt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]);
var l_e = {};
const c_e = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: i,
    light: o,
    orientation: s,
    textAlign: u,
    variant: f
  } = e;
  return Ft({
    root: ["root", t && "absolute", f, o && "light", s === "vertical" && "vertical", i && "flexItem", n && "withChildren", n && s === "vertical" && "withChildrenVertical", u === "right" && s !== "vertical" && "textAlignRight", u === "left" && s !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", s === "vertical" && "wrapperVertical"]
  }, s_e, r);
}, u_e = ye("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(Lt(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Cn(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), d_e = ye("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(Lt(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), pA = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: i = !1,
    children: o,
    className: s,
    orientation: u = "horizontal",
    component: f = o || u === "vertical" ? "div" : "hr",
    flexItem: p = !1,
    light: m = !1,
    role: v = f !== "hr" ? "separator" : void 0,
    textAlign: y = "center",
    variant: S = "fullWidth",
    ...E
  } = r, w = {
    ...r,
    absolute: i,
    component: f,
    flexItem: p,
    light: m,
    orientation: u,
    role: v,
    textAlign: y,
    variant: S
  }, _ = c_e(w);
  return /* @__PURE__ */ T.jsx(u_e, {
    as: f,
    className: yt(_.root, s),
    role: v,
    ref: n,
    ownerState: w,
    "aria-orientation": v === "separator" && (f !== "hr" || u === "vertical") ? u : void 0,
    ...E,
    children: o ? /* @__PURE__ */ T.jsx(d_e, {
      className: _.wrapper,
      ownerState: w,
      children: o
    }) : null
  });
});
pA && (pA.muiSkipListHighlight = !0);
l_e.NODE_ENV !== "production" && (pA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: c.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: c.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: c.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: c.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: c.oneOfType([c.oneOf(["fullWidth", "inset", "middle"]), c.string])
});
function f_e(e) {
  return Vt("MuiListItemIcon", e);
}
const I9 = Wt("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
var p_e = {};
const h_e = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return Ft({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, f_e, n);
}, g_e = ye("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(Lt(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), Bv = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: i,
    ...o
  } = r, s = $.useContext(Pc), u = {
    ...r,
    alignItems: s.alignItems
  }, f = h_e(u);
  return /* @__PURE__ */ T.jsx(g_e, {
    className: yt(f.root, i),
    ownerState: u,
    ref: n,
    ...o
  });
});
p_e.NODE_ENV !== "production" && (Bv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function m_e(e) {
  return Vt("MuiListItemText", e);
}
const q0 = Wt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
var v_e = {};
const y_e = (e) => {
  const {
    classes: t,
    inset: n,
    primary: r,
    secondary: i,
    dense: o
  } = e;
  return Ft({
    root: ["root", n && "inset", o && "dense", r && i && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, m_e, t);
}, b_e = ye("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${q0.primary}`]: t.primary
    }, {
      [`& .${q0.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${u9.root}:where(& .${q0.primary})`]: {
    display: "block"
  },
  [`.${u9.root}:where(& .${q0.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), dp = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiListItemText"
  }), {
    children: i,
    className: o,
    disableTypography: s = !1,
    inset: u = !1,
    primary: f,
    primaryTypographyProps: p,
    secondary: m,
    secondaryTypographyProps: v,
    slots: y = {},
    slotProps: S = {},
    ...E
  } = r, {
    dense: w
  } = $.useContext(Pc);
  let _ = f ?? i, O = m;
  const D = {
    ...r,
    disableTypography: s,
    inset: u,
    primary: !!_,
    secondary: !!O,
    dense: w
  }, P = y_e(D), M = {
    slots: y,
    slotProps: {
      primary: p,
      secondary: v,
      ...S
    }
  }, [N, k] = Xt("root", {
    className: yt(P.root, o),
    elementType: b_e,
    externalForwardedProps: {
      ...M,
      ...E
    },
    ownerState: D,
    ref: n
  }), [U, H] = Xt("primary", {
    className: P.primary,
    elementType: St,
    externalForwardedProps: M,
    ownerState: D
  }), [Y, z] = Xt("secondary", {
    className: P.secondary,
    elementType: St,
    externalForwardedProps: M,
    ownerState: D
  });
  return _ != null && _.type !== St && !s && (_ = /* @__PURE__ */ T.jsx(U, {
    variant: w ? "body2" : "body1",
    component: H != null && H.variant ? void 0 : "span",
    ...H,
    children: _
  })), O != null && O.type !== St && !s && (O = /* @__PURE__ */ T.jsx(Y, {
    variant: "body2",
    color: "textSecondary",
    ...z,
    children: O
  })), /* @__PURE__ */ T.jsxs(N, {
    ...k,
    children: [_, O]
  });
});
v_e.NODE_ENV !== "production" && (dp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: c.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: c.bool,
  /**
   * The main content element.
   */
  primary: c.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: c.object,
  /**
   * The secondary content element.
   */
  secondary: c.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: c.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    primary: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    secondary: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    primary: c.elementType,
    root: c.elementType,
    secondary: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function x_e(e) {
  return Vt("MuiMenuItem", e);
}
const nE = Wt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]);
var Nre = {};
const S_e = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, w_e = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: i,
    selected: o,
    classes: s
  } = e, f = Ft({
    root: ["root", n && "dense", t && "disabled", !i && "gutters", r && "divider", o && "selected"]
  }, x_e, s);
  return {
    ...s,
    ...f
  };
}, T_e = ye(Ws, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: S_e
})(Lt(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${nE.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${nE.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${nE.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${nE.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${nE.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${D9.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${D9.inset}`]: {
    marginLeft: 52
  },
  [`& .${q0.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${q0.inset}`]: {
    paddingLeft: 36
  },
  [`& .${I9.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${I9.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), qo = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: i = !1,
    component: o = "li",
    dense: s = !1,
    divider: u = !1,
    disableGutters: f = !1,
    focusVisibleClassName: p,
    role: m = "menuitem",
    tabIndex: v,
    className: y,
    ...S
  } = r, E = $.useContext(Pc), w = $.useMemo(() => ({
    dense: s || E.dense || !1,
    disableGutters: f
  }), [E.dense, s, f]), _ = $.useRef(null);
  gs(() => {
    i && (_.current ? _.current.focus() : Nre.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [i]);
  const O = {
    ...r,
    dense: w.dense,
    divider: u,
    disableGutters: f
  }, D = w_e(r), P = kr(_, n);
  let M;
  return r.disabled || (M = v !== void 0 ? v : -1), /* @__PURE__ */ T.jsx(Pc.Provider, {
    value: w,
    children: /* @__PURE__ */ T.jsx(T_e, {
      ref: P,
      role: m,
      tabIndex: M,
      component: o,
      focusVisibleClassName: yt(D.focusVisible, p),
      className: yt(D.root, y),
      ...S,
      ownerState: O,
      classes: D
    })
  });
});
Nre.NODE_ENV !== "production" && (qo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: c.bool,
  /**
   * @ignore
   */
  disabled: c.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  role: c.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @default 0
   */
  tabIndex: c.number
});
/*! @license DOMPurify 3.0.9 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.9/LICENSE */
const {
  entries: Mre,
  setPrototypeOf: P9,
  isFrozen: E_e,
  getPrototypeOf: __e,
  getOwnPropertyDescriptor: C_e
} = Object;
let {
  freeze: ms,
  seal: Pu,
  create: jre
} = Object, {
  apply: sV,
  construct: lV
} = typeof Reflect < "u" && Reflect;
ms || (ms = function(t) {
  return t;
});
Pu || (Pu = function(t) {
  return t;
});
sV || (sV = function(t, n, r) {
  return t.apply(n, r);
});
lV || (lV = function(t, n) {
  return new t(...n);
});
const qR = kl(Array.prototype.forEach), N9 = kl(Array.prototype.pop), rE = kl(Array.prototype.push), jO = kl(String.prototype.toLowerCase), Jk = kl(String.prototype.toString), R_e = kl(String.prototype.match), iE = kl(String.prototype.replace), O_e = kl(String.prototype.indexOf), A_e = kl(String.prototype.trim), Tu = kl(Object.prototype.hasOwnProperty), Sl = kl(RegExp.prototype.test), oE = D_e(TypeError);
function kl(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return sV(e, t, r);
  };
}
function D_e(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return lV(e, n);
  };
}
function Gn(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : jO;
  P9 && P9(e, null);
  let r = t.length;
  for (; r--; ) {
    let i = t[r];
    if (typeof i == "string") {
      const o = n(i);
      o !== i && (E_e(t) || (t[r] = o), i = o);
    }
    e[i] = !0;
  }
  return e;
}
function I_e(e) {
  for (let t = 0; t < e.length; t++)
    Tu(e, t) || (e[t] = null);
  return e;
}
function fv(e) {
  const t = jre(null);
  for (const [n, r] of Mre(e))
    Tu(e, n) && (Array.isArray(r) ? t[n] = I_e(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = fv(r) : t[n] = r);
  return t;
}
function $R(e, t) {
  for (; e !== null; ) {
    const r = C_e(e, t);
    if (r) {
      if (r.get)
        return kl(r.get);
      if (typeof r.value == "function")
        return kl(r.value);
    }
    e = __e(e);
  }
  function n() {
    return null;
  }
  return n;
}
const M9 = ms(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ez = ms(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), tz = ms(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), P_e = ms(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), nz = ms(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), N_e = ms(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), j9 = ms(["#text"]), L9 = ms(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), rz = ms(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), k9 = ms(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), GR = ms(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), M_e = Pu(/\{\{[\w\W]*|[\w\W]*\}\}/gm), j_e = Pu(/<%[\w\W]*|[\w\W]*%>/gm), L_e = Pu(/\${[\w\W]*}/gm), k_e = Pu(/^data-[\-\w.\u00B7-\uFFFF]/), z_e = Pu(/^aria-[\-\w]+$/), Lre = Pu(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), B_e = Pu(/^(?:\w+script|data):/i), V_e = Pu(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), kre = Pu(/^html$/i);
var z9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: M_e,
  ERB_EXPR: j_e,
  TMPLIT_EXPR: L_e,
  DATA_ATTR: k_e,
  ARIA_ATTR: z_e,
  IS_ALLOWED_URI: Lre,
  IS_SCRIPT_OR_DATA: B_e,
  ATTR_WHITESPACE: V_e,
  DOCTYPE_NAME: kre
});
const U_e = function() {
  return typeof window > "u" ? null : window;
}, F_e = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const o = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(o, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
};
function zre() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : U_e();
  const t = (Le) => zre(Le);
  if (t.version = "3.0.9", t.removed = [], !e || !e.document || e.document.nodeType !== 9)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, i = r.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: u,
    Element: f,
    NodeFilter: p,
    NamedNodeMap: m = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: v,
    DOMParser: y,
    trustedTypes: S
  } = e, E = f.prototype, w = $R(E, "cloneNode"), _ = $R(E, "nextSibling"), O = $R(E, "childNodes"), D = $R(E, "parentNode");
  if (typeof s == "function") {
    const Le = n.createElement("template");
    Le.content && Le.content.ownerDocument && (n = Le.content.ownerDocument);
  }
  let P, M = "";
  const {
    implementation: N,
    createNodeIterator: k,
    createDocumentFragment: U,
    getElementsByTagName: H
  } = n, {
    importNode: Y
  } = r;
  let z = {};
  t.isSupported = typeof Mre == "function" && typeof D == "function" && N && N.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: V,
    ERB_EXPR: F,
    TMPLIT_EXPR: X,
    DATA_ATTR: oe,
    ARIA_ATTR: re,
    IS_SCRIPT_OR_DATA: Z,
    ATTR_WHITESPACE: ee
  } = z9;
  let {
    IS_ALLOWED_URI: J
  } = z9, le = null;
  const be = Gn({}, [...M9, ...ez, ...tz, ...nz, ...j9]);
  let ne = null;
  const ae = Gn({}, [...L9, ...rz, ...k9, ...GR]);
  let ie = Object.seal(jre(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), he = null, pe = null, me = !0, Ee = !0, Ie = !1, Pe = !0, De = !1, Ye = !1, Ue = !1, ve = !1, rt = !1, Te = !1, Je = !1, L = !0, te = !1;
  const ge = "user-content-";
  let ke = !0, We = !1, Be = {}, je = null;
  const mt = Gn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let qe = null;
  const at = Gn({}, ["audio", "video", "img", "source", "image", "track"]);
  let et = null;
  const bt = Gn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), q = "http://www.w3.org/1998/Math/MathML", W = "http://www.w3.org/2000/svg", Q = "http://www.w3.org/1999/xhtml";
  let ce = Q, _e = !1, Fe = null;
  const gt = Gn({}, [q, W, Q], Jk);
  let ct = null;
  const ht = ["application/xhtml+xml", "text/html"], Yt = "text/html";
  let Rt = null, cn = null;
  const Kt = n.createElement("form"), Zt = function(de) {
    return de instanceof RegExp || de instanceof Function;
  }, dn = function() {
    let de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(cn && cn === de)) {
      if ((!de || typeof de != "object") && (de = {}), de = fv(de), ct = // eslint-disable-next-line unicorn/prefer-includes
      ht.indexOf(de.PARSER_MEDIA_TYPE) === -1 ? Yt : de.PARSER_MEDIA_TYPE, Rt = ct === "application/xhtml+xml" ? Jk : jO, le = Tu(de, "ALLOWED_TAGS") ? Gn({}, de.ALLOWED_TAGS, Rt) : be, ne = Tu(de, "ALLOWED_ATTR") ? Gn({}, de.ALLOWED_ATTR, Rt) : ae, Fe = Tu(de, "ALLOWED_NAMESPACES") ? Gn({}, de.ALLOWED_NAMESPACES, Jk) : gt, et = Tu(de, "ADD_URI_SAFE_ATTR") ? Gn(
        fv(bt),
        // eslint-disable-line indent
        de.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        Rt
        // eslint-disable-line indent
      ) : bt, qe = Tu(de, "ADD_DATA_URI_TAGS") ? Gn(
        fv(at),
        // eslint-disable-line indent
        de.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        Rt
        // eslint-disable-line indent
      ) : at, je = Tu(de, "FORBID_CONTENTS") ? Gn({}, de.FORBID_CONTENTS, Rt) : mt, he = Tu(de, "FORBID_TAGS") ? Gn({}, de.FORBID_TAGS, Rt) : {}, pe = Tu(de, "FORBID_ATTR") ? Gn({}, de.FORBID_ATTR, Rt) : {}, Be = Tu(de, "USE_PROFILES") ? de.USE_PROFILES : !1, me = de.ALLOW_ARIA_ATTR !== !1, Ee = de.ALLOW_DATA_ATTR !== !1, Ie = de.ALLOW_UNKNOWN_PROTOCOLS || !1, Pe = de.ALLOW_SELF_CLOSE_IN_ATTR !== !1, De = de.SAFE_FOR_TEMPLATES || !1, Ye = de.WHOLE_DOCUMENT || !1, rt = de.RETURN_DOM || !1, Te = de.RETURN_DOM_FRAGMENT || !1, Je = de.RETURN_TRUSTED_TYPE || !1, ve = de.FORCE_BODY || !1, L = de.SANITIZE_DOM !== !1, te = de.SANITIZE_NAMED_PROPS || !1, ke = de.KEEP_CONTENT !== !1, We = de.IN_PLACE || !1, J = de.ALLOWED_URI_REGEXP || Lre, ce = de.NAMESPACE || Q, ie = de.CUSTOM_ELEMENT_HANDLING || {}, de.CUSTOM_ELEMENT_HANDLING && Zt(de.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ie.tagNameCheck = de.CUSTOM_ELEMENT_HANDLING.tagNameCheck), de.CUSTOM_ELEMENT_HANDLING && Zt(de.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ie.attributeNameCheck = de.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), de.CUSTOM_ELEMENT_HANDLING && typeof de.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ie.allowCustomizedBuiltInElements = de.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), De && (Ee = !1), Te && (rt = !0), Be && (le = Gn({}, j9), ne = [], Be.html === !0 && (Gn(le, M9), Gn(ne, L9)), Be.svg === !0 && (Gn(le, ez), Gn(ne, rz), Gn(ne, GR)), Be.svgFilters === !0 && (Gn(le, tz), Gn(ne, rz), Gn(ne, GR)), Be.mathMl === !0 && (Gn(le, nz), Gn(ne, k9), Gn(ne, GR))), de.ADD_TAGS && (le === be && (le = fv(le)), Gn(le, de.ADD_TAGS, Rt)), de.ADD_ATTR && (ne === ae && (ne = fv(ne)), Gn(ne, de.ADD_ATTR, Rt)), de.ADD_URI_SAFE_ATTR && Gn(et, de.ADD_URI_SAFE_ATTR, Rt), de.FORBID_CONTENTS && (je === mt && (je = fv(je)), Gn(je, de.FORBID_CONTENTS, Rt)), ke && (le["#text"] = !0), Ye && Gn(le, ["html", "head", "body"]), le.table && (Gn(le, ["tbody"]), delete he.tbody), de.TRUSTED_TYPES_POLICY) {
        if (typeof de.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw oE('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof de.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw oE('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        P = de.TRUSTED_TYPES_POLICY, M = P.createHTML("");
      } else
        P === void 0 && (P = F_e(S, i)), P !== null && typeof M == "string" && (M = P.createHTML(""));
      ms && ms(de), cn = de;
    }
  }, xr = Gn({}, ["mi", "mo", "mn", "ms", "mtext"]), Hr = Gn({}, ["foreignobject", "desc", "title", "annotation-xml"]), jr = Gn({}, ["title", "style", "font", "a", "script"]), Ut = Gn({}, [...ez, ...tz, ...P_e]), ei = Gn({}, [...nz, ...N_e]), It = function(de) {
    let Ne = D(de);
    (!Ne || !Ne.tagName) && (Ne = {
      namespaceURI: ce,
      tagName: "template"
    });
    const vt = jO(de.tagName), kt = jO(Ne.tagName);
    return Fe[de.namespaceURI] ? de.namespaceURI === W ? Ne.namespaceURI === Q ? vt === "svg" : Ne.namespaceURI === q ? vt === "svg" && (kt === "annotation-xml" || xr[kt]) : !!Ut[vt] : de.namespaceURI === q ? Ne.namespaceURI === Q ? vt === "math" : Ne.namespaceURI === W ? vt === "math" && Hr[kt] : !!ei[vt] : de.namespaceURI === Q ? Ne.namespaceURI === W && !Hr[kt] || Ne.namespaceURI === q && !xr[kt] ? !1 : !ei[vt] && (jr[vt] || !Ut[vt]) : !!(ct === "application/xhtml+xml" && Fe[de.namespaceURI]) : !1;
  }, Et = function(de) {
    rE(t.removed, {
      element: de
    });
    try {
      de.parentNode.removeChild(de);
    } catch {
      de.remove();
    }
  }, jt = function(de, Ne) {
    try {
      rE(t.removed, {
        attribute: Ne.getAttributeNode(de),
        from: Ne
      });
    } catch {
      rE(t.removed, {
        attribute: null,
        from: Ne
      });
    }
    if (Ne.removeAttribute(de), de === "is" && !ne[de])
      if (rt || Te)
        try {
          Et(Ne);
        } catch {
        }
      else
        try {
          Ne.setAttribute(de, "");
        } catch {
        }
  }, Jt = function(de) {
    let Ne = null, vt = null;
    if (ve)
      de = "<remove></remove>" + de;
    else {
      const fn = R_e(de, /^[\r\n\t ]+/);
      vt = fn && fn[0];
    }
    ct === "application/xhtml+xml" && ce === Q && (de = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + de + "</body></html>");
    const kt = P ? P.createHTML(de) : de;
    if (ce === Q)
      try {
        Ne = new y().parseFromString(kt, ct);
      } catch {
      }
    if (!Ne || !Ne.documentElement) {
      Ne = N.createDocument(ce, "template", null);
      try {
        Ne.documentElement.innerHTML = _e ? M : kt;
      } catch {
      }
    }
    const zt = Ne.body || Ne.documentElement;
    return de && vt && zt.insertBefore(n.createTextNode(vt), zt.childNodes[0] || null), ce === Q ? H.call(Ne, Ye ? "html" : "body")[0] : Ye ? Ne.documentElement : zt;
  }, Nn = function(de) {
    return k.call(
      de.ownerDocument || de,
      de,
      // eslint-disable-next-line no-bitwise
      p.SHOW_ELEMENT | p.SHOW_COMMENT | p.SHOW_TEXT,
      null
    );
  }, Ai = function(de) {
    return de instanceof v && (typeof de.nodeName != "string" || typeof de.textContent != "string" || typeof de.removeChild != "function" || !(de.attributes instanceof m) || typeof de.removeAttribute != "function" || typeof de.setAttribute != "function" || typeof de.namespaceURI != "string" || typeof de.insertBefore != "function" || typeof de.hasChildNodes != "function");
  }, ho = function(de) {
    return typeof u == "function" && de instanceof u;
  }, gi = function(de, Ne, vt) {
    z[de] && qR(z[de], (kt) => {
      kt.call(t, Ne, vt, cn);
    });
  }, go = function(de) {
    let Ne = null;
    if (gi("beforeSanitizeElements", de, null), Ai(de))
      return Et(de), !0;
    const vt = Rt(de.nodeName);
    if (gi("uponSanitizeElement", de, {
      tagName: vt,
      allowedTags: le
    }), de.hasChildNodes() && !ho(de.firstElementChild) && Sl(/<[/\w]/g, de.innerHTML) && Sl(/<[/\w]/g, de.textContent))
      return Et(de), !0;
    if (!le[vt] || he[vt]) {
      if (!he[vt] && _t(vt) && (ie.tagNameCheck instanceof RegExp && Sl(ie.tagNameCheck, vt) || ie.tagNameCheck instanceof Function && ie.tagNameCheck(vt)))
        return !1;
      if (ke && !je[vt]) {
        const kt = D(de) || de.parentNode, zt = O(de) || de.childNodes;
        if (zt && kt) {
          const fn = zt.length;
          for (let Xn = fn - 1; Xn >= 0; --Xn)
            kt.insertBefore(w(zt[Xn], !0), _(de));
        }
      }
      return Et(de), !0;
    }
    return de instanceof f && !It(de) || (vt === "noscript" || vt === "noembed" || vt === "noframes") && Sl(/<\/no(script|embed|frames)/i, de.innerHTML) ? (Et(de), !0) : (De && de.nodeType === 3 && (Ne = de.textContent, qR([V, F, X], (kt) => {
      Ne = iE(Ne, kt, " ");
    }), de.textContent !== Ne && (rE(t.removed, {
      element: de.cloneNode()
    }), de.textContent = Ne)), gi("afterSanitizeElements", de, null), !1);
  }, gr = function(de, Ne, vt) {
    if (L && (Ne === "id" || Ne === "name") && (vt in n || vt in Kt))
      return !1;
    if (!(Ee && !pe[Ne] && Sl(oe, Ne))) {
      if (!(me && Sl(re, Ne))) {
        if (!ne[Ne] || pe[Ne]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(_t(de) && (ie.tagNameCheck instanceof RegExp && Sl(ie.tagNameCheck, de) || ie.tagNameCheck instanceof Function && ie.tagNameCheck(de)) && (ie.attributeNameCheck instanceof RegExp && Sl(ie.attributeNameCheck, Ne) || ie.attributeNameCheck instanceof Function && ie.attributeNameCheck(Ne)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Ne === "is" && ie.allowCustomizedBuiltInElements && (ie.tagNameCheck instanceof RegExp && Sl(ie.tagNameCheck, vt) || ie.tagNameCheck instanceof Function && ie.tagNameCheck(vt)))
          ) return !1;
        } else if (!et[Ne]) {
          if (!Sl(J, iE(vt, ee, ""))) {
            if (!((Ne === "src" || Ne === "xlink:href" || Ne === "href") && de !== "script" && O_e(vt, "data:") === 0 && qe[de])) {
              if (!(Ie && !Sl(Z, iE(vt, ee, "")))) {
                if (vt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, _t = function(de) {
    return de !== "annotation-xml" && de.indexOf("-") > 0;
  }, mi = function(de) {
    gi("beforeSanitizeAttributes", de, null);
    const {
      attributes: Ne
    } = de;
    if (!Ne)
      return;
    const vt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ne
    };
    let kt = Ne.length;
    for (; kt--; ) {
      const zt = Ne[kt], {
        name: fn,
        namespaceURI: Xn,
        value: mo
      } = zt, ys = Rt(fn);
      let Di = fn === "value" ? mo : A_e(mo);
      if (vt.attrName = ys, vt.attrValue = Di, vt.keepAttr = !0, vt.forceKeepAttr = void 0, gi("uponSanitizeAttribute", de, vt), Di = vt.attrValue, vt.forceKeepAttr || (jt(fn, de), !vt.keepAttr))
        continue;
      if (!Pe && Sl(/\/>/i, Di)) {
        jt(fn, de);
        continue;
      }
      De && qR([V, F, X], (vo) => {
        Di = iE(Di, vo, " ");
      });
      const qa = Rt(de.nodeName);
      if (gr(qa, ys, Di)) {
        if (te && (ys === "id" || ys === "name") && (jt(fn, de), Di = ge + Di), P && typeof S == "object" && typeof S.getAttributeType == "function" && !Xn)
          switch (S.getAttributeType(qa, ys)) {
            case "TrustedHTML": {
              Di = P.createHTML(Di);
              break;
            }
            case "TrustedScriptURL": {
              Di = P.createScriptURL(Di);
              break;
            }
          }
        try {
          Xn ? de.setAttributeNS(Xn, fn, Di) : de.setAttribute(fn, Di), N9(t.removed);
        } catch {
        }
      }
    }
    gi("afterSanitizeAttributes", de, null);
  }, ti = function Le(de) {
    let Ne = null;
    const vt = Nn(de);
    for (gi("beforeSanitizeShadowDOM", de, null); Ne = vt.nextNode(); )
      gi("uponSanitizeShadowNode", Ne, null), !go(Ne) && (Ne.content instanceof o && Le(Ne.content), mi(Ne));
    gi("afterSanitizeShadowDOM", de, null);
  };
  return t.sanitize = function(Le) {
    let de = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ne = null, vt = null, kt = null, zt = null;
    if (_e = !Le, _e && (Le = "<!-->"), typeof Le != "string" && !ho(Le))
      if (typeof Le.toString == "function") {
        if (Le = Le.toString(), typeof Le != "string")
          throw oE("dirty is not a string, aborting");
      } else
        throw oE("toString is not a function");
    if (!t.isSupported)
      return Le;
    if (Ue || dn(de), t.removed = [], typeof Le == "string" && (We = !1), We) {
      if (Le.nodeName) {
        const mo = Rt(Le.nodeName);
        if (!le[mo] || he[mo])
          throw oE("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Le instanceof u)
      Ne = Jt("<!---->"), vt = Ne.ownerDocument.importNode(Le, !0), vt.nodeType === 1 && vt.nodeName === "BODY" || vt.nodeName === "HTML" ? Ne = vt : Ne.appendChild(vt);
    else {
      if (!rt && !De && !Ye && // eslint-disable-next-line unicorn/prefer-includes
      Le.indexOf("<") === -1)
        return P && Je ? P.createHTML(Le) : Le;
      if (Ne = Jt(Le), !Ne)
        return rt ? null : Je ? M : "";
    }
    Ne && ve && Et(Ne.firstChild);
    const fn = Nn(We ? Le : Ne);
    for (; kt = fn.nextNode(); )
      go(kt) || (kt.content instanceof o && ti(kt.content), mi(kt));
    if (We)
      return Le;
    if (rt) {
      if (Te)
        for (zt = U.call(Ne.ownerDocument); Ne.firstChild; )
          zt.appendChild(Ne.firstChild);
      else
        zt = Ne;
      return (ne.shadowroot || ne.shadowrootmode) && (zt = Y.call(r, zt, !0)), zt;
    }
    let Xn = Ye ? Ne.outerHTML : Ne.innerHTML;
    return Ye && le["!doctype"] && Ne.ownerDocument && Ne.ownerDocument.doctype && Ne.ownerDocument.doctype.name && Sl(kre, Ne.ownerDocument.doctype.name) && (Xn = "<!DOCTYPE " + Ne.ownerDocument.doctype.name + `>
` + Xn), De && qR([V, F, X], (mo) => {
      Xn = iE(Xn, mo, " ");
    }), P && Je ? P.createHTML(Xn) : Xn;
  }, t.setConfig = function() {
    let Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    dn(Le), Ue = !0;
  }, t.clearConfig = function() {
    cn = null, Ue = !1;
  }, t.isValidAttribute = function(Le, de, Ne) {
    cn || dn({});
    const vt = Rt(Le), kt = Rt(de);
    return gr(vt, kt, Ne);
  }, t.addHook = function(Le, de) {
    typeof de == "function" && (z[Le] = z[Le] || [], rE(z[Le], de));
  }, t.removeHook = function(Le) {
    if (z[Le])
      return N9(z[Le]);
  }, t.removeHooks = function(Le) {
    z[Le] && (z[Le] = []);
  }, t.removeAllHooks = function() {
    z = {};
  }, t;
}
var Bre = zre();
const W_e = {}, H_e = {
  ALLOWED_TAGS: []
}, q_e = {
  ALLOWED_ATTR: ["href", "src", "alt"],
  ALLOWED_TAGS: ["a", "b", "br", "i", "img", "p", "span"]
}, $_e = {
  ALLOWED_ATTR: ["href", "target", "src", "alt", "dir"],
  ALLOWED_TAGS: ["a", "b", "br", "i", "img", "p", "span", "strong", "em", "ul", "ol", "li"]
}, G_e = {
  iiif: q_e,
  liberal: W_e,
  mirador2: $_e,
  noHtml: H_e
}, Y_e = ye("span", { name: "IIIFHtmlContent", slot: "root" })({});
Bre.addHook("afterSanitizeAttributes", (e) => {
  "target" in e && (e.setAttribute("target", "_blank"), e.setAttribute("rel", "noopener noreferrer"));
});
function Bs({
  classes: e = {},
  htmlString: t,
  ruleSet: n,
  ...r
}) {
  return /* @__PURE__ */ T.jsx(
    Y_e,
    {
      className: [Nt("third-party-html"), e.root].join(" "),
      dangerouslySetInnerHTML: {
        // eslint-disable-line react/no-danger
        __html: Bre.sanitize(t, G_e[n])
      },
      ...r
    }
  );
}
Bs.propTypes = {
  classes: c.objectOf(c.string),
  htmlString: c.string.isRequired,
  ruleSet: c.string.isRequired
};
function X_e(e) {
  const t = an();
  return ln(() => {
    t.current = e;
  }, [e]), t.current;
}
function zx({
  children: e,
  containerRef: t,
  offsetTop: n = 0,
  scrollTo: r,
  ...i
}) {
  const o = an(), s = X_e(r);
  return ln(() => {
    var S, E;
    if (!r || r === s) return;
    const u = o == null ? void 0 : o.current;
    if (!u) return;
    const f = (S = t == null ? void 0 : t.current) == null ? void 0 : S.querySelector(`.${Nt("scrollto-scrollable")}`);
    if (!f) return;
    const p = ((E = t == null ? void 0 : t.current) == null ? void 0 : E.getBoundingClientRect()) || {}, m = (u == null ? void 0 : u.getBoundingClientRect()) || {};
    if (!(m.top < p.top + n || m.bottom > p.bottom)) return;
    const y = u.offsetTop - p.height / 2 + n;
    f.scrollTo(0, y);
  }, [t, o, r, s, n]), !r && B2(i) ? e : jd(e, { ref: o, ...i });
}
zx.propTypes = {
  children: c.node.isRequired,
  containerRef: c.oneOfType([
    c.func,
    c.shape({ current: c.instanceOf(Element) })
  ]).isRequired,
  offsetTop: c.number,
  scrollTo: c.bool.isRequired
};
function Vre({
  annotations: e = [],
  index: t,
  label: n,
  selectedAnnotationId: r = void 0,
  totalSize: i,
  listContainerComponent: o = "li",
  htmlSanitizationRuleSet: s = "iiif",
  hoveredAnnotationIds: u = [],
  containerRef: f = void 0,
  deselectAnnotation: p,
  selectAnnotation: m,
  windowId: v,
  hoverAnnotation: y
}) {
  const { t: S } = Ct(), E = Yn((O, D) => {
    r === D.id ? p(v, D.id) : m(v, D.id);
  }, [v, p, m, r]), w = Yn((O) => {
    y(v, [O.id]);
  }, [y, v]), _ = Yn(() => {
    y(v, []);
  }, [y, v]);
  return e.length === 0 ? null : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(St, { sx: { paddingLeft: 2, paddingRight: 1, paddingTop: 2 }, variant: "overline", children: S("annotationCanvasLabel", { context: `${t + 1}/${i}`, label: n }) }),
    /* @__PURE__ */ T.jsx(ty, { autoFocusItem: !0, variant: "selectedMenu", children: e.map((O) => /* @__PURE__ */ T.jsx(
      zx,
      {
        containerRef: f,
        offsetTop: 96,
        scrollTo: r === O.id,
        selected: r === O.id,
        children: /* @__PURE__ */ T.jsx(
          qo,
          {
            component: o,
            variant: "multiline",
            divider: !0,
            sx: {
              "&:hover,&:focus": {
                backgroundColor: "action.hover"
              },
              backgroundColor: u.includes(O.id) ? "action.hover" : ""
            },
            annotationid: O.id,
            onClick: (D) => E(D, O),
            onFocus: () => w(O),
            onBlur: _,
            onMouseEnter: () => w(O),
            onMouseLeave: _,
            children: /* @__PURE__ */ T.jsx(
              dp,
              {
                primaryTypographyProps: { variant: "body2" },
                primary: /* @__PURE__ */ T.jsx(Bs, { ruleSet: s, htmlString: O.content }),
                secondary: O.tags.map((D) => /* @__PURE__ */ T.jsx(kx, { component: "span", size: "small", variant: "outlined", label: D, id: D }, D.toString()))
              }
            )
          },
          O.id
        )
      },
      `${O.id}-scroll`
    )) })
  ] });
}
Vre.propTypes = {
  annotations: c.arrayOf(
    c.shape({
      content: c.string.isRequired,
      id: c.string.isRequired
    })
  ),
  containerRef: c.oneOfType([
    c.func,
    c.shape({ current: c.instanceOf(Element) })
  ]),
  deselectAnnotation: c.func.isRequired,
  hoverAnnotation: c.func.isRequired,
  hoveredAnnotationIds: c.arrayOf(c.string),
  htmlSanitizationRuleSet: c.string,
  index: c.number.isRequired,
  label: c.string.isRequired,
  listContainerComponent: c.elementType,
  selectAnnotation: c.func.isRequired,
  selectedAnnotationId: c.string,
  totalSize: c.number.isRequired,
  windowId: c.string.isRequired
};
function Z_e(e) {
  return e.map((t, n) => ({
    content: t.chars,
    id: t.id,
    tags: t.tags,
    targetId: t.targetId
  }));
}
const K_e = (e, { canvasId: t, windowId: n }) => ({
  annotations: Z_e(
    fte(e, { canvasId: t, windowId: n })
  ),
  htmlSanitizationRuleSet: Dn(e).annotations.htmlSanitizationRuleSet,
  label: yg(e, {
    canvasId: t,
    windowId: n
  }),
  selectedAnnotationId: X1(e, { windowId: n })
}), Q_e = {
  deselectAnnotation: B3,
  hoverAnnotation: V3,
  selectAnnotation: Kv
}, J_e = wt(
  At(K_e, Q_e),
  Tt("CanvasAnnotations")
), eCe = J_e(Vre), m_ = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "CloseSharp"), tCe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 19H5V5h7V3H3v18h18v-9h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNewSharp"), nCe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "DragIndicatorSharp");
function rCe(e) {
  return Vt("MuiToolbar", e);
}
Wt("MuiToolbar", ["root", "gutters", "regular", "dense"]);
var iCe = {};
const oCe = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: r
  } = e;
  return Ft({
    root: ["root", !n && "gutters", r]
  }, rCe, t);
}, aCe = ye("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})(Lt(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2),
      [e.breakpoints.up("sm")]: {
        paddingLeft: e.spacing(3),
        paddingRight: e.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: e.mixins.toolbar
  }]
}))), ny = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiToolbar"
  }), {
    className: i,
    component: o = "div",
    disableGutters: s = !1,
    variant: u = "regular",
    ...f
  } = r, p = {
    ...r,
    component: o,
    disableGutters: s,
    variant: u
  }, m = oCe(p);
  return /* @__PURE__ */ T.jsx(aCe, {
    as: o,
    className: yt(m.root, i),
    ref: n,
    ownerState: p,
    ...f
  });
});
iCe.NODE_ENV !== "production" && (ny.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: c.oneOfType([c.oneOf(["dense", "regular"]), c.string])
});
var aE = { exports: {} }, iz = {};
function Ure(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Ure(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function B9() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = Ure(e)) && (r && (r += " "), r += t);
  return r;
}
const sCe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: B9,
  default: B9
}, Symbol.toStringTag, { value: "Module" })), lCe = /* @__PURE__ */ SJ(sCe);
var Yi = {}, Uh = {}, V9;
function rI() {
  if (V9) return Uh;
  V9 = 1, Object.defineProperty(Uh, "__esModule", {
    value: !0
  }), Uh.dontSetMe = i, Uh.findInArray = e, Uh.int = r, Uh.isFunction = t, Uh.isNum = n;
  function e(o, s) {
    for (var u = 0, f = o.length; u < f; u++)
      if (s.apply(s, [o[u], u, o])) return o[u];
  }
  function t(o) {
    return typeof o == "function" || Object.prototype.toString.call(o) === "[object Function]";
  }
  function n(o) {
    return typeof o == "number" && !isNaN(o);
  }
  function r(o) {
    return parseInt(o, 10);
  }
  function i(o, s, u) {
    if (o[s])
      return new Error("Invalid prop ".concat(s, " passed to ").concat(u, " - do not set this, set it on the child."));
  }
  return Uh;
}
var Fh = {}, U9;
function cCe() {
  if (U9) return Fh;
  U9 = 1, Object.defineProperty(Fh, "__esModule", {
    value: !0
  }), Fh.browserPrefixToKey = n, Fh.browserPrefixToStyle = r, Fh.default = void 0, Fh.getPrefix = t;
  var e = ["Moz", "Webkit", "O", "ms"];
  function t() {
    var s, u, f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
    if (typeof window > "u") return "";
    var p = (s = window.document) === null || s === void 0 || (u = s.documentElement) === null || u === void 0 ? void 0 : u.style;
    if (!p || f in p) return "";
    for (var m = 0; m < e.length; m++)
      if (n(f, e[m]) in p) return e[m];
    return "";
  }
  function n(s, u) {
    return u ? "".concat(u).concat(i(s)) : s;
  }
  function r(s, u) {
    return u ? "-".concat(u.toLowerCase(), "-").concat(s) : s;
  }
  function i(s) {
    for (var u = "", f = !0, p = 0; p < s.length; p++)
      f ? (u += s[p].toUpperCase(), f = !1) : s[p] === "-" ? f = !0 : u += s[p];
    return u;
  }
  var o = t();
  return Fh.default = o, Fh;
}
var F9;
function yF() {
  if (F9) return Yi;
  F9 = 1;
  function e(V) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(F) {
      return typeof F;
    } : function(F) {
      return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
    }, e(V);
  }
  Object.defineProperty(Yi, "__esModule", {
    value: !0
  }), Yi.addClassName = Y, Yi.addEvent = v, Yi.addUserSelectStyles = U, Yi.createCSSTransform = D, Yi.createSVGTransform = P, Yi.getTouch = N, Yi.getTouchIdentifier = k, Yi.getTranslation = M, Yi.innerHeight = w, Yi.innerWidth = _, Yi.matchesSelector = p, Yi.matchesSelectorAndParentsTo = m, Yi.offsetXYFromParent = O, Yi.outerHeight = S, Yi.outerWidth = E, Yi.removeClassName = z, Yi.removeEvent = y, Yi.removeUserSelectStyles = H;
  var t = rI(), n = i(cCe());
  function r(V) {
    if (typeof WeakMap != "function") return null;
    var F = /* @__PURE__ */ new WeakMap(), X = /* @__PURE__ */ new WeakMap();
    return (r = function(re) {
      return re ? X : F;
    })(V);
  }
  function i(V, F) {
    if (V && V.__esModule)
      return V;
    if (V === null || e(V) !== "object" && typeof V != "function")
      return { default: V };
    var X = r(F);
    if (X && X.has(V))
      return X.get(V);
    var oe = {}, re = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Z in V)
      if (Z !== "default" && Object.prototype.hasOwnProperty.call(V, Z)) {
        var ee = re ? Object.getOwnPropertyDescriptor(V, Z) : null;
        ee && (ee.get || ee.set) ? Object.defineProperty(oe, Z, ee) : oe[Z] = V[Z];
      }
    return oe.default = V, X && X.set(V, oe), oe;
  }
  function o(V, F) {
    var X = Object.keys(V);
    if (Object.getOwnPropertySymbols) {
      var oe = Object.getOwnPropertySymbols(V);
      F && (oe = oe.filter(function(re) {
        return Object.getOwnPropertyDescriptor(V, re).enumerable;
      })), X.push.apply(X, oe);
    }
    return X;
  }
  function s(V) {
    for (var F = 1; F < arguments.length; F++) {
      var X = arguments[F] != null ? arguments[F] : {};
      F % 2 ? o(Object(X), !0).forEach(function(oe) {
        u(V, oe, X[oe]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(V, Object.getOwnPropertyDescriptors(X)) : o(Object(X)).forEach(function(oe) {
        Object.defineProperty(V, oe, Object.getOwnPropertyDescriptor(X, oe));
      });
    }
    return V;
  }
  function u(V, F, X) {
    return F in V ? Object.defineProperty(V, F, { value: X, enumerable: !0, configurable: !0, writable: !0 }) : V[F] = X, V;
  }
  var f = "";
  function p(V, F) {
    return f || (f = (0, t.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(X) {
      return (0, t.isFunction)(V[X]);
    })), (0, t.isFunction)(V[f]) ? V[f](F) : !1;
  }
  function m(V, F, X) {
    var oe = V;
    do {
      if (p(oe, F)) return !0;
      if (oe === X) return !1;
      oe = oe.parentNode;
    } while (oe);
    return !1;
  }
  function v(V, F, X, oe) {
    if (V) {
      var re = s({
        capture: !0
      }, oe);
      V.addEventListener ? V.addEventListener(F, X, re) : V.attachEvent ? V.attachEvent("on" + F, X) : V["on" + F] = X;
    }
  }
  function y(V, F, X, oe) {
    if (V) {
      var re = s({
        capture: !0
      }, oe);
      V.removeEventListener ? V.removeEventListener(F, X, re) : V.detachEvent ? V.detachEvent("on" + F, X) : V["on" + F] = null;
    }
  }
  function S(V) {
    var F = V.clientHeight, X = V.ownerDocument.defaultView.getComputedStyle(V);
    return F += (0, t.int)(X.borderTopWidth), F += (0, t.int)(X.borderBottomWidth), F;
  }
  function E(V) {
    var F = V.clientWidth, X = V.ownerDocument.defaultView.getComputedStyle(V);
    return F += (0, t.int)(X.borderLeftWidth), F += (0, t.int)(X.borderRightWidth), F;
  }
  function w(V) {
    var F = V.clientHeight, X = V.ownerDocument.defaultView.getComputedStyle(V);
    return F -= (0, t.int)(X.paddingTop), F -= (0, t.int)(X.paddingBottom), F;
  }
  function _(V) {
    var F = V.clientWidth, X = V.ownerDocument.defaultView.getComputedStyle(V);
    return F -= (0, t.int)(X.paddingLeft), F -= (0, t.int)(X.paddingRight), F;
  }
  function O(V, F, X) {
    var oe = F === F.ownerDocument.body, re = oe ? {
      left: 0,
      top: 0
    } : F.getBoundingClientRect(), Z = (V.clientX + F.scrollLeft - re.left) / X, ee = (V.clientY + F.scrollTop - re.top) / X;
    return {
      x: Z,
      y: ee
    };
  }
  function D(V, F) {
    var X = M(V, F, "px");
    return u({}, (0, n.browserPrefixToKey)("transform", n.default), X);
  }
  function P(V, F) {
    var X = M(V, F, "");
    return X;
  }
  function M(V, F, X) {
    var oe = V.x, re = V.y, Z = "translate(".concat(oe).concat(X, ",").concat(re).concat(X, ")");
    if (F) {
      var ee = "".concat(typeof F.x == "string" ? F.x : F.x + X), J = "".concat(typeof F.y == "string" ? F.y : F.y + X);
      Z = "translate(".concat(ee, ", ").concat(J, ")") + Z;
    }
    return Z;
  }
  function N(V, F) {
    return V.targetTouches && (0, t.findInArray)(V.targetTouches, function(X) {
      return F === X.identifier;
    }) || V.changedTouches && (0, t.findInArray)(V.changedTouches, function(X) {
      return F === X.identifier;
    });
  }
  function k(V) {
    if (V.targetTouches && V.targetTouches[0]) return V.targetTouches[0].identifier;
    if (V.changedTouches && V.changedTouches[0]) return V.changedTouches[0].identifier;
  }
  function U(V) {
    if (V) {
      var F = V.getElementById("react-draggable-style-el");
      F || (F = V.createElement("style"), F.type = "text/css", F.id = "react-draggable-style-el", F.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, F.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, V.getElementsByTagName("head")[0].appendChild(F)), V.body && Y(V.body, "react-draggable-transparent-selection");
    }
  }
  function H(V) {
    if (V)
      try {
        if (V.body && z(V.body, "react-draggable-transparent-selection"), V.selection)
          V.selection.empty();
        else {
          var F = (V.defaultView || window).getSelection();
          F && F.type !== "Caret" && F.removeAllRanges();
        }
      } catch {
      }
  }
  function Y(V, F) {
    V.classList ? V.classList.add(F) : V.className.match(new RegExp("(?:^|\\s)".concat(F, "(?!\\S)"))) || (V.className += " ".concat(F));
  }
  function z(V, F) {
    V.classList ? V.classList.remove(F) : V.className = V.className.replace(new RegExp("(?:^|\\s)".concat(F, "(?!\\S)"), "g"), "");
  }
  return Yi;
}
var Od = {}, W9;
function Fre() {
  if (W9) return Od;
  W9 = 1, Object.defineProperty(Od, "__esModule", {
    value: !0
  }), Od.canDragX = i, Od.canDragY = o, Od.createCoreData = u, Od.createDraggableData = f, Od.getBoundPosition = n, Od.getControlPosition = s, Od.snapToGrid = r;
  var e = rI(), t = yF();
  function n(v, y, S) {
    if (!v.props.bounds) return [y, S];
    var E = v.props.bounds;
    E = typeof E == "string" ? E : p(E);
    var w = m(v);
    if (typeof E == "string") {
      var _ = w.ownerDocument, O = _.defaultView, D;
      if (E === "parent" ? D = w.parentNode : D = _.querySelector(E), !(D instanceof O.HTMLElement))
        throw new Error('Bounds selector "' + E + '" could not find an element.');
      var P = D, M = O.getComputedStyle(w), N = O.getComputedStyle(P);
      E = {
        left: -w.offsetLeft + (0, e.int)(N.paddingLeft) + (0, e.int)(M.marginLeft),
        top: -w.offsetTop + (0, e.int)(N.paddingTop) + (0, e.int)(M.marginTop),
        right: (0, t.innerWidth)(P) - (0, t.outerWidth)(w) - w.offsetLeft + (0, e.int)(N.paddingRight) - (0, e.int)(M.marginRight),
        bottom: (0, t.innerHeight)(P) - (0, t.outerHeight)(w) - w.offsetTop + (0, e.int)(N.paddingBottom) - (0, e.int)(M.marginBottom)
      };
    }
    return (0, e.isNum)(E.right) && (y = Math.min(y, E.right)), (0, e.isNum)(E.bottom) && (S = Math.min(S, E.bottom)), (0, e.isNum)(E.left) && (y = Math.max(y, E.left)), (0, e.isNum)(E.top) && (S = Math.max(S, E.top)), [y, S];
  }
  function r(v, y, S) {
    var E = Math.round(y / v[0]) * v[0], w = Math.round(S / v[1]) * v[1];
    return [E, w];
  }
  function i(v) {
    return v.props.axis === "both" || v.props.axis === "x";
  }
  function o(v) {
    return v.props.axis === "both" || v.props.axis === "y";
  }
  function s(v, y, S) {
    var E = typeof y == "number" ? (0, t.getTouch)(v, y) : null;
    if (typeof y == "number" && !E) return null;
    var w = m(S), _ = S.props.offsetParent || w.offsetParent || w.ownerDocument.body;
    return (0, t.offsetXYFromParent)(E || v, _, S.props.scale);
  }
  function u(v, y, S) {
    var E = v.state, w = !(0, e.isNum)(E.lastX), _ = m(v);
    return w ? {
      node: _,
      deltaX: 0,
      deltaY: 0,
      lastX: y,
      lastY: S,
      x: y,
      y: S
    } : {
      node: _,
      deltaX: y - E.lastX,
      deltaY: S - E.lastY,
      lastX: E.lastX,
      lastY: E.lastY,
      x: y,
      y: S
    };
  }
  function f(v, y) {
    var S = v.props.scale;
    return {
      node: y.node,
      x: v.state.x + y.deltaX / S,
      y: v.state.y + y.deltaY / S,
      deltaX: y.deltaX / S,
      deltaY: y.deltaY / S,
      lastX: v.state.x,
      lastY: v.state.y
    };
  }
  function p(v) {
    return {
      left: v.left,
      top: v.top,
      right: v.right,
      bottom: v.bottom
    };
  }
  function m(v) {
    var y = v.findDOMNode();
    if (!y)
      throw new Error("<DraggableCore>: Unmounted during event!");
    return y;
  }
  return Od;
}
var sE = {}, YR = {}, H9;
function Wre() {
  if (H9) return YR;
  H9 = 1, Object.defineProperty(YR, "__esModule", {
    value: !0
  }), YR.default = e;
  function e() {
  }
  return YR;
}
var q9;
function uCe() {
  if (q9) return sE;
  q9 = 1;
  function e(re) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Z) {
      return typeof Z;
    } : function(Z) {
      return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
    }, e(re);
  }
  Object.defineProperty(sE, "__esModule", {
    value: !0
  }), sE.default = void 0;
  var t = m(it), n = f(/* @__PURE__ */ yU()), r = f(Pd), i = yF(), o = Fre(), s = rI(), u = f(Wre());
  function f(re) {
    return re && re.__esModule ? re : { default: re };
  }
  function p(re) {
    if (typeof WeakMap != "function") return null;
    var Z = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap();
    return (p = function(le) {
      return le ? ee : Z;
    })(re);
  }
  function m(re, Z) {
    if (re && re.__esModule)
      return re;
    if (re === null || e(re) !== "object" && typeof re != "function")
      return { default: re };
    var ee = p(Z);
    if (ee && ee.has(re))
      return ee.get(re);
    var J = {}, le = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var be in re)
      if (be !== "default" && Object.prototype.hasOwnProperty.call(re, be)) {
        var ne = le ? Object.getOwnPropertyDescriptor(re, be) : null;
        ne && (ne.get || ne.set) ? Object.defineProperty(J, be, ne) : J[be] = re[be];
      }
    return J.default = re, ee && ee.set(re, J), J;
  }
  function v(re, Z) {
    return _(re) || w(re, Z) || S(re, Z) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(re, Z) {
    if (re) {
      if (typeof re == "string") return E(re, Z);
      var ee = Object.prototype.toString.call(re).slice(8, -1);
      if (ee === "Object" && re.constructor && (ee = re.constructor.name), ee === "Map" || ee === "Set") return Array.from(re);
      if (ee === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ee)) return E(re, Z);
    }
  }
  function E(re, Z) {
    (Z == null || Z > re.length) && (Z = re.length);
    for (var ee = 0, J = new Array(Z); ee < Z; ee++)
      J[ee] = re[ee];
    return J;
  }
  function w(re, Z) {
    var ee = re == null ? null : typeof Symbol < "u" && re[Symbol.iterator] || re["@@iterator"];
    if (ee != null) {
      var J = [], le = !0, be = !1, ne, ae;
      try {
        for (ee = ee.call(re); !(le = (ne = ee.next()).done) && (J.push(ne.value), !(Z && J.length === Z)); le = !0)
          ;
      } catch (ie) {
        be = !0, ae = ie;
      } finally {
        try {
          !le && ee.return != null && ee.return();
        } finally {
          if (be) throw ae;
        }
      }
      return J;
    }
  }
  function _(re) {
    if (Array.isArray(re)) return re;
  }
  function O(re, Z) {
    if (!(re instanceof Z))
      throw new TypeError("Cannot call a class as a function");
  }
  function D(re, Z) {
    for (var ee = 0; ee < Z.length; ee++) {
      var J = Z[ee];
      J.enumerable = J.enumerable || !1, J.configurable = !0, "value" in J && (J.writable = !0), Object.defineProperty(re, J.key, J);
    }
  }
  function P(re, Z, ee) {
    return Z && D(re.prototype, Z), Object.defineProperty(re, "prototype", { writable: !1 }), re;
  }
  function M(re, Z) {
    if (typeof Z != "function" && Z !== null)
      throw new TypeError("Super expression must either be null or a function");
    re.prototype = Object.create(Z && Z.prototype, { constructor: { value: re, writable: !0, configurable: !0 } }), Object.defineProperty(re, "prototype", { writable: !1 }), Z && N(re, Z);
  }
  function N(re, Z) {
    return N = Object.setPrototypeOf || function(J, le) {
      return J.__proto__ = le, J;
    }, N(re, Z);
  }
  function k(re) {
    var Z = Y();
    return function() {
      var J = z(re), le;
      if (Z) {
        var be = z(this).constructor;
        le = Reflect.construct(J, arguments, be);
      } else
        le = J.apply(this, arguments);
      return U(this, le);
    };
  }
  function U(re, Z) {
    if (Z && (e(Z) === "object" || typeof Z == "function"))
      return Z;
    if (Z !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return H(re);
  }
  function H(re) {
    if (re === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return re;
  }
  function Y() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function z(re) {
    return z = Object.setPrototypeOf ? Object.getPrototypeOf : function(ee) {
      return ee.__proto__ || Object.getPrototypeOf(ee);
    }, z(re);
  }
  function V(re, Z, ee) {
    return Z in re ? Object.defineProperty(re, Z, { value: ee, enumerable: !0, configurable: !0, writable: !0 }) : re[Z] = ee, re;
  }
  var F = {
    touch: {
      start: "touchstart",
      move: "touchmove",
      stop: "touchend"
    },
    mouse: {
      start: "mousedown",
      move: "mousemove",
      stop: "mouseup"
    }
  }, X = F.mouse, oe = /* @__PURE__ */ (function(re) {
    M(ee, re);
    var Z = k(ee);
    function ee() {
      var J;
      O(this, ee);
      for (var le = arguments.length, be = new Array(le), ne = 0; ne < le; ne++)
        be[ne] = arguments[ne];
      return J = Z.call.apply(Z, [this].concat(be)), V(H(J), "state", {
        dragging: !1,
        // Used while dragging to determine deltas.
        lastX: NaN,
        lastY: NaN,
        touchIdentifier: null
      }), V(H(J), "mounted", !1), V(H(J), "handleDragStart", function(ae) {
        if (J.props.onMouseDown(ae), !J.props.allowAnyClick && typeof ae.button == "number" && ae.button !== 0) return !1;
        var ie = J.findDOMNode();
        if (!ie || !ie.ownerDocument || !ie.ownerDocument.body)
          throw new Error("<DraggableCore> not mounted on DragStart!");
        var he = ie.ownerDocument;
        if (!(J.props.disabled || !(ae.target instanceof he.defaultView.Node) || J.props.handle && !(0, i.matchesSelectorAndParentsTo)(ae.target, J.props.handle, ie) || J.props.cancel && (0, i.matchesSelectorAndParentsTo)(ae.target, J.props.cancel, ie))) {
          ae.type === "touchstart" && ae.preventDefault();
          var pe = (0, i.getTouchIdentifier)(ae);
          J.setState({
            touchIdentifier: pe
          });
          var me = (0, o.getControlPosition)(ae, pe, H(J));
          if (me != null) {
            var Ee = me.x, Ie = me.y, Pe = (0, o.createCoreData)(H(J), Ee, Ie);
            (0, u.default)("DraggableCore: handleDragStart: %j", Pe), (0, u.default)("calling", J.props.onStart);
            var De = J.props.onStart(ae, Pe);
            De === !1 || J.mounted === !1 || (J.props.enableUserSelectHack && (0, i.addUserSelectStyles)(he), J.setState({
              dragging: !0,
              lastX: Ee,
              lastY: Ie
            }), (0, i.addEvent)(he, X.move, J.handleDrag), (0, i.addEvent)(he, X.stop, J.handleDragStop));
          }
        }
      }), V(H(J), "handleDrag", function(ae) {
        var ie = (0, o.getControlPosition)(ae, J.state.touchIdentifier, H(J));
        if (ie != null) {
          var he = ie.x, pe = ie.y;
          if (Array.isArray(J.props.grid)) {
            var me = he - J.state.lastX, Ee = pe - J.state.lastY, Ie = (0, o.snapToGrid)(J.props.grid, me, Ee), Pe = v(Ie, 2);
            if (me = Pe[0], Ee = Pe[1], !me && !Ee) return;
            he = J.state.lastX + me, pe = J.state.lastY + Ee;
          }
          var De = (0, o.createCoreData)(H(J), he, pe);
          (0, u.default)("DraggableCore: handleDrag: %j", De);
          var Ye = J.props.onDrag(ae, De);
          if (Ye === !1 || J.mounted === !1) {
            try {
              J.handleDragStop(new MouseEvent("mouseup"));
            } catch {
              var Ue = document.createEvent("MouseEvents");
              Ue.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), J.handleDragStop(Ue);
            }
            return;
          }
          J.setState({
            lastX: he,
            lastY: pe
          });
        }
      }), V(H(J), "handleDragStop", function(ae) {
        if (J.state.dragging) {
          var ie = (0, o.getControlPosition)(ae, J.state.touchIdentifier, H(J));
          if (ie != null) {
            var he = ie.x, pe = ie.y;
            if (Array.isArray(J.props.grid)) {
              var me = he - J.state.lastX || 0, Ee = pe - J.state.lastY || 0, Ie = (0, o.snapToGrid)(J.props.grid, me, Ee), Pe = v(Ie, 2);
              me = Pe[0], Ee = Pe[1], he = J.state.lastX + me, pe = J.state.lastY + Ee;
            }
            var De = (0, o.createCoreData)(H(J), he, pe), Ye = J.props.onStop(ae, De);
            if (Ye === !1 || J.mounted === !1) return !1;
            var Ue = J.findDOMNode();
            Ue && J.props.enableUserSelectHack && (0, i.removeUserSelectStyles)(Ue.ownerDocument), (0, u.default)("DraggableCore: handleDragStop: %j", De), J.setState({
              dragging: !1,
              lastX: NaN,
              lastY: NaN
            }), Ue && ((0, u.default)("DraggableCore: Removing handlers"), (0, i.removeEvent)(Ue.ownerDocument, X.move, J.handleDrag), (0, i.removeEvent)(Ue.ownerDocument, X.stop, J.handleDragStop));
          }
        }
      }), V(H(J), "onMouseDown", function(ae) {
        return X = F.mouse, J.handleDragStart(ae);
      }), V(H(J), "onMouseUp", function(ae) {
        return X = F.mouse, J.handleDragStop(ae);
      }), V(H(J), "onTouchStart", function(ae) {
        return X = F.touch, J.handleDragStart(ae);
      }), V(H(J), "onTouchEnd", function(ae) {
        return X = F.touch, J.handleDragStop(ae);
      }), J;
    }
    return P(ee, [{
      key: "componentDidMount",
      value: function() {
        this.mounted = !0;
        var le = this.findDOMNode();
        le && (0, i.addEvent)(le, F.touch.start, this.onTouchStart, {
          passive: !1
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.mounted = !1;
        var le = this.findDOMNode();
        if (le) {
          var be = le.ownerDocument;
          (0, i.removeEvent)(be, F.mouse.move, this.handleDrag), (0, i.removeEvent)(be, F.touch.move, this.handleDrag), (0, i.removeEvent)(be, F.mouse.stop, this.handleDragStop), (0, i.removeEvent)(be, F.touch.stop, this.handleDragStop), (0, i.removeEvent)(le, F.touch.start, this.onTouchStart, {
            passive: !1
          }), this.props.enableUserSelectHack && (0, i.removeUserSelectStyles)(be);
        }
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
    }, {
      key: "findDOMNode",
      value: function() {
        var le, be, ne;
        return (le = this.props) !== null && le !== void 0 && le.nodeRef ? (be = this.props) === null || be === void 0 || (ne = be.nodeRef) === null || ne === void 0 ? void 0 : ne.current : r.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function() {
        return /* @__PURE__ */ t.cloneElement(t.Children.only(this.props.children), {
          // Note: mouseMove handler is attached to document so it will still function
          // when the user drags quickly and leaves the bounds of the element.
          onMouseDown: this.onMouseDown,
          onMouseUp: this.onMouseUp,
          // onTouchStart is added on `componentDidMount` so they can be added with
          // {passive: false}, which allows it to cancel. See
          // https://developers.google.com/web/updates/2017/01/scrolling-intervention
          onTouchEnd: this.onTouchEnd
        });
      }
    }]), ee;
  })(t.Component);
  return sE.default = oe, V(oe, "displayName", "DraggableCore"), V(oe, "propTypes", {
    /**
     * `allowAnyClick` allows dragging using any mouse button.
     * By default, we only accept the left button.
     *
     * Defaults to `false`.
     */
    allowAnyClick: n.default.bool,
    /**
     * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
     * with the exception of `onMouseDown`, will not fire.
     */
    disabled: n.default.bool,
    /**
     * By default, we add 'user-select:none' attributes to the document body
     * to prevent ugly text selection during drag. If this is causing problems
     * for your app, set this to `false`.
     */
    enableUserSelectHack: n.default.bool,
    /**
     * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
     * instead of using the parent node.
     */
    offsetParent: function(Z, ee) {
      if (Z[ee] && Z[ee].nodeType !== 1)
        throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
     * `grid` specifies the x and y that dragging should snap to.
     */
    grid: n.default.arrayOf(n.default.number),
    /**
     * `handle` specifies a selector to be used as the handle that initiates drag.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable handle=".handle">
     *              <div>
     *                  <div className="handle">Click me to drag</div>
     *                  <div>This is some other content</div>
     *              </div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    handle: n.default.string,
    /**
     * `cancel` specifies a selector to be used to prevent drag initialization.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *           return(
     *               <Draggable cancel=".cancel">
     *                   <div>
     *                     <div className="cancel">You can't drag from here</div>
     *                     <div>Dragging here works fine</div>
     *                   </div>
     *               </Draggable>
     *           );
     *       }
     *   });
     * ```
     */
    cancel: n.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
     * Unfortunately, in order for <Draggable> to work properly, we need raw access
     * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
     * as in this example:
     *
     * function MyComponent() {
     *   const nodeRef = React.useRef(null);
     *   return (
     *     <Draggable nodeRef={nodeRef}>
     *       <div ref={nodeRef}>Example Target</div>
     *     </Draggable>
     *   );
     * }
     *
     * This can be used for arbitrarily nested components, so long as the ref ends up
     * pointing to the actual child DOM node and not a custom component.
     */
    nodeRef: n.default.object,
    /**
     * Called when dragging starts.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onStart: n.default.func,
    /**
     * Called while dragging.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onDrag: n.default.func,
    /**
     * Called when dragging stops.
     * If this function returns the boolean false, the drag will remain active.
     */
    onStop: n.default.func,
    /**
     * A workaround option which can be passed if onMouseDown needs to be accessed,
     * since it'll always be blocked (as there is internal use of onMouseDown)
     */
    onMouseDown: n.default.func,
    /**
     * `scale`, if set, applies scaling while dragging an element
     */
    scale: n.default.number,
    /**
     * These properties should be defined on the child, not here.
     */
    className: s.dontSetMe,
    style: s.dontSetMe,
    transform: s.dontSetMe
  }), V(oe, "defaultProps", {
    allowAnyClick: !1,
    // by default only accept left click
    disabled: !1,
    enableUserSelectHack: !0,
    onStart: function() {
    },
    onDrag: function() {
    },
    onStop: function() {
    },
    onMouseDown: function() {
    },
    scale: 1
  }), sE;
}
var $9;
function dCe() {
  return $9 || ($9 = 1, (function(e) {
    function t(ae) {
      "@babel/helpers - typeof";
      return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
        return typeof ie;
      } : function(ie) {
        return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
      }, t(ae);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "DraggableCore", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), e.default = void 0;
    var n = E(it), r = y(/* @__PURE__ */ yU()), i = y(Pd), o = y(lCe), s = yF(), u = Fre(), f = rI(), p = y(uCe()), m = y(Wre()), v = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
    function y(ae) {
      return ae && ae.__esModule ? ae : { default: ae };
    }
    function S(ae) {
      if (typeof WeakMap != "function") return null;
      var ie = /* @__PURE__ */ new WeakMap(), he = /* @__PURE__ */ new WeakMap();
      return (S = function(me) {
        return me ? he : ie;
      })(ae);
    }
    function E(ae, ie) {
      if (ae && ae.__esModule)
        return ae;
      if (ae === null || t(ae) !== "object" && typeof ae != "function")
        return { default: ae };
      var he = S(ie);
      if (he && he.has(ae))
        return he.get(ae);
      var pe = {}, me = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var Ee in ae)
        if (Ee !== "default" && Object.prototype.hasOwnProperty.call(ae, Ee)) {
          var Ie = me ? Object.getOwnPropertyDescriptor(ae, Ee) : null;
          Ie && (Ie.get || Ie.set) ? Object.defineProperty(pe, Ee, Ie) : pe[Ee] = ae[Ee];
        }
      return pe.default = ae, he && he.set(ae, pe), pe;
    }
    function w() {
      return w = Object.assign || function(ae) {
        for (var ie = 1; ie < arguments.length; ie++) {
          var he = arguments[ie];
          for (var pe in he)
            Object.prototype.hasOwnProperty.call(he, pe) && (ae[pe] = he[pe]);
        }
        return ae;
      }, w.apply(this, arguments);
    }
    function _(ae, ie) {
      if (ae == null) return {};
      var he = O(ae, ie), pe, me;
      if (Object.getOwnPropertySymbols) {
        var Ee = Object.getOwnPropertySymbols(ae);
        for (me = 0; me < Ee.length; me++)
          pe = Ee[me], !(ie.indexOf(pe) >= 0) && Object.prototype.propertyIsEnumerable.call(ae, pe) && (he[pe] = ae[pe]);
      }
      return he;
    }
    function O(ae, ie) {
      if (ae == null) return {};
      var he = {}, pe = Object.keys(ae), me, Ee;
      for (Ee = 0; Ee < pe.length; Ee++)
        me = pe[Ee], !(ie.indexOf(me) >= 0) && (he[me] = ae[me]);
      return he;
    }
    function D(ae, ie) {
      var he = Object.keys(ae);
      if (Object.getOwnPropertySymbols) {
        var pe = Object.getOwnPropertySymbols(ae);
        ie && (pe = pe.filter(function(me) {
          return Object.getOwnPropertyDescriptor(ae, me).enumerable;
        })), he.push.apply(he, pe);
      }
      return he;
    }
    function P(ae) {
      for (var ie = 1; ie < arguments.length; ie++) {
        var he = arguments[ie] != null ? arguments[ie] : {};
        ie % 2 ? D(Object(he), !0).forEach(function(pe) {
          be(ae, pe, he[pe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ae, Object.getOwnPropertyDescriptors(he)) : D(Object(he)).forEach(function(pe) {
          Object.defineProperty(ae, pe, Object.getOwnPropertyDescriptor(he, pe));
        });
      }
      return ae;
    }
    function M(ae, ie) {
      return Y(ae) || H(ae, ie) || k(ae, ie) || N();
    }
    function N() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function k(ae, ie) {
      if (ae) {
        if (typeof ae == "string") return U(ae, ie);
        var he = Object.prototype.toString.call(ae).slice(8, -1);
        if (he === "Object" && ae.constructor && (he = ae.constructor.name), he === "Map" || he === "Set") return Array.from(ae);
        if (he === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(he)) return U(ae, ie);
      }
    }
    function U(ae, ie) {
      (ie == null || ie > ae.length) && (ie = ae.length);
      for (var he = 0, pe = new Array(ie); he < ie; he++)
        pe[he] = ae[he];
      return pe;
    }
    function H(ae, ie) {
      var he = ae == null ? null : typeof Symbol < "u" && ae[Symbol.iterator] || ae["@@iterator"];
      if (he != null) {
        var pe = [], me = !0, Ee = !1, Ie, Pe;
        try {
          for (he = he.call(ae); !(me = (Ie = he.next()).done) && (pe.push(Ie.value), !(ie && pe.length === ie)); me = !0)
            ;
        } catch (De) {
          Ee = !0, Pe = De;
        } finally {
          try {
            !me && he.return != null && he.return();
          } finally {
            if (Ee) throw Pe;
          }
        }
        return pe;
      }
    }
    function Y(ae) {
      if (Array.isArray(ae)) return ae;
    }
    function z(ae, ie) {
      if (!(ae instanceof ie))
        throw new TypeError("Cannot call a class as a function");
    }
    function V(ae, ie) {
      for (var he = 0; he < ie.length; he++) {
        var pe = ie[he];
        pe.enumerable = pe.enumerable || !1, pe.configurable = !0, "value" in pe && (pe.writable = !0), Object.defineProperty(ae, pe.key, pe);
      }
    }
    function F(ae, ie, he) {
      return ie && V(ae.prototype, ie), he && V(ae, he), Object.defineProperty(ae, "prototype", { writable: !1 }), ae;
    }
    function X(ae, ie) {
      if (typeof ie != "function" && ie !== null)
        throw new TypeError("Super expression must either be null or a function");
      ae.prototype = Object.create(ie && ie.prototype, { constructor: { value: ae, writable: !0, configurable: !0 } }), Object.defineProperty(ae, "prototype", { writable: !1 }), ie && oe(ae, ie);
    }
    function oe(ae, ie) {
      return oe = Object.setPrototypeOf || function(pe, me) {
        return pe.__proto__ = me, pe;
      }, oe(ae, ie);
    }
    function re(ae) {
      var ie = J();
      return function() {
        var pe = le(ae), me;
        if (ie) {
          var Ee = le(this).constructor;
          me = Reflect.construct(pe, arguments, Ee);
        } else
          me = pe.apply(this, arguments);
        return Z(this, me);
      };
    }
    function Z(ae, ie) {
      if (ie && (t(ie) === "object" || typeof ie == "function"))
        return ie;
      if (ie !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return ee(ae);
    }
    function ee(ae) {
      if (ae === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return ae;
    }
    function J() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function le(ae) {
      return le = Object.setPrototypeOf ? Object.getPrototypeOf : function(he) {
        return he.__proto__ || Object.getPrototypeOf(he);
      }, le(ae);
    }
    function be(ae, ie, he) {
      return ie in ae ? Object.defineProperty(ae, ie, { value: he, enumerable: !0, configurable: !0, writable: !0 }) : ae[ie] = he, ae;
    }
    var ne = /* @__PURE__ */ (function(ae) {
      X(he, ae);
      var ie = re(he);
      function he(pe) {
        var me;
        return z(this, he), me = ie.call(this, pe), be(ee(me), "onDragStart", function(Ee, Ie) {
          (0, m.default)("Draggable: onDragStart: %j", Ie);
          var Pe = me.props.onStart(Ee, (0, u.createDraggableData)(ee(me), Ie));
          if (Pe === !1) return !1;
          me.setState({
            dragging: !0,
            dragged: !0
          });
        }), be(ee(me), "onDrag", function(Ee, Ie) {
          if (!me.state.dragging) return !1;
          (0, m.default)("Draggable: onDrag: %j", Ie);
          var Pe = (0, u.createDraggableData)(ee(me), Ie), De = {
            x: Pe.x,
            y: Pe.y
          };
          if (me.props.bounds) {
            var Ye = De.x, Ue = De.y;
            De.x += me.state.slackX, De.y += me.state.slackY;
            var ve = (0, u.getBoundPosition)(ee(me), De.x, De.y), rt = M(ve, 2), Te = rt[0], Je = rt[1];
            De.x = Te, De.y = Je, De.slackX = me.state.slackX + (Ye - De.x), De.slackY = me.state.slackY + (Ue - De.y), Pe.x = De.x, Pe.y = De.y, Pe.deltaX = De.x - me.state.x, Pe.deltaY = De.y - me.state.y;
          }
          var L = me.props.onDrag(Ee, Pe);
          if (L === !1) return !1;
          me.setState(De);
        }), be(ee(me), "onDragStop", function(Ee, Ie) {
          if (!me.state.dragging) return !1;
          var Pe = me.props.onStop(Ee, (0, u.createDraggableData)(ee(me), Ie));
          if (Pe === !1) return !1;
          (0, m.default)("Draggable: onDragStop: %j", Ie);
          var De = {
            dragging: !1,
            slackX: 0,
            slackY: 0
          }, Ye = !!me.props.position;
          if (Ye) {
            var Ue = me.props.position, ve = Ue.x, rt = Ue.y;
            De.x = ve, De.y = rt;
          }
          me.setState(De);
        }), me.state = {
          // Whether or not we are currently dragging.
          dragging: !1,
          // Whether or not we have been dragged before.
          dragged: !1,
          // Current transform x and y.
          x: pe.position ? pe.position.x : pe.defaultPosition.x,
          y: pe.position ? pe.position.y : pe.defaultPosition.y,
          prevPropsPosition: P({}, pe.position),
          // Used for compensating for out-of-bounds drags
          slackX: 0,
          slackY: 0,
          // Can only determine if SVG after mounting
          isElementSVG: !1
        }, pe.position && !(pe.onDrag || pe.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."), me;
      }
      return F(he, [{
        key: "componentDidMount",
        value: function() {
          typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
            isElementSVG: !0
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.setState({
            dragging: !1
          });
        }
        // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        // the underlying DOM node ourselves. See the README for more information.
      }, {
        key: "findDOMNode",
        value: function() {
          var me, Ee, Ie;
          return (me = (Ee = this.props) === null || Ee === void 0 || (Ie = Ee.nodeRef) === null || Ie === void 0 ? void 0 : Ie.current) !== null && me !== void 0 ? me : i.default.findDOMNode(this);
        }
      }, {
        key: "render",
        value: function() {
          var me, Ee = this.props;
          Ee.axis, Ee.bounds;
          var Ie = Ee.children, Pe = Ee.defaultPosition, De = Ee.defaultClassName, Ye = Ee.defaultClassNameDragging, Ue = Ee.defaultClassNameDragged, ve = Ee.position, rt = Ee.positionOffset;
          Ee.scale;
          var Te = _(Ee, v), Je = {}, L = null, te = !!ve, ge = !te || this.state.dragging, ke = ve || Pe, We = {
            // Set left if horizontal drag is enabled
            x: (0, u.canDragX)(this) && ge ? this.state.x : ke.x,
            // Set top if vertical drag is enabled
            y: (0, u.canDragY)(this) && ge ? this.state.y : ke.y
          };
          this.state.isElementSVG ? L = (0, s.createSVGTransform)(We, rt) : Je = (0, s.createCSSTransform)(We, rt);
          var Be = (0, o.default)(Ie.props.className || "", De, (me = {}, be(me, Ye, this.state.dragging), be(me, Ue, this.state.dragged), me));
          return /* @__PURE__ */ n.createElement(p.default, w({}, Te, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
          }), /* @__PURE__ */ n.cloneElement(n.Children.only(Ie), {
            className: Be,
            style: P(P({}, Ie.props.style), Je),
            transform: L
          }));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: (
          // React 16.3+
          // Arity (props, state)
          function(me, Ee) {
            var Ie = me.position, Pe = Ee.prevPropsPosition;
            return Ie && (!Pe || Ie.x !== Pe.x || Ie.y !== Pe.y) ? ((0, m.default)("Draggable: getDerivedStateFromProps %j", {
              position: Ie,
              prevPropsPosition: Pe
            }), {
              x: Ie.x,
              y: Ie.y,
              prevPropsPosition: P({}, Ie)
            }) : null;
          }
        )
      }]), he;
    })(n.Component);
    e.default = ne, be(ne, "displayName", "Draggable"), be(ne, "propTypes", P(P({}, p.default.propTypes), {}, {
      /**
       * `axis` determines which axis the draggable can move.
       *
       *  Note that all callbacks will still return data as normal. This only
       *  controls flushing to the DOM.
       *
       * 'both' allows movement horizontally and vertically.
       * 'x' limits movement to horizontal axis.
       * 'y' limits movement to vertical axis.
       * 'none' limits all movement.
       *
       * Defaults to 'both'.
       */
      axis: r.default.oneOf(["both", "x", "y", "none"]),
      /**
       * `bounds` determines the range of movement available to the element.
       * Available values are:
       *
       * 'parent' restricts movement within the Draggable's parent node.
       *
       * Alternatively, pass an object with the following properties, all of which are optional:
       *
       * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
       *
       * All values are in px.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable bounds={{right: 300, bottom: 300}}>
       *              <div>Content</div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      bounds: r.default.oneOfType([r.default.shape({
        left: r.default.number,
        right: r.default.number,
        top: r.default.number,
        bottom: r.default.number
      }), r.default.string, r.default.oneOf([!1])]),
      defaultClassName: r.default.string,
      defaultClassNameDragging: r.default.string,
      defaultClassNameDragged: r.default.string,
      /**
       * `defaultPosition` specifies the x and y that the dragged item should start at
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable defaultPosition={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      defaultPosition: r.default.shape({
        x: r.default.number,
        y: r.default.number
      }),
      positionOffset: r.default.shape({
        x: r.default.oneOfType([r.default.number, r.default.string]),
        y: r.default.oneOfType([r.default.number, r.default.string])
      }),
      /**
       * `position`, if present, defines the current position of the element.
       *
       *  This is similar to how form elements in React work - if no `position` is supplied, the component
       *  is uncontrolled.
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable position={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      position: r.default.shape({
        x: r.default.number,
        y: r.default.number
      }),
      /**
       * These properties should be defined on the child, not here.
       */
      className: f.dontSetMe,
      style: f.dontSetMe,
      transform: f.dontSetMe
    })), be(ne, "defaultProps", P(P({}, p.default.defaultProps), {}, {
      axis: "both",
      bounds: !1,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    }));
  })(iz)), iz;
}
var G9;
function fCe() {
  if (G9) return aE.exports;
  G9 = 1;
  var e = dCe(), t = e.default, n = e.DraggableCore;
  return aE.exports = t, aE.exports.default = t, aE.exports.DraggableCore = n, aE.exports;
}
var pCe = fCe();
const hCe = /* @__PURE__ */ Hn(pCe);
var gCe = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), hA = function() {
  return hA = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, hA.apply(this, arguments);
}, mCe = {
  top: {
    width: "100%",
    height: "10px",
    top: "-5px",
    left: "0px",
    cursor: "row-resize"
  },
  right: {
    width: "10px",
    height: "100%",
    top: "0px",
    right: "-5px",
    cursor: "col-resize"
  },
  bottom: {
    width: "100%",
    height: "10px",
    bottom: "-5px",
    left: "0px",
    cursor: "row-resize"
  },
  left: {
    width: "10px",
    height: "100%",
    top: "0px",
    left: "-5px",
    cursor: "col-resize"
  },
  topRight: {
    width: "20px",
    height: "20px",
    position: "absolute",
    right: "-10px",
    top: "-10px",
    cursor: "ne-resize"
  },
  bottomRight: {
    width: "20px",
    height: "20px",
    position: "absolute",
    right: "-10px",
    bottom: "-10px",
    cursor: "se-resize"
  },
  bottomLeft: {
    width: "20px",
    height: "20px",
    position: "absolute",
    left: "-10px",
    bottom: "-10px",
    cursor: "sw-resize"
  },
  topLeft: {
    width: "20px",
    height: "20px",
    position: "absolute",
    left: "-10px",
    top: "-10px",
    cursor: "nw-resize"
  }
}, vCe = (
  /** @class */
  (function(e) {
    gCe(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseDown = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n.onTouchStart = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n;
    }
    return t.prototype.render = function() {
      return $.createElement("div", { className: this.props.className || "", style: hA(hA({ position: "absolute", userSelect: "none" }, mCe[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, t;
  })($.PureComponent)
), XR = { exports: {} }, Y9;
function yCe() {
  if (Y9) return XR.exports;
  Y9 = 1;
  function e(v, y) {
    var S = y && y.cache ? y.cache : m, E = y && y.serializer ? y.serializer : f, w = y && y.strategy ? y.strategy : o;
    return w(v, {
      cache: S,
      serializer: E
    });
  }
  function t(v) {
    return v == null || typeof v == "number" || typeof v == "boolean";
  }
  function n(v, y, S, E) {
    var w = t(E) ? E : S(E), _ = y.get(w);
    return typeof _ > "u" && (_ = v.call(this, E), y.set(w, _)), _;
  }
  function r(v, y, S) {
    var E = Array.prototype.slice.call(arguments, 3), w = S(E), _ = y.get(w);
    return typeof _ > "u" && (_ = v.apply(this, E), y.set(w, _)), _;
  }
  function i(v, y, S, E, w) {
    return S.bind(
      y,
      v,
      E,
      w
    );
  }
  function o(v, y) {
    var S = v.length === 1 ? n : r;
    return i(
      v,
      this,
      S,
      y.cache.create(),
      y.serializer
    );
  }
  function s(v, y) {
    var S = r;
    return i(
      v,
      this,
      S,
      y.cache.create(),
      y.serializer
    );
  }
  function u(v, y) {
    var S = n;
    return i(
      v,
      this,
      S,
      y.cache.create(),
      y.serializer
    );
  }
  function f() {
    return JSON.stringify(arguments);
  }
  function p() {
    this.cache = /* @__PURE__ */ Object.create(null);
  }
  p.prototype.has = function(v) {
    return v in this.cache;
  }, p.prototype.get = function(v) {
    return this.cache[v];
  }, p.prototype.set = function(v, y) {
    this.cache[v] = y;
  };
  var m = {
    create: function() {
      return new p();
    }
  };
  return XR.exports = e, XR.exports.strategies = {
    variadic: s,
    monadic: u
  }, XR.exports;
}
var bCe = yCe();
const ry = /* @__PURE__ */ Hn(bCe);
var xCe = /* @__PURE__ */ (function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
})(), Ad = function() {
  return Ad = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ad.apply(this, arguments);
}, SCe = {
  width: "auto",
  height: "auto"
}, ZR = ry(function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}), X9 = ry(function(e, t) {
  return Math.round(e / t) * t;
}), D0 = ry(function(e, t) {
  return new RegExp(e, "i").test(t);
}), KR = function(e) {
  return !!(e.touches && e.touches.length);
}, wCe = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, Z9 = ry(function(e, t, n) {
  n === void 0 && (n = 0);
  var r = t.reduce(function(o, s, u) {
    return Math.abs(s - e) < Math.abs(t[o] - e) ? u : o;
  }, 0), i = Math.abs(t[r] - e);
  return n === 0 || i < n ? t[r] : e;
}), Uo = ry(function(e, t) {
  return e.substr(e.length - t.length, t.length) === t;
}), oz = ry(function(e) {
  return e = e.toString(), e === "auto" || Uo(e, "px") || Uo(e, "%") || Uo(e, "vh") || Uo(e, "vw") || Uo(e, "vmax") || Uo(e, "vmin") ? e : e + "px";
}), QR = function(e, t, n, r) {
  if (e && typeof e == "string") {
    if (Uo(e, "px"))
      return Number(e.replace("px", ""));
    if (Uo(e, "%")) {
      var i = Number(e.replace("%", "")) / 100;
      return t * i;
    }
    if (Uo(e, "vw")) {
      var i = Number(e.replace("vw", "")) / 100;
      return n * i;
    }
    if (Uo(e, "vh")) {
      var i = Number(e.replace("vh", "")) / 100;
      return r * i;
    }
  }
  return e;
}, TCe = ry(function(e, t, n, r, i, o, s) {
  return r = QR(r, e.width, t, n), i = QR(i, e.height, t, n), o = QR(o, e.width, t, n), s = QR(s, e.height, t, n), {
    maxWidth: typeof r > "u" ? void 0 : Number(r),
    maxHeight: typeof i > "u" ? void 0 : Number(i),
    minWidth: typeof o > "u" ? void 0 : Number(o),
    minHeight: typeof s > "u" ? void 0 : Number(s)
  };
}), ECe = [
  "as",
  "style",
  "className",
  "grid",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], K9 = "__resizable_base__", _Ce = (
  /** @class */
  (function(e) {
    xCe(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.ratio = 1, r.resizable = null, r.parentLeft = 0, r.parentTop = 0, r.resizableLeft = 0, r.resizableRight = 0, r.resizableTop = 0, r.resizableBottom = 0, r.targetLeft = 0, r.targetTop = 0, r.appendBase = function() {
        if (!r.resizable || !r.window)
          return null;
        var i = r.parentNode;
        if (!i)
          return null;
        var o = r.window.document.createElement("div");
        return o.style.width = "100%", o.style.height = "100%", o.style.position = "absolute", o.style.transform = "scale(0, 0)", o.style.left = "0", o.style.flex = "0 0 100%", o.classList ? o.classList.add(K9) : o.className += K9, i.appendChild(o), o;
      }, r.removeBase = function(i) {
        var o = r.parentNode;
        o && o.removeChild(i);
      }, r.ref = function(i) {
        i && (r.resizable = i);
      }, r.state = {
        isResizing: !1,
        width: typeof (r.propsSize && r.propsSize.width) > "u" ? "auto" : r.propsSize && r.propsSize.width,
        height: typeof (r.propsSize && r.propsSize.height) > "u" ? "auto" : r.propsSize && r.propsSize.height,
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, r.onResizeStart = r.onResizeStart.bind(r), r.onMouseMove = r.onMouseMove.bind(r), r.onMouseUp = r.onMouseUp.bind(r), r;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || SCe;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, r = 0;
        if (this.resizable && this.window) {
          var i = this.resizable.offsetWidth, o = this.resizable.offsetHeight, s = this.resizable.style.position;
          s !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : i, r = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : o, this.resizable.style.position = s;
        }
        return { width: n, height: r };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, r = this.props.size, i = function(u) {
          if (typeof n.state[u] > "u" || n.state[u] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[u] && Uo(n.propsSize[u].toString(), "%")) {
            if (Uo(n.state[u].toString(), "%"))
              return n.state[u].toString();
            var f = n.getParentSize(), p = Number(n.state[u].toString().replace("px", "")), m = p / f[u] * 100;
            return m + "%";
          }
          return oz(n.state[u]);
        }, o = r && typeof r.width < "u" && !this.state.isResizing ? oz(r.width) : i("width"), s = r && typeof r.height < "u" && !this.state.isResizing ? oz(r.height) : i("height");
        return { width: o, height: s };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var r = !1, i = this.parentNode.style.flexWrap;
      i !== "wrap" && (r = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%", n.style.minHeight = "100%";
      var o = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return r && (this.parentNode.style.flexWrap = i), this.removeBase(n), o;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, r) {
      var i = this.propsSize && this.propsSize[r];
      return this.state[r] === "auto" && this.state.original[r] === n && (typeof i > "u" || i === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, r) {
      var i = this.props.boundsByDirection, o = this.state.direction, s = i && D0("left", o), u = i && D0("top", o), f, p;
      if (this.props.bounds === "parent") {
        var m = this.parentNode;
        m && (f = s ? this.resizableRight - this.parentLeft : m.offsetWidth + (this.parentLeft - this.resizableLeft), p = u ? this.resizableBottom - this.parentTop : m.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (f = s ? this.resizableRight : this.window.innerWidth - this.resizableLeft, p = u ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (f = s ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), p = u ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return f && Number.isFinite(f) && (n = n && n < f ? n : f), p && Number.isFinite(p) && (r = r && r < p ? r : p), { maxWidth: n, maxHeight: r };
    }, t.prototype.calculateNewSizeFromDirection = function(n, r) {
      var i = this.props.scale || 1, o = this.props.resizeRatio || 1, s = this.state, u = s.direction, f = s.original, p = this.props, m = p.lockAspectRatio, v = p.lockAspectRatioExtraHeight, y = p.lockAspectRatioExtraWidth, S = f.width, E = f.height, w = v || 0, _ = y || 0;
      return D0("right", u) && (S = f.width + (n - f.x) * o / i, m && (E = (S - _) / this.ratio + w)), D0("left", u) && (S = f.width - (n - f.x) * o / i, m && (E = (S - _) / this.ratio + w)), D0("bottom", u) && (E = f.height + (r - f.y) * o / i, m && (S = (E - w) * this.ratio + _)), D0("top", u) && (E = f.height - (r - f.y) * o / i, m && (S = (E - w) * this.ratio + _)), { newWidth: S, newHeight: E };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, r, i, o) {
      var s = this.props, u = s.lockAspectRatio, f = s.lockAspectRatioExtraHeight, p = s.lockAspectRatioExtraWidth, m = typeof o.width > "u" ? 10 : o.width, v = typeof i.width > "u" || i.width < 0 ? n : i.width, y = typeof o.height > "u" ? 10 : o.height, S = typeof i.height > "u" || i.height < 0 ? r : i.height, E = f || 0, w = p || 0;
      if (u) {
        var _ = (y - E) * this.ratio + w, O = (S - E) * this.ratio + w, D = (m - w) / this.ratio + E, P = (v - w) / this.ratio + E, M = Math.max(m, _), N = Math.min(v, O), k = Math.max(y, D), U = Math.min(S, P);
        n = ZR(n, M, N), r = ZR(r, k, U);
      } else
        n = ZR(n, m, v), r = ZR(r, y, S);
      return { newWidth: n, newHeight: r };
    }, t.prototype.setBoundingClientRect = function() {
      if (this.props.bounds === "parent") {
        var n = this.parentNode;
        if (n) {
          var r = n.getBoundingClientRect();
          this.parentLeft = r.left, this.parentTop = r.top;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var i = this.props.bounds.getBoundingClientRect();
        this.targetLeft = i.left, this.targetTop = i.top;
      }
      if (this.resizable) {
        var o = this.resizable.getBoundingClientRect(), s = o.left, u = o.top, f = o.right, p = o.bottom;
        this.resizableLeft = s, this.resizableRight = f, this.resizableTop = u, this.resizableBottom = p;
      }
    }, t.prototype.onResizeStart = function(n, r) {
      if (!(!this.resizable || !this.window)) {
        var i = 0, o = 0;
        if (n.nativeEvent && wCe(n.nativeEvent) ? (i = n.nativeEvent.clientX, o = n.nativeEvent.clientY) : n.nativeEvent && KR(n.nativeEvent) && (i = n.nativeEvent.touches[0].clientX, o = n.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var s = this.props.onResizeStart(n, r, this.resizable);
          if (s === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var u, f = this.window.getComputedStyle(this.resizable);
        if (f.flexBasis !== "auto") {
          var p = this.parentNode;
          if (p) {
            var m = this.window.getComputedStyle(p).flexDirection;
            this.flexDir = m.startsWith("row") ? "row" : "column", u = f.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var v = {
          original: {
            x: i,
            y: o,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: Ad(Ad({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: r,
          flexBasis: u
        };
        this.setState(v);
      }
    }, t.prototype.onMouseMove = function(n) {
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && KR(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var r = this.props, i = r.maxWidth, o = r.maxHeight, s = r.minWidth, u = r.minHeight, f = KR(n) ? n.touches[0].clientX : n.clientX, p = KR(n) ? n.touches[0].clientY : n.clientY, m = this.state, v = m.direction, y = m.original, S = m.width, E = m.height, w = this.getParentSize(), _ = TCe(w, this.window.innerWidth, this.window.innerHeight, i, o, s, u);
        i = _.maxWidth, o = _.maxHeight, s = _.minWidth, u = _.minHeight;
        var O = this.calculateNewSizeFromDirection(f, p), D = O.newHeight, P = O.newWidth, M = this.calculateNewMaxFromBoundary(i, o);
        this.props.snap && this.props.snap.x && (P = Z9(P, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (D = Z9(D, this.props.snap.y, this.props.snapGap));
        var N = this.calculateNewSizeFromAspectRatio(P, D, { width: M.maxWidth, height: M.maxHeight }, { width: s, height: u });
        if (P = N.newWidth, D = N.newHeight, this.props.grid) {
          var k = X9(P, this.props.grid[0]), U = X9(D, this.props.grid[1]), H = this.props.snapGap || 0;
          P = H === 0 || Math.abs(k - P) <= H ? k : P, D = H === 0 || Math.abs(U - D) <= H ? U : D;
        }
        var Y = {
          width: P - y.width,
          height: D - y.height
        };
        if (S && typeof S == "string") {
          if (Uo(S, "%")) {
            var z = P / w.width * 100;
            P = z + "%";
          } else if (Uo(S, "vw")) {
            var V = P / this.window.innerWidth * 100;
            P = V + "vw";
          } else if (Uo(S, "vh")) {
            var F = P / this.window.innerHeight * 100;
            P = F + "vh";
          }
        }
        if (E && typeof E == "string") {
          if (Uo(E, "%")) {
            var z = D / w.height * 100;
            D = z + "%";
          } else if (Uo(E, "vw")) {
            var V = D / this.window.innerWidth * 100;
            D = V + "vw";
          } else if (Uo(E, "vh")) {
            var F = D / this.window.innerHeight * 100;
            D = F + "vh";
          }
        }
        var X = {
          width: this.createSizeForCssProperty(P, "width"),
          height: this.createSizeForCssProperty(D, "height")
        };
        this.flexDir === "row" ? X.flexBasis = X.width : this.flexDir === "column" && (X.flexBasis = X.height), this.setState(X), this.props.onResize && this.props.onResize(n, v, this.resizable, Y);
      }
    }, t.prototype.onMouseUp = function(n) {
      var r = this.state, i = r.isResizing, o = r.direction, s = r.original;
      if (!(!i || !this.resizable)) {
        var u = {
          width: this.size.width - s.width,
          height: this.size.height - s.height
        };
        this.props.onResizeStop && this.props.onResizeStop(n, o, this.resizable, u), this.props.size && this.setState(this.props.size), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: Ad(Ad({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, t.prototype.updateSize = function(n) {
      this.setState({ width: n.width, height: n.height });
    }, t.prototype.renderResizer = function() {
      var n = this, r = this.props, i = r.enable, o = r.handleStyles, s = r.handleClasses, u = r.handleWrapperStyle, f = r.handleWrapperClass, p = r.handleComponent;
      if (!i)
        return null;
      var m = Object.keys(i).map(function(v) {
        return i[v] !== !1 ? $.createElement(vCe, { key: v, direction: v, onResizeStart: n.onResizeStart, replaceStyles: o && o[v], className: s && s[v] }, p && p[v] ? p[v] : null) : null;
      });
      return $.createElement("div", { className: f, style: u }, m);
    }, t.prototype.render = function() {
      var n = this, r = Object.keys(this.props).reduce(function(s, u) {
        return ECe.indexOf(u) !== -1 || (s[u] = n.props[u]), s;
      }, {}), i = Ad(Ad(Ad({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (i.flexBasis = this.state.flexBasis);
      var o = this.props.as || "div";
      return $.createElement(
        o,
        Ad({ ref: this.ref, style: i, className: this.props.className }, r),
        this.state.isResizing && $.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  })($.PureComponent)
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var cV = function(e, t) {
  return cV = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) r.hasOwnProperty(i) && (n[i] = r[i]);
  }, cV(e, t);
};
function CCe(e, t) {
  cV(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Ro = function() {
  return Ro = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Ro.apply(this, arguments);
};
function RCe(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
var OCe = hCe, ACe = {
  width: "auto",
  height: "auto",
  display: "inline-block",
  position: "absolute",
  top: 0,
  left: 0
}, DCe = function(e) {
  return {
    bottom: e,
    bottomLeft: e,
    bottomRight: e,
    left: e,
    right: e,
    top: e,
    topLeft: e,
    topRight: e
  };
}, bF = (
  /** @class */
  (function(e) {
    CCe(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.resizingPosition = { x: 0, y: 0 }, r.offsetFromParent = { left: 0, top: 0 }, r.resizableElement = { current: null }, r.originalPosition = { x: 0, y: 0 }, r.refDraggable = function(i) {
        i && (r.draggable = i);
      }, r.refResizable = function(i) {
        i && (r.resizable = i, r.resizableElement.current = i.resizable);
      }, r.state = {
        resizing: !1,
        bounds: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        maxWidth: n.maxWidth,
        maxHeight: n.maxHeight
      }, r.onResizeStart = r.onResizeStart.bind(r), r.onResize = r.onResize.bind(r), r.onResizeStop = r.onResizeStop.bind(r), r.onDragStart = r.onDragStart.bind(r), r.onDrag = r.onDrag.bind(r), r.onDragStop = r.onDragStop.bind(r), r.getMaxSizesFromProps = r.getMaxSizesFromProps.bind(r), r;
    }
    return t.prototype.componentDidMount = function() {
      this.updateOffsetFromParent();
      var n = this.offsetFromParent, r = n.left, i = n.top, o = this.getDraggablePosition(), s = o.x, u = o.y;
      this.draggable.setState({
        x: s - r,
        y: u - i
      }), this.forceUpdate();
    }, t.prototype.getDraggablePosition = function() {
      var n = this.draggable.state, r = n.x, i = n.y;
      return { x: r, y: i };
    }, t.prototype.getParent = function() {
      return this.resizable && this.resizable.parentNode;
    }, t.prototype.getParentSize = function() {
      return this.resizable.getParentSize();
    }, t.prototype.getMaxSizesFromProps = function() {
      var n = typeof this.props.maxWidth > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth, r = typeof this.props.maxHeight > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
      return { maxWidth: n, maxHeight: r };
    }, t.prototype.getSelfElement = function() {
      return this.resizable && this.resizable.resizable;
    }, t.prototype.getOffsetHeight = function(n) {
      var r = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerHeight / r;
        case "body":
          return document.body.offsetHeight / r;
        default:
          return n.offsetHeight;
      }
    }, t.prototype.getOffsetWidth = function(n) {
      var r = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerWidth / r;
        case "body":
          return document.body.offsetWidth / r;
        default:
          return n.offsetWidth;
      }
    }, t.prototype.onDragStart = function(n, r) {
      this.props.onDragStart && this.props.onDragStart(n, r);
      var i = this.getDraggablePosition();
      if (this.originalPosition = i, !!this.props.bounds) {
        var o = this.getParent(), s = this.props.scale, u;
        if (this.props.bounds === "parent")
          u = o;
        else if (this.props.bounds === "body") {
          var f = o.getBoundingClientRect(), p = f.left, m = f.top, v = document.body.getBoundingClientRect(), y = -(p - o.offsetLeft * s - v.left) / s, S = -(m - o.offsetTop * s - v.top) / s, E = (document.body.offsetWidth - this.resizable.size.width * s) / s + y, w = (document.body.offsetHeight - this.resizable.size.height * s) / s + S;
          return this.setState({ bounds: { top: S, right: E, bottom: w, left: y } });
        } else if (this.props.bounds === "window") {
          if (!this.resizable)
            return;
          var _ = o.getBoundingClientRect(), O = _.left, D = _.top, P = -(O - o.offsetLeft * s) / s, M = -(D - o.offsetTop * s) / s, E = (window.innerWidth - this.resizable.size.width * s) / s + P, w = (window.innerHeight - this.resizable.size.height * s) / s + M;
          return this.setState({ bounds: { top: M, right: E, bottom: w, left: P } });
        } else typeof this.props.bounds == "string" ? u = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (u = this.props.bounds);
        if (!(!(u instanceof HTMLElement) || !(o instanceof HTMLElement))) {
          var N = u.getBoundingClientRect(), k = N.left, U = N.top, H = o.getBoundingClientRect(), Y = H.left, z = H.top, V = (k - Y) / s, F = U - z;
          if (this.resizable) {
            this.updateOffsetFromParent();
            var X = this.offsetFromParent;
            this.setState({
              bounds: {
                top: F - X.top,
                right: V + (u.offsetWidth - this.resizable.size.width) - X.left / s,
                bottom: F + (u.offsetHeight - this.resizable.size.height) - X.top,
                left: V - X.left / s
              }
            });
          }
        }
      }
    }, t.prototype.onDrag = function(n, r) {
      if (this.props.onDrag) {
        var i = this.offsetFromParent, o = i.left, s = i.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDrag(n, Ro(Ro({}, r), { x: r.x - o, y: r.y - s }));
        if (this.props.dragAxis === "x")
          return this.props.onDrag(n, Ro(Ro({}, r), { x: r.x + o, y: this.originalPosition.y + s, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDrag(n, Ro(Ro({}, r), { x: this.originalPosition.x + o, y: r.y + s, deltaX: 0 }));
      }
    }, t.prototype.onDragStop = function(n, r) {
      if (this.props.onDragStop) {
        var i = this.offsetFromParent, o = i.left, s = i.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDragStop(n, Ro(Ro({}, r), { x: r.x + o, y: r.y + s }));
        if (this.props.dragAxis === "x")
          return this.props.onDragStop(n, Ro(Ro({}, r), { x: r.x + o, y: this.originalPosition.y + s, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDragStop(n, Ro(Ro({}, r), { x: this.originalPosition.x + o, y: r.y + s, deltaX: 0 }));
      }
    }, t.prototype.onResizeStart = function(n, r, i) {
      n.stopPropagation(), this.setState({
        resizing: !0
      });
      var o = this.props.scale, s = this.offsetFromParent, u = this.getDraggablePosition();
      if (this.resizingPosition = { x: u.x + s.left, y: u.y + s.top }, this.originalPosition = u, this.props.bounds) {
        var f = this.getParent(), p = void 0;
        this.props.bounds === "parent" ? p = f : this.props.bounds === "body" ? p = document.body : this.props.bounds === "window" ? p = window : typeof this.props.bounds == "string" ? p = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (p = this.props.bounds);
        var m = this.getSelfElement();
        if (m instanceof Element && (p instanceof HTMLElement || p === window) && f instanceof HTMLElement) {
          var v = this.getMaxSizesFromProps(), y = v.maxWidth, S = v.maxHeight, E = this.getParentSize();
          if (y && typeof y == "string")
            if (y.endsWith("%")) {
              var w = Number(y.replace("%", "")) / 100;
              y = E.width * w;
            } else y.endsWith("px") && (y = Number(y.replace("px", "")));
          if (S && typeof S == "string")
            if (S.endsWith("%")) {
              var w = Number(S.replace("%", "")) / 100;
              S = E.width * w;
            } else S.endsWith("px") && (S = Number(S.replace("px", "")));
          var _ = m.getBoundingClientRect(), O = _.left, D = _.top, P = this.props.bounds === "window" ? { left: 0, top: 0 } : p.getBoundingClientRect(), M = P.left, N = P.top, k = this.getOffsetWidth(p), U = this.getOffsetHeight(p), H = r.toLowerCase().endsWith("left"), Y = r.toLowerCase().endsWith("right"), z = r.startsWith("top"), V = r.startsWith("bottom");
          if ((H || z) && this.resizable) {
            var F = (O - M) / o + this.resizable.size.width;
            this.setState({ maxWidth: F > Number(y) ? y : F });
          }
          if (Y || this.props.lockAspectRatio && !H && !z) {
            var F = k + (M - O) / o;
            this.setState({ maxWidth: F > Number(y) ? y : F });
          }
          if ((z || H) && this.resizable) {
            var F = (D - N) / o + this.resizable.size.height;
            this.setState({
              maxHeight: F > Number(S) ? S : F
            });
          }
          if (V || this.props.lockAspectRatio && !z && !H) {
            var F = U + (N - D) / o;
            this.setState({
              maxHeight: F > Number(S) ? S : F
            });
          }
        }
      } else
        this.setState({
          maxWidth: this.props.maxWidth,
          maxHeight: this.props.maxHeight
        });
      this.props.onResizeStart && this.props.onResizeStart(n, r, i);
    }, t.prototype.onResize = function(n, r, i, o) {
      var s = { x: this.originalPosition.x, y: this.originalPosition.y }, u = -o.width, f = -o.height, p = ["top", "left", "topLeft", "bottomLeft", "topRight"];
      p.indexOf(r) !== -1 && (r === "bottomLeft" ? s.x += u : (r === "topRight" || (s.x += u), s.y += f)), (s.x !== this.draggable.state.x || s.y !== this.draggable.state.y) && this.draggable.setState(s), this.updateOffsetFromParent();
      var m = this.offsetFromParent, v = this.getDraggablePosition().x + m.left, y = this.getDraggablePosition().y + m.top;
      this.resizingPosition = { x: v, y }, this.props.onResize && this.props.onResize(n, r, i, o, {
        x: v,
        y
      });
    }, t.prototype.onResizeStop = function(n, r, i, o) {
      this.setState({
        resizing: !1
      });
      var s = this.getMaxSizesFromProps(), u = s.maxWidth, f = s.maxHeight;
      this.setState({ maxWidth: u, maxHeight: f }), this.props.onResizeStop && this.props.onResizeStop(n, r, i, o, this.resizingPosition);
    }, t.prototype.updateSize = function(n) {
      this.resizable && this.resizable.updateSize({ width: n.width, height: n.height });
    }, t.prototype.updatePosition = function(n) {
      this.draggable.setState(n);
    }, t.prototype.updateOffsetFromParent = function() {
      var n = this.props.scale, r = this.getParent(), i = this.getSelfElement();
      if (!r || i === null)
        return {
          top: 0,
          left: 0
        };
      var o = r.getBoundingClientRect(), s = o.left, u = o.top, f = i.getBoundingClientRect(), p = this.getDraggablePosition(), m = r.scrollLeft, v = r.scrollTop;
      this.offsetFromParent = {
        left: f.left - s + m - p.x * n,
        top: f.top - u + v - p.y * n
      };
    }, t.prototype.render = function() {
      var n = this.props, r = n.disableDragging, i = n.style, o = n.dragHandleClassName, s = n.position, u = n.onMouseDown, f = n.onMouseUp, p = n.dragAxis, m = n.dragGrid, v = n.bounds, y = n.enableUserSelectHack, S = n.cancel, E = n.children;
      n.onResizeStart, n.onResize, n.onResizeStop, n.onDragStart, n.onDrag, n.onDragStop;
      var w = n.resizeHandleStyles, _ = n.resizeHandleClasses, O = n.resizeHandleComponent, D = n.enableResizing, P = n.resizeGrid, M = n.resizeHandleWrapperClass, N = n.resizeHandleWrapperStyle, k = n.scale, U = n.allowAnyClick, H = RCe(n, ["disableDragging", "style", "dragHandleClassName", "position", "onMouseDown", "onMouseUp", "dragAxis", "dragGrid", "bounds", "enableUserSelectHack", "cancel", "children", "onResizeStart", "onResize", "onResizeStop", "onDragStart", "onDrag", "onDragStop", "resizeHandleStyles", "resizeHandleClasses", "resizeHandleComponent", "enableResizing", "resizeGrid", "resizeHandleWrapperClass", "resizeHandleWrapperStyle", "scale", "allowAnyClick"]), Y = this.props.default ? Ro({}, this.props.default) : void 0;
      delete H.default;
      var z = r || o ? { cursor: "auto" } : { cursor: "move" }, V = Ro(Ro(Ro({}, ACe), z), i), F = this.offsetFromParent, X = F.left, oe = F.top, re;
      s && (re = {
        x: s.x - X,
        y: s.y - oe
      });
      var Z = this.state.resizing ? void 0 : re, ee = this.state.resizing ? "both" : p;
      return Ou(
        OCe,
        { ref: this.refDraggable, handle: o ? ".".concat(o) : void 0, defaultPosition: Y, onMouseDown: u, onMouseUp: f, onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop, axis: ee, disabled: r, grid: m, bounds: v ? this.state.bounds : void 0, position: Z, enableUserSelectHack: y, cancel: S, scale: k, allowAnyClick: U, nodeRef: this.resizableElement },
        Ou(_Ce, Ro({}, H, { ref: this.refResizable, defaultSize: Y, size: this.props.size, enable: typeof D == "boolean" ? DCe(D) : D, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeStop: this.onResizeStop, style: V, minWidth: this.props.minWidth, minHeight: this.props.minHeight, maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth, maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight, grid: P, handleWrapperClass: M, handleWrapperStyle: N, lockAspectRatio: this.props.lockAspectRatio, lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth, lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight, handleStyles: w, handleClasses: _, handleComponent: O, scale: this.props.scale }), E)
      );
    }, t.defaultProps = {
      maxWidth: Number.MAX_SAFE_INTEGER,
      maxHeight: Number.MAX_SAFE_INTEGER,
      scale: 1,
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      onDragStart: function() {
      },
      onDrag: function() {
      },
      onDragStop: function() {
      }
    }, t;
  })(oU)
), lE = {}, Q9;
function ICe() {
  if (Q9) return lE;
  Q9 = 1, Object.defineProperty(lE, "__esModule", { value: !0 }), lE.useElementSize = void 0;
  var e = it;
  function t() {
    var n = (0, e.useState)(null), r = n[0], i = n[1], o = (0, e.useState)({ width: 0, height: 0 }), s = o[0], u = o[1], f = (0, e.useCallback)(function() {
      r && u({
        width: r.offsetWidth,
        height: r.offsetHeight
      });
    }, [r]), p = typeof window < "u" ? e.useLayoutEffect : e.useEffect;
    return p(function() {
      if (r) {
        f();
        var m = new ResizeObserver(f);
        return m.observe(r), function() {
          return m.disconnect();
        };
      }
    }, [r, f]), [i, s];
  }
  return lE.useElementSize = t, lE;
}
var Hre = ICe();
function qre() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = e.filter(Boolean);
  if (n.length <= 1) {
    var r = n[0];
    return r || null;
  }
  return function(o) {
    n.forEach(function(s) {
      typeof s == "function" ? s(o) : s && (s.current = o);
    });
  };
}
const PCe = ye(Ei, { name: "CompanionWindow", slot: "root" })({}), NCe = ye(ny, { name: "CompanionWindow", slot: "toolbar" })({}), MCe = ye(St, { name: "CompanionWindow", slot: "title" })({}), jCe = ye("div", { name: "CompanionWindow", slot: "controls" })({}), LCe = ye(Ei, { name: "CompanionWindow", slot: "contents" })({}), kCe = ye(bF, { name: "CompanionWindow", slot: "resize" })({}), zCe = ye(Jn, { name: "CompanionWindow", slot: "positionButton" })({}), BCe = ye(Jn, { name: "CompanionWindow", slot: "closeButton" })({}), xF = YA((e, t) => {
  const {
    ariaLabel: n = void 0,
    classes: r = {},
    direction: i,
    id: o,
    paperClassName: s = "",
    onCloseClick: u = () => {
    },
    updateCompanionWindow: f = void 0,
    isDisplayed: p = !1,
    position: m = null,
    title: v = null,
    children: y = void 0,
    titleControls: S = null,
    defaultSidebarPanelWidth: E = 235,
    defaultSidebarPanelHeight: w = 201
  } = e, [_, O] = Hre.useElementSize(), { t: D } = Ct(), P = Ba((H) => KU(H, { companionWindowId: o }), [o]), M = i === "rtl" ? { transform: "scale(-1, 1)" } : {}, N = (() => {
    const H = {
      ltr: {
        default: "left",
        opposite: "right"
      },
      rtl: {
        default: "right",
        opposite: "left"
      }
    }, Y = {
      bottom: !1,
      bottomLeft: !1,
      bottomRight: !1,
      left: !1,
      right: !1,
      top: !1,
      topLeft: !1,
      topRight: !1
    };
    return m === "right" || m === "far-right" ? { ...Y, [H[i].default]: !0 } : m === "left" ? { ...Y, [H[i].opposite]: !0 } : m === "bottom" || m === "far-bottom" ? { ...Y, top: !0 } : Y;
  })(), k = m === "bottom" || m === "far-bottom", U = aU.map(y, (H) => H ? jd(
    H,
    {
      parentactions: {
        closeCompanionWindow: u
      }
    }
  ) : null);
  return /* @__PURE__ */ T.jsx(
    PCe,
    {
      ownerState: e,
      ref: qre(t, _),
      style: {
        display: p ? null : "none",
        order: m === "left" ? -1 : null
      },
      className: [Nt(`companion-window-${m}`), s, m === "bottom" ? r.horizontal : r.vertical].join(" "),
      square: !0,
      component: "aside",
      "aria-label": n || v,
      children: /* @__PURE__ */ T.jsx(JD.Provider, { value: P, children: /* @__PURE__ */ T.jsxs(
        kCe,
        {
          style: { display: "inherit", position: "inherit" },
          ownerState: e,
          default: {
            height: k ? w : "100%",
            width: k ? "auto" : E
          },
          disableDragging: !0,
          enableResizing: N,
          minHeight: 50,
          minWidth: m === "left" ? 235 : 100,
          children: [
            /* @__PURE__ */ T.jsxs(
              NCe,
              {
                variant: "dense",
                className: [Nt("companion-window-header"), O.width < 370 ? "test" : null].join(" "),
                disableGutters: !0,
                children: [
                  /* @__PURE__ */ T.jsx(MCe, { variant: "h3", children: v }),
                  m === "left" ? f && /* @__PURE__ */ T.jsx(
                    Jn,
                    {
                      "aria-label": D("openInCompanionWindow"),
                      onClick: () => {
                        f({ position: "right" });
                      },
                      children: /* @__PURE__ */ T.jsx(tCe, { style: M })
                    }
                  ) : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
                    f && /* @__PURE__ */ T.jsx(
                      zCe,
                      {
                        "aria-label": D(m === "bottom" ? "moveCompanionWindowToRight" : "moveCompanionWindowToBottom"),
                        onClick: () => {
                          f({ position: m === "bottom" ? "right" : "bottom" });
                        },
                        children: /* @__PURE__ */ T.jsx(nCe, {})
                      }
                    ),
                    /* @__PURE__ */ T.jsx(
                      BCe,
                      {
                        sx: {
                          ...O.width < 370 && {
                            order: "unset"
                          }
                        },
                        "aria-label": D("closeCompanionWindow"),
                        onClick: u,
                        children: /* @__PURE__ */ T.jsx(m_, {})
                      }
                    )
                  ] }),
                  S && /* @__PURE__ */ T.jsx(
                    jCe,
                    {
                      ownerState: { position: m },
                      sx: {
                        order: k || O.width < 370 ? "unset" : 1e3
                      },
                      className: Nt("companion-window-title-controls"),
                      children: S
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ T.jsx(
              LCe,
              {
                className: Nt("scrollto-scrollable"),
                elevation: 0,
                children: U
              }
            )
          ]
        }
      ) })
    }
  );
});
xF.propTypes = {
  ariaLabel: c.string,
  children: c.node,
  classes: c.objectOf(c.string),
  defaultSidebarPanelHeight: c.number,
  defaultSidebarPanelWidth: c.number,
  direction: c.string.isRequired,
  id: c.string.isRequired,
  isDisplayed: c.bool,
  onCloseClick: c.func,
  paperClassName: c.string,
  position: c.string,
  size: c.shape({ width: c.number }),
  title: c.oneOfType([
    c.string,
    c.node
  ]),
  titleControls: c.node,
  updateCompanionWindow: c.func
};
xF.displayName = "CompanionWindow";
const VCe = (e, { id: t, windowId: n }) => {
  const r = ju(e, { companionWindowId: t }), {
    defaultSidebarPanelHeight: i,
    defaultSidebarPanelWidth: o
  } = fa(e, { windowId: n });
  return {
    ...r,
    defaultSidebarPanelHeight: i,
    defaultSidebarPanelWidth: o,
    direction: Ax(e),
    isDisplayed: r && r.content && r.content.length > 0
  };
}, UCe = (e, { windowId: t, id: n }) => ({
  onCloseClick: () => e(
    Pte(t, n)
  ),
  updateCompanionWindow: (...r) => e(
    Nx(t, n, ...r)
  )
}), FCe = wt(
  At(VCe, UCe, null, { forwardRef: !0 }),
  Tt("CompanionWindow")
), Zd = FCe(xF), _v = ye("div", { name: "CompanionWindowSection", slot: "root" })(({ theme: e }) => ({
  paddingBlockEnd: e.spacing(1),
  paddingBlockStart: e.spacing(2),
  paddingInlineEnd: e.spacing(1),
  paddingInlineStart: e.spacing(2)
}));
function $re({
  annotationCount: e,
  canvasIds: t = [],
  windowId: n,
  id: r
}) {
  const { t: i } = Ct(), o = yJ();
  return /* @__PURE__ */ T.jsxs(
    Zd,
    {
      title: i("annotations"),
      paperClassName: Nt("window-sidebar-annotation-panel"),
      windowId: n,
      id: r,
      ref: o,
      titleControls: /* @__PURE__ */ T.jsx(G1e, { windowId: n }),
      children: [
        /* @__PURE__ */ T.jsx(_v, { children: /* @__PURE__ */ T.jsx(St, { component: "p", variant: "subtitle2", children: i("showingNumAnnotations", { count: e, number: e }) }) }),
        t.map((s, u) => /* @__PURE__ */ T.jsx(
          eCe,
          {
            canvasId: s,
            containerRef: o,
            index: u,
            totalSize: t.length,
            windowId: n
          },
          s
        ))
      ]
    }
  );
}
$re.propTypes = {
  annotationCount: c.number.isRequired,
  canvasIds: c.arrayOf(c.string),
  id: c.string.isRequired,
  windowId: c.string.isRequired
};
const WCe = (e, { windowId: t }) => ({
  annotationCount: wD(
    e,
    { windowId: t }
  ).length,
  canvasIds: ku(e, { windowId: t })
}), HCe = wt(
  At(WCe, null),
  Tt("WindowSideBarAnnotationsPanel")
  // further HOC
), qCe = HCe($re);
function $Ce(e) {
  return Vt("MuiCollapse", e);
}
Wt("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
var GCe = {};
const YCe = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, r = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Ft(r, $Ce, n);
}, XCe = ye("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(Lt(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), ZCe = ye("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), KCe = ye("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), px = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: i,
    children: o,
    className: s,
    collapsedSize: u = "0px",
    component: f,
    easing: p,
    in: m,
    onEnter: v,
    onEntered: y,
    onEntering: S,
    onExit: E,
    onExited: w,
    onExiting: _,
    orientation: O = "vertical",
    style: D,
    timeout: P = Zne.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: M = Vc,
    ...N
  } = r, k = {
    ...r,
    orientation: O,
    collapsedSize: u
  }, U = YCe(k), H = pa(), Y = eg(), z = $.useRef(null), V = $.useRef(), F = typeof u == "number" ? `${u}px` : u, X = O === "horizontal", oe = X ? "width" : "height", re = $.useRef(null), Z = kr(n, re), ee = (me) => (Ee) => {
    if (me) {
      const Ie = re.current;
      Ee === void 0 ? me(Ie) : me(Ie, Ee);
    }
  }, J = () => z.current ? z.current[X ? "clientWidth" : "clientHeight"] : 0, le = ee((me, Ee) => {
    z.current && X && (z.current.style.position = "absolute"), me.style[oe] = F, v && v(me, Ee);
  }), be = ee((me, Ee) => {
    const Ie = J();
    z.current && X && (z.current.style.position = "");
    const {
      duration: Pe,
      easing: De
    } = cg({
      style: D,
      timeout: P,
      easing: p
    }, {
      mode: "enter"
    });
    if (P === "auto") {
      const Ye = H.transitions.getAutoHeightDuration(Ie);
      me.style.transitionDuration = `${Ye}ms`, V.current = Ye;
    } else
      me.style.transitionDuration = typeof Pe == "string" ? Pe : `${Pe}ms`;
    me.style[oe] = `${Ie}px`, me.style.transitionTimingFunction = De, S && S(me, Ee);
  }), ne = ee((me, Ee) => {
    me.style[oe] = "auto", y && y(me, Ee);
  }), ae = ee((me) => {
    me.style[oe] = `${J()}px`, E && E(me);
  }), ie = ee(w), he = ee((me) => {
    const Ee = J(), {
      duration: Ie,
      easing: Pe
    } = cg({
      style: D,
      timeout: P,
      easing: p
    }, {
      mode: "exit"
    });
    if (P === "auto") {
      const De = H.transitions.getAutoHeightDuration(Ee);
      me.style.transitionDuration = `${De}ms`, V.current = De;
    } else
      me.style.transitionDuration = typeof Ie == "string" ? Ie : `${Ie}ms`;
    me.style[oe] = F, me.style.transitionTimingFunction = Pe, _ && _(me);
  }), pe = (me) => {
    P === "auto" && Y.start(V.current || 0, me), i && i(re.current, me);
  };
  return /* @__PURE__ */ T.jsx(M, {
    in: m,
    onEnter: le,
    onEntered: ne,
    onEntering: be,
    onExit: ae,
    onExited: ie,
    onExiting: he,
    addEndListener: pe,
    nodeRef: re,
    timeout: P === "auto" ? null : P,
    ...N,
    children: (me, {
      ownerState: Ee,
      ...Ie
    }) => /* @__PURE__ */ T.jsx(XCe, {
      as: f,
      className: yt(U.root, s, {
        entered: U.entered,
        exited: !m && F === "0px" && U.hidden
      }[me]),
      style: {
        [X ? "minWidth" : "minHeight"]: F,
        ...D
      },
      ref: Z,
      ownerState: {
        ...k,
        state: me
      },
      ...Ie,
      children: /* @__PURE__ */ T.jsx(ZCe, {
        ownerState: {
          ...k,
          state: me
        },
        className: U.wrapper,
        ref: z,
        children: /* @__PURE__ */ T.jsx(KCe, {
          ownerState: {
            ...k,
            state: me
          },
          className: U.wrapperInner,
          children: o
        })
      })
    })
  });
});
GCe.NODE_ENV !== "production" && (px.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * The content node to be collapsed.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: c.oneOfType([c.number, c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Qv,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: c.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
px && (px.muiSupportAuto = !0);
var QCe = {};
const SF = /* @__PURE__ */ $.createContext({});
QCe.NODE_ENV !== "production" && (SF.displayName = "AccordionContext");
function JCe(e) {
  return Vt("MuiAccordion", e);
}
const JR = Wt("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]);
var eRe = {};
const tRe = (e) => {
  const {
    classes: t,
    square: n,
    expanded: r,
    disabled: i,
    disableGutters: o
  } = e;
  return Ft({
    root: ["root", !n && "rounded", r && "expanded", i && "disabled", !o && "gutters"],
    heading: ["heading"],
    region: ["region"]
  }, JCe, t);
}, nRe = ye(Ei, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${JR.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(Lt(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${JR.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${JR.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}), Lt(({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${JR.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}))), rRe = ye("h3", {
  name: "MuiAccordion",
  slot: "Heading",
  overridesResolver: (e, t) => t.heading
})({
  all: "unset"
}), iI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiAccordion"
  }), {
    children: i,
    className: o,
    defaultExpanded: s = !1,
    disabled: u = !1,
    disableGutters: f = !1,
    expanded: p,
    onChange: m,
    square: v = !1,
    slots: y = {},
    slotProps: S = {},
    TransitionComponent: E,
    TransitionProps: w,
    ..._
  } = r, [O, D] = ip({
    controlled: p,
    default: s,
    name: "Accordion",
    state: "expanded"
  }), P = $.useCallback((J) => {
    D(!O), m && m(J, !O);
  }, [O, m, D]), [M, ...N] = $.Children.toArray(i), k = $.useMemo(() => ({
    expanded: O,
    disabled: u,
    disableGutters: f,
    toggle: P
  }), [O, u, f, P]), U = {
    ...r,
    square: v,
    disabled: u,
    disableGutters: f,
    expanded: O
  }, H = tRe(U), Y = {
    transition: E,
    ...y
  }, z = {
    transition: w,
    ...S
  }, V = {
    slots: Y,
    slotProps: z
  }, [F, X] = Xt("root", {
    elementType: nRe,
    externalForwardedProps: {
      ...V,
      ..._
    },
    className: yt(H.root, o),
    shouldForwardComponentProp: !0,
    ownerState: U,
    ref: n,
    additionalProps: {
      square: v
    }
  }), [oe, re] = Xt("heading", {
    elementType: rRe,
    externalForwardedProps: V,
    className: H.heading,
    ownerState: U
  }), [Z, ee] = Xt("transition", {
    elementType: px,
    externalForwardedProps: V,
    ownerState: U
  });
  return /* @__PURE__ */ T.jsxs(F, {
    ...X,
    children: [/* @__PURE__ */ T.jsx(oe, {
      ...re,
      children: /* @__PURE__ */ T.jsx(SF.Provider, {
        value: k,
        children: M
      })
    }), /* @__PURE__ */ T.jsx(Z, {
      in: O,
      timeout: "auto",
      ...ee,
      children: /* @__PURE__ */ T.jsx("div", {
        "aria-labelledby": M.props.id,
        id: M.props["aria-controls"],
        role: "region",
        className: H.region,
        children: N
      })
    })]
  });
});
eRe.NODE_ENV !== "production" && (iI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Wa(c.node.isRequired, (e) => {
    const t = $.Children.toArray(e.children)[0];
    return g_.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ $.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: c.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: c.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    heading: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    heading: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: c.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: c.object
});
function iRe(e) {
  return Vt("MuiAccordionDetails", e);
}
Wt("MuiAccordionDetails", ["root"]);
var oRe = {};
const aRe = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, iRe, t);
}, sRe = ye("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Lt(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
}))), oI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: i,
    ...o
  } = r, s = r, u = aRe(s);
  return /* @__PURE__ */ T.jsx(sRe, {
    className: yt(u.root, i),
    ref: n,
    ownerState: s,
    ...o
  });
});
oRe.NODE_ENV !== "production" && (oI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function lRe(e) {
  return Vt("MuiAccordionSummary", e);
}
const $0 = Wt("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]);
var cRe = {};
const uRe = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: r,
    disableGutters: i
  } = e;
  return Ft({
    root: ["root", n && "expanded", r && "disabled", !i && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !i && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, lRe, t);
}, dRe = ye(Ws, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Lt(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    width: "100%",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${$0.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${$0.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${$0.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (n) => !n.disableGutters,
      style: {
        [`&.${$0.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
})), fRe = ye("span", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  textAlign: "start",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${$0.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}))), pRe = ye("span", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${$0.expanded}`]: {
    transform: "rotate(180deg)"
  }
}))), aI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: i,
    className: o,
    expandIcon: s,
    focusVisibleClassName: u,
    onClick: f,
    slots: p,
    slotProps: m,
    ...v
  } = r, {
    disabled: y = !1,
    disableGutters: S,
    expanded: E,
    toggle: w
  } = $.useContext(SF), _ = (z) => {
    w && w(z), f && f(z);
  }, O = {
    ...r,
    expanded: E,
    disabled: y,
    disableGutters: S
  }, D = uRe(O), P = {
    slots: p,
    slotProps: m
  }, [M, N] = Xt("root", {
    ref: n,
    shouldForwardComponentProp: !0,
    className: yt(D.root, o),
    elementType: dRe,
    externalForwardedProps: {
      ...P,
      ...v
    },
    ownerState: O,
    additionalProps: {
      focusRipple: !1,
      disableRipple: !0,
      disabled: y,
      "aria-expanded": E,
      focusVisibleClassName: yt(D.focusVisible, u)
    },
    getSlotProps: (z) => ({
      ...z,
      onClick: (V) => {
        var F;
        (F = z.onClick) == null || F.call(z, V), _(V);
      }
    })
  }), [k, U] = Xt("content", {
    className: D.content,
    elementType: fRe,
    externalForwardedProps: P,
    ownerState: O
  }), [H, Y] = Xt("expandIconWrapper", {
    className: D.expandIconWrapper,
    elementType: pRe,
    externalForwardedProps: P,
    ownerState: O
  });
  return /* @__PURE__ */ T.jsxs(M, {
    ...N,
    children: [/* @__PURE__ */ T.jsx(k, {
      ...U,
      children: i
    }), s && /* @__PURE__ */ T.jsx(H, {
      ...Y,
      children: s
    })]
  });
});
cRe.NODE_ENV !== "production" && (aI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: c.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    content: c.oneOfType([c.func, c.object]),
    expandIconWrapper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    content: c.elementType,
    expandIconWrapper: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const sI = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
function iy({
  children: e,
  id: t,
  label: n
}) {
  const { t: r } = Ct(), [i, o] = Bn(!0), s = Yn((u, f) => {
    o(f);
  }, [o]);
  return /* @__PURE__ */ T.jsxs(iI, { slotProps: { heading: { component: "h4" } }, id: t, elevation: 0, expanded: i, onChange: s, disableGutters: !0, square: !0, variant: "compact", children: [
    /* @__PURE__ */ T.jsx(aI, { id: `${t}-header`, "aria-controls": `${t}-content`, "aria-label": r(i ? "collapseSection" : "expandSection", { section: n }), expandIcon: /* @__PURE__ */ T.jsx(sI, {}), children: /* @__PURE__ */ T.jsx(St, { variant: "overline", children: n }) }),
    /* @__PURE__ */ T.jsx(oI, { children: e })
  ] });
}
iy.propTypes = {
  children: c.node.isRequired,
  id: c.string.isRequired,
  label: c.string.isRequired
};
function v_({ defaultLabel: e = void 0, labelValuePairs: t }) {
  return t.length === 0 ? null : /* @__PURE__ */ T.jsx("dl", { className: Nt("label-value-metadata"), children: t.reduce((n, r, i) => n.concat([
    /* @__PURE__ */ T.jsx(St, { component: "dt", variant: "subtitle2", children: r.label || e }, `label-${i}`),
    /* @__PURE__ */ T.jsx(St, { style: { marginBottom: ".5em", marginLeft: "0px" }, component: "dd", variant: "body1", children: /* @__PURE__ */ T.jsx(Bs, { htmlString: r.values.join(", "), ruleSet: "iiif" }) }, `value-${i}`)
  ]), []) });
}
v_.propTypes = {
  defaultLabel: c.string,
  labelValuePairs: c.arrayOf(c.shape({
    label: c.string,
    values: c.arrayOf(c.string)
  })).isRequired
};
function lI(e) {
  const n = (Qi(bU) || {})[e];
  return { PluginComponents: ((n == null ? void 0 : n.add) || []).map((i) => i.component) };
}
const Ki = YA(({ classes: e = {}, targetName: t, ...n }, r) => {
  const { PluginComponents: i } = lI(t);
  return i ? i.map((o, s) => (
    // eslint-disable-line react/prop-types
    X0(o) ? jd(o, { ...n, ref: r }) : /* @__PURE__ */ Ou(
      o,
      {
        ref: r,
        ...n,
        key: s
      }
    )
  )) : null;
});
Ki.displayName = "PluginHook";
Ki.propTypes = {
  classes: c.object,
  // eslint-disable-line react/forbid-prop-types, react/require-default-props
  targetName: c.string.isRequired
};
function Gre({
  canvasDescription: e = null,
  canvasLabel: t = null,
  canvasMetadata: n = [],
  index: r = 1,
  totalSize: i = 1
}) {
  const { t: o } = Ct(), s = uo(), u = uo(), f = arguments[0];
  return /* @__PURE__ */ T.jsxs(
    iy,
    {
      id: s,
      label: o("currentItem", { context: `${r + 1}/${i}` }),
      children: [
        t && /* @__PURE__ */ T.jsx(
          St,
          {
            "aria-labelledby": `${s} ${u}`,
            id: u,
            variant: "h4",
            component: "h5",
            children: t
          }
        ),
        e && /* @__PURE__ */ T.jsx(St, { variant: "body1", children: /* @__PURE__ */ T.jsx(Bs, { htmlString: e, ruleSet: "iiif" }) }),
        n && n.length > 0 && /* @__PURE__ */ T.jsx(v_, { labelValuePairs: n }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "CanvasInfo", ...f })
      ]
    }
  );
}
Gre.propTypes = {
  canvasDescription: c.string,
  canvasLabel: c.string,
  canvasMetadata: c.array,
  // eslint-disable-line react/forbid-prop-types
  index: c.number,
  totalSize: c.number
};
const hRe = (e, { canvasId: t, companionWindowId: n, windowId: r }) => ({
  canvasDescription: lte(e, { canvasId: t, companionWindowId: n, windowId: r }),
  canvasLabel: yg(e, { canvasId: t, companionWindowId: n, windowId: r }),
  canvasMetadata: l3(
    Yd(e, { canvasId: t, companionWindowId: n, windowId: r })
  )
}), gRe = wt(
  At(hRe),
  Tt("CanvasInfo")
), mRe = gRe(Gre);
var az, J9;
function vRe() {
  if (J9) return az;
  J9 = 1;
  var e = oD(), t = Nee(), n = t(function(r, i, o) {
    e(r, o, i);
  });
  return az = n, az;
}
var yRe = vRe();
const bRe = /* @__PURE__ */ Hn(yRe);
function oy({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, i) => (r[i] = e[i], n && typeof e[i] > "u" && (r[i] = n[i]), r), {});
}
var xRe = {};
const y_ = /* @__PURE__ */ $.createContext(void 0);
xRe.NODE_ENV !== "production" && (y_.displayName = "FormControlContext");
function pp() {
  return $.useContext(y_);
}
function SRe(e) {
  return Vt("MuiFormLabel", e);
}
const VE = Wt("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]);
var wRe = {};
const TRe = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: i,
    error: o,
    filled: s,
    required: u
  } = e, f = {
    root: ["root", `color${Ke(n)}`, i && "disabled", o && "error", s && "filled", r && "focused", u && "required"],
    asterisk: ["asterisk", o && "error"]
  };
  return Ft(f, SRe, t);
}, ERe = ye("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }
})(Lt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${VE.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${VE.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${VE.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), _Re = ye("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(Lt(({
  theme: e
}) => ({
  [`&.${VE.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), Yre = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: i,
    className: o,
    color: s,
    component: u = "label",
    disabled: f,
    error: p,
    filled: m,
    focused: v,
    required: y,
    ...S
  } = r, E = pp(), w = oy({
    props: r,
    muiFormControl: E,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), _ = {
    ...r,
    color: w.color || "primary",
    component: u,
    disabled: w.disabled,
    error: w.error,
    filled: w.filled,
    focused: w.focused,
    required: w.required
  }, O = TRe(_);
  return /* @__PURE__ */ T.jsxs(ERe, {
    as: u,
    ownerState: _,
    className: yt(O.root, o),
    ref: n,
    ...S,
    children: [i, w.required && /* @__PURE__ */ T.jsxs(_Re, {
      ownerState: _,
      "aria-hidden": !0,
      className: O.asterisk,
      children: [" ", "*"]
    })]
  });
});
wRe.NODE_ENV !== "production" && (Yre.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: c.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: c.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: c.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function CRe(e) {
  return Vt("MuiInputLabel", e);
}
Wt("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
var RRe = {};
const ORe = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: i,
    disableAnimation: o,
    variant: s,
    required: u
  } = e, f = {
    root: ["root", n && "formControl", !o && "animated", i && "shrink", r && r !== "normal" && `size${Ke(r)}`, s],
    asterisk: [u && "asterisk"]
  }, p = Ft(f, CRe, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...p
  };
}, ARe = ye(Yre, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${VE.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(Lt(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: r
    }) => t === "filled" && n.shrink && r === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), wF = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: i = !1,
    margin: o,
    shrink: s,
    variant: u,
    className: f,
    ...p
  } = r, m = pp();
  let v = s;
  typeof v > "u" && m && (v = m.filled || m.focused || m.adornedStart);
  const y = oy({
    props: r,
    muiFormControl: m,
    states: ["size", "variant", "required", "focused"]
  }), S = {
    ...r,
    disableAnimation: i,
    formControl: m,
    shrink: v,
    size: y.size,
    variant: y.variant,
    required: y.required,
    focused: y.focused
  }, E = ORe(S);
  return /* @__PURE__ */ T.jsx(ARe, {
    "data-shrink": v,
    ref: n,
    className: yt(E.root, f),
    ...p,
    ownerState: S,
    classes: E
  });
});
RRe.NODE_ENV !== "production" && (wF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), c.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: c.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: c.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: c.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: c.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: c.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: c.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: c.oneOfType([c.oneOf(["normal", "small"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
function e7(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function gA(e, t = !1) {
  return e && (e7(e.value) && e.value !== "" || t && e7(e.defaultValue) && e.defaultValue !== "");
}
function DRe(e) {
  return e.startAdornment;
}
function IRe(e) {
  return Vt("MuiFormControl", e);
}
Wt("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
var Xre = {};
const PRe = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, i = {
    root: ["root", n !== "none" && `margin${Ke(n)}`, r && "fullWidth"]
  };
  return Ft(i, IRe, t);
}, NRe = ye("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${Ke(n.margin)}`], n.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), b_ = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiFormControl"
  }), {
    children: i,
    className: o,
    color: s = "primary",
    component: u = "div",
    disabled: f = !1,
    error: p = !1,
    focused: m,
    fullWidth: v = !1,
    hiddenLabel: y = !1,
    margin: S = "none",
    required: E = !1,
    size: w = "medium",
    variant: _ = "outlined",
    ...O
  } = r, D = {
    ...r,
    color: s,
    component: u,
    disabled: f,
    error: p,
    fullWidth: v,
    hiddenLabel: y,
    margin: S,
    required: E,
    size: w,
    variant: _
  }, P = PRe(D), [M, N] = $.useState(() => {
    let Z = !1;
    return i && $.Children.forEach(i, (ee) => {
      if (!J0(ee, ["Input", "Select"]))
        return;
      const J = J0(ee, ["Select"]) ? ee.props.input : ee;
      J && DRe(J.props) && (Z = !0);
    }), Z;
  }), [k, U] = $.useState(() => {
    let Z = !1;
    return i && $.Children.forEach(i, (ee) => {
      J0(ee, ["Input", "Select"]) && (gA(ee.props, !0) || gA(ee.props.inputProps, !0)) && (Z = !0);
    }), Z;
  }), [H, Y] = $.useState(!1);
  f && H && Y(!1);
  const z = m !== void 0 && !f ? m : H;
  let V;
  const F = $.useRef(!1);
  Xre.NODE_ENV !== "production" && (V = () => (F.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), F.current = !0, () => {
    F.current = !1;
  }));
  const X = $.useCallback(() => {
    U(!0);
  }, []), oe = $.useCallback(() => {
    U(!1);
  }, []), re = $.useMemo(() => ({
    adornedStart: M,
    setAdornedStart: N,
    color: s,
    disabled: f,
    error: p,
    filled: k,
    focused: z,
    fullWidth: v,
    hiddenLabel: y,
    size: w,
    onBlur: () => {
      Y(!1);
    },
    onFocus: () => {
      Y(!0);
    },
    onEmpty: oe,
    onFilled: X,
    registerEffect: V,
    required: E,
    variant: _
  }), [M, s, f, p, k, z, v, y, V, oe, X, E, w, _]);
  return /* @__PURE__ */ T.jsx(y_.Provider, {
    value: re,
    children: /* @__PURE__ */ T.jsx(NRe, {
      as: u,
      ownerState: D,
      className: yt(P.root, o),
      ref: n,
      ...O,
      children: i
    })
  });
});
Xre.NODE_ENV !== "production" && (b_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: c.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: c.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: c.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: c.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: c.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
function ap(e) {
  return typeof e == "string";
}
function MRe(e) {
  const t = Vi(e);
  return t.body === e ? jl(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function UE(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function t7(e) {
  return parseInt(jl(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function jRe(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function n7(e, t, n, r, i) {
  const o = [t, n, ...r];
  [].forEach.call(e.children, (s) => {
    const u = !o.includes(s), f = !jRe(s);
    u && f && UE(s, i);
  });
}
function sz(e, t) {
  let n = -1;
  return e.some((r, i) => t(r) ? (n = i, !0) : !1), n;
}
function LRe(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (MRe(r)) {
      const s = Wne(jl(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${t7(r) + s}px`;
      const u = Vi(r).querySelectorAll(".mui-fixed");
      [].forEach.call(u, (f) => {
        n.push({
          value: f.style.paddingRight,
          property: "padding-right",
          el: f
        }), f.style.paddingRight = `${t7(f) + s}px`;
      });
    }
    let o;
    if (r.parentNode instanceof DocumentFragment)
      o = Vi(r).body;
    else {
      const s = r.parentElement, u = jl(r);
      o = (s == null ? void 0 : s.nodeName) === "HTML" && u.getComputedStyle(s).overflowY === "scroll" ? s : r;
    }
    n.push({
      value: o.style.overflow,
      property: "overflow",
      el: o
    }, {
      value: o.style.overflowX,
      property: "overflow-x",
      el: o
    }, {
      value: o.style.overflowY,
      property: "overflow-y",
      el: o
    }), o.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: o,
      el: s,
      property: u
    }) => {
      o ? s.style.setProperty(u, o) : s.style.removeProperty(u);
    });
  };
}
function kRe(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class zRe {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && UE(t.modalRef, !1);
    const i = kRe(n);
    n7(n, t.mount, t.modalRef, i, !0);
    const o = sz(this.containers, (s) => s.container === n);
    return o !== -1 ? (this.containers[o].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: i
    }), r);
  }
  mount(t, n) {
    const r = sz(this.containers, (o) => o.modals.includes(t)), i = this.containers[r];
    i.restore || (i.restore = LRe(i, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const i = sz(this.containers, (s) => s.modals.includes(t)), o = this.containers[i];
    if (o.modals.splice(o.modals.indexOf(t), 1), this.modals.splice(r, 1), o.modals.length === 0)
      o.restore && o.restore(), t.modalRef && UE(t.modalRef, n), n7(o.container, t.mount, t.modalRef, o.hiddenSiblings, !1), this.containers.splice(i, 1);
    else {
      const s = o.modals[o.modals.length - 1];
      s.modalRef && UE(s.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
var TF = {};
const BRe = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function VRe(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function URe(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function FRe(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || URe(e));
}
function WRe(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(BRe)).forEach((r, i) => {
    const o = VRe(r);
    o === -1 || !FRe(r) || (o === 0 ? t.push(r) : n.push({
      documentOrder: i,
      tabIndex: o,
      node: r
    }));
  }), n.sort((r, i) => r.tabIndex === i.tabIndex ? r.documentOrder - i.documentOrder : r.tabIndex - i.tabIndex).map((r) => r.node).concat(t);
}
function HRe() {
  return !0;
}
function mA(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: i = !1,
    getTabbable: o = WRe,
    isEnabled: s = HRe,
    open: u
  } = e, f = $.useRef(!1), p = $.useRef(null), m = $.useRef(null), v = $.useRef(null), y = $.useRef(null), S = $.useRef(!1), E = $.useRef(null), w = kr(Sg(t), E), _ = $.useRef(null);
  $.useEffect(() => {
    !u || !E.current || (S.current = !n);
  }, [n, u]), $.useEffect(() => {
    if (!u || !E.current)
      return;
    const P = Vi(E.current);
    return E.current.contains(P.activeElement) || (E.current.hasAttribute("tabIndex") || (TF.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), E.current.setAttribute("tabIndex", "-1")), S.current && E.current.focus()), () => {
      i || (v.current && v.current.focus && (f.current = !0, v.current.focus()), v.current = null);
    };
  }, [u]), $.useEffect(() => {
    if (!u || !E.current)
      return;
    const P = Vi(E.current), M = (U) => {
      _.current = U, !(r || !s() || U.key !== "Tab") && P.activeElement === E.current && U.shiftKey && (f.current = !0, m.current && m.current.focus());
    }, N = () => {
      var Y, z;
      const U = E.current;
      if (U === null)
        return;
      if (!P.hasFocus() || !s() || f.current) {
        f.current = !1;
        return;
      }
      if (U.contains(P.activeElement) || r && P.activeElement !== p.current && P.activeElement !== m.current)
        return;
      if (P.activeElement !== y.current)
        y.current = null;
      else if (y.current !== null)
        return;
      if (!S.current)
        return;
      let H = [];
      if ((P.activeElement === p.current || P.activeElement === m.current) && (H = o(E.current)), H.length > 0) {
        const V = !!((Y = _.current) != null && Y.shiftKey && ((z = _.current) == null ? void 0 : z.key) === "Tab"), F = H[0], X = H[H.length - 1];
        typeof F != "string" && typeof X != "string" && (V ? X.focus() : F.focus());
      } else
        U.focus();
    };
    P.addEventListener("focusin", N), P.addEventListener("keydown", M, !0);
    const k = setInterval(() => {
      P.activeElement && P.activeElement.tagName === "BODY" && N();
    }, 50);
    return () => {
      clearInterval(k), P.removeEventListener("focusin", N), P.removeEventListener("keydown", M, !0);
    };
  }, [n, r, i, s, u, o]);
  const O = (P) => {
    v.current === null && (v.current = P.relatedTarget), S.current = !0, y.current = P.target;
    const M = t.props.onFocus;
    M && M(P);
  }, D = (P) => {
    v.current === null && (v.current = P.relatedTarget), S.current = !0;
  };
  return /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [/* @__PURE__ */ T.jsx("div", {
      tabIndex: u ? 0 : -1,
      onFocus: D,
      ref: p,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ $.cloneElement(t, {
      ref: w,
      onFocus: O
    }), /* @__PURE__ */ T.jsx("div", {
      tabIndex: u ? 0 : -1,
      onFocus: D,
      ref: m,
      "data-testid": "sentinelEnd"
    })]
  });
}
TF.NODE_ENV !== "production" && (mA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: xg,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: c.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: c.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: c.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: c.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: c.func,
  /**
   * If `true`, focus is locked.
   */
  open: c.bool.isRequired
});
TF.NODE_ENV !== "production" && (mA.propTypes = tF(mA.propTypes));
var qRe = {};
const $Re = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, vA = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = pa(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: o,
    appear: s = !0,
    children: u,
    easing: f,
    in: p,
    onEnter: m,
    onEntered: v,
    onEntering: y,
    onExit: S,
    onExited: E,
    onExiting: w,
    style: _,
    timeout: O = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: D = Vc,
    ...P
  } = t, M = $.useRef(null), N = kr(M, Sg(u), n), k = (oe) => (re) => {
    if (oe) {
      const Z = M.current;
      re === void 0 ? oe(Z) : oe(Z, re);
    }
  }, U = k(y), H = k((oe, re) => {
    uF(oe);
    const Z = cg({
      style: _,
      timeout: O,
      easing: f
    }, {
      mode: "enter"
    });
    oe.style.webkitTransition = r.transitions.create("opacity", Z), oe.style.transition = r.transitions.create("opacity", Z), m && m(oe, re);
  }), Y = k(v), z = k(w), V = k((oe) => {
    const re = cg({
      style: _,
      timeout: O,
      easing: f
    }, {
      mode: "exit"
    });
    oe.style.webkitTransition = r.transitions.create("opacity", re), oe.style.transition = r.transitions.create("opacity", re), S && S(oe);
  }), F = k(E), X = (oe) => {
    o && o(M.current, oe);
  };
  return /* @__PURE__ */ T.jsx(D, {
    appear: s,
    in: p,
    nodeRef: M,
    onEnter: H,
    onEntered: Y,
    onEntering: U,
    onExit: V,
    onExited: F,
    onExiting: z,
    addEndListener: X,
    timeout: O,
    ...P,
    children: (oe, {
      ownerState: re,
      ...Z
    }) => /* @__PURE__ */ $.cloneElement(u, {
      style: {
        opacity: 0,
        visibility: oe === "exited" && !p ? "hidden" : void 0,
        ...$Re[oe],
        ..._,
        ...u.props.style
      },
      ref: N,
      ...Z
    })
  });
});
qRe.NODE_ENV !== "production" && (vA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: xg.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
function GRe(e) {
  return Vt("MuiBackdrop", e);
}
Wt("MuiBackdrop", ["root", "invisible"]);
var YRe = {};
const XRe = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Ft({
    root: ["root", n && "invisible"]
  }, GRe, t);
}, ZRe = ye("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), cI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: i,
    className: o,
    component: s = "div",
    invisible: u = !1,
    open: f,
    components: p = {},
    componentsProps: m = {},
    slotProps: v = {},
    slots: y = {},
    TransitionComponent: S,
    transitionDuration: E,
    ...w
  } = r, _ = {
    ...r,
    component: s,
    invisible: u
  }, O = XRe(_), D = {
    transition: S,
    root: p.Root,
    ...y
  }, P = {
    ...m,
    ...v
  }, M = {
    slots: D,
    slotProps: P
  }, [N, k] = Xt("root", {
    elementType: ZRe,
    externalForwardedProps: M,
    className: yt(O.root, o),
    ownerState: _
  }), [U, H] = Xt("transition", {
    elementType: vA,
    externalForwardedProps: M,
    ownerState: _
  });
  return /* @__PURE__ */ T.jsx(U, {
    in: f,
    timeout: E,
    ...w,
    ...H,
    children: /* @__PURE__ */ T.jsx(N, {
      "aria-hidden": !0,
      ...k,
      classes: O,
      ref: n,
      children: i
    })
  });
});
YRe.NODE_ENV !== "production" && (cI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    root: c.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: c.bool,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: c.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
function KRe(e) {
  return typeof e == "function" ? e() : e;
}
function QRe(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const r7 = () => {
}, eO = new zRe();
function JRe(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: i = !1,
    onTransitionEnter: o,
    onTransitionExited: s,
    children: u,
    onClose: f,
    open: p,
    rootRef: m
  } = e, v = $.useRef({}), y = $.useRef(null), S = $.useRef(null), E = kr(S, m), [w, _] = $.useState(!p), O = QRe(u);
  let D = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (D = !1);
  const P = () => Vi(y.current), M = () => (v.current.modalRef = S.current, v.current.mount = y.current, v.current), N = () => {
    eO.mount(M(), {
      disableScrollLock: r
    }), S.current && (S.current.scrollTop = 0);
  }, k = Mr(() => {
    const re = KRe(t) || P().body;
    eO.add(M(), re), S.current && N();
  }), U = () => eO.isTopModal(M()), H = Mr((re) => {
    y.current = re, re && (p && U() ? N() : S.current && UE(S.current, D));
  }), Y = $.useCallback(() => {
    eO.remove(M(), D);
  }, [D]);
  $.useEffect(() => () => {
    Y();
  }, [Y]), $.useEffect(() => {
    p ? k() : (!O || !i) && Y();
  }, [p, Y, O, i, k]);
  const z = (re) => (Z) => {
    var ee;
    (ee = re.onKeyDown) == null || ee.call(re, Z), !(Z.key !== "Escape" || Z.which === 229 || // Wait until IME is settled.
    !U()) && (n || (Z.stopPropagation(), f && f(Z, "escapeKeyDown")));
  }, V = (re) => (Z) => {
    var ee;
    (ee = re.onClick) == null || ee.call(re, Z), Z.target === Z.currentTarget && f && f(Z, "backdropClick");
  };
  return {
    getRootProps: (re = {}) => {
      const Z = op(e);
      delete Z.onTransitionEnter, delete Z.onTransitionExited;
      const ee = {
        ...Z,
        ...re
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...ee,
        onKeyDown: z(ee),
        ref: E
      };
    },
    getBackdropProps: (re = {}) => {
      const Z = re;
      return {
        "aria-hidden": !0,
        ...Z,
        onClick: V(Z),
        open: p
      };
    },
    getTransitionProps: () => {
      const re = () => {
        _(!1), o && o();
      }, Z = () => {
        _(!0), s && s(), i && Y();
      };
      return {
        onEnter: FG(re, (u == null ? void 0 : u.props.onEnter) ?? r7),
        onExited: FG(Z, (u == null ? void 0 : u.props.onExited) ?? r7)
      };
    },
    rootRef: E,
    portalRef: H,
    isTopModal: U,
    exited: w,
    hasTransition: O
  };
}
function eOe(e) {
  return Vt("MuiModal", e);
}
Wt("MuiModal", ["root", "hidden", "backdrop"]);
var tOe = {};
const nOe = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Ft({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, eOe, r);
}, rOe = ye("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(Lt(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), iOe = ye(cI, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), uI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: i = iOe,
    BackdropProps: o,
    classes: s,
    className: u,
    closeAfterTransition: f = !1,
    children: p,
    container: m,
    component: v,
    components: y = {},
    componentsProps: S = {},
    disableAutoFocus: E = !1,
    disableEnforceFocus: w = !1,
    disableEscapeKeyDown: _ = !1,
    disablePortal: O = !1,
    disableRestoreFocus: D = !1,
    disableScrollLock: P = !1,
    hideBackdrop: M = !1,
    keepMounted: N = !1,
    onBackdropClick: k,
    onClose: U,
    onTransitionEnter: H,
    onTransitionExited: Y,
    open: z,
    slotProps: V = {},
    slots: F = {},
    // eslint-disable-next-line react/prop-types
    theme: X,
    ...oe
  } = r, re = {
    ...r,
    closeAfterTransition: f,
    disableAutoFocus: E,
    disableEnforceFocus: w,
    disableEscapeKeyDown: _,
    disablePortal: O,
    disableRestoreFocus: D,
    disableScrollLock: P,
    hideBackdrop: M,
    keepMounted: N
  }, {
    getRootProps: Z,
    getBackdropProps: ee,
    getTransitionProps: J,
    portalRef: le,
    isTopModal: be,
    exited: ne,
    hasTransition: ae
  } = JRe({
    ...re,
    rootRef: n
  }), ie = {
    ...re,
    exited: ne
  }, he = nOe(ie), pe = {};
  if (p.props.tabIndex === void 0 && (pe.tabIndex = "-1"), ae) {
    const {
      onEnter: Ye,
      onExited: Ue
    } = J();
    pe.onEnter = Ye, pe.onExited = Ue;
  }
  const me = {
    slots: {
      root: y.Root,
      backdrop: y.Backdrop,
      ...F
    },
    slotProps: {
      ...S,
      ...V
    }
  }, [Ee, Ie] = Xt("root", {
    ref: n,
    elementType: rOe,
    externalForwardedProps: {
      ...me,
      ...oe,
      component: v
    },
    getSlotProps: Z,
    ownerState: ie,
    className: yt(u, he == null ? void 0 : he.root, !ie.open && ie.exited && (he == null ? void 0 : he.hidden))
  }), [Pe, De] = Xt("backdrop", {
    ref: o == null ? void 0 : o.ref,
    elementType: i,
    externalForwardedProps: me,
    shouldForwardComponentProp: !0,
    additionalProps: o,
    getSlotProps: (Ye) => ee({
      ...Ye,
      onClick: (Ue) => {
        k && k(Ue), Ye != null && Ye.onClick && Ye.onClick(Ue);
      }
    }),
    className: yt(o == null ? void 0 : o.className, he == null ? void 0 : he.backdrop),
    ownerState: ie
  });
  return !N && !z && (!ae || ne) ? null : /* @__PURE__ */ T.jsx(c1, {
    ref: le,
    container: m,
    disablePortal: O,
    children: /* @__PURE__ */ T.jsxs(Ee, {
      ...Ie,
      children: [!M && i ? /* @__PURE__ */ T.jsx(Pe, {
        ...De
      }) : null, /* @__PURE__ */ T.jsx(mA, {
        disableEnforceFocus: w,
        disableAutoFocus: E,
        disableRestoreFocus: D,
        isEnabled: be,
        open: z,
        children: /* @__PURE__ */ $.cloneElement(p, pe)
      })]
    })
  });
});
tOe.NODE_ENV !== "production" && (uI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: c.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: c.object,
  /**
   * A single child content element.
   */
  children: xg.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: c.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Backdrop: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Fd, c.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: c.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: c.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: c.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: c.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: c.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: c.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: c.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function oOe(e) {
  return Vt("MuiPopover", e);
}
Wt("MuiPopover", ["root", "paper"]);
var G0 = {};
function i7(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function o7(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function a7(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function OE(e) {
  return typeof e == "function" ? e() : e;
}
const aOe = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"],
    paper: ["paper"]
  }, oOe, t);
}, sOe = ye(uI, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Zre = ye(Ei, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), EF = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiPopover"
  }), {
    action: i,
    anchorEl: o,
    anchorOrigin: s = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: u,
    anchorReference: f = "anchorEl",
    children: p,
    className: m,
    container: v,
    elevation: y = 8,
    marginThreshold: S = 16,
    open: E,
    PaperProps: w = {},
    // TODO: remove in v7
    slots: _ = {},
    slotProps: O = {},
    transformOrigin: D = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: P,
    // TODO: remove in v7
    transitionDuration: M = "auto",
    TransitionProps: N = {},
    // TODO: remove in v7
    disableScrollLock: k = !1,
    ...U
  } = r, H = $.useRef(), Y = {
    ...r,
    anchorOrigin: s,
    anchorReference: f,
    elevation: y,
    marginThreshold: S,
    transformOrigin: D,
    TransitionComponent: P,
    transitionDuration: M,
    TransitionProps: N
  }, z = aOe(Y), V = $.useCallback(() => {
    if (f === "anchorPosition")
      return G0.NODE_ENV !== "production" && (u || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), u;
    const De = OE(o), Ye = De && De.nodeType === 1 ? De : Vi(H.current).body, Ue = Ye.getBoundingClientRect();
    if (G0.NODE_ENV !== "production") {
      const ve = Ye.getBoundingClientRect();
      G0.NODE_ENV !== "test" && ve.top === 0 && ve.left === 0 && ve.right === 0 && ve.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Ue.top + i7(Ue, s.vertical),
      left: Ue.left + o7(Ue, s.horizontal)
    };
  }, [o, s.horizontal, s.vertical, u, f]), F = $.useCallback((De) => ({
    vertical: i7(De, D.vertical),
    horizontal: o7(De, D.horizontal)
  }), [D.horizontal, D.vertical]), X = $.useCallback((De) => {
    const Ye = {
      width: De.offsetWidth,
      height: De.offsetHeight
    }, Ue = F(Ye);
    if (f === "none")
      return {
        top: null,
        left: null,
        transformOrigin: a7(Ue)
      };
    const ve = V();
    let rt = ve.top - Ue.vertical, Te = ve.left - Ue.horizontal;
    const Je = rt + Ye.height, L = Te + Ye.width, te = jl(OE(o)), ge = te.innerHeight - S, ke = te.innerWidth - S;
    if (S !== null && rt < S) {
      const We = rt - S;
      rt -= We, Ue.vertical += We;
    } else if (S !== null && Je > ge) {
      const We = Je - ge;
      rt -= We, Ue.vertical += We;
    }
    if (G0.NODE_ENV !== "production" && Ye.height > ge && Ye.height && ge && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Ye.height - ge}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), S !== null && Te < S) {
      const We = Te - S;
      Te -= We, Ue.horizontal += We;
    } else if (L > ke) {
      const We = L - ke;
      Te -= We, Ue.horizontal += We;
    }
    return {
      top: `${Math.round(rt)}px`,
      left: `${Math.round(Te)}px`,
      transformOrigin: a7(Ue)
    };
  }, [o, f, V, F, S]), [oe, re] = $.useState(E), Z = $.useCallback(() => {
    const De = H.current;
    if (!De)
      return;
    const Ye = X(De);
    Ye.top !== null && De.style.setProperty("top", Ye.top), Ye.left !== null && (De.style.left = Ye.left), De.style.transformOrigin = Ye.transformOrigin, re(!0);
  }, [X]);
  $.useEffect(() => (k && window.addEventListener("scroll", Z), () => window.removeEventListener("scroll", Z)), [o, k, Z]);
  const ee = () => {
    Z();
  }, J = () => {
    re(!1);
  };
  $.useEffect(() => {
    E && Z();
  }), $.useImperativeHandle(i, () => E ? {
    updatePosition: () => {
      Z();
    }
  } : null, [E, Z]), $.useEffect(() => {
    if (!E)
      return;
    const De = u_(() => {
      Z();
    }), Ye = jl(OE(o));
    return Ye.addEventListener("resize", De), () => {
      De.clear(), Ye.removeEventListener("resize", De);
    };
  }, [o, E, Z]);
  let le = M;
  const be = {
    slots: {
      transition: P,
      ..._
    },
    slotProps: {
      transition: N,
      paper: w,
      ...O
    }
  }, [ne, ae] = Xt("transition", {
    elementType: lx,
    externalForwardedProps: be,
    ownerState: Y,
    getSlotProps: (De) => ({
      ...De,
      onEntering: (Ye, Ue) => {
        var ve;
        (ve = De.onEntering) == null || ve.call(De, Ye, Ue), ee();
      },
      onExited: (Ye) => {
        var Ue;
        (Ue = De.onExited) == null || Ue.call(De, Ye), J();
      }
    }),
    additionalProps: {
      appear: !0,
      in: E
    }
  });
  M === "auto" && !ne.muiSupportAuto && (le = void 0);
  const ie = v || (o ? Vi(OE(o)).body : void 0), [he, {
    slots: pe,
    slotProps: me,
    ...Ee
  }] = Xt("root", {
    ref: n,
    elementType: sOe,
    externalForwardedProps: {
      ...be,
      ...U
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: _.backdrop
      },
      slotProps: {
        backdrop: sF(typeof O.backdrop == "function" ? O.backdrop(Y) : O.backdrop, {
          invisible: !0
        })
      },
      container: ie,
      open: E
    },
    ownerState: Y,
    className: yt(z.root, m)
  }), [Ie, Pe] = Xt("paper", {
    ref: H,
    className: z.paper,
    elementType: Zre,
    externalForwardedProps: be,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: y,
      style: oe ? void 0 : {
        opacity: 0
      }
    },
    ownerState: Y
  });
  return /* @__PURE__ */ T.jsx(he, {
    ...Ee,
    ...!ap(he) && {
      slots: pe,
      slotProps: me,
      disableScrollLock: k
    },
    children: /* @__PURE__ */ T.jsx(ne, {
      ...ae,
      timeout: le,
      children: /* @__PURE__ */ T.jsx(Ie, {
        ...Pe,
        children: p
      })
    })
  });
});
G0.NODE_ENV !== "production" && (EF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: $s,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Wa(c.oneOfType([Fd, c.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = OE(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (G0.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: c.shape({
    horizontal: c.oneOfType([c.oneOf(["center", "left", "right"]), c.number]).isRequired,
    vertical: c.oneOfType([c.oneOf(["bottom", "center", "top"]), c.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: c.shape({
    left: c.number.isRequired,
    top: c.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: c.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: c.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: c.object,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([Fd, c.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: c.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: jD,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: c.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: c.shape({
    component: Qv
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    paper: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: c.shape({
    horizontal: c.oneOfType([c.oneOf(["center", "left", "right"]), c.number]).isRequired,
    vertical: c.oneOfType([c.oneOf(["bottom", "center", "top"]), c.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: c.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object
});
function lOe(e) {
  return Vt("MuiMenu", e);
}
Wt("MuiMenu", ["root", "paper", "list"]);
var Kre = {};
const cOe = {
  vertical: "top",
  horizontal: "right"
}, uOe = {
  vertical: "top",
  horizontal: "left"
}, dOe = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, lOe, t);
}, fOe = ye(EF, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), pOe = ye(Zre, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), hOe = ye(ty, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Bx = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: i = !0,
    children: o,
    className: s,
    disableAutoFocusItem: u = !1,
    MenuListProps: f = {},
    onClose: p,
    open: m,
    PaperProps: v = {},
    PopoverClasses: y,
    transitionDuration: S = "auto",
    TransitionProps: {
      onEntering: E,
      ...w
    } = {},
    variant: _ = "selectedMenu",
    slots: O = {},
    slotProps: D = {},
    ...P
  } = r, M = wg(), N = {
    ...r,
    autoFocus: i,
    disableAutoFocusItem: u,
    MenuListProps: f,
    onEntering: E,
    PaperProps: v,
    transitionDuration: S,
    TransitionProps: w,
    variant: _
  }, k = dOe(N), U = i && !u && m, H = $.useRef(null), Y = (le, be) => {
    H.current && H.current.adjustStyleForScrollbar(le, {
      direction: M ? "rtl" : "ltr"
    }), E && E(le, be);
  }, z = (le) => {
    le.key === "Tab" && (le.preventDefault(), p && p(le, "tabKeyDown"));
  };
  let V = -1;
  $.Children.map(o, (le, be) => {
    /* @__PURE__ */ $.isValidElement(le) && (Kre.NODE_ENV !== "production" && g_.isFragment(le) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), le.props.disabled || (_ === "selectedMenu" && le.props.selected || V === -1) && (V = be));
  });
  const F = {
    slots: O,
    slotProps: {
      list: f,
      transition: w,
      paper: v,
      ...D
    }
  }, X = Oo({
    elementType: O.root,
    externalSlotProps: D.root,
    ownerState: N,
    className: [k.root, s]
  }), [oe, re] = Xt("paper", {
    className: k.paper,
    elementType: pOe,
    externalForwardedProps: F,
    shouldForwardComponentProp: !0,
    ownerState: N
  }), [Z, ee] = Xt("list", {
    className: yt(k.list, f.className),
    elementType: hOe,
    shouldForwardComponentProp: !0,
    externalForwardedProps: F,
    getSlotProps: (le) => ({
      ...le,
      onKeyDown: (be) => {
        var ne;
        z(be), (ne = le.onKeyDown) == null || ne.call(le, be);
      }
    }),
    ownerState: N
  }), J = typeof F.slotProps.transition == "function" ? F.slotProps.transition(N) : F.slotProps.transition;
  return /* @__PURE__ */ T.jsx(fOe, {
    onClose: p,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: M ? "right" : "left"
    },
    transformOrigin: M ? cOe : uOe,
    slots: {
      root: O.root,
      paper: oe,
      backdrop: O.backdrop,
      ...O.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: O.transition
      }
    },
    slotProps: {
      root: X,
      paper: re,
      backdrop: typeof D.backdrop == "function" ? D.backdrop(N) : D.backdrop,
      transition: {
        ...J,
        onEntering: (...le) => {
          var be;
          Y(...le), (be = J == null ? void 0 : J.onEntering) == null || be.call(J, ...le);
        }
      }
    },
    open: m,
    ref: n,
    transitionDuration: S,
    ownerState: N,
    ...P,
    classes: y,
    children: /* @__PURE__ */ T.jsx(Z, {
      actions: H,
      autoFocus: i && (V === -1 || u),
      autoFocusItem: U,
      variant: _,
      ...ee,
      children: o
    })
  });
});
Kre.NODE_ENV !== "production" && (Bx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: c.oneOfType([Fd, c.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: c.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: c.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: c.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: c.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: c.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    list: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    list: c.elementType,
    paper: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: c.oneOf(["menu", "selectedMenu"])
});
function gOe(e) {
  return Vt("MuiNativeSelect", e);
}
const _F = Wt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var mOe = {};
const vOe = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: o,
    error: s
  } = e, u = {
    select: ["select", n, r && "disabled", i && "multiple", s && "error"],
    icon: ["icon", `icon${Ke(n)}`, o && "iconOpen", r && "disabled"]
  };
  return Ft(u, gOe, t);
}, Qre = ye("select", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${_F.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), yOe = ye(Qre, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: ha,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${_F.multiple}`]: t.multiple
    }];
  }
})({}), Jre = ye("svg", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${_F.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), bOe = ye(Jre, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Ke(n.variant)}`], n.open && t.iconOpen];
  }
})({}), eie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: i,
    error: o,
    IconComponent: s,
    inputRef: u,
    variant: f = "standard",
    ...p
  } = t, m = {
    ...t,
    disabled: i,
    variant: f,
    error: o
  }, v = vOe(m);
  return /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [/* @__PURE__ */ T.jsx(yOe, {
      ownerState: m,
      className: yt(v.select, r),
      disabled: i,
      ref: u || n,
      ...p
    }), t.multiple ? null : /* @__PURE__ */ T.jsx(bOe, {
      as: s,
      ownerState: m,
      className: v.icon
    })]
  });
});
mOe.NODE_ENV !== "production" && (eie.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The CSS class name of the select element.
   */
  className: c.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: c.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: c.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: $s,
  /**
   * @ignore
   */
  multiple: c.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: c.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The input value.
   */
  value: c.any,
  /**
   * The variant to use.
   */
  variant: c.oneOf(["standard", "outlined", "filled"])
});
function tie(e) {
  return Vt("MuiSelect", e);
}
const cE = Wt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var LO = {}, s7;
const xOe = ye(Qre, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${cE.select}`]: t.select
      },
      {
        [`&.${cE.select}`]: t[n.variant]
      },
      {
        [`&.${cE.error}`]: t.error
      },
      {
        [`&.${cE.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${cE.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SOe = ye(Jre, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Ke(n.variant)}`], n.open && t.iconOpen];
  }
})({}), wOe = ye("input", {
  shouldForwardProp: (e) => QD(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function l7(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function TOe(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const EOe = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: o,
    error: s
  } = e, u = {
    select: ["select", n, r && "disabled", i && "multiple", s && "error"],
    icon: ["icon", `icon${Ke(n)}`, o && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Ft(u, tie, t);
}, nie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  var gt;
  const {
    "aria-describedby": r,
    "aria-label": i,
    autoFocus: o,
    autoWidth: s,
    children: u,
    className: f,
    defaultOpen: p,
    defaultValue: m,
    disabled: v,
    displayEmpty: y,
    error: S = !1,
    IconComponent: E,
    inputRef: w,
    labelId: _,
    MenuProps: O = {},
    multiple: D,
    name: P,
    onBlur: M,
    onChange: N,
    onClose: k,
    onFocus: U,
    onOpen: H,
    open: Y,
    readOnly: z,
    renderValue: V,
    required: F,
    SelectDisplayProps: X = {},
    tabIndex: oe,
    // catching `type` from Input which makes no sense for SelectInput
    type: re,
    value: Z,
    variant: ee = "standard",
    ...J
  } = t, [le, be] = ip({
    controlled: Z,
    default: m,
    name: "Select"
  }), [ne, ae] = ip({
    controlled: Y,
    default: p,
    name: "Select"
  }), ie = $.useRef(null), he = $.useRef(null), [pe, me] = $.useState(null), {
    current: Ee
  } = $.useRef(Y != null), [Ie, Pe] = $.useState(), De = kr(n, w), Ye = $.useCallback((ct) => {
    he.current = ct, ct && me(ct);
  }, []), Ue = pe == null ? void 0 : pe.parentNode;
  $.useImperativeHandle(De, () => ({
    focus: () => {
      he.current.focus();
    },
    node: ie.current,
    value: le
  }), [le]), $.useEffect(() => {
    p && ne && pe && !Ee && (Pe(s ? null : Ue.clientWidth), he.current.focus());
  }, [pe, s]), $.useEffect(() => {
    o && he.current.focus();
  }, [o]), $.useEffect(() => {
    if (!_)
      return;
    const ct = Vi(he.current).getElementById(_);
    if (ct) {
      const ht = () => {
        getSelection().isCollapsed && he.current.focus();
      };
      return ct.addEventListener("click", ht), () => {
        ct.removeEventListener("click", ht);
      };
    }
  }, [_]);
  const ve = (ct, ht) => {
    ct ? H && H(ht) : k && k(ht), Ee || (Pe(s ? null : Ue.clientWidth), ae(ct));
  }, rt = (ct) => {
    ct.button === 0 && (ct.preventDefault(), he.current.focus(), ve(!0, ct));
  }, Te = (ct) => {
    ve(!1, ct);
  }, Je = $.Children.toArray(u), L = (ct) => {
    const ht = Je.find((Yt) => Yt.props.value === ct.target.value);
    ht !== void 0 && (be(ht.props.value), N && N(ct, ht));
  }, te = (ct) => (ht) => {
    let Yt;
    if (ht.currentTarget.hasAttribute("tabindex")) {
      if (D) {
        Yt = Array.isArray(le) ? le.slice() : [];
        const Rt = le.indexOf(ct.props.value);
        Rt === -1 ? Yt.push(ct.props.value) : Yt.splice(Rt, 1);
      } else
        Yt = ct.props.value;
      if (ct.props.onClick && ct.props.onClick(ht), le !== Yt && (be(Yt), N)) {
        const Rt = ht.nativeEvent || ht, cn = new Rt.constructor(Rt.type, Rt);
        Object.defineProperty(cn, "target", {
          writable: !0,
          value: {
            value: Yt,
            name: P
          }
        }), N(cn, ct);
      }
      D || ve(!1, ht);
    }
  }, ge = (ct) => {
    z || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(ct.key) && (ct.preventDefault(), ve(!0, ct));
  }, ke = pe !== null && ne, We = (ct) => {
    !ke && M && (Object.defineProperty(ct, "target", {
      writable: !0,
      value: {
        value: le,
        name: P
      }
    }), M(ct));
  };
  delete J["aria-invalid"];
  let Be, je;
  const mt = [];
  let qe = !1, at = !1;
  (gA({
    value: le
  }) || y) && (V ? Be = V(le) : qe = !0);
  const et = Je.map((ct) => {
    if (!/* @__PURE__ */ $.isValidElement(ct))
      return null;
    LO.NODE_ENV !== "production" && g_.isFragment(ct) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let ht;
    if (D) {
      if (!Array.isArray(le))
        throw new Error(LO.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : Ud(2));
      ht = le.some((Yt) => l7(Yt, ct.props.value)), ht && qe && mt.push(ct.props.children);
    } else
      ht = l7(le, ct.props.value), ht && qe && (je = ct.props.children);
    return ht && (at = !0), /* @__PURE__ */ $.cloneElement(ct, {
      "aria-selected": ht ? "true" : "false",
      onClick: te(ct),
      onKeyUp: (Yt) => {
        Yt.key === " " && Yt.preventDefault(), ct.props.onKeyUp && ct.props.onKeyUp(Yt);
      },
      role: "option",
      selected: ht,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": ct.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  LO.NODE_ENV !== "production" && $.useEffect(() => {
    if (!at && !D && le !== "") {
      const ct = Je.map((ht) => ht.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${le}\` for the select ${P ? `(name="${P}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${ct.filter((ht) => ht != null).map((ht) => `\`${ht}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [at, Je, D, P, le]), qe && (D ? mt.length === 0 ? Be = null : Be = mt.reduce((ct, ht, Yt) => (ct.push(ht), Yt < mt.length - 1 && ct.push(", "), ct), []) : Be = je);
  let bt = Ie;
  !s && Ee && pe && (bt = Ue.clientWidth);
  let q;
  typeof oe < "u" ? q = oe : q = v ? null : 0;
  const W = X.id || (P ? `mui-component-select-${P}` : void 0), Q = {
    ...t,
    variant: ee,
    value: le,
    open: ke,
    error: S
  }, ce = EOe(Q), _e = {
    ...O.PaperProps,
    ...(gt = O.slotProps) == null ? void 0 : gt.paper
  }, Fe = Jv();
  return /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [/* @__PURE__ */ T.jsx(xOe, {
      as: "div",
      ref: Ye,
      tabIndex: q,
      role: "combobox",
      "aria-controls": ke ? Fe : void 0,
      "aria-disabled": v ? "true" : void 0,
      "aria-expanded": ke ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": i,
      "aria-labelledby": [_, W].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": F ? "true" : void 0,
      "aria-invalid": S ? "true" : void 0,
      onKeyDown: ge,
      onMouseDown: v || z ? null : rt,
      onBlur: We,
      onFocus: U,
      ...X,
      ownerState: Q,
      className: yt(X.className, ce.select, f),
      id: W,
      children: TOe(Be) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        s7 || (s7 = /* @__PURE__ */ T.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : Be
    }), /* @__PURE__ */ T.jsx(wOe, {
      "aria-invalid": S,
      value: Array.isArray(le) ? le.join(",") : le,
      name: P,
      ref: ie,
      "aria-hidden": !0,
      onChange: L,
      tabIndex: -1,
      disabled: v,
      className: ce.nativeInput,
      autoFocus: o,
      required: F,
      ...J,
      ownerState: Q
    }), /* @__PURE__ */ T.jsx(SOe, {
      as: E,
      className: ce.icon,
      ownerState: Q
    }), /* @__PURE__ */ T.jsx(Bx, {
      id: `menu-${P || ""}`,
      anchorEl: Ue,
      open: ke,
      onClose: Te,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...O,
      slotProps: {
        ...O.slotProps,
        list: {
          "aria-labelledby": _,
          role: "listbox",
          "aria-multiselectable": D ? "true" : void 0,
          disableListWrap: !0,
          id: Fe,
          ...O.MenuListProps
        },
        paper: {
          ..._e,
          style: {
            minWidth: bt,
            ..._e != null ? _e.style : null
          }
        }
      },
      children: et
    })]
  });
});
LO.NODE_ENV !== "production" && (nie.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": c.string,
  /**
   * @ignore
   */
  "aria-label": c.string,
  /**
   * @ignore
   */
  autoFocus: c.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: c.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The CSS class name of the select element.
   */
  className: c.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: c.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: c.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: c.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: c.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: $s,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: c.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: c.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: c.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * @ignore
   */
  readOnly: c.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * If `true`, the component is required.
   */
  required: c.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: c.object,
  /**
   * @ignore
   */
  tabIndex: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  type: c.any,
  /**
   * The input value.
   */
  value: c.any,
  /**
   * The variant to use.
   */
  variant: c.oneOf(["standard", "outlined", "filled"])
});
const rie = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
var _Oe = {};
function tO(e) {
  return parseInt(e, 10) || 0;
}
const COe = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function ROe(e) {
  for (const t in e)
    return !1;
  return !0;
}
function c7(e) {
  return ROe(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const iie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: i,
    minRows: o = 1,
    style: s,
    value: u,
    ...f
  } = t, {
    current: p
  } = $.useRef(u != null), m = $.useRef(null), v = kr(n, m), y = $.useRef(null), S = $.useRef(null), E = $.useCallback(() => {
    const P = m.current, M = S.current;
    if (!P || !M)
      return;
    const k = jl(P).getComputedStyle(P);
    if (k.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    M.style.width = k.width, M.value = P.value || t.placeholder || "x", M.value.slice(-1) === `
` && (M.value += " ");
    const U = k.boxSizing, H = tO(k.paddingBottom) + tO(k.paddingTop), Y = tO(k.borderBottomWidth) + tO(k.borderTopWidth), z = M.scrollHeight;
    M.value = "x";
    const V = M.scrollHeight;
    let F = z;
    o && (F = Math.max(Number(o) * V, F)), i && (F = Math.min(Number(i) * V, F)), F = Math.max(F, V);
    const X = F + (U === "border-box" ? H + Y : 0), oe = Math.abs(F - z) <= 1;
    return {
      outerHeightStyle: X,
      overflowing: oe
    };
  }, [i, o, t.placeholder]), w = Mr(() => {
    const P = m.current, M = E();
    if (!P || !M || c7(M))
      return !1;
    const N = M.outerHeightStyle;
    return y.current != null && y.current !== N;
  }), _ = $.useCallback(() => {
    const P = m.current, M = E();
    if (!P || !M || c7(M))
      return;
    const N = M.outerHeightStyle;
    y.current !== N && (y.current = N, P.style.height = `${N}px`), P.style.overflow = M.overflowing ? "hidden" : "";
  }, [E]), O = $.useRef(-1);
  gs(() => {
    const P = u_(_), M = m == null ? void 0 : m.current;
    if (!M)
      return;
    const N = jl(M);
    N.addEventListener("resize", P);
    let k;
    return typeof ResizeObserver < "u" && (k = new ResizeObserver(() => {
      w() && (k.unobserve(M), cancelAnimationFrame(O.current), _(), O.current = requestAnimationFrame(() => {
        k.observe(M);
      }));
    }), k.observe(M)), () => {
      P.clear(), cancelAnimationFrame(O.current), N.removeEventListener("resize", P), k && k.disconnect();
    };
  }, [E, _, w]), gs(() => {
    _();
  });
  const D = (P) => {
    p || _(), r && r(P);
  };
  return /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [/* @__PURE__ */ T.jsx("textarea", {
      value: u,
      onChange: D,
      ref: v,
      rows: o,
      style: s,
      ...f
    }), /* @__PURE__ */ T.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: S,
      tabIndex: -1,
      style: {
        ...COe.shadow,
        ...s,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
_Oe.NODE_ENV !== "production" && (iie.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: c.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  onChange: c.func,
  /**
   * @ignore
   */
  placeholder: c.string,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * @ignore
   */
  value: c.oneOfType([c.arrayOf(c.string), c.number, c.string])
});
function OOe(e) {
  return Vt("MuiInputBase", e);
}
const Rl = Wt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var AE = {}, u7;
const dI = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${Ke(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, fI = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, AOe = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: i,
    endAdornment: o,
    focused: s,
    formControl: u,
    fullWidth: f,
    hiddenLabel: p,
    multiline: m,
    readOnly: v,
    size: y,
    startAdornment: S,
    type: E
  } = e, w = {
    root: ["root", `color${Ke(n)}`, r && "disabled", i && "error", f && "fullWidth", s && "focused", u && "formControl", y && y !== "medium" && `size${Ke(y)}`, m && "multiline", S && "adornedStart", o && "adornedEnd", p && "hiddenLabel", v && "readOnly"],
    input: ["input", r && "disabled", E === "search" && "inputTypeSearch", m && "inputMultiline", y === "small" && "inputSizeSmall", p && "inputHiddenLabel", S && "inputAdornedStart", o && "inputAdornedEnd", v && "readOnly"]
  };
  return Ft(w, OOe, t);
}, pI = ye("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: dI
})(Lt(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Rl.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), hI = ye("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: fI
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, r = {
    opacity: "0 !important"
  }, i = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Rl.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${Rl.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: o
      }) => !o.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: o
      }) => o.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), d7 = mwe({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), gI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": i,
    autoComplete: o,
    autoFocus: s,
    className: u,
    color: f,
    components: p = {},
    componentsProps: m = {},
    defaultValue: v,
    disabled: y,
    disableInjectingGlobalStyles: S,
    endAdornment: E,
    error: w,
    fullWidth: _ = !1,
    id: O,
    inputComponent: D = "input",
    inputProps: P = {},
    inputRef: M,
    margin: N,
    maxRows: k,
    minRows: U,
    multiline: H = !1,
    name: Y,
    onBlur: z,
    onChange: V,
    onClick: F,
    onFocus: X,
    onKeyDown: oe,
    onKeyUp: re,
    placeholder: Z,
    readOnly: ee,
    renderSuffix: J,
    rows: le,
    size: be,
    slotProps: ne = {},
    slots: ae = {},
    startAdornment: ie,
    type: he = "text",
    value: pe,
    ...me
  } = r, Ee = P.value != null ? P.value : pe, {
    current: Ie
  } = $.useRef(Ee != null), Pe = $.useRef(), De = $.useCallback((Q) => {
    AE.NODE_ENV !== "production" && Q && Q.nodeName !== "INPUT" && !Q.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Ye = kr(Pe, M, P.ref, De), [Ue, ve] = $.useState(!1), rt = pp();
  AE.NODE_ENV !== "production" && $.useEffect(() => {
    if (rt)
      return rt.registerEffect();
  }, [rt]);
  const Te = oy({
    props: r,
    muiFormControl: rt,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Te.focused = rt ? rt.focused : Ue, $.useEffect(() => {
    !rt && y && Ue && (ve(!1), z && z());
  }, [rt, y, Ue, z]);
  const Je = rt && rt.onFilled, L = rt && rt.onEmpty, te = $.useCallback((Q) => {
    gA(Q) ? Je && Je() : L && L();
  }, [Je, L]);
  gs(() => {
    Ie && te({
      value: Ee
    });
  }, [Ee, te, Ie]);
  const ge = (Q) => {
    X && X(Q), P.onFocus && P.onFocus(Q), rt && rt.onFocus ? rt.onFocus(Q) : ve(!0);
  }, ke = (Q) => {
    z && z(Q), P.onBlur && P.onBlur(Q), rt && rt.onBlur ? rt.onBlur(Q) : ve(!1);
  }, We = (Q, ...ce) => {
    if (!Ie) {
      const _e = Q.target || Pe.current;
      if (_e == null)
        throw new Error(AE.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Ud(1));
      te({
        value: _e.value
      });
    }
    P.onChange && P.onChange(Q, ...ce), V && V(Q, ...ce);
  };
  $.useEffect(() => {
    te(Pe.current);
  }, []);
  const Be = (Q) => {
    Pe.current && Q.currentTarget === Q.target && Pe.current.focus(), F && F(Q);
  };
  let je = D, mt = P;
  H && je === "input" && (le ? (AE.NODE_ENV !== "production" && (U || k) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), mt = {
    type: void 0,
    minRows: le,
    maxRows: le,
    ...mt
  }) : mt = {
    type: void 0,
    maxRows: k,
    minRows: U,
    ...mt
  }, je = iie);
  const qe = (Q) => {
    te(Q.animationName === "mui-auto-fill-cancel" ? Pe.current : {
      value: "x"
    });
  };
  $.useEffect(() => {
    rt && rt.setAdornedStart(!!ie);
  }, [rt, ie]);
  const at = {
    ...r,
    color: Te.color || "primary",
    disabled: Te.disabled,
    endAdornment: E,
    error: Te.error,
    focused: Te.focused,
    formControl: rt,
    fullWidth: _,
    hiddenLabel: Te.hiddenLabel,
    multiline: H,
    size: Te.size,
    startAdornment: ie,
    type: he
  }, et = AOe(at), bt = ae.root || p.Root || pI, q = ne.root || m.root || {}, W = ae.input || p.Input || hI;
  return mt = {
    ...mt,
    ...ne.input ?? m.input
  }, /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [!S && typeof d7 == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (u7 || (u7 = /* @__PURE__ */ T.jsx(d7, {}))), /* @__PURE__ */ T.jsxs(bt, {
      ...q,
      ref: n,
      onClick: Be,
      ...me,
      ...!ap(bt) && {
        ownerState: {
          ...at,
          ...q.ownerState
        }
      },
      className: yt(et.root, q.className, u, ee && "MuiInputBase-readOnly"),
      children: [ie, /* @__PURE__ */ T.jsx(y_.Provider, {
        value: null,
        children: /* @__PURE__ */ T.jsx(W, {
          "aria-invalid": Te.error,
          "aria-describedby": i,
          autoComplete: o,
          autoFocus: s,
          defaultValue: v,
          disabled: Te.disabled,
          id: O,
          onAnimationStart: qe,
          name: Y,
          placeholder: Z,
          readOnly: ee,
          required: Te.required,
          rows: le,
          value: Ee,
          onKeyDown: oe,
          onKeyUp: re,
          type: he,
          ...mt,
          ...!ap(W) && {
            as: je,
            ownerState: {
              ...at,
              ...mt.ownerState
            }
          },
          ref: Ye,
          className: yt(et.input, mt.className, ee && "MuiInputBase-readOnly"),
          onBlur: ke,
          onChange: We,
          onFocus: ge
        })
      }), E, J ? J({
        ...Te,
        startAdornment: ie
      }) : null]
    })]
  });
});
AE.NODE_ENV !== "production" && (gI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": c.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Qv,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: c.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * @ignore
   */
  renderSuffix: c.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The size of the component.
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
function DOe(e) {
  return Vt("MuiInput", e);
}
const Xh = {
  ...Rl,
  ...Wt("MuiInput", ["root", "underline", "input"])
};
var IOe = {};
const POe = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = Ft({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, DOe, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...i
  };
}, NOe = ye(pI, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...dI(e, t), !n.disableUnderline && t.underline];
  }
})(Lt(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Xh.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Xh.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Xh.disabled}, .${Xh.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Xh.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Jr()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), MOe = ye(hI, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: fI
})({}), x_ = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: i = !1,
    components: o = {},
    componentsProps: s,
    fullWidth: u = !1,
    inputComponent: f = "input",
    multiline: p = !1,
    slotProps: m,
    slots: v = {},
    type: y = "text",
    ...S
  } = r, E = POe(r), _ = {
    root: {
      ownerState: {
        disableUnderline: i
      }
    }
  }, O = m ?? s ? Ua(m ?? s, _) : _, D = v.root ?? o.Root ?? NOe, P = v.input ?? o.Input ?? MOe;
  return /* @__PURE__ */ T.jsx(gI, {
    slots: {
      root: D,
      input: P
    },
    slotProps: O,
    fullWidth: u,
    inputComponent: f,
    multiline: p,
    ref: n,
    type: y,
    ...S,
    classes: E
  });
});
IOe.NODE_ENV !== "production" && (x_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
x_.muiName = "Input";
function jOe(e) {
  return Vt("MuiFilledInput", e);
}
const Ol = {
  ...Rl,
  ...Wt("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
};
var LOe = {};
const kOe = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: i,
    size: o,
    hiddenLabel: s,
    multiline: u
  } = e, f = {
    root: ["root", !n && "underline", r && "adornedStart", i && "adornedEnd", o === "small" && `size${Ke(o)}`, s && "hiddenLabel", u && "multiline"],
    input: ["input"]
  }, p = Ft(f, jOe, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...p
  };
}, zOe = ye(pI, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...dI(e, t), !n.disableUnderline && t.underline];
  }
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", i = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", o = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : i,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${Ol.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${Ol.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : o
    },
    variants: [{
      props: ({
        ownerState: s
      }) => !s.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Ol.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Ol.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Ol.disabled}, .${Ol.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${Ol.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Jr()).map(([s]) => {
      var u;
      return {
        props: {
          disableUnderline: !1,
          color: s
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(u = (e.vars || e).palette[s]) == null ? void 0 : u.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: s
      }) => s.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: s
      }) => s.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: s,
        size: u
      }) => s.multiline && u === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline && s.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline && s.hiddenLabel && s.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), BOe = ye(hI, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: fI
})(Lt(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), mI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: i = !1,
    components: o = {},
    componentsProps: s,
    fullWidth: u = !1,
    hiddenLabel: f,
    // declare here to prevent spreading to DOM
    inputComponent: p = "input",
    multiline: m = !1,
    slotProps: v,
    slots: y = {},
    type: S = "text",
    ...E
  } = r, w = {
    ...r,
    disableUnderline: i,
    fullWidth: u,
    inputComponent: p,
    multiline: m,
    type: S
  }, _ = kOe(r), O = {
    root: {
      ownerState: w
    },
    input: {
      ownerState: w
    }
  }, D = v ?? s ? Ua(O, v ?? s) : O, P = y.root ?? o.Root ?? zOe, M = y.input ?? o.Input ?? BOe;
  return /* @__PURE__ */ T.jsx(gI, {
    slots: {
      root: P,
      input: M
    },
    slotProps: D,
    fullWidth: u,
    inputComponent: p,
    multiline: m,
    ref: n,
    type: S,
    ...E,
    classes: _
  });
});
LOe.NODE_ENV !== "production" && (mI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
mI.muiName = "Input";
var VOe = {}, f7;
const UOe = ye("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: ha
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), FOe = ye("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: ha
})(Lt(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function oie(e) {
  const {
    children: t,
    classes: n,
    className: r,
    label: i,
    notched: o,
    ...s
  } = e, u = i != null && i !== "", f = {
    ...e,
    notched: o,
    withLabel: u
  };
  return /* @__PURE__ */ T.jsx(UOe, {
    "aria-hidden": !0,
    className: r,
    ownerState: f,
    ...s,
    children: /* @__PURE__ */ T.jsx(FOe, {
      ownerState: f,
      children: u ? /* @__PURE__ */ T.jsx("span", {
        children: i
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        f7 || (f7 = /* @__PURE__ */ T.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
VOe.NODE_ENV !== "production" && (oie.propTypes = {
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The label.
   */
  label: c.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: c.bool.isRequired,
  /**
   * @ignore
   */
  style: c.object
});
function WOe(e) {
  return Vt("MuiOutlinedInput", e);
}
const xc = {
  ...Rl,
  ...Wt("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
var HOe = {};
const qOe = (e) => {
  const {
    classes: t
  } = e, r = Ft({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, WOe, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, $Oe = ye(pI, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: dI
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${xc.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${xc.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${xc.focused} .${xc.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(Jr()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${xc.focused} .${xc.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${xc.error} .${xc.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${xc.disabled} .${xc.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), GOe = ye(oie, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), YOe = ye(hI, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: fI
})(Lt(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), vI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: i = {},
    fullWidth: o = !1,
    inputComponent: s = "input",
    label: u,
    multiline: f = !1,
    notched: p,
    slots: m = {},
    slotProps: v = {},
    type: y = "text",
    ...S
  } = r, E = qOe(r), w = pp(), _ = oy({
    props: r,
    muiFormControl: w,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), O = {
    ...r,
    color: _.color || "primary",
    disabled: _.disabled,
    error: _.error,
    focused: _.focused,
    formControl: w,
    fullWidth: o,
    hiddenLabel: _.hiddenLabel,
    multiline: f,
    size: _.size,
    type: y
  }, D = m.root ?? i.Root ?? $Oe, P = m.input ?? i.Input ?? YOe, [M, N] = Xt("notchedOutline", {
    elementType: GOe,
    className: E.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: O,
    externalForwardedProps: {
      slots: m,
      slotProps: v
    },
    additionalProps: {
      label: u != null && u !== "" && _.required ? /* @__PURE__ */ T.jsxs($.Fragment, {
        children: [u, " ", "*"]
      }) : u
    }
  });
  return /* @__PURE__ */ T.jsx(gI, {
    slots: {
      root: D,
      input: P
    },
    slotProps: v,
    renderSuffix: (k) => /* @__PURE__ */ T.jsx(M, {
      ...N,
      notched: typeof p < "u" ? p : !!(k.startAdornment || k.filled || k.focused)
    }),
    fullWidth: o,
    inputComponent: s,
    multiline: f,
    ref: n,
    type: y,
    ...S,
    classes: {
      ...E,
      notchedOutline: null
    }
  });
});
HOe.NODE_ENV !== "production" && (vI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: c.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: c.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    notchedOutline: c.oneOfType([c.func, c.object]),
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    notchedOutline: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
vI.muiName = "Input";
var XOe = {};
const ZOe = (e) => {
  const {
    classes: t
  } = e, r = Ft({
    root: ["root"]
  }, tie, t);
  return {
    ...t,
    ...r
  };
}, CF = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => ha(e) && e !== "variant",
  slot: "Root"
}, KOe = ye(x_, CF)(""), QOe = ye(vI, CF)(""), JOe = ye(mI, CF)(""), Vx = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: i = !1,
    children: o,
    classes: s = {},
    className: u,
    defaultOpen: f = !1,
    displayEmpty: p = !1,
    IconComponent: m = rie,
    id: v,
    input: y,
    inputProps: S,
    label: E,
    labelId: w,
    MenuProps: _,
    multiple: O = !1,
    native: D = !1,
    onClose: P,
    onOpen: M,
    open: N,
    renderValue: k,
    SelectDisplayProps: U,
    variant: H = "outlined",
    ...Y
  } = r, z = D ? eie : nie, V = pp(), F = oy({
    props: r,
    muiFormControl: V,
    states: ["variant", "error"]
  }), X = F.variant || H, oe = {
    ...r,
    variant: X,
    classes: s
  }, re = ZOe(oe), {
    root: Z,
    ...ee
  } = re, J = y || {
    standard: /* @__PURE__ */ T.jsx(KOe, {
      ownerState: oe
    }),
    outlined: /* @__PURE__ */ T.jsx(QOe, {
      label: E,
      ownerState: oe
    }),
    filled: /* @__PURE__ */ T.jsx(JOe, {
      ownerState: oe
    })
  }[X], le = kr(n, Sg(J));
  return /* @__PURE__ */ T.jsx($.Fragment, {
    children: /* @__PURE__ */ $.cloneElement(J, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: z,
      inputProps: {
        children: o,
        error: F.error,
        IconComponent: m,
        variant: X,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: O,
        ...D ? {
          id: v
        } : {
          autoWidth: i,
          defaultOpen: f,
          displayEmpty: p,
          labelId: w,
          MenuProps: _,
          onClose: P,
          onOpen: M,
          open: N,
          renderValue: k,
          SelectDisplayProps: {
            id: v,
            ...U
          }
        },
        ...S,
        classes: S ? Ua(ee, S.classes) : ee,
        ...y ? y.props.inputProps : {}
      },
      ...(O && D || p) && X === "outlined" ? {
        notched: !0
      } : {},
      ref: le,
      className: yt(J.props.className, u, re.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!y && {
        variant: X
      },
      ...Y
    })
  });
});
XOe.NODE_ENV !== "production" && (Vx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: c.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: c.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: c.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: c.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: c.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: c.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: c.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: c.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: c.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: c.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: c.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: c.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: c.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: c.oneOfType([c.oneOf([""]), c.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
Vx.muiName = "Select";
function aie({ availableLocales: e = [], locale: t = "", setLocale: n = void 0 }) {
  const r = Ba((u) => t3(u)), { t: i } = Ct();
  if (!n || e.length < 2) return null;
  const o = e.indexOf(t) >= 0 ? t : e[0], s = bRe(r, (u) => u.locale);
  return /* @__PURE__ */ T.jsxs(b_, { variant: "standard", children: [
    /* @__PURE__ */ T.jsx(wF, { children: i("language") }),
    /* @__PURE__ */ T.jsx(
      Vx,
      {
        MenuProps: {
          anchorOrigin: {
            horizontal: "left",
            vertical: "bottom"
          }
        },
        autoWidth: !0,
        displayEmpty: !0,
        value: o,
        onChange: (u) => {
          n(u.target.value);
        },
        name: "locale",
        children: e.map((u) => {
          var f;
          return /* @__PURE__ */ T.jsx(qo, { value: u, children: /* @__PURE__ */ T.jsx(St, { variant: "body2", children: ((f = s[u]) == null ? void 0 : f.label) || u }) }, u);
        })
      }
    )
  ] });
}
aie.propTypes = {
  availableLocales: c.arrayOf(c.string),
  locale: c.string,
  setLocale: c.func
};
function sie({
  manifestDescription: e = null,
  manifestLabel: t = null,
  manifestMetadata: n = [],
  manifestSummary: r = null,
  ...i
}) {
  const { t: o } = Ct(), s = uo(), u = {
    manifestDescription: e,
    manifestLabel: t,
    manifestMetadata: n,
    manifestSummary: r,
    ...i
  };
  return /* @__PURE__ */ T.jsxs(
    iy,
    {
      id: `${s}-resource`,
      label: o("resource"),
      children: [
        t && /* @__PURE__ */ T.jsx(
          St,
          {
            "aria-labelledby": `${s}-resource ${s}-resource-heading`,
            id: `${s}-resource-heading`,
            variant: "h4",
            component: "h5",
            children: t
          }
        ),
        e && /* @__PURE__ */ T.jsx(St, { variant: "body1", children: /* @__PURE__ */ T.jsx(Bs, { htmlString: e, ruleSet: "iiif" }) }),
        r && /* @__PURE__ */ T.jsx(St, { variant: "body1", children: /* @__PURE__ */ T.jsx(Bs, { htmlString: r, ruleSet: "iiif" }) }),
        n.length > 0 && /* @__PURE__ */ T.jsx(v_, { labelValuePairs: n }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "ManifestInfo", ...u })
      ]
    }
  );
}
sie.propTypes = {
  manifestDescription: c.string,
  manifestLabel: c.string,
  manifestMetadata: c.array,
  // eslint-disable-line react/forbid-prop-types
  manifestSummary: c.string
};
const eAe = (e, { companionWindowId: t, manifestId: n, windowId: r }) => ({
  manifestDescription: Zee(e, {
    companionWindowId: t,
    manifestId: n,
    windowId: r
  }),
  manifestLabel: Lu(e, { companionWindowId: t, manifestId: n, windowId: r }),
  manifestMetadata: Qee(e, { companionWindowId: t, manifestId: n, windowId: r }),
  manifestSummary: Kee(e, {
    companionWindowId: t,
    manifestId: n,
    windowId: r
  })
}), tAe = wt(
  At(eAe),
  Tt("ManifestInfo")
), lie = tAe(sie);
function nAe(e) {
  return Vt("MuiButton", e);
}
const lv = Wt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]);
var rAe = {};
const RF = /* @__PURE__ */ $.createContext({});
rAe.NODE_ENV !== "production" && (RF.displayName = "ButtonGroupContext");
var iAe = {};
const OF = /* @__PURE__ */ $.createContext(void 0);
iAe.NODE_ENV !== "production" && (OF.displayName = "ButtonGroupButtonContext");
var oAe = {};
const aAe = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: i,
    variant: o,
    loading: s,
    loadingPosition: u,
    classes: f
  } = e, p = {
    root: ["root", s && "loading", o, `${o}${Ke(t)}`, `size${Ke(i)}`, `${o}Size${Ke(i)}`, `color${Ke(t)}`, n && "disableElevation", r && "fullWidth", s && `loadingPosition${Ke(u)}`],
    startIcon: ["icon", "startIcon", `iconSize${Ke(i)}`],
    endIcon: ["icon", "endIcon", `iconSize${Ke(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, m = Ft(p, nAe, f);
  return {
    ...f,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...m
  };
}, cie = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], sAe = ye(Ws, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Ke(n.color)}`], t[`size${Ke(n.size)}`], t[`${n.variant}Size${Ke(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth, n.loading && t.loading];
  }
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${lv.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${lv.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${lv.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${lv.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Jr()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[r].main,
        "--variant-outlinedColor": (e.vars || e).palette[r].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.5)` : Cn(e.palette[r].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[r].contrastText,
        "--variant-containedBg": (e.vars || e).palette[r].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[r].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette[r].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[r].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette[r].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${lv.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${lv.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${lv.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), lAe = ye("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, n.loading && t.startIconLoadingStart, t[`iconSize${Ke(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...cie]
})), cAe = ye("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, n.loading && t.endIconLoadingEnd, t[`iconSize${Ke(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...cie]
})), uAe = ye("span", {
  name: "MuiButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), p7 = ye("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder",
  overridesResolver: (e, t) => t.loadingIconPlaceholder
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), hi = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = $.useContext(RF), i = $.useContext(OF), o = a1(r, t), s = Gt({
    props: o,
    name: "MuiButton"
  }), {
    children: u,
    color: f = "primary",
    component: p = "button",
    className: m,
    disabled: v = !1,
    disableElevation: y = !1,
    disableFocusRipple: S = !1,
    endIcon: E,
    focusVisibleClassName: w,
    fullWidth: _ = !1,
    id: O,
    loading: D = null,
    loadingIndicator: P,
    loadingPosition: M = "center",
    size: N = "medium",
    startIcon: k,
    type: U,
    variant: H = "text",
    ...Y
  } = s, z = Jv(O), V = P ?? /* @__PURE__ */ T.jsx(eI, {
    "aria-labelledby": z,
    color: "inherit",
    size: 16
  }), F = {
    ...s,
    color: f,
    component: p,
    disabled: v,
    disableElevation: y,
    disableFocusRipple: S,
    fullWidth: _,
    loading: D,
    loadingIndicator: V,
    loadingPosition: M,
    size: N,
    type: U,
    variant: H
  }, X = aAe(F), oe = (k || D && M === "start") && /* @__PURE__ */ T.jsx(lAe, {
    className: X.startIcon,
    ownerState: F,
    children: k || /* @__PURE__ */ T.jsx(p7, {
      className: X.loadingIconPlaceholder,
      ownerState: F
    })
  }), re = (E || D && M === "end") && /* @__PURE__ */ T.jsx(cAe, {
    className: X.endIcon,
    ownerState: F,
    children: E || /* @__PURE__ */ T.jsx(p7, {
      className: X.loadingIconPlaceholder,
      ownerState: F
    })
  }), Z = i || "", ee = typeof D == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ T.jsx("span", {
      className: X.loadingWrapper,
      style: {
        display: "contents"
      },
      children: D && /* @__PURE__ */ T.jsx(uAe, {
        className: X.loadingIndicator,
        ownerState: F,
        children: V
      })
    })
  ) : null;
  return /* @__PURE__ */ T.jsxs(sAe, {
    ownerState: F,
    className: yt(r.className, X.root, m, Z),
    component: p,
    disabled: v || D,
    focusRipple: !S,
    focusVisibleClassName: yt(X.focusVisible, w),
    ref: n,
    type: U,
    id: D ? z : O,
    ...Y,
    classes: X,
    children: [oe, M !== "end" && ee, u, M === "end" && ee, re]
  });
});
oAe.NODE_ENV !== "production" && (hi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * Element placed after the children.
   */
  endIcon: c.node,
  /**
   * @ignore
   */
  focusVisibleClassName: c.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: c.string,
  /**
   * @ignore
   */
  id: c.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: c.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: c.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: c.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * Element placed before the children.
   */
  startIcon: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @ignore
   */
  type: c.oneOfType([c.oneOf(["button", "reset", "submit"]), c.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: c.oneOfType([c.oneOf(["contained", "outlined", "text"]), c.string])
});
const AF = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M3 14h4v-4H3zm0 5h4v-4H3zM3 9h4V5H3zm5 5h13v-4H8zm0 5h13v-4H8zM8 5v4h13V5z"
}), "ViewListSharp");
function uie({
  collectionLabel: e = null,
  collectionPath: t = [],
  showCollectionDialog: n,
  windowId: r = null
}) {
  const { t: i } = Ct(), o = uo(), s = uo(), u = () => {
    const f = t[t.length - 1];
    n(f, t.slice(0, -1), r);
  };
  return t.length === 0 ? null : /* @__PURE__ */ T.jsxs(
    iy,
    {
      id: o,
      label: i("collection"),
      children: [
        e && /* @__PURE__ */ T.jsx(
          St,
          {
            "aria-labelledby": `${o} ${s}`,
            id: s,
            variant: "h4",
            children: e
          }
        ),
        /* @__PURE__ */ T.jsx(
          hi,
          {
            color: "primary",
            onClick: u,
            startIcon: /* @__PURE__ */ T.jsx(AF, {}),
            children: i("showCollection")
          }
        )
      ]
    }
  );
}
uie.propTypes = {
  collectionLabel: c.string,
  collectionPath: c.arrayOf(c.string),
  showCollectionDialog: c.func.isRequired,
  windowId: c.string
};
const dAe = (e, { companionWindowId: t, windowId: n }) => {
  const { collectionPath: r } = Wn(e, { windowId: n }) || {}, i = r[r.length - 1];
  return {
    collectionLabel: Lu(e, { manifestId: i }),
    collectionPath: r
  };
}, fAe = {
  showCollectionDialog: i_
}, pAe = wt(
  At(dAe, fAe),
  Tt("CollectionInfo")
), hAe = pAe(uie);
function gAe(e) {
  return Vt("MuiLink", e);
}
const mAe = Wt("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), vAe = ({
  theme: e,
  ownerState: t
}) => {
  const n = t.color, r = Qh(e, `palette.${n}.main`, !1) || Qh(e, `palette.${n}`, !1) || t.color, i = Qh(e, `palette.${n}.mainChannel`) || Qh(e, `palette.${n}Channel`);
  return "vars" in e && i ? `rgba(${i} / 0.4)` : Cn(r, 0.4);
};
var yAe = {};
const h7 = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, bAe = (e) => {
  const {
    classes: t,
    component: n,
    focusVisible: r,
    underline: i
  } = e, o = {
    root: ["root", `underline${Ke(i)}`, n === "button" && "button", r && "focusVisible"]
  };
  return Ft(o, gAe, t);
}, xAe = ye(St, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`underline${Ke(n.underline)}`], n.component === "button" && t.button];
  }
})(Lt(({
  theme: e
}) => ({
  variants: [{
    props: {
      underline: "none"
    },
    style: {
      textDecoration: "none"
    }
  }, {
    props: {
      underline: "hover"
    },
    style: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }, {
    props: {
      underline: "always"
    },
    style: {
      textDecoration: "underline",
      "&:hover": {
        textDecorationColor: "inherit"
      }
    }
  }, {
    props: ({
      underline: t,
      ownerState: n
    }) => t === "always" && n.color !== "inherit",
    style: {
      textDecorationColor: "var(--Link-underlineColor)"
    }
  }, ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      underline: "always",
      color: t
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.4)` : Cn(e.palette[t].main, 0.4)
    }
  })), {
    props: {
      underline: "always",
      color: "textPrimary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Cn(e.palette.text.primary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textSecondary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.secondaryChannel} / 0.4)` : Cn(e.palette.text.secondary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textDisabled"
    },
    style: {
      "--Link-underlineColor": (e.vars || e).palette.text.disabled
    }
  }, {
    props: {
      component: "button"
    },
    style: {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      MozAppearance: "none",
      // Reset
      WebkitAppearance: "none",
      // Reset
      "&::-moz-focus-inner": {
        borderStyle: "none"
        // Remove Firefox dotted outline.
      },
      [`&.${mAe.focusVisible}`]: {
        outline: "auto"
      }
    }
  }]
}))), ka = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiLink"
  }), i = pa(), {
    className: o,
    color: s = "primary",
    component: u = "a",
    onBlur: f,
    onFocus: p,
    TypographyClasses: m,
    underline: v = "always",
    variant: y = "inherit",
    sx: S,
    ...E
  } = r, [w, _] = $.useState(!1), O = (N) => {
    lg(N.target) || _(!1), f && f(N);
  }, D = (N) => {
    lg(N.target) && _(!0), p && p(N);
  }, P = {
    ...r,
    color: s,
    component: u,
    focusVisible: w,
    underline: v,
    variant: y
  }, M = bAe(P);
  return /* @__PURE__ */ T.jsx(xAe, {
    color: s,
    className: yt(M.root, o),
    classes: m,
    component: u,
    onBlur: O,
    onFocus: D,
    ref: n,
    ownerState: P,
    variant: y,
    ...E,
    sx: [...h7[s] === void 0 ? [{
      color: s
    }] : [], ...Array.isArray(S) ? S : [S]],
    style: {
      ...E.style,
      ...v === "always" && s !== "inherit" && !h7[s] && {
        "--Link-underlineColor": vAe({
          theme: i,
          ownerState: P
        })
      }
    }
  });
});
yAe.NODE_ENV !== "production" && (ka.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Qv,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */
  TypographyClasses: c.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: c.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: c.oneOfType([c.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), c.string])
});
const SAe = ye("dl")(({ theme: e }) => ({
  "& dd": {
    marginBottom: ".5em",
    marginLeft: "0"
  }
}));
function die({
  homepage: e = null,
  manifestUrl: t = null,
  related: n = null,
  renderings: r = null,
  seeAlso: i = null,
  ...o
}) {
  const { t: s } = Ct(), u = uo(), f = uo(), p = {
    homepage: e,
    manifestUrl: t,
    related: n,
    renderings: r,
    seeAlso: i,
    t: s,
    ...o
  };
  return /* @__PURE__ */ T.jsxs(
    iy,
    {
      "aria-labelledby": f,
      id: u,
      label: s("related"),
      children: [
        /* @__PURE__ */ T.jsx(
          St,
          {
            "aria-labelledby": `${u} ${f}`,
            id: f,
            variant: "h4",
            component: "h5",
            children: s("links")
          }
        ),
        /* @__PURE__ */ T.jsxs(SAe, { className: On(Nt("label-value-metadata")), children: [
          e && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: s("iiif_homepage") }),
            e.map((m) => /* @__PURE__ */ T.jsx(St, { variant: "body1", component: "dd", children: /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: m.value, children: m.label || m.value }) }, m.value))
          ] }),
          r && r.length > 0 && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: s("iiif_renderings") }),
            r.map((m) => /* @__PURE__ */ T.jsx(St, { variant: "body1", component: "dd", children: /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: m.value, children: m.label || m.value }) }, m.value))
          ] }),
          n && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: s("iiif_related") }),
            n.map((m) => /* @__PURE__ */ T.jsxs(St, { variant: "body1", component: "dd", children: [
              /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: m.value, children: m.label || m.value }),
              m.format && /* @__PURE__ */ T.jsx(St, { component: "span", children: ` (${m.format})` })
            ] }, m.value))
          ] }),
          i && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: s("iiif_seeAlso") }),
            i.map((m) => /* @__PURE__ */ T.jsxs(St, { variant: "body1", component: "dd", children: [
              /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: m.value, children: m.label || m.value }),
              m.format && /* @__PURE__ */ T.jsx(St, { component: "span", children: ` (${m.format})` })
            ] }, m.value))
          ] }),
          t && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: s("iiif_manifest") }),
            /* @__PURE__ */ T.jsx(St, { variant: "body1", component: "dd", children: /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: t, children: t }) })
          ] })
        ] }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "ManifestRelatedLinks", ...p })
      ]
    }
  );
}
die.propTypes = {
  homepage: c.arrayOf(c.shape({
    label: c.string,
    value: c.string
  })),
  manifestUrl: c.string,
  related: c.arrayOf(c.shape({
    format: c.string,
    label: c.string,
    value: c.string
  })),
  renderings: c.arrayOf(c.shape({
    label: c.string,
    value: c.string
  })),
  seeAlso: c.arrayOf(c.shape({
    format: c.string,
    label: c.string,
    value: c.string
  }))
};
const wAe = (e, { companionWindowId: t, windowId: n }) => ({
  homepage: qee(e, { windowId: n }),
  manifestUrl: B1(e, { windowId: n }),
  related: Gee(e, { windowId: n }),
  renderings: $ee(e, { windowId: n }),
  seeAlso: a3(e, { windowId: n })
}), TAe = wt(
  At(wAe),
  Tt("ManifestRelatedLinks")
), EAe = TAe(die);
function fie({
  windowId: e,
  id: t,
  canvasIds: n = [],
  collectionPath: r = [],
  locale: i = "",
  setLocale: o = void 0,
  availableLocales: s = [],
  showLocalePicker: u = !1
}) {
  const { t: f } = Ct();
  return /* @__PURE__ */ T.jsxs(
    Zd,
    {
      title: f("aboutThisItem"),
      paperClassName: Nt("window-sidebar-info-panel"),
      windowId: e,
      id: t,
      titleControls: u && /* @__PURE__ */ T.jsx(
        aie,
        {
          locale: i,
          setLocale: o,
          availableLocales: s
        }
      ),
      children: [
        n.map((p, m) => /* @__PURE__ */ T.jsx(
          _v,
          {
            children: /* @__PURE__ */ T.jsx(
              mRe,
              {
                canvasId: p,
                companionWindowId: t,
                index: m,
                totalSize: n.length,
                windowId: e
              }
            )
          },
          p
        )),
        r.length > 0 && /* @__PURE__ */ T.jsx(_v, { children: /* @__PURE__ */ T.jsx(hAe, { companionWindowId: t, windowId: e }) }),
        /* @__PURE__ */ T.jsx(_v, { children: /* @__PURE__ */ T.jsx(lie, { companionWindowId: t, windowId: e }) }),
        /* @__PURE__ */ T.jsx(_v, { children: /* @__PURE__ */ T.jsx(EAe, { companionWindowId: t, windowId: e }) })
      ]
    }
  );
}
fie.propTypes = {
  availableLocales: c.arrayOf(c.string),
  canvasIds: c.arrayOf(c.string),
  collectionPath: c.arrayOf(c.string),
  id: c.string.isRequired,
  locale: c.string,
  setLocale: c.func,
  showLocalePicker: c.bool,
  windowId: c.string.isRequired
};
const _Ae = (e, { id: t, windowId: n }) => ({
  availableLocales: Jee(e, { companionWindowId: t, windowId: n }),
  canvasIds: ku(e, { windowId: n }),
  collectionPath: (Wn(e, { windowId: n }) || {}).collectionPath,
  locale: ju(e, { companionWindowId: t }).locale || Oi(e, { windowId: n }),
  showLocalePicker: fa(e, { windowId: n }).showLocalePicker
}), CAe = (e, { windowId: t, id: n }) => ({
  setLocale: (r) => e(Nx(t, n, { locale: r }))
}), RAe = wt(
  At(_Ae, CAe),
  Tt("WindowSideBarInfoPanel")
), OAe = RAe(fie);
function AAe(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function DAe(e, t, n, r = {}, i = () => {
}) {
  const {
    ease: o = AAe,
    duration: s = 300
    // standard
  } = r;
  let u = null;
  const f = t[e];
  let p = !1;
  const m = () => {
    p = !0;
  }, v = (y) => {
    if (p) {
      i(new Error("Animation cancelled"));
      return;
    }
    u === null && (u = y);
    const S = Math.min(1, (y - u) / s);
    if (t[e] = o(S) * (n - f) + f, S >= 1) {
      requestAnimationFrame(() => {
        i(null);
      });
      return;
    }
    requestAnimationFrame(v);
  };
  return f === n ? (i(new Error("Element already at target position")), m) : (requestAnimationFrame(v), m);
}
var IAe = {};
const PAe = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function pie(e) {
  const {
    onChange: t,
    ...n
  } = e, r = $.useRef(), i = $.useRef(null), o = () => {
    r.current = i.current.offsetHeight - i.current.clientHeight;
  };
  return gs(() => {
    const s = u_(() => {
      const f = r.current;
      o(), f !== r.current && t(r.current);
    }), u = jl(i.current);
    return u.addEventListener("resize", s), () => {
      s.clear(), u.removeEventListener("resize", s);
    };
  }, [t]), $.useEffect(() => {
    o(), t(r.current);
  }, [t]), /* @__PURE__ */ T.jsx("div", {
    style: PAe,
    ...n,
    ref: i
  });
}
IAe.NODE_ENV !== "production" && (pie.propTypes = {
  onChange: c.func.isRequired
});
const NAe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), MAe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function jAe(e) {
  return Vt("MuiTabScrollButton", e);
}
const LAe = Wt("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]);
var kAe = {};
const zAe = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: r
  } = e;
  return Ft({
    root: ["root", n, r && "disabled"]
  }, jAe, t);
}, BAe = ye(Ws, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${LAe.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), hie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: i,
    slots: o = {},
    slotProps: s = {},
    direction: u,
    orientation: f,
    disabled: p,
    ...m
  } = r, v = wg(), y = {
    isRtl: v,
    ...r
  }, S = zAe(y), E = o.StartScrollButtonIcon ?? NAe, w = o.EndScrollButtonIcon ?? MAe, _ = Oo({
    elementType: E,
    externalSlotProps: s.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: y
  }), O = Oo({
    elementType: w,
    externalSlotProps: s.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: y
  });
  return /* @__PURE__ */ T.jsx(BAe, {
    component: "div",
    className: yt(S.root, i),
    ref: n,
    role: null,
    ownerState: y,
    tabIndex: null,
    ...m,
    style: {
      ...m.style,
      ...f === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${v ? -90 : 90}deg)`
      }
    },
    children: u === "left" ? /* @__PURE__ */ T.jsx(E, {
      ..._
    }) : /* @__PURE__ */ T.jsx(w, {
      ...O
    })
  });
});
kAe.NODE_ENV !== "production" && (hie.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The direction the button should indicate.
   */
  direction: c.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: c.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: c.shape({
    endScrollButtonIcon: c.oneOfType([c.func, c.object]),
    startScrollButtonIcon: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    EndScrollButtonIcon: c.elementType,
    StartScrollButtonIcon: c.elementType
  }),
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function VAe(e) {
  return Vt("MuiTabs", e);
}
const lz = Wt("MuiTabs", ["root", "vertical", "list", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]);
var V0 = {};
const g7 = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, m7 = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, nO = (e, t, n) => {
  let r = !1, i = n(e, t);
  for (; i; ) {
    if (i === e.firstChild) {
      if (r)
        return;
      r = !0;
    }
    const o = i.disabled || i.getAttribute("aria-disabled") === "true";
    if (!i.hasAttribute("tabindex") || o)
      i = n(e, i);
    else {
      i.focus();
      return;
    }
  }
}, UAe = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: r,
    scrollableX: i,
    scrollableY: o,
    centered: s,
    scrollButtonsHideMobile: u,
    classes: f
  } = e;
  return Ft({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", r && "hideScrollbar", i && "scrollableX", o && "scrollableY"],
    list: ["list", "flexContainer", t && "flexContainerVertical", t && "vertical", s && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", u && "scrollButtonsHideMobile"],
    scrollableX: [i && "scrollableX"],
    hideScrollbar: [r && "hideScrollbar"]
  }, VAe, f);
}, FAe = ye("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${lz.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${lz.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(Lt(({
  theme: e
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollButtonsHideMobile,
    style: {
      [`& .${lz.scrollButtons}`]: {
        [e.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), WAe = ye("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState: e
    }) => e.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), HAe = ye("div", {
  name: "MuiTabs",
  slot: "List",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.list, t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState: e
    }) => e.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.centered,
    style: {
      justifyContent: "center"
    }
  }]
}), qAe = ye("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(Lt(({
  theme: e
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.secondary.main
    }
  }, {
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), $Ae = ye(pie)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), v7 = {};
let y7 = !1;
const yI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiTabs"
  }), i = pa(), o = wg(), {
    "aria-label": s,
    "aria-labelledby": u,
    action: f,
    centered: p = !1,
    children: m,
    className: v,
    component: y = "div",
    allowScrollButtonsMobile: S = !1,
    indicatorColor: E = "primary",
    onChange: w,
    orientation: _ = "horizontal",
    ScrollButtonComponent: O,
    // TODO: remove in v7 (deprecated in v6)
    scrollButtons: D = "auto",
    selectionFollowsFocus: P,
    slots: M = {},
    slotProps: N = {},
    TabIndicatorProps: k = {},
    // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps: U = {},
    // TODO: remove in v7 (deprecated in v6)
    textColor: H = "primary",
    value: Y,
    variant: z = "standard",
    visibleScrollbar: V = !1,
    ...F
  } = r, X = z === "scrollable", oe = _ === "vertical", re = oe ? "scrollTop" : "scrollLeft", Z = oe ? "top" : "left", ee = oe ? "bottom" : "right", J = oe ? "clientHeight" : "clientWidth", le = oe ? "height" : "width", be = {
    ...r,
    component: y,
    allowScrollButtonsMobile: S,
    indicatorColor: E,
    orientation: _,
    vertical: oe,
    scrollButtons: D,
    textColor: H,
    variant: z,
    visibleScrollbar: V,
    fixed: !X,
    hideScrollbar: X && !V,
    scrollableX: X && !oe,
    scrollableY: X && oe,
    centered: p && !X,
    scrollButtonsHideMobile: !S
  }, ne = UAe(be), ae = Oo({
    elementType: M.StartScrollButtonIcon,
    externalSlotProps: N.startScrollButtonIcon,
    ownerState: be
  }), ie = Oo({
    elementType: M.EndScrollButtonIcon,
    externalSlotProps: N.endScrollButtonIcon,
    ownerState: be
  });
  V0.NODE_ENV !== "production" && p && X && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [he, pe] = $.useState(!1), [me, Ee] = $.useState(v7), [Ie, Pe] = $.useState(!1), [De, Ye] = $.useState(!1), [Ue, ve] = $.useState(!1), [rt, Te] = $.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), Je = /* @__PURE__ */ new Map(), L = $.useRef(null), te = $.useRef(null), ge = {
    slots: M,
    slotProps: {
      indicator: k,
      scrollButton: U,
      ...N
    }
  }, ke = () => {
    const It = L.current;
    let Et;
    if (It) {
      const Jt = It.getBoundingClientRect();
      Et = {
        clientWidth: It.clientWidth,
        scrollLeft: It.scrollLeft,
        scrollTop: It.scrollTop,
        scrollWidth: It.scrollWidth,
        top: Jt.top,
        bottom: Jt.bottom,
        left: Jt.left,
        right: Jt.right
      };
    }
    let jt;
    if (It && Y !== !1) {
      const Jt = te.current.children;
      if (Jt.length > 0) {
        const Nn = Jt[Je.get(Y)];
        V0.NODE_ENV !== "production" && (Nn || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${Y}".`, Je.keys ? `You can provide one of the following values: ${Array.from(Je.keys()).join(", ")}.` : null].join(`
`))), jt = Nn ? Nn.getBoundingClientRect() : null, V0.NODE_ENV !== "production" && V0.NODE_ENV !== "test" && !y7 && jt && jt.width === 0 && jt.height === 0 && // if the whole Tabs component is hidden, don't warn
        Et.clientWidth !== 0 && (Et = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${Y}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), y7 = !0);
      }
    }
    return {
      tabsMeta: Et,
      tabMeta: jt
    };
  }, We = Mr(() => {
    const {
      tabsMeta: It,
      tabMeta: Et
    } = ke();
    let jt = 0, Jt;
    oe ? (Jt = "top", Et && It && (jt = Et.top - It.top + It.scrollTop)) : (Jt = o ? "right" : "left", Et && It && (jt = (o ? -1 : 1) * (Et[Jt] - It[Jt] + It.scrollLeft)));
    const Nn = {
      [Jt]: jt,
      // May be wrong until the font is loaded.
      [le]: Et ? Et[le] : 0
    };
    if (typeof me[Jt] != "number" || typeof me[le] != "number")
      Ee(Nn);
    else {
      const Ai = Math.abs(me[Jt] - Nn[Jt]), ho = Math.abs(me[le] - Nn[le]);
      (Ai >= 1 || ho >= 1) && Ee(Nn);
    }
  }), Be = (It, {
    animation: Et = !0
  } = {}) => {
    Et ? DAe(re, L.current, It, {
      duration: i.transitions.duration.standard
    }) : L.current[re] = It;
  }, je = (It) => {
    let Et = L.current[re];
    oe ? Et += It : Et += It * (o ? -1 : 1), Be(Et);
  }, mt = () => {
    const It = L.current[J];
    let Et = 0;
    const jt = Array.from(te.current.children);
    for (let Jt = 0; Jt < jt.length; Jt += 1) {
      const Nn = jt[Jt];
      if (Et + Nn[J] > It) {
        Jt === 0 && (Et = It);
        break;
      }
      Et += Nn[J];
    }
    return Et;
  }, qe = () => {
    je(-1 * mt());
  }, at = () => {
    je(mt());
  }, [et, {
    onChange: bt,
    ...q
  }] = Xt("scrollbar", {
    className: yt(ne.scrollableX, ne.hideScrollbar),
    elementType: $Ae,
    shouldForwardComponentProp: !0,
    externalForwardedProps: ge,
    ownerState: be
  }), W = $.useCallback((It) => {
    bt == null || bt(It), Te({
      overflow: null,
      scrollbarWidth: It
    });
  }, [bt]), [Q, ce] = Xt("scrollButtons", {
    className: yt(ne.scrollButtons, U.className),
    elementType: hie,
    externalForwardedProps: ge,
    ownerState: be,
    additionalProps: {
      orientation: _,
      slots: {
        StartScrollButtonIcon: M.startScrollButtonIcon || M.StartScrollButtonIcon,
        EndScrollButtonIcon: M.endScrollButtonIcon || M.EndScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: ae,
        endScrollButtonIcon: ie
      }
    }
  }), _e = () => {
    const It = {};
    It.scrollbarSizeListener = X ? /* @__PURE__ */ T.jsx(et, {
      ...q,
      onChange: W
    }) : null;
    const jt = X && (D === "auto" && (Ie || De) || D === !0);
    return It.scrollButtonStart = jt ? /* @__PURE__ */ T.jsx(Q, {
      direction: o ? "right" : "left",
      onClick: qe,
      disabled: !Ie,
      ...ce
    }) : null, It.scrollButtonEnd = jt ? /* @__PURE__ */ T.jsx(Q, {
      direction: o ? "left" : "right",
      onClick: at,
      disabled: !De,
      ...ce
    }) : null, It;
  }, Fe = Mr((It) => {
    const {
      tabsMeta: Et,
      tabMeta: jt
    } = ke();
    if (!(!jt || !Et)) {
      if (jt[Z] < Et[Z]) {
        const Jt = Et[re] + (jt[Z] - Et[Z]);
        Be(Jt, {
          animation: It
        });
      } else if (jt[ee] > Et[ee]) {
        const Jt = Et[re] + (jt[ee] - Et[ee]);
        Be(Jt, {
          animation: It
        });
      }
    }
  }), gt = Mr(() => {
    X && D !== !1 && ve(!Ue);
  });
  $.useEffect(() => {
    const It = u_(() => {
      L.current && We();
    });
    let Et;
    const jt = (Ai) => {
      Ai.forEach((ho) => {
        ho.removedNodes.forEach((gi) => {
          Et == null || Et.unobserve(gi);
        }), ho.addedNodes.forEach((gi) => {
          Et == null || Et.observe(gi);
        });
      }), It(), gt();
    }, Jt = jl(L.current);
    Jt.addEventListener("resize", It);
    let Nn;
    return typeof ResizeObserver < "u" && (Et = new ResizeObserver(It), Array.from(te.current.children).forEach((Ai) => {
      Et.observe(Ai);
    })), typeof MutationObserver < "u" && (Nn = new MutationObserver(jt), Nn.observe(te.current, {
      childList: !0
    })), () => {
      It.clear(), Jt.removeEventListener("resize", It), Nn == null || Nn.disconnect(), Et == null || Et.disconnect();
    };
  }, [We, gt]), $.useEffect(() => {
    const It = Array.from(te.current.children), Et = It.length;
    if (typeof IntersectionObserver < "u" && Et > 0 && X && D !== !1) {
      const jt = It[0], Jt = It[Et - 1], Nn = {
        root: L.current,
        threshold: 0.99
      }, Ai = (gr) => {
        Pe(!gr[0].isIntersecting);
      }, ho = new IntersectionObserver(Ai, Nn);
      ho.observe(jt);
      const gi = (gr) => {
        Ye(!gr[0].isIntersecting);
      }, go = new IntersectionObserver(gi, Nn);
      return go.observe(Jt), () => {
        ho.disconnect(), go.disconnect();
      };
    }
  }, [X, D, Ue, m == null ? void 0 : m.length]), $.useEffect(() => {
    pe(!0);
  }, []), $.useEffect(() => {
    We();
  }), $.useEffect(() => {
    Fe(v7 !== me);
  }, [Fe, me]), $.useImperativeHandle(f, () => ({
    updateIndicator: We,
    updateScrollButtons: gt
  }), [We, gt]);
  const [ct, ht] = Xt("indicator", {
    className: yt(ne.indicator, k.className),
    elementType: qAe,
    externalForwardedProps: ge,
    ownerState: be,
    additionalProps: {
      style: me
    }
  }), Yt = /* @__PURE__ */ T.jsx(ct, {
    ...ht
  });
  let Rt = 0;
  const cn = $.Children.map(m, (It) => {
    if (!/* @__PURE__ */ $.isValidElement(It))
      return null;
    V0.NODE_ENV !== "production" && g_.isFragment(It) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const Et = It.props.value === void 0 ? Rt : It.props.value;
    Je.set(Et, Rt);
    const jt = Et === Y;
    return Rt += 1, /* @__PURE__ */ $.cloneElement(It, {
      fullWidth: z === "fullWidth",
      indicator: jt && !he && Yt,
      selected: jt,
      selectionFollowsFocus: P,
      onChange: w,
      textColor: H,
      value: Et,
      ...Rt === 1 && Y === !1 && !It.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), Kt = (It) => {
    if (It.altKey || It.shiftKey || It.ctrlKey || It.metaKey)
      return;
    const Et = te.current, jt = Vi(Et).activeElement;
    if (jt.getAttribute("role") !== "tab")
      return;
    let Nn = _ === "horizontal" ? "ArrowLeft" : "ArrowUp", Ai = _ === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (_ === "horizontal" && o && (Nn = "ArrowRight", Ai = "ArrowLeft"), It.key) {
      case Nn:
        It.preventDefault(), nO(Et, jt, m7);
        break;
      case Ai:
        It.preventDefault(), nO(Et, jt, g7);
        break;
      case "Home":
        It.preventDefault(), nO(Et, null, g7);
        break;
      case "End":
        It.preventDefault(), nO(Et, null, m7);
        break;
    }
  }, Zt = _e(), [dn, xr] = Xt("root", {
    ref: n,
    className: yt(ne.root, v),
    elementType: FAe,
    externalForwardedProps: {
      ...ge,
      ...F,
      component: y
    },
    ownerState: be
  }), [Hr, jr] = Xt("scroller", {
    ref: L,
    className: ne.scroller,
    elementType: WAe,
    externalForwardedProps: ge,
    ownerState: be,
    additionalProps: {
      style: {
        overflow: rt.overflow,
        [oe ? `margin${o ? "Left" : "Right"}` : "marginBottom"]: V ? void 0 : -rt.scrollbarWidth
      }
    }
  }), [Ut, ei] = Xt("list", {
    ref: te,
    className: yt(ne.list, ne.flexContainer),
    elementType: HAe,
    externalForwardedProps: ge,
    ownerState: be,
    getSlotProps: (It) => ({
      ...It,
      onKeyDown: (Et) => {
        var jt;
        Kt(Et), (jt = It.onKeyDown) == null || jt.call(It, Et);
      }
    })
  });
  return /* @__PURE__ */ T.jsxs(dn, {
    ...xr,
    children: [Zt.scrollButtonStart, Zt.scrollbarSizeListener, /* @__PURE__ */ T.jsxs(Hr, {
      ...jr,
      children: [/* @__PURE__ */ T.jsx(Ut, {
        "aria-label": s,
        "aria-labelledby": u,
        "aria-orientation": _ === "vertical" ? "vertical" : null,
        role: "tablist",
        ...ei,
        children: cn
      }), he && Yt]
    }), Zt.scrollButtonEnd]
  });
});
V0.NODE_ENV !== "production" && (yI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: $s,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: c.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": c.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": c.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: c.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: c.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @deprecated use the `slots.scrollButtons` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default TabScrollButton
   */
  ScrollButtonComponent: c.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: c.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: c.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    endScrollButtonIcon: c.oneOfType([c.func, c.object]),
    indicator: c.oneOfType([c.func, c.object]),
    list: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    scrollbar: c.oneOfType([c.func, c.object]),
    scrollButtons: c.oneOfType([c.func, c.object]),
    scroller: c.oneOfType([c.func, c.object]),
    startScrollButtonIcon: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    endScrollButtonIcon: c.elementType,
    EndScrollButtonIcon: c.elementType,
    indicator: c.elementType,
    list: c.elementType,
    root: c.elementType,
    scrollbar: c.elementType,
    scrollButtons: c.elementType,
    scroller: c.elementType,
    startScrollButtonIcon: c.elementType,
    StartScrollButtonIcon: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Props applied to the tab indicator element.
   * @deprecated use the `slotProps.indicator` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default  {}
   */
  TabIndicatorProps: c.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @deprecated use the `slotProps.scrollButtons` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TabScrollButtonProps: c.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: c.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: c.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: c.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: c.bool
});
function GAe(e) {
  return Vt("MuiTab", e);
}
const gc = Wt("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]);
var YAe = {};
const XAe = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: r,
    wrapped: i,
    icon: o,
    label: s,
    selected: u,
    disabled: f
  } = e, p = {
    root: ["root", o && s && "labelIcon", `textColor${Ke(n)}`, r && "fullWidth", i && "wrapped", u && "selected", f && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return Ft(p, GAe, t);
}, ZAe = ye(Ws, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${Ke(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${gc.iconWrapper}`]: t.iconWrapper
    }, {
      [`& .${gc.icon}`]: t.icon
    }];
  }
})(Lt(({
  theme: e
}) => ({
  ...e.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: ({
      ownerState: t
    }) => t.label && (t.iconPosition === "top" || t.iconPosition === "bottom"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.label && t.iconPosition !== "top" && t.iconPosition !== "bottom",
    style: {
      flexDirection: "row"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.icon && t.label,
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "top",
    style: {
      [`& > .${gc.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "bottom",
    style: {
      [`& > .${gc.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "start",
    style: {
      [`& > .${gc.icon}`]: {
        marginRight: e.spacing(1)
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "end",
    style: {
      [`& > .${gc.icon}`]: {
        marginLeft: e.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${gc.selected}`]: {
        opacity: 1
      },
      [`&.${gc.disabled}`]: {
        opacity: (e.vars || e).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${gc.selected}`]: {
        color: (e.vars || e).palette.primary.main
      },
      [`&.${gc.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${gc.selected}`]: {
        color: (e.vars || e).palette.secondary.main
      },
      [`&.${gc.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.wrapped,
    style: {
      fontSize: e.typography.pxToRem(12)
    }
  }]
}))), ex = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiTab"
  }), {
    className: i,
    disabled: o = !1,
    disableFocusRipple: s = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: u,
    icon: f,
    iconPosition: p = "top",
    // eslint-disable-next-line react/prop-types
    indicator: m,
    label: v,
    onChange: y,
    onClick: S,
    onFocus: E,
    // eslint-disable-next-line react/prop-types
    selected: w,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: _,
    // eslint-disable-next-line react/prop-types
    textColor: O = "inherit",
    value: D,
    wrapped: P = !1,
    ...M
  } = r, N = {
    ...r,
    disabled: o,
    disableFocusRipple: s,
    selected: w,
    icon: !!f,
    iconPosition: p,
    label: !!v,
    fullWidth: u,
    textColor: O,
    wrapped: P
  }, k = XAe(N), U = f && v && /* @__PURE__ */ $.isValidElement(f) ? /* @__PURE__ */ $.cloneElement(f, {
    className: yt(k.icon, f.props.className)
  }) : f, H = (z) => {
    !w && y && y(z, D), S && S(z);
  }, Y = (z) => {
    _ && !w && y && y(z, D), E && E(z);
  };
  return /* @__PURE__ */ T.jsxs(ZAe, {
    focusRipple: !s,
    className: yt(k.root, i),
    ref: n,
    role: "tab",
    "aria-selected": w,
    disabled: o,
    onClick: H,
    onFocus: Y,
    ownerState: N,
    tabIndex: w ? 0 : -1,
    ...M,
    children: [p === "top" || p === "start" ? /* @__PURE__ */ T.jsxs($.Fragment, {
      children: [U, v]
    }) : /* @__PURE__ */ T.jsxs($.Fragment, {
      children: [v, U]
    }), m]
  });
});
YAe.NODE_ENV !== "production" && (ex.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: nF,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * The icon to display.
   */
  icon: c.oneOfType([c.element, c.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: c.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: c.node,
  /**
   * @ignore
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: c.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: c.bool
});
const KAe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M3 15h18v-2H3zm0 4h18v-2H3zm0-8h18V9H3zm0-6v2h18V5z"
}), "ReorderSharp"), QAe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z"
}), "SortSharp"), JAe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForwardSharp");
function gie({ label: e }) {
  return /* @__PURE__ */ T.jsx(
    St,
    {
      variant: "body1",
      children: e
    }
  );
}
gie.propTypes = {
  label: c.string.isRequired
};
const eDe = wt(
  At(null, null),
  Tt("SidebarIndexItem")
), tDe = eDe(gie);
function mie({
  canvas: e,
  height: t = void 0,
  label: n,
  width: r = void 0
}) {
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx("div", { style: { minWidth: 50 }, children: /* @__PURE__ */ T.jsx(
      jx,
      {
        label: n,
        resource: e,
        maxHeight: t,
        maxWidth: r
      }
    ) }),
    /* @__PURE__ */ T.jsx(St, { children: n })
  ] });
}
mie.propTypes = {
  canvas: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  height: c.number,
  label: c.string.isRequired,
  width: c.number
};
const nDe = (e, { data: t }) => ({
  ...Dn(e).canvasNavigation || {}
}), rDe = wt(
  At(nDe, null),
  Tt("SidebarIndexThumbnail")
), iDe = rDe(mie), oDe = ye(qo, { name: "SidebarIndexList", slot: "item" })(({ theme: e }) => ({
  alignItems: "flex-start",
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(1),
  position: "initial",
  whiteSpace: "normal"
}));
function aDe(e) {
  return e.map((t) => ({
    id: t.id,
    label: new Ox(t).getLabel()
  }));
}
function vie({
  canvases: e,
  containerRef: t,
  selectedCanvasIds: n = [],
  setCanvas: r,
  variant: i = "item",
  windowId: o
}) {
  const s = Ui(() => aDe(e), [e]);
  let u;
  switch (i) {
    case "thumbnail":
      u = iDe;
      break;
    default:
      u = tDe;
  }
  return /* @__PURE__ */ T.jsx(ty, { variant: "selectedMenu", children: s.map((f, p) => {
    const m = () => {
      r(o, f.id);
    };
    return /* @__PURE__ */ T.jsx(
      zx,
      {
        containerRef: t,
        offsetTop: 96,
        selected: n.includes(f.id),
        scrollTo: n.includes(f.id),
        children: /* @__PURE__ */ T.jsx(
          oDe,
          {
            divider: !0,
            onClick: m,
            component: "li",
            children: /* @__PURE__ */ T.jsx(u, { label: f.label, canvas: e[p] })
          },
          f.id
        )
      },
      `${f.id}-${i}`
    );
  }) });
}
vie.propTypes = {
  canvases: c.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  containerRef: c.oneOfType([
    c.func,
    c.shape({ current: c.instanceOf(Element) })
  ]).isRequired,
  selectedCanvasIds: c.arrayOf(c.string),
  setCanvas: c.func.isRequired,
  variant: c.oneOf(["item", "thumbnail"]),
  windowId: c.string.isRequired
};
const sDe = (e, { id: t, windowId: n }) => ({
  canvases: Fa(e, { windowId: n }),
  selectedCanvasIds: ku(e, { windowId: n }),
  variant: ju(e, { companionWindowId: t, windowId: n }).variant
}), lDe = (e, { id: t, windowId: n }) => ({
  setCanvas: (...r) => e(Iu(...r))
}), cDe = wt(
  At(sDe, lDe),
  Tt("SidebarIndexList")
), uDe = cDe(vie);
var dDe = {};
const b7 = /* @__PURE__ */ new Set();
function yA(e, t = "warning") {
  if (dDe.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  b7.has(n) || (b7.add(n), t === "error" ? console.error(n) : console.warn(n));
}
function yie(e) {
  return Fwe;
}
function fDe(e) {
  return Vt("MuiSimpleTreeView", e);
}
Wt("MuiSimpleTreeView", ["root"]);
var pDe = {};
const hDe = (e, t) => {
  const n = $.useRef({}), [r, i] = $.useState(() => {
    const s = {};
    return e.forEach((u) => {
      u.models && Object.entries(u.models).forEach(([f, p]) => {
        n.current[f] = {
          isControlled: t[f] !== void 0,
          getDefaultValue: p.getDefaultValue
        }, s[f] = p.getDefaultValue(t);
      });
    }), s;
  }), o = Object.fromEntries(Object.entries(n.current).map(([s, u]) => {
    const f = t[s] ?? r[s];
    return [s, {
      value: f,
      setControlledValue: (p) => {
        u.isControlled || i((m) => $t({}, m, {
          [s]: p
        }));
      }
    }];
  }));
  return pDe.NODE_ENV !== "production" && Object.entries(n.current).forEach(([s, u]) => {
    const f = t[s], p = u.getDefaultValue(t);
    $.useEffect(() => {
      u.isControlled !== (f !== void 0) && console.error([`MUI X: A component is changing the ${u.isControlled ? "" : "un"}controlled ${s} state of TreeView to be ${u.isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${s} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [f]);
    const {
      current: m
    } = $.useRef(p);
    $.useEffect(() => {
      !u.isControlled && m !== p && console.error([`MUI X: A component is changing the default ${s} state of an uncontrolled TreeView after being initialized. To suppress this warning opt to use a controlled TreeView.`].join(`
`));
    }, [JSON.stringify(p)]);
  }), o;
};
var gDe = {};
class mDe {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, r = {}) {
    let i = this.events[t];
    if (i || (i = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = i), r.isFirst ? i.highPriority.set(n, !0) : i.regular.set(n, !0), gDe.NODE_ENV !== "production") {
      const o = i.highPriority.size + i.regular.size;
      o > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${o} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const r = this.events[t];
    if (!r)
      return;
    const i = Array.from(r.highPriority.keys()), o = Array.from(r.regular.keys());
    for (let s = i.length - 1; s >= 0; s -= 1) {
      const u = i[s];
      r.highPriority.has(u) && u.apply(this, n);
    }
    for (let s = 0; s < o.length; s += 1) {
      const u = o[s];
      r.regular.has(u) && u.apply(this, n);
    }
  }
  once(t, n) {
    const r = this;
    this.on(t, function i(...o) {
      r.removeListener(t, i), n.apply(r, o);
    });
  }
}
const vDe = (e) => e.isPropagationStopped !== void 0, bie = () => {
  const [e] = $.useState(() => new mDe()), t = $.useCallback((...r) => {
    const [i, o, s = {}] = r;
    s.defaultMuiPrevented = !1, !(vDe(s) && s.isPropagationStopped()) && e.emit(i, o, s);
  }, [e]), n = $.useCallback((r, i) => (e.on(r, i), () => {
    e.removeListener(r, i);
  }), [e]);
  return {
    instance: {
      $$publishEvent: t,
      $$subscribeEvent: n
    }
  };
};
bie.params = {};
const xie = ({
  plugins: e
}) => {
  const t = new Set(e);
  return {
    instance: {
      getAvailablePlugins: () => t
    }
  };
};
xie.params = {};
let x7 = 0;
const yDe = () => (x7 += 1, `mui-tree-view-${x7}`), bI = ({
  id: e,
  treeId: t = "",
  itemId: n
}) => e ?? `${t}-${n}`, DF = ({
  params: e,
  state: t,
  setState: n
}) => {
  $.useEffect(() => {
    n((i) => i.id.treeId === e.id && i.id.treeId !== void 0 ? i : $t({}, i, {
      id: $t({}, i.id, {
        treeId: e.id ?? yDe()
      })
    }));
  }, [n, e.id]);
  const r = e.id ?? t.id.treeId;
  return {
    getRootProps: () => ({
      id: r
    }),
    contextValue: {
      treeId: r
    }
  };
};
DF.params = {
  id: !0
};
DF.getInitialState = ({
  id: e
}) => ({
  id: {
    treeId: e ?? void 0
  }
});
const bDe = [bie, xie, DF], xDe = ["slots", "slotProps", "apiRef", "experimentalFeatures"], SDe = (e) => {
  let {
    props: {
      slots: t,
      slotProps: n,
      apiRef: r,
      experimentalFeatures: i
    },
    plugins: o
  } = e, s = Dl(e.props, xDe);
  const u = {};
  o.forEach((y) => {
    Object.assign(u, y.params);
  });
  const f = {}, p = {};
  Object.keys(s).forEach((y) => {
    const S = s[y];
    u[y] ? f[y] = S : p[y] = S;
  });
  const m = i ?? {}, v = o.reduce((y, S) => S.getDefaultizedParams ? S.getDefaultizedParams({
    params: y,
    experimentalFeatures: m
  }) : y, f);
  return {
    apiRef: r,
    forwardedProps: p,
    pluginParams: v,
    slots: t ?? {},
    slotProps: n ?? {},
    experimentalFeatures: m
  };
}, wDe = ({
  plugins: e,
  instance: t,
  publicAPI: n,
  rootRef: r
}) => ({
  runItemPlugins: (u) => {
    let f = null, p = null;
    const m = [], v = {};
    e.forEach((E) => {
      if (!E.itemPlugin)
        return;
      const w = E.itemPlugin({
        props: u,
        rootRef: f,
        contentRef: p
      });
      w != null && w.rootRef && (f = w.rootRef), w != null && w.contentRef && (p = w.contentRef), w != null && w.propsEnhancers && (m.push(w.propsEnhancers), Object.keys(w.propsEnhancers).forEach((_) => {
        v[_] = !0;
      }));
    });
    const y = (E) => (w) => {
      const _ = {};
      return m.forEach((O) => {
        const D = O[E];
        D != null && Object.assign(_, D(w));
      }), _;
    }, S = Object.fromEntries(Object.keys(v).map((E) => [E, y(E)]));
    return {
      contentRef: p,
      rootRef: f,
      propsEnhancers: S
    };
  },
  wrapItem: ({
    itemId: u,
    children: f
  }) => {
    let p = f;
    for (let m = e.length - 1; m >= 0; m -= 1) {
      const v = e[m];
      v.wrapItem && (p = v.wrapItem({
        itemId: u,
        children: p,
        instance: t
      }));
    }
    return p;
  },
  wrapRoot: ({
    children: u
  }) => {
    let f = u;
    for (let p = e.length - 1; p >= 0; p -= 1) {
      const m = e[p];
      m.wrapRoot && (f = m.wrapRoot({
        children: f,
        instance: t
      }));
    }
    return f;
  },
  instance: t,
  rootRef: r,
  publicAPI: n
});
function TDe(e) {
  const t = $.useRef({});
  return e ? (e.current == null && (e.current = {}), e.current) : t.current;
}
const EDe = ({
  plugins: e,
  rootRef: t,
  props: n
}) => {
  const r = [...bDe, ...e], {
    pluginParams: i,
    forwardedProps: o,
    apiRef: s,
    experimentalFeatures: u,
    slots: f,
    slotProps: p
  } = SDe({
    plugins: r,
    props: n
  }), m = hDe(r, i), y = $.useRef({}).current, S = TDe(s), E = $.useRef(null), w = kr(E, t), _ = wDe({
    plugins: r,
    instance: y,
    publicAPI: S,
    rootRef: E
  }), [O, D] = $.useState(() => {
    const k = {};
    return r.forEach((U) => {
      U.getInitialState && Object.assign(k, U.getInitialState(i));
    }), k;
  }), P = [], M = (k) => {
    const U = k({
      instance: y,
      params: i,
      slots: f,
      slotProps: p,
      experimentalFeatures: u,
      state: O,
      setState: D,
      rootRef: E,
      models: m,
      plugins: r
    });
    U.getRootProps && P.push(U.getRootProps), U.publicAPI && Object.assign(S, U.publicAPI), U.instance && Object.assign(y, U.instance), U.contextValue && Object.assign(_, U.contextValue);
  };
  return r.forEach(M), {
    getRootProps: (k = {}) => {
      const U = $t({
        role: "tree"
      }, o, k, {
        ref: w
      });
      return P.forEach((H) => {
        Object.assign(U, H(k));
      }), U;
    },
    rootRef: w,
    contextValue: _,
    instance: y
  };
};
var _De = {};
const IF = /* @__PURE__ */ $.createContext(null);
_De.NODE_ENV !== "production" && (IF.displayName = "TreeViewContext");
function CDe(e) {
  const {
    value: t,
    children: n
  } = e;
  return /* @__PURE__ */ T.jsx(IF.Provider, {
    value: t,
    children: t.wrapRoot({
      children: n,
      instance: t.instance
    })
  });
}
const Ux = () => {
  const e = $.useContext(IF);
  if (e == null)
    throw new Error(["MUI X: Could not find the Tree View context.", "It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  return e;
}, Sie = (e, t, n) => {
  e.$$publishEvent(t, n);
}, Cv = "__TREE_VIEW_ROOT_PARENT_ID__", wie = (e) => {
  const t = {};
  return e.forEach((n, r) => {
    t[n] = r;
  }), t;
};
var RDe = {};
const hx = /* @__PURE__ */ $.createContext(() => -1);
RDe.NODE_ENV !== "production" && (hx.displayName = "TreeViewItemDepthContext");
const ODe = ["children"], Tie = ({
  items: e,
  isItemDisabled: t,
  getItemLabel: n,
  getItemId: r
}) => {
  const i = {}, o = {}, s = {
    [Cv]: []
  }, u = (p, m, v) => {
    var w, _;
    const y = r ? r(p) : p.id;
    if (y == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", "An item was provided without id in the `items` prop:", JSON.stringify(p)].join(`
`));
    if (i[y] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${y}"`].join(`
`));
    const S = n ? n(p) : p.label;
    if (S == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.", "An item was provided without label in the `items` prop:", JSON.stringify(p)].join(`
`));
    i[y] = {
      id: y,
      label: S,
      parentId: v,
      idAttribute: void 0,
      expandable: !!((w = p.children) != null && w.length),
      disabled: t ? t(p) : !1,
      depth: m
    }, o[y] = p;
    const E = v ?? Cv;
    s[E] || (s[E] = []), s[E].push(y), (_ = p.children) == null || _.forEach((O) => u(O, m + 1, y));
  };
  e.forEach((p) => u(p, 0, null));
  const f = {};
  return Object.keys(s).forEach((p) => {
    f[p] = wie(s[p]);
  }), {
    itemMetaMap: i,
    itemMap: o,
    itemOrderedChildrenIds: s,
    itemChildrenIndexes: f
  };
}, S_ = ({
  instance: e,
  params: t,
  state: n,
  setState: r,
  experimentalFeatures: i
}) => {
  const o = $.useCallback((O) => n.items.itemMetaMap[O], [n.items.itemMetaMap]), s = $.useCallback((O) => n.items.itemMap[O], [n.items.itemMap]), u = $.useCallback(() => {
    const O = (D) => {
      const P = n.items.itemMap[D], M = Dl(P, ODe), N = n.items.itemOrderedChildrenIds[D];
      return N && (M.children = N.map(O)), M;
    };
    return n.items.itemOrderedChildrenIds[Cv].map(O);
  }, [n.items.itemMap, n.items.itemOrderedChildrenIds]), f = $.useCallback((O) => {
    if (O == null)
      return !1;
    let D = e.getItemMeta(O);
    if (!D)
      return !1;
    if (D.disabled)
      return !0;
    for (; D.parentId != null; )
      if (D = e.getItemMeta(D.parentId), D.disabled)
        return !0;
    return !1;
  }, [e]), p = $.useCallback((O) => {
    const D = e.getItemMeta(O).parentId ?? Cv;
    return n.items.itemChildrenIndexes[D][O];
  }, [e, n.items.itemChildrenIndexes]), m = $.useCallback((O) => n.items.itemOrderedChildrenIds[O ?? Cv] ?? [], [n.items.itemOrderedChildrenIds]), v = (O) => {
    const D = e.getItemMeta(O);
    return D == null ? null : document.getElementById(bI({
      treeId: n.id.treeId,
      itemId: O,
      id: D.idAttribute
    }));
  }, y = (O) => t.disabledItemsFocusable ? !0 : !e.isItemDisabled(O), S = $.useRef(!1), E = $.useCallback(() => {
    S.current = !0;
  }, []), w = $.useCallback(() => S.current, []);
  return $.useEffect(() => {
    e.areItemUpdatesPrevented() || r((O) => {
      const D = Tie({
        items: t.items,
        isItemDisabled: t.isItemDisabled,
        getItemId: t.getItemId,
        getItemLabel: t.getItemLabel
      });
      return Object.values(O.items.itemMetaMap).forEach((P) => {
        D.itemMetaMap[P.id] || Sie(e, "removeItem", {
          id: P.id
        });
      }), $t({}, O, {
        items: D
      });
    });
  }, [e, r, t.items, t.isItemDisabled, t.getItemId, t.getItemLabel]), {
    getRootProps: () => ({
      style: {
        "--TreeView-itemChildrenIndentation": typeof t.itemChildrenIndentation == "number" ? `${t.itemChildrenIndentation}px` : t.itemChildrenIndentation
      }
    }),
    publicAPI: {
      getItem: s,
      getItemDOMElement: v,
      getItemTree: u,
      getItemOrderedChildrenIds: m
    },
    instance: {
      getItemMeta: o,
      getItem: s,
      getItemTree: u,
      getItemsToRender: () => {
        const O = (D) => {
          var M;
          const P = n.items.itemMetaMap[D];
          return {
            label: P.label,
            itemId: P.id,
            id: P.idAttribute,
            children: (M = n.items.itemOrderedChildrenIds[D]) == null ? void 0 : M.map(O)
          };
        };
        return n.items.itemOrderedChildrenIds[Cv].map(O);
      },
      getItemIndex: p,
      getItemDOMElement: v,
      getItemOrderedChildrenIds: m,
      isItemDisabled: f,
      isItemNavigable: y,
      preventItemUpdates: E,
      areItemUpdatesPrevented: w
    },
    contextValue: {
      items: {
        onItemClick: t.onItemClick,
        disabledItemsFocusable: t.disabledItemsFocusable,
        indentationAtItemLevel: i.indentationAtItemLevel ?? !1
      }
    }
  };
};
S_.getInitialState = (e) => ({
  items: Tie({
    items: e.items,
    isItemDisabled: e.isItemDisabled,
    getItemId: e.getItemId,
    getItemLabel: e.getItemLabel
  })
});
S_.getDefaultizedParams = ({
  params: e
}) => $t({}, e, {
  disabledItemsFocusable: e.disabledItemsFocusable ?? !1,
  itemChildrenIndentation: e.itemChildrenIndentation ?? "12px"
});
S_.wrapRoot = ({
  children: e,
  instance: t
}) => /* @__PURE__ */ T.jsx(hx.Provider, {
  value: (n) => {
    var r;
    return ((r = t.getItemMeta(n)) == null ? void 0 : r.depth) ?? 0;
  },
  children: e
});
S_.params = {
  disabledItemsFocusable: !0,
  items: !0,
  isItemDisabled: !0,
  getItemLabel: !0,
  getItemId: !0,
  onItemClick: !0,
  itemChildrenIndentation: !0
};
const xI = ({
  instance: e,
  params: t,
  models: n
}) => {
  const r = $.useMemo(() => {
    const v = /* @__PURE__ */ new Map();
    return n.expandedItems.value.forEach((y) => {
      v.set(y, !0);
    }), v;
  }, [n.expandedItems.value]), i = (v, y) => {
    var S;
    (S = t.onExpandedItemsChange) == null || S.call(t, v, y), n.expandedItems.setControlledValue(y);
  }, o = $.useCallback((v) => r.has(v), [r]), s = $.useCallback((v) => {
    var y;
    return !!((y = e.getItemMeta(v)) != null && y.expandable);
  }, [e]), u = Mr((v, y) => {
    const S = e.isItemExpanded(y);
    e.setItemExpansion(v, y, !S);
  }), f = Mr((v, y, S) => {
    if (e.isItemExpanded(y) === S)
      return;
    let w;
    S ? w = [y].concat(n.expandedItems.value) : w = n.expandedItems.value.filter((_) => _ !== y), t.onItemExpansionToggle && t.onItemExpansionToggle(v, y, S), i(v, w);
  }), p = (v, y) => {
    const S = e.getItemMeta(y), w = e.getItemOrderedChildrenIds(S.parentId).filter((O) => e.isItemExpandable(O) && !e.isItemExpanded(O)), _ = n.expandedItems.value.concat(w);
    w.length > 0 && (t.onItemExpansionToggle && w.forEach((O) => {
      t.onItemExpansionToggle(v, O, !0);
    }), i(v, _));
  }, m = $.useMemo(() => t.expansionTrigger ? t.expansionTrigger : e.isTreeViewEditable ? "iconContainer" : "content", [t.expansionTrigger, e.isTreeViewEditable]);
  return {
    publicAPI: {
      setItemExpansion: f
    },
    instance: {
      isItemExpanded: o,
      isItemExpandable: s,
      setItemExpansion: f,
      toggleItemExpansion: u,
      expandAllSiblings: p
    },
    contextValue: {
      expansion: {
        expansionTrigger: m
      }
    }
  };
};
xI.models = {
  expandedItems: {
    getDefaultValue: (e) => e.defaultExpandedItems
  }
};
const ADe = [];
xI.getDefaultizedParams = ({
  params: e
}) => $t({}, e, {
  defaultExpandedItems: e.defaultExpandedItems ?? ADe
});
xI.params = {
  expandedItems: !0,
  defaultExpandedItems: !0,
  onExpandedItemsChange: !0,
  onItemExpansionToggle: !0,
  expansionTrigger: !0
};
const Eie = (e, t) => {
  let n = t.length - 1;
  for (; n >= 0 && !e.isItemNavigable(t[n]); )
    n -= 1;
  if (n !== -1)
    return t[n];
}, _ie = (e, t) => {
  const n = e.getItemMeta(t), r = e.getItemOrderedChildrenIds(n.parentId), i = e.getItemIndex(t);
  if (i === 0)
    return n.parentId;
  let o = i - 1;
  for (; !e.isItemNavigable(r[o]) && o >= 0; )
    o -= 1;
  if (o === -1)
    return n.parentId == null ? null : _ie(e, n.parentId);
  let s = r[o], u = Eie(e, e.getItemOrderedChildrenIds(s));
  for (; e.isItemExpanded(s) && u != null; )
    s = u, u = e.getItemOrderedChildrenIds(s).find(e.isItemNavigable);
  return s;
}, kO = (e, t) => {
  if (e.isItemExpanded(t)) {
    const r = e.getItemOrderedChildrenIds(t).find(e.isItemNavigable);
    if (r != null)
      return r;
  }
  let n = e.getItemMeta(t);
  for (; n != null; ) {
    const r = e.getItemOrderedChildrenIds(n.parentId), i = e.getItemIndex(n.id);
    if (i < r.length - 1) {
      let o = i + 1;
      for (; !e.isItemNavigable(r[o]) && o < r.length - 1; )
        o += 1;
      if (e.isItemNavigable(r[o]))
        return r[o];
    }
    n = e.getItemMeta(n.parentId);
  }
  return null;
}, Cie = (e) => {
  let t = null;
  for (; t == null || e.isItemExpanded(t); ) {
    const n = e.getItemOrderedChildrenIds(t), r = Eie(e, n);
    if (r == null)
      return t;
    t = r;
  }
  return t;
}, u1 = (e) => e.getItemOrderedChildrenIds(null).find(e.isItemNavigable), Rie = (e, t, n) => {
  if (t === n)
    return [t, n];
  const r = e.getItemMeta(t), i = e.getItemMeta(n);
  if (r.parentId === i.id || i.parentId === r.id)
    return i.parentId === r.id ? [r.id, i.id] : [i.id, r.id];
  const o = [r.id], s = [i.id];
  let u = r.parentId, f = i.parentId, p = s.indexOf(u) !== -1, m = o.indexOf(f) !== -1, v = !0, y = !0;
  for (; !m && !p; )
    v && (o.push(u), p = s.indexOf(u) !== -1, v = u !== null, !p && v && (u = e.getItemMeta(u).parentId)), y && !p && (s.push(f), m = o.indexOf(f) !== -1, y = f !== null, !m && y && (f = e.getItemMeta(f).parentId));
  const S = p ? u : f, E = e.getItemOrderedChildrenIds(S), w = o[o.indexOf(S) - 1], _ = s[s.indexOf(S) - 1];
  return E.indexOf(w) < E.indexOf(_) ? [t, n] : [n, t];
}, DDe = (e, t, n) => {
  const r = (f) => {
    if (e.isItemExpandable(f) && e.isItemExpanded(f))
      return e.getItemOrderedChildrenIds(f)[0];
    let p = e.getItemMeta(f);
    for (; p != null; ) {
      const m = e.getItemOrderedChildrenIds(p.parentId), v = e.getItemIndex(p.id);
      if (v < m.length - 1)
        return m[v + 1];
      p = e.getItemMeta(p.parentId);
    }
    throw new Error("Invalid range");
  }, [i, o] = Rie(e, t, n), s = [i];
  let u = i;
  for (; u !== o; )
    u = r(u), e.isItemDisabled(u) || s.push(u);
  return s;
}, IDe = (e) => {
  let t = u1(e);
  const n = [];
  for (; t != null; )
    n.push(t), t = kO(e, t);
  return n;
}, uV = (e, t) => t !== e.closest('*[role="treeitem"]'), zO = (e) => Array.isArray(e) ? e : e != null ? [e] : [], cz = (e) => {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}, SI = ({
  instance: e,
  params: t,
  models: n
}) => {
  const r = $.useRef(null), i = $.useRef({}), o = $.useMemo(() => {
    const w = /* @__PURE__ */ new Map();
    return Array.isArray(n.selectedItems.value) ? n.selectedItems.value.forEach((_) => {
      w.set(_, !0);
    }) : n.selectedItems.value != null && w.set(n.selectedItems.value, !0), w;
  }, [n.selectedItems.value]), s = (w, _) => {
    if (t.onItemSelectionToggle)
      if (t.multiSelect) {
        const O = _.filter((P) => !e.isItemSelected(P)), D = n.selectedItems.value.filter((P) => !_.includes(P));
        O.forEach((P) => {
          t.onItemSelectionToggle(w, P, !0);
        }), D.forEach((P) => {
          t.onItemSelectionToggle(w, P, !1);
        });
      } else _ !== n.selectedItems.value && (n.selectedItems.value != null && t.onItemSelectionToggle(w, n.selectedItems.value, !1), _ != null && t.onItemSelectionToggle(w, _, !0));
    t.onSelectedItemsChange && t.onSelectedItemsChange(w, _), n.selectedItems.setControlledValue(_);
  }, u = (w) => o.has(w), f = ({
    event: w,
    itemId: _,
    keepExistingSelection: O = !1,
    shouldBeSelected: D
  }) => {
    if (t.disableSelection)
      return;
    let P;
    if (O) {
      const M = zO(n.selectedItems.value), N = e.isItemSelected(_);
      N && (D === !1 || D == null) ? P = M.filter((k) => k !== _) : !N && (D === !0 || D == null) ? P = [_].concat(M) : P = M;
    } else
      D === !1 || D == null && e.isItemSelected(_) ? P = t.multiSelect ? [] : null : P = t.multiSelect ? [_] : _;
    s(w, P), r.current = _, i.current = {};
  }, p = (w, [_, O]) => {
    if (t.disableSelection || !t.multiSelect)
      return;
    let D = zO(n.selectedItems.value).slice();
    Object.keys(i.current).length > 0 && (D = D.filter((k) => !i.current[k]));
    const P = cz(D), M = DDe(e, _, O), N = M.filter((k) => !P[k]);
    D = D.concat(N), s(w, D), i.current = cz(M);
  };
  return {
    getRootProps: () => ({
      "aria-multiselectable": t.multiSelect
    }),
    publicAPI: {
      selectItem: f
    },
    instance: {
      isItemSelected: u,
      selectItem: f,
      selectAllNavigableItems: (w) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        const _ = IDe(e);
        s(w, _), i.current = cz(_);
      },
      expandSelectionRange: (w, _) => {
        if (r.current != null) {
          const [O, D] = Rie(e, _, r.current);
          p(w, [O, D]);
        }
      },
      selectRangeFromStartToItem: (w, _) => {
        p(w, [u1(e), _]);
      },
      selectRangeFromItemToEnd: (w, _) => {
        p(w, [_, Cie(e)]);
      },
      selectItemFromArrowNavigation: (w, _, O) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        let D = zO(n.selectedItems.value).slice();
        Object.keys(i.current).length === 0 ? (D.push(O), i.current = {
          [_]: !0,
          [O]: !0
        }) : (i.current[_] || (i.current = {}), i.current[O] ? (D = D.filter((P) => P !== _), delete i.current[_]) : (D.push(O), i.current[O] = !0)), s(w, D);
      }
    },
    contextValue: {
      selection: {
        multiSelect: t.multiSelect,
        checkboxSelection: t.checkboxSelection,
        disableSelection: t.disableSelection
      }
    }
  };
};
SI.models = {
  selectedItems: {
    getDefaultValue: (e) => e.defaultSelectedItems
  }
};
const PDe = [];
SI.getDefaultizedParams = ({
  params: e
}) => $t({}, e, {
  disableSelection: e.disableSelection ?? !1,
  multiSelect: e.multiSelect ?? !1,
  checkboxSelection: e.checkboxSelection ?? !1,
  defaultSelectedItems: e.defaultSelectedItems ?? (e.multiSelect ? PDe : null)
});
SI.params = {
  disableSelection: !0,
  multiSelect: !0,
  checkboxSelection: !0,
  defaultSelectedItems: !0,
  selectedItems: !0,
  onSelectedItemsChange: !0,
  onItemSelectionToggle: !0
};
const S7 = 1e3;
class NDe {
  constructor(t = S7) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = S7, this.cleanupTimeout = t;
  }
  register(t, n, r) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const i = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(r.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(r.cleanupToken, i);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class MDe {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, r) {
    this.registry.register(t, n, r);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
class jDe {
}
function LDe(e) {
  let t = 0;
  return function(r, i, o) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new MDe() : new NDe());
    const [s] = $.useState(new jDe()), u = $.useRef(null), f = $.useRef(void 0);
    f.current = o;
    const p = $.useRef(null);
    if (!u.current && f.current) {
      const m = (v, y) => {
        var S;
        y.defaultMuiPrevented || (S = f.current) == null || S.call(f, v, y);
      };
      u.current = r.$$subscribeEvent(i, m), t += 1, p.current = {
        cleanupToken: t
      }, e.registry.register(
        s,
        // The callback below will be called once this reference stops being retained
        () => {
          var v;
          (v = u.current) == null || v.call(u), u.current = null, p.current = null;
        },
        p.current
      );
    } else !f.current && u.current && (u.current(), u.current = null, p.current && (e.registry.unregister(p.current), p.current = null));
    $.useEffect(() => {
      if (!u.current && f.current) {
        const m = (v, y) => {
          var S;
          y.defaultMuiPrevented || (S = f.current) == null || S.call(f, v, y);
        };
        u.current = r.$$subscribeEvent(i, m);
      }
      return p.current && e.registry && (e.registry.unregister(p.current), p.current = null), () => {
        var m;
        (m = u.current) == null || m.call(u), u.current = null;
      };
    }, [r, i]);
  };
}
const kDe = {
  registry: null
}, zDe = LDe(kDe), Oie = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? Oie(t.shadowRoot) : t : null;
};
function BDe(e) {
  return e.replace(/["\\]/g, "\\$&");
}
const VDe = (e, t) => {
  let n = zO(t).find((r) => {
    if (!e.isItemNavigable(r))
      return !1;
    const i = e.getItemMeta(r);
    return i && (i.parentId == null || e.isItemExpanded(i.parentId));
  });
  return n == null && (n = u1(e)), n;
}, PF = ({
  instance: e,
  params: t,
  state: n,
  setState: r,
  models: i,
  rootRef: o
}) => {
  const s = VDe(e, i.selectedItems.value), u = Mr((_) => {
    const O = typeof _ == "function" ? _(n.focusedItemId) : _;
    n.focusedItemId !== O && r((D) => $t({}, D, {
      focusedItemId: O
    }));
  }), f = $.useCallback(() => !!o.current && o.current.contains(Oie(Vi(o.current))), [o]), p = $.useCallback((_) => n.focusedItemId === _ && f(), [n.focusedItemId, f]), m = (_) => {
    const O = e.getItemMeta(_);
    return O && (O.parentId == null || e.isItemExpanded(O.parentId));
  }, v = (_, O) => {
    const D = e.getItemDOMElement(O);
    D && D.focus(), u(O), t.onItemFocus && t.onItemFocus(_, O);
  }, y = Mr((_, O) => {
    m(O) && v(_, O);
  }), S = Mr(() => {
    if (n.focusedItemId == null)
      return;
    if (e.getItemMeta(n.focusedItemId)) {
      const O = e.getItemDOMElement(n.focusedItemId);
      O && O.blur();
    }
    u(null);
  }), E = (_) => _ === s;
  zDe(e, "removeItem", ({
    id: _
  }) => {
    n.focusedItemId === _ && v(null, s);
  });
  const w = (_) => (O) => {
    var D;
    (D = _.onFocus) == null || D.call(_, O), !O.defaultMuiPrevented && O.target === O.currentTarget && v(O, s);
  };
  return {
    getRootProps: (_) => ({
      onFocus: w(_)
    }),
    publicAPI: {
      focusItem: y
    },
    instance: {
      isItemFocused: p,
      canItemBeTabbed: E,
      focusItem: y,
      removeFocusedItem: S
    }
  };
};
PF.getInitialState = () => ({
  focusedItemId: null
});
PF.params = {
  onItemFocus: !0
};
const BO = (e, t) => e.getAvailablePlugins().has(t), UDe = ({
  props: e
}) => {
  const {
    instance: t
  } = Ux(), {
    label: n,
    itemId: r
  } = e, [i, o] = $.useState(n), s = t.isItemBeingEdited(r);
  return $.useEffect(() => {
    s || o(n);
  }, [s, n]), {
    propsEnhancers: {
      labelInput: ({
        externalEventHandlers: u,
        interactions: f
      }) => t.isItemEditable(r) ? {
        value: i ?? "",
        "data-element": "labelInput",
        onChange: (S) => {
          var E;
          (E = u.onChange) == null || E.call(u, S), o(S.target.value);
        },
        onKeyDown: (S) => {
          var w;
          if ((w = u.onKeyDown) == null || w.call(u, S), S.defaultMuiPrevented)
            return;
          const E = S.target;
          S.key === "Enter" && E.value ? f.handleSaveItemLabel(S, E.value) : S.key === "Escape" && f.handleCancelItemLabelEditing(S);
        },
        onBlur: (S) => {
          var E;
          (E = u.onBlur) == null || E.call(u, S), !S.defaultMuiPrevented && S.target.value && f.handleSaveItemLabel(S, S.target.value);
        },
        autoFocus: !0,
        type: "text"
      } : {}
    }
  };
};
var FDe = {};
const tg = ({
  instance: e,
  state: t,
  setState: n,
  params: r
}) => {
  const i = $.useRef(t.editedItemId), o = (v) => i.current === v, s = (v) => {
    n((y) => $t({}, y, {
      editedItemId: v
    })), i.current = v;
  }, u = (v) => v === t.editedItemId, f = !!r.isItemEditable, p = (v) => {
    if (v == null || !f)
      return !1;
    const y = e.getItem(v);
    return y ? typeof r.isItemEditable == "function" ? r.isItemEditable(y) : !!r.isItemEditable : !1;
  }, m = (v, y) => {
    if (!y)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "The label of an item cannot be empty.", v].join(`
`));
    n((S) => {
      const E = S.items.itemMetaMap[v];
      return E.label !== y ? $t({}, S, {
        items: $t({}, S.items, {
          itemMetaMap: $t({}, S.items.itemMetaMap, {
            [v]: $t({}, E, {
              label: y
            })
          })
        })
      }) : S;
    }), r.onItemLabelChange && r.onItemLabelChange(v, y);
  };
  return {
    instance: {
      setEditedItemId: s,
      isItemBeingEdited: u,
      updateItemLabel: m,
      isItemEditable: p,
      isTreeViewEditable: f,
      isItemBeingEditedRef: o
    },
    publicAPI: {
      updateItemLabel: m
    }
  };
};
tg.itemPlugin = UDe;
tg.getDefaultizedParams = ({
  params: e,
  experimentalFeatures: t
}) => {
  const n = t == null ? void 0 : t.labelEditing;
  return FDe.NODE_ENV !== "production" && e.isItemEditable && !n && yA(["MUI X: The label editing feature requires the `labelEditing` experimental feature to be enabled.", "You can do it by passing `experimentalFeatures={{ labelEditing: true}}` to the Rich Tree View Pro component.", "Check the documentation for more details: https://mui.com/x/react-tree-view/rich-tree-view/editing/"]), $t({}, e, {
    isItemEditable: n ? e.isItemEditable ?? !1 : !1
  });
};
tg.getInitialState = () => ({
  editedItemId: null
});
tg.params = {
  onItemLabelChange: !0,
  isItemEditable: !0
};
function WDe(e) {
  return !!e && e.length === 1 && !!e.match(/\S/);
}
const Aie = ({
  instance: e,
  params: t,
  state: n
}) => {
  const r = wg(), i = $.useRef({}), o = Mr((m) => {
    i.current = m(i.current);
  });
  $.useEffect(() => {
    if (e.areItemUpdatesPrevented())
      return;
    const m = {}, v = (y) => {
      m[y.id] = y.label.substring(0, 1).toLowerCase();
    };
    Object.values(n.items.itemMetaMap).forEach(v), i.current = m;
  }, [n.items.itemMetaMap, t.getItemId, e]);
  const s = (m, v) => {
    const y = v.toLowerCase(), S = (O) => {
      const D = kO(e, O);
      return D === null ? u1(e) : D;
    };
    let E = null, w = S(m);
    const _ = {};
    for (; E == null && !_[w]; )
      i.current[w] === y ? E = w : (_[w] = !0, w = S(w));
    return E;
  }, u = (m) => !t.disableSelection && !e.isItemDisabled(m), f = (m) => !e.isItemDisabled(m) && e.isItemExpandable(m);
  return {
    instance: {
      updateFirstCharMap: o,
      handleItemKeyDown: (m, v) => {
        if (m.defaultMuiPrevented || m.altKey || uV(m.target, m.currentTarget))
          return;
        const y = m.ctrlKey || m.metaKey, S = m.key;
        switch (!0) {
          // Select the item when pressing "Space"
          case (S === " " && u(v)): {
            m.preventDefault(), t.multiSelect && m.shiftKey ? e.expandSelectionRange(m, v) : e.selectItem({
              event: m,
              itemId: v,
              keepExistingSelection: t.multiSelect,
              shouldBeSelected: t.multiSelect ? void 0 : !0
            });
            break;
          }
          // If the focused item has children, we expand it.
          // If the focused item has no children, we select it.
          case S === "Enter": {
            BO(e, tg) && e.isItemEditable(v) && !e.isItemBeingEdited(v) ? e.setEditedItemId(v) : f(v) ? (e.toggleItemExpansion(m, v), m.preventDefault()) : u(v) && (t.multiSelect ? (m.preventDefault(), e.selectItem({
              event: m,
              itemId: v,
              keepExistingSelection: !0
            })) : e.isItemSelected(v) || (e.selectItem({
              event: m,
              itemId: v
            }), m.preventDefault()));
            break;
          }
          // Focus the next focusable item
          case S === "ArrowDown": {
            const E = kO(e, v);
            E && (m.preventDefault(), e.focusItem(m, E), t.multiSelect && m.shiftKey && u(E) && e.selectItemFromArrowNavigation(m, v, E));
            break;
          }
          // Focuses the previous focusable item
          case S === "ArrowUp": {
            const E = _ie(e, v);
            E && (m.preventDefault(), e.focusItem(m, E), t.multiSelect && m.shiftKey && u(E) && e.selectItemFromArrowNavigation(m, v, E));
            break;
          }
          // If the focused item is expanded, we move the focus to its first child
          // If the focused item is collapsed and has children, we expand it
          case (S === "ArrowRight" && !r || S === "ArrowLeft" && r): {
            if (y)
              return;
            if (e.isItemExpanded(v)) {
              const E = kO(e, v);
              E && (e.focusItem(m, E), m.preventDefault());
            } else f(v) && (e.toggleItemExpansion(m, v), m.preventDefault());
            break;
          }
          // If the focused item is expanded, we collapse it
          // If the focused item is collapsed and has a parent, we move the focus to this parent
          case (S === "ArrowLeft" && !r || S === "ArrowRight" && r): {
            if (y)
              return;
            if (f(v) && e.isItemExpanded(v))
              e.toggleItemExpansion(m, v), m.preventDefault();
            else {
              const E = e.getItemMeta(v).parentId;
              E && (e.focusItem(m, E), m.preventDefault());
            }
            break;
          }
          // Focuses the first item in the tree
          case S === "Home": {
            u(v) && t.multiSelect && y && m.shiftKey ? e.selectRangeFromStartToItem(m, v) : e.focusItem(m, u1(e)), m.preventDefault();
            break;
          }
          // Focuses the last item in the tree
          case S === "End": {
            u(v) && t.multiSelect && y && m.shiftKey ? e.selectRangeFromItemToEnd(m, v) : e.focusItem(m, Cie(e)), m.preventDefault();
            break;
          }
          // Expand all siblings that are at the same level as the focused item
          case S === "*": {
            e.expandAllSiblings(m, v), m.preventDefault();
            break;
          }
          // Multi select behavior when pressing Ctrl + a
          // Selects all the items
          case (String.fromCharCode(m.keyCode) === "A" && y && t.multiSelect && !t.disableSelection): {
            e.selectAllNavigableItems(m), m.preventDefault();
            break;
          }
          // Type-ahead
          // TODO: Support typing multiple characters
          case (!y && !m.shiftKey && WDe(S)): {
            const E = s(v, S);
            E != null && (e.focusItem(m, E), m.preventDefault());
            break;
          }
        }
      }
    }
  };
};
Aie.params = {};
const Die = ({
  slots: e,
  slotProps: t
}) => ({
  contextValue: {
    icons: {
      slots: {
        collapseIcon: e.collapseIcon,
        expandIcon: e.expandIcon,
        endIcon: e.endIcon
      },
      slotProps: {
        collapseIcon: t.collapseIcon,
        expandIcon: t.expandIcon,
        endIcon: t.endIcon
      }
    }
  }
});
Die.params = {};
var Iie = {};
const NF = /* @__PURE__ */ $.createContext(null);
Iie.NODE_ENV !== "production" && (NF.displayName = "TreeViewChildrenItemContext");
function MF(e) {
  const {
    children: t,
    itemId: n = null
  } = e, {
    instance: r,
    treeId: i,
    rootRef: o
  } = Ux(), s = $.useRef(/* @__PURE__ */ new Map());
  $.useEffect(() => {
    if (!o.current)
      return;
    let f = null;
    if (n == null)
      f = o.current.id;
    else {
      const E = r.getItemMeta(n);
      E !== void 0 && (f = bI({
        itemId: n,
        treeId: i,
        id: E.idAttribute
      }));
    }
    if (f == null)
      return;
    const p = r.getItemOrderedChildrenIds(n ?? null) ?? [], m = BDe(f), v = o.current.querySelectorAll(`${n == null ? "" : `*[id="${m}"] `}[role="treeitem"]:not(*[id="${m}"] [role="treeitem"] [role="treeitem"])`), y = Array.from(v).map((E) => s.current.get(E.id));
    (y.length !== p.length || y.some((E, w) => E !== p[w])) && r.setJSXItemsOrderedChildrenIds(n ?? null, y);
  });
  const u = $.useMemo(() => ({
    registerChild: (f, p) => s.current.set(f, p),
    unregisterChild: (f) => s.current.delete(f),
    parentId: n
  }), [n]);
  return /* @__PURE__ */ T.jsx(NF.Provider, {
    value: u,
    children: t
  });
}
Iie.NODE_ENV !== "production" && (MF.propTypes = {
  children: c.node,
  id: c.string
});
const w_ = ({
  instance: e,
  setState: t
}) => {
  e.preventItemUpdates();
  const n = Mr((o) => (t((s) => {
    if (s.items.itemMetaMap[o.id] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${o.id}"`].join(`
`));
    return $t({}, s, {
      items: $t({}, s.items, {
        itemMetaMap: $t({}, s.items.itemMetaMap, {
          [o.id]: o
        }),
        // For Simple Tree View, we don't have a proper `item` object, so we create a very basic one.
        itemMap: $t({}, s.items.itemMap, {
          [o.id]: {
            id: o.id,
            label: o.label
          }
        })
      })
    });
  }), () => {
    t((s) => {
      const u = $t({}, s.items.itemMetaMap), f = $t({}, s.items.itemMap);
      return delete u[o.id], delete f[o.id], $t({}, s, {
        items: $t({}, s.items, {
          itemMetaMap: u,
          itemMap: f
        })
      });
    }), Sie(e, "removeItem", {
      id: o.id
    });
  })), r = (o, s) => {
    const u = o ?? Cv;
    t((f) => $t({}, f, {
      items: $t({}, f.items, {
        itemOrderedChildrenIds: $t({}, f.items.itemOrderedChildrenIds, {
          [u]: s
        }),
        itemChildrenIndexes: $t({}, f.items.itemChildrenIndexes, {
          [u]: wie(s)
        })
      })
    }));
  }, i = Mr((o, s) => (e.updateFirstCharMap((u) => (u[o] = s, u)), () => {
    e.updateFirstCharMap((u) => {
      const f = $t({}, u);
      return delete f[o], f;
    });
  }));
  return {
    instance: {
      insertJSXItem: n,
      setJSXItemsOrderedChildrenIds: r,
      mapFirstCharFromJSX: i
    }
  };
}, Pie = (e) => Array.isArray(e) ? e.length > 0 && e.some(Pie) : !!e, HDe = ({
  props: e,
  rootRef: t,
  contentRef: n
}) => {
  const {
    instance: r,
    treeId: i
  } = Ux(), {
    children: o,
    disabled: s = !1,
    label: u,
    itemId: f,
    id: p
  } = e, m = $.useContext(NF);
  if (m == null)
    throw new Error(["MUI X: Could not find the Tree View Children Item context.", "It looks like you rendered your component outside of a SimpleTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  const {
    registerChild: v,
    unregisterChild: y,
    parentId: S
  } = m, E = Pie(o), w = $.useRef(null), _ = kr(w, n);
  return gs(() => {
    const O = bI({
      itemId: f,
      treeId: i,
      id: p
    });
    return v(O, f), () => {
      y(O);
    };
  }, [v, y, f, p, i]), $.useEffect(() => r.insertJSXItem({
    id: f,
    idAttribute: p,
    parentId: S,
    expandable: E,
    disabled: s
  }), [r, S, f, E, s, p]), $.useEffect(() => {
    var O;
    if (u)
      return r.mapFirstCharFromJSX(f, (((O = w.current) == null ? void 0 : O.textContent) ?? "").substring(0, 1).toLowerCase());
  }, [r, f, u]), {
    contentRef: _,
    rootRef: t
  };
};
w_.itemPlugin = HDe;
w_.wrapItem = ({
  children: e,
  itemId: t
}) => {
  const n = $.useContext(hx);
  return /* @__PURE__ */ T.jsx(MF, {
    itemId: t,
    children: /* @__PURE__ */ T.jsx(hx.Provider, {
      value: n + 1,
      children: e
    })
  });
};
w_.wrapRoot = ({
  children: e
}) => /* @__PURE__ */ T.jsx(MF, {
  children: /* @__PURE__ */ T.jsx(hx.Provider, {
    value: 0,
    children: e
  })
});
w_.params = {};
const qDe = [S_, xI, SI, PF, Aie, Die, w_];
var Nie = {};
const $De = yie(), GDe = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, fDe, t);
}, YDe = ye("ul", {
  name: "MuiSimpleTreeView",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  margin: 0,
  listStyle: "none",
  outline: 0,
  position: "relative"
}), XDe = [], Mie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = $De({
    props: t,
    name: "MuiSimpleTreeView"
  }), i = r;
  Nie.NODE_ENV !== "production" && r.items != null && yA(["MUI X: The Simple Tree View component does not support the `items` prop.", "If you want to add items, you need to pass them as JSX children.", "Check the documentation for more details: https://mui.com/x/react-tree-view/simple-tree-view/items/."]);
  const {
    getRootProps: o,
    contextValue: s
  } = EDe({
    plugins: qDe,
    rootRef: n,
    props: $t({}, r, {
      items: XDe
    })
  }), {
    slots: u,
    slotProps: f
  } = r, p = GDe(r), m = (u == null ? void 0 : u.root) ?? YDe, v = Oo({
    elementType: m,
    externalSlotProps: f == null ? void 0 : f.root,
    className: p.root,
    getSlotProps: o,
    ownerState: i
  });
  return /* @__PURE__ */ T.jsx(CDe, {
    value: s,
    children: /* @__PURE__ */ T.jsx(m, $t({}, v))
  });
});
Nie.NODE_ENV !== "production" && (Mie.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows Tree View manipulation. Can be instantiated with `useTreeViewApiRef()`.
   */
  apiRef: c.shape({
    current: c.shape({
      focusItem: c.func.isRequired,
      getItem: c.func.isRequired,
      getItemDOMElement: c.func.isRequired,
      getItemOrderedChildrenIds: c.func.isRequired,
      getItemTree: c.func.isRequired,
      selectItem: c.func.isRequired,
      setItemExpansion: c.func.isRequired
    })
  }),
  /**
   * If `true`, the Tree View renders a checkbox at the left of its label that allows selecting it.
   * @default false
   */
  checkboxSelection: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  className: c.string,
  /**
   * Expanded item ids.
   * Used when the item's expansion is not controlled.
   * @default []
   */
  defaultExpandedItems: c.arrayOf(c.string),
  /**
   * Selected item ids. (Uncontrolled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   * @default []
   */
  defaultSelectedItems: c.any,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true` selection is disabled.
   * @default false
   */
  disableSelection: c.bool,
  /**
   * Expanded item ids.
   * Used when the item's expansion is controlled.
   */
  expandedItems: c.arrayOf(c.string),
  /**
   * The slot that triggers the item's expansion when clicked.
   * @default 'content'
   */
  expansionTrigger: c.oneOf(["content", "iconContainer"]),
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`,
   * the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: c.shape({
    indentationAtItemLevel: c.bool
  }),
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: c.string,
  /**
   * Horizontal indentation between an item and its children.
   * Examples: 24, "24px", "2rem", "2em".
   * @default 12px
   */
  itemChildrenIndentation: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, `ctrl` and `shift` will trigger multiselect.
   * @default false
   */
  multiSelect: c.bool,
  /**
   * Callback fired when Tree Items are expanded/collapsed.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemIds The ids of the expanded items.
   */
  onExpandedItemsChange: c.func,
  /**
   * Callback fired when the `content` slot of a given Tree Item is clicked.
   * @param {React.MouseEvent} event The DOM event that triggered the change.
   * @param {string} itemId The id of the focused item.
   */
  onItemClick: c.func,
  /**
   * Callback fired when a Tree Item is expanded or collapsed.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isExpanded `true` if the item has just been expanded, `false` if it has just been collapsed.
   */
  onItemExpansionToggle: c.func,
  /**
   * Callback fired when a given Tree Item is focused.
   * @param {React.SyntheticEvent | null} event The DOM event that triggered the change. **Warning**: This is a generic event not a focus event.
   * @param {string} itemId The id of the focused item.
   */
  onItemFocus: c.func,
  /**
   * Callback fired when a Tree Item is selected or deselected.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isSelected `true` if the item has just been selected, `false` if it has just been deselected.
   */
  onItemSelectionToggle: c.func,
  /**
   * Callback fired when Tree Items are selected/deselected.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {string[] | string} itemIds The ids of the selected items.
   * When `multiSelect` is `true`, this is an array of strings; when false (default) a string.
   */
  onSelectedItemsChange: c.func,
  /**
   * Selected item ids. (Controlled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   */
  selectedItems: c.any,
  /**
   * The props used for each component slot.
   */
  slotProps: c.object,
  /**
   * Overridable component slots.
   */
  slots: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function ZDe(e) {
  return Vt("PrivateSwitchBase", e);
}
Wt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
var KDe = {};
const QDe = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: i
  } = e, o = {
    root: ["root", n && "checked", r && "disabled", i && `edge${Ke(i)}`],
    input: ["input"]
  };
  return Ft(o, ZDe, t);
}, JDe = ye(Ws, {
  name: "MuiSwitchBase"
})({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), eIe = ye("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: ha
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), jie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: i,
    checkedIcon: o,
    defaultChecked: s,
    disabled: u,
    disableFocusRipple: f = !1,
    edge: p = !1,
    icon: m,
    id: v,
    inputProps: y,
    inputRef: S,
    name: E,
    onBlur: w,
    onChange: _,
    onFocus: O,
    readOnly: D,
    required: P = !1,
    tabIndex: M,
    type: N,
    value: k,
    slots: U = {},
    slotProps: H = {},
    ...Y
  } = t, [z, V] = ip({
    controlled: i,
    default: !!s,
    name: "SwitchBase",
    state: "checked"
  }), F = pp(), X = (pe) => {
    O && O(pe), F && F.onFocus && F.onFocus(pe);
  }, oe = (pe) => {
    w && w(pe), F && F.onBlur && F.onBlur(pe);
  }, re = (pe) => {
    if (pe.nativeEvent.defaultPrevented)
      return;
    const me = pe.target.checked;
    V(me), _ && _(pe, me);
  };
  let Z = u;
  F && typeof Z > "u" && (Z = F.disabled);
  const ee = N === "checkbox" || N === "radio", J = {
    ...t,
    checked: z,
    disabled: Z,
    disableFocusRipple: f,
    edge: p
  }, le = QDe(J), be = {
    slots: U,
    slotProps: {
      input: y,
      ...H
    }
  }, [ne, ae] = Xt("root", {
    ref: n,
    elementType: JDe,
    className: le.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...be,
      component: "span",
      ...Y
    },
    getSlotProps: (pe) => ({
      ...pe,
      onFocus: (me) => {
        var Ee;
        (Ee = pe.onFocus) == null || Ee.call(pe, me), X(me);
      },
      onBlur: (me) => {
        var Ee;
        (Ee = pe.onBlur) == null || Ee.call(pe, me), oe(me);
      }
    }),
    ownerState: J,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !f,
      disabled: Z,
      role: void 0,
      tabIndex: null
    }
  }), [ie, he] = Xt("input", {
    ref: S,
    elementType: eIe,
    className: le.input,
    externalForwardedProps: be,
    getSlotProps: (pe) => ({
      onChange: (me) => {
        var Ee;
        (Ee = pe.onChange) == null || Ee.call(pe, me), re(me);
      }
    }),
    ownerState: J,
    additionalProps: {
      autoFocus: r,
      checked: i,
      defaultChecked: s,
      disabled: Z,
      id: ee ? v : void 0,
      name: E,
      readOnly: D,
      required: P,
      tabIndex: M,
      type: N,
      ...N === "checkbox" && k === void 0 ? {} : {
        value: k
      }
    }
  });
  return /* @__PURE__ */ T.jsxs(ne, {
    ...ae,
    children: [/* @__PURE__ */ T.jsx(ie, {
      ...he
    }), z ? o : m]
  });
});
KDe.NODE_ENV !== "production" && (jie.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: c.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: c.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * @ignore
   */
  defaultChecked: c.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: c.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: c.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /*
   * @ignore
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: c.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    input: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.object,
  /**
   * @ignore
   */
  tabIndex: c.oneOfType([c.number, c.string]),
  /**
   * The input component prop `type`.
   */
  type: c.string.isRequired,
  /**
   * The value of the component.
   */
  value: c.any
});
const tIe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), nIe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), rIe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function iIe(e) {
  return Vt("MuiCheckbox", e);
}
const uz = Wt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]);
var oIe = {};
const aIe = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: i
  } = e, o = {
    root: ["root", n && "indeterminate", `color${Ke(r)}`, `size${Ke(i)}`]
  }, s = Ft(o, iIe, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...s
  };
}, sIe = ye(jie, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Ke(n.size)}`], n.color !== "default" && t[`color${Ke(n.color)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cn(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${uz.checked}, &.${uz.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${uz.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), lIe = /* @__PURE__ */ T.jsx(nIe, {}), cIe = /* @__PURE__ */ T.jsx(tIe, {}), uIe = /* @__PURE__ */ T.jsx(rIe, {}), Lie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: i = lIe,
    color: o = "primary",
    icon: s = cIe,
    indeterminate: u = !1,
    indeterminateIcon: f = uIe,
    inputProps: p,
    size: m = "medium",
    disableRipple: v = !1,
    className: y,
    slots: S = {},
    slotProps: E = {},
    ...w
  } = r, _ = u ? f : s, O = u ? f : i, D = {
    ...r,
    disableRipple: v,
    color: o,
    indeterminate: u,
    size: m
  }, P = aIe(D), M = E.input ?? p, [N, k] = Xt("root", {
    ref: n,
    elementType: sIe,
    className: yt(P.root, y),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: S,
      slotProps: E,
      ...w
    },
    ownerState: D,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ $.cloneElement(_, {
        fontSize: _.props.fontSize ?? m
      }),
      checkedIcon: /* @__PURE__ */ $.cloneElement(O, {
        fontSize: O.props.fontSize ?? m
      }),
      disableRipple: v,
      slots: S,
      slotProps: {
        input: sF(typeof M == "function" ? M(D) : M, {
          "data-indeterminate": u
        })
      }
    }
  });
  return /* @__PURE__ */ T.jsx(N, {
    ...k,
    classes: P
  });
});
oIe.NODE_ENV !== "production" && (Lie.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: c.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: c.node,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: c.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: c.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: c.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: c.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: c.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    input: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: c.any
});
function kie(e) {
  const {
    instance: t,
    items: {
      onItemClick: n
    },
    selection: {
      multiSelect: r,
      checkboxSelection: i,
      disableSelection: o
    },
    expansion: {
      expansionTrigger: s
    }
  } = Ux(), u = t.isItemExpandable(e), f = t.isItemExpanded(e), p = t.isItemFocused(e), m = t.isItemSelected(e), v = t.isItemDisabled(e), y = t != null && t.isItemBeingEdited ? t == null ? void 0 : t.isItemBeingEdited(e) : !1, S = t.isItemEditable ? t.isItemEditable(e) : !1, E = (N) => {
    if (!v) {
      p || t.focusItem(N, e);
      const k = r && (N.shiftKey || N.ctrlKey || N.metaKey);
      u && !(k && t.isItemExpanded(e)) && t.toggleItemExpansion(N, e);
    }
  }, w = (N) => {
    v || (!p && !y && t.focusItem(N, e), r && (N.shiftKey || N.ctrlKey || N.metaKey) ? N.shiftKey ? t.expandSelectionRange(N, e) : t.selectItem({
      event: N,
      itemId: e,
      keepExistingSelection: !0
    }) : t.selectItem({
      event: N,
      itemId: e,
      shouldBeSelected: !0
    }));
  }, _ = (N) => {
    if (o || v)
      return;
    const k = N.nativeEvent.shiftKey;
    r && k ? t.expandSelectionRange(N, e) : t.selectItem({
      event: N,
      itemId: e,
      keepExistingSelection: r,
      shouldBeSelected: N.target.checked
    });
  }, O = (N) => {
    (N.shiftKey || N.ctrlKey || N.metaKey || v) && N.preventDefault();
  }, D = () => {
    BO(t, tg) && t.isItemEditable(e) && (t.isItemBeingEdited(e) ? t.setEditedItemId(null) : t.setEditedItemId(e));
  };
  return {
    disabled: v,
    expanded: f,
    selected: m,
    focused: p,
    editable: S,
    editing: y,
    disableSelection: o,
    checkboxSelection: i,
    handleExpansion: E,
    handleSelection: w,
    handleCheckboxSelection: _,
    handleContentClick: n,
    preventSelection: O,
    expansionTrigger: s,
    toggleItemEditing: D,
    handleSaveItemLabel: (N, k) => {
      BO(t, tg) && t.isItemBeingEditedRef(e) && (t.updateItemLabel(e, k), D(), t.focusItem(N, e));
    },
    handleCancelItemLabelEditing: (N) => {
      BO(t, tg) && t.isItemBeingEditedRef(e) && (D(), t.focusItem(N, e));
    }
  };
}
var dIe = {};
const fIe = ye("div", {
  name: "MuiTreeItem2DragAndDropOverlay",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => yhe(e) && e !== "action"
})(({
  theme: e
}) => ({
  position: "absolute",
  left: 0,
  display: "flex",
  top: 0,
  bottom: 0,
  right: 0,
  pointerEvents: "none",
  variants: [{
    props: {
      action: "make-child"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderRadius: e.shape.borderRadius,
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.darkChannel} / ${e.vars.palette.action.focusOpacity})` : _u(e.palette.primary.dark, e.palette.action.focusOpacity)
    }
  }, {
    props: {
      action: "reorder-above"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderTop: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "reorder-below"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "move-to-parent"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }]
}));
function zie(e) {
  return e.action == null ? null : /* @__PURE__ */ T.jsx(fIe, $t({}, e));
}
dIe.NODE_ENV !== "production" && (zie.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  action: c.oneOf(["make-child", "move-to-parent", "reorder-above", "reorder-below"]),
  style: c.object
});
const pIe = ye("input", {
  name: "MuiTreeItem2",
  slot: "LabelInput",
  overridesResolver: (e, t) => t.labelInput
})(({
  theme: e
}) => $t({}, e.typography.body1, {
  width: "100%",
  backgroundColor: e.palette.background.paper,
  borderRadius: e.shape.borderRadius,
  border: "none",
  padding: "0 2px",
  boxSizing: "border-box",
  "&:focus": {
    outline: `1px solid ${e.palette.primary.main}`
  }
}));
var hIe = {};
const gIe = ["classes", "className", "displayIcon", "expansionIcon", "icon", "label", "itemId", "onClick", "onMouseDown", "dragAndDropOverlayProps", "labelInputProps"], jF = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const {
    classes: r,
    className: i,
    displayIcon: o,
    expansionIcon: s,
    icon: u,
    label: f,
    itemId: p,
    onClick: m,
    onMouseDown: v,
    dragAndDropOverlayProps: y,
    labelInputProps: S
  } = t, E = Dl(t, gIe), {
    disabled: w,
    expanded: _,
    selected: O,
    focused: D,
    editing: P,
    editable: M,
    disableSelection: N,
    checkboxSelection: k,
    handleExpansion: U,
    handleSelection: H,
    handleCheckboxSelection: Y,
    handleContentClick: z,
    preventSelection: V,
    expansionTrigger: F,
    toggleItemEditing: X
  } = kie(p), oe = u || s || o, re = $.useRef(null), Z = (le) => {
    V(le), v && v(le);
  }, ee = (le) => {
    var be;
    z == null || z(le, p), !((be = re.current) != null && be.contains(le.target)) && (F === "content" && U(le), k || H(le), m && m(le));
  }, J = (le) => {
    le.defaultMuiPrevented || X();
  };
  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */
    /* @__PURE__ */ T.jsxs("div", $t({}, E, {
      className: yt(r.root, i, _ && r.expanded, O && r.selected, D && r.focused, w && r.disabled, P && r.editing, M && r.editable),
      onClick: ee,
      onMouseDown: Z,
      ref: n,
      children: [/* @__PURE__ */ T.jsx("div", {
        className: r.iconContainer,
        children: oe
      }), k && /* @__PURE__ */ T.jsx(Lie, {
        className: r.checkbox,
        checked: O,
        onChange: Y,
        disabled: w || N,
        ref: re,
        tabIndex: -1
      }), P ? /* @__PURE__ */ T.jsx(pIe, $t({}, S, {
        className: r.labelInput
      })) : /* @__PURE__ */ T.jsx("div", $t({
        className: r.label
      }, M && {
        onDoubleClick: J
      }, {
        children: f
      })), y && /* @__PURE__ */ T.jsx(zie, $t({}, y))]
    }))
  );
});
hIe.NODE_ENV !== "production" && (jF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object.isRequired,
  className: c.string,
  /**
   * The icon to display next to the Tree Item's label. Either a parent or end icon.
   */
  displayIcon: c.node,
  dragAndDropOverlayProps: c.shape({
    action: c.oneOf(["make-child", "move-to-parent", "reorder-above", "reorder-below"]),
    style: c.object
  }),
  /**
   * The icon to display next to the Tree Item's label. Either an expansion or collapse icon.
   */
  expansionIcon: c.node,
  /**
   * The icon to display next to the Tree Item's label.
   */
  icon: c.node,
  /**
   * The id of the item.
   */
  itemId: c.string.isRequired,
  /**
   * The Tree Item label.
   */
  label: c.node,
  labelInputProps: c.shape({
    autoFocus: c.oneOf([!0]),
    "data-element": c.oneOf(["labelInput"]),
    onBlur: c.func,
    onChange: c.func,
    onKeyDown: c.func,
    type: c.oneOf(["text"]),
    value: c.string
  })
});
function mIe(e) {
  return Vt("MuiTreeItem", e);
}
const Zf = Wt("MuiTreeItem", ["root", "groupTransition", "content", "expanded", "selected", "focused", "disabled", "iconContainer", "label", "checkbox", "labelInput", "editable", "editing", "dragAndDropOverlay"]), vIe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "TreeViewExpandIcon"), yIe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "TreeViewCollapseIcon");
function Bie(e) {
  const {
    children: t,
    itemId: n
  } = e, {
    wrapItem: r,
    instance: i
  } = Ux();
  return r({
    children: t,
    itemId: n,
    instance: i
  });
}
Bie.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: c.node,
  itemId: c.string.isRequired
};
var Vie = {};
const bIe = ["children", "className", "slots", "slotProps", "ContentComponent", "ContentProps", "itemId", "id", "label", "onClick", "onMouseDown", "onFocus", "onBlur", "onKeyDown"], xIe = ["ownerState"], SIe = ["ownerState"], wIe = ["ownerState"], TIe = yie(), EIe = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    labelInput: ["labelInput"],
    editing: ["editing"],
    editable: ["editable"],
    groupTransition: ["groupTransition"]
  }, mIe, t);
}, _Ie = ye("li", {
  name: "MuiTreeItem",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), CIe = ye(jF, {
  name: "MuiTreeItem",
  slot: "Content",
  overridesResolver: (e, t) => [t.content, t.iconContainer && {
    [`& .${Zf.iconContainer}`]: t.iconContainer
  }, t.label && {
    [`& .${Zf.label}`]: t.label
  }],
  shouldForwardProp: (e) => kE(e) && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Zf.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    backgroundColor: "transparent"
  },
  [`&.${Zf.focused}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Zf.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _u(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : _u(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : _u(e.palette.primary.main, e.palette.action.selectedOpacity)
      }
    },
    [`&.${Zf.focused}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : _u(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`& .${Zf.iconContainer}`]: {
    width: 16,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& svg": {
      fontSize: 18
    }
  },
  [`& .${Zf.label}`]: $t({
    width: "100%",
    boxSizing: "border-box",
    // prevent width + padding to overflow
    // fixes overflow - see https://github.com/mui/material-ui/issues/27372
    minWidth: 0,
    position: "relative"
  }, e.typography.body1),
  [`& .${Zf.checkbox}`]: {
    padding: 0
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }]
})), RIe = ye(px, {
  name: "MuiTreeItem",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => kE(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), Uie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  var ht, Yt, Rt, cn;
  const {
    icons: r,
    runItemPlugins: i,
    items: {
      disabledItemsFocusable: o,
      indentationAtItemLevel: s
    },
    selection: {
      disableSelection: u
    },
    expansion: {
      expansionTrigger: f
    },
    treeId: p,
    instance: m
  } = Ux(), v = $.useContext(hx), y = TIe({
    props: t,
    name: "MuiTreeItem"
  }), {
    children: S,
    className: E,
    slots: w,
    slotProps: _,
    ContentComponent: O = jF,
    ContentProps: D,
    itemId: P,
    id: M,
    label: N,
    onClick: k,
    onMouseDown: U,
    onBlur: H,
    onKeyDown: Y
  } = y, z = Dl(y, bIe), {
    expanded: V,
    focused: F,
    selected: X,
    disabled: oe,
    editing: re,
    handleExpansion: Z,
    handleCancelItemLabelEditing: ee,
    handleSaveItemLabel: J
  } = kie(P);
  Vie.NODE_ENV !== "production" && (y.ContentComponent && yA(["MUI X: The ContentComponent prop of the TreeItem component is deprecated and will be removed in the next major release.", "You can use the new TreeItem2 component or the new useTreeItem2 hook to customize the rendering of the content.", "For more detail, see https://mui.com/x/react-tree-view/tree-item-customization/."]), y.ContentProps && yA(["MUI X: The ContentProps prop of the TreeItem component is deprecated and will be removed in the next major release.", "You can use the new TreeItem2 component or the new useTreeItem2 hook to customize the rendering of the content.", "For more detail, see https://mui.com/x/react-tree-view/tree-item-customization/."]));
  const {
    contentRef: le,
    rootRef: be,
    propsEnhancers: ne
  } = i(y), ae = $.useRef(null), ie = $.useRef(null), he = kr(n, be, ae), pe = kr(D == null ? void 0 : D.ref, le, ie), me = {
    expandIcon: (w == null ? void 0 : w.expandIcon) ?? r.slots.expandIcon ?? vIe,
    collapseIcon: (w == null ? void 0 : w.collapseIcon) ?? r.slots.collapseIcon ?? yIe,
    endIcon: (w == null ? void 0 : w.endIcon) ?? r.slots.endIcon,
    icon: w == null ? void 0 : w.icon,
    groupTransition: w == null ? void 0 : w.groupTransition
  }, Ee = (Kt) => Array.isArray(Kt) ? Kt.length > 0 && Kt.some(Ee) : !!Kt, Ie = Ee(S), Pe = $t({}, y, {
    expanded: V,
    focused: F,
    selected: X,
    disabled: oe,
    indentationAtItemLevel: s
  }), De = EIe(Pe), Ye = me.groupTransition ?? void 0, Ue = Oo({
    elementType: Ye,
    ownerState: {},
    externalSlotProps: _ == null ? void 0 : _.groupTransition,
    additionalProps: $t({
      unmountOnExit: !0,
      in: V,
      component: "ul",
      role: "group"
    }, s ? {
      indentationAtItemLevel: !0
    } : {}),
    className: De.groupTransition
  }), ve = (Kt) => {
    f === "iconContainer" && Z(Kt);
  }, rt = V ? me.collapseIcon : me.expandIcon, Te = Oo({
    elementType: rt,
    ownerState: {},
    externalSlotProps: (Kt) => V ? $t({}, Yh(r.slotProps.collapseIcon, Kt), Yh(_ == null ? void 0 : _.collapseIcon, Kt)) : $t({}, Yh(r.slotProps.expandIcon, Kt), Yh(_ == null ? void 0 : _.expandIcon, Kt)),
    additionalProps: {
      onClick: ve
    }
  }), Je = Dl(Te, xIe), L = Ie && rt ? /* @__PURE__ */ T.jsx(rt, $t({}, Je)) : null, te = Ie ? void 0 : me.endIcon, ge = Oo({
    elementType: te,
    ownerState: {},
    externalSlotProps: (Kt) => Ie ? {} : $t({}, Yh(r.slotProps.endIcon, Kt), Yh(_ == null ? void 0 : _.endIcon, Kt))
  }), ke = Dl(ge, SIe), We = te ? /* @__PURE__ */ T.jsx(te, $t({}, ke)) : null, Be = me.icon, je = Oo({
    elementType: Be,
    ownerState: {},
    externalSlotProps: _ == null ? void 0 : _.icon
  }), mt = Dl(je, wIe), qe = Be ? /* @__PURE__ */ T.jsx(Be, $t({}, mt)) : null;
  let at;
  X ? at = !0 : u || oe ? at = void 0 : at = !1;
  function et(Kt) {
    !F && (!oe || o) && Kt.currentTarget === Kt.target && m.focusItem(Kt, P);
  }
  function bt(Kt) {
    var Zt, dn, xr, Hr;
    H == null || H(Kt), !(re || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
    // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
    Kt.relatedTarget && uV(Kt.relatedTarget, ae.current) && (Kt.target && ((dn = (Zt = Kt.target) == null ? void 0 : Zt.dataset) == null ? void 0 : dn.element) === "labelInput" && uV(Kt.target, ae.current) || ((Hr = (xr = Kt.relatedTarget) == null ? void 0 : xr.dataset) == null ? void 0 : Hr.element) === "labelInput")) && m.removeFocusedItem();
  }
  const q = (Kt) => {
    var Zt, dn;
    Y == null || Y(Kt), ((dn = (Zt = Kt.target) == null ? void 0 : Zt.dataset) == null ? void 0 : dn.element) !== "labelInput" && m.handleItemKeyDown(Kt, P);
  }, W = bI({
    itemId: P,
    treeId: p,
    id: M
  }), Q = m.canItemBeTabbed(P) ? 0 : -1, ce = {
    rootRefObject: ae,
    contentRefObject: ie,
    interactions: {
      handleSaveItemLabel: J,
      handleCancelItemLabelEditing: ee
    }
  }, _e = ((ht = ne.root) == null ? void 0 : ht.call(ne, $t({}, ce, {
    externalEventHandlers: op(z)
  }))) ?? {}, Fe = ((Yt = ne.content) == null ? void 0 : Yt.call(ne, $t({}, ce, {
    externalEventHandlers: op(D)
  }))) ?? {}, gt = ((Rt = ne.dragAndDropOverlay) == null ? void 0 : Rt.call(ne, $t({}, ce, {
    externalEventHandlers: {}
  }))) ?? {}, ct = ((cn = ne.labelInput) == null ? void 0 : cn.call(ne, $t({}, ce, {
    externalEventHandlers: {}
  }))) ?? {};
  return /* @__PURE__ */ T.jsx(Bie, {
    itemId: P,
    children: /* @__PURE__ */ T.jsxs(_Ie, $t({
      className: yt(De.root, E),
      role: "treeitem",
      "aria-expanded": Ie ? V : void 0,
      "aria-selected": at,
      "aria-disabled": oe || void 0,
      id: W,
      tabIndex: Q
    }, z, {
      ownerState: Pe,
      onFocus: et,
      onBlur: bt,
      onKeyDown: q,
      ref: he,
      style: s ? $t({}, z.style, {
        "--TreeView-itemDepth": typeof v == "function" ? v(P) : v
      }) : z.style
    }, _e, {
      children: [/* @__PURE__ */ T.jsx(CIe, $t({
        as: O,
        classes: {
          root: De.content,
          expanded: De.expanded,
          selected: De.selected,
          focused: De.focused,
          disabled: De.disabled,
          editable: De.editable,
          editing: De.editing,
          iconContainer: De.iconContainer,
          label: De.label,
          labelInput: De.labelInput,
          checkbox: De.checkbox
        },
        label: N,
        itemId: P,
        onClick: k,
        onMouseDown: U,
        icon: qe,
        expansionIcon: L,
        displayIcon: We,
        ownerState: Pe
      }, D, Fe, gt.action == null ? {} : {
        dragAndDropOverlayProps: gt
      }, ct.value == null ? {} : {
        labelInputProps: ct
      }, {
        ref: pe
      })), S && /* @__PURE__ */ T.jsx(RIe, $t({
        as: Ye
      }, Ue, {
        children: S
      }))]
    }))
  });
});
Vie.NODE_ENV !== "production" && (Uie.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  className: c.string,
  /**
   * The component used to render the content of the item.
   * @deprecated Consider using the `<TreeItem2 />` component or the `useTreeItem2` hook instead. For more details, see https://mui.com/x/react-tree-view/tree-item-customization/.
   * @default TreeItemContent
   */
  ContentComponent: Qv,
  /**
   * Props applied to ContentComponent.
   * @deprecated Consider using the `<TreeItem2 />` component or the `useTreeItem2` hook instead. For more details, see https://mui.com/x/react-tree-view/tree-item-customization/.
   */
  ContentProps: c.object,
  /**
   * If `true`, the item is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * The id of the item.
   */
  itemId: c.string.isRequired,
  /**
   * The Tree Item label.
   */
  label: c.node,
  /**
   * This prop isn't supported.
   * Use the `onItemFocus` callback on the tree if you need to monitor a item's focus.
   */
  onFocus: nF,
  /**
   * Callback fired when a key of the keyboard is pressed on the item.
   */
  onKeyDown: c.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: c.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const OIe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight"), AIe = ye("div")(() => ({}));
function DIe(e) {
  const t = e.data.__jsonld;
  if (t.startCanvas && typeof t.startCanvas == "string")
    return t.startCanvas;
  if (t.start) {
    if (t.start.type === "Canvas" && typeof t.start.id == "string")
      return t.start.id;
    if (t.start.type === "SpecificResource" && typeof t.start.source == "string")
      return t.start.source;
  }
  return e.data.getCanvasIds()[0];
}
function Fie(e, t) {
  if (e.id === t)
    return e;
  let n = null;
  if (e.nodes)
    for (let r = 0; n == null && r < e.nodes.length; r += 1)
      n = Fie(e.nodes[r], t);
  return n;
}
const Wie = ({ children: e, itemId: t, ...n }) => /* @__PURE__ */ T.jsx(zx, { ...n, children: e });
Wie.propTypes = {
  children: c.node.isRequired,
  itemId: c.string.isRequired
};
const IIe = (e) => /* @__PURE__ */ T.jsx(sI, { ...e, color: "action" }), PIe = (e) => /* @__PURE__ */ T.jsx(OIe, { ...e, color: "action" });
function Hie({
  toggleNode: e,
  expandNodes: t,
  setCanvas: n,
  windowId: r,
  treeStructure: i,
  visibleNodeIds: o,
  expandedNodeIds: s,
  containerRef: u,
  nodeIdToScrollTo: f
}) {
  const p = (S, E) => {
    (S.key === " " || S.key === "Spacebar") && e(E), v(E);
  }, m = (S, E) => {
    t(E);
  }, v = (S) => {
    const E = Fie(i, S);
    if (!E.data.getCanvasIds() || E.data.getCanvasIds().length === 0 || E.nodes.length > 0)
      return;
    const w = DIe(E), _ = w.indexOf("#") === -1 ? w : w.substr(0, w.indexOf("#"));
    n(r, _);
  };
  if (!i)
    return null;
  const y = (S) => /* @__PURE__ */ T.jsx(
    Wie,
    {
      containerRef: u,
      itemId: S.id,
      offsetTop: 96,
      scrollTo: f === S.id,
      children: /* @__PURE__ */ T.jsx(
        Uie,
        {
          itemId: S.id,
          label: /* @__PURE__ */ T.jsx(
            AIe,
            {
              sx: (E) => {
                var w;
                return {
                  backgroundColor: o.indexOf(S.id) !== -1 && _u(((w = E.palette.highlights) == null ? void 0 : w.primary) || E.palette.action.selected, 0.35),
                  display: o.indexOf(S.id) !== -1 && "inline"
                };
              },
              children: S.label
            }
          ),
          children: S.nodes && S.nodes.length > 0 ? S.nodes.map(y) : null
        }
      )
    },
    S.id
  );
  return /* @__PURE__ */ T.jsx(
    Mie,
    {
      sx: { flexGrow: 1 },
      slots: {
        collapseIcon: IIe,
        endIcon: null,
        expandIcon: PIe
      },
      onSelectedItemsChange: p,
      onExpandedItemsChange: m,
      expandedItems: s,
      children: Array.isArray(i.nodes) && i.nodes.length > 0 ? i.nodes.map((S) => y(S)) : /* @__PURE__ */ T.jsx("p", { children: "No items found" })
    }
  );
}
Hie.propTypes = {
  containerRef: c.oneOfType([
    c.func,
    c.shape({ current: c.instanceOf(Element) })
  ]).isRequired,
  expandedNodeIds: c.arrayOf(c.string).isRequired,
  expandNodes: c.func.isRequired,
  nodeIdToScrollTo: c.string.isRequired,
  setCanvas: c.func.isRequired,
  toggleNode: c.func.isRequired,
  treeStructure: c.shape({
    id: c.string.isRequired,
    label: c.string.isRequired,
    nodes: c.arrayOf(c.shape({
      id: c.string.isRequired,
      label: c.string.isRequired,
      nodes: c.array
      // eslint-disable-line react/forbid-prop-types
    }))
  }).isRequired,
  visibleNodeIds: c.arrayOf(c.string).isRequired,
  windowId: c.string.isRequired
};
const NIe = (e, { id: t, windowId: n }) => ({
  expandedNodeIds: Ete(e, { companionWindowId: t, windowId: n }),
  nodeIdToScrollTo: _te(e, { companionWindowId: t, windowId: n }),
  treeStructure: U1(e, { windowId: n }),
  visibleNodeIds: C3(e, { companionWindowId: t, windowId: n })
}), MIe = (e, { id: t, windowId: n }) => ({
  expandNodes: (r) => e(Mte(n, t, r)),
  setCanvas: (...r) => e(Iu(...r)),
  toggleNode: (r) => e(Nte(n, t, r))
}), jIe = wt(
  At(NIe, MIe),
  Tt("SidebarIndexTableOfContents")
), LIe = jIe(Hie), kIe = ye("div")(() => ({
  flexBasis: "100%",
  height: 0
}));
function qie({
  collection: e = null,
  id: t,
  showMultipart: n,
  sequenceId: r = null,
  sequences: i = [],
  variant: o,
  showToc: s = !1,
  updateSequence: u,
  updateVariant: f,
  windowId: p
}) {
  const { t: m } = Ct(), v = an(), y = uo(), S = (_) => {
    u(_.target.value);
  }, E = (_, O) => {
    f(O);
  };
  let w;
  return o === "tableOfContents" ? w = /* @__PURE__ */ T.jsx(
    LIe,
    {
      id: t,
      containerRef: v,
      windowId: p
    }
  ) : w = /* @__PURE__ */ T.jsx(
    uDe,
    {
      id: t,
      containerRef: v,
      windowId: p
    }
  ), /* @__PURE__ */ T.jsx(
    Zd,
    {
      title: m("canvasIndex"),
      id: t,
      windowId: p,
      ref: v,
      titleControls: /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        i && i.length > 1 && /* @__PURE__ */ T.jsx(b_, { children: /* @__PURE__ */ T.jsx(
          Vx,
          {
            MenuProps: {
              anchorOrigin: {
                horizontal: "left",
                vertical: "bottom"
              }
            },
            displayEmpty: !0,
            value: r,
            onChange: S,
            name: "sequenceId",
            sx: {
              "&.MuiSelect-select": {
                "&:focus": {
                  backgroundColor: "background.paper"
                }
              },
              backgroundColor: "background.paper"
            },
            "data-testid": "sequence-select",
            children: i.map((_, O) => /* @__PURE__ */ T.jsx(qo, { value: _.id, children: /* @__PURE__ */ T.jsx(St, { variant: "body2", children: /* @__PURE__ */ T.jsx(Cc, { resource: _ }) }) }, _.id))
          }
        ) }),
        /* @__PURE__ */ T.jsx(kIe, {}),
        /* @__PURE__ */ T.jsxs(
          yI,
          {
            value: o,
            onChange: E,
            variant: "fullWidth",
            indicatorColor: "primary",
            textColor: "primary",
            children: [
              s && /* @__PURE__ */ T.jsx(Bd, { title: m("tableOfContentsList"), value: "tableOfContents", children: /* @__PURE__ */ T.jsx(ex, { sx: { minWidth: "auto" }, value: "tableOfContents", "aria-label": m("tableOfContentsList"), "aria-controls": y, icon: /* @__PURE__ */ T.jsx(QAe, { style: { transform: "scale(-1, 1)" } }) }) }),
              /* @__PURE__ */ T.jsx(Bd, { title: m("itemList"), value: "item", children: /* @__PURE__ */ T.jsx(ex, { sx: { minWidth: "auto" }, value: "item", "aria-label": m("itemList"), "aria-controls": y, icon: /* @__PURE__ */ T.jsx(KAe, {}) }) }),
              /* @__PURE__ */ T.jsx(Bd, { title: m("thumbnailList"), value: "thumbnail", children: /* @__PURE__ */ T.jsx(ex, { sx: { minWidth: "auto" }, value: "thumbnail", "aria-label": m("thumbnailList"), "aria-controls": y, icon: /* @__PURE__ */ T.jsx(AF, {}) }) })
            ]
          }
        )
      ] }),
      children: /* @__PURE__ */ T.jsxs("div", { id: y, children: [
        e && /* @__PURE__ */ T.jsx(
          hi,
          {
            fullWidth: !0,
            onClick: n,
            endIcon: /* @__PURE__ */ T.jsx(JAe, {}),
            children: /* @__PURE__ */ T.jsx(St, { sx: { textTransform: "none" }, children: /* @__PURE__ */ T.jsx(Cc, { resource: e }) })
          }
        ),
        w
      ] })
    }
  );
}
qie.propTypes = {
  collection: c.object,
  // eslint-disable-line react/forbid-prop-types
  id: c.string.isRequired,
  sequenceId: c.string,
  sequences: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  showMultipart: c.func.isRequired,
  showToc: c.bool,
  updateSequence: c.func.isRequired,
  updateVariant: c.func.isRequired,
  variant: c.oneOf(["item", "thumbnail", "tableOfContents"]).isRequired,
  windowId: c.string.isRequired
};
const zIe = (e, { id: t, windowId: n }) => {
  const r = U1(e, { windowId: n }), i = Wn(e, { windowId: n }), { config: o } = e, s = ju(e, { companionWindowId: t }), u = i.collectionPath || [], f = u && u[u.length - 1], p = Gd(e, { windowId: n });
  return {
    collection: f && nr(e, { manifestId: f }),
    config: o,
    sequenceId: p && p.id,
    sequences: c3(e, { windowId: n }),
    showToc: r && r.nodes && r.nodes.length > 0,
    variant: s.variant || R3(e, { windowId: n })
  };
}, BIe = (e, { id: t, windowId: n }) => ({
  showMultipart: () => e(
    I3(n, { content: "collection", position: "right" })
  ),
  updateSequence: (r) => e(
    Po(n, { sequenceId: r })
  ),
  updateVariant: (r) => e(
    Nx(n, t, { variant: r })
  )
}), VIe = wt(
  At(zIe, BIe),
  Tt("WindowSideBarCanvasPanel")
), UIe = VIe(qie);
function FIe(e) {
  return Vt("MuiSkeleton", e);
}
Wt("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
var WIe = {};
const HIe = (e) => {
  const {
    classes: t,
    variant: n,
    animation: r,
    hasChildren: i,
    width: o,
    height: s
  } = e;
  return Ft({
    root: ["root", n, r, i && "withChildren", i && !o && "fitContent", i && !s && "heightAuto"]
  }, FIe, t);
}, dV = Hv`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, fV = Hv`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, qIe = typeof dV != "string" ? ZA`
        animation: ${dV} 2s ease-in-out 0.5s infinite;
      ` : null, $Ie = typeof fV != "string" ? ZA`
        &::after {
          animation: ${fV} 2s linear 0.5s infinite;
        }
      ` : null, GIe = ye("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(Lt(({
  theme: e
}) => {
  const t = Vwe(e.shape.borderRadius) || "px", n = Uwe(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : _u(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${n}${t}/${Math.round(n / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: qIe || {
        animation: `${dV} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: $Ie || {
        "&::after": {
          animation: `${fV} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), pi = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: i = "pulse",
    className: o,
    component: s = "span",
    height: u,
    style: f,
    variant: p = "text",
    width: m,
    ...v
  } = r, y = {
    ...r,
    animation: i,
    component: s,
    variant: p,
    hasChildren: !!v.children
  }, S = HIe(y);
  return /* @__PURE__ */ T.jsx(GIe, {
    as: s,
    ref: n,
    className: yt(S.root, o),
    ownerState: y,
    ...v,
    style: {
      width: m,
      height: u,
      ...f
    }
  });
});
WIe.NODE_ENV !== "production" && (pi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: c.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: c.oneOfType([c.oneOf(["circular", "rectangular", "rounded", "text"]), c.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: c.oneOfType([c.number, c.string])
});
function d1(e) {
  "@babel/helpers - typeof";
  return d1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d1(e);
}
function YIe(e, t) {
  if (d1(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (d1(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function XIe(e) {
  var t = YIe(e, "string");
  return d1(t) == "symbol" ? t : t + "";
}
function LF(e, t, n) {
  return (t = XIe(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var $ie = (function(e) {
  var t = e.decode, n = t === void 0 ? !0 : t, r = e.crossOrigin, i = r === void 0 ? "" : r;
  return function(o) {
    return new Promise(function(s, u) {
      var f = new Image();
      i && (f.crossOrigin = i), f.onload = function() {
        n && f.decode ? f.decode().then(s).catch(u) : s();
      }, f.onerror = u, f.src = o;
    });
  };
});
function w7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w7(Object(n), !0).forEach(function(r) {
      LF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w7(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ZIe = function(t) {
  return t.filter(function(n) {
    return n;
  });
}, KIe = function(t) {
  return Array.isArray(t) ? t : [t];
}, wl = {}, QIe = function(t, n) {
  var r = !1;
  return new Promise(function(i, o) {
    var s = function(f) {
      return n(f).then(function() {
        r = !0, i(f);
      });
    };
    t.reduce(function(u, f) {
      return u.catch(function() {
        if (!r) return s(f);
      });
    }, s(t.shift())).catch(o);
  });
};
function JIe(e) {
  var t = e.srcList, n = e.imgPromise, r = n === void 0 ? $ie({
    decode: !0
  }) : n, i = e.useSuspense, o = i === void 0 ? !0 : i, s = Bn(!1), u = s[1], f = ZIe(KIe(t)), p = f.join("");
  if (wl[p] || (wl[p] = {
    promise: QIe(f, r),
    cache: "pending",
    error: null
  }), wl[p].cache === "resolved")
    return {
      src: wl[p].src,
      isLoading: !1,
      error: null
    };
  if (wl[p].cache === "rejected") {
    if (o) throw wl[p].error;
    return {
      isLoading: !1,
      error: wl[p].error,
      src: void 0
    };
  }
  if (wl[p].promise.then(function(m) {
    wl[p] = rO(rO({}, wl[p]), {}, {
      cache: "resolved",
      src: m
    }), o || u(p);
  }).catch(function(m) {
    wl[p] = rO(rO({}, wl[p]), {}, {
      cache: "rejected",
      error: m
    }), o || u(p);
  }), o) throw wl[p].promise;
  return {
    isLoading: !0,
    src: void 0,
    error: null
  };
}
var ePe = ["decode", "src", "loader", "unloader", "container", "loaderContainer", "unloaderContainer", "imgPromise", "crossorigin", "useSuspense"];
function T7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tPe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? T7(Object(n), !0).forEach(function(r) {
      LF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : T7(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var dz = function(t) {
  return t;
};
function wI(e) {
  var t = e.decode, n = t === void 0 ? !0 : t, r = e.src, i = r === void 0 ? [] : r, o = e.loader, s = o === void 0 ? null : o, u = e.unloader, f = u === void 0 ? null : u, p = e.container, m = p === void 0 ? dz : p, v = e.loaderContainer, y = v === void 0 ? dz : v, S = e.unloaderContainer, E = S === void 0 ? dz : S, w = e.imgPromise, _ = e.crossorigin, O = e.useSuspense, D = O === void 0 ? !1 : O, P = Dl(e, ePe);
  w = w || $ie({
    decode: n,
    crossOrigin: _
  });
  var M = JIe({
    srcList: i,
    imgPromise: w,
    useSuspense: D
  }), N = M.src, k = M.isLoading;
  return N ? m(/* @__PURE__ */ it.createElement("img", tPe({
    src: N
  }, P))) : !D && k ? y(s) : !D && f ? E(f) : null;
}
const nPe = ye(wI)(() => ({
  maxWidth: "100%"
})), rPe = ye(pi)(({ theme: e }) => ({
  backgroundColor: e.palette.grey[300]
}));
function Gie({
  manifestLogo: e = null,
  requiredStatement: t = null,
  rights: n = null,
  windowId: r,
  id: i
}) {
  const { t: o } = Ct(), s = arguments[0];
  return /* @__PURE__ */ T.jsxs(
    Zd,
    {
      title: o("attributionTitle"),
      paperClassName: Nt("attribution-panel"),
      windowId: r,
      id: i,
      children: [
        /* @__PURE__ */ T.jsxs(_v, { children: [
          t && /* @__PURE__ */ T.jsx(v_, { labelValuePairs: t, defaultLabel: o("attribution") }),
          n && n.length > 0 && /* @__PURE__ */ T.jsxs("dl", { className: Nt("label-value-metadata"), children: [
            /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: o("rights") }),
            n.map((u) => /* @__PURE__ */ T.jsx(St, { variant: "body1", component: "dd", children: /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: u, children: u }) }, u.toString()))
          ] })
        ] }),
        e && /* @__PURE__ */ T.jsx(_v, { children: /* @__PURE__ */ T.jsx(
          nPe,
          {
            src: [e],
            alt: "",
            role: "presentation",
            unloader: /* @__PURE__ */ T.jsx(rPe, { variant: "rectangular", height: 60, width: 60 })
          }
        ) }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "AttributionPanel", ...s })
      ]
    }
  );
}
Gie.propTypes = {
  id: c.string.isRequired,
  manifestLogo: c.string,
  requiredStatement: c.arrayOf(c.shape({
    label: c.string,
    value: c.string
  })),
  rights: c.arrayOf(c.string),
  windowId: c.string.isRequired
};
const iPe = (e, { id: t, windowId: n }) => ({
  manifestLogo: o3(e, { windowId: n }),
  requiredStatement: Yee(e, { windowId: n }),
  rights: s3(e, { windowId: n })
}), oPe = wt(
  At(iPe),
  Tt("AttributionPanel")
), aPe = oPe(Gie);
var fz, E7;
function sPe() {
  if (E7) return fz;
  E7 = 1;
  function e(t) {
    return function(n) {
      return t == null ? void 0 : t[n];
    };
  }
  return fz = e, fz;
}
var pz, _7;
function lPe() {
  if (_7) return pz;
  _7 = 1;
  var e = sPe(), t = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, n = e(t);
  return pz = n, pz;
}
var hz, C7;
function cPe() {
  if (C7) return hz;
  C7 = 1;
  var e = lPe(), t = TU(), n = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, r = "\\u0300-\\u036f", i = "\\ufe20-\\ufe2f", o = "\\u20d0-\\u20ff", s = r + i + o, u = "[" + s + "]", f = RegExp(u, "g");
  function p(m) {
    return m = t(m), m && m.replace(n, e).replace(f, "");
  }
  return hz = p, hz;
}
var uPe = cPe();
const R7 = /* @__PURE__ */ Hn(uPe);
var dPe = Mu();
const TI = /* @__PURE__ */ Hn(dPe);
function kF(e, t, n, r) {
  var i = this, o = an(null), s = an(0), u = an(0), f = an(null), p = an([]), m = an(), v = an(), y = an(e), S = an(!0);
  y.current = e;
  var E = typeof window < "u", w = !t && t !== 0 && E;
  if (typeof e != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var _ = !!(n = n || {}).leading, O = !("trailing" in n) || !!n.trailing, D = "maxWait" in n, P = "debounceOnServer" in n && !!n.debounceOnServer, M = D ? Math.max(+n.maxWait || 0, t) : null;
  ln(function() {
    return S.current = !0, function() {
      S.current = !1;
    };
  }, []);
  var N = Ui(function() {
    var k = function(X) {
      var oe = p.current, re = m.current;
      return p.current = m.current = null, s.current = X, u.current = u.current || X, v.current = y.current.apply(re, oe);
    }, U = function(X, oe) {
      w && cancelAnimationFrame(f.current), f.current = w ? requestAnimationFrame(X) : setTimeout(X, oe);
    }, H = function(X) {
      if (!S.current) return !1;
      var oe = X - o.current;
      return !o.current || oe >= t || oe < 0 || D && X - s.current >= M;
    }, Y = function(X) {
      return f.current = null, O && p.current ? k(X) : (p.current = m.current = null, v.current);
    }, z = function X() {
      var oe = Date.now();
      if (_ && u.current === s.current && V(), H(oe)) return Y(oe);
      if (S.current) {
        var re = t - (oe - o.current), Z = D ? Math.min(re, M - (oe - s.current)) : re;
        U(X, Z);
      }
    }, V = function() {
    }, F = function() {
      if (E || P) {
        var X = Date.now(), oe = H(X);
        if (p.current = [].slice.call(arguments), m.current = i, o.current = X, oe) {
          if (!f.current && S.current) return s.current = o.current, U(z, t), _ ? k(o.current) : v.current;
          if (D) return U(z, t), k(o.current);
        }
        return f.current || U(z, t), v.current;
      }
    };
    return F.cancel = function() {
      f.current && (w ? cancelAnimationFrame(f.current) : clearTimeout(f.current)), s.current = 0, p.current = o.current = m.current = f.current = null;
    }, F.isPending = function() {
      return !!f.current;
    }, F.flush = function() {
      return f.current ? Y(Date.now()) : v.current;
    }, F;
  }, [_, D, t, M, O, w, E, P, r]);
  return N;
}
var iO = {};
function O7(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function fPe(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: i = "any",
    stringify: o,
    trim: s = !1
  } = e;
  return (u, {
    inputValue: f,
    getOptionLabel: p
  }) => {
    let m = s ? f.trim() : f;
    n && (m = m.toLowerCase()), t && (m = O7(m));
    const v = m ? u.filter((y) => {
      let S = (o || p)(y);
      return n && (S = S.toLowerCase()), t && (S = O7(S)), i === "start" ? S.startsWith(m) : S.includes(m);
    }) : u;
    return typeof r == "number" ? v.slice(0, r) : v;
  };
}
const pPe = fPe(), A7 = 5, hPe = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, gPe = [];
function D7(e, t, n) {
  if (t || e == null)
    return "";
  const r = n(e);
  return typeof r == "string" ? r : "";
}
function mPe(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = hPe,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: i = !1,
    autoSelect: o = !1,
    blurOnSelect: s = !1,
    clearOnBlur: u = !e.freeSolo,
    clearOnEscape: f = !1,
    componentName: p = "useAutocomplete",
    defaultValue: m = e.multiple ? gPe : null,
    disableClearable: v = !1,
    disableCloseOnSelect: y = !1,
    disabled: S,
    disabledItemsFocusable: E = !1,
    disableListWrap: w = !1,
    filterOptions: _ = pPe,
    filterSelectedOptions: O = !1,
    freeSolo: D = !1,
    getOptionDisabled: P,
    getOptionKey: M,
    getOptionLabel: N = (Le) => Le.label ?? Le,
    groupBy: k,
    handleHomeEndKeys: U = !e.freeSolo,
    id: H,
    includeInputInList: Y = !1,
    inputValue: z,
    isOptionEqualToValue: V = (Le, de) => Le === de,
    multiple: F = !1,
    onChange: X,
    onClose: oe,
    onHighlightChange: re,
    onInputChange: Z,
    onOpen: ee,
    open: J,
    openOnFocus: le = !1,
    options: be,
    readOnly: ne = !1,
    selectOnFocus: ae = !e.freeSolo,
    value: ie
  } = e, he = Jv(H);
  let pe = N;
  pe = (Le) => {
    const de = N(Le);
    if (typeof de != "string") {
      if (iO.NODE_ENV !== "production") {
        const Ne = de === void 0 ? "undefined" : `${typeof de} (${de})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${p} returned ${Ne} instead of a string for ${JSON.stringify(Le)}.`);
      }
      return String(de);
    }
    return de;
  };
  const me = $.useRef(!1), Ee = $.useRef(!0), Ie = $.useRef(null), Pe = $.useRef(null), [De, Ye] = $.useState(null), [Ue, ve] = $.useState(-1), rt = i ? 0 : -1, Te = $.useRef(rt), Je = $.useRef(D7(m ?? ie, F, pe)).current, [L, te] = ip({
    controlled: ie,
    default: m,
    name: p
  }), [ge, ke] = ip({
    controlled: z,
    default: Je,
    name: p,
    state: "inputValue"
  }), [We, Be] = $.useState(!1), je = $.useCallback((Le, de, Ne) => {
    if (!(F ? L.length < de.length : de !== null) && !u)
      return;
    const kt = D7(de, F, pe);
    ge !== kt && (ke(kt), Z && Z(Le, kt, Ne));
  }, [pe, ge, F, Z, ke, u, L]), [mt, qe] = ip({
    controlled: J,
    default: !1,
    name: p,
    state: "open"
  }), [at, et] = $.useState(!0), bt = !F && L != null && ge === pe(L), q = mt && !ne, W = q ? _(
    be.filter((Le) => !(O && (F ? L : [L]).some((de) => de !== null && V(Le, de)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: bt && at ? "" : ge,
      getOptionLabel: pe
    }
  ) : [], Q = rF({
    filteredOptions: W,
    value: L,
    inputValue: ge
  });
  $.useEffect(() => {
    const Le = L !== Q.value;
    We && !Le || D && !Le || je(null, L, "reset");
  }, [L, je, We, Q.value, D]);
  const ce = mt && W.length > 0 && !ne, _e = Mr((Le) => {
    Le === -1 ? Ie.current.focus() : De.querySelector(`[data-tag-index="${Le}"]`).focus();
  });
  $.useEffect(() => {
    F && Ue > L.length - 1 && (ve(-1), _e(-1));
  }, [L, F, Ue, _e]);
  function Fe(Le, de) {
    if (!Pe.current || Le < 0 || Le >= W.length)
      return -1;
    let Ne = Le;
    for (; ; ) {
      const vt = Pe.current.querySelector(`[data-option-index="${Ne}"]`), kt = E ? !1 : !vt || vt.disabled || vt.getAttribute("aria-disabled") === "true";
      if (vt && vt.hasAttribute("tabindex") && !kt)
        return Ne;
      if (de === "next" ? Ne = (Ne + 1) % W.length : Ne = (Ne - 1 + W.length) % W.length, Ne === Le)
        return -1;
    }
  }
  const gt = Mr(({
    event: Le,
    index: de,
    reason: Ne
  }) => {
    if (Te.current = de, de === -1 ? Ie.current.removeAttribute("aria-activedescendant") : Ie.current.setAttribute("aria-activedescendant", `${he}-option-${de}`), re && ["mouse", "keyboard", "touch"].includes(Ne) && re(Le, de === -1 ? null : W[de], Ne), !Pe.current)
      return;
    const vt = Pe.current.querySelector(`[role="option"].${n}-focused`);
    vt && (vt.classList.remove(`${n}-focused`), vt.classList.remove(`${n}-focusVisible`));
    let kt = Pe.current;
    if (Pe.current.getAttribute("role") !== "listbox" && (kt = Pe.current.parentElement.querySelector('[role="listbox"]')), !kt)
      return;
    if (de === -1) {
      kt.scrollTop = 0;
      return;
    }
    const zt = Pe.current.querySelector(`[data-option-index="${de}"]`);
    if (zt && (zt.classList.add(`${n}-focused`), Ne === "keyboard" && zt.classList.add(`${n}-focusVisible`), kt.scrollHeight > kt.clientHeight && Ne !== "mouse" && Ne !== "touch")) {
      const fn = zt, Xn = kt.clientHeight + kt.scrollTop, mo = fn.offsetTop + fn.offsetHeight;
      mo > Xn ? kt.scrollTop = mo - kt.clientHeight : fn.offsetTop - fn.offsetHeight * (k ? 1.3 : 0) < kt.scrollTop && (kt.scrollTop = fn.offsetTop - fn.offsetHeight * (k ? 1.3 : 0));
    }
  }), ct = Mr(({
    event: Le,
    diff: de,
    direction: Ne = "next",
    reason: vt
  }) => {
    if (!q)
      return;
    const zt = Fe((() => {
      const fn = W.length - 1;
      if (de === "reset")
        return rt;
      if (de === "start")
        return 0;
      if (de === "end")
        return fn;
      const Xn = Te.current + de;
      return Xn < 0 ? Xn === -1 && Y ? -1 : w && Te.current !== -1 || Math.abs(de) > 1 ? 0 : fn : Xn > fn ? Xn === fn + 1 && Y ? -1 : w || Math.abs(de) > 1 ? fn : 0 : Xn;
    })(), Ne);
    if (gt({
      index: zt,
      reason: vt,
      event: Le
    }), r && de !== "reset")
      if (zt === -1)
        Ie.current.value = ge;
      else {
        const fn = pe(W[zt]);
        Ie.current.value = fn, fn.toLowerCase().indexOf(ge.toLowerCase()) === 0 && ge.length > 0 && Ie.current.setSelectionRange(ge.length, fn.length);
      }
  }), ht = () => {
    const Le = (de, Ne) => {
      const vt = de ? pe(de) : "", kt = Ne ? pe(Ne) : "";
      return vt === kt;
    };
    if (Te.current !== -1 && Q.filteredOptions && Q.filteredOptions.length !== W.length && Q.inputValue === ge && (F ? L.length === Q.value.length && Q.value.every((de, Ne) => pe(L[Ne]) === pe(de)) : Le(Q.value, L))) {
      const de = Q.filteredOptions[Te.current];
      if (de)
        return W.findIndex((Ne) => pe(Ne) === pe(de));
    }
    return -1;
  }, Yt = $.useCallback(() => {
    if (!q)
      return;
    const Le = ht();
    if (Le !== -1) {
      Te.current = Le;
      return;
    }
    const de = F ? L[0] : L;
    if (W.length === 0 || de == null) {
      ct({
        diff: "reset"
      });
      return;
    }
    if (Pe.current) {
      if (de != null) {
        const Ne = W[Te.current];
        if (F && Ne && L.findIndex((kt) => V(Ne, kt)) !== -1)
          return;
        const vt = W.findIndex((kt) => V(kt, de));
        vt === -1 ? ct({
          diff: "reset"
        }) : gt({
          index: vt
        });
        return;
      }
      if (Te.current >= W.length - 1) {
        gt({
          index: W.length - 1
        });
        return;
      }
      gt({
        index: Te.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    W.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    F ? !1 : L,
    O,
    ct,
    gt,
    q,
    ge,
    F
  ]), Rt = Mr((Le) => {
    $2(Pe, Le), Le && Yt();
  });
  iO.NODE_ENV !== "production" && $.useEffect(() => {
    (!Ie.current || Ie.current.nodeName !== "INPUT") && (Ie.current && Ie.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${p} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Ie.current} while an HTMLInputElement was expected.`, `Instead, ${p} expects an input element.`, "", p === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [p]), $.useEffect(() => {
    Yt();
  }, [Yt]);
  const cn = (Le) => {
    mt || (qe(!0), et(!0), ee && ee(Le));
  }, Kt = (Le, de) => {
    mt && (qe(!1), oe && oe(Le, de));
  }, Zt = (Le, de, Ne, vt) => {
    if (F) {
      if (L.length === de.length && L.every((kt, zt) => kt === de[zt]))
        return;
    } else if (L === de)
      return;
    X && X(Le, de, Ne, vt), te(de);
  }, dn = $.useRef(!1), xr = (Le, de, Ne = "selectOption", vt = "options") => {
    let kt = Ne, zt = de;
    if (F) {
      if (zt = Array.isArray(L) ? L.slice() : [], iO.NODE_ENV !== "production") {
        const Xn = zt.filter((mo) => V(de, mo));
        Xn.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${p} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Xn.length} matches.`].join(`
`));
      }
      const fn = zt.findIndex((Xn) => V(de, Xn));
      fn === -1 ? zt.push(de) : vt !== "freeSolo" && (zt.splice(fn, 1), kt = "removeOption");
    }
    je(Le, zt, kt), Zt(Le, zt, kt, {
      option: de
    }), !y && (!Le || !Le.ctrlKey && !Le.metaKey) && Kt(Le, kt), (s === !0 || s === "touch" && dn.current || s === "mouse" && !dn.current) && Ie.current.blur();
  };
  function Hr(Le, de) {
    if (Le === -1)
      return -1;
    let Ne = Le;
    for (; ; ) {
      if (de === "next" && Ne === L.length || de === "previous" && Ne === -1)
        return -1;
      const vt = De.querySelector(`[data-tag-index="${Ne}"]`);
      if (!vt || !vt.hasAttribute("tabindex") || vt.disabled || vt.getAttribute("aria-disabled") === "true")
        Ne += de === "next" ? 1 : -1;
      else
        return Ne;
    }
  }
  const jr = (Le, de) => {
    if (!F)
      return;
    ge === "" && Kt(Le, "toggleInput");
    let Ne = Ue;
    Ue === -1 ? ge === "" && de === "previous" && (Ne = L.length - 1) : (Ne += de === "next" ? 1 : -1, Ne < 0 && (Ne = 0), Ne === L.length && (Ne = -1)), Ne = Hr(Ne, de), ve(Ne), _e(Ne);
  }, Ut = (Le) => {
    me.current = !0, ke(""), Z && Z(Le, "", "clear"), Zt(Le, F ? [] : null, "clear");
  }, ei = (Le) => (de) => {
    if (Le.onKeyDown && Le.onKeyDown(de), !de.defaultMuiPrevented && (Ue !== -1 && !["ArrowLeft", "ArrowRight"].includes(de.key) && (ve(-1), _e(-1)), de.which !== 229))
      switch (de.key) {
        case "Home":
          q && U && (de.preventDefault(), ct({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: de
          }));
          break;
        case "End":
          q && U && (de.preventDefault(), ct({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: de
          }));
          break;
        case "PageUp":
          de.preventDefault(), ct({
            diff: -A7,
            direction: "previous",
            reason: "keyboard",
            event: de
          }), cn(de);
          break;
        case "PageDown":
          de.preventDefault(), ct({
            diff: A7,
            direction: "next",
            reason: "keyboard",
            event: de
          }), cn(de);
          break;
        case "ArrowDown":
          de.preventDefault(), ct({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: de
          }), cn(de);
          break;
        case "ArrowUp":
          de.preventDefault(), ct({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: de
          }), cn(de);
          break;
        case "ArrowLeft":
          jr(de, "previous");
          break;
        case "ArrowRight":
          jr(de, "next");
          break;
        case "Enter":
          if (Te.current !== -1 && q) {
            const Ne = W[Te.current], vt = P ? P(Ne) : !1;
            if (de.preventDefault(), vt)
              return;
            xr(de, Ne, "selectOption"), r && Ie.current.setSelectionRange(Ie.current.value.length, Ie.current.value.length);
          } else D && ge !== "" && bt === !1 && (F && de.preventDefault(), xr(de, ge, "createOption", "freeSolo"));
          break;
        case "Escape":
          q ? (de.preventDefault(), de.stopPropagation(), Kt(de, "escape")) : f && (ge !== "" || F && L.length > 0) && (de.preventDefault(), de.stopPropagation(), Ut(de));
          break;
        case "Backspace":
          if (F && !ne && ge === "" && L.length > 0) {
            const Ne = Ue === -1 ? L.length - 1 : Ue, vt = L.slice();
            vt.splice(Ne, 1), Zt(de, vt, "removeOption", {
              option: L[Ne]
            });
          }
          break;
        case "Delete":
          if (F && !ne && ge === "" && L.length > 0 && Ue !== -1) {
            const Ne = Ue, vt = L.slice();
            vt.splice(Ne, 1), Zt(de, vt, "removeOption", {
              option: L[Ne]
            });
          }
          break;
      }
  }, It = (Le) => {
    Be(!0), le && !me.current && cn(Le);
  }, Et = (Le) => {
    if (t(Pe)) {
      Ie.current.focus();
      return;
    }
    Be(!1), Ee.current = !0, me.current = !1, o && Te.current !== -1 && q ? xr(Le, W[Te.current], "blur") : o && D && ge !== "" ? xr(Le, ge, "blur", "freeSolo") : u && je(Le, L, "blur"), Kt(Le, "blur");
  }, jt = (Le) => {
    const de = Le.target.value;
    ge !== de && (ke(de), et(!1), Z && Z(Le, de, "input")), de === "" ? !v && !F && Zt(Le, null, "clear") : cn(Le);
  }, Jt = (Le) => {
    const de = Number(Le.currentTarget.getAttribute("data-option-index"));
    Te.current !== de && gt({
      event: Le,
      index: de,
      reason: "mouse"
    });
  }, Nn = (Le) => {
    gt({
      event: Le,
      index: Number(Le.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), dn.current = !0;
  }, Ai = (Le) => {
    const de = Number(Le.currentTarget.getAttribute("data-option-index"));
    xr(Le, W[de], "selectOption"), dn.current = !1;
  }, ho = (Le) => (de) => {
    const Ne = L.slice();
    Ne.splice(Le, 1), Zt(de, Ne, "removeOption", {
      option: L[Le]
    });
  }, gi = (Le) => {
    mt ? Kt(Le, "toggleInput") : cn(Le);
  }, go = (Le) => {
    Le.currentTarget.contains(Le.target) && Le.target.getAttribute("id") !== he && Le.preventDefault();
  }, gr = (Le) => {
    Le.currentTarget.contains(Le.target) && (Ie.current.focus(), ae && Ee.current && Ie.current.selectionEnd - Ie.current.selectionStart === 0 && Ie.current.select(), Ee.current = !1);
  }, _t = (Le) => {
    !S && (ge === "" || !mt) && gi(Le);
  };
  let mi = D && ge.length > 0;
  mi = mi || (F ? L.length > 0 : L !== null);
  let ti = W;
  if (k) {
    const Le = /* @__PURE__ */ new Map();
    let de = !1;
    ti = W.reduce((Ne, vt, kt) => {
      const zt = k(vt);
      return Ne.length > 0 && Ne[Ne.length - 1].group === zt ? Ne[Ne.length - 1].options.push(vt) : (iO.NODE_ENV !== "production" && (Le.get(zt) && !de && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${p} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), de = !0), Le.set(zt, !0)), Ne.push({
        key: kt,
        index: kt,
        group: zt,
        options: [vt]
      })), Ne;
    }, []);
  }
  return S && We && Et(), {
    getRootProps: (Le = {}) => ({
      ...Le,
      onKeyDown: ei(Le),
      onMouseDown: go,
      onClick: gr
    }),
    getInputLabelProps: () => ({
      id: `${he}-label`,
      htmlFor: he
    }),
    getInputProps: () => ({
      id: he,
      value: ge,
      onBlur: Et,
      onFocus: It,
      onChange: jt,
      onMouseDown: _t,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": q ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": ce ? `${he}-listbox` : void 0,
      "aria-expanded": ce,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Ie,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: S
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Ut
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: gi
    }),
    getTagProps: ({
      index: Le
    }) => ({
      key: Le,
      "data-tag-index": Le,
      tabIndex: -1,
      ...!ne && {
        onDelete: ho(Le)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${he}-listbox`,
      "aria-labelledby": `${he}-label`,
      ref: Rt,
      onMouseDown: (Le) => {
        Le.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Le,
      option: de
    }) => {
      const Ne = (F ? L : [L]).some((kt) => kt != null && V(de, kt)), vt = P ? P(de) : !1;
      return {
        key: (M == null ? void 0 : M(de)) ?? pe(de),
        tabIndex: -1,
        role: "option",
        id: `${he}-option-${Le}`,
        onMouseMove: Jt,
        onClick: Ai,
        onTouchStart: Nn,
        "data-option-index": Le,
        "aria-disabled": vt,
        "aria-selected": Ne
      };
    },
    id: he,
    inputValue: ge,
    value: L,
    dirty: mi,
    expanded: q && De,
    popupOpen: q,
    focused: We || Ue !== -1,
    anchorEl: De,
    setAnchorEl: Ye,
    focusedTag: Ue,
    groupedOptions: ti
  };
}
function vPe(e) {
  return Vt("MuiListSubheader", e);
}
Wt("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
var yPe = {};
const bPe = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: i,
    disableSticky: o
  } = e, s = {
    root: ["root", n !== "default" && `color${Ke(n)}`, !r && "gutters", i && "inset", !o && "sticky"]
  };
  return Ft(s, vPe, t);
}, xPe = ye("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Ke(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(Lt(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), ug = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: i,
    color: o = "default",
    component: s = "li",
    disableGutters: u = !1,
    disableSticky: f = !1,
    inset: p = !1,
    ...m
  } = r, v = {
    ...r,
    color: o,
    component: s,
    disableGutters: u,
    disableSticky: f,
    inset: p
  }, y = bPe(v);
  return /* @__PURE__ */ T.jsx(xPe, {
    as: s,
    className: yt(y.root, i),
    ref: n,
    ownerState: v,
    ...m
  });
});
ug && (ug.muiSkipListHighlight = !0);
yPe.NODE_ENV !== "production" && (ug.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: c.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: c.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const Yie = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function SPe(e) {
  return Vt("MuiAutocomplete", e);
}
const kn = Wt("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var wPe = {}, I7, P7;
const TPe = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: i,
    fullWidth: o,
    hasClearIcon: s,
    hasPopupIcon: u,
    inputFocused: f,
    popupOpen: p,
    size: m
  } = e, v = {
    root: ["root", r && "expanded", i && "focused", o && "fullWidth", s && "hasClearIcon", u && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", f && "inputFocused"],
    tag: ["tag", `tagSize${Ke(m)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", p && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Ft(v, SPe, t);
}, EPe = ye("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: i,
      hasPopupIcon: o,
      inputFocused: s,
      size: u
    } = n;
    return [{
      [`& .${kn.tag}`]: t.tag
    }, {
      [`& .${kn.tag}`]: t[`tagSize${Ke(u)}`]
    }, {
      [`& .${kn.inputRoot}`]: t.inputRoot
    }, {
      [`& .${kn.input}`]: t.input
    }, {
      [`& .${kn.input}`]: s && t.inputFocused
    }, t.root, r && t.fullWidth, o && t.hasPopupIcon, i && t.hasClearIcon];
  }
})({
  [`&.${kn.focused} .${kn.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${kn.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${kn.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${kn.inputRoot}`]: {
    [`.${kn.hasPopupIcon}&, .${kn.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${kn.hasPopupIcon}.${kn.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${kn.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Xh.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Xh.root}.${Rl.sizeSmall}`]: {
    [`& .${Xh.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${xc.root}`]: {
    padding: 9,
    [`.${kn.hasPopupIcon}&, .${kn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${kn.hasPopupIcon}.${kn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${kn.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${kn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${xc.root}.${Rl.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${kn.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Ol.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${kn.hasPopupIcon}&, .${kn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${kn.hasPopupIcon}.${kn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Ol.input}`]: {
      padding: "7px 4px"
    },
    [`& .${kn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Ol.root}.${Rl.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Ol.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Rl.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Ol.root}.${Rl.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${kn.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Ol.root}.${Rl.hiddenLabel}.${Rl.sizeSmall}`]: {
    [`& .${kn.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${kn.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${kn.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${kn.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${kn.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), _Pe = ye("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), CPe = ye(ey, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), RPe = ye(ey, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), OPe = ye(h_, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${kn.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(Lt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), APe = ye(Ei, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(Lt(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), DPe = ye("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(Lt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), IPe = ye("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(Lt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), PPe = ye("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(Lt(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${kn.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${kn.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${kn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${kn.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${kn.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), NPe = ye(ug, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(Lt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), MPe = ye("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${kn.option}`]: {
    paddingLeft: 24
  }
}), Xie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: i = !1,
    autoHighlight: o = !1,
    autoSelect: s = !1,
    blurOnSelect: u = !1,
    ChipProps: f,
    className: p,
    clearIcon: m = I7 || (I7 = /* @__PURE__ */ T.jsx(Yie, {
      fontSize: "small"
    })),
    clearOnBlur: v = !r.freeSolo,
    clearOnEscape: y = !1,
    clearText: S = "Clear",
    closeText: E = "Close",
    componentsProps: w,
    defaultValue: _ = r.multiple ? [] : null,
    disableClearable: O = !1,
    disableCloseOnSelect: D = !1,
    disabled: P = !1,
    disabledItemsFocusable: M = !1,
    disableListWrap: N = !1,
    disablePortal: k = !1,
    filterOptions: U,
    filterSelectedOptions: H = !1,
    forcePopupIcon: Y = "auto",
    freeSolo: z = !1,
    fullWidth: V = !1,
    getLimitTagsText: F = (yn) => `+${yn}`,
    getOptionDisabled: X,
    getOptionKey: oe,
    getOptionLabel: re,
    isOptionEqualToValue: Z,
    groupBy: ee,
    handleHomeEndKeys: J = !r.freeSolo,
    id: le,
    includeInputInList: be = !1,
    inputValue: ne,
    limitTags: ae = -1,
    ListboxComponent: ie,
    ListboxProps: he,
    loading: pe = !1,
    loadingText: me = "Loading…",
    multiple: Ee = !1,
    noOptionsText: Ie = "No options",
    onChange: Pe,
    onClose: De,
    onHighlightChange: Ye,
    onInputChange: Ue,
    onOpen: ve,
    open: rt,
    openOnFocus: Te = !1,
    openText: Je = "Open",
    options: L,
    PaperComponent: te,
    PopperComponent: ge,
    popupIcon: ke = P7 || (P7 = /* @__PURE__ */ T.jsx(rie, {})),
    readOnly: We = !1,
    renderGroup: Be,
    renderInput: je,
    renderOption: mt,
    renderTags: qe,
    selectOnFocus: at = !r.freeSolo,
    size: et = "medium",
    slots: bt = {},
    slotProps: q = {},
    value: W,
    ...Q
  } = r, {
    getRootProps: ce,
    getInputProps: _e,
    getInputLabelProps: Fe,
    getPopupIndicatorProps: gt,
    getClearProps: ct,
    getTagProps: ht,
    getListboxProps: Yt,
    getOptionProps: Rt,
    value: cn,
    dirty: Kt,
    expanded: Zt,
    id: dn,
    popupOpen: xr,
    focused: Hr,
    focusedTag: jr,
    anchorEl: Ut,
    setAnchorEl: ei,
    inputValue: It,
    groupedOptions: Et
  } = mPe({
    ...r,
    componentName: "Autocomplete"
  }), jt = !O && !P && Kt && !We, Jt = (!z || Y === !0) && Y !== !1, {
    onMouseDown: Nn
  } = _e(), {
    ref: Ai,
    ...ho
  } = Yt(), go = re || ((yn) => yn.label ?? yn), gr = {
    ...r,
    disablePortal: k,
    expanded: Zt,
    focused: Hr,
    fullWidth: V,
    getOptionLabel: go,
    hasClearIcon: jt,
    hasPopupIcon: Jt,
    inputFocused: jr === -1,
    popupOpen: xr,
    size: et
  }, _t = TPe(gr), mi = {
    slots: {
      paper: te,
      popper: ge,
      ...bt
    },
    slotProps: {
      chip: f,
      listbox: he,
      ...w,
      ...q
    }
  }, [ti, Le] = Xt("listbox", {
    elementType: PPe,
    externalForwardedProps: mi,
    ownerState: gr,
    className: _t.listbox,
    additionalProps: ho,
    ref: Ai
  }), [de, Ne] = Xt("paper", {
    elementType: Ei,
    externalForwardedProps: mi,
    ownerState: gr,
    className: _t.paper
  }), [vt, kt] = Xt("popper", {
    elementType: h_,
    externalForwardedProps: mi,
    ownerState: gr,
    className: _t.popper,
    additionalProps: {
      disablePortal: k,
      style: {
        width: Ut ? Ut.clientWidth : null
      },
      role: "presentation",
      anchorEl: Ut,
      open: xr
    }
  });
  let zt;
  if (Ee && cn.length > 0) {
    const yn = (Xo) => ({
      className: _t.tag,
      disabled: P,
      ...ht(Xo)
    });
    qe ? zt = qe(cn, yn, gr) : zt = cn.map((Xo, bs) => {
      const {
        key: $a,
        ...vp
      } = yn({
        index: bs
      });
      return /* @__PURE__ */ T.jsx(kx, {
        label: go(Xo),
        size: et,
        ...vp,
        ...mi.slotProps.chip
      }, $a);
    });
  }
  if (ae > -1 && Array.isArray(zt)) {
    const yn = zt.length - ae;
    !Hr && yn > 0 && (zt = zt.splice(0, ae), zt.push(/* @__PURE__ */ T.jsx("span", {
      className: _t.tag,
      children: F(yn)
    }, zt.length)));
  }
  const Xn = Be || ((yn) => /* @__PURE__ */ T.jsxs("li", {
    children: [/* @__PURE__ */ T.jsx(NPe, {
      className: _t.groupLabel,
      ownerState: gr,
      component: "div",
      children: yn.group
    }), /* @__PURE__ */ T.jsx(MPe, {
      className: _t.groupUl,
      ownerState: gr,
      children: yn.children
    })]
  }, yn.key)), ys = mt || ((yn, Xo) => {
    const {
      key: bs,
      ...$a
    } = yn;
    return /* @__PURE__ */ T.jsx("li", {
      ...$a,
      children: go(Xo)
    }, bs);
  }), Di = (yn, Xo) => {
    const bs = Rt({
      option: yn,
      index: Xo
    });
    return ys({
      ...bs,
      className: _t.option
    }, yn, {
      selected: bs["aria-selected"],
      index: Xo,
      inputValue: It
    }, gr);
  }, qa = mi.slotProps.clearIndicator, vo = mi.slotProps.popupIndicator;
  return /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [/* @__PURE__ */ T.jsx(EPe, {
      ref: n,
      className: yt(_t.root, p),
      ownerState: gr,
      ...ce(Q),
      children: je({
        id: dn,
        disabled: P,
        fullWidth: !0,
        size: et === "small" ? "small" : void 0,
        InputLabelProps: Fe(),
        InputProps: {
          ref: ei,
          className: _t.inputRoot,
          startAdornment: zt,
          onMouseDown: (yn) => {
            yn.target === yn.currentTarget && Nn(yn);
          },
          ...(jt || Jt) && {
            endAdornment: /* @__PURE__ */ T.jsxs(_Pe, {
              className: _t.endAdornment,
              ownerState: gr,
              children: [jt ? /* @__PURE__ */ T.jsx(CPe, {
                ...ct(),
                "aria-label": S,
                title: S,
                ownerState: gr,
                ...qa,
                className: yt(_t.clearIndicator, qa == null ? void 0 : qa.className),
                children: m
              }) : null, Jt ? /* @__PURE__ */ T.jsx(RPe, {
                ...gt(),
                disabled: P,
                "aria-label": xr ? E : Je,
                title: xr ? E : Je,
                ownerState: gr,
                ...vo,
                className: yt(_t.popupIndicator, vo == null ? void 0 : vo.className),
                children: ke
              }) : null]
            })
          }
        },
        inputProps: {
          className: _t.input,
          disabled: P,
          readOnly: We,
          ..._e()
        }
      })
    }), Ut ? /* @__PURE__ */ T.jsx(OPe, {
      as: vt,
      ...kt,
      children: /* @__PURE__ */ T.jsxs(APe, {
        as: de,
        ...Ne,
        children: [pe && Et.length === 0 ? /* @__PURE__ */ T.jsx(DPe, {
          className: _t.loading,
          ownerState: gr,
          children: me
        }) : null, Et.length === 0 && !z && !pe ? /* @__PURE__ */ T.jsx(IPe, {
          className: _t.noOptions,
          ownerState: gr,
          role: "presentation",
          onMouseDown: (yn) => {
            yn.preventDefault();
          },
          children: Ie
        }) : null, Et.length > 0 ? /* @__PURE__ */ T.jsx(ti, {
          as: ie,
          ...Le,
          children: Et.map((yn, Xo) => ee ? Xn({
            key: yn.key,
            group: yn.group,
            children: yn.options.map((bs, $a) => Di(bs, yn.index + $a))
          }) : Di(yn, Xo))
        }) : null]
      })
    }) : null]
  });
});
wPe.NODE_ENV !== "production" && (Xie.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: c.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: c.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: c.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: c.oneOfType([c.oneOf(["mouse", "touch"]), c.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: c.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: c.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: c.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: c.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: c.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: c.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: c.shape({
    clearIndicator: c.object,
    paper: c.object,
    popper: c.object,
    popupIndicator: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: Wa(c.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: c.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: c.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: c.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: c.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: c.oneOfType([c.oneOf(["auto"]), c.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: c.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: c.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: c.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: c.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: c.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: c.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: c.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: c.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: c.bool,
  /**
   * The input value.
   */
  inputValue: c.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: c.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: jD,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: c.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: c.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: c.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: c.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: c.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: c.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: c.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: c.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: c.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: c.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: c.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: c.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: c.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: c.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: c.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: c.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: c.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: c.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: c.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: c.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: c.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    chip: c.oneOfType([c.func, c.object]),
    clearIndicator: c.oneOfType([c.func, c.object]),
    listbox: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    popper: c.oneOfType([c.func, c.object]),
    popupIndicator: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    listbox: c.elementType,
    paper: c.elementType,
    popper: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: Wa(c.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
function jPe(e) {
  return Vt("MuiFormHelperText", e);
}
const N7 = Wt("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var LPe = {}, M7;
const kPe = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: i,
    error: o,
    filled: s,
    focused: u,
    required: f
  } = e, p = {
    root: ["root", i && "disabled", o && "error", r && `size${Ke(r)}`, n && "contained", u && "focused", s && "filled", f && "required"]
  };
  return Ft(p, jPe, t);
}, zPe = ye("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${Ke(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(Lt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${N7.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${N7.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), Zie = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: i,
    className: o,
    component: s = "p",
    disabled: u,
    error: f,
    filled: p,
    focused: m,
    margin: v,
    required: y,
    variant: S,
    ...E
  } = r, w = pp(), _ = oy({
    props: r,
    muiFormControl: w,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), O = {
    ...r,
    component: s,
    contained: _.variant === "filled" || _.variant === "outlined",
    variant: _.variant,
    size: _.size,
    disabled: _.disabled,
    error: _.error,
    filled: _.filled,
    focused: _.focused,
    required: _.required
  };
  delete O.ownerState;
  const D = kPe(O);
  return /* @__PURE__ */ T.jsx(zPe, {
    as: s,
    className: yt(D.root, o),
    ref: n,
    ...E,
    ownerState: O,
    children: i === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      M7 || (M7 = /* @__PURE__ */ T.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : i
  });
});
LPe.NODE_ENV !== "production" && (Zie.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: c.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: c.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: c.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: c.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: c.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   */
  variant: c.oneOfType([c.oneOf(["filled", "outlined", "standard"]), c.string])
});
function BPe(e) {
  return Vt("MuiTextField", e);
}
Wt("MuiTextField", ["root"]);
var Kie = {};
const VPe = {
  standard: x_,
  filled: mI,
  outlined: vI
}, UPe = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, BPe, t);
}, FPe = ye(b_, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), EI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: i,
    autoFocus: o = !1,
    children: s,
    className: u,
    color: f = "primary",
    defaultValue: p,
    disabled: m = !1,
    error: v = !1,
    FormHelperTextProps: y,
    fullWidth: S = !1,
    helperText: E,
    id: w,
    InputLabelProps: _,
    inputProps: O,
    InputProps: D,
    inputRef: P,
    label: M,
    maxRows: N,
    minRows: k,
    multiline: U = !1,
    name: H,
    onBlur: Y,
    onChange: z,
    onFocus: V,
    placeholder: F,
    required: X = !1,
    rows: oe,
    select: re = !1,
    SelectProps: Z,
    slots: ee = {},
    slotProps: J = {},
    type: le,
    value: be,
    variant: ne = "outlined",
    ...ae
  } = r, ie = {
    ...r,
    autoFocus: o,
    color: f,
    disabled: m,
    error: v,
    fullWidth: S,
    multiline: U,
    required: X,
    select: re,
    variant: ne
  }, he = UPe(ie);
  Kie.NODE_ENV !== "production" && re && !s && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const pe = Jv(w), me = E && pe ? `${pe}-helper-text` : void 0, Ee = M && pe ? `${pe}-label` : void 0, Ie = VPe[ne], Pe = {
    slots: ee,
    slotProps: {
      input: D,
      inputLabel: _,
      htmlInput: O,
      formHelperText: y,
      select: Z,
      ...J
    }
  }, De = {}, Ye = Pe.slotProps.inputLabel;
  ne === "outlined" && (Ye && typeof Ye.shrink < "u" && (De.notched = Ye.shrink), De.label = M), re && ((!Z || !Z.native) && (De.id = void 0), De["aria-describedby"] = void 0);
  const [Ue, ve] = Xt("root", {
    elementType: FPe,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...Pe,
      ...ae
    },
    ownerState: ie,
    className: yt(he.root, u),
    ref: n,
    additionalProps: {
      disabled: m,
      error: v,
      fullWidth: S,
      required: X,
      color: f,
      variant: ne
    }
  }), [rt, Te] = Xt("input", {
    elementType: Ie,
    externalForwardedProps: Pe,
    additionalProps: De,
    ownerState: ie
  }), [Je, L] = Xt("inputLabel", {
    elementType: wF,
    externalForwardedProps: Pe,
    ownerState: ie
  }), [te, ge] = Xt("htmlInput", {
    elementType: "input",
    externalForwardedProps: Pe,
    ownerState: ie
  }), [ke, We] = Xt("formHelperText", {
    elementType: Zie,
    externalForwardedProps: Pe,
    ownerState: ie
  }), [Be, je] = Xt("select", {
    elementType: Vx,
    externalForwardedProps: Pe,
    ownerState: ie
  }), mt = /* @__PURE__ */ T.jsx(rt, {
    "aria-describedby": me,
    autoComplete: i,
    autoFocus: o,
    defaultValue: p,
    fullWidth: S,
    multiline: U,
    name: H,
    rows: oe,
    maxRows: N,
    minRows: k,
    type: le,
    value: be,
    id: pe,
    inputRef: P,
    onBlur: Y,
    onChange: z,
    onFocus: V,
    placeholder: F,
    inputProps: ge,
    slots: {
      input: ee.htmlInput ? te : void 0
    },
    ...Te
  });
  return /* @__PURE__ */ T.jsxs(Ue, {
    ...ve,
    children: [M != null && M !== "" && /* @__PURE__ */ T.jsx(Je, {
      htmlFor: pe,
      id: Ee,
      ...L,
      children: M
    }), re ? /* @__PURE__ */ T.jsx(Be, {
      "aria-describedby": me,
      id: pe,
      labelId: Ee,
      value: be,
      input: mt,
      ...je,
      children: s
    }) : mt, E && /* @__PURE__ */ T.jsx(ke, {
      id: me,
      ...We,
      children: E
    })]
  });
});
Kie.NODE_ENV !== "production" && (EI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * @ignore
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: c.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: c.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The helper text content.
   */
  helperText: c.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: c.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: c.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: c.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /**
   * The label content.
   */
  label: c.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: c.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: c.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: c.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    formHelperText: c.oneOfType([c.func, c.object]),
    htmlInput: c.oneOfType([c.func, c.object]),
    input: c.oneOfType([c.func, c.object]),
    inputLabel: c.oneOfType([c.func, c.object]),
    select: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    formHelperText: c.elementType,
    htmlInput: c.elementType,
    input: c.elementType,
    inputLabel: c.elementType,
    root: c.elementType,
    select: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
function WPe(e) {
  return Vt("MuiInputAdornment", e);
}
const j7 = Wt("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var Qie = {}, L7;
const HPe = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${Ke(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, qPe = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: i,
    size: o,
    variant: s
  } = e, u = {
    root: ["root", n && "disablePointerEvents", i && `position${Ke(i)}`, s, r && "hiddenLabel", o && `size${Ke(o)}`]
  };
  return Ft(u, WPe, t);
}, $Pe = ye("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: HPe
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${j7.positionStart}&:not(.${j7.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), _I = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: i,
    className: o,
    component: s = "div",
    disablePointerEvents: u = !1,
    disableTypography: f = !1,
    position: p,
    variant: m,
    ...v
  } = r, y = pp() || {};
  let S = m;
  m && y.variant && Qie.NODE_ENV !== "production" && m === y.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), y && !S && (S = y.variant);
  const E = {
    ...r,
    hiddenLabel: y.hiddenLabel,
    size: y.size,
    disablePointerEvents: u,
    position: p,
    variant: S
  }, w = qPe(E);
  return /* @__PURE__ */ T.jsx(y_.Provider, {
    value: null,
    children: /* @__PURE__ */ T.jsx($Pe, {
      as: s,
      ownerState: E,
      className: yt(w.root, o),
      ref: n,
      ...v,
      children: typeof i == "string" && !f ? /* @__PURE__ */ T.jsx(St, {
        color: "textSecondary",
        children: i
      }) : /* @__PURE__ */ T.jsxs($.Fragment, {
        children: [p === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          L7 || (L7 = /* @__PURE__ */ T.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, i]
      })
    })
  });
});
Qie.NODE_ENV !== "production" && (_I.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: c.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: c.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: c.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
const CI = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "SearchSharp"), GPe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeftSharp"), YPe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRightSharp");
function Jie({
  numTotal: e = void 0,
  searchHits: t = [],
  selectedContentSearchAnnotation: n,
  direction: r,
  selectAnnotation: i
}) {
  const { t: o } = Ct(), s = (S) => {
    i(t[S + 1].annotations[0]);
  }, u = (S) => {
    i(t[S - 1].annotations[0]);
  }, f = (S) => t.length === 0 ? !1 : S < t.length - 1, p = (S) => t.length === 0 ? !1 : S > 0, m = r === "rtl" ? { transform: "rotate(180deg)" } : {}, v = t.findIndex((S) => S.annotations.includes(n[0]));
  let y = t.length;
  return t.length < e && (y += "+"), t.length === 0 ? null : /* @__PURE__ */ T.jsxs(St, { variant: "body2", align: "center", children: [
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-label": o("searchPreviousResult"),
        disabled: !p(v),
        onClick: () => u(v),
        children: /* @__PURE__ */ T.jsx(GPe, { style: m })
      }
    ),
    /* @__PURE__ */ T.jsx("span", { style: { unicodeBidi: "plaintext" }, children: o("pagination", { current: v + 1, total: y }) }),
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-label": o("searchNextResult"),
        disabled: !f(v),
        onClick: () => s(v),
        children: /* @__PURE__ */ T.jsx(YPe, { style: m })
      }
    )
  ] });
}
Jie.propTypes = {
  direction: c.string.isRequired,
  numTotal: c.number,
  searchHits: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  selectAnnotation: c.func.isRequired,
  selectedContentSearchAnnotation: c.arrayOf(c.string).isRequired,
  windowId: c.string.isRequired
  // eslint-disable-line react/no-unused-prop-types
};
const XPe = (e, { companionWindowId: t, windowId: n }) => ({
  direction: Ax(e),
  numTotal: x3(e, { companionWindowId: t, windowId: n }),
  searchHits: S3(e, { companionWindowId: t, windowId: n }),
  selectedContentSearchAnnotation: _D(e, {
    companionWindowId: t,
    windowId: n
  })
}), ZPe = (e, { windowId: t }) => ({
  selectAnnotation: (...n) => e(
    Kv(t, ...n)
  )
}), KPe = wt(
  At(XPe, ZPe),
  Tt("SearchPanelNavigation")
), QPe = KPe(Jie), JPe = ye("form", { name: "SearchPanelControls", slot: "form" })(({ theme: e }) => ({
  paddingBottom: e.spacing(1),
  paddingRight: e.spacing(1.5),
  width: "100%"
})), uE = (e) => TI(e) ? e.match : e;
function eoe({
  autocompleteService: e = void 0,
  companionWindowId: t,
  fetchSearch: n,
  query: r = "",
  searchIsFetching: i = !1,
  searchService: o,
  windowId: s
}) {
  const { t: u } = Ct(), [f, p] = Bn(r), [m, v] = Bn(r), [y, S] = Bn([]);
  ln(() => {
    p(r), v(r), S([]);
  }, [r]), ln(() => {
    m && m !== "" && o && n(s, t, `${o.id}?${new URLSearchParams({ q: m })}`, m);
  }, [m, o, t, n, s]);
  const E = (M, N, k) => {
    k === "reset" && !N || (p(N), S([]), N && w(N));
  }, w = kF(Yn(() => {
    e && f && fetch(`${e.id}?${new URLSearchParams({ q: f })}`).then((M) => M.json()).then(_);
  }, [e, f]), 500), _ = (M) => {
    S(M.terms);
  }, O = (M) => {
    f && (M && M.preventDefault(), v(f));
  }, D = (M, N, k) => {
    N && uE(N) && v(uE(N));
  }, P = `search-${t}`;
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      JPe,
      {
        "aria-label": u("searchTitle"),
        onSubmit: O,
        children: /* @__PURE__ */ T.jsx(
          Xie,
          {
            id: P,
            inputValue: f,
            options: y,
            getOptionLabel: uE,
            isOptionEqualToValue: (M, N) => R7(uE(M).trim()).toLowerCase() === R7(uE(N).trim()).toLowerCase(),
            noOptionsText: "",
            onChange: D,
            onInputChange: E,
            freeSolo: !0,
            disableClearable: !0,
            renderInput: (M) => /* @__PURE__ */ T.jsx(
              EI,
              {
                ...M,
                label: u("searchInputLabel"),
                variant: "standard",
                InputProps: {
                  ...M.InputProps,
                  endAdornment: /* @__PURE__ */ T.jsxs(_I, { sx: { position: "relative" }, position: "end", children: [
                    /* @__PURE__ */ T.jsx(Jn, { "aria-label": u("searchSubmitAria"), type: "submit", children: /* @__PURE__ */ T.jsx(CI, {}) }),
                    !!i && /* @__PURE__ */ T.jsx(
                      eI,
                      {
                        sx: {
                          left: "50%",
                          marginLeft: "-25px",
                          marginTop: "-25px",
                          position: "absolute",
                          top: "50%"
                        },
                        size: 50
                      }
                    )
                  ] })
                }
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ T.jsx(QPe, { windowId: s, companionWindowId: t })
  ] });
}
eoe.propTypes = {
  autocompleteService: c.shape({
    id: c.string
  }),
  companionWindowId: c.string.isRequired,
  fetchSearch: c.func.isRequired,
  query: c.string,
  searchIsFetching: c.bool,
  searchService: c.shape({
    id: c.string
  }).isRequired,
  windowId: c.string.isRequired
};
const eNe = (e, { companionWindowId: t, windowId: n }) => ({
  autocompleteService: ete(e, { windowId: n }),
  query: K1(e, { companionWindowId: t, windowId: n }),
  searchIsFetching: b3(e, { companionWindowId: t, windowId: n }),
  searchService: Dx(e, { windowId: n })
}), tNe = {
  fetchSearch: o_
}, nNe = wt(
  At(eNe, tNe),
  Tt("SearchPanelControls")
), rNe = nNe(eoe), zF = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBackSharp"), toe = 7e3;
let gz = null;
function k7(e, t = "assertive", n = toe) {
  gz || (gz = new iNe()), gz.announce(e, t, n);
}
class iNe {
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = toe) {
    if (!this.node) return;
    let i = document.createElement("div");
    i.textContent = t, n === "assertive" ? this.assertiveLog.appendChild(i) : this.politeLog.appendChild(i), t !== "" && setTimeout(() => {
      i.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
  }
}
function oNe(e) {
  const t = an(null);
  return ihe(() => {
    t.current = e;
  }, [e]), Yn((...n) => {
    const r = t.current;
    return r(...n);
  }, []);
}
function aNe(e) {
  return Vt("MuiListItem", e);
}
Wt("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
function sNe(e) {
  return Vt("MuiListItemButton", e);
}
const U0 = Wt("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
var noe = {};
const lNe = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters];
}, cNe = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disabled: i,
    disableGutters: o,
    divider: s,
    selected: u
  } = e, p = Ft({
    root: ["root", r && "dense", !o && "gutters", s && "divider", i && "disabled", t === "flex-start" && "alignItemsFlexStart", u && "selected"]
  }, sNe, n);
  return {
    ...n,
    ...p
  };
}, uNe = ye(Ws, {
  shouldForwardProp: (e) => ha(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: lNe
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${U0.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${U0.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${U0.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Cn(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${U0.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${U0.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), BF = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: i = "center",
    autoFocus: o = !1,
    component: s = "div",
    children: u,
    dense: f = !1,
    disableGutters: p = !1,
    divider: m = !1,
    focusVisibleClassName: v,
    selected: y = !1,
    className: S,
    ...E
  } = r, w = $.useContext(Pc), _ = $.useMemo(() => ({
    dense: f || w.dense || !1,
    alignItems: i,
    disableGutters: p
  }), [i, w.dense, f, p]), O = $.useRef(null);
  gs(() => {
    o && (O.current ? O.current.focus() : noe.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [o]);
  const D = {
    ...r,
    alignItems: i,
    dense: _.dense,
    disableGutters: p,
    divider: m,
    selected: y
  }, P = cNe(D), M = kr(O, n);
  return /* @__PURE__ */ T.jsx(Pc.Provider, {
    value: _,
    children: /* @__PURE__ */ T.jsx(uNe, {
      ref: M,
      href: E.href || E.to,
      component: (E.href || E.to) && s === "div" ? "button" : s,
      focusVisibleClassName: yt(P.focusVisible, v),
      ownerState: D,
      className: yt(P.root, S),
      ...E,
      classes: P,
      children: u
    })
  });
});
noe.NODE_ENV !== "production" && (BF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: c.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  href: c.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function dNe(e) {
  return Vt("MuiListItemSecondaryAction", e);
}
Wt("MuiListItemSecondaryAction", ["root", "disableGutters"]);
var fNe = {};
const pNe = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return Ft({
    root: ["root", t && "disableGutters"]
  }, dNe, n);
}, hNe = ye("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), VF = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: i,
    ...o
  } = r, s = $.useContext(Pc), u = {
    ...r,
    disableGutters: s.disableGutters
  }, f = pNe(u);
  return /* @__PURE__ */ T.jsx(hNe, {
    className: yt(f.root, i),
    ownerState: u,
    ref: n,
    ...o
  });
});
fNe.NODE_ENV !== "production" && (VF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
VF.muiName = "ListItemSecondaryAction";
var gNe = {};
const mNe = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.hasSecondaryAction && t.secondaryAction];
}, vNe = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disableGutters: i,
    disablePadding: o,
    divider: s,
    hasSecondaryAction: u
  } = e;
  return Ft({
    root: ["root", r && "dense", !i && "gutters", !o && "padding", s && "divider", t === "flex-start" && "alignItemsFlexStart", u && "secondaryAction"],
    container: ["container"]
  }, aNe, n);
}, yNe = ye("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: mNe
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${U0.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), bNe = ye("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), Hd = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: i = "center",
    children: o,
    className: s,
    component: u,
    components: f = {},
    componentsProps: p = {},
    ContainerComponent: m = "li",
    ContainerProps: {
      className: v,
      ...y
    } = {},
    dense: S = !1,
    disableGutters: E = !1,
    disablePadding: w = !1,
    divider: _ = !1,
    secondaryAction: O,
    slotProps: D = {},
    slots: P = {},
    ...M
  } = r, N = $.useContext(Pc), k = $.useMemo(() => ({
    dense: S || N.dense || !1,
    alignItems: i,
    disableGutters: E
  }), [i, N.dense, S, E]), U = $.useRef(null), H = $.Children.toArray(o), Y = H.length && J0(H[H.length - 1], ["ListItemSecondaryAction"]), z = {
    ...r,
    alignItems: i,
    dense: k.dense,
    disableGutters: E,
    disablePadding: w,
    divider: _,
    hasSecondaryAction: Y
  }, V = vNe(z), F = kr(U, n), X = P.root || f.Root || yNe, oe = D.root || p.root || {}, re = {
    className: yt(V.root, oe.className, s),
    ...M
  };
  let Z = u || "li";
  return Y ? (Z = !re.component && !u ? "div" : Z, m === "li" && (Z === "li" ? Z = "div" : re.component === "li" && (re.component = "div")), /* @__PURE__ */ T.jsx(Pc.Provider, {
    value: k,
    children: /* @__PURE__ */ T.jsxs(bNe, {
      as: m,
      className: yt(V.container, v),
      ref: F,
      ownerState: z,
      ...y,
      children: [/* @__PURE__ */ T.jsx(X, {
        ...oe,
        ...!ap(X) && {
          as: Z,
          ownerState: {
            ...z,
            ...oe.ownerState
          }
        },
        ...re,
        children: H
      }), H.pop()]
    })
  })) : /* @__PURE__ */ T.jsx(Pc.Provider, {
    value: k,
    children: /* @__PURE__ */ T.jsxs(X, {
      ...oe,
      as: Z,
      ref: F,
      ...!ap(X) && {
        ownerState: {
          ...z,
          ...oe.ownerState
        }
      },
      ...re,
      children: [H, O && /* @__PURE__ */ T.jsx(VF, {
        children: O
      })]
    })
  });
});
gNe.NODE_ENV !== "production" && (Hd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: c.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: Wa(c.node, (e) => {
    const t = $.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const i = t[r];
      if (J0(i, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: c.shape({
    root: c.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: Qv,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: c.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: c.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: c.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: c.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: c.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: c.shape({
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
class xNe {
  /** */
  constructor(t, n = void 0, { maxChars: r = 200, minimum: i = 20 } = {}) {
    this.hit = t, this.annotation = n, this.maxChars = r || 200, this.minimum = i || 20;
  }
  /** */
  get match() {
    return this.hit.match || this.annotation && this.annotation.resource.resource.chars || "-";
  }
  /** */
  get charsOnSide() {
    const t = (this.maxChars - this.match.length) / 2, n = [(this.hit.before || "").length, (this.hit.after || "").length].filter((r) => r > 0);
    return Math.max(Math.min(t, ...n), this.minimum);
  }
  /** */
  get before() {
    return this.hit.before ? this.hit.before.substring(this.hit.before.length - this.charsOnSide, this.hit.before.length) : "";
  }
  /** */
  get after() {
    return this.hit.after ? this.hit.after.substring(0, Math.min(this.hit.after.length, this.charsOnSide)) : "";
  }
}
const SNe = ye(Hd, { name: "SearchHit", slot: "root" })(({ ownerState: e, theme: t }) => ({
  "&.Mui-focused": {
    "&:hover": {
      ...e.windowSelected && {
        backgroundColor: "inherit"
      }
    },
    ...e.windowSelected && {
      backgroundColor: "inherit"
    }
  },
  paddingRight: t.spacing(1)
})), wNe = ye("h4", { name: "SearchHit", slot: "canvasLabel" })(({ theme: e }) => ({
  display: "inline",
  marginBottom: e.spacing(1.5)
})), TNe = ye(kx, { name: "SearchHit", slot: "counter" })(({ ownerState: e, theme: t }) => ({
  // eslint-disable-next-line no-nested-ternary
  backgroundColor: t.palette.hitCounter.default,
  ...e.windowSelected && {
    backgroundColor: t.palette.highlights.primary
  },
  ...e.adjacent && !e.windowSelected && {
    backgroundColor: t.palette.highlights.secondary
  },
  height: 30,
  marginRight: t.spacing(1),
  typography: "subtitle2",
  verticalAlign: "inherit"
}));
function roe({
  adjacent: e = !1,
  annotation: t = void 0,
  annotationId: n = void 0,
  annotationLabel: r = void 0,
  announcer: i = void 0,
  canvasLabel: o = void 0,
  companionWindowId: s = void 0,
  containerRef: u = void 0,
  focused: f = !1,
  hit: p = void 0,
  index: m = void 0,
  selectAnnotation: v = () => {
  },
  selected: y = !1,
  showDetails: S = () => {
  },
  total: E = void 0,
  windowId: w,
  windowSelected: _ = !1
}) {
  const { t: O } = Ct();
  ln(() => {
    y && M();
  }, [y]);
  const D = () => {
    t && n && v(n);
  }, P = Ui(() => p && new xNe(p, t), [p, t]), M = oNe(() => {
    !i || !P || i(
      [
        O("pagination", { current: m + 1, total: E }),
        o,
        r,
        P.before,
        P.match,
        P.after
      ].join(" "),
      "polite"
    );
  }), N = uo();
  if (f && !y) return null;
  const k = f ? p : p && P, U = p && (k.before !== p.before || k.after !== p.after), H = {
    adjacent: e,
    focused: f,
    selected: y,
    windowSelected: _
  }, Y = /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      TNe,
      {
        component: "span",
        ownerState: H,
        label: m + 1
      }
    ),
    /* @__PURE__ */ T.jsxs(wNe, { id: N, children: [
      o,
      r && /* @__PURE__ */ T.jsx(St, { component: "span", sx: { display: "block", marginTop: 1 }, children: r })
    ] })
  ] });
  return /* @__PURE__ */ T.jsx(
    zx,
    {
      containerRef: u,
      offsetTop: 96,
      scrollTo: _ && !f,
      children: /* @__PURE__ */ T.jsx(
        SNe,
        {
          ownerState: H,
          className: _ ? "windowSelected" : "",
          divider: !0,
          component: y ? "li" : BF,
          onClick: D,
          selected: y,
          children: /* @__PURE__ */ T.jsx(
            dp,
            {
              primary: Y,
              primaryTypographyProps: { component: "div", sx: { marginBottom: 1 }, variant: "subtitle2" },
              secondaryTypographyProps: { variant: "body1" },
              secondary: /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
                p && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
                  /* @__PURE__ */ T.jsx(Bs, { ruleSet: "iiif", htmlString: k.before }),
                  " ",
                  /* @__PURE__ */ T.jsx("strong", { children: /* @__PURE__ */ T.jsx(Bs, { ruleSet: "iiif", htmlString: k.match }) }),
                  " ",
                  /* @__PURE__ */ T.jsx(Bs, { ruleSet: "iiif", htmlString: k.after }),
                  " ",
                  U && !f && /* @__PURE__ */ T.jsx(
                    hi,
                    {
                      sx: {
                        "& span": {
                          lineHeight: "1.5em"
                        },
                        margin: 0,
                        padding: 0,
                        textTransform: "none"
                      },
                      onClick: S,
                      color: "secondary",
                      size: "small",
                      "aria-describedby": N,
                      children: O("more")
                    }
                  )
                ] }),
                !p && t && /* @__PURE__ */ T.jsx(Bs, { ruleSet: "iiif", htmlString: t.chars })
              ] })
            }
          )
        }
      )
    }
  );
}
roe.propTypes = {
  adjacent: c.bool,
  annotation: c.shape({
    chars: c.string,
    targetId: c.string
  }),
  annotationId: c.string,
  annotationLabel: c.string,
  announcer: c.func,
  canvasLabel: c.string,
  companionWindowId: c.string,
  containerRef: c.oneOfType([
    c.func,
    c.shape({ current: c.instanceOf(Element) })
  ]),
  focused: c.bool,
  hit: c.shape({
    after: c.string,
    before: c.string,
    match: c.string
  }),
  index: c.number,
  selectAnnotation: c.func,
  selected: c.bool,
  showDetails: c.func,
  total: c.number,
  windowId: c.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  windowSelected: c.bool
};
const ENe = (e, {
  annotationId: t,
  hit: n = { annotations: [] },
  companionWindowId: r,
  windowId: i
}) => {
  const o = t || n.annotations[0], s = T3(
    e,
    {
      annotationUri: o,
      companionWindowId: r,
      windowId: i
    }
  ), u = mte(e, { annotationUri: o, companionWindowId: r, windowId: i }), f = ku(e, { windowId: i }), p = _D(e, {
    companionWindowId: r,
    windowId: i
  }), m = X1(e, { windowId: i }), v = [t, ...n.annotations];
  return {
    adjacent: f.includes(s.targetId),
    annotation: s,
    annotationId: o,
    annotationLabel: u[0],
    canvasLabel: s && yg(e, {
      canvasId: s.targetId,
      windowId: i
    }),
    selected: p[0] && v.includes(p[0]),
    windowSelected: m && v.includes(m)
  };
}, _Ne = (e, { windowId: t }) => ({
  selectAnnotation: (...n) => e(
    Kv(t, ...n)
  )
}), CNe = wt(
  At(ENe, _Ne),
  Tt("SearchHit")
), z7 = CNe(roe);
function RNe({
  companionWindowId: e,
  containerRef: t,
  searchAnnotations: n,
  searchHits: r,
  windowId: i,
  focused: o,
  toggleFocus: s
}) {
  return r.length === 0 && n.length > 0 ? n.map((u, f) => /* @__PURE__ */ T.jsx(
    z7,
    {
      announcer: k7,
      annotationId: u.id,
      companionWindowId: e,
      containerRef: t,
      focused: o,
      index: f,
      total: n.length,
      windowId: i,
      showDetails: s
    },
    u.id
  )) : r.map((u, f) => /* @__PURE__ */ T.jsx(
    z7,
    {
      announcer: k7,
      containerRef: t,
      companionWindowId: e,
      focused: o,
      hit: u,
      index: f,
      total: r.length,
      windowId: i,
      showDetails: s
    },
    u.annotations[0]
  ));
}
function ioe({
  companionWindowId: e,
  containerRef: t = void 0,
  isFetching: n = !1,
  fetchSearch: r,
  nextSearch: i = void 0,
  query: o = void 0,
  searchAnnotations: s = [],
  searchHits: u = [],
  searchNumTotal: f = void 0,
  windowId: p
}) {
  const { t: m } = Ct(), [v, y] = Bn(!1), S = Yn(() => {
    y(!v);
  }, [y, v]), E = o && !n && u.length === 0 && s.length === 0;
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    v && /* @__PURE__ */ T.jsx(zx, { containerRef: t, offsetTop: 96, scrollTo: !0, children: /* @__PURE__ */ T.jsxs(hi, { onClick: S, sx: { textTransform: "none" }, size: "small", children: [
      /* @__PURE__ */ T.jsx(zF, {}),
      m("backToResults")
    ] }) }),
    E && /* @__PURE__ */ T.jsx(
      St,
      {
        sx: {
          padding: 2,
          typography: "h6"
        },
        children: m("searchNoResults")
      }
    ),
    /* @__PURE__ */ T.jsx(Xd, { disablePadding: !0, children: /* @__PURE__ */ T.jsx(
      RNe,
      {
        companionWindowId: e,
        containerRef: t,
        searchAnnotations: s,
        searchHits: u,
        windowId: p,
        focused: v,
        toggleFocus: S
      }
    ) }),
    i && /* @__PURE__ */ T.jsxs(
      hi,
      {
        sx: { width: "100%" },
        color: "secondary",
        onClick: () => r(p, e, i, o),
        children: [
          m("moreResults"),
          /* @__PURE__ */ T.jsx("br", {}),
          `(${m("searchResultsRemaining", { numLeft: f - u.length })})`
        ]
      }
    )
  ] });
}
ioe.propTypes = {
  companionWindowId: c.string.isRequired,
  containerRef: c.oneOfType([
    c.func,
    c.shape({ current: c.instanceOf(Element) })
  ]),
  fetchSearch: c.func.isRequired,
  isFetching: c.bool,
  nextSearch: c.string,
  query: c.string,
  searchAnnotations: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  searchHits: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  searchNumTotal: c.number,
  windowId: c.string.isRequired
  // eslint-disable-line react/no-unused-prop-types
};
const ONe = (e, { companionWindowId: t, windowId: n }) => ({
  isFetching: b3(e, { companionWindowId: t, windowId: n }),
  nextSearch: pte(e, { companionWindowId: t, windowId: n }),
  query: K1(e, { companionWindowId: t, windowId: n }),
  searchAnnotations: w3(e, { companionWindowId: t, windowId: n }),
  searchHits: S3(e, { companionWindowId: t, windowId: n }),
  searchNumTotal: x3(e, { companionWindowId: t, windowId: n })
}), ANe = {
  fetchSearch: o_
}, DNe = wt(
  At(ONe, ANe),
  Tt("SearchResults")
), INe = DNe(ioe);
function ooe({
  fetchSearch: e = void 0,
  id: t,
  query: n = "",
  removeSearch: r,
  searchService: i,
  suggestedSearches: o = [],
  windowId: s
}) {
  const { t: u } = Ct(), f = an(null);
  return /* @__PURE__ */ T.jsxs(
    Zd,
    {
      ariaLabel: u("searchTitle"),
      title: /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        u("searchTitle"),
        n && n !== "" && /* @__PURE__ */ T.jsx(
          kx,
          {
            role: "button",
            sx: { marginLeft: 1 },
            color: "secondary",
            label: u("clearSearch"),
            onClick: r,
            onDelete: r,
            size: "small",
            tabIndex: 0,
            variant: "outlined"
          }
        )
      ] }),
      windowId: s,
      id: t,
      titleControls: /* @__PURE__ */ T.jsx(rNe, { companionWindowId: t, windowId: s }),
      ref: f,
      children: [
        /* @__PURE__ */ T.jsx(
          INe,
          {
            containerRef: f,
            companionWindowId: t,
            windowId: s
          }
        ),
        e && o && n === "" && o.map((p) => /* @__PURE__ */ T.jsx(St, { component: "p", variant: "body1", sx: { margin: 2 }, children: /* @__PURE__ */ T.jsx(
          hi,
          {
            variant: "inlineText",
            color: "secondary",
            onClick: () => e(`${i.id}?q=${p}`, p),
            children: u("suggestSearch", { query: p })
          }
        ) }, p))
      ]
    }
  );
}
ooe.propTypes = {
  fetchSearch: c.func,
  id: c.string.isRequired,
  query: c.string,
  removeSearch: c.func.isRequired,
  searchService: c.shape({
    id: c.string
  }).isRequired,
  suggestedSearches: c.arrayOf(c.string),
  windowId: c.string.isRequired
};
const PNe = (e, { id: t, windowId: n }) => ({
  query: K1(e, { companionWindowId: t, windowId: n }),
  searchService: Dx(e, { windowId: n }),
  suggestedSearches: Wn(e, { windowId: n }).suggestedSearches
}), NNe = (e, t) => ({
  fetchSearch: (n, r) => e(
    o_(t.windowId, t.id, n, r)
  ),
  removeSearch: () => e(dne(t.windowId, t.id))
}), MNe = wt(
  At(PNe, NNe),
  Tt("SearchPanel")
), jNe = MNe(ooe);
function LNe(e, t, n = (r, i) => r === i) {
  return e.length === t.length && e.every((r, i) => n(r, t[i]));
}
const kNe = 2;
function I0(e, t, n, r, i) {
  return n === 1 ? Math.min(e + t, i) : Math.max(e - t, r);
}
function aoe(e, t) {
  return e - t;
}
function B7(e, t) {
  const {
    index: n
  } = e.reduce((r, i, o) => {
    const s = Math.abs(t - i);
    return r === null || s < r.distance || s === r.distance ? {
      distance: s,
      index: o
    } : r;
  }, null) ?? {};
  return n;
}
function oO(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let r = 0; r < n.changedTouches.length; r += 1) {
      const i = n.changedTouches[r];
      if (i.identifier === t.current)
        return {
          x: i.clientX,
          y: i.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function bA(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function zNe(e, t, n) {
  return (n - t) * e + t;
}
function BNe(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function VNe(e, t, n) {
  const r = Math.round((e - n) / t) * t + n;
  return Number(r.toFixed(BNe(t)));
}
function V7({
  values: e,
  newValue: t,
  index: n
}) {
  const r = e.slice();
  return r[n] = t, r.sort(aoe);
}
function aO({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var i, o, s;
  const r = Vi(e.current);
  (!((i = e.current) != null && i.contains(r.activeElement)) || Number((o = r == null ? void 0 : r.activeElement) == null ? void 0 : o.getAttribute("data-index")) !== t) && ((s = e.current) == null || s.querySelector(`[type="range"][data-index="${t}"]`).focus()), n && n(t);
}
function sO(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? LNe(e, t) : !1;
}
const UNe = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, FNe = (e) => e;
let lO;
function U7() {
  return lO === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? lO = CSS.supports("touch-action", "none") : lO = !0), lO;
}
function WNe(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: r = !1,
    disableSwap: i = !1,
    isRtl: o = !1,
    marks: s = !1,
    max: u = 100,
    min: f = 0,
    name: p,
    onChange: m,
    onChangeCommitted: v,
    orientation: y = "horizontal",
    rootRef: S,
    scale: E = FNe,
    step: w = 1,
    shiftStep: _ = 10,
    tabIndex: O,
    value: D
  } = e, P = $.useRef(void 0), [M, N] = $.useState(-1), [k, U] = $.useState(-1), [H, Y] = $.useState(!1), z = $.useRef(0), V = $.useRef(null), [F, X] = ip({
    controlled: D,
    default: n ?? f,
    name: "Slider"
  }), oe = m && ((qe, at, et) => {
    const bt = qe.nativeEvent || qe, q = new bt.constructor(bt.type, bt);
    Object.defineProperty(q, "target", {
      writable: !0,
      value: {
        value: at,
        name: p
      }
    }), V.current = at, m(q, at, et);
  }), re = Array.isArray(F);
  let Z = re ? F.slice().sort(aoe) : [F];
  Z = Z.map((qe) => qe == null ? f : z0(qe, f, u));
  const ee = s === !0 && w !== null ? [...Array(Math.floor((u - f) / w) + 1)].map((qe, at) => ({
    value: f + w * at
  })) : s || [], J = ee.map((qe) => qe.value), [le, be] = $.useState(-1), ne = $.useRef(null), ae = kr(S, ne), ie = (qe) => (at) => {
    var bt;
    const et = Number(at.currentTarget.getAttribute("data-index"));
    lg(at.target) && be(et), U(et), (bt = qe == null ? void 0 : qe.onFocus) == null || bt.call(qe, at);
  }, he = (qe) => (at) => {
    var et;
    lg(at.target) || be(-1), U(-1), (et = qe == null ? void 0 : qe.onBlur) == null || et.call(qe, at);
  }, pe = (qe, at) => {
    const et = Number(qe.currentTarget.getAttribute("data-index")), bt = Z[et], q = J.indexOf(bt);
    let W = at;
    if (ee && w == null) {
      const Q = J[J.length - 1];
      W >= Q ? W = Q : W <= J[0] ? W = J[0] : W = W < bt ? J[q - 1] : J[q + 1];
    }
    if (W = z0(W, f, u), re) {
      i && (W = z0(W, Z[et - 1] || -1 / 0, Z[et + 1] || 1 / 0));
      const Q = W;
      W = V7({
        values: Z,
        newValue: W,
        index: et
      });
      let ce = et;
      i || (ce = W.indexOf(Q)), aO({
        sliderRef: ne,
        activeIndex: ce
      });
    }
    X(W), be(et), oe && !sO(W, F) && oe(qe, W, et), v && v(qe, V.current ?? W);
  }, me = (qe) => (at) => {
    var et;
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(at.key)) {
      at.preventDefault();
      const bt = Number(at.currentTarget.getAttribute("data-index")), q = Z[bt];
      let W = null;
      if (w != null) {
        const Q = at.shiftKey ? _ : w;
        switch (at.key) {
          case "ArrowUp":
            W = I0(q, Q, 1, f, u);
            break;
          case "ArrowRight":
            W = I0(q, Q, o ? -1 : 1, f, u);
            break;
          case "ArrowDown":
            W = I0(q, Q, -1, f, u);
            break;
          case "ArrowLeft":
            W = I0(q, Q, o ? 1 : -1, f, u);
            break;
          case "PageUp":
            W = I0(q, _, 1, f, u);
            break;
          case "PageDown":
            W = I0(q, _, -1, f, u);
            break;
          case "Home":
            W = f;
            break;
          case "End":
            W = u;
            break;
        }
      } else if (ee) {
        const Q = J[J.length - 1], ce = J.indexOf(q), _e = [o ? "ArrowRight" : "ArrowLeft", "ArrowDown", "PageDown", "Home"], Fe = [o ? "ArrowLeft" : "ArrowRight", "ArrowUp", "PageUp", "End"];
        _e.includes(at.key) ? ce === 0 ? W = J[0] : W = J[ce - 1] : Fe.includes(at.key) && (ce === J.length - 1 ? W = Q : W = J[ce + 1]);
      }
      W != null && pe(at, W);
    }
    (et = qe == null ? void 0 : qe.onKeyDown) == null || et.call(qe, at);
  };
  gs(() => {
    var qe;
    r && ne.current.contains(document.activeElement) && ((qe = document.activeElement) == null || qe.blur());
  }, [r]), r && M !== -1 && N(-1), r && le !== -1 && be(-1);
  const Ee = (qe) => (at) => {
    var et;
    (et = qe.onChange) == null || et.call(qe, at), pe(at, at.target.valueAsNumber);
  }, Ie = $.useRef(void 0);
  let Pe = y;
  o && y === "horizontal" && (Pe += "-reverse");
  const De = ({
    finger: qe,
    move: at = !1
  }) => {
    const {
      current: et
    } = ne, {
      width: bt,
      height: q,
      bottom: W,
      left: Q
    } = et.getBoundingClientRect();
    let ce;
    Pe.startsWith("vertical") ? ce = (W - qe.y) / q : ce = (qe.x - Q) / bt, Pe.includes("-reverse") && (ce = 1 - ce);
    let _e;
    if (_e = zNe(ce, f, u), w)
      _e = VNe(_e, w, f);
    else {
      const gt = B7(J, _e);
      _e = J[gt];
    }
    _e = z0(_e, f, u);
    let Fe = 0;
    if (re) {
      at ? Fe = Ie.current : Fe = B7(Z, _e), i && (_e = z0(_e, Z[Fe - 1] || -1 / 0, Z[Fe + 1] || 1 / 0));
      const gt = _e;
      _e = V7({
        values: Z,
        newValue: _e,
        index: Fe
      }), i && at || (Fe = _e.indexOf(gt), Ie.current = Fe);
    }
    return {
      newValue: _e,
      activeIndex: Fe
    };
  }, Ye = Mr((qe) => {
    const at = oO(qe, P);
    if (!at)
      return;
    if (z.current += 1, qe.type === "mousemove" && qe.buttons === 0) {
      Ue(qe);
      return;
    }
    const {
      newValue: et,
      activeIndex: bt
    } = De({
      finger: at,
      move: !0
    });
    aO({
      sliderRef: ne,
      activeIndex: bt,
      setActive: N
    }), X(et), !H && z.current > kNe && Y(!0), oe && !sO(et, F) && oe(qe, et, bt);
  }), Ue = Mr((qe) => {
    const at = oO(qe, P);
    if (Y(!1), !at)
      return;
    const {
      newValue: et
    } = De({
      finger: at,
      move: !0
    });
    N(-1), qe.type === "touchend" && U(-1), v && v(qe, V.current ?? et), P.current = void 0, rt();
  }), ve = Mr((qe) => {
    if (r)
      return;
    U7() || qe.preventDefault();
    const at = qe.changedTouches[0];
    at != null && (P.current = at.identifier);
    const et = oO(qe, P);
    if (et !== !1) {
      const {
        newValue: q,
        activeIndex: W
      } = De({
        finger: et
      });
      aO({
        sliderRef: ne,
        activeIndex: W,
        setActive: N
      }), X(q), oe && !sO(q, F) && oe(qe, q, W);
    }
    z.current = 0;
    const bt = Vi(ne.current);
    bt.addEventListener("touchmove", Ye, {
      passive: !0
    }), bt.addEventListener("touchend", Ue, {
      passive: !0
    });
  }), rt = $.useCallback(() => {
    const qe = Vi(ne.current);
    qe.removeEventListener("mousemove", Ye), qe.removeEventListener("mouseup", Ue), qe.removeEventListener("touchmove", Ye), qe.removeEventListener("touchend", Ue);
  }, [Ue, Ye]);
  $.useEffect(() => {
    const {
      current: qe
    } = ne;
    return qe.addEventListener("touchstart", ve, {
      passive: U7()
    }), () => {
      qe.removeEventListener("touchstart", ve), rt();
    };
  }, [rt, ve]), $.useEffect(() => {
    r && rt();
  }, [r, rt]);
  const Te = (qe) => (at) => {
    var q;
    if ((q = qe.onMouseDown) == null || q.call(qe, at), r || at.defaultPrevented || at.button !== 0)
      return;
    at.preventDefault();
    const et = oO(at, P);
    if (et !== !1) {
      const {
        newValue: W,
        activeIndex: Q
      } = De({
        finger: et
      });
      aO({
        sliderRef: ne,
        activeIndex: Q,
        setActive: N
      }), X(W), oe && !sO(W, F) && oe(at, W, Q);
    }
    z.current = 0;
    const bt = Vi(ne.current);
    bt.addEventListener("mousemove", Ye, {
      passive: !0
    }), bt.addEventListener("mouseup", Ue);
  }, Je = bA(re ? Z[0] : f, f, u), L = bA(Z[Z.length - 1], f, u) - Je, te = (qe = {}) => {
    const at = op(qe), et = {
      onMouseDown: Te(at || {})
    }, bt = {
      ...at,
      ...et
    };
    return {
      ...qe,
      ref: ae,
      ...bt
    };
  }, ge = (qe) => (at) => {
    var bt;
    (bt = qe.onMouseOver) == null || bt.call(qe, at);
    const et = Number(at.currentTarget.getAttribute("data-index"));
    U(et);
  }, ke = (qe) => (at) => {
    var et;
    (et = qe.onMouseLeave) == null || et.call(qe, at), U(-1);
  }, We = (qe = {}) => {
    const at = op(qe), et = {
      onMouseOver: ge(at || {}),
      onMouseLeave: ke(at || {})
    };
    return {
      ...qe,
      ...at,
      ...et
    };
  }, Be = (qe) => ({
    // So the non active thumb doesn't show its label on hover.
    pointerEvents: M !== -1 && M !== qe ? "none" : void 0
  });
  let je;
  return y === "vertical" && (je = o ? "vertical-rl" : "vertical-lr"), {
    active: M,
    axis: Pe,
    axisProps: UNe,
    dragging: H,
    focusedThumbIndex: le,
    getHiddenInputProps: (qe = {}) => {
      const at = op(qe), et = {
        onChange: Ee(at || {}),
        onFocus: ie(at || {}),
        onBlur: he(at || {}),
        onKeyDown: me(at || {})
      }, bt = {
        ...at,
        ...et
      };
      return {
        tabIndex: O,
        "aria-labelledby": t,
        "aria-orientation": y,
        "aria-valuemax": E(u),
        "aria-valuemin": E(f),
        name: p,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : e.step ?? void 0,
        disabled: r,
        ...qe,
        ...bt,
        style: {
          ...XD,
          direction: o ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%",
          writingMode: je
        }
      };
    },
    getRootProps: te,
    getThumbProps: We,
    marks: ee,
    open: k,
    range: re,
    rootRef: ae,
    trackLeap: L,
    trackOffset: Je,
    values: Z,
    getThumbStyle: Be
  };
}
const HNe = (e) => !e || !ap(e);
function qNe(e) {
  return Vt("MuiSlider", e);
}
const Rc = Wt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]);
var $Ne = {};
const GNe = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: yt(t && Rc.valueLabelOpen),
    circle: Rc.valueLabelCircle,
    label: Rc.valueLabelLabel
  };
};
function soe(e) {
  const {
    children: t,
    className: n,
    value: r
  } = e, i = GNe(e);
  return t ? /* @__PURE__ */ $.cloneElement(t, {
    className: yt(t.props.className)
  }, /* @__PURE__ */ T.jsxs($.Fragment, {
    children: [t.props.children, /* @__PURE__ */ T.jsx("span", {
      className: yt(i.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ T.jsx("span", {
        className: i.circle,
        children: /* @__PURE__ */ T.jsx("span", {
          className: i.label,
          children: r
        })
      })
    })]
  })) : null;
}
$Ne.NODE_ENV !== "production" && (soe.propTypes = {
  children: c.element.isRequired,
  className: c.string,
  value: c.node
});
var loe = {};
function F7(e) {
  return e;
}
const YNe = ye("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${Ke(n.color)}`], n.size !== "medium" && t[`size${Ke(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(Lt(({
  theme: e
}) => ({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  WebkitTapHighlightColor: "transparent",
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${Rc.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${Rc.dragging}`]: {
    [`& .${Rc.thumb}, & .${Rc.track}`]: {
      transition: "none"
    }
  },
  variants: [...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: 4,
      width: "100%",
      padding: "13px 0",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0"
      }
    }
  }, {
    props: {
      orientation: "horizontal",
      size: "small"
    },
    style: {
      height: 2
    }
  }, {
    props: {
      orientation: "horizontal",
      marked: !0
    },
    style: {
      marginBottom: 20
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: 4,
      padding: "0 13px",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "0 20px"
      }
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      width: 2
    }
  }, {
    props: {
      orientation: "vertical",
      marked: !0
    },
    style: {
      marginRight: 44
    }
  }]
}))), XNe = ye("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), ZNe = ye("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(Lt(({
  theme: e
}) => ({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  border: "1px solid currentColor",
  backgroundColor: "currentColor",
  transition: e.transitions.create(["left", "width", "bottom", "height"], {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      size: "small"
    },
    style: {
      border: "none"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: !1
    },
    style: {
      display: "none"
    }
  }, ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t,
      track: "inverted"
    },
    style: {
      ...e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${t}Track`],
        borderColor: e.vars.palette.Slider[`${t}Track`]
      } : {
        backgroundColor: Lv(e.palette[t].main, 0.62),
        borderColor: Lv(e.palette[t].main, 0.62),
        ...e.applyStyles("dark", {
          backgroundColor: jv(e.palette[t].main, 0.5)
        }),
        ...e.applyStyles("dark", {
          borderColor: jv(e.palette[t].main, 0.5)
        })
      }
    }
  }))]
}))), KNe = ye("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${Ke(n.color)}`], n.size !== "medium" && t[`thumbSize${Ke(n.size)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  }),
  "&::before": {
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  },
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&.${Rc.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 12,
      height: 12,
      "&::before": {
        boxShadow: "none"
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 50%)"
    }
  }, ...Object.entries(e.palette).filter(Jr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&:hover, &.${Rc.focusVisible}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${Cn(e.palette[t].main, 0.16)}`
        },
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      [`&.${Rc.active}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${Cn(e.palette[t].main, 0.16)}`
        }
      }
    }
  }))]
}))), coe = ye(soe, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(Lt(({
  theme: e
}) => ({
  zIndex: 1,
  whiteSpace: "nowrap",
  ...e.typography.body2,
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${Rc.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${Rc.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})));
loe.NODE_ENV !== "production" && (coe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: c.element.isRequired,
  /**
   * @ignore
   */
  index: c.number.isRequired,
  /**
   * @ignore
   */
  open: c.bool.isRequired,
  /**
   * @ignore
   */
  value: c.node
});
const QNe = ye("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => QD(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(Lt(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
}))), JNe = ye("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => QD(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(Lt(({
  theme: e
}) => ({
  ...e.typography.body2,
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
}))), eMe = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: r,
    orientation: i,
    track: o,
    classes: s,
    color: u,
    size: f
  } = e, p = {
    root: ["root", t && "disabled", n && "dragging", r && "marked", i === "vertical" && "vertical", o === "inverted" && "trackInverted", o === !1 && "trackFalse", u && `color${Ke(u)}`, f && `size${Ke(f)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", f && `thumbSize${Ke(f)}`, u && `thumbColor${Ke(u)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return Ft(p, qNe, s);
}, tMe = ({
  children: e
}) => e, uoe = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiSlider"
  }), i = wg(), {
    "aria-label": o,
    "aria-valuetext": s,
    "aria-labelledby": u,
    // eslint-disable-next-line react/prop-types
    component: f = "span",
    components: p = {},
    componentsProps: m = {},
    color: v = "primary",
    classes: y,
    className: S,
    disableSwap: E = !1,
    disabled: w = !1,
    getAriaLabel: _,
    getAriaValueText: O,
    marks: D = !1,
    max: P = 100,
    min: M = 0,
    name: N,
    onChange: k,
    onChangeCommitted: U,
    orientation: H = "horizontal",
    shiftStep: Y = 10,
    size: z = "medium",
    step: V = 1,
    scale: F = F7,
    slotProps: X,
    slots: oe,
    tabIndex: re,
    track: Z = "normal",
    value: ee,
    valueLabelDisplay: J = "off",
    valueLabelFormat: le = F7,
    ...be
  } = r, ne = {
    ...r,
    isRtl: i,
    max: P,
    min: M,
    classes: y,
    disabled: w,
    disableSwap: E,
    orientation: H,
    marks: D,
    color: v,
    size: z,
    step: V,
    shiftStep: Y,
    scale: F,
    track: Z,
    valueLabelDisplay: J,
    valueLabelFormat: le
  }, {
    axisProps: ae,
    getRootProps: ie,
    getHiddenInputProps: he,
    getThumbProps: pe,
    open: me,
    active: Ee,
    axis: Ie,
    focusedThumbIndex: Pe,
    range: De,
    dragging: Ye,
    marks: Ue,
    values: ve,
    trackOffset: rt,
    trackLeap: Te,
    getThumbStyle: Je
  } = WNe({
    ...ne,
    rootRef: n
  });
  ne.marked = Ue.length > 0 && Ue.some((Zt) => Zt.label), ne.dragging = Ye, ne.focusedThumbIndex = Pe;
  const L = eMe(ne), te = (oe == null ? void 0 : oe.root) ?? p.Root ?? YNe, ge = (oe == null ? void 0 : oe.rail) ?? p.Rail ?? XNe, ke = (oe == null ? void 0 : oe.track) ?? p.Track ?? ZNe, We = (oe == null ? void 0 : oe.thumb) ?? p.Thumb ?? KNe, Be = (oe == null ? void 0 : oe.valueLabel) ?? p.ValueLabel ?? coe, je = (oe == null ? void 0 : oe.mark) ?? p.Mark ?? QNe, mt = (oe == null ? void 0 : oe.markLabel) ?? p.MarkLabel ?? JNe, qe = (oe == null ? void 0 : oe.input) ?? p.Input ?? "input", at = (X == null ? void 0 : X.root) ?? m.root, et = (X == null ? void 0 : X.rail) ?? m.rail, bt = (X == null ? void 0 : X.track) ?? m.track, q = (X == null ? void 0 : X.thumb) ?? m.thumb, W = (X == null ? void 0 : X.valueLabel) ?? m.valueLabel, Q = (X == null ? void 0 : X.mark) ?? m.mark, ce = (X == null ? void 0 : X.markLabel) ?? m.markLabel, _e = (X == null ? void 0 : X.input) ?? m.input, Fe = Oo({
    elementType: te,
    getSlotProps: ie,
    externalSlotProps: at,
    externalForwardedProps: be,
    additionalProps: {
      ...HNe(te) && {
        as: f
      }
    },
    ownerState: {
      ...ne,
      ...at == null ? void 0 : at.ownerState
    },
    className: [L.root, S]
  }), gt = Oo({
    elementType: ge,
    externalSlotProps: et,
    ownerState: ne,
    className: L.rail
  }), ct = Oo({
    elementType: ke,
    externalSlotProps: bt,
    additionalProps: {
      style: {
        ...ae[Ie].offset(rt),
        ...ae[Ie].leap(Te)
      }
    },
    ownerState: {
      ...ne,
      ...bt == null ? void 0 : bt.ownerState
    },
    className: L.track
  }), ht = Oo({
    elementType: We,
    getSlotProps: pe,
    externalSlotProps: q,
    ownerState: {
      ...ne,
      ...q == null ? void 0 : q.ownerState
    },
    className: L.thumb
  }), Yt = Oo({
    elementType: Be,
    externalSlotProps: W,
    ownerState: {
      ...ne,
      ...W == null ? void 0 : W.ownerState
    },
    className: L.valueLabel
  }), Rt = Oo({
    elementType: je,
    externalSlotProps: Q,
    ownerState: ne,
    className: L.mark
  }), cn = Oo({
    elementType: mt,
    externalSlotProps: ce,
    ownerState: ne,
    className: L.markLabel
  }), Kt = Oo({
    elementType: qe,
    getSlotProps: he,
    externalSlotProps: _e,
    ownerState: ne
  });
  return /* @__PURE__ */ T.jsxs(te, {
    ...Fe,
    children: [/* @__PURE__ */ T.jsx(ge, {
      ...gt
    }), /* @__PURE__ */ T.jsx(ke, {
      ...ct
    }), Ue.filter((Zt) => Zt.value >= M && Zt.value <= P).map((Zt, dn) => {
      const xr = bA(Zt.value, M, P), Hr = ae[Ie].offset(xr);
      let jr;
      return Z === !1 ? jr = ve.includes(Zt.value) : jr = Z === "normal" && (De ? Zt.value >= ve[0] && Zt.value <= ve[ve.length - 1] : Zt.value <= ve[0]) || Z === "inverted" && (De ? Zt.value <= ve[0] || Zt.value >= ve[ve.length - 1] : Zt.value >= ve[0]), /* @__PURE__ */ T.jsxs($.Fragment, {
        children: [/* @__PURE__ */ T.jsx(je, {
          "data-index": dn,
          ...Rt,
          ...!ap(je) && {
            markActive: jr
          },
          style: {
            ...Hr,
            ...Rt.style
          },
          className: yt(Rt.className, jr && L.markActive)
        }), Zt.label != null ? /* @__PURE__ */ T.jsx(mt, {
          "aria-hidden": !0,
          "data-index": dn,
          ...cn,
          ...!ap(mt) && {
            markLabelActive: jr
          },
          style: {
            ...Hr,
            ...cn.style
          },
          className: yt(L.markLabel, cn.className, jr && L.markLabelActive),
          children: Zt.label
        }) : null]
      }, dn);
    }), ve.map((Zt, dn) => {
      const xr = bA(Zt, M, P), Hr = ae[Ie].offset(xr), jr = J === "off" ? tMe : Be;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ T.jsx(jr, {
          ...!ap(jr) && {
            valueLabelFormat: le,
            valueLabelDisplay: J,
            value: typeof le == "function" ? le(F(Zt), dn) : le,
            index: dn,
            open: me === dn || Ee === dn || J === "on",
            disabled: w
          },
          ...Yt,
          children: /* @__PURE__ */ T.jsx(We, {
            "data-index": dn,
            ...ht,
            className: yt(L.thumb, ht.className, Ee === dn && L.active, Pe === dn && L.focusVisible),
            style: {
              ...Hr,
              ...Je(dn),
              ...ht.style
            },
            children: /* @__PURE__ */ T.jsx(qe, {
              "data-index": dn,
              "aria-label": _ ? _(dn) : o,
              "aria-valuenow": F(Zt),
              "aria-labelledby": u,
              "aria-valuetext": O ? O(F(Zt), dn) : s,
              value: ve[dn],
              ...Kt
            })
          })
        }, dn)
      );
    })]
  });
});
loe.NODE_ENV !== "production" && (uoe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": Wa(c.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": c.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": Wa(c.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Mark: c.elementType,
    MarkLabel: c.elementType,
    Rail: c.elementType,
    Root: c.elementType,
    Thumb: c.elementType,
    Track: c.elementType,
    ValueLabel: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.oneOfType([c.func, c.object]),
    mark: c.oneOfType([c.func, c.object]),
    markLabel: c.oneOfType([c.func, c.object]),
    rail: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    thumb: c.oneOfType([c.func, c.object]),
    track: c.oneOfType([c.func, c.object]),
    valueLabel: c.oneOfType([c.func, c.shape({
      children: c.element,
      className: c.string,
      open: c.bool,
      style: c.object,
      value: c.node,
      valueLabelDisplay: c.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.oneOfType([c.arrayOf(c.number), c.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: c.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: c.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: c.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: c.oneOfType([c.arrayOf(c.shape({
    label: c.node,
    value: c.number.isRequired
  })), c.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: c.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: c.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: c.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: c.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: c.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: c.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: c.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: c.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium"]), c.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: c.shape({
    input: c.oneOfType([c.func, c.object]),
    mark: c.oneOfType([c.func, c.object]),
    markLabel: c.oneOfType([c.func, c.object]),
    rail: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    thumb: c.oneOfType([c.func, c.object]),
    track: c.oneOfType([c.func, c.object]),
    valueLabel: c.oneOfType([c.func, c.shape({
      children: c.element,
      className: c.string,
      open: c.bool,
      style: c.object,
      value: c.node,
      valueLabelDisplay: c.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    mark: c.elementType,
    markLabel: c.elementType,
    rail: c.elementType,
    root: c.elementType,
    thumb: c.elementType,
    track: c.elementType,
    valueLabel: c.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: c.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: c.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: c.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: c.oneOfType([c.arrayOf(c.number), c.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: c.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: c.oneOfType([c.func, c.string])
});
const nMe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M20 9H4v2h16zM4 15h16v-2H4z"
}), "DragHandleSharp"), rMe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M8 11h3v10h2V11h3l-4-4zM4 3v2h16V3z"
}), "VerticalAlignTopSharp"), doe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M16 13h-3V3h-2v10H8l4 4zM4 19v2h16v-2z"
}), "VerticalAlignBottomSharp"), iMe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M17.66 8 12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8M6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14z"
}), "OpacitySharp");
function W7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function H7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? W7(Object(n), !0).forEach(function(r) {
      LF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : W7(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ds = {};
function Ls(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var q7 = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})(), $7 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, G7 = {
  INIT: "@@redux/INIT" + $7(),
  REPLACE: "@@redux/REPLACE" + $7()
};
function oMe(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function aMe(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (cMe(e)) return "date";
  if (lMe(e)) return "error";
  var n = sMe(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function sMe(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function lMe(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function cMe(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function pv(e) {
  var t = typeof e;
  return ds.NODE_ENV !== "production" && (t = aMe(e)), t;
}
function foe(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(ds.NODE_ENV === "production" ? Ls(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(ds.NODE_ENV === "production" ? Ls(1) : "Expected the enhancer to be a function. Instead, received: '" + pv(n) + "'");
    return n(foe)(e, t);
  }
  if (typeof e != "function")
    throw new Error(ds.NODE_ENV === "production" ? Ls(2) : "Expected the root reducer to be a function. Instead, received: '" + pv(e) + "'");
  var i = e, o = t, s = [], u = s, f = !1;
  function p() {
    u === s && (u = s.slice());
  }
  function m() {
    if (f)
      throw new Error(ds.NODE_ENV === "production" ? Ls(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function v(w) {
    if (typeof w != "function")
      throw new Error(ds.NODE_ENV === "production" ? Ls(4) : "Expected the listener to be a function. Instead, received: '" + pv(w) + "'");
    if (f)
      throw new Error(ds.NODE_ENV === "production" ? Ls(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var _ = !0;
    return p(), u.push(w), function() {
      if (_) {
        if (f)
          throw new Error(ds.NODE_ENV === "production" ? Ls(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        _ = !1, p();
        var D = u.indexOf(w);
        u.splice(D, 1), s = null;
      }
    };
  }
  function y(w) {
    if (!oMe(w))
      throw new Error(ds.NODE_ENV === "production" ? Ls(7) : "Actions must be plain objects. Instead, the actual type was: '" + pv(w) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof w.type > "u")
      throw new Error(ds.NODE_ENV === "production" ? Ls(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (f)
      throw new Error(ds.NODE_ENV === "production" ? Ls(9) : "Reducers may not dispatch actions.");
    try {
      f = !0, o = i(o, w);
    } finally {
      f = !1;
    }
    for (var _ = s = u, O = 0; O < _.length; O++) {
      var D = _[O];
      D();
    }
    return w;
  }
  function S(w) {
    if (typeof w != "function")
      throw new Error(ds.NODE_ENV === "production" ? Ls(10) : "Expected the nextReducer to be a function. Instead, received: '" + pv(w));
    i = w, y({
      type: G7.REPLACE
    });
  }
  function E() {
    var w, _ = v;
    return w = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(D) {
        if (typeof D != "object" || D === null)
          throw new Error(ds.NODE_ENV === "production" ? Ls(11) : "Expected the observer to be an object. Instead, received: '" + pv(D) + "'");
        function P() {
          D.next && D.next(m());
        }
        P();
        var M = _(P);
        return {
          unsubscribe: M
        };
      }
    }, w[q7] = function() {
      return this;
    }, w;
  }
  return y({
    type: G7.INIT
  }), r = {
    dispatch: y,
    subscribe: v,
    getState: m,
    replaceReducer: S
  }, r[q7] = E, r;
}
function Y7(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function X7(e, t) {
  if (typeof e == "function")
    return Y7(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(ds.NODE_ENV === "production" ? Ls(16) : "bindActionCreators expected an object or a function, but instead received: '" + pv(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var n = {};
  for (var r in e) {
    var i = e[r];
    typeof i == "function" && (n[r] = Y7(i, t));
  }
  return n;
}
function poe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, i) {
    return function() {
      return r(i.apply(void 0, arguments));
    };
  });
}
function uMe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var i = r.apply(void 0, arguments), o = function() {
        throw new Error(ds.NODE_ENV === "production" ? Ls(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, s = {
        getState: i.getState,
        dispatch: function() {
          return o.apply(void 0, arguments);
        }
      }, u = t.map(function(f) {
        return f(s);
      });
      return o = poe.apply(void 0, u)(i.dispatch), H7(H7({}, i), {}, {
        dispatch: o
      });
    };
  };
}
var cO = { exports: {} }, mz = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z7;
function dMe() {
  if (Z7) return mz;
  Z7 = 1;
  var e = it;
  function t(v, y) {
    return v === y && (v !== 0 || 1 / v === 1 / y) || v !== v && y !== y;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, s = e.useDebugValue;
  function u(v, y) {
    var S = y(), E = r({ inst: { value: S, getSnapshot: y } }), w = E[0].inst, _ = E[1];
    return o(
      function() {
        w.value = S, w.getSnapshot = y, f(w) && _({ inst: w });
      },
      [v, S, y]
    ), i(
      function() {
        return f(w) && _({ inst: w }), v(function() {
          f(w) && _({ inst: w });
        });
      },
      [v]
    ), s(S), S;
  }
  function f(v) {
    var y = v.getSnapshot;
    v = v.value;
    try {
      var S = y();
      return !n(v, S);
    } catch {
      return !0;
    }
  }
  function p(v, y) {
    return y();
  }
  var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : u;
  return mz.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : m, mz;
}
var vz = {}, K7;
function fMe() {
  if (K7) return vz;
  K7 = 1;
  var e = {};
  /**
   * @license React
   * use-sync-external-store-shim.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(E, w) {
      return E === w && (E !== 0 || 1 / E === 1 / w) || E !== E && w !== w;
    }
    function n(E, w) {
      v || o.startTransition === void 0 || (v = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var _ = w();
      if (!y) {
        var O = w();
        s(_, O) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), y = !0);
      }
      O = u({
        inst: { value: _, getSnapshot: w }
      });
      var D = O[0].inst, P = O[1];
      return p(
        function() {
          D.value = _, D.getSnapshot = w, r(D) && P({ inst: D });
        },
        [E, _, w]
      ), f(
        function() {
          return r(D) && P({ inst: D }), E(function() {
            r(D) && P({ inst: D });
          });
        },
        [E]
      ), m(_), _;
    }
    function r(E) {
      var w = E.getSnapshot;
      E = E.value;
      try {
        var _ = w();
        return !s(E, _);
      } catch {
        return !0;
      }
    }
    function i(E, w) {
      return w();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = it, s = typeof Object.is == "function" ? Object.is : t, u = o.useState, f = o.useEffect, p = o.useLayoutEffect, m = o.useDebugValue, v = !1, y = !1, S = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? i : n;
    vz.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })(), vz;
}
var Q7;
function UF() {
  if (Q7) return cO.exports;
  Q7 = 1;
  var e = {};
  return e.NODE_ENV === "production" ? cO.exports = dMe() : cO.exports = fMe(), cO.exports;
}
var pMe = UF(), uO = { exports: {} }, yz = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J7;
function hMe() {
  if (J7) return yz;
  J7 = 1;
  var e = it, t = UF();
  function n(p, m) {
    return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, s = e.useEffect, u = e.useMemo, f = e.useDebugValue;
  return yz.useSyncExternalStoreWithSelector = function(p, m, v, y, S) {
    var E = o(null);
    if (E.current === null) {
      var w = { hasValue: !1, value: null };
      E.current = w;
    } else w = E.current;
    E = u(
      function() {
        function O(k) {
          if (!D) {
            if (D = !0, P = k, k = y(k), S !== void 0 && w.hasValue) {
              var U = w.value;
              if (S(U, k))
                return M = U;
            }
            return M = k;
          }
          if (U = M, r(P, k)) return U;
          var H = y(k);
          return S !== void 0 && S(U, H) ? (P = k, U) : (P = k, M = H);
        }
        var D = !1, P, M, N = v === void 0 ? null : v;
        return [
          function() {
            return O(m());
          },
          N === null ? void 0 : function() {
            return O(N());
          }
        ];
      },
      [m, v, y, S]
    );
    var _ = i(p, E[0], E[1]);
    return s(
      function() {
        w.hasValue = !0, w.value = _;
      },
      [_]
    ), f(_), _;
  }, yz;
}
var bz = {}, eY;
function gMe() {
  if (eY) return bz;
  eY = 1;
  var e = {};
  /**
   * @license React
   * use-sync-external-store-shim/with-selector.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    function t(m, v) {
      return m === v && (m !== 0 || 1 / m === 1 / v) || m !== m && v !== v;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var n = it, r = UF(), i = typeof Object.is == "function" ? Object.is : t, o = r.useSyncExternalStore, s = n.useRef, u = n.useEffect, f = n.useMemo, p = n.useDebugValue;
    bz.useSyncExternalStoreWithSelector = function(m, v, y, S, E) {
      var w = s(null);
      if (w.current === null) {
        var _ = { hasValue: !1, value: null };
        w.current = _;
      } else _ = w.current;
      w = f(
        function() {
          function D(U) {
            if (!P) {
              if (P = !0, M = U, U = S(U), E !== void 0 && _.hasValue) {
                var H = _.value;
                if (E(H, U))
                  return N = H;
              }
              return N = U;
            }
            if (H = N, i(M, U))
              return H;
            var Y = S(U);
            return E !== void 0 && E(H, Y) ? (M = U, H) : (M = U, N = Y);
          }
          var P = !1, M, N, k = y === void 0 ? null : y;
          return [
            function() {
              return D(v());
            },
            k === null ? void 0 : function() {
              return D(k());
            }
          ];
        },
        [v, y, S, E]
      );
      var O = o(m, w[0], w[1]);
      return u(
        function() {
          _.hasValue = !0, _.value = O;
        },
        [O]
      ), p(O), O;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })(), bz;
}
var tY;
function mMe() {
  if (tY) return uO.exports;
  tY = 1;
  var e = {};
  return e.NODE_ENV === "production" ? uO.exports = hMe() : uO.exports = gMe(), uO.exports;
}
mMe();
function vMe(e) {
  e();
}
let hoe = vMe;
const yMe = (e) => hoe = e, bMe = () => hoe;
var xMe = {};
const nY = Symbol.for("react-redux-context"), rY = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function SMe() {
  var e;
  if (!$.createContext) return {};
  const t = (e = rY[nY]) != null ? e : rY[nY] = /* @__PURE__ */ new Map();
  let n = t.get($.createContext);
  return n || (n = $.createContext(null), xMe.NODE_ENV !== "production" && (n.displayName = "ReactRedux"), t.set($.createContext, n)), n;
}
const goe = /* @__PURE__ */ SMe(), wMe = () => {
  throw new Error("uSES not initialized!");
};
var dO = { exports: {} }, Ar = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iY;
function TMe() {
  if (iY) return Ar;
  iY = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function P(N) {
    if (typeof N == "object" && N !== null) {
      var k = N.$$typeof;
      switch (k) {
        case t:
          switch (N = N.type, N) {
            case f:
            case p:
            case r:
            case o:
            case i:
            case v:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case u:
                case m:
                case E:
                case S:
                case s:
                  return N;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function M(N) {
    return P(N) === p;
  }
  return Ar.AsyncMode = f, Ar.ConcurrentMode = p, Ar.ContextConsumer = u, Ar.ContextProvider = s, Ar.Element = t, Ar.ForwardRef = m, Ar.Fragment = r, Ar.Lazy = E, Ar.Memo = S, Ar.Portal = n, Ar.Profiler = o, Ar.StrictMode = i, Ar.Suspense = v, Ar.isAsyncMode = function(N) {
    return M(N) || P(N) === f;
  }, Ar.isConcurrentMode = M, Ar.isContextConsumer = function(N) {
    return P(N) === u;
  }, Ar.isContextProvider = function(N) {
    return P(N) === s;
  }, Ar.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === t;
  }, Ar.isForwardRef = function(N) {
    return P(N) === m;
  }, Ar.isFragment = function(N) {
    return P(N) === r;
  }, Ar.isLazy = function(N) {
    return P(N) === E;
  }, Ar.isMemo = function(N) {
    return P(N) === S;
  }, Ar.isPortal = function(N) {
    return P(N) === n;
  }, Ar.isProfiler = function(N) {
    return P(N) === o;
  }, Ar.isStrictMode = function(N) {
    return P(N) === i;
  }, Ar.isSuspense = function(N) {
    return P(N) === v;
  }, Ar.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === r || N === p || N === o || N === i || N === v || N === y || typeof N == "object" && N !== null && (N.$$typeof === E || N.$$typeof === S || N.$$typeof === s || N.$$typeof === u || N.$$typeof === m || N.$$typeof === _ || N.$$typeof === O || N.$$typeof === D || N.$$typeof === w);
  }, Ar.typeOf = P, Ar;
}
var Dr = {}, oY;
function EMe() {
  if (oY) return Dr;
  oY = 1;
  var e = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, f = t ? Symbol.for("react.context") : 60110, p = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, v = t ? Symbol.for("react.forward_ref") : 60112, y = t ? Symbol.for("react.suspense") : 60113, S = t ? Symbol.for("react.suspense_list") : 60120, E = t ? Symbol.for("react.memo") : 60115, w = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, O = t ? Symbol.for("react.fundamental") : 60117, D = t ? Symbol.for("react.responder") : 60118, P = t ? Symbol.for("react.scope") : 60119;
    function M(ve) {
      return typeof ve == "string" || typeof ve == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ve === i || ve === m || ve === s || ve === o || ve === y || ve === S || typeof ve == "object" && ve !== null && (ve.$$typeof === w || ve.$$typeof === E || ve.$$typeof === u || ve.$$typeof === f || ve.$$typeof === v || ve.$$typeof === O || ve.$$typeof === D || ve.$$typeof === P || ve.$$typeof === _);
    }
    function N(ve) {
      if (typeof ve == "object" && ve !== null) {
        var rt = ve.$$typeof;
        switch (rt) {
          case n:
            var Te = ve.type;
            switch (Te) {
              case p:
              case m:
              case i:
              case s:
              case o:
              case y:
                return Te;
              default:
                var Je = Te && Te.$$typeof;
                switch (Je) {
                  case f:
                  case v:
                  case w:
                  case E:
                  case u:
                    return Je;
                  default:
                    return rt;
                }
            }
          case r:
            return rt;
        }
      }
    }
    var k = p, U = m, H = f, Y = u, z = n, V = v, F = i, X = w, oe = E, re = r, Z = s, ee = o, J = y, le = !1;
    function be(ve) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ne(ve) || N(ve) === p;
    }
    function ne(ve) {
      return N(ve) === m;
    }
    function ae(ve) {
      return N(ve) === f;
    }
    function ie(ve) {
      return N(ve) === u;
    }
    function he(ve) {
      return typeof ve == "object" && ve !== null && ve.$$typeof === n;
    }
    function pe(ve) {
      return N(ve) === v;
    }
    function me(ve) {
      return N(ve) === i;
    }
    function Ee(ve) {
      return N(ve) === w;
    }
    function Ie(ve) {
      return N(ve) === E;
    }
    function Pe(ve) {
      return N(ve) === r;
    }
    function De(ve) {
      return N(ve) === s;
    }
    function Ye(ve) {
      return N(ve) === o;
    }
    function Ue(ve) {
      return N(ve) === y;
    }
    Dr.AsyncMode = k, Dr.ConcurrentMode = U, Dr.ContextConsumer = H, Dr.ContextProvider = Y, Dr.Element = z, Dr.ForwardRef = V, Dr.Fragment = F, Dr.Lazy = X, Dr.Memo = oe, Dr.Portal = re, Dr.Profiler = Z, Dr.StrictMode = ee, Dr.Suspense = J, Dr.isAsyncMode = be, Dr.isConcurrentMode = ne, Dr.isContextConsumer = ae, Dr.isContextProvider = ie, Dr.isElement = he, Dr.isForwardRef = pe, Dr.isFragment = me, Dr.isLazy = Ee, Dr.isMemo = Ie, Dr.isPortal = Pe, Dr.isProfiler = De, Dr.isStrictMode = Ye, Dr.isSuspense = Ue, Dr.isValidElementType = M, Dr.typeOf = N;
  })(), Dr;
}
var aY;
function _Me() {
  if (aY) return dO.exports;
  aY = 1;
  var e = {};
  return e.NODE_ENV === "production" ? dO.exports = TMe() : dO.exports = EMe(), dO.exports;
}
var xz, sY;
function CMe() {
  if (sY) return xz;
  sY = 1;
  var e = _Me(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = r, o[e.Memo] = i;
  function s(E) {
    return e.isMemo(E) ? i : o[E.$$typeof] || t;
  }
  var u = Object.defineProperty, f = Object.getOwnPropertyNames, p = Object.getOwnPropertySymbols, m = Object.getOwnPropertyDescriptor, v = Object.getPrototypeOf, y = Object.prototype;
  function S(E, w, _) {
    if (typeof w != "string") {
      if (y) {
        var O = v(w);
        O && O !== y && S(E, O, _);
      }
      var D = f(w);
      p && (D = D.concat(p(w)));
      for (var P = s(E), M = s(w), N = 0; N < D.length; ++N) {
        var k = D[N];
        if (!n[k] && !(_ && _[k]) && !(M && M[k]) && !(P && P[k])) {
          var U = m(w, k);
          try {
            u(E, k, U);
          } catch {
          }
        }
      }
    }
    return E;
  }
  return xz = S, xz;
}
var RMe = CMe();
const lY = /* @__PURE__ */ Hn(RMe);
var fO = { exports: {} }, Ir = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cY;
function OMe() {
  if (cY) return Ir;
  cY = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), u = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), E;
  E = Symbol.for("react.module.reference");
  function w(_) {
    if (typeof _ == "object" && _ !== null) {
      var O = _.$$typeof;
      switch (O) {
        case e:
          switch (_ = _.type, _) {
            case n:
            case i:
            case r:
            case p:
            case m:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case u:
                case s:
                case f:
                case y:
                case v:
                case o:
                  return _;
                default:
                  return O;
              }
          }
        case t:
          return O;
      }
    }
  }
  return Ir.ContextConsumer = s, Ir.ContextProvider = o, Ir.Element = e, Ir.ForwardRef = f, Ir.Fragment = n, Ir.Lazy = y, Ir.Memo = v, Ir.Portal = t, Ir.Profiler = i, Ir.StrictMode = r, Ir.Suspense = p, Ir.SuspenseList = m, Ir.isAsyncMode = function() {
    return !1;
  }, Ir.isConcurrentMode = function() {
    return !1;
  }, Ir.isContextConsumer = function(_) {
    return w(_) === s;
  }, Ir.isContextProvider = function(_) {
    return w(_) === o;
  }, Ir.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === e;
  }, Ir.isForwardRef = function(_) {
    return w(_) === f;
  }, Ir.isFragment = function(_) {
    return w(_) === n;
  }, Ir.isLazy = function(_) {
    return w(_) === y;
  }, Ir.isMemo = function(_) {
    return w(_) === v;
  }, Ir.isPortal = function(_) {
    return w(_) === t;
  }, Ir.isProfiler = function(_) {
    return w(_) === i;
  }, Ir.isStrictMode = function(_) {
    return w(_) === r;
  }, Ir.isSuspense = function(_) {
    return w(_) === p;
  }, Ir.isSuspenseList = function(_) {
    return w(_) === m;
  }, Ir.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === n || _ === i || _ === r || _ === p || _ === m || _ === S || typeof _ == "object" && _ !== null && (_.$$typeof === y || _.$$typeof === v || _.$$typeof === o || _.$$typeof === s || _.$$typeof === f || _.$$typeof === E || _.getModuleId !== void 0);
  }, Ir.typeOf = w, Ir;
}
var Pr = {}, uY;
function AMe() {
  if (uY) return Pr;
  uY = 1;
  var e = {};
  /**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && (function() {
    var t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), w = !1, _ = !1, O = !1, D = !1, P = !1, M;
    M = Symbol.for("react.module.reference");
    function N(Te) {
      return !!(typeof Te == "string" || typeof Te == "function" || Te === r || Te === o || P || Te === i || Te === m || Te === v || D || Te === E || w || _ || O || typeof Te == "object" && Te !== null && (Te.$$typeof === S || Te.$$typeof === y || Te.$$typeof === s || Te.$$typeof === u || Te.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Te.$$typeof === M || Te.getModuleId !== void 0));
    }
    function k(Te) {
      if (typeof Te == "object" && Te !== null) {
        var Je = Te.$$typeof;
        switch (Je) {
          case t:
            var L = Te.type;
            switch (L) {
              case r:
              case o:
              case i:
              case m:
              case v:
                return L;
              default:
                var te = L && L.$$typeof;
                switch (te) {
                  case f:
                  case u:
                  case p:
                  case S:
                  case y:
                  case s:
                    return te;
                  default:
                    return Je;
                }
            }
          case n:
            return Je;
        }
      }
    }
    var U = u, H = s, Y = t, z = p, V = r, F = S, X = y, oe = n, re = o, Z = i, ee = m, J = v, le = !1, be = !1;
    function ne(Te) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ae(Te) {
      return be || (be = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ie(Te) {
      return k(Te) === u;
    }
    function he(Te) {
      return k(Te) === s;
    }
    function pe(Te) {
      return typeof Te == "object" && Te !== null && Te.$$typeof === t;
    }
    function me(Te) {
      return k(Te) === p;
    }
    function Ee(Te) {
      return k(Te) === r;
    }
    function Ie(Te) {
      return k(Te) === S;
    }
    function Pe(Te) {
      return k(Te) === y;
    }
    function De(Te) {
      return k(Te) === n;
    }
    function Ye(Te) {
      return k(Te) === o;
    }
    function Ue(Te) {
      return k(Te) === i;
    }
    function ve(Te) {
      return k(Te) === m;
    }
    function rt(Te) {
      return k(Te) === v;
    }
    Pr.ContextConsumer = U, Pr.ContextProvider = H, Pr.Element = Y, Pr.ForwardRef = z, Pr.Fragment = V, Pr.Lazy = F, Pr.Memo = X, Pr.Portal = oe, Pr.Profiler = re, Pr.StrictMode = Z, Pr.Suspense = ee, Pr.SuspenseList = J, Pr.isAsyncMode = ne, Pr.isConcurrentMode = ae, Pr.isContextConsumer = ie, Pr.isContextProvider = he, Pr.isElement = pe, Pr.isForwardRef = me, Pr.isFragment = Ee, Pr.isLazy = Ie, Pr.isMemo = Pe, Pr.isPortal = De, Pr.isProfiler = Ye, Pr.isStrictMode = Ue, Pr.isSuspense = ve, Pr.isSuspenseList = rt, Pr.isValidElementType = N, Pr.typeOf = k;
  })(), Pr;
}
var dY;
function DMe() {
  if (dY) return fO.exports;
  dY = 1;
  var e = {};
  return e.NODE_ENV === "production" ? fO.exports = OMe() : fO.exports = AMe(), fO.exports;
}
var fY = DMe();
function FF(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Sz(e, t) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || FF(`The selector for ${t} of connect did not specify a value for dependsOnOwnProps.`));
  else throw new Error(`Unexpected value for ${t} in connect.`);
}
function IMe(e, t, n) {
  Sz(e, "mapStateToProps"), Sz(t, "mapDispatchToProps"), Sz(n, "mergeProps");
}
var PMe = {};
const NMe = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function MMe(e, t, n, r, {
  areStatesEqual: i,
  areOwnPropsEqual: o,
  areStatePropsEqual: s
}) {
  let u = !1, f, p, m, v, y;
  function S(D, P) {
    return f = D, p = P, m = e(f, p), v = t(r, p), y = n(m, v, p), u = !0, y;
  }
  function E() {
    return m = e(f, p), t.dependsOnOwnProps && (v = t(r, p)), y = n(m, v, p), y;
  }
  function w() {
    return e.dependsOnOwnProps && (m = e(f, p)), t.dependsOnOwnProps && (v = t(r, p)), y = n(m, v, p), y;
  }
  function _() {
    const D = e(f, p), P = !s(D, m);
    return m = D, P && (y = n(m, v, p)), y;
  }
  function O(D, P) {
    const M = !o(P, p), N = !i(D, f, P, p);
    return f = D, p = P, M && N ? E() : M ? w() : N ? _() : y;
  }
  return function(P, M) {
    return u ? O(P, M) : S(P, M);
  };
}
function jMe(e, t) {
  let {
    initMapStateToProps: n,
    initMapDispatchToProps: r,
    initMergeProps: i
  } = t, o = Dl(t, NMe);
  const s = n(e, o), u = r(e, o), f = i(e, o);
  return PMe.NODE_ENV !== "production" && IMe(s, u, f), MMe(s, u, f, e, o);
}
function LMe(e, t) {
  const n = {};
  for (const r in e) {
    const i = e[r];
    typeof i == "function" && (n[r] = (...o) => t(i(...o)));
  }
  return n;
}
function kMe(e) {
  if (typeof e != "object" || e === null) return !1;
  let t = Object.getPrototypeOf(e);
  if (t === null) return !0;
  let n = t;
  for (; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function moe(e, t, n) {
  kMe(e) || FF(`${n}() in ${t} must return a plain object. Instead received ${e}.`);
}
var zMe = {};
function pV(e) {
  return function(n) {
    const r = e(n);
    function i() {
      return r;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function pY(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function voe(e, t) {
  return function(r, {
    displayName: i
  }) {
    const o = function(u, f) {
      return o.dependsOnOwnProps ? o.mapToProps(u, f) : o.mapToProps(u, void 0);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(u, f) {
      o.mapToProps = e, o.dependsOnOwnProps = pY(e);
      let p = o(u, f);
      return typeof p == "function" && (o.mapToProps = p, o.dependsOnOwnProps = pY(p), p = o(u, f)), zMe.NODE_ENV !== "production" && moe(p, i, t), p;
    }, o;
  };
}
function WF(e, t) {
  return (n, r) => {
    throw new Error(`Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`);
  };
}
function BMe(e) {
  return e && typeof e == "object" ? pV((t) => (
    // @ts-ignore
    LMe(e, t)
  )) : e ? typeof e == "function" ? (
    // @ts-ignore
    voe(e, "mapDispatchToProps")
  ) : WF(e, "mapDispatchToProps") : pV((t) => ({
    dispatch: t
  }));
}
function VMe(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    voe(e, "mapStateToProps")
  ) : WF(e, "mapStateToProps") : pV(() => ({}));
}
var UMe = {};
function FMe(e, t, n) {
  return $t({}, n, e, t);
}
function WMe(e) {
  return function(n, {
    displayName: r,
    areMergedPropsEqual: i
  }) {
    let o = !1, s;
    return function(f, p, m) {
      const v = e(f, p, m);
      return o ? i(v, s) || (s = v) : (o = !0, s = v, UMe.NODE_ENV !== "production" && moe(s, r, "mergeProps")), s;
    };
  };
}
function HMe(e) {
  return e ? typeof e == "function" ? WMe(e) : WF(e, "mergeProps") : () => FMe;
}
function qMe() {
  const e = bMe();
  let t = null, n = null;
  return {
    clear() {
      t = null, n = null;
    },
    notify() {
      e(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      let r = [], i = t;
      for (; i; )
        r.push(i), i = i.next;
      return r;
    },
    subscribe(r) {
      let i = !0, o = n = {
        callback: r,
        next: null,
        prev: n
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : n = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
const hY = {
  notify() {
  },
  get: () => []
};
function yoe(e, t) {
  let n, r = hY, i = 0, o = !1;
  function s(w) {
    m();
    const _ = r.subscribe(w);
    let O = !1;
    return () => {
      O || (O = !0, _(), v());
    };
  }
  function u() {
    r.notify();
  }
  function f() {
    E.onStateChange && E.onStateChange();
  }
  function p() {
    return o;
  }
  function m() {
    i++, n || (n = t ? t.addNestedSub(f) : e.subscribe(f), r = qMe());
  }
  function v() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = hY);
  }
  function y() {
    o || (o = !0, m());
  }
  function S() {
    o && (o = !1, v());
  }
  const E = {
    addNestedSub: s,
    notifyNestedSubs: u,
    handleChangeWrapper: f,
    isSubscribed: p,
    trySubscribe: y,
    tryUnsubscribe: S,
    getListeners: () => r
  };
  return E;
}
const $Me = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", xA = $Me ? $.useLayoutEffect : $.useEffect;
function gY(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function wz(e, t) {
  if (gY(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let i = 0; i < n.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, n[i]) || !gY(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
var Tz = {};
const GMe = ["reactReduxForwardedRef"];
let boe = wMe;
const YMe = (e) => {
  boe = e;
}, XMe = [null, null], ZMe = (e) => {
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
};
function KMe(e, t, n) {
  xA(() => e(...t), n);
}
function QMe(e, t, n, r, i, o) {
  e.current = r, n.current = !1, i.current && (i.current = null, o());
}
function JMe(e, t, n, r, i, o, s, u, f, p, m) {
  if (!e) return () => {
  };
  let v = !1, y = null;
  const S = () => {
    if (v || !u.current)
      return;
    const w = t.getState();
    let _, O;
    try {
      _ = r(w, i.current);
    } catch (D) {
      O = D, y = D;
    }
    O || (y = null), _ === o.current ? s.current || p() : (o.current = _, f.current = _, s.current = !0, m());
  };
  return n.onStateChange = S, n.trySubscribe(), S(), () => {
    if (v = !0, n.tryUnsubscribe(), n.onStateChange = null, y)
      throw y;
  };
}
function eje(e, t) {
  return e === t;
}
let mY = !1;
function xoe(e, t, n, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: r,
  areStatesEqual: i = eje,
  areOwnPropsEqual: o = wz,
  areStatePropsEqual: s = wz,
  areMergedPropsEqual: u = wz,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: f = !1,
  // the context consumer to use
  context: p = goe
} = {}) {
  Tz.NODE_ENV !== "production" && r !== void 0 && !mY && (mY = !0, FF('The `pure` option has been removed. `connect` is now always a "pure/memoized" component'));
  const m = p, v = VMe(e), y = BMe(t), S = HMe(n), E = !!e;
  return (_) => {
    if (Tz.NODE_ENV !== "production" && !fY.isValidElementType(_))
      throw new Error(`You must pass a component to the function returned by connect. Instead received ${ZMe(_)}`);
    const O = _.displayName || _.name || "Component", D = `Connect(${O})`, P = {
      shouldHandleStateChanges: E,
      displayName: D,
      wrappedComponentName: O,
      WrappedComponent: _,
      // @ts-ignore
      initMapStateToProps: v,
      // @ts-ignore
      initMapDispatchToProps: y,
      initMergeProps: S,
      areStatesEqual: i,
      areStatePropsEqual: s,
      areOwnPropsEqual: o,
      areMergedPropsEqual: u
    };
    function M(U) {
      const [H, Y, z] = $.useMemo(() => {
        const {
          reactReduxForwardedRef: Ue
        } = U, ve = Dl(U, GMe);
        return [U.context, Ue, ve];
      }, [U]), V = $.useMemo(() => H && H.Consumer && // @ts-ignore
      fY.isContextConsumer(/* @__PURE__ */ $.createElement(H.Consumer, null)) ? H : m, [H, m]), F = $.useContext(V), X = !!U.store && !!U.store.getState && !!U.store.dispatch, oe = !!F && !!F.store;
      if (Tz.NODE_ENV !== "production" && !X && !oe)
        throw new Error(`Could not find "store" in the context of "${D}". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ${D} in connect options.`);
      const re = X ? U.store : F.store, Z = oe ? F.getServerState : re.getState, ee = $.useMemo(() => jMe(re.dispatch, P), [re]), [J, le] = $.useMemo(() => {
        if (!E) return XMe;
        const Ue = yoe(re, X ? void 0 : F.subscription), ve = Ue.notifyNestedSubs.bind(Ue);
        return [Ue, ve];
      }, [re, X, F]), be = $.useMemo(() => X ? F : $t({}, F, {
        subscription: J
      }), [X, F, J]), ne = $.useRef(), ae = $.useRef(z), ie = $.useRef(), he = $.useRef(!1);
      $.useRef(!1);
      const pe = $.useRef(!1), me = $.useRef();
      xA(() => (pe.current = !0, () => {
        pe.current = !1;
      }), []);
      const Ee = $.useMemo(() => () => ie.current && z === ae.current ? ie.current : ee(re.getState(), z), [re, z]), Ie = $.useMemo(() => (ve) => J ? JMe(
        E,
        re,
        J,
        // @ts-ignore
        ee,
        ae,
        ne,
        he,
        pe,
        ie,
        le,
        ve
      ) : () => {
      }, [J]);
      KMe(QMe, [ae, ne, he, z, ie, le]);
      let Pe;
      try {
        Pe = boe(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          Ie,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          Ee,
          Z ? () => ee(Z(), z) : Ee
        );
      } catch (Ue) {
        throw me.current && (Ue.message += `
The error may be correlated with this previous error:
${me.current.stack}

`), Ue;
      }
      xA(() => {
        me.current = void 0, ie.current = void 0, ne.current = Pe;
      });
      const De = $.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ $.createElement(_, $t({}, Pe, {
          ref: Y
        }))
      ), [Y, _, Pe]);
      return $.useMemo(() => E ? /* @__PURE__ */ $.createElement(V.Provider, {
        value: be
      }, De) : De, [V, De, be]);
    }
    const k = $.memo(M);
    if (k.WrappedComponent = _, k.displayName = M.displayName = D, f) {
      const H = $.forwardRef(function(z, V) {
        return /* @__PURE__ */ $.createElement(k, $t({}, z, {
          reactReduxForwardedRef: V
        }));
      });
      return H.displayName = D, H.WrappedComponent = _, lY(H, _);
    }
    return lY(k, _);
  };
}
function tje({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: i = "once",
  noopCheck: o = "once"
}) {
  const s = $.useMemo(() => {
    const p = yoe(e);
    return {
      store: e,
      subscription: p,
      getServerState: r ? () => r : void 0,
      stabilityCheck: i,
      noopCheck: o
    };
  }, [e, r, i, o]), u = $.useMemo(() => e.getState(), [e]);
  xA(() => {
    const {
      subscription: p
    } = s;
    return p.onStateChange = p.notifyNestedSubs, p.trySubscribe(), u !== e.getState() && p.notifyNestedSubs(), () => {
      p.tryUnsubscribe(), p.onStateChange = void 0;
    };
  }, [s, u]);
  const f = t || goe;
  return /* @__PURE__ */ $.createElement(f.Provider, {
    value: s
  }, n);
}
YMe(pMe.useSyncExternalStore);
yMe(lhe);
function nje(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Soe(e, t) {
  var n = Bn(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], r = an(!0), i = an(n), o = r.current || !!(t && i.current.inputs && nje(t, i.current.inputs)), s = o ? i.current : {
    inputs: t,
    result: e()
  };
  return ln(function() {
    r.current = !1, i.current = s;
  }, [s]), s.result;
}
function rje(e, t) {
  return Soe(function() {
    return e;
  }, t);
}
var tr = Soe, rn = rje, ije = {}, oje = ije.NODE_ENV === "production", Ez = "Invariant failed";
function vY(e, t) {
  if (oje)
    throw new Error(Ez);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(Ez, ": ").concat(n) : Ez;
  throw new Error(r);
}
var aje = {}, Ru = function(t) {
  var n = t.top, r = t.right, i = t.bottom, o = t.left, s = r - o, u = i - n, f = {
    top: n,
    right: r,
    bottom: i,
    left: o,
    width: s,
    height: u,
    x: o,
    y: n,
    center: {
      x: (r + o) / 2,
      y: (i + n) / 2
    }
  };
  return f;
}, HF = function(t, n) {
  return {
    top: t.top - n.top,
    left: t.left - n.left,
    bottom: t.bottom + n.bottom,
    right: t.right + n.right
  };
}, yY = function(t, n) {
  return {
    top: t.top + n.top,
    left: t.left + n.left,
    bottom: t.bottom - n.bottom,
    right: t.right - n.right
  };
}, sje = function(t, n) {
  return {
    top: t.top + n.y,
    left: t.left + n.x,
    bottom: t.bottom + n.y,
    right: t.right + n.x
  };
}, _z = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, qF = function(t) {
  var n = t.borderBox, r = t.margin, i = r === void 0 ? _z : r, o = t.border, s = o === void 0 ? _z : o, u = t.padding, f = u === void 0 ? _z : u, p = Ru(HF(n, i)), m = Ru(yY(n, s)), v = Ru(yY(m, f));
  return {
    marginBox: p,
    borderBox: Ru(n),
    paddingBox: m,
    contentBox: v,
    margin: i,
    border: s,
    padding: f
  };
}, mc = function(t) {
  var n = t.slice(0, -2), r = t.slice(-2);
  if (r !== "px")
    return 0;
  var i = Number(n);
  return isNaN(i) && (aje.NODE_ENV !== "production" ? vY(!1, "Could not parse value [raw: " + t + ", without suffix: " + n + "]") : vY()), i;
}, lje = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, SA = function(t, n) {
  var r = t.borderBox, i = t.border, o = t.margin, s = t.padding, u = sje(r, n);
  return qF({
    borderBox: u,
    border: i,
    margin: o,
    padding: s
  });
}, wA = function(t, n) {
  return n === void 0 && (n = lje()), SA(t, n);
}, woe = function(t, n) {
  var r = {
    top: mc(n.marginTop),
    right: mc(n.marginRight),
    bottom: mc(n.marginBottom),
    left: mc(n.marginLeft)
  }, i = {
    top: mc(n.paddingTop),
    right: mc(n.paddingRight),
    bottom: mc(n.paddingBottom),
    left: mc(n.paddingLeft)
  }, o = {
    top: mc(n.borderTopWidth),
    right: mc(n.borderRightWidth),
    bottom: mc(n.borderBottomWidth),
    left: mc(n.borderLeftWidth)
  };
  return qF({
    borderBox: t,
    margin: r,
    padding: i,
    border: o
  });
}, Toe = function(t) {
  var n = t.getBoundingClientRect(), r = window.getComputedStyle(t);
  return woe(n, r);
}, bY = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function cje(e, t) {
  return !!(e === t || bY(e) && bY(t));
}
function uje(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!cje(e[n], t[n]))
      return !1;
  return !0;
}
function $o(e, t) {
  t === void 0 && (t = uje);
  var n = null;
  function r() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    if (n && n.lastThis === this && t(i, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, i);
    return n = {
      lastResult: s,
      lastArgs: i,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
var f1 = function(t) {
  var n = [], r = null, i = function() {
    for (var s = arguments.length, u = new Array(s), f = 0; f < s; f++)
      u[f] = arguments[f];
    n = u, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return i.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, i;
}, ot = {};
const dje = ot.NODE_ENV === "production", fje = /[ \t]{2,}/g, pje = /^[ \t]*/gm, xY = (e) => e.replace(fje, " ").replace(pje, "").trim(), hje = (e) => xY(`
  %c@hello-pangea/dnd

  %c${xY(e)}

  %c👷‍ This is a development only message. It will be removed in production builds.
`), gje = (e) => [hje(e), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"], mje = "__@hello-pangea/dnd-disable-dev-warnings";
function Eoe(e, t) {
  dje || typeof window < "u" && window[mje] || console[e](...gje(t));
}
const si = Eoe.bind(null, "warn"), hV = Eoe.bind(null, "error");
function ng() {
}
function vje(e, t) {
  return {
    ...e,
    ...t
  };
}
function Oc(e, t, n) {
  const r = t.map((i) => {
    const o = vje(n, i.options);
    return e.addEventListener(i.eventName, i.fn, o), function() {
      e.removeEventListener(i.eventName, i.fn, o);
    };
  });
  return function() {
    r.forEach((o) => {
      o();
    });
  };
}
const yje = ot.NODE_ENV === "production", SY = "Invariant failed";
class p1 extends Error {
}
p1.prototype.toString = function() {
  return this.message;
};
function Ae(e, t) {
  throw yje ? new p1(SY) : new p1(`${SY}: ${t || ""}`);
}
let bje = class extends it.Component {
  constructor(...t) {
    super(...t), this.callbacks = null, this.unbind = ng, this.onWindowError = (n) => {
      const r = this.getCallbacks();
      r.isDragging() && (r.tryAbort(), ot.NODE_ENV !== "production" && si(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      const i = n.error;
      i instanceof p1 && (n.preventDefault(), ot.NODE_ENV !== "production" && hV(i.message));
    }, this.getCallbacks = () => {
      if (!this.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return this.callbacks;
    }, this.setCallbacks = (n) => {
      this.callbacks = n;
    };
  }
  componentDidMount() {
    this.unbind = Oc(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }
  componentDidCatch(t) {
    if (t instanceof p1) {
      ot.NODE_ENV !== "production" && hV(t.message), this.setState({});
      return;
    }
    throw t;
  }
  componentWillUnmount() {
    this.unbind();
  }
  render() {
    return this.props.children(this.setCallbacks);
  }
};
const xje = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, TA = (e) => e + 1, Sje = (e) => `
  You have lifted an item in position ${TA(e.source.index)}
`, _oe = (e, t) => {
  const n = e.droppableId === t.droppableId, r = TA(e.index), i = TA(t.index);
  return n ? `
      You have moved the item from position ${r}
      to position ${i}
    ` : `
    You have moved the item from position ${r}
    in list ${e.droppableId}
    to list ${t.droppableId}
    in position ${i}
  `;
}, Coe = (e, t, n) => t.droppableId === n.droppableId ? `
      The item ${e}
      has been combined with ${n.draggableId}` : `
      The item ${e}
      in list ${t.droppableId}
      has been combined with ${n.draggableId}
      in list ${n.droppableId}
    `, wje = (e) => {
  const t = e.destination;
  if (t)
    return _oe(e.source, t);
  const n = e.combine;
  return n ? Coe(e.draggableId, e.source, n) : "You are over an area that cannot be dropped on";
}, wY = (e) => `
  The item has returned to its starting position
  of ${TA(e.index)}
`, Tje = (e) => {
  if (e.reason === "CANCEL")
    return `
      Movement cancelled.
      ${wY(e.source)}
    `;
  const t = e.destination, n = e.combine;
  return t ? `
      You have dropped the item.
      ${_oe(e.source, t)}
    ` : n ? `
      You have dropped the item.
      ${Coe(e.draggableId, e.source, n)}
    ` : `
    The item has been dropped while not over a drop area.
    ${wY(e.source)}
  `;
}, Eje = {
  dragHandleUsageInstructions: xje,
  onDragStart: Sje,
  onDragUpdate: wje,
  onDragEnd: Tje
};
var VO = Eje;
const Go = {
  x: 0,
  y: 0
}, da = (e, t) => ({
  x: e.x + t.x,
  y: e.y + t.y
}), Il = (e, t) => ({
  x: e.x - t.x,
  y: e.y - t.y
}), rg = (e, t) => e.x === t.x && e.y === t.y, Fx = (e) => ({
  x: e.x !== 0 ? -e.x : 0,
  y: e.y !== 0 ? -e.y : 0
}), Vv = (e, t, n = 0) => e === "x" ? {
  x: t,
  y: n
} : {
  x: n,
  y: t
}, h1 = (e, t) => Math.sqrt((t.x - e.x) ** 2 + (t.y - e.y) ** 2), TY = (e, t) => Math.min(...t.map((n) => h1(e, n))), Roe = (e) => (t) => ({
  x: e(t.x),
  y: e(t.y)
});
var _je = ((e, t) => {
  const n = Ru({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return n.width <= 0 || n.height <= 0 ? null : n;
});
const T_ = (e, t) => ({
  top: e.top + t.y,
  left: e.left + t.x,
  bottom: e.bottom + t.y,
  right: e.right + t.x
}), EY = (e) => [{
  x: e.left,
  y: e.top
}, {
  x: e.right,
  y: e.top
}, {
  x: e.left,
  y: e.bottom
}, {
  x: e.right,
  y: e.bottom
}], Cje = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, Rje = (e, t) => t ? T_(e, t.scroll.diff.displacement) : e, Oje = (e, t, n) => n && n.increasedBy ? {
  ...e,
  [t.end]: e[t.end] + n.increasedBy[t.line]
} : e, Aje = (e, t) => t && t.shouldClipSubject ? _je(t.pageMarginBox, e) : Ru(e);
var gx = (({
  page: e,
  withPlaceholder: t,
  axis: n,
  frame: r
}) => {
  const i = Rje(e.marginBox, r), o = Oje(i, n, t), s = Aje(o, r);
  return {
    page: e,
    withPlaceholder: t,
    active: s
  };
}), $F = ((e, t) => {
  e.frame || (ot.NODE_ENV, Ae());
  const n = e.frame, r = Il(t, n.scroll.initial), i = Fx(r), o = {
    ...n,
    scroll: {
      initial: n.scroll.initial,
      current: t,
      diff: {
        value: r,
        displacement: i
      },
      max: n.scroll.max
    }
  }, s = gx({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: o
  });
  return {
    ...e,
    frame: o,
    subject: s
  };
});
const Ooe = $o((e) => e.reduce((t, n) => (t[n.descriptor.id] = n, t), {})), Aoe = $o((e) => e.reduce((t, n) => (t[n.descriptor.id] = n, t), {})), RI = $o((e) => Object.values(e)), Dje = $o((e) => Object.values(e));
var ay = $o((e, t) => Dje(t).filter((r) => e === r.descriptor.droppableId).sort((r, i) => r.descriptor.index - i.descriptor.index));
function GF(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function OI(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var AI = $o((e, t) => t.filter((n) => n.descriptor.id !== e.descriptor.id)), Ije = (({
  isMovingForward: e,
  draggable: t,
  destination: n,
  insideDestination: r,
  previousImpact: i
}) => {
  if (!n.isCombineEnabled || !GF(i))
    return null;
  function s(S) {
    const E = {
      type: "COMBINE",
      combine: {
        draggableId: S,
        droppableId: n.descriptor.id
      }
    };
    return {
      ...i,
      at: E
    };
  }
  const u = i.displaced.all, f = u.length ? u[0] : null;
  if (e)
    return f ? s(f) : null;
  const p = AI(t, r);
  if (!f) {
    if (!p.length)
      return null;
    const S = p[p.length - 1];
    return s(S.descriptor.id);
  }
  const m = p.findIndex((S) => S.descriptor.id === f);
  m === -1 && (ot.NODE_ENV !== "production" ? Ae(!1, "Could not find displaced item in set") : Ae());
  const v = m - 1;
  if (v < 0)
    return null;
  const y = p[v];
  return s(y.descriptor.id);
}), Wx = ((e, t) => e.descriptor.droppableId === t.descriptor.id);
const Doe = {
  point: Go,
  value: 0
}, g1 = {
  invisible: {},
  visible: {},
  all: []
}, Pje = {
  displaced: g1,
  displacedBy: Doe,
  at: null
};
var Nje = Pje, Nc = ((e, t) => (n) => e <= n && n <= t), Ioe = ((e) => {
  const t = Nc(e.top, e.bottom), n = Nc(e.left, e.right);
  return (r) => {
    if (t(r.top) && t(r.bottom) && n(r.left) && n(r.right))
      return !0;
    const o = t(r.top) || t(r.bottom), s = n(r.left) || n(r.right);
    if (o && s)
      return !0;
    const f = r.top < e.top && r.bottom > e.bottom, p = r.left < e.left && r.right > e.right;
    return f && p ? !0 : f && s || p && o;
  };
}), Mje = ((e) => {
  const t = Nc(e.top, e.bottom), n = Nc(e.left, e.right);
  return (r) => t(r.top) && t(r.bottom) && n(r.left) && n(r.right);
});
const YF = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, Poe = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
};
var jje = ((e) => (t) => {
  const n = Nc(t.top, t.bottom), r = Nc(t.left, t.right);
  return (i) => e === YF ? n(i.top) && n(i.bottom) : r(i.left) && r(i.right);
});
const Lje = (e, t) => {
  const n = t.frame ? t.frame.scroll.diff.displacement : Go;
  return T_(e, n);
}, kje = (e, t, n) => t.subject.active ? n(t.subject.active)(e) : !1, zje = (e, t, n) => n(t)(e), XF = ({
  target: e,
  destination: t,
  viewport: n,
  withDroppableDisplacement: r,
  isVisibleThroughFrameFn: i
}) => {
  const o = r ? Lje(e, t) : e;
  return kje(o, t, i) && zje(o, n, i);
}, Bje = (e) => XF({
  ...e,
  isVisibleThroughFrameFn: Ioe
}), Noe = (e) => XF({
  ...e,
  isVisibleThroughFrameFn: Mje
}), Vje = (e) => XF({
  ...e,
  isVisibleThroughFrameFn: jje(e.destination.axis)
}), Uje = (e, t, n) => {
  if (typeof n == "boolean")
    return n;
  if (!t)
    return !0;
  const {
    invisible: r,
    visible: i
  } = t;
  if (r[e])
    return !1;
  const o = i[e];
  return o ? o.shouldAnimate : !0;
};
function Fje(e, t) {
  const n = e.page.marginBox, r = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return Ru(HF(n, r));
}
function m1({
  afterDragging: e,
  destination: t,
  displacedBy: n,
  viewport: r,
  forceShouldAnimate: i,
  last: o
}) {
  return e.reduce(function(u, f) {
    const p = Fje(f, n), m = f.descriptor.id;
    if (u.all.push(m), !Bje({
      target: p,
      destination: t,
      viewport: r,
      withDroppableDisplacement: !0
    }))
      return u.invisible[f.descriptor.id] = !0, u;
    const y = Uje(m, o, i), S = {
      draggableId: m,
      shouldAnimate: y
    };
    return u.visible[m] = S, u;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function Wje(e, t) {
  if (!e.length)
    return 0;
  const n = e[e.length - 1].descriptor.index;
  return t.inHomeList ? n : n + 1;
}
function _Y({
  insideDestination: e,
  inHomeList: t,
  displacedBy: n,
  destination: r
}) {
  const i = Wje(e, {
    inHomeList: t
  });
  return {
    displaced: g1,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: r.descriptor.id,
        index: i
      }
    }
  };
}
function EA({
  draggable: e,
  insideDestination: t,
  destination: n,
  viewport: r,
  displacedBy: i,
  last: o,
  index: s,
  forceShouldAnimate: u
}) {
  const f = Wx(e, n);
  if (s == null)
    return _Y({
      insideDestination: t,
      inHomeList: f,
      displacedBy: i,
      destination: n
    });
  const p = t.find((E) => E.descriptor.index === s);
  if (!p)
    return _Y({
      insideDestination: t,
      inHomeList: f,
      displacedBy: i,
      destination: n
    });
  const m = AI(e, t), v = t.indexOf(p), y = m.slice(v);
  return {
    displaced: m1({
      afterDragging: y,
      destination: n,
      displacedBy: i,
      last: o,
      viewport: r.frame,
      forceShouldAnimate: u
    }),
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: s
      }
    }
  };
}
function dg(e, t) {
  return !!t.effected[e];
}
var Hje = (({
  isMovingForward: e,
  destination: t,
  draggables: n,
  combine: r,
  afterCritical: i
}) => {
  if (!t.isCombineEnabled)
    return null;
  const o = r.draggableId, u = n[o].descriptor.index;
  return dg(o, i) ? e ? u : u - 1 : e ? u + 1 : u;
}), qje = (({
  isMovingForward: e,
  isInHomeList: t,
  insideDestination: n,
  location: r
}) => {
  if (!n.length)
    return null;
  const i = r.index, o = e ? i + 1 : i - 1, s = n[0].descriptor.index, u = n[n.length - 1].descriptor.index, f = t ? u : u + 1;
  return o < s || o > f ? null : o;
}), $je = (({
  isMovingForward: e,
  isInHomeList: t,
  draggable: n,
  draggables: r,
  destination: i,
  insideDestination: o,
  previousImpact: s,
  viewport: u,
  afterCritical: f
}) => {
  const p = s.at;
  if (p || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot move in direction without previous impact location") : Ae()), p.type === "REORDER") {
    const v = qje({
      isMovingForward: e,
      isInHomeList: t,
      location: p.destination,
      insideDestination: o
    });
    return v == null ? null : EA({
      draggable: n,
      insideDestination: o,
      destination: i,
      viewport: u,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: v
    });
  }
  const m = Hje({
    isMovingForward: e,
    destination: i,
    displaced: s.displaced,
    draggables: r,
    combine: p.combine,
    afterCritical: f
  });
  return m == null ? null : EA({
    draggable: n,
    insideDestination: o,
    destination: i,
    viewport: u,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: m
  });
}), Gje = (({
  displaced: e,
  afterCritical: t,
  combineWith: n,
  displacedBy: r
}) => {
  const i = !!(e.visible[n] || e.invisible[n]);
  return dg(n, t) ? i ? Go : Fx(r.point) : i ? r.point : Go;
}), Yje = (({
  afterCritical: e,
  impact: t,
  draggables: n
}) => {
  const r = OI(t);
  r || (ot.NODE_ENV, Ae());
  const i = r.draggableId, o = n[i].page.borderBox.center, s = Gje({
    displaced: t.displaced,
    afterCritical: e,
    combineWith: i,
    displacedBy: t.displacedBy
  });
  return da(o, s);
});
const Moe = (e, t) => t.margin[e.start] + t.borderBox[e.size] / 2, Xje = (e, t) => t.margin[e.end] + t.borderBox[e.size] / 2, ZF = (e, t, n) => t[e.crossAxisStart] + n.margin[e.crossAxisStart] + n.borderBox[e.crossAxisSize] / 2, CY = ({
  axis: e,
  moveRelativeTo: t,
  isMoving: n
}) => Vv(e.line, t.marginBox[e.end] + Moe(e, n), ZF(e, t.marginBox, n)), RY = ({
  axis: e,
  moveRelativeTo: t,
  isMoving: n
}) => Vv(e.line, t.marginBox[e.start] - Xje(e, n), ZF(e, t.marginBox, n)), Zje = ({
  axis: e,
  moveInto: t,
  isMoving: n
}) => Vv(e.line, t.contentBox[e.start] + Moe(e, n), ZF(e, t.contentBox, n));
var Kje = (({
  impact: e,
  draggable: t,
  draggables: n,
  droppable: r,
  afterCritical: i
}) => {
  const o = ay(r.descriptor.id, n), s = t.page, u = r.axis;
  if (!o.length)
    return Zje({
      axis: u,
      moveInto: r.page,
      isMoving: s
    });
  const {
    displaced: f,
    displacedBy: p
  } = e, m = f.all[0];
  if (m) {
    const y = n[m];
    if (dg(m, i))
      return RY({
        axis: u,
        moveRelativeTo: y.page,
        isMoving: s
      });
    const S = SA(y.page, p.point);
    return RY({
      axis: u,
      moveRelativeTo: S,
      isMoving: s
    });
  }
  const v = o[o.length - 1];
  if (v.descriptor.id === t.descriptor.id)
    return s.borderBox.center;
  if (dg(v.descriptor.id, i)) {
    const y = SA(v.page, Fx(i.displacedBy.point));
    return CY({
      axis: u,
      moveRelativeTo: y,
      isMoving: s
    });
  }
  return CY({
    axis: u,
    moveRelativeTo: v.page,
    isMoving: s
  });
}), gV = ((e, t) => {
  const n = e.frame;
  return n ? da(t, n.scroll.diff.displacement) : t;
});
const Qje = ({
  impact: e,
  draggable: t,
  droppable: n,
  draggables: r,
  afterCritical: i
}) => {
  const o = t.page.borderBox.center, s = e.at;
  return !n || !s ? o : s.type === "REORDER" ? Kje({
    impact: e,
    draggable: t,
    draggables: r,
    droppable: n,
    afterCritical: i
  }) : Yje({
    impact: e,
    draggables: r,
    afterCritical: i
  });
};
var DI = ((e) => {
  const t = Qje(e), n = e.droppable;
  return n ? gV(n, t) : t;
}), joe = ((e, t) => {
  const n = Il(t, e.scroll.initial), r = Fx(n);
  return {
    frame: Ru({
      top: t.y,
      bottom: t.y + e.frame.height,
      left: t.x,
      right: t.x + e.frame.width
    }),
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: n,
        displacement: r
      }
    }
  };
});
function OY(e, t) {
  return e.map((n) => t[n]);
}
function Jje(e, t) {
  for (let n = 0; n < t.length; n++) {
    const r = t[n].visible[e];
    if (r)
      return r;
  }
  return null;
}
var eLe = (({
  impact: e,
  viewport: t,
  destination: n,
  draggables: r,
  maxScrollChange: i
}) => {
  const o = joe(t, da(t.scroll.current, i)), s = n.frame ? $F(n, da(n.frame.scroll.current, i)) : n, u = e.displaced, f = m1({
    afterDragging: OY(u.all, r),
    destination: n,
    displacedBy: e.displacedBy,
    viewport: o.frame,
    last: u,
    forceShouldAnimate: !1
  }), p = m1({
    afterDragging: OY(u.all, r),
    destination: s,
    displacedBy: e.displacedBy,
    viewport: t.frame,
    last: u,
    forceShouldAnimate: !1
  }), m = {}, v = {}, y = [u, f, p];
  return u.all.forEach((E) => {
    const w = Jje(E, y);
    if (w) {
      v[E] = w;
      return;
    }
    m[E] = !0;
  }), {
    ...e,
    displaced: {
      all: u.all,
      invisible: m,
      visible: v
    }
  };
}), tLe = ((e, t) => da(e.scroll.diff.displacement, t)), KF = (({
  pageBorderBoxCenter: e,
  draggable: t,
  viewport: n
}) => {
  const r = tLe(n, e), i = Il(r, t.page.borderBox.center);
  return da(t.client.borderBox.center, i);
}), Loe = (({
  draggable: e,
  destination: t,
  newPageBorderBoxCenter: n,
  viewport: r,
  withDroppableDisplacement: i,
  onlyOnMainAxis: o = !1
}) => {
  const s = Il(n, e.page.borderBox.center), f = {
    target: T_(e.page.borderBox, s),
    destination: t,
    withDroppableDisplacement: i,
    viewport: r
  };
  return o ? Vje(f) : Noe(f);
}), nLe = (({
  isMovingForward: e,
  draggable: t,
  destination: n,
  draggables: r,
  previousImpact: i,
  viewport: o,
  previousPageBorderBoxCenter: s,
  previousClientSelection: u,
  afterCritical: f
}) => {
  if (!n.isEnabled)
    return null;
  const p = ay(n.descriptor.id, r), m = Wx(t, n), v = Ije({
    isMovingForward: e,
    draggable: t,
    destination: n,
    insideDestination: p,
    previousImpact: i
  }) || $je({
    isMovingForward: e,
    isInHomeList: m,
    draggable: t,
    draggables: r,
    destination: n,
    insideDestination: p,
    previousImpact: i,
    viewport: o,
    afterCritical: f
  });
  if (!v)
    return null;
  const y = DI({
    impact: v,
    draggable: t,
    droppable: n,
    draggables: r,
    afterCritical: f
  });
  if (Loe({
    draggable: t,
    destination: n,
    newPageBorderBoxCenter: y,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  }))
    return {
      clientSelection: KF({
        pageBorderBoxCenter: y,
        draggable: t,
        viewport: o
      }),
      impact: v,
      scrollJumpRequest: null
    };
  const E = Il(y, s), w = eLe({
    impact: v,
    viewport: o,
    destination: n,
    draggables: r,
    maxScrollChange: E
  });
  return {
    clientSelection: u,
    impact: w,
    scrollJumpRequest: E
  };
});
const cs = (e) => {
  const t = e.subject.active;
  return t || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot get clipped area from droppable") : Ae()), t;
};
var rLe = (({
  isMovingForward: e,
  pageBorderBoxCenter: t,
  source: n,
  droppables: r,
  viewport: i
}) => {
  const o = n.subject.active;
  if (!o)
    return null;
  const s = n.axis, u = Nc(o[s.start], o[s.end]), f = RI(r).filter((m) => m !== n).filter((m) => m.isEnabled).filter((m) => !!m.subject.active).filter((m) => Ioe(i.frame)(cs(m))).filter((m) => {
    const v = cs(m);
    return e ? o[s.crossAxisEnd] < v[s.crossAxisEnd] : v[s.crossAxisStart] < o[s.crossAxisStart];
  }).filter((m) => {
    const v = cs(m), y = Nc(v[s.start], v[s.end]);
    return u(v[s.start]) || u(v[s.end]) || y(o[s.start]) || y(o[s.end]);
  }).sort((m, v) => {
    const y = cs(m)[s.crossAxisStart], S = cs(v)[s.crossAxisStart];
    return e ? y - S : S - y;
  }).filter((m, v, y) => cs(m)[s.crossAxisStart] === cs(y[0])[s.crossAxisStart]);
  if (!f.length)
    return null;
  if (f.length === 1)
    return f[0];
  const p = f.filter((m) => Nc(cs(m)[s.start], cs(m)[s.end])(t[s.line]));
  return p.length === 1 ? p[0] : p.length > 1 ? p.sort((m, v) => cs(m)[s.start] - cs(v)[s.start])[0] : f.sort((m, v) => {
    const y = TY(t, EY(cs(m))), S = TY(t, EY(cs(v)));
    return y !== S ? y - S : cs(m)[s.start] - cs(v)[s.start];
  })[0];
});
const AY = (e, t) => {
  const n = e.page.borderBox.center;
  return dg(e.descriptor.id, t) ? Il(n, t.displacedBy.point) : n;
}, iLe = (e, t) => {
  const n = e.page.borderBox;
  return dg(e.descriptor.id, t) ? T_(n, Fx(t.displacedBy.point)) : n;
};
var oLe = (({
  pageBorderBoxCenter: e,
  viewport: t,
  destination: n,
  insideDestination: r,
  afterCritical: i
}) => r.filter((s) => Noe({
  target: iLe(s, i),
  destination: n,
  viewport: t.frame,
  withDroppableDisplacement: !0
})).sort((s, u) => {
  const f = h1(e, gV(n, AY(s, i))), p = h1(e, gV(n, AY(u, i)));
  return f < p ? -1 : p < f ? 1 : s.descriptor.index - u.descriptor.index;
})[0] || null), E_ = $o(function(t, n) {
  const r = n[t.line];
  return {
    value: r,
    point: Vv(t.line, r)
  };
});
const aLe = (e, t, n) => {
  const r = e.axis;
  if (e.descriptor.mode === "virtual")
    return Vv(r.line, t[r.line]);
  const i = e.subject.page.contentBox[r.size], f = ay(e.descriptor.id, n).reduce((p, m) => p + m.client.marginBox[r.size], 0) + t[r.line] - i;
  return f <= 0 ? null : Vv(r.line, f);
}, koe = (e, t) => ({
  ...e,
  scroll: {
    ...e.scroll,
    max: t
  }
}), zoe = (e, t, n) => {
  const r = e.frame;
  Wx(t, e) && (ot.NODE_ENV !== "production" ? Ae(!1, "Should not add placeholder space to home list") : Ae()), e.subject.withPlaceholder && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot add placeholder size to a subject when it already has one") : Ae());
  const i = E_(e.axis, t.displaceBy).point, o = aLe(e, i, n), s = {
    placeholderSize: i,
    increasedBy: o,
    oldFrameMaxScroll: e.frame ? e.frame.scroll.max : null
  };
  if (!r) {
    const m = gx({
      page: e.subject.page,
      withPlaceholder: s,
      axis: e.axis,
      frame: e.frame
    });
    return {
      ...e,
      subject: m
    };
  }
  const u = o ? da(r.scroll.max, o) : r.scroll.max, f = koe(r, u), p = gx({
    page: e.subject.page,
    withPlaceholder: s,
    axis: e.axis,
    frame: f
  });
  return {
    ...e,
    subject: p,
    frame: f
  };
}, sLe = (e) => {
  const t = e.subject.withPlaceholder;
  t || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot remove placeholder form subject when there was none") : Ae());
  const n = e.frame;
  if (!n) {
    const s = gx({
      page: e.subject.page,
      axis: e.axis,
      frame: null,
      withPlaceholder: null
    });
    return {
      ...e,
      subject: s
    };
  }
  const r = t.oldFrameMaxScroll;
  r || (ot.NODE_ENV !== "production" ? Ae(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : Ae());
  const i = koe(n, r), o = gx({
    page: e.subject.page,
    axis: e.axis,
    frame: i,
    withPlaceholder: null
  });
  return {
    ...e,
    subject: o,
    frame: i
  };
};
var lLe = (({
  previousPageBorderBoxCenter: e,
  moveRelativeTo: t,
  insideDestination: n,
  draggable: r,
  draggables: i,
  destination: o,
  viewport: s,
  afterCritical: u
}) => {
  if (!t) {
    if (n.length)
      return null;
    const v = {
      displaced: g1,
      displacedBy: Doe,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, y = DI({
      impact: v,
      draggable: r,
      droppable: o,
      draggables: i,
      afterCritical: u
    }), S = Wx(r, o) ? o : zoe(o, r, i);
    return Loe({
      draggable: r,
      destination: S,
      newPageBorderBoxCenter: y,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    }) ? v : null;
  }
  const f = e[o.axis.line] <= t.page.borderBox.center[o.axis.line], p = (() => {
    const v = t.descriptor.index;
    return t.descriptor.id === r.descriptor.id || f ? v : v + 1;
  })(), m = E_(o.axis, r.displaceBy);
  return EA({
    draggable: r,
    insideDestination: n,
    destination: o,
    viewport: s,
    displacedBy: m,
    last: g1,
    index: p
  });
}), cLe = (({
  isMovingForward: e,
  previousPageBorderBoxCenter: t,
  draggable: n,
  isOver: r,
  draggables: i,
  droppables: o,
  viewport: s,
  afterCritical: u
}) => {
  const f = rLe({
    isMovingForward: e,
    pageBorderBoxCenter: t,
    source: r,
    droppables: o,
    viewport: s
  });
  if (!f)
    return null;
  const p = ay(f.descriptor.id, i), m = oLe({
    pageBorderBoxCenter: t,
    viewport: s,
    destination: f,
    insideDestination: p,
    afterCritical: u
  }), v = lLe({
    previousPageBorderBoxCenter: t,
    destination: f,
    draggable: n,
    draggables: i,
    moveRelativeTo: m,
    insideDestination: p,
    viewport: s,
    afterCritical: u
  });
  if (!v)
    return null;
  const y = DI({
    impact: v,
    draggable: n,
    droppable: f,
    draggables: i,
    afterCritical: u
  });
  return {
    clientSelection: KF({
      pageBorderBoxCenter: y,
      draggable: n,
      viewport: s
    }),
    impact: v,
    scrollJumpRequest: null
  };
}), Nl = ((e) => {
  const t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
});
const uLe = (e, t) => {
  const n = Nl(e);
  return n ? t[n] : null;
};
var dLe = (({
  state: e,
  type: t
}) => {
  const n = uLe(e.impact, e.dimensions.droppables), r = !!n, i = e.dimensions.droppables[e.critical.droppable.id], o = n || i, s = o.axis.direction, u = s === "vertical" && (t === "MOVE_UP" || t === "MOVE_DOWN") || s === "horizontal" && (t === "MOVE_LEFT" || t === "MOVE_RIGHT");
  if (u && !r)
    return null;
  const f = t === "MOVE_DOWN" || t === "MOVE_RIGHT", p = e.dimensions.draggables[e.critical.draggable.id], m = e.current.page.borderBoxCenter, {
    draggables: v,
    droppables: y
  } = e.dimensions;
  return u ? nLe({
    isMovingForward: f,
    previousPageBorderBoxCenter: m,
    draggable: p,
    destination: o,
    draggables: v,
    viewport: e.viewport,
    previousClientSelection: e.current.client.selection,
    previousImpact: e.impact,
    afterCritical: e.afterCritical
  }) : cLe({
    isMovingForward: f,
    previousPageBorderBoxCenter: m,
    draggable: p,
    isOver: o,
    draggables: v,
    droppables: y,
    viewport: e.viewport,
    afterCritical: e.afterCritical
  });
});
function hv(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function Boe(e) {
  const t = Nc(e.top, e.bottom), n = Nc(e.left, e.right);
  return function(i) {
    return t(i.y) && n(i.x);
  };
}
function fLe(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function pLe({
  pageBorderBox: e,
  draggable: t,
  candidates: n
}) {
  const r = t.page.borderBox.center, i = n.map((o) => {
    const s = o.axis, u = Vv(o.axis.line, e.center[s.line], o.page.borderBox.center[s.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: h1(r, u)
    };
  }).sort((o, s) => s.distance - o.distance);
  return i[0] ? i[0].id : null;
}
function hLe({
  pageBorderBox: e,
  draggable: t,
  droppables: n
}) {
  const r = RI(n).filter((i) => {
    if (!i.isEnabled)
      return !1;
    const o = i.subject.active;
    if (!o || !fLe(e, o))
      return !1;
    if (Boe(o)(e.center))
      return !0;
    const s = i.axis, u = o.center[s.crossAxisLine], f = e[s.crossAxisStart], p = e[s.crossAxisEnd], m = Nc(o[s.crossAxisStart], o[s.crossAxisEnd]), v = m(f), y = m(p);
    return !v && !y ? !0 : v ? f < u : p > u;
  });
  return r.length ? r.length === 1 ? r[0].descriptor.id : pLe({
    pageBorderBox: e,
    draggable: t,
    candidates: r
  }) : null;
}
const Voe = (e, t) => Ru(T_(e, t));
var gLe = ((e, t) => {
  const n = e.frame;
  return n ? Voe(t, n.scroll.diff.value) : t;
});
function Uoe({
  displaced: e,
  id: t
}) {
  return !!(e.visible[t] || e.invisible[t]);
}
function mLe({
  draggable: e,
  closest: t,
  inHomeList: n
}) {
  return t ? n && t.descriptor.index > e.descriptor.index ? t.descriptor.index - 1 : t.descriptor.index : null;
}
var vLe = (({
  pageBorderBoxWithDroppableScroll: e,
  draggable: t,
  destination: n,
  insideDestination: r,
  last: i,
  viewport: o,
  afterCritical: s
}) => {
  const u = n.axis, f = E_(n.axis, t.displaceBy), p = f.value, m = e[u.start], v = e[u.end], S = AI(t, r).find((w) => {
    const _ = w.descriptor.id, O = w.page.borderBox.center[u.line], D = dg(_, s), P = Uoe({
      displaced: i,
      id: _
    });
    return D ? P ? v <= O : m < O - p : P ? v <= O + p : m < O;
  }) || null, E = mLe({
    draggable: t,
    closest: S,
    inHomeList: Wx(t, n)
  });
  return EA({
    draggable: t,
    insideDestination: r,
    destination: n,
    viewport: o,
    last: i,
    displacedBy: f,
    index: E
  });
});
const yLe = 4;
var bLe = (({
  draggable: e,
  pageBorderBoxWithDroppableScroll: t,
  previousImpact: n,
  destination: r,
  insideDestination: i,
  afterCritical: o
}) => {
  if (!r.isCombineEnabled)
    return null;
  const s = r.axis, u = E_(r.axis, e.displaceBy), f = u.value, p = t[s.start], m = t[s.end], y = AI(e, i).find((E) => {
    const w = E.descriptor.id, _ = E.page.borderBox, D = _[s.size] / yLe, P = dg(w, o), M = Uoe({
      displaced: n.displaced,
      id: w
    });
    return P ? M ? m > _[s.start] + D && m < _[s.end] - D : p > _[s.start] - f + D && p < _[s.end] - f - D : M ? m > _[s.start] + f + D && m < _[s.end] + f - D : p > _[s.start] + D && p < _[s.end] - D;
  });
  return y ? {
    displacedBy: u,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: y.descriptor.id,
        droppableId: r.descriptor.id
      }
    }
  } : null;
}), Foe = (({
  pageOffset: e,
  draggable: t,
  draggables: n,
  droppables: r,
  previousImpact: i,
  viewport: o,
  afterCritical: s
}) => {
  const u = Voe(t.page.borderBox, e), f = hLe({
    pageBorderBox: u,
    draggable: t,
    droppables: r
  });
  if (!f)
    return Nje;
  const p = r[f], m = ay(p.descriptor.id, n), v = gLe(p, u);
  return bLe({
    pageBorderBoxWithDroppableScroll: v,
    draggable: t,
    previousImpact: i,
    destination: p,
    insideDestination: m,
    afterCritical: s
  }) || vLe({
    pageBorderBoxWithDroppableScroll: v,
    draggable: t,
    destination: p,
    insideDestination: m,
    last: i.displaced,
    viewport: o,
    afterCritical: s
  });
}), QF = ((e, t) => ({
  ...e,
  [t.descriptor.id]: t
}));
const xLe = ({
  previousImpact: e,
  impact: t,
  droppables: n
}) => {
  const r = Nl(e), i = Nl(t);
  if (!r || r === i)
    return n;
  const o = n[r];
  if (!o.subject.withPlaceholder)
    return n;
  const s = sLe(o);
  return QF(n, s);
};
var SLe = (({
  draggable: e,
  draggables: t,
  droppables: n,
  previousImpact: r,
  impact: i
}) => {
  const o = xLe({
    previousImpact: r,
    impact: i,
    droppables: n
  }), s = Nl(i);
  if (!s)
    return o;
  const u = n[s];
  if (Wx(e, u) || u.subject.withPlaceholder)
    return o;
  const f = zoe(u, e, t);
  return QF(o, f);
}), FE = (({
  state: e,
  clientSelection: t,
  dimensions: n,
  viewport: r,
  impact: i,
  scrollJumpRequest: o
}) => {
  const s = r || e.viewport, u = n || e.dimensions, f = t || e.current.client.selection, p = Il(f, e.initial.client.selection), m = {
    offset: p,
    selection: f,
    borderBoxCenter: da(e.initial.client.borderBoxCenter, p)
  }, v = {
    selection: da(m.selection, s.scroll.current),
    borderBoxCenter: da(m.borderBoxCenter, s.scroll.current),
    offset: da(m.offset, s.scroll.diff.value)
  }, y = {
    client: m,
    page: v
  };
  if (e.phase === "COLLECTING")
    return {
      ...e,
      dimensions: u,
      viewport: s,
      current: y
    };
  const S = u.draggables[e.critical.draggable.id], E = i || Foe({
    pageOffset: v.offset,
    draggable: S,
    draggables: u.draggables,
    droppables: u.droppables,
    previousImpact: e.impact,
    viewport: s,
    afterCritical: e.afterCritical
  }), w = SLe({
    draggable: S,
    impact: E,
    previousImpact: e.impact,
    draggables: u.draggables,
    droppables: u.droppables
  });
  return {
    ...e,
    current: y,
    dimensions: {
      draggables: u.draggables,
      droppables: w
    },
    impact: E,
    viewport: s,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  };
});
function wLe(e, t) {
  return e.map((n) => t[n]);
}
var Woe = (({
  impact: e,
  viewport: t,
  draggables: n,
  destination: r,
  forceShouldAnimate: i
}) => {
  const o = e.displaced, s = wLe(o.all, n), u = m1({
    afterDragging: s,
    destination: r,
    displacedBy: e.displacedBy,
    viewport: t.frame,
    forceShouldAnimate: i,
    last: o
  });
  return {
    ...e,
    displaced: u
  };
}), Hoe = (({
  impact: e,
  draggable: t,
  droppable: n,
  draggables: r,
  viewport: i,
  afterCritical: o
}) => {
  const s = DI({
    impact: e,
    draggable: t,
    draggables: r,
    droppable: n,
    afterCritical: o
  });
  return KF({
    pageBorderBoxCenter: s,
    draggable: t,
    viewport: i
  });
}), qoe = (({
  state: e,
  dimensions: t,
  viewport: n
}) => {
  e.movementMode !== "SNAP" && (ot.NODE_ENV, Ae());
  const r = e.impact, i = n || e.viewport, o = t || e.dimensions, {
    draggables: s,
    droppables: u
  } = o, f = s[e.critical.draggable.id], p = Nl(r);
  p || (ot.NODE_ENV !== "production" ? Ae(!1, "Must be over a destination in SNAP movement mode") : Ae());
  const m = u[p], v = Woe({
    impact: r,
    viewport: i,
    destination: m,
    draggables: s
  }), y = Hoe({
    impact: v,
    draggable: f,
    droppable: m,
    draggables: s,
    viewport: i,
    afterCritical: e.afterCritical
  });
  return FE({
    impact: v,
    clientSelection: y,
    state: e,
    dimensions: o,
    viewport: i
  });
}), TLe = ((e) => ({
  index: e.index,
  droppableId: e.droppableId
})), $oe = (({
  draggable: e,
  home: t,
  draggables: n,
  viewport: r
}) => {
  const i = E_(t.axis, e.displaceBy), o = ay(t.descriptor.id, n), s = o.indexOf(e);
  s === -1 && (ot.NODE_ENV !== "production" ? Ae(!1, "Expected draggable to be inside home list") : Ae());
  const u = o.slice(s + 1), f = u.reduce((y, S) => (y[S.descriptor.id] = !0, y), {}), p = {
    inVirtualList: t.descriptor.mode === "virtual",
    displacedBy: i,
    effected: f
  };
  return {
    impact: {
      displaced: m1({
        afterDragging: u,
        destination: t,
        displacedBy: i,
        last: null,
        viewport: r.frame,
        forceShouldAnimate: !1
      }),
      displacedBy: i,
      at: {
        type: "REORDER",
        destination: TLe(e.descriptor)
      }
    },
    afterCritical: p
  };
}), ELe = ((e, t) => ({
  draggables: e.draggables,
  droppables: QF(e.droppables, t)
})), _Le = (({
  draggable: e,
  offset: t,
  initialWindowScroll: n
}) => {
  const r = SA(e.client, t), i = wA(r, n);
  return {
    ...e,
    placeholder: {
      ...e.placeholder,
      client: r
    },
    client: r,
    page: i
  };
}), CLe = ((e) => {
  const t = e.frame;
  return t || (ot.NODE_ENV !== "production" ? Ae(!1, "Expected Droppable to have a frame") : Ae()), t;
}), RLe = (({
  additions: e,
  updatedDroppables: t,
  viewport: n
}) => {
  const r = n.scroll.diff.value;
  return e.map((i) => {
    const o = i.descriptor.droppableId, s = t[o], f = CLe(s).scroll.diff.value, p = da(r, f);
    return _Le({
      draggable: i,
      offset: p,
      initialWindowScroll: n.scroll.initial
    });
  });
}), OLe = (({
  state: e,
  published: t
}) => {
  const n = t.modified.map((O) => {
    const D = e.dimensions.droppables[O.droppableId];
    return $F(D, O.scroll);
  }), r = {
    ...e.dimensions.droppables,
    ...Ooe(n)
  }, i = Aoe(RLe({
    additions: t.additions,
    updatedDroppables: r,
    viewport: e.viewport
  })), o = {
    ...e.dimensions.draggables,
    ...i
  };
  t.removals.forEach((O) => {
    delete o[O];
  });
  const s = {
    droppables: r,
    draggables: o
  }, u = Nl(e.impact), f = u ? s.droppables[u] : null, p = s.draggables[e.critical.draggable.id], m = s.droppables[e.critical.droppable.id], {
    impact: v,
    afterCritical: y
  } = $oe({
    draggable: p,
    home: m,
    draggables: o,
    viewport: e.viewport
  }), S = f && f.isCombineEnabled ? e.impact : v, E = Foe({
    pageOffset: e.current.page.offset,
    draggable: s.draggables[e.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: S,
    viewport: e.viewport,
    afterCritical: y
  }), w = {
    ...e,
    phase: "DRAGGING",
    impact: E,
    onLiftImpact: v,
    dimensions: s,
    afterCritical: y,
    forceShouldAnimate: !1
  };
  return e.phase === "COLLECTING" ? w : {
    ...w,
    phase: "DROP_PENDING",
    reason: e.reason,
    isWaiting: !1
  };
});
const mV = (e) => e.movementMode === "SNAP", Cz = (e, t, n) => {
  const r = ELe(e.dimensions, t);
  return !mV(e) || n ? FE({
    state: e,
    dimensions: r
  }) : qoe({
    state: e,
    dimensions: r
  });
};
function Rz(e) {
  return e.isDragging && e.movementMode === "SNAP" ? {
    ...e,
    scrollJumpRequest: null
  } : e;
}
const DY = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
};
var ALe = ((e = DY, t) => {
  if (t.type === "FLUSH")
    return {
      ...DY,
      shouldFlush: !0
    };
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (ot.NODE_ENV !== "production" ? Ae(!1, "INITIAL_PUBLISH must come after a IDLE phase") : Ae());
    const {
      critical: n,
      clientSelection: r,
      viewport: i,
      dimensions: o,
      movementMode: s
    } = t.payload, u = o.draggables[n.draggable.id], f = o.droppables[n.droppable.id], p = {
      selection: r,
      borderBoxCenter: u.client.borderBox.center,
      offset: Go
    }, m = {
      client: p,
      page: {
        selection: da(p.selection, i.scroll.initial),
        borderBoxCenter: da(p.selection, i.scroll.initial),
        offset: da(p.selection, i.scroll.diff.value)
      }
    }, v = RI(o.droppables).every((w) => !w.isFixedOnPage), {
      impact: y,
      afterCritical: S
    } = $oe({
      draggable: u,
      home: f,
      draggables: o.draggables,
      viewport: i
    });
    return {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: s,
      dimensions: o,
      initial: m,
      current: m,
      isWindowScrollAllowed: v,
      impact: y,
      afterCritical: S,
      onLiftImpact: y,
      viewport: i,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
  }
  if (t.type === "COLLECTION_STARTING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" ? e : (e.phase !== "DRAGGING" && (ot.NODE_ENV !== "production" ? Ae(!1, `Collection cannot start from phase ${e.phase}`) : Ae()), {
      ...e,
      phase: "COLLECTING"
    });
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (ot.NODE_ENV !== "production" ? Ae(!1, `Unexpected ${t.type} received in phase ${e.phase}`) : Ae()), OLe({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    hv(e) || (ot.NODE_ENV !== "production" ? Ae(!1, `${t.type} not permitted in phase ${e.phase}`) : Ae());
    const {
      client: n
    } = t.payload;
    return rg(n, e.current.client.selection) ? e : FE({
      state: e,
      clientSelection: n,
      impact: mV(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return Rz(e);
    hv(e) || (ot.NODE_ENV !== "production" ? Ae(!1, `${t.type} not permitted in phase ${e.phase}`) : Ae());
    const {
      id: n,
      newScroll: r
    } = t.payload, i = e.dimensions.droppables[n];
    if (!i)
      return e;
    const o = $F(i, r);
    return Cz(e, o, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    hv(e) || (ot.NODE_ENV !== "production" ? Ae(!1, `Attempting to move in an unsupported phase ${e.phase}`) : Ae());
    const {
      id: n,
      isEnabled: r
    } = t.payload, i = e.dimensions.droppables[n];
    i || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot find Droppable[id: ${n}] to toggle its enabled state`) : Ae()), i.isEnabled === r && (ot.NODE_ENV !== "production" ? Ae(!1, `Trying to set droppable isEnabled to ${String(r)}
      but it is already ${String(i.isEnabled)}`) : Ae());
    const o = {
      ...i,
      isEnabled: r
    };
    return Cz(e, o, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    hv(e) || (ot.NODE_ENV !== "production" ? Ae(!1, `Attempting to move in an unsupported phase ${e.phase}`) : Ae());
    const {
      id: n,
      isCombineEnabled: r
    } = t.payload, i = e.dimensions.droppables[n];
    i || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot find Droppable[id: ${n}] to toggle its isCombineEnabled state`) : Ae()), i.isCombineEnabled === r && (ot.NODE_ENV !== "production" ? Ae(!1, `Trying to set droppable isCombineEnabled to ${String(r)}
      but it is already ${String(i.isCombineEnabled)}`) : Ae());
    const o = {
      ...i,
      isCombineEnabled: r
    };
    return Cz(e, o, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    hv(e) || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot move by window in phase ${e.phase}`) : Ae()), e.isWindowScrollAllowed || (ot.NODE_ENV !== "production" ? Ae(!1, "Window scrolling is currently not supported for fixed lists") : Ae());
    const n = t.payload.newScroll;
    if (rg(e.viewport.scroll.current, n))
      return Rz(e);
    const r = joe(e.viewport, n);
    return mV(e) ? qoe({
      state: e,
      viewport: r
    }) : FE({
      state: e,
      viewport: r
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!hv(e))
      return e;
    const n = t.payload.maxScroll;
    if (rg(n, e.viewport.scroll.max))
      return e;
    const r = {
      ...e.viewport,
      scroll: {
        ...e.viewport.scroll,
        max: n
      }
    };
    return {
      ...e,
      viewport: r
    };
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (ot.NODE_ENV !== "production" ? Ae(!1, `${t.type} received while not in DRAGGING phase`) : Ae());
    const n = dLe({
      state: e,
      type: t.type
    });
    return n ? FE({
      state: e,
      impact: n.impact,
      clientSelection: n.clientSelection,
      scrollJumpRequest: n.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    const n = t.payload.reason;
    return e.phase !== "COLLECTING" && (ot.NODE_ENV !== "production" ? Ae(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : Ae()), {
      ...e,
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: n
    };
  }
  if (t.type === "DROP_ANIMATE") {
    const {
      completed: n,
      dropDuration: r,
      newHomeClientOffset: i
    } = t.payload;
    return e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot animate drop from phase ${e.phase}`) : Ae()), {
      phase: "DROP_ANIMATING",
      completed: n,
      dropDuration: r,
      newHomeClientOffset: i,
      dimensions: e.dimensions
    };
  }
  if (t.type === "DROP_COMPLETE") {
    const {
      completed: n
    } = t.payload;
    return {
      phase: "IDLE",
      completed: n,
      shouldFlush: !1
    };
  }
  return e;
});
const DLe = (e) => ({
  type: "BEFORE_INITIAL_CAPTURE",
  payload: e
}), ILe = (e) => ({
  type: "LIFT",
  payload: e
}), PLe = (e) => ({
  type: "INITIAL_PUBLISH",
  payload: e
}), NLe = (e) => ({
  type: "PUBLISH_WHILE_DRAGGING",
  payload: e
}), MLe = () => ({
  type: "COLLECTION_STARTING",
  payload: null
}), jLe = (e) => ({
  type: "UPDATE_DROPPABLE_SCROLL",
  payload: e
}), LLe = (e) => ({
  type: "UPDATE_DROPPABLE_IS_ENABLED",
  payload: e
}), kLe = (e) => ({
  type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
  payload: e
}), Goe = (e) => ({
  type: "MOVE",
  payload: e
}), zLe = (e) => ({
  type: "MOVE_BY_WINDOW_SCROLL",
  payload: e
}), BLe = (e) => ({
  type: "UPDATE_VIEWPORT_MAX_SCROLL",
  payload: e
}), VLe = () => ({
  type: "MOVE_UP",
  payload: null
}), ULe = () => ({
  type: "MOVE_DOWN",
  payload: null
}), FLe = () => ({
  type: "MOVE_RIGHT",
  payload: null
}), WLe = () => ({
  type: "MOVE_LEFT",
  payload: null
}), JF = () => ({
  type: "FLUSH",
  payload: null
}), HLe = (e) => ({
  type: "DROP_ANIMATE",
  payload: e
}), eW = (e) => ({
  type: "DROP_COMPLETE",
  payload: e
}), Yoe = (e) => ({
  type: "DROP",
  payload: e
}), qLe = (e) => ({
  type: "DROP_PENDING",
  payload: e
}), Xoe = () => ({
  type: "DROP_ANIMATION_FINISHED",
  payload: null
});
function $Le(e) {
  if (e.length <= 1)
    return;
  const t = e.map((i) => i.descriptor.index), n = {};
  for (let i = 1; i < t.length; i++) {
    const o = t[i], s = t[i - 1];
    o !== s + 1 && (n[o] = !0);
  }
  if (!Object.keys(n).length)
    return;
  const r = t.map((i) => !!n[i] ? `[🔥${i}]` : `${i}`).join(", ");
  ot.NODE_ENV !== "production" && si(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ${r}
  `);
}
function GLe(e, t) {
  if (ot.NODE_ENV !== "production") {
    const n = ay(e.droppable.id, t.draggables);
    $Le(n);
  }
}
var YLe = ((e) => ({
  getState: t,
  dispatch: n
}) => (r) => (i) => {
  if (i.type !== "LIFT") {
    r(i);
    return;
  }
  const {
    id: o,
    clientSelection: s,
    movementMode: u
  } = i.payload, f = t();
  f.phase === "DROP_ANIMATING" && n(eW({
    completed: f.completed
  })), t().phase !== "IDLE" && (ot.NODE_ENV !== "production" ? Ae(!1, "Unexpected phase to start a drag") : Ae()), n(JF()), n(DLe({
    draggableId: o,
    movementMode: u
  }));
  const m = {
    draggableId: o,
    scrollOptions: {
      shouldPublishImmediately: u === "SNAP"
    }
  }, {
    critical: v,
    dimensions: y,
    viewport: S
  } = e.startPublishing(m);
  GLe(v, y), n(PLe({
    critical: v,
    dimensions: y,
    clientSelection: s,
    movementMode: u,
    viewport: S
  }));
}), XLe = ((e) => () => (t) => (n) => {
  n.type === "INITIAL_PUBLISH" && e.dragging(), n.type === "DROP_ANIMATE" && e.dropping(n.payload.completed.result.reason), (n.type === "FLUSH" || n.type === "DROP_COMPLETE") && e.resting(), t(n);
});
const tW = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, v1 = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, Zoe = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, cv = `${Zoe.outOfTheWay}s ${tW.outOfTheWay}`, WE = {
  fluid: `opacity ${cv}`,
  snap: `transform ${cv}, opacity ${cv}`,
  drop: (e) => {
    const t = `${e}s ${tW.drop}`;
    return `transform ${t}, opacity ${t}`;
  },
  outOfTheWay: `transform ${cv}`,
  placeholder: `height ${cv}, width ${cv}, margin ${cv}`
}, IY = (e) => rg(e, Go) ? void 0 : `translate(${e.x}px, ${e.y}px)`, vV = {
  moveTo: IY,
  drop: (e, t) => {
    const n = IY(e);
    if (n)
      return t ? `${n} scale(${v1.scale.drop})` : n;
  }
}, {
  minDropTime: yV,
  maxDropTime: Koe
} = Zoe, ZLe = Koe - yV, PY = 1500, KLe = 0.6;
var QLe = (({
  current: e,
  destination: t,
  reason: n
}) => {
  const r = h1(e, t);
  if (r <= 0)
    return yV;
  if (r >= PY)
    return Koe;
  const i = r / PY, o = yV + ZLe * i, s = n === "CANCEL" ? o * KLe : o;
  return Number(s.toFixed(2));
}), JLe = (({
  impact: e,
  draggable: t,
  dimensions: n,
  viewport: r,
  afterCritical: i
}) => {
  const {
    draggables: o,
    droppables: s
  } = n, u = Nl(e), f = u ? s[u] : null, p = s[t.descriptor.droppableId], m = Hoe({
    impact: e,
    draggable: t,
    draggables: o,
    afterCritical: i,
    droppable: f || p,
    viewport: r
  });
  return Il(m, t.client.borderBox.center);
}), eke = (({
  draggables: e,
  reason: t,
  lastImpact: n,
  home: r,
  viewport: i,
  onLiftImpact: o
}) => !n.at || t !== "DROP" ? {
  impact: Woe({
    draggables: e,
    impact: o,
    destination: r,
    viewport: i,
    forceShouldAnimate: !0
  }),
  didDropInsideDroppable: !1
} : n.at.type === "REORDER" ? {
  impact: n,
  didDropInsideDroppable: !0
} : {
  impact: {
    ...n,
    displaced: g1
  },
  didDropInsideDroppable: !0
});
const tke = ({
  getState: e,
  dispatch: t
}) => (n) => (r) => {
  if (r.type !== "DROP") {
    n(r);
    return;
  }
  const i = e(), o = r.payload.reason;
  if (i.phase === "COLLECTING") {
    t(qLe({
      reason: o
    }));
    return;
  }
  if (i.phase === "IDLE")
    return;
  i.phase === "DROP_PENDING" && i.isWaiting && (ot.NODE_ENV !== "production" ? Ae(!1, "A DROP action occurred while DROP_PENDING and still waiting") : Ae()), i.phase === "DRAGGING" || i.phase === "DROP_PENDING" || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot drop in phase: ${i.phase}`) : Ae());
  const u = i.critical, f = i.dimensions, p = f.draggables[i.critical.draggable.id], {
    impact: m,
    didDropInsideDroppable: v
  } = eke({
    reason: o,
    lastImpact: i.impact,
    afterCritical: i.afterCritical,
    onLiftImpact: i.onLiftImpact,
    home: i.dimensions.droppables[i.critical.droppable.id],
    viewport: i.viewport,
    draggables: i.dimensions.draggables
  }), y = v ? GF(m) : null, S = v ? OI(m) : null, E = {
    index: u.draggable.index,
    droppableId: u.droppable.id
  }, w = {
    draggableId: p.descriptor.id,
    type: p.descriptor.type,
    source: E,
    reason: o,
    mode: i.movementMode,
    destination: y,
    combine: S
  }, _ = JLe({
    impact: m,
    draggable: p,
    dimensions: f,
    viewport: i.viewport,
    afterCritical: i.afterCritical
  }), O = {
    critical: i.critical,
    afterCritical: i.afterCritical,
    result: w,
    impact: m
  };
  if (!(!rg(i.current.client.offset, _) || !!w.combine)) {
    t(eW({
      completed: O
    }));
    return;
  }
  const P = QLe({
    current: i.current.client.offset,
    destination: _,
    reason: o
  });
  t(HLe({
    newHomeClientOffset: _,
    dropDuration: P,
    completed: O
  }));
};
var nke = tke, Qoe = (() => ({
  x: window.pageXOffset,
  y: window.pageYOffset
}));
function rke(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: (t) => {
      t.target !== window && t.target !== window.document || e();
    }
  };
}
function ike({
  onWindowScroll: e
}) {
  function t() {
    e(Qoe());
  }
  const n = f1(t), r = rke(n);
  let i = ng;
  function o() {
    return i !== ng;
  }
  function s() {
    o() && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot start scroll listener when already active") : Ae()), i = Oc(window, [r]);
  }
  function u() {
    o() || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot stop scroll listener when not active") : Ae()), n.cancel(), i(), i = ng;
  }
  return {
    start: s,
    stop: u,
    isActive: o
  };
}
const oke = (e) => e.type === "DROP_COMPLETE" || e.type === "DROP_ANIMATE" || e.type === "FLUSH", ake = (e) => {
  const t = ike({
    onWindowScroll: (n) => {
      e.dispatch(zLe({
        newScroll: n
      }));
    }
  });
  return (n) => (r) => {
    !t.isActive() && r.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && oke(r) && t.stop(), n(r);
  };
};
var ske = ake, lke = ((e) => {
  let t = !1, n = !1;
  const r = setTimeout(() => {
    n = !0;
  }), i = (o) => {
    if (t) {
      ot.NODE_ENV !== "production" && si("Announcement already made. Not making a second announcement");
      return;
    }
    if (n) {
      ot.NODE_ENV !== "production" && si(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(o), clearTimeout(r);
  };
  return i.wasCalled = () => t, i;
}), cke = (() => {
  const e = [], t = (i) => {
    const o = e.findIndex((u) => u.timerId === i);
    o === -1 && (ot.NODE_ENV !== "production" ? Ae(!1, "Could not find timer") : Ae());
    const [s] = e.splice(o, 1);
    s.callback();
  };
  return {
    add: (i) => {
      const o = setTimeout(() => t(o)), s = {
        timerId: o,
        callback: i
      };
      e.push(s);
    },
    flush: () => {
      if (!e.length)
        return;
      const i = [...e];
      e.length = 0, i.forEach((o) => {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
});
const uke = (e, t) => e == null && t == null ? !0 : e == null || t == null ? !1 : e.droppableId === t.droppableId && e.index === t.index, dke = (e, t) => e == null && t == null ? !0 : e == null || t == null ? !1 : e.draggableId === t.draggableId && e.droppableId === t.droppableId, fke = (e, t) => {
  if (e === t)
    return !0;
  const n = e.draggable.id === t.draggable.id && e.draggable.droppableId === t.draggable.droppableId && e.draggable.type === t.draggable.type && e.draggable.index === t.draggable.index, r = e.droppable.id === t.droppable.id && e.droppable.type === t.droppable.type;
  return n && r;
}, dE = (e, t) => {
  t();
}, pO = (e, t) => ({
  draggableId: e.draggable.id,
  type: e.droppable.type,
  source: {
    droppableId: e.droppable.id,
    index: e.draggable.index
  },
  mode: t
});
function Oz(e, t, n, r) {
  if (!e) {
    n(r(t));
    return;
  }
  const i = lke(n);
  e(t, {
    announce: i
  }), i.wasCalled() || n(r(t));
}
var pke = ((e, t) => {
  const n = cke();
  let r = null;
  const i = (v, y) => {
    r && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : Ae()), dE("onBeforeCapture", () => {
      const S = e().onBeforeCapture;
      S && S({
        draggableId: v,
        mode: y
      });
    });
  }, o = (v, y) => {
    r && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : Ae()), dE("onBeforeDragStart", () => {
      const S = e().onBeforeDragStart;
      S && S(pO(v, y));
    });
  }, s = (v, y) => {
    r && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : Ae());
    const S = pO(v, y);
    r = {
      mode: y,
      lastCritical: v,
      lastLocation: S.source,
      lastCombine: null
    }, n.add(() => {
      dE("onDragStart", () => Oz(e().onDragStart, S, t, VO.onDragStart));
    });
  }, u = (v, y) => {
    const S = GF(y), E = OI(y);
    r || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot fire onDragMove when onDragStart has not been called") : Ae());
    const w = !fke(v, r.lastCritical);
    w && (r.lastCritical = v);
    const _ = !uke(r.lastLocation, S);
    _ && (r.lastLocation = S);
    const O = !dke(r.lastCombine, E);
    if (O && (r.lastCombine = E), !w && !_ && !O)
      return;
    const D = {
      ...pO(v, r.mode),
      combine: E,
      destination: S
    };
    n.add(() => {
      dE("onDragUpdate", () => Oz(e().onDragUpdate, D, t, VO.onDragUpdate));
    });
  }, f = () => {
    r || (ot.NODE_ENV !== "production" ? Ae(!1, "Can only flush responders while dragging") : Ae()), n.flush();
  }, p = (v) => {
    r || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : Ae()), r = null, dE("onDragEnd", () => Oz(e().onDragEnd, v, t, VO.onDragEnd));
  };
  return {
    beforeCapture: i,
    beforeStart: o,
    start: s,
    update: u,
    flush: f,
    drop: p,
    abort: () => {
      if (!r)
        return;
      const v = {
        ...pO(r.lastCritical, r.mode),
        combine: null,
        destination: null,
        reason: "CANCEL"
      };
      p(v);
    }
  };
}), hke = ((e, t) => {
  const n = pke(e, t);
  return (r) => (i) => (o) => {
    if (o.type === "BEFORE_INITIAL_CAPTURE") {
      n.beforeCapture(o.payload.draggableId, o.payload.movementMode);
      return;
    }
    if (o.type === "INITIAL_PUBLISH") {
      const u = o.payload.critical;
      n.beforeStart(u, o.payload.movementMode), i(o), n.start(u, o.payload.movementMode);
      return;
    }
    if (o.type === "DROP_COMPLETE") {
      const u = o.payload.completed.result;
      n.flush(), i(o), n.drop(u);
      return;
    }
    if (i(o), o.type === "FLUSH") {
      n.abort();
      return;
    }
    const s = r.getState();
    s.phase === "DRAGGING" && n.update(s.critical, s.impact);
  };
});
const gke = (e) => (t) => (n) => {
  if (n.type !== "DROP_ANIMATION_FINISHED") {
    t(n);
    return;
  }
  const r = e.getState();
  r.phase !== "DROP_ANIMATING" && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot finish a drop animating when no drop is occurring") : Ae()), e.dispatch(eW({
    completed: r.completed
  }));
};
var mke = gke;
const vke = (e) => {
  let t = null, n = null;
  function r() {
    n && (cancelAnimationFrame(n), n = null), t && (t(), t = null);
  }
  return (i) => (o) => {
    if ((o.type === "FLUSH" || o.type === "DROP_COMPLETE" || o.type === "DROP_ANIMATION_FINISHED") && r(), i(o), o.type !== "DROP_ANIMATE")
      return;
    const s = {
      eventName: "scroll",
      options: {
        capture: !0,
        passive: !1,
        once: !0
      },
      fn: function() {
        e.getState().phase === "DROP_ANIMATING" && e.dispatch(Xoe());
      }
    };
    n = requestAnimationFrame(() => {
      n = null, t = Oc(window, [s]);
    });
  };
};
var yke = vke, bke = ((e) => () => (t) => (n) => {
  (n.type === "DROP_COMPLETE" || n.type === "FLUSH" || n.type === "DROP_ANIMATE") && e.stopPublishing(), t(n);
}), xke = ((e) => {
  let t = !1;
  return () => (n) => (r) => {
    if (r.type === "INITIAL_PUBLISH") {
      t = !0, e.tryRecordFocus(r.payload.critical.draggable.id), n(r), e.tryRestoreFocusRecorded();
      return;
    }
    if (n(r), !!t) {
      if (r.type === "FLUSH") {
        t = !1, e.tryRestoreFocusRecorded();
        return;
      }
      if (r.type === "DROP_COMPLETE") {
        t = !1;
        const i = r.payload.completed.result;
        i.combine && e.tryShiftRecord(i.draggableId, i.combine.draggableId), e.tryRestoreFocusRecorded();
      }
    }
  };
});
const Ske = (e) => e.type === "DROP_COMPLETE" || e.type === "DROP_ANIMATE" || e.type === "FLUSH";
var wke = ((e) => (t) => (n) => (r) => {
  if (Ske(r)) {
    e.stop(), n(r);
    return;
  }
  if (r.type === "INITIAL_PUBLISH") {
    n(r);
    const i = t.getState();
    i.phase !== "DRAGGING" && (ot.NODE_ENV !== "production" ? Ae(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : Ae()), e.start(i);
    return;
  }
  n(r), e.scroll(t.getState());
});
const Tke = (e) => (t) => (n) => {
  if (t(n), n.type !== "PUBLISH_WHILE_DRAGGING")
    return;
  const r = e.getState();
  r.phase === "DROP_PENDING" && (r.isWaiting || e.dispatch(Yoe({
    reason: r.reason
  })));
};
var Eke = Tke;
const _ke = ot.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "@hello-pangea/dnd"
}) : poe;
var Cke = (({
  dimensionMarshal: e,
  focusMarshal: t,
  styleMarshal: n,
  getResponders: r,
  announce: i,
  autoScroller: o
}) => foe(ALe, _ke(uMe(XLe(n), bke(e), YLe(e), nke, mke, yke, Eke, wke(o), ske, xke(t), hke(r, i)))));
const Az = () => ({
  additions: {},
  removals: {},
  modified: {}
});
function Rke({
  registry: e,
  callbacks: t
}) {
  let n = Az(), r = null;
  const i = () => {
    r || (t.collectionStarting(), r = requestAnimationFrame(() => {
      r = null;
      const {
        additions: f,
        removals: p,
        modified: m
      } = n, v = Object.keys(f).map((E) => e.draggable.getById(E).getDimension(Go)).sort((E, w) => E.descriptor.index - w.descriptor.index), y = Object.keys(m).map((E) => {
        const _ = e.droppable.getById(E).callbacks.getScrollWhileDragging();
        return {
          droppableId: E,
          scroll: _
        };
      }), S = {
        additions: v,
        removals: Object.keys(p),
        modified: y
      };
      n = Az(), t.publish(S);
    }));
  };
  return {
    add: (f) => {
      const p = f.descriptor.id;
      n.additions[p] = f, n.modified[f.descriptor.droppableId] = !0, n.removals[p] && delete n.removals[p], i();
    },
    remove: (f) => {
      const p = f.descriptor;
      n.removals[p.id] = !0, n.modified[p.droppableId] = !0, n.additions[p.id] && delete n.additions[p.id], i();
    },
    stop: () => {
      r && (cancelAnimationFrame(r), r = null, n = Az());
    }
  };
}
var Joe = (({
  scrollHeight: e,
  scrollWidth: t,
  height: n,
  width: r
}) => {
  const i = Il({
    x: t,
    y: e
  }, {
    x: r,
    y: n
  });
  return {
    x: Math.max(0, i.x),
    y: Math.max(0, i.y)
  };
}), eae = (() => {
  const e = document.documentElement;
  return e || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot find document.documentElement") : Ae()), e;
}), tae = (() => {
  const e = eae();
  return Joe({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
}), Oke = (() => {
  const e = Qoe(), t = tae(), n = e.y, r = e.x, i = eae(), o = i.clientWidth, s = i.clientHeight, u = r + o, f = n + s;
  return {
    frame: Ru({
      top: n,
      left: r,
      right: u,
      bottom: f
    }),
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Go,
        displacement: Go
      }
    }
  };
}), Ake = (({
  critical: e,
  scrollOptions: t,
  registry: n
}) => {
  const r = Oke(), i = r.scroll.current, o = e.droppable, s = n.droppable.getAllByType(o.type).map((m) => m.callbacks.getDimensionAndWatchScroll(i, t)), u = n.draggable.getAllByType(e.draggable.type).map((m) => m.getDimension(i));
  return {
    dimensions: {
      draggables: Aoe(u),
      droppables: Ooe(s)
    },
    critical: e,
    viewport: r
  };
});
function NY(e, t, n) {
  return n.descriptor.id === t.id || n.descriptor.type !== t.type ? !1 : e.droppable.getById(n.descriptor.droppableId).descriptor.mode !== "virtual" ? (ot.NODE_ENV !== "production" && si(`
      You are attempting to add or remove a Draggable [id: ${n.descriptor.id}]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/hello-pangea/dnd/blob/main/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var Dke = ((e, t) => {
  let n = null;
  const r = Rke({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), i = (y, S) => {
    e.droppable.exists(y) || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot update is enabled flag of Droppable ${y} as it is not registered`) : Ae()), n && t.updateDroppableIsEnabled({
      id: y,
      isEnabled: S
    });
  }, o = (y, S) => {
    n && (e.droppable.exists(y) || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot update isCombineEnabled flag of Droppable ${y} as it is not registered`) : Ae()), t.updateDroppableIsCombineEnabled({
      id: y,
      isCombineEnabled: S
    }));
  }, s = (y, S) => {
    n && (e.droppable.exists(y) || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot update the scroll on Droppable ${y} as it is not registered`) : Ae()), t.updateDroppableScroll({
      id: y,
      newScroll: S
    }));
  }, u = (y, S) => {
    n && e.droppable.getById(y).callbacks.scroll(S);
  }, f = () => {
    if (!n)
      return;
    r.stop();
    const y = n.critical.droppable;
    e.droppable.getAllByType(y.type).forEach((S) => S.callbacks.dragStopped()), n.unsubscribe(), n = null;
  }, p = (y) => {
    n || (ot.NODE_ENV !== "production" ? Ae(!1, "Should only be subscribed when a collection is occurring") : Ae());
    const S = n.critical.draggable;
    y.type === "ADDITION" && NY(e, S, y.value) && r.add(y.value), y.type === "REMOVAL" && NY(e, S, y.value) && r.remove(y.value);
  };
  return {
    updateDroppableIsEnabled: i,
    updateDroppableIsCombineEnabled: o,
    scrollDroppable: u,
    updateDroppableScroll: s,
    startPublishing: (y) => {
      n && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot start capturing critical dimensions as there is already a collection") : Ae());
      const S = e.draggable.getById(y.draggableId), E = e.droppable.getById(S.descriptor.droppableId), w = {
        draggable: S.descriptor,
        droppable: E.descriptor
      }, _ = e.subscribe(p);
      return n = {
        critical: w,
        unsubscribe: _
      }, Ake({
        critical: w,
        registry: e,
        scrollOptions: y.scrollOptions
      });
    },
    stopPublishing: f
  };
}), nae = ((e, t) => e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP"), Ike = ((e) => {
  window.scrollBy(e.x, e.y);
});
const Pke = $o((e) => RI(e).filter((t) => !(!t.isEnabled || !t.frame))), Nke = (e, t) => Pke(t).find((r) => (r.frame || (ot.NODE_ENV !== "production" ? Ae(!1, "Invalid result") : Ae()), Boe(r.frame.pageMarginBox)(e))) || null;
var Mke = (({
  center: e,
  destination: t,
  droppables: n
}) => {
  if (t) {
    const i = n[t];
    return i.frame ? i : null;
  }
  return Nke(e, n);
});
const y1 = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: (e) => e ** 2,
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  },
  disabled: !1
};
var jke = ((e, t, n = () => y1) => {
  const r = n(), i = e[t.size] * r.startFromPercentage, o = e[t.size] * r.maxScrollAtPercentage;
  return {
    startScrollingFrom: i,
    maxScrollValueAt: o
  };
}), rae = (({
  startOfRange: e,
  endOfRange: t,
  current: n
}) => {
  const r = t - e;
  return r === 0 ? (ot.NODE_ENV !== "production" && si(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0) : (n - e) / r;
}), nW = 1, Lke = ((e, t, n = () => y1) => {
  const r = n();
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return r.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return nW;
  const o = 1 - rae({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), s = r.maxPixelScroll * r.ease(o);
  return Math.ceil(s);
}), kke = ((e, t, n) => {
  const r = n(), i = r.durationDampening.accelerateAt, o = r.durationDampening.stopDampeningAt, s = t, u = o, p = Date.now() - s;
  if (p >= o)
    return e;
  if (p < i)
    return nW;
  const m = rae({
    startOfRange: i,
    endOfRange: u,
    current: p
  }), v = e * r.ease(m);
  return Math.ceil(v);
}), MY = (({
  distanceToEdge: e,
  thresholds: t,
  dragStartTime: n,
  shouldUseTimeDampening: r,
  getAutoScrollerOptions: i
}) => {
  const o = Lke(e, t, i);
  return o === 0 ? 0 : r ? Math.max(kke(o, n, i), nW) : o;
}), jY = (({
  container: e,
  distanceToEdges: t,
  dragStartTime: n,
  axis: r,
  shouldUseTimeDampening: i,
  getAutoScrollerOptions: o
}) => {
  const s = jke(e, r, o);
  return t[r.end] < t[r.start] ? MY({
    distanceToEdge: t[r.end],
    thresholds: s,
    dragStartTime: n,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  }) : -1 * MY({
    distanceToEdge: t[r.start],
    thresholds: s,
    dragStartTime: n,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  });
}), zke = (({
  container: e,
  subject: t,
  proposedScroll: n
}) => {
  const r = t.height > e.height, i = t.width > e.width;
  return !i && !r ? n : i && r ? null : {
    x: i ? 0 : n.x,
    y: r ? 0 : n.y
  };
});
const Bke = Roe((e) => e === 0 ? 0 : e);
var iae = (({
  dragStartTime: e,
  container: t,
  subject: n,
  center: r,
  shouldUseTimeDampening: i,
  getAutoScrollerOptions: o
}) => {
  const s = {
    top: r.y - t.top,
    right: t.right - r.x,
    bottom: t.bottom - r.y,
    left: r.x - t.left
  }, u = jY({
    container: t,
    distanceToEdges: s,
    dragStartTime: e,
    axis: YF,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  }), f = jY({
    container: t,
    distanceToEdges: s,
    dragStartTime: e,
    axis: Poe,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  }), p = Bke({
    x: f,
    y: u
  });
  if (rg(p, Go))
    return null;
  const m = zke({
    container: t,
    subject: n,
    proposedScroll: p
  });
  return m ? rg(m, Go) ? null : m : null;
});
const Vke = Roe((e) => e === 0 ? 0 : e > 0 ? 1 : -1), rW = /* @__PURE__ */ (() => {
  const e = (t, n) => t < 0 ? t : t > n ? t - n : 0;
  return ({
    current: t,
    max: n,
    change: r
  }) => {
    const i = da(t, r), o = {
      x: e(i.x, n.x),
      y: e(i.y, n.y)
    };
    return rg(o, Go) ? null : o;
  };
})(), oae = ({
  max: e,
  current: t,
  change: n
}) => {
  const r = {
    x: Math.max(t.x, e.x),
    y: Math.max(t.y, e.y)
  }, i = Vke(n), o = rW({
    max: r,
    current: t,
    change: i
  });
  return !o || i.x !== 0 && o.x === 0 || i.y !== 0 && o.y === 0;
}, iW = (e, t) => oae({
  current: e.scroll.current,
  max: e.scroll.max,
  change: t
}), Uke = (e, t) => {
  if (!iW(e, t))
    return null;
  const n = e.scroll.max, r = e.scroll.current;
  return rW({
    current: r,
    max: n,
    change: t
  });
}, oW = (e, t) => {
  const n = e.frame;
  return n ? oae({
    current: n.scroll.current,
    max: n.scroll.max,
    change: t
  }) : !1;
}, Fke = (e, t) => {
  const n = e.frame;
  return !n || !oW(e, t) ? null : rW({
    current: n.scroll.current,
    max: n.scroll.max,
    change: t
  });
};
var Wke = (({
  viewport: e,
  subject: t,
  center: n,
  dragStartTime: r,
  shouldUseTimeDampening: i,
  getAutoScrollerOptions: o
}) => {
  const s = iae({
    dragStartTime: r,
    container: e.frame,
    subject: t,
    center: n,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  });
  return s && iW(e, s) ? s : null;
}), Hke = (({
  droppable: e,
  subject: t,
  center: n,
  dragStartTime: r,
  shouldUseTimeDampening: i,
  getAutoScrollerOptions: o
}) => {
  const s = e.frame;
  if (!s)
    return null;
  const u = iae({
    dragStartTime: r,
    container: s.pageMarginBox,
    subject: t,
    center: n,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  });
  return u && oW(e, u) ? u : null;
}), LY = (({
  state: e,
  dragStartTime: t,
  shouldUseTimeDampening: n,
  scrollWindow: r,
  scrollDroppable: i,
  getAutoScrollerOptions: o
}) => {
  const s = e.current.page.borderBoxCenter, f = e.dimensions.draggables[e.critical.draggable.id].page.marginBox;
  if (e.isWindowScrollAllowed) {
    const v = e.viewport, y = Wke({
      dragStartTime: t,
      viewport: v,
      subject: f,
      center: s,
      shouldUseTimeDampening: n,
      getAutoScrollerOptions: o
    });
    if (y) {
      r(y);
      return;
    }
  }
  const p = Mke({
    center: s,
    destination: Nl(e.impact),
    droppables: e.dimensions.droppables
  });
  if (!p)
    return;
  const m = Hke({
    dragStartTime: t,
    droppable: p,
    subject: f,
    center: s,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  });
  m && i(p.descriptor.id, m);
}), qke = (({
  scrollWindow: e,
  scrollDroppable: t,
  getAutoScrollerOptions: n = () => y1
}) => {
  const r = f1(e), i = f1(t);
  let o = null;
  const s = (p) => {
    o || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot fluid scroll if not dragging") : Ae());
    const {
      shouldUseTimeDampening: m,
      dragStartTime: v
    } = o;
    LY({
      state: p,
      scrollWindow: r,
      scrollDroppable: i,
      dragStartTime: v,
      shouldUseTimeDampening: m,
      getAutoScrollerOptions: n
    });
  };
  return {
    start: (p) => {
      o && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot start auto scrolling when already started") : Ae());
      const m = Date.now();
      let v = !1;
      const y = () => {
        v = !0;
      };
      LY({
        state: p,
        dragStartTime: 0,
        shouldUseTimeDampening: !1,
        scrollWindow: y,
        scrollDroppable: y,
        getAutoScrollerOptions: n
      }), o = {
        dragStartTime: m,
        shouldUseTimeDampening: v
      }, v && s(p);
    },
    stop: () => {
      o && (r.cancel(), i.cancel(), o = null);
    },
    scroll: s
  };
}), $ke = (({
  move: e,
  scrollDroppable: t,
  scrollWindow: n
}) => {
  const r = (u, f) => {
    const p = da(u.current.client.selection, f);
    e({
      client: p
    });
  }, i = (u, f) => {
    if (!oW(u, f))
      return f;
    const p = Fke(u, f);
    if (!p)
      return t(u.descriptor.id, f), null;
    const m = Il(f, p);
    return t(u.descriptor.id, m), Il(f, m);
  }, o = (u, f, p) => {
    if (!u || !iW(f, p))
      return p;
    const m = Uke(f, p);
    if (!m)
      return n(p), null;
    const v = Il(p, m);
    return n(v), Il(p, v);
  };
  return (u) => {
    const f = u.scrollJumpRequest;
    if (!f)
      return;
    const p = Nl(u.impact);
    p || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot perform a jump scroll when there is no destination") : Ae());
    const m = i(u.dimensions.droppables[p], f);
    if (!m)
      return;
    const v = u.viewport, y = o(u.isWindowScrollAllowed, v, m);
    y && r(u, y);
  };
}), Gke = (({
  scrollDroppable: e,
  scrollWindow: t,
  move: n,
  getAutoScrollerOptions: r
}) => {
  const i = qke({
    scrollWindow: t,
    scrollDroppable: e,
    getAutoScrollerOptions: r
  }), o = $ke({
    move: n,
    scrollWindow: t,
    scrollDroppable: e
  });
  return {
    scroll: (f) => {
      if (!(r().disabled || f.phase !== "DRAGGING")) {
        if (f.movementMode === "FLUID") {
          i.scroll(f);
          return;
        }
        f.scrollJumpRequest && o(f);
      }
    },
    start: i.start,
    stop: i.stop
  };
});
const mx = "data-rfd", vx = (() => {
  const e = `${mx}-drag-handle`;
  return {
    base: e,
    draggableId: `${e}-draggable-id`,
    contextId: `${e}-context-id`
  };
})(), bV = (() => {
  const e = `${mx}-draggable`;
  return {
    base: e,
    contextId: `${e}-context-id`,
    id: `${e}-id`
  };
})(), Yke = (() => {
  const e = `${mx}-droppable`;
  return {
    base: e,
    contextId: `${e}-context-id`,
    id: `${e}-id`
  };
})(), kY = {
  contextId: `${mx}-scroll-container-context-id`
}, Xke = (e) => (t) => `[${t}="${e}"]`, fE = (e, t) => e.map((n) => {
  const r = n.styles[t];
  return r ? `${n.selector} { ${r} }` : "";
}).join(" "), Zke = "pointer-events: none;";
var Kke = ((e) => {
  const t = Xke(e), n = (() => {
    const u = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(vx.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: u,
        dragging: Zke,
        dropAnimating: u
      }
    };
  })(), r = (() => {
    const u = `
      transition: ${WE.outOfTheWay};
    `;
    return {
      selector: t(bV.contextId),
      styles: {
        dragging: u,
        dropAnimating: u,
        userCancel: u
      }
    };
  })(), i = {
    selector: t(Yke.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, s = [r, n, i, {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }];
  return {
    always: fE(s, "always"),
    resting: fE(s, "resting"),
    dragging: fE(s, "dragging"),
    dropAnimating: fE(s, "dropAnimating"),
    userCancel: fE(s, "userCancel")
  };
});
const Qke = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? bJ : ln;
var Ml = Qke;
const Dz = () => {
  const e = document.querySelector("head");
  return e || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot find the head to append a style to") : Ae()), e;
}, zY = (e) => {
  const t = document.createElement("style");
  return e && t.setAttribute("nonce", e), t.type = "text/css", t;
};
function Jke(e, t) {
  const n = tr(() => Kke(e), [e]), r = an(null), i = an(null), o = rn($o((v) => {
    const y = i.current;
    y || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot set dynamic style element if it is not set") : Ae()), y.textContent = v;
  }), []), s = rn((v) => {
    const y = r.current;
    y || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot set dynamic style element if it is not set") : Ae()), y.textContent = v;
  }, []);
  Ml(() => {
    !r.current && !i.current || (ot.NODE_ENV !== "production" ? Ae(!1, "style elements already mounted") : Ae());
    const v = zY(t), y = zY(t);
    return r.current = v, i.current = y, v.setAttribute(`${mx}-always`, e), y.setAttribute(`${mx}-dynamic`, e), Dz().appendChild(v), Dz().appendChild(y), s(n.always), o(n.resting), () => {
      const S = (E) => {
        const w = E.current;
        w || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot unmount ref as it is not set") : Ae()), Dz().removeChild(w), E.current = null;
      };
      S(r), S(i);
    };
  }, [t, s, o, n.always, n.resting, e]);
  const u = rn(() => o(n.dragging), [o, n.dragging]), f = rn((v) => {
    if (v === "DROP") {
      o(n.dropAnimating);
      return;
    }
    o(n.userCancel);
  }, [o, n.dropAnimating, n.userCancel]), p = rn(() => {
    i.current && o(n.resting);
  }, [o, n.resting]);
  return tr(() => ({
    dragging: u,
    dropping: f,
    resting: p
  }), [u, f, p]);
}
function aae(e, t) {
  return Array.from(e.querySelectorAll(t));
}
var sae = ((e) => e && e.ownerDocument && e.ownerDocument.defaultView ? e.ownerDocument.defaultView : window);
function __(e) {
  return e instanceof sae(e).HTMLElement;
}
function lae(e, t) {
  const n = `[${vx.contextId}="${e}"]`, r = aae(document, n);
  if (!r.length)
    return ot.NODE_ENV !== "production" && si(`Unable to find any drag handles in the context "${e}"`), null;
  const i = r.find((o) => o.getAttribute(vx.draggableId) === t);
  return i ? __(i) ? i : (ot.NODE_ENV !== "production" && si("drag handle needs to be a HTMLElement"), null) : (ot.NODE_ENV !== "production" && si(`Unable to find drag handle with id "${t}" as no handle with a matching id was found`), null);
}
function eze(e) {
  const t = an({}), n = an(null), r = an(null), i = an(!1), o = rn(function(y, S) {
    const E = {
      id: y,
      focus: S
    };
    return t.current[y] = E, function() {
      const _ = t.current;
      _[y] !== E && delete _[y];
    };
  }, []), s = rn(function(y) {
    const S = lae(e, y);
    S && S !== document.activeElement && S.focus();
  }, [e]), u = rn(function(y, S) {
    n.current === y && (n.current = S);
  }, []), f = rn(function() {
    r.current || i.current && (r.current = requestAnimationFrame(() => {
      r.current = null;
      const y = n.current;
      y && s(y);
    }));
  }, [s]), p = rn(function(y) {
    n.current = null;
    const S = document.activeElement;
    S && S.getAttribute(vx.draggableId) === y && (n.current = y);
  }, []);
  return Ml(() => (i.current = !0, function() {
    i.current = !1;
    const y = r.current;
    y && cancelAnimationFrame(y);
  }), []), tr(() => ({
    register: o,
    tryRecordFocus: p,
    tryRestoreFocusRecorded: f,
    tryShiftRecord: u
  }), [o, p, f, u]);
}
function tze() {
  const e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function n(v) {
    return t.push(v), function() {
      const S = t.indexOf(v);
      S !== -1 && t.splice(S, 1);
    };
  }
  function r(v) {
    t.length && t.forEach((y) => y(v));
  }
  function i(v) {
    return e.draggables[v] || null;
  }
  function o(v) {
    const y = i(v);
    return y || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot find draggable entry with id [${v}]`) : Ae()), y;
  }
  const s = {
    register: (v) => {
      e.draggables[v.descriptor.id] = v, r({
        type: "ADDITION",
        value: v
      });
    },
    update: (v, y) => {
      const S = e.draggables[y.descriptor.id];
      S && S.uniqueId === v.uniqueId && (delete e.draggables[y.descriptor.id], e.draggables[v.descriptor.id] = v);
    },
    unregister: (v) => {
      const y = v.descriptor.id, S = i(y);
      S && v.uniqueId === S.uniqueId && (delete e.draggables[y], e.droppables[v.descriptor.droppableId] && r({
        type: "REMOVAL",
        value: v
      }));
    },
    getById: o,
    findById: i,
    exists: (v) => !!i(v),
    getAllByType: (v) => Object.values(e.draggables).filter((y) => y.descriptor.type === v)
  };
  function u(v) {
    return e.droppables[v] || null;
  }
  function f(v) {
    const y = u(v);
    return y || (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot find droppable entry with id [${v}]`) : Ae()), y;
  }
  const p = {
    register: (v) => {
      e.droppables[v.descriptor.id] = v;
    },
    unregister: (v) => {
      const y = u(v.descriptor.id);
      y && v.uniqueId === y.uniqueId && delete e.droppables[v.descriptor.id];
    },
    getById: f,
    findById: u,
    exists: (v) => !!u(v),
    getAllByType: (v) => Object.values(e.droppables).filter((y) => y.descriptor.type === v)
  };
  function m() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: s,
    droppable: p,
    subscribe: n,
    clean: m
  };
}
function nze() {
  const e = tr(tze, []);
  return ln(() => function() {
    it.version.startsWith("16") || it.version.startsWith("17") ? requestAnimationFrame(e.clean) : e.clean();
  }, [e]), e;
}
var aW = it.createContext(null), b1 = (() => {
  const e = document.body;
  return e || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot find document.body") : Ae()), e;
});
const rze = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
};
var ize = rze;
const oze = (e) => `rfd-announcement-${e}`;
function aze(e) {
  const t = tr(() => oze(e), [e]), n = an(null);
  return ln(function() {
    const o = document.createElement("div");
    return n.current = o, o.id = t, o.setAttribute("aria-live", "assertive"), o.setAttribute("aria-atomic", "true"), $t(o.style, ize), b1().appendChild(o), function() {
      setTimeout(function() {
        const f = b1();
        f.contains(o) && f.removeChild(o), o === n.current && (n.current = null);
      });
    };
  }, [t]), rn((i) => {
    const o = n.current;
    if (o) {
      o.textContent = i;
      return;
    }
    ot.NODE_ENV !== "production" && si(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "${i}"
    `);
  }, []);
}
let sze = 0;
const cae = {
  separator: "::"
};
function lze(e, t = cae) {
  return tr(() => `${e}${t.separator}${sze++}`, [t.separator, e]);
}
function cze(e, t = cae) {
  const n = it.useId();
  return tr(() => `${e}${t.separator}${n}`, [t.separator, e, n]);
}
var sW = "useId" in it ? cze : lze;
function uze({
  contextId: e,
  uniqueId: t
}) {
  return `rfd-hidden-text-${e}-${t}`;
}
function dze({
  contextId: e,
  text: t
}) {
  const n = sW("hidden-text", {
    separator: "-"
  }), r = tr(() => uze({
    contextId: e,
    uniqueId: n
  }), [n, e]);
  return ln(function() {
    const o = document.createElement("div");
    return o.id = r, o.textContent = t, o.style.display = "none", b1().appendChild(o), function() {
      const u = b1();
      u.contains(o) && u.removeChild(o);
    };
  }, [r, t]), r;
}
var II = it.createContext(null), fze = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
const pze = /(\d+)\.(\d+)\.(\d+)/, BY = (e) => {
  const t = pze.exec(e);
  t == null && (ot.NODE_ENV !== "production" ? Ae(!1, `Unable to parse React version ${e}`) : Ae());
  const n = Number(t[1]), r = Number(t[2]), i = Number(t[3]);
  return {
    major: n,
    minor: r,
    patch: i,
    raw: e
  };
}, hze = (e, t) => t.major > e.major ? !0 : t.major < e.major ? !1 : t.minor > e.minor ? !0 : t.minor < e.minor ? !1 : t.patch >= e.patch;
var gze = ((e, t) => {
  const n = BY(e), r = BY(t);
  hze(n, r) || ot.NODE_ENV !== "production" && si(`
    React version: [${r.raw}]
    does not satisfy expected peer dependency version: [${n.raw}]

    This can result in run time bugs, and even fatal crashes
  `);
});
const Iz = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var mze = ((e) => {
  const t = e.doctype;
  if (!t) {
    ot.NODE_ENV !== "production" && si(`
      No <!doctype html> found.

      ${Iz}
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && ot.NODE_ENV !== "production" && si(`
      Unexpected <!doctype> found: (${t.name})

      ${Iz}
    `), t.publicId !== "" && ot.NODE_ENV !== "production" && si(`
      Unexpected <!doctype> publicId found: (${t.publicId})
      A html5 doctype does not have a publicId

      ${Iz}
    `);
});
function lW(e) {
  ot.NODE_ENV !== "production" && e();
}
function C_(e, t) {
  lW(() => {
    ln(() => {
      try {
        e();
      } catch (n) {
        hV(`
          A setup problem was encountered.

          > ${n.message}
        `);
      }
    }, t);
  });
}
function vze() {
  C_(() => {
    gze(fze.react, it.version), mze(document);
  }, []);
}
function cW(e) {
  const t = an(e);
  return ln(() => {
    t.current = e;
  }), t;
}
function yze() {
  let e = null;
  function t() {
    return !!e;
  }
  function n(s) {
    return s === e;
  }
  function r(s) {
    e && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot claim lock as it is already claimed") : Ae());
    const u = {
      abandon: s
    };
    return e = u, u;
  }
  function i() {
    e || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot release lock when there is no lock") : Ae()), e = null;
  }
  function o() {
    e && (e.abandon(), i());
  }
  return {
    isClaimed: t,
    isActive: n,
    claim: r,
    release: i,
    tryAbandon: o
  };
}
function x1(e) {
  return e.phase === "IDLE" || e.phase === "DROP_ANIMATING" ? !1 : e.isDragging;
}
const bze = 9, xze = 13, uW = 27, uae = 32, Sze = 33, wze = 34, Tze = 35, Eze = 36, _ze = 37, Cze = 38, Rze = 39, Oze = 40, Aze = {
  [xze]: !0,
  [bze]: !0
};
var dae = ((e) => {
  Aze[e.keyCode] && e.preventDefault();
});
const Dze = (() => {
  const e = "visibilitychange";
  return typeof document > "u" ? e : [e, `ms${e}`, `webkit${e}`, `moz${e}`, `o${e}`].find((r) => `on${r}` in document) || e;
})();
var PI = Dze;
const fae = 0, VY = 5;
function Ize(e, t) {
  return Math.abs(t.x - e.x) >= VY || Math.abs(t.y - e.y) >= VY;
}
const UY = {
  type: "IDLE"
};
function Pze({
  cancel: e,
  completed: t,
  getPhase: n,
  setPhase: r
}) {
  return [{
    eventName: "mousemove",
    fn: (i) => {
      const {
        button: o,
        clientX: s,
        clientY: u
      } = i;
      if (o !== fae)
        return;
      const f = {
        x: s,
        y: u
      }, p = n();
      if (p.type === "DRAGGING") {
        i.preventDefault(), p.actions.move(f);
        return;
      }
      p.type !== "PENDING" && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot be IDLE") : Ae());
      const m = p.point;
      if (!Ize(m, f))
        return;
      i.preventDefault();
      const v = p.actions.fluidLift(f);
      r({
        type: "DRAGGING",
        actions: v
      });
    }
  }, {
    eventName: "mouseup",
    fn: (i) => {
      const o = n();
      if (o.type !== "DRAGGING") {
        e();
        return;
      }
      i.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), t();
    }
  }, {
    eventName: "mousedown",
    fn: (i) => {
      n().type === "DRAGGING" && i.preventDefault(), e();
    }
  }, {
    eventName: "keydown",
    fn: (i) => {
      if (n().type === "PENDING") {
        e();
        return;
      }
      if (i.keyCode === uW) {
        i.preventDefault(), e();
        return;
      }
      dae(i);
    }
  }, {
    eventName: "resize",
    fn: e
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: () => {
      n().type === "PENDING" && e();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: (i) => {
      const o = n();
      if (o.type === "IDLE" && (ot.NODE_ENV !== "production" ? Ae(!1, "Unexpected phase") : Ae()), o.actions.shouldRespectForcePress()) {
        e();
        return;
      }
      i.preventDefault();
    }
  }, {
    eventName: PI,
    fn: e
  }];
}
function Nze(e) {
  const t = an(UY), n = an(ng), r = tr(() => ({
    eventName: "mousedown",
    fn: function(v) {
      if (v.defaultPrevented || v.button !== fae || v.ctrlKey || v.metaKey || v.shiftKey || v.altKey)
        return;
      const y = e.findClosestDraggableId(v);
      if (!y)
        return;
      const S = e.tryGetLock(y, s, {
        sourceEvent: v
      });
      if (!S)
        return;
      v.preventDefault();
      const E = {
        x: v.clientX,
        y: v.clientY
      };
      n.current(), p(S, E);
    }
  }), [e]), i = tr(() => ({
    eventName: "webkitmouseforcewillbegin",
    fn: (m) => {
      if (m.defaultPrevented)
        return;
      const v = e.findClosestDraggableId(m);
      if (!v)
        return;
      const y = e.findOptionsForDraggable(v);
      y && (y.shouldRespectForcePress || e.canGetLock(v) && m.preventDefault());
    }
  }), [e]), o = rn(function() {
    const v = {
      passive: !1,
      capture: !0
    };
    n.current = Oc(window, [i, r], v);
  }, [i, r]), s = rn(() => {
    t.current.type !== "IDLE" && (t.current = UY, n.current(), o());
  }, [o]), u = rn(() => {
    const m = t.current;
    s(), m.type === "DRAGGING" && m.actions.cancel({
      shouldBlockNextClick: !0
    }), m.type === "PENDING" && m.actions.abort();
  }, [s]), f = rn(function() {
    const v = {
      capture: !0,
      passive: !1
    }, y = Pze({
      cancel: u,
      completed: s,
      getPhase: () => t.current,
      setPhase: (S) => {
        t.current = S;
      }
    });
    n.current = Oc(window, y, v);
  }, [u, s]), p = rn(function(v, y) {
    t.current.type !== "IDLE" && (ot.NODE_ENV !== "production" ? Ae(!1, "Expected to move from IDLE to PENDING drag") : Ae()), t.current = {
      type: "PENDING",
      point: y,
      actions: v
    }, f();
  }, [f]);
  Ml(function() {
    return o(), function() {
      n.current();
    };
  }, [o]);
}
function Mze() {
}
const jze = {
  [wze]: !0,
  [Sze]: !0,
  [Eze]: !0,
  [Tze]: !0
};
function Lze(e, t) {
  function n() {
    t(), e.cancel();
  }
  function r() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: (i) => {
      if (i.keyCode === uW) {
        i.preventDefault(), n();
        return;
      }
      if (i.keyCode === uae) {
        i.preventDefault(), r();
        return;
      }
      if (i.keyCode === Oze) {
        i.preventDefault(), e.moveDown();
        return;
      }
      if (i.keyCode === Cze) {
        i.preventDefault(), e.moveUp();
        return;
      }
      if (i.keyCode === Rze) {
        i.preventDefault(), e.moveRight();
        return;
      }
      if (i.keyCode === _ze) {
        i.preventDefault(), e.moveLeft();
        return;
      }
      if (jze[i.keyCode]) {
        i.preventDefault();
        return;
      }
      dae(i);
    }
  }, {
    eventName: "mousedown",
    fn: n
  }, {
    eventName: "mouseup",
    fn: n
  }, {
    eventName: "click",
    fn: n
  }, {
    eventName: "touchstart",
    fn: n
  }, {
    eventName: "resize",
    fn: n
  }, {
    eventName: "wheel",
    fn: n,
    options: {
      passive: !0
    }
  }, {
    eventName: PI,
    fn: n
  }];
}
function kze(e) {
  const t = an(Mze), n = tr(() => ({
    eventName: "keydown",
    fn: function(o) {
      if (o.defaultPrevented || o.keyCode !== uae)
        return;
      const s = e.findClosestDraggableId(o);
      if (!s)
        return;
      const u = e.tryGetLock(s, m, {
        sourceEvent: o
      });
      if (!u)
        return;
      o.preventDefault();
      let f = !0;
      const p = u.snapLift();
      t.current();
      function m() {
        f || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot stop capturing a keyboard drag when not capturing") : Ae()), f = !1, t.current(), r();
      }
      t.current = Oc(window, Lze(p, m), {
        capture: !0,
        passive: !1
      });
    }
  }), [e]), r = rn(function() {
    const o = {
      passive: !1,
      capture: !0
    };
    t.current = Oc(window, [n], o);
  }, [n]);
  Ml(function() {
    return r(), function() {
      t.current();
    };
  }, [r]);
}
const Pz = {
  type: "IDLE"
}, zze = 120, Bze = 0.15;
function Vze({
  cancel: e,
  getPhase: t
}) {
  return [{
    eventName: "orientationchange",
    fn: e
  }, {
    eventName: "resize",
    fn: e
  }, {
    eventName: "contextmenu",
    fn: (n) => {
      n.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: (n) => {
      if (t().type !== "DRAGGING") {
        e();
        return;
      }
      n.keyCode === uW && n.preventDefault(), e();
    }
  }, {
    eventName: PI,
    fn: e
  }];
}
function Uze({
  cancel: e,
  completed: t,
  getPhase: n
}) {
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: (r) => {
      const i = n();
      if (i.type !== "DRAGGING") {
        e();
        return;
      }
      i.hasMoved = !0;
      const {
        clientX: o,
        clientY: s
      } = r.touches[0], u = {
        x: o,
        y: s
      };
      r.preventDefault(), i.actions.move(u);
    }
  }, {
    eventName: "touchend",
    fn: (r) => {
      const i = n();
      if (i.type !== "DRAGGING") {
        e();
        return;
      }
      r.preventDefault(), i.actions.drop({
        shouldBlockNextClick: !0
      }), t();
    }
  }, {
    eventName: "touchcancel",
    fn: (r) => {
      if (n().type !== "DRAGGING") {
        e();
        return;
      }
      r.preventDefault(), e();
    }
  }, {
    eventName: "touchforcechange",
    fn: (r) => {
      const i = n();
      i.type === "IDLE" && (ot.NODE_ENV, Ae());
      const o = r.touches[0];
      if (!o || !(o.force >= Bze))
        return;
      const u = i.actions.shouldRespectForcePress();
      if (i.type === "PENDING") {
        u && e();
        return;
      }
      if (u) {
        if (i.hasMoved) {
          r.preventDefault();
          return;
        }
        e();
        return;
      }
      r.preventDefault();
    }
  }, {
    eventName: PI,
    fn: e
  }];
}
function Fze(e) {
  const t = an(Pz), n = an(ng), r = rn(function() {
    return t.current;
  }, []), i = rn(function(S) {
    t.current = S;
  }, []), o = tr(() => ({
    eventName: "touchstart",
    fn: function(S) {
      if (S.defaultPrevented)
        return;
      const E = e.findClosestDraggableId(S);
      if (!E)
        return;
      const w = e.tryGetLock(E, u, {
        sourceEvent: S
      });
      if (!w)
        return;
      const _ = S.touches[0], {
        clientX: O,
        clientY: D
      } = _, P = {
        x: O,
        y: D
      };
      n.current(), v(w, P);
    }
  }), [e]), s = rn(function() {
    const S = {
      capture: !0,
      passive: !1
    };
    n.current = Oc(window, [o], S);
  }, [o]), u = rn(() => {
    const y = t.current;
    y.type !== "IDLE" && (y.type === "PENDING" && clearTimeout(y.longPressTimerId), i(Pz), n.current(), s());
  }, [s, i]), f = rn(() => {
    const y = t.current;
    u(), y.type === "DRAGGING" && y.actions.cancel({
      shouldBlockNextClick: !0
    }), y.type === "PENDING" && y.actions.abort();
  }, [u]), p = rn(function() {
    const S = {
      capture: !0,
      passive: !1
    }, E = {
      cancel: f,
      completed: u,
      getPhase: r
    }, w = Oc(window, Uze(E), S), _ = Oc(window, Vze(E), S);
    n.current = function() {
      w(), _();
    };
  }, [f, r, u]), m = rn(function() {
    const S = r();
    S.type !== "PENDING" && (ot.NODE_ENV !== "production" ? Ae(!1, `Cannot start dragging from phase ${S.type}`) : Ae());
    const E = S.actions.fluidLift(S.point);
    i({
      type: "DRAGGING",
      actions: E,
      hasMoved: !1
    });
  }, [r, i]), v = rn(function(S, E) {
    r().type !== "IDLE" && (ot.NODE_ENV !== "production" ? Ae(!1, "Expected to move from IDLE to PENDING drag") : Ae());
    const w = setTimeout(m, zze);
    i({
      type: "PENDING",
      point: E,
      actions: S,
      longPressTimerId: w
    }), p();
  }, [p, r, i, m]);
  Ml(function() {
    return s(), function() {
      n.current();
      const E = r();
      E.type === "PENDING" && (clearTimeout(E.longPressTimerId), i(Pz));
    };
  }, [r, s, i]), Ml(function() {
    return Oc(window, [{
      eventName: "touchmove",
      fn: () => {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
  }, []);
}
function Wze(e) {
  lW(() => {
    const t = cW(e);
    C_(() => {
      t.current.length !== e.length && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot change the amount of sensor hooks after mounting") : Ae(!1));
    });
  });
}
const Hze = ["input", "button", "textarea", "select", "option", "optgroup", "video", "audio"];
function pae(e, t) {
  if (t == null)
    return !1;
  if (Hze.includes(t.tagName.toLowerCase()))
    return !0;
  const r = t.getAttribute("contenteditable");
  return r === "true" || r === "" ? !0 : t === e ? !1 : pae(e, t.parentElement);
}
function qze(e, t) {
  const n = t.target;
  return __(n) ? pae(e, n) : !1;
}
var $ze = ((e) => Ru(e.getBoundingClientRect()).center);
function Gze(e) {
  return e instanceof sae(e).Element;
}
const Yze = (() => {
  const e = "matches";
  return typeof document > "u" ? e : [e, "msMatchesSelector", "webkitMatchesSelector"].find((r) => r in Element.prototype) || e;
})();
function hae(e, t) {
  return e == null ? null : e[Yze](t) ? e : hae(e.parentElement, t);
}
function Xze(e, t) {
  return e.closest ? e.closest(t) : hae(e, t);
}
function Zze(e) {
  return `[${vx.contextId}="${e}"]`;
}
function Kze(e, t) {
  const n = t.target;
  if (!Gze(n))
    return ot.NODE_ENV !== "production" && si("event.target must be a Element"), null;
  const r = Zze(e), i = Xze(n, r);
  return i ? __(i) ? i : (ot.NODE_ENV !== "production" && si("drag handle must be a HTMLElement"), null) : null;
}
function Qze(e, t) {
  const n = Kze(e, t);
  return n ? n.getAttribute(vx.draggableId) : null;
}
function Jze(e, t) {
  const n = `[${bV.contextId}="${e}"]`, i = aae(document, n).find((o) => o.getAttribute(bV.id) === t);
  return i ? __(i) ? i : (ot.NODE_ENV !== "production" && si("Draggable element is not a HTMLElement"), null) : null;
}
function eBe(e) {
  e.preventDefault();
}
function hO({
  expected: e,
  phase: t,
  isLockActive: n,
  shouldWarn: r
}) {
  return n() ? e !== t ? (r && ot.NODE_ENV !== "production" && si(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ${e}
        You called an action from outdated phase: ${t}

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (r && ot.NODE_ENV !== "production" && si(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function gae({
  lockAPI: e,
  store: t,
  registry: n,
  draggableId: r
}) {
  if (e.isClaimed())
    return !1;
  const i = n.draggable.findById(r);
  return i ? !(!i.options.isEnabled || !nae(t.getState(), r)) : (ot.NODE_ENV !== "production" && si(`Unable to find draggable with id: ${r}`), !1);
}
function tBe({
  lockAPI: e,
  contextId: t,
  store: n,
  registry: r,
  draggableId: i,
  forceSensorStop: o,
  sourceEvent: s
}) {
  if (!gae({
    lockAPI: e,
    store: n,
    registry: r,
    draggableId: i
  }))
    return null;
  const f = r.draggable.getById(i), p = Jze(t, f.descriptor.id);
  if (!p)
    return ot.NODE_ENV !== "production" && si(`Unable to find draggable element with id: ${i}`), null;
  if (s && !f.options.canDragInteractiveElements && qze(p, s))
    return null;
  const m = e.claim(o || ng);
  let v = "PRE_DRAG";
  function y() {
    return f.options.shouldRespectForcePress;
  }
  function S() {
    return e.isActive(m);
  }
  function E(N, k) {
    hO({
      expected: N,
      phase: v,
      isLockActive: S,
      shouldWarn: !0
    }) && n.dispatch(k());
  }
  const w = E.bind(null, "DRAGGING");
  function _(N) {
    function k() {
      e.release(), v = "COMPLETED";
    }
    v !== "PRE_DRAG" && (k(), ot.NODE_ENV !== "production" ? Ae(!1, `Cannot lift in phase ${v}`) : Ae()), n.dispatch(ILe(N.liftActionArgs)), v = "DRAGGING";
    function U(H, Y = {
      shouldBlockNextClick: !1
    }) {
      if (N.cleanup(), Y.shouldBlockNextClick) {
        const z = Oc(window, [{
          eventName: "click",
          fn: eBe,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(z);
      }
      k(), n.dispatch(Yoe({
        reason: H
      }));
    }
    return {
      isActive: () => hO({
        expected: "DRAGGING",
        phase: v,
        isLockActive: S,
        shouldWarn: !1
      }),
      shouldRespectForcePress: y,
      drop: (H) => U("DROP", H),
      cancel: (H) => U("CANCEL", H),
      ...N.actions
    };
  }
  function O(N) {
    const k = f1((H) => {
      w(() => Goe({
        client: H
      }));
    });
    return {
      ..._({
        liftActionArgs: {
          id: i,
          clientSelection: N,
          movementMode: "FLUID"
        },
        cleanup: () => k.cancel(),
        actions: {
          move: k
        }
      }),
      move: k
    };
  }
  function D() {
    const N = {
      moveUp: () => w(VLe),
      moveRight: () => w(FLe),
      moveDown: () => w(ULe),
      moveLeft: () => w(WLe)
    };
    return _({
      liftActionArgs: {
        id: i,
        clientSelection: $ze(p),
        movementMode: "SNAP"
      },
      cleanup: ng,
      actions: N
    });
  }
  function P() {
    hO({
      expected: "PRE_DRAG",
      phase: v,
      isLockActive: S,
      shouldWarn: !0
    }) && e.release();
  }
  return {
    isActive: () => hO({
      expected: "PRE_DRAG",
      phase: v,
      isLockActive: S,
      shouldWarn: !1
    }),
    shouldRespectForcePress: y,
    fluidLift: O,
    snapLift: D,
    abort: P
  };
}
const nBe = [Nze, kze, Fze];
function rBe({
  contextId: e,
  store: t,
  registry: n,
  customSensors: r,
  enableDefaultSensors: i
}) {
  const o = [...i ? nBe : [], ...r || []], s = Bn(() => yze())[0], u = rn(function(_, O) {
    x1(_) && !x1(O) && s.tryAbandon();
  }, [s]);
  Ml(function() {
    let _ = t.getState();
    return t.subscribe(() => {
      const D = t.getState();
      u(_, D), _ = D;
    });
  }, [s, t, u]), Ml(() => s.tryAbandon, [s.tryAbandon]);
  const f = rn((w) => gae({
    lockAPI: s,
    registry: n,
    store: t,
    draggableId: w
  }), [s, n, t]), p = rn((w, _, O) => tBe({
    lockAPI: s,
    registry: n,
    contextId: e,
    store: t,
    draggableId: w,
    forceSensorStop: _ || null,
    sourceEvent: O && O.sourceEvent ? O.sourceEvent : null
  }), [e, s, n, t]), m = rn((w) => Qze(e, w), [e]), v = rn((w) => {
    const _ = n.draggable.findById(w);
    return _ ? _.options : null;
  }, [n.draggable]), y = rn(function() {
    s.isClaimed() && (s.tryAbandon(), t.getState().phase !== "IDLE" && t.dispatch(JF()));
  }, [s, t]), S = rn(() => s.isClaimed(), [s]), E = tr(() => ({
    canGetLock: f,
    tryGetLock: p,
    findClosestDraggableId: m,
    findOptionsForDraggable: v,
    tryReleaseLock: y,
    isLockClaimed: S
  }), [f, p, m, v, y, S]);
  Wze(o);
  for (let w = 0; w < o.length; w++)
    o[w](E);
}
const iBe = (e) => ({
  onBeforeCapture: (t) => {
    const n = () => {
      e.onBeforeCapture && e.onBeforeCapture(t);
    };
    it.version.startsWith("16") || it.version.startsWith("17") ? n() : xJ(n);
  },
  onBeforeDragStart: e.onBeforeDragStart,
  onDragStart: e.onDragStart,
  onDragEnd: e.onDragEnd,
  onDragUpdate: e.onDragUpdate
}), oBe = (e) => ({
  ...y1,
  ...e.autoScrollerOptions,
  durationDampening: {
    ...y1.durationDampening,
    ...e.autoScrollerOptions
  }
});
function pE(e) {
  return e.current || (ot.NODE_ENV !== "production" ? Ae(!1, "Could not find store from lazy ref") : Ae()), e.current;
}
function aBe(e) {
  const {
    contextId: t,
    setCallbacks: n,
    sensors: r,
    nonce: i,
    dragHandleUsageInstructions: o
  } = e, s = an(null);
  vze();
  const u = cW(e), f = rn(() => iBe(u.current), [u]), p = rn(() => oBe(u.current), [u]), m = aze(t), v = dze({
    contextId: t,
    text: o
  }), y = Jke(t, i), S = rn((z) => {
    pE(s).dispatch(z);
  }, []), E = tr(() => X7({
    publishWhileDragging: NLe,
    updateDroppableScroll: jLe,
    updateDroppableIsEnabled: LLe,
    updateDroppableIsCombineEnabled: kLe,
    collectionStarting: MLe
  }, S), [S]), w = nze(), _ = tr(() => Dke(w, E), [w, E]), O = tr(() => Gke({
    scrollWindow: Ike,
    scrollDroppable: _.scrollDroppable,
    getAutoScrollerOptions: p,
    ...X7({
      move: Goe
    }, S)
  }), [_.scrollDroppable, S, p]), D = eze(t), P = tr(() => Cke({
    announce: m,
    autoScroller: O,
    dimensionMarshal: _,
    focusMarshal: D,
    getResponders: f,
    styleMarshal: y
  }), [m, O, _, D, f, y]);
  ot.NODE_ENV !== "production" && s.current && s.current !== P && ot.NODE_ENV !== "production" && si("unexpected store change"), s.current = P;
  const M = rn(() => {
    const z = pE(s);
    z.getState().phase !== "IDLE" && z.dispatch(JF());
  }, []), N = rn(() => {
    const z = pE(s).getState();
    return z.phase === "DROP_ANIMATING" ? !0 : z.phase === "IDLE" ? !1 : z.isDragging;
  }, []), k = tr(() => ({
    isDragging: N,
    tryAbort: M
  }), [N, M]);
  n(k);
  const U = rn((z) => nae(pE(s).getState(), z), []), H = rn(() => hv(pE(s).getState()), []), Y = tr(() => ({
    marshal: _,
    focus: D,
    contextId: t,
    canLift: U,
    isMovementAllowed: H,
    dragHandleUsageInstructionsId: v,
    registry: w
  }), [t, _, v, D, U, H, w]);
  return rBe({
    contextId: t,
    store: P,
    registry: w,
    customSensors: r || null,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), ln(() => M, [M]), it.createElement(II.Provider, {
    value: Y
  }, it.createElement(tje, {
    context: aW,
    store: P
  }, e.children));
}
let sBe = 0;
function lBe() {
  return tr(() => `${sBe++}`, []);
}
function cBe() {
  return it.useId();
}
var uBe = "useId" in it ? cBe : lBe;
function dBe(e) {
  const t = uBe(), n = e.dragHandleUsageInstructions || VO.dragHandleUsageInstructions;
  return it.createElement(bje, null, (r) => it.createElement(aBe, {
    nonce: e.nonce,
    contextId: t,
    setCallbacks: r,
    dragHandleUsageInstructions: n,
    enableDefaultSensors: e.enableDefaultSensors,
    sensors: e.sensors,
    onBeforeCapture: e.onBeforeCapture,
    onBeforeDragStart: e.onBeforeDragStart,
    onDragStart: e.onDragStart,
    onDragUpdate: e.onDragUpdate,
    onDragEnd: e.onDragEnd,
    autoScrollerOptions: e.autoScrollerOptions
  }, e.children));
}
const FY = {
  dragging: 5e3,
  dropAnimating: 4500
}, fBe = (e, t) => t ? WE.drop(t.duration) : e ? WE.snap : WE.fluid, pBe = (e, t) => {
  if (e)
    return t ? v1.opacity.drop : v1.opacity.combining;
}, hBe = (e) => e.forceShouldAnimate != null ? e.forceShouldAnimate : e.mode === "SNAP";
function gBe(e) {
  const n = e.dimension.client, {
    offset: r,
    combineWith: i,
    dropping: o
  } = e, s = !!i, u = hBe(e), f = !!o, p = f ? vV.drop(r, s) : vV.moveTo(r);
  return {
    position: "fixed",
    top: n.marginBox.top,
    left: n.marginBox.left,
    boxSizing: "border-box",
    width: n.borderBox.width,
    height: n.borderBox.height,
    transition: fBe(u, o),
    transform: p,
    opacity: pBe(s, f),
    zIndex: f ? FY.dropAnimating : FY.dragging,
    pointerEvents: "none"
  };
}
function mBe(e) {
  return {
    transform: vV.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? void 0 : "none"
  };
}
function vBe(e) {
  return e.type === "DRAGGING" ? gBe(e) : mBe(e);
}
function yBe(e, t, n = Go) {
  const r = window.getComputedStyle(t), i = t.getBoundingClientRect(), o = woe(i, r), s = wA(o, n), u = {
    client: o,
    tagName: t.tagName.toLowerCase(),
    display: r.display
  }, f = {
    x: o.marginBox.width,
    y: o.marginBox.height
  };
  return {
    descriptor: e,
    placeholder: u,
    displaceBy: f,
    client: o,
    page: s
  };
}
function bBe(e) {
  const t = sW("draggable"), {
    descriptor: n,
    registry: r,
    getDraggableRef: i,
    canDragInteractiveElements: o,
    shouldRespectForcePress: s,
    isEnabled: u
  } = e, f = tr(() => ({
    canDragInteractiveElements: o,
    shouldRespectForcePress: s,
    isEnabled: u
  }), [o, u, s]), p = rn((S) => {
    const E = i();
    return E || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot get dimension when no ref is set") : Ae()), yBe(n, E, S);
  }, [n, i]), m = tr(() => ({
    uniqueId: t,
    descriptor: n,
    options: f,
    getDimension: p
  }), [n, p, f, t]), v = an(m), y = an(!0);
  Ml(() => (r.draggable.register(v.current), () => r.draggable.unregister(v.current)), [r.draggable]), Ml(() => {
    if (y.current) {
      y.current = !1;
      return;
    }
    const S = v.current;
    v.current = m, r.draggable.update(m, S);
  }, [m, r.draggable]);
}
var dW = it.createContext(null);
function mae(e) {
  e && __(e) || (ot.NODE_ENV !== "production" ? Ae(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/hello-pangea/dnd/blob/main/docs/guides/using-inner-ref.md
  `) : Ae());
}
function xBe(e, t, n) {
  C_(() => {
    function r(o) {
      return `Draggable[id: ${o}]: `;
    }
    const i = e.draggableId;
    i || (ot.NODE_ENV !== "production" ? Ae(!1, "Draggable requires a draggableId") : Ae(!1)), typeof i != "string" && (ot.NODE_ENV !== "production" ? Ae(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ${typeof i}] (value: ${i})`) : Ae(!1)), Number.isInteger(e.index) || (ot.NODE_ENV !== "production" ? Ae(!1, `${r(i)} requires an integer index prop`) : Ae(!1)), e.mapped.type !== "DRAGGING" && (mae(n()), e.isEnabled && (lae(t, i) || (ot.NODE_ENV !== "production" ? Ae(!1, `${r(i)} Unable to find drag handle`) : Ae(!1))));
  });
}
function SBe(e) {
  lW(() => {
    const t = an(e);
    C_(() => {
      e !== t.current && (ot.NODE_ENV !== "production" ? Ae(!1, "Draggable isClone prop value changed during component life") : Ae(!1));
    }, [e]);
  });
}
function _A(e) {
  const t = Qi(e);
  return t || (ot.NODE_ENV !== "production" ? Ae(!1, "Could not find required context") : Ae()), t;
}
function wBe(e) {
  e.preventDefault();
}
const TBe = (e) => {
  const t = an(null), n = rn((k = null) => {
    t.current = k;
  }, []), r = rn(() => t.current, []), {
    contextId: i,
    dragHandleUsageInstructionsId: o,
    registry: s
  } = _A(II), {
    type: u,
    droppableId: f
  } = _A(dW), p = tr(() => ({
    id: e.draggableId,
    index: e.index,
    type: u,
    droppableId: f
  }), [e.draggableId, e.index, u, f]), {
    children: m,
    draggableId: v,
    isEnabled: y,
    shouldRespectForcePress: S,
    canDragInteractiveElements: E,
    isClone: w,
    mapped: _,
    dropAnimationFinished: O
  } = e;
  if (xBe(e, i, r), SBe(w), !w) {
    const k = tr(() => ({
      descriptor: p,
      registry: s,
      getDraggableRef: r,
      canDragInteractiveElements: E,
      shouldRespectForcePress: S,
      isEnabled: y
    }), [p, s, r, E, S, y]);
    bBe(k);
  }
  const D = tr(() => y ? {
    tabIndex: 0,
    role: "button",
    "aria-describedby": o,
    "data-rfd-drag-handle-draggable-id": v,
    "data-rfd-drag-handle-context-id": i,
    draggable: !1,
    onDragStart: wBe
  } : null, [i, o, v, y]), P = rn((k) => {
    _.type === "DRAGGING" && _.dropping && k.propertyName === "transform" && (it.version.startsWith("16") || it.version.startsWith("17") ? O() : xJ(O));
  }, [O, _]), M = tr(() => {
    const k = vBe(_), U = _.type === "DRAGGING" && _.dropping ? P : void 0;
    return {
      innerRef: n,
      draggableProps: {
        "data-rfd-draggable-context-id": i,
        "data-rfd-draggable-id": v,
        style: k,
        onTransitionEnd: U
      },
      dragHandleProps: D
    };
  }, [i, D, v, _, P, n]), N = tr(() => ({
    draggableId: p.id,
    type: p.type,
    source: {
      index: p.index,
      droppableId: p.droppableId
    }
  }), [p.droppableId, p.id, p.index, p.type]);
  return it.createElement(it.Fragment, null, m(M, _.snapshot, N));
};
var EBe = TBe, vae = ((e, t) => e === t), yae = ((e) => {
  const {
    combine: t,
    destination: n
  } = e;
  return n ? n.droppableId : t ? t.droppableId : null;
});
const _Be = (e) => e.combine ? e.combine.draggableId : null, CBe = (e) => e.at && e.at.type === "COMBINE" ? e.at.combine.draggableId : null;
function RBe() {
  const e = $o((i, o) => ({
    x: i,
    y: o
  })), t = $o((i, o, s = null, u = null, f = null) => ({
    isDragging: !0,
    isClone: o,
    isDropAnimating: !!f,
    dropAnimation: f,
    mode: i,
    draggingOver: s,
    combineWith: u,
    combineTargetFor: null
  })), n = $o((i, o, s, u, f = null, p = null, m = null) => ({
    mapped: {
      type: "DRAGGING",
      dropping: null,
      draggingOver: f,
      combineWith: p,
      mode: o,
      offset: i,
      dimension: s,
      forceShouldAnimate: m,
      snapshot: t(o, u, f, p, null)
    }
  }));
  return (i, o) => {
    if (x1(i)) {
      if (i.critical.draggable.id !== o.draggableId)
        return null;
      const s = i.current.client.offset, u = i.dimensions.draggables[o.draggableId], f = Nl(i.impact), p = CBe(i.impact), m = i.forceShouldAnimate;
      return n(e(s.x, s.y), i.movementMode, u, o.isClone, f, p, m);
    }
    if (i.phase === "DROP_ANIMATING") {
      const s = i.completed;
      if (s.result.draggableId !== o.draggableId)
        return null;
      const u = o.isClone, f = i.dimensions.draggables[o.draggableId], p = s.result, m = p.mode, v = yae(p), y = _Be(p), E = {
        duration: i.dropDuration,
        curve: tW.drop,
        moveTo: i.newHomeClientOffset,
        opacity: y ? v1.opacity.drop : null,
        scale: y ? v1.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: i.newHomeClientOffset,
          dimension: f,
          dropping: E,
          draggingOver: v,
          combineWith: y,
          mode: m,
          forceShouldAnimate: null,
          snapshot: t(m, u, v, y, E)
        }
      };
    }
    return null;
  };
}
function bae(e = null) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
const OBe = {
  mapped: {
    type: "SECONDARY",
    offset: Go,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: bae(null)
  }
};
function ABe() {
  const e = $o((s, u) => ({
    x: s,
    y: u
  })), t = $o(bae), n = $o((s, u = null, f) => ({
    mapped: {
      type: "SECONDARY",
      offset: s,
      combineTargetFor: u,
      shouldAnimateDisplacement: f,
      snapshot: t(u)
    }
  })), r = (s) => s ? n(Go, s, !0) : null, i = (s, u, f, p) => {
    const m = f.displaced.visible[s], v = !!(p.inVirtualList && p.effected[s]), y = OI(f), S = y && y.draggableId === s ? u : null;
    if (!m) {
      if (!v)
        return r(S);
      if (f.displaced.invisible[s])
        return null;
      const _ = Fx(p.displacedBy.point), O = e(_.x, _.y);
      return n(O, S, !0);
    }
    if (v)
      return r(S);
    const E = f.displacedBy.point, w = e(E.x, E.y);
    return n(w, S, m.shouldAnimate);
  };
  return (s, u) => {
    if (x1(s))
      return s.critical.draggable.id === u.draggableId ? null : i(u.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      const f = s.completed;
      return f.result.draggableId === u.draggableId ? null : i(u.draggableId, f.result.draggableId, f.impact, f.afterCritical);
    }
    return null;
  };
}
const DBe = () => {
  const e = RBe(), t = ABe();
  return (r, i) => e(r, i) || t(r, i) || OBe;
}, IBe = {
  dropAnimationFinished: Xoe
}, PBe = xoe(DBe, IBe, null, {
  context: aW,
  areStatePropsEqual: vae
})(EBe);
var NBe = PBe;
function xae(e) {
  return _A(dW).isUsingCloneFor === e.draggableId && !e.isClone ? null : it.createElement(NBe, e);
}
function MBe(e) {
  const t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, n = !!e.disableInteractiveElementBlocking, r = !!e.shouldRespectForcePress;
  return it.createElement(xae, $t({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: n,
    shouldRespectForcePress: r
  }));
}
const fW = (e) => (t) => e === t, jBe = fW("scroll"), LBe = fW("auto"), kBe = fW("visible"), WY = (e, t) => t(e.overflowX) || t(e.overflowY), zBe = (e, t) => t(e.overflowX) && t(e.overflowY), Sae = (e) => {
  const t = window.getComputedStyle(e), n = {
    overflowX: t.overflowX,
    overflowY: t.overflowY
  };
  return WY(n, jBe) || WY(n, LBe);
}, BBe = () => {
  if (ot.NODE_ENV === "production")
    return !1;
  const e = b1(), t = document.documentElement;
  if (t || (ot.NODE_ENV, Ae()), !Sae(e))
    return !1;
  const n = window.getComputedStyle(t), r = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return zBe(r, kBe) || ot.NODE_ENV !== "production" && si(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, wae = (e) => e == null ? null : e === document.body ? BBe() ? e : null : e === document.documentElement ? null : Sae(e) ? e : wae(e.parentElement);
var Tae = wae, VBe = ((e) => {
  !e || !Tae(e.parentElement) || ot.NODE_ENV !== "production" && si(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
}), xV = ((e) => ({
  x: e.scrollLeft,
  y: e.scrollTop
}));
const Eae = (e) => e ? window.getComputedStyle(e).position === "fixed" ? !0 : Eae(e.parentElement) : !1;
var UBe = ((e) => {
  const t = Tae(e), n = Eae(e);
  return {
    closestScrollable: t,
    isFixedOnPage: n
  };
}), FBe = (({
  descriptor: e,
  isEnabled: t,
  isCombineEnabled: n,
  isFixedOnPage: r,
  direction: i,
  client: o,
  page: s,
  closest: u
}) => {
  const f = (() => {
    if (!u)
      return null;
    const {
      scrollSize: y,
      client: S
    } = u, E = Joe({
      scrollHeight: y.scrollHeight,
      scrollWidth: y.scrollWidth,
      height: S.paddingBox.height,
      width: S.paddingBox.width
    });
    return {
      pageMarginBox: u.page.marginBox,
      frameClient: S,
      scrollSize: y,
      shouldClipSubject: u.shouldClipSubject,
      scroll: {
        initial: u.scroll,
        current: u.scroll,
        max: E,
        diff: {
          value: Go,
          displacement: Go
        }
      }
    };
  })(), p = i === "vertical" ? YF : Poe, m = gx({
    page: s,
    withPlaceholder: null,
    axis: p,
    frame: f
  });
  return {
    descriptor: e,
    isCombineEnabled: n,
    isFixedOnPage: r,
    axis: p,
    isEnabled: t,
    client: o,
    page: s,
    frame: f,
    subject: m
  };
});
const WBe = (e, t) => {
  const n = Toe(e);
  if (!t || e !== t)
    return n;
  const r = n.paddingBox.top - t.scrollTop, i = n.paddingBox.left - t.scrollLeft, o = r + t.scrollHeight, s = i + t.scrollWidth, f = HF({
    top: r,
    right: s,
    bottom: o,
    left: i
  }, n.border);
  return qF({
    borderBox: f,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
};
var HBe = (({
  ref: e,
  descriptor: t,
  env: n,
  windowScroll: r,
  direction: i,
  isDropDisabled: o,
  isCombineEnabled: s,
  shouldClipSubject: u
}) => {
  const f = n.closestScrollable, p = WBe(e, f), m = wA(p, r), v = (() => {
    if (!f)
      return null;
    const S = Toe(f), E = {
      scrollHeight: f.scrollHeight,
      scrollWidth: f.scrollWidth
    };
    return {
      client: S,
      page: wA(S, r),
      scroll: xV(f),
      scrollSize: E,
      shouldClipSubject: u
    };
  })();
  return FBe({
    descriptor: t,
    isEnabled: !o,
    isCombineEnabled: s,
    isFixedOnPage: n.isFixedOnPage,
    direction: i,
    client: p,
    page: m,
    closest: v
  });
});
const qBe = {
  passive: !1
}, $Be = {
  passive: !0
};
var HY = ((e) => e.shouldPublishImmediately ? qBe : $Be);
const gO = (e) => e && e.env.closestScrollable || null;
function GBe(e) {
  const t = an(null), n = _A(II), r = sW("droppable"), {
    registry: i,
    marshal: o
  } = n, s = cW(e), u = tr(() => ({
    id: e.droppableId,
    type: e.type,
    mode: e.mode
  }), [e.droppableId, e.mode, e.type]), f = an(u), p = tr(() => $o((M, N) => {
    t.current || (ot.NODE_ENV !== "production" ? Ae(!1, "Can only update scroll when dragging") : Ae());
    const k = {
      x: M,
      y: N
    };
    o.updateDroppableScroll(u.id, k);
  }), [u.id, o]), m = rn(() => {
    const M = t.current;
    return !M || !M.env.closestScrollable ? Go : xV(M.env.closestScrollable);
  }, []), v = rn(() => {
    const M = m();
    p(M.x, M.y);
  }, [m, p]), y = tr(() => f1(v), [v]), S = rn(() => {
    const M = t.current, N = gO(M);
    if (M && N || (ot.NODE_ENV !== "production" ? Ae(!1, "Could not find scroll options while scrolling") : Ae()), M.scrollOptions.shouldPublishImmediately) {
      v();
      return;
    }
    y();
  }, [y, v]), E = rn((M, N) => {
    t.current && (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot collect a droppable while a drag is occurring") : Ae());
    const k = s.current, U = k.getDroppableRef();
    U || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot collect without a droppable ref") : Ae());
    const H = UBe(U), Y = {
      ref: U,
      descriptor: u,
      env: H,
      scrollOptions: N
    };
    t.current = Y;
    const z = HBe({
      ref: U,
      descriptor: u,
      env: H,
      windowScroll: M,
      direction: k.direction,
      isDropDisabled: k.isDropDisabled,
      isCombineEnabled: k.isCombineEnabled,
      shouldClipSubject: !k.ignoreContainerClipping
    }), V = H.closestScrollable;
    return V && (V.setAttribute(kY.contextId, n.contextId), V.addEventListener("scroll", S, HY(Y.scrollOptions)), ot.NODE_ENV !== "production" && VBe(V)), z;
  }, [n.contextId, u, S, s]), w = rn(() => {
    const M = t.current, N = gO(M);
    return M && N || (ot.NODE_ENV !== "production" ? Ae(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : Ae()), xV(N);
  }, []), _ = rn(() => {
    const M = t.current;
    M || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot stop drag when no active drag") : Ae());
    const N = gO(M);
    t.current = null, N && (y.cancel(), N.removeAttribute(kY.contextId), N.removeEventListener("scroll", S, HY(M.scrollOptions)));
  }, [S, y]), O = rn((M) => {
    const N = t.current;
    N || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot scroll when there is no drag") : Ae());
    const k = gO(N);
    k || (ot.NODE_ENV !== "production" ? Ae(!1, "Cannot scroll a droppable with no closest scrollable") : Ae()), k.scrollTop += M.y, k.scrollLeft += M.x;
  }, []), D = tr(() => ({
    getDimensionAndWatchScroll: E,
    getScrollWhileDragging: w,
    dragStopped: _,
    scroll: O
  }), [_, E, w, O]), P = tr(() => ({
    uniqueId: r,
    descriptor: u,
    callbacks: D
  }), [D, u, r]);
  Ml(() => (f.current = P.descriptor, i.droppable.register(P), () => {
    t.current && (ot.NODE_ENV !== "production" && si("Unsupported: changing the droppableId or type of a Droppable during a drag"), _()), i.droppable.unregister(P);
  }), [D, u, _, P, o, i.droppable]), Ml(() => {
    t.current && o.updateDroppableIsEnabled(f.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, o]), Ml(() => {
    t.current && o.updateDroppableIsCombineEnabled(f.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, o]);
}
function Nz() {
}
const qY = {
  width: 0,
  height: 0,
  margin: Cje
}, YBe = ({
  isAnimatingOpenOnMount: e,
  placeholder: t,
  animate: n
}) => e || n === "close" ? qY : {
  height: t.client.borderBox.height,
  width: t.client.borderBox.width,
  margin: t.client.margin
}, XBe = ({
  isAnimatingOpenOnMount: e,
  placeholder: t,
  animate: n
}) => {
  const r = YBe({
    isAnimatingOpenOnMount: e,
    placeholder: t,
    animate: n
  });
  return {
    display: t.display,
    boxSizing: "border-box",
    width: r.width,
    height: r.height,
    marginTop: r.margin.top,
    marginRight: r.margin.right,
    marginBottom: r.margin.bottom,
    marginLeft: r.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: n !== "none" ? WE.placeholder : null
  };
}, ZBe = (e) => {
  const t = an(null), n = rn(() => {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), {
    animate: r,
    onTransitionEnd: i,
    onClose: o,
    contextId: s
  } = e, [u, f] = Bn(e.animate === "open");
  ln(() => u ? r !== "open" ? (n(), f(!1), Nz) : t.current ? Nz : (t.current = setTimeout(() => {
    t.current = null, f(!1);
  }), n) : Nz, [r, u, n]);
  const p = rn((v) => {
    v.propertyName === "height" && (i(), r === "close" && o());
  }, [r, o, i]), m = XBe({
    isAnimatingOpenOnMount: u,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return it.createElement(e.placeholder.tagName, {
    style: m,
    "data-rfd-placeholder-context-id": s,
    onTransitionEnd: p,
    ref: e.innerRef
  });
};
var KBe = it.memo(ZBe);
function Mz(e) {
  return typeof e == "boolean";
}
function jz(e, t) {
  t.forEach((n) => n(e));
}
const QBe = [function({
  props: t
}) {
  t.droppableId || (ot.NODE_ENV !== "production" ? Ae(!1, "A Droppable requires a droppableId prop") : Ae()), typeof t.droppableId != "string" && (ot.NODE_ENV !== "production" ? Ae(!1, `A Droppable requires a [string] droppableId. Provided: [${typeof t.droppableId}]`) : Ae());
}, function({
  props: t
}) {
  Mz(t.isDropDisabled) || (ot.NODE_ENV !== "production" ? Ae(!1, "isDropDisabled must be a boolean") : Ae()), Mz(t.isCombineEnabled) || (ot.NODE_ENV !== "production" ? Ae(!1, "isCombineEnabled must be a boolean") : Ae()), Mz(t.ignoreContainerClipping) || (ot.NODE_ENV !== "production" ? Ae(!1, "ignoreContainerClipping must be a boolean") : Ae());
}, function({
  getDroppableRef: t
}) {
  mae(t());
}], JBe = [function({
  props: t,
  getPlaceholderRef: n
}) {
  !t.placeholder || n() || ot.NODE_ENV !== "production" && si(`
      Droppable setup issue [droppableId: "${t.droppableId}"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/hello-pangea/dnd/blob/main/docs/api/droppable.md
    `);
}], e2e = [function({
  props: t
}) {
  t.renderClone || (ot.NODE_ENV !== "production" ? Ae(!1, "Must provide a clone render function (renderClone) for virtual lists") : Ae());
}, function({
  getPlaceholderRef: t
}) {
  t() && (ot.NODE_ENV !== "production" ? Ae(!1, "Expected virtual list to not have a placeholder") : Ae());
}];
function t2e(e) {
  C_(() => {
    jz(e, QBe), e.props.mode === "standard" && jz(e, JBe), e.props.mode === "virtual" && jz(e, e2e);
  });
}
class n2e extends it.PureComponent {
  constructor(...t) {
    super(...t), this.state = {
      isVisible: !!this.props.on,
      data: this.props.on,
      animate: this.props.shouldAnimate && this.props.on ? "open" : "none"
    }, this.onClose = () => {
      this.state.animate === "close" && this.setState({
        isVisible: !1
      });
    };
  }
  static getDerivedStateFromProps(t, n) {
    return t.shouldAnimate ? t.on ? {
      isVisible: !0,
      data: t.on,
      animate: "open"
    } : n.isVisible ? {
      isVisible: !0,
      data: n.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!t.on,
      data: t.on,
      animate: "none"
    };
  }
  render() {
    if (!this.state.isVisible)
      return null;
    const t = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(t);
  }
}
const r2e = (e) => {
  const t = Qi(II);
  t || (ot.NODE_ENV !== "production" ? Ae(!1, "Could not find app context") : Ae());
  const {
    contextId: n,
    isMovementAllowed: r
  } = t, i = an(null), o = an(null), {
    children: s,
    droppableId: u,
    type: f,
    mode: p,
    direction: m,
    ignoreContainerClipping: v,
    isDropDisabled: y,
    isCombineEnabled: S,
    snapshot: E,
    useClone: w,
    updateViewportMaxScroll: _,
    getContainerForClone: O
  } = e, D = rn(() => i.current, []), P = rn((F = null) => {
    i.current = F;
  }, []), M = rn(() => o.current, []), N = rn((F = null) => {
    o.current = F;
  }, []);
  t2e({
    props: e,
    getDroppableRef: D,
    getPlaceholderRef: M
  });
  const k = rn(() => {
    r() && _({
      maxScroll: tae()
    });
  }, [r, _]);
  GBe({
    droppableId: u,
    type: f,
    mode: p,
    direction: m,
    isDropDisabled: y,
    isCombineEnabled: S,
    ignoreContainerClipping: v,
    getDroppableRef: D
  });
  const U = tr(() => it.createElement(n2e, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, ({
    onClose: F,
    data: X,
    animate: oe
  }) => it.createElement(KBe, {
    placeholder: X,
    onClose: F,
    innerRef: N,
    animate: oe,
    contextId: n,
    onTransitionEnd: k
  })), [n, k, e.placeholder, e.shouldAnimatePlaceholder, N]), H = tr(() => ({
    innerRef: P,
    placeholder: U,
    droppableProps: {
      "data-rfd-droppable-id": u,
      "data-rfd-droppable-context-id": n
    }
  }), [n, u, U, P]), Y = w ? w.dragging.draggableId : null, z = tr(() => ({
    droppableId: u,
    type: f,
    isUsingCloneFor: Y
  }), [u, Y, f]);
  function V() {
    if (!w)
      return null;
    const {
      dragging: F,
      render: X
    } = w, oe = it.createElement(xae, {
      draggableId: F.draggableId,
      index: F.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, (re, Z) => X(re, Z, F));
    return Pd.createPortal(oe, O());
  }
  return it.createElement(dW.Provider, {
    value: z
  }, s(H, E), V());
};
var i2e = r2e;
function o2e() {
  return document.body || (ot.NODE_ENV !== "production" ? Ae(!1, "document.body is not ready") : Ae()), document.body;
}
const $Y = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: o2e
}, _ae = (e) => {
  let t = {
    ...e
  }, n;
  for (n in $Y)
    e[n] === void 0 && (t = {
      ...t,
      [n]: $Y[n]
    });
  return t;
}, Lz = (e, t) => e === t.droppable.type, GY = (e, t) => t.draggables[e.draggable.id], a2e = () => {
  const e = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, t = {
    ...e,
    shouldAnimatePlaceholder: !1
  }, n = $o((o) => ({
    draggableId: o.id,
    type: o.type,
    source: {
      index: o.index,
      droppableId: o.droppableId
    }
  })), r = $o((o, s, u, f, p, m) => {
    const v = p.descriptor.id;
    if (p.descriptor.droppableId === o) {
      const E = m ? {
        render: m,
        dragging: n(p.descriptor)
      } : null, w = {
        isDraggingOver: u,
        draggingOverWith: u ? v : null,
        draggingFromThisWith: v,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: p.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: w,
        useClone: E
      };
    }
    if (!s)
      return t;
    if (!f)
      return e;
    const S = {
      isDraggingOver: u,
      draggingOverWith: v,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: p.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: S,
      useClone: null
    };
  });
  return (o, s) => {
    const u = _ae(s), f = u.droppableId, p = u.type, m = !u.isDropDisabled, v = u.renderClone;
    if (x1(o)) {
      const y = o.critical;
      if (!Lz(p, y))
        return t;
      const S = GY(y, o.dimensions), E = Nl(o.impact) === f;
      return r(f, m, E, E, S, v);
    }
    if (o.phase === "DROP_ANIMATING") {
      const y = o.completed;
      if (!Lz(p, y.critical))
        return t;
      const S = GY(y.critical, o.dimensions);
      return r(f, m, yae(y.result) === f, Nl(y.impact) === f, S, v);
    }
    if (o.phase === "IDLE" && o.completed && !o.shouldFlush) {
      const y = o.completed;
      if (!Lz(p, y.critical))
        return t;
      const S = Nl(y.impact) === f, E = !!(y.impact.at && y.impact.at.type === "COMBINE"), w = y.critical.droppable.id === f;
      return S ? E ? e : t : w ? e : t;
    }
    return t;
  };
}, s2e = {
  updateViewportMaxScroll: BLe
}, l2e = xoe(a2e, s2e, (e, t, n) => ({
  ..._ae(n),
  ...e,
  ...t
}), {
  context: aW,
  areStatePropsEqual: vae
})(i2e);
var c2e = l2e;
const u2e = ye("div")(({ theme: e }) => ({
  alignItems: "center",
  borderRight: `0.5px solid ${e.palette.divider}`,
  display: "flex",
  flex: 1,
  flexDirection: "row",
  marginBottom: e.spacing(-2),
  marginRight: e.spacing(1),
  marginTop: e.spacing(-2),
  maxWidth: e.spacing(3),
  width: e.spacing(3)
})), kz = (e, t, n) => {
  const r = Array.from(e), [i] = r.splice(t, 1);
  return r.splice(n, 0, i), r;
};
function Cae({
  resource: e,
  layerMetadata: t = {},
  index: n,
  handleOpacityChange: r,
  setLayerVisibility: i,
  moveToBackground: o,
  moveToFront: s
}) {
  const { t: u } = Ct(), { width: f, height: p } = { height: void 0, width: 40 }, m = {
    opacity: 1,
    visibility: !!e.preferred,
    ...t || {}
  };
  return /* @__PURE__ */ T.jsxs("div", { style: { flex: 1 }, children: [
    /* @__PURE__ */ T.jsxs("div", { style: { alignItems: "flex-start", display: "flex" }, children: [
      /* @__PURE__ */ T.jsx(
        jx,
        {
          maxHeight: p,
          maxWidth: f,
          resource: e,
          border: !0
        }
      ),
      /* @__PURE__ */ T.jsxs(
        St,
        {
          sx: {
            paddingLeft: 1
          },
          component: "div",
          variant: "body1",
          children: [
            /* @__PURE__ */ T.jsx(Cc, { resource: e, fallback: n + 1 }),
            /* @__PURE__ */ T.jsxs("div", { children: [
              /* @__PURE__ */ T.jsx(Jn, { "aria-label": u(m.visibility ? "layer_hide" : "layer_show"), edge: "start", size: "small", onClick: () => {
                i(e.id, !m.visibility);
              }, children: m.visibility ? /* @__PURE__ */ T.jsx(pre, {}) : /* @__PURE__ */ T.jsx(hre, {}) }),
              m.index !== 0 && /* @__PURE__ */ T.jsx(Jn, { "aria-label": u("layer_moveToBackground"), size: "small", onClick: () => {
                o(e.id);
              }, children: /* @__PURE__ */ T.jsx(rMe, {}) }),
              m.index !== t && /* @__PURE__ */ T.jsx(Jn, { "aria-label": u("layer_moveToFront"), size: "small", onClick: () => {
                s(e.id);
              }, children: /* @__PURE__ */ T.jsx(doe, {}) })
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ T.jsxs("div", { style: { alignItems: "center", display: "flex" }, children: [
      /* @__PURE__ */ T.jsx(Bd, { title: u("layer_opacity"), children: /* @__PURE__ */ T.jsx(iMe, { sx: { marginRight: 0.5 }, color: m.visibility ? "inherit" : "disabled", fontSize: "small" }) }),
      /* @__PURE__ */ T.jsx(
        x_,
        {
          sx: {
            "MuiInput-input": {
              "&::-webkit-outer-spin-button,&::-webkit-inner-spin-button": {
                margin: 0,
                WebkitAppearance: "none"
              },
              MozAppearance: "textfield",
              textAlign: "right",
              typography: "caption",
              width: "3ch"
            }
          },
          disabled: !m.visibility,
          value: Math.round(m.opacity * 100),
          type: "number",
          min: 0,
          max: 100,
          onChange: (v) => r(e.id, v.target.value),
          endAdornment: /* @__PURE__ */ T.jsx(_I, { disableTypography: !0, position: "end", children: /* @__PURE__ */ T.jsx(St, { variant: "caption", children: "%" }) }),
          inputProps: {
            "aria-label": u("layer_opacity")
          }
        }
      ),
      /* @__PURE__ */ T.jsx(
        uoe,
        {
          sx: {
            marginLeft: 2,
            marginRight: 2,
            maxWidth: 150
          },
          disabled: !m.visibility,
          value: m.opacity * 100,
          onChange: (v, y) => r(e.id, y)
        }
      )
    ] })
  ] });
}
Cae.propTypes = {
  handleOpacityChange: c.func.isRequired,
  index: c.number.isRequired,
  layerMetadata: c.objectOf(c.shape({
    opacity: c.number,
    visibility: c.bool
  })),
  // eslint-disable-line react/forbid-prop-types
  moveToBackground: c.func.isRequired,
  moveToFront: c.func.isRequired,
  resource: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  setLayerVisibility: c.func.isRequired
};
function Rae({
  children: e,
  resource: t,
  index: n
}) {
  const { t: r } = Ct();
  return /* @__PURE__ */ T.jsx(MBe, { draggableId: t.id, index: n, children: (i, o) => /* @__PURE__ */ Ou(
    Hd,
    {
      ref: i.innerRef,
      ...i.draggableProps,
      component: "li",
      divider: !0,
      sx: {
        alignItems: "stretch",
        cursor: "pointer",
        paddingBottom: 2,
        paddingRight: 2,
        paddingTop: 2,
        ...o.isDragging && {
          backgroundColor: "action.hover"
        }
      },
      disableGutters: !0,
      key: t.id
    },
    /* @__PURE__ */ T.jsx(
      u2e,
      {
        ...i.dragHandleProps,
        sx: {
          "&:hover": {
            backgroundColor: o.isDragging ? "action.selected" : "action.hover"
          },
          backgroundColor: o.isDragging ? "action.selected" : "shades.light"
        },
        children: /* @__PURE__ */ T.jsx(Bd, { title: r("layer_move"), children: /* @__PURE__ */ T.jsx(nMe, {}) })
      }
    ),
    e
  ) });
}
Rae.propTypes = {
  children: c.node.isRequired,
  index: c.number.isRequired,
  resource: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
function Oae({
  canvasId: e,
  index: t,
  label: n,
  layers: r,
  layerMetadata: i = {},
  totalSize: o,
  updateLayers: s,
  windowId: u
}) {
  const { t: f } = Ct(), p = uo(), m = Yn((w, _) => {
    const O = {
      [w]: { opacity: _ / 100 }
    };
    s(u, e, O);
  }, [e, s, u]), v = Yn((w) => {
    if (!w.destination || w.destination.droppableId !== p || w.source.droppableId !== p) return;
    const _ = kz(
      r.map((D) => D.id),
      w.source.index,
      w.destination.index
    ), O = r.reduce((D, P) => (D[P.id] = { index: _.indexOf(P.id) }, D), {});
    s(u, e, O);
  }, [e, p, r, s, u]), y = Yn((w, _) => {
    const O = {
      [w]: { visibility: _ }
    };
    s(u, e, O);
  }, [e, s, u]), S = Yn((w) => {
    const _ = kz(r.map((D) => D.id), r.findIndex((D) => D.id === w), 0), O = r.reduce((D, P) => (D[P.id] = { index: _.indexOf(P.id) }, D), {});
    s(u, e, O);
  }, [e, r, s, u]), E = Yn((w) => {
    const _ = kz(r.map((D) => D.id), r.findIndex((D) => D.id === w), r.length - 1), O = r.reduce((D, P) => (D[P.id] = { index: _.indexOf(P.id) }, D), {});
    s(u, e, O);
  }, [e, r, s, u]);
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    o > 1 && /* @__PURE__ */ T.jsx(
      St,
      {
        sx: {
          paddingLeft: 1,
          paddingRight: 1,
          paddingTop: 2
        },
        variant: "overline",
        children: f("annotationCanvasLabel", { context: `${t + 1}/${o}`, label: n })
      }
    ),
    /* @__PURE__ */ T.jsx(dBe, { onDragEnd: v, children: /* @__PURE__ */ T.jsx(c2e, { droppableId: p, children: (w, _) => /* @__PURE__ */ T.jsxs(
      Xd,
      {
        sx: {
          paddingTop: 0
        },
        ...w.droppableProps,
        ref: w.innerRef,
        children: [
          r && r.map((O, D) => /* @__PURE__ */ T.jsx(Rae, { resource: O, index: D, children: /* @__PURE__ */ T.jsx(
            Cae,
            {
              resource: O,
              index: D,
              layerMetadata: (i || {})[O.id] || {},
              handleOpacityChange: m,
              setLayerVisibility: y,
              moveToBackground: S,
              moveToFront: E
            }
          ) }, O.id)),
          w.placeholder
        ]
      }
    ) }) })
  ] });
}
Oae.propTypes = {
  canvasId: c.string.isRequired,
  index: c.number.isRequired,
  label: c.string.isRequired,
  layerMetadata: c.objectOf(c.shape({
    opacity: c.number
  })),
  layers: c.arrayOf(c.shape({})).isRequired,
  totalSize: c.number.isRequired,
  updateLayers: c.func.isRequired,
  windowId: c.string.isRequired
};
const d2e = (e, { canvasId: t, companionWindowId: n, windowId: r }) => ({
  label: yg(e, { canvasId: t, companionWindowId: n, windowId: r }),
  layerMetadata: A3(e, { canvasId: t, companionWindowId: n, windowId: r }),
  layers: Rte(e, { canvasId: t, companionWindowId: n, windowId: r })
}), f2e = {
  updateLayers: pne
}, p2e = wt(
  At(d2e, f2e)
), h2e = p2e(Oae);
function Aae({
  canvasIds: e = [],
  id: t,
  windowId: n
}) {
  const { t: r } = Ct();
  return /* @__PURE__ */ T.jsx(
    Zd,
    {
      title: r("layers"),
      id: t,
      windowId: n,
      children: e.map((i, o) => /* @__PURE__ */ T.jsx(
        h2e,
        {
          canvasId: i,
          index: o,
          totalSize: e.length,
          windowId: n
        },
        i
      ))
    }
  );
}
Aae.propTypes = {
  canvasIds: c.arrayOf(c.string),
  id: c.string.isRequired,
  windowId: c.string.isRequired
};
const g2e = (e, { id: t, windowId: n }) => ({
  canvasIds: ku(e, { windowId: n })
}), m2e = wt(
  At(g2e),
  Tt("LayersPanel")
), v2e = m2e(Aae);
function Dae({
  id: e,
  children: t = null,
  title: n,
  windowId: r
}) {
  const { t: i } = Ct();
  return /* @__PURE__ */ T.jsx(
    Zd,
    {
      title: i(n),
      id: e,
      windowId: r,
      children: t
    }
  );
}
Dae.propTypes = {
  children: c.node,
  id: c.string.isRequired,
  title: c.string.isRequired,
  windowId: c.string.isRequired
};
const y2e = (e, { id: t, windowId: n }) => ({}), b2e = wt(
  At(y2e),
  Tt("CustomPanel")
), x2e = b2e(Dae), S2e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), "ArrowUpwardSharp");
function SV({
  manifest: e,
  canvasNavigation: t,
  variant: n,
  ...r
}) {
  return /* @__PURE__ */ T.jsxs(
    qo,
    {
      alignItems: "flex-start",
      button: !0,
      divider: !0,
      component: "li",
      variant: "multiline",
      sx: {
        paddingRight: 1
      },
      ...r,
      children: [
        n === "thumbnail" && /* @__PURE__ */ T.jsx(Bv, { children: /* @__PURE__ */ T.jsx(
          jx,
          {
            resource: e,
            maxHeight: t.height,
            maxWidth: t.width
          }
        ) }),
        /* @__PURE__ */ T.jsx(dp, { children: /* @__PURE__ */ T.jsx(Cc, { resource: e }) })
      ]
    }
  );
}
SV.propTypes = {
  canvasNavigation: c.shape({
    height: c.number,
    width: c.number
  }).isRequired,
  manifest: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  variant: c.string.isRequired
};
function Iae({
  canvasNavigation: e,
  collectionPath: t = [],
  collection: n = null,
  id: r,
  isFetching: i = !1,
  manifestId: o,
  parentCollection: s = null,
  updateCompanionWindow: u,
  updateWindow: f,
  variant: p = null,
  windowId: m
}) {
  const { t: v } = Ct(), y = (() => {
    if (!n) return !1;
    const S = n.getProperty("behavior");
    return Array.isArray(S) ? S.includes("multi-part") : S === "multi-part";
  })();
  return /* @__PURE__ */ T.jsx(
    Zd,
    {
      title: v(y ? "multipartCollection" : "collection"),
      windowId: m,
      id: r,
      titleControls: /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        s && /* @__PURE__ */ T.jsx(Xd, { children: /* @__PURE__ */ T.jsxs(
          BF,
          {
            onClick: () => u({ collectionPath: t.slice(0, -1) }),
            children: [
              /* @__PURE__ */ T.jsx(Bv, { children: /* @__PURE__ */ T.jsx(S2e, {}) }),
              /* @__PURE__ */ T.jsx(dp, { primaryTypographyProps: { variant: "body1" }, children: /* @__PURE__ */ T.jsx(Cc, { resource: s }) })
            ]
          }
        ) }),
        /* @__PURE__ */ T.jsxs(St, { variant: "h6", children: [
          n && /* @__PURE__ */ T.jsx(Cc, { resource: n }),
          i && /* @__PURE__ */ T.jsx(pi, { variant: "text" })
        ] })
      ] }),
      children: /* @__PURE__ */ T.jsxs(ty, { children: [
        i && /* @__PURE__ */ T.jsx(qo, { children: /* @__PURE__ */ T.jsxs(dp, { children: [
          /* @__PURE__ */ T.jsx(pi, { variant: "text" }),
          /* @__PURE__ */ T.jsx(pi, { variant: "text" }),
          /* @__PURE__ */ T.jsx(pi, { variant: "text" })
        ] }) }),
        n && n.getCollections().map((S) => {
          const E = () => {
            u({ collectionPath: [...t, S.id] });
          };
          return /* @__PURE__ */ T.jsx(
            SV,
            {
              onClick: E,
              canvasNavigation: e,
              manifest: S,
              variant: p,
              selected: o === S.id
            },
            S.id
          );
        }),
        n && n.getManifests().map((S) => {
          const E = () => {
            f({ canvasId: null, collectionPath: t, manifestId: S.id }), u({ multipart: !1 });
          };
          return /* @__PURE__ */ T.jsx(
            SV,
            {
              onClick: E,
              canvasNavigation: e,
              manifest: S,
              variant: p,
              selected: o === S.id
            },
            S.id
          );
        })
      ] })
    }
  );
}
Iae.propTypes = {
  canvasNavigation: c.shape({
    height: c.number,
    width: c.number
  }).isRequired,
  collection: c.object,
  // eslint-disable-line react/forbid-prop-types
  collectionPath: c.arrayOf(c.string),
  id: c.string.isRequired,
  isFetching: c.bool,
  manifestId: c.string.isRequired,
  parentCollection: c.object,
  // eslint-disable-line react/forbid-prop-types
  updateCompanionWindow: c.func.isRequired,
  updateWindow: c.func.isRequired,
  variant: c.string,
  windowId: c.string.isRequired
};
const w2e = (e, { id: t, windowId: n }) => {
  const r = Wn(e, { windowId: n }), i = ju(e, { companionWindowId: t }), { collectionPath: o } = i, s = o || r.collectionPath, u = s && s[s.length - 1], f = s && s[s.length - 2], p = u && Va(e, { manifestId: u }), m = f && Va(e, { manifestId: f }), v = Va(e, { windowId: n });
  return {
    canvasNavigation: e.config.canvasNavigation,
    collection: p && nr(e, { manifestId: p.id }),
    collectionId: u,
    collectionPath: s,
    error: p && p.error,
    isFetching: p && p.isFetching,
    manifestId: v && v.id,
    parentCollection: m && nr(e, { manifestId: m.id }),
    ready: p && !!p.json,
    variant: i.variant || R3(e, { windowId: n })
  };
}, T2e = (e, { id: t, windowId: n }) => ({
  updateCompanionWindow: (...r) => e(
    Nx(n, t, ...r)
  ),
  updateWindow: (...r) => e(Po(n, ...r))
}), E2e = wt(
  At(w2e, T2e),
  Tt("WindowSideBarCollectionPanel")
), _2e = E2e(Iae), wV = {
  annotations: qCe,
  attribution: aPe,
  canvas: UIe,
  collection: _2e,
  custom: x2e,
  info: OAe,
  layers: v2e,
  search: jNe,
  thumbnailNavigation: mTe
};
function C2e(e) {
  return e.reduce((t, n) => Eme(t, [n.target, n.mode], (r) => [...r || [], n]), {});
}
function R2e(e) {
  return e.map((t) => ({ ...t, component: A2e(t) }));
}
function O2e(e) {
  return e.filter((t) => t.companionWindowKey).forEach((t) => {
    wV[t.companionWindowKey] = t.component;
  }), wV;
}
function A2e(e) {
  return !e.mapStateToProps && !e.mapDispatchToProps ? e.component : At(
    e.mapStateToProps,
    e.mapDispatchToProps,
    ...e.connectOptions || []
  )(e.component);
}
function Pae({ plugins: e = [], children: t = null }) {
  const [n, r] = Bn({});
  return ln(() => {
    const i = R2e(e);
    O2e(i), r(C2e(i));
  }, [e]), /* @__PURE__ */ T.jsx(bU.Provider, { value: n, children: t });
}
Pae.propTypes = {
  children: c.node,
  plugins: c.array
  // eslint-disable-line react/forbid-prop-types
};
var Tl = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
}, YY = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
], XY = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
], ZY = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
], ks = typeof window < "u" && typeof window.document < "u" ? window.document : {}, vc = "fullscreenEnabled" in ks && Object.keys(Tl) || YY[0] in ks && YY || XY[0] in ks && XY || ZY[0] in ks && ZY || [], Kf = {
  requestFullscreen: function(e) {
    return e[vc[Tl.requestFullscreen]]();
  },
  requestFullscreenFunction: function(e) {
    return e[vc[Tl.requestFullscreen]];
  },
  get exitFullscreen() {
    return ks[vc[Tl.exitFullscreen]].bind(ks);
  },
  get fullscreenPseudoClass() {
    return ":" + vc[Tl.fullscreen];
  },
  addEventListener: function(e, t, n) {
    return ks.addEventListener(vc[Tl[e]], t, n);
  },
  removeEventListener: function(e, t, n) {
    return ks.removeEventListener(vc[Tl[e]], t, n);
  },
  get fullscreenEnabled() {
    return !!ks[vc[Tl.fullscreenEnabled]];
  },
  set fullscreenEnabled(e) {
  },
  get fullscreenElement() {
    return ks[vc[Tl.fullscreenElement]];
  },
  set fullscreenElement(e) {
  },
  get onfullscreenchange() {
    return ks[("on" + vc[Tl.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(e) {
    return ks[("on" + vc[Tl.fullscreenchange]).toLowerCase()] = e;
  },
  get onfullscreenerror() {
    return ks[("on" + vc[Tl.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(e) {
    return ks[("on" + vc[Tl.fullscreenerror]).toLowerCase()] = e;
  }
};
function D2e() {
  var e = Bn(!1), t = e[0], n = e[1], r = an(null);
  ln(function() {
    var s = function() {
      n(Kf.fullscreenElement === r.current);
    };
    return Kf.addEventListener("fullscreenchange", s), function() {
      return Kf.removeEventListener("fullscreenchange", s);
    };
  }, []);
  var i = Yn(function() {
    if (Kf.fullscreenElement)
      return Kf.exitFullscreen().then(function() {
        return Kf.requestFullscreen(r.current);
      });
    if (r.current)
      return Kf.requestFullscreen(r.current);
  }, []), o = Yn(function() {
    return Kf.fullscreenElement === r.current ? Kf.exitFullscreen() : Promise.resolve();
  }, []);
  return Ui(function() {
    return {
      active: t,
      enter: i,
      exit: o,
      node: r
    };
  }, [t, i, o]);
}
var I2e = function(t) {
  var n = t.handle, r = t.onChange, i = t.children, o = t.className, s = [];
  return o && s.push(o), s.push("fullscreen"), n.active && s.push("fullscreen-enabled"), ln(function() {
    r && r(n.active, n);
  }, [n.active]), it.createElement("div", {
    className: s.join(" "),
    ref: n.node,
    style: n.active ? {
      height: "100%",
      width: "100%"
    } : void 0
  }, i);
};
const NI = hg({
  dragDropManager: void 0
});
var El = {};
function yc(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var KY = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})(), QY = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, JY = {
  INIT: "@@redux/INIT" + QY(),
  REPLACE: "@@redux/REPLACE" + QY()
};
function P2e(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function N2e(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (L2e(e)) return "date";
  if (j2e(e)) return "error";
  var n = M2e(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function M2e(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function j2e(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function L2e(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function P0(e) {
  var t = typeof e;
  return El.NODE_ENV !== "production" && (t = N2e(e)), t;
}
function Nae(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(El.NODE_ENV === "production" ? yc(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(El.NODE_ENV === "production" ? yc(1) : "Expected the enhancer to be a function. Instead, received: '" + P0(n) + "'");
    return n(Nae)(e, t);
  }
  if (typeof e != "function")
    throw new Error(El.NODE_ENV === "production" ? yc(2) : "Expected the root reducer to be a function. Instead, received: '" + P0(e) + "'");
  var i = e, o = t, s = [], u = s, f = !1;
  function p() {
    u === s && (u = s.slice());
  }
  function m() {
    if (f)
      throw new Error(El.NODE_ENV === "production" ? yc(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function v(w) {
    if (typeof w != "function")
      throw new Error(El.NODE_ENV === "production" ? yc(4) : "Expected the listener to be a function. Instead, received: '" + P0(w) + "'");
    if (f)
      throw new Error(El.NODE_ENV === "production" ? yc(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var _ = !0;
    return p(), u.push(w), function() {
      if (_) {
        if (f)
          throw new Error(El.NODE_ENV === "production" ? yc(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        _ = !1, p();
        var D = u.indexOf(w);
        u.splice(D, 1), s = null;
      }
    };
  }
  function y(w) {
    if (!P2e(w))
      throw new Error(El.NODE_ENV === "production" ? yc(7) : "Actions must be plain objects. Instead, the actual type was: '" + P0(w) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof w.type > "u")
      throw new Error(El.NODE_ENV === "production" ? yc(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (f)
      throw new Error(El.NODE_ENV === "production" ? yc(9) : "Reducers may not dispatch actions.");
    try {
      f = !0, o = i(o, w);
    } finally {
      f = !1;
    }
    for (var _ = s = u, O = 0; O < _.length; O++) {
      var D = _[O];
      D();
    }
    return w;
  }
  function S(w) {
    if (typeof w != "function")
      throw new Error(El.NODE_ENV === "production" ? yc(10) : "Expected the nextReducer to be a function. Instead, received: '" + P0(w));
    i = w, y({
      type: JY.REPLACE
    });
  }
  function E() {
    var w, _ = v;
    return w = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(D) {
        if (typeof D != "object" || D === null)
          throw new Error(El.NODE_ENV === "production" ? yc(11) : "Expected the observer to be an object. Instead, received: '" + P0(D) + "'");
        function P() {
          D.next && D.next(m());
        }
        P();
        var M = _(P);
        return {
          unsubscribe: M
        };
      }
    }, w[KY] = function() {
      return this;
    }, w;
  }
  return y({
    type: JY.INIT
  }), r = {
    dispatch: y,
    subscribe: v,
    getState: m,
    replaceReducer: S
  }, r[KY] = E, r;
}
var k2e = {};
function Rn(e, t, ...n) {
  if (z2e() && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    let r;
    if (t === void 0)
      r = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let i = 0;
      r = new Error(t.replace(/%s/g, function() {
        return n[i++];
      })), r.name = "Invariant Violation";
    }
    throw r.framesToPop = 1, r;
  }
}
function z2e() {
  return typeof process < "u" && k2e.NODE_ENV === "production";
}
function B2e(e, t, n) {
  return t.split(".").reduce(
    (r, i) => r && r[i] ? r[i] : n || null,
    e
  );
}
function V2e(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function Mae(e) {
  return typeof e == "object";
}
function U2e(e, t) {
  const n = /* @__PURE__ */ new Map(), r = (o) => {
    n.set(o, n.has(o) ? n.get(o) + 1 : 1);
  };
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach((o, s) => {
    o === 1 && i.push(s);
  }), i;
}
function F2e(e, t) {
  return e.filter(
    (n) => t.indexOf(n) > -1
  );
}
const pW = "dnd-core/INIT_COORDS", MI = "dnd-core/BEGIN_DRAG", hW = "dnd-core/PUBLISH_DRAG_SOURCE", jI = "dnd-core/HOVER", LI = "dnd-core/DROP", kI = "dnd-core/END_DRAG";
function eX(e, t) {
  return {
    type: pW,
    payload: {
      sourceClientOffset: t || null,
      clientOffset: e || null
    }
  };
}
const W2e = {
  type: pW,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function H2e(e) {
  return function(n = [], r = {
    publishSource: !0
  }) {
    const { publishSource: i = !0, clientOffset: o, getSourceClientOffset: s } = r, u = e.getMonitor(), f = e.getRegistry();
    e.dispatch(eX(o)), q2e(n, u, f);
    const p = Y2e(n, u);
    if (p == null) {
      e.dispatch(W2e);
      return;
    }
    let m = null;
    if (o) {
      if (!s)
        throw new Error("getSourceClientOffset must be defined");
      $2e(s), m = s(p);
    }
    e.dispatch(eX(o, m));
    const y = f.getSource(p).beginDrag(u, p);
    if (y == null)
      return;
    G2e(y), f.pinSource(p);
    const S = f.getSourceType(p);
    return {
      type: MI,
      payload: {
        itemType: S,
        item: y,
        sourceId: p,
        clientOffset: o || null,
        sourceClientOffset: m || null,
        isSourcePublic: !!i
      }
    };
  };
}
function q2e(e, t, n) {
  Rn(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function(r) {
    Rn(n.getSource(r), "Expected sourceIds to be registered.");
  });
}
function $2e(e) {
  Rn(typeof e == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function G2e(e) {
  Rn(Mae(e), "Item must be an object.");
}
function Y2e(e, t) {
  let n = null;
  for (let r = e.length - 1; r >= 0; r--)
    if (t.canDragSource(e[r])) {
      n = e[r];
      break;
    }
  return n;
}
function X2e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Z2e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      X2e(e, i, n[i]);
    });
  }
  return e;
}
function K2e(e) {
  return function(n = {}) {
    const r = e.getMonitor(), i = e.getRegistry();
    Q2e(r), tVe(r).forEach((s, u) => {
      const f = J2e(s, u, i, r), p = {
        type: LI,
        payload: {
          dropResult: Z2e({}, n, f)
        }
      };
      e.dispatch(p);
    });
  };
}
function Q2e(e) {
  Rn(e.isDragging(), "Cannot call drop while not dragging."), Rn(!e.didDrop(), "Cannot call drop twice during one drag operation.");
}
function J2e(e, t, n, r) {
  const i = n.getTarget(e);
  let o = i ? i.drop(r, e) : void 0;
  return eVe(o), typeof o > "u" && (o = t === 0 ? {} : r.getDropResult()), o;
}
function eVe(e) {
  Rn(typeof e > "u" || Mae(e), "Drop result must either be an object or undefined.");
}
function tVe(e) {
  const t = e.getTargetIds().filter(e.canDropOnTarget, e);
  return t.reverse(), t;
}
function nVe(e) {
  return function() {
    const n = e.getMonitor(), r = e.getRegistry();
    rVe(n);
    const i = n.getSourceId();
    return i != null && (r.getSource(i, !0).endDrag(n, i), r.unpinSource()), {
      type: kI
    };
  };
}
function rVe(e) {
  Rn(e.isDragging(), "Cannot call endDrag while not dragging.");
}
function TV(e, t) {
  return t === null ? e === null : Array.isArray(e) ? e.some(
    (n) => n === t
  ) : e === t;
}
function iVe(e) {
  return function(n, { clientOffset: r } = {}) {
    oVe(n);
    const i = n.slice(0), o = e.getMonitor(), s = e.getRegistry(), u = o.getItemType();
    return sVe(i, s, u), aVe(i, o, s), lVe(i, o, s), {
      type: jI,
      payload: {
        targetIds: i,
        clientOffset: r || null
      }
    };
  };
}
function oVe(e) {
  Rn(Array.isArray(e), "Expected targetIds to be an array.");
}
function aVe(e, t, n) {
  Rn(t.isDragging(), "Cannot call hover while not dragging."), Rn(!t.didDrop(), "Cannot call hover after drop.");
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    Rn(e.lastIndexOf(i) === r, "Expected targetIds to be unique in the passed array.");
    const o = n.getTarget(i);
    Rn(o, "Expected targetIds to be registered.");
  }
}
function sVe(e, t, n) {
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r], o = t.getTargetType(i);
    TV(o, n) || e.splice(r, 1);
  }
}
function lVe(e, t, n) {
  e.forEach(function(r) {
    n.getTarget(r).hover(t, r);
  });
}
function cVe(e) {
  return function() {
    if (e.getMonitor().isDragging())
      return {
        type: hW
      };
  };
}
function uVe(e) {
  return {
    beginDrag: H2e(e),
    publishDragSource: cVe(e),
    hover: iVe(e),
    drop: K2e(e),
    endDrag: nVe(e)
  };
}
class dVe {
  receiveBackend(t) {
    this.backend = t;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const t = this, { dispatch: n } = this.store;
    function r(o) {
      return (...s) => {
        const u = o.apply(t, s);
        typeof u < "u" && n(u);
      };
    }
    const i = uVe(this);
    return Object.keys(i).reduce((o, s) => {
      const u = i[s];
      return o[s] = r(u), o;
    }, {});
  }
  dispatch(t) {
    this.store.dispatch(t);
  }
  constructor(t, n) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const r = this.store.getState().refCount > 0;
      this.backend && (r && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !r && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = t, this.monitor = n, t.subscribe(this.handleRefCountChange);
  }
}
function fVe(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function jae(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function pVe(e) {
  const { clientOffset: t, initialClientOffset: n, initialSourceClientOffset: r } = e;
  return !t || !n || !r ? null : jae(fVe(t, r), n);
}
function hVe(e) {
  const { clientOffset: t, initialClientOffset: n } = e;
  return !t || !n ? null : jae(t, n);
}
const HE = [], gW = [];
HE.__IS_NONE__ = !0;
gW.__IS_ALL__ = !0;
function gVe(e, t) {
  return e === HE ? !1 : e === gW || typeof t > "u" ? !0 : F2e(t, e).length > 0;
}
class mVe {
  subscribeToStateChange(t, n = {}) {
    const { handlerIds: r } = n;
    Rn(typeof t == "function", "listener must be a function."), Rn(typeof r > "u" || Array.isArray(r), "handlerIds, when specified, must be an array of strings.");
    let i = this.store.getState().stateId;
    const o = () => {
      const s = this.store.getState(), u = s.stateId;
      try {
        u === i || u === i + 1 && !gVe(s.dirtyHandlerIds, r) || t();
      } finally {
        i = u;
      }
    };
    return this.store.subscribe(o);
  }
  subscribeToOffsetChange(t) {
    Rn(typeof t == "function", "listener must be a function.");
    let n = this.store.getState().dragOffset;
    const r = () => {
      const i = this.store.getState().dragOffset;
      i !== n && (n = i, t());
    };
    return this.store.subscribe(r);
  }
  canDragSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t);
    return Rn(n, `Expected to find a valid source. sourceId=${t}`), this.isDragging() ? !1 : n.canDrag(this, t);
  }
  canDropOnTarget(t) {
    if (!t)
      return !1;
    const n = this.registry.getTarget(t);
    if (Rn(n, `Expected to find a valid target. targetId=${t}`), !this.isDragging() || this.didDrop())
      return !1;
    const r = this.registry.getTargetType(t), i = this.getItemType();
    return TV(r, i) && n.canDrop(this, t);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t, !0);
    if (Rn(n, `Expected to find a valid source. sourceId=${t}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const r = this.registry.getSourceType(t), i = this.getItemType();
    return r !== i ? !1 : n.isDragging(this, t);
  }
  isOverTarget(t, n = {
    shallow: !1
  }) {
    if (!t)
      return !1;
    const { shallow: r } = n;
    if (!this.isDragging())
      return !1;
    const i = this.registry.getTargetType(t), o = this.getItemType();
    if (o && !TV(i, o))
      return !1;
    const s = this.getTargetIds();
    if (!s.length)
      return !1;
    const u = s.indexOf(t);
    return r ? u === s.length - 1 : u > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return pVe(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return hVe(this.store.getState().dragOffset);
  }
  constructor(t, n) {
    this.store = t, this.registry = n;
  }
}
const tX = typeof global < "u" ? global : self, Lae = tX.MutationObserver || tX.WebKitMutationObserver;
function kae(e) {
  return function() {
    const n = setTimeout(i, 0), r = setInterval(i, 50);
    function i() {
      clearTimeout(n), clearInterval(r), e();
    }
  };
}
function vVe(e) {
  let t = 1;
  const n = new Lae(e), r = document.createTextNode("");
  return n.observe(r, {
    characterData: !0
  }), function() {
    t = -t, r.data = t;
  };
}
const yVe = typeof Lae == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  vVe
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  kae
);
class bVe {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(t) {
    const { queue: n, requestFlush: r } = this;
    n.length || (r(), this.flushing = !0), n[n.length] = t;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: t } = this;
      for (; this.index < t.length; ) {
        const n = this.index;
        if (this.index++, t[n].call(), this.index > this.capacity) {
          for (let r = 0, i = t.length - this.index; r < i; r++)
            t[r] = t[r + this.index];
          t.length -= this.index, this.index = 0;
        }
      }
      t.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (t) => {
      this.pendingErrors.push(t), this.requestErrorThrow();
    }, this.requestFlush = yVe(this.flush), this.requestErrorThrow = kae(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class xVe {
  call() {
    try {
      this.task && this.task();
    } catch (t) {
      this.onError(t);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(t, n) {
    this.onError = t, this.release = n, this.task = null;
  }
}
class SVe {
  create(t) {
    const n = this.freeTasks, r = n.length ? n.pop() : new xVe(
      this.onError,
      (i) => n[n.length] = i
    );
    return r.task = t, r;
  }
  constructor(t) {
    this.onError = t, this.freeTasks = [];
  }
}
const zae = new bVe(), wVe = new SVe(zae.registerPendingError);
function TVe(e) {
  zae.enqueueTask(wVe.create(e));
}
const mW = "dnd-core/ADD_SOURCE", vW = "dnd-core/ADD_TARGET", yW = "dnd-core/REMOVE_SOURCE", zI = "dnd-core/REMOVE_TARGET";
function EVe(e) {
  return {
    type: mW,
    payload: {
      sourceId: e
    }
  };
}
function _Ve(e) {
  return {
    type: vW,
    payload: {
      targetId: e
    }
  };
}
function CVe(e) {
  return {
    type: yW,
    payload: {
      sourceId: e
    }
  };
}
function RVe(e) {
  return {
    type: zI,
    payload: {
      targetId: e
    }
  };
}
function OVe(e) {
  Rn(typeof e.canDrag == "function", "Expected canDrag to be a function."), Rn(typeof e.beginDrag == "function", "Expected beginDrag to be a function."), Rn(typeof e.endDrag == "function", "Expected endDrag to be a function.");
}
function AVe(e) {
  Rn(typeof e.canDrop == "function", "Expected canDrop to be a function."), Rn(typeof e.hover == "function", "Expected hover to be a function."), Rn(typeof e.drop == "function", "Expected beginDrag to be a function.");
}
function EV(e, t) {
  if (t && Array.isArray(e)) {
    e.forEach(
      (n) => EV(n, !1)
    );
    return;
  }
  Rn(typeof e == "string" || typeof e == "symbol", t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var Tc;
(function(e) {
  e.SOURCE = "SOURCE", e.TARGET = "TARGET";
})(Tc || (Tc = {}));
let DVe = 0;
function IVe() {
  return DVe++;
}
function PVe(e) {
  const t = IVe().toString();
  switch (e) {
    case Tc.SOURCE:
      return `S${t}`;
    case Tc.TARGET:
      return `T${t}`;
    default:
      throw new Error(`Unknown Handler Role: ${e}`);
  }
}
function nX(e) {
  switch (e[0]) {
    case "S":
      return Tc.SOURCE;
    case "T":
      return Tc.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${e}`);
  }
}
function rX(e, t) {
  const n = e.entries();
  let r = !1;
  do {
    const { done: i, value: [, o] } = n.next();
    if (o === t)
      return !0;
    r = !!i;
  } while (!r);
  return !1;
}
class NVe {
  addSource(t, n) {
    EV(t), OVe(n);
    const r = this.addHandler(Tc.SOURCE, t, n);
    return this.store.dispatch(EVe(r)), r;
  }
  addTarget(t, n) {
    EV(t, !0), AVe(n);
    const r = this.addHandler(Tc.TARGET, t, n);
    return this.store.dispatch(_Ve(r)), r;
  }
  containsHandler(t) {
    return rX(this.dragSources, t) || rX(this.dropTargets, t);
  }
  getSource(t, n = !1) {
    return Rn(this.isSourceId(t), "Expected a valid source ID."), n && t === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(t);
  }
  getTarget(t) {
    return Rn(this.isTargetId(t), "Expected a valid target ID."), this.dropTargets.get(t);
  }
  getSourceType(t) {
    return Rn(this.isSourceId(t), "Expected a valid source ID."), this.types.get(t);
  }
  getTargetType(t) {
    return Rn(this.isTargetId(t), "Expected a valid target ID."), this.types.get(t);
  }
  isSourceId(t) {
    return nX(t) === Tc.SOURCE;
  }
  isTargetId(t) {
    return nX(t) === Tc.TARGET;
  }
  removeSource(t) {
    Rn(this.getSource(t), "Expected an existing source."), this.store.dispatch(CVe(t)), TVe(() => {
      this.dragSources.delete(t), this.types.delete(t);
    });
  }
  removeTarget(t) {
    Rn(this.getTarget(t), "Expected an existing target."), this.store.dispatch(RVe(t)), this.dropTargets.delete(t), this.types.delete(t);
  }
  pinSource(t) {
    const n = this.getSource(t);
    Rn(n, "Expected an existing source."), this.pinnedSourceId = t, this.pinnedSource = n;
  }
  unpinSource() {
    Rn(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(t, n, r) {
    const i = PVe(t);
    return this.types.set(i, n), t === Tc.SOURCE ? this.dragSources.set(i, r) : t === Tc.TARGET && this.dropTargets.set(i, r), i;
  }
  constructor(t) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = t;
  }
}
const MVe = (e, t) => e === t;
function jVe(e, t) {
  return !e && !t ? !0 : !e || !t ? !1 : e.x === t.x && e.y === t.y;
}
function LVe(e, t, n = MVe) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; ++r)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function kVe(e = HE, t) {
  switch (t.type) {
    case jI:
      break;
    case mW:
    case vW:
    case zI:
    case yW:
      return HE;
    case MI:
    case hW:
    case kI:
    case LI:
    default:
      return gW;
  }
  const { targetIds: n = [], prevTargetIds: r = [] } = t.payload, i = U2e(n, r);
  if (!(i.length > 0 || !LVe(n, r)))
    return HE;
  const s = r[r.length - 1], u = n[n.length - 1];
  return s !== u && (s && i.push(s), u && i.push(u)), i;
}
function zVe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function BVe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      zVe(e, i, n[i]);
    });
  }
  return e;
}
const iX = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function VVe(e = iX, t) {
  const { payload: n } = t;
  switch (t.type) {
    case pW:
    case MI:
      return {
        initialSourceClientOffset: n.sourceClientOffset,
        initialClientOffset: n.clientOffset,
        clientOffset: n.clientOffset
      };
    case jI:
      return jVe(e.clientOffset, n.clientOffset) ? e : BVe({}, e, {
        clientOffset: n.clientOffset
      });
    case kI:
    case LI:
      return iX;
    default:
      return e;
  }
}
function UVe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function N0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      UVe(e, i, n[i]);
    });
  }
  return e;
}
const FVe = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function WVe(e = FVe, t) {
  const { payload: n } = t;
  switch (t.type) {
    case MI:
      return N0({}, e, {
        itemType: n.itemType,
        item: n.item,
        sourceId: n.sourceId,
        isSourcePublic: n.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case hW:
      return N0({}, e, {
        isSourcePublic: !0
      });
    case jI:
      return N0({}, e, {
        targetIds: n.targetIds
      });
    case zI:
      return e.targetIds.indexOf(n.targetId) === -1 ? e : N0({}, e, {
        targetIds: V2e(e.targetIds, n.targetId)
      });
    case LI:
      return N0({}, e, {
        dropResult: n.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case kI:
      return N0({}, e, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return e;
  }
}
function HVe(e = 0, t) {
  switch (t.type) {
    case mW:
    case vW:
      return e + 1;
    case yW:
    case zI:
      return e - 1;
    default:
      return e;
  }
}
function qVe(e = 0) {
  return e + 1;
}
function $Ve(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function GVe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      $Ve(e, i, n[i]);
    });
  }
  return e;
}
function YVe(e = {}, t) {
  return {
    dirtyHandlerIds: kVe(e.dirtyHandlerIds, {
      type: t.type,
      payload: GVe({}, t.payload, {
        prevTargetIds: B2e(e, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: VVe(e.dragOffset, t),
    refCount: HVe(e.refCount, t),
    dragOperation: WVe(e.dragOperation, t),
    stateId: qVe(e.stateId)
  };
}
function XVe(e, t = void 0, n = {}, r = !1) {
  const i = ZVe(r), o = new mVe(i, new NVe(i)), s = new dVe(i, o), u = e(s, t, n);
  return s.receiveBackend(u), s;
}
function ZVe(e) {
  const t = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return Nae(YVe, e && t && t({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function KVe(e, t) {
  if (e == null) return {};
  var n = QVe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function QVe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
let oX = 0;
const UO = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var Bae = /* @__PURE__ */ ohe(function(t) {
  var { children: n } = t, r = KVe(t, [
    "children"
  ]);
  const [i, o] = JVe(r);
  return ln(() => {
    if (o) {
      const s = Vae();
      return ++oX, () => {
        --oX === 0 && (s[UO] = null);
      };
    }
  }, []), /* @__PURE__ */ T.jsx(NI.Provider, {
    value: i,
    children: n
  });
});
function JVe(e) {
  if ("manager" in e)
    return [
      {
        dragDropManager: e.manager
      },
      !1
    ];
  const t = eUe(e.backend, e.context, e.options, e.debugMode), n = !e.context;
  return [
    t,
    n
  ];
}
function eUe(e, t = Vae(), n, r) {
  const i = t;
  return i[UO] || (i[UO] = {
    dragDropManager: XVe(e, t, n, r)
  }), i[UO];
}
function Vae() {
  return typeof global < "u" ? global : window;
}
var zz, aX;
function tUe() {
  return aX || (aX = 1, zz = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, i, o;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (i = r; i-- !== 0; )
          if (!e(t[i], n[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
      for (i = r; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var s = o[i];
        if (!e(t[s], n[s])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), zz;
}
var nUe = tUe();
const rUe = /* @__PURE__ */ Hn(nUe), Uv = typeof window < "u" ? bJ : ln;
function iUe(e, t, n) {
  const [r, i] = Bn(
    () => t(e)
  ), o = Yn(() => {
    const s = t(e);
    rUe(r, s) || (i(s), n && n());
  }, [
    r,
    e,
    n
  ]);
  return Uv(o), [
    r,
    o
  ];
}
function oUe(e, t, n) {
  const [r, i] = iUe(e, t, n);
  return Uv(function() {
    const s = e.getHandlerId();
    if (s != null)
      return e.subscribeToStateChange(i, {
        handlerIds: [
          s
        ]
      });
  }, [
    e,
    i
  ]), r;
}
function Uae(e, t, n) {
  return oUe(
    t,
    e || (() => ({})),
    () => n.reconnect()
  );
}
function Fae(e, t) {
  const n = [];
  return typeof e != "function" && n.push(e), Ui(() => typeof e == "function" ? e() : e, n);
}
function aUe(e) {
  return Ui(
    () => e.hooks.dragSource(),
    [
      e
    ]
  );
}
function sUe(e) {
  return Ui(
    () => e.hooks.dragPreview(),
    [
      e
    ]
  );
}
let Bz = !1, Vz = !1;
class lUe {
  receiveHandlerId(t) {
    this.sourceId = t;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    Rn(!Bz, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return Bz = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      Bz = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    Rn(!Vz, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return Vz = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      Vz = !1;
    }
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  isDraggingSource(t) {
    return this.internalMonitor.isDraggingSource(t);
  }
  isOverTarget(t, n) {
    return this.internalMonitor.isOverTarget(t, n);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(t) {
    return this.internalMonitor.subscribeToOffsetChange(t);
  }
  canDragSource(t) {
    return this.internalMonitor.canDragSource(t);
  }
  canDropOnTarget(t) {
    return this.internalMonitor.canDropOnTarget(t);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.sourceId = null, this.internalMonitor = t.getMonitor();
  }
}
let Uz = !1;
class cUe {
  receiveHandlerId(t) {
    this.targetId = t;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    Rn(!Uz, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return Uz = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      Uz = !1;
    }
  }
  isOver(t) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, t) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.targetId = null, this.internalMonitor = t.getMonitor();
  }
}
function uUe(e, t, n) {
  const r = n.getRegistry(), i = r.addTarget(e, t);
  return [
    i,
    () => r.removeTarget(i)
  ];
}
function dUe(e, t, n) {
  const r = n.getRegistry(), i = r.addSource(e, t);
  return [
    i,
    () => r.removeSource(i)
  ];
}
function _V(e, t, n, r) {
  let i;
  if (i !== void 0)
    return !!i;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  const o = Object.keys(e), s = Object.keys(t);
  if (o.length !== s.length)
    return !1;
  const u = Object.prototype.hasOwnProperty.bind(t);
  for (let f = 0; f < o.length; f++) {
    const p = o[f];
    if (!u(p))
      return !1;
    const m = e[p], v = t[p];
    if (i = void 0, i === !1 || i === void 0 && m !== v)
      return !1;
  }
  return !0;
}
function CV(e) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    e !== null && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current")
  );
}
function fUe(e) {
  if (typeof e.type == "string")
    return;
  const t = e.type.displayName || e.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${t} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function pUe(e) {
  return (t = null, n = null) => {
    if (!X0(t)) {
      const o = t;
      return e(o, n), o;
    }
    const r = t;
    return fUe(r), hUe(r, n ? (o) => e(o, n) : e);
  };
}
function Wae(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    if (n.endsWith("Ref"))
      t[n] = e[n];
    else {
      const i = pUe(r);
      t[n] = () => i;
    }
  }), t;
}
function sX(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
function hUe(e, t) {
  const n = e.ref;
  return Rn(typeof n != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), n ? jd(e, {
    ref: (r) => {
      sX(n, r), sX(t, r);
    }
  }) : jd(e, {
    ref: t
  });
}
class gUe {
  receiveHandlerId(t) {
    this.handlerId !== t && (this.handlerId = t, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(t) {
    this.dragSourceOptionsInternal = t;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(t) {
    this.dragPreviewOptionsInternal = t;
  }
  reconnect() {
    const t = this.reconnectDragSource();
    this.reconnectDragPreview(t);
  }
  reconnectDragSource() {
    const t = this.dragSource, n = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return n && this.disconnectDragSource(), this.handlerId ? t ? (n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = t, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, t, this.dragSourceOptions)), n) : (this.lastConnectedDragSource = t, n) : n;
  }
  reconnectDragPreview(t = !1) {
    const n = this.dragPreview, r = t || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (r && this.disconnectDragPreview(), !!this.handlerId) {
      if (!n) {
        this.lastConnectedDragPreview = n;
        return;
      }
      r && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = n, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, n, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !_V(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !_V(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(t) {
    this.hooks = Wae({
      dragSource: (n, r) => {
        this.clearDragSource(), this.dragSourceOptions = r || null, CV(n) ? this.dragSourceRef = n : this.dragSourceNode = n, this.reconnectDragSource();
      },
      dragPreview: (n, r) => {
        this.clearDragPreview(), this.dragPreviewOptions = r || null, CV(n) ? this.dragPreviewRef = n : this.dragPreviewNode = n, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = t;
  }
}
class mUe {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const t = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    t && this.disconnectDropTarget();
    const n = this.dropTarget;
    if (this.handlerId) {
      if (!n) {
        this.lastConnectedDropTarget = n;
        return;
      }
      t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = n, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, n, this.dropTargetOptions));
    }
  }
  receiveHandlerId(t) {
    t !== this.handlerId && (this.handlerId = t, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(t) {
    this.dropTargetOptionsInternal = t;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !_V(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(t) {
    this.hooks = Wae({
      dropTarget: (n, r) => {
        this.clearDropTarget(), this.dropTargetOptions = r, CV(n) ? this.dropTargetRef = n : this.dropTargetNode = n, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = t;
  }
}
function Hx() {
  const { dragDropManager: e } = Qi(NI);
  return Rn(e != null, "Expected drag drop context"), e;
}
function vUe(e, t) {
  const n = Hx(), r = Ui(
    () => new gUe(n.getBackend()),
    [
      n
    ]
  );
  return Uv(() => (r.dragSourceOptions = e || null, r.reconnect(), () => r.disconnectDragSource()), [
    r,
    e
  ]), Uv(() => (r.dragPreviewOptions = t || null, r.reconnect(), () => r.disconnectDragPreview()), [
    r,
    t
  ]), r;
}
function yUe() {
  const e = Hx();
  return Ui(
    () => new lUe(e),
    [
      e
    ]
  );
}
class bUe {
  beginDrag() {
    const t = this.spec, n = this.monitor;
    let r = null;
    return typeof t.item == "object" ? r = t.item : typeof t.item == "function" ? r = t.item(n) : r = {}, r ?? null;
  }
  canDrag() {
    const t = this.spec, n = this.monitor;
    return typeof t.canDrag == "boolean" ? t.canDrag : typeof t.canDrag == "function" ? t.canDrag(n) : !0;
  }
  isDragging(t, n) {
    const r = this.spec, i = this.monitor, { isDragging: o } = r;
    return o ? o(i) : n === t.getSourceId();
  }
  endDrag() {
    const t = this.spec, n = this.monitor, r = this.connector, { end: i } = t;
    i && i(n.getItem(), n), r.reconnect();
  }
  constructor(t, n, r) {
    this.spec = t, this.monitor = n, this.connector = r;
  }
}
function xUe(e, t, n) {
  const r = Ui(
    () => new bUe(e, t, n),
    [
      t,
      n
    ]
  );
  return ln(() => {
    r.spec = e;
  }, [
    e
  ]), r;
}
function SUe(e) {
  return Ui(() => {
    const t = e.type;
    return Rn(t != null, "spec.type must be defined"), t;
  }, [
    e
  ]);
}
function wUe(e, t, n) {
  const r = Hx(), i = xUe(e, t, n), o = SUe(e);
  Uv(function() {
    if (o != null) {
      const [u, f] = dUe(o, i, r);
      return t.receiveHandlerId(u), n.receiveHandlerId(u), f;
    }
  }, [
    r,
    t,
    n,
    i,
    o
  ]);
}
function TUe(e, t) {
  const n = Fae(e);
  Rn(!n.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const r = yUe(), i = vUe(n.options, n.previewOptions);
  return wUe(n, r, i), [
    Uae(n.collect, r, i),
    aUe(i),
    sUe(i)
  ];
}
function EUe(e) {
  return Ui(
    () => e.hooks.dropTarget(),
    [
      e
    ]
  );
}
function _Ue(e) {
  const t = Hx(), n = Ui(
    () => new mUe(t.getBackend()),
    [
      t
    ]
  );
  return Uv(() => (n.dropTargetOptions = e || null, n.reconnect(), () => n.disconnectDropTarget()), [
    e
  ]), n;
}
function CUe() {
  const e = Hx();
  return Ui(
    () => new cUe(e),
    [
      e
    ]
  );
}
function RUe(e) {
  const { accept: t } = e;
  return Ui(() => (Rn(e.accept != null, "accept must be defined"), Array.isArray(t) ? t : [
    t
  ]), [
    t
  ]);
}
class OUe {
  canDrop() {
    const t = this.spec, n = this.monitor;
    return t.canDrop ? t.canDrop(n.getItem(), n) : !0;
  }
  hover() {
    const t = this.spec, n = this.monitor;
    t.hover && t.hover(n.getItem(), n);
  }
  drop() {
    const t = this.spec, n = this.monitor;
    if (t.drop)
      return t.drop(n.getItem(), n);
  }
  constructor(t, n) {
    this.spec = t, this.monitor = n;
  }
}
function AUe(e, t) {
  const n = Ui(
    () => new OUe(e, t),
    [
      t
    ]
  );
  return ln(() => {
    n.spec = e;
  }, [
    e
  ]), n;
}
function DUe(e, t, n) {
  const r = Hx(), i = AUe(e, t), o = RUe(e);
  Uv(function() {
    const [u, f] = uUe(o, i, r);
    return t.receiveHandlerId(u), n.receiveHandlerId(u), f;
  }, [
    r,
    t,
    i,
    n,
    o.map(
      (s) => s.toString()
    ).join("|")
  ]);
}
function BI(e, t) {
  const n = Fae(e), r = CUe(), i = _Ue(n.options);
  return DUe(n, r, i), [
    Uae(n.collect, r, i),
    EUe(i)
  ];
}
var Hae = (e) => {
  throw TypeError(e);
}, qae = (e, t, n) => t.has(e) || Hae("Cannot " + n), gn = (e, t, n) => (qae(e, t, "read from private field"), n ? n.call(e) : t.get(e)), bc = (e, t, n) => t.has(e) ? Hae("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), gv = (e, t, n, r) => (qae(e, t, "write to private field"), t.set(e, n), n), Hh, IUe = class {
  constructor() {
    bc(this, Hh), this.register = (t) => {
      gn(this, Hh).push(t);
    }, this.unregister = (t) => {
      for (; gn(this, Hh).indexOf(t) !== -1; ) gn(this, Hh).splice(gn(this, Hh).indexOf(t), 1);
    }, this.backendChanged = (t) => {
      for (let n of gn(this, Hh)) n.backendChanged(t);
    }, gv(this, Hh, []);
  }
};
Hh = /* @__PURE__ */ new WeakMap();
var _l, DE, Cl, Qf, mv, RV, OV, AV, FO, WO, IE, $ae = class HO {
  constructor(t, n, r) {
    if (bc(this, _l), bc(this, DE), bc(this, Cl), bc(this, Qf), bc(this, mv), bc(this, RV, (i, o, s) => {
      if (!s.backend) throw new Error(`You must specify a 'backend' property in your Backend entry: ${JSON.stringify(s)}`);
      let u = s.backend(i, o, s.options), f = s.id, p = !s.id && u && u.constructor;
      if (p && (f = u.constructor.name), !f) throw new Error(`You must specify an 'id' property in your Backend entry: ${JSON.stringify(s)}
        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-5xx`);
      if (p && console.warn(`Deprecation notice: You are using a pipeline which doesn't include backends' 'id'.
        This might be unsupported in the future, please specify 'id' explicitely for every backend.`), gn(this, Cl)[f]) throw new Error(`You must specify a unique 'id' property in your Backend entry:
        ${JSON.stringify(s)} (conflicts with: ${JSON.stringify(gn(this, Cl)[f])})`);
      return { id: f, instance: u, preview: s.preview ?? !1, transition: s.transition, skipDispatchOnTransition: s.skipDispatchOnTransition ?? !1 };
    }), this.setup = () => {
      if (!(typeof window > "u")) {
        if (HO.isSetUp) throw new Error("Cannot have two MultiBackends at the same time.");
        HO.isSetUp = !0, gn(this, OV).call(this, window), gn(this, Cl)[gn(this, _l)].instance.setup();
      }
    }, this.teardown = () => {
      typeof window > "u" || (HO.isSetUp = !1, gn(this, AV).call(this, window), gn(this, Cl)[gn(this, _l)].instance.teardown());
    }, this.connectDragSource = (i, o, s) => gn(this, IE).call(this, "connectDragSource", i, o, s), this.connectDragPreview = (i, o, s) => gn(this, IE).call(this, "connectDragPreview", i, o, s), this.connectDropTarget = (i, o, s) => gn(this, IE).call(this, "connectDropTarget", i, o, s), this.profile = () => gn(this, Cl)[gn(this, _l)].instance.profile(), this.previewEnabled = () => gn(this, Cl)[gn(this, _l)].preview, this.previewsList = () => gn(this, DE), this.backendsList = () => gn(this, Qf), bc(this, OV, (i) => {
      for (let o of gn(this, Qf)) o.transition && i.addEventListener(o.transition.event, gn(this, FO));
    }), bc(this, AV, (i) => {
      for (let o of gn(this, Qf)) o.transition && i.removeEventListener(o.transition.event, gn(this, FO));
    }), bc(this, FO, (i) => {
      var s;
      let o = gn(this, _l);
      if (gn(this, Qf).some((u) => u.id !== gn(this, _l) && u.transition && u.transition.check(i) ? (gv(this, _l, u.id), !0) : !1), gn(this, _l) !== o) {
        gn(this, Cl)[o].instance.teardown();
        for (let [m, v] of Object.entries(gn(this, mv))) v.unsubscribe(), v.unsubscribe = gn(this, WO).call(this, v.func, ...v.args);
        gn(this, DE).backendChanged(this);
        let u = gn(this, Cl)[gn(this, _l)];
        if (u.instance.setup(), u.skipDispatchOnTransition) return;
        let f = i.constructor, p = new f(i.type, i);
        (s = i.target) == null || s.dispatchEvent(p);
      }
    }), bc(this, WO, (i, o, s, u) => gn(this, Cl)[gn(this, _l)].instance[i](o, s, u)), bc(this, IE, (i, o, s, u) => {
      let f = `${i}_${o}`, p = gn(this, WO).call(this, i, o, s, u);
      return gn(this, mv)[f] = { func: i, args: [o, s, u], unsubscribe: p }, () => {
        gn(this, mv)[f].unsubscribe(), delete gn(this, mv)[f];
      };
    }), !r || !r.backends || r.backends.length < 1) throw new Error(`You must specify at least one Backend, if you are coming from 2.x.x (or don't understand this error)
        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-2xx`);
    gv(this, DE, new IUe()), gv(this, Cl, {}), gv(this, Qf, []);
    for (let i of r.backends) {
      let o = gn(this, RV).call(this, t, n, i);
      gn(this, Cl)[o.id] = o, gn(this, Qf).push(o);
    }
    gv(this, _l, gn(this, Qf)[0].id), gv(this, mv, {});
  }
};
_l = /* @__PURE__ */ new WeakMap(), DE = /* @__PURE__ */ new WeakMap(), Cl = /* @__PURE__ */ new WeakMap(), Qf = /* @__PURE__ */ new WeakMap(), mv = /* @__PURE__ */ new WeakMap(), RV = /* @__PURE__ */ new WeakMap(), OV = /* @__PURE__ */ new WeakMap(), AV = /* @__PURE__ */ new WeakMap(), FO = /* @__PURE__ */ new WeakMap(), WO = /* @__PURE__ */ new WeakMap(), IE = /* @__PURE__ */ new WeakMap(), $ae.isSetUp = !1;
var PUe = $ae, Gae = (e, t, n) => new PUe(e, t, n);
function Yae(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
function NUe(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function MUe(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (o) => n.add(o);
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach(
    (o) => i.push(o)
  ), i;
}
class jUe {
  enter(t) {
    const n = this.entered.length, r = (i) => this.isNodeInDocument(i) && (!i.contains || i.contains(t));
    return this.entered = MUe(this.entered.filter(r), [
      t
    ]), n === 0 && this.entered.length > 0;
  }
  leave(t) {
    const n = this.entered.length;
    return this.entered = NUe(this.entered.filter(this.isNodeInDocument), t), n > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(t) {
    this.entered = [], this.isNodeInDocument = t;
  }
}
class LUe {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((t) => {
      Object.defineProperty(this.item, t, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${t}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(t) {
    if (t) {
      const n = {};
      Object.keys(this.config.exposeProperties).forEach((r) => {
        const i = this.config.exposeProperties[r];
        i != null && (n[r] = {
          value: i(t, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, n);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(t, n) {
    return n === t.getSourceId();
  }
  endDrag() {
  }
  constructor(t) {
    this.config = t, this.item = {}, this.initializeExposedProperties();
  }
}
const bW = "__NATIVE_FILE__", xW = "__NATIVE_URL__", Xae = "__NATIVE_TEXT__", Zae = "__NATIVE_HTML__", lX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE: bW,
  HTML: Zae,
  TEXT: Xae,
  URL: xW
}, Symbol.toStringTag, { value: "Module" }));
function Fz(e, t, n) {
  const r = t.reduce(
    (i, o) => i || e.getData(o),
    ""
  );
  return r ?? n;
}
const DV = {
  [bW]: {
    exposeProperties: {
      files: (e) => Array.prototype.slice.call(e.files),
      items: (e) => e.items,
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Files"
    ]
  },
  [Zae]: {
    exposeProperties: {
      html: (e, t) => Fz(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [xW]: {
    exposeProperties: {
      urls: (e, t) => Fz(e, t, "").split(`
`),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [Xae]: {
    exposeProperties: {
      text: (e, t) => Fz(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function kUe(e, t) {
  const n = DV[e];
  if (!n)
    throw new Error(`native type ${e} has no configuration`);
  const r = new LUe(n);
  return r.loadDataTransfer(t), r;
}
function Wz(e) {
  if (!e)
    return null;
  const t = Array.prototype.slice.call(e.types || []);
  return Object.keys(DV).filter((n) => {
    const r = DV[n];
    return r != null && r.matchesTypes ? r.matchesTypes.some(
      (i) => t.indexOf(i) > -1
    ) : !1;
  })[0] || null;
}
const zUe = Yae(
  () => /firefox/i.test(navigator.userAgent)
), Kae = Yae(
  () => !!window.safari
);
class cX {
  interpolate(t) {
    const { xs: n, ys: r, c1s: i, c2s: o, c3s: s } = this;
    let u = n.length - 1;
    if (t === n[u])
      return r[u];
    let f = 0, p = s.length - 1, m;
    for (; f <= p; ) {
      m = Math.floor(0.5 * (f + p));
      const S = n[m];
      if (S < t)
        f = m + 1;
      else if (S > t)
        p = m - 1;
      else
        return r[m];
    }
    u = Math.max(0, p);
    const v = t - n[u], y = v * v;
    return r[u] + i[u] * v + o[u] * y + s[u] * v * y;
  }
  constructor(t, n) {
    const { length: r } = t, i = [];
    for (let S = 0; S < r; S++)
      i.push(S);
    i.sort(
      (S, E) => t[S] < t[E] ? -1 : 1
    );
    const o = [], s = [];
    let u, f;
    for (let S = 0; S < r - 1; S++)
      u = t[S + 1] - t[S], f = n[S + 1] - n[S], o.push(u), s.push(f / u);
    const p = [
      s[0]
    ];
    for (let S = 0; S < o.length - 1; S++) {
      const E = s[S], w = s[S + 1];
      if (E * w <= 0)
        p.push(0);
      else {
        u = o[S];
        const _ = o[S + 1], O = u + _;
        p.push(3 * O / ((O + _) / E + (O + u) / w));
      }
    }
    p.push(s[s.length - 1]);
    const m = [], v = [];
    let y;
    for (let S = 0; S < p.length - 1; S++) {
      y = s[S];
      const E = p[S], w = 1 / o[S], _ = E + p[S + 1] - y - y;
      m.push((y - E - _) * w), v.push(_ * w * w);
    }
    this.xs = t, this.ys = n, this.c1s = p, this.c2s = m, this.c3s = v;
  }
}
const BUe = 1;
function Qae(e) {
  const t = e.nodeType === BUe ? e : e.parentElement;
  if (!t)
    return null;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function mO(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function VUe(e) {
  var t;
  return e.nodeName === "IMG" && (zUe() || !(!((t = document.documentElement) === null || t === void 0) && t.contains(e)));
}
function UUe(e, t, n, r) {
  let i = e ? t.width : n, o = e ? t.height : r;
  return Kae() && e && (o /= window.devicePixelRatio, i /= window.devicePixelRatio), {
    dragPreviewWidth: i,
    dragPreviewHeight: o
  };
}
function FUe(e, t, n, r, i) {
  const o = VUe(t), u = Qae(o ? e : t), f = {
    x: n.x - u.x,
    y: n.y - u.y
  }, { offsetWidth: p, offsetHeight: m } = e, { anchorX: v, anchorY: y } = r, { dragPreviewWidth: S, dragPreviewHeight: E } = UUe(o, t, p, m), w = () => {
    let k = new cX([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      f.y,
      // Align at the center
      f.y / m * E,
      // Dock to the bottom
      f.y + E - m
    ]).interpolate(y);
    return Kae() && o && (k += (window.devicePixelRatio - 1) * E), k;
  }, _ = () => new cX([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    f.x,
    // Align at the center
    f.x / p * S,
    // Dock to the right
    f.x + S - p
  ]).interpolate(v), { offsetX: O, offsetY: D } = i, P = O === 0 || O, M = D === 0 || D;
  return {
    x: P ? O : _(),
    y: M ? D : w()
  };
}
let WUe = class {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var t;
    return !((t = this.globalContext) === null || t === void 0) && t.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var t;
    return ((t = this.optionsArgs) === null || t === void 0 ? void 0 : t.rootElement) || this.window;
  }
  constructor(t, n) {
    this.ownerDocument = null, this.globalContext = t, this.optionsArgs = n;
  }
};
function HUe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function uX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      HUe(e, i, n[i]);
    });
  }
  return e;
}
class qUe {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t, n;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((t = this.dragStartSourceIds) === null || t === void 0 ? void 0 : t.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((n = this.dragOverTargetIds) === null || n === void 0 ? void 0 : n.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const t = this.rootElement;
    if (t !== void 0) {
      if (t.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      t.__isReactDndBackendSetUp = !0, this.addEventListeners(t);
    }
  }
  teardown() {
    const t = this.rootElement;
    if (t !== void 0 && (t.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var n;
      (n = this.window) === null || n === void 0 || n.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDragSource(t, n, r) {
    this.sourceNodes.set(t, n), this.sourceNodeOptions.set(t, r);
    const i = (s) => this.handleDragStart(s, t), o = (s) => this.handleSelectStart(s);
    return n.setAttribute("draggable", "true"), n.addEventListener("dragstart", i), n.addEventListener("selectstart", o), () => {
      this.sourceNodes.delete(t), this.sourceNodeOptions.delete(t), n.removeEventListener("dragstart", i), n.removeEventListener("selectstart", o), n.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(t, n) {
    const r = (s) => this.handleDragEnter(s, t), i = (s) => this.handleDragOver(s, t), o = (s) => this.handleDrop(s, t);
    return n.addEventListener("dragenter", r), n.addEventListener("dragover", i), n.addEventListener("drop", o), () => {
      n.removeEventListener("dragenter", r), n.removeEventListener("dragover", i), n.removeEventListener("drop", o);
    };
  }
  addEventListeners(t) {
    t.addEventListener && (t.addEventListener("dragstart", this.handleTopDragStart), t.addEventListener("dragstart", this.handleTopDragStartCapture, !0), t.addEventListener("dragend", this.handleTopDragEndCapture, !0), t.addEventListener("dragenter", this.handleTopDragEnter), t.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.addEventListener("dragover", this.handleTopDragOver), t.addEventListener("dragover", this.handleTopDragOverCapture, !0), t.addEventListener("drop", this.handleTopDrop), t.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(t) {
    t.removeEventListener && (t.removeEventListener("dragstart", this.handleTopDragStart), t.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), t.removeEventListener("dragend", this.handleTopDragEndCapture, !0), t.removeEventListener("dragenter", this.handleTopDragEnter), t.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.removeEventListener("dragover", this.handleTopDragOver), t.removeEventListener("dragover", this.handleTopDragOverCapture, !0), t.removeEventListener("drop", this.handleTopDrop), t.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourceNodeOptions.get(t);
    return uX({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, n || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourcePreviewNodeOptions.get(t);
    return uX({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, n || {});
  }
  isDraggingNativeItem() {
    const t = this.monitor.getItemType();
    return Object.keys(lX).some(
      (n) => lX[n] === t
    );
  }
  beginDragNativeItem(t, n) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = kUe(t, n), this.currentNativeHandle = this.registry.addSource(t, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(t) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = t;
    const n = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var r;
      return (r = this.rootElement) === null || r === void 0 ? void 0 : r.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, n);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var t;
        (t = this.window) === null || t === void 0 || t.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(t, n) {
    t.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(n));
  }
  handleDragEnter(t, n) {
    this.dragEnterTargetIds.unshift(n);
  }
  handleDragOver(t, n) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(n);
  }
  handleDrop(t, n) {
    this.dropTargetIds.unshift(n);
  }
  constructor(t, n, r) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && Qae(o) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (i) => !!(i && this.document && this.document.body && this.document.body.contains(i)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const i = this.currentDragSourceNode;
      i == null || this.isNodeInDocument(i) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (i) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(i || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (i) => {
      if (i.defaultPrevented)
        return;
      const { dragStartSourceIds: o } = this;
      this.dragStartSourceIds = null;
      const s = mO(i);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(o || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: s
      });
      const { dataTransfer: u } = i, f = Wz(u);
      if (this.monitor.isDragging()) {
        if (u && typeof u.setDragImage == "function") {
          const m = this.monitor.getSourceId(), v = this.sourceNodes.get(m), y = this.sourcePreviewNodes.get(m) || v;
          if (y) {
            const { anchorX: S, anchorY: E, offsetX: w, offsetY: _ } = this.getCurrentSourcePreviewNodeOptions(), P = FUe(v, y, s, {
              anchorX: S,
              anchorY: E
            }, {
              offsetX: w,
              offsetY: _
            });
            u.setDragImage(y, P.x, P.y);
          }
        }
        try {
          u == null || u.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(i.target);
        const { captureDraggingState: p } = this.getCurrentSourcePreviewNodeOptions();
        p ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (f)
        this.beginDragNativeItem(f);
      else {
        if (u && !u.types && (i.target && !i.target.hasAttribute || !i.target.hasAttribute("draggable")))
          return;
        i.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (i) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(i.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: u } = i, f = Wz(u);
      f && this.beginDragNativeItem(f, u);
    }, this.handleTopDragEnter = (i) => {
      const { dragEnterTargetIds: o } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = i.altKey, o.length > 0 && this.actions.hover(o, {
        clientOffset: mO(i)
      }), o.some(
        (u) => this.monitor.canDropOnTarget(u)
      ) && (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (i) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
    }, this.handleTopDragOver = (i) => {
      const { dragOverTargetIds: o } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = i.altKey, this.lastClientOffset = mO(i), this.scheduleHover(o), (o || []).some(
        (u) => this.monitor.canDropOnTarget(u)
      ) ? (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? i.preventDefault() : (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (i) => {
      this.isDraggingNativeItem() && i.preventDefault(), this.enterLeaveCounter.leave(i.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (i) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        i.preventDefault(), (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      } else Wz(i.dataTransfer) && i.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (i) => {
      const { dropTargetIds: o } = this;
      this.dropTargetIds = [], this.actions.hover(o, {
        clientOffset: mO(i)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (i) => {
      const o = i.target;
      typeof o.dragDrop == "function" && (o.tagName === "INPUT" || o.tagName === "SELECT" || o.tagName === "TEXTAREA" || o.isContentEditable || (i.preventDefault(), o.dragDrop()));
    }, this.options = new WUe(n, r), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.registry = t.getRegistry(), this.enterLeaveCounter = new jUe(this.isNodeInDocument);
  }
}
const Jae = function(t, n, r) {
  return new qUe(t, n, r);
};
var ig;
(function(e) {
  e.mouse = "mouse", e.touch = "touch", e.keyboard = "keyboard";
})(ig || (ig = {}));
class $Ue {
  get delay() {
    var t;
    return (t = this.args.delay) !== null && t !== void 0 ? t : 0;
  }
  get scrollAngleRanges() {
    return this.args.scrollAngleRanges;
  }
  get getDropTargetElementsAtPoint() {
    return this.args.getDropTargetElementsAtPoint;
  }
  get ignoreContextMenu() {
    var t;
    return (t = this.args.ignoreContextMenu) !== null && t !== void 0 ? t : !1;
  }
  get enableHoverOutsideTarget() {
    var t;
    return (t = this.args.enableHoverOutsideTarget) !== null && t !== void 0 ? t : !1;
  }
  get enableKeyboardEvents() {
    var t;
    return (t = this.args.enableKeyboardEvents) !== null && t !== void 0 ? t : !1;
  }
  get enableMouseEvents() {
    var t;
    return (t = this.args.enableMouseEvents) !== null && t !== void 0 ? t : !1;
  }
  get enableTouchEvents() {
    var t;
    return (t = this.args.enableTouchEvents) !== null && t !== void 0 ? t : !0;
  }
  get touchSlop() {
    return this.args.touchSlop || 0;
  }
  get delayTouchStart() {
    var t, n, r, i;
    return (i = (r = (t = this.args) === null || t === void 0 ? void 0 : t.delayTouchStart) !== null && r !== void 0 ? r : (n = this.args) === null || n === void 0 ? void 0 : n.delay) !== null && i !== void 0 ? i : 0;
  }
  get delayMouseStart() {
    var t, n, r, i;
    return (i = (r = (t = this.args) === null || t === void 0 ? void 0 : t.delayMouseStart) !== null && r !== void 0 ? r : (n = this.args) === null || n === void 0 ? void 0 : n.delay) !== null && i !== void 0 ? i : 0;
  }
  get window() {
    if (this.context && this.context.window)
      return this.context.window;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var t;
    if (!((t = this.context) === null || t === void 0) && t.document)
      return this.context.document;
    if (this.window)
      return this.window.document;
  }
  get rootElement() {
    var t;
    return ((t = this.args) === null || t === void 0 ? void 0 : t.rootElement) || this.document;
  }
  constructor(t, n) {
    this.args = t, this.context = n;
  }
}
function GUe(e, t, n, r) {
  return Math.sqrt(Math.pow(Math.abs(n - e), 2) + Math.pow(Math.abs(r - t), 2));
}
function YUe(e, t, n, r, i) {
  if (!i)
    return !1;
  const o = Math.atan2(r - t, n - e) * 180 / Math.PI + 180;
  for (let s = 0; s < i.length; ++s) {
    const u = i[s];
    if (u && (u.start == null || o >= u.start) && (u.end == null || o <= u.end))
      return !0;
  }
  return !1;
}
const XUe = {
  Left: 1
}, ZUe = {
  Left: 0
};
function Hz(e) {
  return e.button === void 0 || e.button === ZUe.Left;
}
function KUe(e) {
  return e.buttons === void 0 || (e.buttons & XUe.Left) === 0;
}
function ese(e) {
  return !!e.targetTouches;
}
const QUe = 1;
function JUe(e) {
  const t = e.nodeType === QUe ? e : e.parentElement;
  if (!t)
    return;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function e3e(e, t) {
  if (e.targetTouches.length === 1)
    return CA(e.targetTouches[0]);
  if (t && e.touches.length === 1 && e.touches[0].target === t.target)
    return CA(e.touches[0]);
}
function CA(e, t) {
  return ese(e) ? e3e(e, t) : {
    x: e.clientX,
    y: e.clientY
  };
}
const dX = (() => {
  let e = !1;
  try {
    addEventListener("test", () => {
    }, Object.defineProperty({}, "passive", {
      get() {
        return e = !0, !0;
      }
    }));
  } catch {
  }
  return e;
})(), hE = {
  [ig.mouse]: {
    start: "mousedown",
    move: "mousemove",
    end: "mouseup",
    contextmenu: "contextmenu"
  },
  [ig.touch]: {
    start: "touchstart",
    move: "touchmove",
    end: "touchend"
  },
  [ig.keyboard]: {
    keydown: "keydown"
  }
};
class qE {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t;
    return {
      sourceNodes: this.sourceNodes.size,
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      targetNodes: this.targetNodes.size,
      dragOverTargetIds: ((t = this.dragOverTargetIds) === null || t === void 0 ? void 0 : t.length) || 0
    };
  }
  // public for test
  get document() {
    return this.options.document;
  }
  setup() {
    const t = this.options.rootElement;
    t && (Rn(!qE.isSetUp, "Cannot have two Touch backends at the same time."), qE.isSetUp = !0, this.addEventListener(t, "start", this.getTopMoveStartHandler()), this.addEventListener(t, "start", this.handleTopMoveStartCapture, !0), this.addEventListener(t, "move", this.handleTopMove), this.addEventListener(t, "move", this.handleTopMoveCapture, !0), this.addEventListener(t, "end", this.handleTopMoveEndCapture, !0), this.options.enableMouseEvents && !this.options.ignoreContextMenu && this.addEventListener(t, "contextmenu", this.handleTopMoveEndCapture), this.options.enableKeyboardEvents && this.addEventListener(t, "keydown", this.handleCancelOnEscape, !0));
  }
  teardown() {
    const t = this.options.rootElement;
    t && (qE.isSetUp = !1, this._mouseClientOffset = {}, this.removeEventListener(t, "start", this.handleTopMoveStartCapture, !0), this.removeEventListener(t, "start", this.handleTopMoveStart), this.removeEventListener(t, "move", this.handleTopMoveCapture, !0), this.removeEventListener(t, "move", this.handleTopMove), this.removeEventListener(t, "end", this.handleTopMoveEndCapture, !0), this.options.enableMouseEvents && !this.options.ignoreContextMenu && this.removeEventListener(t, "contextmenu", this.handleTopMoveEndCapture), this.options.enableKeyboardEvents && this.removeEventListener(t, "keydown", this.handleCancelOnEscape, !0), this.uninstallSourceNodeRemovalObserver());
  }
  addEventListener(t, n, r, i = !1) {
    const o = dX ? {
      capture: i,
      passive: !1
    } : i;
    this.listenerTypes.forEach(function(s) {
      const u = hE[s][n];
      u && t.addEventListener(u, r, o);
    });
  }
  removeEventListener(t, n, r, i = !1) {
    const o = dX ? {
      capture: i,
      passive: !1
    } : i;
    this.listenerTypes.forEach(function(s) {
      const u = hE[s][n];
      u && t.removeEventListener(u, r, o);
    });
  }
  connectDragSource(t, n) {
    const r = this.handleMoveStart.bind(this, t);
    return this.sourceNodes.set(t, n), this.addEventListener(n, "start", r), () => {
      this.sourceNodes.delete(t), this.removeEventListener(n, "start", r);
    };
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDropTarget(t, n) {
    const r = this.options.rootElement;
    if (!this.document || !r)
      return () => {
      };
    const i = (o) => {
      if (!this.document || !r || !this.monitor.isDragging())
        return;
      let s;
      switch (o.type) {
        case hE.mouse.move:
          s = {
            x: o.clientX,
            y: o.clientY
          };
          break;
        case hE.touch.move:
          var u, f;
          s = {
            x: ((u = o.touches[0]) === null || u === void 0 ? void 0 : u.clientX) || 0,
            y: ((f = o.touches[0]) === null || f === void 0 ? void 0 : f.clientY) || 0
          };
          break;
      }
      const p = s != null ? this.document.elementFromPoint(s.x, s.y) : void 0, m = p && n.contains(p);
      if (p === n || m)
        return this.handleMove(o, t);
    };
    return this.addEventListener(this.document.body, "move", i), this.targetNodes.set(t, n), () => {
      this.document && (this.targetNodes.delete(t), this.removeEventListener(this.document.body, "move", i));
    };
  }
  getTopMoveStartHandler() {
    return !this.options.delayTouchStart && !this.options.delayMouseStart ? this.handleTopMoveStart : this.handleTopMoveStartDelay;
  }
  installSourceNodeRemovalObserver(t) {
    this.uninstallSourceNodeRemovalObserver(), this.draggedSourceNode = t, this.draggedSourceNodeRemovalObserver = new MutationObserver(() => {
      t && !t.parentElement && (this.resurrectSourceNode(), this.uninstallSourceNodeRemovalObserver());
    }), !(!t || !t.parentElement) && this.draggedSourceNodeRemovalObserver.observe(t.parentElement, {
      childList: !0
    });
  }
  resurrectSourceNode() {
    this.document && this.draggedSourceNode && (this.draggedSourceNode.style.display = "none", this.draggedSourceNode.removeAttribute("data-reactid"), this.document.body.appendChild(this.draggedSourceNode));
  }
  uninstallSourceNodeRemovalObserver() {
    this.draggedSourceNodeRemovalObserver && this.draggedSourceNodeRemovalObserver.disconnect(), this.draggedSourceNodeRemovalObserver = void 0, this.draggedSourceNode = void 0;
  }
  constructor(t, n, r) {
    this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && JUe(o);
    }, this.handleTopMoveStartCapture = (i) => {
      Hz(i) && (this.moveStartSourceIds = []);
    }, this.handleMoveStart = (i) => {
      Array.isArray(this.moveStartSourceIds) && this.moveStartSourceIds.unshift(i);
    }, this.handleTopMoveStart = (i) => {
      if (!Hz(i))
        return;
      const o = CA(i);
      o && (ese(i) && (this.lastTargetTouchFallback = i.targetTouches[0]), this._mouseClientOffset = o), this.waitingForDelay = !1;
    }, this.handleTopMoveStartDelay = (i) => {
      if (!Hz(i))
        return;
      const o = i.type === hE.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
      this.timeout = setTimeout(this.handleTopMoveStart.bind(this, i), o), this.waitingForDelay = !0;
    }, this.handleTopMoveCapture = () => {
      this.dragOverTargetIds = [];
    }, this.handleMove = (i, o) => {
      this.dragOverTargetIds && this.dragOverTargetIds.unshift(o);
    }, this.handleTopMove = (i) => {
      if (this.timeout && clearTimeout(this.timeout), !this.document || this.waitingForDelay)
        return;
      const { moveStartSourceIds: o, dragOverTargetIds: s } = this, u = this.options.enableHoverOutsideTarget, f = CA(i, this.lastTargetTouchFallback);
      if (!f)
        return;
      if (this._isScrolling || !this.monitor.isDragging() && YUe(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, f.x, f.y, this.options.scrollAngleRanges)) {
        this._isScrolling = !0;
        return;
      }
      if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
      this._mouseClientOffset.hasOwnProperty("x") && o && GUe(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, f.x, f.y) > (this.options.touchSlop ? this.options.touchSlop : 0) && (this.moveStartSourceIds = void 0, this.actions.beginDrag(o, {
        clientOffset: this._mouseClientOffset,
        getSourceClientOffset: this.getSourceClientOffset,
        publishSource: !1
      })), !this.monitor.isDragging())
        return;
      const p = this.sourceNodes.get(this.monitor.getSourceId());
      this.installSourceNodeRemovalObserver(p), this.actions.publishDragSource(), i.cancelable && i.preventDefault();
      const m = (s || []).map(
        (E) => this.targetNodes.get(E)
      ).filter(
        (E) => !!E
      ), v = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(f.x, f.y, m) : this.document.elementsFromPoint(f.x, f.y), y = [];
      for (const E in v) {
        if (!v.hasOwnProperty(E))
          continue;
        let w = v[E];
        for (w != null && y.push(w); w; )
          w = w.parentElement, w && y.indexOf(w) === -1 && y.push(w);
      }
      const S = y.filter(
        (E) => m.indexOf(E) > -1
      ).map(
        (E) => this._getDropTargetId(E)
      ).filter(
        (E) => !!E
      ).filter(
        (E, w, _) => _.indexOf(E) === w
      );
      if (u)
        for (const E in this.targetNodes) {
          const w = this.targetNodes.get(E);
          if (p && w && w.contains(p) && S.indexOf(E) === -1) {
            S.unshift(E);
            break;
          }
        }
      S.reverse(), this.actions.hover(S, {
        clientOffset: f
      });
    }, this._getDropTargetId = (i) => {
      const o = this.targetNodes.keys();
      let s = o.next();
      for (; s.done === !1; ) {
        const u = s.value;
        if (i === this.targetNodes.get(u))
          return u;
        s = o.next();
      }
    }, this.handleTopMoveEndCapture = (i) => {
      if (this._isScrolling = !1, this.lastTargetTouchFallback = void 0, !!KUe(i)) {
        if (!this.monitor.isDragging() || this.monitor.didDrop()) {
          this.moveStartSourceIds = void 0;
          return;
        }
        i.cancelable && i.preventDefault(), this._mouseClientOffset = {}, this.uninstallSourceNodeRemovalObserver(), this.actions.drop(), this.actions.endDrag();
      }
    }, this.handleCancelOnEscape = (i) => {
      i.key === "Escape" && this.monitor.isDragging() && (this._mouseClientOffset = {}, this.uninstallSourceNodeRemovalObserver(), this.actions.endDrag());
    }, this.options = new $Ue(r, n), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.targetNodes = /* @__PURE__ */ new Map(), this.listenerTypes = [], this._mouseClientOffset = {}, this._isScrolling = !1, this.options.enableMouseEvents && this.listenerTypes.push(ig.mouse), this.options.enableTouchEvents && this.listenerTypes.push(ig.touch), this.options.enableKeyboardEvents && this.listenerTypes.push(ig.keyboard);
  }
}
const tse = function(t, n = {}, r = {}) {
  return new qE(t, n, r);
};
var nse = (e, t) => ({ event: e, check: t }), t3e = nse("touchstart", (e) => {
  let t = e;
  return t.touches !== null && t.touches !== void 0;
}), n3e = nse("pointerdown", (e) => e.pointerType == "mouse"), r3e = { backends: [{ id: "html5", backend: Jae, transition: n3e }, { id: "touch", backend: tse, options: { enableMouseEvents: !0 }, preview: !0, transition: t3e }] }, vO = { exports: {} };
/*!
 * CSSJanus. https://github.com/cssjanus/cssjanus
 *
 * Copyright 2014 Trevor Parscal
 * Copyright 2010 Roan Kattouw
 * Copyright 2008 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var fX;
function i3e() {
  return fX || (fX = 1, (function(e, t) {
    var n;
    function r(o, s) {
      var u = [], f = 0;
      function p(v) {
        return u.push(v), s;
      }
      function m() {
        return u[f++];
      }
      return {
        /**
         * Replace matching strings with tokens.
         *
         * @param {string} str String to tokenize
         * @return {string} Tokenized string
         */
        tokenize: function(v) {
          return v.replace(o, p);
        },
        /**
         * Restores tokens to their original values.
         *
         * @param {string} str String previously run through tokenize()
         * @return {string} Original string
         */
        detokenize: function(v) {
          return v.replace(new RegExp("(" + s + ")", "g"), m);
        }
      };
    }
    function i() {
      var o = "`TMP`", s = "`NOFLIP_SINGLE`", u = "`NOFLIP_CLASS`", f = "`COMMENT`", p = "[^\\u0020-\\u007e]", m = "(?:(?:\\\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)", v = "(?:[0-9]*\\.[0-9]+|[0-9]+)", y = "(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)", S = "direction\\s*:\\s*", E = "[!#$%&*-~]", w = `['"]?\\s*`, _ = "(^|[^a-zA-Z])", O = "[^\\}]*?", D = "\\/\\*\\!?\\s*@noflip\\s*\\*\\/", P = "\\/\\*[^*]*\\*+([^\\/*][^*]*\\*+)*\\/", M = "(?:" + m + "|\\\\[^\\r\\n\\f0-9a-f])", N = "(?:[_a-z]|" + p + "|" + M + ")", k = "(?:[_a-z0-9-]|" + p + "|" + M + ")", U = "-?" + N + k + "*", H = v + "(?:\\s*" + y + "|" + U + ")?", Y = "((?:-?" + H + ")|(?:inherit|auto))", z = "((?:margin|padding|border-width)\\s*:\\s*)", V = "((?:-color|border-style)\\s*:\\s*)", F = "(#?" + k + "+|(?:rgba?|hsla?)\\([ \\d.,%-]+\\))", X = "(?:" + E + "|" + p + "|" + M + ")*?", oe = "(?![a-zA-Z])", re = "(?!(" + k + `|\\r?\\n|\\s|#|\\:|\\.|\\,|\\+|>|~|\\(|\\)|\\[|\\]|=|\\*=|~=|\\^=|'[^']*'|"[^"]*"|` + f + ")*?{)", Z = "(?!" + X + w + "\\))", ee = "(?=" + X + w + "\\))", J = "(\\s*(?:!important\\s*)?[;}])", le = /`TMP`/g, be = new RegExp(P, "gi"), ne = new RegExp("(" + D + re + "[^;}]+;?)", "gi"), ae = new RegExp("(" + D + O + "})", "gi"), ie = new RegExp("(" + S + ")ltr", "gi"), he = new RegExp("(" + S + ")rtl", "gi"), pe = new RegExp(_ + "(left)" + oe + Z + re, "gi"), me = new RegExp(_ + "(right)" + oe + Z + re, "gi"), Ee = new RegExp(_ + "(left)" + ee, "gi"), Ie = new RegExp(_ + "(right)" + ee, "gi"), Pe = new RegExp(_ + "(ltr)" + ee, "gi"), De = new RegExp(_ + "(rtl)" + ee, "gi"), Ye = new RegExp(_ + "([ns]?)e-resize", "gi"), Ue = new RegExp(_ + "([ns]?)w-resize", "gi"), ve = new RegExp(z + Y + "(\\s+)" + Y + "(\\s+)" + Y + "(\\s+)" + Y + J, "gi"), rt = new RegExp(V + F + "(\\s+)" + F + "(\\s+)" + F + "(\\s+)" + F + J, "gi"), Te = new RegExp("(background(?:-position)?\\s*:\\s*(?:[^:;}\\s]+\\s+)*?)(" + H + ")", "gi"), Je = new RegExp("(background-position-x\\s*:\\s*)(-?" + v + "%)", "gi"), L = new RegExp("(border-radius\\s*:\\s*)" + Y + "(?:(?:\\s+" + Y + ")(?:\\s+" + Y + ")?(?:\\s+" + Y + ")?)?(?:(?:(?:\\s*\\/\\s*)" + Y + ")(?:\\s+" + Y + ")?(?:\\s+" + Y + ")?(?:\\s+" + Y + ")?)?" + J, "gi"), te = new RegExp("(box-shadow\\s*:\\s*(?:inset\\s*)?)" + Y, "gi"), ge = new RegExp("(text-shadow\\s*:\\s*)" + Y + "(\\s*)" + F, "gi"), ke = new RegExp("(text-shadow\\s*:\\s*)" + F + "(\\s*)" + Y, "gi"), We = new RegExp("(text-shadow\\s*:\\s*)" + Y, "gi"), Be = new RegExp("(transform\\s*:[^;}]*)(translateX\\s*\\(\\s*)" + Y + "(\\s*\\))", "gi"), je = new RegExp("(transform\\s*:[^;}]*)(translate\\s*\\(\\s*)" + Y + "((?:\\s*,\\s*" + Y + "){0,2}\\s*\\))", "gi");
      function mt(Q, ce, _e) {
        var Fe, gt;
        return _e.slice(-1) === "%" && (Fe = _e.indexOf("."), Fe !== -1 ? (gt = _e.length - Fe - 2, _e = 100 - parseFloat(_e), _e = _e.toFixed(gt) + "%") : _e = 100 - parseFloat(_e) + "%"), ce + _e;
      }
      function qe(Q) {
        switch (Q.length) {
          case 4:
            Q = [Q[1], Q[0], Q[3], Q[2]];
            break;
          case 3:
            Q = [Q[1], Q[0], Q[1], Q[2]];
            break;
          case 2:
            Q = [Q[1], Q[0]];
            break;
          case 1:
            Q = [Q[0]];
            break;
        }
        return Q.join(" ");
      }
      function at(Q, ce) {
        var _e, Fe = [].slice.call(arguments), gt = Fe.slice(2, 6).filter(function(Yt) {
          return Yt;
        }), ct = Fe.slice(6, 10).filter(function(Yt) {
          return Yt;
        }), ht = Fe[10] || "";
        return ct.length ? _e = qe(gt) + " / " + qe(ct) : _e = qe(gt), ce + _e + ht;
      }
      function et(Q) {
        return parseFloat(Q) === 0 ? Q : Q[0] === "-" ? Q.slice(1) : "-" + Q;
      }
      function bt(Q, ce, _e) {
        return ce + et(_e);
      }
      function q(Q, ce, _e, Fe, gt) {
        return ce + _e + et(Fe) + gt;
      }
      function W(Q, ce, _e, Fe, gt) {
        return ce + _e + Fe + et(gt);
      }
      return {
        /**
         * Transform a left-to-right stylesheet to right-to-left.
         *
         * @param {string} css Stylesheet to transform
         * @param {Object} options Options
         * @param {boolean} [options.transformDirInUrl=false] Transform directions in URLs
         * (e.g. 'ltr', 'rtl')
         * @param {boolean} [options.transformEdgeInUrl=false] Transform edges in URLs
         * (e.g. 'left', 'right')
         * @return {string} Transformed stylesheet
         */
        transform: function(Q, ce) {
          var _e = new r(ne, s), Fe = new r(ae, u), gt = new r(be, f);
          return Q = gt.tokenize(
            Fe.tokenize(
              _e.tokenize(
                // We wrap tokens in ` , not ~ like the original implementation does.
                // This was done because ` is not a legal character in CSS and can only
                // occur in URLs, where we escape it to %60 before inserting our tokens.
                Q.replace("`", "%60")
              )
            )
          ), ce.transformDirInUrl && (Q = Q.replace(Pe, "$1" + o).replace(De, "$1ltr").replace(le, "rtl")), ce.transformEdgeInUrl && (Q = Q.replace(Ee, "$1" + o).replace(Ie, "$1left").replace(le, "right")), Q = Q.replace(ie, "$1" + o).replace(he, "$1ltr").replace(le, "rtl").replace(pe, "$1" + o).replace(me, "$1left").replace(le, "right").replace(Ye, "$1$2" + o).replace(Ue, "$1$2e-resize").replace(le, "w-resize").replace(L, at).replace(te, bt).replace(ge, W).replace(ke, W).replace(We, bt).replace(Be, q).replace(je, q).replace(ve, "$1$2$3$8$5$6$7$4$9").replace(rt, "$1$2$3$8$5$6$7$4$9").replace(Te, mt).replace(Je, mt), Q = _e.detokenize(
            Fe.detokenize(
              gt.detokenize(Q)
            )
          ), Q;
        }
      };
    }
    n = new i(), e.exports ? t.transform = function(o, s, u) {
      var f;
      return typeof s == "object" ? f = s : (f = {}, typeof s == "boolean" && (f.transformDirInUrl = s), typeof u == "boolean" && (f.transformEdgeInUrl = u)), n.transform(o, f);
    } : typeof window < "u" && (window.cssjanus = n);
  })(vO, vO.exports)), vO.exports;
}
var o3e = i3e();
const a3e = /* @__PURE__ */ Hn(o3e);
var ui = "-ms-", $E = "-moz-", Nr = "-webkit-", IV = "comm", S1 = "rule", SW = "decl", s3e = "@media", l3e = "@import", c3e = "@supports", rse = "@keyframes", ise = Math.abs, wW = String.fromCharCode, PV = Object.assign;
function u3e(e, t) {
  return Fo(e, 0) ^ 45 ? (((t << 2 ^ Fo(e, 0)) << 2 ^ Fo(e, 1)) << 2 ^ Fo(e, 2)) << 2 ^ Fo(e, 3) : 0;
}
function ose(e) {
  return e.trim();
}
function Jf(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function zn(e, t, n) {
  return e.replace(t, n);
}
function qO(e, t, n) {
  return e.indexOf(t, n);
}
function Fo(e, t) {
  return e.charCodeAt(t) | 0;
}
function yx(e, t, n) {
  return e.slice(t, n);
}
function ep(e) {
  return e.length;
}
function d3e(e) {
  return e.length;
}
function PE(e, t) {
  return t.push(e), e;
}
function f3e(e, t) {
  return e.map(t).join("");
}
function pX(e, t) {
  return e.filter(function(n) {
    return !Jf(n, t);
  });
}
var VI = 1, bx = 1, ase = 0, Lc = 0, co = 0, qx = "";
function UI(e, t, n, r, i, o, s, u) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: VI, column: bx, length: s, return: "", siblings: u };
}
function qh(e, t) {
  return PV(UI("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function M0(e) {
  for (; e.root; )
    e = qh(e.root, { children: [e] });
  PE(e, e.siblings);
}
function p3e() {
  return co;
}
function h3e() {
  return co = Lc > 0 ? Fo(qx, --Lc) : 0, bx--, co === 10 && (bx = 1, VI--), co;
}
function Au() {
  return co = Lc < ase ? Fo(qx, Lc++) : 0, bx++, co === 10 && (bx = 1, VI++), co;
}
function Iv() {
  return Fo(qx, Lc);
}
function $O() {
  return Lc;
}
function FI(e, t) {
  return yx(qx, e, t);
}
function NV(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function g3e(e) {
  return VI = bx = 1, ase = ep(qx = e), Lc = 0, [];
}
function m3e(e) {
  return qx = "", e;
}
function qz(e) {
  return ose(FI(Lc - 1, MV(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function v3e(e) {
  for (; (co = Iv()) && co < 33; )
    Au();
  return NV(e) > 2 || NV(co) > 3 ? "" : " ";
}
function y3e(e, t) {
  for (; --t && Au() && !(co < 48 || co > 102 || co > 57 && co < 65 || co > 70 && co < 97); )
    ;
  return FI(e, $O() + (t < 6 && Iv() == 32 && Au() == 32));
}
function MV(e) {
  for (; Au(); )
    switch (co) {
      // ] ) " '
      case e:
        return Lc;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && MV(co);
        break;
      // (
      case 40:
        e === 41 && MV(e);
        break;
      // \
      case 92:
        Au();
        break;
    }
  return Lc;
}
function b3e(e, t) {
  for (; Au() && e + co !== 57; )
    if (e + co === 84 && Iv() === 47)
      break;
  return "/*" + FI(t, Lc - 1) + "*" + wW(e === 47 ? e : Au());
}
function x3e(e) {
  for (; !NV(Iv()); )
    Au();
  return FI(e, Lc);
}
function S3e(e) {
  return m3e(GO("", null, null, null, [""], e = g3e(e), 0, [0], e));
}
function GO(e, t, n, r, i, o, s, u, f) {
  for (var p = 0, m = 0, v = s, y = 0, S = 0, E = 0, w = 1, _ = 1, O = 1, D = 0, P = "", M = i, N = o, k = r, U = P; _; )
    switch (E = D, D = Au()) {
      // (
      case 40:
        if (E != 108 && Fo(U, v - 1) == 58) {
          qO(U += zn(qz(D), "&", "&\f"), "&\f", ise(p ? u[p - 1] : 0)) != -1 && (O = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        U += qz(D);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        U += v3e(E);
        break;
      // \
      case 92:
        U += y3e($O() - 1, 7);
        continue;
      // /
      case 47:
        switch (Iv()) {
          case 42:
          case 47:
            PE(w3e(b3e(Au(), $O()), t, n, f), f);
            break;
          default:
            U += "/";
        }
        break;
      // {
      case 123 * w:
        u[p++] = ep(U) * O;
      // } ; \0
      case 125 * w:
      case 59:
      case 0:
        switch (D) {
          // \0 }
          case 0:
          case 125:
            _ = 0;
          // ;
          case 59 + m:
            O == -1 && (U = zn(U, /\f/g, "")), S > 0 && ep(U) - v && PE(S > 32 ? gX(U + ";", r, n, v - 1, f) : gX(zn(U, " ", "") + ";", r, n, v - 2, f), f);
            break;
          // @ ;
          case 59:
            U += ";";
          // { rule/at-rule
          default:
            if (PE(k = hX(U, t, n, p, m, i, u, P, M = [], N = [], v, o), o), D === 123)
              if (m === 0)
                GO(U, t, k, k, M, o, v, u, N);
              else
                switch (y === 99 && Fo(U, 3) === 110 ? 100 : y) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    GO(e, k, k, r && PE(hX(e, k, k, 0, 0, i, u, P, i, M = [], v, N), N), i, N, v, u, r ? M : N);
                    break;
                  default:
                    GO(U, k, k, k, [""], N, 0, u, N);
                }
        }
        p = m = S = 0, w = O = 1, P = U = "", v = s;
        break;
      // :
      case 58:
        v = 1 + ep(U), S = E;
      default:
        if (w < 1) {
          if (D == 123)
            --w;
          else if (D == 125 && w++ == 0 && h3e() == 125)
            continue;
        }
        switch (U += wW(D), D * w) {
          // &
          case 38:
            O = m > 0 ? 1 : (U += "\f", -1);
            break;
          // ,
          case 44:
            u[p++] = (ep(U) - 1) * O, O = 1;
            break;
          // @
          case 64:
            Iv() === 45 && (U += qz(Au())), y = Iv(), m = v = ep(P = U += x3e($O())), D++;
            break;
          // -
          case 45:
            E === 45 && ep(U) == 2 && (w = 0);
        }
    }
  return o;
}
function hX(e, t, n, r, i, o, s, u, f, p, m, v) {
  for (var y = i - 1, S = i === 0 ? o : [""], E = d3e(S), w = 0, _ = 0, O = 0; w < r; ++w)
    for (var D = 0, P = yx(e, y + 1, y = ise(_ = s[w])), M = e; D < E; ++D)
      (M = ose(_ > 0 ? S[D] + " " + P : zn(P, /&\f/g, S[D]))) && (f[O++] = M);
  return UI(e, t, n, i === 0 ? S1 : u, f, p, m, v);
}
function w3e(e, t, n, r) {
  return UI(e, t, n, IV, wW(p3e()), yx(e, 2, -2), 0, r);
}
function gX(e, t, n, r, i) {
  return UI(e, t, n, SW, yx(e, 0, r), yx(e, r + 1, -1), r, i);
}
function sse(e, t, n) {
  switch (u3e(e, t)) {
    // color-adjust
    case 5103:
      return Nr + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Nr + e + e;
    // tab-size
    case 4789:
      return $E + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Nr + e + $E + e + ui + e + e;
    // writing-mode
    case 5936:
      switch (Fo(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Nr + e + ui + zn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Nr + e + ui + zn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Nr + e + ui + zn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return Nr + e + ui + e + e;
    // order
    case 6165:
      return Nr + e + ui + "flex-" + e + e;
    // align-items
    case 5187:
      return Nr + e + zn(e, /(\w+).+(:[^]+)/, Nr + "box-$1$2" + ui + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Nr + e + ui + "flex-item-" + zn(e, /flex-|-self/g, "") + (Jf(e, /flex-|baseline/) ? "" : ui + "grid-row-" + zn(e, /flex-|-self/g, "")) + e;
    // align-content
    case 4675:
      return Nr + e + ui + "flex-line-pack" + zn(e, /align-content|flex-|-self/g, "") + e;
    // flex-shrink
    case 5548:
      return Nr + e + ui + zn(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Nr + e + ui + zn(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Nr + "box-" + zn(e, "-grow", "") + Nr + e + ui + zn(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Nr + zn(e, /([^-])(transform)/g, "$1" + Nr + "$2") + e;
    // cursor
    case 6187:
      return zn(zn(zn(e, /(zoom-|grab)/, Nr + "$1"), /(image-set)/, Nr + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return zn(e, /(image-set\([^]*)/, Nr + "$1$`$1");
    // justify-content
    case 4968:
      return zn(zn(e, /(.+:)(flex-)?(.*)/, Nr + "box-pack:$3" + ui + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Nr + e + e;
    // justify-self
    case 4200:
      if (!Jf(e, /flex-|baseline/)) return ui + "grid-column-align" + yx(e, t) + e;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return ui + zn(e, "template-", "") + e;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return n && n.some(function(r, i) {
        return t = i, Jf(r.props, /grid-\w+-end/);
      }) ? ~qO(e + (n = n[t].value), "span", 0) ? e : ui + zn(e, "-start", "") + e + ui + "grid-row-span:" + (~qO(n, "span", 0) ? Jf(n, /\d+/) : +Jf(n, /\d+/) - +Jf(e, /\d+/)) + ";" : ui + zn(e, "-start", "") + e;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return n && n.some(function(r) {
        return Jf(r.props, /grid-\w+-start/);
      }) ? e : ui + zn(zn(e, "-end", "-span"), "span ", "") + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return zn(e, /(.+)-inline(.+)/, Nr + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ep(e) - 1 - t > 6)
        switch (Fo(e, t + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Fo(e, t + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return zn(e, /(.+:)(.+)-([^]+)/, "$1" + Nr + "$2-$3$1" + $E + (Fo(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          // (s)tretch
          case 115:
            return ~qO(e, "stretch", 0) ? sse(zn(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return zn(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, i, o, s, u, f, p) {
        return ui + i + ":" + o + p + (s ? ui + i + "-span:" + (u ? f : +f - +o) + p : "") + e;
      });
    // position: sticky
    case 4949:
      if (Fo(e, t + 6) === 121)
        return zn(e, ":", ":" + Nr) + e;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Fo(e, Fo(e, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return zn(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Nr + (Fo(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Nr + "$2$3$1" + ui + "$2box$3") + e;
        // (inline-)?gri(d)
        case 100:
          return zn(e, ":", ":" + ui) + e;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return zn(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function lse(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function T3e(e, t, n, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case SW:
        e.return = sse(e.value, e.length, n);
        return;
      case rse:
        return lse([qh(e, { value: zn(e.value, "@", "@" + Nr) })], r);
      case S1:
        if (e.length)
          return f3e(n = e.props, function(i) {
            switch (Jf(i, r = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                M0(qh(e, { props: [zn(i, /:(read-\w+)/, ":" + $E + "$1")] })), M0(qh(e, { props: [i] })), PV(e, { props: pX(n, r) });
                break;
              // :placeholder
              case "::placeholder":
                M0(qh(e, { props: [zn(i, /:(plac\w+)/, ":" + Nr + "input-$1")] })), M0(qh(e, { props: [zn(i, /:(plac\w+)/, ":" + $E + "$1")] })), M0(qh(e, { props: [zn(i, /:(plac\w+)/, ui + "input-$1")] })), M0(qh(e, { props: [i] })), PV(e, { props: pX(n, r) });
                break;
            }
            return "";
          });
    }
}
function cse(e, t, n) {
  switch (e.type) {
    case l3e:
    case SW:
    case IV:
      return e.return = e.return || e.value;
    case S1:
      e.value = Array.isArray(e.props) ? e.props.join(",") : e.props, Array.isArray(e.children) && e.children.forEach(function(i) {
        i.type === IV && (i.children = i.value);
      });
  }
  var r = lse(Array.prototype.concat(e.children), cse);
  return ep(r) ? e.return = e.value + "{" + r + "}" : "";
}
function use(e, t, n, r) {
  if (e.type === rse || e.type === c3e || e.type === S1 && (!e.parent || e.parent.type === s3e || e.parent.type === S1)) {
    var i = a3e.transform(cse(e));
    e.children = i ? S3e(i)[0].children : [], e.return = "";
  }
}
Object.defineProperty(use, "name", { value: "stylisRTLPlugin" });
const E3e = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class RA {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || E3e, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, i) {
    return i && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new RA(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new RA(this.logger, t);
  }
}
var Md = new RA();
class WI {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const i = this.observers[r].get(n) || 0;
      this.observers[r].set(n, i + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((s) => {
      let [u, f] = s;
      for (let p = 0; p < f; p++)
        u(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [u, f] = s;
      for (let p = 0; p < f; p++)
        u.apply(u, [t, ...r]);
    });
  }
}
function gE() {
  let e, t;
  const n = new Promise((r, i) => {
    e = r, t = i;
  });
  return n.resolve = e, n.reject = t, n;
}
function mX(e) {
  return e == null ? "" : "" + e;
}
function _3e(e, t, n) {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}
const C3e = /###/g;
function GE(e, t, n) {
  function r(u) {
    return u && u.indexOf("###") > -1 ? u.replace(C3e, ".") : u;
  }
  function i() {
    return !e || typeof e == "string";
  }
  const o = typeof t != "string" ? t : t.split(".");
  let s = 0;
  for (; s < o.length - 1; ) {
    if (i()) return {};
    const u = r(o[s]);
    !e[u] && n && (e[u] = new n()), Object.prototype.hasOwnProperty.call(e, u) ? e = e[u] : e = {}, ++s;
  }
  return i() ? {} : {
    obj: e,
    k: r(o[s])
  };
}
function vX(e, t, n) {
  const {
    obj: r,
    k: i
  } = GE(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[i] = n;
    return;
  }
  let o = t[t.length - 1], s = t.slice(0, t.length - 1), u = GE(e, s, Object);
  for (; u.obj === void 0 && s.length; )
    o = `${s[s.length - 1]}.${o}`, s = s.slice(0, s.length - 1), u = GE(e, s, Object), u && u.obj && typeof u.obj[`${u.k}.${o}`] < "u" && (u.obj = void 0);
  u.obj[`${u.k}.${o}`] = n;
}
function R3e(e, t, n, r) {
  const {
    obj: i,
    k: o
  } = GE(e, t, Object);
  i[o] = i[o] || [], i[o].push(n);
}
function OA(e, t) {
  const {
    obj: n,
    k: r
  } = GE(e, t);
  if (n)
    return n[r];
}
function O3e(e, t, n) {
  const r = OA(e, n);
  return r !== void 0 ? r : OA(t, n);
}
function dse(e, t, n) {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : dse(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function j0(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var A3e = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function D3e(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => A3e[t]) : e;
}
class I3e {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const P3e = [" ", ",", "?", "!", ";"], N3e = new I3e(20);
function M3e(e, t, n) {
  t = t || "", n = n || "";
  const r = P3e.filter((s) => t.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (r.length === 0) return !0;
  const i = N3e.getRegExp(`(${r.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let o = !i.test(e);
  if (!o) {
    const s = e.indexOf(n);
    s > 0 && !i.test(e.substring(0, s)) && (o = !0);
  }
  return o;
}
function jV(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[t]) return e[t];
  const r = t.split(n);
  let i = e;
  for (let o = 0; o < r.length; ) {
    if (!i || typeof i != "object")
      return;
    let s, u = "";
    for (let f = o; f < r.length; ++f)
      if (f !== o && (u += n), u += r[f], s = i[u], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && f < r.length - 1)
          continue;
        o += f - o + 1;
        break;
      }
    i = s;
  }
  return i;
}
function AA(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class yX extends WI {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, s = i.ignoreJSONStructure !== void 0 ? i.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let u;
    t.indexOf(".") > -1 ? u = t.split(".") : (u = [t, n], r && (Array.isArray(r) ? u.push(...r) : typeof r == "string" && o ? u.push(...r.split(o)) : u.push(r)));
    const f = OA(this.data, u);
    return !f && !n && !r && t.indexOf(".") > -1 && (t = u[0], n = u[1], r = u.slice(2).join(".")), f || !s || typeof r != "string" ? f : jV(this.data && this.data[t] && this.data[t][n], r, o);
  }
  addResource(t, n, r, i) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let u = [t, n];
    r && (u = u.concat(s ? r.split(s) : r)), t.indexOf(".") > -1 && (u = t.split("."), i = n, n = u[1]), this.addNamespaces(n), vX(this.data, u, i), o.silent || this.emit("added", t, n, r, i);
  }
  addResources(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in r)
      (typeof r[o] == "string" || Object.prototype.toString.apply(r[o]) === "[object Array]") && this.addResource(t, n, o, r[o], {
        silent: !0
      });
    i.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, i, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, u = [t, n];
    t.indexOf(".") > -1 && (u = t.split("."), i = r, r = n, n = u[1]), this.addNamespaces(n);
    let f = OA(this.data, u) || {};
    s.skipCopy || (r = JSON.parse(JSON.stringify(r))), i ? dse(f, r, o) : f = {
      ...f,
      ...r
    }, vX(this.data, u, f), s.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((i) => n[i] && Object.keys(n[i]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var fse = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, i) {
    return e.forEach((o) => {
      this.processors[o] && (t = this.processors[o].process(t, n, r, i));
    }), t;
  }
};
const bX = {};
class DA extends WI {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), _3e(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Md.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = n.ns || this.options.defaultNS || [];
    const s = r && t.indexOf(r) > -1, u = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !M3e(t, r, i);
    if (s && !u) {
      const f = t.match(this.interpolator.nestingRegexp);
      if (f && f.length > 0)
        return {
          key: t,
          namespaces: o
        };
      const p = t.split(r);
      (r !== i || r === i && this.options.ns.indexOf(p[0]) > -1) && (o = p.shift()), t = p.join(i);
    }
    return typeof o == "string" && (o = [o]), {
      key: t,
      namespaces: o
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const i = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: u
    } = this.extractFromKey(t[t.length - 1], n), f = u[u.length - 1], p = n.lng || this.language, m = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (p && p.toLowerCase() === "cimode") {
      if (m) {
        const M = n.nsSeparator || this.options.nsSeparator;
        return i ? {
          res: `${f}${M}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: p,
          usedNS: f,
          usedParams: this.getUsedParamsDetails(n)
        } : `${f}${M}${s}`;
      }
      return i ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: p,
        usedNS: f,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    }
    const v = this.resolve(t, n);
    let y = v && v.res;
    const S = v && v.usedKey || s, E = v && v.exactUsedKey || s, w = Object.prototype.toString.apply(y), _ = ["[object Number]", "[object Function]", "[object RegExp]"], O = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, D = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (D && y && (typeof y != "string" && typeof y != "boolean" && typeof y != "number") && _.indexOf(w) < 0 && !(typeof O == "string" && w === "[object Array]")) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(S, y, {
          ...n,
          ns: u
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return i ? (v.res = M, v.usedParams = this.getUsedParamsDetails(n), v) : M;
      }
      if (o) {
        const M = w === "[object Array]", N = M ? [] : {}, k = M ? E : S;
        for (const U in y)
          if (Object.prototype.hasOwnProperty.call(y, U)) {
            const H = `${k}${o}${U}`;
            N[U] = this.translate(H, {
              ...n,
              joinArrays: !1,
              ns: u
            }), N[U] === H && (N[U] = y[U]);
          }
        y = N;
      }
    } else if (D && typeof O == "string" && w === "[object Array]")
      y = y.join(O), y && (y = this.extendTranslation(y, t, n, r));
    else {
      let M = !1, N = !1;
      const k = n.count !== void 0 && typeof n.count != "string", U = DA.hasDefaultValue(n), H = k ? this.pluralResolver.getSuffix(p, n.count, n) : "", Y = n.ordinal && k ? this.pluralResolver.getSuffix(p, n.count, {
        ordinal: !1
      }) : "", z = k && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), V = z && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${H}`] || n[`defaultValue${Y}`] || n.defaultValue;
      !this.isValidLookup(y) && U && (M = !0, y = V), this.isValidLookup(y) || (N = !0, y = s);
      const X = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && N ? void 0 : y, oe = U && V !== y && this.options.updateMissing;
      if (N || M || oe) {
        if (this.logger.log(oe ? "updateKey" : "missingKey", p, f, s, oe ? V : y), o) {
          const J = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          J && J.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let re = [];
        const Z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Z && Z[0])
          for (let J = 0; J < Z.length; J++)
            re.push(Z[J]);
        else this.options.saveMissingTo === "all" ? re = this.languageUtils.toResolveHierarchy(n.lng || this.language) : re.push(n.lng || this.language);
        const ee = (J, le, be) => {
          const ne = U && be !== y ? be : X;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(J, f, le, ne, oe, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(J, f, le, ne, oe, n), this.emit("missingKey", J, f, le, y);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? re.forEach((J) => {
          const le = this.pluralResolver.getSuffixes(J, n);
          z && n[`defaultValue${this.options.pluralSeparator}zero`] && le.indexOf(`${this.options.pluralSeparator}zero`) < 0 && le.push(`${this.options.pluralSeparator}zero`), le.forEach((be) => {
            ee([J], s + be, n[`defaultValue${be}`] || V);
          });
        }) : ee(re, s, V));
      }
      y = this.extendTranslation(y, t, n, v, r), N && y === s && this.options.appendNamespaceToMissingKey && (y = `${f}:${s}`), (N || M) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? y = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${f}:${s}` : s, M ? y : void 0) : y = this.options.parseMissingKeyHandler(y));
    }
    return i ? (v.res = y, v.usedParams = this.getUsedParamsDetails(n), v) : y;
  }
  extendTranslation(t, n, r, i, o) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || i.usedLng, i.usedNS, i.usedKey, {
        resolved: i
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const p = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let m;
      if (p) {
        const y = t.match(this.interpolator.nestingRegexp);
        m = y && y.length;
      }
      let v = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (v = {
        ...this.options.interpolation.defaultVariables,
        ...v
      }), t = this.interpolator.interpolate(t, v, r.lng || this.language, r), p) {
        const y = t.match(this.interpolator.nestingRegexp), S = y && y.length;
        m < S && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && i && i.res && (r.lng = i.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var y = arguments.length, S = new Array(y), E = 0; E < y; E++)
          S[E] = arguments[E];
        return o && o[0] === S[0] && !r.context ? (s.logger.warn(`It seems you are nesting recursively key: ${S[0]} in key: ${n[0]}`), null) : s.translate(...S, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const u = r.postProcess || this.options.postProcess, f = typeof u == "string" ? [u] : u;
    return t != null && f && f.length && r.applyPostProcessor !== !1 && (t = fse.handle(f, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...i,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, i, o, s, u;
    return typeof t == "string" && (t = [t]), t.forEach((f) => {
      if (this.isValidLookup(r)) return;
      const p = this.extractFromKey(f, n), m = p.key;
      i = m;
      let v = p.namespaces;
      this.options.fallbackNS && (v = v.concat(this.options.fallbackNS));
      const y = n.count !== void 0 && typeof n.count != "string", S = y && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), E = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", w = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      v.forEach((_) => {
        this.isValidLookup(r) || (u = _, !bX[`${w[0]}-${_}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(u) && (bX[`${w[0]}-${_}`] = !0, this.logger.warn(`key "${i}" for languages "${w.join(", ")}" won't get resolved as namespace "${u}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), w.forEach((O) => {
          if (this.isValidLookup(r)) return;
          s = O;
          const D = [m];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(D, m, O, _, n);
          else {
            let M;
            y && (M = this.pluralResolver.getSuffix(O, n.count, n));
            const N = `${this.options.pluralSeparator}zero`, k = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (y && (D.push(m + M), n.ordinal && M.indexOf(k) === 0 && D.push(m + M.replace(k, this.options.pluralSeparator)), S && D.push(m + N)), E) {
              const U = `${m}${this.options.contextSeparator}${n.context}`;
              D.push(U), y && (D.push(U + M), n.ordinal && M.indexOf(k) === 0 && D.push(U + M.replace(k, this.options.pluralSeparator)), S && D.push(U + N));
            }
          }
          let P;
          for (; P = D.pop(); )
            this.isValidLookup(r) || (o = P, r = this.getResource(O, _, P, n));
        }));
      });
    }), {
      res: r,
      usedKey: i,
      exactUsedKey: o,
      usedLng: s,
      usedNS: u
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, i) : this.resourceStore.getResource(t, n, r, i);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && typeof t.replace != "string";
    let i = r ? t.replace : t;
    if (r && typeof t.count < "u" && (i.count = t.count), this.options.interpolation.defaultVariables && (i = {
      ...this.options.interpolation.defaultVariables,
      ...i
    }), !r) {
      i = {
        ...i
      };
      for (const o of n)
        delete i[o];
    }
    return i;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
function $z(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class xX {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Md.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = AA(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = AA(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((i) => i.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $z(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $z(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = $z(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((r) => {
      if (n) return;
      const i = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(i)) && (n = i);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n) return;
      const i = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(i)) return n = i;
      n = this.options.supportedLngs.find((o) => {
        if (o === i) return o;
        if (!(o.indexOf("-") < 0 && i.indexOf("-") < 0) && o.indexOf(i) === 0)
          return o;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Object.prototype.toString.apply(t) === "[object Array]") return t;
    if (!n) return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), i = [], o = (s) => {
      s && (this.isSupportedCode(s) ? i.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(t))) : typeof t == "string" && o(this.formatLanguageCode(t)), r.forEach((s) => {
      i.indexOf(s) < 0 && o(this.formatLanguageCode(s));
    }), i;
  }
}
let j3e = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], L3e = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const k3e = ["v1", "v2", "v3"], z3e = ["v4"], SX = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function B3e() {
  const e = {};
  return j3e.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: L3e[t.fc]
      };
    });
  }), e;
}
class V3e {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Md.create("pluralResolver"), (!this.options.compatibilityJSON || z3e.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = B3e();
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(AA(t === "dev" ? "en" : t), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((i) => `${n}${i}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((i, o) => SX[i] - SX[o]).map((i) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${i}`) : r.numbers.map((i) => this.getSuffix(t, i, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const i = this.getRule(t, r);
    return i ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${i.select(n)}` : this.getSuffixRetroCompatible(i, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let i = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (i === 2 ? i = "plural" : i === 1 && (i = ""));
    const o = () => this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
    return this.options.compatibilityJSON === "v1" ? i === 1 ? "" : typeof i == "number" ? `_plural_${i.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !k3e.includes(this.options.compatibilityJSON);
  }
}
function wX(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = O3e(e, t, n);
  return !o && i && typeof n == "string" && (o = jV(e, n, r), o === void 0 && (o = jV(t, n, r))), o;
}
class U3e {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Md.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const n = t.interpolation;
    this.escape = n.escape !== void 0 ? n.escape : D3e, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? j0(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? j0(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? j0(n.nestingPrefix) : n.nestingPrefixEscaped || j0("$t("), this.nestingSuffix = n.nestingSuffix ? j0(n.nestingSuffix) : n.nestingSuffixEscaped || j0(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, i) {
    let o, s, u;
    const f = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function p(E) {
      return E.replace(/\$/g, "$$$$");
    }
    const m = (E) => {
      if (E.indexOf(this.formatSeparator) < 0) {
        const D = wX(n, f, E, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(D, void 0, r, {
          ...i,
          ...n,
          interpolationkey: E
        }) : D;
      }
      const w = E.split(this.formatSeparator), _ = w.shift().trim(), O = w.join(this.formatSeparator).trim();
      return this.format(wX(n, f, _, this.options.keySeparator, this.options.ignoreJSONStructure), O, r, {
        ...i,
        ...n,
        interpolationkey: _
      });
    };
    this.resetRegExp();
    const v = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler, y = i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (E) => p(E)
    }, {
      regex: this.regexp,
      safeValue: (E) => this.escapeValue ? p(this.escape(E)) : p(E)
    }].forEach((E) => {
      for (u = 0; o = E.regex.exec(t); ) {
        const w = o[1].trim();
        if (s = m(w), s === void 0)
          if (typeof v == "function") {
            const O = v(t, o, i);
            s = typeof O == "string" ? O : "";
          } else if (i && Object.prototype.hasOwnProperty.call(i, w))
            s = "";
          else if (y) {
            s = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${w} for interpolating ${t}`), s = "";
        else typeof s != "string" && !this.useRawValueToEscape && (s = mX(s));
        const _ = E.safeValue(s);
        if (t = t.replace(o[0], _), y ? (E.regex.lastIndex += s.length, E.regex.lastIndex -= o[0].length) : E.regex.lastIndex = 0, u++, u >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, o, s;
    function u(f, p) {
      const m = this.nestingOptionsSeparator;
      if (f.indexOf(m) < 0) return f;
      const v = f.split(new RegExp(`${m}[ ]*{`));
      let y = `{${v[1]}`;
      f = v[0], y = this.interpolate(y, s);
      const S = y.match(/'/g), E = y.match(/"/g);
      (S && S.length % 2 === 0 && !E || E.length % 2 !== 0) && (y = y.replace(/'/g, '"'));
      try {
        s = JSON.parse(y), p && (s = {
          ...p,
          ...s
        });
      } catch (w) {
        return this.logger.warn(`failed parsing options string in nesting for key ${f}`, w), `${f}${m}${y}`;
      }
      return delete s.defaultValue, f;
    }
    for (; i = this.nestingRegexp.exec(t); ) {
      let f = [];
      s = {
        ...r
      }, s = s.replace && typeof s.replace != "string" ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let p = !1;
      if (i[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(i[1])) {
        const m = i[1].split(this.formatSeparator).map((v) => v.trim());
        i[1] = m.shift(), f = m, p = !0;
      }
      if (o = n(u.call(this, i[1].trim(), s), s), o && i[0] === t && typeof o != "string") return o;
      typeof o != "string" && (o = mX(o)), o || (this.logger.warn(`missed to resolve ${i[1]} for nesting ${t}`), o = ""), p && (o = f.reduce((m, v) => this.format(m, v, r.lng, {
        ...r,
        interpolationkey: i[1].trim()
      }), o.trim())), t = t.replace(i[0], o), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
function F3e(e) {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const i = r[1].substring(0, r[1].length - 1);
    t === "currency" && i.indexOf(":") < 0 ? n.currency || (n.currency = i.trim()) : t === "relativetime" && i.indexOf(":") < 0 ? n.range || (n.range = i.trim()) : i.split(";").forEach((s) => {
      if (!s) return;
      const [u, ...f] = s.split(":"), p = f.join(":").trim().replace(/^'+|'+$/g, "");
      n[u.trim()] || (n[u.trim()] = p), p === "false" && (n[u.trim()] = !1), p === "true" && (n[u.trim()] = !0), isNaN(p) || (n[u.trim()] = parseInt(p, 10));
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function L0(e) {
  const t = {};
  return function(r, i, o) {
    const s = i + JSON.stringify(o);
    let u = t[s];
    return u || (u = e(AA(i), o), t[s] = u), u(r);
  };
}
class W3e {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Md.create("formatter"), this.options = t, this.formats = {
      number: L0((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (o) => i.format(o);
      }),
      currency: L0((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (o) => i.format(o);
      }),
      datetime: L0((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (o) => i.format(o);
      }),
      relativetime: L0((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (o) => i.format(o, r.range || "day");
      }),
      list: L0((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (o) => i.format(o);
      })
    }, this.init(t);
  }
  init(t) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = L0(n);
  }
  format(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((u, f) => {
      const {
        formatName: p,
        formatOptions: m
      } = F3e(f);
      if (this.formats[p]) {
        let v = u;
        try {
          const y = i && i.formatParams && i.formatParams[i.interpolationkey] || {}, S = y.locale || y.lng || i.locale || i.lng || r;
          v = this.formats[p](u, S, {
            ...m,
            ...i,
            ...y
          });
        } catch (y) {
          this.logger.warn(y);
        }
        return v;
      } else
        this.logger.warn(`there was no format function for ${p}`);
      return u;
    }, t);
  }
}
function H3e(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
class q3e extends WI {
  constructor(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = i, this.logger = Md.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = i.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5, this.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, i.backend, i);
  }
  queueLoad(t, n, r, i) {
    const o = {}, s = {}, u = {}, f = {};
    return t.forEach((p) => {
      let m = !0;
      n.forEach((v) => {
        const y = `${p}|${v}`;
        !r.reload && this.store.hasResourceBundle(p, v) ? this.state[y] = 2 : this.state[y] < 0 || (this.state[y] === 1 ? s[y] === void 0 && (s[y] = !0) : (this.state[y] = 1, m = !1, s[y] === void 0 && (s[y] = !0), o[y] === void 0 && (o[y] = !0), f[v] === void 0 && (f[v] = !0)));
      }), m || (u[p] = !0);
    }), (Object.keys(o).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: i
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(u),
      toLoadNamespaces: Object.keys(f)
    };
  }
  loaded(t, n, r) {
    const i = t.split("|"), o = i[0], s = i[1];
    n && this.emit("failedLoading", o, s, n), r && this.store.addResourceBundle(o, s, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2;
    const u = {};
    this.queue.forEach((f) => {
      R3e(f.loaded, [o], s), H3e(f, t), n && f.errors.push(n), f.pendingCount === 0 && !f.done && (Object.keys(f.loaded).forEach((p) => {
        u[p] || (u[p] = {});
        const m = f.loaded[p];
        m.length && m.forEach((v) => {
          u[p][v] === void 0 && (u[p][v] = !0);
        });
      }), f.done = !0, f.errors.length ? f.callback(f.errors) : f.callback());
    }), this.emit("loaded", u), this.queue = this.queue.filter((f) => !f.done);
  }
  read(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: i,
        wait: o,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const u = (p, m) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const v = this.waitingReads.shift();
        this.read(v.lng, v.ns, v.fcName, v.tried, v.wait, v.callback);
      }
      if (p && m && i < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, i + 1, o * 2, s);
        }, o);
        return;
      }
      s(p, m);
    }, f = this.backend[r].bind(this.backend);
    if (f.length === 2) {
      try {
        const p = f(t, n);
        p && typeof p.then == "function" ? p.then((m) => u(null, m)).catch(u) : u(null, p);
      } catch (p) {
        u(p);
      }
      return;
    }
    return f(t, n, u);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const o = this.queueLoad(t, n, r, i);
    if (!o.toLoad.length)
      return o.pending.length || i(), null;
    o.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), i = r[0], o = r[1];
    this.read(i, o, "read", void 0, void 0, (s, u) => {
      s && this.logger.warn(`${n}loading namespace ${o} for language ${i} failed`, s), !s && u && this.logger.log(`${n}loaded namespace ${o} for language ${i}`, u), this.loaded(t, s, u);
    });
  }
  saveMissing(t, n, r, i, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, u = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const f = {
          ...s,
          isUpdate: o
        }, p = this.backend.create.bind(this.backend);
        if (p.length < 6)
          try {
            let m;
            p.length === 5 ? m = p(t, n, r, i, f) : m = p(t, n, r, i), m && typeof m.then == "function" ? m.then((v) => u(null, v)).catch(u) : u(null, m);
          } catch (m) {
            u(m);
          }
        else
          p(t, n, r, i, u, f);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, i);
    }
  }
}
function TX() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      let n = {};
      if (typeof t[1] == "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
        const r = t[3] || t[2];
        Object.keys(r).forEach((i) => {
          n[i] = r[i];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: (e) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function EX(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function yO() {
}
function $3e(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
}
class w1 extends WI {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = EX(t), this.services = {}, this.logger = Md, this.modules = {
      external: []
    }, $3e(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const i = TX();
    this.options = {
      ...i,
      ...this.options,
      ...EX(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...i.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function o(m) {
      return m ? typeof m == "function" ? new m() : m : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? Md.init(o(this.modules.logger), this.options) : Md.init(null, this.options);
      let m;
      this.modules.formatter ? m = this.modules.formatter : typeof Intl < "u" && (m = W3e);
      const v = new xX(this.options);
      this.store = new yX(this.options.resources, this.options);
      const y = this.services;
      y.logger = Md, y.resourceStore = this.store, y.languageUtils = v, y.pluralResolver = new V3e(v, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), m && (!this.options.interpolation.format || this.options.interpolation.format === i.interpolation.format) && (y.formatter = o(m), y.formatter.init(y, this.options), this.options.interpolation.format = y.formatter.format.bind(y.formatter)), y.interpolator = new U3e(this.options), y.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, y.backendConnector = new q3e(o(this.modules.backend), y.resourceStore, y, this.options), y.backendConnector.on("*", function(S) {
        for (var E = arguments.length, w = new Array(E > 1 ? E - 1 : 0), _ = 1; _ < E; _++)
          w[_ - 1] = arguments[_];
        t.emit(S, ...w);
      }), this.modules.languageDetector && (y.languageDetector = o(this.modules.languageDetector), y.languageDetector.init && y.languageDetector.init(y, this.options.detection, this.options)), this.modules.i18nFormat && (y.i18nFormat = o(this.modules.i18nFormat), y.i18nFormat.init && y.i18nFormat.init(this)), this.translator = new DA(this.services, this.options), this.translator.on("*", function(S) {
        for (var E = arguments.length, w = new Array(E > 1 ? E - 1 : 0), _ = 1; _ < E; _++)
          w[_ - 1] = arguments[_];
        t.emit(S, ...w);
      }), this.modules.external.forEach((S) => {
        S.init && S.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = yO), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const m = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      m.length > 0 && m[0] !== "dev" && (this.options.lng = m[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((m) => {
      this[m] = function() {
        return t.store[m](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((m) => {
      this[m] = function() {
        return t.store[m](...arguments), t;
      };
    });
    const f = gE(), p = () => {
      const m = (v, y) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), f.resolve(y), r(v, y);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return m(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, m);
    };
    return this.options.resources || !this.options.initImmediate ? p() : setTimeout(p, 0), f;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : yO;
    const i = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (i && i.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const o = [], s = (u) => {
        if (!u || u === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(u).forEach((p) => {
          p !== "cimode" && o.indexOf(p) < 0 && o.push(p);
        });
      };
      i ? s(i) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((f) => s(f)), this.options.preload && this.options.preload.forEach((u) => s(u)), this.services.backendConnector.load(o, this.options.ns, (u) => {
        !u && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(u);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const i = gE();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = yO), this.services.backendConnector.reload(t, n, (o) => {
      i.resolve(), r(o);
    }), i;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && fse.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const i = gE();
    this.emit("languageChanging", t);
    const o = (f) => {
      this.language = f, this.languages = this.services.languageUtils.toResolveHierarchy(f), this.resolvedLanguage = void 0, this.setResolvedLanguage(f);
    }, s = (f, p) => {
      p ? (o(p), this.translator.changeLanguage(p), this.isLanguageChangingTo = void 0, this.emit("languageChanged", p), this.logger.log("languageChanged", p)) : this.isLanguageChangingTo = void 0, i.resolve(function() {
        return r.t(...arguments);
      }), n && n(f, function() {
        return r.t(...arguments);
      });
    }, u = (f) => {
      !t && !f && this.services.languageDetector && (f = []);
      const p = typeof f == "string" ? f : this.services.languageUtils.getBestMatchFromCodes(f);
      p && (this.language || o(p), this.translator.language || this.translator.changeLanguage(p), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(p)), this.loadResources(p, (m) => {
        s(m, p);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? u(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(u) : this.services.languageDetector.detect(u) : u(t), i;
  }
  getFixedT(t, n, r) {
    var i = this;
    const o = function(s, u) {
      let f;
      if (typeof u != "object") {
        for (var p = arguments.length, m = new Array(p > 2 ? p - 2 : 0), v = 2; v < p; v++)
          m[v - 2] = arguments[v];
        f = i.options.overloadTranslationOptionHandler([s, u].concat(m));
      } else
        f = {
          ...u
        };
      f.lng = f.lng || o.lng, f.lngs = f.lngs || o.lngs, f.ns = f.ns || o.ns, f.keyPrefix = f.keyPrefix || r || o.keyPrefix;
      const y = i.options.keySeparator || ".";
      let S;
      return f.keyPrefix && Array.isArray(s) ? S = s.map((E) => `${f.keyPrefix}${y}${E}`) : S = f.keyPrefix ? `${f.keyPrefix}${y}${s}` : s, i.t(S, f);
    };
    return typeof t == "string" ? o.lng = t : o.lngs = t, o.ns = n, o.keyPrefix = r, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], i = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const s = (u, f) => {
      const p = this.services.backendConnector.state[`${u}|${f}`];
      return p === -1 || p === 2;
    };
    if (n.precheck) {
      const u = n.precheck(this, s);
      if (u !== void 0) return u;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(r, t) && (!i || s(o, t)));
  }
  loadNamespaces(t, n) {
    const r = gE();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((i) => {
      this.options.ns.indexOf(i) < 0 && this.options.ns.push(i);
    }), this.loadResources((i) => {
      r.resolve(), n && n(i);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = gE();
    typeof t == "string" && (t = [t]);
    const i = this.options.preload || [], o = t.filter((s) => i.indexOf(s) < 0);
    return o.length ? (this.options.preload = i.concat(o), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new xX(TX());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new w1(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : yO;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const i = {
      ...this.options,
      ...t,
      isClone: !0
    }, o = new w1(i);
    return (t.debug !== void 0 || t.prefix !== void 0) && (o.logger = o.logger.clone(t)), ["store", "services", "language"].forEach((u) => {
      o[u] = this[u];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, r && (o.store = new yX(this.store.data, i), o.services.resourceStore = o.store), o.translator = new DA(o.services, i), o.translator.on("*", function(u) {
      for (var f = arguments.length, p = new Array(f > 1 ? f - 1 : 0), m = 1; m < f; m++)
        p[m - 1] = arguments[m];
      o.emit(u, ...p);
    }), o.init(i, n), o.translator.options = i, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const vs = w1.createInstance();
vs.createInstance = w1.createInstance;
const G3e = vs.createInstance;
vs.dir;
vs.init;
vs.loadResources;
vs.reloadResources;
vs.use;
vs.changeLanguage;
vs.getFixedT;
vs.t;
vs.exists;
vs.setDefaultNamespace;
vs.hasLoadedNamespace;
vs.loadNamespaces;
vs.loadLanguages;
const Y3e = { aboutThisItem: "عن هذا العنصر", addedFromUrl: "(تمت إضافته من الرابط)", addManifestUrl: "موقع المصدر", addManifestUrlHelp: "الرابط لمصدر IIIF ", addResource: "اضف مصدر", "annotationCanvasLabel_1/1": "العنصر: [{{الملصق}}]", "annotationCanvasLabel_1/2": "يسار: [{{الملصق }}]", "annotationCanvasLabel_2/2": "يمين: [{{الملصق}}]", annotations: "ملاحظات", attribution: "إسناد", attributionTitle: "حقوق", authenticationFailed: "التوثيق لم ينجح", authenticationRequired: "يجب توثيق الحساب لمنح الدخول الكامل", backToResults: "الرجوع الى النتائج", book: "كتاب", bottom: "أسفل", cancel: "الغاء", canvasIndex: "فهرس", changeTheme: "قم بتغيير الموضوع", clearSearch: "امسح", closeAddResourceForm: "إغلاق الإستمارة", closeAddResourceMenu: "إغلاق قائمة المصادر", closeCompanionWindow: "إغلاق اللوحة", closeWindow: "إغلاق النافذة", collapseSection: "تصغير جزء {{section}}", collapseSidePanel: "تصغير الشريط الجانبي", continue: "استمر", copy: "نسخ", currentItem: "العنصر الحالي", "currentItem_1/1": "العنصر الحالي", "currentItem_1/2": "يسار", "currentItem_2/2": "يمين", dark: "موضوع داكن", dismiss: "تجاهل", downloadExport: "تصدير مساحة العمل", downloadExportWorkspace: "تصدير مساحة العمل", elastic: "مرن", elasticDescription: "حرك النوافذ و غير حجمها بحرية في مساحة عمل غير محدودة. يمكن أن تتداخل النوافذ أيضاً .", emptyResourceList: "قائمة المصادر الخاصة بك فارغة.", errorDialogConfirm: "حسناً", errorDialogTitle: "لقد حدث خطأ", exitFullScreen: "خروج من الشاشة الكاملة", expandSection: "توسيع الجزء {{section}}", expandSidePanel: "توسيع الشريط الجانبي", fetchManifest: "أضف", fullScreen: "شاشة كاملة", gallery: "المعرض", hideZoomControls: "إخفاء ضوابط التكبير", highlightAllAnnotations: "تحديد الكل", iiif_homepage: "عن هذه المصدر", iiif_manifest: "IIIF قائمة ", iiif_renderings: "تنسيقات بديلة", iiif_seeAlso: "أنظر أيضا", import: "استورد ", importWorkspace: "استيراد مساحة العمل", importWorkspaceHint: "قم بلصق تركيبة Mirador 4 ليتم استيراده", item: "العنصر: {{label}}", itemList: "قائمة العناصر", language: "اللغة", layer_hide: "إخفاء الطبقة", layer_move: "تحريك الطبقة", layer_opacity: "تعتيم الطبقة", layer_show: "إظهار الطبقة", layers: "طبقات", light: "موضوع فاتح", links: "الروابط", listAllOpenWindows: "انتقل بسرعة للنافذة", login: "تسجيل الدخول", logout: "تسجيل الخروج", manifestError: "لا يمكن إضافة المصدر:", maximizeWindow: "تكبير النافذة إلى الحد الاكبر", minimizeWindow: "تصغير النافذة إلى الحد الأدنى", mirador: "Mirador", miradorResources: "مصادر Mirador ", miradorViewer: "مشاهد Mirador", more: "أكثر...", moreResults: "نتائج إضافية", mosaic: "فسيفساء", mosaicDescription: "حرك وغيٌر حجم النوافذ المتعلقة ببعضها البعض داخل الإطار المرئي.", moveCompanionWindowToBottom: "انتقل للأسفل", moveCompanionWindowToRight: "انتقل لليمين", nextCanvas: "العنصر التالي", numItems_one: "{{number}} عناصر", off: "ايقاف", openCompanionWindow_annotations: "ملاحظات", openCompanionWindow_attribution: "حقوق", openCompanionWindow_canvas: "فهرس", openCompanionWindow_info: "معلومات", openCompanionWindow_layers: "طبقات", openCompanionWindow_search: "بحث", openInCompanionWindow: "افتح في صفحة جديدة", openWindows: "النوافذ الحالية المفتوحة", pagination: "{{current}} من {{total}}", position: "مركز", previewWindowTitle: "عنوان", previousCanvas: "العنصر السابق", related: "ذات صلة", resource: "مصدر", retry: "أعد المحاولة ", right: "حق", rights: "ترخيص", searchInputLabel: "مصطلحات البحث", searchNextResult: "النتيجة التالية", searchNoResults: "لم يتم العثور على نتائج", searchPreviousResult: "النتيجة السابقة", searchSubmitAria: "ابحث", searchTitle: "بحث", selectWorkspaceMenu: "اختر نوع مساحة العمل", showingNumAnnotations_one: "تظهر {{number}} ملاحظات", showZoomControls: "اظهر عناصر التحكم بالتكبير و التصغير", sidebarPanelsNavigation: "تصفح لوح الشريط الجانبي", single: "مفرد", startHere: "إبدأ هنا", suggestSearch: 'ابحث في هذا المستند عن  "{{ query }}"', tableOfContentsList: "جدول المحتويات", theme: "موضوع", thumbnailList: "قائمة الصور المصغرة", thumbnailNavigation: "الصور المصغرة", thumbnails: "الصور المصغرة", toggleWindowSideBar: "تبديل الشريط الجانبي", tryAgain: "حاول مرة أخرى", untitled: "[بدون عنوان]", view: "شاهد", welcome: "مرحباً بكم في Mirador", window: "النافذة:  {{label}}", windowMenu: "عرض النوافذ و الصور المصغرة", windowNavigation: "تصفح النافذة", windowPluginButtons: "خيارات", windowPluginMenu: "خيارات النافذة", workspace: "مساحة العمل", workspaceFullScreen: "شاشة كاملة", workspaceMenu: "اعدادات مساحة العمل", workspaceOptions: "خيارات مساحة العمل ", workspaceSelectionTitle: "اختر نوع مساحة العمل", zoomIn: "تكبير الصورة", zoomOut: "تصغير الصورة", zoomReset: "الرجوع لحجم الصورة الأساسي" }, X3e = {
  translation: Y3e
}, Z3e = { aboutMirador: "Über Mirador", aboutThisItem: "Über dieses Element", addedFromUrl: "(Via URL hinzugefügt)", addManifestUrl: "Ort der Ressource", addManifestUrlHelp: "Die URL einer IIIF-Ressource", addResource: "Ressource hinzufügen", "annotationCanvasLabel_1/1": "Objekt: [{{label}}]", "annotationCanvasLabel_1/2": "Links: [{{label}}]", "annotationCanvasLabel_2/2": "Rechts: [{{label}}]", annotations: "Annotationen", attribution: "Zuschreibung", attributionTitle: "Rechte", authenticationFailed: "Authentifizierung fehlgeschlagen", authenticationRequired: "Für vollen Zugriff ist eine Authentifizierung nötig.", backToResults: "Zurück zur Trefferansicht", book: "Buch", bottom: "Unten", cancel: "Abbrechen", canvasIndex: "Index", changeTheme: "Farbschema ändern", clearSearch: "zurücksetzen", close: "Schließen", closeAddResourceForm: "Formular schließen", closeAddResourceMenu: "Ressourcenliste schließen", closeCompanionWindow: "Hilfsfenster schließen", closeWindow: "Fenster schließen", collapseSection: 'Bereich "{{section}}" zuklappen', collapseSidePanel: "Seitenleiste zuklappen", collection: "Sammlung", continue: "Fortfahren", copy: "Kopieren", currentItem: "Aktuelles Objekt", "currentItem_1/1": "Aktuelles Objekt", "currentItem_1/2": "Links", "currentItem_2/2": "Rechts", dark: "Dunkel", digitizedView: "Digitalisat-Ansicht", dismiss: "Verwerfen", displayNoAnnotations: "Keine hervorheben", downloadExport: "Arbeitsfläche exportieren", downloadExportWorkspace: "Arbeitsfläche exportieren", elastic: "Elastisch", elasticDescription: "Fenster können frei und unbegrenzt innerhalb der Arbeitsfläche bewegt werden und sich überlappen", emptyResourceList: "Ihre Ressourcenliste ist leer", error: "Fehler", errorDialogConfirm: "OK", errorDialogTitle: "Es ist ein Fehler aufgetreten", exitFullScreen: "Vollbildmodus verlassen", expandSection: 'Bereich "{{section}}" aufklappen', expandSidePanel: "Seitenleiste aufklappen", exportCopied: "Die Konfiguration der Arbeitsfläche wurde in die Zwischenablage kopiert.", fetchManifest: "Hinzufügen", fullScreen: "Vollbild", gallery: "Galerie", hideZoomControls: "Zoomsteuerung verbergen", highlightAllAnnotations: "Alle hervorheben", iiif_homepage: "Über diese Ressource", iiif_manifest: "IIIF-Manifest", iiif_related: "Verwandtes", iiif_renderings: "Alternative Formate", iiif_seeAlso: "Siehe auch", import: "Importieren", importWorkspace: "Arbeitsfläche importieren", importWorkspaceHint: "Fügen Sie eine Mirador-3-Konfiguration ein, die importiert werden soll.", item: "Objekt: {{label}}", itemList: "Kompaktliste", jsError: "Technische Details", jsStack: "{{ stack }}", language: "Sprache", layer_hide: "Ebene verbergen", layer_move: "Ebene verschieben", layer_moveToBackground: "Ebene in der Hintergrund verschieben", layer_moveToFront: "Ebene ganz nach vorn bringen", layer_opacity: "Ebenendeckkraft", layer_show: "Ebene anzeigen", layers: "Ebenen", light: "Hell", links: "Links", listAllOpenWindows: "Zu Fenster springen", login: "Anmelden", logout: "Abmelden", manifestError: "Die Ressource konnte nicht hinzugefügt werden:", maximizeWindow: "Fenster maximieren", minimizeWindow: "Fenster minimieren", mirador: "Mirador", miradorResources: "Mirador-Ressourcen", miradorViewer: "Mirador", more: "mehr...", moreResults: "Mehr Treffer", mosaic: "Mosaik", mosaicDescription: "Fenster können innerhalb der Arbeitsfläche in Relation zueinander verschoben und ihrer Größe verändert werden.", moveCompanionWindowToBottom: "Unten anordnen", moveCompanionWindowToRight: "Rechts anordnen", multipartCollection: "Mehrteilige Sammlung", nextCanvas: "Nächstes Objekt", noItemSelected: "Kein Objekt ausgewählt", numItems_one: "{{number}} Elemente", numItems_other: "{{number}} Elemente", off: "Keine", openCompanionWindow_annotations: "Annotationen", openCompanionWindow_attribution: "Rechte", openCompanionWindow_canvas: "Index", openCompanionWindow_info: "Informationen", openCompanionWindow_layers: "Ebenen", openCompanionWindow_search: "Suche", openInCompanionWindow: "In Hilfsfenster öffnen", openWindows: "Aktuell offene Fenster", pagination: "{{current}} von {{total}}", position: "Position", previewWindowTitle: "{{title}}", previousCanvas: "Vorheriges Objekt", related: "Verwandtes", resource: "Ressource", retry: "Erneut versuchen", right: "Rechts", rights: "Lizenz", scroll: "Kontinuierlich", searchInputLabel: "Suchbegriffe", searchNextResult: "Nächster Treffer", searchNoResults: "Keine Treffer", searchPreviousResult: "Vorheriger Treffer", searchResultsRemaining: "{{numLeft}} weitere", searchSubmitAria: "Suchen", searchTitle: "Suche", selectWorkspaceMenu: "Wählen Sie einen Arbeitsflächentyp", showCollection: "Zeige Sammlung", showingNumAnnotations_one: "{{number}} Annotation wird angezeigt", showingNumAnnotations_other: "{{number}} Annotationen werden angezeigt", showZoomControls: "Zoomsteuerung anzeigen", sidebarPanelsNavigation: "Hilfsfensternavigation", single: "Einzeln", startHere: "Hier starten", suggestSearch: 'Dieses Dokument durchsuchen nach "{{ query }}"', tableOfContentsList: "Inhaltsverzeichnis", theme: "Farbschema", thumbnailList: "Miniaturansicht", thumbnailNavigation: "Miniaturansicht", thumbnails: "Miniaturansicht", toggleWindowSideBar: "Seitenleiste umschalten", totalCollections_one: "{{count}} Sammlung", totalCollections_other: "{{count}} Sammlungen", totalManifests_one: "{{count}} Manifest", totalManifests_other: "{{count}} Manifeste", tryAgain: "Wiederholen", untitled: "[Unbenannt]", view: "Ansicht", viewWorkspaceConfiguration: "Zeige Konfiguration der Arbeitsfläche", welcome: "Willkommen bei Mirador", window: "Fenster: {{label}}", windowMenu: "Fenstermenü und Miniaturansicht", windowNavigation: "Fensternavigation", windowPluginButtons: "Optionen", windowPluginMenu: "Fensteroptionen", workspace: "Arbeitsfläche", workspaceFullScreen: "Vollbild", workspaceMenu: "Arbeitsflächenmenü", workspaceNavigation: "Arbeitsflächensteuerung", workspaceOptions: "Arbeitsflächenoptionen", workspaceSelectionTitle: "Bitte wählen Sie einen Arbeitsflächentyp", zoomIn: "Vergrößern", zoomOut: "Verkleinern", zoomReset: "Ansicht zurücksetzen" }, K3e = {
  translation: Z3e
}, Q3e = { aboutMirador: "About Project Mirador", aboutThisItem: "About this item", addedFromUrl: "(Added from URL)", addManifestUrl: "Resource location", addManifestUrlHelp: "The URL of a IIIF resource", addResource: "Add resource", "annotationCanvasLabel_1/1": "Item: [{{label}}]", "annotationCanvasLabel_1/2": "Left: [{{label}}]", "annotationCanvasLabel_2/2": "Right: [{{label}}]", annotations: "Annotations", attribution: "Attribution", attributionTitle: "Rights", authenticationFailed: "Authentication failed.", authenticationRequired: "Authentication required for full access", backToResults: "Back to results", book: "Book", bottom: "Bottom", cancel: "Cancel", canvasIndex: "Index", changeTheme: "Change theme", citationTitle: "Citation", citeThisItem: "Cite this item", clearSearch: "clear", close: "Close", closeAddResourceForm: "Close form", closeAddResourceMenu: "Close resource list", closeCompanionWindow: "Close panel", closeWindow: "Close window", collapseSection: 'Collapse "{{section}}" section', collapseSidePanel: "Collapse sidebar", collection: "Collection", continue: "Continue", copy: "Copy", currentItem: "Current item", "currentItem_1/1": "Current item", "currentItem_1/2": "Left", "currentItem_2/2": "Right", dark: "Dark theme", digitizedView: "Digitized view", dismiss: "Dismiss", displayNoAnnotations: "Highlight none", downloadExport: "Export workspace", downloadExportWorkspace: "Export workspace", elastic: "Elastic", elasticDescription: "Move and size windows freely in an unlimited workspace. Windows can overlap.", emptyResourceList: "Your resource list is empty", error: "Error", errorDialogConfirm: "OK", errorDialogTitle: "An error occurred", exitFullScreen: "Exit full screen", expandSection: 'Expand "{{section}}" section', expandSidePanel: "Expand sidebar", exportCopied: "The workspace configuration was copied to your clipboard", fetchManifest: "Add", fullScreen: "Full Screen", gallery: "Gallery", hideZoomControls: "Hide zoom controls", highlightAllAnnotations: "Highlight all", iiif_homepage: "About this resource", iiif_manifest: "IIIF manifest", iiif_related: "Related", iiif_renderings: "Alternate formats", iiif_seeAlso: "See also", import: "Import", importWorkspace: "Import workspace", importWorkspaceHint: "Paste a Mirador 4 configuration to be imported", item: "Item: {{label}}", itemList: "Item list", jsError: "Technical details", jsStack: "{{ stack }}", language: "Language", layer_hide: "Hide layer", layer_move: "Move layer", layer_moveToBackground: "Move layer to background", layer_moveToFront: "Move layer to front", layer_opacity: "Layer opacity", layer_show: "Show layer", layers: "Layers", light: "Light theme", links: "Links", listAllOpenWindows: "Jump to window", login: "Log in", logout: "Log out", manifestError: "The resource cannot be added:", maximizeWindow: "Maximize window", minimizeWindow: "Minimize window", mirador: "Mirador", miradorResources: "Mirador resources", miradorViewer: "Mirador viewer", more: "more...", moreResults: "More results", mosaic: "Mosaic", mosaicDescription: "Move and size windows in relation to each other, within the visible frame.", moveCompanionWindowToBottom: "Move to bottom", moveCompanionWindowToRight: "Move to right", multipartCollection: "Multipart Collection", nextCanvas: "Next item", noItemSelected: "No item selected", numItems_one: "{{number}} item", numItems_other: "{{number}} items", off: "Off", openCompanionWindow_annotations: "Annotations", openCompanionWindow_attribution: "Rights", openCompanionWindow_canvas: "Index", openCompanionWindow_citation: "Citation", openCompanionWindow_info: "Information", openCompanionWindow_layers: "Layers", openCompanionWindow_search: "Search", openInCompanionWindow: "Open in separate panel", openWindows: "Current open windows", pagination: "{{current}} of {{total}}", position: "Position", previewWindowTitle: "{{title}}", previousCanvas: "Previous item", related: "Related", resource: "Resource", retry: "Retry", right: "Right", rights: "License", scroll: "Scroll", searchInputLabel: "search terms", searchNextResult: "Next result", searchNoResults: "No results found", searchPreviousResult: "Previous result", searchResultsRemaining: "{{numLeft}} remaining", searchSubmitAria: "Submit search", searchTitle: "Search", selectWorkspaceMenu: "Select workspace type", showCollection: "Show collection", showingNumAnnotations_one: "Showing {{number}} annotation", showingNumAnnotations_other: "Showing {{number}} annotations", showZoomControls: "Show zoom controls", sidebarPanelsNavigation: "Sidebar panels navigation", single: "Single", startHere: "Start Here", suggestSearch: 'Search this document for "{{ query }}"', tableOfContentsList: "Table of contents", theme: "Theme", thumbnailList: "Thumbnail list", thumbnailNavigation: "Thumbnails", thumbnails: "Thumbnails", toggleWindowSideBar: "Toggle sidebar", totalCollections_one: "{{count}} collection", totalCollections_other: "{{count}} collections", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifests", tryAgain: "Try again", untitled: "[Untitled]", view: "View", viewWorkspaceConfiguration: "View workspace configuration", welcome: "Welcome to Mirador", window: "Window: {{label}}", windowMenu: "Window views & thumbnail display", windowNavigation: "Window navigation", windowPluginButtons: "Options", windowPluginMenu: "Window options", workspace: "Workspace", workspaceFullScreen: "Full screen", workspaceMenu: "Workspace settings", workspaceNavigation: "Workspace navigation", workspaceOptions: "Workspace options", workspaceSelectionTitle: "Select a workspace type", zoomIn: "Zoom in", zoomOut: "Zoom out", zoomReset: "Reset zoom" }, J3e = {
  translation: Q3e
}, eFe = { aboutMirador: "Projekti Mirador kohta", aboutThisItem: "Teave teose kohta", addedFromUrl: "(Lisatud URL-ist)", addManifestUrl: "Teose asukoht", addManifestUrlHelp: "IIIF manifesti URL", addResource: "Lisa teos", "annotationCanvasLabel_1/1": "Teos: [{{label}}]", "annotationCanvasLabel_1/2": "Vasak: [{{label}}]", "annotationCanvasLabel_2/2": "Parem: [{{label}}]", annotations: "Annotatsioonid", attribution: "Omistus", attributionTitle: "Kasutusõigused", authenticationFailed: "Autentimine ebaõnnestus", authenticationRequired: "Juurdepääsu saamiseks on vajalik autentimine.", backToResults: "Tagasi tulemustele", book: "Raamat", bottom: "All", cancel: "Katkesta", canvasIndex: "Indeks", changeTheme: "Muuda teema", clearSearch: "Puhasta", close: "Sulge", closeAddResourceForm: "Sulge vorm", closeAddResourceMenu: "Sulge teoste loend", closeCompanionWindow: "Sulge paneel", closeWindow: "Sulge aken", collapseSection: 'Sulge "{{section}}"', collapseSidePanel: "Sulge külgpaneel", collection: "Kollektsioon", continue: "Jätka", copy: "Kopeeri", currentItem: "Kuvatav lõuend", "currentItem_1/1": "Pealkiri", "currentItem_1/2": "Vasak", "currentItem_2/2": "Parem", dark: "Tume teema", digitizedView: "Digiteeritud vaade", dismiss: "Vabasta", displayNoAnnotations: "Ära kuva annotatsioone", downloadExport: "Ekspordi tööruum", downloadExportWorkspace: "Ekspordi tööruum", elastic: "Paindlik vaade", elasticDescription: "Saad akende suurust muuta ja neid vabalt tööruumis ringi liigutada.", emptyResourceList: "Teoste loend on tühi", error: "Viga", errorDialogConfirm: "OK", errorDialogTitle: "Esines viga", exitFullScreen: "Lähtesta", expandSection: 'Ava "{{section}}"', expandSidePanel: "Ava külgpaneel", exportCopied: "Tööruumi seadustused kopeeriti lõikepuhvrisse.", fetchManifest: "Lisa", fullScreen: "Täisekraan", gallery: "Galerii", hideZoomControls: "Peida suurendamisnupud", highlightAllAnnotations: "Kuva kõik annotatsioonid", iiif_homepage: "Teave teose kohta", iiif_manifest: "IIIF manifest", iiif_related: "Seotud", iiif_renderings: "Alternatiivsed vormingud", iiif_seeAlso: "Vaata ka", import: "Impordi", importWorkspace: "Impordi tööruum", importWorkspaceHint: "Kleebi imporditava tööruumi seadistused.", item: "Lõuend: {{label}}", itemList: "Lõuendite loetelu", jsError: "Tehnilised üksikasjad", jsStack: "{{ stack }}", language: "Keel", layer_hide: "Peida kiht", layer_move: "Liiguta kihti", layer_opacity: "Kihi läbipaistvus", layer_show: "Näita kihti", layers: "Kihid", light: "Hele teema", links: "Lingid", listAllOpenWindows: "Vali aken", login: "Logi sisse", logout: "Logi välja", manifestError: "Ei ole võimalik lisada soovitud teost:", maximizeWindow: "Suurenda akent", minimizeWindow: "Vähenda akent", mirador: "Mirador", miradorResources: "Miradori teoste loetelu", miradorViewer: "Miradori vaatur", more: "rohkem...", moreResults: "Veel tulemusi", mosaic: "Mosaiik", mosaicDescription: "Muuda töölaua akende suurust ja liiguta neid üksteise suhtes.", moveCompanionWindowToBottom: "Liiguta alla", moveCompanionWindowToRight: "Liiguta paremale", multipartCollection: "Mitmeosaline kollektsioon", nextCanvas: "Järgmine lõuend", noItemSelected: "Ühtegi lõuendit pole valitud.", numItems_one: "{{number}} lõuend", numItems_other: "{{number}} lõuendit", off: "Väljas", openCompanionWindow_annotations: "Annotatsioonid", openCompanionWindow_attribution: "Kasutusõigused", openCompanionWindow_canvas: "Struktuur", openCompanionWindow_info: "Teave", openCompanionWindow_layers: "Kihid", openCompanionWindow_search: "Otsing", openInCompanionWindow: "Ava eraldi paneelis", openWindows: "Hetkel avatud aknad", pagination: "{{current}} / {{total}}", position: "Asukoht", previewWindowTitle: "{{title}}", previousCanvas: "Eelmine lõuend", related: "Seotud", resource: "Teos", retry: "Proovi uuesti", right: "Parem", rights: "Kasutuslitsents", scroll: "Keri", searchInputLabel: "otsinguterminid", searchNextResult: "Järgmine tulemus", searchNoResults: "Tulemusi ei leitud", searchPreviousResult: "Eelmine tulemus", searchResultsRemaining: "{{numLeft}} alles", searchSubmitAria: "Otsi", searchTitle: "Otsi", selectWorkspaceMenu: "Vali tööruumi tüüp", showCollection: "Näita kollektsiooni", showingNumAnnotations_one: "Näitan {{number}} annotatsiooni", showingNumAnnotations_other: "Näitan {{number}} annotatsiooni", showZoomControls: "Näita suurendamisnuppe", sidebarPanelsNavigation: "Külgpaneelide navigeerimine", single: "Üksik", startHere: "Alusta siit", suggestSearch: 'Otsi sellest dokumendist "{{ query }}"', tableOfContentsList: "Sisukord", theme: "Teema", thumbnailList: "Pisipiltide loend", thumbnailNavigation: "Pisipildid", thumbnails: "Pisipildid", toggleWindowSideBar: "külgpaneel", totalCollections_one: "{{count}} kollektsioon", totalCollections_other: "{{count}} kollektsiooni", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifesti", tryAgain: "Proovi uuesti", untitled: "[Pealkiri puudub]", view: "Vaade", viewWorkspaceConfiguration: "Vaata tööruumi seadistusi", welcome: "Tere tulemast Miradori", window: "Aken: {{label}}", windowMenu: "Akna vaated ja pisipiltide kuvamine", windowNavigation: "Akna navigeerimine", windowPluginButtons: "Suvandid", windowPluginMenu: "Akna suvandid", workspace: "Tööruum", workspaceFullScreen: "Täisekraan", workspaceMenu: "Tööruumi sätted", workspaceNavigation: "Tööruumi navigeerimine", workspaceOptions: "Tööruumi valikud", workspaceSelectionTitle: "Vali tööruumi tüüp", zoomIn: "Suurenda sisse", zoomOut: "Suurenda välja", zoomReset: "Lähtesta suurendus" }, tFe = {
  translation: eFe
}, nFe = { aboutMirador: "در بارهٔ پروژه Mirador", aboutThisItem: "در بارهٔ این مورد", addedFromUrl: "(از آدرس اینترنتی ازافه شده)", addManifestUrl: "مکان منبع", addManifestUrlHelp: "آدرس اینترنتی منبع IIIF ", addResource: "منبع را ازافه کن", "annotationCanvasLabel_1/1": "مورد: [{{label}}]", "annotationCanvasLabel_1/2": "چپ: [{{label}}]", "annotationCanvasLabel_2/2": "راست: [{{label}}]", annotations: "حاشیه نویسی ها", attribution: "نسبت دادن", attributionTitle: "حقوق", authenticationFailed: "تصدیق هویت ناموفق بود.", authenticationRequired: "برای دسترسی کامل نیاز به احراز هویت", backToResults: "بازگشت به نتایج", book: "کتاب", bottom: "پایان", cancel: "لغو", canvasIndex: "فهرست راهنما", changeTheme: "تغیر زمینه", clearSearch: "پاک کن", close: "ببند", closeAddResourceForm: "پرسش‌نامه‌ را ببند", closeAddResourceMenu: "فهرست منابع را ببند", closeCompanionWindow: "پانل را ببند", closeWindow: "پنجره را ببند", collapseSection: 'بخش "{{section}}" را کوچک کنید', collapseSidePanel: "نوار کناری را کوچک کن", collection: "مجموعه", continue: "ادامه", copy: "کپی", currentItem: "مورد فعلی", "currentItem_1/1": "مورد فعلی", "currentItem_1/2": "چپ", "currentItem_2/2": "راست", dark: "زمینه تاریک", digitizedView: "نمای دیجیتالی شده", dismiss: "مرخص کن", displayNoAnnotations: "هیچ کدام را برجسته نکنید", downloadExport: "صدور فضای کاری", downloadExportWorkspace: "صدور فضای کاری", elastic: "کشدار", elasticDescription: "پنجره ها را آزادانه در یک فضای کاری نامحدود حرکت دهید و اندازه کنید. پنجره ها می تواند همپوشانی داشته باشند.", emptyResourceList: "فهرست منابع شما خالی است", error: "خطا", errorDialogConfirm: "OK", errorDialogTitle: "خطایی اتفاق افتاد", exitFullScreen: "خروج از تمام صفحه", expandSection: 'بخش "{{section}}" را باز کنید', expandSidePanel: "نوار کناری را باز کن", exportCopied: "پیکربندی فضای کاری در کلیپ بورد شما کپی شد", fetchManifest: "اضافه کن", fullScreen: "تمام صفحه", gallery: "آلبوم عکس", hideZoomControls: "کنترل های بزرگنما را مخفی کنید", highlightAllAnnotations: "همه را برجسته کنید", iiif_homepage: "در باره ی این منبع", iiif_manifest: "بیانیه ی IIIF", iiif_related: "مربوط", iiif_renderings: "فرمت های جایگزین", iiif_seeAlso: "همچنین ببینید", import: "وارد كنید", importWorkspace: "فضای کاری را وارد كنید", importWorkspaceHint: "پیکربندی Mirador 4 را برای وارد کردن جای‌گذاری کنید", item: "مورد: {{label}}", itemList: "فهرست موارد", jsError: "جزییات فنی", jsStack: "{{ stack }}", language: "زبان", layer_hide: "لایه را پنهان کنید", layer_move: "لایه را حرکت دهید", layer_opacity: "لایه کدورت", layer_show: "نمایش لایه", layers: "لایه ها", light: "زمینه رشن", links: "پیوندها", listAllOpenWindows: "پرش به پنجره", login: "وارد به سیستم", logout: "خروج از سیستم", manifestError: "منبع اضافه نمیشود :", maximizeWindow: "پنجره را به حداکثر برسانید", minimizeWindow: "پنجره را به حداقل برسانید", mirador: "Mirador", miradorResources: "منابعی Mirador", miradorViewer: "بیننده Mirador", more: "بیشتر...", moreResults: "نتایج بیشتر", mosaic: "موزائیک", mosaicDescription: "جابجایی و اندازه پنجره ها نسبت به یکدیگر، در چارچوب قابل مشاهده.", moveCompanionWindowToBottom: "حرکت به سمت پایین", moveCompanionWindowToRight: "حرکت به سمت راست", multipartCollection: "مجموعه چند قسمتی", nextCanvas: "مورد بعدی", noItemSelected: "هیچ موردی انتخاب نشده است", numItems_one: "{{number}} مورد", numItems_other: "{{number}} موارد", off: "خاموش", openCompanionWindow_annotations: "حاشیه نویسی ها", openCompanionWindow_attribution: "حقوق", openCompanionWindow_canvas: "فهرست راهنما", openCompanionWindow_info: "اطلاعات", openCompanionWindow_layers: "لایه ها", openCompanionWindow_search: "جستجو", openInCompanionWindow: "در پنل جداگانه باز کن", openWindows: "پنجره های باز", pagination: "{{total}} از {{current}}", position: "موقعیت", previewWindowTitle: "{{title}}", previousCanvas: "مورد قبلی", related: "مربوط", resource: "منبع", retry: "امتحان دوباره", right: "حقوق", rights: "مجوز", scroll: "پیمایش", searchInputLabel: "عبارات جستجو", searchNextResult: "نتیجه بعدی", searchNoResults: "نتیجه ای پیدا نشد", searchPreviousResult: "نتیجه قبلی", searchResultsRemaining: "{{numLeft}} باقی مانده", searchSubmitAria: "ارسال جستجو", searchTitle: "جستجو", selectWorkspaceMenu: "نوع فضای کار را انتخاب کنید", showCollection: "نمایش مجموعه", showingNumAnnotations_one: "نمایش {{number}} حاشیه نویسی", showingNumAnnotations_other: "نمایش {{number}} حاشیه نویسی", showZoomControls: "نمایش کنترل های بزرگنمایی", sidebarPanelsNavigation: "پانل های ناوبری نوار کناری", single: "واحد", startHere: "از اینجا شروع کنید", suggestSearch: 'این سند را برای "{{ query }}" جستجوی کنید', tableOfContentsList: "فهرست مطالب", theme: "زمینه", thumbnailList: "فهرست تصاویر بندانگشتی", thumbnailNavigation: "تصاویر بندانگشتی", thumbnails: "تصاویر بندانگشتی", toggleWindowSideBar: "نوار کناری را تغییر دهید", totalCollections_one: "{{count}} مجموعه", totalCollections_other: "{{count}} مجموعات", totalManifests_one: "{{count}} بیانیه", totalManifests_other: "{{count}} بیانیه ها", tryAgain: "دوباره امتحان کنید", untitled: "[بدون عنوان]", view: "مشاهده", viewWorkspaceConfiguration: "مشاهده پیکربندی فضای کاری", welcome: "به Mirador خوش آمدید", window: "پنجره: {{label}}", windowMenu: "نماهای پنجره و نمایش تصاویر کوچک", windowNavigation: "جهت یابی پنجره", windowPluginButtons: "گزینه ها", windowPluginMenu: "گزینه های پنجره", workspace: "فضای کار", workspaceFullScreen: "تمام صفحه", workspaceMenu: "تنظیمات فضای کاری", workspaceNavigation: "جهت یابی فضای کاری", workspaceOptions: "گزینه های فضای کاری", workspaceSelectionTitle: "نوع فضای کاری را انتخاب کنید", zoomIn: "بزرگنمایی", zoomOut: "کوچک نمایی", zoomReset: " تنظیم بزرگنما" }, rFe = {
  translation: nFe
}, iFe = { aboutMirador: "关于Mirador项目", aboutThisItem: "有关此条目", addedFromUrl: "(从URL添加)", addManifestUrl: "来源", addManifestUrlHelp: "IIIF资源的URL", addResource: "添加资源", "annotationCanvasLabel_1/1": "条目: [{{label}}]", "annotationCanvasLabel_1/2": "左方: [{{label}}]", "annotationCanvasLabel_2/2": "右方: [{{label}}]", annotations: "标注", attribution: "著作权", attributionTitle: "著作权", authenticationFailed: "认证失败。", authenticationRequired: "完全访问需要认证", backToResults: "返回到结果", book: "书籍", bottom: "下方", cancel: "取消", canvasIndex: "索引", changeTheme: "变更背景主题", clearSearch: "清除", close: "关闭", closeAddResourceForm: "关闭表格", closeAddResourceMenu: "关闭资源列表", closeCompanionWindow: "关闭附属窗口", closeWindow: "关闭窗口", collapseSection: "关闭{{section}}分页", collapseSidePanel: "关闭边栏", collection: "集合", continue: "继续", copy: "复制", currentItem: "当前条目", "currentItem_1/1": "当前条目", "currentItem_1/2": "左方", "currentItem_2/2": "右方", dark: "暗色主题", digitizedView: "数字视图", dismiss: "关闭信息", displayNoAnnotations: "不高亮", downloadExport: "导出桌面排版", downloadExportWorkspace: "导出桌面排版", elastic: "弹性", elasticDescription: "在桌面上自由摆放窗口", emptyResourceList: "空资源列表", error: "错误", errorDialogConfirm: "确定", errorDialogTitle: "发生错误", exitFullScreen: "退出全屏", expandSection: "开启{{section}}分页", expandSidePanel: "开启边栏", exportCopied: "工作区配置被复制到你的剪贴板上了", fetchManifest: "添加", fullScreen: "全屏", gallery: "画廊", hideZoomControls: "隐藏缩放选项", highlightAllAnnotations: "高亮所有标注", iiif_homepage: "主页", iiif_manifest: "IIIF清单", iiif_renderings: "其他格式", iiif_seeAlso: "另见", import: "导入", importWorkspace: "导入桌面排版", importWorkspaceHint: "在此贴上Mirador 4排版设定码", item: "条目: {{label}}", itemList: "标题列表", jsError: "技术细节", jsStack: "{{ stack }}", language: "语言", layer_hide: "隐藏图层", layer_move: "移动图层", layer_opacity: "图层不透明度", layer_show: "显示图层", layers: "图层", light: "亮色主题", links: "链接", listAllOpenWindows: "切换至窗口", login: "登入", logout: "登出", manifestError: "无法增添资源:", maximizeWindow: "窗口最大化", minimizeWindow: "窗口最小化", mirador: "Mirador", miradorResources: "Mirador资源", miradorViewer: "Mirador阅览器", more: "更多...", moreResults: "更多结果", mosaic: "马赛克", mosaicDescription: "在桌面上以格状方式排列窗口", moveCompanionWindowToBottom: "移至下方", moveCompanionWindowToRight: "移至右方", multipartCollection: "多卷集合", nextCanvas: "下一页", noItemSelected: "没有条目被选中", numItems_one: "{{number}} 项条目", numItems_other: "{{number}} 项条目", off: "关闭", openCompanionWindow_annotations: "标注", openCompanionWindow_attribution: "著作权", openCompanionWindow_canvas: "目录", openCompanionWindow_info: "资讯", openCompanionWindow_layers: "图层", openCompanionWindow_search: "搜索", openInCompanionWindow: "移至新附属窗口", openWindows: "当前窗口", pagination: "{{current}} / {{total}}", position: "位置", previewWindowTitle: "{{title}}", previousCanvas: "上一页", related: "相关信息", resource: "资源", retry: "重试", right: "右方", rights: "版权", scroll: "滚动", searchInputLabel: "搜索关键字", searchNextResult: "下一个结果", searchNoResults: "没有搜索到结果", searchPreviousResult: "前一个结果", searchResultsRemaining: "{{numLeft}}剩余", searchSubmitAria: "提交搜索", searchTitle: "搜索", selectWorkspaceMenu: "选择桌面排版方式", showCollection: "显示集合", showingNumAnnotations_one: "显示 {{number}} 项标注", showingNumAnnotations_other: "显示 {{number}} 项标注", showZoomControls: "显示缩放选项", sidebarPanelsNavigation: "切换边栏", single: "单项", startHere: "按此开始", suggestSearch: '搜索本文档以"{{ query }}"', tableOfContentsList: "目录", theme: "背景主题", thumbnailList: "缩略图列表", thumbnailNavigation: "缩略图", thumbnails: "缩略图", toggleWindowSideBar: "切换边栏开关", totalCollections_one: "{{count}} 集合", totalCollections_other: "{{count}} 集合", totalManifests_one: "{{count}} 清单", totalManifests_other: "{{count}} 清单", tryAgain: "请重试", untitled: "[无标题]", view: "条目排列方式", viewWorkspaceConfiguration: "查看工作区配置", welcome: "欢迎使用Mirador", window: "窗口: {{label}}", windowMenu: "窗口视图 & 缩略图显示", windowNavigation: "切换窗口", windowPluginButtons: "选项", windowPluginMenu: "窗口选项", workspace: "桌面", workspaceFullScreen: "全屏", workspaceMenu: "桌面设定", workspaceNavigation: "工作区导航", workspaceOptions: "桌面选项", workspaceSelectionTitle: "选择桌面排版方式", zoomIn: "放大", zoomOut: "缩小", zoomReset: "重设缩放" }, oFe = {
  translation: iFe
}, aFe = { aboutMirador: "關於Mirador項目", aboutThisItem: "有關此物件", addedFromUrl: "(從URL添加)", addManifestUrl: "來源", addManifestUrlHelp: "IIIF資源的URL", addResource: "添加資源", "annotationCanvasLabel_1/1": "物件: [{{label}}]", "annotationCanvasLabel_1/2": "左方: [{{label}}]", "annotationCanvasLabel_2/2": "右方: [{{label}}]", annotations: "標註", attribution: "著作權", attributionTitle: "著作權", authenticationFailed: "認證失敗。", authenticationRequired: "完全訪問需要認證", backToResults: "返回到結果", book: "書籍", bottom: "下方", cancel: "取消", canvasIndex: "索引", changeTheme: "變更佈景主題", clearSearch: "清除", close: "關閉", closeAddResourceForm: "關閉表格", closeAddResourceMenu: "關閉資源列表", closeCompanionWindow: "關閉附屬視窗", closeWindow: "關閉視窗", collapseSection: "關閉{{section}}分頁", collapseSidePanel: "關閉邊欄", collection: "集合", continue: "繼續", copy: "複製", currentItem: "目前物件", "currentItem_1/1": "目前物件", "currentItem_1/2": "左方", "currentItem_2/2": "右方", dark: "暗色主題", digitizedView: "數字視圖", dismiss: "關閉信息", displayNoAnnotations: "不高亮", downloadExport: "滙出桌面排版", downloadExportWorkspace: "滙出桌面排版", elastic: "彈性", elasticDescription: "在桌面上自由擺放視窗", emptyResourceList: "資源列表沒有物件", error: "錯誤", errorDialogConfirm: "確定", errorDialogTitle: "發生錯誤", exitFullScreen: "退出全螢幕", expandSection: "開啟{{section}}分頁", expandSidePanel: "開啟邊欄", exportCopied: "工作區配置被複製到你的剪貼板上了", fetchManifest: "添加", fullScreen: "全螢幕", gallery: "矩列", hideZoomControls: "隱藏縮放選項", highlightAllAnnotations: "高亮所有標註", iiif_homepage: "有關此資源", iiif_manifest: "IIIF清單", iiif_renderings: "其他格式", iiif_seeAlso: "另見", import: "滙入", importWorkspace: "滙入桌面排版", importWorkspaceHint: "在此貼上Mirador 4排版設定碼", item: "物件: {{label}}", itemList: "標題列表", jsError: "技術細節", jsStack: "{{ stack }}", language: "語言", layer_hide: "隱藏圖層", layer_move: "移動圖層", layer_opacity: "圖層不透明度", layer_show: "顯示圖層", layers: "圖層", light: "亮色主題", links: "連結", listAllOpenWindows: "切換至視窗", login: "登入", logout: "登出", manifestError: "無法增添資源:", maximizeWindow: "視窗最大化", minimizeWindow: "視窗最小化", mirador: "Mirador", miradorResources: "Mirador資源", miradorViewer: "Mirador閱覽器", more: "更多...", moreResults: "更多結果", mosaic: "馬賽克", mosaicDescription: "在桌面上以格狀方式排列視窗", moveCompanionWindowToBottom: "移至下方", moveCompanionWindowToRight: "移至右方", multipartCollection: "多卷集合", nextCanvas: "下一頁", noItemSelected: "沒有物件被選中", numItems_one: "{{number}} 項物件", numItems_other: "{{number}} 項物件", off: "關閉", openCompanionWindow_annotations: "標註", openCompanionWindow_attribution: "著作權", openCompanionWindow_canvas: "目錄", openCompanionWindow_info: "資訊", openCompanionWindow_layers: "圖層", openCompanionWindow_search: "搜索", openInCompanionWindow: "移至新附屬視窗", openWindows: "現有視窗", pagination: "{{current}} / {{total}}", position: "位置", previewWindowTitle: "{{title}}", previousCanvas: "上一頁", related: "相關資訊", resource: "資源", retry: "重試", right: "右方", rights: "版權", scroll: "滾動", searchInputLabel: "搜索關鍵字", searchNextResult: "下一個結果", searchNoResults: "沒有搜索到結果", searchPreviousResult: "前一個結果", searchResultsRemaining: "{{numLeft}}剩餘", searchSubmitAria: "提交搜索", searchTitle: "搜索", selectWorkspaceMenu: "選擇桌面排版方式", showCollection: "顯示集合", showingNumAnnotations_one: "顯示 {{number}} 項標註", showingNumAnnotations_other: "顯示 {{number}} 項標註", showZoomControls: "顯示縮放選項", sidebarPanelsNavigation: "切換邊欄", single: "單項", startHere: "按此開始", suggestSearch: '搜索本文檔以"{{ query }}"', tableOfContentsList: "目錄", theme: "佈景主題", thumbnailList: "縮略圖列表", thumbnailNavigation: "縮略圖", thumbnails: "縮略圖", toggleWindowSideBar: "切換邊欄開關", totalCollections_one: "{{count}} 集合", totalCollections_other: "{{count}} 集合", totalManifests_one: "{{count}} 清單", totalManifests_other: "{{count}} 清單", tryAgain: "請重試", untitled: "[無標題]", view: "物件排列方式", viewWorkspaceConfiguration: "查看工作區配置", welcome: "歡迎使用Mirador", window: "視窗: {{label}}", windowMenu: "視窗視圖 & 縮略圖顯示", windowNavigation: "切換視窗", windowPluginButtons: "選項", windowPluginMenu: "視窗選項", workspace: "桌面", workspaceFullScreen: "全螢幕", workspaceMenu: "桌面設定", workspaceNavigation: "工作區導航", workspaceOptions: "桌面選項", workspaceSelectionTitle: "選擇桌面排版方式", zoomIn: "放大", zoomOut: "縮小", zoomReset: "重設縮放" }, sFe = {
  translation: aFe
}, lFe = { aboutMirador: "A propos du projet Mirador", aboutThisItem: "Informations", addedFromUrl: "(Ajouté depuis une URL)", addManifestUrl: "Emplacement de la ressource", addManifestUrlHelp: "Coller ici l'URL de la ressource IIIF", addResource: "Ajouter une ressource", "annotationCanvasLabel_1/1": "Item : [{{label}}]", "annotationCanvasLabel_1/2": "Gauche : [{{label}}]", "annotationCanvasLabel_2/2": "Droite : [{{label}}]", annotations: "Annotations", attribution: "Attribution", attributionTitle: "Droits", authenticationFailed: "L'authentification a échoué.", authenticationRequired: "Authentification requise pour un accès complet", backToResults: "Retour aux résultats", book: "Livre", bottom: "Bas", cancel: "Annuler", canvasIndex: "Index", changeTheme: "Changer le thème", clearSearch: "effacer", closeAddResourceForm: "Fermer le panneau", closeAddResourceMenu: "Fermer la liste des ressources", closeCompanionWindow: "Fermer le panneau", closeWindow: "Fermer cette fenêtre", collapseSection: 'Replier la section "{{section}}"', collapseSidePanel: "Replier le panneau", continue: "Continuer", copy: "Copier", currentItem: "Image courante", "currentItem_1/1": "Image courante", "currentItem_1/2": "Gauche", "currentItem_2/2": "Droite", dark: "Thème sombre", digitizedView: "Vue de l'objet numérique", dismiss: "Rejeter", displayNoAnnotations: "Masquer tout", downloadExport: "Exporter l'espace de travail", downloadExportWorkspace: "Exporter l'espace de travail", elastic: "Elastique", elasticDescription: "Déplacer et redimensionner librement les fenêtres dans un espace de travail non limité par l'écran. Les fenêtres peuvent être superposées.", emptyResourceList: "Votre liste de ressource est vide", error: "Erreur", errorDialogConfirm: "OK", errorDialogTitle: "Une erreur est survenue", exitFullScreen: "Quitter le plein écran", expandSection: 'Déplier la section "{{section}}"', expandSidePanel: "Déplier le panneau", exportCopied: "La configuration de l'espace de travail a été copiée dans votre presse-papier", fetchManifest: "Ajouter", fullScreen: "Plein écran", gallery: "Galerie", hideZoomControls: "Désactiver les commandes de zoom", highlightAllAnnotations: "Afficher tout", iiif_homepage: "A propos de cette ressource", iiif_manifest: "Manifeste IIIF", iiif_renderings: "Formats alternatifs", iiif_seeAlso: "Voir aussi", import: "Importer", importWorkspace: "Importer un espace de travail", importWorkspaceHint: "Insérer une configuration Mirador 4 à importer", item: "Item : {{label}}", itemList: "Liste compacte", jsError: "Détails techniques", jsStack: "{{ stack }}", language: "Langue", layer_hide: "Masquer le calque", layer_move: "Déplacer le calque", layer_opacity: "Opacité du calque", layer_show: "Afficher le calque", layers: "Calques", light: "Thème clair", links: "Liens", listAllOpenWindows: "Lister les fenêtres", login: "Se connecter", logout: "Se déconnecter", manifestError: "Cette ressource ne peut pas être ajoutée :", maximizeWindow: "Agrandir cette fenêtre", minimizeWindow: "Réduire cette fenêtre", mirador: "Mirador", miradorResources: "Ressources Mirador", miradorViewer: "Visualiseur Mirador", more: "plus...", moreResults: "Plus de résultats", mosaic: "Mosaïque", mosaicDescription: "Déplacer et redimensionner les fenêtres les unes par rapport aux autres dans l'espace disponible sur l'écran", moveCompanionWindowToBottom: "Déplacer en bas", moveCompanionWindowToRight: "Déplacer à droite", nextCanvas: "Suivant", noItemSelected: "Aucun élément sélectionné", numItems_one: "{{number}} image", numItems_other: "{{number}} images", off: "aucun", openCompanionWindow_annotations: "Annotations", openCompanionWindow_attribution: "Droits", openCompanionWindow_canvas: "Index", openCompanionWindow_info: "Informations", openCompanionWindow_layers: "Calques", openCompanionWindow_search: "Rechercher", openInCompanionWindow: "Ouvrir dans un panneau séparé", openWindows: "Fenêtres ouvertes", pagination: "{{current}} sur {{total}}", position: "Position", previewWindowTitle: "{{title}}", previousCanvas: "Précédent", related: "En relation", resource: "Ressource", retry: "Réessayer", right: "Droite", rights: "Licence", scroll: "Défilement horizontal", searchInputLabel: "Chercher un mot", searchNextResult: "Résultat suivant", searchNoResults: "Aucun résultat trouvé", searchPreviousResult: "Résultat précédent", searchSubmitAria: "Lancer la recherche", searchTitle: "Rechercher", selectWorkspaceMenu: "Changer de type d'espace de travail", showCollection: "Voir la collection", showingNumAnnotations_one: "{{number}} annotation affichée", showingNumAnnotations_other: "{{number}} annotations affichées", showZoomControls: "Activer les commandes de zoom", sidebarPanelsNavigation: "Navigation dans les panneaux latéraux", single: "Simple", startHere: "Commencer ici", suggestSearch: 'Rechercher "{{ query }}" dans ce document', tableOfContentsList: "Sommaire", theme: "Thème", thumbnailList: "Liste des vignettes", thumbnailNavigation: "Vignettes", thumbnails: "Afficher les vignettes", toggleWindowSideBar: "Afficher le menu latéral", totalCollections_one: "{{count}} collection", totalCollections_other: "{{count}} collections", totalManifests_one: "{{count}} manifeste", totalManifests_other: "{{count}} manifestes", tryAgain: "Essayer à nouveau", untitled: "[Sans titre]", view: "Voir les images en mode", welcome: "Bienvenue dans Mirador", window: "Fenêtre : {{label}}", windowMenu: "Options de fenêtre", windowNavigation: "Navigation dans les fenêtres", windowPluginButtons: "Options", windowPluginMenu: "Autres options et outils", workspace: "Espace de travail", workspaceFullScreen: "Plein écran", workspaceMenu: "Réglages de l'espace de travail", workspaceNavigation: "Menu de l'espace de travail", workspaceOptions: "Options de l'espace de travail", workspaceSelectionTitle: "Sélectionner un type d'espace de travail", zoomIn: "Zoom avant", zoomOut: "Zoom arrière", zoomReset: "Réinitialiser le zoom" }, cFe = {
  translation: lFe
}, uFe = { aboutMirador: "O Projektu Mirador", aboutThisItem: "O ovom zapisu", addedFromUrl: "(Dodano s URL-a)", addManifestUrl: "Lokacija resursa", addManifestUrlHelp: "URL IIIF resursa", addResource: "Dodaj resurs", "annotationCanvasLabel_1/1": "Stavka: [{{label}}]", "annotationCanvasLabel_1/2": "Lijevo: [{{label}}]", "annotationCanvasLabel_2/2": "Desno: [{{label}}]", annotations: "Anotacije", attribution: "Pripisivanje", attributionTitle: "Prava", authenticationFailed: "Autentifikacija nije uspjela", authenticationRequired: "Potrebna je autentifikacija za potpuni pristup", backToResults: "Povratak na rezultate", book: "Knjiga", bottom: "Dno", cancel: "Otkaži", canvasIndex: "Indeks", changeTheme: "Promijeni temu", clearSearch: "očisti", close: "Zatvori", closeAddResourceForm: "Zatvori obrazac", closeAddResourceMenu: "Zatvori popis resursa", closeCompanionWindow: "Zatvori ploču", closeWindow: "Zatvori prozor", collapseSection: 'Sažmi "{{section}}" odjeljak', collapseSidePanel: "Sklopi bočnu traku", collection: "Kolekcija", continue: "Nastavi", copy: "Kopiraj", currentItem: "Trenutna stavka", "currentItem_1/1": "Trenutna stavka", "currentItem_1/2": "Lijevo", "currentItem_2/2": "Desno", dark: "Tamna tema", digitizedView: "Digitalizirani prikaz", dismiss: "Odbaci", displayNoAnnotations: "Istaknite ništa", downloadExport: "Izvezi radni prostor", downloadExportWorkspace: "Izvezi radni prostor", elastic: "Elastičan", elasticDescription: "Premještajte i mijenjajte veličinu prozora slobodno u neograničenom radnom prostoru. Prozori se mogu preklapati.", emptyResourceList: "Vaš popis resursa je prazan", error: "Greška", errorDialogConfirm: "U redu", errorDialogTitle: "Došlo je do greške", exitFullScreen: "Izađi iz punog zaslona", expandSection: 'Proširi odjeljak "{{section}}"', expandSidePanel: "Proširi bočnu traku", exportCopied: "Konfiguracija radnog prostora kopirana je u vaš međuspremnik", fetchManifest: "Dodaj", fullScreen: "Cijeli ekran", gallery: "Galerija", hideZoomControls: "Sakrij kontrole zuma", highlightAllAnnotations: "Istakni sve", iiif_homepage: "O ovom resursu", iiif_manifest: "IIIF manifest", iiif_related: "Srodno", iiif_renderings: "Alternativni formati", iiif_seeAlso: "Vidi također", import: "Uvoz", importWorkspace: "Uvezi radni prostor", importWorkspaceHint: "Zalijepite konfiguraciju Mirador 4 koju treba uvesti", item: "Stavka: {{label}}", itemList: "Popis stavki", jsError: "Tehnički detalji", jsStack: "{{ stack }}", language: "Jezik", layer_hide: "Sakrij sloj", layer_move: "Premjesti sloj", layer_opacity: "Prozirnost sloja", layer_show: "Prikaži sloj", layers: "Slojevi", light: "Svijetla tema", links: "Poveznice", listAllOpenWindows: "Skoči do prozora", login: "Prijavi se", logout: "Odjavi se", manifestError: "Resurs se ne može dodati", maximizeWindow: "Maksimiziraj prozor", minimizeWindow: "Minimiziraj prozor", mirador: "Mirador", miradorResources: "Mirador resursi", miradorViewer: "Preglednik Mirador", more: "još...", moreResults: "Više rezultata", mosaic: "Mozaik", mosaicDescription: "Pomičite i mijenjajte veličinu prozora u odnosu jedan prema drugom, unutar vidljivog okvira.", moveCompanionWindowToBottom: "Pomakni se na dno", moveCompanionWindowToRight: "Pomakni se udesno", multipartCollection: "Višedijelna zbirka", nextCanvas: "Sljedeća stavka", noItemSelected: "Nijedna stavka nije odabrana", numItems_one: "{{number}} predmet", numItems_other: "{{number}} artikala", off: "Isključeno", openCompanionWindow_annotations: "Bilješke", openCompanionWindow_attribution: "Prava", openCompanionWindow_canvas: "Indeks", openCompanionWindow_info: "Informacija", openCompanionWindow_layers: "Slojevi", openCompanionWindow_search: "Pretraživanje", openInCompanionWindow: "Otvori u zasebnom panelu", openWindows: "Trenutno otvoreni prozori", pagination: "{{current}} od {{total}}", position: "Pozicija", previewWindowTitle: "{{title}}", previousCanvas: "Prethodna stavka", related: "Srodno", resource: "Resurs", retry: "Pokušaj ponovno", right: "Desno", rights: "Licenca", scroll: "Pomakni", searchInputLabel: "pojmovima pretraživanja", searchNextResult: "Sljedeći rezultat", searchNoResults: "Nema rezultata", searchPreviousResult: "Prethodni rezultat", searchResultsRemaining: "Preostalo je {{numLeft}}", searchSubmitAria: "Podnesi pretragu", searchTitle: "Pretraživanje", selectWorkspaceMenu: "Odaberite vrstu radnog prostora", showCollection: "Prikaži kolekciju", showingNumAnnotations_one: "Prikazivanje {{number}} bilješke", showingNumAnnotations_other: "Prikazivanje {{number}} bilješki", showZoomControls: "Prikaži kontrole zumiranja", sidebarPanelsNavigation: "Bočne ploče navigacija", single: "Jedan", startHere: "Počnite ovdje", suggestSearch: 'Pretraži ovaj dokument za "{{ query }}"', tableOfContentsList: "Sadržaj", theme: "Tema", thumbnailList: "Popis sličica", thumbnailNavigation: "Sličice", thumbnails: "Sličice", toggleWindowSideBar: "Prebaci bočnu traku", totalCollections_one: "{{count}} kolekcija", totalCollections_other: "{{count}} kolekcija", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifesta", tryAgain: "Pokušaj ponovno", untitled: "[Nenaslovljeno]", view: "Pogled", viewWorkspaceConfiguration: "Pogledaj konfiguraciju radnog prostora", welcome: "Dobrodošli u Mirador", window: "Prozor: {{label}}", windowMenu: "Prikazi prozora i prikaz sličica", windowNavigation: "Navigacija prozorom", windowPluginButtons: "Opcije", windowPluginMenu: "Opcije prozora", workspace: "Radni prostor", workspaceFullScreen: "Puni zaslon", workspaceMenu: "Postavke radnog prostora", workspaceNavigation: "Navigacija radnog prostora", workspaceOptions: "Opcije radnog prostora", workspaceSelectionTitle: "Odaberite vrstu radnog prostora", zoomIn: "Povećaj", zoomOut: "Umanji prikaz", zoomReset: "Poništi zumiranje" }, dFe = {
  translation: uFe
}, fFe = { aboutMirador: "Project Miradorについて", aboutThisItem: "この資料について", addedFromUrl: "(URLで追加)", addManifestUrl: "資料のIIIFマニフェストURI", addManifestUrlHelp: "追加したいIIIF資料のURIを上記に入力してください", addResource: "資料の追加", "annotationCanvasLabel_1/1": "アイテム: [{{label}}]", "annotationCanvasLabel_1/2": "左: [{{label}}]", "annotationCanvasLabel_2/2": "右: [{{label}}]", annotations: "アノテーション", attribution: "帰属", attributionTitle: "権利", authenticationFailed: "認証失敗", authenticationRequired: "フルアクセスには認証が必要", backToResults: "結果に戻る", book: "見開き", bottom: "下部", cancel: "キャンセル", canvasIndex: "インデックス", changeTheme: "テーマの変更", clearSearch: "クリア", close: "閉じる", closeAddResourceForm: "フォームを閉じる", closeAddResourceMenu: "資料一覧を閉じる", closeCompanionWindow: "パネルを閉じる", closeWindow: "ウインドウを閉じる", collapseSection: "{{section}} セクションを畳む", collapseSidePanel: "サイドバーを畳む", collection: "コレクション", continue: "続ける", copy: "コピー", currentItem: "現在のアイテム", "currentItem_1/1": "現在のアイテム", "currentItem_1/2": "左", "currentItem_2/2": "右", dark: "ダークなテーマ", digitizedView: "デジタルビュー", dismiss: "片付け", displayNoAnnotations: "アノテーションを非表示", downloadExport: "ワークスペースをエクスポート", downloadExportWorkspace: "ワークスペースをエクスポート", elastic: "伸縮", elasticDescription: "自由なウインドウの伸縮", emptyResourceList: "資料の一覧が空です", error: "エラー", errorDialogConfirm: "OK", errorDialogTitle: "エラー発生", exitFullScreen: "全画面を解除", expandSection: "セクション {{section}}を拡大", expandSidePanel: "サイドバーを拡大", exportCopied: "ワークスペースの設定がクリップボードにコピーされました。", fetchManifest: "追加", fullScreen: "全画面", gallery: "ギャラリー", hideZoomControls: "zoom制御を隠す", highlightAllAnnotations: "すべてを表示", iiif_homepage: "IIIFホームページ", iiif_manifest: "IIIF マニフェスト", iiif_renderings: "別の形式", iiif_seeAlso: "参照", import: "取り込み", importWorkspace: "ワークスペースの取り込み", importWorkspaceHint: "Mirador3の設定を貼り付け", item: "アイテム: {{label}}", itemList: "アイテム一覧", jsError: "技術的な詳細", jsStack: "{{ stack }}", language: "言語", layer_hide: "レイヤーを隠す", layer_move: "レイヤーを動かす", layer_opacity: "レイヤーの透過度", layer_show: "レイヤーを表示", layers: "レイヤー", light: "明るいテーマ", links: "リンク", listAllOpenWindows: "ウインドウにジャンプ", login: "ログイン", logout: "ログアウト", manifestError: "資料追加に失敗:", maximizeWindow: "ウインドウを最大化", minimizeWindow: "ウインドウを最小化", mirador: "Mirador", miradorResources: "Mirador資料", miradorViewer: "Miradorビューワ", more: "さらに...", moreResults: "さらに結果を", mosaic: "モザイク", mosaicDescription: "モザイク表示", moveCompanionWindowToBottom: "下部に移動", moveCompanionWindowToRight: "右に移動", nextCanvas: "次のアイテム", noItemSelected: "アイテムが未選択", numItems_one: "{{number}} アイテム", off: "オフ", openCompanionWindow_annotations: "アノテーション", openCompanionWindow_attribution: "権利", openCompanionWindow_canvas: "インデックス", openCompanionWindow_info: "情報", openCompanionWindow_layers: "レイヤー", openCompanionWindow_search: "検索", openInCompanionWindow: "別のパネルで開く", openWindows: "現在開いているウインドウ", pagination: "{{current}} of {{total}}", position: "位置", previewWindowTitle: "{{title}}", previousCanvas: "前のアイテム", related: "関連", resource: "資料", retry: "リトライ", right: "右側", rights: "利用条件", scroll: "スクロール", searchInputLabel: "検索語", searchNextResult: "次の結果", searchNoResults: "ヒットせず", searchPreviousResult: "前の結果", searchSubmitAria: "検索", searchTitle: "検索", selectWorkspaceMenu: "ワークスペースタイプの選択", showCollection: "コレクションを表示", showingNumAnnotations_one: "アノテーション {{number}} を表示", showZoomControls: "ズーム操作を表示", sidebarPanelsNavigation: "サイドバーパネルの操作", single: "単一", startHere: "ここから始める", suggestSearch: 'この文書を "{{ query }}" で検索', tableOfContentsList: "目次", theme: "テーマ", thumbnailList: "サムネイル一覧", thumbnailNavigation: "サムネイル", thumbnails: "サムネイル表示", toggleWindowSideBar: "サイドバー切り替え", totalCollections_one: "{{count}} コレクション", totalManifests_one: "{{count}} マニフェスト", tryAgain: "もう一度試す", untitled: "[タイトル無し]", view: "表示の仕方", welcome: "Miradorにようこそ", window: "{{label}} ウインドウ", windowMenu: "ウインドウメニュー", windowNavigation: "ウィンドウ操作", windowPluginButtons: "オプション", windowPluginMenu: "ウインドウオプション", workspace: "ワークスペース", workspaceFullScreen: "全画面", workspaceMenu: "ワークスペースの設定", workspaceNavigation: "ワークスペースナビ", workspaceOptions: "ワークスペースのオプション", workspaceSelectionTitle: "ワークスペースのタイプを選択", zoomIn: "ズームイン", zoomOut: "ズームアウト", zoomReset: "ズームを戻す" }, pFe = {
  translation: fFe
}, hFe = { aboutMirador: "Mirador 프로젝트에 대하여", aboutThisItem: "해당 아이템에 대하여", addedFromUrl: "(URL에서 추가됨)", addManifestUrl: "리소스의 위치", addManifestUrlHelp: "IIIF 리소스의 URL", addResource: "리소스 추가", "annotationCanvasLabel_1/1": "아이템: [{{label}}]", "annotationCanvasLabel_1/2": "왼쪽: [{{label}}]", "annotationCanvasLabel_2/2": "오른쪽: [{{label}}]", annotations: "주석", attribution: "귀속", attributionTitle: "권리", authenticationFailed: "인증 실패.", authenticationRequired: "모든 정보에 접근하기 위해선 인증이 필요합니다.", backToResults: "결과로 돌아가기", book: "책", bottom: "아래", cancel: "취소", canvasIndex: "인덱스", changeTheme: "테마 변경", clearSearch: "지우기", close: "닫기", closeAddResourceForm: "폼 닫기", closeAddResourceMenu: "리소스 목록 닫기", closeCompanionWindow: "패널 닫기", closeWindow: "윈도우 닫기", collapseSection: '"{{section}}" 섹션 접기', collapseSidePanel: "사이드바 접기", collection: "컬렉션", continue: "계속하기", copy: "복사", currentItem: "현재 아이템", "currentItem_1/1": "현재 아이템", "currentItem_1/2": "왼쪽", "currentItem_2/2": "오른쪽", dark: "다크 모드", digitizedView: "디지털 뷰", dismiss: "무시하기", displayNoAnnotations: "하이라이트 해제", downloadExport: "작업공간 내보내기", downloadExportWorkspace: "작업공간 내보내기", elastic: "신축성", elasticDescription: "무한한 작업공간에서 윈도우를 자유롭게 움직이고 조절해보세요. 윈도우는 서로 겹칠 수 있습니다.", emptyResourceList: "리소스 목록이 비어있습니다", error: "오류", errorDialogConfirm: "허락", errorDialogTitle: "오류 발생", exitFullScreen: "전체화면에서 나가기", expandSection: '"{{section}}" 섹션 확장', expandSidePanel: "사이드바 확장", exportCopied: "작업공간 환경설정을 클립보드에 복사했습니다", fetchManifest: "추가하기", fullScreen: "전체화면", gallery: "갤러리", hideZoomControls: "확대/축소 기능 숨기기", highlightAllAnnotations: "모두 하이라이트하기", iiif_homepage: "해당 리소스에 대하여", iiif_manifest: "IIIF 매니페스트", iiif_renderings: "대체 포맷", iiif_seeAlso: "참고", import: "가져오기", importWorkspace: "작업공간 가져오기", importWorkspaceHint: "Mirador 4 환경설정 가져와 붙여넣기", item: "아이템: {{label}}", itemList: "아이템 목록", jsError: "기술적인 세부사항", jsStack: "{{ stack }}", language: "언어", layer_hide: "레이어 숨기기", layer_move: "레이어 움직이기", layer_opacity: "레이어 불투명도", layer_show: "레이어 보이기", layers: "레이어", light: "라이트 모드", links: "링크", listAllOpenWindows: "윈도우로 이동하기", login: "로그인", logout: "로그아웃", manifestError: "리소스를 추가할 수 없습니다:", maximizeWindow: "윈도우 크기 최대화", minimizeWindow: "윈도우 크기 최소화", mirador: "Mirador", miradorResources: "Mirador 리소스", miradorViewer: "Mirador 뷰어", more: "더 보기...", moreResults: "결과 더 보기", mosaic: "모자이크", mosaicDescription: "프레임 내에서 윈도우를 이동하고 크기를 조정합니다.", moveCompanionWindowToBottom: "아래로 옮기기", moveCompanionWindowToRight: "오른쪽으로 옮기기", nextCanvas: "다음 아이템", noItemSelected: "아이템이 선택되지 않았습니다", numItems_one: "{{number}}개의 아이템", numItems_other: "{{number}}개의 아이템", off: "끄기", openCompanionWindow_annotations: "주석", openCompanionWindow_attribution: "권리", openCompanionWindow_canvas: "인덱스", openCompanionWindow_info: "정보", openCompanionWindow_layers: "레이어", openCompanionWindow_search: "검색", openInCompanionWindow: "별도의 패널에서 열기", openWindows: "현재 열려있는 윈도우", pagination: "{{current}} of {{total}}", position: "배치", previewWindowTitle: "{{title}}", previousCanvas: "이전 아이템", related: "관련", resource: "리소스", retry: "재시도", right: "오른쪽", rights: "라이선스", scroll: "스크롤", searchInputLabel: "용어 찾기", searchNextResult: "다음 결과", searchNoResults: "해당 결과 없음", searchPreviousResult: "이전 결과", searchResultsRemaining: "{{numLeft}}개 남음", searchSubmitAria: "검색하기", searchTitle: "검색", selectWorkspaceMenu: "작업공간 유형 선택", showCollection: "컬렉션 보이기", showingNumAnnotations_one: "{{number}}개의 주석 나타내기", showingNumAnnotations_other: "{{number}}개의 주석 나타내기", showZoomControls: "확대/축소 기능 보이기", sidebarPanelsNavigation: "사이드바 패널 탐색", single: "한 개", startHere: "시작하기", suggestSearch: '이 문서를 "{{ query }}"로 검색하기', tableOfContentsList: "목차", theme: "테마", thumbnailList: "썸네일 목록", thumbnailNavigation: "썸네일", thumbnails: "썸네일", toggleWindowSideBar: "사이드바 전환", totalCollections_one: "{{count}}개의 컬렉션", totalCollections_other: "{{count}}개의 컬렉션", totalManifests_one: "{{count}}개의 매니페스트", totalManifests_other: "{{count}}개의 매니페스트", tryAgain: "다시 시도하세요", untitled: "[타이틀 없음]", view: "뷰", viewWorkspaceConfiguration: "작업공간 환경설정 ㅂ괴", welcome: "Mirador에 오신 것을 환영합니다", window: "윈도우: {{label}}", windowMenu: "윈도우 뷰 & 썸네일 표시", windowNavigation: "윈도우 탐색", windowPluginButtons: "옵션", windowPluginMenu: "윈도우 옵션", workspace: "작업공간", workspaceFullScreen: "전체화면", workspaceMenu: "작업공간 설정", workspaceNavigation: "작업공간 탐색", workspaceOptions: "작업공간 옵션", workspaceSelectionTitle: "작업공간 유형을 선택하세요", zoomIn: "확대", zoomOut: "축소", zoomReset: "줌 재설정" }, gFe = {
  translation: hFe
}, mFe = { aboutThisItem: "Over dit item", addedFromUrl: "(Toegevoegd via URL)", addManifestUrl: "Locatie bron", addManifestUrlHelp: "De URL van een IIIF-resource", addResource: "Voeg bron toe", "annotationCanvasLabel_1/1": "Item: [{{label}}]", "annotationCanvasLabel_1/2": "Links: [{{label}}]", "annotationCanvasLabel_2/2": "Rechts: [{{label}}]", annotations: "Annotaties", attribution: "Naamsvermelding", attributionTitle: "Rechten", authenticationFailed: "Authenticatie gefaald.", authenticationRequired: "Authenticatie is vereist voor volledige toegang", backToResults: "Terug naar resultaten", book: "Boek", bottom: "Onderaan", cancel: "Annuleer", canvasIndex: "Index", changeTheme: "Wijzig thema", clearSearch: "clear", closeAddResourceForm: "Sluit formulier", closeAddResourceMenu: "Sluit lijst met bronnen", closeCompanionWindow: "Sluit paneel", closeWindow: "Sluit venster", collapseSection: 'Klap "{{section}}" sectie in', collapseSidePanel: "Klap zijbalk in", continue: "Ga verder", copy: "Kopieer", currentItem: "Huidig item", "currentItem_1/1": "Huidig item", "currentItem_1/2": "Links", "currentItem_2/2": "Rechts", dark: "Donker thema", dismiss: "Dismiss", downloadExport: "Exporteer workspace", downloadExportWorkspace: "Exporteer workspace", elastic: "Elastisch", elasticDescription: "Verplaats en rangschik vensters vrij in een onbeperkte workspace. Vensters kunnen elkaar overlappen.", emptyResourceList: "Je lijst met bronnen is leeg", errorDialogConfirm: "OK", errorDialogTitle: "Er is een fout opgetreden", exitFullScreen: "Verlaat volledig scherm", expandSection: 'Klap "{{section}}" sectie uit', expandSidePanel: "Klap zijbalk uit", fetchManifest: "Voeg toe", fullScreen: "Volledig scherm", gallery: "Gallerij", hideZoomControls: "Verberg zoomknoppen", highlightAllAnnotations: "Markeer alles", iiif_homepage: "Over deze bron", iiif_manifest: "IIIF-manifest", iiif_renderings: "Alternatieve formaten", iiif_seeAlso: "Zie ook", import: "Importeer", importWorkspace: "Importeer workspace", importWorkspaceHint: "Plak een Mirador 4 configuratie die geïmporteerd moet worden", item: "Item: {{label}}", itemList: "Compacte lijst", language: "Taal", light: "Licht thema", links: "Links", listAllOpenWindows: "Ga naar venster", login: "Log in", manifestError: "De bron kan niet worden toegevoegd:", maximizeWindow: "Maximaliseer venster", minimizeWindow: "Minimaliseer venster", mirador: "Mirador", miradorResources: "Mirador resources", miradorViewer: "Mirador viewer", more: "meer...", moreResults: "Meer resultaten", mosaic: "Mozaïek", mosaicDescription: "Verplaats en rangschik vensters in verhouding tot elkaar binnen het zichtbare kader.", moveCompanionWindowToBottom: "Verplaats naar beneden", moveCompanionWindowToRight: "Verplaats naar rechts", nextCanvas: "Volgend item", numItems_one: "{{number}} item", numItems_other: "{{number}} items", off: "Uit", openCompanionWindow_annotations: "Annotaties", openCompanionWindow_attribution: "Rechten", openCompanionWindow_canvas: "Index", openCompanionWindow_info: "Informatie", openCompanionWindow_search: "Zoeken", openInCompanionWindow: "Open in een apart paneel", openWindows: "Geopende vensters", pagination: "{{current}} van {{total}}", position: "Positie", previewWindowTitle: "{{title}}", previousCanvas: "Vorig item", related: "Verwant", resource: "Bron", retry: "Probeer opnieuw", right: "Rechts", rights: "Licentie", searchInputLabel: "zoek termen", searchNextResult: "Volgend resultaat", searchNoResults: "Geen resultaten gevonden", searchPreviousResult: "Vorig resultaat", searchSubmitAria: "Zoeken", searchTitle: "Zoek", selectWorkspaceMenu: "Selecteer workspacetype", showingNumAnnotations_one: "{{number}} annotatie weergegeven", showingNumAnnotations_other: "{{number}} annotaties weergegeven", showZoomControls: "Toon zoomknoppen", sidebarPanelsNavigation: "Zijbalk panelen navigatie", single: "Enkel", startHere: "Begin Hier", suggestSearch: 'Zoek in dit document naar "{{ query }}"', theme: "Thema", thumbnailList: "Lijst thumbnails", thumbnailNavigation: "Thumbnails", thumbnails: "Thumbnails", toggleWindowSideBar: "Toon zijbalk", totalCollections_one: "{{count}} collectie", totalCollections_other: "{{count}} collecties", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifests", tryAgain: "Probeer opnieuw", untitled: "[Zonder titel]", view: "Weergave", welcome: "Welkom in Mirador", window: "Venster: {{label}}", windowMenu: "Vensters- en miniatuurweergave", windowNavigation: "Navigatie venster", windowPluginButtons: "Opties", windowPluginMenu: "Vensteropties", workspace: "Workspace", workspaceFullScreen: "Volledig scherm", workspaceMenu: "Workspace instellingen", workspaceOptions: "Workspace opties", workspaceSelectionTitle: "Selecteer een workspace type", zoomIn: "Zoom in", zoomOut: "Zoom out", zoomReset: "Reset zoom" }, vFe = {
  translation: mFe
}, yFe = { aboutMirador: "O Projekcie Mirador", aboutThisItem: "O bieżącej pozycji", addedFromUrl: "(Dodano z URL)", addManifestUrl: "Lokalizacja zasobów", addManifestUrlHelp: "URL zasobów IIIF", addResource: "Dodaj zasoby", "annotationCanvasLabel_1/1": "Pozycja: [{{label}}]", "annotationCanvasLabel_1/2": "Lewo: [{{label}}]", "annotationCanvasLabel_2/2": "Prawo: [{{label}}]", annotations: "Adnotacje", attribution: "Atrybucja", attributionTitle: "Prawa", authenticationFailed: "Uwierzytelnianie nie powiodło się.", authenticationRequired: "Do pełnego dostępu wymagane jest uwierzytelnienie", backToResults: "Powrót do wyników", book: "Książka", bottom: "Dół", cancel: "Anuluj", canvasIndex: "Indeks", changeTheme: "Zmień motyw", clearSearch: "wyczyść", close: "Zamknij", closeAddResourceForm: "Zamknij formularz", closeAddResourceMenu: "Zamknij listę zasobów", closeCompanionWindow: "Zamknij panel", closeWindow: "Zamknij okno", collapseSection: 'Zwiń sekcję "{{section}}"', collapseSidePanel: "Zwiń panel boczny", collection: "Zbiór", continue: "Kontynuuj", copy: "Kopiuj", currentItem: "Bieżąca pozycja", "currentItem_1/1": "Bieżąca pozycja", "currentItem_1/2": "Lewo", "currentItem_2/2": "Prawo", dark: "Ciemny motyw", digitizedView: "Widok zdigitalizowany", dismiss: "Odrzuć", displayNoAnnotations: "Nie podświetlaj", downloadExport: "Eksportuj obszar roboczy", downloadExportWorkspace: "Eksportuj obszar roboczy", elastic: "Elastyczny", elasticDescription: "Swobodnie przesuwaj i dopasowuj okna w nieograniczonej przestrzeni roboczej. Okna mogą zachodzić na siebie.", emptyResourceList: "Twoja lista zasobów jest pusta", error: "Błąd", errorDialogConfirm: "OK", errorDialogTitle: "Wystąpił błąd", exitFullScreen: "Wyłącz tryb pełnoekranowy", expandSection: 'Rozwiń sekcję "{{section}}"', expandSidePanel: "Rozwiń panel boczny", exportCopied: "Konfiguracja obszaru roboczego została skopiowana do schowka", fetchManifest: "Dodaj", fullScreen: "Pełny ekran", gallery: "Galeria", hideZoomControls: "Ukryj kontrolki powiększenia", highlightAllAnnotations: "Podświetl wszystko", iiif_homepage: "O tym zasobie", iiif_manifest: "Manifest IIIF", iiif_renderings: "Alternatywne formaty", iiif_seeAlso: "Zobacz też", import: "Importuj", importWorkspace: "Importuj obszar roboczy", importWorkspaceHint: "Wklej konfigurację Mirador 4 do zaimportowania", item: "Pozycja: {{label}}", itemList: "Lista pozycji", jsError: "Szczegóły techniczne", jsStack: "{{ stack }}", language: "Język", layer_hide: "Ukryj warstwę", layer_move: "Przenieś warstwę", layer_opacity: "Krycie warstwy", layer_show: "Pokaż warstwę", layers: "Warstwy", light: "Jasny motyw", links: "Linki", listAllOpenWindows: "Przejdź do okna", login: "Zaloguj", logout: "Wyloguj", manifestError: "Następujące zasoby nie mogą być dodane:", maximizeWindow: "Maksymalizuj okno", minimizeWindow: "Minimalizuj okno", mirador: "Mirador", miradorResources: "Zasoby Mirador", miradorViewer: "Przeglądarka Mirador", more: "więcej...", moreResults: "Więcej wyników", mosaic: "Mozaika", mosaicDescription: "Przesuwaj i zmieniaj rozmiary okien względem siebie, w widocznej ramce.", moveCompanionWindowToBottom: "Przesuń na dół", moveCompanionWindowToRight: "Przesuń w prawo", nextCanvas: "Następna pozycja", noItemSelected: "Nie wybrano pozycji", numItems_one: "{{number}} pozycja", numItems_other: "{{number}} pozycje", off: "Wyłącz", openCompanionWindow_annotations: "Adnotacje", openCompanionWindow_attribution: "Prawa", openCompanionWindow_canvas: "Indeks", openCompanionWindow_info: "Informacje", openCompanionWindow_layers: "Warstwy", openCompanionWindow_search: "Szukaj", openInCompanionWindow: "Otwórz w oddzielnym panelu", openWindows: "Aktualnie otwarte okna", pagination: "{{current}} of {{total}}", position: "Pozycja", previewWindowTitle: "{{title}}", previousCanvas: "Poprzednia pozycja", related: "Powiązane", resource: "Zasoby", retry: "Spróbuj ponownie", right: "Prawo", rights: "Licencja", scroll: "Przewiń", searchInputLabel: "szukane słowa", searchNextResult: "Następny wynik", searchNoResults: "Nie znaleziono wyników", searchPreviousResult: "Poprzedni wynik", searchResultsRemaining: "Pozostało {{numLeft}}", searchSubmitAria: "Wyszukaj", searchTitle: "Wyszukaj", selectWorkspaceMenu: "Wybierz typ obszaru roboczego", showCollection: "Pokaż zbiór", showingNumAnnotations_one: "Wyświetlanie {{number}} adnotacji", showingNumAnnotations_other: "Wyświetlanie {{number}} adnotacji", showZoomControls: "Pokaż kontrolki powiększenia", sidebarPanelsNavigation: "Nawigacja pasków panelu bocznego", single: "Pojedynczy", startHere: "Zacznij tutaj", suggestSearch: 'Przeszukaj ten dokument pod kątem "{{ query }}"', tableOfContentsList: "Spis treści", theme: "Motyw", thumbnailList: "Lista miniatur", thumbnailNavigation: "Miniatury", thumbnails: "Miniatury", toggleWindowSideBar: "Przełącz panel boczny", totalCollections_one: "{{count}} zbiór", totalCollections_other: "{{count}} zbiorów", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifestów", tryAgain: "Spróbuj ponownie", untitled: "[Bez nazwy]", view: "Widok", viewWorkspaceConfiguration: "Wyświetl konfigurację obszaru roboczego", welcome: "Witaj w Miradorze", window: "Okno: {{label}}", windowMenu: "Widoki okien i wyświetlanie miniatur", windowNavigation: "Nawigacja okna", windowPluginButtons: "Opcje", windowPluginMenu: "Opcje okna", workspace: "Obszar roboczy", workspaceFullScreen: "Pełny ekran", workspaceMenu: "Ustawienia obszaru roboczego", workspaceNavigation: "Nawigacja obszaru roboczego", workspaceOptions: "Opcje obszaru roboczego", workspaceSelectionTitle: "Wybierz typ obszaru roboczego", zoomIn: "Przybliż", zoomOut: "Oddal", zoomReset: "Zresetuj powiększenie" }, bFe = {
  translation: yFe
}, xFe = { aboutThisItem: "Sobre esse item", addedFromUrl: "(Adicionado por URL)", addManifestUrl: "Localização do manifesto", addManifestUrlHelp: "URL do manifesto IIIF", addResource: "Adicionar conteúdo", "annotationCanvasLabel_1/1": "Item: [{{label}}]", "annotationCanvasLabel_1/2": "Esquerda: [{{label}}]", "annotationCanvasLabel_2/2": "Direita: [{{label}}]", annotations: "Anotações", attribution: "Atribuições", attributionTitle: "Direitos", authenticationFailed: "Falha na autenticação.", authenticationRequired: "Autenticação necessária para acesso completo", backToResults: "Voltar aos resultados", book: "Livro", bottom: "Embaixo", cancel: "Cancelar", canvasIndex: "Índice", changeTheme: "Mudar tema", clearSearch: "limpar", closeAddResourceForm: "Fechar formulário", closeAddResourceMenu: "Fechar lista de conteúdo", closeCompanionWindow: "Fechar painel", closeWindow: "Fechar janela", collapseSection: 'Suprimir seção "{{section}}"', collapseSidePanel: "Suprimir barra lateral", continue: "Continuar", copy: "Copiar", currentItem: "Item atual", "currentItem_1/1": "Item atual", "currentItem_1/2": "Esquerda", "currentItem_2/2": "Direita", dark: "Tema escuro", dismiss: "Cancelar", downloadExport: "Exportar área de trabalho", downloadExportWorkspace: "Exportar área de trabalho", elastic: "Elástico", elasticDescription: "Mova e redimensione janelas livremente numa área de trabalho ilimitada. Janelas podem se sobrepor.", emptyResourceList: "Sua lista de conteúdos está vazia", errorDialogConfirm: "OK", errorDialogTitle: "Um erro ocorreu", exitFullScreen: "Sair do modo tela cheia", expandSection: 'Expandir seção "{{section}}"', expandSidePanel: "Expandir barra lateral", fetchManifest: "Adicionar", fullScreen: "Tela cheia", gallery: "Galeria", hideZoomControls: "Ocultar controles de zoom", highlightAllAnnotations: "Exibir todas", iiif_homepage: "Sobre esse conteúdo", iiif_manifest: "Manifesto IIIF", iiif_renderings: "Outros formatos", iiif_seeAlso: "Veja também", import: "Importar", importWorkspace: "Importar área de trabalho", importWorkspaceHint: "Cole uma configuração do Mirador 4 para importar", item: "Item: {{label}}", itemList: "Lista compacta", language: "Idioma", light: "Tema claro", links: "Links", listAllOpenWindows: "Pular para janela", login: "Login", manifestError: "O conteúdo não pode ser adicionado:", maximizeWindow: "Maximizar janela", minimizeWindow: "Minimizar janela", mirador: "Mirador", miradorResources: "conteúdo Mirador", miradorViewer: "visualizador Mirador", more: "mais...", moreResults: "Mais resultados", mosaic: "Mosáico", mosaicDescription: "Mova e redimensione janelas em relação entre si, dentro de uma área visível (grid).", moveCompanionWindowToBottom: "Mover para baixo", moveCompanionWindowToRight: "Mover para direita", nextCanvas: "Próximo item", numItems_one: "{{number}} itens", off: "Desativado", openCompanionWindow_annotations: "Anotações", openCompanionWindow_attribution: "Direitos", openCompanionWindow_canvas: "Índice", openCompanionWindow_info: "Informações", openCompanionWindow_search: "Busca", openInCompanionWindow: "Abrir em janela separada", openWindows: "Janelas abertas", pagination: "{{current}} de {{total}}", position: "Posição", previewWindowTitle: "{{title}}", previousCanvas: "Item anterior", related: "Relacionado", resource: "Conteúdo", retry: "Tentar novamente", right: "Direita", rights: "Licenças", searchInputLabel: "termos de busca", searchNextResult: "Próximo resultado", searchNoResults: "Nenhum resultado encontrado", searchPreviousResult: "Resultado anterior", searchSubmitAria: "Realizar busca", searchTitle: "Busca", selectWorkspaceMenu: "Selecione um tipo de área de trabalho", showingNumAnnotations_one: "Mostrando {{number}} anotações", showZoomControls: "Mostrar controles de zoom", sidebarPanelsNavigation: "Navegação por paineis na barra lateral", single: "Individual", startHere: "Comece aqui", suggestSearch: 'Procurar neste documento por "{{ query }}"', theme: "Tema", thumbnailList: "Lista de thumbnails", thumbnailNavigation: "Thumbnails", thumbnails: "Thumbnails", toggleWindowSideBar: "Ver barra lateral", tryAgain: "Tente novamente", untitled: "[Sem título]", view: "Visualizações", welcome: "Bem-vindo ao Mirador", window: "Janela: {{label}}", windowMenu: "Opções de visualização de janelas e thumbnails", windowNavigation: "Navegação de janelas", windowPluginButtons: "Opções", windowPluginMenu: "Opções de janela", workspace: "Área de trabalho", workspaceFullScreen: "Tela cheia", workspaceMenu: "Configurações de área de trabalho", workspaceOptions: "Opções de área de trabalho", workspaceSelectionTitle: "Selecionar tipo de área de trabalho", zoomIn: "Mais zoom", zoomOut: "Menos zoom", zoomReset: "Zerar zoom" }, SFe = {
  translation: xFe
}, wFe = { aboutMirador: "Informazioni su Mirador", aboutThisItem: "Informazioni sull'oggetto", addedFromUrl: "(Aggiunto dall'URL)", addManifestUrl: "URL della risorsa", addManifestUrlHelp: "L'URL di una risorsa IIIF", addResource: "Aggiungi una risorsa", "annotationCanvasLabel_1/1": "Oggetto: [{{label}}]", "annotationCanvasLabel_1/2": "Sinistra: [{{label}}]", "annotationCanvasLabel_2/2": "Destra: [{{label}}]", annotations: "Annotazioni", attribution: "Attribuzione", attributionTitle: "Diritti", authenticationFailed: "Autenticazione fallita.", authenticationRequired: "Autenticazione richiesta per l'accesso completo", backToResults: "Torna ai risultati", book: "Libro", bottom: "Fondo", cancel: "Cancella", canvasIndex: "Indice", changeTheme: "Cambia tema", clearSearch: "pulisci", close: "Chiudi", closeAddResourceForm: "Chiudi il modulo", closeAddResourceMenu: "Chiudi la lista di risorse", closeCompanionWindow: "Chiudi il pannello", closeWindow: "Chiudi finestra", collapseSection: 'Collassa la sezione "{{section}}"', collapseSidePanel: "Collassa la barra laterale", collection: "Collezione", continue: "Continua", copy: "Copia", currentItem: "Oggetto corrente", "currentItem_1/1": "Oggetto corrente", "currentItem_1/2": "Sinistra", "currentItem_2/2": "Destra", dark: "Tema scuro", digitizedView: "Digitized view", dismiss: "Dismiss", displayNoAnnotations: "Nascondi evidenziazione", downloadExport: "Esporta il workspace", downloadExportWorkspace: "Esporta il workspace", elastic: "Elastico", elasticDescription: "Muovi e ridimensiona le finestre liberamente in un workspace illimitato. Le finestre possono sovrapporsi.", emptyResourceList: "La tua lista di risorse è vuota.", error: "Errore", errorDialogConfirm: "OK", errorDialogTitle: "Si è verificato un errore.", exitFullScreen: "Esci da schermo intero", expandSection: 'Espandi la sezione "{{section}}"', expandSidePanel: "Espandi la barra laterale", exportCopied: "La configurazione del workspace è stata copiata nella tua clipboard", fetchManifest: "Aggiungi", fullScreen: "Schermo intero", gallery: "Galleria", hideZoomControls: "Nascondi i controlli di zoom", highlightAllAnnotations: "Evidenzia tutto", iiif_homepage: "Informazioni su questa risorsa", iiif_manifest: "IIIF manifest", iiif_renderings: "Formati alternativi", iiif_seeAlso: "Vedi anche", import: "Importa", importWorkspace: "Importa workspace", importWorkspaceHint: "Incolla una configurazione di Mirador 4 da importare", item: "Oggetto: {{label}}", itemList: "Lista compatta", jsError: "Dettagli tecnici", jsStack: "{{ stack }}", language: "Lingua", layer_hide: "Nascondi livello", layer_move: "Sposta livello", layer_opacity: "Opacità del livello", layer_show: "Visualizza livello", layers: "Livelli", light: "Tema chiaro", links: "Link", listAllOpenWindows: "Vai alla finestra", login: "Entra", logout: "Esci", manifestError: "La risorsa non può essere aggiunta:", maximizeWindow: "Massimizza la finestra", minimizeWindow: "Minimizza la finestra", mirador: "Mirador", miradorResources: "Risorse Mirador", miradorViewer: "Visualizzatore Mirador", more: "ancora...", moreResults: "Più risultati", mosaic: "Mosaico", mosaicDescription: "Muovi e ridimensiona le finestre, tenendole all'interno dell'area visibile", moveCompanionWindowToBottom: "Sposta in fondo", moveCompanionWindowToRight: "Sposta a destra", nextCanvas: "Oggetto Successivo", noItemSelected: "Nessun oggetto selezionato", numItems_one: "{{number}} oggetti", numItems_other: "{{number}} oggetti", off: "Off", openCompanionWindow_annotations: "Annotazioni", openCompanionWindow_attribution: "Diritti", openCompanionWindow_canvas: "Indice", openCompanionWindow_info: "Informazioni", openCompanionWindow_layers: "Livelli", openCompanionWindow_search: "Cerca", openInCompanionWindow: "Apri in un pannello separato", openWindows: "Finestre aperte in questo momento", pagination: "{{current}} di {{total}}", position: "Posizione", previewWindowTitle: "{{title}}", previousCanvas: "Oggetto precedente", related: "Contenuti collegati", resource: "Risorsa", retry: "Riprova", right: "Right", rights: "Licenza", scroll: "Scorri", searchInputLabel: "termini di ricerca", searchNextResult: "Prossimo risultato", searchNoResults: "Nessun risultato", searchPreviousResult: "Risultato precedente", searchResultsRemaining: "{{numLeft}} rimanenti", searchSubmitAria: "Cerca", searchTitle: "Cerca", selectWorkspaceMenu: "Selezione il tipo di workspace", showCollection: "Visualizza la collezione", showingNumAnnotations_one: "Sto mostrando {{number}} annotazioni", showingNumAnnotations_other: "Visualizzando {{number}} annotazioni", showZoomControls: "Mostra i controlli di zoom", sidebarPanelsNavigation: "Navigazione dei pannelli della barra laterale", single: "Singolo", startHere: "Inizia qui", suggestSearch: 'Cerca in questo documento: "{{ query }}"', tableOfContentsList: "Sommario", theme: "Tema", thumbnailList: "Lista thumbnail", thumbnailNavigation: "Thumbnails", thumbnails: "Thumbnails", toggleWindowSideBar: "Apri/Chiudi la barra", totalCollections_one: "{{count}} collezione", totalCollections_other: "{{count}} collezioni", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifests", tryAgain: "Riprova", untitled: "[senza titolo]", view: "Visualizza", viewWorkspaceConfiguration: "Visualizza la configurazione del workspace", welcome: "Benvenuto in Mirador", window: "Finestra: {{label}}", windowMenu: "Visualizzazioni finestra e display thumbnail", windowNavigation: "Navigazione finestra", windowPluginButtons: "Opzioni", windowPluginMenu: "Opzioni finestra", workspace: "Workspace", workspaceFullScreen: "Schermo intero", workspaceMenu: "Configurazioni Workspace", workspaceNavigation: "Navigazione del workspace", workspaceOptions: "Opzioni Workspace", workspaceSelectionTitle: "Seleziona il tipo di workspace", zoomIn: "Zoom in", zoomOut: "Zoom out", zoomReset: "Reimposta zoom" }, TFe = {
  translation: wFe
}, EFe = { aboutMirador: "О пројекту Mirador", aboutThisItem: "Опис", addedFromUrl: "(Додато са URL)", addManifestUrl: "Локација ресурса", addManifestUrlHelp: "URL IIIF ресурса", addResource: "Додајте ресурс", "annotationCanvasLabel_1/1": "Страница: [{{label}}]", "annotationCanvasLabel_1/2": "Лева: [{{label}}]", "annotationCanvasLabel_2/2": "Десна: [{{label}}]", annotations: "Анотације", attribution: "Приступ", attributionTitle: "Права", authenticationFailed: "Неуспела аутентификација.", authenticationRequired: "За потпуни приступ неопходна је аутентификација", backToResults: "Повратак на резултате", book: "Књига", bottom: "На дну", cancel: "Одустаните", canvasIndex: "Индекс", changeTheme: "Промените тему", clearSearch: "обришите", close: "Затворите", closeAddResourceForm: "Затворите", closeAddResourceMenu: "Затворите листу ресурса", closeCompanionWindow: "Затворите панел", closeWindow: "Затворите приказ", collapseSection: 'Сакријте "{{section}}" секцију', collapseSidePanel: "Сакријте", collection: "Колекција", continue: "Наставите", copy: "Копирајте", currentItem: "Тренутна страница", "currentItem_1/1": "Тренутна страница", "currentItem_1/2": "Лева", "currentItem_2/2": "Десна", dark: "Тамна тема", digitizedView: "Приказ дигиталног објекта", dismiss: "Откажите", displayNoAnnotations: "Без приказа", downloadExport: "Извезите радно окружење", downloadExportWorkspace: "Извезите радно окружење", elastic: "Еластични", elasticDescription: "Слободно померајте и одредите величину приказа у неограниченом радном простору. Прикази могу бити већи од радног простора.", emptyResourceList: "Ваша листа ресурса је празна", error: "Грешка", errorDialogConfirm: "OK", errorDialogTitle: "Дошло је до грешке", exitFullScreen: "Изађите из приказа преко целог екрана", expandSection: 'Проширите "{{section}}" секцију', expandSidePanel: "Прикажите", exportCopied: "Конфигурација радног окружења је копирана у привремену меморију", fetchManifest: "Додајте", fullScreen: "Приказ у пуном екрану", gallery: "Галерија", hideZoomControls: "Сакријте контроле зума", highlightAllAnnotations: "Приказ свих", iiif_homepage: "О ресурсу", iiif_manifest: "IIIF manifest", iiif_renderings: "Додатни формати", iiif_seeAlso: "Погледајте и", import: "Увезите", importWorkspace: "Увезите радно окружење", importWorkspaceHint: "Убаците конфигурацију Mirador 4 како би могли да је увезете", item: "Страница: {{label}}", itemList: "Листа страница", jsError: "Технички детаљи", jsStack: "{{ stack }}", language: "Језик приказа", layer_hide: "Сакријте слој", layer_move: "Померите слој", layer_opacity: "Видљивост слоја", layer_show: "Приказ слоја", layers: "Слојеви", light: "Светла тема", links: "Линкови", listAllOpenWindows: "Идите на приказ", login: "Улогујте се", logout: "Излогујте се", manifestError: "Ресурс се не може додати", maximizeWindow: "Максималан приказ", minimizeWindow: "Минималан приказ", mirador: "Mirador", miradorResources: "Mirador ресурси", miradorViewer: "Mirador прегледач", more: "још...", moreResults: "Још резултата", mosaic: "Мозаик", mosaicDescription: "Померајте и одредите величину приказа који су у међусобној релацији, унутар видљивог оквира.", moveCompanionWindowToBottom: "Пребаците на дно", moveCompanionWindowToRight: "Померите у десну страну", nextCanvas: "Следећа", noItemSelected: "Нема изабраних објеката", numItems_one: "{{number}} страница/це", off: "Искључене", openCompanionWindow_annotations: "Анотације", openCompanionWindow_attribution: "Права", openCompanionWindow_canvas: "Индекс", openCompanionWindow_info: "Информације", openCompanionWindow_layers: "Слојеви", openCompanionWindow_search: "Претрага", openInCompanionWindow: "Отворите у засебном панелу", openWindows: "Тренутно отворени прикази", pagination: "{{current}} од {{total}}", position: "Позиција", previewWindowTitle: "{{title}}", previousCanvas: "Претходна", related: "Релације", resource: "Ресурс", retry: "Покушајте поново", right: "Десно", rights: "Лиценца", scroll: "Померајте", searchInputLabel: "претражите појам", searchNextResult: "Следећи резултат", searchNoResults: "Тражени појам није пронађен", searchPreviousResult: "Претходни резултат", searchSubmitAria: "Претражите", searchTitle: "Претрага", selectWorkspaceMenu: "Изаберите тип радног окружења", showCollection: "Прикажи колекцију", showingNumAnnotations_one: "Приказ {{number}} анотација/је", showZoomControls: "Приказ контрола зума", sidebarPanelsNavigation: "Навигација сајдбар панела", single: "Појединачно", startHere: "Започните", suggestSearch: 'Пронађите појам "{{ query }}" у овом документу', tableOfContentsList: "Садржај", theme: "Тема", thumbnailList: "Листа сличица", thumbnailNavigation: "Сличице", thumbnails: "Сличице", toggleWindowSideBar: "Сајдбар", totalCollections_one: "{{count}} колекција/е", totalManifests_one: "{{count}} објек(а)та", tryAgain: "Покушајте поново", untitled: "[Без наслова]", view: "Преглед", welcome: "Добродошли у прегледач Mirador", window: "Приказ: {{label}}", windowMenu: "Изглед прегледа и позиција сличица", windowNavigation: "Навигација приказа", windowPluginButtons: "Опције", windowPluginMenu: "Опције приказа", workspace: "Радни простор", workspaceFullScreen: "Приказ преко целог екрана", workspaceMenu: "Уређивање радног простора", workspaceOptions: "Опције радног окружења", workspaceSelectionTitle: "Изаберите тип радног окружења", zoomIn: "Увећајте", zoomOut: "Умањите", zoomReset: "Ресет зума" }, _Fe = {
  translation: EFe
}, CFe = { aboutMirador: "Om Projekt Mirador", aboutThisItem: "Om det här objektet", addedFromUrl: "(Tillagd från URL)", addManifestUrl: "Webbadress till samling eller manifest", addManifestUrlHelp: "URL till en IIIF-resurs", addResource: "Lägg till resurs", "annotationCanvasLabel_1/1": "Objekt: [{{label}}]", "annotationCanvasLabel_1/2": "Vänster: [{{label}}]", "annotationCanvasLabel_2/2": "Höger: [{{label}}]", annotations: "Noteringar", attribution: "Tillskrivning", attributionTitle: "Rättigheter", authenticationFailed: "Autentisering misslyckades.", authenticationRequired: "Autentisering krävs för full åtkomst", backToResults: "Tillbaka till resultat", book: "Bok", bottom: "Nederkant", cancel: "Avbryt", canvasIndex: "Index", changeTheme: "Ändra tema", clearSearch: "Ta bort sökning", close: "Stäng", closeAddResourceForm: "Stäng formulär", closeAddResourceMenu: "Stäng resurslista", closeCompanionWindow: "Stäng panel", closeWindow: "Stäng fönster", collapseSection: 'Stäng sektionen "{{section}}"', collapseSidePanel: "Stäng sidofält", collection: "Samling", continue: "Fortsätt", copy: "Kopiera", currentItem: "Aktuellt objekt", "currentItem_1/1": "Aktuellt objekt", "currentItem_1/2": "Vänster", "currentItem_2/2": "Höger", dark: "Mörkt tema", digitizedView: "Digitaliserad vy", dismiss: "Stäng", displayNoAnnotations: "Avmarkera alla", downloadExport: "Exportera arbetsyta", downloadExportWorkspace: "Exportera arbetsyta", elastic: "Elastisk", elasticDescription: "Flytta och ändra storlek på fönster fritt i en obegränsad arbetsyta. Fönster kan överlappa.", emptyResourceList: "Din resurslista är tom", error: "Error", errorDialogConfirm: "OK", errorDialogTitle: "Ett problem uppstod", exitFullScreen: "Lämna helskärmsläge", expandSection: 'Expandera sektionen "{{section}}"', expandSidePanel: "Expandera sidofält", exportCopied: "Konfiguration av arbetsytan har kopierats till dina urklipp", fetchManifest: "Lägg till", fullScreen: "Helskärmsläge", gallery: "Galleri", hideZoomControls: "Dölj zoomkontroller", highlightAllAnnotations: "Markera alla", iiif_homepage: "Om den här resursen", iiif_manifest: "IIIF manifest", iiif_renderings: "Alternativa format", iiif_seeAlso: "Se även", import: "Importera", importWorkspace: "Importera arbetsyta", importWorkspaceHint: "Klistra in en Mirador 4 konfiguration att importera", item: "Objekt: {{label}}", itemList: "Objektlista", jsError: "Tekniska detaljer", jsStack: "{{ stack }}", language: "Språk", layer_hide: "Dölj lager", layer_move: "Flytta lager", layer_opacity: "Lageropacitet", layer_show: "Visa lager", layers: "Lager", light: "Ljust tema", links: "Länkar", listAllOpenWindows: "Gå till fönster", login: "Logga in", logout: "Logga ut", manifestError: "Resursen kan inte läggas till:", maximizeWindow: "Maximera fönster", minimizeWindow: "Minimera fönster", mirador: "Mirador", miradorResources: "Miradorresurser", miradorViewer: "Mirador bildvisare", more: "mer...", moreResults: "Fler resultat", mosaic: "Mosaik", mosaicDescription: "Flytta och ändra storlek på fönster i relation till varandra, innanför den synliga ramen.", moveCompanionWindowToBottom: "Flytta till botten", moveCompanionWindowToRight: "Flytta till höger", nextCanvas: "Nästa objekt", noItemSelected: "Inga valda objekt", numItems_one: "{{number}} objekt", off: "Av", openCompanionWindow_annotations: "Noteringar", openCompanionWindow_attribution: "Rättigheter", openCompanionWindow_canvas: "Index", openCompanionWindow_info: "Information", openCompanionWindow_layers: "Lager", openCompanionWindow_search: "Sök", openInCompanionWindow: "Öppna i separat panel", openWindows: "Öppna fönster", pagination: "{{current}} av {{total}}", position: "Position", previewWindowTitle: "{{title}}", previousCanvas: "Föregående objekt", related: "Relaterat", resource: "Resurs", retry: "Försök igen", right: "Till höger", rights: "Licens", scroll: "Scrolla", searchInputLabel: "Sökord", searchNextResult: "Nästa resultat", searchNoResults: "Inga resultat hittades", searchPreviousResult: "Föregående resultat", searchResultsRemaining: "{{numLeft}} kvar", searchSubmitAria: "Sök", searchTitle: "Sök", selectWorkspaceMenu: "Välj typ av arbetsyta", showCollection: "Visa samling", showingNumAnnotations_one: "Visar {{number}} noteringar", showZoomControls: "Visa zoomkontroller", sidebarPanelsNavigation: "Sidofältspaneler navigering", single: "En och en", startHere: "Börja här", suggestSearch: 'Sök i detta dokument efter "{{ query }}"', tableOfContentsList: "Innehållsförteckning", theme: "Tema", thumbnailList: "Miniatyrlista", thumbnailNavigation: "Miniatyrer", thumbnails: "Miniatyrer", toggleWindowSideBar: "Visa/dölj sidofält", totalCollections_one: "{{count}} samlingar", totalManifests_one: "{{count}} manifest", tryAgain: "Försök igen", untitled: "[namnlös]", view: "Vy", welcome: "Välkommen till Mirador", window: "Fönster: {{label}}", windowMenu: "Fönstervyer & miniatyrdisplay", windowNavigation: "Fönsternavigation", windowPluginButtons: "Inställningar", windowPluginMenu: "Fönsterinställningar", workspace: "Arbetsyta", workspaceFullScreen: "Helskärmsläge", workspaceMenu: "Inställningar för arbetsyta", workspaceNavigation: "Navigera i arbetsyta", workspaceOptions: "Fler val för arbetsyta", workspaceSelectionTitle: "Välj typ av arbetsyta", zoomIn: "Zooma in", zoomOut: "Zooma ut", zoomReset: "Återställ zoom" }, RFe = {
  translation: CFe
}, OFe = { aboutMirador: "Apie Project Mirador", aboutThisItem: "Apie šį įrašą", addedFromUrl: "(Pridėta naudojant URL)", addManifestUrl: "Šaltinio adresas", addManifestUrlHelp: "Nuoroda į IIIF šaltinį", addResource: "Pridėti šaltinį", "annotationCanvasLabel_1/1": "Įrašas: [{{label}}]", "annotationCanvasLabel_1/2": "Kairė: [{{label}}]", "annotationCanvasLabel_2/2": "Dešinė: [{{label}}]", annotations: "Anotacijos", attribution: "Priskyrimas", attributionTitle: "Teisės", authenticationFailed: "Autentifikavimo klaida.", authenticationRequired: "Pilnai prieigai būtina autentifikacija", backToResults: "Grįžti į rezultatus", book: "Knyga", bottom: "Apačia", cancel: "Atšaukti", canvasIndex: "Indeksas", changeTheme: "Keisti temą", clearSearch: "valyti", closeAddResourceForm: "Uždaryti paraišką", closeAddResourceMenu: "Uždaryti šaltinių sąrašą", closeCompanionWindow: "Uždaryti panelę", closeWindow: "Uždaryti langą", collapseSection: 'Suskleisti "{{section}}" sekciją', collapseSidePanel: "Suskleisti šoninę juostą", continue: "Tęsti", copy: "Kopijuoti", currentItem: "Dabartinis įrašas", "currentItem_1/1": "Dabartinis įrašas", "currentItem_1/2": "Kairė", "currentItem_2/2": "Dešinė", dark: "Tamsi tema", digitizedView: "Skaitmenintas vaizdas", dismiss: "Atmesti", displayNoAnnotations: "Slėpti viską", downloadExport: "Išsaugoti darbalaukį", downloadExportWorkspace: "Išsaugoti darbalaukį", elastic: "Lankstus", elasticDescription: "Langų dydis ir vieta gali būti laisvai valdomi. Langai gali persidengti.", emptyResourceList: "Jūsų šaltinių sąrašas yra tuščias", error: "Klaida", errorDialogConfirm: "Gerai", errorDialogTitle: "Įvyko klaida", exitFullScreen: "Išjungti pilno ekrano režimą", expandSection: 'Išplėsti "{{section}}" sekciją', expandSidePanel: "Išplėsti šoninę juostą", exportCopied: "Darbalaukio nustatymai nukopijuoti", fetchManifest: "Pridėti", fullScreen: "Pilnas ekranas", gallery: "Galerija", hideZoomControls: "Slėpti priartinimo valdymą", highlightAllAnnotations: "Paryškinti viską", iiif_homepage: "Apie šį šaltinį", iiif_manifest: "IIIF manifestas", iiif_renderings: "Kiti formatai", iiif_seeAlso: "Susiję", import: "Įkelti", importWorkspace: "Įkelti darbalaukį", importWorkspaceHint: "Įterpkite Mirador 4 nustatymus įkėlimui", item: "Įrašas: {{label}}", itemList: "Įrašų sąrašas", jsError: "Techninė informacija", jsStack: "{{ stack }}", language: "Kalba", layer_hide: "Slėpti sluoksnį", layer_move: "Perkelti sluoksnį", layer_opacity: "Sluoksnio nepermatomumas", layer_show: "Rodyti sluoksnį", layers: "Sluoksniai", light: "Šviesi tema", links: "Nuorodos", listAllOpenWindows: "Rodyti aktyvius langus", login: "Prisijungti", logout: "Atsijungti", manifestError: "Šaltinis negali būti pridėtas:", maximizeWindow: "Išdidinti langą", minimizeWindow: "Sumažinti langą", mirador: "Mirador", miradorResources: "Mirador šaltiniai", miradorViewer: "Mirador žiūryklė", more: "daugiau...", moreResults: "Daugiau rezultatų", mosaic: "Mosaic", mosaicDescription: "Langų dydžio ir pozicijos keitimai apribojami ekrano erdvėje.", moveCompanionWindowToBottom: "Perkelti į apačią", moveCompanionWindowToRight: "Perkelti į dešinę", nextCanvas: "Kitas įrašas", numItems_one: "{{number}} įrašas (-ai)", off: "Išjungti", openCompanionWindow_annotations: "Anotacijos", openCompanionWindow_attribution: "Teisės", openCompanionWindow_canvas: "Indeksas", openCompanionWindow_info: "Informacija", openCompanionWindow_layers: "Sluoksniai", openCompanionWindow_search: "Paieška", openInCompanionWindow: "Atidaryti kaip naują panelę", openWindows: "Aktyvųs langai", pagination: "{{current}} iš {{total}}", position: "Pozicija", previewWindowTitle: "{{title}}", previousCanvas: "Buvęs įrašas", related: "Susiję", resource: "Šaltinis", retry: "Pabandyti iš naujo", right: "Dešinė", rights: "Teisės", scroll: "Paslinkti", searchInputLabel: "paieškos terminas", searchNextResult: "Kitas rezultatas", searchNoResults: "Nėra rezultatų", searchPreviousResult: "Buvęs rezultatas", searchSubmitAria: "Pateikti paieškos užklausą", searchTitle: "Ieškoti", selectWorkspaceMenu: "Pasirinkti darbalaukio tipą", showCollection: "Rodyti kolekciją", showingNumAnnotations_one: "Rodoma {{number}} anotacija (-os)", showZoomControls: "Rodyti priartinimo valdymą", sidebarPanelsNavigation: "Šoninės juostos valdymas", single: "Atskiras", startHere: "Pradėkite čia", suggestSearch: 'Ieškoti "{{ query }}" visame documente', tableOfContentsList: "Turinys", theme: "Tema", thumbnailList: "Miniatiūrų sąrašas", thumbnailNavigation: "Miniatiūros", thumbnails: "Miniatiūros", toggleWindowSideBar: "Perjungti šoninę juostą", totalCollections_one: "{{count}} kolekcija (-os)", totalManifests_one: "{{count}} šaltinis (-iai)", tryAgain: "Bandykite dar kartą", untitled: "[Be pavadinimo]", view: "Žiūrėti", welcome: "Sveiki atvykę į Mirador", window: "Langas: {{label}}", windowMenu: "Langų & miniatiūrų atvaizdavimas", windowNavigation: "Langų valdymas", windowPluginButtons: "Pasirinkimai", windowPluginMenu: "Langų pasirinkimai", workspace: "Darbalaukis", workspaceFullScreen: "Pilnas ekranas", workspaceMenu: "Darbalaukio nustatymai", workspaceNavigation: "Darbalaukio valdymas", workspaceOptions: "Darbalaukio pasirinkimai", workspaceSelectionTitle: "Pasirinkite darbalaukio tipą", zoomIn: "Priartinti", zoomOut: "Atitolinti", zoomReset: "Atstatyti priartinimą" }, AFe = {
  translation: OFe
}, DFe = { aboutMirador: "Về dự án Mirador", aboutThisItem: "Về khoản mục này", addedFromUrl: "(Được thêm từ URL)", addManifestUrl: "Vị trí tài nguyên", addManifestUrlHelp: "URL của tài nguyên IIIF", addResource: "Bổ sung tài nguyên", "annotationCanvasLabel_1/1": "Khoản mục: [{{label}}]", "annotationCanvasLabel_1/2": "Trái: [{{label}}]", "annotationCanvasLabel_2/2": "Phải: [{{label}}]", annotations: "Chú giải", attribution: "Quyền hạn", attributionTitle: "Quyền", authenticationFailed: "Xác thực thất bại.", authenticationRequired: "Xác thực được yêu cầu cho truy nhập đầy đủ", backToResults: "Trở lại kết quả", book: "Sách", bottom: "Đáy", cancel: "Huỷ bỏ", canvasIndex: "Chỉ mục", changeTheme: "Đổi chủ đề", clearSearch: "xoá", close: "Đóng", closeAddResourceForm: "Đóng mẫu", closeAddResourceMenu: "Đóng danh sách tài nguyên", closeCompanionWindow: "Đóng panel", closeWindow: "Đóng cửa sổ", collapseSection: "Co sập {{section}} mục", collapseSidePanel: "Co sập thanh bên", collection: "Tuyển tập", continue: "Tiếp tục", copy: "Sao", currentItem: "Khoản mục hiện thời", "currentItem_1/1": "Khoản mục hiện thời", "currentItem_1/2": "Trái", "currentItem_2/2": "Phải", dark: "Chủ đề tối", digitizedView: "Cái nhìn số hoá", dismiss: "Bác bỏ", displayNoAnnotations: "Không làm nổi bật", downloadExport: "Vùng xuất khẩu", downloadExportWorkspace: "Vùng xuất khẩu", elastic: "Co giãn", elasticDescription: "Di chuyển và định cỡ cửa sổ tự do trong vùng vô giới hạn. Cửa sổ có thể chèn lấp.", emptyResourceList: "Danh sách tài nguyên của bạn là trống", error: "Lỗi", errorDialogConfirm: "OK", errorDialogTitle: "Lỗi đã xuất hiện", exitFullScreen: "Ra khỏi toàn màn hình", expandSection: "Mở rộng {{section}} mục", expandSidePanel: "Mở rộng thanh bên", exportCopied: "Cấu hình vùng làm việc được sao vào bảng đệm của bạn", fetchManifest: "Thêm", fullScreen: "Toàn màn hình", gallery: "Phòng tranh", hideZoomControls: "Ẩn điều khiển thu phóng", highlightAllAnnotations: "Làm nổi bật tất", iiif_homepage: "Về tài nguyên này", iiif_manifest: "Bản kê IIIF", iiif_renderings: "Dạng thức luân phiên", iiif_seeAlso: "Cũng xem", import: "Nhập khẩu", importWorkspace: "Vùng nhập khẩu", importWorkspaceHint: "Dán cấu hình Mirador 4 để được nhập khẩu", item: "Khoản mục: {{label}}", itemList: "Danh sách khoản mục", jsError: "Chi tiết kĩ thuật", jsStack: "{{ stack }}", language: "Ngôn ngữ", layer_hide: "Giấu tầng", layer_move: "Chuyển tầng", layer_opacity: "Làm mờ tầng", layer_show: "Hiện tầng", layers: "Tầng", light: "Chủ đề sáng", links: "Móc nối", listAllOpenWindows: "Nhảy tới cửa sổ", login: "Đăng nhập", logout: "Đăng xuất", manifestError: "Tài nguyên không thể được bổ sung:", maximizeWindow: "Cực đại cửa sổ", minimizeWindow: "Cực tiểu cửa sổ", mirador: "Mirador", miradorResources: "Tài nguyên Mirador", miradorViewer: "Bộ xem Mirador", more: "thêm...", moreResults: "Thêm kết quả", mosaic: "Mosaic", mosaicDescription: "Di chuyển và định cỡ cửa sổ trong quan hệ lẫn nhau, bên trong khung thấy được.", moveCompanionWindowToBottom: "Chuyển tới đáy", moveCompanionWindowToRight: "Chuyển sang phải", nextCanvas: "Khoản mục tiếp", noItemSelected: "Không khoản mục nào được chọn", numItems_one: "{{number}} khoản mục", off: "Off", openCompanionWindow_annotations: "Chú giải", openCompanionWindow_attribution: "Quyền", openCompanionWindow_canvas: "Chỉ mục", openCompanionWindow_info: "Thông tin", openCompanionWindow_layers: "Tầng", openCompanionWindow_search: "Tìm", openInCompanionWindow: "Mở trong ngăn tách rời", openWindows: "Cửa sổ mở hiện thời", pagination: "{{current}} trong {{total}}", position: "Vị trí", previewWindowTitle: "{{title}}", previousCanvas: "Khoản mục trước", related: "Có liên quan", resource: "Tài nguyên", retry: "Thử lại", right: "Quyền", rights: "Cấp phép", scroll: "Cuộn", searchInputLabel: "Từ tìm kiếm", searchNextResult: "Kết quả tiếp", searchNoResults: "Không tìm được kết quả nào", searchPreviousResult: "Kết quả trước", searchSubmitAria: "Đệ trình việc tìm", searchTitle: "Tìm", selectWorkspaceMenu: "Chọn kiểu vùng làm việc", showCollection: "Hiện bộ sưu tập", showingNumAnnotations_one: "Hiện {{number}} chú giải", showZoomControls: "Hiện kiểm soát thu phóng", sidebarPanelsNavigation: "Dẫn lái ngăn thanh bên", single: "Chỉ một", startHere: "Bắt đầu ở đây", suggestSearch: 'Tìm tài liệu này cho "{{ query }}"', tableOfContentsList: "Mục lục", theme: "Chủ đề", thumbnailList: "Danh sách ảnh thu nhỏ", thumbnailNavigation: "Ảnh thu nhỏ", thumbnails: "Ảnh thu nhỏ", toggleWindowSideBar: "chốt thanh bên", totalCollections_one: "{{count}} bộ sưu tập", totalManifests_one: "{{count}} bản kê", tryAgain: "Thử lại", untitled: "[Untitled]", view: "Xem", welcome: "Chào mừng bạn tới Mirador", window: "Cửa sổ: {{label}}", windowMenu: "Xem cửa sổ & hiển thị ảnh thu nhỏ", windowNavigation: "Dẫn lái cửa sổ", windowPluginButtons: "Tuỳ chọn", windowPluginMenu: "Tuỳ chọn cửa sổ", workspace: "Vùng làm việc", workspaceFullScreen: "Toàn màn hình", workspaceMenu: "Thiết đặt vùng làm việc", workspaceNavigation: "Dẫn lái vùng làm việc", workspaceOptions: "Tuỳ chọn vùng làm việc", workspaceSelectionTitle: "Chọn kiểu vùng làm việc", zoomIn: "Thu nhỏ", zoomOut: "Phóng to", zoomReset: "Đặt lại thu phóng" }, IFe = {
  translation: DFe
}, PFe = { aboutMirador: "За проекта Mirador", aboutThisItem: "За този елемент", addedFromUrl: "(Добавено от линк)", addManifestUrl: "Адрес на ресурса", addManifestUrlHelp: "Адресът на IIIF ресурса", addResource: "Добавяне на ресурс", "annotationCanvasLabel_1/1": "Елемент: [{{label}}]", "annotationCanvasLabel_1/2": "Ляво: [{{label}}]", "annotationCanvasLabel_2/2": "Дясно: [{{label}}]", annotations: "Анотации", attribution: "Принос", attributionTitle: "Права", authenticationFailed: "Неуспешна аутентикация.", authenticationRequired: "Необходима е аутентикация за пълен достъп", backToResults: "Назад към ресултатите", book: "Книга", bottom: "Долу", cancel: "Отказ", canvasIndex: "Индекс", changeTheme: "Промяна на темата", clearSearch: "изчистване", close: "Затвори", closeAddResourceForm: "Затваряне на формата", closeAddResourceMenu: "Затваряне на списъка с ресурси", closeCompanionWindow: "Затваряне на панела", closeWindow: "Затваряне на прозореца", collapseSection: 'Свиване на секция "{{section}}"', collapseSidePanel: "Свиване на страничен панел", collection: "Колекция", continue: "Продължи", copy: "Копиране", currentItem: "Текущ елемент", "currentItem_1/1": "Текущ елемент", "currentItem_1/2": "Ляво", "currentItem_2/2": "Дясно", dark: "Тъмен режим", digitizedView: "Цифровизиран преглед", dismiss: "Отхвърляне", displayNoAnnotations: "Изчистване на маркирането", downloadExport: "Експорт на работното пространство", downloadExportWorkspace: "Експорт на работното пространство", elastic: "Еластичен", elasticDescription: "Премествайте и оразмерявайте прозорците свободно в неограничено работно пространство. Прозорците могат да се застъпват.", emptyResourceList: "Списъкът с ресурси е празен", error: "Грешка", errorDialogConfirm: "OK", errorDialogTitle: "Възникна грешка", exitFullScreen: "Изход от цял екран", expandSection: 'Разширяване на секция "{{section}}"', expandSidePanel: "разширяване на страничния панел", exportCopied: "Конфигурацията на работното пространство е копирана в клипборда", fetchManifest: "Добавяне", fullScreen: "Цял екран", gallery: "Галерия", hideZoomControls: "Скриване на контролите за мащабиране", highlightAllAnnotations: "Маркиране на всичко", iiif_homepage: "За този ресурс", iiif_manifest: "IIIF манифест", iiif_related: "Свързано", iiif_renderings: "Алтернативни формати", iiif_seeAlso: "Вижте също", import: "Импорт", importWorkspace: "Импорт на работно пространство", importWorkspaceHint: "Поставете Mirador 4 конфигурация за импорт", item: "Елемент: {{label}}", itemList: "Списък с елементи", jsError: "Технически детайли", jsStack: "{{ stack }}", language: "Език", layer_hide: "Скриване на слой", layer_move: "Преместване на слой", layer_opacity: "Прозрачност на слой", layer_show: "Показване на слой", layers: "Слоеве", light: "Светъл режим", links: "Връзки", listAllOpenWindows: "Към прозорец", login: "Вход", logout: "Изход", manifestError: "Ресурсът не може да бъде добавен:", maximizeWindow: "Увеличаване на прозореца", minimizeWindow: "Минимизиране на прозореца", mirador: "Mirador", miradorResources: "Mirador ресурси", miradorViewer: "Mirador viewer", more: "още...", moreResults: "Още резултати", mosaic: "Мозайка", mosaicDescription: "Премествайте и оразмерявайте прозорците помежду им в рамките на видимата рамка.", moveCompanionWindowToBottom: "Преместване отдолу", moveCompanionWindowToRight: "Преместване вдясно", multipartCollection: "Колекция от много части", nextCanvas: "Следващ елемент", noItemSelected: "Не е избран елемент", numItems: "{{number}} елемент", numItems_plural: "{{number}} елемента", off: "Изключено", openCompanionWindow_annotations: "Анотации", openCompanionWindow_attribution: "Права", openCompanionWindow_canvas: "Индекс", openCompanionWindow_info: "Информация", openCompanionWindow_layers: "Слоеве", openCompanionWindow_search: "Търсене", openInCompanionWindow: "Отваряне в отделен панел", openWindows: "Текущо отворени прозорци", pagination: "{{current}} от {{total}}", position: "Позиция", previewWindowTitle: "{{title}}", previousCanvas: "Предишен елемент", related: "Свързано", resource: "Ресурс", retry: "Опитайте отново", right: "Дясно", rights: "Лиценз", scroll: "Скрол", searchInputLabel: "термини за търсене", searchNextResult: "Следващ резултат", searchNoResults: "Не са намерени резултати", searchPreviousResult: "Предишен резултат", searchResultsRemaining: "{{numLeft}} оставащи", searchSubmitAria: "Търси", searchTitle: "Търсене", selectWorkspaceMenu: "Посочете тип работно пространство", showCollection: "Показване на колекция", showingNumAnnotations: "Показване на {{number}} анотация", showingNumAnnotations_plural: "Показване на {{number}} анотации", showZoomControls: "Показване на контролите за мащабиране", sidebarPanelsNavigation: "Навигация на страничните панели", single: "Единичен", startHere: "Започнете оттук", suggestSearch: 'Търсене в този документ за "{{ query }}"', tableOfContentsList: "Съдържание", theme: "Тема", thumbnailList: "Списък с представителни изображения", thumbnailNavigation: "Представителни изображения", thumbnails: "Представителни изображения", toggleWindowSideBar: "Превключване на страничния панел", totalCollections: "{{count}} колекция", totalCollections_plural: "{{count}} колекции", totalManifests: "{{count}} манифест", totalManifests_plural: "{{count}} манифеста", tryAgain: "Опитайте отново", untitled: "[Неозаглавено]", view: "Изглед", viewWorkspaceConfiguration: "Преглед на конфигурацията на работното пространство", welcome: "Добре дошли в Mirador", window: "Прозорец: {{label}}", windowMenu: "Изгледи на прозорците и на елементите", windowNavigation: "Навигация на прозорците", windowPluginButtons: "Настройки", windowPluginMenu: "Настройки на прозорците", workspace: "Работно пространство", workspaceFullScreen: "Цял екран", workspaceMenu: "Настройки на работното пространство", workspaceNavigation: "Навигация на работното пространство", workspaceOptions: "Опции за работното пространство", workspaceSelectionTitle: "Изберете тип на работно пространство", zoomIn: "Увеличаване", zoomOut: "Намаляване", zoomReset: "Нулиране" }, NFe = {
  translation: PFe
}, MFe = { aboutMirador: "Om Projekt Mirador", aboutThisItem: "Om dette objektet", addedFromUrl: "(Lagt til fra URL)", addManifestUrl: "Nettadresse til samling eller manifest", addManifestUrlHelp: "URL til en IIIF-ressurs", addResource: "Legg til ressurs", "annotationCanvasLabel_1/1": "Objekt: [{{label}}]", "annotationCanvasLabel_1/2": "Venstre: [{{label}}]", "annotationCanvasLabel_2/2": "Høyre: [{{label}}]", annotations: "Annoteringer", attribution: "Tilskrivelse", attributionTitle: "Rettigheter", authenticationFailed: "Autentiseringen feilet.", authenticationRequired: "Autentisering kreves for full tilgang", backToResults: "Tilbake til resultat", book: "Bok", bottom: "Nederst", cancel: "Avbryt", canvasIndex: "Index", changeTheme: "Skift tema", clearSearch: "Fjern søket", close: "Lukk", closeAddResourceForm: "Lukk skjemaet", closeAddResourceMenu: "Lukk ressurslisten", closeCompanionWindow: "Lukk panelet", closeWindow: "Lukk vinduet", collapseSection: 'Lukk seksjonen "{{section}}"', collapseSidePanel: "Lukk sidemenyen", collection: "Samling", continue: "Fortsett", copy: "Kopiere", currentItem: "Valgt objekt", "currentItem_1/1": "Valgt objekt", "currentItem_1/2": "Venstre", "currentItem_2/2": "Høyre", dark: "Mørkt tema", digitizedView: "Digitalisert visning", dismiss: "Lukk", displayNoAnnotations: "Avmarkér alle", downloadExport: "Eksportér arbeidsområde", downloadExportWorkspace: "Eksportér arbeidsområde", elastic: "Elastisk", elasticDescription: "Flytt og endre størrelsen på vinduet fritt i et ubegrenset arbeidsområde. Vindu kan overlappe.", emptyResourceList: "Din resursliste er tom", error: "Error", errorDialogConfirm: "OK", errorDialogTitle: "Et problem oppstod", exitFullScreen: "Forlat fullskjermsvisning", expandSection: 'Ekspandér seksjonen "{{section}}"', expandSidePanel: "Ekspandér sidemenyen", exportCopied: "Konfiguration av arbeidsområdet ble kopiert til din utklippstavle", fetchManifest: "Legg til", fullScreen: "Fullskjermsvisning", gallery: "Galleri", hideZoomControls: "Skjul zoomkontroll", highlightAllAnnotations: "Markér alle", iiif_homepage: "Om denne ressursen", iiif_manifest: "IIIF manifest", iiif_renderings: "Alternativt format", iiif_seeAlso: "Se også", import: "Importér", importWorkspace: "Importér arbeidsområde", importWorkspaceHint: "Lim inn en Mirador 4 konfigurasjon for import", item: "Objekt: {{label}}", itemList: "Objektliste", jsError: "Tekniske detaljer", jsStack: "{{ stack }}", language: "Språk", layer_hide: "Skjul lag", layer_move: "Flytt lag", layer_opacity: "Lag-gjennomsiktighet", layer_show: "Vis lag", layers: "Lag", light: "Lyst tema", links: "Lenker", listAllOpenWindows: "Gå til vindu", login: "Logg inn", logout: "Logg ut", manifestError: "Ressursen kan ikke legges til:", maximizeWindow: "Maksimér vinduet", minimizeWindow: "Minimér vinduet", mirador: "Mirador", miradorResources: "Miradorressurser", miradorViewer: "Mirador bildeviser", more: "mer...", moreResults: "Flere resultat", mosaic: "Mosaik", mosaicDescription: "Flytt og endre størrelse på vinduet i relasjon til hverandre, innenfor den synlige rammen.", moveCompanionWindowToBottom: "Flytt til bunnen", moveCompanionWindowToRight: "Flytt til høyre", nextCanvas: "Neste objekt", noItemSelected: "Ingen valgte objekt", numItems_one: "{{number}} objekt", numItems_other: "{{number}} objekter", off: "Av", openCompanionWindow_annotations: "Annoteringer", openCompanionWindow_attribution: "Rettigheter", openCompanionWindow_canvas: "Indeks", openCompanionWindow_info: "Informasjon", openCompanionWindow_layers: "Lag", openCompanionWindow_search: "Søk", openInCompanionWindow: "Åpne i eget panel", openWindows: "Åpne vindu", pagination: "{{current}} av {{total}}", position: "Posisjon", previewWindowTitle: "{{title}}", previousCanvas: "Forrige objekt", related: "Relatert", resource: "Ressurs", retry: "Forsøk igjen", right: "Til høyre", rights: "Lisens", scroll: "Bla", searchInputLabel: "Søkeord", searchNextResult: "Neste resultat", searchNoResults: "Ingen treff", searchPreviousResult: "Forrige resultat", searchResultsRemaining: "{{numLeft}} igjen", searchSubmitAria: "Søk", searchTitle: "Søk", selectWorkspaceMenu: "Velg arbeidsområde-type", showCollection: "Vis samling", showingNumAnnotations_one: "Vis {{number}} annotasjon", showingNumAnnotations_other: "Vis {{number}} annotasjoner", showZoomControls: "Vis zoomkontroll", sidebarPanelsNavigation: "Sidemeny-panel navigering", single: "En og en", startHere: "Start her", suggestSearch: 'Søk etter "{{ query }}" i dette dokument', tableOfContentsList: "Innholdsfortegnelse", theme: "Tema", thumbnailList: "Miniatyrliste", thumbnailNavigation: "Miniatyrer", thumbnails: "Miniatyrer", toggleWindowSideBar: "Vis/skjul sidemenyen", totalCollections_one: "{{count}} samling", totalCollections_other: "{{count}} samlinger", totalManifests_one: "{{count}} manifest", totalManifests_other: "{{count}} manifester", tryAgain: "Forsøk igjen", untitled: "[uten tittel]", view: "Visning", viewWorkspaceConfiguration: "Vis konfigurasjon av arbeidsområde.", welcome: "Velkommen til Mirador", window: "Vindu: {{label}}", windowMenu: "Vindusvisning & miniatyrvisning", windowNavigation: "Vindusnavigasjon", windowPluginButtons: "Innstillinger", windowPluginMenu: "Vindusinnstillinger", workspace: "Arbeidsområde", workspaceFullScreen: "Fullskjermsvisning", workspaceMenu: "Innstillinger for arbeidsområdet", workspaceNavigation: "Navigasjon i arbeidsområdet", workspaceOptions: "Flere valg for arbeidsområdet", workspaceSelectionTitle: "Velg arbeidsområde-type", zoomIn: "Zoom inn", zoomOut: "Zoom ut", zoomReset: "Tilbakestill zoom" }, jFe = {
  translation: MFe
};
function LFe(e = {}) {
  const t = {
    ar: X3e,
    bg: NFe,
    de: K3e,
    en: J3e,
    et: tFe,
    fa: rFe,
    fr: cFe,
    hr: dFe,
    it: TFe,
    ja: pFe,
    kr: gFe,
    lt: AFe,
    "nb-NO": jFe,
    nl: vFe,
    pl: bFe,
    "pt-BR": SFe,
    sr: _Fe,
    sv: RFe,
    vi: IFe,
    "zh-CN": oFe,
    "zh-TW": sFe
  }, n = G3e();
  return n.use(che).init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: !1
      // react is already safe from xss
    },
    lng: "en",
    resources: t,
    ...e
  }), n;
}
const pse = hg(), hse = ({ dndManager: e = void 0, children: t }) => e === !1 ? t : e === void 0 ? /* @__PURE__ */ T.jsx(Bae, { backend: Gae, options: r3e, children: t }) : /* @__PURE__ */ T.jsx(NI.Provider, { value: e, children: t });
hse.propTypes = {
  children: c.node.isRequired,
  dndManager: c.oneOf([
    void 0,
    !1,
    c.object
    // eslint-disable-line react/forbid-prop-types
  ])
};
const gse = ({ children: e }) => {
  const t = D2e();
  return /* @__PURE__ */ T.jsx(I2e, { handle: t, children: /* @__PURE__ */ T.jsx(pse.Provider, { value: t, children: e }) });
};
gse.propTypes = {
  children: c.node.isRequired
};
const mse = ({ children: e, language: t, translations: n }) => {
  const [r] = Bn(LFe({ lng: t }));
  return ln(() => {
    r && r.language !== t && r.changeLanguage(t);
  }, [r, t]), ln(() => {
    Object.keys(n).forEach((i) => {
      r.addResourceBundle(i, "translation", n[i], !0, !0);
    });
  }, [r, n]), /* @__PURE__ */ T.jsx(uhe, { i18n: r, children: e });
};
mse.propTypes = {
  children: c.node.isRequired,
  language: c.string.isRequired,
  translations: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const kFe = zne({
  key: "muirtl",
  stylisPlugins: [T3e, use]
}), zFe = zne({
  key: "mui"
});
function vse({
  children: e = null,
  language: t,
  theme: n,
  translations: r,
  dndManager: i = void 0
}) {
  return /* @__PURE__ */ T.jsx(gse, { children: /* @__PURE__ */ T.jsx(mse, { language: t, translations: r, children: /* @__PURE__ */ T.jsx(JD.Provider, { value: t, children: /* @__PURE__ */ T.jsx(bhe, { injectFirst: !0, children: /* @__PURE__ */ T.jsx(Che, { value: n.direction === "rtl" ? kFe : zFe, children: /* @__PURE__ */ T.jsx($we, { theme: d_(n), children: /* @__PURE__ */ T.jsx(hse, { dndManager: i, children: e }) }) }) }) }) }) });
}
vse.propTypes = {
  children: c.node,
  dndManager: c.object,
  // eslint-disable-line react/forbid-prop-types
  language: c.string.isRequired,
  theme: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  translations: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const BFe = (e) => ({
  language: Dn(e).language,
  theme: r3(e),
  translations: Dn(e).translations
}), VFe = wt(
  At(BFe),
  Tt("AppProviders")
), UFe = VFe(vse), FFe = gg(() => Promise.resolve().then(() => _mt));
function yse({ dndManager: e = void 0, plugins: t = [] }) {
  const n = yJ();
  return /* @__PURE__ */ T.jsx(Pae, { plugins: t, children: /* @__PURE__ */ T.jsx(UFe, { dndManager: e, children: /* @__PURE__ */ T.jsx(Eg.Provider, { value: n, children: /* @__PURE__ */ T.jsx(
    sU,
    {
      fallback: /* @__PURE__ */ T.jsx("div", {}),
      children: /* @__PURE__ */ T.jsx(FFe, { areaRef: n })
    }
  ) }) }) });
}
yse.propTypes = {
  dndManager: c.object,
  // eslint-disable-line react/forbid-prop-types
  plugins: c.array
  // eslint-disable-line react/forbid-prop-types
};
var Gz, _X;
function WFe() {
  if (_X) return Gz;
  _X = 1;
  var e = mg(), t = Yo(), n = Bl(), r = "[object String]";
  function i(o) {
    return typeof o == "string" || !t(o) && n(o) && e(o) == r;
  }
  return Gz = i, Gz;
}
var HFe = WFe();
const bse = /* @__PURE__ */ Hn(HFe);
var Yz, CX;
function qFe() {
  if (CX) return Yz;
  CX = 1;
  function e(t) {
    return t === void 0;
  }
  return Yz = e, Yz;
}
var $Fe = qFe();
const fg = /* @__PURE__ */ Hn($Fe);
var GFe = JA();
const TW = /* @__PURE__ */ Hn(GFe);
var Xz, RX;
function YFe() {
  if (RX) return Xz;
  RX = 1;
  function e(t) {
    return t === null;
  }
  return Xz = e, Xz;
}
var XFe = YFe();
const xse = /* @__PURE__ */ Hn(XFe);
var Zz, OX;
function ZFe() {
  if (OX) return Zz;
  OX = 1;
  var e = Tx();
  function t(n, r) {
    return e(r, function(i) {
      return n[i];
    });
  }
  return Zz = t, Zz;
}
var Kz, AX;
function KFe() {
  if (AX) return Kz;
  AX = 1;
  var e = ZFe(), t = Cx();
  function n(r) {
    return r == null ? [] : e(r, t(r));
  }
  return Kz = n, Kz;
}
var QFe = KFe();
const JFe = /* @__PURE__ */ Hn(QFe), DX = (e) => [
  eWe,
  tWe,
  nWe,
  rWe,
  iWe,
  oWe,
  aWe
].every((t) => t(e)), eWe = (e) => TI(e), tWe = (e) => {
  const { name: t } = e;
  return fg(t) || bse(t);
}, nWe = (e) => {
  const { mode: t, target: n } = e;
  return fg(t) ? fg(n) : bse(n);
}, rWe = (e) => {
  const { mode: t } = e;
  return fg(t) || ["add", "wrap"].some((n) => n === t);
}, iWe = (e) => {
  const { mapStateToProps: t } = e;
  return fg(t) || xse(t) || TW(t);
}, oWe = (e) => {
  const { mapDispatchToProps: t } = e;
  return fg(t) || xse(t) || TW(t) || TI(t);
}, aWe = (e) => {
  const { reducers: t } = e;
  return fg(t) || TI(t) && JFe(t).every(TW);
};
function Sse(e) {
  const { validPlugins: t, invalidPlugins: n } = sWe(e);
  return lWe(n), t;
}
function sWe(e) {
  const t = [], n = [];
  return e.forEach((r) => {
    Array.isArray(r) ? r.every((o) => DX(o)) ? n.push(...r) : t.push(...r) : DX(r) ? n.push(r) : t.push(r);
  }), { invalidPlugins: t, validPlugins: n };
}
function lWe(e) {
  e.forEach((t) => console.log(`Mirador: Plugin ${t.name} is not valid and was rejected.`));
}
function cWe(e) {
  return e && e.reduce((t, n) => ({ ...t, ...n.reducers }), {});
}
function uWe(e) {
  return e && e.reduce((t, n) => tp(t, n.config || {}), {});
}
function dWe(e) {
  return e && e.filter((t) => t.saga).map((t) => t.saga);
}
function fWe(e) {
  return ({ dispatch: n, getState: r }) => (i) => (o) => typeof o == "function" ? o(n, r, e) : i(o);
}
var pWe = fWe(), zu = function(t) {
  return "@@redux-saga/" + t;
}, wse = /* @__PURE__ */ zu("CANCEL_PROMISE"), Tse = /* @__PURE__ */ zu("CHANNEL_END"), EW = /* @__PURE__ */ zu("IO"), IX = /* @__PURE__ */ zu("MATCH"), Ese = /* @__PURE__ */ zu("MULTICAST"), _se = /* @__PURE__ */ zu("SAGA_ACTION"), hWe = /* @__PURE__ */ zu("SELF_CANCELLATION"), gWe = /* @__PURE__ */ zu("TASK"), tx = /* @__PURE__ */ zu("TASK_CANCEL"), Cse = /* @__PURE__ */ zu("TERMINATE"), mWe = /* @__PURE__ */ zu("LOCATION"), Rse = function(t) {
  return t == null;
}, Ao = function(t) {
  return t != null;
}, Lr = function(t) {
  return typeof t == "function";
}, HI = function(t) {
  return typeof t == "string";
}, Bu = Array.isArray, _W = function(t) {
  return t && !Bu(t) && typeof t == "object";
}, qI = function(t) {
  return t && Lr(t.then);
}, $I = function(t) {
  return t && Lr(t.next) && Lr(t.throw);
}, vWe = function(t) {
  return t && Lr(t.isEmpty) && Lr(t.take) && Lr(t.put);
}, PX = function e(t) {
  return t && (HI(t) || Ase(t) || Lr(t) || Bu(t) && t.every(e));
}, R_ = function(t) {
  return t && Lr(t.take) && Lr(t.close);
}, Ose = function(t) {
  return Lr(t) && t.hasOwnProperty("toString");
}, Ase = function(t) {
  return !!t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype;
}, yWe = function(t) {
  return R_(t) && t[Ese];
}, Dse = function(t) {
  return t && t[EW];
}, bWe = {}, Qz = 2147483647;
function xWe(e, t) {
  if (t === void 0 && (t = !0), bWe.NODE_ENV !== "production" && e > Qz)
    throw new Error("delay only supports a maximum value of " + Qz + "ms");
  var n, r = new Promise(function(i) {
    n = setTimeout(i, Math.min(Qz, e), t);
  });
  return r[wse] = function() {
    clearTimeout(n);
  }, r;
}
var Nu = {}, SWe = function(t) {
  return function() {
    return t;
  };
}, wWe = /* @__PURE__ */ SWe(!0), ca = function() {
};
Nu.NODE_ENV !== "production" && typeof Proxy < "u" && (ca = /* @__PURE__ */ new Proxy(ca, {
  set: function() {
    throw IA("There was an attempt to assign a property to internal `noop` function.");
  }
}));
var Ise = function(t) {
  return t;
}, TWe = typeof Symbol == "function", EWe = TWe && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function er(e, t, n) {
  if (!t(e))
    throw new Error(n);
}
var CW = function(t, n) {
  $t(t, n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(n).forEach(function(r) {
    t[r] = n[r];
  });
}, _We = function(t, n) {
  var r;
  return (r = []).concat.apply(r, n.map(t));
};
function GI(e, t) {
  var n = e.indexOf(t);
  n >= 0 && e.splice(n, 1);
}
function CWe(e) {
  var t = !1;
  return function() {
    t || (t = !0, e());
  };
}
var RWe = function(t) {
  throw t;
}, OWe = function(t) {
  return {
    value: t,
    done: !0
  };
};
function LV(e, t, n) {
  t === void 0 && (t = RWe), n === void 0 && (n = "iterator");
  var r = {
    meta: {
      name: n
    },
    next: e,
    throw: t,
    return: OWe,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (r[Symbol.iterator] = function() {
    return r;
  }), r;
}
function AWe(e, t) {
  var n = t.sagaStack;
  console.error(e), console.error(n);
}
var IA = function(t) {
  return new Error(`
  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug
  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.
  Error: ` + t + `
`);
}, Pse = function(t, n) {
  return (t ? t + "." : "") + "setContext(props): argument " + n + " is not a plain object";
}, DWe = `You can't put (a.k.a. dispatch from saga) frozen actions.
We have to define a special non-enumerable property on those actions for scheduling purposes.
Otherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).
If you are using redux and you care about this behaviour (frozen actions),
then you might want to switch to freezing actions in a middleware rather than in action creator.
Example implementation:

const freezeActions = store => next => action => next(Object.freeze(action))
`, Nse = function(t) {
  return Array.apply(null, new Array(t));
}, IWe = function(t) {
  return function(n) {
    return Nu.NODE_ENV !== "production" && er(n, function(r) {
      return !Object.isFrozen(r);
    }, DWe), t(Object.defineProperty(n, _se, {
      value: !0
    }));
  };
}, Mse = function(t) {
  return t === Cse;
}, jse = function(t) {
  return t === tx;
}, Lse = function(t) {
  return Mse(t) || jse(t);
};
function kse(e, t) {
  var n = Object.keys(e), r = n.length;
  Nu.NODE_ENV !== "production" && er(r, function(p) {
    return p > 0;
  }, "createAllStyleChildCallbacks: get an empty array or object");
  var i = 0, o, s = Bu(e) ? Nse(r) : {}, u = {};
  function f() {
    i === r && (o = !0, t(s));
  }
  return n.forEach(function(p) {
    var m = function(y, S) {
      o || (S || Lse(y) ? (t.cancel(), t(y, S)) : (s[p] = y, i++, f()));
    };
    m.cancel = ca, u[p] = m;
  }), t.cancel = function() {
    o || (o = !0, n.forEach(function(p) {
      return u[p].cancel();
    }));
  }, u;
}
function RW(e) {
  return {
    name: e.name || "anonymous",
    location: zse(e)
  };
}
function zse(e) {
  return e[mWe];
}
function PWe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, i) {
    return function() {
      return r(i.apply(void 0, arguments));
    };
  });
}
var NWe = "Channel's Buffer overflow!", MWe = 1, jWe = 3, Bse = 4;
function LWe(e, t) {
  e === void 0 && (e = 10);
  var n = new Array(e), r = 0, i = 0, o = 0, s = function(m) {
    n[i] = m, i = (i + 1) % e, r++;
  }, u = function() {
    if (r != 0) {
      var m = n[o];
      return n[o] = null, r--, o = (o + 1) % e, m;
    }
  }, f = function() {
    for (var m = []; r; )
      m.push(u());
    return m;
  };
  return {
    isEmpty: function() {
      return r == 0;
    },
    put: function(m) {
      if (r < e)
        s(m);
      else {
        var v;
        switch (t) {
          case MWe:
            throw new Error(NWe);
          case jWe:
            n[i] = m, i = (i + 1) % e, o = i;
            break;
          case Bse:
            v = 2 * e, n = f(), r = n.length, i = n.length, o = 0, n.length = v, e = v, s(m);
            break;
        }
      }
    },
    take: u,
    flush: f
  };
}
var kWe = function(t) {
  return LWe(t, Bse);
}, YO = "TAKE", Vse = "PUT", Use = "ALL", zWe = "RACE", Fse = "CALL", BWe = "CPS", YI = "FORK", VWe = "JOIN", UWe = "CANCEL", Wse = "SELECT", FWe = "ACTION_CHANNEL", WWe = "CANCELLED", HWe = "FLUSH", qWe = "GET_CONTEXT", $We = "SET_CONTEXT", sp = function(t, n) {
  var r;
  return r = {}, r[EW] = !0, r.combinator = !1, r.type = t, r.payload = n, r;
}, GWe = function(t) {
  return Dse(t) && t.type === YI;
}, YWe = function(t) {
  return Nu.NODE_ENV !== "production" && er(t, GWe, "detach(eff): argument must be a fork effect"), sp(YI, $t({}, t.payload, {
    detached: !0
  }));
};
function XWe(e, t) {
  if (e === void 0 && (e = "*"), Nu.NODE_ENV !== "production" && arguments.length && er(arguments[0], Ao, "take(patternOrChannel): patternOrChannel is undefined"), PX(e))
    return Ao(t) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), sp(YO, {
      pattern: e
    });
  if (yWe(e) && Ao(t) && PX(t))
    return sp(YO, {
      channel: e,
      pattern: t
    });
  if (R_(e))
    return Ao(t) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), sp(YO, {
      channel: e
    });
  if (Nu.NODE_ENV !== "production")
    throw new Error("take(patternOrChannel): argument " + e + " is not valid channel or a valid pattern");
}
function Qn(e, t) {
  return Nu.NODE_ENV !== "production" && (arguments.length > 1 ? (er(e, Ao, "put(channel, action): argument channel is undefined"), er(e, R_, "put(channel, action): argument " + e + " is not a valid channel"), er(t, Ao, "put(channel, action): argument action is undefined")) : er(e, Ao, "put(action): argument action is undefined")), Rse(t) && (t = e, e = void 0), sp(Vse, {
    channel: e,
    action: t
  });
}
function po(e) {
  var t = sp(Use, e);
  return t.combinator = !0, t;
}
var OW = function(t, n) {
  if (er(n, Ao, t + ": argument fn is undefined or null"), !Lr(n)) {
    var r = null, i;
    if (Bu(n))
      r = n[0], i = n[1], er(i, Ao, t + ": argument of type [context, fn] has undefined or null `fn`");
    else if (_W(n))
      r = n.context, i = n.fn, er(i, Ao, t + ": argument of type {context, fn} has undefined or null `fn`");
    else {
      er(n, Lr, t + ": argument fn is not function");
      return;
    }
    if (r && HI(i)) {
      er(r[i], Lr, t + ': context arguments has no such method - "' + i + '"');
      return;
    }
    er(i, Lr, t + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
  }
};
function Hse(e, t) {
  var n = null, r;
  return Lr(e) ? r = e : (Bu(e) ? (n = e[0], r = e[1]) : (n = e.context, r = e.fn), n && HI(r) && Lr(n[r]) && (r = n[r])), {
    context: n,
    fn: r,
    args: t
  };
}
var ZWe = function(t) {
  return t !== DW;
};
function br(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (Nu.NODE_ENV !== "production") {
    var i = typeof n[0] == "number" ? n[0] : "ms";
    er(e, ZWe, "instead of writing `yield call(delay, " + i + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + i + ")`"), OW("call", e);
  }
  return sp(Fse, Hse(e, n));
}
function AW(e) {
  Nu.NODE_ENV !== "production" && (OW("fork", e), er(e, function(i) {
    return !Dse(i);
  }, "fork: argument must not be an effect"));
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return sp(YI, Hse(e, n));
}
function KWe(e) {
  Nu.NODE_ENV !== "production" && OW("spawn", e);
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return YWe(AW.apply(void 0, [e].concat(n)));
}
function An(e) {
  e === void 0 && (e = Ise);
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return Nu.NODE_ENV !== "production" && arguments.length && (er(arguments[0], Ao, "select(selector, [...]): argument selector is undefined"), er(e, Lr, "select(selector, [...]): argument " + e + " is not a function")), sp(Wse, {
    selector: e,
    args: n
  });
}
var DW = /* @__PURE__ */ br.bind(null, xWe);
function QWe() {
  var e = {};
  return e.promise = new Promise(function(t, n) {
    e.resolve = t, e.reject = n;
  }), e;
}
var za = {}, qse = [], XI = 0;
function JWe(e) {
  try {
    IW(), e();
  } finally {
    Yse();
  }
}
function $se(e) {
  qse.push(e), XI || (IW(), Xse());
}
function Gse(e) {
  try {
    return IW(), e();
  } finally {
    Xse();
  }
}
function IW() {
  XI++;
}
function Yse() {
  XI--;
}
function Xse() {
  Yse();
  for (var e; !XI && (e = qse.shift()) !== void 0; )
    JWe(e);
}
var eHe = function(t) {
  return function(n) {
    return t.some(function(r) {
      return PW(r)(n);
    });
  };
}, tHe = function(t) {
  return function(n) {
    return t(n);
  };
}, NX = function(t) {
  return function(n) {
    return n.type === String(t);
  };
}, nHe = function(t) {
  return function(n) {
    return n.type === t;
  };
}, Zse = function() {
  return wWe;
};
function PW(e) {
  var t = e === "*" ? Zse : HI(e) ? NX : Bu(e) ? eHe : Ose(e) ? NX : Lr(e) ? tHe : Ase(e) ? nHe : null;
  if (t === null)
    throw new Error("invalid pattern: " + e);
  return t(e);
}
var YE = {
  type: Tse
}, NW = function(t) {
  return t && t.type === Tse;
}, Kse = "Cannot have a closed channel with pending takers", rHe = "invalid buffer passed to channel factory function", Qse = `Saga or channel was provided with an undefined action
Hints:
  - check that your Action Creator returns a non-undefined value
  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners`;
function iHe(e) {
  e === void 0 && (e = kWe());
  var t = !1, n = [];
  za.NODE_ENV !== "production" && er(e, vWe, rHe);
  function r() {
    if (t && n.length)
      throw IA(Kse);
    if (n.length && !e.isEmpty())
      throw IA("Cannot have pending takers with non empty buffer");
  }
  function i(f) {
    if (za.NODE_ENV !== "production" && (r(), er(f, Ao, Qse)), !t) {
      if (n.length === 0)
        return e.put(f);
      var p = n.shift();
      p(f);
    }
  }
  function o(f) {
    za.NODE_ENV !== "production" && (r(), er(f, Lr, "channel.take's callback must be a function")), t && e.isEmpty() ? f(YE) : e.isEmpty() ? (n.push(f), f.cancel = function() {
      GI(n, f);
    }) : f(e.take());
  }
  function s(f) {
    if (za.NODE_ENV !== "production" && (r(), er(f, Lr, "channel.flush' callback must be a function")), t && e.isEmpty()) {
      f(YE);
      return;
    }
    f(e.flush());
  }
  function u() {
    if (za.NODE_ENV !== "production" && r(), !t) {
      t = !0;
      var f = n;
      n = [];
      for (var p = 0, m = f.length; p < m; p++) {
        var v = f[p];
        v(YE);
      }
    }
  }
  return {
    take: o,
    put: i,
    flush: s,
    close: u
  };
}
function oHe() {
  var e, t = !1, n = [], r = n;
  function i() {
    if (t && r.length)
      throw IA(Kse);
  }
  var o = function() {
    r === n && (r = n.slice());
  }, s = function() {
    za.NODE_ENV !== "production" && i(), t = !0;
    var f = n = r;
    r = [], f.forEach(function(p) {
      p(YE);
    });
  };
  return e = {}, e[Ese] = !0, e.put = function(f) {
    if (za.NODE_ENV !== "production" && (i(), er(f, Ao, Qse)), !t) {
      if (NW(f)) {
        s();
        return;
      }
      for (var p = n = r, m = 0, v = p.length; m < v; m++) {
        var y = p[m];
        y[IX](f) && (y.cancel(), y(f));
      }
    }
  }, e.take = function(f, p) {
    if (p === void 0 && (p = Zse), za.NODE_ENV !== "production" && i(), t) {
      f(YE);
      return;
    }
    f[IX] = p, o(), r.push(f), f.cancel = CWe(function() {
      o(), GI(r, f);
    });
  }, e.close = s, e;
}
function Jse() {
  var e = oHe(), t = e.put;
  return e.put = function(n) {
    if (n[_se]) {
      t(n);
      return;
    }
    $se(function() {
      t(n);
    });
  }, e;
}
var bv = 0, np = 1, XO = 2, ele = 3;
function MW(e, t) {
  var n = e[wse];
  Lr(n) && (t.cancel = n), e.then(t, function(r) {
    t(r, !0);
  });
}
var O_ = 0, tle = (function() {
  return ++O_;
}), ia;
function aHe(e, t) {
  return e.isSagaIterator ? {
    name: e.meta.name
  } : RW(t);
}
function sHe(e) {
  var t = e.context, n = e.fn, r = e.args;
  try {
    var i = n.apply(t, r);
    if ($I(i))
      return i;
    var o = !1, s = function(f) {
      return o ? {
        value: f,
        done: !0
      } : (o = !0, {
        value: i,
        done: !qI(i)
      });
    };
    return LV(s);
  } catch (u) {
    return LV(function() {
      throw u;
    });
  }
}
function lHe(e, t, n) {
  var r = t.channel, i = t.action, o = t.resolve;
  $se(function() {
    var s;
    try {
      s = (r ? r.put : e.dispatch)(i);
    } catch (u) {
      n(u, !0);
      return;
    }
    o && qI(s) ? MW(s, n) : n(s);
  });
}
function cHe(e, t, n) {
  var r = t.channel, i = r === void 0 ? e.channel : r, o = t.pattern, s = t.maybe, u = function(p) {
    if (p instanceof Error) {
      n(p, !0);
      return;
    }
    if (NW(p) && !s) {
      n(Cse);
      return;
    }
    n(p);
  };
  try {
    i.take(u, Ao(o) ? PW(o) : null);
  } catch (f) {
    n(f, !0);
    return;
  }
  n.cancel = u.cancel;
}
function uHe(e, t, n, r) {
  var i = t.context, o = t.fn, s = t.args, u = r.task;
  try {
    var f = o.apply(i, s);
    if (qI(f)) {
      MW(f, n);
      return;
    }
    if ($I(f)) {
      ZI(
        e,
        f,
        u.context,
        O_,
        RW(o),
        /* isRoot */
        !1,
        n
      );
      return;
    }
    n(f);
  } catch (p) {
    n(p, !0);
  }
}
function dHe(e, t, n) {
  var r = t.context, i = t.fn, o = t.args;
  try {
    var s = function(f, p) {
      Rse(f) ? n(p) : n(f, !0);
    };
    i.apply(r, o.concat(s)), s.cancel && (n.cancel = s.cancel);
  } catch (u) {
    n(u, !0);
  }
}
function fHe(e, t, n, r) {
  var i = t.context, o = t.fn, s = t.args, u = t.detached, f = r.task, p = sHe({
    context: i,
    fn: o,
    args: s
  }), m = aHe(p, o);
  Gse(function() {
    var v = ZI(e, p, f.context, O_, m, u, void 0);
    u ? n(v) : v.isRunning() ? (f.queue.addTask(v), n(v)) : v.isAborted() ? f.queue.abort(v.error()) : n(v);
  });
}
function pHe(e, t, n, r) {
  var i = r.task, o = function(f, p) {
    if (f.isRunning()) {
      var m = {
        task: i,
        cb: p
      };
      p.cancel = function() {
        f.isRunning() && GI(f.joiners, m);
      }, f.joiners.push(m);
    } else
      f.isAborted() ? p(f.error(), !0) : p(f.result());
  };
  if (Bu(t)) {
    if (t.length === 0) {
      n([]);
      return;
    }
    var s = kse(t, n);
    t.forEach(function(u, f) {
      o(u, s[f]);
    });
  } else
    o(t, n);
}
function Jz(e) {
  e.isRunning() && e.cancel();
}
function hHe(e, t, n, r) {
  var i = r.task;
  t === hWe ? Jz(i) : Bu(t) ? t.forEach(Jz) : Jz(t), n();
}
function gHe(e, t, n, r) {
  var i = r.digestEffect, o = O_, s = Object.keys(t);
  if (s.length === 0) {
    n(Bu(t) ? [] : {});
    return;
  }
  var u = kse(t, n);
  s.forEach(function(f) {
    i(t[f], o, u[f], f);
  });
}
function mHe(e, t, n, r) {
  var i = r.digestEffect, o = O_, s = Object.keys(t), u = Bu(t) ? Nse(s.length) : {}, f = {}, p = !1;
  s.forEach(function(m) {
    var v = function(S, E) {
      p || (E || Lse(S) ? (n.cancel(), n(S, E)) : (n.cancel(), p = !0, u[m] = S, n(u)));
    };
    v.cancel = ca, f[m] = v;
  }), n.cancel = function() {
    p || (p = !0, s.forEach(function(m) {
      return f[m].cancel();
    }));
  }, s.forEach(function(m) {
    p || i(t[m], o, f[m], m);
  });
}
function vHe(e, t, n) {
  var r = t.selector, i = t.args;
  try {
    var o = r.apply(void 0, [e.getState()].concat(i));
    n(o);
  } catch (s) {
    n(s, !0);
  }
}
function yHe(e, t, n) {
  var r = t.pattern, i = t.buffer, o = iHe(i), s = PW(r), u = function p(m) {
    NW(m) || e.channel.take(p, s), o.put(m);
  }, f = o.close;
  o.close = function() {
    u.cancel(), f();
  }, e.channel.take(u, s), n(o);
}
function bHe(e, t, n, r) {
  var i = r.task;
  n(i.isCancelled());
}
function xHe(e, t, n) {
  t.flush(n);
}
function SHe(e, t, n, r) {
  var i = r.task;
  n(i.context[t]);
}
function wHe(e, t, n, r) {
  var i = r.task;
  CW(i.context, t), n();
}
var THe = (ia = {}, ia[YO] = cHe, ia[Vse] = lHe, ia[Use] = gHe, ia[zWe] = mHe, ia[Fse] = uHe, ia[BWe] = dHe, ia[YI] = fHe, ia[VWe] = pHe, ia[UWe] = hHe, ia[Wse] = vHe, ia[FWe] = yHe, ia[WWe] = bHe, ia[HWe] = xHe, ia[qWe] = SHe, ia[$We] = wHe, ia);
function EHe(e, t, n) {
  var r = [], i, o = !1;
  f(e);
  var s = function() {
    return r;
  };
  function u(m) {
    t(), p(), n(m, !0);
  }
  function f(m) {
    r.push(m), m.cont = function(v, y) {
      o || (GI(r, m), m.cont = ca, y ? u(v) : (m === e && (i = v), r.length || (o = !0, n(i))));
    };
  }
  function p() {
    o || (o = !0, r.forEach(function(m) {
      m.cont = ca, m.cancel();
    }), r = []);
  }
  return {
    addTask: f,
    cancelAll: p,
    abort: u,
    getTasks: s
  };
}
function nle(e, t) {
  return e + "?" + t;
}
function _He(e) {
  var t = zse(e);
  if (t) {
    var n = t.code, r = t.fileName, i = t.lineNumber, o = n + "  " + nle(r, i);
    return o;
  }
  return "";
}
function MX(e) {
  var t = e.name, n = e.location;
  return n ? t + "  " + nle(n.fileName, n.lineNumber) : t;
}
function CHe(e) {
  var t = _We(function(n) {
    return n.cancelledTasks;
  }, e);
  return t.length ? ["Tasks cancelled due to error:"].concat(t).join(`
`) : "";
}
var jW = null, XE = [], RHe = function(t) {
  t.crashedEffect = jW, XE.push(t);
}, rle = function() {
  jW = null, XE.length = 0;
}, OHe = function(t) {
  jW = t;
}, AHe = function() {
  var t = XE[0], n = XE.slice(1), r = t.crashedEffect ? _He(t.crashedEffect) : null, i = "The above error occurred in task " + MX(t.meta) + (r ? ` 
 when executing effect ` + r : "");
  return [i].concat(n.map(function(o) {
    return "    created by " + MX(o.meta);
  }), [CHe(XE)]).join(`
`);
};
function DHe(e, t, n, r, i, o, s) {
  var u;
  s === void 0 && (s = ca);
  var f = bv, p, m, v = null, y = [], S = Object.create(n), E = EHe(t, function() {
    y.push.apply(y, E.getTasks().map(function(N) {
      return N.meta.name;
    }));
  }, _);
  function w() {
    f === bv && (f = np, E.cancelAll(), _(tx, !1));
  }
  function _(M, N) {
    if (!N)
      M === tx ? f = np : f !== np && (f = ele), p = M, v && v.resolve(M);
    else {
      if (f = XO, RHe({
        meta: i,
        cancelledTasks: y
      }), P.isRoot) {
        var k = AHe();
        rle(), e.onError(M, {
          sagaStack: k
        });
      }
      m = M, v && v.reject(M);
    }
    P.cont(M, N), P.joiners.forEach(function(U) {
      U.cb(M, N);
    }), P.joiners = null;
  }
  function O(M) {
    za.NODE_ENV !== "production" && er(M, _W, Pse("task", M)), CW(S, M);
  }
  function D() {
    return v || (v = QWe(), f === XO ? v.reject(m) : f !== bv && v.resolve(p)), v.promise;
  }
  var P = (u = {}, u[gWe] = !0, u.id = r, u.meta = i, u.isRoot = o, u.context = S, u.joiners = [], u.queue = E, u.cancel = w, u.cont = s, u.end = _, u.setContext = O, u.toPromise = D, u.isRunning = function() {
    return f === bv;
  }, u.isCancelled = function() {
    return f === np || f === bv && t.status === np;
  }, u.isAborted = function() {
    return f === XO;
  }, u.result = function() {
    return p;
  }, u.error = function() {
    return m;
  }, u);
  return P;
}
function ZI(e, t, n, r, i, o, s) {
  if (za.NODE_ENV !== "production" && t[EWe])
    throw new Error("redux-saga doesn't support async generators, please use only regular ones");
  var u = e.finalizeRunEffect(S);
  y.cancel = ca;
  var f = {
    meta: i,
    cancel: v,
    status: bv
  }, p = DHe(e, f, n, r, i, o, s), m = {
    task: p,
    digestEffect: E
  };
  function v() {
    f.status === bv && (f.status = np, y(tx));
  }
  return s && (s.cancel = p.cancel), y(), p;
  function y(w, _) {
    try {
      var O;
      _ ? (O = t.throw(w), rle()) : jse(w) ? (f.status = np, y.cancel(), O = Lr(t.return) ? t.return(tx) : {
        done: !0,
        value: tx
      }) : Mse(w) ? O = Lr(t.return) ? t.return() : {
        done: !0
      } : O = t.next(w), O.done ? (f.status !== np && (f.status = ele), f.cont(O.value)) : E(O.value, r, y);
    } catch (D) {
      if (f.status === np)
        throw D;
      f.status = XO, f.cont(D, !0);
    }
  }
  function S(w, _, O) {
    if (qI(w))
      MW(w, O);
    else if ($I(w))
      ZI(
        e,
        w,
        p.context,
        _,
        i,
        /* isRoot */
        !1,
        O
      );
    else if (w && w[EW]) {
      var D = THe[w.type];
      D(e, w.payload, O, m);
    } else
      O(w);
  }
  function E(w, _, O, D) {
    D === void 0 && (D = "");
    var P = tle();
    e.sagaMonitor && e.sagaMonitor.effectTriggered({
      effectId: P,
      parentEffectId: _,
      label: D,
      effect: w
    });
    var M;
    function N(k, U) {
      M || (M = !0, O.cancel = ca, e.sagaMonitor && (U ? e.sagaMonitor.effectRejected(P, k) : e.sagaMonitor.effectResolved(P, k)), U && OHe(w), O(k, U));
    }
    N.cancel = ca, O.cancel = function() {
      M || (M = !0, N.cancel(), N.cancel = ca, e.sagaMonitor && e.sagaMonitor.effectCancelled(P));
    }, u(w, P, N);
  }
}
var IHe = "runSaga(options, saga, ...args)", jX = IHe + ": saga argument must be a Generator function!";
function PHe(e, t) {
  var n = e.channel, r = n === void 0 ? Jse() : n, i = e.dispatch, o = e.getState, s = e.context, u = s === void 0 ? {} : s, f = e.sagaMonitor, p = e.effectMiddlewares, m = e.onError, v = m === void 0 ? AWe : m;
  za.NODE_ENV !== "production" && er(t, Lr, jX);
  for (var y = arguments.length, S = new Array(y > 2 ? y - 2 : 0), E = 2; E < y; E++)
    S[E - 2] = arguments[E];
  var w = t.apply(void 0, S);
  za.NODE_ENV !== "production" && er(w, $I, jX);
  var _ = tle();
  if (f && (f.rootSagaStarted = f.rootSagaStarted || ca, f.effectTriggered = f.effectTriggered || ca, f.effectResolved = f.effectResolved || ca, f.effectRejected = f.effectRejected || ca, f.effectCancelled = f.effectCancelled || ca, f.actionDispatched = f.actionDispatched || ca, f.rootSagaStarted({
    effectId: _,
    saga: t,
    args: S
  })), za.NODE_ENV !== "production") {
    if (Ao(i) && er(i, Lr, "dispatch must be a function"), Ao(o) && er(o, Lr, "getState must be a function"), Ao(p)) {
      var O = "effectMiddlewares must be an array of functions";
      er(p, Bu, O), p.forEach(function(N) {
        return er(N, Lr, O);
      });
    }
    er(v, Lr, "onError passed to the redux-saga is not a function!");
  }
  var D;
  if (p) {
    var P = PWe.apply(void 0, p);
    D = function(k) {
      return function(U, H, Y) {
        var z = function(F) {
          return k(F, H, Y);
        };
        return P(z)(U);
      };
    };
  } else
    D = Ise;
  var M = {
    channel: r,
    dispatch: IWe(i),
    getState: o,
    sagaMonitor: f,
    onError: v,
    finalizeRunEffect: D
  };
  return Gse(function() {
    var N = ZI(
      M,
      w,
      u,
      _,
      RW(t),
      /* isRoot */
      !0,
      void 0
    );
    return f && f.effectResolved(_, N), N;
  });
}
function NHe(e) {
  var t = {}, n = t.context, r = n === void 0 ? {} : n, i = t.channel, o = i === void 0 ? Jse() : i, s = t.sagaMonitor, u = Dl(t, ["context", "channel", "sagaMonitor"]), f;
  za.NODE_ENV !== "production" && er(o, R_, "options.channel passed to the Saga middleware is not a channel");
  function p(m) {
    var v = m.getState, y = m.dispatch;
    return f = PHe.bind(null, $t({}, u, {
      context: r,
      channel: o,
      dispatch: y,
      getState: v,
      sagaMonitor: s
    })), function(S) {
      return function(E) {
        s && s.actionDispatched && s.actionDispatched(E);
        var w = S(E);
        return o.put(E), w;
      };
    };
  }
  return p.run = function() {
    if (za.NODE_ENV !== "production" && !f)
      throw new Error("Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware");
    return f.apply(void 0, arguments);
  }, p.setContext = function(m) {
    za.NODE_ENV !== "production" && er(m, _W, Pse("sagaMiddleware", m)), CW(r, m);
  }, p;
}
function MHe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (t.length !== 0)
    return typeof t[0] == "object" ? wt : wt(...t);
}
const jHe = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : MHe;
var eB, LX;
function A_() {
  if (LX) return eB;
  LX = 1;
  var e = EU(), t = oD();
  function n(r, i, o, s) {
    var u = !o;
    o || (o = {});
    for (var f = -1, p = i.length; ++f < p; ) {
      var m = i[f], v = s ? s(o[m], r[m], m, o, r) : void 0;
      v === void 0 && (v = r[m]), u ? t(o, m, v) : e(o, m, v);
    }
    return o;
  }
  return eB = n, eB;
}
var tB, kX;
function ile() {
  if (kX) return tB;
  kX = 1;
  var e = A_(), t = Cx();
  function n(r, i) {
    return r && e(i, t(i), r);
  }
  return tB = n, tB;
}
var nB, zX;
function LHe() {
  if (zX) return nB;
  zX = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return nB = e, nB;
}
var rB, BX;
function kHe() {
  if (BX) return rB;
  BX = 1;
  var e = Mu(), t = cD(), n = LHe(), r = Object.prototype, i = r.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return n(s);
    var u = t(s), f = [];
    for (var p in s)
      p == "constructor" && (u || !i.call(s, p)) || f.push(p);
    return f;
  }
  return rB = o, rB;
}
var iB, VX;
function LW() {
  if (VX) return iB;
  VX = 1;
  var e = gee(), t = kHe(), n = Gv();
  function r(i) {
    return n(i) ? e(i, !0) : t(i);
  }
  return iB = r, iB;
}
var oB, UX;
function zHe() {
  if (UX) return oB;
  UX = 1;
  var e = A_(), t = LW();
  function n(r, i) {
    return r && e(i, t(i), r);
  }
  return oB = n, oB;
}
var NE = { exports: {} };
NE.exports;
var FX;
function BHe() {
  return FX || (FX = 1, (function(e, t) {
    var n = Hs(), r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, s = o ? n.Buffer : void 0, u = s ? s.allocUnsafe : void 0;
    function f(p, m) {
      if (m)
        return p.slice();
      var v = p.length, y = u ? u(v) : new p.constructor(v);
      return p.copy(y), y;
    }
    e.exports = f;
  })(NE, NE.exports)), NE.exports;
}
var aB, WX;
function VHe() {
  if (WX) return aB;
  WX = 1;
  var e = A_(), t = qU();
  function n(r, i) {
    return e(r, t(r), i);
  }
  return aB = n, aB;
}
var sB, HX;
function kW() {
  if (HX) return sB;
  HX = 1;
  var e = fee(), t = e(Object.getPrototypeOf, Object);
  return sB = t, sB;
}
var lB, qX;
function ole() {
  if (qX) return lB;
  qX = 1;
  var e = HU(), t = kW(), n = qU(), r = bee(), i = Object.getOwnPropertySymbols, o = i ? function(s) {
    for (var u = []; s; )
      e(u, n(s)), s = t(s);
    return u;
  } : r;
  return lB = o, lB;
}
var cB, $X;
function UHe() {
  if ($X) return cB;
  $X = 1;
  var e = A_(), t = ole();
  function n(r, i) {
    return e(r, t(r), i);
  }
  return cB = n, cB;
}
var uB, GX;
function ale() {
  if (GX) return uB;
  GX = 1;
  var e = yee(), t = ole(), n = LW();
  function r(i) {
    return e(i, n, t);
  }
  return uB = r, uB;
}
var dB, YX;
function FHe() {
  if (YX) return dB;
  YX = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var i = r.length, o = new r.constructor(i);
    return i && typeof r[0] == "string" && t.call(r, "index") && (o.index = r.index, o.input = r.input), o;
  }
  return dB = n, dB;
}
var fB, XX;
function zW() {
  if (XX) return fB;
  XX = 1;
  var e = vee();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return fB = t, fB;
}
var pB, ZX;
function WHe() {
  if (ZX) return pB;
  ZX = 1;
  var e = zW();
  function t(n, r) {
    var i = r ? e(n.buffer) : n.buffer;
    return new n.constructor(i, n.byteOffset, n.byteLength);
  }
  return pB = t, pB;
}
var hB, KX;
function HHe() {
  if (KX) return hB;
  KX = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return hB = t, hB;
}
var gB, QX;
function qHe() {
  if (QX) return gB;
  QX = 1;
  var e = Sx(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(i) {
    return n ? Object(n.call(i)) : {};
  }
  return gB = r, gB;
}
var mB, JX;
function $He() {
  if (JX) return mB;
  JX = 1;
  var e = zW();
  function t(n, r) {
    var i = r ? e(n.buffer) : n.buffer;
    return new n.constructor(i, n.byteOffset, n.length);
  }
  return mB = t, mB;
}
var vB, eZ;
function GHe() {
  if (eZ) return vB;
  eZ = 1;
  var e = zW(), t = WHe(), n = HHe(), r = qHe(), i = $He(), o = "[object Boolean]", s = "[object Date]", u = "[object Map]", f = "[object Number]", p = "[object RegExp]", m = "[object Set]", v = "[object String]", y = "[object Symbol]", S = "[object ArrayBuffer]", E = "[object DataView]", w = "[object Float32Array]", _ = "[object Float64Array]", O = "[object Int8Array]", D = "[object Int16Array]", P = "[object Int32Array]", M = "[object Uint8Array]", N = "[object Uint8ClampedArray]", k = "[object Uint16Array]", U = "[object Uint32Array]";
  function H(Y, z, V) {
    var F = Y.constructor;
    switch (z) {
      case S:
        return e(Y);
      case o:
      case s:
        return new F(+Y);
      case E:
        return t(Y, V);
      case w:
      case _:
      case O:
      case D:
      case P:
      case M:
      case N:
      case k:
      case U:
        return i(Y, V);
      case u:
        return new F();
      case f:
      case v:
        return new F(Y);
      case p:
        return n(Y);
      case m:
        return new F();
      case y:
        return r(Y);
    }
  }
  return vB = H, vB;
}
var yB, tZ;
function YHe() {
  if (tZ) return yB;
  tZ = 1;
  var e = aD(), t = kW(), n = cD();
  function r(i) {
    return typeof i.constructor == "function" && !n(i) ? e(t(i)) : {};
  }
  return yB = r, yB;
}
var bB, nZ;
function XHe() {
  if (nZ) return bB;
  nZ = 1;
  var e = _x(), t = Bl(), n = "[object Map]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return bB = r, bB;
}
var xB, rZ;
function ZHe() {
  if (rZ) return xB;
  rZ = 1;
  var e = XHe(), t = M1(), n = LU(), r = n && n.isMap, i = r ? t(r) : e;
  return xB = i, xB;
}
var SB, iZ;
function KHe() {
  if (iZ) return SB;
  iZ = 1;
  var e = _x(), t = Bl(), n = "[object Set]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return SB = r, SB;
}
var wB, oZ;
function QHe() {
  if (oZ) return wB;
  oZ = 1;
  var e = KHe(), t = M1(), n = LU(), r = n && n.isSet, i = r ? t(r) : e;
  return wB = i, wB;
}
var TB, aZ;
function BW() {
  if (aZ) return TB;
  aZ = 1;
  var e = VU(), t = AU(), n = EU(), r = ile(), i = zHe(), o = BHe(), s = lD(), u = VHe(), f = UHe(), p = xee(), m = ale(), v = _x(), y = FHe(), S = GHe(), E = YHe(), w = Yo(), _ = dD(), O = ZHe(), D = Mu(), P = QHe(), M = Cx(), N = LW(), k = 1, U = 2, H = 4, Y = "[object Arguments]", z = "[object Array]", V = "[object Boolean]", F = "[object Date]", X = "[object Error]", oe = "[object Function]", re = "[object GeneratorFunction]", Z = "[object Map]", ee = "[object Number]", J = "[object Object]", le = "[object RegExp]", be = "[object Set]", ne = "[object String]", ae = "[object Symbol]", ie = "[object WeakMap]", he = "[object ArrayBuffer]", pe = "[object DataView]", me = "[object Float32Array]", Ee = "[object Float64Array]", Ie = "[object Int8Array]", Pe = "[object Int16Array]", De = "[object Int32Array]", Ye = "[object Uint8Array]", Ue = "[object Uint8ClampedArray]", ve = "[object Uint16Array]", rt = "[object Uint32Array]", Te = {};
  Te[Y] = Te[z] = Te[he] = Te[pe] = Te[V] = Te[F] = Te[me] = Te[Ee] = Te[Ie] = Te[Pe] = Te[De] = Te[Z] = Te[ee] = Te[J] = Te[le] = Te[be] = Te[ne] = Te[ae] = Te[Ye] = Te[Ue] = Te[ve] = Te[rt] = !0, Te[X] = Te[oe] = Te[ie] = !1;
  function Je(L, te, ge, ke, We, Be) {
    var je, mt = te & k, qe = te & U, at = te & H;
    if (ge && (je = We ? ge(L, ke, We, Be) : ge(L)), je !== void 0)
      return je;
    if (!D(L))
      return L;
    var et = w(L);
    if (et) {
      if (je = y(L), !mt)
        return s(L, je);
    } else {
      var bt = v(L), q = bt == oe || bt == re;
      if (_(L))
        return o(L, mt);
      if (bt == J || bt == Y || q && !We) {
        if (je = qe || q ? {} : E(L), !mt)
          return qe ? f(L, i(je, L)) : u(L, r(je, L));
      } else {
        if (!Te[bt])
          return We ? L : {};
        je = S(L, bt, mt);
      }
    }
    Be || (Be = new e());
    var W = Be.get(L);
    if (W)
      return W;
    Be.set(L, je), P(L) ? L.forEach(function(_e) {
      je.add(Je(_e, te, ge, _e, L, Be));
    }) : O(L) && L.forEach(function(_e, Fe) {
      je.set(Fe, Je(_e, te, ge, Fe, L, Be));
    });
    var Q = at ? qe ? m : p : qe ? N : M, ce = et ? void 0 : Q(L);
    return t(ce || L, function(_e, Fe) {
      ce && (Fe = _e, _e = L[Fe]), n(je, Fe, Je(_e, te, ge, Fe, L, Be));
    }), je;
  }
  return TB = Je, TB;
}
var EB, sZ;
function JHe() {
  if (sZ) return EB;
  sZ = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return EB = e, EB;
}
var _B, lZ;
function sle() {
  if (lZ) return _B;
  lZ = 1;
  function e(t, n, r) {
    var i = -1, o = t.length;
    n < 0 && (n = -n > o ? 0 : o + n), r = r > o ? o : r, r < 0 && (r += o), o = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var s = Array(o); ++i < o; )
      s[i] = t[i + n];
    return s;
  }
  return _B = e, _B;
}
var CB, cZ;
function e5e() {
  if (cZ) return CB;
  cZ = 1;
  var e = P1(), t = sle();
  function n(r, i) {
    return i.length < 2 ? r : e(r, t(i, 0, -1));
  }
  return CB = n, CB;
}
var RB, uZ;
function t5e() {
  if (uZ) return RB;
  uZ = 1;
  var e = I1(), t = JHe(), n = e5e(), r = $v();
  function i(o, s) {
    return s = e(s, o), o = n(o, s), o == null || delete o[r(t(s))];
  }
  return RB = i, RB;
}
var OB, dZ;
function lle() {
  if (dZ) return OB;
  dZ = 1;
  var e = mg(), t = kW(), n = Bl(), r = "[object Object]", i = Function.prototype, o = Object.prototype, s = i.toString, u = o.hasOwnProperty, f = s.call(Object);
  function p(m) {
    if (!n(m) || e(m) != r)
      return !1;
    var v = t(m);
    if (v === null)
      return !0;
    var y = u.call(v, "constructor") && v.constructor;
    return typeof y == "function" && y instanceof y && s.call(y) == f;
  }
  return OB = p, OB;
}
var AB, fZ;
function n5e() {
  if (fZ) return AB;
  fZ = 1;
  var e = lle();
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return AB = t, AB;
}
var DB, pZ;
function cle() {
  if (pZ) return DB;
  pZ = 1;
  var e = Tee(), t = yte(), n = OU();
  function r(i) {
    return n(t(i, void 0, e), i + "");
  }
  return DB = r, DB;
}
var IB, hZ;
function r5e() {
  if (hZ) return IB;
  hZ = 1;
  var e = Tx(), t = BW(), n = t5e(), r = I1(), i = A_(), o = n5e(), s = cle(), u = ale(), f = 1, p = 2, m = 4, v = s(function(y, S) {
    var E = {};
    if (y == null)
      return E;
    var w = !1;
    S = e(S, function(O) {
      return O = r(O, y), w || (w = O.length > 1), O;
    }), i(y, u(y), E), w && (E = t(E, f | p | m, o));
    for (var _ = S.length; _--; )
      n(E, S[_]);
    return E;
  });
  return IB = v, IB;
}
var i5e = r5e();
const qd = /* @__PURE__ */ Hn(i5e);
function ule(e = {}, t) {
  var n, r;
  switch (t.type) {
    case Ce.RESOLVE_AUTHENTICATION_REQUEST:
      return {
        ...e,
        [t.tokenServiceId]: {
          authId: t.id,
          id: t.tokenServiceId,
          isFetching: !0
        }
      };
    case Ce.REQUEST_ACCESS_TOKEN:
      return {
        ...e,
        [t.serviceId]: {
          authId: t.authId,
          id: t.serviceId,
          isFetching: !0
        }
      };
    case Ce.RECEIVE_ACCESS_TOKEN:
      return {
        ...e,
        [t.serviceId]: {
          ...e[t.serviceId],
          isFetching: !1,
          json: t.json
        }
      };
    case Ce.RECEIVE_ACCESS_TOKEN_FAILURE:
      return {
        ...e,
        [t.serviceId]: {
          ...e[t.serviceId],
          error: t.error,
          isFetching: !1
        }
      };
    case Ce.RESET_AUTHENTICATION_STATE:
      return qd(e, t.tokenServiceId);
    case Ce.RECEIVE_INFO_RESPONSE:
      return !t.tokenServiceId || (n = e[t.tokenServiceId]) != null && n.success ? e : {
        ...e,
        [t.tokenServiceId]: {
          ...e[t.tokenServiceId],
          success: !0
        }
      };
    case Ce.RECEIVE_PROBE_RESPONSE:
      return !t.tokenServiceId || (r = e[t.tokenServiceId]) != null && r.success ? e : {
        ...e,
        [t.tokenServiceId]: {
          ...e[t.tokenServiceId],
          success: !0
        }
      };
    default:
      return e;
  }
}
var PB = {}, gZ;
function o5e() {
  return gZ || (gZ = 1, (function(e) {
    e.aliasToReal = {
      // Lodash aliases.
      each: "forEach",
      eachRight: "forEachRight",
      entries: "toPairs",
      entriesIn: "toPairsIn",
      extend: "assignIn",
      extendAll: "assignInAll",
      extendAllWith: "assignInAllWith",
      extendWith: "assignInWith",
      first: "head",
      // Methods that are curried variants of others.
      conforms: "conformsTo",
      matches: "isMatch",
      property: "get",
      // Ramda aliases.
      __: "placeholder",
      F: "stubFalse",
      T: "stubTrue",
      all: "every",
      allPass: "overEvery",
      always: "constant",
      any: "some",
      anyPass: "overSome",
      apply: "spread",
      assoc: "set",
      assocPath: "set",
      complement: "negate",
      compose: "flowRight",
      contains: "includes",
      dissoc: "unset",
      dissocPath: "unset",
      dropLast: "dropRight",
      dropLastWhile: "dropRightWhile",
      equals: "isEqual",
      identical: "eq",
      indexBy: "keyBy",
      init: "initial",
      invertObj: "invert",
      juxt: "over",
      omitAll: "omit",
      nAry: "ary",
      path: "get",
      pathEq: "matchesProperty",
      pathOr: "getOr",
      paths: "at",
      pickAll: "pick",
      pipe: "flow",
      pluck: "map",
      prop: "get",
      propEq: "matchesProperty",
      propOr: "getOr",
      props: "at",
      symmetricDifference: "xor",
      symmetricDifferenceBy: "xorBy",
      symmetricDifferenceWith: "xorWith",
      takeLast: "takeRight",
      takeLastWhile: "takeRightWhile",
      unapply: "rest",
      unnest: "flatten",
      useWith: "overArgs",
      where: "conformsTo",
      whereEq: "isMatch",
      zipObj: "zipObject"
    }, e.aryMethod = {
      1: [
        "assignAll",
        "assignInAll",
        "attempt",
        "castArray",
        "ceil",
        "create",
        "curry",
        "curryRight",
        "defaultsAll",
        "defaultsDeepAll",
        "floor",
        "flow",
        "flowRight",
        "fromPairs",
        "invert",
        "iteratee",
        "memoize",
        "method",
        "mergeAll",
        "methodOf",
        "mixin",
        "nthArg",
        "over",
        "overEvery",
        "overSome",
        "rest",
        "reverse",
        "round",
        "runInContext",
        "spread",
        "template",
        "trim",
        "trimEnd",
        "trimStart",
        "uniqueId",
        "words",
        "zipAll"
      ],
      2: [
        "add",
        "after",
        "ary",
        "assign",
        "assignAllWith",
        "assignIn",
        "assignInAllWith",
        "at",
        "before",
        "bind",
        "bindAll",
        "bindKey",
        "chunk",
        "cloneDeepWith",
        "cloneWith",
        "concat",
        "conformsTo",
        "countBy",
        "curryN",
        "curryRightN",
        "debounce",
        "defaults",
        "defaultsDeep",
        "defaultTo",
        "delay",
        "difference",
        "divide",
        "drop",
        "dropRight",
        "dropRightWhile",
        "dropWhile",
        "endsWith",
        "eq",
        "every",
        "filter",
        "find",
        "findIndex",
        "findKey",
        "findLast",
        "findLastIndex",
        "findLastKey",
        "flatMap",
        "flatMapDeep",
        "flattenDepth",
        "forEach",
        "forEachRight",
        "forIn",
        "forInRight",
        "forOwn",
        "forOwnRight",
        "get",
        "groupBy",
        "gt",
        "gte",
        "has",
        "hasIn",
        "includes",
        "indexOf",
        "intersection",
        "invertBy",
        "invoke",
        "invokeMap",
        "isEqual",
        "isMatch",
        "join",
        "keyBy",
        "lastIndexOf",
        "lt",
        "lte",
        "map",
        "mapKeys",
        "mapValues",
        "matchesProperty",
        "maxBy",
        "meanBy",
        "merge",
        "mergeAllWith",
        "minBy",
        "multiply",
        "nth",
        "omit",
        "omitBy",
        "overArgs",
        "pad",
        "padEnd",
        "padStart",
        "parseInt",
        "partial",
        "partialRight",
        "partition",
        "pick",
        "pickBy",
        "propertyOf",
        "pull",
        "pullAll",
        "pullAt",
        "random",
        "range",
        "rangeRight",
        "rearg",
        "reject",
        "remove",
        "repeat",
        "restFrom",
        "result",
        "sampleSize",
        "some",
        "sortBy",
        "sortedIndex",
        "sortedIndexOf",
        "sortedLastIndex",
        "sortedLastIndexOf",
        "sortedUniqBy",
        "split",
        "spreadFrom",
        "startsWith",
        "subtract",
        "sumBy",
        "take",
        "takeRight",
        "takeRightWhile",
        "takeWhile",
        "tap",
        "throttle",
        "thru",
        "times",
        "trimChars",
        "trimCharsEnd",
        "trimCharsStart",
        "truncate",
        "union",
        "uniqBy",
        "uniqWith",
        "unset",
        "unzipWith",
        "without",
        "wrap",
        "xor",
        "zip",
        "zipObject",
        "zipObjectDeep"
      ],
      3: [
        "assignInWith",
        "assignWith",
        "clamp",
        "differenceBy",
        "differenceWith",
        "findFrom",
        "findIndexFrom",
        "findLastFrom",
        "findLastIndexFrom",
        "getOr",
        "includesFrom",
        "indexOfFrom",
        "inRange",
        "intersectionBy",
        "intersectionWith",
        "invokeArgs",
        "invokeArgsMap",
        "isEqualWith",
        "isMatchWith",
        "flatMapDepth",
        "lastIndexOfFrom",
        "mergeWith",
        "orderBy",
        "padChars",
        "padCharsEnd",
        "padCharsStart",
        "pullAllBy",
        "pullAllWith",
        "rangeStep",
        "rangeStepRight",
        "reduce",
        "reduceRight",
        "replace",
        "set",
        "slice",
        "sortedIndexBy",
        "sortedLastIndexBy",
        "transform",
        "unionBy",
        "unionWith",
        "update",
        "xorBy",
        "xorWith",
        "zipWith"
      ],
      4: [
        "fill",
        "setWith",
        "updateWith"
      ]
    }, e.aryRearg = {
      2: [1, 0],
      3: [2, 0, 1],
      4: [3, 2, 0, 1]
    }, e.iterateeAry = {
      dropRightWhile: 1,
      dropWhile: 1,
      every: 1,
      filter: 1,
      find: 1,
      findFrom: 1,
      findIndex: 1,
      findIndexFrom: 1,
      findKey: 1,
      findLast: 1,
      findLastFrom: 1,
      findLastIndex: 1,
      findLastIndexFrom: 1,
      findLastKey: 1,
      flatMap: 1,
      flatMapDeep: 1,
      flatMapDepth: 1,
      forEach: 1,
      forEachRight: 1,
      forIn: 1,
      forInRight: 1,
      forOwn: 1,
      forOwnRight: 1,
      map: 1,
      mapKeys: 1,
      mapValues: 1,
      partition: 1,
      reduce: 2,
      reduceRight: 2,
      reject: 1,
      remove: 1,
      some: 1,
      takeRightWhile: 1,
      takeWhile: 1,
      times: 1,
      transform: 2
    }, e.iterateeRearg = {
      mapKeys: [1],
      reduceRight: [1, 0]
    }, e.methodRearg = {
      assignInAllWith: [1, 0],
      assignInWith: [1, 2, 0],
      assignAllWith: [1, 0],
      assignWith: [1, 2, 0],
      differenceBy: [1, 2, 0],
      differenceWith: [1, 2, 0],
      getOr: [2, 1, 0],
      intersectionBy: [1, 2, 0],
      intersectionWith: [1, 2, 0],
      isEqualWith: [1, 2, 0],
      isMatchWith: [2, 1, 0],
      mergeAllWith: [1, 0],
      mergeWith: [1, 2, 0],
      padChars: [2, 1, 0],
      padCharsEnd: [2, 1, 0],
      padCharsStart: [2, 1, 0],
      pullAllBy: [2, 1, 0],
      pullAllWith: [2, 1, 0],
      rangeStep: [1, 2, 0],
      rangeStepRight: [1, 2, 0],
      setWith: [3, 1, 2, 0],
      sortedIndexBy: [2, 1, 0],
      sortedLastIndexBy: [2, 1, 0],
      unionBy: [1, 2, 0],
      unionWith: [1, 2, 0],
      updateWith: [3, 1, 2, 0],
      xorBy: [1, 2, 0],
      xorWith: [1, 2, 0],
      zipWith: [1, 2, 0]
    }, e.methodSpread = {
      assignAll: { start: 0 },
      assignAllWith: { start: 0 },
      assignInAll: { start: 0 },
      assignInAllWith: { start: 0 },
      defaultsAll: { start: 0 },
      defaultsDeepAll: { start: 0 },
      invokeArgs: { start: 2 },
      invokeArgsMap: { start: 2 },
      mergeAll: { start: 0 },
      mergeAllWith: { start: 0 },
      partial: { start: 1 },
      partialRight: { start: 1 },
      without: { start: 1 },
      zipAll: { start: 0 }
    }, e.mutate = {
      array: {
        fill: !0,
        pull: !0,
        pullAll: !0,
        pullAllBy: !0,
        pullAllWith: !0,
        pullAt: !0,
        remove: !0,
        reverse: !0
      },
      object: {
        assign: !0,
        assignAll: !0,
        assignAllWith: !0,
        assignIn: !0,
        assignInAll: !0,
        assignInAllWith: !0,
        assignInWith: !0,
        assignWith: !0,
        defaults: !0,
        defaultsAll: !0,
        defaultsDeep: !0,
        defaultsDeepAll: !0,
        merge: !0,
        mergeAll: !0,
        mergeAllWith: !0,
        mergeWith: !0
      },
      set: {
        set: !0,
        setWith: !0,
        unset: !0,
        update: !0,
        updateWith: !0
      }
    }, e.realToAlias = (function() {
      var t = Object.prototype.hasOwnProperty, n = e.aliasToReal, r = {};
      for (var i in n) {
        var o = n[i];
        t.call(r, o) ? r[o].push(i) : r[o] = [i];
      }
      return r;
    })(), e.remap = {
      assignAll: "assign",
      assignAllWith: "assignWith",
      assignInAll: "assignIn",
      assignInAllWith: "assignInWith",
      curryN: "curry",
      curryRightN: "curryRight",
      defaultsAll: "defaults",
      defaultsDeepAll: "defaultsDeep",
      findFrom: "find",
      findIndexFrom: "findIndex",
      findLastFrom: "findLast",
      findLastIndexFrom: "findLastIndex",
      getOr: "get",
      includesFrom: "includes",
      indexOfFrom: "indexOf",
      invokeArgs: "invoke",
      invokeArgsMap: "invokeMap",
      lastIndexOfFrom: "lastIndexOf",
      mergeAll: "merge",
      mergeAllWith: "mergeWith",
      padChars: "pad",
      padCharsEnd: "padEnd",
      padCharsStart: "padStart",
      propertyOf: "get",
      rangeStep: "range",
      rangeStepRight: "rangeRight",
      restFrom: "rest",
      spreadFrom: "spread",
      trimChars: "trim",
      trimCharsEnd: "trimEnd",
      trimCharsStart: "trimStart",
      zipAll: "zip"
    }, e.skipFixed = {
      castArray: !0,
      flow: !0,
      flowRight: !0,
      iteratee: !0,
      mixin: !0,
      rearg: !0,
      runInContext: !0
    }, e.skipRearg = {
      add: !0,
      assign: !0,
      assignIn: !0,
      bind: !0,
      bindKey: !0,
      concat: !0,
      difference: !0,
      divide: !0,
      eq: !0,
      gt: !0,
      gte: !0,
      isEqual: !0,
      lt: !0,
      lte: !0,
      matchesProperty: !0,
      merge: !0,
      multiply: !0,
      overArgs: !0,
      partial: !0,
      partialRight: !0,
      propertyOf: !0,
      random: !0,
      range: !0,
      rangeRight: !0,
      subtract: !0,
      zip: !0,
      zipObject: !0,
      zipObjectDeep: !0
    };
  })(PB)), PB;
}
var NB, mZ;
function VW() {
  return mZ || (mZ = 1, NB = {}), NB;
}
var MB, vZ;
function a5e() {
  if (vZ) return MB;
  vZ = 1;
  var e = o5e(), t = VW(), n = Array.prototype.push;
  function r(m, v) {
    return v == 2 ? function(y, S) {
      return m.apply(void 0, arguments);
    } : function(y) {
      return m.apply(void 0, arguments);
    };
  }
  function i(m, v) {
    return v == 2 ? function(y, S) {
      return m(y, S);
    } : function(y) {
      return m(y);
    };
  }
  function o(m) {
    for (var v = m ? m.length : 0, y = Array(v); v--; )
      y[v] = m[v];
    return y;
  }
  function s(m) {
    return function(v) {
      return m({}, v);
    };
  }
  function u(m, v) {
    return function() {
      for (var y = arguments.length, S = y - 1, E = Array(y); y--; )
        E[y] = arguments[y];
      var w = E[v], _ = E.slice(0, v);
      return w && n.apply(_, w), v != S && n.apply(_, E.slice(v + 1)), m.apply(this, _);
    };
  }
  function f(m, v) {
    return function() {
      var y = arguments.length;
      if (y) {
        for (var S = Array(y); y--; )
          S[y] = arguments[y];
        var E = S[0] = v.apply(void 0, S);
        return m.apply(void 0, S), E;
      }
    };
  }
  function p(m, v, y, S) {
    var E = typeof v == "function", w = v === Object(v);
    if (w && (S = y, y = v, v = void 0), y == null)
      throw new TypeError();
    S || (S = {});
    var _ = {
      cap: "cap" in S ? S.cap : !0,
      curry: "curry" in S ? S.curry : !0,
      fixed: "fixed" in S ? S.fixed : !0,
      immutable: "immutable" in S ? S.immutable : !0,
      rearg: "rearg" in S ? S.rearg : !0
    }, O = E ? y : t, D = "curry" in S && S.curry, P = "fixed" in S && S.fixed, M = "rearg" in S && S.rearg, N = E ? y.runInContext() : void 0, k = E ? y : {
      ary: m.ary,
      assign: m.assign,
      clone: m.clone,
      curry: m.curry,
      forEach: m.forEach,
      isArray: m.isArray,
      isError: m.isError,
      isFunction: m.isFunction,
      isWeakMap: m.isWeakMap,
      iteratee: m.iteratee,
      keys: m.keys,
      rearg: m.rearg,
      toInteger: m.toInteger,
      toPath: m.toPath
    }, U = k.ary, H = k.assign, Y = k.clone, z = k.curry, V = k.forEach, F = k.isArray, X = k.isError, oe = k.isFunction, re = k.isWeakMap, Z = k.keys, ee = k.rearg, J = k.toInteger, le = k.toPath, be = Z(e.aryMethod), ne = {
      castArray: function(Te) {
        return function() {
          var Je = arguments[0];
          return F(Je) ? Te(o(Je)) : Te.apply(void 0, arguments);
        };
      },
      iteratee: function(Te) {
        return function() {
          var Je = arguments[0], L = arguments[1], te = Te(Je, L), ge = te.length;
          return _.cap && typeof L == "number" ? (L = L > 2 ? L - 2 : 1, ge && ge <= L ? te : i(te, L)) : te;
        };
      },
      mixin: function(Te) {
        return function(Je) {
          var L = this;
          if (!oe(L))
            return Te(L, Object(Je));
          var te = [];
          return V(Z(Je), function(ge) {
            oe(Je[ge]) && te.push([ge, L.prototype[ge]]);
          }), Te(L, Object(Je)), V(te, function(ge) {
            var ke = ge[1];
            oe(ke) ? L.prototype[ge[0]] = ke : delete L.prototype[ge[0]];
          }), L;
        };
      },
      nthArg: function(Te) {
        return function(Je) {
          var L = Je < 0 ? 1 : J(Je) + 1;
          return z(Te(Je), L);
        };
      },
      rearg: function(Te) {
        return function(Je, L) {
          var te = L ? L.length : 0;
          return z(Te(Je, L), te);
        };
      },
      runInContext: function(Te) {
        return function(Je) {
          return p(m, Te(Je), S);
        };
      }
    };
    function ae(Te, Je) {
      if (_.cap) {
        var L = e.iterateeRearg[Te];
        if (L)
          return De(Je, L);
        var te = !E && e.iterateeAry[Te];
        if (te)
          return Pe(Je, te);
      }
      return Je;
    }
    function ie(Te, Je, L) {
      return D || _.curry && L > 1 ? z(Je, L) : Je;
    }
    function he(Te, Je, L) {
      if (_.fixed && (P || !e.skipFixed[Te])) {
        var te = e.methodSpread[Te], ge = te && te.start;
        return ge === void 0 ? U(Je, L) : u(Je, ge);
      }
      return Je;
    }
    function pe(Te, Je, L) {
      return _.rearg && L > 1 && (M || !e.skipRearg[Te]) ? ee(Je, e.methodRearg[Te] || e.aryRearg[L]) : Je;
    }
    function me(Te, Je) {
      Je = le(Je);
      for (var L = -1, te = Je.length, ge = te - 1, ke = Y(Object(Te)), We = ke; We != null && ++L < te; ) {
        var Be = Je[L], je = We[Be];
        je != null && !(oe(je) || X(je) || re(je)) && (We[Be] = Y(L == ge ? je : Object(je))), We = We[Be];
      }
      return ke;
    }
    function Ee(Te) {
      return ve.runInContext.convert(Te)(void 0);
    }
    function Ie(Te, Je) {
      var L = e.aliasToReal[Te] || Te, te = e.remap[L] || L, ge = S;
      return function(ke) {
        var We = E ? N : k, Be = E ? N[te] : Je, je = H(H({}, ge), ke);
        return p(We, L, Be, je);
      };
    }
    function Pe(Te, Je) {
      return Ye(Te, function(L) {
        return typeof L == "function" ? i(L, Je) : L;
      });
    }
    function De(Te, Je) {
      return Ye(Te, function(L) {
        var te = Je.length;
        return r(ee(i(L, te), Je), te);
      });
    }
    function Ye(Te, Je) {
      return function() {
        var L = arguments.length;
        if (!L)
          return Te();
        for (var te = Array(L); L--; )
          te[L] = arguments[L];
        var ge = _.rearg ? 0 : L - 1;
        return te[ge] = Je(te[ge]), Te.apply(void 0, te);
      };
    }
    function Ue(Te, Je, L) {
      var te, ge = e.aliasToReal[Te] || Te, ke = Je, We = ne[ge];
      return We ? ke = We(Je) : _.immutable && (e.mutate.array[ge] ? ke = f(Je, o) : e.mutate.object[ge] ? ke = f(Je, s(Je)) : e.mutate.set[ge] && (ke = f(Je, me))), V(be, function(Be) {
        return V(e.aryMethod[Be], function(je) {
          if (ge == je) {
            var mt = e.methodSpread[ge], qe = mt && mt.afterRearg;
            return te = qe ? he(ge, pe(ge, ke, Be), Be) : pe(ge, he(ge, ke, Be), Be), te = ae(ge, te), te = ie(ge, te, Be), !1;
          }
        }), !te;
      }), te || (te = ke), te == Je && (te = D ? z(te, 1) : function() {
        return Je.apply(this, arguments);
      }), te.convert = Ie(ge, Je), te.placeholder = Je.placeholder = L, te;
    }
    if (!w)
      return Ue(v, y, O);
    var ve = y, rt = [];
    return V(be, function(Te) {
      V(e.aryMethod[Te], function(Je) {
        var L = ve[e.remap[Je] || Je];
        L && rt.push([Je, Ue(Je, L, ve)]);
      });
    }), V(Z(ve), function(Te) {
      var Je = ve[Te];
      if (typeof Je == "function") {
        for (var L = rt.length; L--; )
          if (rt[L][0] == Te)
            return;
        Je.convert = Ie(Te, Je), rt.push([Te, Je]);
      }
    }), V(rt, function(Te) {
      ve[Te[0]] = Te[1];
    }), ve.convert = Ee, ve.placeholder = ve, V(Z(ve), function(Te) {
      V(e.realToAlias[Te] || [], function(Je) {
        ve[Je] = ve[Te];
      });
    }), ve;
  }
  return MB = p, MB;
}
var jB, yZ;
function s5e() {
  if (yZ) return jB;
  yZ = 1;
  var e = NU(), t = 128;
  function n(r, i, o) {
    return i = o ? void 0 : i, i = r && i == null ? r.length : i, e(r, t, void 0, void 0, void 0, void 0, i);
  }
  return jB = n, jB;
}
var LB, bZ;
function l5e() {
  if (bZ) return LB;
  bZ = 1;
  var e = BW(), t = 4;
  function n(r) {
    return e(r, t);
  }
  return LB = n, LB;
}
var kB, xZ;
function c5e() {
  if (xZ) return kB;
  xZ = 1;
  var e = mg(), t = Bl(), n = lle(), r = "[object DOMException]", i = "[object Error]";
  function o(s) {
    if (!t(s))
      return !1;
    var u = e(s);
    return u == i || u == r || typeof s.message == "string" && typeof s.name == "string" && !n(s);
  }
  return kB = o, kB;
}
var zB, SZ;
function u5e() {
  if (SZ) return zB;
  SZ = 1;
  var e = _x(), t = Bl(), n = "[object WeakMap]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return zB = r, zB;
}
var BB, wZ;
function d5e() {
  if (wZ) return BB;
  wZ = 1;
  var e = BW(), t = fD(), n = 1;
  function r(i) {
    return t(typeof i == "function" ? i : e(i, n));
  }
  return BB = r, BB;
}
var VB, TZ;
function f5e() {
  if (TZ) return VB;
  TZ = 1;
  var e = NU(), t = cle(), n = 256, r = t(function(i, o) {
    return e(i, n, void 0, void 0, void 0, o);
  });
  return VB = r, VB;
}
var UB, EZ;
function p5e() {
  if (EZ) return UB;
  EZ = 1;
  var e = Tx(), t = lD(), n = Yo(), r = wx(), i = HJ(), o = $v(), s = TU();
  function u(f) {
    return n(f) ? e(f, o) : r(f) ? [f] : t(i(s(f)));
  }
  return UB = u, UB;
}
var FB, _Z;
function h5e() {
  return _Z || (_Z = 1, FB = {
    ary: s5e(),
    assign: ile(),
    clone: l5e(),
    curry: dee(),
    forEach: AU(),
    isArray: Yo(),
    isError: c5e(),
    isFunction: JA(),
    isWeakMap: u5e(),
    iteratee: d5e(),
    keys: MU(),
    rearg: f5e(),
    toInteger: PU(),
    toPath: p5e()
  }), FB;
}
var WB, CZ;
function dle() {
  if (CZ) return WB;
  CZ = 1;
  var e = a5e(), t = h5e();
  function n(r, i, o) {
    return e(t, r, i, o);
  }
  return WB = n, WB;
}
var HB, RZ;
function g5e() {
  if (RZ) return HB;
  RZ = 1;
  var e = $J();
  function t(n, r, i) {
    return n == null ? n : e(n, r, i);
  }
  return HB = t, HB;
}
var qB, OZ;
function m5e() {
  if (OZ) return qB;
  OZ = 1;
  var e = dle(), t = e("set", g5e());
  return t.placeholder = VW(), qB = t, qB;
}
var v5e = m5e();
const kV = /* @__PURE__ */ Hn(v5e);
var $B, AZ;
function y5e() {
  if (AZ) return $B;
  AZ = 1;
  var e = dle(), t = e("update", GJ());
  return t.placeholder = VW(), $B = t, $B;
}
var b5e = y5e();
const T1 = /* @__PURE__ */ Hn(b5e);
function fle(e = {}, t) {
  switch (t.type) {
    case Ce.ADD_COMPANION_WINDOW:
      return kV([t.id], t.payload, e);
    case Ce.ADD_WINDOW:
      return {
        ...e,
        ...(t.companionWindows || []).reduce((n, r) => (n[r.id] = {
          // eslint-disable-line no-param-reassign
          ...e[r.id],
          ...r,
          windowId: t.id
        }, n), {})
      };
    case Ce.REMOVE_WINDOW:
      return Object.keys(e).reduce((n, r) => (e[r].windowId !== t.windowId && (n[r] = e[r]), n), {});
    case Ce.UPDATE_COMPANION_WINDOW:
      return T1([t.id], (n) => ({ ...n || {}, ...t.payload }), e);
    case Ce.REMOVE_COMPANION_WINDOW:
      return qd(e, t.id);
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.companionWindows || [];
    case Ce.TOGGLE_TOC_NODE:
      return T1([t.id, "tocNodes"], (n) => ({ ...n || {}, ...t.payload }), e);
    default:
      return e;
  }
}
const DZ = { items: [] }, ple = (e = DZ, t) => {
  let n;
  switch (t.type) {
    case Ce.ADD_ERROR:
      return { ...e, [t.id]: { id: t.id, message: t.message }, items: [...e.items, t.id] };
    // eslint-disable-line max-len
    case Ce.RECEIVE_INFO_RESPONSE_FAILURE:
      return {
        ...e,
        [t.infoId]: {
          id: t.infoId,
          message: t.error
        },
        items: [...e.items, t.infoId]
      };
    case Ce.RECEIVE_SEARCH_FAILURE:
      return {
        ...e,
        [t.searchId]: {
          id: t.searchId,
          message: t.error
        },
        items: [...e.items, t.searchId]
      };
    case Ce.REMOVE_ERROR:
      return n = Object.keys(e).reduce((r, i) => (i !== t.id && (r[i] = e[i]), r), {}), n.items = Ste(n.items, t.id), n;
    case Ce.IMPORT_MIRADOR_STATE:
      return DZ;
    default:
      return e;
  }
};
function x5e(e) {
  return e.x !== void 0 && e.y !== void 0 && e.width !== void 0 && e.height !== void 0;
}
function S5e(e, t) {
  return t.x - t.width / 2 > e.x - e.width / 2 && t.y - t.height / 2 > e.y - e.height / 2 && t.x + t.width / 2 < e.x + e.width / 2 && t.y + t.height / 2 < e.y + e.height / 2;
}
const hle = (e = { ...Pv.workspace, windowIds: [] }, t) => {
  let n, r, i;
  switch (t.type) {
    case Ce.UPDATE_WORKSPACE:
      return {
        ...e,
        ...t.config
      };
    case Ce.FOCUS_WINDOW:
      return {
        ...e,
        focusedWindowId: t.windowId,
        viewportPosition: {
          ...e.viewportPosition,
          ...t.position
        }
      };
    case Ce.ADD_WINDOW:
      return {
        ...e,
        focusedWindowId: t.window.id,
        windowIds: [...e.windowIds || [], t.window.id]
      };
    case Ce.REMOVE_WINDOW:
      return i = (e.windowIds || []).filter((o) => o !== t.windowId), {
        ...e,
        focusedWindowId: t.windowId === e.focusedWindowId ? i[i.length - 1] : e.focusedWindowId,
        windowIds: i
      };
    case Ce.SET_WORKSPACE_FULLSCREEN:
      return { ...e, isFullscreenEnabled: t.isFullscreenEnabled };
    case Ce.TOGGLE_ZOOM_CONTROLS:
      return { ...e, showZoomControls: t.showZoomControls };
    case Ce.UPDATE_WORKSPACE_MOSAIC_LAYOUT:
      return { ...e, layout: t.layout };
    case Ce.SET_WORKSPACE_ADD_VISIBILITY:
      return { ...e, isWorkspaceAddVisible: t.isWorkspaceAddVisible };
    case Ce.SET_WORKSPACE_VIEWPORT_POSITION:
      return n = {}, r = {
        ...e.viewportPosition,
        ...t.payload.position
      }, x5e(r) && !S5e({
        height: e.height,
        width: e.width,
        x: 0,
        y: 0
      }, r) && (n = {
        height: e.height * 2,
        width: e.width * 2
      }), {
        ...e,
        ...n,
        viewportPosition: r
      };
    case Ce.SET_CONFIG:
    case Ce.IMPORT_CONFIG:
    case Ce.UPDATE_CONFIG:
      return { ...e, ...t.config.workspace };
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.workspace || {};
    case Ce.TOGGLE_DRAGGING:
      return { ...e, draggingEnabled: !e.draggingEnabled };
    default:
      return e;
  }
}, gle = (e = {}, t) => {
  switch (t.type) {
    case Ce.ADD_WINDOW:
      return { ...e, [t.window.id]: t.window };
    case Ce.MAXIMIZE_WINDOW:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          maximized: !0
        }
      };
    case Ce.MINIMIZE_WINDOW:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          maximized: !1
        }
      };
    case Ce.UPDATE_WINDOW:
      return T1([t.id], (n) => ({ ...n || {}, ...t.payload }), e);
    case Ce.REMOVE_WINDOW:
      return qd(e, [t.windowId]);
    case Ce.TOGGLE_WINDOW_SIDE_BAR:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          sideBarOpen: !e[t.windowId].sideBarOpen
        }
      };
    case Ce.SET_WINDOW_VIEW_TYPE:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          view: t.viewType
        }
      };
    case Ce.UPDATE_WINDOW_POSITION:
      return {
        ...e,
        [t.payload.windowId]: {
          ...e[t.payload.windowId],
          x: t.payload.position.x,
          y: t.payload.position.y
        }
      };
    case Ce.SET_WINDOW_SIZE:
      return {
        ...e,
        [t.payload.windowId]: {
          ...e[t.payload.windowId],
          height: t.payload.size.height,
          width: t.payload.size.width,
          x: t.payload.size.x,
          y: t.payload.size.y
        }
      };
    case Ce.SET_CANVAS:
      return e[t.windowId] ? T1([t.windowId], (n) => ({
        ...n || {},
        canvasId: t.canvasId,
        visibleCanvases: t.visibleCanvases || []
      }), e) : e;
    case Ce.ADD_COMPANION_WINDOW:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          companionWindowIds: e[t.windowId].companionWindowIds.concat([t.id]),
          ...t.payload.position === "left" ? { companionAreaOpen: !0, sideBarPanel: t.payload.content } : {}
        }
      };
    case Ce.UPDATE_COMPANION_WINDOW:
      return t.payload.position !== "left" ? e : {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          companionAreaOpen: !0
        }
      };
    case Ce.REMOVE_COMPANION_WINDOW:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          companionWindowIds: e[t.windowId].companionWindowIds.filter((n) => n !== t.id)
        }
      };
    case Ce.SELECT_ANNOTATION:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          selectedAnnotationId: t.annotationId
        }
      };
    case Ce.DESELECT_ANNOTATION:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          selectedAnnotationId: void 0
        }
      };
    case Ce.HOVER_ANNOTATION:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          hoveredAnnotationIds: t.annotationIds
        }
      };
    case Ce.TOGGLE_ANNOTATION_DISPLAY:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          highlightAllAnnotations: !e[t.windowId].highlightAllAnnotations
        }
      };
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.windows || [];
    case Ce.REQUEST_SEARCH:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          suggestedSearches: void 0
        }
      };
    case Ce.SHOW_COLLECTION_DIALOG:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          collectionDialogOn: !0,
          collectionManifestId: t.manifestId,
          collectionPath: t.collectionPath
        }
      };
    case Ce.HIDE_COLLECTION_DIALOG:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          collectionDialogOn: !1
        }
      };
    default:
      return e;
  }
}, mle = (e = {}, t) => {
  switch (t.type) {
    case Ce.REQUEST_MANIFEST:
      return {
        [t.manifestId]: {
          ...e[t.manifestId],
          ...t.properties,
          id: t.manifestId
        },
        ...qd(e, t.manifestId)
      };
    case Ce.RECEIVE_MANIFEST:
      return {
        ...e,
        [t.manifestId]: {
          ...e[t.manifestId],
          error: null,
          // Explicitly set the error to null in case this is a re-fetch
          id: t.manifestId,
          isFetching: !1,
          json: t.manifestJson
        }
      };
    case Ce.RECEIVE_MANIFEST_FAILURE:
      return {
        ...e,
        [t.manifestId]: {
          ...e[t.manifestId],
          error: t.error,
          id: t.manifestId,
          isFetching: !1
        }
      };
    case Ce.REMOVE_MANIFEST:
      return Object.keys(e).reduce((n, r) => (r !== t.manifestId && (n[r] = e[r]), n), {});
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.manifests || {};
    default:
      return e;
  }
}, vle = (e = {}, t) => {
  switch (t.type) {
    case Ce.REQUEST_INFO_RESPONSE:
      return {
        ...e,
        [t.infoId]: {
          id: t.infoId,
          isFetching: !0
        }
      };
    case Ce.RECEIVE_INFO_RESPONSE:
      return {
        ...e,
        [t.infoId]: {
          degraded: !1,
          id: t.infoId,
          isFetching: !1,
          json: t.infoJson,
          tokenServiceId: t.tokenServiceId
        }
      };
    case Ce.RECEIVE_DEGRADED_INFO_RESPONSE:
      return {
        ...e,
        [t.infoId]: {
          degraded: !0,
          id: t.infoId,
          isFetching: !1,
          json: t.infoJson,
          tokenServiceId: t.tokenServiceId
        }
      };
    case Ce.RECEIVE_INFO_RESPONSE_FAILURE:
      return {
        ...e,
        [t.infoId]: {
          error: t.error,
          id: t.infoId,
          isFetching: !1,
          tokenServiceId: t.tokenServiceId
        }
      };
    case Ce.REMOVE_INFO_RESPONSE:
      return Object.keys(e).reduce((n, r) => (r !== t.infoId && (n[r] = e[r]), n), {});
    case Ce.IMPORT_MIRADOR_STATE:
      return {};
    default:
      return e;
  }
}, w5e = { ...Pv }, mE = (e, t, n) => t, yle = (e = w5e, t) => {
  var n, r, i, o;
  switch (t.type) {
    case Ce.UPDATE_CONFIG:
    case Ce.IMPORT_CONFIG:
      return tp(e, t.config, { arrayMerge: mE });
    case Ce.SET_CONFIG:
      return t.config;
    case Ce.IMPORT_MIRADOR_STATE:
      return {
        ...t.state.config || {},
        export: tp(e.export || {}, ((n = t.state.config) == null ? void 0 : n.export) || {}, { arrayMerge: mE }),
        requests: tp(e.requests || {}, ((r = t.state.config) == null ? void 0 : r.requests) || {}, { arrayMerge: mE }),
        theme: tp(e.theme || {}, ((i = t.state.config) == null ? void 0 : i.theme) || {}, { arrayMerge: mE }),
        themes: tp(e.themes || {}, ((o = t.state.config) == null ? void 0 : o.themes) || {}, { arrayMerge: mE })
      };
    default:
      return e;
  }
}, ble = (e = {}, t) => {
  switch (t.type) {
    case Ce.UPDATE_VIEWPORT:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          ...t.payload
        }
      };
    case Ce.ADD_WINDOW:
      return t.window.initialViewerConfig ? {
        ...e,
        [t.window.id]: {
          ...e[t.window.id],
          ...t.window.initialViewerConfig
        }
      } : e;
    case Ce.REMOVE_WINDOW:
      return qd(e, t.windowId);
    case Ce.SET_WINDOW_VIEW_TYPE:
      return kV([t.windowId], null, e);
    case Ce.SET_CANVAS:
      return t.preserveViewport ? e : kV([t.windowId], null, e);
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.viewers || {};
    default:
      return e;
  }
}, xle = (e = {}, t) => {
  switch (t.type) {
    case Ce.REQUEST_ANNOTATION:
      return {
        ...e,
        [t.targetId]: {
          ...e[t.targetId],
          [t.annotationId]: {
            id: t.annotationId,
            isFetching: !0
          }
        }
      };
    case Ce.RECEIVE_ANNOTATION:
      return {
        ...e,
        [t.targetId]: {
          ...e[t.targetId],
          [t.annotationId]: {
            id: t.annotationId,
            isFetching: !1,
            json: t.annotationJson
          }
        }
      };
    case Ce.RECEIVE_ANNOTATION_FAILURE:
      return {
        ...e,
        [t.targetId]: {
          ...e[t.targetId],
          [t.annotationId]: {
            error: t.error,
            id: t.annotationId,
            isFetching: !1
          }
        }
      };
    case Ce.IMPORT_MIRADOR_STATE:
      return {};
    default:
      return e;
  }
}, Sle = (e = {}, t) => {
  switch (t.type) {
    case Ce.ADD_AUTHENTICATION_REQUEST:
      return {
        ...e,
        [t.id]: {
          id: t.id,
          isFetching: !0,
          profile: t.profile,
          windowId: t.windowId
        }
      };
    case Ce.RESOLVE_AUTHENTICATION_REQUEST:
      return {
        ...e,
        [t.id]: {
          id: t.id,
          // external services skip ADD_AUTHENTICATION_REQUEST and need id
          ...e[t.id],
          isFetching: !1,
          ok: t.ok
        }
      };
    case Ce.RECEIVE_ACCESS_TOKEN:
      return t.authId ? {
        ...e,
        [t.authId]: {
          ...e[t.authId],
          ok: !0
        }
      } : e;
    case Ce.RECEIVE_ACCESS_TOKEN_FAILURE:
      return !t.authId || t.authId !== "external" ? e : {
        ...e,
        [t.authId]: {
          ...e[t.authId],
          ok: !1
        }
      };
    case Ce.RESET_AUTHENTICATION_STATE:
      return qd(e, t.id);
    default:
      return e;
  }
}, wle = (e = {}, t) => {
  switch (t.type) {
    case Ce.ADD_WINDOW:
      return {
        ...e,
        [t.window.id]: {
          windowId: t.window.id,
          ...t.elasticLayout
        }
      };
    case Ce.UPDATE_ELASTIC_WINDOW_LAYOUT:
      return T1([t.windowId], (n) => ({ ...n || {}, ...t.payload }), e);
    case Ce.REMOVE_WINDOW:
      return qd(e, t.windowId);
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.elasticLayout || {};
    default:
      return e;
  }
}, Tle = (e = {}, t) => {
  const n = (e[t.windowId] || {})[t.companionWindowId] || {};
  switch (t.type) {
    case Ce.REQUEST_SEARCH:
      return n.query !== t.query ? {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          [t.companionWindowId]: {
            ...n,
            data: {
              [t.searchId]: {
                isFetching: !0
              }
            },
            query: t.query,
            selectedContentSearchAnnotation: []
          }
        }
      } : {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          [t.companionWindowId]: {
            ...n,
            data: {
              ...n.data,
              [t.searchId]: {
                isFetching: !0
              }
            }
          }
        }
      };
    case Ce.RECEIVE_SEARCH:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          [t.companionWindowId]: {
            ...n,
            data: {
              ...n.data,
              [t.searchId]: {
                isFetching: !1,
                json: t.searchJson
              }
            }
          }
        }
      };
    case Ce.RECEIVE_SEARCH_FAILURE:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          [t.companionWindowId]: {
            ...n,
            data: {
              ...n.data,
              [t.searchId]: {
                error: t.error,
                isFetching: !1
              }
            }
          }
        }
      };
    case Ce.REMOVE_SEARCH:
      return {
        ...e,
        [t.windowId]: Object.keys(e[t.windowId]).reduce((r, i) => (i !== t.companionWindowId && (r[i] = e[t.windowId][i]), r), {})
      };
    case Ce.SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          [t.companionWindowId]: {
            ...n,
            selectedContentSearchAnnotationIds: t.annotationIds
          }
        }
      };
    case Ce.SELECT_ANNOTATION:
      return e[t.windowId] ? {
        ...e,
        [t.windowId]: Object.keys(e[t.windowId]).reduce((r, i) => {
          const o = e[t.windowId][i];
          return o.data && Object.values(o.data).filter((u) => u.json && u.json.resources).some((u) => vn([u.json.resources]).some((f) => f["@id"] === t.annotationId)) ? r[i] = {
            // eslint-disable-line no-param-reassign
            ...o,
            selectedContentSearchAnnotationIds: [t.annotationId]
          } : r[i] = o, r;
        }, {})
      } : e;
    case Ce.IMPORT_MIRADOR_STATE:
      return {};
    case Ce.REMOVE_WINDOW:
      return qd(e, t.windowId);
    case Ce.REMOVE_COMPANION_WINDOW:
      return e[t.windowId] ? {
        ...e,
        [t.windowId]: {
          ...qd(e[t.windowId], t.id)
        }
      } : e;
    default:
      return e;
  }
}, Ele = (e = {}, t) => {
  switch (t.type) {
    case Ce.UPDATE_LAYERS:
      return {
        ...e,
        [t.windowId]: {
          ...e[t.windowId],
          [t.canvasId]: tp(
            (e[t.windowId] || {})[t.canvasId] || {},
            t.payload
          )
        }
      };
    case Ce.REMOVE_WINDOW:
      return qd(e, [t.windowId]);
    default:
      return e;
  }
}, _le = (e = [], t) => {
  switch (t.type) {
    case Ce.ADD_RESOURCE:
      return e.some((n) => n.manifestId === t.manifestId) ? e : [
        { manifestId: t.manifestId, ...t.payload },
        ...e
      ];
    case Ce.ADD_WINDOW:
      return e.some((n) => n.manifestId === t.window.manifestId) ? e : [
        { manifestId: t.window.manifestId },
        ...e
      ];
    case Ce.UPDATE_WINDOW:
      return !t.payload.manifestId || e.some((n) => n.manifestId === t.payload.manifestId) ? e : [
        { manifestId: t.payload.manifestId },
        ...e
      ];
    case Ce.REMOVE_RESOURCE:
      return e.filter((n) => n.manifestId !== t.manifestId);
    case Ce.IMPORT_CONFIG:
      return t.config.catalog || [];
    case Ce.IMPORT_MIRADOR_STATE:
      return t.state.catalog || [];
    default:
      return e;
  }
}, Cle = (e = {}, t) => {
  switch (t.type) {
    case Ce.REQUEST_PROBE_RESPONSE:
      return {
        ...e,
        [t.probeId]: {
          id: t.probeId,
          isFetching: !0
        }
      };
    case Ce.RECEIVE_PROBE_RESPONSE:
      return {
        ...e,
        [t.probeId]: {
          degraded: !1,
          id: t.probeId,
          isFetching: !1,
          json: t.probeJson,
          tokenServiceId: t.tokenServiceId
        }
      };
    case Ce.RECEIVE_DEGRADED_PROBE_RESPONSE:
      return {
        ...e,
        [t.probeId]: {
          degraded: !0,
          id: t.probeId,
          isFetching: !1,
          json: t.probeJson,
          tokenServiceId: t.tokenServiceId
        }
      };
    case Ce.RECEIVE_PROBE_RESPONSE_FAILURE:
      return {
        ...e,
        [t.probeId]: {
          error: t.error,
          id: t.probeId,
          isFetching: !1,
          tokenServiceId: t.tokenServiceId
        }
      };
    case Ce.REMOVE_PROBE_RESPONSE:
      return Object.keys(e).reduce((n, r) => (r !== t.probeId && (n[r] = e[r]), n), {});
    case Ce.IMPORT_MIRADOR_STATE:
      return {};
    default:
      return e;
  }
}, T5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accessTokensReducer: ule,
  annotationsReducer: xle,
  authReducer: Sle,
  catalogReducer: _le,
  companionWindowsReducer: fle,
  configReducer: yle,
  elasticLayoutReducer: wle,
  errorsReducer: ple,
  infoResponsesReducer: vle,
  layersReducer: Ele,
  manifestsReducer: mle,
  probeResponsesReducer: Cle,
  searchesReducer: Tle,
  viewersReducer: ble,
  windowsReducer: gle,
  workspaceReducer: hle
}, Symbol.toStringTag, { value: "Module" }));
function E5e(e) {
  return ZJ({
    accessTokens: ule,
    annotations: xle,
    auth: Sle,
    catalog: _le,
    companionWindows: fle,
    config: yle,
    elasticLayout: wle,
    errors: ple,
    infoResponses: vle,
    layers: Ele,
    manifests: mle,
    probeResponses: Cle,
    searches: Tle,
    viewers: ble,
    windows: gle,
    workspace: hle,
    ...e
  });
}
var _5e = {}, IZ = function(t) {
  return {
    done: !0,
    value: t
  };
}, GB = {};
function C5e(e) {
  return R_(e) ? "channel" : Ose(e) ? String(e) : Lr(e) ? e.name : String(e);
}
function R5e(e, t, n) {
  var r, i, o, s = t;
  function u(f, p) {
    if (s === GB)
      return IZ(f);
    if (p && !i)
      throw s = GB, p;
    r && r(f);
    var m = p ? e[i](p) : e[s]();
    return s = m.nextState, o = m.effect, r = m.stateUpdater, i = m.errorState, s === GB ? IZ(f) : o;
  }
  return LV(u, function(f) {
    return u(null, f);
  }, n);
}
function O5e(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var o = {
    done: !1,
    value: XWe(e)
  }, s = function(m) {
    return {
      done: !1,
      value: AW.apply(void 0, [t].concat(r, [m]))
    };
  }, u, f = function(m) {
    return u = m;
  };
  return R5e({
    q1: function() {
      return {
        nextState: "q2",
        effect: o,
        stateUpdater: f
      };
    },
    q2: function() {
      return {
        nextState: "q1",
        effect: s(u)
      };
    }
  }, "q1", "takeEvery(" + C5e(e) + ", " + t.name + ")");
}
var A5e = function(t, n, r) {
  er(n, Ao, t.name + " requires a pattern or channel"), er(r, Ao, t.name + " requires a saga parameter");
};
function hr(e, t) {
  _5e.NODE_ENV !== "production" && A5e(hr, e, t);
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return AW.apply(void 0, [O5e, e, t].concat(r));
}
function D5e(e, t, { success: n, degraded: r, failure: i }) {
  return fetch(e, t).then((o) => o.json().then((s) => o.status === 401 ? (r || n)({ json: s, response: o }) : o.ok ? n({ json: s, response: o }) : i({ error: o.statusText, json: s, response: o })).catch((s) => i({ error: s, response: o }))).catch((o) => i({ error: o }));
}
function* KI(e, t, { success: n, degraded: r, failure: i }) {
  const { preprocessors: o = [], postprocessors: s = [] } = yield An(zee);
  try {
    const u = o.reduce((p, m) => m(e, p) || p, t);
    let f = yield br(D5e, e, u, { degraded: r, failure: i, success: n });
    return f = s.reduce((p, m) => m(e, p) || p, f), f;
  } catch (u) {
    return i({ error: u });
  }
}
function* UW(e, t, n, { degraded: r, failure: i, success: o }) {
  const s = { ...n };
  let u;
  if (t) {
    const S = yield br(PZ, t);
    u = S && S.id, S && S.json && (s.headers = {
      Authorization: `Bearer ${S.json.accessToken}`,
      ...n.headers
    });
  }
  const { error: f, json: p, response: m } = yield br(
    KI,
    e,
    s,
    { failure: (S) => S, success: (S) => S }
  );
  if (f) {
    yield Qn(i({
      error: f,
      json: p,
      response: m,
      tokenServiceId: u
    }));
    return;
  }
  const v = p["@id"] || p.id;
  if (m.ok) {
    if (v && W0(v, { stripAuthentication: !1 }) === W0(e.replace(/info\.json$/, ""), { stripAuthentication: !1 }) && !p.substitute) {
      yield Qn(o({ json: p, response: m, tokenServiceId: u }));
      return;
    }
  } else if (m.status !== 401) {
    yield Qn(i({
      error: f,
      json: p,
      response: m,
      tokenServiceId: u
    }));
    return;
  }
  const y = yield br(PZ, p);
  if (y && y.id !== u) {
    yield br(UW, e, p, n, { degraded: r, failure: i, success: o });
    return;
  }
  yield Qn((r || o)({ json: p, response: m, tokenServiceId: u }));
}
function* FW({ manifestId: e }) {
  const n = yield br(KI, e, {}, {
    failure: ({ error: r, json: i, response: o }) => $te(e, typeof r == "object" ? String(r) : r),
    success: ({ json: r, response: i }) => AD(e, r)
  });
  yield Qn(n);
}
function* PZ(e) {
  const t = e && e.__jsonld ? e : { ...e, options: {} }, n = ate(t);
  if (n.length === 0) return;
  const r = yield An(e_);
  if (r)
    for (let i = 0; i < n.length; i += 1) {
      const o = n[i], s = W1(o), u = s && r[s.id];
      if (u && u.json) return u;
    }
}
function* Rle({ imageResource: e, infoId: t, windowId: n }) {
  let r = e;
  r || (r = yield An(v3, { infoId: t }));
  const i = {
    degraded: ({
      json: o,
      response: s,
      tokenServiceId: u
    }) => Xte(t, o, s.ok, u, n),
    failure: ({
      error: o,
      json: s,
      response: u,
      tokenServiceId: f
    }) => Zte(t, o, f),
    success: ({
      json: o,
      response: s,
      tokenServiceId: u
    }) => Yte(t, o, s.ok, u)
  };
  yield br(UW, `${t.replace(/\/$/, "")}/info.json`, r, {}, i);
}
function* Ole({ resource: e, probeId: t, windowId: n }) {
  let r = e;
  r || (r = yield An(ute, { probeId: t })), yield br(UW, t, r, {}, {
    degraded: ({
      json: o,
      response: s,
      tokenServiceId: u
    }) => vne(t, o, s.ok, u, n),
    failure: ({
      error: o,
      json: s,
      response: u,
      tokenServiceId: f
    }) => yne(t, o, f),
    success: ({
      json: o,
      response: s,
      tokenServiceId: u
    }) => mne(t, o, s.ok, u)
  });
}
function* I5e({
  windowId: e,
  companionWindowId: t,
  query: n,
  searchId: r
}) {
  const o = yield br(KI, r, {}, {
    failure: ({ error: s, json: u, response: f }) => une(e, t, r, s),
    success: ({ json: s, response: u }) => cne(e, t, r, s)
  });
  yield Qn(o);
}
function* P5e({ targetId: e, annotationId: t }) {
  const r = yield br(KI, t, {}, {
    failure: ({ error: i, json: o, response: s }) => rne(e, t, i),
    success: ({ json: i, response: o }) => z3(e, t, i)
  });
  yield Qn(r);
}
function* N5e({ manifestId: e, manifestJson: t }) {
  if (t) {
    yield Qn(AD(e, t));
    return;
  }
  if (!e) return;
  (yield An(L1) || {})[e] || (yield* FW({ manifestId: e }));
}
function* QI(...e) {
  const t = yield An(L1);
  for (let n = 0; n < e.length; n += 1) {
    const r = e[n];
    t[r] || (yield br(FW, { manifestId: r }));
  }
}
function* M5e() {
  yield po([
    hr(Ce.REQUEST_MANIFEST, FW),
    hr(Ce.REQUEST_INFO_RESPONSE, Rle),
    hr(Ce.REQUEST_PROBE_RESPONSE, Ole),
    hr(Ce.REQUEST_SEARCH, I5e),
    hr(Ce.REQUEST_ANNOTATION, P5e),
    hr(Ce.ADD_RESOURCE, N5e)
  ]);
}
function* zV(e) {
  const {
    collectionPath: t,
    id: n,
    manifestId: r
  } = e.payload || e.window;
  r && (e.manifest ? yield Qn(AD(r, e.manifest)) : yield br(QI, r, ...t || []), yield br(z5e, e), yield br(B5e, e), t || (yield br(L5e, { manifestId: r, windowId: e.id || e.window.id })), yield br(Y5e, r, n));
}
function* j5e(e) {
  const t = e.id;
  if (!e || !e.payload || !e.payload.sequenceId) return;
  const n = yield An(Fa, { windowId: t });
  if (!n || !n[0] || !n[0].id) return;
  const r = yield br(Iu, t, n[0].id);
  yield Qn(r);
}
function* L5e({ manifestId: e, windowId: t }) {
  const n = yield An(nr, { manifestId: e });
  if (n) {
    const r = n.getProperty("partOf"), i = Array.isArray(r) ? r[0] : r;
    i && i.id && (yield Qn(Po(t, { collectionPath: [i.id] })));
  }
}
function* k5e(e) {
  const { collectionPath: t } = e.payload;
  t && (yield br(QI, ...t));
}
function* z5e(e) {
  const { canvasId: t, canvasIndex: n, manifestId: r } = e.payload || e.window, i = e.id || e.window.id;
  if (t) {
    const o = yield br(Iu, i, t, null, { preserveViewport: !!e.payload });
    yield Qn(o);
  } else {
    const o = yield An(XU), s = yield An(nr, { manifestId: r });
    if (s) {
      const u = o(s), f = u.startCanvas || u.canvasAt(n || 0) || u.canvasAt(0);
      if (f) {
        const p = yield br(Iu, i, f.id);
        yield Qn(p);
      }
    }
  }
}
function* B5e(e) {
  if (!e.window || !e.window.defaultSearchQuery) return;
  const { id: t, defaultSearchQuery: n } = e.window, r = yield An(Dx, { windowId: t }), o = (yield An(gD, { position: "left", windowId: t }))[0];
  if (r && o) {
    const s = r && `${r.id}?q=${n}`;
    yield Qn(o_(t, o, s, n));
  }
}
function V5e(e, { canvasIds: t, companionWindowIds: n, windowId: r }) {
  return n.reduce((o, s) => {
    const p = Q1(e, {
      companionWindowId: s,
      windowId: r
    }).resources.find((m) => t.includes(m.targetId));
    return p && (o[s] = [p.id]), o;
  }, {});
}
function* U5e({
  annotationId: e,
  windowId: t,
  visibleCanvases: n
}) {
  const r = yield An(TD, { windowId: t }), i = Object.keys(r || {});
  if (i.length === 0) return;
  const o = yield An(
    V5e,
    {
      canvasIds: n,
      companionWindowIds: i,
      windowId: t
    }
  );
  yield po(
    Object.keys(o).map((s) => Qn(fne(
      t,
      s,
      o[s]
    )))
  ), Object.values(o).length > 0 && (yield Qn(Kv(t, Object.values(o)[0][0])));
}
function* F5e({ pan: e, windowId: t }) {
  if (!e) return;
  const n = yield An(vD), {
    x: r,
    y: i,
    width: o,
    height: s
  } = n[t] || {}, {
    viewportPosition: { width: u, height: f }
  } = yield An(Do);
  yield Qn(L3({
    x: r + o / 2 - u / 2,
    y: i + s / 2 - f / 2
  }));
}
function* W5e({ windowId: e }) {
  const { canvasId: t } = yield An(Wn, { windowId: e }), n = yield An(g3, { canvasId: t, windowId: e });
  yield Qn(Po(e, { visibleCanvases: (n || []).map((r) => r.id) }));
}
function* H5e({ companionWindowId: e, windowId: t }) {
  const { switchCanvasOnSearch: n } = yield An(fa, { windowId: t });
  if (!n || (yield An(_D, {
    companionWindowId: e,
    windowId: t
  })).length !== 0) return;
  const i = yield An(w3, { companionWindowId: e, windowId: t });
  !i || i.length === 0 || (yield Qn(Kv(t, i[0].id)));
}
function* q5e({ annotationId: e, windowId: t }) {
  const n = yield An(ku, { windowId: t }), r = yield An(vte, {
    annotationId: e,
    windowId: t
  });
  if (!r || n.includes(r.id)) return;
  const i = yield br(Iu, t, r.id);
  yield Qn(i);
}
function* $5e({ visibleCanvases: e, windowId: t }) {
  const n = yield An(Fa, { windowId: t }), r = yield An(Px), i = (n || []).filter((s) => e.includes(s.id)), o = yield An(Ho);
  yield po(i.map((s) => {
    const u = o(s);
    return po(u.iiifImageResources.map((f) => !r[f.getServices()[0].id] && Qn(Kte({ imageResource: f, windowId: t }))).filter(Boolean));
  }));
}
function* G5e({ visibleCanvases: e, windowId: t }) {
  const n = yield An(Fa, { windowId: t }), r = yield An(Zv), i = (n || []).filter((o) => e.includes(o.id));
  yield po(i.map((o) => {
    const s = new Ox(o);
    return po(s.contentBodies.filter((u) => rp(u)).map((u) => !r[rp(u).id] && Qn(bne({ resource: u, windowId: t }))).filter(Boolean));
  }));
}
function* Y5e(e, t) {
  const n = yield An(nr, { manifestId: e });
  n && n.isCollection() && (yield Qn(i_(e, [], t)));
}
function* X5e() {
  yield po([
    hr(Ce.ADD_WINDOW, zV),
    hr(Ce.UPDATE_WINDOW, zV),
    hr(Ce.UPDATE_WINDOW, j5e),
    hr(Ce.SET_CANVAS, U5e),
    hr(Ce.SET_CANVAS, $5e),
    hr(Ce.SET_CANVAS, G5e),
    hr(Ce.UPDATE_COMPANION_WINDOW, k5e),
    hr(Ce.SET_WINDOW_VIEW_TYPE, W5e),
    hr(Ce.RECEIVE_SEARCH, H5e),
    hr(Ce.SELECT_ANNOTATION, q5e),
    hr(Ce.FOCUS_WINDOW, F5e)
  ]);
}
function* Z5e(e) {
  yield po([
    ...Object.entries(e.state.windows || {}).map(([t, n]) => br(zV, { id: n.id, payload: n })),
    ...Object.entries(e.state.manifests || {}).filter(([t, n]) => !n.json).map(([t, n]) => br(QI, n.id))
  ]);
}
function* K5e({ config: { thumbnailNavigation: e, windows: t } }) {
  if (!t || t.length === 0) return;
  const n = yield po(
    t.map((r) => {
      const i = `window-${zs()}`, o = r.manifestId || r.loadedManifest;
      return br(r_, {
        // these are default values ...
        id: i,
        manifestId: o,
        thumbnailNavigationPosition: e && e.defaultPosition,
        // ... overridden by values from the window configuration ...
        ...r
      });
    })
  );
  yield po(n.map((r) => Qn(r)));
}
function* Q5e(e) {
  const { collectionPath: t, manifestId: n } = e;
  yield br(QI, n, ...t);
}
function* J5e() {
  yield po([
    hr(Ce.IMPORT_MIRADOR_STATE, Z5e),
    hr(Ce.IMPORT_CONFIG, K5e),
    hr(Ce.SHOW_COLLECTION_DIALOG, Q5e)
  ]);
}
function* e4e({ canvasId: e, windowId: t }) {
  const n = yield An(Yd, { canvasId: e, windowId: t }), r = yield An(SD), o = (yield An(Ho))(n);
  return yield po([
    // IIIF v2
    ...o.annotationListUris.filter((s) => !(r[n.id] && r[n.id][s])).map((s) => Qn(U2(n.id, s))),
    // IIIF v3
    ...o.canvasAnnotationPages.filter((s) => !(r[n.id] && r[n.id][s.id])).map((s) => s.items ? Qn(z3(n.id, s.id, s)) : Qn(U2(n.id, s.id)))
  ]);
}
function* t4e({ visibleCanvases: e = [], windowId: t }) {
  return yield po(e.map((n) => Qn(k3(t, n))));
}
function* n4e() {
  yield po([
    hr(Ce.REQUEST_CANVAS_ANNOTATIONS, e4e),
    hr(Ce.SET_CANVAS, t4e)
  ]);
}
function* r4e({ tokenServiceId: e }) {
  yield DW(2e3), yield br(Ale, { serviceId: e });
}
function* Ale({ serviceId: e }) {
  const t = yield An(vg), n = yield po(
    Object.keys(t).map((f) => An(Ul, { windowId: f }))
  ), r = yield An(Ho), i = vn(vn(n).map((f) => r(f).imageServiceIds)), o = yield An(Px), s = (f) => nn.getServices(f).some((m) => {
    const v = W1(m);
    return v && v.id === e;
  }), u = Object.values(o).filter(
    (f) => f.json && s(f.json)
  );
  yield po(u.map(({ id: f }) => i.includes(f) ? br(Rle, { infoId: f }) : Qn({ infoId: f, type: Ce.REMOVE_INFO_RESPONSE })));
}
function* i4e({ tokenServiceId: e }) {
  yield DW(2e3), yield br(Dle, { serviceId: e });
}
function* Dle({ serviceId: e }) {
  const t = yield An(vg), n = yield po(
    Object.keys(t).map((s) => An(Ul, { windowId: s }))
  ), r = vn(vn(n).map((s) => {
    const u = new Ox(s), f = u.imageResources.filter((m) => rp(m)).map((m) => rp(m)), p = u.contentBodies.filter((m) => rp(m)).map((m) => rp(m));
    return f.concat(p);
  })), i = {};
  r.reduce((s, u) => (s[u.id] = h3(u), s), i);
  const o = Object.keys(i).filter((s) => {
    const u = i[s];
    return u && u.find((f) => f.id === e);
  });
  yield po(o.map((s) => {
    const u = r.find((f) => f.id === s);
    return u ? br(Ole, { probeId: s, resource: u }) : Qn({ probeId: s, type: Ce.REMOVE_PROBE_RESPONSE });
  }));
}
function bO(e, t) {
  return t != null && t.external ? e.id || "external" : e.id;
}
function NZ(e, t, n = ((r) => r)) {
  return e.getProfile ? t.find((r) => r.profile === e.getProfile() && n(r)) : null;
}
function* MZ({ infoJson: e, probeJson: t, windowId: n }) {
  const r = yield An(t_), i = yield An(RD), o = (f) => f.external || f.kiosk, s = nn.getServices(e || t).filter((f) => !r[bO(f)]).find((f) => NZ(f, i, o));
  if (!s) return;
  const u = NZ(s, i);
  if (u.kiosk)
    yield Qn(U3(n, bO(s, u), s.getProfile()));
  else if (u.external) {
    const f = W1(s);
    if (!f) return;
    yield Qn(MD(bO(s, u), f.id, { ok: !0 })), yield Qn(F3(f.id, bO(s, u)));
  }
}
function* jZ({
  infoJson: e,
  probeJson: t,
  windowId: n,
  tokenServiceId: r
}) {
  if (!r) return;
  const i = nn.getServices(e || t).find((u) => {
    const f = W1(u);
    return f && f.id === r;
  });
  if (!i) return;
  const s = (yield An(e_))[r];
  s && s.success && (yield Qn(F3(r, i.id)));
}
function* o4e({ serviceId: e }) {
  const t = yield An(e_), n = yield An(t_), r = t[e];
  if (!r) return;
  const i = n[r.authId];
  i && (r.success ? yield Qn(W3({
    authServiceId: i.id,
    tokenServiceId: r.id
  })) : yield Qn(MD(
    i.id,
    r.id,
    { ok: !1 }
  )));
}
function* a4e() {
  yield po([
    hr(Ce.RECEIVE_DEGRADED_INFO_RESPONSE, jZ),
    hr(Ce.RECEIVE_DEGRADED_PROBE_RESPONSE, jZ),
    hr(Ce.RECEIVE_ACCESS_TOKEN_FAILURE, o4e),
    hr(Ce.RECEIVE_DEGRADED_INFO_RESPONSE, MZ),
    hr(Ce.RECEIVE_DEGRADED_PROBE_RESPONSE, MZ),
    hr(Ce.RECEIVE_ACCESS_TOKEN, Ale),
    hr(Ce.RECEIVE_ACCESS_TOKEN, Dle),
    hr(Ce.RESET_AUTHENTICATION_STATE, r4e),
    hr(Ce.RESET_AUTHENTICATION_STATE, i4e)
  ]);
}
function* s4e(e) {
  for (; ; )
    try {
      yield br(e);
      break;
    } catch (t) {
      console.log(t);
    }
}
function Ile(e = []) {
  return function* () {
    const n = [
      n4e,
      J5e,
      M5e,
      X5e,
      a4e,
      ...e
    ];
    yield po(n.map((r) => KWe(s4e, r)));
  };
}
const l4e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ile
}, Symbol.toStringTag, { value: "Module" }));
function Ple(e, t = []) {
  const n = E5e(e), r = Pv.state.slice ? ZJ({ [Pv.state.slice]: n }) : n, i = NHe(), o = XJ(
    r,
    jHe(
      Nme(pWe, i)
    )
  );
  return i.run(Ile(t)), o;
}
function c4e(e, t = []) {
  const n = Sse(t), r = Ple(
    cWe(n),
    dWe(n)
  );
  return r.dispatch(
    jte(
      tp(uWe(n), e)
    )
  ), r;
}
class u4e {
  /**
   */
  constructor(t, n = {}) {
    this.plugins = Sse(n.plugins || []), this.config = t, this.store = n.store || c4e(this.config, this.plugins), t.id && this.renderInto(document.getElementById(t.id));
  }
  /**
   * @private
   * @param {*} container
   */
  renderInto(t) {
    this.container = t, this.root = Whe.createRoot(this.container), this.root.render(this.render());
  }
  /**
   * Render the mirador viewer
   */
  render(t = {}) {
    return /* @__PURE__ */ T.jsx(zge, { store: this.store, children: /* @__PURE__ */ T.jsx(yse, { plugins: this.plugins, ...t }) });
  }
  /**
   * Cleanup method to unmount Mirador from the dom
   */
  unmount() {
    this.root && this.root.unmount();
  }
}
function d4e(e, t) {
  let n;
  return Array.isArray(t) ? n = { plugins: t } : n = t, new u4e(e, n);
}
const f4e = {
  viewer: d4e
}, p4e = {
  actions: t0e,
  createStore: Ple,
  reducers: T5e,
  sagas: l4e,
  selectors: Zbe
}, h4e = Wt("MuiBox", ["root"]);
var g4e = {};
const m4e = d_(), ur = xhe({
  themeId: Ac,
  defaultTheme: m4e,
  defaultClassName: h4e.root,
  generateClassName: Hne.generate
});
g4e.NODE_ENV !== "production" && (ur.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: c.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function v4e(e) {
  return Vt("MuiButtonGroup", e);
}
const Pn = Wt("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "horizontal", "vertical", "colorPrimary", "colorSecondary", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]);
var y4e = {};
const b4e = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [{
    [`& .${Pn.grouped}`]: t.grouped
  }, {
    [`& .${Pn.grouped}`]: t[`grouped${Ke(n.orientation)}`]
  }, {
    [`& .${Pn.grouped}`]: t[`grouped${Ke(n.variant)}`]
  }, {
    [`& .${Pn.grouped}`]: t[`grouped${Ke(n.variant)}${Ke(n.orientation)}`]
  }, {
    [`& .${Pn.grouped}`]: t[`grouped${Ke(n.variant)}${Ke(n.color)}`]
  }, {
    [`& .${Pn.firstButton}`]: t.firstButton
  }, {
    [`& .${Pn.lastButton}`]: t.lastButton
  }, {
    [`& .${Pn.middleButton}`]: t.middleButton
  }, t.root, t[n.variant], n.disableElevation === !0 && t.disableElevation, n.fullWidth && t.fullWidth, n.orientation === "vertical" && t.vertical];
}, x4e = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    disableElevation: i,
    fullWidth: o,
    orientation: s,
    variant: u
  } = e, f = {
    root: ["root", u, s, o && "fullWidth", i && "disableElevation", `color${Ke(n)}`],
    grouped: ["grouped", `grouped${Ke(s)}`, `grouped${Ke(u)}`, `grouped${Ke(u)}${Ke(s)}`, `grouped${Ke(u)}${Ke(n)}`, r && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Ft(f, v4e, t);
}, S4e = ye("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: b4e
})(Lt(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      variant: "contained"
    },
    style: {
      boxShadow: (e.vars || e).shadows[2]
    }
  }, {
    props: {
      disableElevation: !0
    },
    style: {
      boxShadow: "none"
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${Pn.lastButton},& .${Pn.middleButton}`]: {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${Pn.lastButton},& .${Pn.middleButton}`]: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "horizontal"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${Pn.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "vertical"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${Pn.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Jr()).flatMap(([t]) => [{
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : Cn(e.palette[t].main, 0.5)
      }
    }
  }]), {
    props: {
      variant: "outlined",
      orientation: "horizontal"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderRightColor: "transparent",
        "&:hover": {
          borderRightColor: "currentColor"
        }
      },
      [`& .${Pn.lastButton},& .${Pn.middleButton}`]: {
        marginLeft: -1
      }
    }
  }, {
    props: {
      variant: "outlined",
      orientation: "vertical"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderBottomColor: "transparent",
        "&:hover": {
          borderBottomColor: "currentColor"
        }
      },
      [`& .${Pn.lastButton},& .${Pn.middleButton}`]: {
        marginTop: -1
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "horizontal"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${Pn.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "vertical"
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${Pn.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Jr(["dark"])).map(([t]) => ({
    props: {
      variant: "contained",
      color: t
    },
    style: {
      [`& .${Pn.firstButton},& .${Pn.middleButton}`]: {
        borderColor: (e.vars || e).palette[t].dark
      }
    }
  }))],
  [`& .${Pn.grouped}`]: {
    minWidth: 40,
    boxShadow: "none",
    props: {
      variant: "contained"
    },
    style: {
      "&:hover": {
        boxShadow: "none"
      }
    }
  }
}))), Nle = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: i,
    className: o,
    color: s = "primary",
    component: u = "div",
    disabled: f = !1,
    disableElevation: p = !1,
    disableFocusRipple: m = !1,
    disableRipple: v = !1,
    fullWidth: y = !1,
    orientation: S = "horizontal",
    size: E = "medium",
    variant: w = "outlined",
    ..._
  } = r, O = {
    ...r,
    color: s,
    component: u,
    disabled: f,
    disableElevation: p,
    disableFocusRipple: m,
    disableRipple: v,
    fullWidth: y,
    orientation: S,
    size: E,
    variant: w
  }, D = x4e(O), P = $.useMemo(() => ({
    className: D.grouped,
    color: s,
    disabled: f,
    disableElevation: p,
    disableFocusRipple: m,
    disableRipple: v,
    fullWidth: y,
    size: E,
    variant: w
  }), [s, f, p, m, v, y, E, w, D.grouped]), M = pSe(i), N = M.length, k = (U) => {
    const H = U === 0, Y = U === N - 1;
    return H && Y ? "" : H ? D.firstButton : Y ? D.lastButton : D.middleButton;
  };
  return /* @__PURE__ */ T.jsx(S4e, {
    as: u,
    role: "group",
    className: yt(D.root, o),
    ref: n,
    ownerState: O,
    ..._,
    children: /* @__PURE__ */ T.jsx(RF.Provider, {
      value: P,
      children: M.map((U, H) => /* @__PURE__ */ T.jsx(OF.Provider, {
        value: k(H),
        children: U
      }, H))
    })
  });
});
y4e.NODE_ENV !== "production" && (Nle.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: c.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: c.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOfType([c.oneOf(["contained", "outlined", "text"]), c.string])
});
function w4e(e) {
  return Vt("MuiDialog", e);
}
const YB = Wt("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]);
var T4e = {};
const WW = /* @__PURE__ */ $.createContext({});
T4e.NODE_ENV !== "production" && (WW.displayName = "DialogContext");
var E4e = {};
const _4e = ye(cI, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), C4e = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: i,
    fullScreen: o
  } = e, s = {
    root: ["root"],
    container: ["container", `scroll${Ke(n)}`],
    paper: ["paper", `paperScroll${Ke(n)}`, `paperWidth${Ke(String(r))}`, i && "paperFullWidth", o && "paperFullScreen"]
  };
  return Ft(s, w4e, t);
}, R4e = ye(uI, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), O4e = ye("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${Ke(n.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), A4e = ye(Ei, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${Ke(n.scroll)}`], t[`paperWidth${Ke(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(Lt(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${YB.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 64)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${YB.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 64)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${YB.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), D_ = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiDialog"
  }), i = pa(), o = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    "aria-describedby": s,
    "aria-labelledby": u,
    "aria-modal": f = !0,
    BackdropComponent: p,
    BackdropProps: m,
    children: v,
    className: y,
    disableEscapeKeyDown: S = !1,
    fullScreen: E = !1,
    fullWidth: w = !1,
    maxWidth: _ = "sm",
    onBackdropClick: O,
    onClick: D,
    onClose: P,
    open: M,
    PaperComponent: N = Ei,
    PaperProps: k = {},
    scroll: U = "paper",
    slots: H = {},
    slotProps: Y = {},
    TransitionComponent: z = vA,
    transitionDuration: V = o,
    TransitionProps: F,
    ...X
  } = r, oe = {
    ...r,
    disableEscapeKeyDown: S,
    fullScreen: E,
    fullWidth: w,
    maxWidth: _,
    scroll: U
  }, re = C4e(oe), Z = $.useRef(), ee = (rt) => {
    Z.current = rt.target === rt.currentTarget;
  }, J = (rt) => {
    D && D(rt), Z.current && (Z.current = null, O && O(rt), P && P(rt, "backdropClick"));
  }, le = Jv(u), be = $.useMemo(() => ({
    titleId: le
  }), [le]), ne = {
    transition: z,
    ...H
  }, ae = {
    transition: F,
    paper: k,
    backdrop: m,
    ...Y
  }, ie = {
    slots: ne,
    slotProps: ae
  }, [he, pe] = Xt("root", {
    elementType: R4e,
    shouldForwardComponentProp: !0,
    externalForwardedProps: ie,
    ownerState: oe,
    className: yt(re.root, y),
    ref: n
  }), [me, Ee] = Xt("backdrop", {
    elementType: _4e,
    shouldForwardComponentProp: !0,
    externalForwardedProps: ie,
    ownerState: oe
  }), [Ie, Pe] = Xt("paper", {
    elementType: A4e,
    shouldForwardComponentProp: !0,
    externalForwardedProps: ie,
    ownerState: oe,
    className: yt(re.paper, k.className)
  }), [De, Ye] = Xt("container", {
    elementType: O4e,
    externalForwardedProps: ie,
    ownerState: oe,
    className: yt(re.container)
  }), [Ue, ve] = Xt("transition", {
    elementType: vA,
    externalForwardedProps: ie,
    ownerState: oe,
    additionalProps: {
      appear: !0,
      in: M,
      timeout: V,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ T.jsx(he, {
    closeAfterTransition: !0,
    slots: {
      backdrop: me
    },
    slotProps: {
      backdrop: {
        transitionDuration: V,
        as: p,
        ...Ee
      }
    },
    disableEscapeKeyDown: S,
    onClose: P,
    open: M,
    onClick: J,
    ...pe,
    ...X,
    children: /* @__PURE__ */ T.jsx(Ue, {
      ...ve,
      children: /* @__PURE__ */ T.jsx(De, {
        onMouseDown: ee,
        ...Ye,
        children: /* @__PURE__ */ T.jsx(Ie, {
          as: N,
          elevation: 24,
          role: "dialog",
          "aria-describedby": s,
          "aria-labelledby": le,
          "aria-modal": f,
          ...Pe,
          children: /* @__PURE__ */ T.jsx(WW.Provider, {
            value: be,
            children: v
          })
        })
      })
    })
  });
});
E4e.NODE_ENV !== "production" && (D_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": c.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": c.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": c.oneOfType([c.oneOf(["false", "true"]), c.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: c.elementType,
  /**
   * @ignore
   */
  BackdropProps: c.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: c.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: c.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: c.oneOfType([c.oneOf(["xs", "sm", "md", "lg", "xl", !1]), c.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: c.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: c.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: c.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    container: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    container: c.elementType,
    paper: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: c.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: c.object
});
function D4e(e) {
  return Vt("MuiDialogActions", e);
}
Wt("MuiDialogActions", ["root", "spacing"]);
var I4e = {};
const P4e = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return Ft({
    root: ["root", !n && "spacing"]
  }, D4e, t);
}, N4e = ye("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), $x = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: i,
    disableSpacing: o = !1,
    ...s
  } = r, u = {
    ...r,
    disableSpacing: o
  }, f = P4e(u);
  return /* @__PURE__ */ T.jsx(N4e, {
    className: yt(f.root, i),
    ownerState: u,
    ref: n,
    ...s
  });
});
I4e.NODE_ENV !== "production" && ($x.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function M4e(e) {
  return Vt("MuiDialogTitle", e);
}
const j4e = Wt("MuiDialogTitle", ["root"]);
var L4e = {};
const k4e = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, M4e, t);
}, z4e = ye(St, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), _g = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: i,
    id: o,
    ...s
  } = r, u = r, f = k4e(u), {
    titleId: p = o
  } = $.useContext(WW);
  return /* @__PURE__ */ T.jsx(z4e, {
    component: "h2",
    className: yt(f.root, i),
    ownerState: u,
    ref: n,
    variant: "h6",
    id: o ?? p,
    ...s
  });
});
L4e.NODE_ENV !== "production" && (_g.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * @ignore
   */
  id: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function B4e(e) {
  return Vt("MuiAlert", e);
}
const LZ = Wt("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]), V4e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), U4e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), F4e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), W4e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");
var H4e = {};
const q4e = (e) => {
  const {
    variant: t,
    color: n,
    severity: r,
    classes: i
  } = e, o = {
    root: ["root", `color${Ke(n || r)}`, `${t}${Ke(n || r)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Ft(o, B4e, i);
}, $4e = ye(Ei, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Ke(n.color || n.severity)}`]];
  }
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? jv : Lv, n = e.palette.mode === "light" ? Lv : jv;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(Jr(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${r}StandardBg`] : n(e.palette[r].light, 0.9),
        [`& .${LZ.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(Jr(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[r].light}`,
        [`& .${LZ.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(Jr(["dark"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${r}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${r}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[r].dark : e.palette[r].main,
          color: e.palette.getContrastText(e.palette[r].main)
        }
      }
    }))]
  };
})), G4e = ye("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), Y4e = ye("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), X4e = ye("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), kZ = {
  success: /* @__PURE__ */ T.jsx(V4e, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ T.jsx(U4e, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ T.jsx(F4e, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ T.jsx(W4e, {
    fontSize: "inherit"
  })
}, JI = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiAlert"
  }), {
    action: i,
    children: o,
    className: s,
    closeText: u = "Close",
    color: f,
    components: p = {},
    componentsProps: m = {},
    icon: v,
    iconMapping: y = kZ,
    onClose: S,
    role: E = "alert",
    severity: w = "success",
    slotProps: _ = {},
    slots: O = {},
    variant: D = "standard",
    ...P
  } = r, M = {
    ...r,
    color: f,
    severity: w,
    variant: D,
    colorSeverity: f || w
  }, N = q4e(M), k = {
    slots: {
      closeButton: p.CloseButton,
      closeIcon: p.CloseIcon,
      ...O
    },
    slotProps: {
      ...m,
      ..._
    }
  }, [U, H] = Xt("root", {
    ref: n,
    shouldForwardComponentProp: !0,
    className: yt(N.root, s),
    elementType: $4e,
    externalForwardedProps: {
      ...k,
      ...P
    },
    ownerState: M,
    additionalProps: {
      role: E,
      elevation: 0
    }
  }), [Y, z] = Xt("icon", {
    className: N.icon,
    elementType: G4e,
    externalForwardedProps: k,
    ownerState: M
  }), [V, F] = Xt("message", {
    className: N.message,
    elementType: Y4e,
    externalForwardedProps: k,
    ownerState: M
  }), [X, oe] = Xt("action", {
    className: N.action,
    elementType: X4e,
    externalForwardedProps: k,
    ownerState: M
  }), [re, Z] = Xt("closeButton", {
    elementType: ey,
    externalForwardedProps: k,
    ownerState: M
  }), [ee, J] = Xt("closeIcon", {
    elementType: Yie,
    externalForwardedProps: k,
    ownerState: M
  });
  return /* @__PURE__ */ T.jsxs(U, {
    ...H,
    children: [v !== !1 ? /* @__PURE__ */ T.jsx(Y, {
      ...z,
      children: v || y[w] || kZ[w]
    }) : null, /* @__PURE__ */ T.jsx(V, {
      ...F,
      children: o
    }), i != null ? /* @__PURE__ */ T.jsx(X, {
      ...oe,
      children: i
    }) : null, i == null && S ? /* @__PURE__ */ T.jsx(X, {
      ...oe,
      children: /* @__PURE__ */ T.jsx(re, {
        size: "small",
        "aria-label": u,
        title: u,
        color: "inherit",
        onClick: S,
        ...Z,
        children: /* @__PURE__ */ T.jsx(ee, {
          fontSize: "small",
          ...J
        })
      })
    }) : null]
  });
});
H4e.NODE_ENV !== "production" && (JI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: c.node,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: c.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["error", "info", "success", "warning"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    CloseButton: c.elementType,
    CloseIcon: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    closeButton: c.object,
    closeIcon: c.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: c.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: c.shape({
    error: c.node,
    info: c.node,
    success: c.node,
    warning: c.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: c.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: c.oneOfType([c.oneOf(["error", "info", "success", "warning"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    action: c.oneOfType([c.func, c.object]),
    closeButton: c.oneOfType([c.func, c.object]),
    closeIcon: c.oneOfType([c.func, c.object]),
    icon: c.oneOfType([c.func, c.object]),
    message: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    action: c.elementType,
    closeButton: c.elementType,
    closeIcon: c.elementType,
    icon: c.elementType,
    message: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: c.oneOfType([c.oneOf(["filled", "outlined", "standard"]), c.string])
});
function Z4e(e) {
  return Vt("MuiDialogContent", e);
}
Wt("MuiDialogContent", ["root", "dividers"]);
var K4e = {};
const Q4e = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return Ft({
    root: ["root", n && "dividers"]
  }, Z4e, t);
}, J4e = ye("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(Lt(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${j4e.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), eP = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: i,
    dividers: o = !1,
    ...s
  } = r, u = {
    ...r,
    dividers: o
  }, f = Q4e(u);
  return /* @__PURE__ */ T.jsx(J4e, {
    className: yt(f.root, i),
    ownerState: u,
    ref: n,
    ...s
  });
});
K4e.NODE_ENV !== "production" && (eP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const zZ = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, eqe = ye(eP, { name: "ScrollIndicatedDialogContent", slot: "root" })(({ ownerState: e, theme: t }) => {
  const n = t.palette.mode === "dark" ? {
    backgroundImage: `linear-gradient(${_u(
      "#fff",
      zZ((e == null ? void 0 : e.elevation) || 24)
    )}, ${_u("#fff", zZ((e == null ? void 0 : e.elevation) || 24))})`
  } : t.palette.background.paper;
  return {
    /* Shadow covers */
    background: `linear-gradient(${n} 30%, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), ${n} 70%) 0 100%, radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)), radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0)) 0 100%;`,
    backgroundAttachment: "local, local, scroll, scroll",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 40px, 100% 40px, 100% 14px, 100% 14px",
    overflowY: "auto"
  };
});
function Cg({ classes: e = {}, className: t = "", ...n }) {
  const r = [t, e.shadowScrollDialog].join(" ");
  return /* @__PURE__ */ T.jsx(
    eqe,
    {
      className: r,
      ...n
    }
  );
}
Cg.propTypes = {
  classes: c.shape({
    shadowScrollDialog: c.string
  }),
  className: c.string
};
const tqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2zm-1 7h5.5L14 6.5z"
}), "FileCopy"), Mle = ({ onCopy: e, supported: t }) => {
  const { t: n } = Ct();
  return t ? /* @__PURE__ */ T.jsx(_I, { children: /* @__PURE__ */ T.jsx(
    Lx,
    {
      "aria-label": n("canvasLink.copyToClipboard"),
      edge: "end",
      onClick: e,
      children: /* @__PURE__ */ T.jsx(tqe, { fontSize: "small" })
    }
  ) }) : null;
};
Mle.propTypes = {
  onCopy: c.func.isRequired,
  supported: c.bool.isRequired
};
const jle = ({ rights: e }) => {
  const { t } = Ct();
  return e.length ? /* @__PURE__ */ T.jsxs(JI, { severity: "warning", sx: { mt: 2 }, children: [
    /* @__PURE__ */ T.jsxs("span", { children: [
      t("canvasLink.noteRights", { count: e.length }),
      ":",
      " "
    ] }),
    e.length === 1 ? /* @__PURE__ */ T.jsx(ka, { href: e[0], rel: "noopener", target: "_blank", children: e[0] }) : /* @__PURE__ */ T.jsx("ul", { children: e.map((n) => /* @__PURE__ */ T.jsx("li", { children: /* @__PURE__ */ T.jsx(ka, { href: n, rel: "noopener", target: "_blank", children: n }) }, e)) })
  ] }) : null;
};
jle.propTypes = {
  rights: c.arrayOf(c.string).isRequired
};
const nqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), "Facebook"), rqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
}), "Mail"), iqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M9.04 21.54c.96.29 1.93.46 2.96.46a10 10 0 0 0 10-10A10 10 0 0 0 12 2 10 10 0 0 0 2 12c0 4.25 2.67 7.9 6.44 9.34-.09-.78-.18-2.07 0-2.96l1.15-4.94s-.29-.58-.29-1.5c0-1.38.86-2.41 1.84-2.41.86 0 1.26.63 1.26 1.44 0 .86-.57 2.09-.86 3.27-.17.98.52 1.84 1.52 1.84 1.78 0 3.16-1.9 3.16-4.58 0-2.4-1.72-4.04-4.19-4.04-2.82 0-4.48 2.1-4.48 4.31 0 .86.28 1.73.74 2.3.09.06.09.14.06.29l-.29 1.09c0 .17-.11.23-.28.11-1.28-.56-2.02-2.38-2.02-3.85 0-3.16 2.24-6.03 6.56-6.03 3.44 0 6.12 2.47 6.12 5.75 0 3.44-2.13 6.2-5.18 6.2-.97 0-1.92-.52-2.26-1.13l-.67 2.37c-.23.86-.86 2.01-1.29 2.7v-.03z"
}), "Pinterest"), oqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
}), "Twitter"), aqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
}), "WhatsApp"), sqe = (e, t, n, r, i) => {
  let o = n;
  switch (e && (o += ` (${e})`), r) {
    case "envelope":
      return `mailto:?subject=${o}&body=${o}: ${t}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?title=${o}&u=${t}`;
    case "pinterest":
      return `http://pinterest.com/pin/create/bookmarklet/?url=${t}&description=${o}&media=${i}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?text=${o.length > 60 ? `${o.substring(0, 60)}...` : o}&url=${t}&hashtags=iiif`;
    case "whatsapp":
      return `whatsapp://send?text=${o}: ${t}`;
    default:
      return null;
  }
}, lqe = {
  envelope: rqe,
  facebook: nqe,
  pinterest: iqe,
  twitter: oqe,
  whatsapp: aqe
}, Lle = ({
  attribution: e = null,
  canvasLink: t,
  label: n,
  provider: r,
  thumbnailUrl: i,
  title: o
}) => {
  const s = sqe(
    e,
    t,
    n,
    r,
    i
  ), u = lqe[r];
  return /* @__PURE__ */ T.jsx(
    Lx,
    {
      "aria-label": o,
      href: encodeURI(s),
      rel: "noopener",
      target: "_blank",
      children: /* @__PURE__ */ T.jsx(u, {})
    }
  );
};
Lle.propTypes = {
  attribution: c.string,
  canvasLink: c.string.isRequired,
  label: c.string.isRequired,
  provider: c.string.isRequired,
  thumbnailUrl: c.string.isRequired,
  title: c.string.isRequired
};
const cqe = d_((e) => ({
  actionButtons: {
    flexWrap: "wrap"
  },
  actions: {
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  alert: {
    marginBottom: e.spacing(1)
  }
})), uqe = "clipboard" in navigator, kle = ({
  config: e,
  containerId: t,
  manifestId: n,
  visibleCanvases: r = [],
  label: i = "",
  rights: o = [],
  updateConfig: s
}) => {
  const {
    dialogOpen: u,
    enabled: f,
    showRightsInformation: p,
    getCanvasLink: m,
    providers: v
  } = e, [y, S] = Bn(!1), { actions: E, actionButtons: w, alert: _ } = cqe, { t: O } = Ct();
  if (!f || !u || r.length === 0)
    return null;
  const D = () => s({
    ...e,
    dialogOpen: !1
  }), P = m(n, r), M = (N) => {
    var k;
    return `${(k = r[0]) == null ? void 0 : k.imageServiceIds[0]}/full/${N},/0/default.jpg`;
  };
  return /* @__PURE__ */ T.jsxs(
    D_,
    {
      container: document.querySelector(`#${t} .${Nt("viewer")}`),
      fullWidth: !0,
      maxWidth: "sm",
      scroll: "paper",
      open: u,
      onClose: D,
      children: [
        /* @__PURE__ */ T.jsx(_g, { disableTypography: !0, children: /* @__PURE__ */ T.jsx(St, { variant: "h4", children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", children: O("canvasLink.shareLink") }) }) }),
        /* @__PURE__ */ T.jsxs(Cg, { dividers: !0, children: [
          y && /* @__PURE__ */ T.jsx(
            JI,
            {
              className: _,
              closeText: O("canvasLink.close"),
              onClose: () => S(!1),
              severity: "success",
              children: O("canvasLink.copiedToClipboard")
            }
          ),
          /* @__PURE__ */ T.jsx(
            EI,
            {
              fullWidth: !0,
              InputProps: {
                endAdornment: /* @__PURE__ */ T.jsx(
                  Mle,
                  {
                    onCopy: () => {
                      navigator.clipboard.writeText(P), S(!0), setTimeout(() => S(!1), 3e3);
                    },
                    supported: uqe,
                    t: O
                  }
                ),
                readOnly: !0
              },
              size: "small",
              value: P,
              variant: "outlined"
            }
          ),
          p && /* @__PURE__ */ T.jsx(jle, { t: O, rights: o })
        ] }),
        /* @__PURE__ */ T.jsxs($x, { className: E, children: [
          /* @__PURE__ */ T.jsx(Nle, { className: w, children: v.map(
            (N) => /* @__PURE__ */ T.jsx(
              Lle,
              {
                canvasLink: P,
                label: i,
                provider: N,
                thumbnailUrl: M(250),
                title: O(`canvasLink.share.${N}`)
              },
              N
            )
          ) }),
          /* @__PURE__ */ T.jsx("div", { style: { flex: "1 0 0" } }),
          /* @__PURE__ */ T.jsx(hi, { color: "primary", onClick: D, children: O("canvasLink.close") })
        ] })
      ]
    }
  );
};
kle.propTypes = {
  config: c.shape({
    dialogOpen: c.bool.isRequired,
    enabled: c.bool.isRequired,
    getCanvasLink: c.func.isRequired,
    providers: c.arrayOf(c.string),
    showRightsInformation: c.bool.isRequired
  }).isRequired,
  containerId: c.string.isRequired,
  label: c.string,
  manifestId: c.string.isRequired,
  rights: c.arrayOf(c.string),
  updateConfig: c.func.isRequired,
  visibleCanvases: c.arrayOf(
    c.shape({
      id: c.string.isRequired,
      imageServiceIds: c.arrayOf(c.string).isRequired
    })
  )
};
const dqe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92"
}), "Share"), zle = ({
  containerId: e,
  config: t,
  updateConfig: n,
  windowViewType: r
}) => {
  const { dialogOpen: i, enabled: o, singleCanvasOnly: s } = t, { t: u } = Ct();
  return !o || s && r !== "single" || r === "gallery" ? null : /* @__PURE__ */ T.jsx(
    Lx,
    {
      "aria-expanded": i,
      "aria-label": u("canvasLink.shareLink"),
      containerId: e,
      onClick: () => n({
        ...t,
        dialogOpen: !i
      }),
      children: /* @__PURE__ */ T.jsx(dqe, {})
    }
  );
};
zle.propTypes = {
  config: c.shape({
    dialogOpen: c.bool.isRequired,
    enabled: c.bool.isRequired,
    singleCanvasOnly: c.bool.isRequired
  }).isRequired,
  containerId: c.string.isRequired,
  updateConfig: c.func.isRequired,
  windowViewType: c.string.isRequired
};
const BZ = {
  de: {
    canvasLink: {
      close: "Schließen",
      copiedToClipboard: "Erfolgreich in die Zwischenablage kopiert",
      copyToClipboard: "In die Zwischenablage kopieren",
      noteRights: "Bitte beachten Sie den Rechtehinweis",
      noteRights_plural: "Bitte beachten Sie die Rechtehinweise",
      share: {
        envelope: "Per Mail teilen",
        facebook: "Auf Facebook teilen",
        pinterest: "Auf Pinterest teilen",
        twitter: "Auf Twitter teilen",
        whatsapp: "Per WhatsApp teilen"
      },
      shareLink: "Link auf diese Seite teilen"
    }
  },
  en: {
    canvasLink: {
      close: "Close",
      copiedToClipboard: "Copied successfully to the clipboard",
      copyToClipboard: "Copy to clipboard",
      noteRights: "Please note the rights statement",
      noteRights_plural: "Please note the rights statements",
      share: {
        envelope: "Share via mail",
        facebook: "Share on Facebook",
        pinterest: "Share on Pinterest",
        twitter: "Share on Twitter",
        whatsapp: "Share via WhatsApp"
      },
      shareLink: "Share link to this page"
    }
  }
}, fqe = {
  // Open the settings dialog
  dialogOpen: !1,
  // Enable share plugin
  enabled: !0,
  // Show the rights information defined in the manifest
  showRightsInformation: !0,
  // Show only in single canvas view,
  singleCanvasOnly: !1
}, VZ = Qe(
  [fa],
  ({ canvasLink: e = {} }) => ({
    ...fqe,
    ...e
  })
), pqe = [
  {
    component: zle,
    config: {
      translations: BZ
    },
    mapDispatchToProps: (e, { windowId: t }) => ({
      updateConfig: (n) => e(Po(t, { canvasLink: n }))
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      config: VZ(e, { windowId: t }),
      containerId: Du(e),
      windowViewType: Nv(e, { windowId: t })
    }),
    mode: "add",
    target: "WindowTopBarPluginArea"
  },
  {
    component: kle,
    config: {
      translations: BZ
    },
    mapDispatchToProps: (e, { windowId: t }) => ({
      updateConfig: (n) => e(Po(t, { canvasLink: n }))
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      canvases: Fa(e, { windowId: t }),
      config: VZ(e, { windowId: t }),
      containerId: Du(e),
      manifestId: ZU(e)[0],
      rights: s3(e, { windowId: t }),
      visibleCanvases: Ul(e, { windowId: t }),
      windowViewType: Nv(e, { windowId: t })
    }),
    mode: "add",
    target: "Window"
  }
];
function Ble(e) {
  return Qe(
    [Vl],
    (t) => t && t.getProperty(e)
  );
}
const hqe = Qe(
  [Vl],
  (e) => e && (e.id || e["@id"])
), gqe = Qe(
  [
    Ble("related"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => typeof n == "string" ? {
    value: n
  } : {
    format: n.format,
    label: Ti.parse(n.label, t).getValue(),
    value: n.id || n["@id"]
  })
), mqe = Qe(
  [Vl],
  (e) => e && e.getRenderings().map((t) => ({
    label: t.getLabel().getValue(),
    value: t.id
  }))
), vqe = Qe(
  [
    Ble("seeAlso"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => ({
    format: n.format,
    label: Ti.parse(n.label, t).getValue(),
    value: n.id || n["@id"]
  }))
), yqe = ye("dl")(({ theme: e }) => ({
  "& dd": {
    marginBottom: ".5em",
    marginLeft: "0"
  }
})), XB = (e) => e && e.length > 0, Vle = ({
  related: e = null,
  renderings: t = null,
  seeAlso: n = null,
  id: r = null
}) => {
  const { t: i } = Ct();
  return !r || !XB(e) && !XB(t) && !XB(n) ? /* @__PURE__ */ T.jsx("div", {}) : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      St,
      {
        "aria-labelledby": `${r}-related ${r}-related-heading`,
        id: `${r}-related-heading`,
        variant: "h5",
        component: "h6",
        children: i("links")
      }
    ),
    /* @__PURE__ */ T.jsxs(yqe, { className: On(Nt("label-value-metadata")), children: [
      t && t.length > 0 && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: i("iiif_renderings") }),
        t.map((o) => /* @__PURE__ */ T.jsx(St, { variant: "body1", component: "dd", children: /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: o.value, children: o.label || o.value }) }, o.value))
      ] }),
      e && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: i("iiif_related") }),
        e.map((o) => /* @__PURE__ */ T.jsxs(St, { variant: "body1", component: "dd", children: [
          /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: o.value, children: o.label || o.value }),
          o.format && /* @__PURE__ */ T.jsx(St, { component: "span", children: ` (${o.format})` })
        ] }, o.value))
      ] }),
      n && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        /* @__PURE__ */ T.jsx(St, { variant: "subtitle2", component: "dt", children: i("iiif_seeAlso") }),
        n.map((o) => /* @__PURE__ */ T.jsxs(St, { variant: "body1", component: "dd", children: [
          /* @__PURE__ */ T.jsx(ka, { target: "_blank", rel: "noopener noreferrer", href: o.value, children: o.label || o.value }),
          o.format && /* @__PURE__ */ T.jsx(St, { component: "span", children: ` (${o.format})` })
        ] }, o.value))
      ] })
    ] })
  ] });
};
Vle.propTypes = {
  id: c.string,
  related: c.arrayOf(c.shape({
    format: c.string,
    label: c.string,
    value: c.string
  })),
  renderings: c.arrayOf(c.shape({
    label: c.string,
    value: c.string
  })),
  seeAlso: c.arrayOf(c.shape({
    format: c.string,
    label: c.string,
    value: c.string
  }))
};
const bqe = (e, { id: t, windowId: n }) => ({
  id: t || hqe(e, { windowId: n }),
  related: gqe(e, { windowId: n }),
  renderings: mqe(e, { windowId: n }),
  seeAlso: vqe(e, { windowId: n })
}), xqe = wt(
  At(bqe),
  Tt("CanvasRelatedLinks")
), Sqe = xqe(Vle), wqe = [
  {
    component: Sqe,
    mode: "add",
    name: "CanvasRelatedLinks",
    target: "CanvasInfo"
  }
];
function Ule(e) {
  return Qe(
    [Vl],
    (t) => t && t.getProperty(e)
  );
}
Qe(
  [
    Ule("related"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => typeof n == "string" ? {
    value: n
  } : {
    format: n.format,
    label: Ti.parse(n.label, t).getValue(),
    value: n.id || n["@id"]
  })
);
const Tqe = Qe(
  [Vl],
  (e) => e && e.getRenderings().map((t) => ({
    label: t.getLabel().getValue(),
    value: t.id
  }))
), Fle = Qe(
  [
    Ule("seeAlso"),
    Oi
  ],
  (e, t) => e && hs(e).map((n) => ({
    format: n.format,
    label: Ti.parse(n.label, t).getValue(),
    value: n.id || n["@id"]
  }))
), Eqe = (e, t) => {
  if (!e && !t) return !0;
  if (!e || !t) return !1;
  if (e && e.length === (t == null ? void 0 : t.length)) {
    for (let n = 0; n < e.length; n += 1)
      if (e[n] !== t[n]) return !1;
    return !0;
  }
  return !1;
}, Wle = Qe(
  [Wn],
  (e) => e && e.collectionPath
), BV = Qe(
  [Fa],
  (e) => {
    const t = [];
    return e == null || e.forEach((n) => {
      new Ox(n).imageResources.forEach(((r) => {
        !t.includes("Audio") && Kh.audioTypes.includes(r.getProperty("type")) && t.push("Audio"), !t.includes("Image") && Kh.imageTypes.includes(r.getProperty("type")) && t.push("Image"), !t.includes("Text") && Kh.textTypes.includes(r.getProperty("type")) && t.push("Text"), !t.includes("Video") && Kh.videoTypes.includes(r.getProperty("type")) && t.push("Video");
      }));
    }), t;
  }
), Hle = (e) => Qe(
  [nr],
  (t) => t && t.getProperty(e)
), _qe = Qe(
  [Hle("doi")],
  (e) => e ? Object.prototype.hasOwnProperty.call(e, "id") ? e.id : Object.prototype.hasOwnProperty.call(e, "@id") ? e["@id"] : e.toString() : null
), qle = (e) => Qe(
  [
    Hle(e),
    Oi
  ],
  (t, n) => t ? hs(t).map((r) => ({
    ...r,
    format: r.format,
    label: Ti.parse(r.label, n).getValue(),
    value: r.id || r["@id"]
  })) : null
), $le = qle("rendering"), Cqe = qle("seeAlso"), Rqe = Qe(
  [
    $le,
    Cqe
  ],
  (e, t) => !e && !t ? null : hs(e || []).concat(t || [])
), Oqe = Mt([/* @__PURE__ */ T.jsx("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4z"
}, "0"), /* @__PURE__ */ T.jsx("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 10-2.5-1.5L15 12V4h5z"
}, "1")], "CollectionsBookmark");
class E1 extends $.Component {
  /**
   * render
   * @return
   */
  render() {
    const {
      classes: t
    } = this.props, { badge: n } = t;
    return /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", classes: { badge: n }, variant: "dot", children: /* @__PURE__ */ T.jsx(Oqe, {}) });
  }
}
E1.value = "citation";
E1.propTypes = {
  classes: c.objectOf(c.string)
};
E1.defaultProps = {
  classes: {}
};
const HW = ye("div")(() => ({
  "& .MuiPaper-root": {
    background: "transparent"
  },
  padding: (e) => e.spacing(2)
})), ps = (e) => e && e.length > 0, La = (e) => ps(e) ? e.endsWith(".") ? e : `${e}.` : "", qW = (e) => {
  if (!ps(e)) return "";
  const t = /^(['"]).*(['"])$/, n = e.match(t);
  return n ? n[1] === n[2] ? e : `${e}${n[1]}` : `"${e}"`;
}, PA = (e) => {
  if (!ps(e)) return "";
  const t = e.startsWith("doi:") ? e.slice(4, -1) : e;
  return t.startsWith("10.") ? `https://doi.org/${t}` : t;
};
function Aqe(e, t) {
  const {
    collectionName: n,
    doi: r,
    format: i,
    nameForCitation: o,
    providers: s,
    repositoryName: u,
    textualDate: f,
    title: p
  } = e;
  ps(n), ps(u);
  const m = [];
  ps(s[0]) && m.push(s[0]), ps(s[1]) && m.push(`[${s[1]}]`);
  const { section: v } = t;
  return /* @__PURE__ */ T.jsxs(HW, { className: v, children: [
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationName", children: La(o) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationDate", children: La(f) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationTitle", children: La(qW(p)) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { fontStyle: "italic", typography: "body2" }, className: "citationProvider", children: La(m.join(" ")) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationFormat", children: La(i) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationUrl", children: `Retrieved from ${PA(r)}` })
  ] });
}
function Dqe(e, t) {
  const {
    collectionName: n,
    doi: r,
    format: i,
    nameForCitation: o,
    providers: s,
    repositoryName: u,
    textualDate: f,
    title: p
  } = e;
  ps(n), ps(u);
  const m = [];
  ps(s[0]) && m.push(s[0]), ps(s[1]) && m.push(`[${s[1]}]`);
  const { section: v } = t;
  return /* @__PURE__ */ T.jsxs(HW, { className: v, children: [
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationName", children: La(o) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationTitle", children: La(qW(p)) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationFormat", children: La(i) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationDate", children: La(f) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { fontStyle: "italic", typography: "body2" }, className: "citationProvider", children: La(m.join(" ")) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationAccessed", children: `Accessed ${(/* @__PURE__ */ new Date()).toDateString()}.` }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationUrl", children: PA(r) })
  ] });
}
function Gle(e, t) {
  const {
    collectionName: n,
    doi: r,
    format: i,
    nameForCitation: o,
    providers: s,
    repositoryName: u,
    textualDate: f,
    title: p
  } = e, m = [];
  ps(n) && m.push(n), ps(u) && m.push(u);
  const v = [];
  ps(s[0]) && v.push(s[0]), ps(PA(r)) && v.push(PA(r));
  const { section: y } = t;
  return /* @__PURE__ */ T.jsxs(HW, { className: y, children: [
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationName", children: La(o) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationTitle", children: La(qW(p)) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationDate", children: La(f) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationFormat", children: La(i) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationLocation", children: La(m.join(", ")) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { fontStyle: "italic", typography: "body2" }, className: "citationProvider", children: La(v.join(", ")) }),
    /* @__PURE__ */ T.jsx(ur, { sx: { typography: "body2" }, className: "citationAccessed", children: `Accessed ${(/* @__PURE__ */ new Date()).toDateString()}` })
  ] });
}
const Iqe = {
  apa: Aqe,
  chicago: Dqe,
  mla: Gle
};
function Yle({
  availableCitationStyles: e = ["apa", "chicago", "mla"],
  citationStyle: t = "mla",
  setCitationStyle: n = void 0
}) {
  return !n || e.length < 2 ? null : /* @__PURE__ */ T.jsx(b_, { sx: { m: 1, minWidth: 60 }, size: "small", children: /* @__PURE__ */ T.jsx(
    Vx,
    {
      MenuProps: {
        anchorOrigin: {
          horizontal: "left",
          vertical: "bottom"
        }
      },
      displayEmpty: !0,
      value: t,
      onChange: (r) => {
        n(r.target.value);
      },
      name: "citationStyle",
      children: e.map((r) => /* @__PURE__ */ T.jsx(qo, { value: r, children: /* @__PURE__ */ T.jsx(St, { variant: "body2", children: r }) }, r))
    }
  ) });
}
Yle.propTypes = {
  availableCitationStyles: c.arrayOf(c.string),
  citationStyle: c.string,
  setCitationStyle: c.func
};
const Pqe = (e) => Iqe[e] || Gle;
function Xle({
  citationData: e = {},
  classes: t = {},
  id: n,
  manifestDoi: r = null,
  manifestProviderNames: i = [],
  manifestTitle: o = "",
  windowId: s
}) {
  const { t: u } = Ct(), [f, p] = $.useState("mla"), m = Pqe(f), v = {
    doi: r,
    providers: i,
    title: o,
    ...e
  };
  return /* @__PURE__ */ T.jsx(
    Zd,
    {
      title: u("citeThisItem"),
      paperClassName: Nt("window-sidebar-citation-panel"),
      windowId: s,
      id: n,
      titleControls: /* @__PURE__ */ T.jsx(Yle, { citationStyle: f, setCitationStyle: p, availableCitationStyles: ["mla", "chicago", "apa"] }),
      children: m(v, t)
    }
  );
}
Xle.propTypes = {
  citationData: c.objectOf(c.string),
  classes: c.objectOf(c.string),
  id: c.string.isRequired,
  manifestDoi: c.string,
  manifestProviderNames: c.arrayOf(c.string),
  manifestTitle: c.string,
  windowId: c.string.isRequired
};
const ZO = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e)) return e.find((i) => ZO(i, t));
  const n = Object.keys(t)[0], r = t[n];
  return e[n] === r ? !0 : Array.isArray(e[n]) ? e[n].find((i) => ZO(i, r)) : Object.keys(r)[0] && r.constructor !== String ? e[n] && ZO(e[n], r) : !1;
};
Qe(
  [nr],
  (e) => e == null ? void 0 : e.getProperty("metadata")
);
const Zle = (e, t) => t ? e == null ? void 0 : e.find((n) => ZO(n, t)) : null, Kle = (e, t, n, r = !0) => {
  const i = Zle(e, t);
  if (i) {
    const o = new t1(n);
    return o.parse(i), o.getValue(n, r);
  }
  return "";
}, Nqe = (e) => Qe(
  [nr],
  (t) => {
    var r;
    const n = Zle(t.getProperty("metadata"), e);
    return n && n.seeAlso && ((r = n.seeAlso[0]) == null ? void 0 : r.id);
  }
), Mqe = /(.+)(,\W\d{1,4}\s*(-?\s*\d{0,4})?)(.*)/, jqe = (e) => Qe(
  [nr, Oi],
  (t, n) => {
    const r = Kle(t.getProperty("metadata"), e, n, !1), i = r.match(Mqe);
    return i ? `${i[1]} ${i[4]}` : r;
  }
), k0 = (e) => Qe(
  [nr, Oi],
  (t, n) => Kle(t.getProperty("metadata"), e, n)
), Lqe = {
  dataSelectors: {
    collectionName: k0({
      seeAlso: {
        profile: "https://clio.columbia.edu/archives"
      }
    }),
    collectionUri: Nqe({
      seeAlso: {
        profile: "https://clio.columbia.edu/archives"
      }
    }),
    doi: k0({
      profile: "http://purl.org/ontology/bibo/doi"
    }),
    format: k0({
      label: { en: "Format" }
    }),
    genre: k0({
      label: { en: "Genre" }
    }),
    nameForCitation: jqe({
      label: { en: "Name" }
    }),
    repositoryName: k0({
      seeAlso: {
        profile: "https://id.loc.gov/vocabulary/organizations"
      }
    }),
    textualDate: k0({
      label: { en: "Date" }
    })
  },
  // Enable the plugin
  enabled: !0,
  // Open the panel
  panelOpen: !1
}, ZB = Qe(
  [fa],
  ({ openPanel: e = {} }) => ({
    ...Lqe,
    ...e
  })
), kqe = Qe(
  [
    nr,
    Oi
  ],
  (e, t) => {
    const n = e.getProperty("provider"), r = n && n[0].label && Ti.parse(n[0].label, t).getValue(), i = n && n[0].partOf, o = (i == null ? void 0 : i.label) && Ti.parse(i.label, t).getValue();
    return [r, o].filter((s) => s);
  }
), zqe = [
  {
    component: E1,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      /** */
      updateConfig(n) {
        return e(Po(t, { openPanel: n }));
      }
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      config: ZB(e, { windowId: t }),
      containerId: Du(e),
      translations: Dn(e).translations
    }),
    mode: "add",
    name: "WindowSideBarCitationButton",
    target: "WindowSideBarButtons"
  },
  {
    companionWindowKey: E1.value,
    component: Xle,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      /** */
      updateConfig(n) {
        return e(Po(t, { openPanel: n }));
      }
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      citationData: ((n) => Object.getOwnPropertyNames(n.dataSelectors).reduce((r, i) => (r[i] = n.dataSelectors[i](e, { windowId: t }), r), {}))(ZB(e, { windowId: t })),
      config: ZB(e, { windowId: t }),
      containerId: Du(e),
      manifestDoi: _qe(e, { windowId: t }),
      manifestId: B1(e, { windowId: t }),
      manifestLocale: Oi(e, { windowId: t }),
      manifestProviderNames: kqe(e, { windowId: t }),
      manifestTitle: Lu(e, { windowId: t })
    }),
    // see mirador/dist/es/src/extend/pluginMapping.js
    name: "WindowSideBarCitationPanel"
  }
], Bqe = (e) => !1, Qle = ({
  collectionLabel: e = null,
  collectionPath: t = [],
  id: n,
  updateWindow: r,
  windowId: i = null
}) => {
  const { t: o } = Ct(), s = () => {
    const u = {
      collectionPath: t.slice(0, t.length - 1),
      manifestId: t[t.length - 1]
    };
    r(i, u);
  };
  return t.length === 0 ? null : /* @__PURE__ */ T.jsxs(
    iy,
    {
      id: `${n}-collection`,
      label: o("collection"),
      children: [
        e && /* @__PURE__ */ T.jsx(
          St,
          {
            "aria-labelledby": `${n}-resource ${n}-resource-heading`,
            id: `${n}-resource-heading`,
            variant: "h4",
            children: e
          }
        ),
        /* @__PURE__ */ T.jsx(
          hi,
          {
            color: "primary",
            onClick: s,
            startIcon: /* @__PURE__ */ T.jsx(AF, {}),
            children: o("showCollection")
          }
        )
      ]
    }
  );
};
Qle.propTypes = {
  collectionLabel: c.string,
  collectionPath: c.arrayOf(c.string),
  id: c.string.isRequired,
  updateWindow: c.func.isRequired,
  windowId: c.string
};
const Jle = ({
  backToCollection: e,
  collectionId: t,
  collectionPath: n,
  fetchManifest: r,
  getCollectionManifesto: i,
  getLabel: o,
  locale: s,
  windowId: u = null
}) => {
  const { t: f } = Ct(), p = Ba((y) => Va(y, { manifestId: t }), Nd), m = p && i(t);
  ln(() => {
    !m && !(p != null && p.isFetching) && r(t);
  }, [m, t, p, r]);
  const v = t.split("/").pop();
  return /* @__PURE__ */ T.jsx(
    hi,
    {
      startIcon: /* @__PURE__ */ T.jsx(zF, {}),
      onClick: () => e({ collection: m, collectionPath: n }),
      children: o({ fallback: v, locale: s, resource: m })
    }
  );
};
Jle.propTypes = {
  backToCollection: c.func.isRequired,
  collectionId: c.string.isRequired,
  collectionPath: c.arrayOf(c.string).isRequired,
  fetchManifest: c.func.isRequired,
  getCollectionManifesto: c.func.isRequired,
  getLabel: c.func.isRequired,
  locale: c.string.isRequired,
  windowId: c.string
};
var Vqe = {};
const VV = /* @__PURE__ */ $.createContext();
Vqe.NODE_ENV !== "production" && (VV.displayName = "GridContext");
function Uqe(e) {
  return Vt("MuiGrid", e);
}
const Fqe = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Wqe = ["column-reverse", "column", "row-reverse", "row"], Hqe = ["nowrap", "wrap-reverse", "wrap"], vE = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], _1 = Wt("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...Fqe.map((e) => `spacing-xs-${e}`),
  // direction values
  ...Wqe.map((e) => `direction-xs-${e}`),
  // wrap values
  ...Hqe.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...vE.map((e) => `grid-xs-${e}`),
  ...vE.map((e) => `grid-sm-${e}`),
  ...vE.map((e) => `grid-md-${e}`),
  ...vE.map((e) => `grid-lg-${e}`),
  ...vE.map((e) => `grid-xl-${e}`)
]);
var ece = {};
function qqe({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((r, i) => {
    let o = {};
    if (t[i] && (n = t[i]), !n)
      return r;
    if (n === !0)
      o = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      o = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const s = KA({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), u = typeof s == "object" ? s[i] : s;
      if (u == null)
        return r;
      const f = `${Math.round(n / u * 1e8) / 1e6}%`;
      let p = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const m = e.spacing(t.columnSpacing);
        if (m !== "0px") {
          const v = `calc(${f} + ${m})`;
          p = {
            flexBasis: v,
            maxWidth: v
          };
        }
      }
      o = {
        flexBasis: f,
        flexGrow: 0,
        maxWidth: f,
        ...p
      };
    }
    return e.breakpoints.values[i] === 0 ? Object.assign(r, o) : r[e.breakpoints.up(i)] = o, r;
  }, {});
}
function $qe({
  theme: e,
  ownerState: t
}) {
  const n = KA({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return lU({
    theme: e
  }, n, (r) => {
    const i = {
      flexDirection: r
    };
    return r.startsWith("column") && (i[`& > .${_1.item}`] = {
      maxWidth: "none"
    }), i;
  });
}
function tce({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((i) => {
    n === "" && t[i] !== 0 && (n = i);
  });
  const r = Object.keys(e).sort((i, o) => e[i] - e[o]);
  return r.slice(0, r.indexOf(n));
}
function Gqe({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: r
  } = t;
  let i = {};
  if (n && r !== 0) {
    const o = KA({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let s;
    typeof o == "object" && (s = tce({
      breakpoints: e.breakpoints.values,
      values: o
    })), i = lU({
      theme: e
    }, o, (u, f) => {
      const p = e.spacing(u);
      return p !== "0px" ? {
        marginTop: `calc(-1 * ${p})`,
        [`& > .${_1.item}`]: {
          paddingTop: p
        }
      } : s != null && s.includes(f) ? {} : {
        marginTop: 0,
        [`& > .${_1.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return i;
}
function Yqe({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: r
  } = t;
  let i = {};
  if (n && r !== 0) {
    const o = KA({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let s;
    typeof o == "object" && (s = tce({
      breakpoints: e.breakpoints.values,
      values: o
    })), i = lU({
      theme: e
    }, o, (u, f) => {
      const p = e.spacing(u);
      if (p !== "0px") {
        const m = `calc(-1 * ${p})`;
        return {
          width: `calc(100% + ${p})`,
          marginLeft: m,
          [`& > .${_1.item}`]: {
            paddingLeft: p
          }
        };
      }
      return s != null && s.includes(f) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${_1.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return i;
}
function Xqe(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const r = [];
  return t.forEach((i) => {
    const o = e[i];
    Number(o) > 0 && r.push(n[`spacing-${i}-${String(o)}`]);
  }), r;
}
const Zqe = ye("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: r,
      direction: i,
      item: o,
      spacing: s,
      wrap: u,
      zeroMinWidth: f,
      breakpoints: p
    } = n;
    let m = [];
    r && (m = Xqe(s, p, t));
    const v = [];
    return p.forEach((y) => {
      const S = n[y];
      S && v.push(t[`grid-${y}-${String(S)}`]);
    }), [t.root, r && t.container, o && t.item, f && t.zeroMinWidth, ...m, i !== "row" && t[`direction-xs-${String(i)}`], u !== "wrap" && t[`wrap-xs-${String(u)}`], ...v];
  }
})(
  // FIXME(romgrk): Can't use memoTheme here
  ({
    ownerState: e
  }) => ({
    boxSizing: "border-box",
    ...e.container && {
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    ...e.item && {
      margin: 0
      // For instance, it's useful when used with a `figure` element.
    },
    ...e.zeroMinWidth && {
      minWidth: 0
    },
    ...e.wrap !== "wrap" && {
      flexWrap: e.wrap
    }
  }),
  $qe,
  Gqe,
  Yqe,
  qqe
);
function Kqe(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((r) => {
    const i = e[r];
    if (Number(i) > 0) {
      const o = `spacing-${r}-${String(i)}`;
      n.push(o);
    }
  }), n;
}
const Qqe = (e) => {
  const {
    classes: t,
    container: n,
    direction: r,
    item: i,
    spacing: o,
    wrap: s,
    zeroMinWidth: u,
    breakpoints: f
  } = e;
  let p = [];
  n && (p = Kqe(o, f));
  const m = [];
  f.forEach((y) => {
    const S = e[y];
    S && m.push(`grid-${y}-${String(S)}`);
  });
  const v = {
    root: ["root", n && "container", i && "item", u && "zeroMinWidth", ...p, r !== "row" && `direction-xs-${String(r)}`, s !== "wrap" && `wrap-xs-${String(s)}`, ...m]
  };
  return Ft(v, Uqe, t);
}, pr = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: i
  } = pa(), o = Z3(r), {
    className: s,
    columns: u,
    columnSpacing: f,
    component: p = "div",
    container: m = !1,
    direction: v = "row",
    item: y = !1,
    rowSpacing: S,
    spacing: E = 0,
    wrap: w = "wrap",
    zeroMinWidth: _ = !1,
    ...O
  } = o, D = S || E, P = f || E, M = $.useContext(VV), N = m ? u || 12 : M, k = {}, U = {
    ...O
  };
  i.keys.forEach((z) => {
    O[z] != null && (k[z] = O[z], delete U[z]);
  });
  const H = {
    ...o,
    columns: N,
    container: m,
    direction: v,
    item: y,
    rowSpacing: D,
    columnSpacing: P,
    wrap: w,
    zeroMinWidth: _,
    spacing: E,
    ...k,
    breakpoints: i.keys
  }, Y = Qqe(H);
  return /* @__PURE__ */ T.jsx(VV.Provider, {
    value: N,
    children: /* @__PURE__ */ T.jsx(Zqe, {
      ownerState: H,
      className: yt(Y.root, s),
      as: p,
      ref: n,
      ...U
    })
  });
});
ece.NODE_ENV !== "production" && (pr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: c.oneOfType([c.arrayOf(c.number), c.number, c.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: c.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: c.oneOfType([c.oneOf(["column-reverse", "column", "row-reverse", "row"]), c.arrayOf(c.oneOf(["column-reverse", "column", "row-reverse", "row"])), c.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: c.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: c.oneOfType([c.oneOf(["auto"]), c.number, c.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: c.oneOfType([c.oneOf(["auto"]), c.number, c.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: c.oneOfType([c.oneOf(["auto"]), c.number, c.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: c.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: c.oneOfType([c.oneOf(["auto"]), c.number, c.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: c.oneOfType([c.oneOf(["auto"]), c.number, c.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: c.bool
});
if (ece.NODE_ENV !== "production") {
  const e = Une("Grid", pr);
  pr.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...pr.propTypes,
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  };
}
const Jqe = ye(Hd, { name: "CollectionListHeaders", slot: "root" })(({ ownerState: e, theme: t }) => ({
  "&:hover,&:focus-within": {
    backgroundColor: t.palette.action.hover,
    borderLeftColor: e != null && e.active ? t.palette.primary.main : t.palette.action.hover
  },
  borderLeft: "4px solid",
  borderLeftColor: e != null && e.active ? t.palette.primary.main : "transparent",
  paddingLeft: t.spacing(2),
  paddingRight: t.spacing(2),
  [t.breakpoints.up("sm")]: {
    paddingLeft: t.spacing(3),
    paddingRight: t.spacing(3)
  }
})), nce = ({ collectionId: e }) => /* @__PURE__ */ T.jsx(
  Jqe,
  {
    divider: !0,
    "data-manifestid": e,
    children: /* @__PURE__ */ T.jsxs(pr, { container: !0, className: Nt("collection-list-item"), spacing: 2, children: [
      /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ T.jsxs(
        pr,
        {
          container: !0,
          spacing: 2,
          sx: {
            textAlign: "left",
            textTransform: "initial"
          },
          component: "span",
          children: [
            /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 4, sm: 3, component: "span" }),
            /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 8, sm: 9, component: "span", children: /* @__PURE__ */ T.jsx(St, { component: "span", variant: "h6", fontWeight: "bold", children: "Name" }) })
          ]
        }
      ) }),
      /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 8, sm: 4, children: /* @__PURE__ */ T.jsx(St, { component: "span", variant: "h6", fontWeight: "bold", children: "Number of Items" }) }),
      /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 4, sm: 2 })
    ] })
  }
);
nce.propTypes = {
  collectionId: c.string.isRequired
};
const e6e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"
}), "Folder"), UZ = (e) => e.isSequence && e.isSequence();
class t6e {
  /** */
  constructor(t = 0) {
    this.count = t;
  }
  /** */
  increment() {
    this.count += 1;
  }
}
function NA(e, t = (n) => !0) {
  if (e === null || typeof e != "object") return !1;
  if (e.isManifest && e.isManifest() && e.getSequences().reduce(
    (r, i) => r || (UZ(i) ? NA(i, t) : i.getCanvases().some(t)),
    !1
  ))
    return !0;
  if (e.isRange && e.isRange()) {
    if (e.canvases.some(t)) return !0;
    e.getRanges().reduce((n, r) => n || NA(r, t), !1);
  }
  return UZ(e) ? e.getCanvases().some(t) : e.isCanvas && e.isCanvas() ? t(e) : !1;
}
function n6e(e) {
  const t = new t6e();
  return NA(e, (n) => t.increment() && !1), t.count;
}
class r6e {
  /** */
  constructor(t = null) {
    this.type = t;
  }
  /** */
  match(t) {
    return t && !this.type ? (this.type = t.toLowerCase(), this.matcher = new RegExp(this.type, "i"), !0) : t ? t.match(this.matcher) : !!this.type;
  }
}
const i6e = (e) => `${e.slice(0, 1).toUpperCase()}${e.slice(1)}`;
function o6e(e) {
  var u, f;
  if (!e) return null;
  const t = (u = e.isCollection() && e.items) == null ? void 0 : u.length;
  if (t) return `${t} Item${t === 1 ? "" : "s"}`;
  const n = n6e(e);
  if (!n) return null;
  const r = n === 1 ? "" : "s";
  if (e.getBehavior && ((f = e.getBehavior()) != null && f.includes("paged"))) return `${n} Page${r}`;
  const i = new r6e();
  if (NA(e, (p) => {
    var v, y;
    const m = (S) => {
      const E = (S == null ? void 0 : S.getBody) && S.getBody();
      if (E && E[0]) return E == null ? void 0 : E.some((_) => !i.match(_.getType ? _.getType() : null));
      const w = (S == null ? void 0 : S.getResource) && S.getResource();
      return w ? !i.match(w.getType ? w.getType() : null) : i.type === null;
    };
    (v = p.getContent()) == null || v.some(m), (y = p.getImages()) == null || y.some(m);
  })) return `${n} Asset${r}`;
  const s = i.type || "asset";
  return `${n} ${i6e(s)}${r}`;
}
const $W = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutlineSharp"), a6e = nre(), s6e = (e, t) => e.filter((n) => t.includes(n)), Gx = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((i, o) => {
    n((s, u) => {
      o <= e.keys.length - 1 && (o === 0 ? Object.assign(s, u) : s[e.up(e.keys[o])] = u);
    }, i);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : s6e(e.keys, Object.keys(t))).forEach((o) => {
    if (e.keys.includes(o)) {
      const s = t[o];
      s !== void 0 && n((u, f) => {
        r === o ? Object.assign(u, f) : u[e.up(o)] = f;
      }, s);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((i, o) => {
    Object.assign(i, o);
  }, t);
};
function MA(e) {
  return `--Grid-${e}Spacing`;
}
function tP(e) {
  return `--Grid-parent-${e}Spacing`;
}
const FZ = "--Grid-columns", nx = "--Grid-parent-columns", l6e = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Gx(e.breakpoints, t.size, (r, i) => {
    let o = {};
    i === "grow" && (o = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), i === "auto" && (o = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof i == "number" && (o = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${i} / var(${nx}) - (var(${nx}) - ${i}) * (var(${tP("column")}) / var(${nx})))`
    }), r(n, o);
  }), n;
}, c6e = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Gx(e.breakpoints, t.offset, (r, i) => {
    let o = {};
    i === "auto" && (o = {
      marginLeft: "auto"
    }), typeof i == "number" && (o = {
      marginLeft: i === 0 ? "0px" : `calc(100% * ${i} / var(${nx}) + var(${tP("column")}) * ${i} / var(${nx}))`
    }), r(n, o);
  }), n;
}, u6e = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [FZ]: 12
  };
  return Gx(e.breakpoints, t.columns, (r, i) => {
    const o = i ?? 12;
    r(n, {
      [FZ]: o,
      "> *": {
        [nx]: o
      }
    });
  }), n;
}, d6e = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Gx(e.breakpoints, t.rowSpacing, (r, i) => {
    var s;
    const o = typeof i == "string" ? i : (s = e.spacing) == null ? void 0 : s.call(e, i);
    r(n, {
      [MA("row")]: o,
      "> *": {
        [tP("row")]: o
      }
    });
  }), n;
}, f6e = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Gx(e.breakpoints, t.columnSpacing, (r, i) => {
    var s;
    const o = typeof i == "string" ? i : (s = e.spacing) == null ? void 0 : s.call(e, i);
    r(n, {
      [MA("column")]: o,
      "> *": {
        [tP("column")]: o
      }
    });
  }), n;
}, p6e = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Gx(e.breakpoints, t.direction, (r, i) => {
    r(n, {
      flexDirection: i
    });
  }), n;
}, h6e = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${MA("row")}) var(${MA("column")})`
  }
}), g6e = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, m6e = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([i, o]) => {
      n(o) && r.push(`spacing-${i}-${String(o)}`);
    }), r;
  }
  return [];
}, v6e = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`];
var y6e = {};
const b6e = (e) => ["item", "zeroMinWidth"].includes(e) ? `The \`${e}\` prop has been removed and is no longer necessary. You can safely remove it.` : `The \`${e}\` prop has been removed. See https://v6.mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`, WZ = [];
function x6e(e, t) {
  const n = [];
  e.item !== void 0 && (delete e.item, n.push("item")), e.zeroMinWidth !== void 0 && (delete e.zeroMinWidth, n.push("zeroMinWidth")), t.keys.forEach((r) => {
    e[r] !== void 0 && (n.push(r), delete e[r]);
  }), y6e.NODE_ENV !== "production" && n.forEach((r) => {
    WZ.includes(r) || (WZ.push(r), console.warn(`MUI Grid2: ${b6e(r)}
`));
  });
}
var S6e = {};
const w6e = ZD(), T6e = a6e("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function E6e(e) {
  return sre({
    props: e,
    name: "MuiGrid",
    defaultTheme: w6e
  });
}
function _6e(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = T6e,
    useThemeProps: n = E6e,
    useTheme: r = Yne,
    componentName: i = "MuiGrid"
  } = e, o = (p, m) => {
    const {
      container: v,
      direction: y,
      spacing: S,
      wrap: E,
      size: w
    } = p, _ = {
      root: ["root", v && "container", E !== "wrap" && `wrap-xs-${String(E)}`, ...v6e(y), ...g6e(w), ...v ? m6e(S, m.breakpoints.keys[0]) : []]
    };
    return Ft(_, (O) => Vt(i, O), {});
  };
  function s(p, m, v = () => !0) {
    const y = {};
    return p === null || (Array.isArray(p) ? p.forEach((S, E) => {
      S !== null && v(S) && m.keys[E] && (y[m.keys[E]] = S);
    }) : typeof p == "object" ? Object.keys(p).forEach((S) => {
      const E = p[S];
      E != null && v(E) && (y[S] = E);
    }) : y[m.keys[0]] = p), y;
  }
  const u = t(u6e, f6e, d6e, l6e, p6e, h6e, c6e), f = /* @__PURE__ */ $.forwardRef(function(m, v) {
    const y = r(), S = n(m), E = Z3(S);
    x6e(E, y.breakpoints);
    const {
      className: w,
      children: _,
      columns: O = 12,
      container: D = !1,
      component: P = "div",
      direction: M = "row",
      wrap: N = "wrap",
      size: k = {},
      offset: U = {},
      spacing: H = 0,
      rowSpacing: Y = H,
      columnSpacing: z = H,
      unstable_level: V = 0,
      ...F
    } = E, X = s(k, y.breakpoints, (ne) => ne !== !1), oe = s(U, y.breakpoints), re = m.columns ?? (V ? void 0 : O), Z = m.spacing ?? (V ? void 0 : H), ee = m.rowSpacing ?? m.spacing ?? (V ? void 0 : Y), J = m.columnSpacing ?? m.spacing ?? (V ? void 0 : z), le = {
      ...E,
      level: V,
      columns: re,
      container: D,
      direction: M,
      wrap: N,
      spacing: Z,
      rowSpacing: ee,
      columnSpacing: J,
      size: X,
      offset: oe
    }, be = o(le, y);
    return /* @__PURE__ */ T.jsx(u, {
      ref: v,
      as: P,
      ownerState: le,
      className: yt(be.root, w),
      ...F,
      children: $.Children.map(_, (ne) => {
        var ae;
        return /* @__PURE__ */ $.isValidElement(ne) && J0(ne, ["Grid"]) && D && ne.props.container ? /* @__PURE__ */ $.cloneElement(ne, {
          unstable_level: ((ae = ne.props) == null ? void 0 : ae.unstable_level) ?? V + 1
        }) : ne;
      })
    });
  });
  return S6e.NODE_ENV !== "production" && (f.propTypes = {
    children: c.node,
    className: c.string,
    columns: c.oneOfType([c.arrayOf(c.number), c.number, c.object]),
    columnSpacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
    component: c.elementType,
    container: c.bool,
    direction: c.oneOfType([c.oneOf(["column-reverse", "column", "row-reverse", "row"]), c.arrayOf(c.oneOf(["column-reverse", "column", "row-reverse", "row"])), c.object]),
    offset: c.oneOfType([c.string, c.number, c.arrayOf(c.oneOfType([c.string, c.number])), c.object]),
    rowSpacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
    size: c.oneOfType([c.string, c.bool, c.number, c.arrayOf(c.oneOfType([c.string, c.bool, c.number])), c.object]),
    spacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
    sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
    wrap: c.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), f.muiName = "Grid", f;
}
var rce = {};
const Ri = _6e({
  createStyledComponent: ye("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => Gt({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: pa
});
rce.NODE_ENV !== "production" && (Ri.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: c.oneOfType([c.arrayOf(c.number), c.number, c.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: c.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: c.oneOfType([c.oneOf(["column-reverse", "column", "row-reverse", "row"]), c.arrayOf(c.oneOf(["column-reverse", "column", "row-reverse", "row"])), c.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: c.oneOfType([c.string, c.number, c.arrayOf(c.oneOfType([c.string, c.number])), c.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: c.oneOfType([c.string, c.bool, c.number, c.arrayOf(c.oneOfType([c.string, c.bool, c.number])), c.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * @ignore
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: c.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: c.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (rce.NODE_ENV !== "production") {
  const e = Ri, t = Une("Grid2", e);
  e.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...e.propTypes,
    direction: t("container"),
    spacing: t("container"),
    wrap: t("container")
  };
}
function ice({
  manifestId: e,
  onDismissClick: t,
  onTryAgainClick: n
}) {
  const { t: r } = Ct();
  return /* @__PURE__ */ T.jsxs(Ri, { container: !0, children: [
    /* @__PURE__ */ T.jsx(Ri, { container: !0, children: /* @__PURE__ */ T.jsxs(Ri, { container: !0, xs: 12, sm: 6, children: [
      /* @__PURE__ */ T.jsx(Ri, { xs: 4, sm: 3, children: /* @__PURE__ */ T.jsx(Ri, { container: !0, justifyContent: "center", children: /* @__PURE__ */ T.jsx(
        $W,
        {
          sx: {
            color: "error.main",
            height: "2rem",
            width: "2rem"
          }
        }
      ) }) }),
      /* @__PURE__ */ T.jsxs(Ri, { xs: 8, sm: 9, children: [
        /* @__PURE__ */ T.jsx(St, { children: r("manifestError") }),
        /* @__PURE__ */ T.jsx(St, { sx: { wordBreak: "break-all" }, children: e })
      ] })
    ] }) }),
    /* @__PURE__ */ T.jsx(Ri, { container: !0, children: /* @__PURE__ */ T.jsx(Ri, { container: !0, xs: 12, sm: 6, justifyContent: "flex-end", children: /* @__PURE__ */ T.jsxs(Ri, { children: [
      /* @__PURE__ */ T.jsx(hi, { onClick: () => {
        t(e);
      }, children: r("dismiss") }),
      /* @__PURE__ */ T.jsx(hi, { onClick: () => {
        n(e);
      }, children: r("tryAgain") })
    ] }) }) })
  ] });
}
ice.propTypes = {
  manifestId: c.string.isRequired,
  onDismissClick: c.func.isRequired,
  onTryAgainClick: c.func.isRequired
};
const C6e = {
  onDismissClick: hne,
  onTryAgainClick: DD
}, R6e = wt(
  At(null, C6e),
  Tt("ManifestListItemError")
), oce = R6e(ice), KB = ye(Hd, { name: "CollectionListItem", slot: "root" })(({ ownerState: e, theme: t }) => ({
  "&:hover,&:focus-within": {
    backgroundColor: t.palette.action.hover,
    borderLeftColor: t.palette.action.hover
  },
  borderLeft: "4px solid",
  borderLeftColor: "transparent",
  paddingLeft: t.spacing(2),
  paddingRight: t.spacing(2),
  [t.breakpoints.up("sm")]: {
    paddingLeft: t.spacing(3),
    paddingRight: t.spacing(3)
  }
})), O6e = ye(wI, { name: "CollectionListItem", slot: "logo" })(({ theme: e }) => ({
  height: "2.5rem",
  maxWidth: "100%",
  objectFit: "contain",
  paddingRight: 1
}));
function ace({
  buttonRef: e = void 0,
  handleClose: t = () => {
  },
  manifestId: n,
  title: r = null,
  manifestLogo: i = null,
  t: o = (y) => y,
  fetchManifest: s,
  getCollectionManifesto: u,
  isCollection: f = !1,
  isMultipart: p = !1,
  updateWindow: m,
  windowId: v
}) {
  const y = arguments[0], S = Ba((M) => n && Va(M, { manifestId: n, windowId: v }), Nd);
  ln(() => {
    const { error: M, isFetching: N } = S || {};
    !(S && !!S.json) && !M && !N && s(n);
  }, [s, S, n]);
  const E = u(n), w = () => {
    const {
      collectionPath: M,
      setCollection: N
    } = y;
    N({ collection: S, collectionPath: M }), t();
  }, _ = () => {
    const {
      collectionPath: M
    } = y;
    m(v, { collectionPath: M, manifestId: n }), t();
  }, O = /* @__PURE__ */ T.jsxs(pr, { container: !0, className: Nt("manifest-list-item"), spacing: 2, children: [
    /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 3, sm: 2, children: /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "rectangular", height: 80, width: 120 }) }),
    /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 9, sm: 6, children: /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "text" }) }),
    /* @__PURE__ */ T.jsxs(pr, { item: !0, xs: 8, sm: 2, children: [
      /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "text" }),
      /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "text" })
    ] }),
    /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 4, sm: 2, children: /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "rectangular", height: 60, width: 60 }) })
  ] }), D = /* @__PURE__ */ T.jsx(
    pi,
    {
      variant: "rectangular",
      animation: !1,
      sx: { bgcolor: "grey[300]" },
      height: 80,
      width: 120
    }
  ), P = (M) => {
    if (!M) return D;
    if (M.isCollection())
      return /* @__PURE__ */ T.jsx(e6e, { fontSize: "large", color: "primary" });
    const { url: N } = xbe(M);
    return M && N ? /* @__PURE__ */ T.jsx(
      jx,
      {
        resource: M,
        alt: "",
        style: {
          maxWidth: "100%",
          objectFit: "contain"
        },
        variant: "inside"
      }
    ) : D;
  };
  return E ? S.error ? /* @__PURE__ */ T.jsx(
    KB,
    {
      ownerState: y,
      divider: !0,
      "data-manifestid": n,
      children: /* @__PURE__ */ T.jsx(oce, { manifestId: n })
    }
  ) : /* @__PURE__ */ T.jsx(
    KB,
    {
      divider: !0,
      "data-manifestid": S == null ? void 0 : S.id,
      children: /* @__PURE__ */ T.jsxs(pr, { container: !0, className: Nt("manifest-list-item"), spacing: 2, children: [
        /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ T.jsx(
          Ws,
          {
            ref: e,
            className: Nt("manifest-list-item-title"),
            style: { width: "100%" },
            onClick: E.isCollection() ? w : _,
            children: /* @__PURE__ */ T.jsxs(
              pr,
              {
                container: !0,
                spacing: 2,
                sx: {
                  textAlign: "left",
                  textTransform: "initial"
                },
                component: "span",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: [
                  /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 4, sm: 3, component: "span", children: P(E) }),
                  /* @__PURE__ */ T.jsxs(pr, { item: !0, xs: 8, sm: 9, component: "span", children: [
                    f && /* @__PURE__ */ T.jsx(St, { component: "div", variant: "overline", children: o(p ? "multipartCollection" : "collection") }),
                    /* @__PURE__ */ T.jsx(St, { component: "span", variant: "h6", children: r || n })
                  ] })
                ]
              }
            )
          }
        ) }),
        /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 8, sm: 4, display: "flex", justifyContent: "left", alignItems: "center", children: /* @__PURE__ */ T.jsx(St, { children: o6e(E) }) }),
        /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 4, sm: 2, children: i && /* @__PURE__ */ T.jsx(
          O6e,
          {
            src: [i],
            alt: "",
            role: "presentation",
            unloader: /* @__PURE__ */ T.jsx(
              pi,
              {
                variant: "rectangular",
                animation: !1,
                sx: { bgcolor: "grey[300]" },
                height: 60,
                width: 60
              }
            )
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ T.jsx(
    KB,
    {
      ownerState: y,
      divider: !0,
      "data-manifestid": n,
      children: O
    }
  );
}
ace.propTypes = {
  buttonRef: c.elementType,
  fetchManifest: c.func.isRequired,
  getCollectionManifesto: c.func.isRequired,
  handleClose: c.func,
  isCollection: c.bool,
  isMultipart: c.bool,
  manifestId: c.string.isRequired,
  manifestLogo: c.string,
  t: c.func,
  title: c.string,
  updateWindow: c.func.isRequired,
  windowId: c.string.isRequired
};
const A6e = ye(Ei, { name: "GalleryView", slot: "root" })(({ theme: e }) => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowX: "hidden",
  overflowY: "scroll",
  padding: "50px 0 50px 20px",
  width: "100%"
})), HZ = ({ fallback: e, locale: t, resource: n }) => {
  if (!n) return e;
  const r = n.getLabel();
  return r ? r.getValue(t) ?? (e || n.id) : e;
}, sce = ({
  collectionId: e,
  fetchManifest: t,
  getCollectionManifesto: n,
  updateWindow: r,
  windowId: i = null
}) => {
  const { t: o } = Ct(), s = Ba((w) => Wle(w, { windowId: i }), Eqe), u = Ba((w) => Va(w, { manifestId: e }), Nd), f = u && n(e), p = Qi(JD), m = Ba((w) => z1(w, {})), v = p || m || "";
  ln(() => {
    !f && !(u != null && u.isFetching) && t(e);
  }, [f, e, u, t]);
  const y = ({ collection: w, collectionPath: _ }) => {
    const O = _.indexOf(w.id), P = { collectionPath: O > 0 ? _.slice(0, O) : [], manifestId: w.id };
    r(i, P);
  }, S = ({ collection: w, collectionPath: _ }) => {
    const O = { collectionPath: _, manifestId: w.id };
    r(i, O);
  }, E = f == null ? void 0 : f.items;
  return /* @__PURE__ */ T.jsx(
    A6e,
    {
      component: "section",
      "aria-label": "collection navigation section",
      dir: "ltr",
      square: !0,
      elevation: 0,
      id: `${i}-collections`,
      children: /* @__PURE__ */ T.jsxs(Xd, { sx: { bgcolor: "background.paper", width: "100%" }, children: [
        s == null ? void 0 : s.map((w, _) => /* @__PURE__ */ T.jsx(
          Jle,
          {
            backToCollection: y,
            collectionId: w,
            collectionPath: s,
            getCollectionManifesto: n,
            getLabel: HZ,
            locale: v
          },
          w
        )),
        /* @__PURE__ */ T.jsx(nce, { collectionId: e }),
        E && E.map((w, _) => /* @__PURE__ */ T.jsx(
          ace,
          {
            title: HZ({ fallback: (_ + 1).toString(), locale: v, resource: w }),
            manifestId: w.id,
            fetchManifest: t,
            getCollectionManifesto: n,
            collectionPath: [...s, f.id],
            setCollection: S,
            updateWindow: r,
            windowId: i,
            handleClose: () => {
            }
          },
          w.id
        ))
      ] })
    }
  );
};
sce.propTypes = {
  collectionId: c.string.isRequired,
  fetchManifest: c.func.isRequired,
  getCollectionManifesto: c.func.isRequired,
  updateWindow: c.func.isRequired,
  windowId: c.string
};
const D6e = [
  {
    component: sce,
    config: {},
    mapDispatchToProps: (e, { canvas: t, id: n, windowId: r }) => ({
      fetchManifest: (...i) => e(DD(...i)),
      requestItemAnnotations: () => [],
      updateWindow: (...i) => e(Po(...i))
    }),
    /** */
    mapStateToProps: (e, { windowId: t, provider: n }) => {
      const { collectionPath: r, collectionManifestId: i, manifestId: o } = Wn(e, { windowId: t });
      return {
        collectionId: o || i,
        collectionPath: r,
        getCollection: (f) => f && Va(e, { manifestId: f, windowId: t }),
        getCollectionManifesto: (f) => f && nr(e, { manifestId: f }),
        getManifests: L1,
        windowId: t
      };
    },
    mode: "wrap",
    name: "SelectCollectionFolders",
    target: "SelectCollection"
  },
  {
    component: Qle,
    config: {},
    mapDispatchToProps: (e, { canvas: t, id: n, windowId: r }) => ({
      updateWindow: (...i) => e(Po(...i))
    }),
    mapStateToProps: (e, { id: t, windowId: n }) => {
      const { collectionPath: r, manifestId: i } = Wn(e, { windowId: n }) || {}, o = r[r.length - 1];
      return {
        collectionLabel: Lu(e, { manifestId: o }),
        collectionPath: r,
        id: o,
        manifestId: i,
        windowId: n
      };
    },
    mode: "wrap",
    name: "CollectionFolderInfo",
    target: "CollectionInfo"
  },
  {
    component: Bqe,
    config: {},
    mapDispatchToProps: (e, { canvas: t, id: n, windowId: r }) => ({}),
    mapStateToProps: (e, { id: t, windowId: n }) => ({}),
    mode: "wrap",
    name: "CollectionFolderDialog",
    target: "CollectionDialog"
  }
], lce = ({
  config: e,
  containerId: t,
  suppressDownload: n,
  updateConfig: r
}) => {
  const { t: i } = Ct(), { dialogOpen: o, enabled: s } = e;
  if (!s)
    return null;
  const u = n ? "limitedDownloadOptions" : "showDownloadOptions";
  return /* @__PURE__ */ T.jsx(
    Lx,
    {
      "aria-expanded": o,
      "aria-haspopup": !0,
      "aria-label": i(u),
      onClick: () => r({
        ...e,
        dialogOpen: !o
      }),
      children: /* @__PURE__ */ T.jsx(_c, { color: "error", invisible: !n, variant: "dot", children: /* @__PURE__ */ T.jsx(doe, {}) })
    }
  );
};
lce.propTypes = {
  config: c.shape({
    dialogOpen: c.bool.isRequired,
    enabled: c.bool.isRequired
  }).isRequired,
  containerId: c.string.isRequired,
  suppressDownload: c.bool.isRequired,
  updateConfig: c.func.isRequired
};
function I6e(e) {
  return Vt("MuiCard", e);
}
Wt("MuiCard", ["root"]);
var P6e = {};
const N6e = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, I6e, t);
}, M6e = ye(Ei, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflow: "hidden"
}), I_ = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiCard"
  }), {
    className: i,
    raised: o = !1,
    ...s
  } = r, u = {
    ...r,
    raised: o
  }, f = N6e(u);
  return /* @__PURE__ */ T.jsx(M6e, {
    className: yt(f.root, i),
    elevation: o ? 8 : void 0,
    ref: n,
    ownerState: u,
    ...s
  });
});
P6e.NODE_ENV !== "production" && (I_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: Wa(c.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function j6e(e) {
  return Vt("MuiCardContent", e);
}
Wt("MuiCardContent", ["root"]);
var L6e = {};
const k6e = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"]
  }, j6e, t);
}, z6e = ye("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
}), P_ = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiCardContent"
  }), {
    className: i,
    component: o = "div",
    ...s
  } = r, u = {
    ...r,
    component: o
  }, f = k6e(u);
  return /* @__PURE__ */ T.jsx(z6e, {
    as: o,
    className: yt(f.root, i),
    ownerState: u,
    ref: n,
    ...s
  });
});
L6e.NODE_ENV !== "production" && (P_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const B6e = (e) => /* @__PURE__ */ T.jsx(Ki, { ...e }), V6e = wt(
  XA(),
  At(null, null),
  Tt("DownloadDialogPluginArea")
)(B6e), cce = ({
  height: e,
  linkTarget: t,
  t: n,
  width: r
}) => {
  const i = pa();
  return /* @__PURE__ */ T.jsxs(
    ur,
    {
      fontFamily: i.typography.fontFamily ?? "sans-serif",
      fontSize: "0.75rem",
      children: [
        "JPEG:",
        " ",
        /* @__PURE__ */ T.jsx(ka, { href: t, target: "_blank", children: `${r} x ${e} ${n("pixels")}` })
      ]
    }
  );
};
cce.propTypes = {
  height: c.number.isRequired,
  linkTarget: c.string.isRequired,
  t: c.func.isRequired,
  width: c.number.isRequired
};
const GW = ({ label: e, t }) => /* @__PURE__ */ T.jsx(I_, { className: "mb-3", raised: !0, children: /* @__PURE__ */ T.jsx(P_, { children: /* @__PURE__ */ T.jsx(St, { component: "h5", style: { textTransform: "none" }, variant: "h6", children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", textTransform: "none", children: `${t(
  "suppressedDownloads"
)}: ${e}` }) }) }) });
GW.propTypes = {
  label: c.string.isRequired,
  t: c.func.isRequired
};
const uce = ({
  canvas: e,
  label: t,
  sizes: n = [],
  suppressDownload: r
}) => {
  const { t: i } = Ct();
  return r ? /* @__PURE__ */ T.jsx(GW, { label: t, t: i }) : /* @__PURE__ */ T.jsx(I_, { className: "mb-3", raised: !0, children: /* @__PURE__ */ T.jsxs(P_, { children: [
    /* @__PURE__ */ T.jsx(St, { component: "h5", style: { textTransform: "none" }, variant: "h6", children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", textTransform: "none", children: `${i(
      "image"
    )}: ${t}` }) }),
    /* @__PURE__ */ T.jsx(Xd, { children: n.sort((o, s) => s.width - o.width).map(({ height: o, width: s }) => /* @__PURE__ */ T.jsx(Hd, { dense: !0, children: /* @__PURE__ */ T.jsx(
      cce,
      {
        height: o,
        linkTarget: e.getCanonicalImageUri(s),
        t: i,
        width: s
      }
    ) }, `${o}x${s}`)) })
  ] }) });
};
uce.propTypes = {
  canvas: c.shape({
    getCanonicalImageUri: c.func.isRequired,
    getHeight: c.func.isRequired,
    getWidth: c.func.isRequired
  }).isRequired,
  label: c.oneOfType([c.number, c.string]).isRequired,
  sizes: c.arrayOf(
    c.shape({
      height: c.number.isRequired,
      width: c.number.isRequired
    })
  ),
  suppressDownload: c.bool.isRequired
};
const U6e = (e) => (e || []).filter((t) => YU([t]).length > 0), dce = ({
  canvas: e,
  canvasRenderings: t = [],
  label: n,
  sizes: r = [],
  suppressDownload: i,
  t: o = (s) => s
}) => {
  const s = pa();
  return i ? /* @__PURE__ */ T.jsx(GW, { label: n, t: o }) : e && U6e(e.imageResources).length > 0 ? /* @__PURE__ */ T.jsx(
    uce,
    {
      canvas: e,
      label: n,
      sizes: r,
      suppressDownload: i,
      t: o
    },
    e.id
  ) : !t || t.length < 1 ? null : /* @__PURE__ */ T.jsx(I_, { className: "mb-3", raised: !0, children: /* @__PURE__ */ T.jsxs(P_, { children: [
    /* @__PURE__ */ T.jsx(St, { component: "h5", style: { textTransform: "none" }, variant: "h6", children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", textTransform: "none", children: n }) }),
    /* @__PURE__ */ T.jsx(Xd, { children: t == null ? void 0 : t.filter(({ format: u }) => u !== "text/html").map((u) => /* @__PURE__ */ T.jsx(Hd, { dense: !0, children: /* @__PURE__ */ T.jsx(
      ur,
      {
        fontFamily: s.typography.fontFamily ?? "sans-serif",
        fontSize: "0.75rem",
        children: /* @__PURE__ */ T.jsx(ka, { href: u.value, rel: "noopener", target: "_blank", children: u.label })
      }
    ) }, u.value)) })
  ] }) });
};
dce.propTypes = {
  canvas: c.shape({
    getCanonicalImageUri: c.func.isRequired,
    getHeight: c.func.isRequired,
    getWidth: c.func.isRequired,
    id: c.string.isRequired,
    imageResources: c.array
    // eslint-disable-line react/forbid-prop-types
  }).isRequired,
  canvasRenderings: c.arrayOf(
    c.shape({
      format: c.string.isRequired,
      label: c.string.isRequired,
      value: c.string.isRequired
    })
  ),
  label: c.oneOfType([c.number, c.string]).isRequired,
  sizes: c.arrayOf(
    c.shape({
      height: c.number.isRequired,
      width: c.number.isRequired
    })
  ),
  suppressDownload: c.bool.isRequired,
  t: c.func
};
const fce = ({
  canvasLabel: e,
  canvasRenderings: t = [],
  children: n = void 0,
  config: r,
  containerId: i,
  infoResponse: o,
  manifestRenderings: s = [],
  manifestUrl: u = void 0,
  suppressDownload: f,
  updateConfig: p,
  visibleCanvases: m = [],
  windowId: v
}) => {
  const y = pa(), { t: S } = Ct(), { dialogOpen: E, enabled: w } = r;
  if (!w || !E || !u || !(m && m.length > 0))
    return null;
  const _ = () => p({
    ...r,
    dialogOpen: !1
  });
  return /* @__PURE__ */ T.jsxs(
    D_,
    {
      container: document.querySelector(`#${i} .${Nt("viewer")}`),
      fullWidth: !0,
      maxWidth: "xs",
      onClose: _,
      open: E,
      scroll: "paper",
      children: [
        /* @__PURE__ */ T.jsx(_g, { children: /* @__PURE__ */ T.jsx(St, { variant: "h4", component: "span", children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", children: S("downloadOptions") }) }) }),
        /* @__PURE__ */ T.jsxs(Cg, { dividers: !0, children: [
          m.map((O) => {
            var D;
            return /* @__PURE__ */ T.jsx(
              dce,
              {
                canvas: O,
                canvasRenderings: t,
                label: e(O.id),
                sizes: (D = o(O.id).json) == null ? void 0 : D.sizes,
                suppressDownload: f,
                t: S
              },
              O.id
            );
          }),
          /* @__PURE__ */ T.jsx(V6e, { windowId: v }),
          n,
          /* @__PURE__ */ T.jsx(ur, { sx: { marginTop: "1rem" }, children: /* @__PURE__ */ T.jsx(I_, { raised: !0, children: /* @__PURE__ */ T.jsxs(P_, { children: [
            /* @__PURE__ */ T.jsx(
              St,
              {
                component: "h5",
                style: { textTransform: "none" },
                variant: "h6",
                children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", textTransform: "none", children: S("otherDownloadOptions") })
              }
            ),
            /* @__PURE__ */ T.jsxs(Xd, { children: [
              /* @__PURE__ */ T.jsx(Hd, { dense: !0, children: /* @__PURE__ */ T.jsx(
                ur,
                {
                  fontFamily: y.typography.fontFamily ?? "sans-serif",
                  fontSize: "0.75rem",
                  children: /* @__PURE__ */ T.jsx(ka, { href: u, rel: "noopener", target: "_blank", children: S("iiifManifest") })
                }
              ) }),
              s == null ? void 0 : s.filter(({ format: O }) => O !== "text/html").map(({ label: O, value: D }) => /* @__PURE__ */ T.jsx(Hd, { dense: !0, children: /* @__PURE__ */ T.jsx(
                ur,
                {
                  fontFamily: y.typography.fontFamily ?? "sans-serif",
                  fontSize: "0.75rem",
                  children: /* @__PURE__ */ T.jsx(ka, { href: D, rel: "noopener", target: "_blank", children: O })
                }
              ) }, D))
            ] })
          ] }) }) })
        ] }),
        /* @__PURE__ */ T.jsx($x, { children: /* @__PURE__ */ T.jsx(hi, { color: "primary", onClick: _, children: S("close") }) })
      ]
    }
  );
};
fce.propTypes = {
  canvasLabel: c.func.isRequired,
  canvasRenderings: c.arrayOf(
    c.shape({
      format: c.string,
      label: c.string,
      value: c.string
    })
  ),
  children: c.element,
  config: c.shape({
    dialogOpen: c.bool.isRequired,
    enabled: c.bool.isRequired
  }).isRequired,
  containerId: c.string.isRequired,
  infoResponse: c.func.isRequired,
  manifestRenderings: c.arrayOf(
    c.shape({
      format: c.string,
      label: c.string,
      value: c.string
    })
  ),
  manifestUrl: c.string,
  suppressDownload: c.bool.isRequired,
  updateConfig: c.func.isRequired,
  visibleCanvases: c.arrayOf(
    c.shape({ id: c.string, index: c.number })
  ),
  windowId: c.string.isRequired
};
const qZ = {
  de: {
    close: "Schließen",
    downloadOptions: "Download-Optionen",
    iiifManifest: "IIIF-Manifest",
    image: "Einzelbild",
    limitedDownloadOptions: "Begrenzte Download-Optionen",
    otherDownloadOptions: "Andere Download-Optionen",
    pixels: "Pixel",
    showDownloadOptions: "Download-Optionen anzeigen",
    suppressedDownloads: "Download nicht erlaubt"
  },
  en: {
    close: "Close",
    downloadOptions: "Download options",
    iiifManifest: "IIIF manifest",
    image: "Single image",
    limitedDownloadOptions: "Limited download options",
    otherDownloadOptions: "Other download options",
    pixels: "pixels",
    showDownloadOptions: "Show download options",
    suppressedDownloads: "Download not allowed"
  },
  fr: {
    close: "Fermer",
    downloadOptions: "Options de téléchargement",
    iiifManifest: "Manifeste IIIF",
    image: "Image",
    limitedDownloadOptions: "Options de téléchargement limitées",
    otherDownloadOptions: "Autres liens de téléchargement",
    pixels: "pixels",
    showDownloadOptions: "Afficher les options de téléchargement",
    suppressedDownloads: "Téléchargement non autorisé"
  }
}, F6e = {
  // Open the download dialog
  dialogOpen: !1,
  // Enable the plugin
  enabled: !0
}, $Z = Qe(
  [fa],
  ({ downloadDialog: e = {} }) => ({
    ...F6e,
    ...e
  })
), GZ = Qe(
  [Vl],
  (e) => ((e == null ? void 0 : e.getProperty("behavior")) || []).includes("no-download")
), W6e = [
  {
    component: lce,
    config: {
      translations: qZ
    },
    mapDispatchToProps: (e, { windowId: t }) => ({
      updateConfig: (n) => e(Po(t, { downloadDialog: n }))
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      config: $Z(e, { windowId: t }),
      containerId: Du(e),
      suppressDownload: GZ(e, { windowId: t })
    }),
    mode: "add",
    name: "DownloadButton",
    target: "WindowTopBarPluginArea"
  },
  {
    component: fce,
    config: {
      translations: qZ
    },
    mapDispatchToProps: (e, { windowId: t }) => ({
      updateConfig: (n) => e(Po(t, { downloadDialog: n }))
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      canvasLabel: (n) => yg(e, { canvasId: n, windowId: t }),
      canvasRenderings: Tqe(e, { windowId: t }),
      config: $Z(e, { windowId: t }),
      containerId: Du(e),
      infoResponse: (n) => v3(e, { canvasId: n, windowId: t }) ?? {},
      manifestRenderings: $le(e, { windowId: t }),
      manifestUrl: B1(e, { windowId: t }),
      suppressDownload: GZ(e, { windowId: t }),
      visibleCanvases: Ul(e, { windowId: t })
    }),
    mode: "add",
    name: "DownloadDialog",
    target: "Window"
  }
], YW = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "MenuSharp");
function H6e(e) {
  return Vt("MuiAppBar", e);
}
Wt("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
var q6e = {};
const $6e = (e) => {
  const {
    color: t,
    position: n,
    classes: r
  } = e, i = {
    root: ["root", `color${Ke(t)}`, `position${Ke(n)}`]
  };
  return Ft(i, H6e, r);
}, YZ = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, G6e = ye(Ei, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`position${Ke(n.position)}`], t[`color${Ke(n.color)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  boxSizing: "border-box",
  // Prevent padding issue with the Modal and fixed positioned AppBar.
  flexShrink: 0,
  variants: [{
    props: {
      position: "fixed"
    },
    style: {
      position: "fixed",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0,
      "@media print": {
        // Prevent the app bar to be visible on each printed page.
        position: "absolute"
      }
    }
  }, {
    props: {
      position: "absolute"
    },
    style: {
      position: "absolute",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "sticky"
    },
    style: {
      position: "sticky",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "static"
    },
    style: {
      position: "static"
    }
  }, {
    props: {
      position: "relative"
    },
    style: {
      position: "relative"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      "--AppBar-color": "inherit"
    }
  }, {
    props: {
      color: "default"
    },
    style: {
      "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[100],
      "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[100]),
      ...e.applyStyles("dark", {
        "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[900],
        "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[900])
      })
    }
  }, ...Object.entries(e.palette).filter(Jr(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--AppBar-background": (e.vars ?? e).palette[t].main,
      "--AppBar-color": (e.vars ?? e).palette[t].contrastText
    }
  })), {
    props: (t) => t.enableColorOnDark === !0 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)"
    }
  }, {
    props: (t) => t.enableColorOnDark === !1 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundColor: e.vars ? YZ(e.vars.palette.AppBar.darkBg, "var(--AppBar-background)") : null,
        color: e.vars ? YZ(e.vars.palette.AppBar.darkColor, "var(--AppBar-color)") : null
      })
    }
  }, {
    props: {
      color: "transparent"
    },
    style: {
      "--AppBar-background": "transparent",
      "--AppBar-color": "inherit",
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundImage: "none"
      })
    }
  }]
}))), Yx = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiAppBar"
  }), {
    className: i,
    color: o = "primary",
    enableColorOnDark: s = !1,
    position: u = "fixed",
    ...f
  } = r, p = {
    ...r,
    color: o,
    position: u,
    enableColorOnDark: s
  }, m = $6e(p);
  return /* @__PURE__ */ T.jsx(G6e, {
    square: !0,
    component: "header",
    ownerState: p,
    elevation: 4,
    className: yt(m.root, i, u === "fixed" && "mui-fixed"),
    ref: n,
    ...f
  });
});
q6e.NODE_ENV !== "production" && (Yx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"]), c.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: c.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/position).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: c.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const Y6e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
}), "AccountTree"), pce = ({ className: e = null, color: t = null, windowId: n }) => {
  const r = Ba((m) => Wle(m, { windowId: n })), o = Ba((m) => Va(m, { windowId: n }), (m, v) => !m && !v ? !0 : !(!m || !v || (m == null ? void 0 : m.id) !== (v == null ? void 0 : v.id) || (m == null ? void 0 : m.isFetching) !== (v == null ? void 0 : v.isFetching))), s = Uge(), u = o ? nn.parseManifest(o.json, void 0) : !1;
  if (!u || u.isCollection()) return !1;
  const f = !(r != null && r.at(0)), p = () => {
    if (!u || f) return;
    const m = { collectionPath: r.slice(0, -1), manifestId: r.at(-1) };
    s(Po(n, m));
  };
  return /* @__PURE__ */ T.jsx(
    Jn,
    {
      "aria-label": "View Collection",
      className: e || Nt("window-menu-btn"),
      color: t,
      disabled: f,
      onClick: p,
      children: /* @__PURE__ */ T.jsx(Y6e, {})
    }
  );
};
pce.propTypes = {
  className: c.string,
  color: c.string,
  windowId: c.string.isRequired
};
const XZ = ye(hce)(({ theme: e }) => ({
  ...e.typography.h6,
  flexGrow: 1,
  fontWeight: "bold",
  paddingLeft: e.spacing(0.5)
})), ZZ = ye("div")(({ theme: e }) => ({
  ...e.typography.h6,
  flexGrow: 1,
  paddingLeft: e.spacing(0.5)
}));
function hce({ children: e, ...t }) {
  return /* @__PURE__ */ T.jsx(St, { variant: "h2", noWrap: !0, color: "inherit", ...t, children: e });
}
hce.propTypes = {
  children: c.node.isRequired
};
const gce = ({ windowId: e }) => {
  const t = Ba((s) => ax(s, { windowId: e }).error, Nd), n = Ba((s) => fa(s, { windowId: e }).hideWindowTitle, Nd), r = Ba((s) => ax(s, { windowId: e }).isFetching, Nd), i = Ba((s) => Lu(s, { windowId: e }), Nd);
  let o = null;
  return r ? o = /* @__PURE__ */ T.jsx(ZZ, {}) : t ? o = /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx($W, { color: "error" }),
    /* @__PURE__ */ T.jsx(XZ, { color: "textSecondary", children: t })
  ] }) : n ? o = /* @__PURE__ */ T.jsx(ZZ, {}) : o = /* @__PURE__ */ T.jsx(XZ, { children: i || "" }), o;
};
gce.propTypes = {
  windowId: c.string
};
function X6e(e) {
  return Vt("MuiFormControlLabel", e);
}
const ME = Wt("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]);
var Z6e = {};
const K6e = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: r,
    error: i,
    required: o
  } = e, s = {
    root: ["root", n && "disabled", `labelPlacement${Ke(r)}`, i && "error", o && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", i && "error"]
  };
  return Ft(s, X6e, t);
}, Q6e = ye("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${ME.label}`]: t.label
    }, t.root, t[`labelPlacement${Ke(n.labelPlacement)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${ME.disabled}`]: {
    cursor: "default"
  },
  [`& .${ME.label}`]: {
    [`&.${ME.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), J6e = ye("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(Lt(({
  theme: e
}) => ({
  [`&.${ME.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), ZE = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: i,
    className: o,
    componentsProps: s = {},
    control: u,
    disabled: f,
    disableTypography: p,
    inputRef: m,
    label: v,
    labelPlacement: y = "end",
    name: S,
    onChange: E,
    required: w,
    slots: _ = {},
    slotProps: O = {},
    value: D,
    ...P
  } = r, M = pp(), N = f ?? u.props.disabled ?? (M == null ? void 0 : M.disabled), k = w ?? u.props.required, U = {
    disabled: N,
    required: k
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((re) => {
    typeof u.props[re] > "u" && typeof r[re] < "u" && (U[re] = r[re]);
  });
  const H = oy({
    props: r,
    muiFormControl: M,
    states: ["error"]
  }), Y = {
    ...r,
    disabled: N,
    labelPlacement: y,
    required: k,
    error: H.error
  }, z = K6e(Y), V = {
    slots: _,
    slotProps: {
      ...s,
      ...O
    }
  }, [F, X] = Xt("typography", {
    elementType: St,
    externalForwardedProps: V,
    ownerState: Y
  });
  let oe = v;
  return oe != null && oe.type !== St && !p && (oe = /* @__PURE__ */ T.jsx(F, {
    component: "span",
    ...X,
    className: yt(z.label, X == null ? void 0 : X.className),
    children: oe
  })), /* @__PURE__ */ T.jsxs(Q6e, {
    className: yt(z.root, o),
    ownerState: Y,
    ref: n,
    ...P,
    children: [/* @__PURE__ */ $.cloneElement(u, U), k ? /* @__PURE__ */ T.jsxs("div", {
      children: [oe, /* @__PURE__ */ T.jsxs(J6e, {
        ownerState: Y,
        "aria-hidden": !0,
        className: z.asterisk,
        children: [" ", "*"]
      })]
    }) : oe]
  });
});
Z6e.NODE_ENV !== "production" && (ZE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: c.shape({
    typography: c.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: c.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: c.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $s,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: c.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: c.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: c.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: c.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: c.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    typography: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    typography: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The value of the component.
   */
  value: c.any
});
const e$e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M21 3H3v18h18zm-2 16H5V5h14z"
}), "CropDinSharp");
function t$e(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ T.jsx("path", { d: "M3,3H21V5H3Z", transform: "translate(0 16)" }),
    /* @__PURE__ */ T.jsx("path", { d: "M21,5H3V19H21ZM19,17H5V7H19Z", transform: "translate(0 -2)" })
  ] }) });
}
function n$e(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ T.jsx("path", { d: "M0,0H24V24H0Z", transform: "translate(24) rotate(90)", fill: "none" }),
    /* @__PURE__ */ T.jsx("path", { d: "M3,3H21V5H3Z", transform: "translate(24) rotate(90)" }),
    /* @__PURE__ */ T.jsx("path", { d: "M19,3H5V21H19ZM17,19H7V5H17Z", transform: "translate(-2)" })
  ] }) });
}
const QB = ye(qo, { name: "WindowThumbnailSettings", slot: "option" })(({ selected: e, theme: t }) => ({
  "& .MuiFormControlLabel-label": {
    borderBottom: "2px solid transparent",
    ...e && {
      borderBottomColor: t.palette.secondary.main
    },
    "&.Mui-selected": {
      backgroundColor: "transparent !important"
    },
    "&.Mui-selected.Mui-focusVisible": {
      backgroundColor: `${(t.vars || t).palette.action.focus} !important`
    },
    "&:focused": {
      backgroundColor: `${(t.vars || t).palette.action.focus} !important`
    },
    color: e ? t.palette.secondary.main : void 0,
    display: "inline-flex"
  }
})), r$e = ye(ty, { name: "WindowViewSettings", slot: "option" })(() => ({
  display: "inline-flex"
}));
function mce({
  handleClose: e = () => {
  },
  thumbnailNavigationPosition: t,
  direction: n,
  windowId: r,
  setWindowThumbnailPosition: i
}) {
  const { t: o } = Ct(), s = (u) => {
    i(r, u), e();
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(ug, { role: "presentation", disableSticky: !0, children: o("thumbnails") }),
    /* @__PURE__ */ T.jsxs(r$e, { role: "menubar", children: [
      /* @__PURE__ */ T.jsx(
        QB,
        {
          "aria-checked": t === "off",
          onClick: () => {
            s("off");
          },
          role: "menuitemradio",
          selected: t === "off",
          children: /* @__PURE__ */ T.jsx(
            ZE,
            {
              control: /* @__PURE__ */ T.jsx(e$e, { color: t === "off" ? "secondary" : void 0, fill: "currentcolor" }),
              label: o("off"),
              labelPlacement: "bottom",
              value: "off"
            }
          )
        },
        "off"
      ),
      /* @__PURE__ */ T.jsx(
        QB,
        {
          "aria-checked": t === "far-bottom",
          onClick: () => {
            s("far-bottom");
          },
          role: "menuitemradio",
          selected: t === "far-bottom",
          children: /* @__PURE__ */ T.jsx(
            ZE,
            {
              control: /* @__PURE__ */ T.jsx(t$e, { color: t === "far-bottom" ? "secondary" : void 0, fill: "currentcolor" }),
              label: o("bottom"),
              labelPlacement: "bottom",
              value: "far-bottom"
            }
          )
        },
        "far-bottom"
      ),
      /* @__PURE__ */ T.jsx(
        QB,
        {
          "aria-checked": t === "far-right",
          onClick: () => {
            s("far-right");
          },
          role: "menuitemradio",
          selected: t === "far-right",
          children: /* @__PURE__ */ T.jsx(
            ZE,
            {
              control: /* @__PURE__ */ T.jsx(
                n$e,
                {
                  color: t === "far-right" ? "secondary" : void 0,
                  fill: "currentcolor",
                  style: n === "rtl" ? { transform: "rotate(180deg)" } : {}
                }
              ),
              label: o("right"),
              labelPlacement: "bottom",
              value: "far-right"
            }
          )
        },
        "far-right"
      )
    ] })
  ] });
}
mce.propTypes = {
  direction: c.string.isRequired,
  handleClose: c.func,
  setWindowThumbnailPosition: c.func.isRequired,
  thumbnailNavigationPosition: c.string.isRequired,
  windowId: c.string.isRequired
};
const i$e = { setWindowThumbnailPosition: Wte }, o$e = (e, { windowId: t }) => ({
  direction: Ax(e),
  thumbnailNavigationPosition: QU(e, { windowId: t })
}), a$e = wt(
  At(o$e, i$e, null, { forwardRef: !0 }),
  Tt("WindowThumbnailSettings")
  // further HOC go here
), s$e = a$e(mce), l$e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M21 3H3v18h18zm-2 16H5V5h14zm-5.04-6.71-2.75 3.54-1.96-2.36L6.5 17h11z"
}), "CropOriginalSharp"), c$e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), "ViewColumn");
function u$e(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ T.jsx("path", { d: "M1,4V21H22.853V4.1ZM3,19V6h8V19Zm18,0H13V6h8ZM14,9.5h6V11H14ZM14,12h6v1.5H14Zm0,2.5h6V16H14Z" }) }) });
}
function d$e(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ T.jsx("path", { d: "M19.974,2H2V19.974H19.974V2ZM7.392,18.177H3.8V14.582H7.392Zm0-5.392H3.8V9.19H7.392Zm0-5.392H3.8V3.8H7.392Zm5.392,10.785H9.19V14.582h3.595Zm0-5.392H9.19V9.19h3.595Zm0-5.392H9.19V3.8h3.595Zm5.392,10.785H14.582V14.582h3.595Zm0-5.392H14.582V9.19h3.595Zm0-5.392H14.582V3.8h3.595Z", transform: "translate(1 1)" }) }) });
}
const f$e = ye(qo, { name: "WindowViewSettings", slot: "option" })(({ selected: e, theme: t }) => ({
  "& .MuiFormControlLabel-label": {
    borderBottom: "2px solid transparent",
    ...e && {
      borderBottomColor: t.palette.secondary.main
    },
    "&.Mui-selected": {
      backgroundColor: "transparent !important"
    },
    "&.Mui-selected.Mui-focusVisible": {
      backgroundColor: `${(t.vars || t).palette.action.focus} !important`
    },
    "&:focused": {
      backgroundColor: `${(t.vars || t).palette.action.focus} !important`
    },
    color: e ? t.palette.secondary.main : void 0,
    display: "inline-block"
  }
})), p$e = ye(ty, { name: "WindowViewSettings", slot: "option" })(() => ({
  display: "inline-flex"
}));
function vce({
  handleClose: e = () => {
  },
  windowViewType: t,
  viewTypes: n = [],
  setWindowViewType: r,
  windowId: i
}) {
  const { t: o } = Ct(), s = (p) => {
    r(i, p);
  }, u = {
    book: u$e,
    gallery: d$e,
    scroll: c$e,
    single: l$e
  }, f = ({ value: p, Icon: m }) => /* @__PURE__ */ T.jsx(
    f$e,
    {
      "aria-checked": t === p,
      autoFocus: t === p,
      onClick: () => {
        s(p), e();
      },
      role: "menuitemradio",
      selected: t === p,
      children: /* @__PURE__ */ T.jsx(
        ZE,
        {
          value: p,
          control: /* @__PURE__ */ T.jsx(m, { fill: "currentcolor", color: t === p ? "secondary" : void 0 }),
          label: o(p),
          labelPlacement: "bottom"
        }
      )
    },
    p
  );
  return n.length === 0 ? null : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(ug, { role: "presentation", disableSticky: !0, children: o("view") }),
    /* @__PURE__ */ T.jsx(p$e, { role: "menubar", children: n.map((p) => f({ Icon: u[p], value: p })) })
  ] });
}
vce.propTypes = {
  handleClose: c.func,
  setWindowViewType: c.func.isRequired,
  viewTypes: c.arrayOf(c.string),
  windowId: c.string.isRequired,
  windowViewType: c.string.isRequired
};
const h$e = { setWindowViewType: M3 }, g$e = (e, { windowId: t }) => ({
  viewTypes: ite(e, { windowId: t }),
  windowViewType: Nv(e, { windowId: t })
}), m$e = wt(
  At(g$e, h$e, null, { forwardRef: !0 }),
  Tt("WindowViewSettings")
), v$e = m$e(vce);
function yce({ targetName: e, ...t }) {
  const n = lI(e), { t: r } = Ct();
  return (n == null ? void 0 : n.length) > 0 ? /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(ug, { role: "presentation", disableSticky: !0, tabIndex: -1, children: r("windowPluginButtons") }),
    /* @__PURE__ */ T.jsx(Ki, { targetName: e, ...t })
  ] }) : null;
}
yce.propTypes = {
  targetName: c.string.isRequired
};
function bce({
  handleClose: e,
  showThumbnailNavigationSettings: t = !0,
  toggleDraggingEnabled: n,
  windowId: r,
  anchorEl: i = null,
  open: o = !1
}) {
  const s = Qi(Eg), u = arguments[0];
  return /* @__PURE__ */ T.jsxs(
    EF,
    {
      container: s == null ? void 0 : s.current,
      anchorOrigin: {
        horizontal: "right",
        vertical: "bottom"
      },
      transformOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      onClose: e,
      TransitionProps: {
        onEntering: n,
        onExit: n
      },
      orientation: "horizontal",
      anchorEl: i,
      open: o,
      role: "menu",
      children: [
        /* @__PURE__ */ T.jsx(v$e, { windowId: r, handleClose: e }),
        t && /* @__PURE__ */ T.jsx(s$e, { windowId: r, handleClose: e }),
        /* @__PURE__ */ T.jsx(yce, { targetName: "WindowTopMenu", ...u })
      ]
    }
  );
}
bce.propTypes = {
  anchorEl: c.object,
  // eslint-disable-line react/forbid-prop-types
  handleClose: c.func.isRequired,
  open: c.bool,
  showThumbnailNavigationSettings: c.bool,
  toggleDraggingEnabled: c.func.isRequired,
  windowId: c.string.isRequired
};
const y$e = (e) => ({
  showThumbnailNavigationSettings: Dn(e).thumbnailNavigation.displaySettings
}), b$e = (e) => ({
  toggleDraggingEnabled: () => e(nne())
}), x$e = wt(
  At(y$e, b$e),
  Tt("WindowTopMenu")
), S$e = x$e(bce);
function w$e(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ T.jsx("path", { d: "M0,0H24V24H0Z", fill: "none" }),
    /* @__PURE__ */ T.jsx("path", { d: "M24.852,17.981,3,18V15.945l21.852-.019Z", transform: "translate(-2 5)" }),
    /* @__PURE__ */ T.jsx("path", { d: "M1,4V21H22.853V4.1ZM3,19V6h8V19Zm18,0H13V6h8Z", transform: "translate(0 -2)" })
  ] }) });
}
function xce({ classes: e = {}, windowId: t }) {
  const { t: n } = Ct(), [r, i] = Bn(null), [o, s] = Bn(!1), u = uo(), f = (m) => {
    i(m.currentTarget), s(!0);
  }, p = () => {
    i(null), s(!1);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-haspopup": "true",
        "aria-label": n("windowMenu"),
        "aria-owns": o ? u : void 0,
        className: o ? e.ctrlBtnSelected : void 0,
        selected: o,
        onClick: f,
        children: /* @__PURE__ */ T.jsx(w$e, {})
      }
    ),
    /* @__PURE__ */ T.jsx(
      S$e,
      {
        windowId: t,
        anchorEl: r,
        handleClose: p,
        id: u,
        open: o
      }
    )
  ] });
}
xce.propTypes = {
  classes: c.objectOf(c.string),
  windowId: c.string.isRequired
};
const T$e = wt(
  Tt("WindowTopMenuButton")
), Sce = T$e(xce);
function E$e(e) {
  return /* @__PURE__ */ T.jsx(Ki, { targetName: "WindowTopBarPluginArea", ...e });
}
const _$e = wt(
  At(null, null),
  Tt("WindowTopBarPluginArea")
), wce = _$e(E$e), C$e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVertSharp");
function Tce({
  windowId: e,
  menuIcon: t = /* @__PURE__ */ T.jsx(C$e, {})
}) {
  const { t: n } = Ct(), r = Qi(Eg), i = arguments[0], [o, s] = Bn(null), [u, f] = Bn(!1), p = uo(), { PluginComponents: m } = lI("WindowTopBarPluginMenu"), v = (S) => {
    s(S.currentTarget), f(!0);
  }, y = () => {
    s(null), f(!1);
  };
  return !m || m.length === 0 ? null : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-haspopup": "true",
        "aria-label": n("windowPluginMenu"),
        "aria-owns": u ? p : void 0,
        selected: u,
        onClick: v,
        children: t
      }
    ),
    /* @__PURE__ */ T.jsx(
      Bx,
      {
        id: p,
        container: r == null ? void 0 : r.current,
        anchorEl: o,
        anchorOrigin: {
          horizontal: "right",
          vertical: "bottom"
        },
        transformOrigin: {
          horizontal: "right",
          vertical: "top"
        },
        open: u,
        onClose: y,
        children: /* @__PURE__ */ T.jsx(Ki, { targetName: "WindowTopBarPluginMenu", handleClose: y, ...i })
      }
    )
  ] });
}
Tce.propTypes = {
  anchorEl: c.object,
  // eslint-disable-line react/forbid-prop-types
  container: c.shape({ current: c.instanceOf(Element) }),
  menuIcon: c.element,
  open: c.bool,
  windowId: c.string.isRequired
};
const R$e = wt(
  Tt("WindowTopBarPluginMenu")
), Ece = R$e(Tce), O$e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "FullscreenSharp"), A$e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), "FullscreenExitSharp");
function _ce({ className: e = void 0 }) {
  const { t } = Ct(), n = Qi(pse);
  return n && n.active ? /* @__PURE__ */ T.jsx(Jn, { className: e, "aria-label": t("exitFullScreen"), onClick: n.exit, children: /* @__PURE__ */ T.jsx(A$e, {}) }) : n ? /* @__PURE__ */ T.jsx(Jn, { className: e, "aria-label": t("workspaceFullScreen"), onClick: n.enter, children: /* @__PURE__ */ T.jsx(O$e, {}) }) : null;
}
_ce.propTypes = {
  className: c.string
};
const D$e = (e) => ({}), I$e = {}, P$e = wt(
  At(D$e, I$e),
  Tt("FullScreenButton")
), XW = P$e(_ce);
function Cce(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ T.jsx("path", { d: "M7,14H5v5h5V17H7Zm7-9V7h3v3h2V5Z" }),
    /* @__PURE__ */ T.jsx("path", { d: "M22.517,1.524H1.736V22.37H22.517Zm-2,18.845H3.736V3.524H20.517Z" })
  ] }) });
}
function Rce(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ T.jsx("path", { d: "M5,16H8v3h2V14H5ZM16,8V5H14v5h5V8Z" }),
    /* @__PURE__ */ T.jsx("path", { d: "M22.517,1.524H1.736V22.37H22.517Zm-2,18.845H3.736V3.524H20.517Z" })
  ] }) });
}
const N$e = ye(Yx, { name: "WindowTopBar", slot: "root" })(() => ({
  zIndex: 1100
})), M$e = ye(ny, { name: "WindowTopBar", slot: "toolbar" })(({ ownerState: e, theme: t }) => {
  var n;
  return {
    backgroundColor: (n = t.palette.shades) == null ? void 0 : n.main,
    borderTop: "2px solid",
    borderTopColor: e != null && e.focused ? t.palette.primary.main : "transparent",
    minHeight: 32,
    paddingLeft: t.spacing(0.5),
    paddingRight: t.spacing(0.5),
    ...(e == null ? void 0 : e.windowDraggable) && {
      cursor: "move"
    }
  };
}), JB = () => {
};
function Oce({
  allowClose: e = !0,
  allowFullscreen: t = !0,
  allowMaximize: n = !0,
  allowTopCollectionButton: r = !1,
  allowTopMenuButton: i = !0,
  allowWindowSideBar: o = !0,
  component: s = "nav",
  focused: u = !1,
  focusWindow: f = JB,
  hasOpenSideBar: p = !1,
  hintSideBar: m = !1,
  maximized: v = !1,
  maximizeWindow: y = JB,
  minimizeWindow: S = JB,
  removeWindow: E,
  toggleWindowSideBar: w,
  windowDraggable: _ = !0,
  windowId: O
}) {
  const { t: D } = Ct(), P = arguments[0], M = {
    color: m ? "primary" : "",
    invisible: p || !m,
    variant: "dot"
  }, N = m ? "secondary" : "";
  return /* @__PURE__ */ T.jsx(N$e, { component: s, "aria-label": D("windowNavigation"), position: "relative", color: "default", enableColorOnDark: !0, children: /* @__PURE__ */ T.jsxs(
    M$e,
    {
      disableGutters: !0,
      onMouseDown: f,
      ownerState: P,
      className: On(Nt("window-top-bar")),
      variant: "dense",
      children: [
        o && /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": D("toggleWindowSideBar"),
            onClick: w,
            className: Nt("window-menu-btn"),
            badge: m,
            BadgeProps: M,
            color: N,
            children: /* @__PURE__ */ T.jsx(YW, {})
          }
        ),
        /* @__PURE__ */ T.jsx(
          gce,
          {
            windowId: O
          }
        ),
        i && /* @__PURE__ */ T.jsx(Sce, { windowId: O, className: Nt("window-menu-btn") }),
        /* @__PURE__ */ T.jsx(wce, { windowId: O }),
        /* @__PURE__ */ T.jsx(Ece, { windowId: O }),
        r && /* @__PURE__ */ T.jsx(pce, { className: Nt("window-menu-btn"), color: N, windowId: O }),
        n && /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": D(v ? "minimizeWindow" : "maximizeWindow"),
            className: On(Nt("window-maximize"), Nt("window-menu-btn")),
            onClick: v ? S : y,
            children: v ? /* @__PURE__ */ T.jsx(Rce, {}) : /* @__PURE__ */ T.jsx(Cce, {})
          }
        ),
        t && /* @__PURE__ */ T.jsx(XW, { className: Nt("window-menu-btn") }),
        e && /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": D("closeWindow"),
            className: On(Nt("window-close"), Nt("window-menu-btn")),
            onClick: E,
            children: /* @__PURE__ */ T.jsx(m_, {})
          }
        )
      ]
    }
  ) });
}
Oce.propTypes = {
  allowClose: c.bool,
  allowFullscreen: c.bool,
  allowMaximize: c.bool,
  allowTopCollectionButton: c.bool,
  allowTopMenuButton: c.bool,
  allowWindowSideBar: c.bool,
  component: c.elementType,
  focused: c.bool,
  // eslint-disable-line react/no-unused-prop-types
  focusWindow: c.func,
  hasOpenSideBar: c.bool,
  hintSideBar: c.bool,
  maximized: c.bool,
  maximizeWindow: c.func,
  minimizeWindow: c.func,
  removeWindow: c.func.isRequired,
  toggleWindowSideBar: c.func.isRequired,
  windowDraggable: c.bool,
  // eslint-disable-line react/no-unused-prop-types
  windowId: c.string.isRequired
};
const Ace = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), "InfoSharp"), ZW = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M21.99 2H2v16h16l4 4zM18 14H6v-2h12zm0-3H6V9h12zm0-3H6V6h12z"
}), "CommentSharp"), Dce = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "CopyrightSharp"), Ice = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z"
}), "LayersSharp");
function Pce(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ T.jsx("path", { d: "M6.924,21H21V19H6.924ZM3,17H21V15H3Zm3.924-4H21V11H6.924Zm0-4H21V7H6.924ZM3,3V5H21V3Z" }) }) });
}
const j$e = ye(ex, { name: "WindowSideBarButtons", slot: "button" })(({ theme: e }) => ({
  "&.Mui-selected": {
    ".MuiBadge-badge": {
      display: "none"
    },
    borderRight: "2px solid",
    borderRightColor: e.palette.primary.main
  },
  "&.MuiTab-root": {
    "&:active": {
      backgroundColor: e.palette.action.active
    },
    "&:focus": {
      "@media (hover: none)": {
        backgroundColor: "transparent"
      },
      backgroundColor: e.palette.action.hover,
      textDecoration: "none"
      // Reset on touch devices, it doesn't add specificity
    },
    "&:hover": {
      "@media (hover: none)": {
        backgroundColor: "transparent"
      },
      backgroundColor: e.palette.action.hover,
      textDecoration: "none"
      // Reset on touch devices, it doesn't add specificity
    },
    borderRight: "2px solid transparent",
    minWidth: "auto"
  },
  fill: "currentcolor"
}));
function $h({ t: e, value: t, ...n }) {
  return /* @__PURE__ */ T.jsx(Bd, { title: e("openCompanionWindow", { context: t }), children: /* @__PURE__ */ T.jsx(
    j$e,
    {
      ...n,
      value: t,
      "aria-label": e("openCompanionWindow", { context: t }),
      disableRipple: !0
    }
  ) });
}
$h.propTypes = {
  t: c.func.isRequired,
  value: c.string.isRequired
};
const L$e = ye(yI, { name: "WindowSideBarButtons", slot: "root" })({
  "& .MuiTabs-flexContainer": {
    flexDirection: "column"
  },
  "&.MuiTabs-indicator": {
    display: "none"
  }
}), Nce = ({
  addCompanionWindow: e,
  canvasContentTypes: t = [],
  canvasSeeAlso: n = [],
  hasAnnotations: r = !1,
  hasAnyAnnotations: i = !1,
  hasAnyLayers: o = !1,
  hasCurrentLayers: s = !1,
  hasSearchResults: u = !1,
  hasSearchService: f = !1,
  panels: p = [],
  PluginComponents: m = null,
  sideBarPanel: v = "closed",
  windowId: y
}) => {
  const { t: S } = Ct(), E = (O, D) => e(D), w = ((t == null ? void 0 : t.length) || 0) > 1, _ = ((n == null ? void 0 : n.length) || 0) > 0;
  return /* @__PURE__ */ T.jsxs(
    L$e,
    {
      value: v === "closed" ? !1 : v,
      onChange: E,
      variant: "fullWidth",
      indicatorColor: "primary",
      textColor: "primary",
      orientation: "vertical",
      "aria-orientation": "vertical",
      "aria-label": S("sidebarPanelsNavigation"),
      children: [
        p.info && /* @__PURE__ */ T.jsx(
          $h,
          {
            color: _ ? "info" : "",
            value: "info",
            onKeyUp: E,
            t: S,
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "info", invisible: !_, variant: "dot", children: /* @__PURE__ */ T.jsx(Ace, {}) })
          }
        ),
        p.attribution && /* @__PURE__ */ T.jsx(
          $h,
          {
            value: "attribution",
            onKeyUp: E,
            t: S,
            icon: /* @__PURE__ */ T.jsx(Dce, {})
          }
        ),
        p.canvas && /* @__PURE__ */ T.jsx(
          $h,
          {
            color: w ? "info" : "",
            value: "canvas",
            onKeyUp: E,
            t: S,
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "info", invisible: !w, variant: "dot", children: /* @__PURE__ */ T.jsx(Pce, {}) })
          }
        ),
        p.annotations && (r || i) && /* @__PURE__ */ T.jsx(
          $h,
          {
            value: "annotations",
            onKeyUp: E,
            t: S,
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "notification", invisible: !r, variant: "dot", children: /* @__PURE__ */ T.jsx(ZW, {}) })
          }
        ),
        p.search && f && /* @__PURE__ */ T.jsx(
          $h,
          {
            value: "search",
            onKeyUp: E,
            t: S,
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "notification", invisible: !u, variant: "dot", children: /* @__PURE__ */ T.jsx(CI, {}) })
          }
        ),
        p.layers && o && /* @__PURE__ */ T.jsx(
          $h,
          {
            value: "layers",
            onKeyUp: E,
            t: S,
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "notification", invisible: !s, variant: "dot", children: /* @__PURE__ */ T.jsx(Ice, {}) })
          }
        ),
        m && m.map((O) => /* @__PURE__ */ T.jsx(
          $h,
          {
            onKeyUp: E,
            t: S,
            value: O.value,
            icon: /* @__PURE__ */ T.jsx(O, { windowId: y })
          },
          O.value
        ))
      ]
    }
  );
};
Nce.propTypes = {
  addCompanionWindow: c.func.isRequired,
  canvasContentTypes: c.arrayOf(c.string),
  canvasSeeAlso: c.array,
  // eslint-disable-line react/forbid-prop-types
  hasAnnotations: c.bool,
  hasAnyAnnotations: c.bool,
  hasAnyLayers: c.bool,
  hasCurrentLayers: c.bool,
  hasSearchResults: c.bool,
  hasSearchService: c.bool,
  panels: c.shape({
    annotations: c.bool,
    attribution: c.bool,
    canvas: c.bool,
    info: c.bool,
    layers: c.bool,
    search: c.bool
  }),
  PluginComponents: c.array,
  // eslint-disable-line react/forbid-prop-types
  sideBarPanel: c.string,
  windowId: c.string.isRequired
};
const k$e = Qe(
  [Wn],
  (e) => e == null ? void 0 : e.sideBarOpen
), z$e = Qe(
  [BV, Fle],
  (e, t) => ((e == null ? void 0 : e.length) || 0) > 1 || ((t == null ? void 0 : t.length) || 0) > 0
), B$e = [
  {
    component: Oce,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      /** */
      updateConfig(n) {
        return e(Po(t, { openPanel: n }));
      }
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      allowTopCollectionButton: fa(e, { windowId: t }).allowTopCollectionButton,
      canvasContentTypes: BV(e, { windowId: t }),
      containerId: Du(e),
      hasOpenSideBar: k$e(e, { windowId: t }),
      hintSideBar: z$e(e, { windowId: t }),
      translations: Dn(e).translations,
      windowId: t
    }),
    mode: "wrap",
    name: "HintingTopBar",
    target: "WindowTopBar"
  },
  {
    component: Nce,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      /** */
      updateConfig(n) {
        return e(Po(t, { openPanel: n }));
      }
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      canvasContentTypes: BV(e, { windowId: t }),
      canvasSeeAlso: Fle(e, { windowId: t }),
      containerId: Du(e),
      translations: Dn(e).translations,
      windowId: t
    }),
    mode: "wrap",
    name: "HintingSideBarButtons",
    target: "WindowSideBarButtons"
  }
], V$e = ye("div")({
  alignItems: "center",
  display: "flex",
  width: "100%"
}), U$e = ye("object")({
  width: "100%"
});
function Mce({ nativeObjectOptions: e = {}, nativeObjectResources: t = [], windowId: n }) {
  var f;
  const r = (p) => {
    var m;
    return p || ((m = document.body.querySelector(`#${n} .mirador-primary-window`)) == null ? void 0 : m.getBoundingClientRect());
  }, i = an(null), [o, s] = Bn({
    current: (f = i.current) == null ? void 0 : f.getBoundingClientRect(),
    original: r(null)
  });
  ln(() => {
    const p = i.current;
    if (!p) return () => {
    };
    const m = p.getBoundingClientRect(), v = new ResizeObserver((y) => {
      if (y.length === 0) return;
      const S = document.fullscreenElement ? y[0].contentRect : m;
      s({ current: S, original: m });
    });
    return v.observe(p), () => {
      v.disconnect();
    };
  }, [i]);
  const u = o.current || o.original;
  return /* @__PURE__ */ T.jsx(V$e, { ref: i, children: /* @__PURE__ */ T.jsx(U$e, { ...e, children: t.map((p) => /* @__PURE__ */ T.jsx(L2, { children: /* @__PURE__ */ T.jsx("object", { data: `${p.id}`, type: p.getFormat(), width: `${u == null ? void 0 : u.width}px`, height: `${u == null ? void 0 : u.height}px` }) }, p.id)) }) });
}
Mce.propTypes = {
  nativeObjectOptions: c.object,
  // eslint-disable-line react/forbid-prop-types
  nativeObjectResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  windowId: c.string.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const F$e = (e, { windowId: t }) => ({
  nativeObjectOptions: Dn(e).nativeObjectOptions,
  nativeObjectResources: yD(e, { windowId: t }) || [],
  windowId: t
}), W$e = wt(
  XA(),
  At(F$e, null),
  Tt("NativeObjectViewer")
), H$e = W$e(Mce), q$e = [
  {
    component: H$e,
    mode: "wrap",
    name: "NativeObjectViewer",
    target: "TextViewer"
  }
], KW = ({ options: e = {}, onReady: t = null }) => {
  const n = it.useRef(null), r = it.useRef(null);
  return it.useEffect(() => {
    if (r.current) {
      const i = r.current;
      i.autoplay(e.autoplay), i.src(e.sources);
    } else {
      const i = document.createElement("video-js");
      i.classList.add("vjs-big-play-centered"), n.current.appendChild(i);
      const o = $4(i, e, () => {
        $4.log("player is ready"), t && t(o);
      });
      r.current = o;
    }
  }, [e, n, t]), it.useEffect(() => {
    const i = r.current;
    return () => {
      i && !i.isDisposed() && (i.dispose(), r.current = null);
    };
  }, [r]), /* @__PURE__ */ T.jsx("div", { ref: n, "data-vjs-player": !0, style: { width: "100%" } });
};
KW.propTypes = {
  onReady: c.func,
  options: c.shape({
    autoplay: c.bool,
    sources: c.array.isRequired
    // eslint-disable-line react/forbid-prop-types
  })
};
const QW = ({ id: e = null }) => /* @__PURE__ */ T.jsx("div", { className: "alert alert-warning w-100 d-flex", children: /* @__PURE__ */ T.jsx("h3", { className: "my-auto mx-auto h6", children: `you do not currently have access to ${e}` }) });
QW.propTypes = {
  id: c.string
};
const $$e = (e, { windowId: t }) => ({
  audioOptions: Dn(e).audioOptions,
  audioResources: xD(e, { windowId: t }) || [],
  captions: G1(e, { windowId: t }) || []
}), G$e = wt(
  XA(),
  At($$e, null)
), jce = ({
  audioOptions: e,
  audioResources: t,
  captions: n
}) => {
  const r = {
    ...e,
    autoplay: !1,
    controlBar: {
      remainingTimeDisplay: !1
    },
    controls: !0,
    fill: !0,
    playbackRates: [0.5, 1, 1.5, 2],
    responsive: !0,
    sources: t.filter((i) => i.id && i.getFormat()).map(
      (i) => ({ src: i.id, type: i.getFormat() })
    ),
    tracks: n.filter((i) => i.id).map((i) => ({ kind: i.kind || "captions", src: i.id }))
  };
  return r.sources.length === 0 ? /* @__PURE__ */ T.jsx(QW, { id: "this content" }) : /* @__PURE__ */ T.jsx(KW, { options: r });
}, Y$e = G$e(jce), X$e = ({ targetProps: e }) => /* @__PURE__ */ T.jsx(Y$e, { ...e });
jce.propTypes = {
  audioOptions: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  audioResources: c.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  captions: c.array.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const Z$e = ye("div")(() => ({
  alignItems: "center",
  display: "flex",
  width: "100%"
})), K$e = ye("video")(() => ({
  maxHeight: "100%",
  width: "100%"
}));
function Lce({ captions: e = [], videoOptions: t = {}, videoResources: n = [] }) {
  return /* @__PURE__ */ T.jsx(Z$e, { children: /* @__PURE__ */ T.jsxs(K$e, { ...t, children: [
    n.map((r) => /* @__PURE__ */ T.jsx("source", { src: r.id, type: r.getFormat() }, r.io)),
    e.map((r) => /* @__PURE__ */ T.jsx("track", { src: r.id, label: r.getDefaultLabel(), srcLang: r.getProperty("language") }, r.id))
  ] }) });
}
Lce.propTypes = {
  captions: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  videoOptions: c.object,
  // eslint-disable-line react/forbid-prop-types
  videoResources: c.arrayOf(c.object)
  // eslint-disable-line react/forbid-prop-types
};
const Q$e = (e, { windowId: t }) => ({
  captions: G1(e, { windowId: t }) || [],
  videoOptions: Dn(e).videoOptions,
  videoResources: bD(e, { windowId: t }) || []
}), J$e = wt(
  XA(),
  At(Q$e, null)
);
function kce({ captions: e, videoOptions: t, videoResources: n }) {
  const r = {
    ...t,
    autoplay: !1,
    controlBar: {
      remainingTimeDisplay: !1
    },
    controls: !0,
    fill: !0,
    playbackRates: [0.5, 1, 1.5, 2],
    responsive: !0,
    sources: n.filter((i) => i.id && i.getFormat()).map(
      (i) => ({ src: i.id, type: i.getFormat() })
    ),
    tracks: e.filter((i) => i.id).map((i) => ({ kind: i.kind || "captions", src: i.id }))
  };
  return r.sources.length === 0 ? /* @__PURE__ */ T.jsx(QW, { id: "this content" }) : /* @__PURE__ */ T.jsx(KW, { options: r });
}
const e8e = J$e(kce), t8e = ({ targetProps: e }) => /* @__PURE__ */ T.jsx(e8e, { ...e });
kce.propTypes = {
  captions: c.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  videoOptions: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  videoResources: c.array.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const n8e = [
  {
    component: X$e,
    mode: "wrap",
    name: "VideoJSAudioViewer",
    target: "AudioViewer"
  },
  {
    component: t8e,
    mode: "wrap",
    name: "VideoJSViewer",
    target: "VideoViewer"
  }
], KZ = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m19 1-5 5v11l5-4.5zM1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5V6c-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6m22 13.5V6c-.6-.45-1.25-.75-2-1v13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v2c1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5z"
}), "AutoStories"), QZ = () => {
};
function zce({
  hasNextCanvas: e = !1,
  hasPreviousCanvas: t = !1,
  setNextCanvas: n = QZ,
  setPreviousCanvas: r = QZ,
  viewingDirection: i = ""
}) {
  const { t: o } = Ct();
  if (!t && !e) return null;
  let s = "ltr";
  const u = ["scale(-1, 1)"], f = [];
  switch (i) {
    case "top-to-bottom":
      u.unshift("rotate(90deg)"), f.unshift("rotate(90deg)");
      break;
    case "bottom-to-top":
      u.unshift("rotate(270deg)"), f.unshift("rotate(270deg)");
      break;
    case "right-to-left":
      s = "rtl", f.push(u.pop());
      break;
  }
  const p = u.length > 0 ? { transform: u.join(" ") } : {}, m = f.length > 0 ? { transform: f.join(" ") } : {};
  return /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: On(Nt("osd-navigation")),
      dir: s,
      children: [
        /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": o("previousCanvas"),
            className: Nt("previous-canvas-button"),
            disabled: !t,
            onClick: () => {
              t && r();
            },
            children: /* @__PURE__ */ T.jsx(KZ, { style: p })
          }
        ),
        /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": o("nextCanvas"),
            className: Nt("next-canvas-button"),
            disabled: !e,
            onClick: () => {
              e && n();
            },
            children: /* @__PURE__ */ T.jsx(KZ, { style: m })
          }
        )
      ]
    }
  );
}
zce.propTypes = {
  hasNextCanvas: c.bool,
  hasPreviousCanvas: c.bool,
  setNextCanvas: c.func,
  setPreviousCanvas: c.func,
  viewingDirection: c.string
};
const r8e = [
  {
    component: zce,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      setNextCanvas: (...n) => e(ID(t)),
      setPreviousCanvas: (...n) => e(PD(t))
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      hasNextCanvas: !!q1(e, { windowId: t }),
      hasPreviousCanvas: !!$1(e, { windowId: t }),
      viewingDirection: Ix(e, { windowId: t })
    }),
    mode: "wrap",
    name: "PageIconViewerNavigation",
    target: "ViewerNavigation"
  }
], i8e = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7m17 3c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4z"
}), "DataObject");
self.$RefreshReg$ = () => {
};
self.$RefreshSig$ = () => () => {
};
const Bce = ({ config: e, updateConfig: t }) => {
  const { dialogOpen: n, enabled: r } = e;
  return r ? /* @__PURE__ */ T.jsx(
    Jn,
    {
      "aria-expanded": n,
      "aria-haspopup": !0,
      "aria-label": "View MODS",
      onClick: () => t({
        ...e,
        dialogOpen: !n
      }),
      children: /* @__PURE__ */ T.jsx(i8e, {})
    }
  ) : null;
};
Bce.propTypes = {
  config: c.shape({
    dialogOpen: c.bool.isRequired,
    enabled: c.bool.isRequired
  }).isRequired,
  updateConfig: c.func.isRequired
};
const JZ = ":@", jA = "#text", JW = "#comment", eH = "#cdata", Vce = "DECLARATION_TAG", o8e = "TAG", UV = {
  tagColor: "#d43900",
  textColor: "#333",
  attributeKeyColor: "#2a7ab0",
  attributeValueColor: "#008000",
  separatorColor: "#333",
  commentColor: "#aaa",
  cdataColor: "#1d781d",
  fontFamily: "monospace"
}, a8e = {
  theme: UV,
  collapsible: !1,
  indentSize: 2
}, Uce = hg(a8e), hp = () => Qi(Uce);
var xO = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function tH(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nH = {}, nP = {};
(function(e) {
  const t = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", n = t + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", r = "[" + t + "][" + n + "]*", i = new RegExp("^" + r + "$"), o = function(u, f) {
    const p = [];
    let m = f.exec(u);
    for (; m; ) {
      const v = [];
      v.startIndex = f.lastIndex - m[0].length;
      const y = m.length;
      for (let S = 0; S < y; S++)
        v.push(m[S]);
      p.push(v), m = f.exec(u);
    }
    return p;
  }, s = function(u) {
    const f = i.exec(u);
    return !(f === null || typeof f > "u");
  };
  e.isExist = function(u) {
    return typeof u < "u";
  }, e.isEmptyObject = function(u) {
    return Object.keys(u).length === 0;
  }, e.merge = function(u, f, p) {
    if (f) {
      const m = Object.keys(f), v = m.length;
      for (let y = 0; y < v; y++)
        p === "strict" ? u[m[y]] = [f[m[y]]] : u[m[y]] = f[m[y]];
    }
  }, e.getValue = function(u) {
    return e.isExist(u) ? u : "";
  }, e.isName = s, e.getAllMatches = o, e.nameRegexp = r;
})(nP);
const rH = nP, s8e = {
  allowBooleanAttributes: !1,
  //A tag can have attributes without any value
  unpairedTags: []
};
nH.validate = function(e, t) {
  t = Object.assign({}, s8e, t);
  const n = [];
  let r = !1, i = !1;
  e[0] === "\uFEFF" && (e = e.substr(1));
  for (let o = 0; o < e.length; o++)
    if (e[o] === "<" && e[o + 1] === "?") {
      if (o += 2, o = tK(e, o), o.err)
        return o;
    } else if (e[o] === "<") {
      let s = o;
      if (o++, e[o] === "!") {
        o = nK(e, o);
        continue;
      } else {
        let u = !1;
        e[o] === "/" && (u = !0, o++);
        let f = "";
        for (; o < e.length && e[o] !== ">" && e[o] !== " " && e[o] !== "	" && e[o] !== `
` && e[o] !== "\r"; o++)
          f += e[o];
        if (f = f.trim(), f[f.length - 1] === "/" && (f = f.substring(0, f.length - 1), o--), !g8e(f)) {
          let v;
          return f.trim().length === 0 ? v = "Invalid space after '<'." : v = "Tag '" + f + "' is an invalid name.", Xi("InvalidTag", v, us(e, o));
        }
        const p = u8e(e, o);
        if (p === !1)
          return Xi("InvalidAttr", "Attributes for '" + f + "' have open quote.", us(e, o));
        let m = p.value;
        if (o = p.index, m[m.length - 1] === "/") {
          const v = o - m.length;
          m = m.substring(0, m.length - 1);
          const y = rK(m, t);
          if (y === !0)
            r = !0;
          else
            return Xi(y.err.code, y.err.msg, us(e, v + y.err.line));
        } else if (u)
          if (p.tagClosed) {
            if (m.trim().length > 0)
              return Xi("InvalidTag", "Closing tag '" + f + "' can't have attributes or invalid starting.", us(e, s));
            if (n.length === 0)
              return Xi("InvalidTag", "Closing tag '" + f + "' has not been opened.", us(e, s));
            {
              const v = n.pop();
              if (f !== v.tagName) {
                let y = us(e, v.tagStartPos);
                return Xi(
                  "InvalidTag",
                  "Expected closing tag '" + v.tagName + "' (opened in line " + y.line + ", col " + y.col + ") instead of closing tag '" + f + "'.",
                  us(e, s)
                );
              }
              n.length == 0 && (i = !0);
            }
          } else
            return Xi("InvalidTag", "Closing tag '" + f + "' doesn't have proper closing.", us(e, o));
        else {
          const v = rK(m, t);
          if (v !== !0)
            return Xi(v.err.code, v.err.msg, us(e, o - m.length + v.err.line));
          if (i === !0)
            return Xi("InvalidXml", "Multiple possible root nodes found.", us(e, o));
          t.unpairedTags.indexOf(f) !== -1 || n.push({ tagName: f, tagStartPos: s }), r = !0;
        }
        for (o++; o < e.length; o++)
          if (e[o] === "<")
            if (e[o + 1] === "!") {
              o++, o = nK(e, o);
              continue;
            } else if (e[o + 1] === "?") {
              if (o = tK(e, ++o), o.err)
                return o;
            } else
              break;
          else if (e[o] === "&") {
            const v = p8e(e, o);
            if (v == -1)
              return Xi("InvalidChar", "char '&' is not expected.", us(e, o));
            o = v;
          } else if (i === !0 && !eK(e[o]))
            return Xi("InvalidXml", "Extra text at the end", us(e, o));
        e[o] === "<" && o--;
      }
    } else {
      if (eK(e[o]))
        continue;
      return Xi("InvalidChar", "char '" + e[o] + "' is not expected.", us(e, o));
    }
  if (r) {
    if (n.length == 1)
      return Xi("InvalidTag", "Unclosed tag '" + n[0].tagName + "'.", us(e, n[0].tagStartPos));
    if (n.length > 0)
      return Xi("InvalidXml", "Invalid '" + JSON.stringify(n.map((o) => o.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else
    return Xi("InvalidXml", "Start tag expected.", 1);
  return !0;
};
function eK(e) {
  return e === " " || e === "	" || e === `
` || e === "\r";
}
function tK(e, t) {
  const n = t;
  for (; t < e.length; t++)
    if (e[t] == "?" || e[t] == " ") {
      const r = e.substr(n, t - n);
      if (t > 5 && r === "xml")
        return Xi("InvalidXml", "XML declaration allowed only at the start of the document.", us(e, t));
      if (e[t] == "?" && e[t + 1] == ">") {
        t++;
        break;
      } else
        continue;
    }
  return t;
}
function nK(e, t) {
  if (e.length > t + 5 && e[t + 1] === "-" && e[t + 2] === "-") {
    for (t += 3; t < e.length; t++)
      if (e[t] === "-" && e[t + 1] === "-" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  } else if (e.length > t + 8 && e[t + 1] === "D" && e[t + 2] === "O" && e[t + 3] === "C" && e[t + 4] === "T" && e[t + 5] === "Y" && e[t + 6] === "P" && e[t + 7] === "E") {
    let n = 1;
    for (t += 8; t < e.length; t++)
      if (e[t] === "<")
        n++;
      else if (e[t] === ">" && (n--, n === 0))
        break;
  } else if (e.length > t + 9 && e[t + 1] === "[" && e[t + 2] === "C" && e[t + 3] === "D" && e[t + 4] === "A" && e[t + 5] === "T" && e[t + 6] === "A" && e[t + 7] === "[") {
    for (t += 8; t < e.length; t++)
      if (e[t] === "]" && e[t + 1] === "]" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  }
  return t;
}
const l8e = '"', c8e = "'";
function u8e(e, t) {
  let n = "", r = "", i = !1;
  for (; t < e.length; t++) {
    if (e[t] === l8e || e[t] === c8e)
      r === "" ? r = e[t] : r !== e[t] || (r = "");
    else if (e[t] === ">" && r === "") {
      i = !0;
      break;
    }
    n += e[t];
  }
  return r !== "" ? !1 : {
    value: n,
    index: t,
    tagClosed: i
  };
}
const d8e = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function rK(e, t) {
  const n = rH.getAllMatches(e, d8e), r = {};
  for (let i = 0; i < n.length; i++) {
    if (n[i][1].length === 0)
      return Xi("InvalidAttr", "Attribute '" + n[i][2] + "' has no space in starting.", yE(n[i]));
    if (n[i][3] !== void 0 && n[i][4] === void 0)
      return Xi("InvalidAttr", "Attribute '" + n[i][2] + "' is without value.", yE(n[i]));
    if (n[i][3] === void 0 && !t.allowBooleanAttributes)
      return Xi("InvalidAttr", "boolean attribute '" + n[i][2] + "' is not allowed.", yE(n[i]));
    const o = n[i][2];
    if (!h8e(o))
      return Xi("InvalidAttr", "Attribute '" + o + "' is an invalid name.", yE(n[i]));
    if (!r.hasOwnProperty(o))
      r[o] = 1;
    else
      return Xi("InvalidAttr", "Attribute '" + o + "' is repeated.", yE(n[i]));
  }
  return !0;
}
function f8e(e, t) {
  let n = /\d/;
  for (e[t] === "x" && (t++, n = /[\da-fA-F]/); t < e.length; t++) {
    if (e[t] === ";")
      return t;
    if (!e[t].match(n))
      break;
  }
  return -1;
}
function p8e(e, t) {
  if (t++, e[t] === ";")
    return -1;
  if (e[t] === "#")
    return t++, f8e(e, t);
  let n = 0;
  for (; t < e.length; t++, n++)
    if (!(e[t].match(/\w/) && n < 20)) {
      if (e[t] === ";")
        break;
      return -1;
    }
  return t;
}
function Xi(e, t, n) {
  return {
    err: {
      code: e,
      msg: t,
      line: n.line || n,
      col: n.col
    }
  };
}
function h8e(e) {
  return rH.isName(e);
}
function g8e(e) {
  return rH.isName(e);
}
function us(e, t) {
  const n = e.substring(0, t).split(/\r?\n/);
  return {
    line: n.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: n[n.length - 1].length + 1
  };
}
function yE(e) {
  return e.startIndex + e[1].length;
}
var iH = {};
const Fce = {
  preserveOrder: !1,
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  removeNSPrefix: !1,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: !1,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: !0,
  parseAttributeValue: !1,
  trimValues: !0,
  //Trim string values of tag and attributes
  cdataPropName: !1,
  numberParseOptions: {
    hex: !0,
    leadingZeros: !0,
    eNotation: !0
  },
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: !1,
  isArray: () => !1,
  commentPropName: !1,
  unpairedTags: [],
  processEntities: !0,
  htmlEntities: !1,
  ignoreDeclaration: !1,
  ignorePiTags: !1,
  transformTagName: !1,
  transformAttributeName: !1,
  updateTag: function(e, t, n) {
    return e;
  }
  // skipEmptyListItem: false
}, m8e = function(e) {
  return Object.assign({}, Fce, e);
};
iH.buildOptions = m8e;
iH.defaultOptions = Fce;
class v8e {
  constructor(t) {
    this.tagname = t, this.child = [], this[":@"] = {};
  }
  add(t, n) {
    t === "__proto__" && (t = "#__proto__"), this.child.push({ [t]: n });
  }
  addChild(t) {
    t.tagname === "__proto__" && (t.tagname = "#__proto__"), t[":@"] && Object.keys(t[":@"]).length > 0 ? this.child.push({ [t.tagname]: t.child, ":@": t[":@"] }) : this.child.push({ [t.tagname]: t.child });
  }
}
var y8e = v8e;
const b8e = nP;
function x8e(e, t) {
  const n = {};
  if (e[t + 3] === "O" && e[t + 4] === "C" && e[t + 5] === "T" && e[t + 6] === "Y" && e[t + 7] === "P" && e[t + 8] === "E") {
    t = t + 9;
    let r = 1, i = !1, o = !1, s = "";
    for (; t < e.length; t++)
      if (e[t] === "<" && !o) {
        if (i && T8e(e, t))
          t += 7, [entityName, val, t] = S8e(e, t + 1), val.indexOf("&") === -1 && (n[R8e(entityName)] = {
            regx: RegExp(`&${entityName};`, "g"),
            val
          });
        else if (i && E8e(e, t))
          t += 8;
        else if (i && _8e(e, t))
          t += 8;
        else if (i && C8e(e, t))
          t += 9;
        else if (w8e)
          o = !0;
        else
          throw new Error("Invalid DOCTYPE");
        r++, s = "";
      } else if (e[t] === ">") {
        if (o ? e[t - 1] === "-" && e[t - 2] === "-" && (o = !1, r--) : r--, r === 0)
          break;
      } else
        e[t] === "[" ? i = !0 : s += e[t];
    if (r !== 0)
      throw new Error("Unclosed DOCTYPE");
  } else
    throw new Error("Invalid Tag instead of DOCTYPE");
  return { entities: n, i: t };
}
function S8e(e, t) {
  let n = "";
  for (; t < e.length && e[t] !== "'" && e[t] !== '"'; t++)
    n += e[t];
  if (n = n.trim(), n.indexOf(" ") !== -1)
    throw new Error("External entites are not supported");
  const r = e[t++];
  let i = "";
  for (; t < e.length && e[t] !== r; t++)
    i += e[t];
  return [n, i, t];
}
function w8e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "-" && e[t + 3] === "-";
}
function T8e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "N" && e[t + 4] === "T" && e[t + 5] === "I" && e[t + 6] === "T" && e[t + 7] === "Y";
}
function E8e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "L" && e[t + 4] === "E" && e[t + 5] === "M" && e[t + 6] === "E" && e[t + 7] === "N" && e[t + 8] === "T";
}
function _8e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "A" && e[t + 3] === "T" && e[t + 4] === "T" && e[t + 5] === "L" && e[t + 6] === "I" && e[t + 7] === "S" && e[t + 8] === "T";
}
function C8e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "N" && e[t + 3] === "O" && e[t + 4] === "T" && e[t + 5] === "A" && e[t + 6] === "T" && e[t + 7] === "I" && e[t + 8] === "O" && e[t + 9] === "N";
}
function R8e(e) {
  if (b8e.isName(e))
    return e;
  throw new Error(`Invalid entity name ${e}`);
}
var O8e = x8e;
const A8e = /^[-+]?0x[a-fA-F0-9]+$/, D8e = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
!Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt);
!Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const I8e = {
  hex: !0,
  leadingZeros: !0,
  decimalPoint: ".",
  eNotation: !0
  //skipLike: /regex/
};
function P8e(e, t = {}) {
  if (t = Object.assign({}, I8e, t), !e || typeof e != "string")
    return e;
  let n = e.trim();
  if (t.skipLike !== void 0 && t.skipLike.test(n))
    return e;
  if (t.hex && A8e.test(n))
    return Number.parseInt(n, 16);
  {
    const r = D8e.exec(n);
    if (r) {
      const i = r[1], o = r[2];
      let s = N8e(r[3]);
      const u = r[4] || r[6];
      if (!t.leadingZeros && o.length > 0 && i && n[2] !== "." || !t.leadingZeros && o.length > 0 && !i && n[1] !== ".")
        return e;
      {
        const f = Number(n), p = "" + f;
        return p.search(/[eE]/) !== -1 || u ? t.eNotation ? f : e : n.indexOf(".") !== -1 ? p === "0" && s === "" || p === s || i && p === "-" + s ? f : e : o ? s === p || i + s === p ? f : e : n === p || n === i + p ? f : e;
      }
    } else
      return e;
  }
}
function N8e(e) {
  return e && e.indexOf(".") !== -1 && (e = e.replace(/0+$/, ""), e === "." ? e = "0" : e[0] === "." ? e = "0" + e : e[e.length - 1] === "." && (e = e.substr(0, e.length - 1))), e;
}
var M8e = P8e;
function j8e(e) {
  return typeof e == "function" ? e : Array.isArray(e) ? (t) => {
    for (const n of e)
      if (typeof n == "string" && t === n || n instanceof RegExp && n.test(t))
        return !0;
  } : () => !1;
}
var Wce = j8e;
const Hce = nP, bE = y8e, L8e = O8e, k8e = M8e, z8e = Wce;
let B8e = class {
  constructor(e) {
    this.options = e, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = {
      apos: { regex: /&(apos|#39|#x27);/g, val: "'" },
      gt: { regex: /&(gt|#62|#x3E);/g, val: ">" },
      lt: { regex: /&(lt|#60|#x3C);/g, val: "<" },
      quot: { regex: /&(quot|#34|#x22);/g, val: '"' }
    }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = {
      space: { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      cent: { regex: /&(cent|#162);/g, val: "¢" },
      pound: { regex: /&(pound|#163);/g, val: "£" },
      yen: { regex: /&(yen|#165);/g, val: "¥" },
      euro: { regex: /&(euro|#8364);/g, val: "€" },
      copyright: { regex: /&(copy|#169);/g, val: "©" },
      reg: { regex: /&(reg|#174);/g, val: "®" },
      inr: { regex: /&(inr|#8377);/g, val: "₹" },
      num_dec: { regex: /&#([0-9]{1,7});/g, val: (t, n) => String.fromCharCode(Number.parseInt(n, 10)) },
      num_hex: { regex: /&#x([0-9a-fA-F]{1,6});/g, val: (t, n) => String.fromCharCode(Number.parseInt(n, 16)) }
    }, this.addExternalEntities = V8e, this.parseXml = q8e, this.parseTextData = U8e, this.resolveNameSpace = F8e, this.buildAttributesMap = H8e, this.isItStopNode = X8e, this.replaceEntitiesValue = G8e, this.readStopNodeData = K8e, this.saveTextToParentTag = Y8e, this.addChild = $8e, this.ignoreAttributesFn = z8e(this.options.ignoreAttributes);
  }
};
function V8e(e) {
  const t = Object.keys(e);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    this.lastEntities[r] = {
      regex: new RegExp("&" + r + ";", "g"),
      val: e[r]
    };
  }
}
function U8e(e, t, n, r, i, o, s) {
  if (e !== void 0 && (this.options.trimValues && !r && (e = e.trim()), e.length > 0)) {
    s || (e = this.replaceEntitiesValue(e));
    const u = this.options.tagValueProcessor(t, e, n, i, o);
    return u == null ? e : typeof u != typeof e || u !== e ? u : this.options.trimValues ? WV(e, this.options.parseTagValue, this.options.numberParseOptions) : e.trim() === e ? WV(e, this.options.parseTagValue, this.options.numberParseOptions) : e;
  }
}
function F8e(e) {
  if (this.options.removeNSPrefix) {
    const t = e.split(":"), n = e.charAt(0) === "/" ? "/" : "";
    if (t[0] === "xmlns")
      return "";
    t.length === 2 && (e = n + t[1]);
  }
  return e;
}
const W8e = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
function H8e(e, t, n) {
  if (this.options.ignoreAttributes !== !0 && typeof e == "string") {
    const r = Hce.getAllMatches(e, W8e), i = r.length, o = {};
    for (let s = 0; s < i; s++) {
      const u = this.resolveNameSpace(r[s][1]);
      if (this.ignoreAttributesFn(u, t))
        continue;
      let f = r[s][4], p = this.options.attributeNamePrefix + u;
      if (u.length)
        if (this.options.transformAttributeName && (p = this.options.transformAttributeName(p)), p === "__proto__" && (p = "#__proto__"), f !== void 0) {
          this.options.trimValues && (f = f.trim()), f = this.replaceEntitiesValue(f);
          const m = this.options.attributeValueProcessor(u, f, t);
          m == null ? o[p] = f : typeof m != typeof f || m !== f ? o[p] = m : o[p] = WV(
            f,
            this.options.parseAttributeValue,
            this.options.numberParseOptions
          );
        } else
          this.options.allowBooleanAttributes && (o[p] = !0);
    }
    if (!Object.keys(o).length)
      return;
    if (this.options.attributesGroupName) {
      const s = {};
      return s[this.options.attributesGroupName] = o, s;
    }
    return o;
  }
}
const q8e = function(e) {
  e = e.replace(/\r\n?/g, `
`);
  const t = new bE("!xml");
  let n = t, r = "", i = "";
  for (let o = 0; o < e.length; o++)
    if (e[o] === "<")
      if (e[o + 1] === "/") {
        const s = Rv(e, ">", o, "Closing Tag is not closed.");
        let u = e.substring(o + 2, s).trim();
        if (this.options.removeNSPrefix) {
          const m = u.indexOf(":");
          m !== -1 && (u = u.substr(m + 1));
        }
        this.options.transformTagName && (u = this.options.transformTagName(u)), n && (r = this.saveTextToParentTag(r, n, i));
        const f = i.substring(i.lastIndexOf(".") + 1);
        if (u && this.options.unpairedTags.indexOf(u) !== -1)
          throw new Error(`Unpaired tag can not be used as closing tag: </${u}>`);
        let p = 0;
        f && this.options.unpairedTags.indexOf(f) !== -1 ? (p = i.lastIndexOf(".", i.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : p = i.lastIndexOf("."), i = i.substring(0, p), n = this.tagsNodeStack.pop(), r = "", o = s;
      } else if (e[o + 1] === "?") {
        let s = FV(e, o, !1, "?>");
        if (!s)
          throw new Error("Pi Tag is not closed.");
        if (r = this.saveTextToParentTag(r, n, i), !(this.options.ignoreDeclaration && s.tagName === "?xml" || this.options.ignorePiTags)) {
          const u = new bE(s.tagName);
          u.add(this.options.textNodeName, ""), s.tagName !== s.tagExp && s.attrExpPresent && (u[":@"] = this.buildAttributesMap(s.tagExp, i, s.tagName)), this.addChild(n, u, i);
        }
        o = s.closeIndex + 1;
      } else if (e.substr(o + 1, 3) === "!--") {
        const s = Rv(e, "-->", o + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          const u = e.substring(o + 4, s - 2);
          r = this.saveTextToParentTag(r, n, i), n.add(this.options.commentPropName, [{ [this.options.textNodeName]: u }]);
        }
        o = s;
      } else if (e.substr(o + 1, 2) === "!D") {
        const s = L8e(e, o);
        this.docTypeEntities = s.entities, o = s.i;
      } else if (e.substr(o + 1, 2) === "![") {
        const s = Rv(e, "]]>", o, "CDATA is not closed.") - 2, u = e.substring(o + 9, s);
        r = this.saveTextToParentTag(r, n, i);
        let f = this.parseTextData(u, n.tagname, i, !0, !1, !0, !0);
        f == null && (f = ""), this.options.cdataPropName ? n.add(this.options.cdataPropName, [{ [this.options.textNodeName]: u }]) : n.add(this.options.textNodeName, f), o = s + 2;
      } else {
        let s = FV(e, o, this.options.removeNSPrefix), u = s.tagName;
        const f = s.rawTagName;
        let p = s.tagExp, m = s.attrExpPresent, v = s.closeIndex;
        this.options.transformTagName && (u = this.options.transformTagName(u)), n && r && n.tagname !== "!xml" && (r = this.saveTextToParentTag(r, n, i, !1));
        const y = n;
        if (y && this.options.unpairedTags.indexOf(y.tagname) !== -1 && (n = this.tagsNodeStack.pop(), i = i.substring(0, i.lastIndexOf("."))), u !== t.tagname && (i += i ? "." + u : u), this.isItStopNode(this.options.stopNodes, i, u)) {
          let S = "";
          if (p.length > 0 && p.lastIndexOf("/") === p.length - 1)
            u[u.length - 1] === "/" ? (u = u.substr(0, u.length - 1), i = i.substr(0, i.length - 1), p = u) : p = p.substr(0, p.length - 1), o = s.closeIndex;
          else if (this.options.unpairedTags.indexOf(u) !== -1)
            o = s.closeIndex;
          else {
            const w = this.readStopNodeData(e, f, v + 1);
            if (!w)
              throw new Error(`Unexpected end of ${f}`);
            o = w.i, S = w.tagContent;
          }
          const E = new bE(u);
          u !== p && m && (E[":@"] = this.buildAttributesMap(p, i, u)), S && (S = this.parseTextData(S, u, i, !0, m, !0, !0)), i = i.substr(0, i.lastIndexOf(".")), E.add(this.options.textNodeName, S), this.addChild(n, E, i);
        } else {
          if (p.length > 0 && p.lastIndexOf("/") === p.length - 1) {
            u[u.length - 1] === "/" ? (u = u.substr(0, u.length - 1), i = i.substr(0, i.length - 1), p = u) : p = p.substr(0, p.length - 1), this.options.transformTagName && (u = this.options.transformTagName(u));
            const S = new bE(u);
            u !== p && m && (S[":@"] = this.buildAttributesMap(p, i, u)), this.addChild(n, S, i), i = i.substr(0, i.lastIndexOf("."));
          } else {
            const S = new bE(u);
            this.tagsNodeStack.push(n), u !== p && m && (S[":@"] = this.buildAttributesMap(p, i, u)), this.addChild(n, S, i), n = S;
          }
          r = "", o = v;
        }
      }
    else
      r += e[o];
  return t.child;
};
function $8e(e, t, n) {
  const r = this.options.updateTag(t.tagname, n, t[":@"]);
  r === !1 || (typeof r == "string" && (t.tagname = r), e.addChild(t));
}
const G8e = function(e) {
  if (this.options.processEntities) {
    for (let t in this.docTypeEntities) {
      const n = this.docTypeEntities[t];
      e = e.replace(n.regx, n.val);
    }
    for (let t in this.lastEntities) {
      const n = this.lastEntities[t];
      e = e.replace(n.regex, n.val);
    }
    if (this.options.htmlEntities)
      for (let t in this.htmlEntities) {
        const n = this.htmlEntities[t];
        e = e.replace(n.regex, n.val);
      }
    e = e.replace(this.ampEntity.regex, this.ampEntity.val);
  }
  return e;
};
function Y8e(e, t, n, r) {
  return e && (r === void 0 && (r = Object.keys(t.child).length === 0), e = this.parseTextData(
    e,
    t.tagname,
    n,
    !1,
    t[":@"] ? Object.keys(t[":@"]).length !== 0 : !1,
    r
  ), e !== void 0 && e !== "" && t.add(this.options.textNodeName, e), e = ""), e;
}
function X8e(e, t, n) {
  const r = "*." + n;
  for (const i in e) {
    const o = e[i];
    if (r === o || t === o)
      return !0;
  }
  return !1;
}
function Z8e(e, t, n = ">") {
  let r, i = "";
  for (let o = t; o < e.length; o++) {
    let s = e[o];
    if (r)
      s === r && (r = "");
    else if (s === '"' || s === "'")
      r = s;
    else if (s === n[0])
      if (n[1]) {
        if (e[o + 1] === n[1])
          return {
            data: i,
            index: o
          };
      } else
        return {
          data: i,
          index: o
        };
    else
      s === "	" && (s = " ");
    i += s;
  }
}
function Rv(e, t, n, r) {
  const i = e.indexOf(t, n);
  if (i === -1)
    throw new Error(r);
  return i + t.length - 1;
}
function FV(e, t, n, r = ">") {
  const i = Z8e(e, t + 1, r);
  if (!i)
    return;
  let o = i.data;
  const s = i.index, u = o.search(/\s/);
  let f = o, p = !0;
  u !== -1 && (f = o.substring(0, u), o = o.substring(u + 1).trimStart());
  const m = f;
  if (n) {
    const v = f.indexOf(":");
    v !== -1 && (f = f.substr(v + 1), p = f !== i.data.substr(v + 1));
  }
  return {
    tagName: f,
    tagExp: o,
    closeIndex: s,
    attrExpPresent: p,
    rawTagName: m
  };
}
function K8e(e, t, n) {
  const r = n;
  let i = 1;
  for (; n < e.length; n++)
    if (e[n] === "<")
      if (e[n + 1] === "/") {
        const o = Rv(e, ">", n, `${t} is not closed`);
        if (e.substring(n + 2, o).trim() === t && (i--, i === 0))
          return {
            tagContent: e.substring(r, n),
            i: o
          };
        n = o;
      } else if (e[n + 1] === "?")
        n = Rv(e, "?>", n + 1, "StopNode is not closed.");
      else if (e.substr(n + 1, 3) === "!--")
        n = Rv(e, "-->", n + 3, "StopNode is not closed.");
      else if (e.substr(n + 1, 2) === "![")
        n = Rv(e, "]]>", n, "StopNode is not closed.") - 2;
      else {
        const o = FV(e, n, ">");
        o && ((o && o.tagName) === t && o.tagExp[o.tagExp.length - 1] !== "/" && i++, n = o.closeIndex);
      }
}
function WV(e, t, n) {
  if (t && typeof e == "string") {
    const r = e.trim();
    return r === "true" ? !0 : r === "false" ? !1 : k8e(e, n);
  } else
    return Hce.isExist(e) ? e : "";
}
var Q8e = B8e, qce = {};
function J8e(e, t) {
  return $ce(e, t);
}
function $ce(e, t, n) {
  let r;
  const i = {};
  for (let o = 0; o < e.length; o++) {
    const s = e[o], u = eGe(s);
    let f = "";
    if (n === void 0 ? f = u : f = n + "." + u, u === t.textNodeName)
      r === void 0 ? r = s[u] : r += "" + s[u];
    else {
      if (u === void 0)
        continue;
      if (s[u]) {
        let p = $ce(s[u], t, f);
        const m = nGe(p, t);
        s[":@"] ? tGe(p, s[":@"], f, t) : Object.keys(p).length === 1 && p[t.textNodeName] !== void 0 && !t.alwaysCreateTextNode ? p = p[t.textNodeName] : Object.keys(p).length === 0 && (t.alwaysCreateTextNode ? p[t.textNodeName] = "" : p = ""), i[u] !== void 0 && i.hasOwnProperty(u) ? (Array.isArray(i[u]) || (i[u] = [i[u]]), i[u].push(p)) : t.isArray(u, f, m) ? i[u] = [p] : i[u] = p;
      }
    }
  }
  return typeof r == "string" ? r.length > 0 && (i[t.textNodeName] = r) : r !== void 0 && (i[t.textNodeName] = r), i;
}
function eGe(e) {
  const t = Object.keys(e);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (r !== ":@")
      return r;
  }
}
function tGe(e, t, n, r) {
  if (t) {
    const i = Object.keys(t), o = i.length;
    for (let s = 0; s < o; s++) {
      const u = i[s];
      r.isArray(u, n + "." + u, !0, !0) ? e[u] = [t[u]] : e[u] = t[u];
    }
  }
}
function nGe(e, t) {
  const { textNodeName: n } = t, r = Object.keys(e).length;
  return !!(r === 0 || r === 1 && (e[n] || typeof e[n] == "boolean" || e[n] === 0));
}
qce.prettify = J8e;
const { buildOptions: rGe } = iH, iGe = Q8e, { prettify: oGe } = qce, aGe = nH;
let sGe = class {
  constructor(e) {
    this.externalEntities = {}, this.options = rGe(e);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */
  parse(e, t) {
    if (typeof e != "string")
      if (e.toString)
        e = e.toString();
      else
        throw new Error("XML data is accepted in String or Bytes[] form.");
    if (t) {
      t === !0 && (t = {});
      const i = aGe.validate(e, t);
      if (i !== !0)
        throw Error(`${i.err.msg}:${i.err.line}:${i.err.col}`);
    }
    const n = new iGe(this.options);
    n.addExternalEntities(this.externalEntities);
    const r = n.parseXml(e);
    return this.options.preserveOrder || r === void 0 ? r : oGe(r, this.options);
  }
  /**
   * Add Entity which is not by default supported by this library
   * @param {string} key 
   * @param {string} value 
   */
  addEntity(e, t) {
    if (t.indexOf("&") !== -1)
      throw new Error("Entity value can't have '&'");
    if (e.indexOf("&") !== -1 || e.indexOf(";") !== -1)
      throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
    if (t === "&")
      throw new Error("An entity with value '&' is not permitted");
    this.externalEntities[e] = t;
  }
};
var lGe = sGe;
const cGe = `
`;
function uGe(e, t) {
  let n = "";
  return t.format && t.indentBy.length > 0 && (n = cGe), Gce(e, t, "", n);
}
function Gce(e, t, n, r) {
  let i = "", o = !1;
  for (let s = 0; s < e.length; s++) {
    const u = e[s], f = dGe(u);
    if (f === void 0)
      continue;
    let p = "";
    if (n.length === 0 ? p = f : p = `${n}.${f}`, f === t.textNodeName) {
      let E = u[f];
      fGe(p, t) || (E = t.tagValueProcessor(f, E), E = Yce(E, t)), o && (i += r), i += E, o = !1;
      continue;
    } else if (f === t.cdataPropName) {
      o && (i += r), i += `<![CDATA[${u[f][0][t.textNodeName]}]]>`, o = !1;
      continue;
    } else if (f === t.commentPropName) {
      i += r + `<!--${u[f][0][t.textNodeName]}-->`, o = !0;
      continue;
    } else if (f[0] === "?") {
      const E = iK(u[":@"], t), w = f === "?xml" ? "" : r;
      let _ = u[f][0][t.textNodeName];
      _ = _.length !== 0 ? " " + _ : "", i += w + `<${f}${_}${E}?>`, o = !0;
      continue;
    }
    let m = r;
    m !== "" && (m += t.indentBy);
    const v = iK(u[":@"], t), y = r + `<${f}${v}`, S = Gce(u[f], t, p, m);
    t.unpairedTags.indexOf(f) !== -1 ? t.suppressUnpairedNode ? i += y + ">" : i += y + "/>" : (!S || S.length === 0) && t.suppressEmptyNode ? i += y + "/>" : S && S.endsWith(">") ? i += y + `>${S}${r}</${f}>` : (i += y + ">", S && r !== "" && (S.includes("/>") || S.includes("</")) ? i += r + t.indentBy + S + r : i += S, i += `</${f}>`), o = !0;
  }
  return i;
}
function dGe(e) {
  const t = Object.keys(e);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (e.hasOwnProperty(r) && r !== ":@")
      return r;
  }
}
function iK(e, t) {
  let n = "";
  if (e && !t.ignoreAttributes)
    for (let r in e) {
      if (!e.hasOwnProperty(r))
        continue;
      let i = t.attributeValueProcessor(r, e[r]);
      i = Yce(i, t), i === !0 && t.suppressBooleanAttributes ? n += ` ${r.substr(t.attributeNamePrefix.length)}` : n += ` ${r.substr(t.attributeNamePrefix.length)}="${i}"`;
    }
  return n;
}
function fGe(e, t) {
  e = e.substr(0, e.length - t.textNodeName.length - 1);
  let n = e.substr(e.lastIndexOf(".") + 1);
  for (let r in t.stopNodes)
    if (t.stopNodes[r] === e || t.stopNodes[r] === "*." + n)
      return !0;
  return !1;
}
function Yce(e, t) {
  if (e && e.length > 0 && t.processEntities)
    for (let n = 0; n < t.entities.length; n++) {
      const r = t.entities[n];
      e = e.replace(r.regex, r.val);
    }
  return e;
}
var pGe = uGe;
const hGe = pGe, gGe = Wce, mGe = {
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  cdataPropName: !1,
  format: !1,
  indentBy: "  ",
  suppressEmptyNode: !1,
  suppressUnpairedNode: !0,
  suppressBooleanAttributes: !0,
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  preserveOrder: !1,
  commentPropName: !1,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },
    //it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("'", "g"), val: "&apos;" },
    { regex: new RegExp('"', "g"), val: "&quot;" }
  ],
  processEntities: !0,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: !1
};
function Rg(e) {
  this.options = Object.assign({}, mGe, e), this.options.ignoreAttributes === !0 || this.options.attributesGroupName ? this.isAttribute = function() {
    return !1;
  } : (this.ignoreAttributesFn = gGe(this.options.ignoreAttributes), this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = bGe), this.processTextOrObjNode = vGe, this.options.format ? (this.indentate = yGe, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
Rg.prototype.build = function(e) {
  return this.options.preserveOrder ? hGe(e, this.options) : (Array.isArray(e) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (e = {
    [this.options.arrayNodeName]: e
  }), this.j2x(e, 0, []).val);
};
Rg.prototype.j2x = function(e, t, n) {
  let r = "", i = "";
  const o = n.join(".");
  for (let s in e)
    if (Object.prototype.hasOwnProperty.call(e, s))
      if (typeof e[s] > "u")
        this.isAttribute(s) && (i += "");
      else if (e[s] === null)
        this.isAttribute(s) ? i += "" : s[0] === "?" ? i += this.indentate(t) + "<" + s + "?" + this.tagEndChar : i += this.indentate(t) + "<" + s + "/" + this.tagEndChar;
      else if (e[s] instanceof Date)
        i += this.buildTextValNode(e[s], s, "", t);
      else if (typeof e[s] != "object") {
        const u = this.isAttribute(s);
        if (u && !this.ignoreAttributesFn(u, o))
          r += this.buildAttrPairStr(u, "" + e[s]);
        else if (!u)
          if (s === this.options.textNodeName) {
            let f = this.options.tagValueProcessor(s, "" + e[s]);
            i += this.replaceEntitiesValue(f);
          } else
            i += this.buildTextValNode(e[s], s, "", t);
      } else if (Array.isArray(e[s])) {
        const u = e[s].length;
        let f = "", p = "";
        for (let m = 0; m < u; m++) {
          const v = e[s][m];
          if (!(typeof v > "u"))
            if (v === null)
              s[0] === "?" ? i += this.indentate(t) + "<" + s + "?" + this.tagEndChar : i += this.indentate(t) + "<" + s + "/" + this.tagEndChar;
            else if (typeof v == "object")
              if (this.options.oneListGroup) {
                const y = this.j2x(v, t + 1, n.concat(s));
                f += y.val, this.options.attributesGroupName && v.hasOwnProperty(this.options.attributesGroupName) && (p += y.attrStr);
              } else
                f += this.processTextOrObjNode(v, s, t, n);
            else if (this.options.oneListGroup) {
              let y = this.options.tagValueProcessor(s, v);
              y = this.replaceEntitiesValue(y), f += y;
            } else
              f += this.buildTextValNode(v, s, "", t);
        }
        this.options.oneListGroup && (f = this.buildObjectNode(f, s, p, t)), i += f;
      } else if (this.options.attributesGroupName && s === this.options.attributesGroupName) {
        const u = Object.keys(e[s]), f = u.length;
        for (let p = 0; p < f; p++)
          r += this.buildAttrPairStr(u[p], "" + e[s][u[p]]);
      } else
        i += this.processTextOrObjNode(e[s], s, t, n);
  return { attrStr: r, val: i };
};
Rg.prototype.buildAttrPairStr = function(e, t) {
  return t = this.options.attributeValueProcessor(e, "" + t), t = this.replaceEntitiesValue(t), this.options.suppressBooleanAttributes && t === "true" ? " " + e : " " + e + '="' + t + '"';
};
function vGe(e, t, n, r) {
  const i = this.j2x(e, n + 1, r.concat(t));
  return e[this.options.textNodeName] !== void 0 && Object.keys(e).length === 1 ? this.buildTextValNode(e[this.options.textNodeName], t, i.attrStr, n) : this.buildObjectNode(i.val, t, i.attrStr, n);
}
Rg.prototype.buildObjectNode = function(e, t, n, r) {
  if (e === "")
    return t[0] === "?" ? this.indentate(r) + "<" + t + n + "?" + this.tagEndChar : this.indentate(r) + "<" + t + n + this.closeTag(t) + this.tagEndChar;
  {
    let i = "</" + t + this.tagEndChar, o = "";
    return t[0] === "?" && (o = "?", i = ""), (n || n === "") && e.indexOf("<") === -1 ? this.indentate(r) + "<" + t + n + o + ">" + e + i : this.options.commentPropName !== !1 && t === this.options.commentPropName && o.length === 0 ? this.indentate(r) + `<!--${e}-->` + this.newLine : this.indentate(r) + "<" + t + n + o + this.tagEndChar + e + this.indentate(r) + i;
  }
};
Rg.prototype.closeTag = function(e) {
  let t = "";
  return this.options.unpairedTags.indexOf(e) !== -1 ? this.options.suppressUnpairedNode || (t = "/") : this.options.suppressEmptyNode ? t = "/" : t = `></${e}`, t;
};
Rg.prototype.buildTextValNode = function(e, t, n, r) {
  if (this.options.cdataPropName !== !1 && t === this.options.cdataPropName)
    return this.indentate(r) + `<![CDATA[${e}]]>` + this.newLine;
  if (this.options.commentPropName !== !1 && t === this.options.commentPropName)
    return this.indentate(r) + `<!--${e}-->` + this.newLine;
  if (t[0] === "?")
    return this.indentate(r) + "<" + t + n + "?" + this.tagEndChar;
  {
    let i = this.options.tagValueProcessor(t, e);
    return i = this.replaceEntitiesValue(i), i === "" ? this.indentate(r) + "<" + t + n + this.closeTag(t) + this.tagEndChar : this.indentate(r) + "<" + t + n + ">" + i + "</" + t + this.tagEndChar;
  }
};
Rg.prototype.replaceEntitiesValue = function(e) {
  if (e && e.length > 0 && this.options.processEntities)
    for (let t = 0; t < this.options.entities.length; t++) {
      const n = this.options.entities[t];
      e = e.replace(n.regex, n.val);
    }
  return e;
};
function yGe(e) {
  return this.options.indentBy.repeat(e);
}
function bGe(e) {
  return e.startsWith(this.options.attributeNamePrefix) && e !== this.options.textNodeName ? e.substr(this.attrPrefixLen) : !1;
}
var xGe = Rg;
const SGe = nH, wGe = lGe, TGe = xGe;
var Xce = {
  XMLParser: wGe,
  XMLValidator: SGe,
  XMLBuilder: TGe
};
const EGe = new Xce.XMLParser({
  preserveOrder: !0,
  ignoreAttributes: !1,
  attributeNamePrefix: "",
  allowBooleanAttributes: !0,
  commentPropName: JW,
  cdataPropName: eH,
  parseTagValue: !1
});
function _Ge(e) {
  return Ui(() => {
    try {
      if (!Xce.XMLValidator.validate(e))
        throw new Error("Invalid XML!");
      const t = EGe.parse(e);
      if (typeof e == "string" && e.trim().length > 0 && t.length === 0)
        throw new Error("Invalid XML!");
      return { json: t, valid: !0 };
    } catch (t) {
      return { json: null, valid: !1, errorMessage: `Fail to parse: ${t.message}` };
    }
  }, [e]);
}
function CGe() {
  this.__data__ = [], this.size = 0;
}
var RGe = CGe;
function OGe(e, t) {
  return e === t || e !== e && t !== t;
}
var oH = OGe, AGe = oH;
function DGe(e, t) {
  for (var n = e.length; n--; )
    if (AGe(e[n][0], t))
      return n;
  return -1;
}
var rP = DGe, IGe = rP, PGe = Array.prototype, NGe = PGe.splice;
function MGe(e) {
  var t = this.__data__, n = IGe(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : NGe.call(t, n, 1), --this.size, !0;
}
var jGe = MGe, LGe = rP;
function kGe(e) {
  var t = this.__data__, n = LGe(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var zGe = kGe, BGe = rP;
function VGe(e) {
  return BGe(this.__data__, e) > -1;
}
var UGe = VGe, FGe = rP;
function WGe(e, t) {
  var n = this.__data__, r = FGe(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var HGe = WGe, qGe = RGe, $Ge = jGe, GGe = zGe, YGe = UGe, XGe = HGe;
function Xx(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Xx.prototype.clear = qGe;
Xx.prototype.delete = $Ge;
Xx.prototype.get = GGe;
Xx.prototype.has = YGe;
Xx.prototype.set = XGe;
var iP = Xx, ZGe = iP;
function KGe() {
  this.__data__ = new ZGe(), this.size = 0;
}
var QGe = KGe;
function JGe(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var e9e = JGe;
function t9e(e) {
  return this.__data__.get(e);
}
var n9e = t9e;
function r9e(e) {
  return this.__data__.has(e);
}
var i9e = r9e, o9e = typeof xO == "object" && xO && xO.Object === Object && xO, Zce = o9e, a9e = Zce, s9e = typeof self == "object" && self && self.Object === Object && self, l9e = a9e || s9e || Function("return this")(), Kd = l9e, c9e = Kd, u9e = c9e.Symbol, Zx = u9e, oK = Zx, Kce = Object.prototype, d9e = Kce.hasOwnProperty, f9e = Kce.toString, xE = oK ? oK.toStringTag : void 0;
function p9e(e) {
  var t = d9e.call(e, xE), n = e[xE];
  try {
    e[xE] = void 0;
    var r = !0;
  } catch {
  }
  var i = f9e.call(e);
  return r && (t ? e[xE] = n : delete e[xE]), i;
}
var h9e = p9e, g9e = Object.prototype, m9e = g9e.toString;
function v9e(e) {
  return m9e.call(e);
}
var y9e = v9e, aK = Zx, b9e = h9e, x9e = y9e, S9e = "[object Null]", w9e = "[object Undefined]", sK = aK ? aK.toStringTag : void 0;
function T9e(e) {
  return e == null ? e === void 0 ? w9e : S9e : sK && sK in Object(e) ? b9e(e) : x9e(e);
}
var Kx = T9e;
function E9e(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var N_ = E9e, _9e = Kx, C9e = N_, R9e = "[object AsyncFunction]", O9e = "[object Function]", A9e = "[object GeneratorFunction]", D9e = "[object Proxy]";
function I9e(e) {
  if (!C9e(e))
    return !1;
  var t = _9e(e);
  return t == O9e || t == A9e || t == R9e || t == D9e;
}
var Qce = I9e, P9e = Kd, N9e = P9e["__core-js_shared__"], M9e = N9e, e2 = M9e, lK = (function() {
  var e = /[^.]+$/.exec(e2 && e2.keys && e2.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function j9e(e) {
  return !!lK && lK in e;
}
var L9e = j9e, k9e = Function.prototype, z9e = k9e.toString;
function B9e(e) {
  if (e != null) {
    try {
      return z9e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Jce = B9e, V9e = Qce, U9e = L9e, F9e = N_, W9e = Jce, H9e = /[\\^$.*+?()[\]{}|]/g, q9e = /^\[object .+?Constructor\]$/, $9e = Function.prototype, G9e = Object.prototype, Y9e = $9e.toString, X9e = G9e.hasOwnProperty, Z9e = RegExp(
  "^" + Y9e.call(X9e).replace(H9e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function K9e(e) {
  if (!F9e(e) || U9e(e))
    return !1;
  var t = V9e(e) ? Z9e : q9e;
  return t.test(W9e(e));
}
var Q9e = K9e;
function J9e(e, t) {
  return e == null ? void 0 : e[t];
}
var e7e = J9e, t7e = Q9e, n7e = e7e;
function r7e(e, t) {
  var n = n7e(e, t);
  return t7e(n) ? n : void 0;
}
var sy = r7e, i7e = sy, o7e = Kd, a7e = i7e(o7e, "Map"), aH = a7e, s7e = sy, l7e = s7e(Object, "create"), oP = l7e, cK = oP;
function c7e() {
  this.__data__ = cK ? cK(null) : {}, this.size = 0;
}
var u7e = c7e;
function d7e(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var f7e = d7e, p7e = oP, h7e = "__lodash_hash_undefined__", g7e = Object.prototype, m7e = g7e.hasOwnProperty;
function v7e(e) {
  var t = this.__data__;
  if (p7e) {
    var n = t[e];
    return n === h7e ? void 0 : n;
  }
  return m7e.call(t, e) ? t[e] : void 0;
}
var y7e = v7e, b7e = oP, x7e = Object.prototype, S7e = x7e.hasOwnProperty;
function w7e(e) {
  var t = this.__data__;
  return b7e ? t[e] !== void 0 : S7e.call(t, e);
}
var T7e = w7e, E7e = oP, _7e = "__lodash_hash_undefined__";
function C7e(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = E7e && t === void 0 ? _7e : t, this;
}
var R7e = C7e, O7e = u7e, A7e = f7e, D7e = y7e, I7e = T7e, P7e = R7e;
function Qx(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Qx.prototype.clear = O7e;
Qx.prototype.delete = A7e;
Qx.prototype.get = D7e;
Qx.prototype.has = I7e;
Qx.prototype.set = P7e;
var N7e = Qx, uK = N7e, M7e = iP, j7e = aH;
function L7e() {
  this.size = 0, this.__data__ = {
    hash: new uK(),
    map: new (j7e || M7e)(),
    string: new uK()
  };
}
var k7e = L7e;
function z7e(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var B7e = z7e, V7e = B7e;
function U7e(e, t) {
  var n = e.__data__;
  return V7e(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var aP = U7e, F7e = aP;
function W7e(e) {
  var t = F7e(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var H7e = W7e, q7e = aP;
function $7e(e) {
  return q7e(this, e).get(e);
}
var G7e = $7e, Y7e = aP;
function X7e(e) {
  return Y7e(this, e).has(e);
}
var Z7e = X7e, K7e = aP;
function Q7e(e, t) {
  var n = K7e(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var J7e = Q7e, eYe = k7e, tYe = H7e, nYe = G7e, rYe = Z7e, iYe = J7e;
function Jx(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Jx.prototype.clear = eYe;
Jx.prototype.delete = tYe;
Jx.prototype.get = nYe;
Jx.prototype.has = rYe;
Jx.prototype.set = iYe;
var sH = Jx, oYe = iP, aYe = aH, sYe = sH, lYe = 200;
function cYe(e, t) {
  var n = this.__data__;
  if (n instanceof oYe) {
    var r = n.__data__;
    if (!aYe || r.length < lYe - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new sYe(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var uYe = cYe, dYe = iP, fYe = QGe, pYe = e9e, hYe = n9e, gYe = i9e, mYe = uYe;
function eS(e) {
  var t = this.__data__ = new dYe(e);
  this.size = t.size;
}
eS.prototype.clear = fYe;
eS.prototype.delete = pYe;
eS.prototype.get = hYe;
eS.prototype.has = gYe;
eS.prototype.set = mYe;
var eue = eS, vYe = "__lodash_hash_undefined__";
function yYe(e) {
  return this.__data__.set(e, vYe), this;
}
var bYe = yYe;
function xYe(e) {
  return this.__data__.has(e);
}
var SYe = xYe, wYe = sH, TYe = bYe, EYe = SYe;
function LA(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new wYe(); ++t < n; )
    this.add(e[t]);
}
LA.prototype.add = LA.prototype.push = TYe;
LA.prototype.has = EYe;
var _Ye = LA;
function CYe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var RYe = CYe;
function OYe(e, t) {
  return e.has(t);
}
var AYe = OYe, DYe = _Ye, IYe = RYe, PYe = AYe, NYe = 1, MYe = 2;
function jYe(e, t, n, r, i, o) {
  var s = n & NYe, u = e.length, f = t.length;
  if (u != f && !(s && f > u))
    return !1;
  var p = o.get(e), m = o.get(t);
  if (p && m)
    return p == t && m == e;
  var v = -1, y = !0, S = n & MYe ? new DYe() : void 0;
  for (o.set(e, t), o.set(t, e); ++v < u; ) {
    var E = e[v], w = t[v];
    if (r)
      var _ = s ? r(w, E, v, t, e, o) : r(E, w, v, e, t, o);
    if (_ !== void 0) {
      if (_)
        continue;
      y = !1;
      break;
    }
    if (S) {
      if (!IYe(t, function(O, D) {
        if (!PYe(S, D) && (E === O || i(E, O, n, r, o)))
          return S.push(D);
      })) {
        y = !1;
        break;
      }
    } else if (!(E === w || i(E, w, n, r, o))) {
      y = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), y;
}
var tue = jYe, LYe = Kd, kYe = LYe.Uint8Array, nue = kYe;
function zYe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var BYe = zYe;
function VYe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var UYe = VYe, dK = Zx, fK = nue, FYe = oH, WYe = tue, HYe = BYe, qYe = UYe, $Ye = 1, GYe = 2, YYe = "[object Boolean]", XYe = "[object Date]", ZYe = "[object Error]", KYe = "[object Map]", QYe = "[object Number]", JYe = "[object RegExp]", eXe = "[object Set]", tXe = "[object String]", nXe = "[object Symbol]", rXe = "[object ArrayBuffer]", iXe = "[object DataView]", pK = dK ? dK.prototype : void 0, t2 = pK ? pK.valueOf : void 0;
function oXe(e, t, n, r, i, o, s) {
  switch (n) {
    case iXe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case rXe:
      return !(e.byteLength != t.byteLength || !o(new fK(e), new fK(t)));
    case YYe:
    case XYe:
    case QYe:
      return FYe(+e, +t);
    case ZYe:
      return e.name == t.name && e.message == t.message;
    case JYe:
    case tXe:
      return e == t + "";
    case KYe:
      var u = HYe;
    case eXe:
      var f = r & $Ye;
      if (u || (u = qYe), e.size != t.size && !f)
        return !1;
      var p = s.get(e);
      if (p)
        return p == t;
      r |= GYe, s.set(e, t);
      var m = WYe(u(e), u(t), r, i, o, s);
      return s.delete(e), m;
    case nXe:
      if (t2)
        return t2.call(e) == t2.call(t);
  }
  return !1;
}
var aXe = oXe;
function sXe(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var lH = sXe, lXe = Array.isArray, Og = lXe, cXe = lH, uXe = Og;
function dXe(e, t, n) {
  var r = t(e);
  return uXe(e) ? r : cXe(r, n(e));
}
var rue = dXe;
function fXe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (o[i++] = s);
  }
  return o;
}
var pXe = fXe;
function hXe() {
  return [];
}
var iue = hXe, gXe = pXe, mXe = iue, vXe = Object.prototype, yXe = vXe.propertyIsEnumerable, hK = Object.getOwnPropertySymbols, bXe = hK ? function(e) {
  return e == null ? [] : (e = Object(e), gXe(hK(e), function(t) {
    return yXe.call(e, t);
  }));
} : mXe, cH = bXe;
function xXe(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var SXe = xXe;
function wXe(e) {
  return e != null && typeof e == "object";
}
var Ag = wXe, TXe = Kx, EXe = Ag, _Xe = "[object Arguments]";
function CXe(e) {
  return EXe(e) && TXe(e) == _Xe;
}
var RXe = CXe, gK = RXe, OXe = Ag, oue = Object.prototype, AXe = oue.hasOwnProperty, DXe = oue.propertyIsEnumerable, IXe = gK(/* @__PURE__ */ (function() {
  return arguments;
})()) ? gK : function(e) {
  return OXe(e) && AXe.call(e, "callee") && !DXe.call(e, "callee");
}, aue = IXe, kA = { exports: {} };
function PXe() {
  return !1;
}
var NXe = PXe;
kA.exports;
(function(e, t) {
  var n = Kd, r = NXe, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, s = o && o.exports === i, u = s ? n.Buffer : void 0, f = u ? u.isBuffer : void 0, p = f || r;
  e.exports = p;
})(kA, kA.exports);
var uH = kA.exports, MXe = 9007199254740991, jXe = /^(?:0|[1-9]\d*)$/;
function LXe(e, t) {
  var n = typeof e;
  return t = t ?? MXe, !!t && (n == "number" || n != "symbol" && jXe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var kXe = LXe, zXe = 9007199254740991;
function BXe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= zXe;
}
var sue = BXe, VXe = Kx, UXe = sue, FXe = Ag, WXe = "[object Arguments]", HXe = "[object Array]", qXe = "[object Boolean]", $Xe = "[object Date]", GXe = "[object Error]", YXe = "[object Function]", XXe = "[object Map]", ZXe = "[object Number]", KXe = "[object Object]", QXe = "[object RegExp]", JXe = "[object Set]", eZe = "[object String]", tZe = "[object WeakMap]", nZe = "[object ArrayBuffer]", rZe = "[object DataView]", iZe = "[object Float32Array]", oZe = "[object Float64Array]", aZe = "[object Int8Array]", sZe = "[object Int16Array]", lZe = "[object Int32Array]", cZe = "[object Uint8Array]", uZe = "[object Uint8ClampedArray]", dZe = "[object Uint16Array]", fZe = "[object Uint32Array]", di = {};
di[iZe] = di[oZe] = di[aZe] = di[sZe] = di[lZe] = di[cZe] = di[uZe] = di[dZe] = di[fZe] = !0;
di[WXe] = di[HXe] = di[nZe] = di[qXe] = di[rZe] = di[$Xe] = di[GXe] = di[YXe] = di[XXe] = di[ZXe] = di[KXe] = di[QXe] = di[JXe] = di[eZe] = di[tZe] = !1;
function pZe(e) {
  return FXe(e) && UXe(e.length) && !!di[VXe(e)];
}
var hZe = pZe;
function gZe(e) {
  return function(t) {
    return e(t);
  };
}
var dH = gZe, zA = { exports: {} };
zA.exports;
(function(e, t) {
  var n = Zce, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, s = o && n.process, u = (function() {
    try {
      var f = i && i.require && i.require("util").types;
      return f || s && s.binding && s.binding("util");
    } catch {
    }
  })();
  e.exports = u;
})(zA, zA.exports);
var fH = zA.exports, mZe = hZe, vZe = dH, mK = fH, vK = mK && mK.isTypedArray, yZe = vK ? vZe(vK) : mZe, lue = yZe, bZe = SXe, xZe = aue, SZe = Og, wZe = uH, TZe = kXe, EZe = lue, _Ze = Object.prototype, CZe = _Ze.hasOwnProperty;
function RZe(e, t) {
  var n = SZe(e), r = !n && xZe(e), i = !n && !r && wZe(e), o = !n && !r && !i && EZe(e), s = n || r || i || o, u = s ? bZe(e.length, String) : [], f = u.length;
  for (var p in e)
    (t || CZe.call(e, p)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
    TZe(p, f))) && u.push(p);
  return u;
}
var cue = RZe, OZe = Object.prototype;
function AZe(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || OZe;
  return e === n;
}
var pH = AZe;
function DZe(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var uue = DZe, IZe = uue, PZe = IZe(Object.keys, Object), NZe = PZe, MZe = pH, jZe = NZe, LZe = Object.prototype, kZe = LZe.hasOwnProperty;
function zZe(e) {
  if (!MZe(e))
    return jZe(e);
  var t = [];
  for (var n in Object(e))
    kZe.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var BZe = zZe, VZe = Qce, UZe = sue;
function FZe(e) {
  return e != null && UZe(e.length) && !VZe(e);
}
var due = FZe, WZe = cue, HZe = BZe, qZe = due;
function $Ze(e) {
  return qZe(e) ? WZe(e) : HZe(e);
}
var hH = $Ze, GZe = rue, YZe = cH, XZe = hH;
function ZZe(e) {
  return GZe(e, XZe, YZe);
}
var fue = ZZe, yK = fue, KZe = 1, QZe = Object.prototype, JZe = QZe.hasOwnProperty;
function eKe(e, t, n, r, i, o) {
  var s = n & KZe, u = yK(e), f = u.length, p = yK(t), m = p.length;
  if (f != m && !s)
    return !1;
  for (var v = f; v--; ) {
    var y = u[v];
    if (!(s ? y in t : JZe.call(t, y)))
      return !1;
  }
  var S = o.get(e), E = o.get(t);
  if (S && E)
    return S == t && E == e;
  var w = !0;
  o.set(e, t), o.set(t, e);
  for (var _ = s; ++v < f; ) {
    y = u[v];
    var O = e[y], D = t[y];
    if (r)
      var P = s ? r(D, O, y, t, e, o) : r(O, D, y, e, t, o);
    if (!(P === void 0 ? O === D || i(O, D, n, r, o) : P)) {
      w = !1;
      break;
    }
    _ || (_ = y == "constructor");
  }
  if (w && !_) {
    var M = e.constructor, N = t.constructor;
    M != N && "constructor" in e && "constructor" in t && !(typeof M == "function" && M instanceof M && typeof N == "function" && N instanceof N) && (w = !1);
  }
  return o.delete(e), o.delete(t), w;
}
var tKe = eKe, nKe = sy, rKe = Kd, iKe = nKe(rKe, "DataView"), oKe = iKe, aKe = sy, sKe = Kd, lKe = aKe(sKe, "Promise"), cKe = lKe, uKe = sy, dKe = Kd, fKe = uKe(dKe, "Set"), pKe = fKe, hKe = sy, gKe = Kd, mKe = hKe(gKe, "WeakMap"), vKe = mKe, HV = oKe, qV = aH, $V = cKe, GV = pKe, YV = vKe, pue = Kx, tS = Jce, bK = "[object Map]", yKe = "[object Object]", xK = "[object Promise]", SK = "[object Set]", wK = "[object WeakMap]", TK = "[object DataView]", bKe = tS(HV), xKe = tS(qV), SKe = tS($V), wKe = tS(GV), TKe = tS(YV), vv = pue;
(HV && vv(new HV(new ArrayBuffer(1))) != TK || qV && vv(new qV()) != bK || $V && vv($V.resolve()) != xK || GV && vv(new GV()) != SK || YV && vv(new YV()) != wK) && (vv = function(e) {
  var t = pue(e), n = t == yKe ? e.constructor : void 0, r = n ? tS(n) : "";
  if (r)
    switch (r) {
      case bKe:
        return TK;
      case xKe:
        return bK;
      case SKe:
        return xK;
      case wKe:
        return SK;
      case TKe:
        return wK;
    }
  return t;
});
var sP = vv, n2 = eue, EKe = tue, _Ke = aXe, CKe = tKe, EK = sP, _K = Og, CK = uH, RKe = lue, OKe = 1, RK = "[object Arguments]", OK = "[object Array]", SO = "[object Object]", AKe = Object.prototype, AK = AKe.hasOwnProperty;
function DKe(e, t, n, r, i, o) {
  var s = _K(e), u = _K(t), f = s ? OK : EK(e), p = u ? OK : EK(t);
  f = f == RK ? SO : f, p = p == RK ? SO : p;
  var m = f == SO, v = p == SO, y = f == p;
  if (y && CK(e)) {
    if (!CK(t))
      return !1;
    s = !0, m = !1;
  }
  if (y && !m)
    return o || (o = new n2()), s || RKe(e) ? EKe(e, t, n, r, i, o) : _Ke(e, t, f, n, r, i, o);
  if (!(n & OKe)) {
    var S = m && AK.call(e, "__wrapped__"), E = v && AK.call(t, "__wrapped__");
    if (S || E) {
      var w = S ? e.value() : e, _ = E ? t.value() : t;
      return o || (o = new n2()), i(w, _, n, r, o);
    }
  }
  return y ? (o || (o = new n2()), CKe(e, t, n, r, i, o)) : !1;
}
var IKe = DKe, PKe = IKe, DK = Ag;
function hue(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !DK(e) && !DK(t) ? e !== e && t !== t : PKe(e, t, n, r, hue, i);
}
var NKe = hue, MKe = NKe;
function jKe(e, t) {
  return MKe(e, t);
}
var LKe = jKe;
const kKe = /* @__PURE__ */ tH(LKe);
function zKe(e) {
  const { indentation: t, children: n, isInline: r } = e, { theme: i } = hp();
  return /* @__PURE__ */ T.jsxs("div", { style: { color: i.cdataColor }, children: [
    /* @__PURE__ */ T.jsx("span", { children: `${t}<![CDATA[` }),
    n,
    /* @__PURE__ */ T.jsx("span", { children: `${r ? "" : t}]]>` })
  ] });
}
const BKe = (e) => /* @__PURE__ */ $.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ $.createElement("path", { d: "M9 17.898C9 18.972 10.2649 19.546 11.0731 18.8388L17.3838 13.3169C18.1806 12.6197 18.1806 11.3801 17.3838 10.6829L11.0731 5.16108C10.2649 4.45388 9 5.02785 9 6.1018V17.898Z" }));
function gue(e) {
  const { collapsible: t, theme: n } = hp(), { collapsed: r } = e;
  return t ? /* @__PURE__ */ T.jsx("span", { style: { position: "relative" }, children: /* @__PURE__ */ T.jsx("span", { style: { position: "absolute", right: "0", border: 0, padding: 0, background: "none" }, children: /* @__PURE__ */ T.jsx(
    BKe,
    {
      fill: n.separatorColor,
      style: { transform: `rotate(${r ? 0 : 90}deg)`, transition: "transform 0.2s" }
    }
  ) }) }) : null;
}
function VKe(e) {
  return e == null;
}
var UKe = VKe;
const IK = /* @__PURE__ */ tH(UKe);
function mue(e) {
  const { collapsible: t, initialCollapsedDepth: n } = hp(), [r, i] = Bn(
    () => IK(n) || !t ? !1 : e >= n
  ), o = () => i((s) => !s);
  return ln(() => {
    i(
      IK(n) || !t ? !1 : e >= n
    );
  }, [n, e, t]), {
    collapsed: r,
    buttonProps: t ? {
      onClick: o,
      role: "button",
      style: { cursor: "pointer" }
    } : {}
  };
}
function FKe(e) {
  const { indentation: t, children: n, isInline: r, level: i } = e, { theme: o } = hp(), { collapsed: s, buttonProps: u } = mue(i);
  return /* @__PURE__ */ T.jsxs("div", { style: { color: o.commentColor }, children: [
    /* @__PURE__ */ T.jsxs("span", { ...u, children: [
      /* @__PURE__ */ T.jsx("span", { children: t }),
      /* @__PURE__ */ T.jsx(gue, { collapsed: s }),
      /* @__PURE__ */ T.jsx("span", { children: "<!-- " })
    ] }),
    !s && n,
    s && "...",
    /* @__PURE__ */ T.jsx("span", { children: `${r || s ? " " : t}-->` })
  ] });
}
function vue(e) {
  const { attributes: t } = e, { theme: n } = hp();
  return t ? /* @__PURE__ */ T.jsx("span", { children: Object.entries(t).map(([r, i]) => /* @__PURE__ */ T.jsxs("span", { children: [
    /* @__PURE__ */ T.jsx("span", { style: { color: n.attributeKeyColor }, children: ` ${r}` }),
    /* @__PURE__ */ T.jsx("span", { style: { color: n.separatorColor }, children: "=" }),
    /* @__PURE__ */ T.jsx("span", { style: { color: n.attributeValueColor }, children: `"${i}"` })
  ] }, `attribute-${r}`)) }) : null;
}
function WKe(e) {
  const { indentation: t, tagKey: n, attributes: r } = e, { theme: i } = hp();
  return /* @__PURE__ */ T.jsxs("div", { children: [
    /* @__PURE__ */ T.jsx("span", { style: { color: i.separatorColor }, children: `${t}<?` }),
    /* @__PURE__ */ T.jsx("span", { style: { color: i.tagColor }, children: `${n.slice(1)}` }),
    /* @__PURE__ */ T.jsx(vue, { attributes: r }),
    /* @__PURE__ */ T.jsx("span", { style: { color: i.separatorColor }, children: "?>" })
  ] });
}
function HKe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var yue = HKe;
function qKe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var $Ke = qKe, GKe = sy, YKe = (function() {
  try {
    var e = GKe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), bue = YKe, PK = bue;
function XKe(e, t, n) {
  t == "__proto__" && PK ? PK(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var xue = XKe, ZKe = xue, KKe = oH, QKe = Object.prototype, JKe = QKe.hasOwnProperty;
function eQe(e, t, n) {
  var r = e[t];
  (!(JKe.call(e, t) && KKe(r, n)) || n === void 0 && !(t in e)) && ZKe(e, t, n);
}
var Sue = eQe, tQe = Sue, nQe = xue;
function rQe(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = t.length; ++o < s; ) {
    var u = t[o], f = r ? r(n[u], e[u], u, n, e) : void 0;
    f === void 0 && (f = e[u]), i ? nQe(n, u, f) : tQe(n, u, f);
  }
  return n;
}
var M_ = rQe, iQe = M_, oQe = hH;
function aQe(e, t) {
  return e && iQe(t, oQe(t), e);
}
var sQe = aQe;
function lQe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var cQe = lQe, uQe = N_, dQe = pH, fQe = cQe, pQe = Object.prototype, hQe = pQe.hasOwnProperty;
function gQe(e) {
  if (!uQe(e))
    return fQe(e);
  var t = dQe(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !hQe.call(e, r)) || n.push(r);
  return n;
}
var mQe = gQe, vQe = cue, yQe = mQe, bQe = due;
function xQe(e) {
  return bQe(e) ? vQe(e, !0) : yQe(e);
}
var gH = xQe, SQe = M_, wQe = gH;
function TQe(e, t) {
  return e && SQe(t, wQe(t), e);
}
var EQe = TQe, BA = { exports: {} };
BA.exports;
(function(e, t) {
  var n = Kd, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, s = o ? n.Buffer : void 0, u = s ? s.allocUnsafe : void 0;
  function f(p, m) {
    if (m)
      return p.slice();
    var v = p.length, y = u ? u(v) : new p.constructor(v);
    return p.copy(y), y;
  }
  e.exports = f;
})(BA, BA.exports);
var _Qe = BA.exports;
function CQe(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var RQe = CQe, OQe = M_, AQe = cH;
function DQe(e, t) {
  return OQe(e, AQe(e), t);
}
var IQe = DQe, PQe = uue, NQe = PQe(Object.getPrototypeOf, Object), mH = NQe, MQe = lH, jQe = mH, LQe = cH, kQe = iue, zQe = Object.getOwnPropertySymbols, BQe = zQe ? function(e) {
  for (var t = []; e; )
    MQe(t, LQe(e)), e = jQe(e);
  return t;
} : kQe, wue = BQe, VQe = M_, UQe = wue;
function FQe(e, t) {
  return VQe(e, UQe(e), t);
}
var WQe = FQe, HQe = rue, qQe = wue, $Qe = gH;
function GQe(e) {
  return HQe(e, $Qe, qQe);
}
var Tue = GQe, YQe = Object.prototype, XQe = YQe.hasOwnProperty;
function ZQe(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && XQe.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var KQe = ZQe, NK = nue;
function QQe(e) {
  var t = new e.constructor(e.byteLength);
  return new NK(t).set(new NK(e)), t;
}
var vH = QQe, JQe = vH;
function eJe(e, t) {
  var n = t ? JQe(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var tJe = eJe, nJe = /\w*$/;
function rJe(e) {
  var t = new e.constructor(e.source, nJe.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var iJe = rJe, MK = Zx, jK = MK ? MK.prototype : void 0, LK = jK ? jK.valueOf : void 0;
function oJe(e) {
  return LK ? Object(LK.call(e)) : {};
}
var aJe = oJe, sJe = vH;
function lJe(e, t) {
  var n = t ? sJe(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var cJe = lJe, uJe = vH, dJe = tJe, fJe = iJe, pJe = aJe, hJe = cJe, gJe = "[object Boolean]", mJe = "[object Date]", vJe = "[object Map]", yJe = "[object Number]", bJe = "[object RegExp]", xJe = "[object Set]", SJe = "[object String]", wJe = "[object Symbol]", TJe = "[object ArrayBuffer]", EJe = "[object DataView]", _Je = "[object Float32Array]", CJe = "[object Float64Array]", RJe = "[object Int8Array]", OJe = "[object Int16Array]", AJe = "[object Int32Array]", DJe = "[object Uint8Array]", IJe = "[object Uint8ClampedArray]", PJe = "[object Uint16Array]", NJe = "[object Uint32Array]";
function MJe(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case TJe:
      return uJe(e);
    case gJe:
    case mJe:
      return new r(+e);
    case EJe:
      return dJe(e, n);
    case _Je:
    case CJe:
    case RJe:
    case OJe:
    case AJe:
    case DJe:
    case IJe:
    case PJe:
    case NJe:
      return hJe(e, n);
    case vJe:
      return new r();
    case yJe:
    case SJe:
      return new r(e);
    case bJe:
      return fJe(e);
    case xJe:
      return new r();
    case wJe:
      return pJe(e);
  }
}
var jJe = MJe, LJe = N_, kK = Object.create, kJe = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!LJe(t))
      return {};
    if (kK)
      return kK(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
})(), zJe = kJe, BJe = zJe, VJe = mH, UJe = pH;
function FJe(e) {
  return typeof e.constructor == "function" && !UJe(e) ? BJe(VJe(e)) : {};
}
var WJe = FJe, HJe = sP, qJe = Ag, $Je = "[object Map]";
function GJe(e) {
  return qJe(e) && HJe(e) == $Je;
}
var YJe = GJe, XJe = YJe, ZJe = dH, zK = fH, BK = zK && zK.isMap, KJe = BK ? ZJe(BK) : XJe, QJe = KJe, JJe = sP, eet = Ag, tet = "[object Set]";
function net(e) {
  return eet(e) && JJe(e) == tet;
}
var ret = net, iet = ret, oet = dH, VK = fH, UK = VK && VK.isSet, aet = UK ? oet(UK) : iet, set = aet, cet = eue, uet = $Ke, det = Sue, fet = sQe, pet = EQe, het = _Qe, get = RQe, met = IQe, vet = WQe, yet = fue, bet = Tue, xet = sP, wet = KQe, Tet = jJe, Eet = WJe, _et = Og, Cet = uH, Ret = QJe, Oet = N_, Aet = set, Det = hH, Iet = gH, Pet = 1, Net = 2, Met = 4, Eue = "[object Arguments]", jet = "[object Array]", Let = "[object Boolean]", ket = "[object Date]", zet = "[object Error]", _ue = "[object Function]", Bet = "[object GeneratorFunction]", Vet = "[object Map]", Uet = "[object Number]", Cue = "[object Object]", Fet = "[object RegExp]", Wet = "[object Set]", Het = "[object String]", qet = "[object Symbol]", $et = "[object WeakMap]", Get = "[object ArrayBuffer]", Yet = "[object DataView]", Xet = "[object Float32Array]", Zet = "[object Float64Array]", Ket = "[object Int8Array]", Qet = "[object Int16Array]", Jet = "[object Int32Array]", ett = "[object Uint8Array]", ttt = "[object Uint8ClampedArray]", ntt = "[object Uint16Array]", rtt = "[object Uint32Array]", oi = {};
oi[Eue] = oi[jet] = oi[Get] = oi[Yet] = oi[Let] = oi[ket] = oi[Xet] = oi[Zet] = oi[Ket] = oi[Qet] = oi[Jet] = oi[Vet] = oi[Uet] = oi[Cue] = oi[Fet] = oi[Wet] = oi[Het] = oi[qet] = oi[ett] = oi[ttt] = oi[ntt] = oi[rtt] = !0;
oi[zet] = oi[_ue] = oi[$et] = !1;
function KO(e, t, n, r, i, o) {
  var s, u = t & Pet, f = t & Net, p = t & Met;
  if (n && (s = i ? n(e, r, i, o) : n(e)), s !== void 0)
    return s;
  if (!Oet(e))
    return e;
  var m = _et(e);
  if (m) {
    if (s = wet(e), !u)
      return get(e, s);
  } else {
    var v = xet(e), y = v == _ue || v == Bet;
    if (Cet(e))
      return het(e, u);
    if (v == Cue || v == Eue || y && !i) {
      if (s = f || y ? {} : Eet(e), !u)
        return f ? vet(e, pet(s, e)) : met(e, fet(s, e));
    } else {
      if (!oi[v])
        return i ? e : {};
      s = Tet(e, v, u);
    }
  }
  o || (o = new cet());
  var S = o.get(e);
  if (S)
    return S;
  o.set(e, s), Aet(e) ? e.forEach(function(_) {
    s.add(KO(_, t, n, _, e, o));
  }) : Ret(e) && e.forEach(function(_, O) {
    s.set(O, KO(_, t, n, O, e, o));
  });
  var E = p ? f ? bet : yet : f ? Iet : Det, w = m ? void 0 : E(e);
  return uet(w || e, function(_, O) {
    w && (O = _, _ = e[O]), det(s, O, KO(_, t, n, O, e, o));
  }), s;
}
var itt = KO, ott = Kx, att = Ag, stt = "[object Symbol]";
function ltt(e) {
  return typeof e == "symbol" || att(e) && ott(e) == stt;
}
var yH = ltt, ctt = Og, utt = yH, dtt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ftt = /^\w*$/;
function ptt(e, t) {
  if (ctt(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || utt(e) ? !0 : ftt.test(e) || !dtt.test(e) || t != null && e in Object(t);
}
var htt = ptt, Rue = sH, gtt = "Expected a function";
function bH(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(gtt);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (bH.Cache || Rue)(), n;
}
bH.Cache = Rue;
var mtt = bH, vtt = mtt, ytt = 500;
function btt(e) {
  var t = vtt(e, function(r) {
    return n.size === ytt && n.clear(), r;
  }), n = t.cache;
  return t;
}
var xtt = btt, Stt = xtt, wtt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ttt = /\\(\\)?/g, Ett = Stt(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(wtt, function(n, r, i, o) {
    t.push(i ? o.replace(Ttt, "$1") : r || n);
  }), t;
}), _tt = Ett, FK = Zx, Ctt = yue, Rtt = Og, Ott = yH, WK = FK ? FK.prototype : void 0, HK = WK ? WK.toString : void 0;
function Oue(e) {
  if (typeof e == "string")
    return e;
  if (Rtt(e))
    return Ctt(e, Oue) + "";
  if (Ott(e))
    return HK ? HK.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Att = Oue, Dtt = Att;
function Itt(e) {
  return e == null ? "" : Dtt(e);
}
var Ptt = Itt, Ntt = Og, Mtt = htt, jtt = _tt, Ltt = Ptt;
function ktt(e, t) {
  return Ntt(e) ? e : Mtt(e, t) ? [e] : jtt(Ltt(e));
}
var xH = ktt;
function ztt(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Btt = ztt, Vtt = yH;
function Utt(e) {
  if (typeof e == "string" || Vtt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Aue = Utt, Ftt = xH, Wtt = Aue;
function Htt(e, t) {
  t = Ftt(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Wtt(t[n++])];
  return n && n == r ? e : void 0;
}
var qtt = Htt;
function $tt(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var Gtt = $tt, Ytt = qtt, Xtt = Gtt;
function Ztt(e, t) {
  return t.length < 2 ? e : Ytt(e, Xtt(t, 0, -1));
}
var Ktt = Ztt, Qtt = xH, Jtt = Btt, ent = Ktt, tnt = Aue;
function nnt(e, t) {
  return t = Qtt(t, e), e = ent(e, t), e == null || delete e[tnt(Jtt(t))];
}
var rnt = nnt, int = Kx, ont = mH, ant = Ag, snt = "[object Object]", lnt = Function.prototype, cnt = Object.prototype, Due = lnt.toString, unt = cnt.hasOwnProperty, dnt = Due.call(Object);
function fnt(e) {
  if (!ant(e) || int(e) != snt)
    return !1;
  var t = ont(e);
  if (t === null)
    return !0;
  var n = unt.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Due.call(n) == dnt;
}
var pnt = fnt, hnt = pnt;
function gnt(e) {
  return hnt(e) ? void 0 : e;
}
var mnt = gnt, qK = Zx, vnt = aue, ynt = Og, $K = qK ? qK.isConcatSpreadable : void 0;
function bnt(e) {
  return ynt(e) || vnt(e) || !!($K && e && e[$K]);
}
var xnt = bnt, Snt = lH, wnt = xnt;
function Iue(e, t, n, r, i) {
  var o = -1, s = e.length;
  for (n || (n = wnt), i || (i = []); ++o < s; ) {
    var u = e[o];
    t > 0 && n(u) ? t > 1 ? Iue(u, t - 1, n, r, i) : Snt(i, u) : r || (i[i.length] = u);
  }
  return i;
}
var Tnt = Iue, Ent = Tnt;
function _nt(e) {
  var t = e == null ? 0 : e.length;
  return t ? Ent(e, 1) : [];
}
var Cnt = _nt;
function Rnt(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Ont = Rnt, Ant = Ont, GK = Math.max;
function Dnt(e, t, n) {
  return t = GK(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = GK(r.length - t, 0), s = Array(o); ++i < o; )
      s[i] = r[t + i];
    i = -1;
    for (var u = Array(t + 1); ++i < t; )
      u[i] = r[i];
    return u[t] = n(s), Ant(e, this, u);
  };
}
var Int = Dnt;
function Pnt(e) {
  return function() {
    return e;
  };
}
var Nnt = Pnt;
function Mnt(e) {
  return e;
}
var jnt = Mnt, Lnt = Nnt, YK = bue, knt = jnt, znt = YK ? function(e, t) {
  return YK(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Lnt(t),
    writable: !0
  });
} : knt, Bnt = znt, Vnt = 800, Unt = 16, Fnt = Date.now;
function Wnt(e) {
  var t = 0, n = 0;
  return function() {
    var r = Fnt(), i = Unt - (r - n);
    if (n = r, i > 0) {
      if (++t >= Vnt)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Hnt = Wnt, qnt = Bnt, $nt = Hnt, Gnt = $nt(qnt), Ynt = Gnt, Xnt = Cnt, Znt = Int, Knt = Ynt;
function Qnt(e) {
  return Knt(Znt(e, void 0, Xnt), e + "");
}
var Jnt = Qnt, ert = yue, trt = itt, nrt = rnt, rrt = xH, irt = M_, ort = mnt, art = Jnt, srt = Tue, lrt = 1, crt = 2, urt = 4, drt = art(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = ert(t, function(o) {
    return o = rrt(o, e), r || (r = o.length > 1), o;
  }), irt(e, srt(e), n), r && (n = trt(n, lrt | crt | urt, ort));
  for (var i = t.length; i--; )
    nrt(n, t[i]);
  return n;
}), frt = drt;
const prt = /* @__PURE__ */ tH(frt);
function hrt(e, t) {
  return new Array(t * e + 1).join(" ");
}
function Pue(e) {
  return typeof e == "string" && e.includes(`
`);
}
function grt(e) {
  return typeof e == "string" ? !1 : e.length === 1 && jA in e[0] && !Pue(e[0][jA]);
}
function mrt(e) {
  switch (e) {
    case jA:
    case eH:
    case JW:
      return e;
    default:
      return e.startsWith("?") ? Vce : o8e;
  }
}
function vrt(e) {
  const t = e[JZ], n = prt(e, JZ), [[r, i]] = Object.entries(n), o = mrt(r);
  return { attributes: t, tagKey: r, subElements: i, type: o };
}
function yrt(e) {
  return e ? Object.keys(e).length > 0 : !1;
}
function brt(e) {
  const { indentation: t, tagKey: n, attributes: r, children: i, isInline: o, hasChildren: s, level: u } = e, { collapsed: f, buttonProps: p } = mue(u), { theme: m } = hp();
  return /* @__PURE__ */ T.jsxs("div", { children: [
    /* @__PURE__ */ T.jsxs("span", { ...p, children: [
      /* @__PURE__ */ T.jsx("span", { children: t }),
      /* @__PURE__ */ T.jsx(gue, { collapsed: f }),
      /* @__PURE__ */ T.jsx("span", { style: { color: m.separatorColor }, children: "<" }),
      /* @__PURE__ */ T.jsx("span", { style: { color: m.tagColor }, children: `${n}` }),
      !f && /* @__PURE__ */ T.jsx(vue, { attributes: r }),
      f && yrt(r) && " ...",
      /* @__PURE__ */ T.jsx("span", { style: { color: m.separatorColor }, children: s ? ">" : " />" })
    ] }),
    s && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
      !f && i,
      f && "...",
      /* @__PURE__ */ T.jsx("span", { style: { color: m.separatorColor }, children: `${o || f ? "" : t}</` }),
      /* @__PURE__ */ T.jsx("span", { style: { color: m.tagColor }, children: `${n}` }),
      /* @__PURE__ */ T.jsx("span", { style: { color: m.separatorColor }, children: ">" })
    ] })
  ] });
}
function xrt(e) {
  const { hasSiblings: t, text: n, indentation: r, isText: i } = e, { theme: o } = hp(), s = i ? { color: o.textColor } : void 0;
  return Pue(n) || t ? /* @__PURE__ */ T.jsx("div", { style: s, children: n.split(`
`).filter((u) => !!u.trim()).map((u, f) => /* @__PURE__ */ T.jsx("div", { children: `${r}${u.trim()}` }, `${f}`)) }) : /* @__PURE__ */ T.jsx("span", { style: s, children: n });
}
function QO(e) {
  const { elements: t, level: n = 0, isText: r = !0 } = e, { indentSize: i } = hp();
  return !Array.isArray(t) || t.length === 0 ? null : /* @__PURE__ */ T.jsx(T.Fragment, { children: t.map((o, s) => {
    const { tagKey: u, attributes: f, subElements: p, type: m } = vrt(o), v = t.length > 1, y = hrt(i, n), S = `${n}-${s}`, E = grt(p);
    switch (m) {
      case jA:
        return /* @__PURE__ */ T.jsx(
          xrt,
          {
            text: p,
            indentation: y,
            hasSiblings: v,
            isText: r
          },
          S
        );
      case JW:
        return /* @__PURE__ */ T.jsx(FKe, { isInline: E, indentation: y, level: n, children: /* @__PURE__ */ T.jsx(QO, { elements: p, level: n + 1, isText: !1 }) }, S);
      case eH:
        return /* @__PURE__ */ T.jsx(zKe, { indentation: y, isInline: E, children: /* @__PURE__ */ T.jsx(QO, { elements: p, level: n + 1, isText: !1 }) }, S);
      case Vce:
        return /* @__PURE__ */ T.jsx(
          WKe,
          {
            indentation: y,
            tagKey: u,
            attributes: f
          },
          S
        );
      default:
        return /* @__PURE__ */ T.jsx(
          brt,
          {
            indentation: y,
            tagKey: u,
            attributes: f,
            isInline: E,
            hasChildren: p.length > 0,
            level: n,
            children: /* @__PURE__ */ T.jsx(QO, { elements: p, level: n + 1 })
          },
          S
        );
    }
  }) });
}
function Srt() {
  return /* @__PURE__ */ T.jsx("div", { children: "Invalid XML!" });
}
function wrt(e) {
  const {
    theme: t,
    xml: n,
    collapsible: r = !1,
    indentSize: i = 2,
    invalidXml: o,
    initalCollapsedDepth: s,
    initialCollapsedDepth: u
  } = e, [f, p] = Bn(() => ({ ...UV, ...t })), { json: m, valid: v } = _Ge(n), y = Ui(
    () => ({
      theme: f,
      collapsible: r,
      indentSize: i,
      initialCollapsedDepth: u ?? s
    }),
    [f, r, i, s, u]
  );
  return ln(() => {
    p((S) => {
      const E = { ...UV, ...t };
      return kKe(E, S) ? S : E;
    });
  }, [t]), v ? /* @__PURE__ */ T.jsx(Uce.Provider, { value: y, children: /* @__PURE__ */ T.jsx(
    "div",
    {
      className: "rxv-container",
      style: { whiteSpace: "pre-wrap", fontFamily: f.fontFamily, overflowWrap: "break-word" },
      children: /* @__PURE__ */ T.jsx(QO, { elements: m })
    }
  ) }) : o || /* @__PURE__ */ T.jsx(Srt, {});
}
var ua = typeof globalThis < "u" && globalThis || typeof self < "u" && self || // eslint-disable-next-line no-undef
typeof global < "u" && global || {}, fs = {
  searchParams: "URLSearchParams" in ua,
  iterable: "Symbol" in ua && "iterator" in Symbol,
  blob: "FileReader" in ua && "Blob" in ua && (function() {
    try {
      return new Blob(), !0;
    } catch {
      return !1;
    }
  })(),
  formData: "FormData" in ua,
  arrayBuffer: "ArrayBuffer" in ua
};
function Trt(e) {
  return e && DataView.prototype.isPrototypeOf(e);
}
if (fs.arrayBuffer)
  var Ert = [
    "[object Int8Array]",
    "[object Uint8Array]",
    "[object Uint8ClampedArray]",
    "[object Int16Array]",
    "[object Uint16Array]",
    "[object Int32Array]",
    "[object Uint32Array]",
    "[object Float32Array]",
    "[object Float64Array]"
  ], _rt = ArrayBuffer.isView || function(e) {
    return e && Ert.indexOf(Object.prototype.toString.call(e)) > -1;
  };
function nS(e) {
  if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || e === "")
    throw new TypeError('Invalid character in header field name: "' + e + '"');
  return e.toLowerCase();
}
function SH(e) {
  return typeof e != "string" && (e = String(e)), e;
}
function wH(e) {
  var t = {
    next: function() {
      var n = e.shift();
      return { done: n === void 0, value: n };
    }
  };
  return fs.iterable && (t[Symbol.iterator] = function() {
    return t;
  }), t;
}
function No(e) {
  this.map = {}, e instanceof No ? e.forEach(function(t, n) {
    this.append(n, t);
  }, this) : Array.isArray(e) ? e.forEach(function(t) {
    if (t.length != 2)
      throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + t.length);
    this.append(t[0], t[1]);
  }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
    this.append(t, e[t]);
  }, this);
}
No.prototype.append = function(e, t) {
  e = nS(e), t = SH(t);
  var n = this.map[e];
  this.map[e] = n ? n + ", " + t : t;
};
No.prototype.delete = function(e) {
  delete this.map[nS(e)];
};
No.prototype.get = function(e) {
  return e = nS(e), this.has(e) ? this.map[e] : null;
};
No.prototype.has = function(e) {
  return this.map.hasOwnProperty(nS(e));
};
No.prototype.set = function(e, t) {
  this.map[nS(e)] = SH(t);
};
No.prototype.forEach = function(e, t) {
  for (var n in this.map)
    this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
};
No.prototype.keys = function() {
  var e = [];
  return this.forEach(function(t, n) {
    e.push(n);
  }), wH(e);
};
No.prototype.values = function() {
  var e = [];
  return this.forEach(function(t) {
    e.push(t);
  }), wH(e);
};
No.prototype.entries = function() {
  var e = [];
  return this.forEach(function(t, n) {
    e.push([n, t]);
  }), wH(e);
};
fs.iterable && (No.prototype[Symbol.iterator] = No.prototype.entries);
function r2(e) {
  if (!e._noBody) {
    if (e.bodyUsed)
      return Promise.reject(new TypeError("Already read"));
    e.bodyUsed = !0;
  }
}
function Nue(e) {
  return new Promise(function(t, n) {
    e.onload = function() {
      t(e.result);
    }, e.onerror = function() {
      n(e.error);
    };
  });
}
function Crt(e) {
  var t = new FileReader(), n = Nue(t);
  return t.readAsArrayBuffer(e), n;
}
function Rrt(e) {
  var t = new FileReader(), n = Nue(t), r = /charset=([A-Za-z0-9_-]+)/.exec(e.type), i = r ? r[1] : "utf-8";
  return t.readAsText(e, i), n;
}
function Ort(e) {
  for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++)
    n[r] = String.fromCharCode(t[r]);
  return n.join("");
}
function XK(e) {
  if (e.slice)
    return e.slice(0);
  var t = new Uint8Array(e.byteLength);
  return t.set(new Uint8Array(e)), t.buffer;
}
function Mue() {
  return this.bodyUsed = !1, this._initBody = function(e) {
    this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : fs.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : fs.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : fs.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : fs.arrayBuffer && fs.blob && Trt(e) ? (this._bodyArrayBuffer = XK(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : fs.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || _rt(e)) ? this._bodyArrayBuffer = XK(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : fs.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
  }, fs.blob && (this.blob = function() {
    var e = r2(this);
    if (e)
      return e;
    if (this._bodyBlob)
      return Promise.resolve(this._bodyBlob);
    if (this._bodyArrayBuffer)
      return Promise.resolve(new Blob([this._bodyArrayBuffer]));
    if (this._bodyFormData)
      throw new Error("could not read FormData body as blob");
    return Promise.resolve(new Blob([this._bodyText]));
  }), this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var e = r2(this);
      return e || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
        this._bodyArrayBuffer.buffer.slice(
          this._bodyArrayBuffer.byteOffset,
          this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
        )
      ) : Promise.resolve(this._bodyArrayBuffer));
    } else {
      if (fs.blob)
        return this.blob().then(Crt);
      throw new Error("could not read as ArrayBuffer");
    }
  }, this.text = function() {
    var e = r2(this);
    if (e)
      return e;
    if (this._bodyBlob)
      return Rrt(this._bodyBlob);
    if (this._bodyArrayBuffer)
      return Promise.resolve(Ort(this._bodyArrayBuffer));
    if (this._bodyFormData)
      throw new Error("could not read FormData body as text");
    return Promise.resolve(this._bodyText);
  }, fs.formData && (this.formData = function() {
    return this.text().then(Irt);
  }), this.json = function() {
    return this.text().then(JSON.parse);
  }, this;
}
var Art = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
function Drt(e) {
  var t = e.toUpperCase();
  return Art.indexOf(t) > -1 ? t : e;
}
function Fv(e, t) {
  if (!(this instanceof Fv))
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  t = t || {};
  var n = t.body;
  if (e instanceof Fv) {
    if (e.bodyUsed)
      throw new TypeError("Already read");
    this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new No(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, !n && e._bodyInit != null && (n = e._bodyInit, e.bodyUsed = !0);
  } else
    this.url = String(e);
  if (this.credentials = t.credentials || this.credentials || "same-origin", (t.headers || !this.headers) && (this.headers = new No(t.headers)), this.method = Drt(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || (function() {
    if ("AbortController" in ua) {
      var o = new AbortController();
      return o.signal;
    }
  })(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && n)
    throw new TypeError("Body not allowed for GET or HEAD requests");
  if (this._initBody(n), (this.method === "GET" || this.method === "HEAD") && (t.cache === "no-store" || t.cache === "no-cache")) {
    var r = /([?&])_=[^&]*/;
    if (r.test(this.url))
      this.url = this.url.replace(r, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
    else {
      var i = /\?/;
      this.url += (i.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
    }
  }
}
Fv.prototype.clone = function() {
  return new Fv(this, { body: this._bodyInit });
};
function Irt(e) {
  var t = new FormData();
  return e.trim().split("&").forEach(function(n) {
    if (n) {
      var r = n.split("="), i = r.shift().replace(/\+/g, " "), o = r.join("=").replace(/\+/g, " ");
      t.append(decodeURIComponent(i), decodeURIComponent(o));
    }
  }), t;
}
function Prt(e) {
  var t = new No(), n = e.replace(/\r?\n[\t ]+/g, " ");
  return n.split("\r").map(function(r) {
    return r.indexOf(`
`) === 0 ? r.substr(1, r.length) : r;
  }).forEach(function(r) {
    var i = r.split(":"), o = i.shift().trim();
    if (o) {
      var s = i.join(":").trim();
      try {
        t.append(o, s);
      } catch (u) {
        console.warn("Response " + u.message);
      }
    }
  }), t;
}
Mue.call(Fv.prototype);
function $d(e, t) {
  if (!(this instanceof $d))
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  if (t || (t = {}), this.type = "default", this.status = t.status === void 0 ? 200 : t.status, this.status < 200 || this.status > 599)
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
  this.ok = this.status >= 200 && this.status < 300, this.statusText = t.statusText === void 0 ? "" : "" + t.statusText, this.headers = new No(t.headers), this.url = t.url || "", this._initBody(e);
}
Mue.call($d.prototype);
$d.prototype.clone = function() {
  return new $d(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new No(this.headers),
    url: this.url
  });
};
$d.error = function() {
  var e = new $d(null, { status: 200, statusText: "" });
  return e.ok = !1, e.status = 0, e.type = "error", e;
};
var Nrt = [301, 302, 303, 307, 308];
$d.redirect = function(e, t) {
  if (Nrt.indexOf(t) === -1)
    throw new RangeError("Invalid status code");
  return new $d(null, { status: t, headers: { location: e } });
};
var xv = ua.DOMException;
try {
  new xv();
} catch {
  xv = function(t, n) {
    this.message = t, this.name = n;
    var r = Error(t);
    this.stack = r.stack;
  }, xv.prototype = Object.create(Error.prototype), xv.prototype.constructor = xv;
}
function TH(e, t) {
  return new Promise(function(n, r) {
    var i = new Fv(e, t);
    if (i.signal && i.signal.aborted)
      return r(new xv("Aborted", "AbortError"));
    var o = new XMLHttpRequest();
    function s() {
      o.abort();
    }
    o.onload = function() {
      var p = {
        statusText: o.statusText,
        headers: Prt(o.getAllResponseHeaders() || "")
      };
      i.url.indexOf("file://") === 0 && (o.status < 200 || o.status > 599) ? p.status = 200 : p.status = o.status, p.url = "responseURL" in o ? o.responseURL : p.headers.get("X-Request-URL");
      var m = "response" in o ? o.response : o.responseText;
      setTimeout(function() {
        n(new $d(m, p));
      }, 0);
    }, o.onerror = function() {
      setTimeout(function() {
        r(new TypeError("Network request failed"));
      }, 0);
    }, o.ontimeout = function() {
      setTimeout(function() {
        r(new TypeError("Network request timed out"));
      }, 0);
    }, o.onabort = function() {
      setTimeout(function() {
        r(new xv("Aborted", "AbortError"));
      }, 0);
    };
    function u(p) {
      try {
        return p === "" && ua.location.href ? ua.location.href : p;
      } catch {
        return p;
      }
    }
    if (o.open(i.method, u(i.url), !0), i.credentials === "include" ? o.withCredentials = !0 : i.credentials === "omit" && (o.withCredentials = !1), "responseType" in o && (fs.blob ? o.responseType = "blob" : fs.arrayBuffer && (o.responseType = "arraybuffer")), t && typeof t.headers == "object" && !(t.headers instanceof No || ua.Headers && t.headers instanceof ua.Headers)) {
      var f = [];
      Object.getOwnPropertyNames(t.headers).forEach(function(p) {
        f.push(nS(p)), o.setRequestHeader(p, SH(t.headers[p]));
      }), i.headers.forEach(function(p, m) {
        f.indexOf(m) === -1 && o.setRequestHeader(m, p);
      });
    } else
      i.headers.forEach(function(p, m) {
        o.setRequestHeader(m, p);
      });
    i.signal && (i.signal.addEventListener("abort", s), o.onreadystatechange = function() {
      o.readyState === 4 && i.signal.removeEventListener("abort", s);
    }), o.send(typeof i._bodyInit > "u" ? null : i._bodyInit);
  });
}
TH.polyfill = !0;
ua.fetch || (ua.fetch = TH, ua.Headers = No, ua.Request = Fv, ua.Response = $d);
self.$RefreshReg$ = () => {
};
self.$RefreshSig$ = () => () => {
};
const jue = ({
  config: e,
  containerId: t,
  manifestId: n = "",
  relatedLinks: r = [],
  updateConfig: i,
  windowId: o
}) => {
  const { dialogOpen: s, enabled: u, xmlSource: f } = e;
  if (!u || !s)
    return null;
  const p = (function(S) {
    var E;
    return S ? (E = S.find((w) => w.schema === "http://www.loc.gov/mods/v3")) == null ? void 0 : E.id : null;
  })(r);
  if (!p) return null;
  if (!e.xmlSource)
    return TH(p).then((y) => y.text()).then((y) => {
      i(
        {
          ...e,
          xmlSource: y
        }
      );
    }), null;
  const m = () => i({
    ...e,
    dialogOpen: !1
  }), v = Rhe();
  return /* @__PURE__ */ T.jsx(Ohe, { theme: v, children: /* @__PURE__ */ T.jsxs(
    D_,
    {
      container: document.querySelector(`#${t} .${Nt("viewer")}`),
      fullWidth: !0,
      maxWidth: "xl",
      onClose: m,
      open: s,
      scroll: "paper",
      children: [
        /* @__PURE__ */ T.jsx(_g, { disableTypography: !0, children: /* @__PURE__ */ T.jsx(St, { variant: "h4", children: /* @__PURE__ */ T.jsx(ur, { fontWeight: "fontWeightBold", children: "MODS XML" }) }) }),
        /* @__PURE__ */ T.jsx(Cg, { children: /* @__PURE__ */ T.jsx(wrt, { xml: f }) }),
        /* @__PURE__ */ T.jsx($x, { children: /* @__PURE__ */ T.jsx(hi, { color: "primary", onClick: m, children: "Close" }) })
      ]
    }
  ) });
};
jue.propTypes = {
  config: c.shape({
    dialogOpen: c.bool.isRequired,
    enabled: c.bool.isRequired,
    xmlSource: c.string
  }).isRequired,
  containerId: c.string.isRequired,
  manifestId: c.string,
  relatedLinks: c.arrayOf(
    c.shape({
      format: c.string,
      label: c.string,
      profile: c.string,
      schema: c.string,
      value: c.string
    })
  ),
  updateConfig: c.func.isRequired,
  windowId: c.string.isRequired
};
const Mrt = {
  // Open the view dialog
  dialogOpen: !1,
  // Enable the plugin
  enabled: !0
}, ZK = Qe(
  [fa],
  ({ viewXmlDialog: e = {} }) => ({
    ...Mrt,
    ...e
  })
), jrt = [
  {
    component: Bce,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      /** */
      updateConfig(n) {
        return e(Po(t, { viewXmlDialog: n }));
      }
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      config: ZK(e, { windowId: t }),
      containerId: Du(e)
    }),
    mode: "add",
    name: "MiradorViewXmlPlugin",
    target: "WindowTopBarPluginArea"
  },
  {
    component: jue,
    config: {},
    mapDispatchToProps: (e, { windowId: t }) => ({
      /** */
      updateConfig(n) {
        return e(Po(t, { viewXmlDialog: n }));
      }
    }),
    mapStateToProps: (e, { windowId: t }) => ({
      config: ZK(e, { windowId: t }),
      containerId: Du(e),
      manifestId: B1(e, { windowId: t }),
      relatedLinks: Rqe(e, { windowId: t })
    }),
    mode: "add",
    name: "MiradorViewXmlDialog",
    target: "Window"
  }
], Lrt = {
  canvasLinkPlugin: pqe,
  canvasRelatedLinksPlugin: wqe,
  citationsSidebarPlugin: zqe,
  collectionFoldersPlugin: D6e,
  downloadDialogPlugin: W6e,
  hintingSideBar: B$e,
  nativeObjectViewerPlugin: q$e,
  videojsPlugin: n8e,
  viewerNavigation: r8e,
  viewXmlPlugin: jrt
};
var SE = {}, KK;
function krt() {
  if (KK) return SE;
  KK = 1, Object.defineProperty(SE, "__esModule", {
    value: !0
  }), SE.default = void 0;
  var e = t(it);
  function t(D) {
    return D && D.__esModule ? D : { default: D };
  }
  function n(D) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(M) {
      return typeof M;
    } : n = function(M) {
      return M && typeof Symbol == "function" && M.constructor === Symbol && M !== Symbol.prototype ? "symbol" : typeof M;
    }, n(D);
  }
  function r(D) {
    for (var P = 1; P < arguments.length; P++) {
      var M = arguments[P] != null ? arguments[P] : {}, N = Object.keys(M);
      typeof Object.getOwnPropertySymbols == "function" && (N = N.concat(Object.getOwnPropertySymbols(M).filter(function(k) {
        return Object.getOwnPropertyDescriptor(M, k).enumerable;
      }))), N.forEach(function(k) {
        y(D, k, M[k]);
      });
    }
    return D;
  }
  function i(D, P) {
    if (!(D instanceof P))
      throw new TypeError("Cannot call a class as a function");
  }
  function o(D, P) {
    if (typeof P != "function" && P !== null)
      throw new TypeError("Super expression must either be null or a function");
    s(D.prototype, P && P.prototype), P && s(D, P);
  }
  function s(D, P) {
    return s = Object.setPrototypeOf || function(N, k) {
      return N.__proto__ = k, N;
    }, s(D, P);
  }
  function u(D, P) {
    for (var M = 0; M < P.length; M++) {
      var N = P[M];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(D, N.key, N);
    }
  }
  function f(D, P, M) {
    return P && u(D.prototype, P), D;
  }
  function p(D, P) {
    return P && (n(P) === "object" || typeof P == "function") ? P : v(D);
  }
  function m(D) {
    return m = Object.getPrototypeOf || function(M) {
      return M.__proto__;
    }, m(D);
  }
  function v(D) {
    if (D === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return D;
  }
  function y(D, P, M) {
    return P in D ? Object.defineProperty(D, P, { value: M, enumerable: !0, configurable: !0, writable: !0 }) : D[P] = M, D;
  }
  var S = {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
    zIndex: -1,
    visibility: "hidden",
    pointerEvents: "none"
  }, E = {
    position: "absolute",
    left: 0,
    top: 0,
    transition: "0s"
  };
  function w(D, P) {
    for (var M = D.parentNode; M; ) {
      if (M === P)
        return !0;
      M = M.parentNode;
    }
    return !1;
  }
  var _ = /* @__PURE__ */ (function(D) {
    function P() {
      var M, N, k;
      i(this, P);
      for (var U = arguments.length, H = new Array(U), Y = 0; Y < U; Y++)
        H[Y] = arguments[Y];
      return p(k, (N = k = p(this, (M = m(P)).call.apply(M, [this].concat(H))), y(v(v(k)), "_expandRef", null), y(v(v(k)), "_shrinkRef", null), y(v(v(k)), "_node", null), y(v(v(k)), "_lastWidth", void 0), y(v(v(k)), "_lastHeight", void 0), y(v(v(k)), "_lastRect", void 0), y(v(v(k)), "_hasResize", !1), y(v(v(k)), "_handleScroll", function(z) {
        (k.props.onPosition || k.props.onReflow || k.props.onResize) && (k._globalScollTarget(z.target) || k._refScrollTarget(z.target) || k._ancestorScollTarget(z.target)) && k._reflow();
      }), y(v(v(k)), "_globalScollTarget", function(z) {
        return z instanceof Node && (k.props.onPosition || k.props.onReflow) && (z === document || z === document.documentElement || z === document.body);
      }), y(v(v(k)), "_refScrollTarget", function(z) {
        if (z instanceof HTMLElement && (z === k._expandRef || z === k._shrinkRef)) {
          var V = z.offsetWidth, F = z.offsetHeight;
          if (V !== k._lastWidth || F !== k._lastHeight)
            return k._lastWidth = V, k._lastHeight = F, k._reset(k._expandRef), k._reset(k._shrinkRef), !0;
        }
        return !1;
      }), y(v(v(k)), "_ancestorScollTarget", function(z) {
        return z instanceof Node && (k.props.onPosition || k.props.onReflow) && k._node && w(k._node, z);
      }), y(v(v(k)), "_reflow", function() {
        if (!(!k._node || !(k._node.parentNode instanceof Element))) {
          var z = k._node.parentNode.getBoundingClientRect(), V = !0, F = !0;
          k._lastRect && (V = z.width !== k._lastRect.width || z.height !== k._lastRect.height, F = z.top !== k._lastRect.top || z.left !== k._lastRect.left), k._lastRect = z, V && k.props.onResize && k.props.onResize(z), F && k.props.onPosition && k.props.onPosition(z), (V || F) && k.props.onReflow && k.props.onReflow(z);
        }
      }), y(v(v(k)), "_handleRef", function(z) {
        k._node = z;
      }), y(v(v(k)), "_handleExpandRef", function(z) {
        k._reset(z), k._expandRef = z;
      }), y(v(v(k)), "_handleShrinkRef", function(z) {
        k._reset(z), k._shrinkRef = z;
      }), N));
    }
    return f(P, [{
      key: "componentDidMount",
      value: function() {
        this._reflow(), window.addEventListener("scroll", this._handleScroll, !0), (this.props.onPosition || this.props.onReflow) && (window.addEventListener("resize", this._reflow, !0), this._hasResize = !0);
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        (this.props.onPosition || this.props.onReflow) && !this._hasResize ? (window.addEventListener("resize", this._reflow, !0), this._hasResize = !0) : !(this.props.onPosition || this.props.onReflow) && this._hasResize && (window.removeEventListener("resize", this._reflow, !0), this._hasResize = !1);
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("scroll", this._handleScroll, !0), this._hasResize && window.removeEventListener("resize", this._reflow, !0);
      }
    }, {
      key: "_reset",
      value: function(N) {
        N && (N.scrollLeft = 1e5, N.scrollTop = 1e5);
      }
    }, {
      key: "render",
      value: function() {
        return this.props.onResize || this.props.onReflow ? e.default.createElement("div", {
          style: S,
          ref: this._handleRef
        }, e.default.createElement("div", {
          ref: this._handleExpandRef,
          style: S
        }, e.default.createElement("div", {
          style: r({}, E, {
            width: 1e5,
            height: 1e5
          })
        })), e.default.createElement("div", {
          ref: this._handleShrinkRef,
          style: S
        }, e.default.createElement("div", {
          style: r({}, E, {
            width: "200%",
            height: "200%"
          })
        }))) : e.default.createElement("noscript", {
          ref: this._handleRef
        });
      }
    }]), o(P, D), P;
  })(e.default.Component);
  y(_, "displayName", "ResizeObserver");
  var O = _;
  return SE.default = O, SE;
}
var zrt = krt();
const Brt = /* @__PURE__ */ Hn(zrt);
var Lue = typeof global == "object" && global && global.Object === Object && global, Vrt = typeof self == "object" && self && self.Object === Object && self, Vu = Lue || Vrt || Function("return this")(), kc = Vu.Symbol, kue = Object.prototype, Urt = kue.hasOwnProperty, Frt = kue.toString, wE = kc ? kc.toStringTag : void 0;
function Wrt(e) {
  var t = Urt.call(e, wE), n = e[wE];
  try {
    e[wE] = void 0;
    var r = !0;
  } catch {
  }
  var i = Frt.call(e);
  return r && (t ? e[wE] = n : delete e[wE]), i;
}
var Hrt = Object.prototype, qrt = Hrt.toString;
function $rt(e) {
  return qrt.call(e);
}
var Grt = "[object Null]", Yrt = "[object Undefined]", QK = kc ? kc.toStringTag : void 0;
function rS(e) {
  return e == null ? e === void 0 ? Yrt : Grt : QK && QK in Object(e) ? Wrt(e) : $rt(e);
}
function pg(e) {
  return e != null && typeof e == "object";
}
var Xrt = "[object Symbol]";
function lP(e) {
  return typeof e == "symbol" || pg(e) && rS(e) == Xrt;
}
function EH(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var zl = Array.isArray, JK = kc ? kc.prototype : void 0, eQ = JK ? JK.toString : void 0;
function zue(e) {
  if (typeof e == "string")
    return e;
  if (zl(e))
    return EH(e, zue) + "";
  if (lP(e))
    return eQ ? eQ.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Zrt = /\s/;
function Krt(e) {
  for (var t = e.length; t-- && Zrt.test(e.charAt(t)); )
    ;
  return t;
}
var Qrt = /^\s+/;
function Jrt(e) {
  return e && e.slice(0, Krt(e) + 1).replace(Qrt, "");
}
function zc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var tQ = NaN, eit = /^[-+]0x[0-9a-f]+$/i, tit = /^0b[01]+$/i, nit = /^0o[0-7]+$/i, rit = parseInt;
function rx(e) {
  if (typeof e == "number")
    return e;
  if (lP(e))
    return tQ;
  if (zc(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = zc(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Jrt(e);
  var n = tit.test(e);
  return n || nit.test(e) ? rit(e.slice(2), n ? 2 : 8) : eit.test(e) ? tQ : +e;
}
var nQ = 1 / 0, iit = 17976931348623157e292;
function oit(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = rx(e), e === nQ || e === -nQ) {
    var t = e < 0 ? -1 : 1;
    return t * iit;
  }
  return e === e ? e : 0;
}
function _H(e) {
  var t = oit(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function CH(e) {
  return e;
}
var ait = "[object AsyncFunction]", sit = "[object Function]", lit = "[object GeneratorFunction]", cit = "[object Proxy]";
function Bue(e) {
  if (!zc(e))
    return !1;
  var t = rS(e);
  return t == sit || t == lit || t == ait || t == cit;
}
var i2 = Vu["__core-js_shared__"], rQ = (function() {
  var e = /[^.]+$/.exec(i2 && i2.keys && i2.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function uit(e) {
  return !!rQ && rQ in e;
}
var dit = Function.prototype, fit = dit.toString;
function ly(e) {
  if (e != null) {
    try {
      return fit.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var pit = /[\\^$.*+?()[\]{}|]/g, hit = /^\[object .+?Constructor\]$/, git = Function.prototype, mit = Object.prototype, vit = git.toString, yit = mit.hasOwnProperty, bit = RegExp(
  "^" + vit.call(yit).replace(pit, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function xit(e) {
  if (!zc(e) || uit(e))
    return !1;
  var t = Bue(e) ? bit : hit;
  return t.test(ly(e));
}
function Sit(e, t) {
  return e == null ? void 0 : e[t];
}
function cy(e, t) {
  var n = Sit(e, t);
  return xit(n) ? n : void 0;
}
var XV = cy(Vu, "WeakMap"), iQ = Object.create, wit = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!zc(t))
      return {};
    if (iQ)
      return iQ(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
})();
function Tit(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function RH() {
}
function Eit(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var _it = 800, Cit = 16, Rit = Date.now;
function Oit(e) {
  var t = 0, n = 0;
  return function() {
    var r = Rit(), i = Cit - (r - n);
    if (n = r, i > 0) {
      if (++t >= _it)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Ait(e) {
  return function() {
    return e;
  };
}
var VA = (function() {
  try {
    var e = cy(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), Dit = VA ? function(e, t) {
  return VA(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ait(t),
    writable: !0
  });
} : CH, Iit = Oit(Dit);
function Pit(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Nit = 9007199254740991, Mit = /^(?:0|[1-9]\d*)$/;
function OH(e, t) {
  var n = typeof e;
  return t = t ?? Nit, !!t && (n == "number" || n != "symbol" && Mit.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function AH(e, t, n) {
  t == "__proto__" && VA ? VA(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function DH(e, t) {
  return e === t || e !== e && t !== t;
}
var jit = Object.prototype, Lit = jit.hasOwnProperty;
function IH(e, t, n) {
  var r = e[t];
  (!(Lit.call(e, t) && DH(r, n)) || n === void 0 && !(t in e)) && AH(e, t, n);
}
function Vue(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = t.length; ++o < s; ) {
    var u = t[o], f = void 0;
    f === void 0 && (f = e[u]), i ? AH(n, u, f) : IH(n, u, f);
  }
  return n;
}
var oQ = Math.max;
function kit(e, t, n) {
  return t = oQ(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = oQ(r.length - t, 0), s = Array(o); ++i < o; )
      s[i] = r[t + i];
    i = -1;
    for (var u = Array(t + 1); ++i < t; )
      u[i] = r[i];
    return u[t] = n(s), Tit(e, this, u);
  };
}
function zit(e, t) {
  return Iit(kit(e, t, CH), e + "");
}
var Bit = 9007199254740991;
function PH(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Bit;
}
function cP(e) {
  return e != null && PH(e.length) && !Bue(e);
}
var Vit = Object.prototype;
function uP(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Vit;
  return e === n;
}
function Uit(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Fit = "[object Arguments]";
function aQ(e) {
  return pg(e) && rS(e) == Fit;
}
var Uue = Object.prototype, Wit = Uue.hasOwnProperty, Hit = Uue.propertyIsEnumerable, dP = aQ(/* @__PURE__ */ (function() {
  return arguments;
})()) ? aQ : function(e) {
  return pg(e) && Wit.call(e, "callee") && !Hit.call(e, "callee");
};
function qit() {
  return !1;
}
var Fue = typeof exports == "object" && exports && !exports.nodeType && exports, sQ = Fue && typeof module == "object" && module && !module.nodeType && module, $it = sQ && sQ.exports === Fue, lQ = $it ? Vu.Buffer : void 0, Git = lQ ? lQ.isBuffer : void 0, C1 = Git || qit, Yit = "[object Arguments]", Xit = "[object Array]", Zit = "[object Boolean]", Kit = "[object Date]", Qit = "[object Error]", Jit = "[object Function]", eot = "[object Map]", tot = "[object Number]", not = "[object Object]", rot = "[object RegExp]", iot = "[object Set]", oot = "[object String]", aot = "[object WeakMap]", sot = "[object ArrayBuffer]", lot = "[object DataView]", cot = "[object Float32Array]", uot = "[object Float64Array]", dot = "[object Int8Array]", fot = "[object Int16Array]", pot = "[object Int32Array]", hot = "[object Uint8Array]", got = "[object Uint8ClampedArray]", mot = "[object Uint16Array]", vot = "[object Uint32Array]", fi = {};
fi[cot] = fi[uot] = fi[dot] = fi[fot] = fi[pot] = fi[hot] = fi[got] = fi[mot] = fi[vot] = !0;
fi[Yit] = fi[Xit] = fi[sot] = fi[Zit] = fi[lot] = fi[Kit] = fi[Qit] = fi[Jit] = fi[eot] = fi[tot] = fi[not] = fi[rot] = fi[iot] = fi[oot] = fi[aot] = !1;
function yot(e) {
  return pg(e) && PH(e.length) && !!fi[rS(e)];
}
function NH(e) {
  return function(t) {
    return e(t);
  };
}
var Wue = typeof exports == "object" && exports && !exports.nodeType && exports, KE = Wue && typeof module == "object" && module && !module.nodeType && module, bot = KE && KE.exports === Wue, o2 = bot && Lue.process, xx = (function() {
  try {
    var e = KE && KE.require && KE.require("util").types;
    return e || o2 && o2.binding && o2.binding("util");
  } catch {
  }
})(), cQ = xx && xx.isTypedArray, MH = cQ ? NH(cQ) : yot, xot = Object.prototype, Sot = xot.hasOwnProperty;
function Hue(e, t) {
  var n = zl(e), r = !n && dP(e), i = !n && !r && C1(e), o = !n && !r && !i && MH(e), s = n || r || i || o, u = s ? Uit(e.length, String) : [], f = u.length;
  for (var p in e)
    (t || Sot.call(e, p)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
    OH(p, f))) && u.push(p);
  return u;
}
function que(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var wot = que(Object.keys, Object), Tot = Object.prototype, Eot = Tot.hasOwnProperty;
function $ue(e) {
  if (!uP(e))
    return wot(e);
  var t = [];
  for (var n in Object(e))
    Eot.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function iS(e) {
  return cP(e) ? Hue(e) : $ue(e);
}
function _ot(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Cot = Object.prototype, Rot = Cot.hasOwnProperty;
function Oot(e) {
  if (!zc(e))
    return _ot(e);
  var t = uP(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !Rot.call(e, r)) || n.push(r);
  return n;
}
function Aot(e) {
  return cP(e) ? Hue(e, !0) : Oot(e);
}
var Dot = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Iot = /^\w*$/;
function jH(e, t) {
  if (zl(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || lP(e) ? !0 : Iot.test(e) || !Dot.test(e) || t != null && e in Object(t);
}
var R1 = cy(Object, "create");
function Pot() {
  this.__data__ = R1 ? R1(null) : {}, this.size = 0;
}
function Not(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Mot = "__lodash_hash_undefined__", jot = Object.prototype, Lot = jot.hasOwnProperty;
function kot(e) {
  var t = this.__data__;
  if (R1) {
    var n = t[e];
    return n === Mot ? void 0 : n;
  }
  return Lot.call(t, e) ? t[e] : void 0;
}
var zot = Object.prototype, Bot = zot.hasOwnProperty;
function Vot(e) {
  var t = this.__data__;
  return R1 ? t[e] !== void 0 : Bot.call(t, e);
}
var Uot = "__lodash_hash_undefined__";
function Fot(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = R1 && t === void 0 ? Uot : t, this;
}
function Wv(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Wv.prototype.clear = Pot;
Wv.prototype.delete = Not;
Wv.prototype.get = kot;
Wv.prototype.has = Vot;
Wv.prototype.set = Fot;
function Wot() {
  this.__data__ = [], this.size = 0;
}
function fP(e, t) {
  for (var n = e.length; n--; )
    if (DH(e[n][0], t))
      return n;
  return -1;
}
var Hot = Array.prototype, qot = Hot.splice;
function $ot(e) {
  var t = this.__data__, n = fP(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : qot.call(t, n, 1), --this.size, !0;
}
function Got(e) {
  var t = this.__data__, n = fP(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Yot(e) {
  return fP(this.__data__, e) > -1;
}
function Xot(e, t) {
  var n = this.__data__, r = fP(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function gp(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
gp.prototype.clear = Wot;
gp.prototype.delete = $ot;
gp.prototype.get = Got;
gp.prototype.has = Yot;
gp.prototype.set = Xot;
var O1 = cy(Vu, "Map");
function Zot() {
  this.size = 0, this.__data__ = {
    hash: new Wv(),
    map: new (O1 || gp)(),
    string: new Wv()
  };
}
function Kot(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function pP(e, t) {
  var n = e.__data__;
  return Kot(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Qot(e) {
  var t = pP(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Jot(e) {
  return pP(this, e).get(e);
}
function eat(e) {
  return pP(this, e).has(e);
}
function tat(e, t) {
  var n = pP(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function mp(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
mp.prototype.clear = Zot;
mp.prototype.delete = Qot;
mp.prototype.get = Jot;
mp.prototype.has = eat;
mp.prototype.set = tat;
var nat = "Expected a function";
function LH(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(nat);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (LH.Cache || mp)(), n;
}
LH.Cache = mp;
var rat = 500;
function iat(e) {
  var t = LH(e, function(r) {
    return n.size === rat && n.clear(), r;
  }), n = t.cache;
  return t;
}
var oat = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, aat = /\\(\\)?/g, sat = iat(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(oat, function(n, r, i, o) {
    t.push(i ? o.replace(aat, "$1") : r || n);
  }), t;
});
function kH(e) {
  return e == null ? "" : zue(e);
}
function hP(e, t) {
  return zl(e) ? e : jH(e, t) ? [e] : sat(kH(e));
}
function j_(e) {
  if (typeof e == "string" || lP(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function zH(e, t) {
  t = hP(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[j_(t[n++])];
  return n && n == r ? e : void 0;
}
function Gue(e, t, n) {
  var r = e == null ? void 0 : zH(e, t);
  return r === void 0 ? n : r;
}
function BH(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var uQ = kc ? kc.isConcatSpreadable : void 0;
function lat(e) {
  return zl(e) || dP(e) || !!(uQ && e && e[uQ]);
}
function cat(e, t, n, r, i) {
  var o = -1, s = e.length;
  for (n || (n = lat), i || (i = []); ++o < s; ) {
    var u = e[o];
    n(u) ? BH(i, u) : i[i.length] = u;
  }
  return i;
}
function uat(e) {
  var t = e == null ? 0 : e.length;
  return t ? cat(e) : [];
}
var Yue = que(Object.getPrototypeOf, Object);
function VH(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
function dat(e, t, n, r) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; )
    n = t(n, e[i], i, e);
  return n;
}
function fat(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var pat = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, hat = fat(pat), gat = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, mat = "\\u0300-\\u036f", vat = "\\ufe20-\\ufe2f", yat = "\\u20d0-\\u20ff", bat = mat + vat + yat, xat = "[" + bat + "]", Sat = RegExp(xat, "g");
function wat(e) {
  return e = kH(e), e && e.replace(gat, hat).replace(Sat, "");
}
var Tat = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Eat(e) {
  return e.match(Tat) || [];
}
var _at = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Cat(e) {
  return _at.test(e);
}
var Xue = "\\ud800-\\udfff", Rat = "\\u0300-\\u036f", Oat = "\\ufe20-\\ufe2f", Aat = "\\u20d0-\\u20ff", Dat = Rat + Oat + Aat, Zue = "\\u2700-\\u27bf", Kue = "a-z\\xdf-\\xf6\\xf8-\\xff", Iat = "\\xac\\xb1\\xd7\\xf7", Pat = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Nat = "\\u2000-\\u206f", Mat = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Que = "A-Z\\xc0-\\xd6\\xd8-\\xde", jat = "\\ufe0e\\ufe0f", Jue = Iat + Pat + Nat + Mat, ede = "['’]", dQ = "[" + Jue + "]", Lat = "[" + Dat + "]", tde = "\\d+", kat = "[" + Zue + "]", nde = "[" + Kue + "]", rde = "[^" + Xue + Jue + tde + Zue + Kue + Que + "]", zat = "\\ud83c[\\udffb-\\udfff]", Bat = "(?:" + Lat + "|" + zat + ")", Vat = "[^" + Xue + "]", ide = "(?:\\ud83c[\\udde6-\\uddff]){2}", ode = "[\\ud800-\\udbff][\\udc00-\\udfff]", F0 = "[" + Que + "]", Uat = "\\u200d", fQ = "(?:" + nde + "|" + rde + ")", Fat = "(?:" + F0 + "|" + rde + ")", pQ = "(?:" + ede + "(?:d|ll|m|re|s|t|ve))?", hQ = "(?:" + ede + "(?:D|LL|M|RE|S|T|VE))?", ade = Bat + "?", sde = "[" + jat + "]?", Wat = "(?:" + Uat + "(?:" + [Vat, ide, ode].join("|") + ")" + sde + ade + ")*", Hat = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", qat = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $at = sde + ade + Wat, Gat = "(?:" + [kat, ide, ode].join("|") + ")" + $at, Yat = RegExp([
  F0 + "?" + nde + "+" + pQ + "(?=" + [dQ, F0, "$"].join("|") + ")",
  Fat + "+" + hQ + "(?=" + [dQ, F0 + fQ, "$"].join("|") + ")",
  F0 + "?" + fQ + "+" + pQ,
  F0 + "+" + hQ,
  qat,
  Hat,
  tde,
  Gat
].join("|"), "g");
function Xat(e) {
  return e.match(Yat) || [];
}
function Zat(e, t, n) {
  return e = kH(e), t = t, t === void 0 ? Cat(e) ? Xat(e) : Eat(e) : e.match(t) || [];
}
var Kat = "['’]", Qat = RegExp(Kat, "g");
function Jat(e) {
  return function(t) {
    return dat(Zat(wat(t).replace(Qat, "")), e, "");
  };
}
function est(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
function tst(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = rx(n), n = n === n ? n : 0), t !== void 0 && (t = rx(t), t = t === t ? t : 0), est(rx(e), t, n);
}
function nst() {
  this.__data__ = new gp(), this.size = 0;
}
function rst(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function ist(e) {
  return this.__data__.get(e);
}
function ost(e) {
  return this.__data__.has(e);
}
var ast = 200;
function sst(e, t) {
  var n = this.__data__;
  if (n instanceof gp) {
    var r = n.__data__;
    if (!O1 || r.length < ast - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new mp(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Vd(e) {
  var t = this.__data__ = new gp(e);
  this.size = t.size;
}
Vd.prototype.clear = nst;
Vd.prototype.delete = rst;
Vd.prototype.get = ist;
Vd.prototype.has = ost;
Vd.prototype.set = sst;
function lst(e, t) {
  return e && Vue(t, iS(t), e);
}
var lde = typeof exports == "object" && exports && !exports.nodeType && exports, gQ = lde && typeof module == "object" && module && !module.nodeType && module, cst = gQ && gQ.exports === lde, mQ = cst ? Vu.Buffer : void 0, vQ = mQ ? mQ.allocUnsafe : void 0;
function ust(e, t) {
  var n = e.length, r = vQ ? vQ(n) : new e.constructor(n);
  return e.copy(r), r;
}
function dst(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (o[i++] = s);
  }
  return o;
}
function cde() {
  return [];
}
var fst = Object.prototype, pst = fst.propertyIsEnumerable, yQ = Object.getOwnPropertySymbols, UH = yQ ? function(e) {
  return e == null ? [] : (e = Object(e), dst(yQ(e), function(t) {
    return pst.call(e, t);
  }));
} : cde;
function hst(e, t) {
  return Vue(e, UH(e), t);
}
var gst = Object.getOwnPropertySymbols, mst = gst ? function(e) {
  for (var t = []; e; )
    BH(t, UH(e)), e = Yue(e);
  return t;
} : cde;
function ude(e, t, n) {
  var r = t(e);
  return zl(e) ? r : BH(r, n(e));
}
function ZV(e) {
  return ude(e, iS, UH);
}
function vst(e) {
  return ude(e, Aot, mst);
}
var KV = cy(Vu, "DataView"), QV = cy(Vu, "Promise"), JV = cy(Vu, "Set"), bQ = "[object Map]", yst = "[object Object]", xQ = "[object Promise]", SQ = "[object Set]", wQ = "[object WeakMap]", TQ = "[object DataView]", bst = ly(KV), xst = ly(O1), Sst = ly(QV), wst = ly(JV), Tst = ly(XV), Ec = rS;
(KV && Ec(new KV(new ArrayBuffer(1))) != TQ || O1 && Ec(new O1()) != bQ || QV && Ec(QV.resolve()) != xQ || JV && Ec(new JV()) != SQ || XV && Ec(new XV()) != wQ) && (Ec = function(e) {
  var t = rS(e), n = t == yst ? e.constructor : void 0, r = n ? ly(n) : "";
  if (r)
    switch (r) {
      case bst:
        return TQ;
      case xst:
        return bQ;
      case Sst:
        return xQ;
      case wst:
        return SQ;
      case Tst:
        return wQ;
    }
  return t;
});
var Est = Object.prototype, _st = Est.hasOwnProperty;
function Cst(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && _st.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var UA = Vu.Uint8Array;
function Rst(e) {
  var t = new e.constructor(e.byteLength);
  return new UA(t).set(new UA(e)), t;
}
function Ost(e, t) {
  var n = e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Ast = /\w*$/;
function Dst(e) {
  var t = new e.constructor(e.source, Ast.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var EQ = kc ? kc.prototype : void 0, _Q = EQ ? EQ.valueOf : void 0;
function Ist(e) {
  return _Q ? Object(_Q.call(e)) : {};
}
function Pst(e, t) {
  var n = e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Nst = "[object Boolean]", Mst = "[object Date]", jst = "[object Map]", Lst = "[object Number]", kst = "[object RegExp]", zst = "[object Set]", Bst = "[object String]", Vst = "[object Symbol]", Ust = "[object ArrayBuffer]", Fst = "[object DataView]", Wst = "[object Float32Array]", Hst = "[object Float64Array]", qst = "[object Int8Array]", $st = "[object Int16Array]", Gst = "[object Int32Array]", Yst = "[object Uint8Array]", Xst = "[object Uint8ClampedArray]", Zst = "[object Uint16Array]", Kst = "[object Uint32Array]";
function Qst(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case Ust:
      return Rst(e);
    case Nst:
    case Mst:
      return new r(+e);
    case Fst:
      return Ost(e);
    case Wst:
    case Hst:
    case qst:
    case $st:
    case Gst:
    case Yst:
    case Xst:
    case Zst:
    case Kst:
      return Pst(e);
    case jst:
      return new r();
    case Lst:
    case Bst:
      return new r(e);
    case kst:
      return Dst(e);
    case zst:
      return new r();
    case Vst:
      return Ist(e);
  }
}
function Jst(e) {
  return typeof e.constructor == "function" && !uP(e) ? wit(Yue(e)) : {};
}
var elt = "[object Map]";
function tlt(e) {
  return pg(e) && Ec(e) == elt;
}
var CQ = xx && xx.isMap, nlt = CQ ? NH(CQ) : tlt, rlt = "[object Set]";
function ilt(e) {
  return pg(e) && Ec(e) == rlt;
}
var RQ = xx && xx.isSet, olt = RQ ? NH(RQ) : ilt, dde = "[object Arguments]", alt = "[object Array]", slt = "[object Boolean]", llt = "[object Date]", clt = "[object Error]", fde = "[object Function]", ult = "[object GeneratorFunction]", dlt = "[object Map]", flt = "[object Number]", pde = "[object Object]", plt = "[object RegExp]", hlt = "[object Set]", glt = "[object String]", mlt = "[object Symbol]", vlt = "[object WeakMap]", ylt = "[object ArrayBuffer]", blt = "[object DataView]", xlt = "[object Float32Array]", Slt = "[object Float64Array]", wlt = "[object Int8Array]", Tlt = "[object Int16Array]", Elt = "[object Int32Array]", _lt = "[object Uint8Array]", Clt = "[object Uint8ClampedArray]", Rlt = "[object Uint16Array]", Olt = "[object Uint32Array]", ai = {};
ai[dde] = ai[alt] = ai[ylt] = ai[blt] = ai[slt] = ai[llt] = ai[xlt] = ai[Slt] = ai[wlt] = ai[Tlt] = ai[Elt] = ai[dlt] = ai[flt] = ai[pde] = ai[plt] = ai[hlt] = ai[glt] = ai[mlt] = ai[_lt] = ai[Clt] = ai[Rlt] = ai[Olt] = !0;
ai[clt] = ai[fde] = ai[vlt] = !1;
function JO(e, t, n, r, i, o) {
  var s;
  if (s !== void 0)
    return s;
  if (!zc(e))
    return e;
  var u = zl(e);
  if (u)
    return s = Cst(e), Eit(e, s);
  var f = Ec(e), p = f == fde || f == ult;
  if (C1(e))
    return ust(e);
  if (f == pde || f == dde || p && !i)
    return s = p ? {} : Jst(e), hst(e, lst(s, e));
  if (!ai[f])
    return i ? e : {};
  s = Qst(e, f), o || (o = new Vd());
  var m = o.get(e);
  if (m)
    return m;
  o.set(e, s), olt(e) ? e.forEach(function(S) {
    s.add(JO(S, t, n, S, e, o));
  }) : nlt(e) && e.forEach(function(S, E) {
    s.set(E, JO(S, t, n, E, e, o));
  });
  var v = ZV, y = u ? void 0 : v(e);
  return Pit(y || e, function(S, E) {
    y && (E = S, S = e[E]), IH(s, E, JO(S, t, n, E, e, o));
  }), s;
}
var Alt = 4;
function Dlt(e) {
  return JO(e, Alt);
}
var Ilt = "__lodash_hash_undefined__";
function Plt(e) {
  return this.__data__.set(e, Ilt), this;
}
function Nlt(e) {
  return this.__data__.has(e);
}
function FA(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new mp(); ++t < n; )
    this.add(e[t]);
}
FA.prototype.add = FA.prototype.push = Plt;
FA.prototype.has = Nlt;
function Mlt(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function jlt(e, t) {
  return e.has(t);
}
var Llt = 1, klt = 2;
function hde(e, t, n, r, i, o) {
  var s = n & Llt, u = e.length, f = t.length;
  if (u != f && !(s && f > u))
    return !1;
  var p = o.get(e), m = o.get(t);
  if (p && m)
    return p == t && m == e;
  var v = -1, y = !0, S = n & klt ? new FA() : void 0;
  for (o.set(e, t), o.set(t, e); ++v < u; ) {
    var E = e[v], w = t[v];
    if (r)
      var _ = s ? r(w, E, v, t, e, o) : r(E, w, v, e, t, o);
    if (_ !== void 0) {
      if (_)
        continue;
      y = !1;
      break;
    }
    if (S) {
      if (!Mlt(t, function(O, D) {
        if (!jlt(S, D) && (E === O || i(E, O, n, r, o)))
          return S.push(D);
      })) {
        y = !1;
        break;
      }
    } else if (!(E === w || i(E, w, n, r, o))) {
      y = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), y;
}
function zlt(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function Blt(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Vlt = 1, Ult = 2, Flt = "[object Boolean]", Wlt = "[object Date]", Hlt = "[object Error]", qlt = "[object Map]", $lt = "[object Number]", Glt = "[object RegExp]", Ylt = "[object Set]", Xlt = "[object String]", Zlt = "[object Symbol]", Klt = "[object ArrayBuffer]", Qlt = "[object DataView]", OQ = kc ? kc.prototype : void 0, a2 = OQ ? OQ.valueOf : void 0;
function Jlt(e, t, n, r, i, o, s) {
  switch (n) {
    case Qlt:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Klt:
      return !(e.byteLength != t.byteLength || !o(new UA(e), new UA(t)));
    case Flt:
    case Wlt:
    case $lt:
      return DH(+e, +t);
    case Hlt:
      return e.name == t.name && e.message == t.message;
    case Glt:
    case Xlt:
      return e == t + "";
    case qlt:
      var u = zlt;
    case Ylt:
      var f = r & Vlt;
      if (u || (u = Blt), e.size != t.size && !f)
        return !1;
      var p = s.get(e);
      if (p)
        return p == t;
      r |= Ult, s.set(e, t);
      var m = hde(u(e), u(t), r, i, o, s);
      return s.delete(e), m;
    case Zlt:
      if (a2)
        return a2.call(e) == a2.call(t);
  }
  return !1;
}
var ect = 1, tct = Object.prototype, nct = tct.hasOwnProperty;
function rct(e, t, n, r, i, o) {
  var s = n & ect, u = ZV(e), f = u.length, p = ZV(t), m = p.length;
  if (f != m && !s)
    return !1;
  for (var v = f; v--; ) {
    var y = u[v];
    if (!(s ? y in t : nct.call(t, y)))
      return !1;
  }
  var S = o.get(e), E = o.get(t);
  if (S && E)
    return S == t && E == e;
  var w = !0;
  o.set(e, t), o.set(t, e);
  for (var _ = s; ++v < f; ) {
    y = u[v];
    var O = e[y], D = t[y];
    if (r)
      var P = s ? r(D, O, y, t, e, o) : r(O, D, y, e, t, o);
    if (!(P === void 0 ? O === D || i(O, D, n, r, o) : P)) {
      w = !1;
      break;
    }
    _ || (_ = y == "constructor");
  }
  if (w && !_) {
    var M = e.constructor, N = t.constructor;
    M != N && "constructor" in e && "constructor" in t && !(typeof M == "function" && M instanceof M && typeof N == "function" && N instanceof N) && (w = !1);
  }
  return o.delete(e), o.delete(t), w;
}
var ict = 1, AQ = "[object Arguments]", DQ = "[object Array]", wO = "[object Object]", oct = Object.prototype, IQ = oct.hasOwnProperty;
function act(e, t, n, r, i, o) {
  var s = zl(e), u = zl(t), f = s ? DQ : Ec(e), p = u ? DQ : Ec(t);
  f = f == AQ ? wO : f, p = p == AQ ? wO : p;
  var m = f == wO, v = p == wO, y = f == p;
  if (y && C1(e)) {
    if (!C1(t))
      return !1;
    s = !0, m = !1;
  }
  if (y && !m)
    return o || (o = new Vd()), s || MH(e) ? hde(e, t, n, r, i, o) : Jlt(e, t, f, n, r, i, o);
  if (!(n & ict)) {
    var S = m && IQ.call(e, "__wrapped__"), E = v && IQ.call(t, "__wrapped__");
    if (S || E) {
      var w = S ? e.value() : e, _ = E ? t.value() : t;
      return o || (o = new Vd()), i(w, _, n, r, o);
    }
  }
  return y ? (o || (o = new Vd()), rct(e, t, n, r, i, o)) : !1;
}
function gP(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !pg(e) && !pg(t) ? e !== e && t !== t : act(e, t, n, r, gP, i);
}
var sct = 1, lct = 2;
function cct(e, t, n, r) {
  var i = n.length, o = i;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var u = s[0], f = e[u], p = s[1];
    if (s[2]) {
      if (f === void 0 && !(u in e))
        return !1;
    } else {
      var m = new Vd(), v;
      if (!(v === void 0 ? gP(p, f, sct | lct, r, m) : v))
        return !1;
    }
  }
  return !0;
}
function gde(e) {
  return e === e && !zc(e);
}
function uct(e) {
  for (var t = iS(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, gde(i)];
  }
  return t;
}
function mde(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function dct(e) {
  var t = uct(e);
  return t.length == 1 && t[0][2] ? mde(t[0][0], t[0][1]) : function(n) {
    return n === e || cct(n, e, t);
  };
}
function fct(e, t) {
  return e != null && t in Object(e);
}
function pct(e, t, n) {
  t = hP(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var s = j_(t[r]);
    if (!(o = e != null && n(e, s)))
      break;
    e = e[s];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && PH(i) && OH(s, i) && (zl(e) || dP(e)));
}
function hct(e, t) {
  return e != null && pct(e, t, fct);
}
var gct = 1, mct = 2;
function vct(e, t) {
  return jH(e) && gde(t) ? mde(j_(e), t) : function(n) {
    var r = Gue(n, e);
    return r === void 0 && r === t ? hct(n, e) : gP(t, r, gct | mct);
  };
}
function yct(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function bct(e) {
  return function(t) {
    return zH(t, e);
  };
}
function xct(e) {
  return jH(e) ? yct(j_(e)) : bct(e);
}
function vde(e) {
  return typeof e == "function" ? e : e == null ? CH : typeof e == "object" ? zl(e) ? vct(e[0], e[1]) : dct(e) : xct(e);
}
function Sct(e, t, n, r) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var s = e[i];
    t(r, s, n(s), e);
  }
  return r;
}
function wct(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), s = r(t), u = s.length; u--; ) {
      var f = s[++i];
      if (n(o[f], f, o) === !1)
        break;
    }
    return t;
  };
}
var Tct = wct();
function Ect(e, t) {
  return e && Tct(e, t, iS);
}
function _ct(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!cP(n))
      return e(n, r);
    for (var i = n.length, o = -1, s = Object(n); ++o < i && r(s[o], o, s) !== !1; )
      ;
    return n;
  };
}
var Cct = _ct(Ect);
function Rct(e, t, n, r) {
  return Cct(e, function(i, o, s) {
    t(r, i, n(i), s);
  }), r;
}
function Oct(e, t) {
  return function(n, r) {
    var i = zl(n) ? Sct : Rct, o = {};
    return i(n, e, vde(r), o);
  };
}
var Act = Object.prototype, Dct = Act.hasOwnProperty, Ict = Oct(function(e, t, n) {
  Dct.call(e, n) ? ++e[n] : AH(e, n, 1);
}), s2 = function() {
  return Vu.Date.now();
}, Pct = "Expected a function", Nct = Math.max, Mct = Math.min;
function jct(e, t, n) {
  var r, i, o, s, u, f, p = 0, m = !1, v = !1, y = !0;
  if (typeof e != "function")
    throw new TypeError(Pct);
  t = rx(t) || 0, zc(n) && (m = !!n.leading, v = "maxWait" in n, o = v ? Nct(rx(n.maxWait) || 0, t) : o, y = "trailing" in n ? !!n.trailing : y);
  function S(k) {
    var U = r, H = i;
    return r = i = void 0, p = k, s = e.apply(H, U), s;
  }
  function E(k) {
    return p = k, u = setTimeout(O, t), m ? S(k) : s;
  }
  function w(k) {
    var U = k - f, H = k - p, Y = t - U;
    return v ? Mct(Y, o - H) : Y;
  }
  function _(k) {
    var U = k - f, H = k - p;
    return f === void 0 || U >= t || U < 0 || v && H >= o;
  }
  function O() {
    var k = s2();
    if (_(k))
      return D(k);
    u = setTimeout(O, w(k));
  }
  function D(k) {
    return u = void 0, y && r ? S(k) : (r = i = void 0, s);
  }
  function P() {
    u !== void 0 && clearTimeout(u), p = 0, r = f = i = u = void 0;
  }
  function M() {
    return u === void 0 ? s : D(s2());
  }
  function N() {
    var k = s2(), U = _(k);
    if (r = arguments, i = this, f = k, U) {
      if (u === void 0)
        return E(f);
      if (v)
        return clearTimeout(u), u = setTimeout(O, t), S(f);
    }
    return u === void 0 && (u = setTimeout(O, t)), s;
  }
  return N.cancel = P, N.flush = M, N;
}
var Lct = "Expected a function";
function kct(e, t, n) {
  if (typeof e != "function")
    throw new TypeError(Lct);
  return setTimeout(function() {
    e.apply(void 0, n);
  }, t);
}
var zct = zit(function(e, t) {
  return kct(e, 1, t);
});
function yde(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function Bct(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? (t = t === void 0 ? 1 : _H(t), VH(e, t < 0 ? 0 : t, r)) : [];
}
function FH(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? (t = t === void 0 ? 1 : _H(t), t = r - t, VH(e, 0, t < 0 ? 0 : t)) : [];
}
function Vct(e, t) {
  return EH(t, function(n) {
    return e[n];
  });
}
function bde(e) {
  return e == null ? [] : Vct(e, iS(e));
}
var Uct = "[object Map]", Fct = "[object Set]", Wct = Object.prototype, Hct = Wct.hasOwnProperty;
function qct(e) {
  if (e == null)
    return !0;
  if (cP(e) && (zl(e) || typeof e == "string" || typeof e.splice == "function" || C1(e) || MH(e) || dP(e)))
    return !e.length;
  var t = Ec(e);
  if (t == Uct || t == Fct)
    return !e.size;
  if (uP(e))
    return !$ue(e).length;
  for (var n in e)
    if (Hct.call(e, n))
      return !1;
  return !0;
}
function xde(e, t) {
  return gP(e, t);
}
var PQ = Jat(function(e, t, n) {
  return e + (n ? "-" : "") + t.toLowerCase();
});
function Sde(e, t, n, r) {
  if (!zc(e))
    return e;
  t = hP(t, e);
  for (var i = -1, o = t.length, s = o - 1, u = e; u != null && ++i < o; ) {
    var f = j_(t[i]), p = n;
    if (f === "__proto__" || f === "constructor" || f === "prototype")
      return e;
    if (i != s) {
      var m = u[f];
      p = void 0, p === void 0 && (p = zc(m) ? m : OH(t[i + 1]) ? [] : {});
    }
    IH(u, f, p), u = u[f];
  }
  return e;
}
function $ct(e, t, n) {
  for (var r = -1, i = t.length, o = {}; ++r < i; ) {
    var s = t[r], u = zH(e, s);
    n(u, s) && Sde(o, hP(s, e), u);
  }
  return o;
}
function Gct(e, t) {
  if (e == null)
    return {};
  var n = EH(vst(e), function(r) {
    return [r];
  });
  return t = vde(t), $ct(e, n, function(r, i) {
    return t(r, i[0]);
  });
}
function Yct(e, t, n) {
  return e == null ? e : Sde(e, t, n);
}
function NQ(e, t, n) {
  return e && e.length ? (t = t === void 0 ? 1 : _H(t), VH(e, 0, t < 0 ? 0 : t)) : [];
}
var Xct = "Expected a function";
function Zct(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Xct);
  return zc(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), jct(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
var wde = (e, t) => ({ event: e, check: t }), Kct = wde("touchstart", (e) => {
  let t = e;
  return t.touches !== null && t.touches !== void 0;
}), Qct = wde("pointerdown", (e) => e.pointerType === "mouse"), Jct = { backends: [{ id: "html5", backend: Jae, transition: Qct }, { id: "touch", backend: tse, options: { enableMouseEvents: !0 }, preview: !0, transition: Kct }] };
const aa = [];
for (let e = 0; e < 256; ++e)
  aa.push((e + 256).toString(16).slice(1));
function eut(e, t = 0) {
  return (aa[e[t + 0]] + aa[e[t + 1]] + aa[e[t + 2]] + aa[e[t + 3]] + "-" + aa[e[t + 4]] + aa[e[t + 5]] + "-" + aa[e[t + 6]] + aa[e[t + 7]] + "-" + aa[e[t + 8]] + aa[e[t + 9]] + "-" + aa[e[t + 10]] + aa[e[t + 11]] + aa[e[t + 12]] + aa[e[t + 13]] + aa[e[t + 14]] + aa[e[t + 15]]).toLowerCase();
}
let l2;
const tut = new Uint8Array(16);
function nut() {
  if (!l2) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    l2 = crypto.getRandomValues.bind(crypto);
  }
  return l2(tut);
}
const rut = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), MQ = { randomUUID: rut };
function iut(e, t, n) {
  var i;
  if (MQ.randomUUID && !e)
    return MQ.randomUUID();
  e = e || {};
  const r = e.random ?? ((i = e.rng) == null ? void 0 : i.call(e)) ?? nut();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, eut(r);
}
var Qd = it.createContext(void 0), oS = it.createContext(void 0);
function c2(e) {
  throw new Error("Unhandled case: " + JSON.stringify(e));
}
var og;
((e) => {
  function t() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }
  e.empty = t;
  function n(s, u, f) {
    const p = r(s, u, f);
    return f === "column" ? {
      first: {
        ...s,
        bottom: 100 - p
      },
      second: {
        ...s,
        top: p
      }
    } : f === "row" ? {
      first: {
        ...s,
        right: 100 - p
      },
      second: {
        ...s,
        left: p
      }
    } : c2(f);
  }
  e.split = n;
  function r(s, u, f) {
    const { top: p, right: m, bottom: v, left: y } = s;
    return f === "column" ? (100 - p - v) * u / 100 + p : f === "row" ? (100 - m - y) * u / 100 + y : c2(f);
  }
  e.getAbsoluteSplitPercentage = r;
  function i(s, u, f) {
    const { top: p, right: m, bottom: v, left: y } = s;
    if (f === "column") {
      const S = 100 - p - v;
      return (u - p) / S * 100;
    } else if (f === "row") {
      const S = 100 - m - y;
      return (u - y) / S * 100;
    } else
      return c2(f);
  }
  e.getRelativeSplitPercentage = i;
  function o({ top: s, right: u, bottom: f, left: p }) {
    return {
      top: `${s}%`,
      right: `${u}%`,
      bottom: `${f}%`,
      left: `${p}%`
    };
  }
  e.asStyles = o;
})(og || (og = {}));
var out = 1e3 / 30, TO = {
  capture: !0,
  passive: !1
}, O2, aut = (O2 = class extends it.PureComponent {
  constructor() {
    super(...arguments);
    Un(this, "rootElement", it.createRef());
    Un(this, "listenersBound", !1);
    Un(this, "onMouseDown", (t) => {
      !jQ(t) && t.button !== 0 || (t.preventDefault(), this.bindListeners());
    });
    Un(this, "onMouseUp", (t) => {
      this.unbindListeners();
      const n = this.calculateRelativePercentage(t);
      this.props.onRelease(n);
    });
    Un(this, "onMouseMove", (t) => {
      t.preventDefault(), this.throttledUpdatePercentage(t);
    });
    Un(this, "throttledUpdatePercentage", Zct((t) => {
      const n = this.calculateRelativePercentage(t);
      n !== this.props.splitPercentage && this.props.onChange(n);
    }, out));
  }
  render() {
    const { direction: t } = this.props;
    return /* @__PURE__ */ it.createElement(
      "div",
      {
        className: On("mosaic-split", {
          "-row": t === "row",
          "-column": t === "column"
        }),
        ref: this.rootElement,
        onMouseDown: this.onMouseDown,
        style: this.computeStyle()
      },
      /* @__PURE__ */ it.createElement("div", { className: "mosaic-split-line" })
    );
  }
  componentDidMount() {
    this.rootElement.current.addEventListener("touchstart", this.onMouseDown, TO);
  }
  componentWillUnmount() {
    this.unbindListeners(), this.rootElement.current && this.rootElement.current.ownerDocument.removeEventListener("touchstart", this.onMouseDown, TO);
  }
  bindListeners() {
    this.listenersBound || (this.rootElement.current.ownerDocument.addEventListener("mousemove", this.onMouseMove, !0), this.rootElement.current.ownerDocument.addEventListener("touchmove", this.onMouseMove, TO), this.rootElement.current.ownerDocument.addEventListener("mouseup", this.onMouseUp, !0), this.rootElement.current.ownerDocument.addEventListener("touchend", this.onMouseUp, !0), this.listenersBound = !0);
  }
  unbindListeners() {
    this.rootElement.current && (this.rootElement.current.ownerDocument.removeEventListener("mousemove", this.onMouseMove, !0), this.rootElement.current.ownerDocument.removeEventListener("touchmove", this.onMouseMove, TO), this.rootElement.current.ownerDocument.removeEventListener("mouseup", this.onMouseUp, !0), this.rootElement.current.ownerDocument.removeEventListener("touchend", this.onMouseUp, !0), this.listenersBound = !1);
  }
  computeStyle() {
    const { boundingBox: t, direction: n, splitPercentage: r } = this.props, i = n === "column" ? "top" : "left", o = og.getAbsoluteSplitPercentage(t, r, n);
    return {
      ...og.asStyles(t),
      [i]: `${o}%`
    };
  }
  calculateRelativePercentage(t) {
    const { minimumPaneSizePercentage: n, direction: r, boundingBox: i } = this.props, o = this.rootElement.current.parentElement.getBoundingClientRect(), s = jQ(t) ? t.changedTouches[0] : t;
    let u;
    r === "column" ? u = (s.clientY - o.top) / o.height * 100 : u = (s.clientX - o.left) / o.width * 100;
    const f = og.getRelativeSplitPercentage(i, u, r);
    return tst(f, n, 100 - n);
  }
}, Un(O2, "defaultProps", {
  onChange: () => {
  },
  onRelease: () => {
  },
  minimumPaneSizePercentage: 20
}), O2);
function jQ(e) {
  return e.changedTouches != null;
}
function eU(e, t = "row") {
  if (mP(e)) {
    const n = Ede(t);
    return {
      direction: t,
      first: eU(e.first, n),
      second: eU(e.second, n)
    };
  } else
    return e;
}
var Tde = /* @__PURE__ */ ((e) => (e[e.TOP_LEFT = 1] = "TOP_LEFT", e[e.TOP_RIGHT = 2] = "TOP_RIGHT", e[e.BOTTOM_LEFT = 3] = "BOTTOM_LEFT", e[e.BOTTOM_RIGHT = 4] = "BOTTOM_RIGHT", e))(Tde || {});
function mP(e) {
  return e.direction != null;
}
function tU(e, t = "row") {
  if (e.length === 0)
    return null;
  let n = Dlt(e), r = [];
  for (; n.length > 1; ) {
    for (; n.length > 0; )
      n.length > 1 ? r.push({
        direction: "row",
        first: n.shift(),
        second: n.shift()
      }) : r.unshift(n.shift());
    n = r, r = [];
  }
  return eU(n[0], t);
}
function sut(e) {
  if (e === "first")
    return "second";
  if (e === "second")
    return "first";
  throw new Error(`Branch '${e}' not a valid branch`);
}
function Ede(e) {
  return e === "row" ? "column" : "row";
}
function lut(e, t) {
  let n = e;
  const r = [];
  for (; mP(n); )
    n.direction === "row" && (t === 1 || t === 3) || n.direction === "column" && (t === 1 || t === 2) ? (r.push("first"), n = n.first) : (r.push("second"), n = n.second);
  return r;
}
function A1(e) {
  return e == null ? [] : mP(e) ? A1(e.first).concat(A1(e.second)) : [e];
}
function nU(e, t) {
  return t.length > 0 ? Gue(e, t, null) : e;
}
function WA(e, t) {
  if (e == null)
    throw new Error("Root is empty, cannot fetch path");
  const n = nU(e, t);
  if (n == null)
    throw new Error(`Path [${t.join(", ")}] did not resolve to a node`);
  return n;
}
var A2, cut = (A2 = class extends it.PureComponent {
  constructor() {
    super(...arguments);
    Un(this, "onResize", (t, n, r) => {
      this.context.mosaicActions.updateTree(
        [
          {
            path: n,
            spec: {
              splitPercentage: {
                $set: t
              }
            }
          }
        ],
        r
      );
    });
  }
  render() {
    const { root: t } = this.props;
    return /* @__PURE__ */ it.createElement("div", { className: "mosaic-root" }, this.renderRecursively(t, og.empty(), []));
  }
  renderRecursively(t, n, r) {
    if (mP(t)) {
      const i = t.splitPercentage == null ? 50 : t.splitPercentage, { first: o, second: s } = og.split(n, i, t.direction);
      return uat(
        [
          this.renderRecursively(t.first, o, r.concat("first")),
          this.renderSplit(t.direction, n, i, r),
          this.renderRecursively(t.second, s, r.concat("second"))
        ].filter(uut)
      );
    } else
      return /* @__PURE__ */ it.createElement("div", { key: t, className: "mosaic-tile", style: { ...og.asStyles(n) } }, this.props.renderTile(t, r));
  }
  renderSplit(t, n, r, i) {
    const { resize: o } = this.props;
    return o !== "DISABLED" ? /* @__PURE__ */ it.createElement(
      aut,
      {
        key: i.join(",") + "splitter",
        ...o,
        boundingBox: n,
        splitPercentage: r,
        direction: t,
        onChange: (s) => this.onResize(s, i, !0),
        onRelease: (s) => this.onResize(s, i, !1)
      }
    ) : null;
  }
}, Un(A2, "contextType", Qd), A2);
function uut(e) {
  return e !== null;
}
var Wo;
((e) => {
  e.Icon = ({
    icon: r,
    className: i,
    size: o = "standard"
  }) => {
    const { blueprintNamespace: s } = $.useContext(Qd);
    return /* @__PURE__ */ $.createElement(
      "span",
      {
        className: On(i, n(s, r), `${s}-icon-${o}`)
      }
    );
  };
  function t(r, ...i) {
    return i.map((o) => `${r}-${PQ(o)}`).join(" ");
  }
  e.getClasses = t;
  function n(r, i) {
    return `${r}-icon-${PQ(i)}`;
  }
  e.getIconClass = n;
})(Wo || (Wo = {}));
var D2, dut = (D2 = class extends it.PureComponent {
  constructor() {
    super(...arguments);
    Un(this, "replace", () => Promise.resolve(this.props.createNode()).then((t) => this.context.mosaicActions.replaceWith([], t)).catch(RH));
  }
  render() {
    return /* @__PURE__ */ it.createElement(
      "div",
      {
        className: On(
          "mosaic-zero-state",
          Wo.getClasses(this.context.blueprintNamespace, "NON_IDEAL_STATE")
        )
      },
      /* @__PURE__ */ it.createElement("div", { className: Wo.getClasses(this.context.blueprintNamespace, "NON_IDEAL_STATE_VISUAL") }, /* @__PURE__ */ it.createElement(Wo.Icon, { className: "default-zero-state-icon", size: "large", icon: "APPLICATIONS" })),
      /* @__PURE__ */ it.createElement("h4", { className: Wo.getClasses(this.context.blueprintNamespace, "HEADING") }, "No Windows Present"),
      /* @__PURE__ */ it.createElement("div", null, this.props.createNode && /* @__PURE__ */ it.createElement(
        "button",
        {
          className: On(
            Wo.getClasses(this.context.blueprintNamespace, "BUTTON"),
            Wo.getIconClass(this.context.blueprintNamespace, "ADD")
          ),
          onClick: this.replace
        },
        "Add New Window"
      ))
    );
  }
  // Swallow rejections (i.e. on user cancel)
}, Un(D2, "contextType", Qd), D2), Y0 = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
}, D1 = {
  WINDOW: "MosaicWindow"
};
function _de({ path: e, position: t }) {
  const { mosaicId: n } = Qi(Qd), [{ isOver: r, draggedMosaicId: i }, o] = BI({
    accept: D1.WINDOW,
    drop: (s, u) => n === (s == null ? void 0 : s.mosaicId) ? { path: e, position: t } : {},
    collect: (s) => ({
      isOver: s.isOver(),
      draggedMosaicId: (s.getItem() || {}).mosaicId
    })
  });
  return /* @__PURE__ */ it.createElement(
    "div",
    {
      ref: (s) => {
        o(s);
      },
      className: On("drop-target", t, {
        "drop-target-hover": r && i === n
      })
    }
  );
}
var Cde = it.memo(() => {
  const [{ isDragging: e }] = BI({
    accept: D1.WINDOW,
    collect: (n) => ({
      isDragging: n.getItem() !== null && n.getItemType() === D1.WINDOW
    })
  }), t = fut(e, 0);
  return /* @__PURE__ */ it.createElement(
    "div",
    {
      className: On("drop-target-container", {
        "-dragging": t
      })
    },
    bde(Y0).map((n) => /* @__PURE__ */ it.createElement(_de, { position: n, path: [], key: n }))
  );
});
Cde.displayName = "RootDropTargets";
function fut(e, t) {
  const n = it.useRef(e), [, r] = it.useState(0), i = (o) => {
    n.current = o, r((s) => s + 1);
  };
  return e || (n.current = !1), it.useEffect(() => {
    if (n.current === e || !e)
      return;
    const o = window.setTimeout(() => i(!0), t);
    return () => {
      window.clearTimeout(o);
    };
  }, [e]), n.current;
}
var EO = { exports: {} }, LQ;
function put() {
  return LQ || (LQ = 1, (function(e, t) {
    var n = {};
    Object.defineProperty(t, "__esModule", { value: !0 });
    function r(H) {
      return typeof H == "object" && !("toString" in H) ? Object.prototype.toString.call(H).slice(8, -1) : H;
    }
    var i = typeof process == "object" && n.NODE_ENV === "production";
    function o(H, Y) {
      if (!H)
        throw i ? new Error("Invariant failed") : new Error(Y());
    }
    t.invariant = o;
    var s = Object.prototype.hasOwnProperty, u = Array.prototype.splice, f = Object.prototype.toString;
    function p(H) {
      return f.call(H).slice(8, -1);
    }
    var m = Object.assign || /* istanbul ignore next */
    (function(H, Y) {
      return v(Y).forEach(function(z) {
        s.call(Y, z) && (H[z] = Y[z]);
      }), H;
    }), v = typeof Object.getOwnPropertySymbols == "function" ? function(H) {
      return Object.keys(H).concat(Object.getOwnPropertySymbols(H));
    } : function(H) {
      return Object.keys(H);
    };
    function y(H) {
      return Array.isArray(H) ? m(H.constructor(H.length), H) : p(H) === "Map" ? new Map(H) : p(H) === "Set" ? new Set(H) : H && typeof H == "object" ? m(Object.create(Object.getPrototypeOf(H)), H) : H;
    }
    var S = (
      /** @class */
      (function() {
        function H() {
          this.commands = m({}, E), this.update = this.update.bind(this), this.update.extend = this.extend = this.extend.bind(this), this.update.isEquals = function(Y, z) {
            return Y === z;
          }, this.update.newContext = function() {
            return new H().update;
          };
        }
        return Object.defineProperty(H.prototype, "isEquals", {
          get: function() {
            return this.update.isEquals;
          },
          set: function(Y) {
            this.update.isEquals = Y;
          },
          enumerable: !0,
          configurable: !0
        }), H.prototype.extend = function(Y, z) {
          this.commands[Y] = z;
        }, H.prototype.update = function(Y, z) {
          var V = this, F = typeof z == "function" ? { $apply: z } : z;
          Array.isArray(Y) && Array.isArray(F) || o(!Array.isArray(F), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
          }), o(typeof F == "object" && F !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(V.commands).join(", ") + ".");
          });
          var X = Y;
          return v(F).forEach(function(oe) {
            if (s.call(V.commands, oe)) {
              var re = Y === X;
              X = V.commands[oe](F[oe], X, F, Y), re && V.isEquals(X, Y) && (X = Y);
            } else {
              var Z = p(Y) === "Map" ? V.update(Y.get(oe), F[oe]) : V.update(Y[oe], F[oe]), ee = p(X) === "Map" ? X.get(oe) : X[oe];
              (!V.isEquals(Z, ee) || typeof Z > "u" && !s.call(Y, oe)) && (X === Y && (X = y(Y)), p(X) === "Map" ? X.set(oe, Z) : X[oe] = Z);
            }
          }), X;
        }, H;
      })()
    );
    t.Context = S;
    var E = {
      $push: function(H, Y, z) {
        return _(Y, z, "$push"), H.length ? Y.concat(H) : Y;
      },
      $unshift: function(H, Y, z) {
        return _(Y, z, "$unshift"), H.length ? H.concat(Y) : Y;
      },
      $splice: function(H, Y, z, V) {
        return D(Y, z), H.forEach(function(F) {
          P(F), Y === V && F.length && (Y = y(V)), u.apply(Y, F);
        }), Y;
      },
      $set: function(H, Y, z) {
        return N(z), H;
      },
      $toggle: function(H, Y) {
        O(H, "$toggle");
        var z = H.length ? y(Y) : Y;
        return H.forEach(function(V) {
          z[V] = !Y[V];
        }), z;
      },
      $unset: function(H, Y, z, V) {
        return O(H, "$unset"), H.forEach(function(F) {
          Object.hasOwnProperty.call(Y, F) && (Y === V && (Y = y(V)), delete Y[F]);
        }), Y;
      },
      $add: function(H, Y, z, V) {
        return U(Y, "$add"), O(H, "$add"), p(Y) === "Map" ? H.forEach(function(F) {
          var X = F[0], oe = F[1];
          Y === V && Y.get(X) !== oe && (Y = y(V)), Y.set(X, oe);
        }) : H.forEach(function(F) {
          Y === V && !Y.has(F) && (Y = y(V)), Y.add(F);
        }), Y;
      },
      $remove: function(H, Y, z, V) {
        return U(Y, "$remove"), O(H, "$remove"), H.forEach(function(F) {
          Y === V && Y.has(F) && (Y = y(V)), Y.delete(F);
        }), Y;
      },
      $merge: function(H, Y, z, V) {
        return k(Y, H), v(H).forEach(function(F) {
          H[F] !== Y[F] && (Y === V && (Y = y(V)), Y[F] = H[F]);
        }), Y;
      },
      $apply: function(H, Y) {
        return M(H), H(Y);
      }
    }, w = new S();
    t.isEquals = w.update.isEquals, t.extend = w.extend, t.default = w.update, t.default.default = e.exports = m(t.default, t);
    function _(H, Y, z) {
      o(Array.isArray(H), function() {
        return "update(): expected target of " + r(z) + " to be an array; got " + r(H) + ".";
      }), O(Y[z], z);
    }
    function O(H, Y) {
      o(Array.isArray(H), function() {
        return "update(): expected spec of " + r(Y) + " to be an array; got " + r(H) + ". Did you forget to wrap your parameter in an array?";
      });
    }
    function D(H, Y) {
      o(Array.isArray(H), function() {
        return "Expected $splice target to be an array; got " + r(H);
      }), P(Y.$splice);
    }
    function P(H) {
      o(Array.isArray(H), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + r(H) + ". Did you forget to wrap your parameters in an array?";
      });
    }
    function M(H) {
      o(typeof H == "function", function() {
        return "update(): expected spec of $apply to be a function; got " + r(H) + ".";
      });
    }
    function N(H) {
      o(Object.keys(H).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
      });
    }
    function k(H, Y) {
      o(Y && typeof Y == "object", function() {
        return "update(): $merge expects a spec of type 'object'; got " + r(Y);
      }), o(H && typeof H == "object", function() {
        return "update(): $merge expects a target of type 'object'; got " + r(H);
      });
    }
    function U(H, Y) {
      var z = p(H);
      o(z === "Map" || z === "Set", function() {
        return "update(): " + r(Y) + " expects a target of type Set or Map; got " + r(z);
      });
    }
  })(EO, EO.exports)), EO.exports;
}
var hut = put();
const gut = /* @__PURE__ */ Hn(hut);
function mut(e) {
  return e.path.length > 0 ? Yct({}, e.path, e.spec) : e.spec;
}
function HA(e, t) {
  let n = e;
  return t.forEach((r) => {
    n = gut(n, mut(r));
  }), n;
}
function qA(e, t) {
  const n = FH(t), r = yde(t), i = n.concat(sut(r)), o = WA(e, i);
  return {
    path: n,
    spec: {
      $set: o
    }
  };
}
function kQ(e, t, n) {
  return xde(NQ(e, n), NQ(t, n));
}
function vut(e, t, n, r) {
  let i = WA(e, n);
  const o = [];
  kQ(t, n, n.length) ? i = HA(i, [
    qA(i, Bct(t, n.length))
  ]) : (o.push(qA(e, t)), kQ(t, n, t.length - 1) && n.splice(t.length - 1, 1));
  const u = WA(e, t);
  let f, p;
  r === Y0.LEFT || r === Y0.TOP ? (f = u, p = i) : (f = i, p = u);
  let m = "column";
  return (r === Y0.LEFT || r === Y0.RIGHT) && (m = "row"), o.push({
    path: n,
    spec: {
      $set: { first: f, second: p, direction: m }
    }
  }), o;
}
function yut(e) {
  const t = FH(e), n = yde(e);
  let r;
  return n === "first" ? r = 0 : r = 100, {
    path: t,
    spec: {
      splitPercentage: {
        $set: r
      }
    }
  };
}
function but(e, t) {
  let n = {};
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    n = {
      splitPercentage: {
        $set: i === "first" ? t : 100 - t
      },
      [i]: n
    };
  }
  return {
    spec: n,
    path: []
  };
}
var zQ = {}, xut = 70;
function u2(e) {
  return e.initialValue != null;
}
var I2, Sut = (I2 = class extends it.PureComponent {
  constructor() {
    super(...arguments);
    Un(this, "state", {
      currentNode: null,
      lastInitialValue: null,
      mosaicId: this.props.mosaicId ?? iut()
    });
    Un(this, "updateRoot", (t, n = !1) => {
      const r = this.getRoot() || {};
      this.replaceRoot(HA(r, t), n);
    });
    Un(this, "replaceRoot", (t, n = !1) => {
      this.props.onChange(t), !n && this.props.onRelease && this.props.onRelease(t), u2(this.props) && this.setState({ currentNode: t });
    });
    Un(this, "actions", {
      updateTree: this.updateRoot,
      remove: (t) => {
        t.length === 0 ? this.replaceRoot(null) : this.updateRoot([qA(this.getRoot(), t)]);
      },
      expand: (t, n = xut) => this.updateRoot([but(t, n)]),
      getRoot: () => this.getRoot(),
      hide: (t) => this.updateRoot([yut(t)]),
      replaceWith: (t, n) => this.updateRoot([
        {
          path: t,
          spec: {
            $set: n
          }
        }
      ])
    });
    Un(this, "childContext", {
      mosaicActions: this.actions,
      mosaicId: this.state.mosaicId,
      blueprintNamespace: this.props.blueprintNamespace
    });
  }
  static getDerivedStateFromProps(t, n) {
    if (t.mosaicId && n.mosaicId !== t.mosaicId && zQ.NODE_ENV !== "production")
      throw new Error("Mosaic does not support updating the mosaicId after instantiation");
    return u2(t) && t.initialValue !== n.lastInitialValue ? {
      lastInitialValue: t.initialValue,
      currentNode: t.initialValue
    } : null;
  }
  render() {
    const { className: t } = this.props;
    return /* @__PURE__ */ it.createElement(Qd.Provider, { value: this.childContext }, /* @__PURE__ */ it.createElement("div", { className: On(t, "mosaic mosaic-drop-target") }, this.renderTree(), /* @__PURE__ */ it.createElement(Cde, null)));
  }
  getRoot() {
    return u2(this.props) ? this.state.currentNode : this.props.value;
  }
  renderTree() {
    const t = this.getRoot();
    if (this.validateTree(t), t == null)
      return this.props.zeroStateView;
    {
      const { renderTile: n, resize: r } = this.props;
      return /* @__PURE__ */ it.createElement(cut, { root: t, renderTile: n, resize: r });
    }
  }
  validateTree(t) {
    if (zQ.NODE_ENV !== "production") {
      const n = iS(Gct(Ict(A1(t)), (r) => r > 1));
      if (n.length > 0)
        throw new Error(
          `Duplicate IDs [${n.join(", ")}] detected. Mosaic does not support leaves with the same ID`
        );
    }
  }
}, Un(I2, "defaultProps", {
  onChange: () => {
  },
  zeroStateView: /* @__PURE__ */ it.createElement(dut, null),
  className: "mosaic-blueprint-theme",
  blueprintNamespace: "bp3"
}), I2), wut = class extends it.PureComponent {
  render() {
    return /* @__PURE__ */ it.createElement(
      Bae,
      {
        backend: Gae,
        options: Jct,
        context: window,
        ...this.props.dragAndDropManager && { manager: this.props.dragAndDropManager }
      },
      /* @__PURE__ */ it.createElement(Sut, { ...this.props })
    );
  }
}, vP = ({
  title: e,
  className: t,
  onClick: n,
  text: r
}) => {
  const { blueprintNamespace: i } = it.useContext(Qd);
  return /* @__PURE__ */ it.createElement(
    "button",
    {
      title: e,
      onClick: n,
      className: On(
        "mosaic-default-control",
        Wo.getClasses(i, "BUTTON", "MINIMAL"),
        t
      )
    },
    r && /* @__PURE__ */ it.createElement("span", { className: "control-text" }, r)
  );
}, P2, Rde = (P2 = class extends it.PureComponent {
  render() {
    return /* @__PURE__ */ it.createElement(Qd.Consumer, null, ({ mosaicActions: e }) => /* @__PURE__ */ it.createElement(
      vP,
      {
        title: "Expand",
        className: On(
          "expand-button",
          Wo.getIconClass(this.context.blueprintNamespace, "MAXIMIZE")
        ),
        onClick: this.createExpand(e)
      }
    ));
  }
  createExpand(e) {
    return () => {
      e.expand(this.context.mosaicWindowActions.getPath()), this.props.onClick && this.props.onClick();
    };
  }
}, Un(P2, "contextType", oS), P2), N2, Ode = (N2 = class extends it.PureComponent {
  render() {
    return /* @__PURE__ */ it.createElement(Qd.Consumer, null, ({ mosaicActions: e, blueprintNamespace: t }) => /* @__PURE__ */ it.createElement(
      vP,
      {
        title: "Close Window",
        className: On("close-button", Wo.getIconClass(t, "CROSS")),
        onClick: this.createRemove(e)
      }
    ));
  }
  createRemove(e) {
    return () => {
      e.remove(this.context.mosaicWindowActions.getPath()), this.props.onClick && this.props.onClick();
    };
  }
}, Un(N2, "contextType", oS), N2), M2, Tut = (M2 = class extends it.PureComponent {
  constructor() {
    super(...arguments);
    Un(this, "replace", () => {
      this.context.mosaicWindowActions.replaceWithNew().then(() => {
        this.props.onClick && this.props.onClick();
      }).catch(RH);
    });
  }
  render() {
    return /* @__PURE__ */ it.createElement(
      vP,
      {
        title: "Replace Window",
        className: On(
          "replace-button",
          Wo.getIconClass(this.context.blueprintNamespace, "EXCHANGE")
        ),
        onClick: this.replace
      }
    );
  }
}, Un(M2, "contextType", oS), M2), j2, Eut = (j2 = class extends it.PureComponent {
  constructor() {
    super(...arguments);
    Un(this, "split", () => {
      this.context.mosaicWindowActions.split().then(() => {
        this.props.onClick && this.props.onClick();
      }).catch(RH);
    });
  }
  render() {
    return /* @__PURE__ */ it.createElement(
      vP,
      {
        title: "Split Window",
        className: On(
          "split-button",
          Wo.getIconClass(this.context.blueprintNamespace, "ADD_COLUMN_RIGHT")
        ),
        onClick: this.split
      }
    );
  }
}, Un(j2, "contextType", oS), j2), _ut = it.Children.toArray([
  /* @__PURE__ */ it.createElement(Tut, null),
  /* @__PURE__ */ it.createElement(Eut, null),
  /* @__PURE__ */ it.createElement(Rde, null),
  /* @__PURE__ */ it.createElement(Ode, null)
]), Cut = it.Children.toArray([/* @__PURE__ */ it.createElement(Rde, null), /* @__PURE__ */ it.createElement(Ode, null)]), Rut = class extends it.PureComponent {
  render() {
    return /* @__PURE__ */ it.createElement("div", { className: "separator" });
  }
}, CO, Out = (CO = class extends it.Component {
  constructor() {
    super(...arguments);
    Un(this, "state", {
      additionalControlsOpen: !1
    });
    Un(this, "rootElement", null);
    Un(this, "renderDropTarget", (t) => {
      const { path: n } = this.props;
      return /* @__PURE__ */ it.createElement(_de, { position: t, path: n, key: t });
    });
    Un(this, "split", (...t) => {
      this.checkCreateNode();
      const { createNode: n, path: r } = this.props, { mosaicActions: i } = this.context, o = i.getRoot(), s = this.rootElement.offsetWidth > this.rootElement.offsetHeight ? "row" : "column";
      return Promise.resolve(n(...t)).then(
        (u) => i.replaceWith(r, {
          direction: s,
          second: u,
          first: WA(o, r)
        })
      );
    });
    Un(this, "swap", (...t) => {
      this.checkCreateNode();
      const { mosaicActions: n } = this.context, { createNode: r, path: i } = this.props;
      return Promise.resolve(r(...t)).then((o) => n.replaceWith(i, o));
    });
    Un(this, "setAdditionalControlsOpen", (t) => {
      var r, i;
      const n = t === "toggle" ? !this.state.additionalControlsOpen : t;
      this.setState({ additionalControlsOpen: n }), (i = (r = this.props).onAdditionalControlsToggle) == null || i.call(r, n);
    });
    Un(this, "getPath", () => this.props.path);
    Un(this, "connectDragSource", (t) => {
      const { connectDragSource: n } = this.props;
      return n(t);
    });
    Un(this, "childContext", {
      // @ts-ignore
      blueprintNamespace: this.context.blueprintNamespace,
      mosaicWindowActions: {
        split: this.split,
        replaceWithNew: this.swap,
        setAdditionalControlsOpen: this.setAdditionalControlsOpen,
        getPath: this.getPath,
        connectDragSource: this.connectDragSource
      }
    });
  }
  render() {
    const {
      className: t,
      isOver: n,
      renderPreview: r,
      additionalControls: i,
      connectDropTarget: o,
      connectDragPreview: s,
      draggedMosaicId: u,
      disableAdditionalControlsOverlay: f
    } = this.props;
    return /* @__PURE__ */ it.createElement(oS.Provider, { value: this.childContext }, o(
      /* @__PURE__ */ it.createElement(
        "div",
        {
          className: On("mosaic-window mosaic-drop-target", t, {
            "drop-target-hover": n && u === this.context.mosaicId,
            "additional-controls-open": this.state.additionalControlsOpen
          }),
          ref: (p) => {
            this.rootElement = p;
          }
        },
        this.renderToolbar(),
        /* @__PURE__ */ it.createElement("div", { className: "mosaic-window-body" }, this.props.children),
        !f && /* @__PURE__ */ it.createElement(
          "div",
          {
            className: "mosaic-window-body-overlay",
            onClick: () => {
              this.setAdditionalControlsOpen(!1);
            }
          }
        ),
        /* @__PURE__ */ it.createElement("div", { className: "mosaic-window-additional-actions-bar" }, i),
        s(r(this.props)),
        /* @__PURE__ */ it.createElement("div", { className: "drop-target-container" }, bde(Y0).map(this.renderDropTarget))
      )
    ));
  }
  getToolbarControls() {
    const { toolbarControls: t, createNode: n } = this.props;
    return t || (n ? _ut : Cut);
  }
  renderToolbar() {
    const { title: t, draggable: n, additionalControls: r, additionalControlButtonText: i, path: o, renderToolbar: s } = this.props, { additionalControlsOpen: u } = this.state, f = this.getToolbarControls(), p = n && o.length > 0, m = p ? this.props.connectDragSource : (S) => S;
    if (s) {
      const S = m(s(this.props, n));
      return /* @__PURE__ */ it.createElement("div", { className: On("mosaic-window-toolbar", { draggable: p }) }, S);
    }
    const v = m(
      /* @__PURE__ */ it.createElement("div", { title: t, className: "mosaic-window-title" }, t)
    ), y = !qct(r);
    return /* @__PURE__ */ it.createElement("div", { className: On("mosaic-window-toolbar", { draggable: p }) }, v, /* @__PURE__ */ it.createElement("div", { className: On("mosaic-window-controls", Wo.getClasses("BUTTON_GROUP")) }, y && /* @__PURE__ */ it.createElement(
      "button",
      {
        onClick: () => this.setAdditionalControlsOpen(!u),
        className: On(
          Wo.getClasses(this.context.blueprintNamespace, "BUTTON", "MINIMAL"),
          Wo.getIconClass(this.context.blueprintNamespace, "MORE"),
          {
            [Wo.getClasses(this.context.blueprintNamespace, "ACTIVE")]: u
          }
        )
      },
      /* @__PURE__ */ it.createElement("span", { className: "control-text" }, i)
    ), y && /* @__PURE__ */ it.createElement(Rut, null), f));
  }
  checkCreateNode() {
    if (this.props.createNode == null)
      throw new Error("Operation invalid unless `createNode` is defined");
  }
}, Un(CO, "defaultProps", {
  additionalControlButtonText: "More",
  draggable: !0,
  renderPreview: ({ title: t }) => /* @__PURE__ */ it.createElement("div", { className: "mosaic-preview" }, /* @__PURE__ */ it.createElement("div", { className: "mosaic-window-toolbar" }, /* @__PURE__ */ it.createElement("div", { className: "mosaic-window-title" }, t)), /* @__PURE__ */ it.createElement("div", { className: "mosaic-window-body" }, /* @__PURE__ */ it.createElement("h4", null, t), /* @__PURE__ */ it.createElement(Wo.Icon, { className: "default-preview-icon", size: "large", icon: "APPLICATION" }))),
  renderToolbar: null
}), Un(CO, "contextType", Qd), CO);
function Aut(e) {
  const { mosaicActions: t, mosaicId: n } = Qi(Qd), [, r, i] = TUe({
    type: D1.WINDOW,
    item: (f) => {
      e.onDragStart && e.onDragStart();
      const p = zct(() => t.hide(e.path));
      return {
        mosaicId: n,
        hideTimer: p
      };
    },
    end: (f, p) => {
      const { hideTimer: m } = f;
      window.clearTimeout(m);
      const v = e.path, y = p.getDropResult() || {}, { position: S, path: E } = y;
      S != null && E != null && !xde(E, v) ? (t.updateTree(vut(t.getRoot(), v, E, S)), e.onDragEnd && e.onDragEnd("drop")) : (t.updateTree([
        {
          path: FH(v),
          spec: {
            splitPercentage: {
              $set: void 0
            }
          }
        }
      ]), e.onDragEnd && e.onDragEnd("reset"));
    }
  }), [{ isOver: o, draggedMosaicId: s }, u] = BI({
    accept: D1.WINDOW,
    collect: (f) => {
      var p;
      return {
        isOver: f.isOver(),
        draggedMosaicId: (p = f.getItem()) == null ? void 0 : p.mosaicId
      };
    }
  });
  return /* @__PURE__ */ it.createElement(
    Out,
    {
      ...e,
      connectDragPreview: i,
      connectDragSource: r,
      connectDropTarget: u,
      isOver: o,
      draggedMosaicId: s
    }
  );
}
var Dut = class extends it.PureComponent {
  render() {
    return /* @__PURE__ */ it.createElement(Aut, { ...this.props });
  }
};
const Iut = hg(null), d2 = {
  didCatch: !1,
  error: null
};
class WH extends vJ {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = d2;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, r, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
        o[s] = arguments[s];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(d2);
    }
  }
  componentDidCatch(t, n) {
    var r, i;
    (r = (i = this.props).onError) === null || r === void 0 || r.call(i, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (r && n.error !== null && Put(t.resetKeys, i)) {
      var o, s;
      (o = (s = this.props).onReset) === null || o === void 0 || o.call(s, {
        next: i,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(d2);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: i
    } = this.props, {
      didCatch: o,
      error: s
    } = this.state;
    let u = t;
    if (o) {
      const f = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        u = n(f);
      else if (r)
        u = Ou(r, f);
      else if (i !== void 0)
        u = i;
      else
        throw s;
    }
    return Ou(Iut.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function Put() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
const f2 = ye(Ade)(({ theme: e }) => ({
  ...e.typography.h6,
  flexGrow: 1,
  paddingLeft: e.spacing(0.5)
})), Nut = ye("div")(({ theme: e }) => ({
  ...e.typography.h6,
  flexGrow: 1,
  paddingLeft: e.spacing(0.5)
}));
function Ade({ children: e, ...t }) {
  return /* @__PURE__ */ T.jsx(St, { variant: "h2", noWrap: !0, color: "inherit", ...t, children: e });
}
Ade.propTypes = {
  children: c.node.isRequired
};
function Dde({
  error: e = null,
  hideWindowTitle: t = !1,
  isFetching: n = !1,
  manifestTitle: r = ""
}) {
  let i = null;
  return n ? i = /* @__PURE__ */ T.jsx(f2, { children: /* @__PURE__ */ T.jsx(pi, { variant: "text" }) }) : e ? i = /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx($W, { color: "error" }),
    /* @__PURE__ */ T.jsx(f2, { color: "textSecondary", children: e })
  ] }) : t ? i = /* @__PURE__ */ T.jsx(Nut, {}) : i = /* @__PURE__ */ T.jsx(f2, { children: r }), i;
}
Dde.propTypes = {
  error: c.string,
  hideWindowTitle: c.bool,
  isFetching: c.bool,
  manifestTitle: c.string
};
const Mut = (e, { windowId: t }) => ({
  error: ax(e, { windowId: t }).error,
  hideWindowTitle: fa(e, { windowId: t }).hideWindowTitle,
  isFetching: ax(e, { windowId: t }).isFetching,
  manifestTitle: Lu(e, { windowId: t })
}), jut = wt(
  At(Mut, null),
  Tt("WindowTopBarTitle")
), Lut = jut(Dde), kut = ye(Yx, { name: "WindowTopBar", slot: "root" })(() => ({
  zIndex: 1100
})), zut = ye(ny, { name: "WindowTopBar", slot: "toolbar" })(({ ownerState: e, theme: t }) => {
  var n;
  return {
    backgroundColor: (n = t.palette.shades) == null ? void 0 : n.main,
    borderTop: "2px solid",
    borderTopColor: e != null && e.focused ? t.palette.primary.main : "transparent",
    minHeight: 32,
    paddingLeft: t.spacing(0.5),
    paddingRight: t.spacing(0.5),
    ...(e == null ? void 0 : e.windowDraggable) && {
      cursor: "move"
    }
  };
});
function Ide({
  removeWindow: e,
  windowId: t,
  toggleWindowSideBar: n,
  maximizeWindow: r = () => {
  },
  maximized: i = !1,
  minimizeWindow: o = () => {
  },
  allowClose: s = !0,
  allowMaximize: u = !0,
  focusWindow: f = () => {
  },
  allowFullscreen: p = !1,
  allowTopMenuButton: m = !0,
  allowWindowSideBar: v = !0,
  component: y = "nav"
}) {
  const { t: S } = Ct(), E = arguments[0];
  return /* @__PURE__ */ T.jsx(kut, { component: y, "aria-label": S("windowNavigation"), position: "relative", color: "default", enableColorOnDark: !0, children: /* @__PURE__ */ T.jsxs(
    zut,
    {
      disableGutters: !0,
      onMouseDown: f,
      ownerState: E,
      className: On(Nt("window-top-bar")),
      variant: "dense",
      children: [
        v && /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": S("toggleWindowSideBar"),
            onClick: n,
            className: Nt("window-menu-btn"),
            children: /* @__PURE__ */ T.jsx(YW, {})
          }
        ),
        /* @__PURE__ */ T.jsx(
          Lut,
          {
            windowId: t
          }
        ),
        m && /* @__PURE__ */ T.jsx(Sce, { windowId: t, className: Nt("window-menu-btn") }),
        /* @__PURE__ */ T.jsx(wce, { windowId: t }),
        /* @__PURE__ */ T.jsx(Ece, { windowId: t }),
        u && /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": S(i ? "minimizeWindow" : "maximizeWindow"),
            className: On(Nt("window-maximize"), Nt("window-menu-btn")),
            onClick: i ? o : r,
            children: i ? /* @__PURE__ */ T.jsx(Rce, {}) : /* @__PURE__ */ T.jsx(Cce, {})
          }
        ),
        p && /* @__PURE__ */ T.jsx(XW, { className: Nt("window-menu-btn") }),
        s && /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": S("closeWindow"),
            className: On(Nt("window-close"), Nt("window-menu-btn")),
            onClick: e,
            children: /* @__PURE__ */ T.jsx(m_, {})
          }
        )
      ]
    }
  ) });
}
Ide.propTypes = {
  allowClose: c.bool,
  allowFullscreen: c.bool,
  allowMaximize: c.bool,
  allowTopMenuButton: c.bool,
  allowWindowSideBar: c.bool,
  component: c.elementType,
  focused: c.bool,
  // eslint-disable-line react/no-unused-prop-types
  focusWindow: c.func,
  maximized: c.bool,
  maximizeWindow: c.func,
  minimizeWindow: c.func,
  removeWindow: c.func.isRequired,
  toggleWindowSideBar: c.func.isRequired,
  windowDraggable: c.bool,
  // eslint-disable-line react/no-unused-prop-types
  windowId: c.string.isRequired
};
const But = (e, { windowId: t }) => {
  const n = fa(e, { windowId: t });
  return {
    allowClose: n.allowClose,
    allowFullscreen: n.allowFullscreen,
    allowMaximize: n.allowMaximize,
    allowTopMenuButton: n.allowTopMenuButton,
    allowWindowSideBar: n.allowWindowSideBar,
    focused: p3(e, { windowId: t }),
    maximized: n.maximized
  };
}, Vut = (e, { windowId: t }) => ({
  focusWindow: () => e(n_(t)),
  maximizeWindow: () => e(Bte(t)),
  minimizeWindow: () => e(Vte(t)),
  removeWindow: () => e(N3(t)),
  toggleWindowSideBar: () => e(Fte(t))
}), Uut = wt(
  At(But, Vut),
  Tt("WindowTopBar")
), Fut = Uut(Ide);
var BQ = {};
function Wut(e, t, n) {
  const r = t.getBoundingClientRect(), i = n && n.getBoundingClientRect(), o = jl(t);
  let s;
  if (t.fakeTransform)
    s = t.fakeTransform;
  else {
    const p = o.getComputedStyle(t);
    s = p.getPropertyValue("-webkit-transform") || p.getPropertyValue("transform");
  }
  let u = 0, f = 0;
  if (s && s !== "none" && typeof s == "string") {
    const p = s.split("(")[1].split(")")[0].split(",");
    u = parseInt(p[4], 10), f = parseInt(p[5], 10);
  }
  return e === "left" ? i ? `translateX(${i.right + u - r.left}px)` : `translateX(${o.innerWidth + u - r.left}px)` : e === "right" ? i ? `translateX(-${r.right - i.left - u}px)` : `translateX(-${r.left + r.width - u}px)` : e === "up" ? i ? `translateY(${i.bottom + f - r.top}px)` : `translateY(${o.innerHeight + f - r.top}px)` : i ? `translateY(-${r.top - i.top + r.height - f}px)` : `translateY(-${r.top + r.height - f}px)`;
}
function Pde(e) {
  return typeof e == "function" ? e() : e;
}
function _O(e, t, n) {
  const r = Pde(n), i = Wut(e, t, r);
  i && (t.style.webkitTransform = i, t.style.transform = i);
}
const HH = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = pa(), i = {
    enter: r.transitions.easing.easeOut,
    exit: r.transitions.easing.sharp
  }, o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: s,
    appear: u = !0,
    children: f,
    container: p,
    direction: m = "down",
    easing: v = i,
    in: y,
    onEnter: S,
    onEntered: E,
    onEntering: w,
    onExit: _,
    onExited: O,
    onExiting: D,
    style: P,
    timeout: M = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: N = Vc,
    ...k
  } = t, U = $.useRef(null), H = kr(Sg(f), U, n), Y = (J) => (le) => {
    J && (le === void 0 ? J(U.current) : J(U.current, le));
  }, z = Y((J, le) => {
    _O(m, J, p), uF(J), S && S(J, le);
  }), V = Y((J, le) => {
    const be = cg({
      timeout: M,
      style: P,
      easing: v
    }, {
      mode: "enter"
    });
    J.style.webkitTransition = r.transitions.create("-webkit-transform", {
      ...be
    }), J.style.transition = r.transitions.create("transform", {
      ...be
    }), J.style.webkitTransform = "none", J.style.transform = "none", w && w(J, le);
  }), F = Y(E), X = Y(D), oe = Y((J) => {
    const le = cg({
      timeout: M,
      style: P,
      easing: v
    }, {
      mode: "exit"
    });
    J.style.webkitTransition = r.transitions.create("-webkit-transform", le), J.style.transition = r.transitions.create("transform", le), _O(m, J, p), _ && _(J);
  }), re = Y((J) => {
    J.style.webkitTransition = "", J.style.transition = "", O && O(J);
  }), Z = (J) => {
    s && s(U.current, J);
  }, ee = $.useCallback(() => {
    U.current && _O(m, U.current, p);
  }, [m, p]);
  return $.useEffect(() => {
    if (y || m === "down" || m === "right")
      return;
    const J = u_(() => {
      U.current && _O(m, U.current, p);
    }), le = jl(U.current);
    return le.addEventListener("resize", J), () => {
      J.clear(), le.removeEventListener("resize", J);
    };
  }, [m, y, p]), $.useEffect(() => {
    y || ee();
  }, [y, ee]), /* @__PURE__ */ T.jsx(N, {
    nodeRef: U,
    onEnter: z,
    onEntered: F,
    onEntering: V,
    onExit: oe,
    onExited: re,
    onExiting: X,
    addEndListener: Z,
    appear: u,
    in: y,
    timeout: M,
    ...k,
    children: (J, {
      ownerState: le,
      ...be
    }) => /* @__PURE__ */ $.cloneElement(f, {
      ref: H,
      style: {
        visibility: J === "exited" && !y ? "hidden" : void 0,
        ...P,
        ...f.props.style
      },
      ...be
    })
  });
});
BQ.NODE_ENV !== "production" && (HH.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: xg.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: Wa(c.oneOfType([Fd, c.func]), (e) => {
    if (e.open) {
      const t = Pde(e.container);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (BQ.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: c.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
function Hut(e) {
  return Vt("MuiDrawer", e);
}
Wt("MuiDrawer", ["root", "docked", "paper", "anchorLeft", "anchorRight", "anchorTop", "anchorBottom", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
var qut = {};
const Nde = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, (n.variant === "permanent" || n.variant === "persistent") && t.docked, t.modal];
}, $ut = (e) => {
  const {
    classes: t,
    anchor: n,
    variant: r
  } = e, i = {
    root: ["root", `anchor${Ke(n)}`],
    docked: [(r === "permanent" || r === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${Ke(n)}`, r !== "temporary" && `paperAnchorDocked${Ke(n)}`]
  };
  return Ft(i, Hut, t);
}, Gut = ye(uI, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: Nde
})(Lt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
}))), Yut = ye("div", {
  shouldForwardProp: ha,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: Nde
})({
  flex: "0 0 auto"
}), Xut = ye(Ei, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`paperAnchor${Ke(n.anchor)}`], n.variant !== "temporary" && t[`paperAnchorDocked${Ke(n.anchor)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "left" && t.variant !== "temporary",
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "top" && t.variant !== "temporary",
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "right" && t.variant !== "temporary",
    style: {
      borderLeft: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "bottom" && t.variant !== "temporary",
    style: {
      borderTop: `1px solid ${(e.vars || e).palette.divider}`
    }
  }]
}))), Mde = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function Zut(e) {
  return ["left", "right"].includes(e);
}
function Kut({
  direction: e
}, t) {
  return e === "rtl" && Zut(t) ? Mde[t] : t;
}
const qH = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiDrawer"
  }), i = pa(), o = wg(), s = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    anchor: u = "left",
    BackdropProps: f,
    children: p,
    className: m,
    elevation: v = 16,
    hideBackdrop: y = !1,
    ModalProps: {
      BackdropProps: S,
      ...E
    } = {},
    onClose: w,
    open: _ = !1,
    PaperProps: O = {},
    SlideProps: D,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: P,
    transitionDuration: M = s,
    variant: N = "temporary",
    slots: k = {},
    slotProps: U = {},
    ...H
  } = r, Y = $.useRef(!1);
  $.useEffect(() => {
    Y.current = !0;
  }, []);
  const z = Kut({
    direction: o ? "rtl" : "ltr"
  }, u), F = {
    ...r,
    anchor: u,
    elevation: v,
    open: _,
    variant: N,
    ...H
  }, X = $ut(F), oe = {
    slots: {
      transition: P,
      ...k
    },
    slotProps: {
      paper: O,
      transition: D,
      ...U,
      backdrop: sF(U.backdrop || {
        ...f,
        ...S
      }, {
        transitionDuration: M
      })
    }
  }, [re, Z] = Xt("root", {
    ref: n,
    elementType: Gut,
    className: yt(X.root, X.modal, m),
    shouldForwardComponentProp: !0,
    ownerState: F,
    externalForwardedProps: {
      ...oe,
      ...H,
      ...E
    },
    additionalProps: {
      open: _,
      onClose: w,
      hideBackdrop: y,
      slots: {
        backdrop: oe.slots.backdrop
      },
      slotProps: {
        backdrop: oe.slotProps.backdrop
      }
    }
  }), [ee, J] = Xt("paper", {
    elementType: Xut,
    shouldForwardComponentProp: !0,
    className: yt(X.paper, O.className),
    ownerState: F,
    externalForwardedProps: oe,
    additionalProps: {
      elevation: N === "temporary" ? v : 0,
      square: !0
    }
  }), [le, be] = Xt("docked", {
    elementType: Yut,
    ref: n,
    className: yt(X.root, X.docked, m),
    ownerState: F,
    externalForwardedProps: oe,
    additionalProps: H
    // pass `other` here because `DockedSlot` is also a root slot for some variants
  }), [ne, ae] = Xt("transition", {
    elementType: HH,
    ownerState: F,
    externalForwardedProps: oe,
    additionalProps: {
      in: _,
      direction: Mde[z],
      timeout: M,
      appear: Y.current
    }
  }), ie = /* @__PURE__ */ T.jsx(ee, {
    ...J,
    children: p
  });
  if (N === "permanent")
    return /* @__PURE__ */ T.jsx(le, {
      ...be,
      children: ie
    });
  const he = /* @__PURE__ */ T.jsx(ne, {
    ...ae,
    children: ie
  });
  return N === "persistent" ? /* @__PURE__ */ T.jsx(le, {
    ...be,
    children: he
  }) : /* @__PURE__ */ T.jsx(re, {
    ...Z,
    children: he
  });
});
qut.NODE_ENV !== "production" && (qH.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: c.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: c.object,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: jD,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: c.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: c.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: c.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PaperProps: c.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SlideProps: c.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    docked: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    docked: c.elementType,
    paper: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: c.oneOf(["permanent", "persistent", "temporary"])
});
const Qut = ye(yI, { name: "WindowSideBarButtons", slot: "root" })({
  "& .MuiTabs-flexContainer": {
    flexDirection: "column"
  },
  "&.MuiTabs-indicator": {
    display: "none"
  }
}), Jut = ye(ex, { name: "WindowSideBarButtons", slot: "button" })(({ theme: e }) => ({
  "&.Mui-selected": {
    borderRight: "2px solid",
    borderRightColor: e.palette.primary.main
  },
  "&.MuiTab-root": {
    "&:active": {
      backgroundColor: e.palette.action.active
    },
    "&:focus": {
      "@media (hover: none)": {
        backgroundColor: "transparent"
      },
      backgroundColor: e.palette.action.hover,
      textDecoration: "none"
      // Reset on touch devices, it doesn't add specificity
    },
    "&:hover": {
      "@media (hover: none)": {
        backgroundColor: "transparent"
      },
      backgroundColor: e.palette.action.hover,
      textDecoration: "none"
      // Reset on touch devices, it doesn't add specificity
    },
    borderRight: "2px solid transparent",
    minWidth: "auto"
  },
  fill: "currentcolor"
}));
function Gh({ value: e, ...t }) {
  const { t: n } = Ct();
  return /* @__PURE__ */ T.jsx(Bd, { title: n("openCompanionWindow", { context: e }), children: /* @__PURE__ */ T.jsx(
    Jut,
    {
      ...t,
      value: e,
      "aria-label": n("openCompanionWindow", { context: e }),
      disableRipple: !0
    }
  ) });
}
Gh.propTypes = {
  value: c.string.isRequired
};
function jde({
  addCompanionWindow: e,
  hasAnnotations: t = !1,
  hasAnyAnnotations: n = !1,
  hasAnyLayers: r = !1,
  hasCurrentLayers: i = !1,
  hasSearchResults: o = !1,
  hasSearchService: s = !1,
  panels: u = [],
  sideBarPanel: f = "closed"
}) {
  const { t: p } = Ct(), { PluginComponents: m } = lI("WindowSideBarButtons"), v = (y, S) => {
    e(S);
  };
  return /* @__PURE__ */ T.jsxs(
    Qut,
    {
      value: f === "closed" ? !1 : f,
      onChange: v,
      variant: "fullWidth",
      indicatorColor: "primary",
      textColor: "primary",
      orientation: "vertical",
      "aria-orientation": "vertical",
      "aria-label": p("sidebarPanelsNavigation"),
      children: [
        u.info && /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: "info",
            icon: /* @__PURE__ */ T.jsx(Ace, {})
          }
        ),
        u.attribution && /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: "attribution",
            icon: /* @__PURE__ */ T.jsx(Dce, {})
          }
        ),
        u.canvas && /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: "canvas",
            icon: /* @__PURE__ */ T.jsx(Pce, {})
          }
        ),
        u.annotations && (t || n) && /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: "annotations",
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "notification", invisible: !t, variant: "dot", children: /* @__PURE__ */ T.jsx(ZW, {}) })
          }
        ),
        u.search && s && /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: "search",
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "notification", invisible: !o, variant: "dot", children: /* @__PURE__ */ T.jsx(CI, {}) })
          }
        ),
        u.layers && r && /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: "layers",
            icon: /* @__PURE__ */ T.jsx(_c, { overlap: "rectangular", color: "notification", invisible: !i, variant: "dot", children: /* @__PURE__ */ T.jsx(Ice, {}) })
          }
        ),
        m && m.map((y) => /* @__PURE__ */ T.jsx(
          Gh,
          {
            value: y.value,
            icon: /* @__PURE__ */ T.jsx(y, {})
          },
          y.value
        ))
      ]
    }
  );
}
jde.propTypes = {
  addCompanionWindow: c.func.isRequired,
  hasAnnotations: c.bool,
  hasAnyAnnotations: c.bool,
  hasAnyLayers: c.bool,
  hasCurrentLayers: c.bool,
  hasSearchResults: c.bool,
  hasSearchService: c.bool,
  panels: c.objectOf(c.bool),
  sideBarPanel: c.string
};
const edt = (e, { windowId: t }) => ({
  addCompanionWindow: (n) => e(
    I3(t, { content: n, position: "left" })
  )
});
function VQ(e, t) {
  return e && e.some((n) => t(n).imageResources.length > 1);
}
function tdt(e, t) {
  return e && e.some((n) => {
    const r = t(n);
    return r.annotationListUris.length > 0 || r.canvasAnnotationPages.length > 0;
  });
}
function ndt(e, { windowId: t }) {
  var o, s;
  const { suggestedSearches: n } = Wn(e, { windowId: t }), r = (s = (o = e3(e, { position: "left", windowId: t })) == null ? void 0 : o[0]) == null ? void 0 : s.id, i = K1(e, { companionWindowId: r, windowId: t });
  return !!(n || i);
}
const rdt = (e, { windowId: t }) => ({
  hasAnnotations: wD(
    e,
    { windowId: t }
  ).length > 0,
  hasAnyAnnotations: tdt(Fa(e, { windowId: t }), Ho(e)),
  hasAnyLayers: VQ(Fa(e, { windowId: t }), Ho(e)),
  hasCurrentLayers: VQ(Ul(e, { windowId: t }), Ho(e)),
  hasSearchResults: ndt(e, { windowId: t }),
  hasSearchService: Dx(e, { windowId: t }) !== null,
  panels: fa(e, { windowId: t }).panels,
  sideBarPanel: (e3(e, { position: "left", windowId: t })[0] || {}).content
}), idt = wt(
  At(rdt, edt),
  Tt("WindowSideBarButtons")
), odt = idt(jde), adt = ye(qH, { name: "WindowSideBar", slot: "root" })(({ theme: e }) => ({
  flexShrink: 0,
  order: -1e3,
  zIndex: e.zIndex.appBar - 1
})), sdt = ye("nav", { name: "WindowSideBar", slot: "nav" })({
  position: "relative !important",
  width: 48
});
function Lde({
  classes: e = {},
  direction: t,
  windowId: n,
  sideBarOpen: r = !1
}) {
  const { t: i } = Ct();
  return /* @__PURE__ */ T.jsx(
    adt,
    {
      variant: "persistent",
      className: e.drawer,
      anchor: t === "rtl" ? "right" : "left",
      PaperProps: {
        "aria-label": i("sidebarPanelsNavigation"),
        component: sdt,
        variant: "outlined"
      },
      SlideProps: { direction: t === "rtl" ? "left" : "right", mountOnEnter: !0, unmountOnExit: !0 },
      open: r,
      children: /* @__PURE__ */ T.jsx(odt, { windowId: n })
    }
  );
}
Lde.propTypes = {
  classes: c.objectOf(c.string),
  direction: c.string.isRequired,
  sideBarOpen: c.bool,
  windowId: c.string.isRequired
};
const ldt = (e, { windowId: t }) => ({
  direction: Ax(e),
  sideBarOpen: (Wn(e, { windowId: t }) || {}).sideBarOpen,
  sideBarPanel: (Wn(e, { windowId: t }) || {}).sideBarPanel
}), cdt = wt(
  At(ldt, null),
  Tt("WindowSideBar")
), udt = cdt(Lde), UQ = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m14 7-5 5 5 5z"
}), "ArrowLeftSharp"), FQ = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m10 17 5-5-5-5z"
}), "ArrowRightSharp");
var ddt = {};
const yP = She({
  createStyledComponent: ye("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Gt({
    props: e,
    name: "MuiStack"
  })
});
ddt.NODE_ENV !== "production" && (yP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: c.oneOfType([c.oneOf(["column-reverse", "column", "row-reverse", "row"]), c.arrayOf(c.oneOf(["column-reverse", "column", "row-reverse", "row"])), c.object]),
  /**
   * Add an element between each child.
   */
  divider: c.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: c.oneOfType([c.arrayOf(c.oneOfType([c.number, c.string])), c.number, c.object, c.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: c.bool
});
const fdt = ye("pre", { name: "ErrorContent", slot: "stacktrace" })({
  overflowY: "scroll"
}), pdt = ye("pre", { name: "ErrorContent", slot: "metadata" })({
  height: "100px",
  overflowY: "scroll"
}), hdt = ye(iI, { name: "ErrorContent", slot: "accordion" })({
  backgroundColor: "inherit",
  color: "inherit",
  margin: 0
});
function kde({
  error: e,
  metadata: t = null,
  showJsError: n = !0,
  ...r
}) {
  const { t: i } = Ct();
  if (!n) return null;
  const o = {
    error: e,
    metadata: t,
    showJsError: n,
    t: i,
    ...r
  };
  return /* @__PURE__ */ T.jsxs(JI, { elevation: 6, variant: "filled", severity: "error", children: [
    i("errorDialogTitle"),
    n && /* @__PURE__ */ T.jsxs(hdt, { elevation: 2, square: !0, children: [
      /* @__PURE__ */ T.jsx(aI, { sx: { marginInlineStart: "-1rem" }, expandIcon: /* @__PURE__ */ T.jsx(sI, { sx: { color: "#fff" } }), children: i("jsError", { message: e.message, name: e.name }) }),
      /* @__PURE__ */ T.jsx(oI, { children: /* @__PURE__ */ T.jsxs(yP, { children: [
        /* @__PURE__ */ T.jsx(fdt, { children: i("jsStack", { stack: e.stack }) }),
        t && /* @__PURE__ */ T.jsx(pdt, { children: JSON.stringify(t, null, 2) })
      ] }) })
    ] }),
    /* @__PURE__ */ T.jsx(Ki, { targetName: "ErrorContent", ...o })
  ] });
}
kde.propTypes = {
  error: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  metadata: c.object,
  // eslint-disable-line react/forbid-prop-types
  showJsError: c.bool
};
const gdt = (e, { companionWindowId: t, windowId: n }) => ({
  metadata: {
    companionWindow: t && ju(e, { companionWindowId: t }),
    manifest: Va(e, { windowId: n }),
    viewer: hD(e, { windowId: n }),
    window: Wn(e, { windowId: n })
  },
  showJsError: Dn(e).window.showJsError
}), mdt = wt(
  At(gdt),
  Tt("ErrorContent")
), rU = mdt(kde);
function zde({
  content: e = null,
  id: t,
  windowId: n
}) {
  const { t: r } = Ct(), i = Yn(({ error: s }) => /* @__PURE__ */ T.jsx(
    Zd,
    {
      title: r("error"),
      windowId: n,
      id: t,
      children: /* @__PURE__ */ T.jsx(rU, { error: s, windowId: n, companionWindowId: t })
    }
  ), [n, r, t]), o = wV[e];
  return o ? /* @__PURE__ */ T.jsx(WH, { fallbackComponent: i, children: /* @__PURE__ */ T.jsx(o, { id: t, windowId: n }) }) : null;
}
zde.propTypes = {
  content: c.string,
  id: c.string.isRequired,
  windowId: c.string.isRequired
};
const vdt = (e, { id: t }) => ({
  content: ju(e, { companionWindowId: t }).content,
  id: t
}), ydt = wt(
  At(vdt),
  Tt("CompanionWindowFactory")
), bdt = ydt(zde), xdt = ye("div", { name: "CompanionArea", slot: "root" })(({ ownerState: e, theme: t }) => ({
  display: "flex",
  minHeight: 0,
  position: "relative",
  zIndex: t.zIndex.appBar - 2,
  ...(e.position === "bottom" || e.position === "far-bottom") && {
    flexDirection: "column",
    width: "100%"
  }
})), Sdt = ye("div", { name: "CompanionArea", slot: "container" })(({ ownerState: e }) => ({
  display: e != null && e.companionAreaOpen ? "flex" : "none",
  ...((e == null ? void 0 : e.position) === "bottom" || (e == null ? void 0 : e.position) === "far-bottom") && {
    flexDirection: "column",
    width: "100%"
  },
  ...(e == null ? void 0 : e.position) === "left" && (e == null ? void 0 : e.companionWindowIds) && e.companionWindowIds.length > 0 && {
    minWidth: "235px"
  }
})), wdt = ye("div", { name: "CompanionArea", slot: "toggle" })(({ theme: e }) => {
  var t;
  return {
    alignItems: "center",
    backgroundColor: e.palette.background.paper,
    border: `1px solid ${(t = e.palette.shades) == null ? void 0 : t.dark}`,
    ...e.applyStyles("dark", { borderColor: e.palette.divider }),
    borderInlineStart: 0,
    borderRadius: 0,
    display: "inline-flex",
    height: "48px",
    left: "100%",
    marginTop: "1rem",
    overflow: "hidden",
    padding: 2,
    position: "absolute",
    width: "23px",
    zIndex: e.zIndex.drawer
  };
});
function Bde({
  classes: e = {},
  className: t = void 0,
  direction: n,
  companionWindowIds: r,
  companionAreaOpen: i,
  setCompanionAreaOpen: o = () => {
  },
  position: s,
  sideBarOpen: u = !1,
  windowId: f
}) {
  const { t: p } = Ct(), m = s === "bottom" || s === "far-bottom" ? e.horizontal : null, v = n === "rtl" ? i ? /* @__PURE__ */ T.jsx(FQ, {}) : /* @__PURE__ */ T.jsx(UQ, {}) : i ? /* @__PURE__ */ T.jsx(UQ, {}) : /* @__PURE__ */ T.jsx(FQ, {}), y = (() => {
    const w = n === "rtl" ? "left" : "right", _ = n === "rtl" ? "right" : "left";
    switch (s) {
      case "right":
      case "far-right":
        return _;
      case "bottom":
      case "far-bottom":
        return "up";
      default:
        return w;
    }
  })(), S = On(m, Nt(`companion-area-${s}`), t), E = arguments[0];
  return /* @__PURE__ */ T.jsxs(xdt, { ownerState: E, className: S, children: [
    /* @__PURE__ */ T.jsx(HH, { in: i, direction: y, children: /* @__PURE__ */ T.jsx(
      Sdt,
      {
        ownerState: E,
        className: `${Nt("companion-windows")}`,
        children: r.map((w) => /* @__PURE__ */ T.jsx(bdt, { id: w, windowId: f }, w))
      }
    ) }),
    o && s === "left" && u && r.length > 0 && /* @__PURE__ */ T.jsx(wdt, { children: /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-expanded": i,
        "aria-label": p(i ? "collapseSidePanel" : "expandSidePanel"),
        edge: "start",
        onClick: () => {
          o(f, !i);
        },
        TooltipProps: { placement: "right" },
        children: v
      }
    ) })
  ] });
}
Bde.propTypes = {
  classes: c.objectOf(c.string),
  className: c.string,
  companionAreaOpen: c.bool.isRequired,
  companionWindowIds: c.arrayOf(c.string).isRequired,
  direction: c.string.isRequired,
  position: c.string.isRequired,
  setCompanionAreaOpen: c.func,
  sideBarOpen: c.bool,
  windowId: c.string.isRequired
};
const Tdt = (e, { windowId: t, position: n }) => ({
  companionAreaOpen: jee(e, { position: n, windowId: t }),
  companionWindowIds: gD(e, { position: n, windowId: t }),
  direction: Ax(e),
  sideBarOpen: (Wn(e, { windowId: t }) || {}).sideBarOpen
}), Edt = {
  setCompanionAreaOpen: Ute
}, _dt = wt(
  At(Tdt, Edt),
  Tt("CompanionArea")
), QE = _dt(Bde), Cdt = ye(Cg)(() => ({
  padding: (e) => e.spacing(1)
})), Rdt = ye("div")(() => ({
  "& .MuiPaper-root": {
    background: "transparent"
  },
  padding: (e) => e.spacing(2)
})), Odt = ye("div")(() => ({
  padding: (e) => e.spacing(2),
  paddingTop: 0
})), Vde = ({ onClose: e, container: t }) => /* @__PURE__ */ T.jsxs(
  cU,
  {
    variant: "contained",
    onClose: e,
    open: !0,
    container: t,
    children: [
      /* @__PURE__ */ T.jsx(uU, { id: "select-collection", children: /* @__PURE__ */ T.jsx(pi, { variant: "text" }) }),
      /* @__PURE__ */ T.jsxs(Cg, { children: [
        /* @__PURE__ */ T.jsx(pi, { variant: "text" }),
        /* @__PURE__ */ T.jsx(pi, { variant: "text" })
      ] })
    ]
  }
);
Vde.propTypes = {
  container: c.instanceOf(Element).isRequired,
  onClose: c.func.isRequired
};
function Ude({
  addWindow: e,
  collection: t = null,
  collectionPath: n = [],
  error: r = null,
  hideCollectionDialog: i,
  isMultipart: o = !1,
  manifest: s,
  manifestId: u,
  ready: f = !1,
  setWorkspaceAddVisibility: p,
  showCollectionDialog: m,
  updateWindow: v,
  windowId: y = null
}) {
  const S = Qi(Eg), { t: E } = Ct(), [w, _] = Bn(null), O = () => {
    i(y);
  }, D = (z) => {
    m(z.id, [...n, u], y);
  }, P = () => {
    m(
      n[n.length - 1],
      n.slice(0, -1),
      y
    );
  }, M = (z) => {
    y ? v(y, {
      canvasId: null,
      collectionPath: [...n, u],
      manifestId: z.id
    }) : e({ collectionPath: [...n, u], manifestId: z.id }), O(), p(!1);
  }, N = ((S == null ? void 0 : S.current) || document.body).querySelector(`#${y}`);
  if (r || !N)
    return null;
  if (!f) return /* @__PURE__ */ T.jsx(Vde, { container: N, onClose: O });
  const k = s && hs(s.getProperty("rights") || s.getProperty("license")), U = s && hs(s.getRequiredStatement()).filter((z) => z && z.getValue()).map((z) => ({
    label: null,
    values: z.getValues()
  })), H = s.getCollections(), Y = w || (H.length > 0 ? "collections" : "manifests");
  return /* @__PURE__ */ T.jsxs(
    cU,
    {
      variant: "contained",
      onClose: O,
      container: N,
      open: !0,
      children: [
        /* @__PURE__ */ T.jsxs(uU, { id: "select-collection", children: [
          /* @__PURE__ */ T.jsx(Zh, { component: "div", variant: "overline", children: E(o ? "multipartCollection" : "collection") }),
          /* @__PURE__ */ T.jsx(Zh, { component: "div", variant: "h3", children: /* @__PURE__ */ T.jsx(Cc, { resource: s }) })
        ] }),
        /* @__PURE__ */ T.jsxs(Cdt, { children: [
          t && /* @__PURE__ */ T.jsx(
            G4,
            {
              startIcon: /* @__PURE__ */ T.jsx(zF, {}),
              onClick: () => P(),
              children: /* @__PURE__ */ T.jsx(Cc, { resource: t })
            }
          ),
          /* @__PURE__ */ T.jsxs(Rdt, { children: [
            /* @__PURE__ */ T.jsx(lie, { manifestId: s.id }),
            /* @__PURE__ */ T.jsxs(
              iy,
              {
                id: "select-collection-rights",
                label: E("attributionTitle"),
                children: [
                  U && /* @__PURE__ */ T.jsx(v_, { labelValuePairs: U, defaultLabel: E("attribution") }),
                  k && k.length > 0 && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
                    /* @__PURE__ */ T.jsx(Zh, { variant: "subtitle2", component: "dt", children: E("rights") }),
                    k.map((z) => /* @__PURE__ */ T.jsx(Zh, { variant: "body1", component: "dd", children: /* @__PURE__ */ T.jsx(Ahe, { target: "_blank", rel: "noopener noreferrer", href: z, children: z }) }, z))
                  ] })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ T.jsxs(Odt, { children: [
            s.getTotalCollections() > 0 && /* @__PURE__ */ T.jsx(Y4, { clickable: !0, color: Y === "collections" ? "primary" : "default", onClick: () => _("collections"), label: E("totalCollections", { count: s.getTotalCollections() }) }),
            s.getTotalManifests() > 0 && /* @__PURE__ */ T.jsx(Y4, { clickable: !0, color: Y === "manifests" ? "primary" : "default", onClick: () => _("manifests"), label: E("totalManifests", { count: s.getTotalManifests() }) })
          ] }),
          Y === "collections" && /* @__PURE__ */ T.jsx(tA, { children: H.map((z) => /* @__PURE__ */ T.jsx(
            JE,
            {
              onClick: () => {
                D(z);
              },
              variant: "multiline",
              children: /* @__PURE__ */ T.jsx(Cc, { resource: z })
            },
            z.id
          )) }),
          Y === "manifests" && /* @__PURE__ */ T.jsx(tA, { children: s.getManifests().map((z) => /* @__PURE__ */ T.jsx(
            JE,
            {
              onClick: () => {
                M(z);
              },
              variant: "multiline",
              children: /* @__PURE__ */ T.jsx(Cc, { resource: z })
            },
            z.id
          )) })
        ] }),
        /* @__PURE__ */ T.jsx(dU, { children: /* @__PURE__ */ T.jsx(G4, { onClick: O, children: E("close") }) })
      ]
    }
  );
}
Ude.propTypes = {
  addWindow: c.func.isRequired,
  collection: c.object,
  // eslint-disable-line react/forbid-prop-types
  collectionPath: c.arrayOf(c.string),
  error: c.string,
  hideCollectionDialog: c.func.isRequired,
  isMultipart: c.bool,
  manifest: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  manifestId: c.string.isRequired,
  ready: c.bool,
  setWorkspaceAddVisibility: c.func.isRequired,
  showCollectionDialog: c.func.isRequired,
  updateWindow: c.func.isRequired,
  windowId: c.string
};
const Adt = {
  addWindow: r_,
  hideCollectionDialog: Hte,
  setWorkspaceAddVisibility: ND,
  showCollectionDialog: i_,
  updateWindow: Po
}, Ddt = (e, { windowId: t }) => {
  const { collectionPath: n, collectionManifestId: r } = Wn(e, { windowId: t }), i = Va(e, { manifestId: r }), o = n && n[n.length - 1], s = o && Va(e, { manifestId: o });
  return {
    collection: s && nr(e, { manifestId: s.id }),
    collectionPath: n,
    error: i && i.error,
    isMultipart: V1(e, { manifestId: r }).includes("multi-part"),
    manifest: i && nr(e, { manifestId: r }),
    manifestId: r,
    open: e.workspace.collectionDialogOn,
    ready: i && !!i.json,
    windowId: t
  };
}, Idt = wt(
  At(Ddt, Adt),
  Tt("CollectionDialog")
), Pdt = Idt(Ude), Ndt = gg(() => Promise.resolve().then(() => Zgt)), Fde = gg(() => Promise.resolve().then(() => emt)), Wde = gg(() => Promise.resolve().then(() => umt)), Hde = gg(() => Promise.resolve().then(() => Smt)), Mdt = gg(() => Promise.resolve().then(() => ymt)), jdt = gg(() => Promise.resolve().then(() => hmt));
Fde.displayName = "GalleryView";
Wde.displayName = "SelectCollection";
Hde.displayName = "WindowViewer";
const Ldt = ye("div", { name: "PrimaryWindow", slot: "root" })(() => ({
  display: "flex",
  flex: 1,
  position: "relative"
})), qde = ({
  audioResources: e = [],
  isCollection: t = !1,
  isFetching: n = !1,
  textResources: r = [],
  videoResources: i = [],
  view: o = void 0,
  windowId: s
}) => t ? /* @__PURE__ */ T.jsx(
  Wde,
  {
    windowId: s
  }
) : n === !1 ? o === "gallery" ? /* @__PURE__ */ T.jsx(
  Fde,
  {
    windowId: s
  }
) : i && i.length > 0 ? /* @__PURE__ */ T.jsx(
  Mdt,
  {
    windowId: s
  }
) : e && e.length > 0 ? /* @__PURE__ */ T.jsx(
  Ndt,
  {
    windowId: s
  }
) : r && r.length > 0 ? /* @__PURE__ */ T.jsx(
  jdt,
  {
    windowId: s
  }
) : /* @__PURE__ */ T.jsx(
  Hde,
  {
    windowId: s
  }
) : null;
qde.propTypes = {
  audioResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  isCollection: c.bool,
  isFetching: c.bool,
  textResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  videoResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  view: c.string,
  windowId: c.string.isRequired
};
function $de({
  audioResources: e = void 0,
  children: t = null,
  className: n = void 0,
  isCollection: r = !1,
  isCollectionDialogVisible: i = !1,
  isFetching: o = !1,
  textResources: s = void 0,
  videoResources: u = void 0,
  view: f = void 0,
  windowId: p
}) {
  const m = {
    audioResources: e,
    isCollection: r,
    isFetching: o,
    textResources: s,
    videoResources: u,
    view: f,
    windowId: p
  };
  return /* @__PURE__ */ T.jsxs(Ldt, { "data-testid": "test-window", className: On(Nt("primary-window"), n), children: [
    /* @__PURE__ */ T.jsx(udt, { windowId: p }),
    /* @__PURE__ */ T.jsx(QE, { windowId: p, position: "left" }),
    i && /* @__PURE__ */ T.jsx(Pdt, { windowId: p }),
    /* @__PURE__ */ T.jsx(sU, { fallback: /* @__PURE__ */ T.jsx("div", {}), children: t || /* @__PURE__ */ T.jsx(qde, { ...m }) })
  ] });
}
$de.propTypes = {
  audioResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  children: c.node,
  className: c.string,
  isCollection: c.bool,
  isCollectionDialogVisible: c.bool,
  isFetching: c.bool,
  textResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  videoResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  view: c.string,
  windowId: c.string.isRequired
};
const kdt = (e, { windowId: t }) => {
  const n = nr(e, { windowId: t });
  return {
    audioResources: xD(e, { windowId: t }) || [],
    isCollection: n && n.isCollection(),
    isCollectionDialogVisible: Wn(e, { windowId: t }).collectionDialogOn,
    textResources: yD(e, { windowId: t }) || [],
    videoResources: bD(e, { windowId: t }) || []
  };
}, zdt = wt(
  At(kdt, null),
  Tt("PrimaryWindow")
), Bdt = zdt($de), Vdt = ye(Jn)(() => ({
  marginLeft: "auto"
}));
function Gde({
  allowClose: e = !0,
  allowWindowSideBar: t = !0,
  ariaLabel: n = !0,
  children: r = null,
  label: i = "",
  removeWindow: o = () => {
  },
  windowId: s
}) {
  const { t: u } = Ct();
  return /* @__PURE__ */ T.jsxs(
    Ei,
    {
      component: "section",
      elevation: 1,
      id: s,
      className: On(Nt("placeholder-window")),
      sx: {
        backgroundColor: "shades.dark",
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        width: "100%"
      },
      "aria-label": i && n ? u("window", { label: i }) : null,
      children: [
        /* @__PURE__ */ T.jsx(Yx, { position: "relative", color: "default", enableColorOnDark: !0, children: /* @__PURE__ */ T.jsxs(
          ny,
          {
            disableGutters: !0,
            className: On(Nt("window-top-bar")),
            sx: {
              backgroundColor: "shades.main",
              borderTop: "2px solid transparent",
              minHeight: 32,
              paddingLeft: 0.5,
              paddingRight: 0.5
            },
            variant: "dense",
            children: [
              t && /* @__PURE__ */ T.jsx(
                Jn,
                {
                  "aria-label": u("toggleWindowSideBar"),
                  disabled: !0,
                  children: /* @__PURE__ */ T.jsx(YW, {})
                }
              ),
              /* @__PURE__ */ T.jsx(
                St,
                {
                  variant: "h2",
                  noWrap: !0,
                  color: "inherit",
                  sx: {
                    flexGrow: 1,
                    paddingLeft: 0.5,
                    typography: "h6"
                  },
                  children: i
                }
              ),
              e && o && /* @__PURE__ */ T.jsx(
                Vdt,
                {
                  "aria-label": u("closeWindow"),
                  className: On(Nt("window-close")),
                  onClick: o,
                  TooltipProps: {
                    tabIndex: n ? 0 : -1
                  },
                  children: /* @__PURE__ */ T.jsx(m_, {})
                }
              )
            ]
          }
        ) }),
        r
      ]
    }
  );
}
Gde.propTypes = {
  allowClose: c.bool,
  allowWindowSideBar: c.bool,
  ariaLabel: c.bool,
  children: c.node,
  label: c.string,
  removeWindow: c.func,
  windowId: c.string.isRequired
};
const Udt = (e, { windowId: t }) => ({
  allowClose: fa(e, { windowId: t }).allowClose,
  allowWindowSideBar: fa(e, { windowId: t }).allowWindowSideBar
}), Fdt = (e, { windowId: t }) => ({
  removeWindow: () => e(N3(t))
}), Wdt = wt(
  At(Udt, Fdt),
  Tt("MinimalWindow")
), Yde = Wdt(Gde), Hdt = {
  "aria-hidden": !0,
  frameBorder: 0,
  height: 1,
  name: void 0,
  scrolling: void 0,
  style: { visibility: "hidden" },
  width: 1
};
function Xde({ handleReceiveMessage: e = void 0, ...t }) {
  return ln(() => {
    if (e)
      return window.addEventListener("message", e), () => window.removeEventListener("message", e, !1);
  }, [e]), // iframe "title" attribute is passed in via props for accessibility
  // eslint-disable-next-line jsx-a11y/iframe-has-title
  /* @__PURE__ */ T.jsx(
    "iframe",
    {
      ...Hdt,
      ...t
    }
  );
}
Xde.propTypes = {
  "aria-hidden": c.bool,
  frameBorder: c.oneOfType([c.string, c.number]),
  handleReceiveMessage: c.func,
  height: c.oneOfType([c.string, c.number]),
  name: c.string,
  scrolling: c.string,
  src: c.string.isRequired,
  style: c.shape({}),
  width: c.oneOfType([c.string, c.number])
};
function Zde({ handleAccessTokenMessage: e, url: t = void 0 }) {
  const n = Yn((i) => {
    i.data && i.data.messageId && i.data.messageId === t && e(i.data);
  }, [e, t]);
  if (!t) return null;
  const r = new URL(t);
  return r.searchParams.append("origin", window.origin), r.searchParams.append("messageId", t), /* @__PURE__ */ T.jsx(
    Xde,
    {
      src: r.toString(),
      title: "AccessTokenSender",
      handleReceiveMessage: n
    }
  );
}
Zde.propTypes = {
  handleAccessTokenMessage: c.func.isRequired,
  url: c.string
};
function Kde({
  depWindow: e = void 0,
  features: t = void 0,
  name: n = void 0,
  onClose: r,
  url: i
}) {
  const o = an(!1);
  return ln(() => {
    const s = (e || window).open(i, n, t), u = setInterval(() => {
      !o.current && (!s || s.closed) && (o.current = !0, clearInterval(u), r(i));
    }, 250);
    return () => {
      clearInterval(u), s.close();
    };
  }), null;
}
Kde.propTypes = {
  depWindow: c.object,
  // eslint-disable-line react/forbid-prop-types
  features: c.string,
  name: c.string,
  onClose: c.func.isRequired,
  url: c.string.isRequired
};
const WQ = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M20 8h-3V6.21c0-2.61-1.91-4.94-4.51-5.19C9.51.74 7 3.08 7 6v2H4v14h16zm-8 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2z"
}), "LockSharp"), qdt = ye("div")(({ theme: e }) => ({
  "&:hover": {
    backgroundColor: e.palette.secondary.main
  },
  alignItems: "center",
  display: "flex"
})), $dt = ye("span")(({ theme: e }) => ({
  marginLeft: e.spacing(2.5)
}));
function Qde({
  confirmButton: e = void 0,
  continueLabel: t = void 0,
  header: n = void 0,
  description: r = void 0,
  icon: i = void 0,
  label: o,
  ruleSet: s = "iiif",
  hasLogoutService: u = !0,
  status: f = void 0,
  ConfirmProps: p = {},
  onConfirm: m
}) {
  const { t: v } = Ct(), y = arguments[0], [S, E] = Bn(!1), w = () => {
    E(!1), m();
  };
  if (f === "ok" && !u) return null;
  const _ = /* @__PURE__ */ T.jsx(
    hi,
    {
      onClick: w,
      color: "secondary",
      sx: (O) => ({
        "&:hover": {
          backgroundColor: _u(O.palette.secondary.contrastText, 1 - O.palette.action.hoverOpacity)
        },
        backgroundColor: O.palette.secondary.contrastText
      }),
      ...p,
      children: e || v("login")
    }
  );
  return !r && !n ? /* @__PURE__ */ T.jsx(
    Ei,
    {
      square: !0,
      elevation: 4,
      color: "secondary",
      children: /* @__PURE__ */ T.jsxs(qdt, { children: [
        i || /* @__PURE__ */ T.jsx(WQ, { sx: { marginInlineEnd: 1.5 } }),
        /* @__PURE__ */ T.jsx(St, { component: "h3", variant: "body1", color: "inherit", children: s ? /* @__PURE__ */ T.jsx(Bs, { htmlString: o, ruleSet: s }) : o }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "WindowAuthenticationBar", ...y }),
        _
      ] })
    }
  ) : /* @__PURE__ */ T.jsxs(
    Ei,
    {
      square: !0,
      elevation: 4,
      color: "secondary",
      children: [
        /* @__PURE__ */ T.jsxs(
          hi,
          {
            fullWidth: !0,
            onClick: () => E(!0),
            component: "div",
            color: "inherit",
            sx: (O) => ({
              "&:hover": {
                backgroundColor: O.palette.secondary.main
              },
              backgroundColor: O.palette.secondary.main,
              borderRadius: 0,
              color: O.palette.secondary.contrastText,
              justifyContent: "start",
              textTransform: "none"
            }),
            children: [
              i || /* @__PURE__ */ T.jsx(WQ, { sx: { marginInlineEnd: 1.5 } }),
              /* @__PURE__ */ T.jsx(St, { sx: { paddingBlockEnd: 1, paddingBlockStart: 1 }, component: "h3", variant: "body1", color: "inherit", children: s ? /* @__PURE__ */ T.jsx(Bs, { htmlString: o, ruleSet: s }) : o }),
              /* @__PURE__ */ T.jsx(Ki, { targetName: "WindowAuthenticationBar", ...y }),
              /* @__PURE__ */ T.jsx($dt, { children: !S && /* @__PURE__ */ T.jsx(St, { variant: "button", color: "inherit", children: t || v("continue") }) })
            ]
          }
        ),
        /* @__PURE__ */ T.jsxs(
          px,
          {
            sx: (O) => ({
              backgroundColor: O.palette.secondary.main,
              color: O.palette.secondary.contrastText,
              paddingInlineEnd: O.spacing(1),
              paddingInlineStart: O.spacing(1)
            }),
            in: S,
            onClose: () => E(!1),
            children: [
              /* @__PURE__ */ T.jsxs(St, { variant: "body1", color: "inherit", children: [
                s ? /* @__PURE__ */ T.jsx(Bs, { htmlString: n, ruleSet: s }) : n,
                n && r ? ": " : "",
                s ? /* @__PURE__ */ T.jsx(Bs, { htmlString: r, ruleSet: s }) : r
              ] }),
              /* @__PURE__ */ T.jsxs($x, { children: [
                /* @__PURE__ */ T.jsx(hi, { onClick: () => E(!1), color: "inherit", children: v("cancel") }),
                _
              ] })
            ]
          }
        )
      ]
    }
  );
}
Qde.propTypes = {
  confirmButton: c.string,
  ConfirmProps: c.object,
  // eslint-disable-line react/forbid-prop-types
  continueLabel: c.string,
  description: c.node,
  hasLogoutService: c.bool,
  header: c.node,
  icon: c.node,
  label: c.node.isRequired,
  onConfirm: c.func.isRequired,
  ruleSet: c.string,
  status: c.string
};
const Gdt = wt(
  Tt("WindowAuthenticationBar")
), p2 = Gdt(Qde);
function Jde({
  accessTokenServiceId: e = void 0,
  authServiceExternal: t = void 0,
  authServiceId: n = void 0,
  confirm: r = void 0,
  description: i = void 0,
  failureDescription: o = void 0,
  failureHeader: s = void 0,
  features: u = "centerscreen",
  handleAuthInteraction: f,
  header: p = void 0,
  isInteractive: m = !0,
  label: v = void 0,
  logoutConfirm: y = void 0,
  logoutServiceId: S = void 0,
  openWindow: E = window.open,
  resetAuthenticationState: w,
  resolveAccessTokenRequest: _,
  resolveAuthenticationRequest: O,
  status: D = null,
  windowId: P
}) {
  const { t: M } = Ct(), N = (X) => {
    _(n, e, X);
  }, k = () => ({
    authServiceId: n,
    hasLogoutService: !!S,
    status: D,
    windowId: P
  }), U = () => {
    E(S, void 0, u), w({ authServiceId: n, tokenServiceId: e });
  }, H = () => m ? /* @__PURE__ */ T.jsx(
    p2,
    {
      confirmButton: y || M("logout"),
      onConfirm: U,
      ...k()
    }
  ) : null, Y = () => /* @__PURE__ */ T.jsx(
    p2,
    {
      header: s,
      description: o,
      confirmButton: M("retry"),
      onConfirm: () => f(P, n),
      ...k()
    }
  ), z = () => /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    F(),
    /* @__PURE__ */ T.jsx(Kde, { name: "IiifLoginSender", url: `${n}?origin=${window.origin}`, features: u, onClose: () => O(n, e) })
  ] }), V = () => /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    F(),
    /* @__PURE__ */ T.jsx(
      Zde,
      {
        handleAccessTokenMessage: N,
        url: e
      }
    )
  ] }), F = () => m ? /* @__PURE__ */ T.jsx(
    p2,
    {
      header: p,
      description: i,
      label: v,
      confirmButton: r,
      onConfirm: () => f(P, n),
      ...k()
    }
  ) : null;
  return n ? D === null ? t || !m ? V() : F() : D === "cookie" ? z() : D === "token" ? V() : D === "failed" ? Y() : D === "ok" ? H() : null : null;
}
Jde.propTypes = {
  accessTokenServiceId: c.string,
  authServiceExternal: c.bool,
  authServiceId: c.string,
  confirm: c.string,
  description: c.string,
  failureDescription: c.string,
  failureHeader: c.string,
  features: c.string,
  handleAuthInteraction: c.func.isRequired,
  header: c.string,
  isInteractive: c.bool,
  label: c.string,
  logoutConfirm: c.string,
  logoutServiceId: c.string,
  openWindow: c.func,
  resetAuthenticationState: c.func.isRequired,
  resolveAccessTokenRequest: c.func.isRequired,
  resolveAuthenticationRequest: c.func.isRequired,
  status: c.oneOf(["logout", "ok", "token", "cookie", "failed", null]),
  windowId: c.string.isRequired
};
const Ydt = (e, { windowId: t }) => {
  var O;
  const n = Ate(e, { windowId: t }), r = RD(e), i = n[0];
  if (!i) return {};
  const s = (O = ((D) => r.find((P) => P.profile === D.getProfile()))(i)) == null ? void 0 : O.external, u = s ? i.id || "external" : i.id, f = W1(i), p = Obe(i), m = t_(e), v = i && m[u], y = e_(e), S = f && y[f.id];
  let E = null;
  v ? v.isFetching ? v.windowId === t && (E = "cookie") : S && S.isFetching ? v.windowId === t && (E = "token") : v.ok ? E = "ok" : v.ok === !1 && (E = "failed") : E = null;
  const w = i.getProfile(), _ = r.some(
    (D) => D.profile === w && !(D.external || D.kiosk)
  );
  return {
    accessTokenServiceId: f && f.id,
    authServiceExternal: s,
    authServiceId: u,
    confirm: i && i.getConfirmLabel(),
    description: i && i.getDescription(),
    failureDescription: i && i.getFailureDescription(),
    failureHeader: i && i.getFailureHeader(),
    header: i && i.getHeader(),
    isInteractive: _,
    label: i && i.getLabel()[0].value,
    logoutConfirm: p && p.getLabel()[0] && p.getLabel()[0].value,
    logoutServiceId: p && p.id,
    profile: w,
    status: E
  };
}, Xdt = {
  handleAuthInteraction: U3,
  resetAuthenticationState: W3,
  resolveAccessTokenRequest: sne,
  resolveAuthenticationRequest: MD
}, Zdt = wt(
  At(Ydt, Xdt),
  Tt("IIIFAuthentication")
), Kdt = Zdt(Jde), bP = {
  display: "flex",
  flex: "1",
  flexDirection: "row",
  minHeight: 0
}, efe = {
  display: "flex",
  flex: "1",
  flexDirection: "column",
  minHeight: 0
}, Qdt = ye(Ei, { name: "Window", slot: "root" })(({ ownerState: e, theme: t }) => {
  var n;
  return {
    ...efe,
    backgroundColor: (n = t.palette.shades) == null ? void 0 : n.dark,
    borderRadius: 0,
    height: "100%",
    overflow: "hidden",
    width: "100%",
    ...(e == null ? void 0 : e.maximized) && {
      left: 0,
      position: "absolute",
      top: 0,
      zIndex: t.zIndex.modal - 1
    }
  };
}), Jdt = ye("div", { name: "Window", slot: "row" })(() => ({
  ...bP
})), eft = ye("div", { name: "Window", slot: "column" })(() => ({
  ...efe
})), tft = ye(Bdt, { name: "Window", slot: "primary" })(() => ({
  ...bP,
  height: "300px",
  position: "relative"
})), nft = ye(QE, { name: "Window", slot: "bottom" })(() => ({
  ...bP,
  flex: "0",
  flexBasis: "auto"
})), rft = ye("div", { name: "Window", slot: "right" })(() => ({
  ...bP,
  flex: "0 1 auto"
})), ift = ({ children: e, ...t }) => {
  const { mosaicWindowActions: n } = Qi(oS);
  return n.connectDragSource(
    /* @__PURE__ */ T.jsx("nav", { ...t, children: e })
  );
};
function tfe({
  focusWindow: e = () => {
  },
  label: t = null,
  isFetching: n = !1,
  sideBarOpen: r = !1,
  view: i = void 0,
  windowDraggable: o = null,
  windowId: s,
  workspaceType: u = null,
  manifestError: f = null
}) {
  const { t: p } = Ct(), m = arguments[0], v = Yn(({ error: y }) => /* @__PURE__ */ T.jsx(Yde, { windowId: s, children: /* @__PURE__ */ T.jsx(rU, { error: y, windowId: s }) }), [s]);
  return /* @__PURE__ */ T.jsx(WH, { FallbackComponent: v, children: /* @__PURE__ */ T.jsxs(
    Qdt,
    {
      onFocus: e,
      ownerState: m,
      component: "section",
      elevation: 1,
      id: s,
      className: Nt("window"),
      "aria-label": p("window", { label: t }),
      children: [
        /* @__PURE__ */ T.jsx(
          Fut,
          {
            component: u === "mosaic" && o ? ift : void 0,
            windowId: s,
            windowDraggable: o
          }
        ),
        /* @__PURE__ */ T.jsx(Kdt, { windowId: s }),
        f && /* @__PURE__ */ T.jsx(rU, { error: { stack: f }, windowId: s }),
        /* @__PURE__ */ T.jsxs(Jdt, { children: [
          /* @__PURE__ */ T.jsxs(eft, { children: [
            /* @__PURE__ */ T.jsx(
              tft,
              {
                view: i,
                windowId: s,
                isFetching: n,
                sideBarOpen: r
              }
            ),
            /* @__PURE__ */ T.jsx(nft, { windowId: s, position: "bottom" })
          ] }),
          /* @__PURE__ */ T.jsxs(rft, { children: [
            /* @__PURE__ */ T.jsx(QE, { windowId: s, position: "right" }),
            /* @__PURE__ */ T.jsx(QE, { windowId: s, position: "far-right" })
          ] })
        ] }),
        /* @__PURE__ */ T.jsx(QE, { windowId: s, position: "far-bottom" }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "Window", ...m })
      ]
    }
  ) });
}
tfe.propTypes = {
  focusWindow: c.func,
  isFetching: c.bool,
  label: c.string,
  manifestError: c.string,
  maximized: c.bool,
  sideBarOpen: c.bool,
  view: c.string,
  windowDraggable: c.bool,
  windowId: c.string.isRequired,
  workspaceType: c.string
};
const oft = (e, { windowId: t }) => ({
  isFetching: ax(e, { windowId: t }).isFetching,
  label: Lu(e, { windowId: t }),
  manifestError: Fee(e, { windowId: t }),
  maximized: (Wn(e, { windowId: t }) || {}).maximized,
  sideBarOpen: (Wn(e, { windowId: t }) || {}).sideBarOpen,
  thumbnailNavigationPosition: QU(e, { windowId: t }),
  view: Nv(e, { windowId: t }),
  windowDraggable: ote(e, { windowId: t }),
  workspaceType: F1(e)
}), aft = (e, { windowId: t }) => ({
  focusWindow: () => e(n_(t))
}), sft = wt(
  At(oft, aft),
  Tt("Window")
), $A = sft(tfe), lft = ye(bF, { shouldForwardProp: (e) => e !== "focused" })(({ focused: e, theme: t }) => ({
  zIndex: e ? t.zIndex.modal - 1 : "auto"
}));
function nfe({
  classes: e = {},
  companionWindowDimensions: t = { height: 0, width: 0 },
  focused: n = !1,
  focusWindow: r = () => {
  },
  layout: i,
  workspace: o,
  updateElasticWindowLayout: s
}) {
  const u = o.width / 2, f = o.height / 2;
  return /* @__PURE__ */ T.jsx(
    lft,
    {
      focused: n,
      className: n ? e.focused : void 0,
      size: {
        height: i.height + t.height,
        width: i.width + t.width
      },
      position: { x: i.x + u, y: i.y + f },
      bounds: "parent",
      onDragStop: (p, m) => {
        s(
          i.windowId,
          { x: m.x - u, y: m.y - f }
        );
      },
      onDragStart: r,
      onResize: (p, m, v, y, S) => {
        s(i.windowId, {
          height: Number.parseInt(v.style.height, 10) - t.height,
          width: Number.parseInt(v.style.width, 10) - t.width,
          x: S.x - u,
          y: S.y - f
        });
      },
      dragHandleClassName: Nt("window-top-bar"),
      cancel: `.${Nt("window-menu-btn")}`,
      children: /* @__PURE__ */ T.jsx(
        $A,
        {
          windowId: i.windowId
        }
      )
    },
    `${i.windowId}-${o.id}`
  );
}
nfe.propTypes = {
  classes: c.objectOf(c.string),
  companionWindowDimensions: c.shape({
    height: c.number,
    width: c.number
  }),
  focused: c.bool,
  focusWindow: c.func,
  layout: c.shape({
    height: c.number,
    id: c.string,
    width: c.number,
    windowId: c.string,
    x: c.number,
    y: c.number
  }).isRequired,
  updateElasticWindowLayout: c.func.isRequired,
  workspace: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
const cft = (e, { windowId: t }) => ({
  companionWindowDimensions: Lee(e, { windowId: t }),
  focused: p3(e, { windowId: t }),
  layout: vD(e)[t],
  workspace: Do(e)
}), uft = (e, t) => ({
  focusWindow: () => e(n_(t.windowId)),
  updateElasticWindowLayout: (n, r) => {
    e(
      H3(n, r)
    );
  }
}), dft = wt(
  At(cft, uft)
  // further HOC go here
), fft = dft(nfe), pft = ye("div", { name: "WorkspaceElastic", slot: "root" })({
  height: "100%",
  position: "relative",
  width: "100%"
}), hft = ye(bF)({
  boxSizing: "border-box",
  margin: 0,
  position: "absolute",
  transitionDuration: ".7s",
  // order matters
  // eslint-disable-next-line sort-keys
  "&.react-draggable-dragging": {
    transitionDuration: "unset"
  }
});
function rfe({
  workspace: e,
  elasticLayout: t,
  setWorkspaceViewportDimensions: n,
  setWorkspaceViewportPosition: r
}) {
  const { viewportPosition: i } = e, o = e.width / 2, s = e.height / 2;
  return /* @__PURE__ */ T.jsxs(pft, { children: [
    /* @__PURE__ */ T.jsx(
      Brt,
      {
        onReflow: () => {
        },
        onResize: (u) => {
          n(u);
        }
      }
    ),
    /* @__PURE__ */ T.jsx(
      hft,
      {
        size: {
          height: e.height,
          width: e.width
        },
        position: {
          x: -1 * i.x - o,
          y: -1 * i.y - s
        },
        enableResizing: {
          bottom: !1,
          bottomLeft: !1,
          bottomRight: !1,
          left: !1,
          right: !1,
          top: !1,
          topLeft: !1,
          topRight: !1
        },
        onDragStop: (u, f) => {
          r({ x: -1 * f.x - o, y: -1 * f.y - s });
        },
        cancel: `.${Nt("window")}`,
        className: Nt("workspace"),
        disableDragging: !e.draggingEnabled,
        children: Object.keys(t).map((u) => /* @__PURE__ */ T.jsx(
          fft,
          {
            windowId: u
          },
          u
        ))
      }
    )
  ] });
}
rfe.propTypes = {
  elasticLayout: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  setWorkspaceViewportDimensions: c.func.isRequired,
  setWorkspaceViewportPosition: c.func.isRequired,
  workspace: c.object.isRequired
  // eslint-disable-line react/forbid-prop-types
};
var h2, HQ;
function gft() {
  if (HQ) return h2;
  HQ = 1;
  var e = BU(), t = Gv();
  function n(r, i) {
    var o = -1, s = t(r) ? Array(r.length) : [];
    return e(r, function(u, f, p) {
      s[++o] = i(u, f, p);
    }), s;
  }
  return h2 = n, h2;
}
var g2, qQ;
function mft() {
  if (qQ) return g2;
  qQ = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return g2 = e, g2;
}
var m2, $Q;
function vft() {
  if ($Q) return m2;
  $Q = 1;
  var e = wx();
  function t(n, r) {
    if (n !== r) {
      var i = n !== void 0, o = n === null, s = n === n, u = e(n), f = r !== void 0, p = r === null, m = r === r, v = e(r);
      if (!p && !v && !u && n > r || u && f && m && !p && !v || o && f && m || !i && m || !s)
        return 1;
      if (!o && !u && !v && n < r || v && i && s && !o && !u || p && i && s || !f && s || !m)
        return -1;
    }
    return 0;
  }
  return m2 = t, m2;
}
var v2, GQ;
function yft() {
  if (GQ) return v2;
  GQ = 1;
  var e = vft();
  function t(n, r, i) {
    for (var o = -1, s = n.criteria, u = r.criteria, f = s.length, p = i.length; ++o < f; ) {
      var m = e(s[o], u[o]);
      if (m) {
        if (o >= p)
          return m;
        var v = i[o];
        return m * (v == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return v2 = t, v2;
}
var y2, YQ;
function bft() {
  if (YQ) return y2;
  YQ = 1;
  var e = Tx(), t = P1(), n = fD(), r = gft(), i = mft(), o = M1(), s = yft(), u = Ex(), f = Yo();
  function p(m, v, y) {
    v.length ? v = e(v, function(w) {
      return f(w) ? function(_) {
        return t(_, w.length === 1 ? w[0] : w);
      } : w;
    }) : v = [u];
    var S = -1;
    v = e(v, o(n));
    var E = r(m, function(w, _, O) {
      var D = e(v, function(P) {
        return P(w);
      });
      return { criteria: D, index: ++S, value: w };
    });
    return i(E, function(w, _) {
      return s(w, _, y);
    });
  }
  return y2 = p, y2;
}
var b2, XQ;
function xft() {
  if (XQ) return b2;
  XQ = 1;
  var e = tD(), t = Gv(), n = N1(), r = Mu();
  function i(o, s, u) {
    if (!r(u))
      return !1;
    var f = typeof s;
    return (f == "number" ? t(u) && n(s, u.length) : f == "string" && s in u) ? e(u[s], o) : !1;
  }
  return b2 = i, b2;
}
var x2, ZQ;
function Sft() {
  if (ZQ) return x2;
  ZQ = 1;
  var e = Rx(), t = bft(), n = J1(), r = xft(), i = n(function(o, s) {
    if (o == null)
      return [];
    var u = s.length;
    return u > 1 && r(o, s[0], s[1]) ? s = [] : u > 2 && r(s[0], s[1], s[2]) && (s = [s[0]]), t(o, e(s, 1), []);
  });
  return x2 = i, x2;
}
var wft = Sft();
const KQ = /* @__PURE__ */ Hn(wft);
var S2, QQ;
function Tft() {
  if (QQ) return S2;
  QQ = 1;
  var e = E3(), t = Rx(), n = xte();
  function r(i, o, s) {
    var u = i.length;
    if (u < 2)
      return u ? n(i[0]) : [];
    for (var f = -1, p = Array(u); ++f < u; )
      for (var m = i[f], v = -1; ++v < u; )
        v != f && (p[f] = e(p[f] || m, i[v], o, s));
    return n(t(p, 1), o, s);
  }
  return S2 = r, S2;
}
var w2, JQ;
function Eft() {
  if (JQ) return w2;
  JQ = 1;
  var e = zU(), t = J1(), n = Tft(), r = CD(), i = t(function(o) {
    return n(e(o, r));
  });
  return w2 = i, w2;
}
var _ft = Eft();
const Cft = /* @__PURE__ */ Hn(_ft);
var eA = { exports: {} }, Rft = eA.exports, eJ;
function Oft() {
  return eJ || (eJ = 1, (function(e) {
    //! openseadragon 5.0.1
    //! Built on 2024-12-09
    //! Git commit: v5.0.1-0-480de92d
    //! http://openseadragon.github.io
    //! License: http://openseadragon.github.io/license/
    function t(n) {
      return new t.Viewer(n);
    }
    (function(n) {
      n.version = {
        versionStr: "5.0.1",
        major: parseInt("5", 10),
        minor: parseInt("0", 10),
        revision: parseInt("1", 10)
      };
      var r = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object AsyncFunction]": "function",
        "[object Promise]": "promise",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regexp",
        "[object Object]": "object"
      }, i = Object.prototype.toString, o = Object.prototype.hasOwnProperty;
      n.isFunction = function(s) {
        return n.type(s) === "function";
      }, n.isArray = Array.isArray || function(s) {
        return n.type(s) === "array";
      }, n.isWindow = function(s) {
        return s && typeof s == "object" && "setInterval" in s;
      }, n.type = function(s) {
        return s == null ? String(s) : r[i.call(s)] || "object";
      }, n.isPlainObject = function(s) {
        if (!s || t.type(s) !== "object" || s.nodeType || n.isWindow(s) || s.constructor && !o.call(s, "constructor") && !o.call(s.constructor.prototype, "isPrototypeOf"))
          return !1;
        var u;
        for (var f in s)
          u = f;
        return u === void 0 || o.call(s, u);
      }, n.isEmptyObject = function(s) {
        for (var u in s)
          return !1;
        return !0;
      }, n.freezeObject = function(s) {
        return Object.freeze ? n.freezeObject = Object.freeze : n.freezeObject = function(u) {
          return u;
        }, n.freezeObject(s);
      }, n.supportsCanvas = (function() {
        var s = document.createElement("canvas");
        return !!(n.isFunction(s.getContext) && s.getContext("2d"));
      })(), n.isCanvasTainted = function(s) {
        var u = !1;
        try {
          s.getContext("2d").getImageData(0, 0, 1, 1);
        } catch {
          u = !0;
        }
        return u;
      }, n.supportsAddEventListener = (function() {
        return !!(document.documentElement.addEventListener && document.addEventListener);
      })(), n.supportsRemoveEventListener = (function() {
        return !!(document.documentElement.removeEventListener && document.removeEventListener);
      })(), n.supportsEventListenerOptions = (function() {
        var s = 0;
        if (n.supportsAddEventListener)
          try {
            var u = {
              get capture() {
                return s++, !1;
              },
              get once() {
                return s++, !1;
              },
              get passive() {
                return s++, !1;
              }
            };
            window.addEventListener("test", null, u), window.removeEventListener("test", null, u);
          } catch {
            s = 0;
          }
        return s >= 3;
      })(), n.getCurrentPixelDensityRatio = function() {
        if (n.supportsCanvas) {
          var s = document.createElement("canvas").getContext("2d"), u = window.devicePixelRatio || 1, f = s.webkitBackingStorePixelRatio || s.mozBackingStorePixelRatio || s.msBackingStorePixelRatio || s.oBackingStorePixelRatio || s.backingStorePixelRatio || 1;
          return Math.max(u, 1) / f;
        } else
          return 1;
      }, n.pixelDensityRatio = n.getCurrentPixelDensityRatio();
    })(t), (function(n) {
      n.extend = function() {
        var f, p, m, v, y, S, E = arguments[0] || {}, w = arguments.length, _ = !1, O = 1;
        for (typeof E == "boolean" && (_ = E, E = arguments[1] || {}, O = 2), typeof E != "object" && !t.isFunction(E) && (E = {}), w === O && (E = this, --O); O < w; O++)
          if (f = arguments[O], f !== null || f !== void 0)
            for (p in f) {
              var D = Object.getOwnPropertyDescriptor(f, p);
              if (D !== void 0) {
                if (D.get || D.set) {
                  Object.defineProperty(E, p, D);
                  continue;
                }
                v = D.value;
              } else {
                n.console.warn('Could not copy inherited property "' + p + '".');
                continue;
              }
              E !== v && (_ && v && (t.isPlainObject(v) || (y = t.isArray(v))) ? (m = E[p], y ? (y = !1, S = m && t.isArray(m) ? m : []) : S = m && t.isPlainObject(m) ? m : {}, E[p] = t.extend(_, S, v)) : v !== void 0 && (E[p] = v));
            }
        return E;
      };
      var r = function() {
        if (typeof navigator != "object")
          return !1;
        var f = navigator.userAgent;
        return typeof f != "string" ? !1 : f.indexOf("iPhone") !== -1 || f.indexOf("iPad") !== -1 || f.indexOf("iPod") !== -1;
      };
      n.extend(
        n,
        /** @lends OpenSeadragon */
        {
          /**
           * The default values for the optional settings documented at {@link OpenSeadragon.Options}.
           * @static
           * @type {Object}
           */
          DEFAULT_SETTINGS: {
            //DATA SOURCE DETAILS
            xmlPath: null,
            tileSources: null,
            tileHost: null,
            initialPage: 0,
            crossOriginPolicy: !1,
            ajaxWithCredentials: !1,
            loadTilesWithAjax: !1,
            ajaxHeaders: {},
            splitHashDataForPost: !1,
            //PAN AND ZOOM SETTINGS AND CONSTRAINTS
            panHorizontal: !0,
            panVertical: !0,
            constrainDuringPan: !1,
            wrapHorizontal: !1,
            wrapVertical: !1,
            visibilityRatio: 0.5,
            //-> how much of the viewer can be negative space
            minPixelRatio: 0.5,
            //->closer to 0 draws tiles meant for a higher zoom at this zoom
            defaultZoomLevel: 0,
            minZoomLevel: null,
            maxZoomLevel: null,
            homeFillsViewer: !1,
            //UI RESPONSIVENESS AND FEEL
            clickTimeThreshold: 300,
            clickDistThreshold: 5,
            dblClickTimeThreshold: 300,
            dblClickDistThreshold: 20,
            springStiffness: 6.5,
            animationTime: 1.2,
            gestureSettingsMouse: {
              dragToPan: !0,
              scrollToZoom: !0,
              clickToZoom: !0,
              dblClickToZoom: !1,
              dblClickDragToZoom: !1,
              pinchToZoom: !1,
              zoomToRefPoint: !0,
              flickEnabled: !1,
              flickMinSpeed: 120,
              flickMomentum: 0.25,
              pinchRotate: !1
            },
            gestureSettingsTouch: {
              dragToPan: !0,
              scrollToZoom: !1,
              clickToZoom: !1,
              dblClickToZoom: !0,
              dblClickDragToZoom: !0,
              pinchToZoom: !0,
              zoomToRefPoint: !0,
              flickEnabled: !0,
              flickMinSpeed: 120,
              flickMomentum: 0.25,
              pinchRotate: !1
            },
            gestureSettingsPen: {
              dragToPan: !0,
              scrollToZoom: !1,
              clickToZoom: !0,
              dblClickToZoom: !1,
              dblClickDragToZoom: !1,
              pinchToZoom: !1,
              zoomToRefPoint: !0,
              flickEnabled: !1,
              flickMinSpeed: 120,
              flickMomentum: 0.25,
              pinchRotate: !1
            },
            gestureSettingsUnknown: {
              dragToPan: !0,
              scrollToZoom: !1,
              clickToZoom: !1,
              dblClickToZoom: !0,
              dblClickDragToZoom: !1,
              pinchToZoom: !0,
              zoomToRefPoint: !0,
              flickEnabled: !0,
              flickMinSpeed: 120,
              flickMomentum: 0.25,
              pinchRotate: !1
            },
            zoomPerClick: 2,
            zoomPerScroll: 1.2,
            zoomPerDblClickDrag: 1.2,
            zoomPerSecond: 1,
            blendTime: 0,
            alwaysBlend: !1,
            autoHideControls: !0,
            immediateRender: !1,
            minZoomImageRatio: 0.9,
            //-> closer to 0 allows zoom out to infinity
            maxZoomPixelRatio: 1.1,
            //-> higher allows 'over zoom' into pixels
            smoothTileEdgesMinZoom: 1.1,
            //-> higher than maxZoomPixelRatio disables it
            iOSDevice: r(),
            pixelsPerWheelLine: 40,
            pixelsPerArrowPress: 40,
            autoResize: !0,
            preserveImageSizeOnResize: !1,
            // requires autoResize=true
            minScrollDeltaTime: 50,
            rotationIncrement: 90,
            maxTilesPerFrame: 1,
            //DEFAULT CONTROL SETTINGS
            showSequenceControl: !0,
            //SEQUENCE
            sequenceControlAnchor: null,
            //SEQUENCE
            preserveViewport: !1,
            //SEQUENCE
            preserveOverlays: !1,
            //SEQUENCE
            navPrevNextWrap: !1,
            //SEQUENCE
            showNavigationControl: !0,
            //ZOOM/HOME/FULL/ROTATION
            navigationControlAnchor: null,
            //ZOOM/HOME/FULL/ROTATION
            showZoomControl: !0,
            //ZOOM
            showHomeControl: !0,
            //HOME
            showFullPageControl: !0,
            //FULL
            showRotationControl: !1,
            //ROTATION
            showFlipControl: !1,
            //FLIP
            controlsFadeDelay: 2e3,
            //ZOOM/HOME/FULL/SEQUENCE
            controlsFadeLength: 1500,
            //ZOOM/HOME/FULL/SEQUENCE
            mouseNavEnabled: !0,
            //GENERAL MOUSE INTERACTIVITY
            //VIEWPORT NAVIGATOR SETTINGS
            showNavigator: !1,
            navigatorElement: null,
            navigatorId: null,
            navigatorPosition: null,
            navigatorSizeRatio: 0.2,
            navigatorMaintainSizeRatio: !1,
            navigatorTop: null,
            navigatorLeft: null,
            navigatorHeight: null,
            navigatorWidth: null,
            navigatorAutoResize: !0,
            navigatorAutoFade: !0,
            navigatorRotate: !0,
            navigatorBackground: "#000",
            navigatorOpacity: 0.8,
            navigatorBorderColor: "#555",
            navigatorDisplayRegionColor: "#900",
            // INITIAL ROTATION
            degrees: 0,
            // INITIAL FLIP STATE
            flipped: !1,
            overlayPreserveContentDirection: !0,
            // APPEARANCE
            opacity: 1,
            // to be passed into each TiledImage
            compositeOperation: null,
            // to be passed into each TiledImage
            // DRAWER SETTINGS
            drawer: ["webgl", "canvas", "html"],
            // prefer using webgl, then canvas (i.e. context2d), then fallback to html
            drawerOptions: {
              webgl: {},
              canvas: {},
              html: {},
              custom: {}
            },
            // TILED IMAGE SETTINGS
            preload: !1,
            // to be passed into each TiledImage
            imageSmoothingEnabled: !0,
            // to be passed into each TiledImage
            placeholderFillStyle: null,
            // to be passed into each TiledImage
            subPixelRoundingForTransparency: null,
            // to be passed into each TiledImage
            //REFERENCE STRIP SETTINGS
            showReferenceStrip: !1,
            referenceStripScroll: "horizontal",
            referenceStripElement: null,
            referenceStripHeight: null,
            referenceStripWidth: null,
            referenceStripPosition: "BOTTOM_LEFT",
            referenceStripSizeRatio: 0.2,
            //COLLECTION VISUALIZATION SETTINGS
            collectionRows: 3,
            //or columns depending on layout
            collectionColumns: 0,
            //columns in horizontal layout, rows in vertical layout
            collectionLayout: "horizontal",
            //vertical
            collectionMode: !1,
            collectionTileSize: 800,
            collectionTileMargin: 80,
            //PERFORMANCE SETTINGS
            imageLoaderLimit: 0,
            maxImageCacheCount: 200,
            timeout: 3e4,
            tileRetryMax: 0,
            tileRetryDelay: 2500,
            //INTERFACE RESOURCE SETTINGS
            prefixUrl: "/images/",
            navImages: {
              zoomIn: {
                REST: "zoomin_rest.png",
                GROUP: "zoomin_grouphover.png",
                HOVER: "zoomin_hover.png",
                DOWN: "zoomin_pressed.png"
              },
              zoomOut: {
                REST: "zoomout_rest.png",
                GROUP: "zoomout_grouphover.png",
                HOVER: "zoomout_hover.png",
                DOWN: "zoomout_pressed.png"
              },
              home: {
                REST: "home_rest.png",
                GROUP: "home_grouphover.png",
                HOVER: "home_hover.png",
                DOWN: "home_pressed.png"
              },
              fullpage: {
                REST: "fullpage_rest.png",
                GROUP: "fullpage_grouphover.png",
                HOVER: "fullpage_hover.png",
                DOWN: "fullpage_pressed.png"
              },
              rotateleft: {
                REST: "rotateleft_rest.png",
                GROUP: "rotateleft_grouphover.png",
                HOVER: "rotateleft_hover.png",
                DOWN: "rotateleft_pressed.png"
              },
              rotateright: {
                REST: "rotateright_rest.png",
                GROUP: "rotateright_grouphover.png",
                HOVER: "rotateright_hover.png",
                DOWN: "rotateright_pressed.png"
              },
              flip: {
                // Flip icon designed by Yaroslav Samoylov from the Noun Project and modified by Nelson Campos ncampos@criteriamarathon.com, https://thenounproject.com/term/flip/136289/
                REST: "flip_rest.png",
                GROUP: "flip_grouphover.png",
                HOVER: "flip_hover.png",
                DOWN: "flip_pressed.png"
              },
              previous: {
                REST: "previous_rest.png",
                GROUP: "previous_grouphover.png",
                HOVER: "previous_hover.png",
                DOWN: "previous_pressed.png"
              },
              next: {
                REST: "next_rest.png",
                GROUP: "next_grouphover.png",
                HOVER: "next_hover.png",
                DOWN: "next_pressed.png"
              }
            },
            //DEVELOPER SETTINGS
            debugMode: !1,
            debugGridColor: ["#437AB2", "#1B9E77", "#D95F02", "#7570B3", "#E7298A", "#66A61E", "#E6AB02", "#A6761D", "#666666"],
            silenceMultiImageWarnings: !1
          },
          /**
           * Returns a function which invokes the method as if it were a method belonging to the object.
           * @function
           * @param {Object} object
           * @param {Function} method
           * @returns {Function}
           */
          delegate: function(f, p) {
            return function() {
              var m = arguments;
              return m === void 0 && (m = []), p.apply(f, m);
            };
          },
          /**
           * An enumeration of Browser vendors.
           * @static
           * @type {Object}
           * @property {Number} UNKNOWN
           * @property {Number} IE
           * @property {Number} FIREFOX
           * @property {Number} SAFARI
           * @property {Number} CHROME
           * @property {Number} OPERA
           * @property {Number} EDGE
           * @property {Number} CHROMEEDGE
           */
          BROWSERS: {
            UNKNOWN: 0,
            IE: 1,
            FIREFOX: 2,
            SAFARI: 3,
            CHROME: 4,
            OPERA: 5,
            EDGE: 6,
            CHROMEEDGE: 7
          },
          /**
           * An enumeration of when subpixel rounding should occur.
           * @static
           * @type {Object}
           * @property {Number} NEVER Never apply subpixel rounding for transparency.
           * @property {Number} ONLY_AT_REST Do not apply subpixel rounding for transparency during animation (panning, zoom, rotation) and apply it once animation is over.
           * @property {Number} ALWAYS Apply subpixel rounding for transparency during animation and when animation is over.
           */
          SUBPIXEL_ROUNDING_OCCURRENCES: {
            NEVER: 0,
            ONLY_AT_REST: 1,
            ALWAYS: 2
          },
          /**
           * Keep track of which {@link Viewer}s have been created.
           * - Key: {@link Element} to which a Viewer is attached.
           * - Value: {@link Viewer} of the element defined by the key.
           * @private
           * @static
           * @type {Object}
           */
          _viewers: /* @__PURE__ */ new Map(),
          /**
            * Returns the {@link Viewer} attached to a given DOM element. If there is
            * no viewer attached to the provided element, undefined is returned.
            * @function
            * @param {String|Element} element Accepts an id or element.
            * @returns {Viewer} The viewer attached to the given element, or undefined.
            */
          getViewer: function(f) {
            return n._viewers.get(this.getElement(f));
          },
          /**
           * Returns a DOM Element for the given id or element.
           * @function
           * @param {String|Element} element Accepts an id or element.
           * @returns {Element} The element with the given id, null, or the element itself.
           */
          getElement: function(f) {
            return typeof f == "string" && (f = document.getElementById(f)), f;
          },
          /**
           * Determines the position of the upper-left corner of the element.
           * @function
           * @param {Element|String} element - the element we want the position for.
           * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element.
           */
          getElementPosition: function(f) {
            var p = new n.Point(), m, v;
            for (f = n.getElement(f), m = n.getElementStyle(f).position === "fixed", v = u(f, m); v; )
              p.x += f.offsetLeft, p.y += f.offsetTop, m && (p = p.plus(n.getPageScroll())), f = v, m = n.getElementStyle(f).position === "fixed", v = u(f, m);
            return p;
          },
          /**
           * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll.
           * @function
           * @param {Element|String} element - the element we want the position for.
           * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element adjusted for current page and/or element scroll.
           */
          getElementOffset: function(f) {
            f = n.getElement(f);
            var p = f && f.ownerDocument, m, v, y = { top: 0, left: 0 };
            return p ? (m = p.documentElement, typeof f.getBoundingClientRect < "u" && (y = f.getBoundingClientRect()), v = p === p.window ? p : p.nodeType === 9 ? p.defaultView || p.parentWindow : !1, new n.Point(
              y.left + (v.pageXOffset || m.scrollLeft) - (m.clientLeft || 0),
              y.top + (v.pageYOffset || m.scrollTop) - (m.clientTop || 0)
            )) : new n.Point();
          },
          /**
           * Determines the height and width of the given element.
           * @function
           * @param {Element|String} element
           * @returns {OpenSeadragon.Point}
           */
          getElementSize: function(f) {
            return f = n.getElement(f), new n.Point(
              f.clientWidth,
              f.clientHeight
            );
          },
          /**
           * Returns the CSSStyle object for the given element.
           * @function
           * @param {Element|String} element
           * @returns {CSSStyle}
           */
          getElementStyle: document.documentElement.currentStyle ? function(f) {
            return f = n.getElement(f), f.currentStyle;
          } : function(f) {
            return f = n.getElement(f), window.getComputedStyle(f, "");
          },
          /**
           * Returns the property with the correct vendor prefix appended.
           * @param {String} property the property name
           * @returns {String} the property with the correct prefix or null if not
           * supported.
           */
          getCssPropertyWithVendorPrefix: function(f) {
            var p = {};
            return n.getCssPropertyWithVendorPrefix = function(m) {
              if (p[m] !== void 0)
                return p[m];
              var v = document.createElement("div").style, y = null;
              if (v[m] !== void 0)
                y = m;
              else
                for (var S = [
                  "Webkit",
                  "Moz",
                  "MS",
                  "O",
                  "webkit",
                  "moz",
                  "ms",
                  "o"
                ], E = n.capitalizeFirstLetter(m), w = 0; w < S.length; w++) {
                  var _ = S[w] + E;
                  if (v[_] !== void 0) {
                    y = _;
                    break;
                  }
                }
              return p[m] = y, y;
            }, n.getCssPropertyWithVendorPrefix(f);
          },
          /**
           * Capitalizes the first letter of a string
           * @param {String} string
           * @returns {String} The string with the first letter capitalized
           */
          capitalizeFirstLetter: function(f) {
            return f.charAt(0).toUpperCase() + f.slice(1);
          },
          /**
           * Compute the modulo of a number but makes sure to always return
           * a positive value (also known as Euclidean modulo).
           * @param {Number} number the number to compute the modulo of
           * @param {Number} modulo the modulo
           * @returns {Number} the result of the modulo of number
           */
          positiveModulo: function(f, p) {
            var m = f % p;
            return m < 0 && (m += p), m;
          },
          /**
           * Determines if a point is within the bounding rectangle of the given element (hit-test).
           * @function
           * @param {Element|String} element
           * @param {OpenSeadragon.Point} point
           * @returns {Boolean}
           */
          pointInElement: function(f, p) {
            f = n.getElement(f);
            var m = n.getElementOffset(f), v = n.getElementSize(f);
            return p.x >= m.x && p.x < m.x + v.x && p.y < m.y + v.y && p.y >= m.y;
          },
          /**
           * Gets the position of the mouse on the screen for a given event.
           * @function
           * @param {Event} [event]
           * @returns {OpenSeadragon.Point}
           */
          getMousePosition: function(f) {
            if (typeof f.pageX == "number")
              n.getMousePosition = function(p) {
                var m = new n.Point();
                return m.x = p.pageX, m.y = p.pageY, m;
              };
            else if (typeof f.clientX == "number")
              n.getMousePosition = function(p) {
                var m = new n.Point();
                return m.x = p.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, m.y = p.clientY + document.body.scrollTop + document.documentElement.scrollTop, m;
              };
            else
              throw new Error(
                "Unknown event mouse position, no known technique."
              );
            return n.getMousePosition(f);
          },
          /**
           * Determines the page's current scroll position.
           * @function
           * @returns {OpenSeadragon.Point}
           */
          getPageScroll: function() {
            var f = document.documentElement || {}, p = document.body || {};
            if (typeof window.pageXOffset == "number")
              n.getPageScroll = function() {
                return new n.Point(
                  window.pageXOffset,
                  window.pageYOffset
                );
              };
            else if (p.scrollLeft || p.scrollTop)
              n.getPageScroll = function() {
                return new n.Point(
                  document.body.scrollLeft,
                  document.body.scrollTop
                );
              };
            else if (f.scrollLeft || f.scrollTop)
              n.getPageScroll = function() {
                return new n.Point(
                  document.documentElement.scrollLeft,
                  document.documentElement.scrollTop
                );
              };
            else
              return new n.Point(0, 0);
            return n.getPageScroll();
          },
          /**
           * Set the page scroll position.
           * @function
           * @returns {OpenSeadragon.Point}
           */
          setPageScroll: function(f) {
            if (typeof window.scrollTo < "u")
              n.setPageScroll = function(v) {
                window.scrollTo(v.x, v.y);
              };
            else {
              var p = n.getPageScroll();
              if (p.x === f.x && p.y === f.y)
                return;
              document.body.scrollLeft = f.x, document.body.scrollTop = f.y;
              var m = n.getPageScroll();
              if (m.x !== p.x && m.y !== p.y) {
                n.setPageScroll = function(v) {
                  document.body.scrollLeft = v.x, document.body.scrollTop = v.y;
                };
                return;
              }
              if (document.documentElement.scrollLeft = f.x, document.documentElement.scrollTop = f.y, m = n.getPageScroll(), m.x !== p.x && m.y !== p.y) {
                n.setPageScroll = function(v) {
                  document.documentElement.scrollLeft = v.x, document.documentElement.scrollTop = v.y;
                };
                return;
              }
              n.setPageScroll = function(v) {
              };
            }
            n.setPageScroll(f);
          },
          /**
           * Determines the size of the browsers window.
           * @function
           * @returns {OpenSeadragon.Point}
           */
          getWindowSize: function() {
            var f = document.documentElement || {}, p = document.body || {};
            if (typeof window.innerWidth == "number")
              n.getWindowSize = function() {
                return new n.Point(
                  window.innerWidth,
                  window.innerHeight
                );
              };
            else if (f.clientWidth || f.clientHeight)
              n.getWindowSize = function() {
                return new n.Point(
                  document.documentElement.clientWidth,
                  document.documentElement.clientHeight
                );
              };
            else if (p.clientWidth || p.clientHeight)
              n.getWindowSize = function() {
                return new n.Point(
                  document.body.clientWidth,
                  document.body.clientHeight
                );
              };
            else
              throw new Error("Unknown window size, no known technique.");
            return n.getWindowSize();
          },
          /**
           * Wraps the given element in a nest of divs so that the element can
           * be easily centered using CSS tables
           * @function
           * @param {Element|String} element
           * @returns {Element} outermost wrapper element
           */
          makeCenteredNode: function(f) {
            f = n.getElement(f);
            var p = [
              n.makeNeutralElement("div"),
              n.makeNeutralElement("div"),
              n.makeNeutralElement("div")
            ];
            return n.extend(p[0].style, {
              display: "table",
              height: "100%",
              width: "100%"
            }), n.extend(p[1].style, {
              display: "table-row"
            }), n.extend(p[2].style, {
              display: "table-cell",
              verticalAlign: "middle",
              textAlign: "center"
            }), p[0].appendChild(p[1]), p[1].appendChild(p[2]), p[2].appendChild(f), p[0];
          },
          /**
           * Creates an easily positionable element of the given type that therefor
           * serves as an excellent container element.
           * @function
           * @param {String} tagName
           * @returns {Element}
           */
          makeNeutralElement: function(f) {
            var p = document.createElement(f), m = p.style;
            return m.background = "transparent none", m.border = "none", m.margin = "0px", m.padding = "0px", m.position = "static", p;
          },
          /**
           * Returns the current milliseconds, using Date.now() if available
           * @function
           */
          now: function() {
            return Date.now ? n.now = Date.now : n.now = function() {
              return (/* @__PURE__ */ new Date()).getTime();
            }, n.now();
          },
          /**
           * Ensures an image is loaded correctly to support alpha transparency.
           * @function
           * @param {String} src
           * @returns {Element}
           */
          makeTransparentImage: function(f) {
            var p = n.makeNeutralElement("img");
            return p.src = f, p;
          },
          /**
           * Sets the opacity of the specified element.
           * @function
           * @param {Element|String} element
           * @param {Number} opacity
           * @param {Boolean} [usesAlpha]
           */
          setElementOpacity: function(f, p, m) {
            var v, y;
            f = n.getElement(f), m && !n.Browser.alpha && (p = Math.round(p)), n.Browser.opacity ? f.style.opacity = p < 1 ? p : "" : p < 1 ? (v = Math.round(100 * p), y = "alpha(opacity=" + v + ")", f.style.filter = y) : f.style.filter = "";
          },
          /**
           * Sets the specified element's touch-action style attribute to 'none'.
           * @function
           * @param {Element|String} element
           */
          setElementTouchActionNone: function(f) {
            f = n.getElement(f), typeof f.style.touchAction < "u" ? f.style.touchAction = "none" : typeof f.style.msTouchAction < "u" && (f.style.msTouchAction = "none");
          },
          /**
           * Sets the specified element's pointer-events style attribute to the passed value.
           * @function
           * @param {Element|String} element
           * @param {String} value
           */
          setElementPointerEvents: function(f, p) {
            f = n.getElement(f), typeof f.style < "u" && typeof f.style.pointerEvents < "u" && (f.style.pointerEvents = p);
          },
          /**
           * Sets the specified element's pointer-events style attribute to 'none'.
           * @function
           * @param {Element|String} element
           */
          setElementPointerEventsNone: function(f) {
            n.setElementPointerEvents(f, "none");
          },
          /**
           * Add the specified CSS class to the element if not present.
           * @function
           * @param {Element|String} element
           * @param {String} className
           */
          addClass: function(f, p) {
            f = n.getElement(f), f.className ? (" " + f.className + " ").indexOf(" " + p + " ") === -1 && (f.className += " " + p) : f.className = p;
          },
          /**
           * Find the first index at which an element is found in an array or -1
           * if not present.
           *
           * Code taken and adapted from
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
           *
           * @function
           * @param {Array} array The array from which to find the element
           * @param {Object} searchElement The element to find
           * @param {Number} [fromIndex=0] Index to start research.
           * @returns {Number} The index of the element in the array.
           */
          indexOf: function(f, p, m) {
            return Array.prototype.indexOf ? this.indexOf = function(v, y, S) {
              return v.indexOf(y, S);
            } : this.indexOf = function(v, y, S) {
              var E, w = S || 0, _;
              if (!v)
                throw new TypeError();
              if (_ = v.length, _ === 0 || w >= _)
                return -1;
              for (w < 0 && (w = _ - Math.abs(w)), E = w; E < _; E++)
                if (v[E] === y)
                  return E;
              return -1;
            }, this.indexOf(f, p, m);
          },
          /**
           * Remove the specified CSS class from the element.
           * @function
           * @param {Element|String} element
           * @param {String} className
           */
          removeClass: function(f, p) {
            var m, v = [], y;
            for (f = n.getElement(f), m = f.className.split(/\s+/), y = 0; y < m.length; y++)
              m[y] && m[y] !== p && v.push(m[y]);
            f.className = v.join(" ");
          },
          /**
           * Convert passed addEventListener() options to boolean or options object,
           * depending on browser support.
           * @function
           * @param {Boolean|Object} [options] Boolean useCapture, or if [supportsEventListenerOptions]{@link OpenSeadragon.supportsEventListenerOptions}, can be an object
           * @param {Boolean} [options.capture]
           * @param {Boolean} [options.passive]
           * @param {Boolean} [options.once]
           * @returns {String} The protocol (http:, https:, file:, ftp: ...)
           */
          normalizeEventListenerOptions: function(f) {
            var p;
            return typeof f < "u" ? typeof f == "boolean" ? p = n.supportsEventListenerOptions ? { capture: f } : f : p = n.supportsEventListenerOptions ? f : typeof f.capture < "u" ? f.capture : !1 : p = n.supportsEventListenerOptions ? { capture: !1 } : !1, p;
          },
          /**
           * Adds an event listener for the given element, eventName and handler.
           * @function
           * @param {Element|String} element
           * @param {String} eventName
           * @param {Function} handler
           * @param {Boolean|Object} [options] Boolean useCapture, or if [supportsEventListenerOptions]{@link OpenSeadragon.supportsEventListenerOptions}, can be an object
           * @param {Boolean} [options.capture]
           * @param {Boolean} [options.passive]
           * @param {Boolean} [options.once]
           */
          addEvent: (function() {
            if (n.supportsAddEventListener)
              return function(f, p, m, v) {
                v = n.normalizeEventListenerOptions(v), f = n.getElement(f), f.addEventListener(p, m, v);
              };
            if (document.documentElement.attachEvent && document.attachEvent)
              return function(f, p, m) {
                f = n.getElement(f), f.attachEvent("on" + p, m);
              };
            throw new Error("No known event model.");
          })(),
          /**
           * Remove a given event listener for the given element, event type and
           * handler.
           * @function
           * @param {Element|String} element
           * @param {String} eventName
           * @param {Function} handler
           * @param {Boolean|Object} [options] Boolean useCapture, or if [supportsEventListenerOptions]{@link OpenSeadragon.supportsEventListenerOptions}, can be an object
           * @param {Boolean} [options.capture]
           */
          removeEvent: (function() {
            if (n.supportsRemoveEventListener)
              return function(f, p, m, v) {
                v = n.normalizeEventListenerOptions(v), f = n.getElement(f), f.removeEventListener(p, m, v);
              };
            if (document.documentElement.detachEvent && document.detachEvent)
              return function(f, p, m) {
                f = n.getElement(f), f.detachEvent("on" + p, m);
              };
            throw new Error("No known event model.");
          })(),
          /**
           * Cancels the default browser behavior had the event propagated all
           * the way up the DOM to the window object.
           * @function
           * @param {Event} [event]
           */
          cancelEvent: function(f) {
            f.preventDefault();
          },
          /**
           * Returns true if {@link OpenSeadragon.cancelEvent|cancelEvent} has been called on
           * the event, otherwise returns false.
           * @function
           * @param {Event} [event]
           */
          eventIsCanceled: function(f) {
            return f.defaultPrevented;
          },
          /**
           * Stops the propagation of the event through the DOM in the capturing and bubbling phases.
           * @function
           * @param {Event} [event]
           */
          stopEvent: function(f) {
            f.stopPropagation();
          },
          // Deprecated
          createCallback: function(f, p) {
            console.error("The createCallback function is deprecated and will be removed in future versions. Please use alternativeFunction instead.");
            var m = [], v;
            for (v = 2; v < arguments.length; v++)
              m.push(arguments[v]);
            return function() {
              var y = m.concat([]), S;
              for (S = 0; S < arguments.length; S++)
                y.push(arguments[S]);
              return p.apply(f, y);
            };
          },
          /**
           * Retrieves the value of a url parameter from the window.location string.
           * @function
           * @param {String} key
           * @returns {String} The value of the url parameter or null if no param matches.
           */
          getUrlParameter: function(f) {
            var p = s[f];
            return p || null;
          },
          /**
           * Retrieves the protocol used by the url. The url can either be absolute
           * or relative.
           * @function
           * @private
           * @param {String} url The url to retrieve the protocol from.
           * @returns {String} The protocol (http:, https:, file:, ftp: ...)
           */
          getUrlProtocol: function(f) {
            var p = f.match(/^([a-z]+:)\/\//i);
            return p === null ? window.location.protocol : p[1].toLowerCase();
          },
          /**
           * Create an XHR object
           * @private
           * @param {type} [local] Deprecated. Ignored (IE/ActiveXObject file protocol no longer supported).
           * @returns {XMLHttpRequest}
           */
          createAjaxRequest: function() {
            if (window.XMLHttpRequest)
              return n.createAjaxRequest = function() {
                return new XMLHttpRequest();
              }, new XMLHttpRequest();
            throw new Error("Browser doesn't support XMLHttpRequest.");
          },
          /**
           * Makes an AJAX request.
           * @param {Object} options
           * @param {String} options.url - the url to request
           * @param {Function} options.success - a function to call on a successful response
           * @param {Function} options.error - a function to call on when an error occurs
           * @param {Object} options.headers - headers to add to the AJAX request
           * @param {String} options.responseType - the response type of the AJAX request
           * @param {String} options.postData - HTTP POST data (usually but not necessarily in k=v&k2=v2... form,
           *      see TileSource::getPostData), GET method used if null
           * @param {Boolean} [options.withCredentials=false] - whether to set the XHR's withCredentials
           * @throws {Error}
           * @returns {XMLHttpRequest}
           */
          makeAjaxRequest: function(f, p, m) {
            var v, y, S, E;
            n.isPlainObject(f) && (p = f.success, m = f.error, v = f.withCredentials, y = f.headers, S = f.responseType || null, E = f.postData || null, f = f.url);
            var w = n.getUrlProtocol(f), _ = n.createAjaxRequest();
            if (!n.isFunction(p))
              throw new Error("makeAjaxRequest requires a success callback");
            _.onreadystatechange = function() {
              _.readyState === 4 && (_.onreadystatechange = function() {
              }, _.status >= 200 && _.status < 300 || _.status === 0 && w !== "http:" && w !== "https:" ? p(_) : n.isFunction(m) ? m(_) : n.console.error("AJAX request returned %d: %s", _.status, f));
            };
            var O = E ? "POST" : "GET";
            try {
              if (_.open(O, f, !0), S && (_.responseType = S), y)
                for (var D in y)
                  Object.prototype.hasOwnProperty.call(y, D) && y[D] && _.setRequestHeader(D, y[D]);
              v && (_.withCredentials = !0), _.send(E);
            } catch (P) {
              n.console.error("%s while making AJAX request: %s", P.name, P.message), _.onreadystatechange = function() {
              }, n.isFunction(m) && m(_, P);
            }
            return _;
          },
          /**
           * Taken from jQuery 1.6.1
           * @function
           * @param {Object} options
           * @param {String} options.url
           * @param {Function} options.callback
           * @param {String} [options.param='callback'] The name of the url parameter
           *      to request the jsonp provider with.
           * @param {String} [options.callbackName=] The name of the callback to
           *      request the jsonp provider with.
           */
          jsonp: function(f) {
            var p, m = f.url, v = document.head || document.getElementsByTagName("head")[0] || document.documentElement, y = f.callbackName || "openseadragon" + n.now(), S = window[y], E = "$1" + y + "$2", w = f.param || "callback", _ = f.callback;
            m = m.replace(/(=)\?(&|$)|\?\?/i, E), m += (/\?/.test(m) ? "&" : "?") + w + "=" + y, window[y] = function(O) {
              if (S)
                window[y] = S;
              else
                try {
                  delete window[y];
                } catch {
                }
              _ && n.isFunction(_) && _(O);
            }, p = document.createElement("script"), (f.async !== void 0 || f.async !== !1) && (p.async = "async"), f.scriptCharset && (p.charset = f.scriptCharset), p.src = m, p.onload = p.onreadystatechange = function(O, D) {
              (D || !p.readyState || /loaded|complete/.test(p.readyState)) && (p.onload = p.onreadystatechange = null, v && p.parentNode && v.removeChild(p), p = void 0);
            }, v.insertBefore(p, v.firstChild);
          },
          /**
           * Fully deprecated. Will throw an error.
           * @function
           * @deprecated use {@link OpenSeadragon.Viewer#open}
           */
          createFromDZI: function() {
            throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
          },
          /**
           * Parses an XML string into a DOM Document.
           * @function
           * @param {String} string
           * @returns {Document}
           */
          parseXml: function(f) {
            if (window.DOMParser)
              n.parseXml = function(p) {
                var m = null, v;
                return v = new DOMParser(), m = v.parseFromString(p, "text/xml"), m;
              };
            else
              throw new Error("Browser doesn't support XML DOM.");
            return n.parseXml(f);
          },
          /**
           * Parses a JSON string into a Javascript object.
           * @function
           * @param {String} string
           * @returns {Object}
           */
          parseJSON: function(f) {
            return n.parseJSON = window.JSON.parse, n.parseJSON(f);
          },
          /**
           * Reports whether the image format is supported for tiling in this
           * version.
           * @function
           * @param {String} [extension]
           * @returns {Boolean}
           */
          imageFormatSupported: function(f) {
            return f = f || "", !!o[f.toLowerCase()];
          },
          /**
           * Updates supported image formats with user-specified values.
           * Preexisting formats that are not being updated are left unchanged.
           * By default, the defined formats are
           * <pre><code>{
           *      avif: true,
           *      bmp:  false,
           *      jpeg: true,
           *      jpg:  true,
           *      png:  true,
           *      tif:  false,
           *      wdp:  false,
           *      webp: true
           * }
           * </code></pre>
           * @function
           * @example
           * // sets bmp as supported and png as unsupported
           * setImageFormatsSupported({bmp: true, png: false});
           * @param {Object} formats An object containing format extensions as
           * keys and booleans as values.
           */
          setImageFormatsSupported: function(f) {
            n.extend(o, f);
          }
        }
      );
      var i = function(f) {
      };
      n.console = window.console || {
        log: i,
        debug: i,
        info: i,
        warn: i,
        error: i,
        assert: i
      }, n.Browser = {
        vendor: n.BROWSERS.UNKNOWN,
        version: 0,
        alpha: !0
      };
      var o = {
        avif: !0,
        bmp: !1,
        jpeg: !0,
        jpg: !0,
        png: !0,
        tif: !1,
        wdp: !1,
        webp: !0
      }, s = {};
      (function() {
        var f = navigator.appVersion, p = navigator.userAgent, m;
        switch (navigator.appName) {
          case "Microsoft Internet Explorer":
            window.attachEvent && window.ActiveXObject && (n.Browser.vendor = n.BROWSERS.IE, n.Browser.version = parseFloat(
              p.substring(
                p.indexOf("MSIE") + 5,
                p.indexOf(";", p.indexOf("MSIE"))
              )
            ));
            break;
          case "Netscape":
            window.addEventListener && (p.indexOf("Edge") >= 0 ? (n.Browser.vendor = n.BROWSERS.EDGE, n.Browser.version = parseFloat(
              p.substring(p.indexOf("Edge") + 5)
            )) : p.indexOf("Edg") >= 0 ? (n.Browser.vendor = n.BROWSERS.CHROMEEDGE, n.Browser.version = parseFloat(
              p.substring(p.indexOf("Edg") + 4)
            )) : p.indexOf("Firefox") >= 0 ? (n.Browser.vendor = n.BROWSERS.FIREFOX, n.Browser.version = parseFloat(
              p.substring(p.indexOf("Firefox") + 8)
            )) : p.indexOf("Safari") >= 0 ? (n.Browser.vendor = p.indexOf("Chrome") >= 0 ? n.BROWSERS.CHROME : n.BROWSERS.SAFARI, n.Browser.version = parseFloat(
              p.substring(
                p.substring(0, p.indexOf("Safari")).lastIndexOf("/") + 1,
                p.indexOf("Safari")
              )
            )) : (m = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), m.exec(p) !== null && (n.Browser.vendor = n.BROWSERS.IE, n.Browser.version = parseFloat(RegExp.$1))));
            break;
          case "Opera":
            n.Browser.vendor = n.BROWSERS.OPERA, n.Browser.version = parseFloat(f);
            break;
        }
        var v = window.location.search.substring(1), y = v.split("&"), S, E, w;
        for (w = 0; w < y.length; w++)
          if (S = y[w], E = S.indexOf("="), E > 0) {
            var _ = S.substring(0, E), O = S.substring(E + 1);
            try {
              s[_] = decodeURIComponent(O);
            } catch {
              n.console.error("Ignoring malformed URL parameter: %s=%s", _, O);
            }
          }
        n.Browser.alpha = !(n.Browser.vendor === n.BROWSERS.CHROME && n.Browser.version < 2), n.Browser.opacity = !0, n.Browser.vendor === n.BROWSERS.IE && n.console.error("Internet Explorer is not supported by OpenSeadragon");
      })(), (function(f) {
        var p = f.requestAnimationFrame || f.mozRequestAnimationFrame || f.webkitRequestAnimationFrame || f.msRequestAnimationFrame, m = f.cancelAnimationFrame || f.mozCancelAnimationFrame || f.webkitCancelAnimationFrame || f.msCancelAnimationFrame;
        if (p && m)
          n.requestAnimationFrame = function() {
            return p.apply(f, arguments);
          }, n.cancelAnimationFrame = function() {
            return m.apply(f, arguments);
          };
        else {
          var v = [], y = [], S = 0, E;
          n.requestAnimationFrame = function(w) {
            return v.push([++S, w]), E || (E = setInterval(function() {
              if (v.length) {
                var _ = n.now(), O = y;
                for (y = v, v = O; y.length; )
                  y.shift()[1](_);
              } else
                clearInterval(E), E = void 0;
            }, 1e3 / 50)), S;
          }, n.cancelAnimationFrame = function(w) {
            var _, O;
            for (_ = 0, O = v.length; _ < O; _ += 1)
              if (v[_][0] === w) {
                v.splice(_, 1);
                return;
              }
            for (_ = 0, O = y.length; _ < O; _ += 1)
              if (y[_][0] === w) {
                y.splice(_, 1);
                return;
              }
          };
        }
      })(window);
      function u(f, p) {
        return p && f !== document.body ? document.body : f.offsetParent;
      }
    })(t), (function(n, r) {
      e.exports ? e.exports = r() : n.OpenSeadragon = r();
    })(Rft, function() {
      return t;
    }), (function(n) {
      class r {
        constructor(o) {
          o || (o = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ]), this.values = o;
        }
        /**
         * @function makeIdentity
         * @memberof OpenSeadragon.Mat3
         * @static
         * @returns {OpenSeadragon.Mat3} an identity matrix
         */
        static makeIdentity() {
          return new r([
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
          ]);
        }
        /**
         * @function makeTranslation
         * @memberof OpenSeadragon.Mat3
         * @static
         * @param {Number} tx The x value of the translation
         * @param {Number} ty The y value of the translation
         * @returns {OpenSeadragon.Mat3} A translation matrix
         */
        static makeTranslation(o, s) {
          return new r([
            1,
            0,
            0,
            0,
            1,
            0,
            o,
            s,
            1
          ]);
        }
        /**
         * @function makeRotation
         * @memberof OpenSeadragon.Mat3
         * @static
         * @param {Number} angleInRadians The desired rotation angle, in radians
         * @returns {OpenSeadragon.Mat3} A rotation matrix
         */
        static makeRotation(o) {
          var s = Math.cos(o), u = Math.sin(o);
          return new r([
            s,
            -u,
            0,
            u,
            s,
            0,
            0,
            0,
            1
          ]);
        }
        /**
         * @function makeScaling
         * @memberof OpenSeadragon.Mat3
         * @static
         * @param {Number} sx The x value of the scaling
         * @param {Number} sy The y value of the scaling
         * @returns {OpenSeadragon.Mat3} A scaling matrix
         */
        static makeScaling(o, s) {
          return new r([
            o,
            0,
            0,
            0,
            s,
            0,
            0,
            0,
            1
          ]);
        }
        /**
         * @alias multiply
         * @memberof! OpenSeadragon.Mat3
         * @param {OpenSeadragon.Mat3} other the matrix to multiply with
         * @returns {OpenSeadragon.Mat3} The result of matrix multiplication
         */
        multiply(o) {
          let s = this.values, u = o.values;
          var f = s[0], p = s[1], m = s[2], v = s[3], y = s[4], S = s[5], E = s[6], w = s[7], _ = s[8], O = u[0], D = u[1], P = u[2], M = u[3], N = u[4], k = u[5], U = u[6], H = u[7], Y = u[8];
          return new r([
            O * f + D * v + P * E,
            O * p + D * y + P * w,
            O * m + D * S + P * _,
            M * f + N * v + k * E,
            M * p + N * y + k * w,
            M * m + N * S + k * _,
            U * f + H * v + Y * E,
            U * p + H * y + Y * w,
            U * m + H * S + Y * _
          ]);
        }
      }
      n.Mat3 = r;
    })(t), (function(n) {
      var r = {
        supportsFullScreen: !1,
        isFullScreen: function() {
          return !1;
        },
        getFullScreenElement: function() {
          return null;
        },
        requestFullScreen: function() {
        },
        exitFullScreen: function() {
        },
        cancelFullScreen: function() {
        },
        fullScreenEventName: "",
        fullScreenErrorEventName: ""
      };
      document.exitFullscreen ? (r.supportsFullScreen = !0, r.getFullScreenElement = function() {
        return document.fullscreenElement;
      }, r.requestFullScreen = function(i) {
        return i.requestFullscreen().catch(function(o) {
          n.console.error("Fullscreen request failed: ", o);
        });
      }, r.exitFullScreen = function() {
        document.exitFullscreen().catch(function(i) {
          n.console.error("Error while exiting fullscreen: ", i);
        });
      }, r.fullScreenEventName = "fullscreenchange", r.fullScreenErrorEventName = "fullscreenerror") : document.msExitFullscreen ? (r.supportsFullScreen = !0, r.getFullScreenElement = function() {
        return document.msFullscreenElement;
      }, r.requestFullScreen = function(i) {
        return i.msRequestFullscreen();
      }, r.exitFullScreen = function() {
        document.msExitFullscreen();
      }, r.fullScreenEventName = "MSFullscreenChange", r.fullScreenErrorEventName = "MSFullscreenError") : document.webkitExitFullscreen ? (r.supportsFullScreen = !0, r.getFullScreenElement = function() {
        return document.webkitFullscreenElement;
      }, r.requestFullScreen = function(i) {
        return i.webkitRequestFullscreen();
      }, r.exitFullScreen = function() {
        document.webkitExitFullscreen();
      }, r.fullScreenEventName = "webkitfullscreenchange", r.fullScreenErrorEventName = "webkitfullscreenerror") : document.webkitCancelFullScreen ? (r.supportsFullScreen = !0, r.getFullScreenElement = function() {
        return document.webkitCurrentFullScreenElement;
      }, r.requestFullScreen = function(i) {
        return i.webkitRequestFullScreen();
      }, r.exitFullScreen = function() {
        document.webkitCancelFullScreen();
      }, r.fullScreenEventName = "webkitfullscreenchange", r.fullScreenErrorEventName = "webkitfullscreenerror") : document.mozCancelFullScreen && (r.supportsFullScreen = !0, r.getFullScreenElement = function() {
        return document.mozFullScreenElement;
      }, r.requestFullScreen = function(i) {
        return i.mozRequestFullScreen();
      }, r.exitFullScreen = function() {
        document.mozCancelFullScreen();
      }, r.fullScreenEventName = "mozfullscreenchange", r.fullScreenErrorEventName = "mozfullscreenerror"), r.isFullScreen = function() {
        return r.getFullScreenElement() !== null;
      }, r.cancelFullScreen = function() {
        n.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead."), r.exitFullScreen();
      }, n.extend(n, r);
    })(t), (function(n) {
      n.EventSource = function() {
        this.events = {}, this._rejectedEventList = {};
      }, n.EventSource.prototype = {
        /**
         * Add an event handler to be triggered only once (or a given number of times)
         * for a given event. It is not removable with removeHandler().
         * @function
         * @param {String} eventName - Name of event to register.
         * @param {OpenSeadragon.EventHandler} handler - Function to call when event
         * is triggered.
         * @param {Object} [userData=null] - Arbitrary object to be passed unchanged
         * to the handler.
         * @param {Number} [times=1] - The number of times to handle the event
         * before removing it.
         * @param {Number} [priority=0] - Handler priority. By default, all priorities are 0. Higher number = priority.
         * @returns {Boolean} - True if the handler was added, false if it was rejected
         */
        addOnceHandler: function(r, i, o, s, u) {
          var f = this;
          s = s || 1;
          var p = 0, m = function(v) {
            return p++, p === s && f.removeHandler(r, m), i(v);
          };
          return this.addHandler(r, m, o, u);
        },
        /**
         * Add an event handler for a given event.
         * @function
         * @param {String} eventName - Name of event to register.
         * @param {OpenSeadragon.EventHandler} handler - Function to call when event is triggered.
         * @param {Object} [userData=null] - Arbitrary object to be passed unchanged to the handler.
         * @param {Number} [priority=0] - Handler priority. By default, all priorities are 0. Higher number = priority.
         * @returns {Boolean} - True if the handler was added, false if it was rejected
         */
        addHandler: function(r, i, o, s) {
          if (Object.prototype.hasOwnProperty.call(this._rejectedEventList, r))
            return n.console.error(`Error adding handler for ${r}. ${this._rejectedEventList[r]}`), !1;
          var u = this.events[r];
          if (u || (this.events[r] = u = []), i && n.isFunction(i)) {
            var f = u.length, p = { handler: i, userData: o || null, priority: s || 0 };
            for (u[f] = p; f > 0 && u[f - 1].priority < u[f].priority; )
              u[f] = u[f - 1], u[f - 1] = p, f--;
          }
          return !0;
        },
        /**
         * Remove a specific event handler for a given event.
         * @function
         * @param {String} eventName - Name of event for which the handler is to be removed.
         * @param {OpenSeadragon.EventHandler} handler - Function to be removed.
         */
        removeHandler: function(r, i) {
          var o = this.events[r], s = [], u;
          if (o && n.isArray(o)) {
            for (u = 0; u < o.length; u++)
              o[u].handler !== i && s.push(o[u]);
            this.events[r] = s;
          }
        },
        /**
         * Get the amount of handlers registered for a given event.
         * @param {String} eventName - Name of event to inspect.
         * @returns {number} amount of events
         */
        numberOfHandlers: function(r) {
          var i = this.events[r];
          return i ? i.length : 0;
        },
        /**
         * Remove all event handlers for a given event type. If no type is given all
         * event handlers for every event type are removed.
         * @function
         * @param {String} eventName - Name of event for which all handlers are to be removed.
         */
        removeAllHandlers: function(r) {
          if (r)
            this.events[r] = [];
          else
            for (var i in this.events)
              this.events[i] = [];
        },
        /**
         * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
         * @function
         * @param {String} eventName - Name of event to get handlers for.
         */
        getHandler: function(r) {
          var i = this.events[r];
          return !i || !i.length ? null : (i = i.length === 1 ? [i[0]] : Array.apply(null, i), function(o, s) {
            var u, f = i.length;
            for (u = 0; u < f; u++)
              i[u] && (s.eventSource = o, s.userData = i[u].userData, i[u].handler(s));
          });
        },
        /**
         * Trigger an event, optionally passing additional information.
         * @function
         * @param {String} eventName - Name of event to register.
         * @param {Object} eventArgs - Event-specific data.
         * @returns {Boolean} True if the event was fired, false if it was rejected because of rejectEventHandler(eventName)
         */
        raiseEvent: function(r, i) {
          if (Object.prototype.hasOwnProperty.call(this._rejectedEventList, r))
            return n.console.error(`Error adding handler for ${r}. ${this._rejectedEventList[r]}`), !1;
          var o = this.getHandler(r);
          return o && o(this, i || {}), !0;
        },
        /**
         * Set an event name as being disabled, and provide an optional error message
         * to be printed to the console
         * @param {String} eventName - Name of the event
         * @param {String} [errorMessage] - Optional string to print to the console
         * @private
         */
        rejectEventHandler(r, i = "") {
          this._rejectedEventList[r] = i;
        },
        /**
         * Explicitly allow an event handler to be added for this event type, undoing
         * the effects of rejectEventHandler
         * @param {String} eventName - Name of the event
         * @private
         */
        allowEventHandler(r) {
          delete this._rejectedEventList[r];
        }
      };
    })(t), (function(n) {
      var r = {};
      n.MouseTracker = function(q) {
        var W = arguments;
        n.isPlainObject(q) || (q = {
          element: W[0],
          clickTimeThreshold: W[1],
          clickDistThreshold: W[2]
        }), this.hash = Math.random(), this.element = n.getElement(q.element), this.clickTimeThreshold = q.clickTimeThreshold || n.DEFAULT_SETTINGS.clickTimeThreshold, this.clickDistThreshold = q.clickDistThreshold || n.DEFAULT_SETTINGS.clickDistThreshold, this.dblClickTimeThreshold = q.dblClickTimeThreshold || n.DEFAULT_SETTINGS.dblClickTimeThreshold, this.dblClickDistThreshold = q.dblClickDistThreshold || n.DEFAULT_SETTINGS.dblClickDistThreshold, this.userData = q.userData || null, this.stopDelay = q.stopDelay || 50, this.preProcessEventHandler = q.preProcessEventHandler || null, this.contextMenuHandler = q.contextMenuHandler || null, this.enterHandler = q.enterHandler || null, this.leaveHandler = q.leaveHandler || null, this.exitHandler = q.exitHandler || null, this.overHandler = q.overHandler || null, this.outHandler = q.outHandler || null, this.pressHandler = q.pressHandler || null, this.nonPrimaryPressHandler = q.nonPrimaryPressHandler || null, this.releaseHandler = q.releaseHandler || null, this.nonPrimaryReleaseHandler = q.nonPrimaryReleaseHandler || null, this.moveHandler = q.moveHandler || null, this.scrollHandler = q.scrollHandler || null, this.clickHandler = q.clickHandler || null, this.dblClickHandler = q.dblClickHandler || null, this.dragHandler = q.dragHandler || null, this.dragEndHandler = q.dragEndHandler || null, this.pinchHandler = q.pinchHandler || null, this.stopHandler = q.stopHandler || null, this.keyDownHandler = q.keyDownHandler || null, this.keyUpHandler = q.keyUpHandler || null, this.keyHandler = q.keyHandler || null, this.focusHandler = q.focusHandler || null, this.blurHandler = q.blurHandler || null;
        var Q = this;
        r[this.hash] = {
          click: function(ce) {
            P(Q, ce);
          },
          dblclick: function(ce) {
            M(Q, ce);
          },
          keydown: function(ce) {
            N(Q, ce);
          },
          keyup: function(ce) {
            k(Q, ce);
          },
          keypress: function(ce) {
            U(Q, ce);
          },
          focus: function(ce) {
            H(Q, ce);
          },
          blur: function(ce) {
            Y(Q, ce);
          },
          contextmenu: function(ce) {
            z(Q, ce);
          },
          wheel: function(ce) {
            V(Q, ce);
          },
          mousewheel: function(ce) {
            F(Q, ce);
          },
          DOMMouseScroll: function(ce) {
            F(Q, ce);
          },
          MozMousePixelScroll: function(ce) {
            F(Q, ce);
          },
          losecapture: function(ce) {
            oe(Q, ce);
          },
          mouseenter: function(ce) {
            ie(Q, ce);
          },
          mouseleave: function(ce) {
            he(Q, ce);
          },
          mouseover: function(ce) {
            pe(Q, ce);
          },
          mouseout: function(ce) {
            me(Q, ce);
          },
          mousedown: function(ce) {
            Ee(Q, ce);
          },
          mouseup: function(ce) {
            Ie(Q, ce);
          },
          mousemove: function(ce) {
            Ye(Q, ce);
          },
          touchstart: function(ce) {
            re(Q, ce);
          },
          touchend: function(ce) {
            Z(Q, ce);
          },
          touchmove: function(ce) {
            ee(Q, ce);
          },
          touchcancel: function(ce) {
            J(Q, ce);
          },
          gesturestart: function(ce) {
            le(Q, ce);
          },
          // Safari/Safari iOS
          gesturechange: function(ce) {
            be(Q, ce);
          },
          // Safari/Safari iOS
          gotpointercapture: function(ce) {
            ne(Q, ce);
          },
          lostpointercapture: function(ce) {
            ae(Q, ce);
          },
          pointerenter: function(ce) {
            ie(Q, ce);
          },
          pointerleave: function(ce) {
            he(Q, ce);
          },
          pointerover: function(ce) {
            pe(Q, ce);
          },
          pointerout: function(ce) {
            me(Q, ce);
          },
          pointerdown: function(ce) {
            Ee(Q, ce);
          },
          pointerup: function(ce) {
            Ie(Q, ce);
          },
          pointermove: function(ce) {
            Ye(Q, ce);
          },
          pointercancel: function(ce) {
            rt(Q, ce);
          },
          pointerupcaptured: function(ce) {
            Pe(Q, ce);
          },
          pointermovecaptured: function(ce) {
            Ue(Q, ce);
          },
          tracking: !1,
          // Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
          // GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
          // Active pointers are any pointer being tracked for this element which are in the hit-test area
          //     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
          activePointersLists: [],
          // Tracking for double-click gesture
          lastClickPos: null,
          dblClickTimeOut: null,
          // Tracking for pinch gesture
          pinchGPoints: [],
          lastPinchDist: 0,
          currentPinchDist: 0,
          lastPinchCenter: null,
          currentPinchCenter: null,
          // Tracking for drag
          sentDragEvent: !1
        }, this.hasGestureHandlers = !!(this.pressHandler || this.nonPrimaryPressHandler || this.releaseHandler || this.nonPrimaryReleaseHandler || this.clickHandler || this.dblClickHandler || this.dragHandler || this.dragEndHandler || this.pinchHandler), this.hasScrollHandler = !!this.scrollHandler, n.MouseTracker.havePointerEvents && n.setElementPointerEvents(this.element, "auto"), this.exitHandler && n.console.error("MouseTracker.exitHandler is deprecated. Use MouseTracker.leaveHandler instead."), q.startDisabled || this.setTracking(!0);
      }, n.MouseTracker.prototype = {
        /**
         * Clean up any events or objects created by the tracker.
         * @function
         */
        destroy: function() {
          f(this), this.element = null, r[this.hash] = null, delete r[this.hash];
        },
        /**
         * Are we currently tracking events on this element.
         * @deprecated Just use this.tracking
         * @function
         * @returns {Boolean} Are we currently tracking events on this element.
         */
        isTracking: function() {
          return r[this.hash].tracking;
        },
        /**
         * Enable or disable whether or not we are tracking events on this element.
         * @function
         * @param {Boolean} track True to start tracking, false to stop tracking.
         * @returns {OpenSeadragon.MouseTracker} Chainable.
         */
        setTracking: function(q) {
          return q ? u(this) : f(this), this;
        },
        /**
         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for the given pointer device type,
         * creating and caching a new {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} if one doesn't already exist for the type.
         * @function
         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
         * @returns {OpenSeadragon.MouseTracker.GesturePointList}
         */
        getActivePointersListByType: function(q) {
          var W = r[this.hash], Q, ce = W ? W.activePointersLists.length : 0, _e;
          for (Q = 0; Q < ce; Q++)
            if (W.activePointersLists[Q].type === q)
              return W.activePointersLists[Q];
          return _e = new n.MouseTracker.GesturePointList(q), W && W.activePointersLists.push(_e), _e;
        },
        /**
         * Returns the total number of pointers currently active on the tracked element.
         * @function
         * @returns {Number}
         */
        getActivePointerCount: function() {
          var q = r[this.hash], W, Q = q.activePointersLists.length, ce = 0;
          for (W = 0; W < Q; W++)
            ce += q.activePointersLists[W].getLength();
          return ce;
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {OpenSeadragon.MouseTracker.EventProcessInfo} eventInfo
         */
        preProcessEventHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefault
         *      Set to true to prevent the default user-agent's handling of the contextmenu event.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        contextMenuHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        enterHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @since v2.5.0
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        leaveHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @deprecated v2.5.0 Use leaveHandler instead
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        exitHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @since v2.5.0
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        overHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @since v2.5.0
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        outHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        pressHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.button
         *      Button which caused the event.
         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        nonPrimaryPressHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.insideElementReleased
         *      True if the cursor inside the tracked element when the button was released.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        releaseHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.button
         *      Button which caused the event.
         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        nonPrimaryReleaseHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        moveHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.scroll
         *      The scroll delta for the event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead. Touch devices no longer generate scroll event.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefault
         *      Set to true to prevent the default user-agent's handling of the wheel event.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        scrollHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Boolean} event.quick
         *      True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for ignoring drag events.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Element} event.originalTarget
         *      The DOM element clicked on.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        clickHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        dblClickHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {OpenSeadragon.Point} event.delta
         *      The x,y components of the difference between the current position and the last drag event position.  Useful for ignoring or weighting the events.
         * @param {Number} event.speed
         *     Current computed speed, in pixels per second.
         * @param {Number} event.direction
         *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        dragHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.speed
         *     Speed at the end of a drag gesture, in pixels per second.
         * @param {Number} event.direction
         *     Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        dragEndHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} event.gesturePoints
         *      Gesture points associated with the gesture. Velocity data can be found here.
         * @param {OpenSeadragon.Point} event.lastCenter
         *      The previous center point of the two pinch contact points relative to the tracked element.
         * @param {OpenSeadragon.Point} event.center
         *      The center point of the two pinch contact points relative to the tracked element.
         * @param {Number} event.lastDistance
         *      The previous distance between the two pinch contact points in CSS pixels.
         * @param {Number} event.distance
         *      The distance between the two pinch contact points in CSS pixels.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        pinchHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        stopHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefault
         *      Set to true to prevent the default user-agent's handling of the keydown event.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        keyDownHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefault
         *      Set to true to prevent the default user-agent's handling of the keyup event.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        keyUpHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefault
         *      Set to true to prevent the default user-agent's handling of the keypress event.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        keyHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        focusHandler: function() {
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */
        blurHandler: function() {
        }
      };
      var i = (function() {
        try {
          return window.self !== window.top;
        } catch {
          return !0;
        }
      })();
      function o(q) {
        try {
          return q.addEventListener && q.removeEventListener;
        } catch {
          return !1;
        }
      }
      n.MouseTracker.gesturePointVelocityTracker = /* @__PURE__ */ (function() {
        var q = [], W = 0, Q = 0, ce = function(ct, ht) {
          return ct.hash.toString() + ht.type + ht.id.toString();
        }, _e = function() {
          var ct, ht = q.length, Yt, Rt, cn = n.now(), Kt, Zt, dn;
          for (Kt = cn - Q, Q = cn, ct = 0; ct < ht; ct++)
            Yt = q[ct], Rt = Yt.gPoint, Rt.direction = Math.atan2(Rt.currentPos.y - Yt.lastPos.y, Rt.currentPos.x - Yt.lastPos.x), Zt = Yt.lastPos.distanceTo(Rt.currentPos), Yt.lastPos = Rt.currentPos, dn = 1e3 * Zt / (Kt + 1), Rt.speed = 0.75 * dn + 0.25 * Rt.speed;
        }, Fe = function(ct, ht) {
          var Yt = ce(ct, ht);
          q.push(
            {
              guid: Yt,
              gPoint: ht,
              lastPos: ht.currentPos
            }
          ), q.length === 1 && (Q = n.now(), W = window.setInterval(_e, 50));
        }, gt = function(ct, ht) {
          var Yt = ce(ct, ht), Rt, cn = q.length;
          for (Rt = 0; Rt < cn; Rt++)
            if (q[Rt].guid === Yt) {
              q.splice(Rt, 1), cn--, cn === 0 && window.clearInterval(W);
              break;
            }
        };
        return {
          addPoint: Fe,
          removePoint: gt
        };
      })(), n.MouseTracker.captureElement = document, n.MouseTracker.wheelEventName = "onwheel" in document.createElement("div") ? "wheel" : (
        // Modern browsers support 'wheel'
        document.onmousewheel !== void 0 ? "mousewheel" : (
          // Webkit (and unsupported IE) support at least 'mousewheel'
          "DOMMouseScroll"
        )
      ), n.MouseTracker.subscribeEvents = ["click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", "contextmenu", n.MouseTracker.wheelEventName], n.MouseTracker.wheelEventName === "DOMMouseScroll" && n.MouseTracker.subscribeEvents.push("MozMousePixelScroll"), window.PointerEvent ? (n.MouseTracker.havePointerEvents = !0, n.MouseTracker.subscribeEvents.push("pointerenter", "pointerleave", "pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel"), n.MouseTracker.havePointerCapture = (function() {
        var q = document.createElement("div");
        return n.isFunction(q.setPointerCapture) && n.isFunction(q.releasePointerCapture);
      })(), n.MouseTracker.havePointerCapture && n.MouseTracker.subscribeEvents.push("gotpointercapture", "lostpointercapture")) : (n.MouseTracker.havePointerEvents = !1, n.MouseTracker.subscribeEvents.push("mouseenter", "mouseleave", "mouseover", "mouseout", "mousedown", "mouseup", "mousemove"), n.MouseTracker.mousePointerId = "legacy-mouse", n.MouseTracker.havePointerCapture = (function() {
        var q = document.createElement("div");
        return n.isFunction(q.setCapture) && n.isFunction(q.releaseCapture);
      })(), n.MouseTracker.havePointerCapture && n.MouseTracker.subscribeEvents.push("losecapture"), "ontouchstart" in window && n.MouseTracker.subscribeEvents.push("touchstart", "touchend", "touchmove", "touchcancel"), "ongesturestart" in window && n.MouseTracker.subscribeEvents.push("gesturestart", "gesturechange")), n.MouseTracker.GesturePointList = function(q) {
        this._gPoints = [], this.type = q, this.buttons = 0, this.contacts = 0, this.clicks = 0, this.captureCount = 0;
      }, n.MouseTracker.GesturePointList.prototype = {
        /**
         * @function
         * @returns {Number} Number of gesture points in the list.
         */
        getLength: function() {
          return this._gPoints.length;
        },
        /**
         * @function
         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePoint>} The list of gesture points in the list as an array (read-only).
         */
        asArray: function() {
          return this._gPoints;
        },
        /**
         * @function
         * @param {OpenSeadragon.MouseTracker.GesturePoint} gesturePoint - A gesture point to add to the list.
         * @returns {Number} Number of gesture points in the list.
         */
        add: function(q) {
          return this._gPoints.push(q);
        },
        /**
         * @function
         * @param {Number} id - The id of the gesture point to remove from the list.
         * @returns {Number} Number of gesture points in the list.
         */
        removeById: function(q) {
          var W, Q = this._gPoints.length;
          for (W = 0; W < Q; W++)
            if (this._gPoints[W].id === q) {
              this._gPoints.splice(W, 1);
              break;
            }
          return this._gPoints.length;
        },
        /**
         * @function
         * @param {Number} index - The index of the gesture point to retrieve from the list.
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point at the given index, or null if not found.
         */
        getByIndex: function(q) {
          return q < this._gPoints.length ? this._gPoints[q] : null;
        },
        /**
         * @function
         * @param {Number} id - The id of the gesture point to retrieve from the list.
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point with the given id, or null if not found.
         */
        getById: function(q) {
          var W, Q = this._gPoints.length;
          for (W = 0; W < Q; W++)
            if (this._gPoints[W].id === q)
              return this._gPoints[W];
          return null;
        },
        /**
         * @function
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The primary gesture point in the list, or null if not found.
         */
        getPrimary: function(q) {
          var W, Q = this._gPoints.length;
          for (W = 0; W < Q; W++)
            if (this._gPoints[W].isPrimary)
              return this._gPoints[W];
          return null;
        },
        /**
         * Increment this pointer list's contact count.
         * It will evaluate whether this pointer type is allowed to have multiple contacts.
         * @function
         */
        addContact: function() {
          ++this.contacts, this.contacts > 1 && (this.type === "mouse" || this.type === "pen") && (n.console.warn("GesturePointList.addContact() Implausible contacts value"), this.contacts = 1);
        },
        /**
         * Decrement this pointer list's contact count.
         * It will make sure the count does not go below 0.
         * @function
         */
        removeContact: function() {
          --this.contacts, this.contacts < 0 && (this.contacts = 0);
        }
      };
      function s(q) {
        var W = r[q.hash], Q, ce, _e, Fe, gt, ct = W.activePointersLists.length;
        for (Q = 0; Q < ct; Q++)
          if (_e = W.activePointersLists[Q], _e.getLength() > 0) {
            for (gt = [], Fe = _e.asArray(), ce = 0; ce < Fe.length; ce++)
              gt.push(Fe[ce]);
            for (ce = 0; ce < gt.length; ce++)
              Je(q, _e, gt[ce]);
          }
        for (Q = 0; Q < ct; Q++)
          W.activePointersLists.pop();
        W.sentDragEvent = !1;
      }
      function u(q) {
        var W = r[q.hash], Q, ce;
        if (!W.tracking) {
          for (ce = 0; ce < n.MouseTracker.subscribeEvents.length; ce++)
            Q = n.MouseTracker.subscribeEvents[ce], n.addEvent(
              q.element,
              Q,
              W[Q],
              Q === n.MouseTracker.wheelEventName ? { passive: !1, capture: !1 } : !1
            );
          s(q), W.tracking = !0;
        }
      }
      function f(q) {
        var W = r[q.hash], Q, ce;
        if (W.tracking) {
          for (ce = 0; ce < n.MouseTracker.subscribeEvents.length; ce++)
            Q = n.MouseTracker.subscribeEvents[ce], n.removeEvent(
              q.element,
              Q,
              W[Q],
              !1
            );
          s(q), W.tracking = !1;
        }
      }
      function p(q, W) {
        var Q = r[q.hash];
        if (W === "pointerevent")
          return {
            upName: "pointerup",
            upHandler: Q.pointerupcaptured,
            moveName: "pointermove",
            moveHandler: Q.pointermovecaptured
          };
        if (W === "mouse")
          return {
            upName: "pointerup",
            upHandler: Q.pointerupcaptured,
            moveName: "pointermove",
            moveHandler: Q.pointermovecaptured
          };
        if (W === "touch")
          return {
            upName: "touchend",
            upHandler: Q.touchendcaptured,
            moveName: "touchmove",
            moveHandler: Q.touchmovecaptured
          };
        throw new Error("MouseTracker.getCaptureEventParams: Unknown pointer type.");
      }
      function m(q, W) {
        var Q;
        if (n.MouseTracker.havePointerCapture)
          if (n.MouseTracker.havePointerEvents)
            try {
              q.element.setPointerCapture(W.id);
            } catch {
              n.console.warn("setPointerCapture() called on invalid pointer ID");
              return;
            }
          else
            q.element.setCapture(!0);
        else
          Q = p(q, n.MouseTracker.havePointerEvents ? "pointerevent" : W.type), i && o(window.top) && n.addEvent(
            window.top,
            Q.upName,
            Q.upHandler,
            !0
          ), n.addEvent(
            n.MouseTracker.captureElement,
            Q.upName,
            Q.upHandler,
            !0
          ), n.addEvent(
            n.MouseTracker.captureElement,
            Q.moveName,
            Q.moveHandler,
            !0
          );
        ge(q, W, !0);
      }
      function v(q, W) {
        var Q, ce, _e;
        if (n.MouseTracker.havePointerCapture)
          if (n.MouseTracker.havePointerEvents) {
            if (ce = q.getActivePointersListByType(W.type), _e = ce.getById(W.id), !_e || !_e.captured)
              return;
            try {
              q.element.releasePointerCapture(W.id);
            } catch {
            }
          } else
            q.element.releaseCapture();
        else
          Q = p(q, n.MouseTracker.havePointerEvents ? "pointerevent" : W.type), i && o(window.top) && n.removeEvent(
            window.top,
            Q.upName,
            Q.upHandler,
            !0
          ), n.removeEvent(
            n.MouseTracker.captureElement,
            Q.moveName,
            Q.moveHandler,
            !0
          ), n.removeEvent(
            n.MouseTracker.captureElement,
            Q.upName,
            Q.upHandler,
            !0
          );
        ge(q, W, !1);
      }
      function y(q) {
        return n.MouseTracker.havePointerEvents ? q.pointerId : n.MouseTracker.mousePointerId;
      }
      function S(q) {
        return n.MouseTracker.havePointerEvents && q.pointerType ? q.pointerType : "mouse";
      }
      function E(q) {
        return n.MouseTracker.havePointerEvents ? q.isPrimary : !0;
      }
      function w(q) {
        return n.getMousePosition(q);
      }
      function _(q, W) {
        return O(w(q), W);
      }
      function O(q, W) {
        var Q = n.getElementOffset(W);
        return q.minus(Q);
      }
      function D(q, W) {
        return new n.Point((q.x + W.x) / 2, (q.y + W.y) / 2);
      }
      function P(q, W) {
        var Q = {
          originalEvent: W,
          eventType: "click",
          pointerType: "mouse",
          isEmulated: !1
        };
        te(q, Q), Q.preventDefault && !Q.defaultPrevented && n.cancelEvent(W), Q.stopPropagation && n.stopEvent(W);
      }
      function M(q, W) {
        var Q = {
          originalEvent: W,
          eventType: "dblclick",
          pointerType: "mouse",
          isEmulated: !1
        };
        te(q, Q), Q.preventDefault && !Q.defaultPrevented && n.cancelEvent(W), Q.stopPropagation && n.stopEvent(W);
      }
      function N(q, W) {
        var Q = null, ce = {
          originalEvent: W,
          eventType: "keydown",
          pointerType: "",
          isEmulated: !1
        };
        te(q, ce), q.keyDownHandler && !ce.preventGesture && !ce.defaultPrevented && (Q = {
          eventSource: q,
          keyCode: W.keyCode ? W.keyCode : W.charCode,
          ctrl: W.ctrlKey,
          shift: W.shiftKey,
          alt: W.altKey,
          meta: W.metaKey,
          originalEvent: W,
          preventDefault: ce.preventDefault || ce.defaultPrevented,
          userData: q.userData
        }, q.keyDownHandler(Q)), (Q && Q.preventDefault || ce.preventDefault && !ce.defaultPrevented) && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function k(q, W) {
        var Q = null, ce = {
          originalEvent: W,
          eventType: "keyup",
          pointerType: "",
          isEmulated: !1
        };
        te(q, ce), q.keyUpHandler && !ce.preventGesture && !ce.defaultPrevented && (Q = {
          eventSource: q,
          keyCode: W.keyCode ? W.keyCode : W.charCode,
          ctrl: W.ctrlKey,
          shift: W.shiftKey,
          alt: W.altKey,
          meta: W.metaKey,
          originalEvent: W,
          preventDefault: ce.preventDefault || ce.defaultPrevented,
          userData: q.userData
        }, q.keyUpHandler(Q)), (Q && Q.preventDefault || ce.preventDefault && !ce.defaultPrevented) && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function U(q, W) {
        var Q = null, ce = {
          originalEvent: W,
          eventType: "keypress",
          pointerType: "",
          isEmulated: !1
        };
        te(q, ce), q.keyHandler && !ce.preventGesture && !ce.defaultPrevented && (Q = {
          eventSource: q,
          keyCode: W.keyCode ? W.keyCode : W.charCode,
          ctrl: W.ctrlKey,
          shift: W.shiftKey,
          alt: W.altKey,
          meta: W.metaKey,
          originalEvent: W,
          preventDefault: ce.preventDefault || ce.defaultPrevented,
          userData: q.userData
        }, q.keyHandler(Q)), (Q && Q.preventDefault || ce.preventDefault && !ce.defaultPrevented) && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function H(q, W) {
        var Q = {
          originalEvent: W,
          eventType: "focus",
          pointerType: "",
          isEmulated: !1
        };
        te(q, Q), q.focusHandler && !Q.preventGesture && q.focusHandler(
          {
            eventSource: q,
            originalEvent: W,
            userData: q.userData
          }
        );
      }
      function Y(q, W) {
        var Q = {
          originalEvent: W,
          eventType: "blur",
          pointerType: "",
          isEmulated: !1
        };
        te(q, Q), q.blurHandler && !Q.preventGesture && q.blurHandler(
          {
            eventSource: q,
            originalEvent: W,
            userData: q.userData
          }
        );
      }
      function z(q, W) {
        var Q = null, ce = {
          originalEvent: W,
          eventType: "contextmenu",
          pointerType: "mouse",
          isEmulated: !1
        };
        te(q, ce), q.contextMenuHandler && !ce.preventGesture && !ce.defaultPrevented && (Q = {
          eventSource: q,
          position: O(w(W), q.element),
          originalEvent: ce.originalEvent,
          preventDefault: ce.preventDefault || ce.defaultPrevented,
          userData: q.userData
        }, q.contextMenuHandler(Q)), (Q && Q.preventDefault || ce.preventDefault && !ce.defaultPrevented) && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function V(q, W) {
        X(q, W, W);
      }
      function F(q, W) {
        var Q = {
          target: W.target || W.srcElement,
          type: "wheel",
          shiftKey: W.shiftKey || !1,
          clientX: W.clientX,
          clientY: W.clientY,
          pageX: W.pageX ? W.pageX : W.clientX,
          pageY: W.pageY ? W.pageY : W.clientY,
          deltaMode: W.type === "MozMousePixelScroll" ? 0 : 1,
          // 0=pixel, 1=line, 2=page
          deltaX: 0,
          deltaZ: 0
        };
        n.MouseTracker.wheelEventName === "mousewheel" ? Q.deltaY = -W.wheelDelta / n.DEFAULT_SETTINGS.pixelsPerWheelLine : Q.deltaY = W.detail, X(q, Q, W);
      }
      function X(q, W, Q) {
        var ce = 0, _e, Fe = null;
        ce = W.deltaY ? W.deltaY < 0 ? 1 : -1 : 0, _e = {
          originalEvent: W,
          eventType: "wheel",
          pointerType: "mouse",
          isEmulated: W !== Q
        }, te(q, _e), q.scrollHandler && !_e.preventGesture && !_e.defaultPrevented && (Fe = {
          eventSource: q,
          pointerType: "mouse",
          position: _(W, q.element),
          scroll: ce,
          shift: W.shiftKey,
          isTouchEvent: !1,
          originalEvent: Q,
          preventDefault: _e.preventDefault || _e.defaultPrevented,
          userData: q.userData
        }, q.scrollHandler(Fe)), _e.stopPropagation && n.stopEvent(Q), (Fe && Fe.preventDefault || _e.preventDefault && !_e.defaultPrevented) && n.cancelEvent(Q);
      }
      function oe(q, W) {
        var Q = {
          id: n.MouseTracker.mousePointerId,
          type: "mouse"
        }, ce = {
          originalEvent: W,
          eventType: "lostpointercapture",
          pointerType: "mouse",
          isEmulated: !1
        };
        te(q, ce), W.target === q.element && ge(q, Q, !1), ce.stopPropagation && n.stopEvent(W);
      }
      function re(q, W) {
        var Q, ce, _e = W.changedTouches.length, Fe, gt = q.getActivePointersListByType("touch");
        Q = n.now(), gt.getLength() > W.touches.length - _e && n.console.warn("Tracked touch contact count doesn't match event.touches.length");
        var ct = {
          originalEvent: W,
          eventType: "pointerdown",
          pointerType: "touch",
          isEmulated: !1
        };
        for (te(q, ct), ce = 0; ce < _e; ce++)
          Fe = {
            id: W.changedTouches[ce].identifier,
            type: "touch",
            // Simulate isPrimary
            isPrimary: gt.getLength() === 0,
            currentPos: w(W.changedTouches[ce]),
            currentTime: Q
          }, ke(q, ct, Fe), mt(q, ct, Fe, 0), ge(q, Fe, !0);
        ct.preventDefault && !ct.defaultPrevented && n.cancelEvent(W), ct.stopPropagation && n.stopEvent(W);
      }
      function Z(q, W) {
        var Q, ce, _e = W.changedTouches.length, Fe;
        Q = n.now();
        var gt = {
          originalEvent: W,
          eventType: "pointerup",
          pointerType: "touch",
          isEmulated: !1
        };
        for (te(q, gt), ce = 0; ce < _e; ce++)
          Fe = {
            id: W.changedTouches[ce].identifier,
            type: "touch",
            currentPos: w(W.changedTouches[ce]),
            currentTime: Q
          }, qe(q, gt, Fe, 0), ge(q, Fe, !1), We(q, gt, Fe);
        gt.preventDefault && !gt.defaultPrevented && n.cancelEvent(W), gt.stopPropagation && n.stopEvent(W);
      }
      function ee(q, W) {
        var Q, ce, _e = W.changedTouches.length, Fe;
        Q = n.now();
        var gt = {
          originalEvent: W,
          eventType: "pointermove",
          pointerType: "touch",
          isEmulated: !1
        };
        for (te(q, gt), ce = 0; ce < _e; ce++)
          Fe = {
            id: W.changedTouches[ce].identifier,
            type: "touch",
            currentPos: w(W.changedTouches[ce]),
            currentTime: Q
          }, at(q, gt, Fe);
        gt.preventDefault && !gt.defaultPrevented && n.cancelEvent(W), gt.stopPropagation && n.stopEvent(W);
      }
      function J(q, W) {
        var Q = W.changedTouches.length, ce, _e, Fe = {
          originalEvent: W,
          eventType: "pointercancel",
          pointerType: "touch",
          isEmulated: !1
        };
        for (te(q, Fe), ce = 0; ce < Q; ce++)
          _e = {
            id: W.changedTouches[ce].identifier,
            type: "touch"
          }, et(q, Fe, _e);
        Fe.stopPropagation && n.stopEvent(W);
      }
      function le(q, W) {
        return n.eventIsCanceled(W) || W.preventDefault(), !1;
      }
      function be(q, W) {
        return n.eventIsCanceled(W) || W.preventDefault(), !1;
      }
      function ne(q, W) {
        var Q = {
          originalEvent: W,
          eventType: "gotpointercapture",
          pointerType: S(W),
          isEmulated: !1
        };
        te(q, Q), W.target === q.element && ge(q, {
          id: W.pointerId,
          type: S(W)
        }, !0), Q.stopPropagation && n.stopEvent(W);
      }
      function ae(q, W) {
        var Q = {
          originalEvent: W,
          eventType: "lostpointercapture",
          pointerType: S(W),
          isEmulated: !1
        };
        te(q, Q), W.target === q.element && ge(q, {
          id: W.pointerId,
          type: S(W)
        }, !1), Q.stopPropagation && n.stopEvent(W);
      }
      function ie(q, W) {
        var Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        }, ce = {
          originalEvent: W,
          eventType: "pointerenter",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), ke(q, ce, Q);
      }
      function he(q, W) {
        var Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        }, ce = {
          originalEvent: W,
          eventType: "pointerleave",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), We(q, ce, Q);
      }
      function pe(q, W) {
        var Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        }, ce = {
          originalEvent: W,
          eventType: "pointerover",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), Be(q, ce, Q), ce.preventDefault && !ce.defaultPrevented && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function me(q, W) {
        var Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        }, ce = {
          originalEvent: W,
          eventType: "pointerout",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), je(q, ce, Q), ce.preventDefault && !ce.defaultPrevented && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function Ee(q, W) {
        var Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        }, ce = n.MouseTracker.havePointerEvents && Q.type === "touch", _e = {
          originalEvent: W,
          eventType: "pointerdown",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, _e), mt(q, _e, Q, W.button), _e.preventDefault && !_e.defaultPrevented && n.cancelEvent(W), _e.stopPropagation && n.stopEvent(W), _e.shouldCapture && (ce ? ge(q, Q, !0) : m(q, Q));
      }
      function Ie(q, W) {
        De(q, W);
      }
      function Pe(q, W) {
        var Q = q.getActivePointersListByType(S(W));
        Q.getById(W.pointerId) && De(q, W), n.stopEvent(W);
      }
      function De(q, W) {
        var Q;
        Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        };
        var ce = {
          originalEvent: W,
          eventType: "pointerup",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), qe(q, ce, Q, W.button), ce.preventDefault && !ce.defaultPrevented && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W), ce.shouldReleaseCapture && (W.target === q.element ? v(q, Q) : ge(q, Q, !1));
      }
      function Ye(q, W) {
        ve(q, W);
      }
      function Ue(q, W) {
        var Q = q.getActivePointersListByType(S(W));
        Q.getById(W.pointerId) && ve(q, W), n.stopEvent(W);
      }
      function ve(q, W) {
        var Q = {
          id: y(W),
          type: S(W),
          isPrimary: E(W),
          currentPos: w(W),
          currentTime: n.now()
        }, ce = {
          originalEvent: W,
          eventType: "pointermove",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), at(q, ce, Q), ce.preventDefault && !ce.defaultPrevented && n.cancelEvent(W), ce.stopPropagation && n.stopEvent(W);
      }
      function rt(q, W) {
        var Q = {
          id: W.pointerId,
          type: S(W)
        }, ce = {
          originalEvent: W,
          eventType: "pointercancel",
          pointerType: Q.type,
          isEmulated: !1
        };
        te(q, ce), et(q, ce, Q), ce.stopPropagation && n.stopEvent(W);
      }
      function Te(q, W) {
        return W.speed = 0, W.direction = 0, W.contactPos = W.currentPos, W.contactTime = W.currentTime, W.lastPos = W.currentPos, W.lastTime = W.currentTime, q.add(W);
      }
      function Je(q, W, Q) {
        var ce, _e = W.getById(Q.id);
        return _e ? (_e.captured && (n.console.warn("stopTrackingPointer() called on captured pointer"), v(q, _e)), W.removeContact(), ce = W.removeById(Q.id)) : ce = W.getLength(), ce;
      }
      function L(q, W) {
        switch (W.eventType) {
          case "pointermove":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !1, W.preventGesture = !q.hasGestureHandlers, W.stopPropagation = !1;
            break;
          case "pointerover":
          case "pointerout":
          case "contextmenu":
          case "keydown":
          case "keyup":
          case "keypress":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !1, W.preventGesture = !1, W.stopPropagation = !1;
            break;
          case "pointerdown":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !1, W.preventGesture = !q.hasGestureHandlers, W.stopPropagation = !1;
            break;
          case "pointerup":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !1, W.preventGesture = !q.hasGestureHandlers, W.stopPropagation = !1;
            break;
          case "wheel":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !1, W.preventGesture = !q.hasScrollHandler, W.stopPropagation = !1;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
            W.isStoppable = !0, W.isCancelable = !1, W.preventDefault = !1, W.preventGesture = !1, W.stopPropagation = !1;
            break;
          case "click":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !!q.clickHandler, W.preventGesture = !1, W.stopPropagation = !1;
            break;
          case "dblclick":
            W.isStoppable = !0, W.isCancelable = !0, W.preventDefault = !!q.dblClickHandler, W.preventGesture = !1, W.stopPropagation = !1;
            break;
          case "focus":
          case "blur":
          case "pointerenter":
          case "pointerleave":
          default:
            W.isStoppable = !1, W.isCancelable = !1, W.preventDefault = !1, W.preventGesture = !1, W.stopPropagation = !1;
            break;
        }
      }
      function te(q, W) {
        W.eventSource = q, W.eventPhase = W.originalEvent && typeof W.originalEvent.eventPhase < "u" ? W.originalEvent.eventPhase : 0, W.defaultPrevented = n.eventIsCanceled(W.originalEvent), W.shouldCapture = !1, W.shouldReleaseCapture = !1, W.userData = q.userData, L(q, W), q.preProcessEventHandler && q.preProcessEventHandler(W);
      }
      function ge(q, W, Q) {
        var ce = q.getActivePointersListByType(W.type), _e = ce.getById(W.id);
        _e ? Q && !_e.captured ? (_e.captured = !0, ce.captureCount++) : !Q && _e.captured && (_e.captured = !1, ce.captureCount--, ce.captureCount < 0 && (ce.captureCount = 0, n.console.warn("updatePointerCaptured() - pointsList.captureCount went negative"))) : n.console.warn("updatePointerCaptured() called on untracked pointer");
      }
      function ke(q, W, Q) {
        var ce = q.getActivePointersListByType(Q.type), _e;
        _e = ce.getById(Q.id), _e ? (_e.insideElement = !0, _e.lastPos = _e.currentPos, _e.lastTime = _e.currentTime, _e.currentPos = Q.currentPos, _e.currentTime = Q.currentTime, Q = _e) : (Q.captured = !1, Q.insideElementPressed = !1, Q.insideElement = !0, Te(ce, Q)), q.enterHandler && q.enterHandler(
          {
            eventSource: q,
            pointerType: Q.type,
            position: O(Q.currentPos, q.element),
            buttons: ce.buttons,
            pointers: q.getActivePointerCount(),
            insideElementPressed: Q.insideElementPressed,
            buttonDownAny: ce.buttons !== 0,
            isTouchEvent: Q.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        );
      }
      function We(q, W, Q) {
        var ce = q.getActivePointersListByType(Q.type), _e, Fe;
        _e = ce.getById(Q.id), _e ? (_e.captured ? (_e.insideElement = !1, _e.lastPos = _e.currentPos, _e.lastTime = _e.currentTime, _e.currentPos = Q.currentPos, _e.currentTime = Q.currentTime) : Je(q, ce, _e), Q = _e) : (Q.captured = !1, Q.insideElementPressed = !1), (q.leaveHandler || q.exitHandler) && (Fe = {
          eventSource: q,
          pointerType: Q.type,
          // GitHub PR: https://github.com/openseadragon/openseadragon/pull/1754 (gPoint.currentPos && )
          position: Q.currentPos && O(Q.currentPos, q.element),
          buttons: ce.buttons,
          pointers: q.getActivePointerCount(),
          insideElementPressed: Q.insideElementPressed,
          buttonDownAny: ce.buttons !== 0,
          isTouchEvent: Q.type === "touch",
          originalEvent: W.originalEvent,
          userData: q.userData
        }, q.leaveHandler && q.leaveHandler(Fe), q.exitHandler && q.exitHandler(Fe));
      }
      function Be(q, W, Q) {
        var ce, _e;
        ce = q.getActivePointersListByType(Q.type), _e = ce.getById(Q.id), _e ? Q = _e : (Q.captured = !1, Q.insideElementPressed = !1), q.overHandler && q.overHandler(
          {
            eventSource: q,
            pointerType: Q.type,
            position: O(Q.currentPos, q.element),
            buttons: ce.buttons,
            pointers: q.getActivePointerCount(),
            insideElementPressed: Q.insideElementPressed,
            buttonDownAny: ce.buttons !== 0,
            isTouchEvent: Q.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        );
      }
      function je(q, W, Q) {
        var ce, _e;
        ce = q.getActivePointersListByType(Q.type), _e = ce.getById(Q.id), _e ? Q = _e : (Q.captured = !1, Q.insideElementPressed = !1), q.outHandler && q.outHandler({
          eventSource: q,
          pointerType: Q.type,
          position: Q.currentPos && O(Q.currentPos, q.element),
          buttons: ce.buttons,
          pointers: q.getActivePointerCount(),
          insideElementPressed: Q.insideElementPressed,
          buttonDownAny: ce.buttons !== 0,
          isTouchEvent: Q.type === "touch",
          originalEvent: W.originalEvent,
          userData: q.userData
        });
      }
      function mt(q, W, Q, ce) {
        var _e = r[q.hash], Fe = q.getActivePointersListByType(Q.type), gt;
        if (typeof W.originalEvent.buttons < "u" ? Fe.buttons = W.originalEvent.buttons : ce === 0 ? Fe.buttons |= 1 : ce === 1 ? Fe.buttons |= 4 : ce === 2 ? Fe.buttons |= 2 : ce === 3 ? Fe.buttons |= 8 : ce === 4 ? Fe.buttons |= 16 : ce === 5 && (Fe.buttons |= 32), ce !== 0) {
          W.shouldCapture = !1, W.shouldReleaseCapture = !1, q.nonPrimaryPressHandler && !W.preventGesture && !W.defaultPrevented && (W.preventDefault = !0, q.nonPrimaryPressHandler(
            {
              eventSource: q,
              pointerType: Q.type,
              position: O(Q.currentPos, q.element),
              button: ce,
              buttons: Fe.buttons,
              isTouchEvent: Q.type === "touch",
              originalEvent: W.originalEvent,
              userData: q.userData
            }
          ));
          return;
        }
        gt = Fe.getById(Q.id), gt ? (gt.insideElementPressed = !0, gt.insideElement = !0, gt.originalTarget = W.originalEvent.target, gt.contactPos = Q.currentPos, gt.contactTime = Q.currentTime, gt.lastPos = gt.currentPos, gt.lastTime = gt.currentTime, gt.currentPos = Q.currentPos, gt.currentTime = Q.currentTime, Q = gt) : (Q.captured = !1, Q.insideElementPressed = !0, Q.insideElement = !0, Q.originalTarget = W.originalEvent.target, Te(Fe, Q)), Fe.addContact(), !W.preventGesture && !W.defaultPrevented ? (W.shouldCapture = !0, W.shouldReleaseCapture = !1, W.preventDefault = !0, (q.dragHandler || q.dragEndHandler || q.pinchHandler) && n.MouseTracker.gesturePointVelocityTracker.addPoint(q, Q), Fe.contacts === 1 ? q.pressHandler && !W.preventGesture && q.pressHandler(
          {
            eventSource: q,
            pointerType: Q.type,
            position: O(Q.contactPos, q.element),
            buttons: Fe.buttons,
            isTouchEvent: Q.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ) : Fe.contacts === 2 && q.pinchHandler && Q.type === "touch" && (_e.pinchGPoints = Fe.asArray(), _e.lastPinchDist = _e.currentPinchDist = _e.pinchGPoints[0].currentPos.distanceTo(_e.pinchGPoints[1].currentPos), _e.lastPinchCenter = _e.currentPinchCenter = D(_e.pinchGPoints[0].currentPos, _e.pinchGPoints[1].currentPos))) : (W.shouldCapture = !1, W.shouldReleaseCapture = !1);
      }
      function qe(q, W, Q, ce) {
        var _e = r[q.hash], Fe = q.getActivePointersListByType(Q.type), gt, ct, ht, Yt = !1, Rt;
        if (typeof W.originalEvent.buttons < "u" ? Fe.buttons = W.originalEvent.buttons : ce === 0 ? Fe.buttons ^= -2 : ce === 1 ? Fe.buttons ^= -5 : ce === 2 ? Fe.buttons ^= -3 : ce === 3 ? Fe.buttons ^= -9 : ce === 4 ? Fe.buttons ^= -17 : ce === 5 && (Fe.buttons ^= -33), W.shouldCapture = !1, ce !== 0) {
          W.shouldReleaseCapture = !1, q.nonPrimaryReleaseHandler && !W.preventGesture && !W.defaultPrevented && (W.preventDefault = !0, q.nonPrimaryReleaseHandler(
            {
              eventSource: q,
              pointerType: Q.type,
              position: O(Q.currentPos, q.element),
              button: ce,
              buttons: Fe.buttons,
              isTouchEvent: Q.type === "touch",
              originalEvent: W.originalEvent,
              userData: q.userData
            }
          ));
          return;
        }
        ht = Fe.getById(Q.id), ht ? (Fe.removeContact(), ht.captured && (Yt = !0), ht.lastPos = ht.currentPos, ht.lastTime = ht.currentTime, ht.currentPos = Q.currentPos, ht.currentTime = Q.currentTime, ht.insideElement || Je(q, Fe, ht), gt = ht.currentPos, ct = ht.currentTime) : (Q.captured = !1, Q.insideElementPressed = !1, Q.insideElement = !0, Te(Fe, Q), ht = Q), !W.preventGesture && !W.defaultPrevented && (Yt ? (W.shouldReleaseCapture = !0, W.preventDefault = !0, (q.dragHandler || q.dragEndHandler || q.pinchHandler) && n.MouseTracker.gesturePointVelocityTracker.removePoint(q, ht), Fe.contacts === 0 ? (q.releaseHandler && gt && q.releaseHandler(
          {
            eventSource: q,
            pointerType: ht.type,
            position: O(gt, q.element),
            buttons: Fe.buttons,
            insideElementPressed: ht.insideElementPressed,
            insideElementReleased: ht.insideElement,
            isTouchEvent: ht.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ), q.dragEndHandler && _e.sentDragEvent && q.dragEndHandler(
          {
            eventSource: q,
            pointerType: ht.type,
            position: O(ht.currentPos, q.element),
            speed: ht.speed,
            direction: ht.direction,
            shift: W.originalEvent.shiftKey,
            isTouchEvent: ht.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ), _e.sentDragEvent = !1, (q.clickHandler || q.dblClickHandler) && ht.insideElement && (Rt = ct - ht.contactTime <= q.clickTimeThreshold && ht.contactPos.distanceTo(gt) <= q.clickDistThreshold, q.clickHandler && q.clickHandler(
          {
            eventSource: q,
            pointerType: ht.type,
            position: O(ht.currentPos, q.element),
            quick: Rt,
            shift: W.originalEvent.shiftKey,
            isTouchEvent: ht.type === "touch",
            originalEvent: W.originalEvent,
            originalTarget: ht.originalTarget,
            userData: q.userData
          }
        ), q.dblClickHandler && Rt && (Fe.clicks++, Fe.clicks === 1 ? (_e.lastClickPos = gt, _e.dblClickTimeOut = setTimeout(function() {
          Fe.clicks = 0;
        }, q.dblClickTimeThreshold)) : Fe.clicks === 2 && (clearTimeout(_e.dblClickTimeOut), Fe.clicks = 0, _e.lastClickPos.distanceTo(gt) <= q.dblClickDistThreshold && q.dblClickHandler(
          {
            eventSource: q,
            pointerType: ht.type,
            position: O(ht.currentPos, q.element),
            shift: W.originalEvent.shiftKey,
            isTouchEvent: ht.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ), _e.lastClickPos = null)))) : Fe.contacts === 2 && q.pinchHandler && ht.type === "touch" && (_e.pinchGPoints = Fe.asArray(), _e.lastPinchDist = _e.currentPinchDist = _e.pinchGPoints[0].currentPos.distanceTo(_e.pinchGPoints[1].currentPos), _e.lastPinchCenter = _e.currentPinchCenter = D(_e.pinchGPoints[0].currentPos, _e.pinchGPoints[1].currentPos))) : (W.shouldReleaseCapture = !1, q.releaseHandler && gt && (q.releaseHandler(
          {
            eventSource: q,
            pointerType: ht.type,
            position: O(gt, q.element),
            buttons: Fe.buttons,
            insideElementPressed: ht.insideElementPressed,
            insideElementReleased: ht.insideElement,
            isTouchEvent: ht.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ), W.preventDefault = !0)));
      }
      function at(q, W, Q) {
        var ce = r[q.hash], _e = q.getActivePointersListByType(Q.type), Fe, gt, ct;
        if (typeof W.originalEvent.buttons < "u" && (_e.buttons = W.originalEvent.buttons), Fe = _e.getById(Q.id), Fe)
          Fe.lastPos = Fe.currentPos, Fe.lastTime = Fe.currentTime, Fe.currentPos = Q.currentPos, Fe.currentTime = Q.currentTime;
        else
          return;
        W.shouldCapture = !1, W.shouldReleaseCapture = !1, q.stopHandler && Q.type === "mouse" && (clearTimeout(q.stopTimeOut), q.stopTimeOut = setTimeout(function() {
          bt(q, W.originalEvent, Q.type);
        }, q.stopDelay)), _e.contacts === 0 ? q.moveHandler && q.moveHandler(
          {
            eventSource: q,
            pointerType: Q.type,
            position: O(Q.currentPos, q.element),
            buttons: _e.buttons,
            isTouchEvent: Q.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ) : _e.contacts === 1 ? (q.moveHandler && (Fe = _e.asArray()[0], q.moveHandler(
          {
            eventSource: q,
            pointerType: Fe.type,
            position: O(Fe.currentPos, q.element),
            buttons: _e.buttons,
            isTouchEvent: Fe.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        )), q.dragHandler && !W.preventGesture && !W.defaultPrevented && (Fe = _e.asArray()[0], ct = Fe.currentPos.minus(Fe.lastPos), q.dragHandler(
          {
            eventSource: q,
            pointerType: Fe.type,
            position: O(Fe.currentPos, q.element),
            buttons: _e.buttons,
            delta: ct,
            speed: Fe.speed,
            direction: Fe.direction,
            shift: W.originalEvent.shiftKey,
            isTouchEvent: Fe.type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ), W.preventDefault = !0, ce.sentDragEvent = !0)) : _e.contacts === 2 && (q.moveHandler && (gt = _e.asArray(), q.moveHandler(
          {
            eventSource: q,
            pointerType: gt[0].type,
            position: O(D(gt[0].currentPos, gt[1].currentPos), q.element),
            buttons: _e.buttons,
            isTouchEvent: gt[0].type === "touch",
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        )), q.pinchHandler && Q.type === "touch" && !W.preventGesture && !W.defaultPrevented && (ct = ce.pinchGPoints[0].currentPos.distanceTo(ce.pinchGPoints[1].currentPos), ct !== ce.currentPinchDist && (ce.lastPinchDist = ce.currentPinchDist, ce.currentPinchDist = ct, ce.lastPinchCenter = ce.currentPinchCenter, ce.currentPinchCenter = D(ce.pinchGPoints[0].currentPos, ce.pinchGPoints[1].currentPos), q.pinchHandler(
          {
            eventSource: q,
            pointerType: "touch",
            gesturePoints: ce.pinchGPoints,
            lastCenter: O(ce.lastPinchCenter, q.element),
            center: O(ce.currentPinchCenter, q.element),
            lastDistance: ce.lastPinchDist,
            distance: ce.currentPinchDist,
            shift: W.originalEvent.shiftKey,
            originalEvent: W.originalEvent,
            userData: q.userData
          }
        ), W.preventDefault = !0)));
      }
      function et(q, W, Q) {
        var ce = q.getActivePointersListByType(Q.type), _e;
        _e = ce.getById(Q.id), _e && Je(q, ce, _e);
      }
      function bt(q, W, Q) {
        q.stopHandler && q.stopHandler({
          eventSource: q,
          pointerType: Q,
          position: _(W, q.element),
          buttons: q.getActivePointersListByType(Q).buttons,
          isTouchEvent: Q === "touch",
          originalEvent: W,
          userData: q.userData
        });
      }
    })(t), (function(n) {
      n.ControlAnchor = {
        NONE: 0,
        TOP_LEFT: 1,
        TOP_RIGHT: 2,
        BOTTOM_RIGHT: 3,
        BOTTOM_LEFT: 4,
        ABSOLUTE: 5
      }, n.Control = function(r, i, o) {
        var s = r.parentNode;
        typeof i == "number" && (n.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; please use an options object instead.  Support for this deprecated variant is scheduled for removal in December 2013"), i = { anchor: i }), i.attachToViewer = typeof i.attachToViewer > "u" ? !0 : i.attachToViewer, this.autoFade = typeof i.autoFade > "u" ? !0 : i.autoFade, this.element = r, this.anchor = i.anchor, this.container = o, this.anchor === n.ControlAnchor.ABSOLUTE ? (this.wrapper = n.makeNeutralElement("div"), this.wrapper.style.position = "absolute", this.wrapper.style.top = typeof i.top == "number" ? i.top + "px" : i.top, this.wrapper.style.left = typeof i.left == "number" ? i.left + "px" : i.left, this.wrapper.style.height = typeof i.height == "number" ? i.height + "px" : i.height, this.wrapper.style.width = typeof i.width == "number" ? i.width + "px" : i.width, this.wrapper.style.margin = "0px", this.wrapper.style.padding = "0px", this.element.style.position = "relative", this.element.style.top = "0px", this.element.style.left = "0px", this.element.style.height = "100%", this.element.style.width = "100%") : (this.wrapper = n.makeNeutralElement("div"), this.wrapper.style.display = "inline-block", this.anchor === n.ControlAnchor.NONE && (this.wrapper.style.width = this.wrapper.style.height = "100%")), this.wrapper.appendChild(this.element), i.attachToViewer ? this.anchor === n.ControlAnchor.TOP_RIGHT || this.anchor === n.ControlAnchor.BOTTOM_RIGHT ? this.container.insertBefore(
          this.wrapper,
          this.container.firstChild
        ) : this.container.appendChild(this.wrapper) : s.appendChild(this.wrapper);
      }, n.Control.prototype = {
        /**
         * Removes the control from the container.
         * @function
         */
        destroy: function() {
          this.wrapper.removeChild(this.element), this.anchor !== n.ControlAnchor.NONE && this.container.removeChild(this.wrapper);
        },
        /**
         * Determines if the control is currently visible.
         * @function
         * @returns {Boolean} true if currently visible, false otherwise.
         */
        isVisible: function() {
          return this.wrapper.style.display !== "none";
        },
        /**
         * Toggles the visibility of the control.
         * @function
         * @param {Boolean} visible - true to make visible, false to hide.
         */
        setVisible: function(r) {
          this.wrapper.style.display = r ? this.anchor === n.ControlAnchor.ABSOLUTE ? "block" : "inline-block" : "none";
        },
        /**
         * Sets the opacity level for the control.
         * @function
         * @param {Number} opactiy - a value between 1 and 0 inclusively.
         */
        setOpacity: function(r) {
          n.setElementOpacity(this.wrapper, r, !0);
        }
      };
    })(t), (function(n) {
      n.ControlDock = function(i) {
        var o = ["topleft", "topright", "bottomright", "bottomleft"], s, u;
        for (n.extend(!0, this, {
          id: "controldock-" + n.now() + "-" + Math.floor(Math.random() * 1e6),
          container: n.makeNeutralElement("div"),
          controls: []
        }, i), this.container.onsubmit = function() {
          return !1;
        }, this.element && (this.element = n.getElement(this.element), this.element.appendChild(this.container), n.getElementStyle(this.element).position === "static" && (this.element.style.position = "relative"), this.container.style.width = "100%", this.container.style.height = "100%"), u = 0; u < o.length; u++)
          s = o[u], this.controls[s] = n.makeNeutralElement("div"), this.controls[s].style.position = "absolute", s.match("left") && (this.controls[s].style.left = "0px"), s.match("right") && (this.controls[s].style.right = "0px"), s.match("top") && (this.controls[s].style.top = "0px"), s.match("bottom") && (this.controls[s].style.bottom = "0px");
        this.container.appendChild(this.controls.topleft), this.container.appendChild(this.controls.topright), this.container.appendChild(this.controls.bottomright), this.container.appendChild(this.controls.bottomleft);
      }, n.ControlDock.prototype = {
        /**
         * @function
         */
        addControl: function(i, o) {
          i = n.getElement(i);
          var s = null;
          if (!(r(this, i) >= 0)) {
            switch (o.anchor) {
              case n.ControlAnchor.TOP_RIGHT:
                s = this.controls.topright, i.style.position = "relative", i.style.paddingRight = "0px", i.style.paddingTop = "0px";
                break;
              case n.ControlAnchor.BOTTOM_RIGHT:
                s = this.controls.bottomright, i.style.position = "relative", i.style.paddingRight = "0px", i.style.paddingBottom = "0px";
                break;
              case n.ControlAnchor.BOTTOM_LEFT:
                s = this.controls.bottomleft, i.style.position = "relative", i.style.paddingLeft = "0px", i.style.paddingBottom = "0px";
                break;
              case n.ControlAnchor.TOP_LEFT:
                s = this.controls.topleft, i.style.position = "relative", i.style.paddingLeft = "0px", i.style.paddingTop = "0px";
                break;
              case n.ControlAnchor.ABSOLUTE:
                s = this.container, i.style.margin = "0px", i.style.padding = "0px";
                break;
              default:
              case n.ControlAnchor.NONE:
                s = this.container, i.style.margin = "0px", i.style.padding = "0px";
                break;
            }
            this.controls.push(
              new n.Control(i, o, s)
            ), i.style.display = "inline-block";
          }
        },
        /**
         * @function
         * @returns {OpenSeadragon.ControlDock} Chainable.
         */
        removeControl: function(i) {
          i = n.getElement(i);
          var o = r(this, i);
          return o >= 0 && (this.controls[o].destroy(), this.controls.splice(o, 1)), this;
        },
        /**
         * @function
         * @returns {OpenSeadragon.ControlDock} Chainable.
         */
        clearControls: function() {
          for (; this.controls.length > 0; )
            this.controls.pop().destroy();
          return this;
        },
        /**
         * @function
         * @returns {Boolean}
         */
        areControlsEnabled: function() {
          var i;
          for (i = this.controls.length - 1; i >= 0; i--)
            if (this.controls[i].isVisible())
              return !0;
          return !1;
        },
        /**
         * @function
         * @returns {OpenSeadragon.ControlDock} Chainable.
         */
        setControlsEnabled: function(i) {
          var o;
          for (o = this.controls.length - 1; o >= 0; o--)
            this.controls[o].setVisible(i);
          return this;
        }
      };
      function r(i, o) {
        var s = i.controls, u;
        for (u = s.length - 1; u >= 0; u--)
          if (s[u].element === o)
            return u;
        return -1;
      }
    })(t), (function(n) {
      n.Placement = n.freezeObject({
        CENTER: 0,
        TOP_LEFT: 1,
        TOP: 2,
        TOP_RIGHT: 3,
        RIGHT: 4,
        BOTTOM_RIGHT: 5,
        BOTTOM: 6,
        BOTTOM_LEFT: 7,
        LEFT: 8,
        properties: {
          0: {
            isLeft: !1,
            isHorizontallyCentered: !0,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !0,
            isBottom: !1
          },
          1: {
            isLeft: !0,
            isHorizontallyCentered: !1,
            isRight: !1,
            isTop: !0,
            isVerticallyCentered: !1,
            isBottom: !1
          },
          2: {
            isLeft: !1,
            isHorizontallyCentered: !0,
            isRight: !1,
            isTop: !0,
            isVerticallyCentered: !1,
            isBottom: !1
          },
          3: {
            isLeft: !1,
            isHorizontallyCentered: !1,
            isRight: !0,
            isTop: !0,
            isVerticallyCentered: !1,
            isBottom: !1
          },
          4: {
            isLeft: !1,
            isHorizontallyCentered: !1,
            isRight: !0,
            isTop: !1,
            isVerticallyCentered: !0,
            isBottom: !1
          },
          5: {
            isLeft: !1,
            isHorizontallyCentered: !1,
            isRight: !0,
            isTop: !1,
            isVerticallyCentered: !1,
            isBottom: !0
          },
          6: {
            isLeft: !1,
            isHorizontallyCentered: !0,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !1,
            isBottom: !0
          },
          7: {
            isLeft: !0,
            isHorizontallyCentered: !1,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !1,
            isBottom: !0
          },
          8: {
            isLeft: !0,
            isHorizontallyCentered: !1,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !0,
            isBottom: !1
          }
        }
      });
    })(t), (function(n) {
      var r = {}, i = 1;
      n.Viewer = function(L) {
        var te = arguments, ge = this, ke;
        n.isPlainObject(L) || (L = {
          id: te[0],
          xmlPath: te.length > 1 ? te[1] : void 0,
          prefixUrl: te.length > 2 ? te[2] : void 0,
          controls: te.length > 3 ? te[3] : void 0,
          overlays: te.length > 4 ? te[4] : void 0
        }), L.config && (n.extend(!0, L, L.config), delete L.config);
        let We = [
          "useCanvas"
          // deprecated
        ];
        if (L.drawerOptions = Object.assign(
          {},
          We.reduce((je, mt) => (je[mt] = L[mt], delete L[mt], je), {}),
          L.drawerOptions
        ), n.extend(!0, this, {
          //internal state and dom identifiers
          id: L.id,
          hash: L.hash || i++,
          /**
           * Index for page to be shown first next time open() is called (only used in sequenceMode).
           * @member {Number} initialPage
           * @memberof OpenSeadragon.Viewer#
           */
          initialPage: 0,
          //dom nodes
          /**
           * The parent element of this Viewer instance, passed in when the Viewer was created.
           * @member {Element} element
           * @memberof OpenSeadragon.Viewer#
           */
          element: null,
          /**
           * A &lt;div&gt; element (provided by {@link OpenSeadragon.ControlDock}), the base element of this Viewer instance.<br><br>
           * Child element of {@link OpenSeadragon.Viewer#element}.
           * @member {Element} container
           * @memberof OpenSeadragon.Viewer#
           */
          container: null,
          /**
           * A &lt;div&gt; element, the element where user-input events are handled for panning and zooming.<br><br>
           * Child element of {@link OpenSeadragon.Viewer#container},
           * positioned on top of {@link OpenSeadragon.Viewer#keyboardCommandArea}.<br><br>
           * The parent of {@link OpenSeadragon.Drawer#canvas} instances.
           * @member {Element} canvas
           * @memberof OpenSeadragon.Viewer#
           */
          canvas: null,
          // Overlays list. An overlay allows to add html on top of the viewer.
          overlays: [],
          // Container inside the canvas where overlays are drawn.
          overlaysContainer: null,
          //private state properties
          previousBody: [],
          //This was originally initialized in the constructor and so could never
          //have anything in it.  now it can because we allow it to be specified
          //in the options and is only empty by default if not specified. Also
          //this array was returned from get_controls which I find confusing
          //since this object has a controls property which is treated in other
          //functions like clearControls.  I'm removing the accessors.
          customControls: [],
          //These are originally not part options but declared as members
          //in initialize.  It's still considered idiomatic to put them here
          //source is here for backwards compatibility. It is not an official
          //part of the API and should not be relied upon.
          source: null,
          /**
           * Handles rendering of tiles in the viewer. Created for each TileSource opened.
           * @member {OpenSeadragon.Drawer} drawer
           * @memberof OpenSeadragon.Viewer#
           */
          drawer: null,
          /**
           * Keeps track of all of the tiled images in the scene.
           * @member {OpenSeadragon.World} world
           * @memberof OpenSeadragon.Viewer#
           */
          world: null,
          /**
           * Handles coordinate-related functionality - zoom, pan, rotation, etc. Created for each TileSource opened.
           * @member {OpenSeadragon.Viewport} viewport
           * @memberof OpenSeadragon.Viewer#
           */
          viewport: null,
          /**
           * @member {OpenSeadragon.Navigator} navigator
           * @memberof OpenSeadragon.Viewer#
           */
          navigator: null,
          //A collection viewport is a separate viewport used to provide
          //simultaneous rendering of sets of tiles
          collectionViewport: null,
          collectionDrawer: null,
          //UI image resources
          //TODO: rename navImages to uiImages
          navImages: null,
          //interface button controls
          buttonGroup: null,
          //TODO: this is defunct so safely remove it
          profiler: null
        }, n.DEFAULT_SETTINGS, L), typeof this.hash > "u")
          throw new Error("A hash must be defined, either by specifying options.id or options.hash.");
        typeof r[this.hash] < "u" && n.console.warn("Hash " + this.hash + " has already been used."), r[this.hash] = {
          fsBoundsDelta: new n.Point(1, 1),
          prevContainerSize: null,
          animating: !1,
          forceRedraw: !1,
          needsResize: !1,
          forceResize: !1,
          mouseInside: !1,
          group: null,
          // whether we should be continuously zooming
          zooming: !1,
          // how much we should be continuously zooming by
          zoomFactor: null,
          lastZoomTime: null,
          fullPage: !1,
          onfullscreenchange: null,
          lastClickTime: null,
          draggingToZoom: !1
        }, this._sequenceIndex = 0, this._firstOpen = !0, this._updateRequestId = null, this._loadQueue = [], this.currentOverlays = [], this._updatePixelDensityRatioBind = null, this._lastScrollTime = n.now(), n.EventSource.call(this), this.addHandler("open-failed", function(je) {
          var mt = n.getString("Errors.OpenFailed", je.eventSource, je.message);
          ge._showMessage(mt);
        }), n.ControlDock.call(this, L), this.xmlPath && (this.tileSources = [this.xmlPath]), this.element = this.element || document.getElementById(this.id), this.canvas = n.makeNeutralElement("div"), this.canvas.className = "openseadragon-canvas", (function(je) {
          je.width = "100%", je.height = "100%", je.overflow = "hidden", je.position = "absolute", je.top = "0px", je.left = "0px";
        })(this.canvas.style), n.setElementTouchActionNone(this.canvas), L.tabIndex !== "" && (this.canvas.tabIndex = L.tabIndex === void 0 ? 0 : L.tabIndex), this.container.className = "openseadragon-container", (function(je) {
          je.width = "100%", je.height = "100%", je.position = "relative", je.overflow = "hidden", je.left = "0px", je.top = "0px", je.textAlign = "left";
        })(this.container.style), n.setElementTouchActionNone(this.container), this.container.insertBefore(this.canvas, this.container.firstChild), this.element.appendChild(this.container), this.bodyWidth = document.body.style.width, this.bodyHeight = document.body.style.height, this.bodyOverflow = document.body.style.overflow, this.docOverflow = document.documentElement.style.overflow, this.innerTracker = new n.MouseTracker({
          userData: "Viewer.innerTracker",
          element: this.canvas,
          startDisabled: !this.mouseNavEnabled,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          dblClickTimeThreshold: this.dblClickTimeThreshold,
          dblClickDistThreshold: this.dblClickDistThreshold,
          contextMenuHandler: n.delegate(this, _),
          keyDownHandler: n.delegate(this, O),
          keyHandler: n.delegate(this, D),
          clickHandler: n.delegate(this, P),
          dblClickHandler: n.delegate(this, M),
          dragHandler: n.delegate(this, N),
          dragEndHandler: n.delegate(this, k),
          enterHandler: n.delegate(this, U),
          leaveHandler: n.delegate(this, H),
          pressHandler: n.delegate(this, Y),
          releaseHandler: n.delegate(this, z),
          nonPrimaryPressHandler: n.delegate(this, V),
          nonPrimaryReleaseHandler: n.delegate(this, F),
          scrollHandler: n.delegate(this, Z),
          pinchHandler: n.delegate(this, X),
          focusHandler: n.delegate(this, oe),
          blurHandler: n.delegate(this, re)
        }), this.outerTracker = new n.MouseTracker({
          userData: "Viewer.outerTracker",
          element: this.container,
          startDisabled: !this.mouseNavEnabled,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          dblClickTimeThreshold: this.dblClickTimeThreshold,
          dblClickDistThreshold: this.dblClickDistThreshold,
          enterHandler: n.delegate(this, ee),
          leaveHandler: n.delegate(this, J)
        }), this.toolbar && (this.toolbar = new n.ControlDock({ element: this.toolbar })), this.bindStandardControls(), r[this.hash].prevContainerSize = o(this.container), window.ResizeObserver ? (this._autoResizePolling = !1, this._resizeObserver = new ResizeObserver(function() {
          r[ge.hash].needsResize = !0;
        }), this._resizeObserver.observe(this.container, {})) : this._autoResizePolling = !0, this.world = new n.World({
          viewer: this
        }), this.world.addHandler("add-item", function(je) {
          ge.source = ge.world.getItemAt(0).source, r[ge.hash].forceRedraw = !0, ge._updateRequestId || (ge._updateRequestId = p(ge, le));
        }), this.world.addHandler("remove-item", function(je) {
          ge.world.getItemCount() ? ge.source = ge.world.getItemAt(0).source : ge.source = null, r[ge.hash].forceRedraw = !0;
        }), this.world.addHandler("metrics-change", function(je) {
          ge.viewport && ge.viewport._setContentBounds(ge.world.getHomeBounds(), ge.world.getContentFactor());
        }), this.world.addHandler("item-index-change", function(je) {
          ge.source = ge.world.getItemAt(0).source;
        }), this.viewport = new n.Viewport({
          containerSize: r[this.hash].prevContainerSize,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime,
          minZoomImageRatio: this.minZoomImageRatio,
          maxZoomPixelRatio: this.maxZoomPixelRatio,
          visibilityRatio: this.visibilityRatio,
          wrapHorizontal: this.wrapHorizontal,
          wrapVertical: this.wrapVertical,
          defaultZoomLevel: this.defaultZoomLevel,
          minZoomLevel: this.minZoomLevel,
          maxZoomLevel: this.maxZoomLevel,
          viewer: this,
          degrees: this.degrees,
          flipped: this.flipped,
          overlayPreserveContentDirection: this.overlayPreserveContentDirection,
          navigatorRotate: this.navigatorRotate,
          homeFillsViewer: this.homeFillsViewer,
          margins: this.viewportMargins,
          silenceMultiImageWarnings: this.silenceMultiImageWarnings
        }), this.viewport._setContentBounds(this.world.getHomeBounds(), this.world.getContentFactor()), this.imageLoader = new n.ImageLoader({
          jobLimit: this.imageLoaderLimit,
          timeout: L.timeout,
          tileRetryMax: this.tileRetryMax,
          tileRetryDelay: this.tileRetryDelay
        }), this.tileCache = new n.TileCache({
          maxImageCacheCount: this.maxImageCacheCount
        }), Object.prototype.hasOwnProperty.call(this.drawerOptions, "useCanvas") && (n.console.error('useCanvas is deprecated, use the "drawer" option to indicate preferred drawer(s)'), this.drawerOptions.useCanvas || (this.drawer = n.HTMLDrawer), delete this.drawerOptions.useCanvas);
        let Be = Array.isArray(this.drawer) ? this.drawer : [this.drawer];
        Be.length === 0 && (Be = [n.DEFAULT_SETTINGS.drawer].flat(), n.console.warn("No valid drawers were selected. Using the default value.")), this.drawer = null;
        for (const je of Be)
          if (this.requestDrawer(je, { mainDrawer: !0, redrawImmediately: !1 }))
            break;
        if (!this.drawer)
          throw n.console.error("No drawer could be created!"), "Error with creating the selected drawer(s)";
        for (this.drawer.setImageSmoothingEnabled(this.imageSmoothingEnabled), this.overlaysContainer = n.makeNeutralElement("div"), this.canvas.appendChild(this.overlaysContainer), this.drawer.canRotate() || (this.rotateLeft && (ke = this.buttonGroup.buttons.indexOf(this.rotateLeft), this.buttonGroup.buttons.splice(ke, 1), this.buttonGroup.element.removeChild(this.rotateLeft.element)), this.rotateRight && (ke = this.buttonGroup.buttons.indexOf(this.rotateRight), this.buttonGroup.buttons.splice(ke, 1), this.buttonGroup.element.removeChild(this.rotateRight.element))), this._addUpdatePixelDensityRatioEvent(), this.showNavigator && (this.navigator = new n.Navigator({
          element: this.navigatorElement,
          id: this.navigatorId,
          position: this.navigatorPosition,
          sizeRatio: this.navigatorSizeRatio,
          maintainSizeRatio: this.navigatorMaintainSizeRatio,
          top: this.navigatorTop,
          left: this.navigatorLeft,
          width: this.navigatorWidth,
          height: this.navigatorHeight,
          autoResize: this.navigatorAutoResize,
          autoFade: this.navigatorAutoFade,
          prefixUrl: this.prefixUrl,
          viewer: this,
          navigatorRotate: this.navigatorRotate,
          background: this.navigatorBackground,
          opacity: this.navigatorOpacity,
          borderColor: this.navigatorBorderColor,
          displayRegionColor: this.navigatorDisplayRegionColor,
          crossOriginPolicy: this.crossOriginPolicy,
          animationTime: this.animationTime,
          drawer: this.drawer.getType(),
          loadTilesWithAjax: this.loadTilesWithAjax,
          ajaxHeaders: this.ajaxHeaders,
          ajaxWithCredentials: this.ajaxWithCredentials
        })), this.sequenceMode && this.bindSequenceControls(), this.tileSources && this.open(this.tileSources), ke = 0; ke < this.customControls.length; ke++)
          this.addControl(
            this.customControls[ke].id,
            { anchor: this.customControls[ke].anchor }
          );
        n.requestAnimationFrame(function() {
          v(ge);
        }), n._viewers.set(this.element, this);
      }, n.extend(
        n.Viewer.prototype,
        n.EventSource.prototype,
        n.ControlDock.prototype,
        /** @lends OpenSeadragon.Viewer.prototype */
        {
          /**
           * @function
           * @returns {Boolean}
           */
          isOpen: function() {
            return !!this.world.getItemCount();
          },
          // deprecated
          openDzi: function(L) {
            return n.console.error("[Viewer.openDzi] this function is deprecated; use Viewer.open() instead."), this.open(L);
          },
          // deprecated
          openTileSource: function(L) {
            return n.console.error("[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead."), this.open(L);
          },
          //deprecated
          get buttons() {
            return n.console.warn("Viewer.buttons is deprecated; Please use Viewer.buttonGroup"), this.buttonGroup;
          },
          /**
           * Open tiled images into the viewer, closing any others.
           * To get the TiledImage instance created by open, add an event listener for
           * {@link OpenSeadragon.Viewer.html#.event:open}, which when fired can be used to get access
           * to the instance, i.e., viewer.world.getItemAt(0).
           * @function
           * @param {Array|String|Object|Function} tileSources - This can be a TiledImage
           * specifier, a TileSource specifier, or an array of either. A TiledImage specifier
           * is the same as the options parameter for {@link OpenSeadragon.Viewer#addTiledImage},
           * except for the index property; images are added in sequence.
           * A TileSource specifier is anything you could pass as the tileSource property
           * of the options parameter for {@link OpenSeadragon.Viewer#addTiledImage}.
           * @param {Number} initialPage - If sequenceMode is true, display this page initially
           * for the given tileSources. If specified, will overwrite the Viewer's existing initialPage property.
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:open
           * @fires OpenSeadragon.Viewer.event:open-failed
           */
          open: function(L, te) {
            var ge = this;
            if (this.close(), !L)
              return this;
            if (this.sequenceMode && n.isArray(L))
              return this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null), typeof te < "u" && !isNaN(te) && (this.initialPage = te), this.tileSources = L, this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage)), this.tileSources.length && (this.open(this.tileSources[this._sequenceIndex]), this.showReferenceStrip && this.addReferenceStrip()), this._updateSequenceButtons(this._sequenceIndex), this;
            if (n.isArray(L) || (L = [L]), !L.length)
              return this;
            this._opening = !0;
            for (var ke = L.length, We = 0, Be = 0, je, mt = function() {
              if (We + Be === ke)
                if (We) {
                  (ge._firstOpen || !ge.preserveViewport) && (ge.viewport.goHome(!0), ge.viewport.update()), ge._firstOpen = !1;
                  var et = L[0];
                  if (et.tileSource && (et = et.tileSource), ge.overlays && !ge.preserveOverlays)
                    for (var bt = 0; bt < ge.overlays.length; bt++)
                      ge.currentOverlays[bt] = u(ge, ge.overlays[bt]);
                  ge._drawOverlays(), ge._opening = !1, ge.raiseEvent("open", { source: et });
                } else
                  ge._opening = !1, ge.raiseEvent("open-failed", je);
            }, qe = function(et) {
              (!n.isPlainObject(et) || !et.tileSource) && (et = {
                tileSource: et
              }), et.index !== void 0 && (n.console.error("[Viewer.open] setting indexes here is not supported; use addTiledImage instead"), delete et.index), et.collectionImmediately === void 0 && (et.collectionImmediately = !0);
              var bt = et.success;
              et.success = function(W) {
                if (We++, et.tileSource.overlays)
                  for (var Q = 0; Q < et.tileSource.overlays.length; Q++)
                    ge.addOverlay(et.tileSource.overlays[Q]);
                bt && bt(W), mt();
              };
              var q = et.error;
              et.error = function(W) {
                Be++, je || (je = W), q && q(W), mt();
              }, ge.addTiledImage(et);
            }, at = 0; at < L.length; at++)
              qe(L[at]);
            return this;
          },
          /**
           * @function
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:close
           */
          close: function() {
            return r[this.hash] ? (this._opening = !1, this.navigator && this.navigator.close(), this.preserveOverlays || (this.clearOverlays(), this.overlaysContainer.innerHTML = ""), r[this.hash].animating = !1, this.world.removeAll(), this.imageLoader.clear(), this.raiseEvent("close"), this) : this;
          },
          /**
           * Function to destroy the viewer and clean up everything created by OpenSeadragon.
           *
           * Example:
           * var viewer = OpenSeadragon({
           *   [...]
           * });
           *
           * //when you are done with the viewer:
           * viewer.destroy();
           * viewer = null; //important
           *
           * @function
           * @fires OpenSeadragon.Viewer.event:before-destroy
           * @fires OpenSeadragon.Viewer.event:destroy
           */
          destroy: function() {
            if (r[this.hash]) {
              if (this.raiseEvent("before-destroy"), this._removeUpdatePixelDensityRatioEvent(), this.close(), this.clearOverlays(), this.overlaysContainer.innerHTML = "", this._resizeObserver && this._resizeObserver.disconnect(), this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null), this._updateRequestId !== null && (n.cancelAnimationFrame(this._updateRequestId), this._updateRequestId = null), this.drawer && this.drawer.destroy(), this.navigator && (this.navigator.destroy(), r[this.navigator.hash] = null, delete r[this.navigator.hash], this.navigator = null), this.buttonGroup)
                this.buttonGroup.destroy();
              else if (this.customButtons)
                for (; this.customButtons.length; )
                  this.customButtons.pop().destroy();
              if (this.paging && this.paging.destroy(), this.element)
                for (; this.element.firstChild; )
                  this.element.removeChild(this.element.firstChild);
              this.container.onsubmit = null, this.clearControls(), this.innerTracker && this.innerTracker.destroy(), this.outerTracker && this.outerTracker.destroy(), r[this.hash] = null, delete r[this.hash], this.canvas = null, this.container = null, n._viewers.delete(this.element), this.element = null, this.raiseEvent("destroy"), this.removeAllHandlers();
            }
          },
          /**
           * Request a drawer for this viewer, as a supported string or drawer constructor.
           * @param {String | OpenSeadragon.DrawerBase} drawerCandidate The type of drawer to try to construct.
           * @param { Object } options
           * @param { Boolean } [options.mainDrawer] Whether to use this as the viewer's main drawer. Default = true.
           * @param { Boolean } [options.redrawImmediately] Whether to immediately draw a new frame. Only used if options.mainDrawer = true. Default = true.
           * @param { Object } [options.drawerOptions] Options for this drawer. Defaults to viewer.drawerOptions.
           * for this viewer type. See {@link OpenSeadragon.Options}.
           * @returns {Object | Boolean} The drawer that was created, or false if the requested drawer is not supported
           */
          requestDrawer(L, te) {
            const ge = {
              mainDrawer: !0,
              redrawImmediately: !0,
              drawerOptions: null
            };
            te = n.extend(!0, ge, te);
            const ke = te.mainDrawer, We = te.redrawImmediately, Be = te.drawerOptions, je = this.drawer;
            let mt = null;
            if (L && L.prototype instanceof n.DrawerBase ? (mt = L, L = "custom") : typeof L == "string" && (mt = n.determineDrawer(L)), mt || n.console.warn("Unsupported drawer! Drawer must be an existing string type, or a class that extends OpenSeadragon.DrawerBase."), mt && mt.isSupported()) {
              je && ke && je.destroy();
              const qe = new mt({
                viewer: this,
                viewport: this.viewport,
                element: this.canvas,
                debugGridColor: this.debugGridColor,
                options: Be || this.drawerOptions[L]
              });
              return ke && (this.drawer = qe, We && this.forceRedraw()), qe;
            }
            return !1;
          },
          /**
           * @function
           * @returns {Boolean}
           */
          isMouseNavEnabled: function() {
            return this.innerTracker.isTracking();
          },
          /**
           * @function
           * @param {Boolean} enabled - true to enable, false to disable
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:mouse-enabled
           */
          setMouseNavEnabled: function(L) {
            return this.innerTracker.setTracking(L), this.outerTracker.setTracking(L), this.raiseEvent("mouse-enabled", { enabled: L }), this;
          },
          /**
           * @function
           * @returns {Boolean}
           */
          areControlsEnabled: function() {
            var L = this.controls.length, te;
            for (te = 0; te < this.controls.length; te++)
              L = L && this.controls[te].isVisible();
            return L;
          },
          /**
           * Shows or hides the controls (e.g. the default navigation buttons).
           *
           * @function
           * @param {Boolean} true to show, false to hide.
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:controls-enabled
           */
          setControlsEnabled: function(L) {
            return L ? S(this) : v(this), this.raiseEvent("controls-enabled", { enabled: L }), this;
          },
          /**
           * Turns debugging mode on or off for this viewer.
           *
           * @function
           * @param {Boolean} debugMode true to turn debug on, false to turn debug off.
           */
          setDebugMode: function(L) {
            for (var te = 0; te < this.world.getItemCount(); te++)
              this.world.getItemAt(te).debugMode = L;
            this.debugMode = L, this.forceRedraw();
          },
          /**
           * Update headers to include when making AJAX requests.
           *
           * Unless `propagate` is set to false (which is likely only useful in rare circumstances),
           * the updated headers are propagated to all tiled images, each of which will subsequently
           * propagate the changed headers to all their tiles.
           * If applicable, the headers of the viewer's navigator and reference strip will also be updated.
           *
           * Note that the rules for merging headers still apply, i.e. headers returned by
           * {@link OpenSeadragon.TileSource#getTileAjaxHeaders} take precedence over
           * `TiledImage.ajaxHeaders`, which take precedence over the headers here in the viewer.
           *
           * @function
           * @param {Object} ajaxHeaders Updated AJAX headers.
           * @param {Boolean} [propagate=true] Whether to propagate updated headers to tiled images, etc.
           */
          setAjaxHeaders: function(L, te) {
            if (L === null && (L = {}), !n.isPlainObject(L)) {
              console.error("[Viewer.setAjaxHeaders] Ignoring invalid headers, must be a plain object");
              return;
            }
            if (te === void 0 && (te = !0), this.ajaxHeaders = L, te) {
              for (var ge = 0; ge < this.world.getItemCount(); ge++)
                this.world.getItemAt(ge)._updateAjaxHeaders(!0);
              if (this.navigator && this.navigator.setAjaxHeaders(this.ajaxHeaders, !0), this.referenceStrip && this.referenceStrip.miniViewers)
                for (var ke in this.referenceStrip.miniViewers)
                  this.referenceStrip.miniViewers[ke].setAjaxHeaders(this.ajaxHeaders, !0);
            }
          },
          /**
           * Adds the given button to this viewer.
           *
           * @function
           * @param {OpenSeadragon.Button} button
           */
          addButton: function(L) {
            this.buttonGroup.addButton(L);
          },
          /**
           * @function
           * @returns {Boolean}
           */
          isFullPage: function() {
            return r[this.hash] && r[this.hash].fullPage;
          },
          /**
           * Toggle full page mode.
           * @function
           * @param {Boolean} fullPage
           *      If true, enter full page mode.  If false, exit full page mode.
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:pre-full-page
           * @fires OpenSeadragon.Viewer.event:full-page
           */
          setFullPage: function(L) {
            var te = document.body, ge = te.style, ke = document.documentElement.style, We = this, Be, je;
            if (L === this.isFullPage())
              return this;
            var mt = {
              fullPage: L,
              preventDefaultAction: !1
            };
            if (this.raiseEvent("pre-full-page", mt), mt.preventDefaultAction)
              return this;
            if (L && this.element) {
              for (this.elementSize = n.getElementSize(this.element), this.pageScroll = n.getPageScroll(), this.elementMargin = this.element.style.margin, this.element.style.margin = "0", this.elementPadding = this.element.style.padding, this.element.style.padding = "0", this.bodyMargin = ge.margin, this.docMargin = ke.margin, ge.margin = "0", ke.margin = "0", this.bodyPadding = ge.padding, this.docPadding = ke.padding, ge.padding = "0", ke.padding = "0", this.bodyWidth = ge.width, this.docWidth = ke.width, ge.width = "100%", ke.width = "100%", this.bodyHeight = ge.height, this.docHeight = ke.height, ge.height = "100%", ke.height = "100%", this.bodyDisplay = ge.display, ge.display = "block", this.previousBody = [], r[this.hash].prevElementParent = this.element.parentNode, r[this.hash].prevNextSibling = this.element.nextSibling, r[this.hash].prevElementWidth = this.element.style.width, r[this.hash].prevElementHeight = this.element.style.height, Be = te.childNodes.length, je = 0; je < Be; je++)
                this.previousBody.push(te.childNodes[0]), te.removeChild(te.childNodes[0]);
              this.toolbar && this.toolbar.element && (this.toolbar.parentNode = this.toolbar.element.parentNode, this.toolbar.nextSibling = this.toolbar.element.nextSibling, te.appendChild(this.toolbar.element), n.addClass(this.toolbar.element, "fullpage")), n.addClass(this.element, "fullpage"), te.appendChild(this.element), this.element.style.height = "100vh", this.element.style.width = "100vw", this.toolbar && this.toolbar.element && (this.element.style.height = n.getElementSize(this.element).y - n.getElementSize(this.toolbar.element).y + "px"), r[this.hash].fullPage = !0, n.delegate(this, ee)({});
            } else {
              for (this.element.style.margin = this.elementMargin, this.element.style.padding = this.elementPadding, ge.margin = this.bodyMargin, ke.margin = this.docMargin, ge.padding = this.bodyPadding, ke.padding = this.docPadding, ge.width = this.bodyWidth, ke.width = this.docWidth, ge.height = this.bodyHeight, ke.height = this.docHeight, ge.display = this.bodyDisplay, te.removeChild(this.element), Be = this.previousBody.length, je = 0; je < Be; je++)
                te.appendChild(this.previousBody.shift());
              n.removeClass(this.element, "fullpage"), r[this.hash].prevElementParent.insertBefore(
                this.element,
                r[this.hash].prevNextSibling
              ), this.toolbar && this.toolbar.element && (te.removeChild(this.toolbar.element), n.removeClass(this.toolbar.element, "fullpage"), this.toolbar.parentNode.insertBefore(
                this.toolbar.element,
                this.toolbar.nextSibling
              ), delete this.toolbar.parentNode, delete this.toolbar.nextSibling), this.element.style.width = r[this.hash].prevElementWidth, this.element.style.height = r[this.hash].prevElementHeight;
              var qe = 0, at = function() {
                n.setPageScroll(We.pageScroll);
                var et = n.getPageScroll();
                qe++, qe < 10 && (et.x !== We.pageScroll.x || et.y !== We.pageScroll.y) && n.requestAnimationFrame(at);
              };
              n.requestAnimationFrame(at), r[this.hash].fullPage = !1, n.delegate(this, J)({});
            }
            return this.navigator && this.viewport && this.navigator.update(this.viewport), this.raiseEvent("full-page", { fullPage: L }), this;
          },
          /**
           * Toggle full screen mode if supported. Toggle full page mode otherwise.
           * @function
           * @param {Boolean} fullScreen
           *      If true, enter full screen mode.  If false, exit full screen mode.
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:pre-full-screen
           * @fires OpenSeadragon.Viewer.event:full-screen
           */
          setFullScreen: function(L) {
            var te = this;
            if (!n.supportsFullScreen)
              return this.setFullPage(L);
            if (n.isFullScreen() === L)
              return this;
            var ge = {
              fullScreen: L,
              preventDefaultAction: !1
            };
            if (this.raiseEvent("pre-full-screen", ge), ge.preventDefaultAction)
              return this;
            if (L) {
              if (this.setFullPage(!0), !this.isFullPage())
                return this;
              this.fullPageStyleWidth = this.element.style.width, this.fullPageStyleHeight = this.element.style.height, this.element.style.width = "100%", this.element.style.height = "100%";
              var ke = function() {
                var We = n.isFullScreen();
                We || (n.removeEvent(document, n.fullScreenEventName, ke), n.removeEvent(document, n.fullScreenErrorEventName, ke), te.setFullPage(!1), te.isFullPage() && (te.element.style.width = te.fullPageStyleWidth, te.element.style.height = te.fullPageStyleHeight)), te.navigator && te.viewport && setTimeout(function() {
                  te.navigator.update(te.viewport);
                }), te.raiseEvent("full-screen", { fullScreen: We });
              };
              n.addEvent(document, n.fullScreenEventName, ke), n.addEvent(document, n.fullScreenErrorEventName, ke), n.requestFullScreen(document.body);
            } else
              n.exitFullScreen();
            return this;
          },
          /**
           * @function
           * @returns {Boolean}
           */
          isVisible: function() {
            return this.container.style.visibility !== "hidden";
          },
          //
          /**
           * @function
           * @returns {Boolean} returns true if the viewer is in fullscreen
           */
          isFullScreen: function() {
            return n.isFullScreen() && this.isFullPage();
          },
          /**
           * @function
           * @param {Boolean} visible
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:visible
           */
          setVisible: function(L) {
            return this.container.style.visibility = L ? "" : "hidden", this.raiseEvent("visible", { visible: L }), this;
          },
          /**
           * Add a tiled image to the viewer.
           * options.tileSource can be anything that {@link OpenSeadragon.Viewer#open}
           *  supports except arrays of images.
           * Note that you can specify options.width or options.height, but not both.
           * The other dimension will be calculated according to the item's aspect ratio.
           * If collectionMode is on (see {@link OpenSeadragon.Options}), the new image is
           * automatically arranged with the others.
           * @function
           * @param {Object} options
           * @param {String|Object|Function} options.tileSource - The TileSource specifier.
           * A String implies a url used to determine the tileSource implementation
           *      based on the file extension of url. JSONP is implied by *.js,
           *      otherwise the url is retrieved as text and the resulting text is
           *      introspected to determine if its json, xml, or text and parsed.
           * An Object implies an inline configuration which has a single
           *      property sufficient for being able to determine tileSource
           *      implementation. If the object has a property which is a function
           *      named 'getTileUrl', it is treated as a custom TileSource.
           * @param {Number} [options.index] The index of the item. Added on top of
           * all other items if not specified.
           * @param {Boolean} [options.replace=false] If true, the item at options.index will be
           * removed and the new item is added in its place. options.tileSource will be
           * interpreted and fetched if necessary before the old item is removed to avoid leaving
           * a gap in the world.
           * @param {Number} [options.x=0] The X position for the image in viewport coordinates.
           * @param {Number} [options.y=0] The Y position for the image in viewport coordinates.
           * @param {Number} [options.width=1] The width for the image in viewport coordinates.
           * @param {Number} [options.height] The height for the image in viewport coordinates.
           * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
           * to fit the image into. If specified, x, y, width and height get ignored.
           * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
           * How to anchor the image in the bounds if options.fitBounds is set.
           * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
           * (portions of the image outside of this area will not be visible). Only works on
           * browsers that support the HTML5 canvas.
           * @param {Number} [options.opacity=1] Proportional opacity of the tiled images (1=opaque, 0=hidden)
           * @param {Boolean} [options.preload=false]  Default switch for loading hidden images (true loads, false blocks)
           * @param {Number} [options.degrees=0] Initial rotation of the tiled image around
           * its top left corner in degrees.
           * @param {Boolean} [options.flipped=false] Whether to horizontally flip the image.
           * @param {String} [options.compositeOperation] How the image is composited onto other images.
           * @param {String} [options.crossOriginPolicy] The crossOriginPolicy for this specific image,
           * overriding viewer.crossOriginPolicy.
           * @param {Boolean} [options.ajaxWithCredentials] Whether to set withCredentials on tile AJAX
           * @param {Boolean} [options.loadTilesWithAjax]
           *      Whether to load tile data using AJAX requests.
           *      Defaults to the setting in {@link OpenSeadragon.Options}.
           * @param {Object} [options.ajaxHeaders]
           *      A set of headers to include when making tile AJAX requests.
           *      Note that these headers will be merged over any headers specified in {@link OpenSeadragon.Options}.
           *      Specifying a falsy value for a header will clear its existing value set at the Viewer level (if any).
           * @param {Function} [options.success] A function that gets called when the image is
           * successfully added. It's passed the event object which contains a single property:
           * "item", which is the resulting instance of TiledImage.
           * @param {Function} [options.error] A function that gets called if the image is
           * unable to be added. It's passed the error event object, which contains "message"
           * and "source" properties.
           * @param {Boolean} [options.collectionImmediately=false] If collectionMode is on,
           * specifies whether to snap to the new arrangement immediately or to animate to it.
           * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
           * @fires OpenSeadragon.World.event:add-item
           * @fires OpenSeadragon.Viewer.event:add-item-failed
           */
          addTiledImage: function(L) {
            n.console.assert(L, "[Viewer.addTiledImage] options is required"), n.console.assert(L.tileSource, "[Viewer.addTiledImage] options.tileSource is required"), n.console.assert(
              !L.replace || L.index > -1 && L.index < this.world.getItemCount(),
              "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world"
            );
            var te = this;
            L.replace && (L.replaceItem = te.world.getItemAt(L.index)), this._hideMessage(), L.placeholderFillStyle === void 0 && (L.placeholderFillStyle = this.placeholderFillStyle), L.opacity === void 0 && (L.opacity = this.opacity), L.preload === void 0 && (L.preload = this.preload), L.compositeOperation === void 0 && (L.compositeOperation = this.compositeOperation), L.crossOriginPolicy === void 0 && (L.crossOriginPolicy = L.tileSource.crossOriginPolicy !== void 0 ? L.tileSource.crossOriginPolicy : this.crossOriginPolicy), L.ajaxWithCredentials === void 0 && (L.ajaxWithCredentials = this.ajaxWithCredentials), L.loadTilesWithAjax === void 0 && (L.loadTilesWithAjax = this.loadTilesWithAjax), n.isPlainObject(L.ajaxHeaders) || (L.ajaxHeaders = {});
            var ge = {
              options: L
            };
            function ke(je) {
              for (var mt = 0; mt < te._loadQueue.length; mt++)
                if (te._loadQueue[mt] === ge) {
                  te._loadQueue.splice(mt, 1);
                  break;
                }
              te._loadQueue.length === 0 && We(ge), te.raiseEvent("add-item-failed", je), L.error && L.error(je);
            }
            function We(je) {
              te.collectionMode && (te.world.arrange({
                immediately: je.options.collectionImmediately,
                rows: te.collectionRows,
                columns: te.collectionColumns,
                layout: te.collectionLayout,
                tileSize: te.collectionTileSize,
                tileMargin: te.collectionTileMargin
              }), te.world.setAutoRefigureSizes(!0));
            }
            if (n.isArray(L.tileSource)) {
              setTimeout(function() {
                ke({
                  message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
                  source: L.tileSource,
                  options: L
                });
              });
              return;
            }
            this._loadQueue.push(ge);
            function Be() {
              for (var je, mt, qe; te._loadQueue.length && (je = te._loadQueue[0], !!je.tileSource); ) {
                if (te._loadQueue.splice(0, 1), je.options.replace) {
                  var at = te.world.getIndexOfItem(je.options.replaceItem);
                  at !== -1 && (je.options.index = at), te.world.removeItem(je.options.replaceItem);
                }
                mt = new n.TiledImage({
                  viewer: te,
                  source: je.tileSource,
                  viewport: te.viewport,
                  drawer: te.drawer,
                  tileCache: te.tileCache,
                  imageLoader: te.imageLoader,
                  x: je.options.x,
                  y: je.options.y,
                  width: je.options.width,
                  height: je.options.height,
                  fitBounds: je.options.fitBounds,
                  fitBoundsPlacement: je.options.fitBoundsPlacement,
                  clip: je.options.clip,
                  placeholderFillStyle: je.options.placeholderFillStyle,
                  opacity: je.options.opacity,
                  preload: je.options.preload,
                  degrees: je.options.degrees,
                  flipped: je.options.flipped,
                  compositeOperation: je.options.compositeOperation,
                  springStiffness: te.springStiffness,
                  animationTime: te.animationTime,
                  minZoomImageRatio: te.minZoomImageRatio,
                  wrapHorizontal: te.wrapHorizontal,
                  wrapVertical: te.wrapVertical,
                  maxTilesPerFrame: te.maxTilesPerFrame,
                  immediateRender: te.immediateRender,
                  blendTime: te.blendTime,
                  alwaysBlend: te.alwaysBlend,
                  minPixelRatio: te.minPixelRatio,
                  smoothTileEdgesMinZoom: te.smoothTileEdgesMinZoom,
                  iOSDevice: te.iOSDevice,
                  crossOriginPolicy: je.options.crossOriginPolicy,
                  ajaxWithCredentials: je.options.ajaxWithCredentials,
                  loadTilesWithAjax: je.options.loadTilesWithAjax,
                  ajaxHeaders: je.options.ajaxHeaders,
                  debugMode: te.debugMode,
                  subPixelRoundingForTransparency: te.subPixelRoundingForTransparency
                }), te.collectionMode && te.world.setAutoRefigureSizes(!1), te.navigator && (qe = n.extend({}, je.options, {
                  replace: !1,
                  // navigator already removed the layer, nothing to replace
                  originalTiledImage: mt,
                  tileSource: je.tileSource
                }), te.navigator.addTiledImage(qe)), te.world.addItem(mt, {
                  index: je.options.index
                }), te._loadQueue.length === 0 && We(je), te.world.getItemCount() === 1 && !te.preserveViewport && te.viewport.goHome(!0), je.options.success && je.options.success({
                  item: mt
                });
              }
            }
            s(this, L.tileSource, L, function(je) {
              ge.tileSource = je, Be();
            }, function(je) {
              je.options = L, ke(je), Be();
            });
          },
          /**
           * Add a simple image to the viewer.
           * The options are the same as the ones in {@link OpenSeadragon.Viewer#addTiledImage}
           * except for options.tileSource which is replaced by options.url.
           * @function
           * @param {Object} options - See {@link OpenSeadragon.Viewer#addTiledImage}
           * for all the options
           * @param {String} options.url - The URL of the image to add.
           * @fires OpenSeadragon.World.event:add-item
           * @fires OpenSeadragon.Viewer.event:add-item-failed
           */
          addSimpleImage: function(L) {
            n.console.assert(L, "[Viewer.addSimpleImage] options is required"), n.console.assert(L.url, "[Viewer.addSimpleImage] options.url is required");
            var te = n.extend({}, L, {
              tileSource: {
                type: "image",
                url: L.url
              }
            });
            delete te.url, this.addTiledImage(te);
          },
          // deprecated
          addLayer: function(L) {
            var te = this;
            n.console.error("[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead.");
            var ge = n.extend({}, L, {
              success: function(ke) {
                te.raiseEvent("add-layer", {
                  options: L,
                  drawer: ke.item
                });
              },
              error: function(ke) {
                te.raiseEvent("add-layer-failed", ke);
              }
            });
            return this.addTiledImage(ge), this;
          },
          // deprecated
          getLayerAtLevel: function(L) {
            return n.console.error("[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead."), this.world.getItemAt(L);
          },
          // deprecated
          getLevelOfLayer: function(L) {
            return n.console.error("[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead."), this.world.getIndexOfItem(L);
          },
          // deprecated
          getLayersCount: function() {
            return n.console.error("[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead."), this.world.getItemCount();
          },
          // deprecated
          setLayerLevel: function(L, te) {
            return n.console.error("[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead."), this.world.setItemIndex(L, te);
          },
          // deprecated
          removeLayer: function(L) {
            return n.console.error("[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead."), this.world.removeItem(L);
          },
          /**
           * Force the viewer to redraw its contents.
           * @returns {OpenSeadragon.Viewer} Chainable.
           */
          forceRedraw: function() {
            return r[this.hash].forceRedraw = !0, this;
          },
          /**
           * Force the viewer to reset its size to match its container.
           */
          forceResize: function() {
            r[this.hash].needsResize = !0, r[this.hash].forceResize = !0;
          },
          /**
           * @function
           * @returns {OpenSeadragon.Viewer} Chainable.
           */
          bindSequenceControls: function() {
            var L = n.delegate(this, E), te = n.delegate(this, w), ge = n.delegate(this, this.goToNextPage), ke = n.delegate(this, this.goToPreviousPage), We = this.navImages, Be = !0;
            return this.showSequenceControl && ((this.previousButton || this.nextButton) && (Be = !1), this.previousButton = new n.Button({
              element: this.previousButton ? n.getElement(this.previousButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.PreviousPage"),
              srcRest: ie(this.prefixUrl, We.previous.REST),
              srcGroup: ie(this.prefixUrl, We.previous.GROUP),
              srcHover: ie(this.prefixUrl, We.previous.HOVER),
              srcDown: ie(this.prefixUrl, We.previous.DOWN),
              onRelease: ke,
              onFocus: L,
              onBlur: te
            }), this.nextButton = new n.Button({
              element: this.nextButton ? n.getElement(this.nextButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.NextPage"),
              srcRest: ie(this.prefixUrl, We.next.REST),
              srcGroup: ie(this.prefixUrl, We.next.GROUP),
              srcHover: ie(this.prefixUrl, We.next.HOVER),
              srcDown: ie(this.prefixUrl, We.next.DOWN),
              onRelease: ge,
              onFocus: L,
              onBlur: te
            }), this.navPrevNextWrap || this.previousButton.disable(), (!this.tileSources || !this.tileSources.length) && this.nextButton.disable(), Be && (this.paging = new n.ButtonGroup({
              buttons: [
                this.previousButton,
                this.nextButton
              ],
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold
            }), this.pagingControl = this.paging.element, this.toolbar ? this.toolbar.addControl(
              this.pagingControl,
              { anchor: n.ControlAnchor.BOTTOM_RIGHT }
            ) : this.addControl(
              this.pagingControl,
              { anchor: this.sequenceControlAnchor || n.ControlAnchor.TOP_LEFT }
            ))), this;
          },
          /**
           * @function
           * @returns {OpenSeadragon.Viewer} Chainable.
           */
          bindStandardControls: function() {
            var L = n.delegate(this, he), te = n.delegate(this, me), ge = n.delegate(this, Pe), ke = n.delegate(this, pe), We = n.delegate(this, De), Be = n.delegate(this, Ue), je = n.delegate(this, ve), mt = n.delegate(this, rt), qe = n.delegate(this, Te), at = n.delegate(this, Je), et = n.delegate(this, E), bt = n.delegate(this, w), q = this.navImages, W = [], Q = !0;
            return this.showNavigationControl && ((this.zoomInButton || this.zoomOutButton || this.homeButton || this.fullPageButton || this.rotateLeftButton || this.rotateRightButton || this.flipButton) && (Q = !1), this.showZoomControl && (W.push(this.zoomInButton = new n.Button({
              element: this.zoomInButton ? n.getElement(this.zoomInButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.ZoomIn"),
              srcRest: ie(this.prefixUrl, q.zoomIn.REST),
              srcGroup: ie(this.prefixUrl, q.zoomIn.GROUP),
              srcHover: ie(this.prefixUrl, q.zoomIn.HOVER),
              srcDown: ie(this.prefixUrl, q.zoomIn.DOWN),
              onPress: L,
              onRelease: te,
              onClick: ge,
              onEnter: L,
              onExit: te,
              onFocus: et,
              onBlur: bt
            })), W.push(this.zoomOutButton = new n.Button({
              element: this.zoomOutButton ? n.getElement(this.zoomOutButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.ZoomOut"),
              srcRest: ie(this.prefixUrl, q.zoomOut.REST),
              srcGroup: ie(this.prefixUrl, q.zoomOut.GROUP),
              srcHover: ie(this.prefixUrl, q.zoomOut.HOVER),
              srcDown: ie(this.prefixUrl, q.zoomOut.DOWN),
              onPress: ke,
              onRelease: te,
              onClick: We,
              onEnter: ke,
              onExit: te,
              onFocus: et,
              onBlur: bt
            }))), this.showHomeControl && W.push(this.homeButton = new n.Button({
              element: this.homeButton ? n.getElement(this.homeButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.Home"),
              srcRest: ie(this.prefixUrl, q.home.REST),
              srcGroup: ie(this.prefixUrl, q.home.GROUP),
              srcHover: ie(this.prefixUrl, q.home.HOVER),
              srcDown: ie(this.prefixUrl, q.home.DOWN),
              onRelease: Be,
              onFocus: et,
              onBlur: bt
            })), this.showFullPageControl && W.push(this.fullPageButton = new n.Button({
              element: this.fullPageButton ? n.getElement(this.fullPageButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.FullPage"),
              srcRest: ie(this.prefixUrl, q.fullpage.REST),
              srcGroup: ie(this.prefixUrl, q.fullpage.GROUP),
              srcHover: ie(this.prefixUrl, q.fullpage.HOVER),
              srcDown: ie(this.prefixUrl, q.fullpage.DOWN),
              onRelease: je,
              onFocus: et,
              onBlur: bt
            })), this.showRotationControl && (W.push(this.rotateLeftButton = new n.Button({
              element: this.rotateLeftButton ? n.getElement(this.rotateLeftButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.RotateLeft"),
              srcRest: ie(this.prefixUrl, q.rotateleft.REST),
              srcGroup: ie(this.prefixUrl, q.rotateleft.GROUP),
              srcHover: ie(this.prefixUrl, q.rotateleft.HOVER),
              srcDown: ie(this.prefixUrl, q.rotateleft.DOWN),
              onRelease: mt,
              onFocus: et,
              onBlur: bt
            })), W.push(this.rotateRightButton = new n.Button({
              element: this.rotateRightButton ? n.getElement(this.rotateRightButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.RotateRight"),
              srcRest: ie(this.prefixUrl, q.rotateright.REST),
              srcGroup: ie(this.prefixUrl, q.rotateright.GROUP),
              srcHover: ie(this.prefixUrl, q.rotateright.HOVER),
              srcDown: ie(this.prefixUrl, q.rotateright.DOWN),
              onRelease: qe,
              onFocus: et,
              onBlur: bt
            }))), this.showFlipControl && W.push(this.flipButton = new n.Button({
              element: this.flipButton ? n.getElement(this.flipButton) : null,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold,
              tooltip: n.getString("Tooltips.Flip"),
              srcRest: ie(this.prefixUrl, q.flip.REST),
              srcGroup: ie(this.prefixUrl, q.flip.GROUP),
              srcHover: ie(this.prefixUrl, q.flip.HOVER),
              srcDown: ie(this.prefixUrl, q.flip.DOWN),
              onRelease: at,
              onFocus: et,
              onBlur: bt
            })), Q ? (this.buttonGroup = new n.ButtonGroup({
              buttons: W,
              clickTimeThreshold: this.clickTimeThreshold,
              clickDistThreshold: this.clickDistThreshold
            }), this.navControl = this.buttonGroup.element, this.addHandler("open", n.delegate(this, Ye)), this.toolbar ? this.toolbar.addControl(
              this.navControl,
              { anchor: this.navigationControlAnchor || n.ControlAnchor.TOP_LEFT }
            ) : this.addControl(
              this.navControl,
              { anchor: this.navigationControlAnchor || n.ControlAnchor.TOP_LEFT }
            )) : this.customButtons = W), this;
          },
          /**
           * Gets the active page of a sequence
           * @function
           * @returns {Number}
           */
          currentPage: function() {
            return this._sequenceIndex;
          },
          /**
           * @function
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:page
           */
          goToPage: function(L) {
            return this.tileSources && L >= 0 && L < this.tileSources.length && (this._sequenceIndex = L, this._updateSequenceButtons(L), this.open(this.tileSources[L]), this.referenceStrip && this.referenceStrip.setFocus(L), this.raiseEvent("page", { page: L })), this;
          },
          /**
            * Adds an html element as an overlay to the current viewport.  Useful for
            * highlighting words or areas of interest on an image or other zoomable
            * interface. The overlays added via this method are removed when the viewport
            * is closed which include when changing page.
            * @method
            * @param {Element|String|Object} element - A reference to an element or an id for
            *      the element which will be overlaid. Or an Object specifying the configuration for the overlay.
            *      If using an object, see {@link OpenSeadragon.Overlay} for a list of
            *      all available options.
            * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
            *      rectangle which will be overlaid. This is a viewport relative location.
            * @param {OpenSeadragon.Placement} [placement=OpenSeadragon.Placement.TOP_LEFT] - The position of the
            *      viewport which the location coordinates will be treated as relative
            *      to.
            * @param {function} [onDraw] - If supplied the callback is called when the overlay
            *      needs to be drawn. It is the responsibility of the callback to do any drawing/positioning.
            *      It is passed position, size and element.
            * @returns {OpenSeadragon.Viewer} Chainable.
            * @fires OpenSeadragon.Viewer.event:add-overlay
            */
          addOverlay: function(L, te, ge, ke) {
            var We;
            if (n.isPlainObject(L) ? We = L : We = {
              element: L,
              location: te,
              placement: ge,
              onDraw: ke
            }, L = n.getElement(We.element), f(this.currentOverlays, L) >= 0)
              return this;
            var Be = u(this, We);
            return this.currentOverlays.push(Be), Be.drawHTML(this.overlaysContainer, this.viewport), this.raiseEvent("add-overlay", {
              element: L,
              location: We.location,
              placement: We.placement
            }), this;
          },
          /**
           * Updates the overlay represented by the reference to the element or
           * element id moving it to the new location, relative to the new placement.
           * @method
           * @param {Element|String} element - A reference to an element or an id for
           *      the element which is overlaid.
           * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
           *      rectangle which will be overlaid. This is a viewport relative location.
           * @param {OpenSeadragon.Placement} [placement=OpenSeadragon.Placement.TOP_LEFT] - The position of the
           *      viewport which the location coordinates will be treated as relative
           *      to.
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:update-overlay
           */
          updateOverlay: function(L, te, ge) {
            var ke;
            return L = n.getElement(L), ke = f(this.currentOverlays, L), ke >= 0 && (this.currentOverlays[ke].update(te, ge), r[this.hash].forceRedraw = !0, this.raiseEvent("update-overlay", {
              element: L,
              location: te,
              placement: ge
            })), this;
          },
          /**
           * Removes an overlay identified by the reference element or element id
           * and schedules an update.
           * @method
           * @param {Element|String} element - A reference to the element or an
           *      element id which represent the ovelay content to be removed.
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:remove-overlay
           */
          removeOverlay: function(L) {
            var te;
            return L = n.getElement(L), te = f(this.currentOverlays, L), te >= 0 && (this.currentOverlays[te].destroy(), this.currentOverlays.splice(te, 1), r[this.hash].forceRedraw = !0, this.raiseEvent("remove-overlay", {
              element: L
            })), this;
          },
          /**
           * Removes all currently configured Overlays from this Viewer and schedules
           * an update.
           * @method
           * @returns {OpenSeadragon.Viewer} Chainable.
           * @fires OpenSeadragon.Viewer.event:clear-overlay
           */
          clearOverlays: function() {
            for (; this.currentOverlays.length > 0; )
              this.currentOverlays.pop().destroy();
            return r[this.hash].forceRedraw = !0, this.raiseEvent("clear-overlay", {}), this;
          },
          /**
          * Finds an overlay identified by the reference element or element id
          * and returns it as an object, return null if not found.
          * @method
          * @param {Element|String} element - A reference to the element or an
          *      element id which represents the overlay content.
          * @returns {OpenSeadragon.Overlay} the matching overlay or null if none found.
          */
          getOverlayById: function(L) {
            var te;
            return L = n.getElement(L), te = f(this.currentOverlays, L), te >= 0 ? this.currentOverlays[te] : null;
          },
          /**
           * Updates the sequence buttons.
           * @function OpenSeadragon.Viewer.prototype._updateSequenceButtons
           * @private
           * @param {Number} Sequence Value
           */
          _updateSequenceButtons: function(L) {
            this.nextButton && (!this.tileSources || this.tileSources.length - 1 === L ? this.navPrevNextWrap || this.nextButton.disable() : this.nextButton.enable()), this.previousButton && (L > 0 ? this.previousButton.enable() : this.navPrevNextWrap || this.previousButton.disable());
          },
          /**
           * Display a message in the viewport
           * @function OpenSeadragon.Viewer.prototype._showMessage
           * @private
           * @param {String} text message
           */
          _showMessage: function(L) {
            this._hideMessage();
            var te = n.makeNeutralElement("div");
            te.appendChild(document.createTextNode(L)), this.messageDiv = n.makeCenteredNode(te), n.addClass(this.messageDiv, "openseadragon-message"), this.container.appendChild(this.messageDiv);
          },
          /**
           * Hide any currently displayed viewport message
           * @function OpenSeadragon.Viewer.prototype._hideMessage
           * @private
           */
          _hideMessage: function() {
            var L = this.messageDiv;
            L && (L.parentNode.removeChild(L), delete this.messageDiv);
          },
          /**
           * Gets this viewer's gesture settings for the given pointer device type.
           * @method
           * @param {String} type - The pointer device type to get the gesture settings for ("mouse", "touch", "pen", etc.).
           * @returns {OpenSeadragon.GestureSettings}
           */
          gestureSettingsByDeviceType: function(L) {
            switch (L) {
              case "mouse":
                return this.gestureSettingsMouse;
              case "touch":
                return this.gestureSettingsTouch;
              case "pen":
                return this.gestureSettingsPen;
              default:
                return this.gestureSettingsUnknown;
            }
          },
          // private
          _drawOverlays: function() {
            var L, te = this.currentOverlays.length;
            for (L = 0; L < te; L++)
              this.currentOverlays[L].drawHTML(this.overlaysContainer, this.viewport);
          },
          /**
           * Cancel the "in flight" images.
           */
          _cancelPendingImages: function() {
            this._loadQueue = [];
          },
          /**
           * Removes the reference strip and disables displaying it.
           * @function
           */
          removeReferenceStrip: function() {
            this.showReferenceStrip = !1, this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null);
          },
          /**
           * Enables and displays the reference strip based on the currently set tileSources.
           * Works only when the Viewer has sequenceMode set to true.
           * @function
           */
          addReferenceStrip: function() {
            if (this.showReferenceStrip = !0, this.sequenceMode) {
              if (this.referenceStrip)
                return;
              this.tileSources.length && this.tileSources.length > 1 && (this.referenceStrip = new n.ReferenceStrip({
                id: this.referenceStripElement,
                position: this.referenceStripPosition,
                sizeRatio: this.referenceStripSizeRatio,
                scroll: this.referenceStripScroll,
                height: this.referenceStripHeight,
                width: this.referenceStripWidth,
                tileSources: this.tileSources,
                prefixUrl: this.prefixUrl,
                viewer: this
              }), this.referenceStrip.setFocus(this._sequenceIndex));
            } else
              n.console.warn('Attempting to display a reference strip while "sequenceMode" is off.');
          },
          /**
           * Adds _updatePixelDensityRatio to the window resize event.
           * @private
           */
          _addUpdatePixelDensityRatioEvent: function() {
            this._updatePixelDensityRatioBind = this._updatePixelDensityRatio.bind(this), n.addEvent(window, "resize", this._updatePixelDensityRatioBind);
          },
          /**
           * Removes _updatePixelDensityRatio from the window resize event.
           * @private
           */
          _removeUpdatePixelDensityRatioEvent: function() {
            n.removeEvent(window, "resize", this._updatePixelDensityRatioBind);
          },
          /**
           * Update pixel density ratio and forces a resize operation.
           * @private
           */
          _updatePixelDensityRatio: function() {
            var L = n.pixelDensityRatio, te = n.getCurrentPixelDensityRatio();
            L !== te && (n.pixelDensityRatio = te, this.forceResize());
          },
          /**
           * Sets the image source to the source with index equal to
           * currentIndex - 1. Changes current image in sequence mode.
           * If specified, wraps around (see navPrevNextWrap in
           * {@link OpenSeadragon.Options})
           *
           * @method
           */
          goToPreviousPage: function() {
            var L = this._sequenceIndex - 1;
            this.navPrevNextWrap && L < 0 && (L += this.tileSources.length), this.goToPage(L);
          },
          /**
           * Sets the image source to the source with index equal to
           * currentIndex + 1. Changes current image in sequence mode.
           * If specified, wraps around (see navPrevNextWrap in
           * {@link OpenSeadragon.Options})
           *
           * @method
           */
          goToNextPage: function() {
            var L = this._sequenceIndex + 1;
            this.navPrevNextWrap && L >= this.tileSources.length && (L = 0), this.goToPage(L);
          },
          isAnimating: function() {
            return r[this.hash].animating;
          }
        }
      );
      function o(L) {
        return L = n.getElement(L), new n.Point(
          L.clientWidth === 0 ? 1 : L.clientWidth,
          L.clientHeight === 0 ? 1 : L.clientHeight
        );
      }
      function s(L, te, ge, ke, We) {
        var Be = L;
        if (n.type(te) === "string") {
          if (te.match(/^\s*<.*>\s*$/))
            te = n.parseXml(te);
          else if (te.match(/^\s*[{[].*[}\]]\s*$/))
            try {
              var je = n.parseJSON(te);
              te = je;
            } catch {
            }
        }
        function mt(qe, at) {
          qe.ready ? ke(qe) : (qe.addHandler("ready", function() {
            ke(qe);
          }), qe.addHandler("open-failed", function(et) {
            We({
              message: et.message,
              source: at
            });
          }));
        }
        setTimeout(function() {
          if (n.type(te) === "string")
            te = new n.TileSource({
              url: te,
              crossOriginPolicy: ge.crossOriginPolicy !== void 0 ? ge.crossOriginPolicy : L.crossOriginPolicy,
              ajaxWithCredentials: L.ajaxWithCredentials,
              ajaxHeaders: ge.ajaxHeaders ? ge.ajaxHeaders : L.ajaxHeaders,
              splitHashDataForPost: L.splitHashDataForPost,
              success: function(bt) {
                ke(bt.tileSource);
              }
            }), te.addHandler("open-failed", function(bt) {
              We(bt);
            });
          else if (n.isPlainObject(te) || te.nodeType)
            if (te.crossOriginPolicy === void 0 && (ge.crossOriginPolicy !== void 0 || L.crossOriginPolicy !== void 0) && (te.crossOriginPolicy = ge.crossOriginPolicy !== void 0 ? ge.crossOriginPolicy : L.crossOriginPolicy), te.ajaxWithCredentials === void 0 && (te.ajaxWithCredentials = L.ajaxWithCredentials), n.isFunction(te.getTileUrl)) {
              var qe = new n.TileSource(te);
              qe.getTileUrl = te.getTileUrl, ke(qe);
            } else {
              var at = n.TileSource.determineType(Be, te);
              if (!at) {
                We({
                  message: "Unable to load TileSource",
                  source: te
                });
                return;
              }
              var et = at.prototype.configure.apply(Be, [te]);
              mt(new at(et), te);
            }
          else
            mt(te, te);
        });
      }
      function u(L, te) {
        if (te instanceof n.Overlay)
          return te;
        var ge = null;
        if (te.element)
          ge = n.getElement(te.element);
        else {
          var ke = te.id ? te.id : "openseadragon-overlay-" + Math.floor(Math.random() * 1e7);
          ge = n.getElement(te.id), ge || (ge = document.createElement("a"), ge.href = "#/overlay/" + ke), ge.id = ke, n.addClass(
            ge,
            te.className ? te.className : "openseadragon-overlay"
          );
        }
        var We = te.location, Be = te.width, je = te.height;
        if (!We) {
          var mt = te.x, qe = te.y;
          if (te.px !== void 0) {
            var at = L.viewport.imageToViewportRectangle(new n.Rect(
              te.px,
              te.py,
              Be || 0,
              je || 0
            ));
            mt = at.x, qe = at.y, Be = Be !== void 0 ? at.width : void 0, je = je !== void 0 ? at.height : void 0;
          }
          We = new n.Point(mt, qe);
        }
        var et = te.placement;
        return et && n.type(et) === "string" && (et = n.Placement[te.placement.toUpperCase()]), new n.Overlay({
          element: ge,
          location: We,
          placement: et,
          onDraw: te.onDraw,
          checkResize: te.checkResize,
          width: Be,
          height: je,
          rotationMode: te.rotationMode
        });
      }
      function f(L, te) {
        var ge;
        for (ge = L.length - 1; ge >= 0; ge--)
          if (L[ge].element === te)
            return ge;
        return -1;
      }
      function p(L, te) {
        return n.requestAnimationFrame(function() {
          te(L);
        });
      }
      function m(L) {
        n.requestAnimationFrame(function() {
          y(L);
        });
      }
      function v(L) {
        L.autoHideControls && (L.controlsShouldFade = !0, L.controlsFadeBeginTime = n.now() + L.controlsFadeDelay, window.setTimeout(function() {
          m(L);
        }, L.controlsFadeDelay));
      }
      function y(L) {
        var te, ge, ke, We;
        if (L.controlsShouldFade) {
          for (te = n.now(), ge = te - L.controlsFadeBeginTime, ke = 1 - ge / L.controlsFadeLength, ke = Math.min(1, ke), ke = Math.max(0, ke), We = L.controls.length - 1; We >= 0; We--)
            L.controls[We].autoFade && L.controls[We].setOpacity(ke);
          ke > 0 && m(L);
        }
      }
      function S(L) {
        var te;
        for (L.controlsShouldFade = !1, te = L.controls.length - 1; te >= 0; te--)
          L.controls[te].setOpacity(1);
      }
      function E() {
        S(this);
      }
      function w() {
        v(this);
      }
      function _(L) {
        var te = {
          tracker: L.eventSource,
          position: L.position,
          originalEvent: L.originalEvent,
          preventDefault: L.preventDefault
        };
        this.raiseEvent("canvas-contextmenu", te), L.preventDefault = te.preventDefault;
      }
      function O(L) {
        var te = {
          originalEvent: L.originalEvent,
          preventDefaultAction: !1,
          preventVerticalPan: L.preventVerticalPan || !this.panVertical,
          preventHorizontalPan: L.preventHorizontalPan || !this.panHorizontal
        };
        if (this.raiseEvent("canvas-key", te), !te.preventDefaultAction && !L.ctrl && !L.alt && !L.meta)
          switch (L.keyCode) {
            case 38:
              te.preventVerticalPan || (L.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(0, -this.pixelsPerArrowPress))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 40:
              te.preventVerticalPan || (L.shift ? this.viewport.zoomBy(0.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(0, this.pixelsPerArrowPress))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 37:
              te.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(-this.pixelsPerArrowPress, 0))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 39:
              te.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(this.pixelsPerArrowPress, 0))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 187:
              this.viewport.zoomBy(1.1), this.viewport.applyConstraints(), L.preventDefault = !0;
              break;
            case 189:
              this.viewport.zoomBy(0.9), this.viewport.applyConstraints(), L.preventDefault = !0;
              break;
            case 48:
              this.viewport.goHome(), this.viewport.applyConstraints(), L.preventDefault = !0;
              break;
            case 87:
              te.preventVerticalPan || (L.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(0, -40))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 83:
              te.preventVerticalPan || (L.shift ? this.viewport.zoomBy(0.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(0, 40))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 65:
              te.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(-40, 0))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 68:
              te.preventHorizontalPan || (this.viewport.panBy(this.viewport.deltaPointsFromPixels(new n.Point(40, 0))), this.viewport.applyConstraints()), L.preventDefault = !0;
              break;
            case 82:
              L.shift ? this.viewport.flipped ? this.viewport.setRotation(this.viewport.getRotation() + this.rotationIncrement) : this.viewport.setRotation(this.viewport.getRotation() - this.rotationIncrement) : this.viewport.flipped ? this.viewport.setRotation(this.viewport.getRotation() - this.rotationIncrement) : this.viewport.setRotation(this.viewport.getRotation() + this.rotationIncrement), this.viewport.applyConstraints(), L.preventDefault = !0;
              break;
            case 70:
              this.viewport.toggleFlip(), L.preventDefault = !0;
              break;
            case 74:
              this.goToPreviousPage();
              break;
            case 75:
              this.goToNextPage();
              break;
            default:
              L.preventDefault = !1;
              break;
          }
        else
          L.preventDefault = !1;
      }
      function D(L) {
        var te = {
          originalEvent: L.originalEvent
        };
        this.raiseEvent("canvas-key-press", te);
      }
      function P(L) {
        var te, ge = document.activeElement === this.canvas;
        ge || this.canvas.focus(), this.viewport.flipped && (L.position.x = this.viewport.getContainerSize().x - L.position.x);
        var ke = {
          tracker: L.eventSource,
          position: L.position,
          quick: L.quick,
          shift: L.shift,
          originalEvent: L.originalEvent,
          originalTarget: L.originalTarget,
          preventDefaultAction: !1
        };
        this.raiseEvent("canvas-click", ke), !ke.preventDefaultAction && this.viewport && L.quick && (te = this.gestureSettingsByDeviceType(L.pointerType), te.clickToZoom === !0 && (this.viewport.zoomBy(
          L.shift ? 1 / this.zoomPerClick : this.zoomPerClick,
          te.zoomToRefPoint ? this.viewport.pointFromPixel(L.position, !0) : null
        ), this.viewport.applyConstraints()), te.dblClickDragToZoom && (r[this.hash].draggingToZoom === !0 ? (r[this.hash].lastClickTime = null, r[this.hash].draggingToZoom = !1) : r[this.hash].lastClickTime = n.now()));
      }
      function M(L) {
        var te, ge = {
          tracker: L.eventSource,
          position: L.position,
          shift: L.shift,
          originalEvent: L.originalEvent,
          preventDefaultAction: !1
        };
        this.raiseEvent("canvas-double-click", ge), !ge.preventDefaultAction && this.viewport && (te = this.gestureSettingsByDeviceType(L.pointerType), te.dblClickToZoom && (this.viewport.zoomBy(
          L.shift ? 1 / this.zoomPerClick : this.zoomPerClick,
          te.zoomToRefPoint ? this.viewport.pointFromPixel(L.position, !0) : null
        ), this.viewport.applyConstraints()));
      }
      function N(L) {
        var te, ge = {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          delta: L.delta,
          speed: L.speed,
          direction: L.direction,
          shift: L.shift,
          originalEvent: L.originalEvent,
          preventDefaultAction: !1
        };
        if (this.raiseEvent("canvas-drag", ge), te = this.gestureSettingsByDeviceType(L.pointerType), !ge.preventDefaultAction && this.viewport) {
          if (te.dblClickDragToZoom && r[this.hash].draggingToZoom) {
            var ke = Math.pow(this.zoomPerDblClickDrag, L.delta.y / 50);
            this.viewport.zoomBy(ke);
          } else if (te.dragToPan && !r[this.hash].draggingToZoom) {
            if (this.panHorizontal || (L.delta.x = 0), this.panVertical || (L.delta.y = 0), this.viewport.flipped && (L.delta.x = -L.delta.x), this.constrainDuringPan) {
              var We = this.viewport.deltaPointsFromPixels(L.delta.negate());
              this.viewport.centerSpringX.target.value += We.x, this.viewport.centerSpringY.target.value += We.y;
              var Be = this.viewport.getConstrainedBounds();
              this.viewport.centerSpringX.target.value -= We.x, this.viewport.centerSpringY.target.value -= We.y, Be.xConstrained && (L.delta.x = 0), Be.yConstrained && (L.delta.y = 0);
            }
            this.viewport.panBy(this.viewport.deltaPointsFromPixels(L.delta.negate()), te.flickEnabled && !this.constrainDuringPan);
          }
        }
      }
      function k(L) {
        var te, ge = {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          speed: L.speed,
          direction: L.direction,
          shift: L.shift,
          originalEvent: L.originalEvent,
          preventDefaultAction: !1
        };
        if (this.raiseEvent("canvas-drag-end", ge), te = this.gestureSettingsByDeviceType(L.pointerType), !ge.preventDefaultAction && this.viewport) {
          if (!r[this.hash].draggingToZoom && te.dragToPan && te.flickEnabled && L.speed >= te.flickMinSpeed) {
            var ke = 0;
            this.panHorizontal && (ke = te.flickMomentum * L.speed * Math.cos(L.direction));
            var We = 0;
            this.panVertical && (We = te.flickMomentum * L.speed * Math.sin(L.direction));
            var Be = this.viewport.pixelFromPoint(
              this.viewport.getCenter(!0)
            ), je = this.viewport.pointFromPixel(
              new n.Point(Be.x - ke, Be.y - We)
            );
            this.viewport.panTo(je, !1);
          }
          this.viewport.applyConstraints();
        }
        te.dblClickDragToZoom && r[this.hash].draggingToZoom === !0 && (r[this.hash].draggingToZoom = !1);
      }
      function U(L) {
        this.raiseEvent("canvas-enter", {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          buttons: L.buttons,
          pointers: L.pointers,
          insideElementPressed: L.insideElementPressed,
          buttonDownAny: L.buttonDownAny,
          originalEvent: L.originalEvent
        });
      }
      function H(L) {
        this.raiseEvent("canvas-exit", {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          buttons: L.buttons,
          pointers: L.pointers,
          insideElementPressed: L.insideElementPressed,
          buttonDownAny: L.buttonDownAny,
          originalEvent: L.originalEvent
        });
      }
      function Y(L) {
        var te;
        if (this.raiseEvent("canvas-press", {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          insideElementPressed: L.insideElementPressed,
          insideElementReleased: L.insideElementReleased,
          originalEvent: L.originalEvent
        }), te = this.gestureSettingsByDeviceType(L.pointerType), te.dblClickDragToZoom) {
          var ge = r[this.hash].lastClickTime, ke = n.now();
          if (ge === null)
            return;
          ke - ge < this.dblClickTimeThreshold && (r[this.hash].draggingToZoom = !0), r[this.hash].lastClickTime = null;
        }
      }
      function z(L) {
        this.raiseEvent("canvas-release", {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          insideElementPressed: L.insideElementPressed,
          insideElementReleased: L.insideElementReleased,
          originalEvent: L.originalEvent
        });
      }
      function V(L) {
        this.raiseEvent("canvas-nonprimary-press", {
          tracker: L.eventSource,
          position: L.position,
          pointerType: L.pointerType,
          button: L.button,
          buttons: L.buttons,
          originalEvent: L.originalEvent
        });
      }
      function F(L) {
        this.raiseEvent("canvas-nonprimary-release", {
          tracker: L.eventSource,
          position: L.position,
          pointerType: L.pointerType,
          button: L.button,
          buttons: L.buttons,
          originalEvent: L.originalEvent
        });
      }
      function X(L) {
        var te, ge, ke, We, Be = {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          gesturePoints: L.gesturePoints,
          lastCenter: L.lastCenter,
          center: L.center,
          lastDistance: L.lastDistance,
          distance: L.distance,
          shift: L.shift,
          originalEvent: L.originalEvent,
          preventDefaultPanAction: !1,
          preventDefaultZoomAction: !1,
          preventDefaultRotateAction: !1
        };
        if (this.raiseEvent("canvas-pinch", Be), this.viewport && (te = this.gestureSettingsByDeviceType(L.pointerType), te.pinchToZoom && (!Be.preventDefaultPanAction || !Be.preventDefaultZoomAction) && (ge = this.viewport.pointFromPixel(L.center, !0), te.zoomToRefPoint && !Be.preventDefaultPanAction && (ke = this.viewport.pointFromPixel(L.lastCenter, !0), We = ke.minus(ge), this.panHorizontal || (We.x = 0), this.panVertical || (We.y = 0), this.viewport.panBy(We, !0)), Be.preventDefaultZoomAction || this.viewport.zoomBy(L.distance / L.lastDistance, ge, !0), this.viewport.applyConstraints()), te.pinchRotate && !Be.preventDefaultRotateAction)) {
          var je = Math.atan2(
            L.gesturePoints[0].currentPos.y - L.gesturePoints[1].currentPos.y,
            L.gesturePoints[0].currentPos.x - L.gesturePoints[1].currentPos.x
          ), mt = Math.atan2(
            L.gesturePoints[0].lastPos.y - L.gesturePoints[1].lastPos.y,
            L.gesturePoints[0].lastPos.x - L.gesturePoints[1].lastPos.x
          );
          ge = this.viewport.pointFromPixel(L.center, !0), this.viewport.rotateTo(this.viewport.getRotation(!0) + (je - mt) * (180 / Math.PI), ge, !0);
        }
      }
      function oe(L) {
        this.raiseEvent("canvas-focus", {
          tracker: L.eventSource,
          originalEvent: L.originalEvent
        });
      }
      function re(L) {
        this.raiseEvent("canvas-blur", {
          tracker: L.eventSource,
          originalEvent: L.originalEvent
        });
      }
      function Z(L) {
        var te, ge, ke, We, Be;
        We = n.now(), Be = We - this._lastScrollTime, Be > this.minScrollDeltaTime ? (this._lastScrollTime = We, te = {
          tracker: L.eventSource,
          position: L.position,
          scroll: L.scroll,
          shift: L.shift,
          originalEvent: L.originalEvent,
          preventDefaultAction: !1,
          preventDefault: !0
        }, this.raiseEvent("canvas-scroll", te), !te.preventDefaultAction && this.viewport && (this.viewport.flipped && (L.position.x = this.viewport.getContainerSize().x - L.position.x), ge = this.gestureSettingsByDeviceType(L.pointerType), ge.scrollToZoom && (ke = Math.pow(this.zoomPerScroll, L.scroll), this.viewport.zoomBy(
          ke,
          ge.zoomToRefPoint ? this.viewport.pointFromPixel(L.position, !0) : null
        ), this.viewport.applyConstraints())), L.preventDefault = te.preventDefault) : L.preventDefault = !0;
      }
      function ee(L) {
        r[this.hash].mouseInside = !0, S(this), this.raiseEvent("container-enter", {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          buttons: L.buttons,
          pointers: L.pointers,
          insideElementPressed: L.insideElementPressed,
          buttonDownAny: L.buttonDownAny,
          originalEvent: L.originalEvent
        });
      }
      function J(L) {
        L.pointers < 1 && (r[this.hash].mouseInside = !1, r[this.hash].animating || v(this)), this.raiseEvent("container-exit", {
          tracker: L.eventSource,
          pointerType: L.pointerType,
          position: L.position,
          buttons: L.buttons,
          pointers: L.pointers,
          insideElementPressed: L.insideElementPressed,
          buttonDownAny: L.buttonDownAny,
          originalEvent: L.originalEvent
        });
      }
      function le(L) {
        ne(L), L.isOpen() ? L._updateRequestId = p(L, le) : L._updateRequestId = !1;
      }
      function be(L, te) {
        var ge = L.viewport, ke = ge.getZoom(), We = ge.getCenter();
        ge.resize(te, L.preserveImageSizeOnResize), ge.panTo(We, !0);
        var Be;
        if (L.preserveImageSizeOnResize)
          Be = r[L.hash].prevContainerSize.x / te.x;
        else {
          var je = new n.Point(0, 0), mt = new n.Point(r[L.hash].prevContainerSize.x, r[L.hash].prevContainerSize.y).distanceTo(je), qe = new n.Point(te.x, te.y).distanceTo(je);
          Be = qe / mt * r[L.hash].prevContainerSize.x / te.x;
        }
        ge.zoomTo(ke * Be, null, !0), r[L.hash].prevContainerSize = te, r[L.hash].forceRedraw = !0, r[L.hash].needsResize = !1, r[L.hash].forceResize = !1;
      }
      function ne(L) {
        if (!(L._opening || !r[L.hash])) {
          if (L.autoResize || r[L.hash].forceResize) {
            var te;
            if (L._autoResizePolling) {
              te = o(L.container);
              var ge = r[L.hash].prevContainerSize;
              te.equals(ge) || (r[L.hash].needsResize = !0);
            }
            r[L.hash].needsResize && be(L, te || o(L.container));
          }
          var ke = L.viewport.update(), We = L.world.update(ke) || ke;
          ke && L.raiseEvent("viewport-change"), L.referenceStrip && (We = L.referenceStrip.update(L.viewport) || We);
          var Be = r[L.hash].animating;
          !Be && We && (L.raiseEvent("animation-start"), S(L));
          var je = Be && !We;
          je && (r[L.hash].animating = !1), (We || je || r[L.hash].forceRedraw || L.world.needsDraw()) && (ae(L), L._drawOverlays(), L.navigator && L.navigator.update(L.viewport), r[L.hash].forceRedraw = !1, We && L.raiseEvent("animation")), je && (L.raiseEvent("animation-finish"), r[L.hash].mouseInside || v(L)), r[L.hash].animating = We;
        }
      }
      function ae(L) {
        L.imageLoader.clear(), L.world.draw(), L.raiseEvent("update-viewport", {});
      }
      function ie(L, te) {
        return L ? L + te : te;
      }
      function he() {
        r[this.hash].lastZoomTime = n.now(), r[this.hash].zoomFactor = this.zoomPerSecond, r[this.hash].zooming = !0, Ee(this);
      }
      function pe() {
        r[this.hash].lastZoomTime = n.now(), r[this.hash].zoomFactor = 1 / this.zoomPerSecond, r[this.hash].zooming = !0, Ee(this);
      }
      function me() {
        r[this.hash].zooming = !1;
      }
      function Ee(L) {
        n.requestAnimationFrame(n.delegate(L, Ie));
      }
      function Ie() {
        var L, te, ge;
        r[this.hash].zooming && this.viewport && (L = n.now(), te = L - r[this.hash].lastZoomTime, ge = Math.pow(r[this.hash].zoomFactor, te / 1e3), this.viewport.zoomBy(ge), this.viewport.applyConstraints(), r[this.hash].lastZoomTime = L, Ee(this));
      }
      function Pe() {
        this.viewport && (r[this.hash].zooming = !1, this.viewport.zoomBy(
          this.zoomPerClick / 1
        ), this.viewport.applyConstraints());
      }
      function De() {
        this.viewport && (r[this.hash].zooming = !1, this.viewport.zoomBy(
          1 / this.zoomPerClick
        ), this.viewport.applyConstraints());
      }
      function Ye() {
        this.buttonGroup && (this.buttonGroup.emulateEnter(), this.buttonGroup.emulateLeave());
      }
      function Ue() {
        this.viewport && this.viewport.goHome();
      }
      function ve() {
        this.isFullPage() && !n.isFullScreen() ? this.setFullPage(!1) : this.setFullScreen(!this.isFullPage()), this.buttonGroup && this.buttonGroup.emulateLeave(), this.fullPageButton.element.focus(), this.viewport && this.viewport.applyConstraints();
      }
      function rt() {
        if (this.viewport) {
          var L = this.viewport.getRotation();
          this.viewport.flipped ? L += this.rotationIncrement : L -= this.rotationIncrement, this.viewport.setRotation(L);
        }
      }
      function Te() {
        if (this.viewport) {
          var L = this.viewport.getRotation();
          this.viewport.flipped ? L -= this.rotationIncrement : L += this.rotationIncrement, this.viewport.setRotation(L);
        }
      }
      function Je() {
        this.viewport.toggleFlip();
      }
      n.determineDrawer = function(L) {
        for (let te in t) {
          const ge = t[te], ke = ge.prototype;
          if (ke && ke instanceof t.DrawerBase && n.isFunction(ke.getType) && ke.getType.call(ge) === L)
            return ge;
        }
        return null;
      };
    })(t), (function(n) {
      n.Navigator = function(p) {
        var m = p.viewer, v = this, y, S;
        p.element || p.id ? (p.element ? (p.id && n.console.warn("Given option.id for Navigator was ignored since option.element was provided and is being used instead."), p.element.id ? p.id = p.element.id : p.id = "navigator-" + n.now(), this.element = p.element) : this.element = document.getElementById(p.id), p.controlOptions = {
          anchor: n.ControlAnchor.NONE,
          attachToViewer: !1,
          autoFade: !1
        }) : (p.id = "navigator-" + n.now(), this.element = n.makeNeutralElement("div"), p.controlOptions = {
          anchor: n.ControlAnchor.TOP_RIGHT,
          attachToViewer: !0,
          autoFade: p.autoFade
        }, p.position && (p.position === "BOTTOM_RIGHT" ? p.controlOptions.anchor = n.ControlAnchor.BOTTOM_RIGHT : p.position === "BOTTOM_LEFT" ? p.controlOptions.anchor = n.ControlAnchor.BOTTOM_LEFT : p.position === "TOP_RIGHT" ? p.controlOptions.anchor = n.ControlAnchor.TOP_RIGHT : p.position === "TOP_LEFT" ? p.controlOptions.anchor = n.ControlAnchor.TOP_LEFT : p.position === "ABSOLUTE" && (p.controlOptions.anchor = n.ControlAnchor.ABSOLUTE, p.controlOptions.top = p.top, p.controlOptions.left = p.left, p.controlOptions.height = p.height, p.controlOptions.width = p.width))), this.element.id = p.id, this.element.className += " navigator", p = n.extend(!0, {
          sizeRatio: n.DEFAULT_SETTINGS.navigatorSizeRatio
        }, p, {
          element: this.element,
          tabIndex: -1,
          // No keyboard navigation, omit from tab order
          //These need to be overridden to prevent recursion since
          //the navigator is a viewer and a viewer has a navigator
          showNavigator: !1,
          mouseNavEnabled: !1,
          showNavigationControl: !1,
          showSequenceControl: !1,
          immediateRender: !0,
          blendTime: 0,
          animationTime: p.animationTime,
          // disable autoResize since resize behavior is implemented differently by the navigator
          autoResize: !1,
          // prevent resizing the navigator from adding unwanted space around the image
          minZoomImageRatio: 1,
          background: p.background,
          opacity: p.opacity,
          borderColor: p.borderColor,
          displayRegionColor: p.displayRegionColor
        }), p.minPixelRatio = this.minPixelRatio = m.minPixelRatio, n.setElementTouchActionNone(this.element), this.borderWidth = 2, this.fudge = new n.Point(1, 1), this.totalBorderWidths = new n.Point(this.borderWidth * 2, this.borderWidth * 2).minus(this.fudge), p.controlOptions.anchor !== n.ControlAnchor.NONE && (function(_, O) {
          _.margin = "0px", _.border = O + "px solid " + p.borderColor, _.padding = "0px", _.background = p.background, _.opacity = p.opacity, _.overflow = "hidden";
        })(this.element.style, this.borderWidth), this.displayRegion = n.makeNeutralElement("div"), this.displayRegion.id = this.element.id + "-displayregion", this.displayRegion.className = "displayregion", (function(_, O) {
          _.position = "relative", _.top = "0px", _.left = "0px", _.fontSize = "0px", _.overflow = "hidden", _.border = O + "px solid " + p.displayRegionColor, _.margin = "0px", _.padding = "0px", _.background = "transparent", _.float = "left", _.cssFloat = "left", _.zIndex = 999999999, _.cursor = "default", _.boxSizing = "content-box";
        })(this.displayRegion.style, this.borderWidth), n.setElementPointerEventsNone(this.displayRegion), n.setElementTouchActionNone(this.displayRegion), this.displayRegionContainer = n.makeNeutralElement("div"), this.displayRegionContainer.id = this.element.id + "-displayregioncontainer", this.displayRegionContainer.className = "displayregioncontainer", this.displayRegionContainer.style.width = "100%", this.displayRegionContainer.style.height = "100%", n.setElementPointerEventsNone(this.displayRegionContainer), n.setElementTouchActionNone(this.displayRegionContainer), m.addControl(
          this.element,
          p.controlOptions
        ), this._resizeWithViewer = p.controlOptions.anchor !== n.ControlAnchor.ABSOLUTE && p.controlOptions.anchor !== n.ControlAnchor.NONE, p.width && p.height ? (this.setWidth(p.width), this.setHeight(p.height)) : this._resizeWithViewer && (y = n.getElementSize(m.element), this.element.style.height = Math.round(y.y * p.sizeRatio) + "px", this.element.style.width = Math.round(y.x * p.sizeRatio) + "px", this.oldViewerSize = y, S = n.getElementSize(this.element), this.elementArea = S.x * S.y), this.oldContainerSize = new n.Point(0, 0), n.Viewer.apply(this, [p]), this.displayRegionContainer.appendChild(this.displayRegion), this.element.getElementsByTagName("div")[0].appendChild(this.displayRegionContainer);
        function E(_, O) {
          u(v.displayRegionContainer, _), u(v.displayRegion, -_), v.viewport.setRotation(_, O);
        }
        if (p.navigatorRotate) {
          var w = p.viewer.viewport ? p.viewer.viewport.getRotation() : p.viewer.degrees || 0;
          E(w, !0), p.viewer.addHandler("rotate", function(_) {
            E(_.degrees, _.immediately);
          });
        }
        this.innerTracker.destroy(), this.innerTracker = new n.MouseTracker({
          userData: "Navigator.innerTracker",
          element: this.element,
          //this.canvas,
          dragHandler: n.delegate(this, i),
          clickHandler: n.delegate(this, r),
          releaseHandler: n.delegate(this, o),
          scrollHandler: n.delegate(this, s),
          preProcessEventHandler: function(_) {
            _.eventType === "wheel" && (_.preventDefault = !0);
          }
        }), this.outerTracker.userData = "Navigator.outerTracker", n.setElementPointerEventsNone(this.canvas), n.setElementPointerEventsNone(this.container), this.addHandler("reset-size", function() {
          v.viewport && v.viewport.goHome(!0);
        }), m.world.addHandler("item-index-change", function(_) {
          window.setTimeout(function() {
            var O = v.world.getItemAt(_.previousIndex);
            v.world.setItemIndex(O, _.newIndex);
          }, 1);
        }), m.world.addHandler("remove-item", function(_) {
          var O = _.item, D = v._getMatchingItem(O);
          D && v.world.removeItem(D);
        }), this.update(m.viewport);
      }, n.extend(
        n.Navigator.prototype,
        n.EventSource.prototype,
        n.Viewer.prototype,
        /** @lends OpenSeadragon.Navigator.prototype */
        {
          /**
           * Used to notify the navigator when its size has changed.
           * Especially useful when {@link OpenSeadragon.Options}.navigatorAutoResize is set to false and the navigator is resizable.
           * @function
           */
          updateSize: function() {
            if (this.viewport) {
              var p = new n.Point(
                this.container.clientWidth === 0 ? 1 : this.container.clientWidth,
                this.container.clientHeight === 0 ? 1 : this.container.clientHeight
              );
              p.equals(this.oldContainerSize) || (this.viewport.resize(p, !0), this.viewport.goHome(!0), this.oldContainerSize = p, this.world.update(), this.world.draw(), this.update(this.viewer.viewport));
            }
          },
          /**
           * Explicitly sets the width of the navigator, in web coordinates. Disables automatic resizing.
           * @param {Number|String} width - the new width, either a number of pixels or a CSS string, such as "100%"
           */
          setWidth: function(p) {
            this.width = p, this.element.style.width = typeof p == "number" ? p + "px" : p, this._resizeWithViewer = !1, this.updateSize();
          },
          /**
           * Explicitly sets the height of the navigator, in web coordinates. Disables automatic resizing.
           * @param {Number|String} height - the new height, either a number of pixels or a CSS string, such as "100%"
           */
          setHeight: function(p) {
            this.height = p, this.element.style.height = typeof p == "number" ? p + "px" : p, this._resizeWithViewer = !1, this.updateSize();
          },
          /**
            * Flip navigator element
            * @param {Boolean} state - Flip state to set.
            */
          setFlip: function(p) {
            return this.viewport.setFlip(p), this.setDisplayTransform(this.viewer.viewport.getFlip() ? "scale(-1,1)" : "scale(1,1)"), this;
          },
          setDisplayTransform: function(p) {
            f(this.canvas, p), f(this.element, p);
          },
          /**
           * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
           * @function
           * @param {OpenSeadragon.Viewport} [viewport] The viewport to display. Default: the viewport this navigator is tracking.
           */
          update: function(p) {
            var m, v, y, S, E, w;
            if (p || (p = this.viewer.viewport), m = n.getElementSize(this.viewer.element), this._resizeWithViewer && m.x && m.y && !m.equals(this.oldViewerSize) && (this.oldViewerSize = m, this.maintainSizeRatio || !this.elementArea ? (v = m.x * this.sizeRatio, y = m.y * this.sizeRatio) : (v = Math.sqrt(this.elementArea * (m.x / m.y)), y = this.elementArea / v), this.element.style.width = Math.round(v) + "px", this.element.style.height = Math.round(y) + "px", this.elementArea || (this.elementArea = v * y), this.updateSize()), p && this.viewport) {
              if (S = p.getBoundsNoRotate(!0), E = this.viewport.pixelFromPointNoRotate(S.getTopLeft(), !1), w = this.viewport.pixelFromPointNoRotate(S.getBottomRight(), !1).minus(this.totalBorderWidths), !this.navigatorRotate) {
                var _ = p.getRotation(!0);
                u(this.displayRegion, -_);
              }
              var O = this.displayRegion.style;
              O.display = this.world.getItemCount() ? "block" : "none", O.top = E.y.toFixed(2) + "px", O.left = E.x.toFixed(2) + "px";
              var D = w.x - E.x, P = w.y - E.y;
              O.width = Math.round(Math.max(D, 0)) + "px", O.height = Math.round(Math.max(P, 0)) + "px";
            }
          },
          // overrides Viewer.addTiledImage
          addTiledImage: function(p) {
            var m = this, v = p.originalTiledImage;
            delete p.original;
            var y = n.extend({}, p, {
              success: function(S) {
                var E = S.item;
                E._originalForNavigator = v, m._matchBounds(E, v, !0), m._matchOpacity(E, v), m._matchCompositeOperation(E, v);
                function w() {
                  m._matchBounds(E, v);
                }
                function _() {
                  m._matchOpacity(E, v);
                }
                function O() {
                  m._matchCompositeOperation(E, v);
                }
                v.addHandler("bounds-change", w), v.addHandler("clip-change", w), v.addHandler("opacity-change", _), v.addHandler("composite-operation-change", O);
              }
            });
            return n.Viewer.prototype.addTiledImage.apply(this, [y]);
          },
          destroy: function() {
            return n.Viewer.prototype.destroy.apply(this);
          },
          // private
          _getMatchingItem: function(p) {
            for (var m = this.world.getItemCount(), v, y = 0; y < m; y++)
              if (v = this.world.getItemAt(y), v._originalForNavigator === p)
                return v;
            return null;
          },
          // private
          _matchBounds: function(p, m, v) {
            var y = m.getBoundsNoRotate();
            p.setPosition(y.getTopLeft(), v), p.setWidth(y.width, v), p.setRotation(m.getRotation(), v), p.setClip(m.getClip()), p.setFlip(m.getFlip());
          },
          // private
          _matchOpacity: function(p, m) {
            p.setOpacity(m.opacity);
          },
          // private
          _matchCompositeOperation: function(p, m) {
            p.setCompositeOperation(m.compositeOperation);
          }
        }
      );
      function r(p) {
        var m = {
          tracker: p.eventSource,
          position: p.position,
          quick: p.quick,
          shift: p.shift,
          originalEvent: p.originalEvent,
          preventDefaultAction: !1
        };
        if (this.viewer.raiseEvent("navigator-click", m), !m.preventDefaultAction && p.quick && this.viewer.viewport && (this.panVertical || this.panHorizontal)) {
          this.viewer.viewport.flipped && (p.position.x = this.viewport.getContainerSize().x - p.position.x);
          var v = this.viewport.pointFromPixel(p.position);
          this.panVertical ? this.panHorizontal || (v.x = this.viewer.viewport.getCenter(!0).x) : v.y = this.viewer.viewport.getCenter(!0).y, this.viewer.viewport.panTo(v), this.viewer.viewport.applyConstraints();
        }
      }
      function i(p) {
        var m = {
          tracker: p.eventSource,
          position: p.position,
          delta: p.delta,
          speed: p.speed,
          direction: p.direction,
          shift: p.shift,
          originalEvent: p.originalEvent,
          preventDefaultAction: !1
        };
        this.viewer.raiseEvent("navigator-drag", m), !m.preventDefaultAction && this.viewer.viewport && (this.panHorizontal || (p.delta.x = 0), this.panVertical || (p.delta.y = 0), this.viewer.viewport.flipped && (p.delta.x = -p.delta.x), this.viewer.viewport.panBy(
          this.viewport.deltaPointsFromPixels(
            p.delta
          )
        ), this.viewer.constrainDuringPan && this.viewer.viewport.applyConstraints());
      }
      function o(p) {
        p.insideElementPressed && this.viewer.viewport && this.viewer.viewport.applyConstraints();
      }
      function s(p) {
        var m = {
          tracker: p.eventSource,
          position: p.position,
          scroll: p.scroll,
          shift: p.shift,
          originalEvent: p.originalEvent,
          preventDefault: p.preventDefault
        };
        this.viewer.raiseEvent("navigator-scroll", m), p.preventDefault = m.preventDefault;
      }
      function u(p, m) {
        f(p, "rotate(" + m + "deg)");
      }
      function f(p, m) {
        p.style.webkitTransform = m, p.style.mozTransform = m, p.style.msTransform = m, p.style.oTransform = m, p.style.transform = m;
      }
    })(t), (function(n) {
      var r = {
        Errors: {
          Dzc: "Sorry, we don't support Deep Zoom Collections!",
          Dzi: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
          Xml: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
          ImageFormat: "Sorry, we don't support {0}-based Deep Zoom Images.",
          Security: "It looks like a security restriction stopped us from loading this Deep Zoom Image.",
          Status: "This space unintentionally left blank ({0} {1}).",
          OpenFailed: "Unable to open {0}: {1}"
        },
        Tooltips: {
          FullPage: "Toggle full page",
          Home: "Go home",
          ZoomIn: "Zoom in",
          ZoomOut: "Zoom out",
          NextPage: "Next page",
          PreviousPage: "Previous page",
          RotateLeft: "Rotate left",
          RotateRight: "Rotate right",
          Flip: "Flip Horizontally"
        }
      };
      n.extend(
        n,
        /** @lends OpenSeadragon */
        {
          /**
           * @function
           * @param {String} property
           */
          getString: function(i) {
            var o = i.split("."), s = null, u = arguments, f = r, p;
            for (p = 0; p < o.length - 1; p++)
              f = f[o[p]] || {};
            return s = f[o[p]], typeof s != "string" && (n.console.error("Untranslated source string:", i), s = ""), s.replace(/\{\d+\}/g, function(m) {
              var v = parseInt(m.match(/\d+/), 10) + 1;
              return v < u.length ? u[v] : "";
            });
          },
          /**
           * @function
           * @param {String} property
           * @param {*} value
           */
          setString: function(i, o) {
            var s = i.split("."), u = r, f;
            for (f = 0; f < s.length - 1; f++)
              u[s[f]] || (u[s[f]] = {}), u = u[s[f]];
            u[s[f]] = o;
          }
        }
      );
    })(t), (function(n) {
      n.Point = function(r, i) {
        this.x = typeof r == "number" ? r : 0, this.y = typeof i == "number" ? i : 0;
      }, n.Point.prototype = {
        /**
         * @function
         * @returns {OpenSeadragon.Point} a duplicate of this Point
         */
        clone: function() {
          return new n.Point(this.x, this.y);
        },
        /**
         * Add another Point to this point and return a new Point.
         * @function
         * @param {OpenSeadragon.Point} point The point to add vector components.
         * @returns {OpenSeadragon.Point} A new point representing the sum of the
         *  vector components
         */
        plus: function(r) {
          return new n.Point(
            this.x + r.x,
            this.y + r.y
          );
        },
        /**
         * Subtract another Point to this point and return a new Point.
         * @function
         * @param {OpenSeadragon.Point} point The point to subtract vector components.
         * @returns {OpenSeadragon.Point} A new point representing the subtraction of the
         *  vector components
         */
        minus: function(r) {
          return new n.Point(
            this.x - r.x,
            this.y - r.y
          );
        },
        /**
         * Multiply this point by a factor and return a new Point.
         * @function
         * @param {Number} factor The factor to multiply vector components.
         * @returns {OpenSeadragon.Point} A new point representing the multiplication
         *  of the vector components by the factor
         */
        times: function(r) {
          return new n.Point(
            this.x * r,
            this.y * r
          );
        },
        /**
         * Divide this point by a factor and return a new Point.
         * @function
         * @param {Number} factor The factor to divide vector components.
         * @returns {OpenSeadragon.Point} A new point representing the division of the
         *  vector components by the factor
         */
        divide: function(r) {
          return new n.Point(
            this.x / r,
            this.y / r
          );
        },
        /**
         * Compute the opposite of this point and return a new Point.
         * @function
         * @returns {OpenSeadragon.Point} A new point representing the opposite of the
         *  vector components
         */
        negate: function() {
          return new n.Point(-this.x, -this.y);
        },
        /**
         * Compute the distance between this point and another point.
         * @function
         * @param {OpenSeadragon.Point} point The point to compute the distance with.
         * @returns {Number} The distance between the 2 points
         */
        distanceTo: function(r) {
          return Math.sqrt(
            Math.pow(this.x - r.x, 2) + Math.pow(this.y - r.y, 2)
          );
        },
        /**
         * Compute the squared distance between this point and another point.
         * Useful for optimizing things like comparing distances.
         * @function
         * @param {OpenSeadragon.Point} point The point to compute the squared distance with.
         * @returns {Number} The squared distance between the 2 points
         */
        squaredDistanceTo: function(r) {
          return Math.pow(this.x - r.x, 2) + Math.pow(this.y - r.y, 2);
        },
        /**
         * Apply a function to each coordinate of this point and return a new point.
         * @function
         * @param {function} func The function to apply to each coordinate.
         * @returns {OpenSeadragon.Point} A new point with the coordinates computed
         * by the specified function
         */
        apply: function(r) {
          return new n.Point(r(this.x), r(this.y));
        },
        /**
         * Check if this point is equal to another one.
         * @function
         * @param {OpenSeadragon.Point} point The point to compare this point with.
         * @returns {Boolean} true if they are equal, false otherwise.
         */
        equals: function(r) {
          return r instanceof n.Point && this.x === r.x && this.y === r.y;
        },
        /**
         * Rotates the point around the specified pivot
         * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
         * @function
         * @param {Number} degress to rotate around the pivot.
         * @param {OpenSeadragon.Point} [pivot=(0,0)] Point around which to rotate.
         * Defaults to the origin.
         * @returns {OpenSeadragon.Point}. A new point representing the point rotated around the specified pivot
         */
        rotate: function(r, i) {
          i = i || new n.Point(0, 0);
          var o, s;
          if (r % 90 === 0) {
            var u = n.positiveModulo(r, 360);
            switch (u) {
              case 0:
                o = 1, s = 0;
                break;
              case 90:
                o = 0, s = 1;
                break;
              case 180:
                o = -1, s = 0;
                break;
              case 270:
                o = 0, s = -1;
                break;
            }
          } else {
            var f = r * Math.PI / 180;
            o = Math.cos(f), s = Math.sin(f);
          }
          var p = o * (this.x - i.x) - s * (this.y - i.y) + i.x, m = s * (this.x - i.x) + o * (this.y - i.y) + i.y;
          return new n.Point(p, m);
        },
        /**
         * Convert this point to a string in the format (x,y) where x and y are
         * rounded to the nearest integer.
         * @function
         * @returns {String} A string representation of this point.
         */
        toString: function() {
          return "(" + Math.round(this.x * 100) / 100 + "," + Math.round(this.y * 100) / 100 + ")";
        }
      };
    })(t), (function(n) {
      n.TileSource = function(i, o, s, u, f, p) {
        var m = this, v = arguments, y, S;
        if (n.isPlainObject(i) ? y = i : y = {
          width: v[0],
          height: v[1],
          tileSize: v[2],
          tileOverlap: v[3],
          minLevel: v[4],
          maxLevel: v[5]
        }, n.EventSource.call(this), n.extend(!0, this, y), !this.success) {
          for (S = 0; S < arguments.length; S++)
            if (n.isFunction(arguments[S])) {
              this.success = arguments[S];
              break;
            }
        }
        this.success && this.addHandler("ready", function(E) {
          m.success(E);
        }), n.type(arguments[0]) === "string" && (this.url = arguments[0]), this.url ? (this.aspectRatio = 1, this.dimensions = new n.Point(10, 10), this._tileWidth = 0, this._tileHeight = 0, this.tileOverlap = 0, this.minLevel = 0, this.maxLevel = 0, this.ready = !1, this.getImageInfo(this.url)) : (this.ready = !0, this.aspectRatio = y.width && y.height ? y.width / y.height : 1, this.dimensions = new n.Point(y.width, y.height), this.tileSize ? (this._tileWidth = this._tileHeight = this.tileSize, delete this.tileSize) : (this.tileWidth ? (this._tileWidth = this.tileWidth, delete this.tileWidth) : this._tileWidth = 0, this.tileHeight ? (this._tileHeight = this.tileHeight, delete this.tileHeight) : this._tileHeight = 0), this.tileOverlap = y.tileOverlap ? y.tileOverlap : 0, this.minLevel = y.minLevel ? y.minLevel : 0, this.maxLevel = y.maxLevel !== void 0 && y.maxLevel !== null ? y.maxLevel : y.width && y.height ? Math.ceil(
          Math.log(Math.max(y.width, y.height)) / Math.log(2)
        ) : 0, this.success && n.isFunction(this.success) && this.success(this));
      }, n.TileSource.prototype = {
        getTileSize: function(i) {
          return n.console.error(
            "[TileSource.getTileSize] is deprecated. Use TileSource.getTileWidth() and TileSource.getTileHeight() instead"
          ), this._tileWidth;
        },
        /**
         * Return the tileWidth for a given level.
         * Subclasses should override this if tileWidth can be different at different levels
         *   such as in IIIFTileSource.  Code should use this function rather than reading
         *   from ._tileWidth directly.
         * @function
         * @param {Number} level
         */
        getTileWidth: function(i) {
          return this._tileWidth ? this._tileWidth : this.getTileSize(i);
        },
        /**
         * Return the tileHeight for a given level.
         * Subclasses should override this if tileHeight can be different at different levels
         *   such as in IIIFTileSource.  Code should use this function rather than reading
         *   from ._tileHeight directly.
         * @function
         * @param {Number} level
         */
        getTileHeight: function(i) {
          return this._tileHeight ? this._tileHeight : this.getTileSize(i);
        },
        /**
         * Set the maxLevel to the given level, and perform the memoization of
         * getLevelScale with the new maxLevel. This function can be useful if the
         * memoization is required before the first call of getLevelScale, or both
         * memoized getLevelScale and maxLevel should be changed accordingly.
         * @function
         * @param {Number} level
         */
        setMaxLevel: function(i) {
          this.maxLevel = i, this._memoizeLevelScale();
        },
        /**
         * @function
         * @param {Number} level
         */
        getLevelScale: function(i) {
          return this._memoizeLevelScale(), this.getLevelScale(i);
        },
        // private
        _memoizeLevelScale: function() {
          var i = {}, o;
          for (o = 0; o <= this.maxLevel; o++)
            i[o] = 1 / Math.pow(2, this.maxLevel - o);
          this.getLevelScale = function(s) {
            return i[s];
          };
        },
        /**
         * @function
         * @param {Number} level
         */
        getNumTiles: function(i) {
          var o = this.getLevelScale(i), s = Math.ceil(o * this.dimensions.x / this.getTileWidth(i)), u = Math.ceil(o * this.dimensions.y / this.getTileHeight(i));
          return new n.Point(s, u);
        },
        /**
         * @function
         * @param {Number} level
         */
        getPixelRatio: function(i) {
          var o = this.dimensions.times(this.getLevelScale(i)), s = 1 / o.x * n.pixelDensityRatio, u = 1 / o.y * n.pixelDensityRatio;
          return new n.Point(s, u);
        },
        /**
         * @function
         * @returns {Number} The highest level in this tile source that can be contained in a single tile.
         */
        getClosestLevel: function() {
          var i, o;
          for (i = this.minLevel + 1; i <= this.maxLevel && (o = this.getNumTiles(i), !(o.x > 1 || o.y > 1)); i++)
            ;
          return i - 1;
        },
        /**
         * @function
         * @param {Number} level
         * @param {OpenSeadragon.Point} point
         */
        getTileAtPoint: function(i, o) {
          var s = o.x >= 0 && o.x <= 1 && o.y >= 0 && o.y <= 1 / this.aspectRatio;
          n.console.assert(s, "[TileSource.getTileAtPoint] must be called with a valid point.");
          var u = this.dimensions.x * this.getLevelScale(i), f = o.x * u, p = o.y * u, m = Math.floor(f / this.getTileWidth(i)), v = Math.floor(p / this.getTileHeight(i));
          o.x >= 1 && (m = this.getNumTiles(i).x - 1);
          var y = 1e-15;
          return o.y >= 1 / this.aspectRatio - y && (v = this.getNumTiles(i).y - 1), new n.Point(m, v);
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         * @param {Boolean} [isSource=false] Whether to return the source bounds of the tile.
         * @returns {OpenSeadragon.Rect} Either where this tile fits (in normalized coordinates) or the
         * portion of the tile to use as the source of the drawing operation (in pixels), depending on
         * the isSource parameter.
         */
        getTileBounds: function(i, o, s, u) {
          var f = this.dimensions.times(this.getLevelScale(i)), p = this.getTileWidth(i), m = this.getTileHeight(i), v = o === 0 ? 0 : p * o - this.tileOverlap, y = s === 0 ? 0 : m * s - this.tileOverlap, S = p + (o === 0 ? 1 : 2) * this.tileOverlap, E = m + (s === 0 ? 1 : 2) * this.tileOverlap, w = 1 / f.x;
          return S = Math.min(S, f.x - v), E = Math.min(E, f.y - y), u ? new n.Rect(0, 0, S, E) : new n.Rect(v * w, y * w, S * w, E * w);
        },
        /**
         * Responsible for retrieving, and caching the
         * image metadata pertinent to this TileSources implementation.
         * @function
         * @param {String} url
         * @throws {Error}
         */
        getImageInfo: function(i) {
          var o = this, s, u, f, p, m, v, y;
          i && (m = i.split("/"), v = m[m.length - 1], y = v.lastIndexOf("."), y > -1 && (m[m.length - 1] = v.slice(0, y)));
          var S = null;
          if (this.splitHashDataForPost) {
            var E = i.indexOf("#");
            E !== -1 && (S = i.substring(E + 1), i = i.substr(0, E));
          }
          u = function(w) {
            typeof w == "string" && (w = n.parseXml(w));
            var _ = n.TileSource.determineType(o, w, i);
            if (!_) {
              o.raiseEvent("open-failed", { message: "Unable to load TileSource", source: i });
              return;
            }
            p = _.prototype.configure.apply(o, [w, i, S]), p.ajaxWithCredentials === void 0 && (p.ajaxWithCredentials = o.ajaxWithCredentials), f = new _(p), o.ready = !0, o.raiseEvent("ready", { tileSource: f });
          }, i.match(/\.js$/) ? (s = i.split("/").pop().replace(".js", ""), n.jsonp({
            url: i,
            async: !1,
            callbackName: s,
            callback: u
          })) : n.makeAjaxRequest({
            url: i,
            postData: S,
            withCredentials: this.ajaxWithCredentials,
            headers: this.ajaxHeaders,
            success: function(w) {
              var _ = r(w);
              u(_);
            },
            error: function(w, _) {
              var O;
              try {
                O = "HTTP " + w.status + " attempting to load TileSource: " + i;
              } catch {
                var D;
                typeof _ > "u" || !_.toString ? D = "Unknown error" : D = _.toString(), O = D + " attempting to load TileSource: " + i;
              }
              n.console.error(O), o.raiseEvent("open-failed", {
                message: O,
                source: i,
                postData: S
              });
            }
          });
        },
        /**
         * Responsible for determining if the particular TileSource supports the
         * data format ( and allowed to apply logic against the url the data was
         * loaded from, if any ). Overriding implementations are expected to do
         * something smart with data and / or url to determine support.  Also
         * understand that iteration order of TileSources is not guaranteed so
         * please make sure your data or url is expressive enough to ensure a simple
         * and sufficient mechanism for clear determination.
         * @function
         * @param {String|Object|Array|Document} data
         * @param {String} url - the url the data was loaded
         *      from if any.
         * @returns {Boolean}
         */
        supports: function(i, o) {
          return !1;
        },
        /**
         * Responsible for parsing and configuring the
         * image metadata pertinent to this TileSources implementation.
         * This method is not implemented by this class other than to throw an Error
         * announcing you have to implement it.  Because of the variety of tile
         * server technologies, and various specifications for building image
         * pyramids, this method is here to allow easy integration.
         * @function
         * @param {String|Object|Array|Document} data
         * @param {String} url - the url the data was loaded
         *      from if any.
         * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null value obtained from
         *      the protocol URL after '#' sign if flag splitHashDataForPost set to 'true'
         * @returns {Object} options - A dictionary of keyword arguments sufficient
         *      to configure the tile source constructor (include all values you want to
         *      instantiate the TileSource subclass with - what _options_ object should contain).
         * @throws {Error}
         */
        configure: function(i, o, s) {
          throw new Error("Method not implemented.");
        },
        /**
         * Responsible for retrieving the url which will return an image for the
         * region specified by the given x, y, and level components.
         * This method is not implemented by this class other than to throw an Error
         * announcing you have to implement it.  Because of the variety of tile
         * server technologies, and various specifications for building image
         * pyramids, this method is here to allow easy integration.
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         * @returns {String|Function} url - A string for the url or a function that returns a url string.
         * @throws {Error}
         */
        getTileUrl: function(i, o, s) {
          throw new Error("Method not implemented.");
        },
        /**
         * Must use AJAX in order to work, i.e. loadTilesWithAjax = true is set.
         * If a value is returned, ajax issues POST request to the tile url.
         * If null is returned, ajax issues GET request.
         * The return value must comply to the header 'content type'.
         *
         * Examples (USED HEADER --> getTilePostData CODE):
         * 'Content-type': 'application/x-www-form-urlencoded' -->
         *   return "key1=value=1&key2=value2";
         *
         * 'Content-type': 'application/x-www-form-urlencoded' -->
         *   return JSON.stringify({key: "value", number: 5});
         *
         * 'Content-type': 'multipart/form-data' -->
         *   let result = new FormData();
         *   result.append("data", myData);
         *   return result;
         *
         * IMPORTANT: in case you move all the logic on image fetching
         * to post data, you must re-define 'getTileHashKey(...)' to
         * stay unique for different tile images.
         *
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         * @returns {*|null} post data to send with tile configuration request
         */
        getTilePostData: function(i, o, s) {
          return null;
        },
        /**
         * Responsible for retrieving the headers which will be attached to the image request for the
         * region specified by the given x, y, and level components.
         * This option is only relevant if {@link OpenSeadragon.Options}.loadTilesWithAjax is set to true.
         * The headers returned here will override headers specified at the Viewer or TiledImage level.
         * Specifying a falsy value for a header will clear its existing value set at the Viewer or
         * TiledImage level (if any).
         *
         * Note that the headers of existing tiles don't automatically change when this function
         * returns updated headers. To do that, you need to call {@link OpenSeadragon.Viewer#setAjaxHeaders}
         * and propagate the changes.
         *
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         * @returns {Object}
         */
        getTileAjaxHeaders: function(i, o, s) {
          return {};
        },
        /**
         * The tile cache object is uniquely determined by this key and used to lookup
         * the image data in cache: keys should be different if images are different.
         *
         * In case a tile has context2D property defined (TileSource.prototype.getContext2D)
         * or its context2D is set manually; the cache is not used and this function
         * is irrelevant.
         * Note: default behaviour does not take into account post data.
         * @param {Number} level tile level it was fetched with
         * @param {Number} x x-coordinate in the pyramid level
         * @param {Number} y y-coordinate in the pyramid level
         * @param {String} url the tile was fetched with
         * @param {Object} ajaxHeaders the tile was fetched with
         * @param {*} postData data the tile was fetched with (type depends on getTilePostData(..) return type)
         */
        getTileHashKey: function(i, o, s, u, f, p) {
          function m(v) {
            return f ? v + "+" + JSON.stringify(f) : v;
          }
          return m(typeof u != "string" ? i + "/" + o + "_" + s : u);
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */
        tileExists: function(i, o, s) {
          var u = this.getNumTiles(i);
          return i >= this.minLevel && i <= this.maxLevel && o >= 0 && s >= 0 && o < u.x && s < u.y;
        },
        /**
         * Decide whether tiles have transparency: this is crucial for correct images blending.
         * @returns {boolean} true if the image has transparency
         */
        hasTransparency: function(i, o, s, u) {
          return !!i || o.match(".png");
        },
        /**
         * Download tile data.
         * Note that if you override this function, you should override also downloadTileAbort().
         * @param {ImageJob} context job context that you have to call finish(...) on.
         * @param {String} [context.src] - URL of image to download.
         * @param {String} [context.loadWithAjax] - Whether to load this image with AJAX.
         * @param {String} [context.ajaxHeaders] - Headers to add to the image request if using AJAX.
         * @param {Boolean} [context.ajaxWithCredentials] - Whether to set withCredentials on AJAX requests.
         * @param {String} [context.crossOriginPolicy] - CORS policy to use for downloads
         * @param {String} [context.postData] - HTTP POST data (usually but not necessarily in k=v&k2=v2... form,
         *   see TileSource::getPostData) or null
         * @param {*} [context.userData] - Empty object to attach your own data and helper variables to.
         * @param {Function} [context.finish] - Should be called unless abort() was executed, e.g. on all occasions,
         *   be it successful or unsuccessful request.
         *   Usage: context.finish(data, request, errMessage). Pass the downloaded data object or null upon failure.
         *   Add also reference to an ajax request if used. Provide error message in case of failure.
         * @param {Function} [context.abort] - Called automatically when the job times out.
         *   Usage: context.abort().
         * @param {Function} [context.callback] @private - Called automatically once image has been downloaded
         *   (triggered by finish).
         * @param {Number} [context.timeout] @private - The max number of milliseconds that
         *   this image job may take to complete.
         * @param {string} [context.errorMsg] @private - The final error message, default null (set by finish).
         */
        downloadTileStart: function(i) {
          var o = i.userData, s = new Image();
          o.image = s, o.request = null;
          var u = function(f) {
            if (!s) {
              i.finish(null, o.request, "Image load failed: undefined Image instance.");
              return;
            }
            s.onload = s.onerror = s.onabort = null, i.finish(f ? null : s, o.request, f);
          };
          s.onload = function() {
            u();
          }, s.onabort = s.onerror = function() {
            u("Image load aborted.");
          }, i.loadWithAjax ? o.request = n.makeAjaxRequest({
            url: i.src,
            withCredentials: i.ajaxWithCredentials,
            headers: i.ajaxHeaders,
            responseType: "arraybuffer",
            postData: i.postData,
            success: function(f) {
              var p;
              try {
                p = new window.Blob([f.response]);
              } catch (y) {
                var m = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
                if (y.name === "TypeError" && m) {
                  var v = new m();
                  v.append(f.response), p = v.getBlob();
                }
              }
              p.size === 0 ? u("Empty image response.") : s.src = (window.URL || window.webkitURL).createObjectURL(p);
            },
            error: function(f) {
              u("Image load aborted - XHR error");
            }
          }) : (i.crossOriginPolicy !== !1 && (s.crossOrigin = i.crossOriginPolicy), s.src = i.src);
        },
        /**
         * Provide means of aborting the execution.
         * Note that if you override this function, you should override also downloadTileStart().
         * @param {ImageJob} context job, the same object as with downloadTileStart(..)
         * @param {*} [context.userData] - Empty object to attach (and mainly read) your own data.
         */
        downloadTileAbort: function(i) {
          i.userData.request && i.userData.request.abort();
          var o = i.userData.image;
          i.userData.image && (o.onload = o.onerror = o.onabort = null);
        },
        /**
         * Create cache object from the result of the download process. The
         * cacheObject parameter should be used to attach the data to, there are no
         * conventions on how it should be stored - all the logic is implemented within *TileCache() functions.
         *
         * Note that if you override any of *TileCache() functions, you should override all of them.
         * @param {object} cacheObject context cache object
         * @param {*} data image data, the data sent to ImageJob.prototype.finish(), by default an Image object
         * @param {Tile} tile instance the cache was created with
         */
        createTileCache: function(i, o, s) {
          i._data = o;
        },
        /**
         * Cache object destructor, unset all properties you created to allow GC collection.
         * Note that if you override any of *TileCache() functions, you should override all of them.
         * @param {object} cacheObject context cache object
         */
        destroyTileCache: function(i) {
          i._data = null, i._renderedContext = null;
        },
        /**
         * Raw data getter
         * Note that if you override any of *TileCache() functions, you should override all of them.
         * @param {object} cacheObject context cache object
         * @returns {*} cache data
         */
        getTileCacheData: function(i) {
          return i._data;
        },
        /**
         * Compatibility image element getter
         *  - plugins might need image representation of the data
         *  - div HTML rendering relies on image element presence
         * Note that if you override any of *TileCache() functions, you should override all of them.
         *  @param {object} cacheObject context cache object
         *  @returns {Image} cache data as an Image
         */
        getTileCacheDataAsImage: function(i) {
          return i._data;
        },
        /**
         * Compatibility context 2D getter
         *  - most heavily used rendering method is a canvas-based approach,
         *    convert the data to a canvas and return it's 2D context
         * Note that if you override any of *TileCache() functions, you should override all of them.
         * @param {object} cacheObject context cache object
         * @returns {CanvasRenderingContext2D} context of the canvas representation of the cache data
         */
        getTileCacheDataAsContext2D: function(i) {
          if (!i._renderedContext) {
            var o = document.createElement("canvas");
            o.width = i._data.width, o.height = i._data.height, i._renderedContext = o.getContext("2d"), i._renderedContext.drawImage(i._data, 0, 0), i._data = null;
          }
          return i._renderedContext;
        }
      }, n.extend(!0, n.TileSource.prototype, n.EventSource.prototype);
      function r(i) {
        var o = i.responseText, s = i.status, u, f;
        if (i) {
          if (i.status !== 200 && i.status !== 0)
            throw s = i.status, u = s === 404 ? "Not Found" : i.statusText, new Error(n.getString("Errors.Status", s, u));
        } else throw new Error(n.getString("Errors.Security"));
        if (o.match(/^\s*<.*/))
          try {
            f = i.responseXML && i.responseXML.documentElement ? i.responseXML : n.parseXml(o);
          } catch {
            f = i.responseText;
          }
        else if (o.match(/\s*[{[].*/))
          try {
            f = n.parseJSON(o);
          } catch {
            f = o;
          }
        else
          f = o;
        return f;
      }
      n.TileSource.determineType = function(i, o, s) {
        var u;
        for (u in t)
          if (u.match(/.+TileSource$/) && n.isFunction(t[u]) && n.isFunction(t[u].prototype.supports) && t[u].prototype.supports.call(i, o, s))
            return t[u];
        return n.console.error("No TileSource was able to open %s %s", s, o), null;
      };
    })(t), (function(n) {
      n.DziTileSource = function(o, s, u, f, p, m, v, y, S) {
        var E, w, _, O;
        if (n.isPlainObject(o) ? O = o : O = {
          width: arguments[0],
          height: arguments[1],
          tileSize: arguments[2],
          tileOverlap: arguments[3],
          tilesUrl: arguments[4],
          fileFormat: arguments[5],
          displayRects: arguments[6],
          minLevel: arguments[7],
          maxLevel: arguments[8]
        }, this._levelRects = {}, this.tilesUrl = O.tilesUrl, this.fileFormat = O.fileFormat, this.displayRects = O.displayRects, this.displayRects)
          for (E = this.displayRects.length - 1; E >= 0; E--)
            for (w = this.displayRects[E], _ = w.minLevel; _ <= w.maxLevel; _++)
              this._levelRects[_] || (this._levelRects[_] = []), this._levelRects[_].push(w);
        n.TileSource.apply(this, [O]);
      }, n.extend(
        n.DziTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.DziTileSource.prototype */
        {
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} optional - url
           */
          supports: function(o, s) {
            var u;
            return o.Image ? u = o.Image.xmlns : o.documentElement && (o.documentElement.localName === "Image" || o.documentElement.tagName === "Image") && (u = o.documentElement.namespaceURI), u = (u || "").toLowerCase(), u.indexOf("schemas.microsoft.com/deepzoom/2008") !== -1 || u.indexOf("schemas.microsoft.com/deepzoom/2009") !== -1;
          },
          /**
           *
           * @function
           * @param {Object|XMLDocument} data - the raw configuration
           * @param {String} url - the url the data was retrieved from if any.
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} options - A dictionary of keyword arguments sufficient
           *      to configure this tile sources constructor.
           */
          configure: function(o, s, u) {
            var f;
            return n.isPlainObject(o) ? f = i(this, o) : f = r(this, o), s && !f.tilesUrl && (f.tilesUrl = s.replace(
              /([^/]+?)(\.(dzi|xml|js)?(\?[^/]*)?)?\/?$/,
              "$1_files/"
            ), s.search(/\.(dzi|xml|js)\?/) !== -1 ? f.queryParams = s.match(/\?.*/) : f.queryParams = ""), f;
          },
          /**
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           */
          getTileUrl: function(o, s, u) {
            return [this.tilesUrl, o, "/", s, "_", u, ".", this.fileFormat, this.queryParams].join("");
          },
          /**
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           */
          tileExists: function(o, s, u) {
            var f = this._levelRects[o], p, m, v, y, S, E, w;
            if (this.minLevel && o < this.minLevel || this.maxLevel && o > this.maxLevel)
              return !1;
            if (!f || !f.length)
              return !0;
            for (w = f.length - 1; w >= 0; w--)
              if (p = f[w], !(o < p.minLevel || o > p.maxLevel) && (m = this.getLevelScale(o), v = p.x * m, y = p.y * m, S = v + p.width * m, E = y + p.height * m, v = Math.floor(v / this._tileWidth), y = Math.floor(y / this._tileWidth), S = Math.ceil(S / this._tileWidth), E = Math.ceil(E / this._tileWidth), v <= s && s < S && y <= u && u < E))
                return !0;
            return !1;
          }
        }
      );
      function r(o, s) {
        if (!s || !s.documentElement)
          throw new Error(n.getString("Errors.Xml"));
        var u = s.documentElement, f = u.localName || u.tagName, p = s.documentElement.namespaceURI, m = null, v = [], y, S, E, w, _;
        if (f === "Image")
          try {
            if (w = u.getElementsByTagName("Size")[0], w === void 0 && (w = u.getElementsByTagNameNS(p, "Size")[0]), m = {
              Image: {
                xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                Url: u.getAttribute("Url"),
                Format: u.getAttribute("Format"),
                DisplayRect: null,
                Overlap: parseInt(u.getAttribute("Overlap"), 10),
                TileSize: parseInt(u.getAttribute("TileSize"), 10),
                Size: {
                  Height: parseInt(w.getAttribute("Height"), 10),
                  Width: parseInt(w.getAttribute("Width"), 10)
                }
              }
            }, !n.imageFormatSupported(m.Image.Format))
              throw new Error(
                n.getString("Errors.ImageFormat", m.Image.Format.toUpperCase())
              );
            for (y = u.getElementsByTagName("DisplayRect"), y === void 0 && (y = u.getElementsByTagNameNS(p, "DisplayRect")[0]), _ = 0; _ < y.length; _++)
              S = y[_], E = S.getElementsByTagName("Rect")[0], E === void 0 && (E = S.getElementsByTagNameNS(p, "Rect")[0]), v.push({
                Rect: {
                  X: parseInt(E.getAttribute("X"), 10),
                  Y: parseInt(E.getAttribute("Y"), 10),
                  Width: parseInt(E.getAttribute("Width"), 10),
                  Height: parseInt(E.getAttribute("Height"), 10),
                  MinLevel: parseInt(S.getAttribute("MinLevel"), 10),
                  MaxLevel: parseInt(S.getAttribute("MaxLevel"), 10)
                }
              });
            return v.length && (m.Image.DisplayRect = v), i(o, m);
          } catch (P) {
            throw P instanceof Error ? P : new Error(n.getString("Errors.Dzi"));
          }
        else {
          if (f === "Collection")
            throw new Error(n.getString("Errors.Dzc"));
          if (f === "Error") {
            var O = u.getElementsByTagName("Message")[0], D = O.firstChild.nodeValue;
            throw new Error(D);
          }
        }
        throw new Error(n.getString("Errors.Dzi"));
      }
      function i(o, s) {
        var u = s.Image, f = u.Url, p = u.Format, m = u.Size, v = u.DisplayRect || [], y = parseInt(m.Width, 10), S = parseInt(m.Height, 10), E = parseInt(u.TileSize, 10), w = parseInt(u.Overlap, 10), _ = [], O, D;
        for (D = 0; D < v.length; D++)
          O = v[D].Rect, _.push(new n.DisplayRect(
            parseInt(O.X, 10),
            parseInt(O.Y, 10),
            parseInt(O.Width, 10),
            parseInt(O.Height, 10),
            parseInt(O.MinLevel, 10),
            parseInt(O.MaxLevel, 10)
          ));
        return n.extend(!0, {
          width: y,
          /* width *required */
          height: S,
          /* height *required */
          tileSize: E,
          /* tileSize *required */
          tileOverlap: w,
          /* tileOverlap *required */
          minLevel: null,
          /* minLevel */
          maxLevel: null,
          /* maxLevel */
          tilesUrl: f,
          /* tilesUrl */
          fileFormat: p,
          /* fileFormat */
          displayRects: _
          /* displayRects */
        }, s);
      }
    })(t), (function(n) {
      n.IIIFTileSource = function(u) {
        if (n.extend(!0, this, u), this._id = this["@id"] || this.id || this.identifier || null, !(this.height && this.width && this._id))
          throw new Error("IIIF required parameters (width, height, or id) not provided.");
        if (u.tileSizePerScaleFactor = {}, this.tileFormat = this.tileFormat || "jpg", this.version = u.version, this.tile_width && this.tile_height)
          u.tileWidth = this.tile_width, u.tileHeight = this.tile_height;
        else if (this.tile_width)
          u.tileSize = this.tile_width;
        else if (this.tile_height)
          u.tileSize = this.tile_height;
        else if (this.tiles)
          if (this.tiles.length === 1)
            u.tileWidth = this.tiles[0].width, u.tileHeight = this.tiles[0].height || this.tiles[0].width, this.scale_factors = this.tiles[0].scaleFactors;
          else {
            this.scale_factors = [];
            for (var f = 0; f < this.tiles.length; f++)
              for (var p = 0; p < this.tiles[f].scaleFactors.length; p++) {
                var m = this.tiles[f].scaleFactors[p];
                this.scale_factors.push(m), u.tileSizePerScaleFactor[m] = {
                  width: this.tiles[f].width,
                  height: this.tiles[f].height || this.tiles[f].width
                };
              }
          }
        else if (r(u)) {
          for (var v = Math.min(this.height, this.width), y = [256, 512, 1024], S = [], E = 0; E < y.length; E++)
            y[E] <= v && S.push(y[E]);
          S.length > 0 ? u.tileSize = Math.max.apply(null, S) : u.tileSize = v;
        } else this.sizes && this.sizes.length > 0 ? (this.emulateLegacyImagePyramid = !0, u.levels = i(this), n.extend(!0, u, {
          width: u.levels[u.levels.length - 1].width,
          height: u.levels[u.levels.length - 1].height,
          tileSize: Math.max(u.height, u.width),
          tileOverlap: 0,
          minLevel: 0,
          maxLevel: u.levels.length - 1
        }), this.levels = u.levels) : n.console.error("Nothing in the info.json to construct image pyramids from");
        if (!u.maxLevel && !this.emulateLegacyImagePyramid)
          if (!this.scale_factors)
            u.maxLevel = Number(Math.round(Math.log(Math.max(this.width, this.height), 2)));
          else {
            var w = Math.max.apply(null, this.scale_factors);
            u.maxLevel = Math.round(Math.log(w) * Math.LOG2E);
          }
        if (this.sizes) {
          var _ = this.sizes.length;
          (_ === u.maxLevel || _ === u.maxLevel + 1) && (this.levelSizes = this.sizes.slice().sort((O, D) => O.width - D.width), _ === u.maxLevel && this.levelSizes.push({ width: this.width, height: this.height }));
        }
        n.TileSource.apply(this, [u]);
      }, n.extend(
        n.IIIFTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.IIIFTileSource.prototype */
        {
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} [url] - url
           */
          supports: function(u, f) {
            return u.protocol && u.protocol === "http://iiif.io/api/image" || u["@context"] && (u["@context"] === "http://library.stanford.edu/iiif/image-api/1.1/context.json" || u["@context"] === "http://iiif.io/api/image/1/context.json") || u.profile && u.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html") === 0 || u.identifier && u.width && u.height ? !0 : !!(u.documentElement && u.documentElement.tagName === "info" && u.documentElement.namespaceURI === "http://library.stanford.edu/iiif/image-api/ns/");
          },
          /**
           * A static function used to prepare an incoming IIIF Image API info.json
           * response for processing by the tile handler. Normalizes data for all
           * versions of IIIF (1.0, 1.1, 2.x, 3.x) and returns a data object that
           * may be passed to the IIIFTileSource.
           *
           * @function
           * @static
           * @param {Object} data - the raw configuration
           * @param {String} url - the url configuration was retrieved from
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} A normalized IIIF data object
           * @example <caption>IIIF 2.x Info Looks like this</caption>
           * {
           * "@context": "http://iiif.io/api/image/2/context.json",
           * "@id": "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
           * "protocol": "http://iiif.io/api/image",
           * "height": 1024,
           * "width": 775,
           * "tiles" : [{"width":256, "scaleFactors":[1,2,4,8]}],
           *  "profile": ["http://iiif.io/api/image/2/level1.json", {
           *    "qualities": [ "native", "bitonal", "grey", "color" ],
           *    "formats": [ "jpg", "png", "gif" ]
           *   }]
           * }
           */
          configure: function(u, f, p) {
            if (n.isPlainObject(u)) {
              if (!u["@context"])
                u["@context"] = "http://iiif.io/api/image/1.0/context.json", u["@id"] = f.replace("/info.json", ""), u.version = 1;
              else {
                var v = u["@context"];
                if (Array.isArray(v)) {
                  for (var y = 0; y < v.length; y++)
                    if (typeof v[y] == "string" && (/^http:\/\/iiif\.io\/api\/image\/[1-3]\/context\.json$/.test(v[y]) || v[y] === "http://library.stanford.edu/iiif/image-api/1.1/context.json")) {
                      v = v[y];
                      break;
                    }
                }
                switch (v) {
                  case "http://iiif.io/api/image/1/context.json":
                  case "http://library.stanford.edu/iiif/image-api/1.1/context.json":
                    u.version = 1;
                    break;
                  case "http://iiif.io/api/image/2/context.json":
                    u.version = 2;
                    break;
                  case "http://iiif.io/api/image/3/context.json":
                    u.version = 3;
                    break;
                  default:
                    n.console.error("Data has a @context property which contains no known IIIF context URI.");
                }
              }
              if (u.preferredFormats) {
                for (var S = 0; S < u.preferredFormats.length; S++)
                  if (t.imageFormatSupported(u.preferredFormats[S])) {
                    u.tileFormat = u.preferredFormats[S];
                    break;
                  }
              }
              return u;
            } else {
              var m = o(u);
              return m["@context"] = "http://iiif.io/api/image/1.0/context.json", m["@id"] = f.replace("/info.xml", ""), m.version = 1, m;
            }
          },
          /**
           * Return the tileWidth for the given level.
           * @function
           * @param {Number} level
           */
          getTileWidth: function(u) {
            if (this.emulateLegacyImagePyramid)
              return n.TileSource.prototype.getTileWidth.call(this, u);
            var f = Math.pow(2, this.maxLevel - u);
            return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[f] ? this.tileSizePerScaleFactor[f].width : this._tileWidth;
          },
          /**
           * Return the tileHeight for the given level.
           * @function
           * @param {Number} level
           */
          getTileHeight: function(u) {
            if (this.emulateLegacyImagePyramid)
              return n.TileSource.prototype.getTileHeight.call(this, u);
            var f = Math.pow(2, this.maxLevel - u);
            return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[f] ? this.tileSizePerScaleFactor[f].height : this._tileHeight;
          },
          /**
           * @function
           * @param {Number} level
           */
          getLevelScale: function(u) {
            if (this.emulateLegacyImagePyramid) {
              var f = NaN;
              return this.levels.length > 0 && u >= this.minLevel && u <= this.maxLevel && (f = this.levels[u].width / this.levels[this.maxLevel].width), f;
            }
            return n.TileSource.prototype.getLevelScale.call(this, u);
          },
          /**
           * @function
           * @param {Number} level
           */
          getNumTiles: function(u) {
            if (this.emulateLegacyImagePyramid) {
              var f = this.getLevelScale(u);
              return f ? new n.Point(1, 1) : new n.Point(0, 0);
            }
            if (this.levelSizes) {
              var p = this.levelSizes[u], m = Math.ceil(p.width / this.getTileWidth(u)), v = Math.ceil(p.height / this.getTileHeight(u));
              return new n.Point(m, v);
            } else
              return n.TileSource.prototype.getNumTiles.call(this, u);
          },
          /**
           * @function
           * @param {Number} level
           * @param {OpenSeadragon.Point} point
           */
          getTileAtPoint: function(u, f) {
            if (this.emulateLegacyImagePyramid)
              return new n.Point(0, 0);
            if (this.levelSizes) {
              var p = f.x >= 0 && f.x <= 1 && f.y >= 0 && f.y <= 1 / this.aspectRatio;
              n.console.assert(p, "[TileSource.getTileAtPoint] must be called with a valid point.");
              var m = this.levelSizes[u].width, v = f.x * m, y = f.y * m, S = Math.floor(v / this.getTileWidth(u)), E = Math.floor(y / this.getTileHeight(u));
              f.x >= 1 && (S = this.getNumTiles(u).x - 1);
              var w = 1e-15;
              return f.y >= 1 / this.aspectRatio - w && (E = this.getNumTiles(u).y - 1), new n.Point(S, E);
            }
            return n.TileSource.prototype.getTileAtPoint.call(this, u, f);
          },
          /**
           * Responsible for retrieving the url which will return an image for the
           * region specified by the given x, y, and level components.
           * @function
           * @param {Number} level - z index
           * @param {Number} x
           * @param {Number} y
           * @throws {Error}
           */
          getTileUrl: function(u, f, p) {
            if (this.emulateLegacyImagePyramid) {
              var m = null;
              return this.levels.length > 0 && u >= this.minLevel && u <= this.maxLevel && (m = this.levels[u].url), m;
            }
            var v = "0", y = Math.pow(0.5, this.maxLevel - u), S, E, w, _, O, D, P, M, N, k, U, H, Y, z, V, F;
            return this.levelSizes ? (S = this.levelSizes[u].width, E = this.levelSizes[u].height) : (S = Math.ceil(this.width * y), E = Math.ceil(this.height * y)), w = this.getTileWidth(u), _ = this.getTileHeight(u), O = Math.round(w / y), D = Math.round(_ / y), this.version === 1 ? V = "native." + this.tileFormat : V = "default." + this.tileFormat, S < w && E < _ ? (this.version === 2 && S === this.width ? H = "full" : this.version === 3 && S === this.width && E === this.height ? H = "max" : this.version === 3 ? H = S + "," + E : H = S + ",", P = "full") : (M = f * O, N = p * D, k = Math.min(O, this.width - M), U = Math.min(D, this.height - N), f === 0 && p === 0 && k === this.width && U === this.height ? P = "full" : P = [M, N, k, U].join(","), Y = Math.min(w, S - f * w), z = Math.min(_, E - p * _), this.version === 2 && Y === this.width ? H = "full" : this.version === 3 && Y === this.width && z === this.height ? H = "max" : this.version === 3 ? H = Y + "," + z : H = Y + ","), F = [this._id, P, H, v, V].join("/"), F;
          },
          __testonly__: {
            canBeTiled: r,
            constructLevels: i
          }
        }
      );
      function r(u) {
        var f = [
          "http://library.stanford.edu/iiif/image-api/compliance.html#level0",
          "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0",
          "http://iiif.io/api/image/2/level0.json",
          "level0",
          "https://iiif.io/api/image/3/level0.json"
        ], p = Array.isArray(u.profile) ? u.profile[0] : u.profile, m = f.indexOf(p) !== -1, v = !1;
        return u.version === 2 && u.profile.length > 1 && u.profile[1].supports && (v = u.profile[1].supports.indexOf("sizeByW") !== -1), u.version === 3 && u.extraFeatures && (v = u.extraFeatures.indexOf("sizeByWh") !== -1), !m || v;
      }
      function i(u) {
        for (var f = [], p = 0; p < u.sizes.length; p++)
          f.push({
            url: u._id + "/full/" + u.sizes[p].width + "," + (u.version === 3 ? u.sizes[p].height : "") + "/0/default." + u.tileFormat,
            width: u.sizes[p].width,
            height: u.sizes[p].height
          });
        return f.sort(function(m, v) {
          return m.width - v.width;
        });
      }
      function o(u) {
        if (!u || !u.documentElement)
          throw new Error(n.getString("Errors.Xml"));
        var f = u.documentElement, p = f.tagName, m = null;
        if (p === "info")
          try {
            return m = {}, s(f, m), m;
          } catch (v) {
            throw v instanceof Error ? v : new Error(n.getString("Errors.IIIF"));
          }
        throw new Error(n.getString("Errors.IIIF"));
      }
      function s(u, f, p) {
        var m, v;
        if (u.nodeType === 3 && p)
          v = u.nodeValue.trim(), v.match(/^\d*$/) && (v = Number(v)), f[p] ? (n.isArray(f[p]) || (f[p] = [f[p]]), f[p].push(v)) : f[p] = v;
        else if (u.nodeType === 1)
          for (m = 0; m < u.childNodes.length; m++)
            s(u.childNodes[m], f, u.nodeName);
      }
    })(t), (function(n) {
      n.OsmTileSource = function(r, i, o, s, u) {
        var f;
        n.isPlainObject(r) ? f = r : f = {
          width: arguments[0],
          height: arguments[1],
          tileSize: arguments[2],
          tileOverlap: arguments[3],
          tilesUrl: arguments[4]
        }, (!f.width || !f.height) && (f.width = 65572864, f.height = 65572864), f.tileSize || (f.tileSize = 256, f.tileOverlap = 0), f.tilesUrl || (f.tilesUrl = "http://tile.openstreetmap.org/"), f.minLevel = 8, n.TileSource.apply(this, [f]);
      }, n.extend(
        n.OsmTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.OsmTileSource.prototype */
        {
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} optional - url
           */
          supports: function(r, i) {
            return r.type && r.type === "openstreetmaps";
          },
          /**
           *
           * @function
           * @param {Object} data - the raw configuration
           * @param {String} url - the url the data was retrieved from if any.
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} options - A dictionary of keyword arguments sufficient
           *      to configure this tile sources constructor.
           */
          configure: function(r, i, o) {
            return r;
          },
          /**
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           */
          getTileUrl: function(r, i, o) {
            return this.tilesUrl + (r - 8) + "/" + i + "/" + o + ".png";
          }
        }
      );
    })(t), (function(n) {
      n.TmsTileSource = function(r, i, o, s, u) {
        var f;
        n.isPlainObject(r) ? f = r : f = {
          width: arguments[0],
          height: arguments[1],
          tileSize: arguments[2],
          tileOverlap: arguments[3],
          tilesUrl: arguments[4]
        };
        var p = Math.ceil(f.width / 256) * 256, m = Math.ceil(f.height / 256) * 256, v;
        p > m ? v = p / 256 : v = m / 256, f.maxLevel = Math.ceil(Math.log(v) / Math.log(2)) - 1, f.tileSize = 256, f.width = p, f.height = m, n.TileSource.apply(this, [f]);
      }, n.extend(
        n.TmsTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.TmsTileSource.prototype */
        {
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} optional - url
           */
          supports: function(r, i) {
            return r.type && r.type === "tiledmapservice";
          },
          /**
           *
           * @function
           * @param {Object} data - the raw configuration
           * @param {String} url - the url the data was retrieved from if any.
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} options - A dictionary of keyword arguments sufficient
           *      to configure this tile sources constructor.
           */
          configure: function(r, i, o) {
            return r;
          },
          /**
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           */
          getTileUrl: function(r, i, o) {
            var s = this.getNumTiles(r).y - 1;
            return this.tilesUrl + r + "/" + i + "/" + (s - o) + ".png";
          }
        }
      );
    })(t), (function(n) {
      n.ZoomifyTileSource = function(r) {
        typeof r.tileSize > "u" && (r.tileSize = 256), typeof r.fileFormat > "u" && (r.fileFormat = "jpg", this.fileFormat = r.fileFormat);
        var i = {
          x: r.width,
          y: r.height
        };
        for (r.imageSizes = [{
          x: r.width,
          y: r.height
        }], r.gridSize = [this._getGridSize(r.width, r.height, r.tileSize)]; parseInt(i.x, 10) > r.tileSize || parseInt(i.y, 10) > r.tileSize; )
          i.x = Math.floor(i.x / 2), i.y = Math.floor(i.y / 2), r.imageSizes.push({
            x: i.x,
            y: i.y
          }), r.gridSize.push(this._getGridSize(i.x, i.y, r.tileSize));
        r.imageSizes.reverse(), r.gridSize.reverse(), r.minLevel = 0, r.maxLevel = r.gridSize.length - 1, t.TileSource.apply(this, [r]);
      }, n.extend(
        n.ZoomifyTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.ZoomifyTileSource.prototype */
        {
          //private
          _getGridSize: function(r, i, o) {
            return {
              x: Math.ceil(r / o),
              y: Math.ceil(i / o)
            };
          },
          //private
          _calculateAbsoluteTileNumber: function(r, i, o) {
            for (var s = 0, u = {}, f = 0; f < r; f++)
              u = this.gridSize[f], s += u.x * u.y;
            return u = this.gridSize[r], s += u.x * o + i, s;
          },
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} optional - url
           */
          supports: function(r, i) {
            return r.type && r.type === "zoomifytileservice";
          },
          /**
           *
           * @function
           * @param {Object} data - the raw configuration
           * @param {String} url - the url the data was retrieved from if any.
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} options - A dictionary of keyword arguments sufficient
           *      to configure this tile sources constructor.
           */
          configure: function(r, i, o) {
            return r;
          },
          /**
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           */
          getTileUrl: function(r, i, o) {
            var s = 0, u = this._calculateAbsoluteTileNumber(r, i, o);
            return s = Math.floor(u / 256), this.tilesUrl + "TileGroup" + s + "/" + r + "-" + i + "-" + o + "." + this.fileFormat;
          }
        }
      );
    })(t), (function(n) {
      n.LegacyTileSource = function(s) {
        var u, f, p;
        n.isArray(s) && (u = {
          type: "legacy-image-pyramid",
          levels: s
        }), u.levels = r(u.levels), u.levels.length > 0 ? (f = u.levels[u.levels.length - 1].width, p = u.levels[u.levels.length - 1].height) : (f = 0, p = 0, n.console.error("No supported image formats found")), n.extend(!0, u, {
          width: f,
          height: p,
          tileSize: Math.max(p, f),
          tileOverlap: 0,
          minLevel: 0,
          maxLevel: u.levels.length > 0 ? u.levels.length - 1 : 0
        }), n.TileSource.apply(this, [u]), this.levels = u.levels;
      }, n.extend(
        n.LegacyTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.LegacyTileSource.prototype */
        {
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} optional - url
           */
          supports: function(s, u) {
            return s.type && s.type === "legacy-image-pyramid" || s.documentElement && s.documentElement.getAttribute("type") === "legacy-image-pyramid";
          },
          /**
           *
           * @function
           * @param {Object|XMLDocument} configuration - the raw configuration
           * @param {String} dataUrl - the url the data was retrieved from if any.
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} options - A dictionary of keyword arguments sufficient
           *      to configure this tile sources constructor.
           */
          configure: function(s, u, f) {
            var p;
            return n.isPlainObject(s) ? p = o(this, s) : p = i(this, s), p;
          },
          /**
           * @function
           * @param {Number} level
           */
          getLevelScale: function(s) {
            var u = NaN;
            return this.levels.length > 0 && s >= this.minLevel && s <= this.maxLevel && (u = this.levels[s].width / this.levels[this.maxLevel].width), u;
          },
          /**
           * @function
           * @param {Number} level
           */
          getNumTiles: function(s) {
            var u = this.getLevelScale(s);
            return u ? new n.Point(1, 1) : new n.Point(0, 0);
          },
          /**
           * This method is not implemented by this class other than to throw an Error
           * announcing you have to implement it.  Because of the variety of tile
           * server technologies, and various specifications for building image
           * pyramids, this method is here to allow easy integration.
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           * @throws {Error}
           */
          getTileUrl: function(s, u, f) {
            var p = null;
            return this.levels.length > 0 && s >= this.minLevel && s <= this.maxLevel && (p = this.levels[s].url), p;
          }
        }
      );
      function r(s) {
        var u = [], f, p;
        for (p = 0; p < s.length; p++)
          f = s[p], f.height && f.width && f.url ? u.push({
            url: f.url,
            width: Number(f.width),
            height: Number(f.height)
          }) : n.console.error("Unsupported image format: %s", f.url ? f.url : "<no URL>");
        return u.sort(function(m, v) {
          return m.height - v.height;
        });
      }
      function i(s, u) {
        if (!u || !u.documentElement)
          throw new Error(n.getString("Errors.Xml"));
        var f = u.documentElement, p = f.tagName, m = null, v = [], y, S;
        if (p === "image")
          try {
            for (m = {
              type: f.getAttribute("type"),
              levels: []
            }, v = f.getElementsByTagName("level"), S = 0; S < v.length; S++)
              y = v[S], m.levels.push({
                url: y.getAttribute("url"),
                width: parseInt(y.getAttribute("width"), 10),
                height: parseInt(y.getAttribute("height"), 10)
              });
            return o(s, m);
          } catch (E) {
            throw E instanceof Error ? E : new Error("Unknown error parsing Legacy Image Pyramid XML.");
          }
        else {
          if (p === "collection")
            throw new Error("Legacy Image Pyramid Collections not yet supported.");
          if (p === "error")
            throw new Error("Error: " + u);
        }
        throw new Error("Unknown element " + p);
      }
      function o(s, u) {
        return u.levels;
      }
    })(t), (function(n) {
      n.ImageTileSource = function(r) {
        r = n.extend({
          buildPyramid: !0,
          crossOriginPolicy: !1,
          ajaxWithCredentials: !1
        }, r), n.TileSource.apply(this, [r]);
      }, n.extend(
        n.ImageTileSource.prototype,
        n.TileSource.prototype,
        /** @lends OpenSeadragon.ImageTileSource.prototype */
        {
          /**
           * Determine if the data and/or url imply the image service is supported by
           * this tile source.
           * @function
           * @param {Object|Array} data
           * @param {String} optional - url
           */
          supports: function(r, i) {
            return r.type && r.type === "image";
          },
          /**
           *
           * @function
           * @param {Object} options - the options
           * @param {String} dataUrl - the url the image was retrieved from, if any.
           * @param {String} postData - HTTP POST data in k=v&k2=v2... form or null
           * @returns {Object} options - A dictionary of keyword arguments sufficient
           *      to configure this tile sources constructor.
           */
          configure: function(r, i, o) {
            return r;
          },
          /**
           * Responsible for retrieving, and caching the
           * image metadata pertinent to this TileSources implementation.
           * @function
           * @param {String} url
           * @throws {Error}
           */
          getImageInfo: function(r) {
            var i = this._image = new Image(), o = this;
            this.crossOriginPolicy && (i.crossOrigin = this.crossOriginPolicy), this.ajaxWithCredentials && (i.useCredentials = this.ajaxWithCredentials), n.addEvent(i, "load", function() {
              o.width = i.naturalWidth, o.height = i.naturalHeight, o.aspectRatio = o.width / o.height, o.dimensions = new n.Point(o.width, o.height), o._tileWidth = o.width, o._tileHeight = o.height, o.tileOverlap = 0, o.minLevel = 0, o.levels = o._buildLevels(), o.maxLevel = o.levels.length - 1, o.ready = !0, o.raiseEvent("ready", { tileSource: o });
            }), n.addEvent(i, "error", function() {
              o.raiseEvent("open-failed", {
                message: "Error loading image at " + r,
                source: r
              });
            }), i.src = r;
          },
          /**
           * @function
           * @param {Number} level
           */
          getLevelScale: function(r) {
            var i = NaN;
            return r >= this.minLevel && r <= this.maxLevel && (i = this.levels[r].width / this.levels[this.maxLevel].width), i;
          },
          /**
           * @function
           * @param {Number} level
           */
          getNumTiles: function(r) {
            var i = this.getLevelScale(r);
            return i ? new n.Point(1, 1) : new n.Point(0, 0);
          },
          /**
           * Retrieves a tile url
           * @function
           * @param {Number} level Level of the tile
           * @param {Number} x x coordinate of the tile
           * @param {Number} y y coordinate of the tile
           */
          getTileUrl: function(r, i, o) {
            var s = null;
            return r >= this.minLevel && r <= this.maxLevel && (s = this.levels[r].url), s;
          },
          /**
           * Retrieves a tile context 2D
           * @function
           * @param {Number} level Level of the tile
           * @param {Number} x x coordinate of the tile
           * @param {Number} y y coordinate of the tile
           */
          getContext2D: function(r, i, o) {
            var s = null;
            return r >= this.minLevel && r <= this.maxLevel && (s = this.levels[r].context2D), s;
          },
          /**
           * Destroys ImageTileSource
           * @function
           * @param {OpenSeadragon.Viewer} viewer the viewer that is calling
           * destroy on the ImageTileSource
           */
          destroy: function(r) {
            this._freeupCanvasMemory(r);
          },
          // private
          //
          // Builds the different levels of the pyramid if possible
          // (i.e. if canvas API enabled and no canvas tainting issue).
          _buildLevels: function() {
            var r = [{
              url: this._image.src,
              width: this._image.naturalWidth,
              height: this._image.naturalHeight
            }];
            if (!this.buildPyramid || !n.supportsCanvas)
              return delete this._image, r;
            var i = this._image.naturalWidth, o = this._image.naturalHeight, s = document.createElement("canvas"), u = s.getContext("2d");
            if (s.width = i, s.height = o, u.drawImage(this._image, 0, 0, i, o), r[0].context2D = u, delete this._image, n.isCanvasTainted(s))
              return r;
            for (; i >= 2 && o >= 2; ) {
              i = Math.floor(i / 2), o = Math.floor(o / 2);
              var f = document.createElement("canvas"), p = f.getContext("2d");
              f.width = i, f.height = o, p.drawImage(s, 0, 0, i, o), r.splice(0, 0, {
                context2D: p,
                width: i,
                height: o
              }), s = f, u = p;
            }
            return r;
          },
          /**
           * Free up canvas memory
           * (iOS 12 or higher on 2GB RAM device has only 224MB canvas memory,
           * and Safari keeps canvas until its height and width will be set to 0).
           * @function
           */
          _freeupCanvasMemory: function(r) {
            for (var i = 0; i < this.levels.length; i++)
              this.levels[i].context2D && (this.levels[i].context2D.canvas.height = 0, this.levels[i].context2D.canvas.width = 0, r && r.raiseEvent("image-unloaded", {
                context2D: this.levels[i].context2D
              }));
          }
        }
      );
    })(t), (function(n) {
      n.TileSourceCollection = function(r, i, o, s) {
        n.console.error("TileSourceCollection is deprecated; use World instead");
      };
    })(t), (function(n) {
      n.ButtonState = {
        REST: 0,
        GROUP: 1,
        HOVER: 2,
        DOWN: 3
      }, n.Button = function(p) {
        var m = this;
        n.EventSource.call(this), n.extend(!0, this, {
          tooltip: null,
          srcRest: null,
          srcGroup: null,
          srcHover: null,
          srcDown: null,
          clickTimeThreshold: n.DEFAULT_SETTINGS.clickTimeThreshold,
          clickDistThreshold: n.DEFAULT_SETTINGS.clickDistThreshold,
          /**
           * How long to wait before fading.
           * @member {Number} fadeDelay
           * @memberof OpenSeadragon.Button#
           */
          fadeDelay: 0,
          /**
           * How long should it take to fade the button.
           * @member {Number} fadeLength
           * @memberof OpenSeadragon.Button#
           */
          fadeLength: 2e3,
          onPress: null,
          onRelease: null,
          onClick: null,
          onEnter: null,
          onExit: null,
          onFocus: null,
          onBlur: null,
          userData: null
        }, p), this.element = p.element || n.makeNeutralElement("div"), p.element || (this.imgRest = n.makeTransparentImage(this.srcRest), this.imgGroup = n.makeTransparentImage(this.srcGroup), this.imgHover = n.makeTransparentImage(this.srcHover), this.imgDown = n.makeTransparentImage(this.srcDown), this.imgRest.alt = this.imgGroup.alt = this.imgHover.alt = this.imgDown.alt = this.tooltip, n.setElementPointerEventsNone(this.imgRest), n.setElementPointerEventsNone(this.imgGroup), n.setElementPointerEventsNone(this.imgHover), n.setElementPointerEventsNone(this.imgDown), this.element.style.position = "relative", n.setElementTouchActionNone(this.element), this.imgGroup.style.position = this.imgHover.style.position = this.imgDown.style.position = "absolute", this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "0px", this.imgGroup.style.left = this.imgHover.style.left = this.imgDown.style.left = "0px", this.imgHover.style.visibility = this.imgDown.style.visibility = "hidden", this.element.appendChild(this.imgRest), this.element.appendChild(this.imgGroup), this.element.appendChild(this.imgHover), this.element.appendChild(this.imgDown)), this.addHandler("press", this.onPress), this.addHandler("release", this.onRelease), this.addHandler("click", this.onClick), this.addHandler("enter", this.onEnter), this.addHandler("exit", this.onExit), this.addHandler("focus", this.onFocus), this.addHandler("blur", this.onBlur), this.currentState = n.ButtonState.GROUP, this.fadeBeginTime = null, this.shouldFade = !1, this.element.style.display = "inline-block", this.element.style.position = "relative", this.element.title = this.tooltip, this.tracker = new n.MouseTracker({
          userData: "Button.tracker",
          element: this.element,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          enterHandler: function(v) {
            v.insideElementPressed ? (u(m, n.ButtonState.DOWN), m.raiseEvent("enter", { originalEvent: v.originalEvent })) : v.buttonDownAny || u(m, n.ButtonState.HOVER);
          },
          focusHandler: function(v) {
            m.tracker.enterHandler(v), m.raiseEvent("focus", { originalEvent: v.originalEvent });
          },
          leaveHandler: function(v) {
            f(m, n.ButtonState.GROUP), v.insideElementPressed && m.raiseEvent("exit", { originalEvent: v.originalEvent });
          },
          blurHandler: function(v) {
            m.tracker.leaveHandler(v), m.raiseEvent("blur", { originalEvent: v.originalEvent });
          },
          pressHandler: function(v) {
            u(m, n.ButtonState.DOWN), m.raiseEvent("press", { originalEvent: v.originalEvent });
          },
          releaseHandler: function(v) {
            v.insideElementPressed && v.insideElementReleased ? (f(m, n.ButtonState.HOVER), m.raiseEvent("release", { originalEvent: v.originalEvent })) : v.insideElementPressed ? f(m, n.ButtonState.GROUP) : u(m, n.ButtonState.HOVER);
          },
          clickHandler: function(v) {
            v.quick && m.raiseEvent("click", { originalEvent: v.originalEvent });
          },
          keyHandler: function(v) {
            v.keyCode === 13 ? (m.raiseEvent("click", { originalEvent: v.originalEvent }), m.raiseEvent("release", { originalEvent: v.originalEvent }), v.preventDefault = !0) : v.preventDefault = !1;
          }
        }), f(this, n.ButtonState.REST);
      }, n.extend(
        n.Button.prototype,
        n.EventSource.prototype,
        /** @lends OpenSeadragon.Button.prototype */
        {
          /**
           * Used by a button container element (e.g. a ButtonGroup) to transition the button state
           * to ButtonState.GROUP.
           * @function
           */
          notifyGroupEnter: function() {
            u(this, n.ButtonState.GROUP);
          },
          /**
           * Used by a button container element (e.g. a ButtonGroup) to transition the button state
           * to ButtonState.REST.
           * @function
           */
          notifyGroupExit: function() {
            f(this, n.ButtonState.REST);
          },
          /**
           * @function
           */
          disable: function() {
            this.notifyGroupExit(), this.element.disabled = !0, this.tracker.setTracking(!1), n.setElementOpacity(this.element, 0.2, !0);
          },
          /**
           * @function
           */
          enable: function() {
            this.element.disabled = !1, this.tracker.setTracking(!0), n.setElementOpacity(this.element, 1, !0), this.notifyGroupEnter();
          },
          destroy: function() {
            this.imgRest && (this.element.removeChild(this.imgRest), this.imgRest = null), this.imgGroup && (this.element.removeChild(this.imgGroup), this.imgGroup = null), this.imgHover && (this.element.removeChild(this.imgHover), this.imgHover = null), this.imgDown && (this.element.removeChild(this.imgDown), this.imgDown = null), this.removeAllHandlers(), this.tracker.destroy(), this.element = null;
          }
        }
      );
      function r(p) {
        n.requestAnimationFrame(function() {
          i(p);
        });
      }
      function i(p) {
        var m, v, y;
        p.shouldFade && (m = n.now(), v = m - p.fadeBeginTime, y = 1 - v / p.fadeLength, y = Math.min(1, y), y = Math.max(0, y), p.imgGroup && n.setElementOpacity(p.imgGroup, y, !0), y > 0 && r(p));
      }
      function o(p) {
        p.shouldFade = !0, p.fadeBeginTime = n.now() + p.fadeDelay, window.setTimeout(function() {
          r(p);
        }, p.fadeDelay);
      }
      function s(p) {
        p.shouldFade = !1, p.imgGroup && n.setElementOpacity(p.imgGroup, 1, !0);
      }
      function u(p, m) {
        p.element.disabled || (m >= n.ButtonState.GROUP && p.currentState === n.ButtonState.REST && (s(p), p.currentState = n.ButtonState.GROUP), m >= n.ButtonState.HOVER && p.currentState === n.ButtonState.GROUP && (p.imgHover && (p.imgHover.style.visibility = ""), p.currentState = n.ButtonState.HOVER), m >= n.ButtonState.DOWN && p.currentState === n.ButtonState.HOVER && (p.imgDown && (p.imgDown.style.visibility = ""), p.currentState = n.ButtonState.DOWN));
      }
      function f(p, m) {
        p.element.disabled || (m <= n.ButtonState.HOVER && p.currentState === n.ButtonState.DOWN && (p.imgDown && (p.imgDown.style.visibility = "hidden"), p.currentState = n.ButtonState.HOVER), m <= n.ButtonState.GROUP && p.currentState === n.ButtonState.HOVER && (p.imgHover && (p.imgHover.style.visibility = "hidden"), p.currentState = n.ButtonState.GROUP), m <= n.ButtonState.REST && p.currentState === n.ButtonState.GROUP && (o(p), p.currentState = n.ButtonState.REST));
      }
    })(t), (function(n) {
      n.ButtonGroup = function(r) {
        n.extend(!0, this, {
          /**
           * An array containing the buttons themselves.
           * @member {Array} buttons
           * @memberof OpenSeadragon.ButtonGroup#
           */
          buttons: [],
          clickTimeThreshold: n.DEFAULT_SETTINGS.clickTimeThreshold,
          clickDistThreshold: n.DEFAULT_SETTINGS.clickDistThreshold,
          labelText: ""
        }, r);
        var i = this.buttons.concat([]), o = this, s;
        if (this.element = r.element || n.makeNeutralElement("div"), !r.group)
          for (this.element.style.display = "inline-block", s = 0; s < i.length; s++)
            this.element.appendChild(i[s].element);
        n.setElementTouchActionNone(this.element), this.tracker = new n.MouseTracker({
          userData: "ButtonGroup.tracker",
          element: this.element,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          enterHandler: function(u) {
            var f;
            for (f = 0; f < o.buttons.length; f++)
              o.buttons[f].notifyGroupEnter();
          },
          leaveHandler: function(u) {
            var f;
            if (!u.insideElementPressed)
              for (f = 0; f < o.buttons.length; f++)
                o.buttons[f].notifyGroupExit();
          }
        });
      }, n.ButtonGroup.prototype = {
        /**
         * Adds the given button to this button group.
         *
         * @function
         * @param {OpenSeadragon.Button} button
         */
        addButton: function(r) {
          this.buttons.push(r), this.element.appendChild(r.element);
        },
        /**
         * TODO: Figure out why this is used on the public API and if a more useful
         * api can be created.
         * @function
         * @private
         */
        emulateEnter: function() {
          this.tracker.enterHandler({ eventSource: this.tracker });
        },
        /**
         * TODO: Figure out why this is used on the public API and if a more useful
         * api can be created.
         * @function
         * @private
         */
        emulateLeave: function() {
          this.tracker.leaveHandler({ eventSource: this.tracker });
        },
        destroy: function() {
          for (; this.buttons.length; ) {
            var r = this.buttons.pop();
            this.element.removeChild(r.element), r.destroy();
          }
          this.tracker.destroy(), this.element = null;
        }
      };
    })(t), (function(n) {
      n.Rect = function(r, i, o, s, u) {
        this.x = typeof r == "number" ? r : 0, this.y = typeof i == "number" ? i : 0, this.width = typeof o == "number" ? o : 0, this.height = typeof s == "number" ? s : 0, this.degrees = typeof u == "number" ? u : 0, this.degrees = n.positiveModulo(this.degrees, 360);
        var f, p;
        this.degrees >= 270 ? (f = this.getTopRight(), this.x = f.x, this.y = f.y, p = this.height, this.height = this.width, this.width = p, this.degrees -= 270) : this.degrees >= 180 ? (f = this.getBottomRight(), this.x = f.x, this.y = f.y, this.degrees -= 180) : this.degrees >= 90 && (f = this.getBottomLeft(), this.x = f.x, this.y = f.y, p = this.height, this.height = this.width, this.width = p, this.degrees -= 90);
      }, n.Rect.fromSummits = function(r, i, o) {
        var s = r.distanceTo(i), u = r.distanceTo(o), f = i.minus(r), p = Math.atan(f.y / f.x);
        return f.x < 0 ? p += Math.PI : f.y < 0 && (p += 2 * Math.PI), new n.Rect(
          r.x,
          r.y,
          s,
          u,
          p / Math.PI * 180
        );
      }, n.Rect.prototype = {
        /**
         * @function
         * @returns {OpenSeadragon.Rect} a duplicate of this Rect
         */
        clone: function() {
          return new n.Rect(
            this.x,
            this.y,
            this.width,
            this.height,
            this.degrees
          );
        },
        /**
         * The aspect ratio is simply the ratio of width to height.
         * @function
         * @returns {Number} The ratio of width to height.
         */
        getAspectRatio: function() {
          return this.width / this.height;
        },
        /**
         * Provides the coordinates of the upper-left corner of the rectangle as a
         * point.
         * @function
         * @returns {OpenSeadragon.Point} The coordinate of the upper-left corner of
         *  the rectangle.
         */
        getTopLeft: function() {
          return new n.Point(
            this.x,
            this.y
          );
        },
        /**
         * Provides the coordinates of the bottom-right corner of the rectangle as a
         * point.
         * @function
         * @returns {OpenSeadragon.Point} The coordinate of the bottom-right corner of
         *  the rectangle.
         */
        getBottomRight: function() {
          return new n.Point(this.x + this.width, this.y + this.height).rotate(this.degrees, this.getTopLeft());
        },
        /**
         * Provides the coordinates of the top-right corner of the rectangle as a
         * point.
         * @function
         * @returns {OpenSeadragon.Point} The coordinate of the top-right corner of
         *  the rectangle.
         */
        getTopRight: function() {
          return new n.Point(this.x + this.width, this.y).rotate(this.degrees, this.getTopLeft());
        },
        /**
         * Provides the coordinates of the bottom-left corner of the rectangle as a
         * point.
         * @function
         * @returns {OpenSeadragon.Point} The coordinate of the bottom-left corner of
         *  the rectangle.
         */
        getBottomLeft: function() {
          return new n.Point(this.x, this.y + this.height).rotate(this.degrees, this.getTopLeft());
        },
        /**
         * Computes the center of the rectangle.
         * @function
         * @returns {OpenSeadragon.Point} The center of the rectangle as represented
         *  as represented by a 2-dimensional vector (x,y)
         */
        getCenter: function() {
          return new n.Point(
            this.x + this.width / 2,
            this.y + this.height / 2
          ).rotate(this.degrees, this.getTopLeft());
        },
        /**
         * Returns the width and height component as a vector OpenSeadragon.Point
         * @function
         * @returns {OpenSeadragon.Point} The 2 dimensional vector representing the
         *  width and height of the rectangle.
         */
        getSize: function() {
          return new n.Point(this.width, this.height);
        },
        /**
         * Determines if two Rectangles have equivalent components.
         * @function
         * @param {OpenSeadragon.Rect} rectangle The Rectangle to compare to.
         * @returns {Boolean} 'true' if all components are equal, otherwise 'false'.
         */
        equals: function(r) {
          return r instanceof n.Rect && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height && this.degrees === r.degrees;
        },
        /**
        * Multiply all dimensions (except degrees) in this Rect by a factor and
        * return a new Rect.
        * @function
        * @param {Number} factor The factor to multiply vector components.
        * @returns {OpenSeadragon.Rect} A new rect representing the multiplication
        *  of the vector components by the factor
        */
        times: function(r) {
          return new n.Rect(
            this.x * r,
            this.y * r,
            this.width * r,
            this.height * r,
            this.degrees
          );
        },
        /**
        * Translate/move this Rect by a vector and return new Rect.
        * @function
        * @param {OpenSeadragon.Point} delta The translation vector.
        * @returns {OpenSeadragon.Rect} A new rect with altered position
        */
        translate: function(r) {
          return new n.Rect(
            this.x + r.x,
            this.y + r.y,
            this.width,
            this.height,
            this.degrees
          );
        },
        /**
         * Returns the smallest rectangle that will contain this and the given
         * rectangle bounding boxes.
         * @param {OpenSeadragon.Rect} rect
         * @returns {OpenSeadragon.Rect} The new rectangle.
         */
        union: function(r) {
          var i = this.getBoundingBox(), o = r.getBoundingBox(), s = Math.min(i.x, o.x), u = Math.min(i.y, o.y), f = Math.max(
            i.x + i.width,
            o.x + o.width
          ), p = Math.max(
            i.y + i.height,
            o.y + o.height
          );
          return new n.Rect(
            s,
            u,
            f - s,
            p - u
          );
        },
        /**
         * Returns the bounding box of the intersection of this rectangle with the
         * given rectangle.
         * @param {OpenSeadragon.Rect} rect
         * @returns {OpenSeadragon.Rect} the bounding box of the intersection
         * or null if the rectangles don't intersect.
         */
        intersection: function(r) {
          var i = 1e-10, o = [], s = this.getTopLeft();
          r.containsPoint(s, i) && o.push(s);
          var u = this.getTopRight();
          r.containsPoint(u, i) && o.push(u);
          var f = this.getBottomLeft();
          r.containsPoint(f, i) && o.push(f);
          var p = this.getBottomRight();
          r.containsPoint(p, i) && o.push(p);
          var m = r.getTopLeft();
          this.containsPoint(m, i) && o.push(m);
          var v = r.getTopRight();
          this.containsPoint(v, i) && o.push(v);
          var y = r.getBottomLeft();
          this.containsPoint(y, i) && o.push(y);
          var S = r.getBottomRight();
          this.containsPoint(S, i) && o.push(S);
          for (var E = this._getSegments(), w = r._getSegments(), _ = 0; _ < E.length; _++)
            for (var O = E[_], D = 0; D < w.length; D++) {
              var P = w[D], M = N(
                O[0],
                O[1],
                P[0],
                P[1]
              );
              M && o.push(M);
            }
          function N(F, X, oe, re) {
            var Z = X.minus(F), ee = re.minus(oe), J = -ee.x * Z.y + Z.x * ee.y;
            if (J === 0)
              return null;
            var le = (Z.x * (F.y - oe.y) - Z.y * (F.x - oe.x)) / J, be = (ee.x * (F.y - oe.y) - ee.y * (F.x - oe.x)) / J;
            return -i <= le && le <= 1 - i && -i <= be && be <= 1 - i ? new n.Point(F.x + be * Z.x, F.y + be * Z.y) : null;
          }
          if (o.length === 0)
            return null;
          for (var k = o[0].x, U = o[0].x, H = o[0].y, Y = o[0].y, z = 1; z < o.length; z++) {
            var V = o[z];
            V.x < k && (k = V.x), V.x > U && (U = V.x), V.y < H && (H = V.y), V.y > Y && (Y = V.y);
          }
          return new n.Rect(k, H, U - k, Y - H);
        },
        // private
        _getSegments: function() {
          var r = this.getTopLeft(), i = this.getTopRight(), o = this.getBottomLeft(), s = this.getBottomRight();
          return [
            [r, i],
            [i, s],
            [s, o],
            [o, r]
          ];
        },
        /**
         * Rotates a rectangle around a point.
         * @function
         * @param {Number} degrees The angle in degrees to rotate.
         * @param {OpenSeadragon.Point} [pivot] The point about which to rotate.
         * Defaults to the center of the rectangle.
         * @returns {OpenSeadragon.Rect}
         */
        rotate: function(r, i) {
          if (r = n.positiveModulo(r, 360), r === 0)
            return this.clone();
          i = i || this.getCenter();
          var o = this.getTopLeft().rotate(r, i), s = this.getTopRight().rotate(r, i), u = s.minus(o);
          u = u.apply(function(p) {
            var m = 1e-15;
            return Math.abs(p) < m ? 0 : p;
          });
          var f = Math.atan(u.y / u.x);
          return u.x < 0 ? f += Math.PI : u.y < 0 && (f += 2 * Math.PI), new n.Rect(
            o.x,
            o.y,
            this.width,
            this.height,
            f / Math.PI * 180
          );
        },
        /**
         * Retrieves the smallest horizontal (degrees=0) rectangle which contains
         * this rectangle.
         * @returns {OpenSeadragon.Rect}
         */
        getBoundingBox: function() {
          if (this.degrees === 0)
            return this.clone();
          var r = this.getTopLeft(), i = this.getTopRight(), o = this.getBottomLeft(), s = this.getBottomRight(), u = Math.min(r.x, i.x, o.x, s.x), f = Math.max(r.x, i.x, o.x, s.x), p = Math.min(r.y, i.y, o.y, s.y), m = Math.max(r.y, i.y, o.y, s.y);
          return new n.Rect(
            u,
            p,
            f - u,
            m - p
          );
        },
        /**
         * Retrieves the smallest horizontal (degrees=0) rectangle which contains
         * this rectangle and has integers x, y, width and height
         * @returns {OpenSeadragon.Rect}
         */
        getIntegerBoundingBox: function() {
          var r = this.getBoundingBox(), i = Math.floor(r.x), o = Math.floor(r.y), s = Math.ceil(r.width + r.x - i), u = Math.ceil(r.height + r.y - o);
          return new n.Rect(i, o, s, u);
        },
        /**
         * Determines whether a point is inside this rectangle (edge included).
         * @function
         * @param {OpenSeadragon.Point} point
         * @param {Number} [epsilon=0] the margin of error allowed
         * @returns {Boolean} true if the point is inside this rectangle, false
         * otherwise.
         */
        containsPoint: function(r, i) {
          i = i || 0;
          var o = this.getTopLeft(), s = this.getTopRight(), u = this.getBottomLeft(), f = s.minus(o), p = u.minus(o);
          return (r.x - o.x) * f.x + (r.y - o.y) * f.y >= -i && (r.x - s.x) * f.x + (r.y - s.y) * f.y <= i && (r.x - o.x) * p.x + (r.y - o.y) * p.y >= -i && (r.x - u.x) * p.x + (r.y - u.y) * p.y <= i;
        },
        /**
         * Provides a string representation of the rectangle which is useful for
         * debugging.
         * @function
         * @returns {String} A string representation of the rectangle.
         */
        toString: function() {
          return "[" + Math.round(this.x * 100) / 100 + ", " + Math.round(this.y * 100) / 100 + ", " + Math.round(this.width * 100) / 100 + "x" + Math.round(this.height * 100) / 100 + ", " + Math.round(this.degrees * 100) / 100 + "deg]";
        }
      };
    })(t), (function(n) {
      var r = {};
      n.ReferenceStrip = function(y) {
        var S = this, E = y.viewer, w = n.getElementSize(E.element), _, O, D;
        for (y.id || (y.id = "referencestrip-" + n.now(), this.element = n.makeNeutralElement("div"), this.element.id = y.id, this.element.className = "referencestrip"), y = n.extend(!0, {
          sizeRatio: n.DEFAULT_SETTINGS.referenceStripSizeRatio,
          position: n.DEFAULT_SETTINGS.referenceStripPosition,
          scroll: n.DEFAULT_SETTINGS.referenceStripScroll,
          clickTimeThreshold: n.DEFAULT_SETTINGS.clickTimeThreshold
        }, y, {
          element: this.element
        }), n.extend(this, y), r[this.id] = {
          animating: !1
        }, this.minPixelRatio = this.viewer.minPixelRatio, this.element.tabIndex = 0, O = this.element.style, O.marginTop = "0px", O.marginRight = "0px", O.marginBottom = "0px", O.marginLeft = "0px", O.left = "0px", O.bottom = "0px", O.border = "0px", O.background = "#000", O.position = "relative", n.setElementTouchActionNone(this.element), n.setElementOpacity(this.element, 0.8), this.viewer = E, this.tracker = new n.MouseTracker({
          userData: "ReferenceStrip.tracker",
          element: this.element,
          clickHandler: n.delegate(this, i),
          dragHandler: n.delegate(this, o),
          scrollHandler: n.delegate(this, s),
          enterHandler: n.delegate(this, f),
          leaveHandler: n.delegate(this, p),
          keyDownHandler: n.delegate(this, m),
          keyHandler: n.delegate(this, v),
          preProcessEventHandler: function(P) {
            P.eventType === "wheel" && (P.preventDefault = !0);
          }
        }), y.width && y.height ? (this.element.style.width = y.width + "px", this.element.style.height = y.height + "px", E.addControl(
          this.element,
          { anchor: n.ControlAnchor.BOTTOM_LEFT }
        )) : y.scroll === "horizontal" ? (this.element.style.width = w.x * y.sizeRatio * E.tileSources.length + 12 * E.tileSources.length + "px", this.element.style.height = w.y * y.sizeRatio + "px", E.addControl(
          this.element,
          { anchor: n.ControlAnchor.BOTTOM_LEFT }
        )) : (this.element.style.height = w.y * y.sizeRatio * E.tileSources.length + 12 * E.tileSources.length + "px", this.element.style.width = w.x * y.sizeRatio + "px", E.addControl(
          this.element,
          { anchor: n.ControlAnchor.TOP_LEFT }
        )), this.panelWidth = w.x * this.sizeRatio + 8, this.panelHeight = w.y * this.sizeRatio + 8, this.panels = [], this.miniViewers = {}, D = 0; D < E.tileSources.length; D++)
          _ = n.makeNeutralElement("div"), _.id = this.element.id + "-" + D, _.style.width = S.panelWidth + "px", _.style.height = S.panelHeight + "px", _.style.display = "inline", _.style.float = "left", _.style.cssFloat = "left", _.style.padding = "2px", n.setElementTouchActionNone(_), n.setElementPointerEventsNone(_), this.element.appendChild(_), _.activePanel = !1, this.panels.push(_);
        u(this, this.scroll === "vertical" ? w.y : w.x, 0), this.setFocus(0);
      }, n.ReferenceStrip.prototype = {
        /**
         * @function
         */
        setFocus: function(y) {
          var S = this.element.querySelector("#" + this.element.id + "-" + y), E = n.getElementSize(this.viewer.canvas), w = Number(this.element.style.width.replace("px", "")), _ = Number(this.element.style.height.replace("px", "")), O = -Number(this.element.style.marginLeft.replace("px", "")), D = -Number(this.element.style.marginTop.replace("px", "")), P;
          this.currentSelected !== S && (this.currentSelected && (this.currentSelected.style.background = "#000"), this.currentSelected = S, this.currentSelected.style.background = "#999", this.scroll === "horizontal" ? (P = Number(y) * (this.panelWidth + 3), P > O + E.x - this.panelWidth ? (P = Math.min(P, w - E.x), this.element.style.marginLeft = -P + "px", u(this, E.x, -P)) : P < O && (P = Math.max(0, P - E.x / 2), this.element.style.marginLeft = -P + "px", u(this, E.x, -P))) : (P = Number(y) * (this.panelHeight + 3), P > D + E.y - this.panelHeight ? (P = Math.min(P, _ - E.y), this.element.style.marginTop = -P + "px", u(this, E.y, -P)) : P < D && (P = Math.max(0, P - E.y / 2), this.element.style.marginTop = -P + "px", u(this, E.y, -P))), this.currentPage = y, f.call(this, { eventSource: this.tracker }));
        },
        /**
         * @function
         */
        update: function() {
          return !!r[this.id].animating;
        },
        destroy: function() {
          if (this.miniViewers)
            for (var y in this.miniViewers)
              this.miniViewers[y].destroy();
          this.tracker.destroy(), this.element && this.viewer.removeControl(this.element);
        }
      };
      function i(y) {
        if (y.quick) {
          var S;
          this.scroll === "horizontal" ? S = Math.floor(y.position.x / (this.panelWidth + 4)) : S = Math.floor(y.position.y / this.panelHeight), this.viewer.goToPage(S);
        }
        this.element.focus();
      }
      function o(y) {
        if (this.dragging = !0, this.element) {
          var S = Number(this.element.style.marginLeft.replace("px", "")), E = Number(this.element.style.marginTop.replace("px", "")), w = Number(this.element.style.width.replace("px", "")), _ = Number(this.element.style.height.replace("px", "")), O = n.getElementSize(this.viewer.canvas);
          this.scroll === "horizontal" ? -y.delta.x > 0 ? S > -(w - O.x) && (this.element.style.marginLeft = S + y.delta.x * 2 + "px", u(this, O.x, S + y.delta.x * 2)) : -y.delta.x < 0 && S < 0 && (this.element.style.marginLeft = S + y.delta.x * 2 + "px", u(this, O.x, S + y.delta.x * 2)) : -y.delta.y > 0 ? E > -(_ - O.y) && (this.element.style.marginTop = E + y.delta.y * 2 + "px", u(this, O.y, E + y.delta.y * 2)) : -y.delta.y < 0 && E < 0 && (this.element.style.marginTop = E + y.delta.y * 2 + "px", u(this, O.y, E + y.delta.y * 2));
        }
      }
      function s(y) {
        if (this.element) {
          var S = Number(this.element.style.marginLeft.replace("px", "")), E = Number(this.element.style.marginTop.replace("px", "")), w = Number(this.element.style.width.replace("px", "")), _ = Number(this.element.style.height.replace("px", "")), O = n.getElementSize(this.viewer.canvas);
          this.scroll === "horizontal" ? y.scroll > 0 ? S > -(w - O.x) && (this.element.style.marginLeft = S - y.scroll * 60 + "px", u(this, O.x, S - y.scroll * 60)) : y.scroll < 0 && S < 0 && (this.element.style.marginLeft = S - y.scroll * 60 + "px", u(this, O.x, S - y.scroll * 60)) : y.scroll < 0 ? E > O.y - _ && (this.element.style.marginTop = E + y.scroll * 60 + "px", u(this, O.y, E + y.scroll * 60)) : y.scroll > 0 && E < 0 && (this.element.style.marginTop = E + y.scroll * 60 + "px", u(this, O.y, E + y.scroll * 60)), y.preventDefault = !0;
        }
      }
      function u(y, S, E) {
        var w, _, O, D, P, M;
        for (y.scroll === "horizontal" ? w = y.panelWidth : w = y.panelHeight, _ = Math.ceil(S / w) + 5, O = Math.ceil((Math.abs(E) + S) / w) + 1, _ = O - _, _ = _ < 0 ? 0 : _, P = _; P < O && P < y.panels.length; P++)
          if (M = y.panels[P], !M.activePanel) {
            var N, k = y.viewer.tileSources[P];
            k.referenceStripThumbnailUrl ? N = {
              type: "image",
              url: k.referenceStripThumbnailUrl
            } : N = k, D = new n.Viewer({
              id: M.id,
              tileSources: [N],
              element: M,
              navigatorSizeRatio: y.sizeRatio,
              showNavigator: !1,
              mouseNavEnabled: !1,
              showNavigationControl: !1,
              showSequenceControl: !1,
              immediateRender: !0,
              blendTime: 0,
              animationTime: 0,
              loadTilesWithAjax: y.viewer.loadTilesWithAjax,
              ajaxHeaders: y.viewer.ajaxHeaders,
              drawer: "canvas"
              //always use canvas for the reference strip
            }), n.setElementPointerEventsNone(D.canvas), n.setElementPointerEventsNone(D.container), D.innerTracker.setTracking(!1), D.outerTracker.setTracking(!1), y.miniViewers[M.id] = D, M.activePanel = !0;
          }
      }
      function f(y) {
        var S = y.eventSource.element;
        this.scroll === "horizontal" ? S.style.marginBottom = "0px" : S.style.marginLeft = "0px";
      }
      function p(y) {
        var S = y.eventSource.element;
        this.scroll === "horizontal" ? S.style.marginBottom = "-" + n.getElementSize(S).y / 2 + "px" : S.style.marginLeft = "-" + n.getElementSize(S).x / 2 + "px";
      }
      function m(y) {
        if (!y.ctrl && !y.alt && !y.meta)
          switch (y.keyCode) {
            case 38:
              s.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), y.preventDefault = !0;
              break;
            case 40:
              s.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), y.preventDefault = !0;
              break;
            case 37:
              s.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), y.preventDefault = !0;
              break;
            case 39:
              s.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), y.preventDefault = !0;
              break;
            default:
              y.preventDefault = !1;
              break;
          }
        else
          y.preventDefault = !1;
      }
      function v(y) {
        if (!y.ctrl && !y.alt && !y.meta)
          switch (y.keyCode) {
            case 61:
              s.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), y.preventDefault = !0;
              break;
            case 45:
              s.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), y.preventDefault = !0;
              break;
            case 48:
            //0|)
            case 119:
            //w
            case 87:
              s.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), y.preventDefault = !0;
              break;
            case 115:
            //s
            case 83:
              s.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), y.preventDefault = !0;
              break;
            case 97:
              s.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null }), y.preventDefault = !0;
              break;
            case 100:
              s.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null }), y.preventDefault = !0;
              break;
            default:
              y.preventDefault = !1;
              break;
          }
        else
          y.preventDefault = !1;
      }
    })(t), (function(n) {
      n.DisplayRect = function(r, i, o, s, u, f) {
        n.Rect.apply(this, [r, i, o, s]), this.minLevel = u, this.maxLevel = f;
      }, n.extend(n.DisplayRect.prototype, n.Rect.prototype);
    })(t), (function(n) {
      n.Spring = function(i) {
        var o = arguments;
        typeof i != "object" && (i = {
          initial: o.length && typeof o[0] == "number" ? o[0] : void 0,
          /**
           * Spring stiffness.
           * @member {Number} springStiffness
           * @memberof OpenSeadragon.Spring#
           */
          springStiffness: o.length > 1 ? o[1].springStiffness : 5,
          /**
           * Animation duration per spring.
           * @member {Number} animationTime
           * @memberof OpenSeadragon.Spring#
           */
          animationTime: o.length > 1 ? o[1].animationTime : 1.5
        }), n.console.assert(
          typeof i.springStiffness == "number" && i.springStiffness !== 0,
          "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number"
        ), n.console.assert(
          typeof i.animationTime == "number" && i.animationTime >= 0,
          "[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0"
        ), i.exponential && (this._exponential = !0, delete i.exponential), n.extend(!0, this, i), this.current = {
          value: typeof this.initial == "number" ? this.initial : this._exponential ? 0 : 1,
          time: n.now()
          // always work in milliseconds
        }, n.console.assert(
          !this._exponential || this.current.value !== 0,
          "[OpenSeadragon.Spring] value must be non-zero for exponential springs"
        ), this.start = {
          value: this.current.value,
          time: this.current.time
        }, this.target = {
          value: this.current.value,
          time: this.current.time
        }, this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
      }, n.Spring.prototype = {
        /**
         * @function
         * @param {Number} target
         */
        resetTo: function(i) {
          n.console.assert(
            !this._exponential || i !== 0,
            "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs"
          ), this.start.value = this.target.value = this.current.value = i, this.start.time = this.target.time = this.current.time = n.now(), this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
        },
        /**
         * @function
         * @param {Number} target
         */
        springTo: function(i) {
          n.console.assert(
            !this._exponential || i !== 0,
            "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs"
          ), this.start.value = this.current.value, this.start.time = this.current.time, this.target.value = i, this.target.time = this.start.time + 1e3 * this.animationTime, this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value));
        },
        /**
         * @function
         * @param {Number} delta
         */
        shiftBy: function(i) {
          this.start.value += i, this.target.value += i, this._exponential && (n.console.assert(
            this.target.value !== 0 && this.start.value !== 0,
            "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs"
          ), this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value));
        },
        setExponential: function(i) {
          this._exponential = i, this._exponential && (n.console.assert(
            this.current.value !== 0 && this.target.value !== 0 && this.start.value !== 0,
            "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs"
          ), this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
        },
        /**
         * @function
         * @returns true if the spring is still updating its value, false if it is
         * already at the target value.
         */
        update: function() {
          this.current.time = n.now();
          let i, o;
          if (this._exponential ? (i = this.start._logValue, o = this.target._logValue) : (i = this.start.value, o = this.target.value), this.current.time >= this.target.time)
            this.current.value = this.target.value;
          else {
            let s = i + (o - i) * r(
              this.springStiffness,
              (this.current.time - this.start.time) / (this.target.time - this.start.time)
            );
            this._exponential ? this.current.value = Math.exp(s) : this.current.value = s;
          }
          return this.current.value !== this.target.value;
        },
        /**
         * Returns whether the spring is at the target value
         * @function
         * @returns {Boolean} True if at target value, false otherwise
         */
        isAtTargetValue: function() {
          return this.current.value === this.target.value;
        }
      };
      function r(i, o) {
        return (1 - Math.exp(i * -o)) / (1 - Math.exp(-i));
      }
    })(t), (function(n) {
      n.ImageJob = function(i) {
        n.extend(!0, this, {
          timeout: n.DEFAULT_SETTINGS.timeout,
          jobId: null,
          tries: 0
        }, i), this.data = null, this.userData = {}, this.errorMsg = null;
      }, n.ImageJob.prototype = {
        /**
         * Starts the image job.
         * @method
         * @memberof OpenSeadragon.ImageJob#
         */
        start: function() {
          this.tries++;
          var i = this, o = this.abort;
          this.jobId = window.setTimeout(function() {
            i.finish(null, null, "Image load exceeded timeout (" + i.timeout + " ms)");
          }, this.timeout), this.abort = function() {
            i.source.downloadTileAbort(i), typeof o == "function" && o();
          }, this.source.downloadTileStart(this);
        },
        /**
         * Finish this job.
         * @param {*} data data that has been downloaded
         * @param {XMLHttpRequest} request reference to the request if used
         * @param {string} errorMessage description upon failure
         * @memberof OpenSeadragon.ImageJob#
         */
        finish: function(i, o, s) {
          this.data = i, this.request = o, this.errorMsg = s, this.jobId && window.clearTimeout(this.jobId), this.callback(this);
        }
      }, n.ImageLoader = function(i) {
        n.extend(!0, this, {
          jobLimit: n.DEFAULT_SETTINGS.imageLoaderLimit,
          timeout: n.DEFAULT_SETTINGS.timeout,
          jobQueue: [],
          failedTiles: [],
          jobsInProgress: 0
        }, i);
      }, n.ImageLoader.prototype = {
        /**
         * Add an unloaded image to the loader queue.
         * @method
         * @param {Object} options - Options for this job.
         * @param {String} [options.src] - URL of image to download.
         * @param {Tile} [options.tile] - Tile that belongs the data to. The tile instance
         *      is not internally used and serves for custom TileSources implementations.
         * @param {TileSource} [options.source] - Image loading strategy
         * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
         * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
         * @param {String|Boolean} [options.crossOriginPolicy] - CORS policy to use for downloads
         * @param {String} [options.postData] - POST parameters (usually but not necessarily in k=v&k2=v2... form,
         *      see TileSource::getPostData) or null
         * @param {Boolean} [options.ajaxWithCredentials] - Whether to set withCredentials on AJAX
         *      requests.
         * @param {Function} [options.callback] - Called once image has been downloaded.
         * @param {Function} [options.abort] - Called when this image job is aborted.
         */
        addJob: function(i) {
          if (!i.source) {
            n.console.error("ImageLoader.prototype.addJob() requires [options.source]. TileSource since new API defines how images are fetched. Creating a dummy TileSource.");
            var o = n.TileSource.prototype;
            i.source = {
              downloadTileStart: o.downloadTileStart,
              downloadTileAbort: o.downloadTileAbort
            };
          }
          var s = this, u = function(m) {
            r(s, m, i.callback);
          }, f = {
            src: i.src,
            tile: i.tile || {},
            source: i.source,
            loadWithAjax: i.loadWithAjax,
            ajaxHeaders: i.loadWithAjax ? i.ajaxHeaders : null,
            crossOriginPolicy: i.crossOriginPolicy,
            ajaxWithCredentials: i.ajaxWithCredentials,
            postData: i.postData,
            callback: u,
            abort: i.abort,
            timeout: this.timeout
          }, p = new n.ImageJob(f);
          !this.jobLimit || this.jobsInProgress < this.jobLimit ? (p.start(), this.jobsInProgress++) : this.jobQueue.push(p);
        },
        /**
         * Clear any unstarted image loading jobs from the queue.
         * @method
         */
        clear: function() {
          for (var i = 0; i < this.jobQueue.length; i++) {
            var o = this.jobQueue[i];
            typeof o.abort == "function" && o.abort();
          }
          this.jobQueue = [];
        }
      };
      function r(i, o, s) {
        o.errorMsg !== "" && (o.data === null || o.data === void 0) && o.tries < 1 + i.tileRetryMax && i.failedTiles.push(o);
        var u;
        i.jobsInProgress--, (!i.jobLimit || i.jobsInProgress < i.jobLimit) && i.jobQueue.length > 0 && (u = i.jobQueue.shift(), u.start(), i.jobsInProgress++), i.tileRetryMax > 0 && i.jobQueue.length === 0 && (!i.jobLimit || i.jobsInProgress < i.jobLimit) && i.failedTiles.length > 0 && (u = i.failedTiles.shift(), setTimeout(function() {
          u.start();
        }, i.tileRetryDelay), i.jobsInProgress++), s(o.data, o.errorMsg, o.request);
      }
    })(t), (function(n) {
      n.Tile = function(r, i, o, s, u, f, p, m, v, y, S, E) {
        this.level = r, this.x = i, this.y = o, this.bounds = s, this.positionedBounds = new t.Rect(s.x, s.y, s.width, s.height), this.sourceBounds = y, this.exists = u, this._url = f, this.postData = S, this.context2D = p, this.loadWithAjax = m, this.ajaxHeaders = v, E === void 0 && (n.console.warn("Tile constructor needs 'cacheKey' variable: creation tile cache in Tile class is deprecated. TileSource.prototype.getTileHashKey will be used."), E = n.TileSource.prototype.getTileHashKey(r, i, o, f, v, S)), this.cacheKey = E, this.loaded = !1, this.loading = !1, this.element = null, this.imgElement = null, this.style = null, this.position = null, this.size = null, this.flipped = !1, this.blendStart = null, this.opacity = null, this.squaredDistance = null, this.visibility = null, this.hasTransparency = !1, this.beingDrawn = !1, this.lastTouchTime = 0, this.isRightMost = !1, this.isBottomMost = !1;
      }, n.Tile.prototype = {
        /**
         * Provides a string representation of this tiles level and (x,y)
         * components.
         * @function
         * @returns {String}
         */
        toString: function() {
          return this.level + "/" + this.x + "_" + this.y;
        },
        // private
        _hasTransparencyChannel: function() {
          return console.warn("Tile.prototype._hasTransparencyChannel() has been deprecated and will be removed in the future. Use TileSource.prototype.hasTransparency() instead."), !!this.context2D || this.getUrl().match(".png");
        },
        /**
         * The Image object for this tile.
         * @member {Object} image
         * @memberof OpenSeadragon.Tile#
         * @deprecated
         * @returns {Image}
         */
        get image() {
          return n.console.error("[Tile.image] property has been deprecated. Use [Tile.prototype.getImage] instead."), this.getImage();
        },
        /**
         * The URL of this tile's image.
         * @member {String} url
         * @memberof OpenSeadragon.Tile#
         * @deprecated
         * @returns {String}
         */
        get url() {
          return n.console.error("[Tile.url] property has been deprecated. Use [Tile.prototype.getUrl] instead."), this.getUrl();
        },
        /**
         * Get the Image object for this tile.
         * @returns {Image}
         */
        getImage: function() {
          return this.cacheImageRecord.getImage();
        },
        /**
         * Get the url string for this tile.
         * @returns {String}
         */
        getUrl: function() {
          return typeof this._url == "function" ? this._url() : this._url;
        },
        /**
         * Get the CanvasRenderingContext2D instance for tile image data drawn
         * onto Canvas if enabled and available
         * @returns {CanvasRenderingContext2D}
         */
        getCanvasContext: function() {
          return this.context2D || this.cacheImageRecord && this.cacheImageRecord.getRenderedContext();
        },
        /**
         * Get the ratio between current and original size.
         * @function
         * @returns {Float}
         */
        getScaleForEdgeSmoothing: function() {
          var r;
          if (this.cacheImageRecord)
            r = this.cacheImageRecord.getRenderedContext();
          else if (this.context2D)
            r = this.context2D;
          else
            return n.console.warn(
              "[Tile.drawCanvas] attempting to get tile scale %s when tile's not cached",
              this.toString()
            ), 1;
          return r.canvas.width / (this.size.x * n.pixelDensityRatio);
        },
        /**
         * Get a translation vector that when applied to the tile position produces integer coordinates.
         * Needed to avoid swimming and twitching.
         * @function
         * @param {Number} [scale=1] - Scale to be applied to position.
         * @returns {OpenSeadragon.Point}
         */
        getTranslationForEdgeSmoothing: function(r, i, o) {
          var s = Math.max(1, Math.ceil((o.x - i.x) / 2)), u = Math.max(1, Math.ceil((o.y - i.y) / 2));
          return new n.Point(s, u).minus(
            this.position.times(n.pixelDensityRatio).times(r || 1).apply(function(f) {
              return f % 1;
            })
          );
        },
        /**
         * Removes tile from its container.
         * @function
         */
        unload: function() {
          this.imgElement && this.imgElement.parentNode && this.imgElement.parentNode.removeChild(this.imgElement), this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = null, this.imgElement = null, this.loaded = !1, this.loading = !1;
        }
      };
    })(t), (function(n) {
      n.OverlayPlacement = n.Placement, n.OverlayRotationMode = n.freezeObject({
        NO_ROTATION: 1,
        EXACT: 2,
        BOUNDING_BOX: 3
      }), n.Overlay = function(r, i, o) {
        var s;
        n.isPlainObject(r) ? s = r : s = {
          element: r,
          location: i,
          placement: o
        }, this.elementWrapper = document.createElement("div"), this.element = s.element, this.elementWrapper.appendChild(this.element), this.element.id ? this.elementWrapper.id = "overlay-wrapper-" + this.element.id : this.elementWrapper.id = "overlay-wrapper", this.style = this.elementWrapper.style, this._init(s);
      }, n.Overlay.prototype = {
        // private
        _init: function(r) {
          this.location = r.location, this.placement = r.placement === void 0 ? n.Placement.TOP_LEFT : r.placement, this.onDraw = r.onDraw, this.checkResize = r.checkResize === void 0 ? !0 : r.checkResize, this.width = r.width === void 0 ? null : r.width, this.height = r.height === void 0 ? null : r.height, this.rotationMode = r.rotationMode || n.OverlayRotationMode.EXACT, this.location instanceof n.Rect && (this.width = this.location.width, this.height = this.location.height, this.location = this.location.getTopLeft(), this.placement = n.Placement.TOP_LEFT), this.scales = this.width !== null && this.height !== null, this.bounds = new n.Rect(
            this.location.x,
            this.location.y,
            this.width,
            this.height
          ), this.position = this.location;
        },
        /**
         * Internal function to adjust the position of an overlay
         * depending on it size and placement.
         * @function
         * @param {OpenSeadragon.Point} position
         * @param {OpenSeadragon.Point} size
         */
        adjust: function(r, i) {
          var o = n.Placement.properties[this.placement];
          o && (o.isHorizontallyCentered ? r.x -= i.x / 2 : o.isRight && (r.x -= i.x), o.isVerticallyCentered ? r.y -= i.y / 2 : o.isBottom && (r.y -= i.y));
        },
        /**
         * @function
         */
        destroy: function() {
          var r = this.elementWrapper, i = this.style;
          r.parentNode && (r.parentNode.removeChild(r), r.prevElementParent && (i.display = "none", document.body.appendChild(r))), this.onDraw = null, i.top = "", i.left = "", i.position = "", this.width !== null && (i.width = ""), this.height !== null && (i.height = "");
          var o = n.getCssPropertyWithVendorPrefix(
            "transformOrigin"
          ), s = n.getCssPropertyWithVendorPrefix(
            "transform"
          );
          o && s && (i[o] = "", i[s] = "");
        },
        /**
         * @function
         * @param {Element} container
         */
        drawHTML: function(r, i) {
          var o = this.elementWrapper;
          o.parentNode !== r && (o.prevElementParent = o.parentNode, o.prevNextSibling = o.nextSibling, r.appendChild(o), this.style.position = "absolute", this.size = n.getElementSize(this.elementWrapper));
          var s = this._getOverlayPositionAndSize(i), u = s.position, f = this.size = s.size, p = "";
          i.overlayPreserveContentDirection && (p = i.flipped ? " scaleX(-1)" : " scaleX(1)");
          var m = i.flipped ? -s.rotate : s.rotate, v = i.flipped ? " scaleX(-1)" : "";
          if (this.onDraw)
            this.onDraw(u, f, this.element);
          else {
            var y = this.style, S = this.element.style;
            S.display = "block", y.left = u.x + "px", y.top = u.y + "px", this.width !== null && (S.width = f.x + "px"), this.height !== null && (S.height = f.y + "px");
            var E = n.getCssPropertyWithVendorPrefix(
              "transformOrigin"
            ), w = n.getCssPropertyWithVendorPrefix(
              "transform"
            );
            E && w && (m && !i.flipped ? (S[w] = "", y[E] = this._getTransformOrigin(), y[w] = "rotate(" + m + "deg)") : !m && i.flipped ? (S[w] = p, y[E] = this._getTransformOrigin(), y[w] = v) : m && i.flipped ? (S[w] = p, y[E] = this._getTransformOrigin(), y[w] = "rotate(" + m + "deg)" + v) : (S[w] = "", y[E] = "", y[w] = "")), y.display = "flex";
          }
        },
        // private
        _getOverlayPositionAndSize: function(r) {
          var i = r.pixelFromPoint(this.location, !0), o = this._getSizeInPixels(r);
          this.adjust(i, o);
          var s = 0;
          if (r.getRotation(!0) && this.rotationMode !== n.OverlayRotationMode.NO_ROTATION)
            if (this.rotationMode === n.OverlayRotationMode.BOUNDING_BOX && this.width !== null && this.height !== null) {
              var u = new n.Rect(i.x, i.y, o.x, o.y), f = this._getBoundingBox(u, r.getRotation(!0));
              i = f.getTopLeft(), o = f.getSize();
            } else
              s = r.getRotation(!0);
          return r.flipped && (i.x = r.getContainerSize().x - i.x), {
            position: i,
            size: o,
            rotate: s
          };
        },
        // private
        _getSizeInPixels: function(r) {
          var i = this.size.x, o = this.size.y;
          if (this.width !== null || this.height !== null) {
            var s = r.deltaPixelsFromPointsNoRotate(
              new n.Point(this.width || 0, this.height || 0),
              !0
            );
            this.width !== null && (i = s.x), this.height !== null && (o = s.y);
          }
          if (this.checkResize && (this.width === null || this.height === null)) {
            var u = this.size = n.getElementSize(this.elementWrapper);
            this.width === null && (i = u.x), this.height === null && (o = u.y);
          }
          return new n.Point(i, o);
        },
        // private
        _getBoundingBox: function(r, i) {
          var o = this._getPlacementPoint(r);
          return r.rotate(i, o).getBoundingBox();
        },
        // private
        _getPlacementPoint: function(r) {
          var i = new n.Point(r.x, r.y), o = n.Placement.properties[this.placement];
          return o && (o.isHorizontallyCentered ? i.x += r.width / 2 : o.isRight && (i.x += r.width), o.isVerticallyCentered ? i.y += r.height / 2 : o.isBottom && (i.y += r.height)), i;
        },
        // private
        _getTransformOrigin: function() {
          var r = "", i = n.Placement.properties[this.placement];
          return i && (i.isLeft ? r = "left" : i.isRight && (r = "right"), i.isTop ? r += " top" : i.isBottom && (r += " bottom")), r;
        },
        /**
         * Changes the overlay settings.
         * @function
         * @param {OpenSeadragon.Point|OpenSeadragon.Rect|Object} location
         * If an object is specified, the options are the same than the constructor
         * except for the element which can not be changed.
         * @param {OpenSeadragon.Placement} placement
         */
        update: function(r, i) {
          var o = n.isPlainObject(r) ? r : {
            location: r,
            placement: i
          };
          this._init({
            location: o.location || this.location,
            placement: o.placement !== void 0 ? o.placement : this.placement,
            onDraw: o.onDraw || this.onDraw,
            checkResize: o.checkResize || this.checkResize,
            width: o.width !== void 0 ? o.width : this.width,
            height: o.height !== void 0 ? o.height : this.height,
            rotationMode: o.rotationMode || this.rotationMode
          });
        },
        /**
         * Returns the current bounds of the overlay in viewport coordinates
         * @function
         * @param {OpenSeadragon.Viewport} viewport the viewport
         * @returns {OpenSeadragon.Rect} overlay bounds
         */
        getBounds: function(r) {
          n.console.assert(
            r,
            "A viewport must now be passed to Overlay.getBounds."
          );
          var i = this.width, o = this.height;
          if (i === null || o === null) {
            var s = r.deltaPointsFromPixelsNoRotate(this.size, !0);
            i === null && (i = s.x), o === null && (o = s.y);
          }
          var u = this.location.clone();
          return this.adjust(u, new n.Point(i, o)), this._adjustBoundsForRotation(
            r,
            new n.Rect(u.x, u.y, i, o)
          );
        },
        // private
        _adjustBoundsForRotation: function(r, i) {
          if (!r || r.getRotation(!0) === 0 || this.rotationMode === n.OverlayRotationMode.EXACT)
            return i;
          if (this.rotationMode === n.OverlayRotationMode.BOUNDING_BOX) {
            if (this.width === null || this.height === null)
              return i;
            var o = this._getOverlayPositionAndSize(r);
            return r.viewerElementToViewportRectangle(new n.Rect(
              o.position.x,
              o.position.y,
              o.size.x,
              o.size.y
            ));
          }
          return i.rotate(
            -r.getRotation(!0),
            this._getPlacementPoint(i)
          );
        }
      };
    })(t), (function(n) {
      const r = n;
      r.DrawerBase = class {
        constructor(o) {
          n.console.assert(o.viewer, "[Drawer] options.viewer is required"), n.console.assert(o.viewport, "[Drawer] options.viewport is required"), n.console.assert(o.element, "[Drawer] options.element is required"), this.viewer = o.viewer, this.viewport = o.viewport, this.debugGridColor = typeof o.debugGridColor == "string" ? [o.debugGridColor] : o.debugGridColor || n.DEFAULT_SETTINGS.debugGridColor, this.options = o.options || {}, this.container = n.getElement(o.element), this._renderingTarget = this._createDrawingElement(), this.canvas.style.width = "100%", this.canvas.style.height = "100%", this.canvas.style.position = "absolute", this.canvas.style.left = "0", n.setElementOpacity(this.canvas, this.viewer.opacity, !0), n.setElementPointerEventsNone(this.canvas), n.setElementTouchActionNone(this.canvas), this.container.style.textAlign = "left", this.container.appendChild(this.canvas), this._checkForAPIOverrides();
        }
        // protect the canvas member with a getter
        get canvas() {
          return this._renderingTarget;
        }
        get element() {
          return n.console.error("Drawer.element is deprecated. Use Drawer.container instead."), this.container;
        }
        /**
         * @abstract
         * @returns {String | undefined} What type of drawer this is. Must be overridden by extending classes.
         */
        getType() {
          n.console.error("Drawer.getType must be implemented by child class");
        }
        /**
         * @abstract
         * @returns {Boolean} Whether the drawer implementation is supported by the browser. Must be overridden by extending classes.
         */
        static isSupported() {
          n.console.error("Drawer.isSupported must be implemented by child class");
        }
        /**
         * @abstract
         * @returns {Element} the element to draw into
         * @private
         */
        _createDrawingElement() {
          return n.console.error("Drawer._createDrawingElement must be implemented by child class"), null;
        }
        /**
         * @abstract
         * @param {Array} tiledImages - An array of TiledImages that are ready to be drawn.
         * @private
         */
        draw(o) {
          n.console.error("Drawer.draw must be implemented by child class");
        }
        /**
         * @abstract
         * @returns {Boolean} True if rotation is supported.
         */
        canRotate() {
          n.console.error("Drawer.canRotate must be implemented by child class");
        }
        /**
         * @abstract
         */
        destroy() {
          n.console.error("Drawer.destroy must be implemented by child class");
        }
        /**
         * @param {TiledImage} tiledImage the tiled image that is calling the function
         * @returns {Boolean} Whether this drawer requires enforcing minimum tile overlap to avoid showing seams.
         * @private
         */
        minimumOverlapRequired(o) {
          return !1;
        }
        /**
         * @abstract
         * @param {Boolean} [imageSmoothingEnabled] - Whether or not the image is
         * drawn smoothly on the canvas; see imageSmoothingEnabled in
         * {@link OpenSeadragon.Options} for more explanation.
         */
        setImageSmoothingEnabled(o) {
          n.console.error("Drawer.setImageSmoothingEnabled must be implemented by child class");
        }
        /**
         * Optional public API to draw a rectangle (e.g. for debugging purposes)
         * Child classes can override this method if they wish to support this
         * @param {OpenSeadragon.Rect} rect
         */
        drawDebuggingRect(o) {
          n.console.warn("[drawer].drawDebuggingRect is not implemented by this drawer");
        }
        // Deprecated functions
        clear() {
          n.console.warn("[drawer].clear() is deprecated. The drawer is responsible for clearing itself as needed before drawing tiles.");
        }
        // Private functions
        /**
         * Ensures that child classes have provided implementations for public API methods
         * draw, canRotate, destroy, and setImageSmoothinEnabled. Throws an exception if the original
         * placeholder methods are still in place.
         * @private
         *
         */
        _checkForAPIOverrides() {
          if (this._createDrawingElement === n.DrawerBase.prototype._createDrawingElement)
            throw new Error("[drawer]._createDrawingElement must be implemented by child class");
          if (this.draw === n.DrawerBase.prototype.draw)
            throw new Error("[drawer].draw must be implemented by child class");
          if (this.canRotate === n.DrawerBase.prototype.canRotate)
            throw new Error("[drawer].canRotate must be implemented by child class");
          if (this.destroy === n.DrawerBase.prototype.destroy)
            throw new Error("[drawer].destroy must be implemented by child class");
          if (this.setImageSmoothingEnabled === n.DrawerBase.prototype.setImageSmoothingEnabled)
            throw new Error("[drawer].setImageSmoothingEnabled must be implemented by child class");
        }
        // Utility functions
        /**
         * Scale from OpenSeadragon viewer rectangle to drawer rectangle
         * (ignoring rotation)
         * @param {OpenSeadragon.Rect} rectangle - The rectangle in viewport coordinate system.
         * @returns {OpenSeadragon.Rect} Rectangle in drawer coordinate system.
         */
        viewportToDrawerRectangle(o) {
          var s = this.viewport.pixelFromPointNoRotate(o.getTopLeft(), !0), u = this.viewport.deltaPixelsFromPointsNoRotate(o.getSize(), !0);
          return new n.Rect(
            s.x * n.pixelDensityRatio,
            s.y * n.pixelDensityRatio,
            u.x * n.pixelDensityRatio,
            u.y * n.pixelDensityRatio
          );
        }
        /**
         * This function converts the given point from to the drawer coordinate by
         * multiplying it with the pixel density.
         * This function does not take rotation into account, thus assuming provided
         * point is at 0 degree.
         * @param {OpenSeadragon.Point} point - the pixel point to convert
         * @returns {OpenSeadragon.Point} Point in drawer coordinate system.
         */
        viewportCoordToDrawerCoord(o) {
          var s = this.viewport.pixelFromPointNoRotate(o, !0);
          return new n.Point(
            s.x * n.pixelDensityRatio,
            s.y * n.pixelDensityRatio
          );
        }
        // Internal utility functions
        /**
         * Calculate width and height of the canvas based on viewport dimensions
         * and pixelDensityRatio
         * @private
         * @returns {OpenSeadragon.Point} {x, y} size of the canvas
         */
        _calculateCanvasSize() {
          var o = n.pixelDensityRatio, s = this.viewport.getContainerSize();
          return new r.Point(Math.round(s.x * o), Math.round(s.y * o));
        }
        /**
         * Called by implementations to fire the tiled-image-drawn event (used by tests)
         * @private
         */
        _raiseTiledImageDrawnEvent(o, s) {
          this.viewer && this.viewer.raiseEvent("tiled-image-drawn", {
            tiledImage: o,
            tiles: s
          });
        }
        /**
         * Called by implementations to fire the drawer-error event
         * @private
         */
        _raiseDrawerErrorEvent(o, s) {
          this.viewer && this.viewer.raiseEvent("drawer-error", {
            tiledImage: o,
            drawer: this,
            error: s
          });
        }
      };
    })(t), (function(n) {
      const r = n;
      class i extends r.DrawerBase {
        constructor(s) {
          super(s), this.viewer.rejectEventHandler("tile-drawing", "The HTMLDrawer does not raise the tile-drawing event"), this.viewer.allowEventHandler("tile-drawn");
        }
        /**
         * @returns {Boolean} always true
         */
        static isSupported() {
          return !0;
        }
        /**
         *
         * @returns 'html'
         */
        getType() {
          return "html";
        }
        /**
         * @param {TiledImage} tiledImage the tiled image that is calling the function
         * @returns {Boolean} Whether this drawer requires enforcing minimum tile overlap to avoid showing seams.
         * @private
         */
        minimumOverlapRequired(s) {
          return !0;
        }
        /**
         * create the HTML element (e.g. canvas, div) that the image will be drawn into
         * @returns {Element} the div to draw into
         */
        _createDrawingElement() {
          return n.makeNeutralElement("div");
        }
        /**
         * Draws the TiledImages
         */
        draw(s) {
          var u = this;
          this._prepareNewFrame(), s.forEach(function(f) {
            f.opacity !== 0 && u._drawTiles(f);
          });
        }
        /**
         * @returns {Boolean} False - rotation is not supported.
         */
        canRotate() {
          return !1;
        }
        /**
         * Destroy the drawer (unload current loaded tiles)
         */
        destroy() {
          this.container.removeChild(this.canvas);
        }
        /**
         * This function is ignored by the HTML Drawer. Implementing it is required by DrawerBase.
         * @param {Boolean} [imageSmoothingEnabled] - Whether or not the image is
         * drawn smoothly on the canvas; see imageSmoothingEnabled in
         * {@link OpenSeadragon.Options} for more explanation.
         */
        setImageSmoothingEnabled() {
        }
        /**
         * Clears the Drawer so it's ready to draw another frame.
         * @private
         *
         */
        _prepareNewFrame() {
          this.canvas.innerHTML = "";
        }
        /**
         * Draws a TiledImage.
         * @private
         *
         */
        _drawTiles(s) {
          var u = s.getTilesToDraw().map((m) => m.tile);
          if (!(s.opacity === 0 || u.length === 0 && !s.placeholderFillStyle))
            for (var f = u.length - 1; f >= 0; f--) {
              var p = u[f];
              this._drawTile(p), this.viewer && this.viewer.raiseEvent("tile-drawn", {
                tiledImage: s,
                tile: p
              });
            }
        }
        /**
         * Draws the given tile.
         * @private
         * @param {OpenSeadragon.Tile} tile - The tile to draw.
         * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
         * drawingHandler({context, tile, rendered})
         */
        _drawTile(s) {
          n.console.assert(s, "[Drawer._drawTile] tile is required");
          let u = this.canvas;
          if (!s.cacheImageRecord) {
            n.console.warn(
              "[Drawer._drawTileToHTML] attempting to draw tile %s when it's not cached",
              s.toString()
            );
            return;
          }
          if (!s.loaded) {
            n.console.warn(
              "Attempting to draw tile %s when it's not yet loaded.",
              s.toString()
            );
            return;
          }
          if (!s.element) {
            var f = s.getImage();
            if (!f)
              return;
            s.element = n.makeNeutralElement("div"), s.imgElement = f.cloneNode(), s.imgElement.style.msInterpolationMode = "nearest-neighbor", s.imgElement.style.width = "100%", s.imgElement.style.height = "100%", s.style = s.element.style, s.style.position = "absolute";
          }
          s.element.parentNode !== u && u.appendChild(s.element), s.imgElement.parentNode !== s.element && s.element.appendChild(s.imgElement), s.style.top = s.position.y + "px", s.style.left = s.position.x + "px", s.style.height = s.size.y + "px", s.style.width = s.size.x + "px", s.flipped && (s.style.transform = "scaleX(-1)"), n.setElementOpacity(s.element, s.opacity);
        }
      }
      n.HTMLDrawer = i;
    })(t), (function(n) {
      const r = n;
      class i extends r.DrawerBase {
        constructor(m) {
          super(m), this.context = this.canvas.getContext("2d"), this.sketchCanvas = null, this.sketchContext = null, this._imageSmoothingEnabled = !0, this.viewer.allowEventHandler("tile-drawn"), this.viewer.allowEventHandler("tile-drawing");
        }
        /**
         * @returns {Boolean} true if canvas is supported by the browser, otherwise false
         */
        static isSupported() {
          return n.supportsCanvas;
        }
        getType() {
          return "canvas";
        }
        /**
         * create the HTML element (e.g. canvas, div) that the image will be drawn into
         * @returns {Element} the canvas to draw into
         */
        _createDrawingElement() {
          let m = n.makeNeutralElement("canvas"), v = this._calculateCanvasSize();
          return m.width = v.x, m.height = v.y, m;
        }
        /**
         * Draws the TiledImages
         */
        draw(m) {
          this._prepareNewFrame(), this.viewer.viewport.getFlip() !== this._viewportFlipped && this._flip();
          for (const v of m)
            v.opacity !== 0 && this._drawTiles(v);
        }
        /**
         * @returns {Boolean} True - rotation is supported.
         */
        canRotate() {
          return !0;
        }
        /**
         * Destroy the drawer (unload current loaded tiles)
         */
        destroy() {
          this.canvas.width = 1, this.canvas.height = 1, this.sketchCanvas = null, this.sketchContext = null, this.container.removeChild(this.canvas);
        }
        /**
         * @param {TiledImage} tiledImage the tiled image that is calling the function
         * @returns {Boolean} Whether this drawer requires enforcing minimum tile overlap to avoid showing seams.
         * @private
         */
        minimumOverlapRequired(m) {
          return !0;
        }
        /**
         * Turns image smoothing on or off for this viewer. Note: Ignored in some (especially older) browsers that do not support this property.
         *
         * @function
         * @param {Boolean} [imageSmoothingEnabled] - Whether or not the image is
         * drawn smoothly on the canvas; see imageSmoothingEnabled in
         * {@link OpenSeadragon.Options} for more explanation.
         */
        setImageSmoothingEnabled(m) {
          this._imageSmoothingEnabled = !!m, this._updateImageSmoothingEnabled(this.context), this.viewer.forceRedraw();
        }
        /**
         * Draw a rectangle onto the canvas
         * @param {OpenSeadragon.Rect} rect
         */
        drawDebuggingRect(m) {
          var v = this.context;
          v.save(), v.lineWidth = 2 * n.pixelDensityRatio, v.strokeStyle = this.debugGridColor[0], v.fillStyle = this.debugGridColor[0], v.strokeRect(
            m.x * n.pixelDensityRatio,
            m.y * n.pixelDensityRatio,
            m.width * n.pixelDensityRatio,
            m.height * n.pixelDensityRatio
          ), v.restore();
        }
        /**
         * Test whether the current context is flipped or not
         * @private
         */
        get _viewportFlipped() {
          return this.context.getTransform().a < 0;
        }
        /**
         * Fires the tile-drawing event.
         * @private
         */
        _raiseTileDrawingEvent(m, v, y, S) {
          this.viewer.raiseEvent("tile-drawing", {
            tiledImage: m,
            context: v,
            tile: y,
            rendered: S
          });
        }
        /**
         * Clears the Drawer so it's ready to draw another frame.
         * @private
         *
         */
        _prepareNewFrame() {
          var m = this._calculateCanvasSize();
          if ((this.canvas.width !== m.x || this.canvas.height !== m.y) && (this.canvas.width = m.x, this.canvas.height = m.y, this._updateImageSmoothingEnabled(this.context), this.sketchCanvas !== null)) {
            var v = this._calculateSketchCanvasSize();
            this.sketchCanvas.width = v.x, this.sketchCanvas.height = v.y, this._updateImageSmoothingEnabled(this.sketchContext);
          }
          this._clear();
        }
        /**
         * @private
         * @param {Boolean} useSketch Whether to clear sketch canvas or main canvas
         * @param {OpenSeadragon.Rect} [bounds] The rectangle to clear
         */
        _clear(m, v) {
          var y = this._getContext(m);
          if (v)
            y.clearRect(v.x, v.y, v.width, v.height);
          else {
            var S = y.canvas;
            y.clearRect(0, 0, S.width, S.height);
          }
        }
        /**
         * Draws a TiledImage.
         * @private
         *
         */
        _drawTiles(m) {
          var v = m.getTilesToDraw().map((F) => F.tile);
          if (!(m.opacity === 0 || v.length === 0 && !m.placeholderFillStyle)) {
            var y = v[0], S;
            y && (S = m.opacity < 1 || m.compositeOperation && m.compositeOperation !== "source-over" || !m._isBottomItem() && m.source.hasTransparency(y.context2D, y.getUrl(), y.ajaxHeaders, y.postData));
            var E, w, _ = this.viewport.getZoom(!0), O = m.viewportToImageZoom(_);
            v.length > 1 && O > m.smoothTileEdgesMinZoom && !m.iOSDevice && m.getRotation(!0) % 360 === 0 && (S = !0, E = y.getScaleForEdgeSmoothing(), w = y.getTranslationForEdgeSmoothing(
              E,
              this._getCanvasSize(!1),
              this._getCanvasSize(!0)
            ));
            var D;
            S && (E || (D = this.viewport.viewportToViewerElementRectangle(
              m.getClippedBounds(!0)
            ).getIntegerBoundingBox(), D = D.times(n.pixelDensityRatio)), this._clear(!0, D)), E || this._setRotations(m, S);
            var P = !1;
            if (m._clip) {
              this._saveContext(S);
              var M = m.imageToViewportRectangle(m._clip, !0);
              M = M.rotate(-m.getRotation(!0), m._getRotationPoint(!0));
              var N = this.viewportToDrawerRectangle(M);
              E && (N = N.times(E)), w && (N = N.translate(w)), this._setClip(N, S), P = !0;
            }
            if (m._croppingPolygons) {
              var k = this;
              P || this._saveContext(S);
              try {
                var U = m._croppingPolygons.map(function(F) {
                  return F.map(function(X) {
                    var oe = m.imageToViewportCoordinates(X.x, X.y, !0).rotate(-m.getRotation(!0), m._getRotationPoint(!0)), re = k.viewportCoordToDrawerCoord(oe);
                    return E && (re = re.times(E)), w && (re = re.plus(w)), re;
                  });
                });
                this._clipWithPolygons(U, S);
              } catch (F) {
                n.console.error(F);
              }
              P = !0;
            }
            if (m._hasOpaqueTile = !1, m.placeholderFillStyle && m._hasOpaqueTile === !1) {
              let F = this.viewportToDrawerRectangle(m.getBoundsNoRotate(!0));
              E && (F = F.times(E)), w && (F = F.translate(w));
              let X = null;
              typeof m.placeholderFillStyle == "function" ? X = m.placeholderFillStyle(m, this.context) : X = m.placeholderFillStyle, this._drawRectangle(F, X, S);
            }
            var H = f(m.subPixelRoundingForTransparency), Y = !1;
            if (H === n.SUBPIXEL_ROUNDING_OCCURRENCES.ALWAYS)
              Y = !0;
            else if (H === n.SUBPIXEL_ROUNDING_OCCURRENCES.ONLY_AT_REST) {
              var z = this.viewer && this.viewer.isAnimating();
              Y = !z;
            }
            for (var V = 0; V < v.length; V++)
              y = v[V], this._drawTile(
                y,
                m,
                S,
                E,
                w,
                Y,
                m.source
              ), this.viewer && this.viewer.raiseEvent("tile-drawn", {
                tiledImage: m,
                tile: y
              });
            P && this._restoreContext(S), E || (m.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(S), this.viewport.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(S)), S && (E && this._setRotations(m), this.blendSketch({
              opacity: m.opacity,
              scale: E,
              translate: w,
              compositeOperation: m.compositeOperation,
              bounds: D
            }), E && (m.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(!1), this.viewport.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(!1))), this._drawDebugInfo(m, v), this._raiseTiledImageDrawnEvent(m, v);
          }
        }
        /**
         * Draws special debug information for a TiledImage if in debug mode.
         * @private
         * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
         */
        _drawDebugInfo(m, v) {
          if (m.debugMode)
            for (var y = v.length - 1; y >= 0; y--) {
              var S = v[y];
              try {
                this._drawDebugInfoOnTile(S, v.length, y, m);
              } catch (E) {
                n.console.error(E);
              }
            }
        }
        /**
         * This function will create multiple polygon paths on the drawing context by provided polygons,
         * then clip the context to the paths.
         * @private
         * @param {OpenSeadragon.Point[][]} polygons - an array of polygons. A polygon is an array of OpenSeadragon.Point
         * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
         */
        _clipWithPolygons(m, v) {
          var y = this._getContext(v);
          y.beginPath();
          for (const S of m)
            for (const [E, w] of S.entries())
              y[E === 0 ? "moveTo" : "lineTo"](w.x, w.y);
          y.clip();
        }
        /**
         * Draws the given tile.
         * @private
         * @param {OpenSeadragon.Tile} tile - The tile to draw.
         * @param {OpenSeadragon.TiledImage} tiledImage - The tiled image being drawn.
         * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
         * where <code>rendered</code> is the context with the pre-drawn image.
         * @param {Float} [scale=1] - Apply a scale to tile position and size. Defaults to 1.
         * @param {OpenSeadragon.Point} [translate] A translation vector to offset tile position
         * @param {Boolean} [shouldRoundPositionAndSize] - Tells whether to round
         * position and size of tiles supporting alpha channel in non-transparency
         * context.
         * @param {OpenSeadragon.TileSource} source - The source specification of the tile.
         */
        _drawTile(m, v, y, S, E, w, _) {
          n.console.assert(m, "[Drawer._drawTile] tile is required"), n.console.assert(v, "[Drawer._drawTile] drawingHandler is required");
          var O = this._getContext(y);
          S = S || 1, this._drawTileToCanvas(m, O, v, S, E, w, _);
        }
        /**
         * Renders the tile in a canvas-based context.
         * @private
         * @function
         * @param {OpenSeadragon.Tile} tile - the tile to draw to the canvas
         * @param {Canvas} context
         * @param {OpenSeadragon.TiledImage} tiledImage - Method for firing the drawing event.
         * drawingHandler({context, tile, rendered})
         * where <code>rendered</code> is the context with the pre-drawn image.
         * @param {Number} [scale=1] - Apply a scale to position and size
         * @param {OpenSeadragon.Point} [translate] - A translation vector
         * @param {Boolean} [shouldRoundPositionAndSize] - Tells whether to round
         * position and size of tiles supporting alpha channel in non-transparency
         * context.
         * @param {OpenSeadragon.TileSource} source - The source specification of the tile.
         */
        _drawTileToCanvas(m, v, y, S, E, w, _) {
          var O = m.position.times(n.pixelDensityRatio), D = m.size.times(n.pixelDensityRatio), P;
          if (!m.context2D && !m.cacheImageRecord) {
            n.console.warn(
              "[Drawer._drawTileToCanvas] attempting to draw tile %s when it's not cached",
              m.toString()
            );
            return;
          }
          if (P = m.getCanvasContext(), !m.loaded || !P) {
            n.console.warn(
              "Attempting to draw tile %s when it's not yet loaded.",
              m.toString()
            );
            return;
          }
          v.save(), typeof S == "number" && S !== 1 && (O = O.times(S), D = D.times(S)), E instanceof n.Point && (O = O.plus(E)), v.globalAlpha === 1 && m.hasTransparency && (w && (O.x = Math.round(O.x), O.y = Math.round(O.y), D.x = Math.round(D.x), D.y = Math.round(D.y)), v.clearRect(
            O.x,
            O.y,
            D.x,
            D.y
          )), this._raiseTileDrawingEvent(y, v, m, P);
          var M, N;
          m.sourceBounds ? (M = Math.min(m.sourceBounds.width, P.canvas.width), N = Math.min(m.sourceBounds.height, P.canvas.height)) : (M = P.canvas.width, N = P.canvas.height), v.translate(O.x + D.x / 2, 0), m.flipped && v.scale(-1, 1), v.drawImage(
            P.canvas,
            0,
            0,
            M,
            N,
            -D.x / 2,
            O.y,
            D.x,
            D.y
          ), v.restore();
        }
        /**
         * Get the context of the main or sketch canvas
         * @private
         * @param {Boolean} useSketch
         * @returns {CanvasRenderingContext2D}
         */
        _getContext(m) {
          var v = this.context;
          if (m) {
            if (this.sketchCanvas === null) {
              this.sketchCanvas = document.createElement("canvas");
              var y = this._calculateSketchCanvasSize();
              if (this.sketchCanvas.width = y.x, this.sketchCanvas.height = y.y, this.sketchContext = this.sketchCanvas.getContext("2d"), this.viewport.getRotation() === 0) {
                var S = this;
                this.viewer.addHandler("rotate", function E() {
                  if (S.viewport.getRotation() !== 0) {
                    S.viewer.removeHandler("rotate", E);
                    var w = S._calculateSketchCanvasSize();
                    S.sketchCanvas.width = w.x, S.sketchCanvas.height = w.y;
                  }
                });
              }
              this._updateImageSmoothingEnabled(this.sketchContext);
            }
            v = this.sketchContext;
          }
          return v;
        }
        /**
         * Save the context of the main or sketch canvas
         * @private
         * @param {Boolean} useSketch
         */
        _saveContext(m) {
          this._getContext(m).save();
        }
        /**
         * Restore the context of the main or sketch canvas
         * @private
         * @param {Boolean} useSketch
         */
        _restoreContext(m) {
          this._getContext(m).restore();
        }
        // private
        _setClip(m, v) {
          var y = this._getContext(v);
          y.beginPath(), y.rect(m.x, m.y, m.width, m.height), y.clip();
        }
        // private
        // used to draw a placeholder rectangle
        _drawRectangle(m, v, y) {
          var S = this._getContext(y);
          S.save(), S.fillStyle = v, S.fillRect(m.x, m.y, m.width, m.height), S.restore();
        }
        /**
         * Blends the sketch canvas in the main canvas.
         * @param {Object} options The options
         * @param {Float} options.opacity The opacity of the blending.
         * @param {Float} [options.scale=1] The scale at which tiles were drawn on
         * the sketch. Default is 1.
         * Use scale to draw at a lower scale and then enlarge onto the main canvas.
         * @param {OpenSeadragon.Point} [options.translate] A translation vector
         * that was used to draw the tiles
         * @param {String} [options.compositeOperation] - How the image is
         * composited onto other images; see compositeOperation in
         * {@link OpenSeadragon.Options} for possible values.
         * @param {OpenSeadragon.Rect} [options.bounds] The part of the sketch
         * canvas to blend in the main canvas. If specified, options.scale and
         * options.translate get ignored.
         */
        blendSketch(m, v, y, S) {
          var E = m;
          n.isPlainObject(E) || (E = {
            opacity: m,
            scale: v,
            translate: y,
            compositeOperation: S
          }), m = E.opacity, S = E.compositeOperation;
          var w = E.bounds;
          if (this.context.save(), this.context.globalAlpha = m, S && (this.context.globalCompositeOperation = S), w)
            w.x < 0 && (w.width += w.x, w.x = 0), w.x + w.width > this.canvas.width && (w.width = this.canvas.width - w.x), w.y < 0 && (w.height += w.y, w.y = 0), w.y + w.height > this.canvas.height && (w.height = this.canvas.height - w.y), this.context.drawImage(
              this.sketchCanvas,
              w.x,
              w.y,
              w.width,
              w.height,
              w.x,
              w.y,
              w.width,
              w.height
            );
          else {
            v = E.scale || 1, y = E.translate;
            var _ = y instanceof n.Point ? y : new n.Point(0, 0), O = 0, D = 0;
            if (y) {
              var P = this.sketchCanvas.width - this.canvas.width, M = this.sketchCanvas.height - this.canvas.height;
              O = Math.round(P / 2), D = Math.round(M / 2);
            }
            this.context.drawImage(
              this.sketchCanvas,
              _.x - O * v,
              _.y - D * v,
              (this.canvas.width + 2 * O) * v,
              (this.canvas.height + 2 * D) * v,
              -O,
              -D,
              this.canvas.width + 2 * O,
              this.canvas.height + 2 * D
            );
          }
          this.context.restore();
        }
        // private
        _drawDebugInfoOnTile(m, v, y, S) {
          var E = this.viewer.world.getIndexOfItem(S) % this.debugGridColor.length, w = this.context;
          w.save(), w.lineWidth = 2 * n.pixelDensityRatio, w.font = "small-caps bold " + 13 * n.pixelDensityRatio + "px arial", w.strokeStyle = this.debugGridColor[E], w.fillStyle = this.debugGridColor[E], this._setRotations(S), this._viewportFlipped && this._flip({ point: m.position.plus(m.size.divide(2)) }), w.strokeRect(
            m.position.x * n.pixelDensityRatio,
            m.position.y * n.pixelDensityRatio,
            m.size.x * n.pixelDensityRatio,
            m.size.y * n.pixelDensityRatio
          );
          var _ = (m.position.x + m.size.x / 2) * n.pixelDensityRatio, O = (m.position.y + m.size.y / 2) * n.pixelDensityRatio;
          w.translate(_, O);
          const D = this.viewport.getRotation(!0);
          w.rotate(Math.PI / 180 * -D), w.translate(-_, -O), m.x === 0 && m.y === 0 && (w.fillText(
            "Zoom: " + this.viewport.getZoom(),
            m.position.x * n.pixelDensityRatio,
            (m.position.y - 30) * n.pixelDensityRatio
          ), w.fillText(
            "Pan: " + this.viewport.getBounds().toString(),
            m.position.x * n.pixelDensityRatio,
            (m.position.y - 20) * n.pixelDensityRatio
          )), w.fillText(
            "Level: " + m.level,
            (m.position.x + 10) * n.pixelDensityRatio,
            (m.position.y + 20) * n.pixelDensityRatio
          ), w.fillText(
            "Column: " + m.x,
            (m.position.x + 10) * n.pixelDensityRatio,
            (m.position.y + 30) * n.pixelDensityRatio
          ), w.fillText(
            "Row: " + m.y,
            (m.position.x + 10) * n.pixelDensityRatio,
            (m.position.y + 40) * n.pixelDensityRatio
          ), w.fillText(
            "Order: " + y + " of " + v,
            (m.position.x + 10) * n.pixelDensityRatio,
            (m.position.y + 50) * n.pixelDensityRatio
          ), w.fillText(
            "Size: " + m.size.toString(),
            (m.position.x + 10) * n.pixelDensityRatio,
            (m.position.y + 60) * n.pixelDensityRatio
          ), w.fillText(
            "Position: " + m.position.toString(),
            (m.position.x + 10) * n.pixelDensityRatio,
            (m.position.y + 70) * n.pixelDensityRatio
          ), this.viewport.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(), S.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(), w.restore();
        }
        // private
        _updateImageSmoothingEnabled(m) {
          m.msImageSmoothingEnabled = this._imageSmoothingEnabled, m.imageSmoothingEnabled = this._imageSmoothingEnabled;
        }
        /**
         * Get the canvas size
         * @private
         * @param {Boolean} sketch If set to true return the size of the sketch canvas
         * @returns {OpenSeadragon.Point} The size of the canvas
         */
        _getCanvasSize(m) {
          var v = this._getContext(m).canvas;
          return new n.Point(v.width, v.height);
        }
        /**
         * Get the canvas center
         * @private
         * @param {Boolean} sketch If set to true return the center point of the sketch canvas
         * @returns {OpenSeadragon.Point} The center point of the canvas
         */
        _getCanvasCenter() {
          return new n.Point(this.canvas.width / 2, this.canvas.height / 2);
        }
        /**
         * Set rotations for viewport & tiledImage
         * @private
         * @param {OpenSeadragon.TiledImage} tiledImage
         * @param {Boolean} [useSketch=false]
         */
        _setRotations(m, v = !1) {
          var y = !1;
          this.viewport.getRotation(!0) % 360 !== 0 && (this._offsetForRotation({
            degrees: this.viewport.getRotation(!0),
            useSketch: v,
            saveContext: y
          }), y = !1), m.getRotation(!0) % 360 !== 0 && this._offsetForRotation({
            degrees: m.getRotation(!0),
            point: this.viewport.pixelFromPointNoRotate(
              m._getRotationPoint(!0),
              !0
            ),
            useSketch: v,
            saveContext: y
          });
        }
        // private
        _offsetForRotation(m) {
          var v = m.point ? m.point.times(n.pixelDensityRatio) : this._getCanvasCenter(), y = this._getContext(m.useSketch);
          y.save(), y.translate(v.x, v.y), y.rotate(Math.PI / 180 * m.degrees), y.translate(-v.x, -v.y);
        }
        // private
        _flip(m) {
          m = m || {};
          var v = m.point ? m.point.times(n.pixelDensityRatio) : this._getCanvasCenter(), y = this._getContext(m.useSketch);
          y.translate(v.x, 0), y.scale(-1, 1), y.translate(-v.x, 0);
        }
        // private
        _restoreRotationChanges(m) {
          var v = this._getContext(m);
          v.restore();
        }
        // private
        _calculateCanvasSize() {
          var m = n.pixelDensityRatio, v = this.viewport.getContainerSize();
          return {
            // canvas width and height are integers
            x: Math.round(v.x * m),
            y: Math.round(v.y * m)
          };
        }
        // private
        _calculateSketchCanvasSize() {
          var m = this._calculateCanvasSize();
          if (this.viewport.getRotation() === 0)
            return m;
          var v = Math.ceil(Math.sqrt(
            m.x * m.x + m.y * m.y
          ));
          return {
            x: v,
            y: v
          };
        }
      }
      n.CanvasDrawer = i;
      var o = n.SUBPIXEL_ROUNDING_OCCURRENCES.NEVER;
      function s(p) {
        return p !== n.SUBPIXEL_ROUNDING_OCCURRENCES.ALWAYS && p !== n.SUBPIXEL_ROUNDING_OCCURRENCES.ONLY_AT_REST && p !== n.SUBPIXEL_ROUNDING_OCCURRENCES.NEVER;
      }
      function u(p) {
        return s(p) ? o : p;
      }
      function f(p) {
        if (typeof p == "number")
          return u(p);
        if (!p || !n.Browser)
          return o;
        var m = p[n.Browser.vendor];
        return s(m) && (m = p["*"]), u(m);
      }
    })(t), (function(n) {
      const r = n;
      r.WebGLDrawer = class extends r.DrawerBase {
        constructor(o) {
          super(o), this._destroyed = !1, this._TextureMap = /* @__PURE__ */ new Map(), this._TileMap = /* @__PURE__ */ new Map(), this._gl = null, this._firstPass = null, this._secondPass = null, this._glFrameBuffer = null, this._renderToTexture = null, this._glFramebufferToCanvasTransform = null, this._outputCanvas = null, this._outputContext = null, this._clippingCanvas = null, this._clippingContext = null, this._renderingCanvas = null, this._backupCanvasDrawer = null, this._imageSmoothingEnabled = !0, this._boundToTileReady = (s) => this._tileReadyHandler(s), this._boundToImageUnloaded = (s) => this._imageUnloadedHandler(s), this.viewer.addHandler("tile-ready", this._boundToTileReady), this.viewer.addHandler("image-unloaded", this._boundToImageUnloaded), this.viewer.rejectEventHandler("tile-drawn", "The WebGLDrawer does not raise the tile-drawn event"), this.viewer.rejectEventHandler("tile-drawing", "The WebGLDrawer does not raise the tile-drawing event"), this._setupCanvases(), this._setupRenderer(), this.context = this._outputContext;
        }
        // Public API required by all Drawer implementations
        /**
        * Clean up the renderer, removing all resources
        */
        destroy() {
          if (this._destroyed)
            return;
          let o = this._gl;
          var s = o.getParameter(o.MAX_TEXTURE_IMAGE_UNITS);
          for (let f = 0; f < s; ++f)
            o.activeTexture(o.TEXTURE0 + f), o.bindTexture(o.TEXTURE_2D, null), o.bindTexture(o.TEXTURE_CUBE_MAP, null);
          o.bindBuffer(o.ARRAY_BUFFER, null), o.bindBuffer(o.ELEMENT_ARRAY_BUFFER, null), o.bindRenderbuffer(o.RENDERBUFFER, null), o.bindFramebuffer(o.FRAMEBUFFER, null), this._unloadTextures(), o.deleteBuffer(this._secondPass.bufferOutputPosition), o.deleteFramebuffer(this._glFrameBuffer), this._renderingCanvas.width = this._renderingCanvas.height = 1, this._clippingCanvas.width = this._clippingCanvas.height = 1, this._outputCanvas.width = this._outputCanvas.height = 1, this._renderingCanvas = null, this._clippingCanvas = this._clippingContext = null, this._outputCanvas = this._outputContext = null;
          let u = o.getExtension("WEBGL_lose_context");
          u && u.loseContext(), this.viewer.removeHandler("tile-ready", this._boundToTileReady), this.viewer.removeHandler("image-unloaded", this._boundToImageUnloaded), this.viewer.removeHandler("resize", this._resizeHandler), this._gl = null, this._backupCanvasDrawer && (this._backupCanvasDrawer.destroy(), this._backupCanvasDrawer = null), this.container.removeChild(this.canvas), this.viewer.drawer === this && (this.viewer.drawer = null), this._destroyed = !0;
        }
        // Public API required by all Drawer implementations
        /**
        *
        * @returns {Boolean} true
        */
        canRotate() {
          return !0;
        }
        // Public API required by all Drawer implementations
        /**
        * @returns {Boolean} true if canvas and webgl are supported
        */
        static isSupported() {
          let o = document.createElement("canvas"), s = n.isFunction(o.getContext) && o.getContext("webgl"), u = s && s.getExtension("WEBGL_lose_context");
          return u && u.loseContext(), !!s;
        }
        /**
         *
         * @returns 'webgl'
         */
        getType() {
          return "webgl";
        }
        /**
         * @param {TiledImage} tiledImage the tiled image that is calling the function
         * @returns {Boolean} Whether this drawer requires enforcing minimum tile overlap to avoid showing seams.
         * @private
         */
        minimumOverlapRequired(o) {
          return o.isTainted();
        }
        /**
        * create the HTML element (canvas in this case) that the image will be drawn into
        * @private
        * @returns {Element} the canvas to draw into
        */
        _createDrawingElement() {
          let o = n.makeNeutralElement("canvas"), s = this._calculateCanvasSize();
          return o.width = s.x, o.height = s.y, o;
        }
        /**
         * Get the backup renderer (CanvasDrawer) to use if data cannot be used by webgl
         * Lazy loaded
         * @private
         * @returns {CanvasDrawer}
         */
        _getBackupCanvasDrawer() {
          return this._backupCanvasDrawer || (this._backupCanvasDrawer = this.viewer.requestDrawer("canvas", { mainDrawer: !1 }), this._backupCanvasDrawer.canvas.style.setProperty("visibility", "hidden")), this._backupCanvasDrawer;
        }
        /**
        *
        * @param {Array} tiledImages Array of TiledImage objects to draw
        */
        draw(o) {
          let s = this._gl;
          const u = this.viewport.getBoundsNoRotateWithMargins(!0);
          let f = {
            bounds: u,
            center: new r.Point(u.x + u.width / 2, u.y + u.height / 2),
            rotation: this.viewport.getRotation(!0) * Math.PI / 180
          }, p = this.viewport.flipped ? -1 : 1, m = n.Mat3.makeTranslation(-f.center.x, -f.center.y), v = n.Mat3.makeScaling(2 / f.bounds.width * p, -2 / f.bounds.height), y = n.Mat3.makeRotation(-f.rotation), S = v.multiply(y).multiply(m);
          s.bindFramebuffer(s.FRAMEBUFFER, null), s.clear(s.COLOR_BUFFER_BIT), this._outputContext.clearRect(0, 0, this._outputCanvas.width, this._outputCanvas.height);
          let E = !1;
          o.forEach((w, _) => {
            if (w.isTainted()) {
              E && (this._outputContext.drawImage(this._renderingCanvas, 0, 0), s.bindFramebuffer(s.FRAMEBUFFER, null), s.clear(s.COLOR_BUFFER_BIT), E = !1);
              const O = this._getBackupCanvasDrawer();
              O.draw([w]), this._outputContext.drawImage(O.canvas, 0, 0);
            } else {
              let O = w.getTilesToDraw();
              if (w.placeholderFillStyle && w._hasOpaqueTile === !1 && this._drawPlaceholder(w), O.length === 0 || w.getOpacity() === 0)
                return;
              let D = O[0], P = w.compositeOperation || this.viewer.compositeOperation || w._clip || w._croppingPolygons || w.debugMode, M = P || w.opacity < 1 || D.hasTransparency;
              P && (E && this._outputContext.drawImage(this._renderingCanvas, 0, 0), s.bindFramebuffer(s.FRAMEBUFFER, null), s.clear(s.COLOR_BUFFER_BIT)), s.useProgram(this._firstPass.shaderProgram), M ? (s.bindFramebuffer(s.FRAMEBUFFER, this._glFrameBuffer), s.clear(s.COLOR_BUFFER_BIT)) : s.bindFramebuffer(s.FRAMEBUFFER, null);
              let N = S, k = w.getRotation(!0);
              if (k % 360 !== 0) {
                let F = n.Mat3.makeRotation(-k * Math.PI / 180), X = w.getBoundsNoRotate(!0).getCenter(), oe = n.Mat3.makeTranslation(X.x, X.y), re = n.Mat3.makeTranslation(-X.x, -X.y), Z = oe.multiply(F).multiply(re);
                N = S.multiply(Z);
              }
              let U = this._gl.getParameter(this._gl.MAX_TEXTURE_IMAGE_UNITS);
              if (U <= 0)
                throw new Error(`WegGL error: bad value for gl parameter MAX_TEXTURE_IMAGE_UNITS (${U}). This could happen
                        if too many contexts have been created and not released, or there is another problem with the graphics card.`);
              let H = new Float32Array(U * 12), Y = new Array(U), z = new Array(U), V = new Array(U);
              for (let F = 0; F < O.length; F++) {
                let X = O[F].tile, oe = F % U, re = oe + 1, Z = X.getCanvasContext(), ee = Z ? this._TextureMap.get(Z.canvas) : null;
                if (ee || (this._tileReadyHandler({ tile: X, tiledImage: w }), ee = Z ? this._TextureMap.get(Z.canvas) : null), ee && this._getTileData(X, w, ee, N, oe, H, Y, z, V), re === U || F === O.length - 1) {
                  for (let J = 0; J <= re; J++)
                    s.activeTexture(s.TEXTURE0 + J), s.bindTexture(s.TEXTURE_2D, Y[J]);
                  s.bindBuffer(s.ARRAY_BUFFER, this._firstPass.bufferTexturePosition), s.bufferData(s.ARRAY_BUFFER, H, s.DYNAMIC_DRAW), z.forEach((J, le) => {
                    s.uniformMatrix3fv(this._firstPass.uTransformMatrices[le], !1, J);
                  }), s.uniform1fv(this._firstPass.uOpacities, new Float32Array(V)), s.bindBuffer(s.ARRAY_BUFFER, this._firstPass.bufferOutputPosition), s.vertexAttribPointer(this._firstPass.aOutputPosition, 2, s.FLOAT, !1, 0, 0), s.bindBuffer(s.ARRAY_BUFFER, this._firstPass.bufferTexturePosition), s.vertexAttribPointer(this._firstPass.aTexturePosition, 2, s.FLOAT, !1, 0, 0), s.bindBuffer(s.ARRAY_BUFFER, this._firstPass.bufferIndex), s.vertexAttribPointer(this._firstPass.aIndex, 1, s.FLOAT, !1, 0, 0), s.drawArrays(s.TRIANGLES, 0, 6 * re);
                }
              }
              M && (s.useProgram(this._secondPass.shaderProgram), s.bindFramebuffer(s.FRAMEBUFFER, null), s.activeTexture(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, this._renderToTexture), this._gl.uniform1f(this._secondPass.uOpacityMultiplier, w.opacity), s.bindBuffer(s.ARRAY_BUFFER, this._secondPass.bufferTexturePosition), s.vertexAttribPointer(this._secondPass.aTexturePosition, 2, s.FLOAT, !1, 0, 0), s.bindBuffer(s.ARRAY_BUFFER, this._secondPass.bufferOutputPosition), s.vertexAttribPointer(this._secondPass.aOutputPosition, 2, s.FLOAT, !1, 0, 0), s.drawArrays(s.TRIANGLES, 0, 6)), E = !0, P && (this._applyContext2dPipeline(w, O, _), E = !1, s.bindFramebuffer(s.FRAMEBUFFER, null), s.clear(s.COLOR_BUFFER_BIT)), _ === 0 && this._raiseTiledImageDrawnEvent(w, O.map((F) => F.tile));
            }
          }), E && this._outputContext.drawImage(this._renderingCanvas, 0, 0);
        }
        // Public API required by all Drawer implementations
        /**
        * Sets whether image smoothing is enabled or disabled
        * @param {Boolean} enabled If true, uses gl.LINEAR as the TEXTURE_MIN_FILTER and TEXTURE_MAX_FILTER, otherwise gl.NEAREST.
        */
        setImageSmoothingEnabled(o) {
          this._imageSmoothingEnabled !== o && (this._imageSmoothingEnabled = o, this._unloadTextures(), this.viewer.world.draw());
        }
        /**
        * Draw a rect onto the output canvas for debugging purposes
        * @param {OpenSeadragon.Rect} rect
        */
        drawDebuggingRect(o) {
          let s = this._outputContext;
          s.save(), s.lineWidth = 2 * n.pixelDensityRatio, s.strokeStyle = this.debugGridColor[0], s.fillStyle = this.debugGridColor[0], s.strokeRect(
            o.x * n.pixelDensityRatio,
            o.y * n.pixelDensityRatio,
            o.width * n.pixelDensityRatio,
            o.height * n.pixelDensityRatio
          ), s.restore();
        }
        // private
        _getTextureDataFromTile(o) {
          return o.getCanvasContext().canvas;
        }
        /**
        * Draw data from the rendering canvas onto the output canvas, with clipping,
        * cropping and/or debug info as requested.
        * @private
        * @param {OpenSeadragon.TiledImage} tiledImage - the tiledImage to draw
        * @param {Array} tilesToDraw - array of objects containing tiles that were drawn
        */
        _applyContext2dPipeline(o, s, u) {
          if (this._outputContext.save(), this._outputContext.globalCompositeOperation = u === 0 ? null : o.compositeOperation || this.viewer.compositeOperation, o._croppingPolygons || o._clip ? (this._renderToClippingCanvas(o), this._outputContext.drawImage(this._clippingCanvas, 0, 0)) : this._outputContext.drawImage(this._renderingCanvas, 0, 0), this._outputContext.restore(), o.debugMode) {
            const f = this.viewer.viewport.getFlip();
            f && this._flip(), this._drawDebugInfo(s, o, f), f && this._flip();
          }
        }
        // private
        _getTileData(o, s, u, f, p, m, v, y, S) {
          let E = u.texture, w = u.position;
          m.set(w, p * 12);
          let _ = this._calculateOverlapFraction(o, s), O = o.positionedBounds.width * _.x, D = o.positionedBounds.height * _.y, P = o.positionedBounds.x + (o.x === 0 ? 0 : O), M = o.positionedBounds.y + (o.y === 0 ? 0 : D), N = o.positionedBounds.x + o.positionedBounds.width - (o.isRightMost ? 0 : O), k = o.positionedBounds.y + o.positionedBounds.height - (o.isBottomMost ? 0 : D), U = N - P, H = k - M, Y = new n.Mat3([
            U,
            0,
            0,
            0,
            H,
            0,
            P,
            M,
            1
          ]);
          if (o.flipped) {
            let V = n.Mat3.makeTranslation(0.5, 0), F = n.Mat3.makeTranslation(-0.5, 0), X = V.multiply(n.Mat3.makeScaling(-1, 1)).multiply(F);
            Y = Y.multiply(X);
          }
          let z = f.multiply(Y);
          S[p] = o.opacity, v[p] = E, y[p] = z.values;
        }
        // private
        _textureFilter() {
          return this._imageSmoothingEnabled ? this._gl.LINEAR : this._gl.NEAREST;
        }
        // private
        _setupRenderer() {
          let o = this._gl;
          o || n.console.error("_setupCanvases must be called before _setupRenderer"), this._unitQuad = this._makeQuadVertexBuffer(0, 1, 0, 1), this._makeFirstPassShaderProgram(), this._makeSecondPassShaderProgram(), this._renderToTexture = o.createTexture(), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, this._renderToTexture), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, this._renderingCanvas.width, this._renderingCanvas.height, 0, o.RGBA, o.UNSIGNED_BYTE, null), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, this._textureFilter()), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), this._glFrameBuffer = o.createFramebuffer(), o.bindFramebuffer(o.FRAMEBUFFER, this._glFrameBuffer), o.framebufferTexture2D(
            o.FRAMEBUFFER,
            o.COLOR_ATTACHMENT0,
            // attach texture as COLOR_ATTACHMENT0
            o.TEXTURE_2D,
            // attach a 2D texture
            this._renderToTexture,
            // the texture to attach
            0
          ), o.enable(o.BLEND), o.blendFunc(o.ONE, o.ONE_MINUS_SRC_ALPHA);
        }
        //private
        _makeFirstPassShaderProgram() {
          let o = this._glNumTextures = this._gl.getParameter(this._gl.MAX_TEXTURE_IMAGE_UNITS), s = () => [...Array(o).keys()].map((E) => `uniform mat3 u_matrix_${E};`).join(`
`), u = () => [...Array(o).keys()].map((E) => `${E > 0 ? "else " : ""}if(int(a_index) == ${E}) { transform_matrix = u_matrix_${E}; }`).join(`
`);
          const f = `
            attribute vec2 a_output_position;
            attribute vec2 a_texture_position;
            attribute float a_index;

            ${s()} // create a uniform mat3 for each potential tile to draw

            varying vec2 v_texture_position;
            varying float v_image_index;

            void main() {

                mat3 transform_matrix; // value will be set by the if/elses in makeConditional()

                ${u()}

                gl_Position = vec4(transform_matrix * vec3(a_output_position, 1), 1);

                v_texture_position = a_texture_position;
                v_image_index = a_index;
            }
            `, p = `
            precision mediump float;

            // our textures
            uniform sampler2D u_images[${o}];
            // our opacities
            uniform float u_opacities[${o}];

            // the varyings passed in from the vertex shader.
            varying vec2 v_texture_position;
            varying float v_image_index;

            void main() {
                // can't index directly with a variable, need to use a loop iterator hack
                for(int i = 0; i < ${o}; ++i){
                    if(i == int(v_image_index)){
                        gl_FragColor = texture2D(u_images[i], v_texture_position) * u_opacities[i];
                    }
                }
            }
            `;
          let m = this._gl, v = this.constructor.initShaderProgram(m, f, p);
          m.useProgram(v), this._firstPass = {
            shaderProgram: v,
            aOutputPosition: m.getAttribLocation(v, "a_output_position"),
            aTexturePosition: m.getAttribLocation(v, "a_texture_position"),
            aIndex: m.getAttribLocation(v, "a_index"),
            uTransformMatrices: [...Array(this._glNumTextures).keys()].map((E) => m.getUniformLocation(v, `u_matrix_${E}`)),
            uImages: m.getUniformLocation(v, "u_images"),
            uOpacities: m.getUniformLocation(v, "u_opacities"),
            bufferOutputPosition: m.createBuffer(),
            bufferTexturePosition: m.createBuffer(),
            bufferIndex: m.createBuffer()
          }, m.uniform1iv(this._firstPass.uImages, [...Array(o).keys()]);
          let y = new Float32Array(o * 12);
          for (let E = 0; E < o; ++E)
            y.set(Float32Array.from(this._unitQuad), E * 12);
          m.bindBuffer(m.ARRAY_BUFFER, this._firstPass.bufferOutputPosition), m.bufferData(m.ARRAY_BUFFER, y, m.STATIC_DRAW), m.enableVertexAttribArray(this._firstPass.aOutputPosition), m.bindBuffer(m.ARRAY_BUFFER, this._firstPass.bufferTexturePosition), m.enableVertexAttribArray(this._firstPass.aTexturePosition), m.bindBuffer(m.ARRAY_BUFFER, this._firstPass.bufferIndex);
          let S = [...Array(this._glNumTextures).keys()].map((E) => Array(6).fill(E)).flat();
          m.bufferData(m.ARRAY_BUFFER, new Float32Array(S), m.STATIC_DRAW), m.enableVertexAttribArray(this._firstPass.aIndex);
        }
        // private
        _makeSecondPassShaderProgram() {
          const o = `
            attribute vec2 a_output_position;
            attribute vec2 a_texture_position;

            uniform mat3 u_matrix;

            varying vec2 v_texture_position;

            void main() {
                gl_Position = vec4(u_matrix * vec3(a_output_position, 1), 1);

                v_texture_position = a_texture_position;
            }
            `, s = `
            precision mediump float;

            // our texture
            uniform sampler2D u_image;

            // the texCoords passed in from the vertex shader.
            varying vec2 v_texture_position;

            // the opacity multiplier for the image
            uniform float u_opacity_multiplier;

            void main() {
                gl_FragColor = texture2D(u_image, v_texture_position);
                gl_FragColor *= u_opacity_multiplier;
            }
            `;
          let u = this._gl, f = this.constructor.initShaderProgram(u, o, s);
          u.useProgram(f), this._secondPass = {
            shaderProgram: f,
            aOutputPosition: u.getAttribLocation(f, "a_output_position"),
            aTexturePosition: u.getAttribLocation(f, "a_texture_position"),
            uMatrix: u.getUniformLocation(f, "u_matrix"),
            uImage: u.getUniformLocation(f, "u_image"),
            uOpacityMultiplier: u.getUniformLocation(f, "u_opacity_multiplier"),
            bufferOutputPosition: u.createBuffer(),
            bufferTexturePosition: u.createBuffer()
          }, u.bindBuffer(u.ARRAY_BUFFER, this._secondPass.bufferOutputPosition), u.bufferData(u.ARRAY_BUFFER, this._unitQuad, u.STATIC_DRAW), u.enableVertexAttribArray(this._secondPass.aOutputPosition), u.bindBuffer(u.ARRAY_BUFFER, this._secondPass.bufferTexturePosition), u.bufferData(u.ARRAY_BUFFER, this._unitQuad, u.DYNAMIC_DRAW), u.enableVertexAttribArray(this._secondPass.aTexturePosition);
          let p = n.Mat3.makeScaling(2, 2).multiply(n.Mat3.makeTranslation(-0.5, -0.5));
          u.uniformMatrix3fv(this._secondPass.uMatrix, !1, p.values);
        }
        // private
        _resizeRenderer() {
          let o = this._gl, s = this._renderingCanvas.width, u = this._renderingCanvas.height;
          o.viewport(0, 0, s, u), o.deleteTexture(this._renderToTexture), this._renderToTexture = o.createTexture(), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, this._renderToTexture), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, s, u, 0, o.RGBA, o.UNSIGNED_BYTE, null), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, this._textureFilter()), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.bindFramebuffer(o.FRAMEBUFFER, this._glFrameBuffer), o.framebufferTexture2D(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, this._renderToTexture, 0);
        }
        // private
        _setupCanvases() {
          let o = this;
          this._outputCanvas = this.canvas, this._outputContext = this._outputCanvas.getContext("2d"), this._renderingCanvas = document.createElement("canvas"), this._clippingCanvas = document.createElement("canvas"), this._clippingContext = this._clippingCanvas.getContext("2d"), this._renderingCanvas.width = this._clippingCanvas.width = this._outputCanvas.width, this._renderingCanvas.height = this._clippingCanvas.height = this._outputCanvas.height, this._gl = this._renderingCanvas.getContext("webgl"), this._resizeHandler = function() {
            o._outputCanvas !== o.viewer.drawer.canvas && (o._outputCanvas.style.width = o.viewer.drawer.canvas.clientWidth + "px", o._outputCanvas.style.height = o.viewer.drawer.canvas.clientHeight + "px");
            let s = o._calculateCanvasSize();
            (o._outputCanvas.width !== s.x || o._outputCanvas.height !== s.y) && (o._outputCanvas.width = s.x, o._outputCanvas.height = s.y), o._renderingCanvas.style.width = o._outputCanvas.clientWidth + "px", o._renderingCanvas.style.height = o._outputCanvas.clientHeight + "px", o._renderingCanvas.width = o._clippingCanvas.width = o._outputCanvas.width, o._renderingCanvas.height = o._clippingCanvas.height = o._outputCanvas.height, o._resizeRenderer();
          }, this.viewer.addHandler("resize", this._resizeHandler);
        }
        // private
        _makeQuadVertexBuffer(o, s, u, f) {
          return new Float32Array([
            o,
            f,
            s,
            f,
            o,
            u,
            o,
            u,
            s,
            f,
            s,
            u
          ]);
        }
        // private
        _tileReadyHandler(o) {
          let s = o.tile, u = o.tiledImage;
          if (u.isTainted())
            return;
          let f = s.getCanvasContext(), p = f && f.canvas;
          if (!p || n.isCanvasTainted(p)) {
            u.isTainted() || (u.setTainted(!0), n.console.warn("WebGL cannot be used to draw this TiledImage because it has tainted data. Does crossOriginPolicy need to be set?"), this._raiseDrawerErrorEvent(u, "Tainted data cannot be used by the WebGLDrawer. Falling back to CanvasDrawer for this TiledImage."));
            return;
          }
          if (!this._TextureMap.get(p)) {
            let v = this._gl, y = v.createTexture(), S, E = u.source.tileOverlap, w, _;
            if (s.sourceBounds ? (w = Math.min(s.sourceBounds.width, p.width) / p.width, _ = Math.min(s.sourceBounds.height, p.height) / p.height) : (w = 1, _ = 1), E > 0) {
              let D = this._calculateOverlapFraction(s, u), P = (s.x === 0 ? 0 : D.x) * w, M = (s.y === 0 ? 0 : D.y) * _, N = (s.isRightMost ? 1 : 1 - D.x) * w, k = (s.isBottomMost ? 1 : 1 - D.y) * _;
              S = this._makeQuadVertexBuffer(P, N, M, k);
            } else w === 1 && _ === 1 ? S = this._unitQuad : S = this._makeQuadVertexBuffer(0, w, 0, _);
            let O = {
              texture: y,
              position: S
            };
            this._TextureMap.set(p, O), v.activeTexture(v.TEXTURE0), v.bindTexture(v.TEXTURE_2D, y), v.texParameteri(v.TEXTURE_2D, v.TEXTURE_WRAP_S, v.CLAMP_TO_EDGE), v.texParameteri(v.TEXTURE_2D, v.TEXTURE_WRAP_T, v.CLAMP_TO_EDGE), v.texParameteri(v.TEXTURE_2D, v.TEXTURE_MIN_FILTER, this._textureFilter()), v.texParameteri(v.TEXTURE_2D, v.TEXTURE_MAG_FILTER, this._textureFilter()), this._uploadImageData(f);
          }
        }
        // private
        _calculateOverlapFraction(o, s) {
          let u = s.source.tileOverlap, f = o.sourceBounds.width, p = o.sourceBounds.height, m = (o.x === 0 ? 0 : u) + (o.isRightMost ? 0 : u), v = (o.y === 0 ? 0 : u) + (o.isBottomMost ? 0 : u), y = u / (f + m), S = u / (p + v);
          return {
            x: y,
            y: S
          };
        }
        // private
        _unloadTextures() {
          Array.from(this._TextureMap.keys()).forEach((s) => {
            this._cleanupImageData(s);
          });
        }
        // private
        _uploadImageData(o) {
          let s = this._gl, u = o.canvas;
          try {
            if (!u)
              throw o;
            s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, u);
          } catch (f) {
            n.console.error("Error uploading image data to WebGL", f);
          }
        }
        // private
        _imageUnloadedHandler(o) {
          let s = o.context2D.canvas;
          this._cleanupImageData(s);
        }
        // private
        _cleanupImageData(o) {
          let s = this._TextureMap.get(o);
          this._TextureMap.delete(o), s && this._gl.deleteTexture(s.texture);
        }
        // private
        _setClip() {
        }
        // private
        _renderToClippingCanvas(o) {
          if (this._clippingContext.clearRect(0, 0, this._clippingCanvas.width, this._clippingCanvas.height), this._clippingContext.save(), this.viewer.viewport.getFlip()) {
            const s = new n.Point(this.canvas.width / 2, this.canvas.height / 2);
            this._clippingContext.translate(s.x, 0), this._clippingContext.scale(-1, 1), this._clippingContext.translate(-s.x, 0);
          }
          if (o._clip) {
            let u = [
              { x: o._clip.x, y: o._clip.y },
              { x: o._clip.x + o._clip.width, y: o._clip.y },
              { x: o._clip.x + o._clip.width, y: o._clip.y + o._clip.height },
              { x: o._clip.x, y: o._clip.y + o._clip.height }
            ].map((f) => {
              let p = o.imageToViewportCoordinates(f.x, f.y, !0).rotate(this.viewer.viewport.getRotation(!0), this.viewer.viewport.getCenter(!0));
              return this.viewportCoordToDrawerCoord(p);
            });
            this._clippingContext.beginPath(), u.forEach((f, p) => {
              this._clippingContext[p === 0 ? "moveTo" : "lineTo"](f.x, f.y);
            }), this._clippingContext.clip(), this._setClip();
          }
          if (o._croppingPolygons) {
            let s = o._croppingPolygons.map((u) => u.map((f) => {
              let p = o.imageToViewportCoordinates(f.x, f.y, !0).rotate(this.viewer.viewport.getRotation(!0), this.viewer.viewport.getCenter(!0));
              return this.viewportCoordToDrawerCoord(p);
            }));
            this._clippingContext.beginPath(), s.forEach((u) => {
              u.forEach((f, p) => {
                this._clippingContext[p === 0 ? "moveTo" : "lineTo"](f.x, f.y);
              });
            }), this._clippingContext.clip();
          }
          if (this.viewer.viewport.getFlip()) {
            const s = new n.Point(this.canvas.width / 2, this.canvas.height / 2);
            this._clippingContext.translate(s.x, 0), this._clippingContext.scale(-1, 1), this._clippingContext.translate(-s.x, 0);
          }
          this._clippingContext.drawImage(this._renderingCanvas, 0, 0), this._clippingContext.restore();
        }
        /**
         * Set rotations for viewport & tiledImage
         * @private
         * @param {OpenSeadragon.TiledImage} tiledImage
         */
        _setRotations(o) {
          var s = !1;
          this.viewport.getRotation(!0) % 360 !== 0 && (this._offsetForRotation({
            degrees: this.viewport.getRotation(!0),
            saveContext: s
          }), s = !1), o.getRotation(!0) % 360 !== 0 && this._offsetForRotation({
            degrees: o.getRotation(!0),
            point: this.viewport.pixelFromPointNoRotate(
              o._getRotationPoint(!0),
              !0
            ),
            saveContext: s
          });
        }
        // private
        _offsetForRotation(o) {
          var s = o.point ? o.point.times(n.pixelDensityRatio) : this._getCanvasCenter(), u = this._outputContext;
          u.save(), u.translate(s.x, s.y), u.rotate(Math.PI / 180 * o.degrees), u.translate(-s.x, -s.y);
        }
        // private
        _flip(o) {
          o = o || {};
          var s = o.point ? o.point.times(n.pixelDensityRatio) : this._getCanvasCenter(), u = this._outputContext;
          u.translate(s.x, 0), u.scale(-1, 1), u.translate(-s.x, 0);
        }
        // private
        _drawDebugInfo(o, s, u) {
          for (var f = o.length - 1; f >= 0; f--) {
            var p = o[f].tile;
            try {
              this._drawDebugInfoOnTile(p, o.length, f, s, u);
            } catch (m) {
              n.console.error(m);
            }
          }
        }
        // private
        _drawDebugInfoOnTile(o, s, u, f, p) {
          var m = this.viewer.world.getIndexOfItem(f) % this.debugGridColor.length, v = this.context;
          v.save(), v.lineWidth = 2 * n.pixelDensityRatio, v.font = "small-caps bold " + 13 * n.pixelDensityRatio + "px arial", v.strokeStyle = this.debugGridColor[m], v.fillStyle = this.debugGridColor[m], this._setRotations(f), p && this._flip({ point: o.position.plus(o.size.divide(2)) }), v.strokeRect(
            o.position.x * n.pixelDensityRatio,
            o.position.y * n.pixelDensityRatio,
            o.size.x * n.pixelDensityRatio,
            o.size.y * n.pixelDensityRatio
          );
          var y = (o.position.x + o.size.x / 2) * n.pixelDensityRatio, S = (o.position.y + o.size.y / 2) * n.pixelDensityRatio;
          v.translate(y, S);
          const E = this.viewport.getRotation(!0);
          v.rotate(Math.PI / 180 * -E), v.translate(-y, -S), o.x === 0 && o.y === 0 && (v.fillText(
            "Zoom: " + this.viewport.getZoom(),
            o.position.x * n.pixelDensityRatio,
            (o.position.y - 30) * n.pixelDensityRatio
          ), v.fillText(
            "Pan: " + this.viewport.getBounds().toString(),
            o.position.x * n.pixelDensityRatio,
            (o.position.y - 20) * n.pixelDensityRatio
          )), v.fillText(
            "Level: " + o.level,
            (o.position.x + 10) * n.pixelDensityRatio,
            (o.position.y + 20) * n.pixelDensityRatio
          ), v.fillText(
            "Column: " + o.x,
            (o.position.x + 10) * n.pixelDensityRatio,
            (o.position.y + 30) * n.pixelDensityRatio
          ), v.fillText(
            "Row: " + o.y,
            (o.position.x + 10) * n.pixelDensityRatio,
            (o.position.y + 40) * n.pixelDensityRatio
          ), v.fillText(
            "Order: " + u + " of " + s,
            (o.position.x + 10) * n.pixelDensityRatio,
            (o.position.y + 50) * n.pixelDensityRatio
          ), v.fillText(
            "Size: " + o.size.toString(),
            (o.position.x + 10) * n.pixelDensityRatio,
            (o.position.y + 60) * n.pixelDensityRatio
          ), v.fillText(
            "Position: " + o.position.toString(),
            (o.position.x + 10) * n.pixelDensityRatio,
            (o.position.y + 70) * n.pixelDensityRatio
          ), this.viewport.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(), f.getRotation(!0) % 360 !== 0 && this._restoreRotationChanges(), v.restore();
        }
        _drawPlaceholder(o) {
          const s = o.getBounds(!0), u = this.viewportToDrawerRectangle(o.getBounds(!0)), f = this._outputContext;
          let p;
          typeof o.placeholderFillStyle == "function" ? p = o.placeholderFillStyle(o, f) : p = o.placeholderFillStyle, this._offsetForRotation({ degrees: this.viewer.viewport.getRotation(!0) }), f.fillStyle = p, f.translate(u.x, u.y), f.rotate(Math.PI / 180 * s.degrees), f.translate(-u.x, -u.y), f.fillRect(u.x, u.y, u.width, u.height), this._restoreRotationChanges();
        }
        /**
         * Get the canvas center
         * @private
         * @returns {OpenSeadragon.Point} The center point of the canvas
         */
        _getCanvasCenter() {
          return new n.Point(this.canvas.width / 2, this.canvas.height / 2);
        }
        // private
        _restoreRotationChanges() {
          var o = this._outputContext;
          o.restore();
        }
        // modified from https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Tutorial/Adding_2D_content_to_a_WebGL_context
        static initShaderProgram(o, s, u) {
          function f(y, S, E) {
            const w = y.createShader(S);
            return y.shaderSource(w, E), y.compileShader(w), y.getShaderParameter(w, y.COMPILE_STATUS) ? w : (n.console.error(
              `An error occurred compiling the shaders: ${y.getShaderInfoLog(w)}`
            ), y.deleteShader(w), null);
          }
          const p = f(o, o.VERTEX_SHADER, s), m = f(o, o.FRAGMENT_SHADER, u), v = o.createProgram();
          return o.attachShader(v, p), o.attachShader(v, m), o.linkProgram(v), o.getProgramParameter(v, o.LINK_STATUS) ? v : (n.console.error(
            `Unable to initialize the shader program: ${o.getProgramInfoLog(
              v
            )}`
          ), null);
        }
      };
    })(t), (function(n) {
      n.Viewport = function(r) {
        var i = arguments;
        i.length && i[0] instanceof n.Point && (r = {
          containerSize: i[0],
          contentSize: i[1],
          config: i[2]
        }), r.config && (n.extend(!0, r, r.config), delete r.config), this._margins = n.extend({
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        }, r.margins || {}), delete r.margins, r.initialDegrees = r.degrees, delete r.degrees, n.extend(!0, this, {
          //required settings
          containerSize: null,
          contentSize: null,
          //internal state properties
          zoomPoint: null,
          rotationPivot: null,
          viewer: null,
          //configurable options
          springStiffness: n.DEFAULT_SETTINGS.springStiffness,
          animationTime: n.DEFAULT_SETTINGS.animationTime,
          minZoomImageRatio: n.DEFAULT_SETTINGS.minZoomImageRatio,
          maxZoomPixelRatio: n.DEFAULT_SETTINGS.maxZoomPixelRatio,
          visibilityRatio: n.DEFAULT_SETTINGS.visibilityRatio,
          wrapHorizontal: n.DEFAULT_SETTINGS.wrapHorizontal,
          wrapVertical: n.DEFAULT_SETTINGS.wrapVertical,
          defaultZoomLevel: n.DEFAULT_SETTINGS.defaultZoomLevel,
          minZoomLevel: n.DEFAULT_SETTINGS.minZoomLevel,
          maxZoomLevel: n.DEFAULT_SETTINGS.maxZoomLevel,
          initialDegrees: n.DEFAULT_SETTINGS.degrees,
          flipped: n.DEFAULT_SETTINGS.flipped,
          homeFillsViewer: n.DEFAULT_SETTINGS.homeFillsViewer,
          silenceMultiImageWarnings: n.DEFAULT_SETTINGS.silenceMultiImageWarnings
        }, r), this._updateContainerInnerSize(), this.centerSpringX = new n.Spring({
          initial: 0,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this.centerSpringY = new n.Spring({
          initial: 0,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this.zoomSpring = new n.Spring({
          exponential: !0,
          initial: 1,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this.degreesSpring = new n.Spring({
          initial: r.initialDegrees,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._oldCenterX = this.centerSpringX.current.value, this._oldCenterY = this.centerSpringY.current.value, this._oldZoom = this.zoomSpring.current.value, this._oldDegrees = this.degreesSpring.current.value, this._setContentBounds(new n.Rect(0, 0, 1, 1), 1), this.goHome(!0), this.update();
      }, n.Viewport.prototype = {
        // deprecated
        get degrees() {
          return n.console.warn("Accessing [Viewport.degrees] is deprecated. Use viewport.getRotation instead."), this.getRotation();
        },
        // deprecated
        set degrees(r) {
          n.console.warn("Setting [Viewport.degrees] is deprecated. Use viewport.rotateTo, viewport.rotateBy, or viewport.setRotation instead."), this.rotateTo(r);
        },
        /**
         * Updates the viewport's home bounds and constraints for the given content size.
         * @function
         * @param {OpenSeadragon.Point} contentSize - size of the content in content units
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:reset-size
         */
        resetContentSize: function(r) {
          return n.console.assert(r, "[Viewport.resetContentSize] contentSize is required"), n.console.assert(r instanceof n.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point"), n.console.assert(r.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0"), n.console.assert(r.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0"), this._setContentBounds(new n.Rect(0, 0, 1, r.y / r.x), r.x), this;
        },
        // deprecated
        setHomeBounds: function(r, i) {
          n.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually."), this._setContentBounds(r, i);
        },
        // Set the viewport's content bounds
        // @param {OpenSeadragon.Rect} bounds - the new bounds in viewport coordinates
        // without rotation
        // @param {Number} contentFactor - how many content units per viewport unit
        // @fires OpenSeadragon.Viewer.event:reset-size
        // @private
        _setContentBounds: function(r, i) {
          n.console.assert(r, "[Viewport._setContentBounds] bounds is required"), n.console.assert(r instanceof n.Rect, "[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect"), n.console.assert(r.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0"), n.console.assert(r.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0"), this._contentBoundsNoRotate = r.clone(), this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(
            i
          ), this._contentBounds = r.rotate(this.getRotation()).getBoundingBox(), this._contentSize = this._contentBounds.getSize().times(i), this._contentAspectRatio = this._contentSize.x / this._contentSize.y, this.viewer && this.viewer.raiseEvent("reset-size", {
            contentSize: this._contentSizeNoRotate.clone(),
            contentFactor: i,
            homeBounds: this._contentBoundsNoRotate.clone(),
            contentBounds: this._contentBounds.clone()
          });
        },
        /**
         * Returns the home zoom in "viewport zoom" value.
         * @function
         * @returns {Number} The home zoom in "viewport zoom".
         */
        getHomeZoom: function() {
          if (this.defaultZoomLevel)
            return this.defaultZoomLevel;
          var r = this._contentAspectRatio / this.getAspectRatio(), i;
          return this.homeFillsViewer ? i = r >= 1 ? r : 1 : i = r >= 1 ? 1 : r, i / this._contentBounds.width;
        },
        /**
         * Returns the home bounds in viewport coordinates.
         * @function
         * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
         */
        getHomeBounds: function() {
          return this.getHomeBoundsNoRotate().rotate(-this.getRotation());
        },
        /**
         * Returns the home bounds in viewport coordinates.
         * This method ignores the viewport rotation. Use
         * {@link OpenSeadragon.Viewport#getHomeBounds} to take it into account.
         * @function
         * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
         */
        getHomeBoundsNoRotate: function() {
          var r = this._contentBounds.getCenter(), i = 1 / this.getHomeZoom(), o = i / this.getAspectRatio();
          return new n.Rect(
            r.x - i / 2,
            r.y - o / 2,
            i,
            o
          );
        },
        /**
         * @function
         * @param {Boolean} immediately
         * @fires OpenSeadragon.Viewer.event:home
         */
        goHome: function(r) {
          return this.viewer && this.viewer.raiseEvent("home", {
            immediately: r
          }), this.fitBounds(this.getHomeBounds(), r);
        },
        /**
         * @function
         */
        getMinZoom: function() {
          var r = this.getHomeZoom(), i = this.minZoomLevel ? this.minZoomLevel : this.minZoomImageRatio * r;
          return i;
        },
        /**
         * @function
         */
        getMaxZoom: function() {
          var r = this.maxZoomLevel;
          return r || (r = this._contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x, r /= this._contentBounds.width), Math.max(r, this.getHomeZoom());
        },
        /**
         * @function
         */
        getAspectRatio: function() {
          return this._containerInnerSize.x / this._containerInnerSize.y;
        },
        /**
         * @function
         * @returns {OpenSeadragon.Point} The size of the container, in screen coordinates.
         */
        getContainerSize: function() {
          return new n.Point(
            this.containerSize.x,
            this.containerSize.y
          );
        },
        /**
         * The margins push the "home" region in from the sides by the specified amounts.
         * @function
         * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
         */
        getMargins: function() {
          return n.extend({}, this._margins);
        },
        /**
         * The margins push the "home" region in from the sides by the specified amounts.
         * @function
         * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
         */
        setMargins: function(r) {
          n.console.assert(n.type(r) === "object", "[Viewport.setMargins] margins must be an object"), this._margins = n.extend({
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          }, r), this._updateContainerInnerSize(), this.viewer && this.viewer.forceRedraw();
        },
        /**
         * Returns the bounds of the visible area in viewport coordinates.
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
         */
        getBounds: function(r) {
          return this.getBoundsNoRotate(r).rotate(-this.getRotation(r));
        },
        /**
         * Returns the bounds of the visible area in viewport coordinates.
         * This method ignores the viewport rotation. Use
         * {@link OpenSeadragon.Viewport#getBounds} to take it into account.
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
         */
        getBoundsNoRotate: function(r) {
          var i = this.getCenter(r), o = 1 / this.getZoom(r), s = o / this.getAspectRatio();
          return new n.Rect(
            i.x - o / 2,
            i.y - s / 2,
            o,
            s
          );
        },
        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
         * including the space taken by margins, in viewport coordinates.
         */
        getBoundsWithMargins: function(r) {
          return this.getBoundsNoRotateWithMargins(r).rotate(
            -this.getRotation(r),
            this.getCenter(r)
          );
        },
        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
         * including the space taken by margins, in viewport coordinates.
         */
        getBoundsNoRotateWithMargins: function(r) {
          var i = this.getBoundsNoRotate(r), o = this._containerInnerSize.x * this.getZoom(r);
          return i.x -= this._margins.left / o, i.y -= this._margins.top / o, i.width += (this._margins.left + this._margins.right) / o, i.height += (this._margins.top + this._margins.bottom) / o, i;
        },
        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         */
        getCenter: function(r) {
          var i = new n.Point(
            this.centerSpringX.current.value,
            this.centerSpringY.current.value
          ), o = new n.Point(
            this.centerSpringX.target.value,
            this.centerSpringY.target.value
          ), s, u, f, p, m, v, y, S;
          return r ? i : this.zoomPoint ? (s = this.pixelFromPoint(this.zoomPoint, !0), u = this.getZoom(), f = 1 / u, p = f / this.getAspectRatio(), m = new n.Rect(
            i.x - f / 2,
            i.y - p / 2,
            f,
            p
          ), v = this._pixelFromPoint(this.zoomPoint, m), y = v.minus(s).rotate(-this.getRotation(!0)), S = y.divide(this._containerInnerSize.x * u), o.plus(S)) : o;
        },
        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         */
        getZoom: function(r) {
          return r ? this.zoomSpring.current.value : this.zoomSpring.target.value;
        },
        // private
        _applyZoomConstraints: function(r) {
          return Math.max(
            Math.min(r, this.getMaxZoom()),
            this.getMinZoom()
          );
        },
        /**
         * @function
         * @private
         * @param {OpenSeadragon.Rect} bounds
         * @returns {OpenSeadragon.Rect} constrained bounds.
         */
        _applyBoundaryConstraints: function(r) {
          var i = this.viewportToViewerElementRectangle(r).getBoundingBox(), o = this.viewportToViewerElementRectangle(this._contentBoundsNoRotate).getBoundingBox(), s = !1, u = !1;
          if (!this.wrapHorizontal) {
            var f = i.x + i.width, p = o.x + o.width, m, v, y;
            i.width > o.width ? m = this.visibilityRatio * o.width : m = this.visibilityRatio * i.width, v = o.x - f + m, y = p - i.x - m, m > o.width ? (i.x += (v + y) / 2, s = !0) : y < 0 ? (i.x += y, s = !0) : v > 0 && (i.x += v, s = !0);
          }
          if (!this.wrapVertical) {
            var S = i.y + i.height, E = o.y + o.height, w, _, O;
            i.height > o.height ? w = this.visibilityRatio * o.height : w = this.visibilityRatio * i.height, _ = o.y - S + w, O = E - i.y - w, w > o.height ? (i.y += (_ + O) / 2, u = !0) : O < 0 ? (i.y += O, u = !0) : _ > 0 && (i.y += _, u = !0);
          }
          var D = s || u, P = D ? this.viewerElementToViewportRectangle(i) : r.clone();
          return P.xConstrained = s, P.yConstrained = u, P.constraintApplied = D, P;
        },
        /**
         * @function
         * @private
         * @param {Boolean} [immediately=false] - whether the function that triggered this event was
         * called with the "immediately" flag
         */
        _raiseConstraintsEvent: function(r) {
          this.viewer && this.viewer.raiseEvent("constrain", {
            immediately: r
          });
        },
        /**
         * Enforces the minZoom, maxZoom and visibilityRatio constraints by
         * zooming and panning to the closest acceptable zoom and location.
         * @function
         * @param {Boolean} [immediately=false]
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:constrain if constraints were applied
         */
        applyConstraints: function(r) {
          var i = this.getZoom(), o = this._applyZoomConstraints(i);
          i !== o && this.zoomTo(o, this.zoomPoint, r);
          var s = this.getConstrainedBounds(!1);
          return s.constraintApplied && (this.fitBounds(s, r), this._raiseConstraintsEvent(r)), this;
        },
        /**
         * Equivalent to {@link OpenSeadragon.Viewport#applyConstraints}
         * @function
         * @param {Boolean} [immediately=false]
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:constrain
         */
        ensureVisible: function(r) {
          return this.applyConstraints(r);
        },
        /**
         * @function
         * @private
         * @param {OpenSeadragon.Rect} bounds
         * @param {Object} options (immediately=false, constraints=false)
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        _fitBounds: function(r, i) {
          i = i || {};
          var o = i.immediately || !1, s = i.constraints || !1, u = this.getAspectRatio(), f = r.getCenter(), p = new n.Rect(
            r.x,
            r.y,
            r.width,
            r.height,
            r.degrees + this.getRotation()
          ).getBoundingBox();
          p.getAspectRatio() >= u ? p.height = p.width / u : p.width = p.height * u, p.x = f.x - p.width / 2, p.y = f.y - p.height / 2;
          var m = 1 / p.width;
          if (o)
            return this.panTo(f, !0), this.zoomTo(m, null, !0), s && this.applyConstraints(!0), this;
          var v = this.getCenter(!0), y = this.getZoom(!0);
          this.panTo(v, !0), this.zoomTo(y, null, !0);
          var S = this.getBounds(), E = this.getZoom();
          if (E === 0 || Math.abs(m / E - 1) < 1e-8)
            return this.zoomTo(m, null, !0), this.panTo(f, o), s && this.applyConstraints(!1), this;
          if (s) {
            this.panTo(f, !1), m = this._applyZoomConstraints(m), this.zoomTo(m, null, !1);
            var w = this.getConstrainedBounds();
            this.panTo(v, !0), this.zoomTo(y, null, !0), this.fitBounds(w);
          } else {
            var _ = p.rotate(-this.getRotation()), O = _.getTopLeft().times(m).minus(S.getTopLeft().times(E)).divide(m - E);
            this.zoomTo(m, O, o);
          }
          return this;
        },
        /**
         * Makes the viewport zoom and pan so that the specified bounds take
         * as much space as possible in the viewport.
         * Note: this method ignores the constraints (minZoom, maxZoom and
         * visibilityRatio).
         * Use {@link OpenSeadragon.Viewport#fitBoundsWithConstraints} to enforce
         * them.
         * @function
         * @param {OpenSeadragon.Rect} bounds
         * @param {Boolean} [immediately=false]
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        fitBounds: function(r, i) {
          return this._fitBounds(r, {
            immediately: i,
            constraints: !1
          });
        },
        /**
         * Makes the viewport zoom and pan so that the specified bounds take
         * as much space as possible in the viewport while enforcing the constraints
         * (minZoom, maxZoom and visibilityRatio).
         * Note: because this method enforces the constraints, part of the
         * provided bounds may end up outside of the viewport.
         * Use {@link OpenSeadragon.Viewport#fitBounds} to ignore them.
         * @function
         * @param {OpenSeadragon.Rect} bounds
         * @param {Boolean} [immediately=false]
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        fitBoundsWithConstraints: function(r, i) {
          return this._fitBounds(r, {
            immediately: i,
            constraints: !0
          });
        },
        /**
         * Zooms so the image just fills the viewer vertically.
         * @param {Boolean} immediately
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        fitVertically: function(r) {
          var i = new n.Rect(
            this._contentBounds.x + this._contentBounds.width / 2,
            this._contentBounds.y,
            0,
            this._contentBounds.height
          );
          return this.fitBounds(i, r);
        },
        /**
         * Zooms so the image just fills the viewer horizontally.
         * @param {Boolean} immediately
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        fitHorizontally: function(r) {
          var i = new n.Rect(
            this._contentBounds.x,
            this._contentBounds.y + this._contentBounds.height / 2,
            this._contentBounds.width,
            0
          );
          return this.fitBounds(i, r);
        },
        /**
         * Returns bounds taking constraints into account
         * Added to improve constrained panning
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {OpenSeadragon.Rect} The bounds in viewport coordinates after applying constraints. The returned $.Rect
         *                               contains additional properties constraintsApplied, xConstrained and yConstrained.
         *                               These flags indicate whether the viewport bounds were modified by the constraints
         *                               of the viewer rectangle, and in which dimension(s).
         */
        getConstrainedBounds: function(r) {
          var i, o;
          return i = this.getBounds(r), o = this._applyBoundaryConstraints(i), o;
        },
        /**
         * @function
         * @param {OpenSeadragon.Point} delta
         * @param {Boolean} immediately
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:pan
         */
        panBy: function(r, i) {
          var o = new n.Point(
            this.centerSpringX.target.value,
            this.centerSpringY.target.value
          );
          return this.panTo(o.plus(r), i);
        },
        /**
         * @function
         * @param {OpenSeadragon.Point} center
         * @param {Boolean} immediately
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:pan
         */
        panTo: function(r, i) {
          return i ? (this.centerSpringX.resetTo(r.x), this.centerSpringY.resetTo(r.y)) : (this.centerSpringX.springTo(r.x), this.centerSpringY.springTo(r.y)), this.viewer && this.viewer.raiseEvent("pan", {
            center: r,
            immediately: i
          }), this;
        },
        /**
         * @function
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:zoom
         */
        zoomBy: function(r, i, o) {
          return this.zoomTo(
            this.zoomSpring.target.value * r,
            i,
            o
          );
        },
        /**
         * Zooms to the specified zoom level
         * @function
         * @param {Number} zoom The zoom level to zoom to.
         * @param {OpenSeadragon.Point} [refPoint] The point which will stay at
         * the same screen location. Defaults to the viewport center.
         * @param {Boolean} [immediately=false]
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:zoom
         */
        zoomTo: function(r, i, o) {
          var s = this;
          return this.zoomPoint = i instanceof n.Point && !isNaN(i.x) && !isNaN(i.y) ? i : null, o ? this._adjustCenterSpringsForZoomPoint(function() {
            s.zoomSpring.resetTo(r);
          }) : this.zoomSpring.springTo(r), this.viewer && this.viewer.raiseEvent("zoom", {
            zoom: r,
            refPoint: i,
            immediately: o
          }), this;
        },
        /**
         * Rotates this viewport to the angle specified.
         * @function
         * @param {Number} degrees The degrees to set the rotation to.
         * @param {Boolean} [immediately=false] Whether to animate to the new angle
         * or rotate immediately.
         * * @returns {OpenSeadragon.Viewport} Chainable.
         */
        setRotation: function(r, i) {
          return this.rotateTo(r, null, i);
        },
        /**
         * Gets the current rotation in degrees.
         * @function
         * @param {Boolean} [current=false] True for current rotation, false for target.
         * @returns {Number} The current rotation in degrees.
         */
        getRotation: function(r) {
          return r ? this.degreesSpring.current.value : this.degreesSpring.target.value;
        },
        /**
         * Rotates this viewport to the angle specified around a pivot point. Alias for rotateTo.
         * @function
         * @param {Number} degrees The degrees to set the rotation to.
         * @param {OpenSeadragon.Point} [pivot] (Optional) point in viewport coordinates
         * around which the rotation should be performed. Defaults to the center of the viewport.
         * @param {Boolean} [immediately=false] Whether to animate to the new angle
         * or rotate immediately.
         * * @returns {OpenSeadragon.Viewport} Chainable.
         */
        setRotationWithPivot: function(r, i, o) {
          return this.rotateTo(r, i, o);
        },
        /**
         * Rotates this viewport to the angle specified.
         * @function
         * @param {Number} degrees The degrees to set the rotation to.
         * @param {OpenSeadragon.Point} [pivot] (Optional) point in viewport coordinates
         * around which the rotation should be performed. Defaults to the center of the viewport.
         * @param {Boolean} [immediately=false] Whether to animate to the new angle
         * or rotate immediately.
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        rotateTo: function(r, i, o) {
          if (!this.viewer || !this.viewer.drawer.canRotate())
            return this;
          if (this.degreesSpring.target.value === r && this.degreesSpring.isAtTargetValue())
            return this;
          if (this.rotationPivot = i instanceof n.Point && !isNaN(i.x) && !isNaN(i.y) ? i : null, o)
            if (this.rotationPivot) {
              var s = r - this._oldDegrees;
              if (!s)
                return this.rotationPivot = null, this;
              this._rotateAboutPivot(r);
            } else
              this.degreesSpring.resetTo(r);
          else {
            var u = n.positiveModulo(this.degreesSpring.current.value, 360), f = n.positiveModulo(r, 360), p = f - u;
            p > 180 ? f -= 360 : p < -180 && (f += 360);
            var m = u - f;
            this.degreesSpring.resetTo(r + m), this.degreesSpring.springTo(r);
          }
          return this._setContentBounds(
            this.viewer.world.getHomeBounds(),
            this.viewer.world.getContentFactor()
          ), this.viewer.forceRedraw(), this.viewer.raiseEvent("rotate", { degrees: r, immediately: !!o, pivot: this.rotationPivot || this.getCenter() }), this;
        },
        /**
         * Rotates this viewport by the angle specified.
         * @function
         * @param {Number} degrees The degrees by which to rotate the viewport.
         * @param {OpenSeadragon.Point} [pivot] (Optional) point in viewport coordinates
         * around which the rotation should be performed. Defaults to the center of the viewport.
         * * @param {Boolean} [immediately=false] Whether to animate to the new angle
         * or rotate immediately.
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        rotateBy: function(r, i, o) {
          return this.rotateTo(this.degreesSpring.target.value + r, i, o);
        },
        /**
         * @function
         * @returns {OpenSeadragon.Viewport} Chainable.
         * @fires OpenSeadragon.Viewer.event:resize
         */
        resize: function(r, i) {
          var o = this.getBoundsNoRotate(), s = o, u;
          this.containerSize.x = r.x, this.containerSize.y = r.y, this._updateContainerInnerSize(), i && (u = r.x / this.containerSize.x, s.width = o.width * u, s.height = s.width / this.getAspectRatio()), this.viewer && this.viewer.raiseEvent("resize", {
            newContainerSize: r,
            maintain: i
          });
          var f = this.fitBounds(s, !0);
          return this.viewer && this.viewer.raiseEvent("after-resize", {
            newContainerSize: r,
            maintain: i
          }), f;
        },
        // private
        _updateContainerInnerSize: function() {
          this._containerInnerSize = new n.Point(
            Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)),
            Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom))
          );
        },
        /**
         * Update the zoom, degrees, and center (X and Y) springs.
         * @function
         * @returns {Boolean} True if the viewport is still animating, false otherwise.
         */
        update: function() {
          var r = this;
          this._adjustCenterSpringsForZoomPoint(function() {
            r.zoomSpring.update();
          }), this.degreesSpring.isAtTargetValue() && (this.rotationPivot = null), this.centerSpringX.update(), this.centerSpringY.update(), this.rotationPivot ? this._rotateAboutPivot(!0) : this.degreesSpring.update();
          var i = this.centerSpringX.current.value !== this._oldCenterX || this.centerSpringY.current.value !== this._oldCenterY || this.zoomSpring.current.value !== this._oldZoom || this.degreesSpring.current.value !== this._oldDegrees;
          this._oldCenterX = this.centerSpringX.current.value, this._oldCenterY = this.centerSpringY.current.value, this._oldZoom = this.zoomSpring.current.value, this._oldDegrees = this.degreesSpring.current.value;
          var o = i || !this.zoomSpring.isAtTargetValue() || !this.centerSpringX.isAtTargetValue() || !this.centerSpringY.isAtTargetValue() || !this.degreesSpring.isAtTargetValue();
          return o;
        },
        // private - pass true to use spring, or a number for degrees for immediate rotation
        _rotateAboutPivot: function(r) {
          var i = r === !0, o = this.rotationPivot.minus(this.getCenter());
          this.centerSpringX.shiftBy(o.x), this.centerSpringY.shiftBy(o.y), i ? this.degreesSpring.update() : this.degreesSpring.resetTo(r);
          var s = this.degreesSpring.current.value - this._oldDegrees, u = o.rotate(s * -1).times(-1);
          this.centerSpringX.shiftBy(u.x), this.centerSpringY.shiftBy(u.y);
        },
        // private
        _adjustCenterSpringsForZoomPoint: function(r) {
          if (this.zoomPoint) {
            var i = this.pixelFromPoint(this.zoomPoint, !0);
            r();
            var o = this.pixelFromPoint(this.zoomPoint, !0), s = o.minus(i), u = this.deltaPointsFromPixels(
              s,
              !0
            );
            this.centerSpringX.shiftBy(u.x), this.centerSpringY.shiftBy(u.y), this.zoomSpring.isAtTargetValue() && (this.zoomPoint = null);
          } else
            r();
        },
        /**
         * Convert a delta (translation vector) from viewport coordinates to pixels
         * coordinates. This method does not take rotation into account.
         * Consider using deltaPixelsFromPoints if you need to account for rotation.
         * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        deltaPixelsFromPointsNoRotate: function(r, i) {
          return r.times(
            this._containerInnerSize.x * this.getZoom(i)
          );
        },
        /**
         * Convert a delta (translation vector) from viewport coordinates to pixels
         * coordinates.
         * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        deltaPixelsFromPoints: function(r, i) {
          return this.deltaPixelsFromPointsNoRotate(
            r.rotate(this.getRotation(i)),
            i
          );
        },
        /**
         * Convert a delta (translation vector) from pixels coordinates to viewport
         * coordinates. This method does not take rotation into account.
         * Consider using deltaPointsFromPixels if you need to account for rotation.
         * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        deltaPointsFromPixelsNoRotate: function(r, i) {
          return r.divide(
            this._containerInnerSize.x * this.getZoom(i)
          );
        },
        /**
         * Convert a delta (translation vector) from pixels coordinates to viewport
         * coordinates.
         * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        deltaPointsFromPixels: function(r, i) {
          return this.deltaPointsFromPixelsNoRotate(r, i).rotate(-this.getRotation(i));
        },
        /**
         * Convert viewport coordinates to pixels coordinates.
         * This method does not take rotation into account.
         * Consider using pixelFromPoint if you need to account for rotation.
         * @param {OpenSeadragon.Point} point the viewport coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        pixelFromPointNoRotate: function(r, i) {
          return this._pixelFromPointNoRotate(
            r,
            this.getBoundsNoRotate(i)
          );
        },
        /**
         * Convert viewport coordinates to pixel coordinates.
         * @param {OpenSeadragon.Point} point the viewport coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        pixelFromPoint: function(r, i) {
          return this._pixelFromPoint(r, this.getBoundsNoRotate(i));
        },
        // private
        _pixelFromPointNoRotate: function(r, i) {
          return r.minus(
            i.getTopLeft()
          ).times(
            this._containerInnerSize.x / i.width
          ).plus(
            new n.Point(this._margins.left, this._margins.top)
          );
        },
        // private
        _pixelFromPoint: function(r, i) {
          return this._pixelFromPointNoRotate(
            r.rotate(this.getRotation(!0), this.getCenter(!0)),
            i
          );
        },
        /**
         * Convert pixel coordinates to viewport coordinates.
         * This method does not take rotation into account.
         * Consider using pointFromPixel if you need to account for rotation.
         * @param {OpenSeadragon.Point} pixel Pixel coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        pointFromPixelNoRotate: function(r, i) {
          var o = this.getBoundsNoRotate(i);
          return r.minus(
            new n.Point(this._margins.left, this._margins.top)
          ).divide(
            this._containerInnerSize.x / o.width
          ).plus(
            o.getTopLeft()
          );
        },
        /**
         * Convert pixel coordinates to viewport coordinates.
         * @param {OpenSeadragon.Point} pixel Pixel coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {OpenSeadragon.Point}
         */
        pointFromPixel: function(r, i) {
          return this.pointFromPixelNoRotate(r, i).rotate(
            -this.getRotation(i),
            this.getCenter(i)
          );
        },
        // private
        _viewportToImageDelta: function(r, i) {
          var o = this._contentBoundsNoRotate.width;
          return new n.Point(
            r * this._contentSizeNoRotate.x / o,
            i * this._contentSizeNoRotate.x / o
          );
        },
        /**
         * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
         * This method can be called either by passing X,Y coordinates or an
         * OpenSeadragon.Point
         * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
         * @function
         * @param {(OpenSeadragon.Point|Number)} viewerX either a point or the X
         * coordinate in viewport coordinate system.
         * @param {Number} [viewerY] Y coordinate in viewport coordinate system.
         * @returns {OpenSeadragon.Point} a point representing the coordinates in the image.
         */
        viewportToImageCoordinates: function(r, i) {
          if (r instanceof n.Point)
            return this.viewportToImageCoordinates(r.x, r.y);
          if (this.viewer) {
            var o = this.viewer.world.getItemCount();
            if (o > 1)
              this.silenceMultiImageWarnings || n.console.error("[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.");
            else if (o === 1) {
              var s = this.viewer.world.getItemAt(0);
              return s.viewportToImageCoordinates(r, i, !0);
            }
          }
          return this._viewportToImageDelta(
            r - this._contentBoundsNoRotate.x,
            i - this._contentBoundsNoRotate.y
          );
        },
        // private
        _imageToViewportDelta: function(r, i) {
          var o = this._contentBoundsNoRotate.width;
          return new n.Point(
            r / this._contentSizeNoRotate.x * o,
            i / this._contentSizeNoRotate.x * o
          );
        },
        /**
         * Translates from image coordinate system to OpenSeadragon viewer coordinate system
         * This method can be called either by passing X,Y coordinates or an
         * OpenSeadragon.Point
         * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
         * @function
         * @param {(OpenSeadragon.Point | Number)} imageX the point or the
         * X coordinate in image coordinate system.
         * @param {Number} [imageY] Y coordinate in image coordinate system.
         * @returns {OpenSeadragon.Point} a point representing the coordinates in the viewport.
         */
        imageToViewportCoordinates: function(r, i) {
          if (r instanceof n.Point)
            return this.imageToViewportCoordinates(r.x, r.y);
          if (this.viewer) {
            var o = this.viewer.world.getItemCount();
            if (o > 1)
              this.silenceMultiImageWarnings || n.console.error("[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.");
            else if (o === 1) {
              var s = this.viewer.world.getItemAt(0);
              return s.imageToViewportCoordinates(r, i, !0);
            }
          }
          var u = this._imageToViewportDelta(r, i);
          return u.x += this._contentBoundsNoRotate.x, u.y += this._contentBoundsNoRotate.y, u;
        },
        /**
         * Translates from a rectangle which describes a portion of the image in
         * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an
         * OpenSeadragon.Rect
         * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
         * @function
         * @param {(OpenSeadragon.Rect | Number)} imageX the rectangle or the X
         * coordinate of the top left corner of the rectangle in image coordinate system.
         * @param {Number} [imageY] the Y coordinate of the top left corner of the rectangle
         * in image coordinate system.
         * @param {Number} [pixelWidth] the width in pixel of the rectangle.
         * @param {Number} [pixelHeight] the height in pixel of the rectangle.
         * @returns {OpenSeadragon.Rect} This image's bounds in viewport coordinates
         */
        imageToViewportRectangle: function(r, i, o, s) {
          var u = r;
          if (u instanceof n.Rect || (u = new n.Rect(r, i, o, s)), this.viewer) {
            var f = this.viewer.world.getItemCount();
            if (f > 1)
              this.silenceMultiImageWarnings || n.console.error("[Viewport.imageToViewportRectangle] is not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.");
            else if (f === 1) {
              var p = this.viewer.world.getItemAt(0);
              return p.imageToViewportRectangle(
                r,
                i,
                o,
                s,
                !0
              );
            }
          }
          var m = this.imageToViewportCoordinates(u.x, u.y), v = this._imageToViewportDelta(u.width, u.height);
          return new n.Rect(
            m.x,
            m.y,
            v.x,
            v.y,
            u.degrees
          );
        },
        /**
         * Translates from a rectangle which describes a portion of
         * the viewport in point coordinates to image rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an
         * OpenSeadragon.Rect
         * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
         * @function
         * @param {(OpenSeadragon.Rect | Number)} viewerX either a rectangle or
         * the X coordinate of the top left corner of the rectangle in viewport
         * coordinate system.
         * @param {Number} [viewerY] the Y coordinate of the top left corner of the rectangle
         * in viewport coordinate system.
         * @param {Number} [pointWidth] the width of the rectangle in viewport coordinate system.
         * @param {Number} [pointHeight] the height of the rectangle in viewport coordinate system.
         */
        viewportToImageRectangle: function(r, i, o, s) {
          var u = r;
          if (u instanceof n.Rect || (u = new n.Rect(r, i, o, s)), this.viewer) {
            var f = this.viewer.world.getItemCount();
            if (f > 1)
              this.silenceMultiImageWarnings || n.console.error("[Viewport.viewportToImageRectangle] is not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.");
            else if (f === 1) {
              var p = this.viewer.world.getItemAt(0);
              return p.viewportToImageRectangle(
                r,
                i,
                o,
                s,
                !0
              );
            }
          }
          var m = this.viewportToImageCoordinates(u.x, u.y), v = this._viewportToImageDelta(u.width, u.height);
          return new n.Rect(
            m.x,
            m.y,
            v.x,
            v.y,
            u.degrees
          );
        },
        /**
         * Convert pixel coordinates relative to the viewer element to image
         * coordinates.
         * Note: not accurate with multi-image.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        viewerElementToImageCoordinates: function(r) {
          var i = this.pointFromPixel(r, !0);
          return this.viewportToImageCoordinates(i);
        },
        /**
         * Convert pixel coordinates relative to the image to
         * viewer element coordinates.
         * Note: not accurate with multi-image.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        imageToViewerElementCoordinates: function(r) {
          var i = this.imageToViewportCoordinates(r);
          return this.pixelFromPoint(i, !0);
        },
        /**
         * Convert pixel coordinates relative to the window to image coordinates.
         * Note: not accurate with multi-image.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        windowToImageCoordinates: function(r) {
          n.console.assert(
            this.viewer,
            "[Viewport.windowToImageCoordinates] the viewport must have a viewer."
          );
          var i = r.minus(
            n.getElementPosition(this.viewer.element)
          );
          return this.viewerElementToImageCoordinates(i);
        },
        /**
         * Convert image coordinates to pixel coordinates relative to the window.
         * Note: not accurate with multi-image.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        imageToWindowCoordinates: function(r) {
          n.console.assert(
            this.viewer,
            "[Viewport.imageToWindowCoordinates] the viewport must have a viewer."
          );
          var i = this.imageToViewerElementCoordinates(r);
          return i.plus(
            n.getElementPosition(this.viewer.element)
          );
        },
        /**
         * Convert pixel coordinates relative to the viewer element to viewport
         * coordinates.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        viewerElementToViewportCoordinates: function(r) {
          return this.pointFromPixel(r, !0);
        },
        /**
         * Convert viewport coordinates to pixel coordinates relative to the
         * viewer element.
         * @param {OpenSeadragon.Point} point
         * @returns {OpenSeadragon.Point}
         */
        viewportToViewerElementCoordinates: function(r) {
          return this.pixelFromPoint(r, !0);
        },
        /**
         * Convert a rectangle in pixel coordinates relative to the viewer element
         * to viewport coordinates.
         * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
         * @returns {OpenSeadragon.Rect} the converted rectangle
         */
        viewerElementToViewportRectangle: function(r) {
          return n.Rect.fromSummits(
            this.pointFromPixel(r.getTopLeft(), !0),
            this.pointFromPixel(r.getTopRight(), !0),
            this.pointFromPixel(r.getBottomLeft(), !0)
          );
        },
        /**
         * Convert a rectangle in viewport coordinates to pixel coordinates relative
         * to the viewer element.
         * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
         * @returns {OpenSeadragon.Rect} the converted rectangle
         */
        viewportToViewerElementRectangle: function(r) {
          return n.Rect.fromSummits(
            this.pixelFromPoint(r.getTopLeft(), !0),
            this.pixelFromPoint(r.getTopRight(), !0),
            this.pixelFromPoint(r.getBottomLeft(), !0)
          );
        },
        /**
         * Convert pixel coordinates relative to the window to viewport coordinates.
         * @param {OpenSeadragon.Point} pixel
         * @returns {OpenSeadragon.Point}
         */
        windowToViewportCoordinates: function(r) {
          n.console.assert(
            this.viewer,
            "[Viewport.windowToViewportCoordinates] the viewport must have a viewer."
          );
          var i = r.minus(
            n.getElementPosition(this.viewer.element)
          );
          return this.viewerElementToViewportCoordinates(i);
        },
        /**
         * Convert viewport coordinates to pixel coordinates relative to the window.
         * @param {OpenSeadragon.Point} point
         * @returns {OpenSeadragon.Point}
         */
        viewportToWindowCoordinates: function(r) {
          n.console.assert(
            this.viewer,
            "[Viewport.viewportToWindowCoordinates] the viewport must have a viewer."
          );
          var i = this.viewportToViewerElementCoordinates(r);
          return i.plus(
            n.getElementPosition(this.viewer.element)
          );
        },
        /**
         * Convert a viewport zoom to an image zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * Note: not accurate with multi-image.
         * @function
         * @param {Number} viewportZoom The viewport zoom
         * target zoom.
         * @returns {Number} imageZoom The image zoom
         */
        viewportToImageZoom: function(r) {
          if (this.viewer) {
            var i = this.viewer.world.getItemCount();
            if (i > 1)
              this.silenceMultiImageWarnings || n.console.error("[Viewport.viewportToImageZoom] is not accurate with multi-image.");
            else if (i === 1) {
              var o = this.viewer.world.getItemAt(0);
              return o.viewportToImageZoom(r);
            }
          }
          var s = this._contentSizeNoRotate.x, u = this._containerInnerSize.x, f = this._contentBoundsNoRotate.width, p = u / s * f;
          return r * p;
        },
        /**
         * Convert an image zoom to a viewport zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * Note: not accurate with multi-image; use [TiledImage.imageToViewportZoom] for the specific image of interest.
         * @function
         * @param {Number} imageZoom The image zoom
         * target zoom.
         * @returns {Number} viewportZoom The viewport zoom
         */
        imageToViewportZoom: function(r) {
          if (this.viewer) {
            var i = this.viewer.world.getItemCount();
            if (i > 1)
              this.silenceMultiImageWarnings || n.console.error("[Viewport.imageToViewportZoom] is not accurate with multi-image. Instead, use [TiledImage.imageToViewportZoom] for the specific image of interest");
            else if (i === 1) {
              var o = this.viewer.world.getItemAt(0);
              return o.imageToViewportZoom(r);
            }
          }
          var s = this._contentSizeNoRotate.x, u = this._containerInnerSize.x, f = this._contentBoundsNoRotate.width, p = s / u / f;
          return r * p;
        },
        /**
         * Toggles flip state and demands a new drawing on navigator and viewer objects.
         * @function
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        toggleFlip: function() {
          return this.setFlip(!this.getFlip()), this;
        },
        /**
         * Get flip state stored on viewport.
         * @function
         * @returns {Boolean} Flip state.
         */
        getFlip: function() {
          return this.flipped;
        },
        /**
         * Sets flip state according to the state input argument.
         * @function
         * @param {Boolean} state - Flip state to set.
         * @returns {OpenSeadragon.Viewport} Chainable.
         */
        setFlip: function(r) {
          return this.flipped === r ? this : (this.flipped = r, this.viewer.navigator && this.viewer.navigator.setFlip(this.getFlip()), this.viewer.forceRedraw(), this.viewer.raiseEvent("flip", { flipped: r }), this);
        },
        /**
         * Gets current max zoom pixel ratio
         * @function
         * @returns {Number} Max zoom pixel ratio
         */
        getMaxZoomPixelRatio: function() {
          return this.maxZoomPixelRatio;
        },
        /**
         * Sets max zoom pixel ratio
         * @function
         * @param {Number} ratio - Max zoom pixel ratio
         * @param {Boolean} [applyConstraints=true] - Apply constraints after setting ratio;
         * Takes effect only if current zoom is greater than set max zoom pixel ratio
         * @param {Boolean} [immediately=false] - Whether to animate to new zoom
         */
        setMaxZoomPixelRatio: function(r, i = !0, o = !1) {
          n.console.assert(!isNaN(r), "[Viewport.setMaxZoomPixelRatio] ratio must be a number"), !isNaN(r) && (this.maxZoomPixelRatio = r, i && this.getZoom() > this.getMaxZoom() && this.applyConstraints(o));
        }
      };
    })(t), (function(n) {
      n.TiledImage = function(r) {
        this._initialized = !1, n.console.assert(r.tileCache, "[TiledImage] options.tileCache is required"), n.console.assert(r.drawer, "[TiledImage] options.drawer is required"), n.console.assert(r.viewer, "[TiledImage] options.viewer is required"), n.console.assert(r.imageLoader, "[TiledImage] options.imageLoader is required"), n.console.assert(r.source, "[TiledImage] options.source is required"), n.console.assert(
          !r.clip || r.clip instanceof n.Rect,
          "[TiledImage] options.clip must be an OpenSeadragon.Rect if present"
        ), n.EventSource.call(this), this._tileCache = r.tileCache, delete r.tileCache, this._drawer = r.drawer, delete r.drawer, this._imageLoader = r.imageLoader, delete r.imageLoader, r.clip instanceof n.Rect && (this._clip = r.clip.clone()), delete r.clip;
        var i = r.x || 0;
        delete r.x;
        var o = r.y || 0;
        delete r.y, this.normHeight = r.source.dimensions.y / r.source.dimensions.x, this.contentAspectX = r.source.dimensions.x / r.source.dimensions.y;
        var s = 1;
        r.width ? (s = r.width, delete r.width, r.height && (n.console.error("specifying both width and height to a tiledImage is not supported"), delete r.height)) : r.height && (s = r.height / this.normHeight, delete r.height);
        var u = r.fitBounds;
        delete r.fitBounds;
        var f = r.fitBoundsPlacement || t.Placement.CENTER;
        delete r.fitBoundsPlacement;
        var p = r.degrees || 0;
        delete r.degrees;
        var m = r.ajaxHeaders;
        delete r.ajaxHeaders, n.extend(!0, this, {
          //internal state properties
          viewer: null,
          tilesMatrix: {},
          // A '3d' dictionary [level][x][y] --> Tile.
          coverage: {},
          // A '3d' dictionary [level][x][y] --> Boolean; shows what areas have been drawn.
          loadingCoverage: {},
          // A '3d' dictionary [level][x][y] --> Boolean; shows what areas are loaded or are being loaded/blended.
          lastDrawn: [],
          // An unordered list of Tiles drawn last frame.
          lastResetTime: 0,
          // Last time for which the tiledImage was reset.
          _needsDraw: !0,
          // Does the tiledImage need to be drawn again?
          _needsUpdate: !0,
          // Does the tiledImage need to update the viewport again?
          _hasOpaqueTile: !1,
          // Do we have even one fully opaque tile?
          _tilesLoading: 0,
          // The number of pending tile requests.
          _tilesToDraw: [],
          // info about the tiles currently in the viewport, two deep: array[level][tile]
          _lastDrawn: [],
          // array of tiles that were last fetched by the drawer
          _isBlending: !1,
          // Are any tiles still being blended?
          _wasBlending: !1,
          // Were any tiles blending before the last draw?
          _isTainted: !1,
          // Has a Tile been found with tainted data?
          //configurable settings
          springStiffness: n.DEFAULT_SETTINGS.springStiffness,
          animationTime: n.DEFAULT_SETTINGS.animationTime,
          minZoomImageRatio: n.DEFAULT_SETTINGS.minZoomImageRatio,
          wrapHorizontal: n.DEFAULT_SETTINGS.wrapHorizontal,
          wrapVertical: n.DEFAULT_SETTINGS.wrapVertical,
          immediateRender: n.DEFAULT_SETTINGS.immediateRender,
          blendTime: n.DEFAULT_SETTINGS.blendTime,
          alwaysBlend: n.DEFAULT_SETTINGS.alwaysBlend,
          minPixelRatio: n.DEFAULT_SETTINGS.minPixelRatio,
          smoothTileEdgesMinZoom: n.DEFAULT_SETTINGS.smoothTileEdgesMinZoom,
          iOSDevice: n.DEFAULT_SETTINGS.iOSDevice,
          debugMode: n.DEFAULT_SETTINGS.debugMode,
          crossOriginPolicy: n.DEFAULT_SETTINGS.crossOriginPolicy,
          ajaxWithCredentials: n.DEFAULT_SETTINGS.ajaxWithCredentials,
          placeholderFillStyle: n.DEFAULT_SETTINGS.placeholderFillStyle,
          opacity: n.DEFAULT_SETTINGS.opacity,
          preload: n.DEFAULT_SETTINGS.preload,
          compositeOperation: n.DEFAULT_SETTINGS.compositeOperation,
          subPixelRoundingForTransparency: n.DEFAULT_SETTINGS.subPixelRoundingForTransparency,
          maxTilesPerFrame: n.DEFAULT_SETTINGS.maxTilesPerFrame
        }, r), this._preload = this.preload, delete this.preload, this._fullyLoaded = !1, this._xSpring = new n.Spring({
          initial: i,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._ySpring = new n.Spring({
          initial: o,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._scaleSpring = new n.Spring({
          initial: s,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._degreesSpring = new n.Spring({
          initial: p,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._updateForScale(), u && this.fitBounds(u, f, !0), this._ownAjaxHeaders = {}, this.setAjaxHeaders(m, !1), this._initialized = !0;
      }, n.extend(
        n.TiledImage.prototype,
        n.EventSource.prototype,
        /** @lends OpenSeadragon.TiledImage.prototype */
        {
          /**
           * @returns {Boolean} Whether the TiledImage needs to be drawn.
           */
          needsDraw: function() {
            return this._needsDraw;
          },
          /**
           * Mark the tiled image as needing to be (re)drawn
           */
          redraw: function() {
            this._needsDraw = !0;
          },
          /**
           * @returns {Boolean} Whether all tiles necessary for this TiledImage to draw at the current view have been loaded.
           */
          getFullyLoaded: function() {
            return this._fullyLoaded;
          },
          // private
          _setFullyLoaded: function(r) {
            r !== this._fullyLoaded && (this._fullyLoaded = r, this.raiseEvent("fully-loaded-change", {
              fullyLoaded: this._fullyLoaded
            }));
          },
          /**
           * Clears all tiles and triggers an update on the next call to
           * {@link OpenSeadragon.TiledImage#update}.
           */
          reset: function() {
            this._tileCache.clearTilesFor(this), this.lastResetTime = n.now(), this._needsDraw = !0;
          },
          /**
           * Updates the TiledImage's bounds, animating if needed. Based on the new
           * bounds, updates the levels and tiles to be drawn into the viewport.
           * @param viewportChanged Whether the viewport changed meaning tiles need to be updated.
           * @returns {Boolean} Whether the TiledImage needs to be drawn.
           */
          update: function(r) {
            let i = this._xSpring.update(), o = this._ySpring.update(), s = this._scaleSpring.update(), u = this._degreesSpring.update(), f = i || o || s || u || this._needsUpdate;
            if (f || r || !this._fullyLoaded) {
              let p = this._updateLevelsForViewport();
              this._setFullyLoaded(p);
            }
            return this._needsUpdate = !1, f ? (this._updateForScale(), this._raiseBoundsChange(), this._needsDraw = !0, !0) : !1;
          },
          /**
           * Mark this TiledImage as having been drawn, so that it will only be drawn
           * again if something changes about the image. If the image is still blending,
           * this will have no effect.
           * @returns {Boolean} whether the item still needs to be drawn due to blending
           */
          setDrawn: function() {
            return this._needsDraw = this._isBlending || this._wasBlending, this._needsDraw;
          },
          /**
           * Set the internal _isTainted flag for this TiledImage. Lazy loaded - not
           * checked each time a Tile is loaded, but can be set if a consumer of the
           * tiles (e.g. a Drawer) discovers a Tile to have tainted data so that further
           * checks are not needed and alternative rendering strategies can be used.
           * @private
           */
          setTainted(r) {
            this._isTainted = r;
          },
          /**
           * @private
           * @returns {Boolean} whether the TiledImage has been marked as tainted
           */
          isTainted() {
            return this._isTainted;
          },
          /**
           * Destroy the TiledImage (unload current loaded tiles).
           */
          destroy: function() {
            this.reset(), this.source.destroy && this.source.destroy(this.viewer);
          },
          /**
           * Get this TiledImage's bounds in viewport coordinates.
           * @param {Boolean} [current=false] - Pass true for the current location;
           * false for target location.
           * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
           */
          getBounds: function(r) {
            return this.getBoundsNoRotate(r).rotate(this.getRotation(r), this._getRotationPoint(r));
          },
          /**
           * Get this TiledImage's bounds in viewport coordinates without taking
           * rotation into account.
           * @param {Boolean} [current=false] - Pass true for the current location;
           * false for target location.
           * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
           */
          getBoundsNoRotate: function(r) {
            return r ? new n.Rect(
              this._xSpring.current.value,
              this._ySpring.current.value,
              this._worldWidthCurrent,
              this._worldHeightCurrent
            ) : new n.Rect(
              this._xSpring.target.value,
              this._ySpring.target.value,
              this._worldWidthTarget,
              this._worldHeightTarget
            );
          },
          // deprecated
          getWorldBounds: function() {
            return n.console.error("[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead"), this.getBounds();
          },
          /**
           * Get the bounds of the displayed part of the tiled image.
           * @param {Boolean} [current=false] Pass true for the current location,
           * false for the target location.
           * @returns {$.Rect} The clipped bounds in viewport coordinates.
           */
          getClippedBounds: function(r) {
            var i = this.getBoundsNoRotate(r);
            if (this._clip) {
              var o = r ? this._worldWidthCurrent : this._worldWidthTarget, s = o / this.source.dimensions.x, u = this._clip.times(s);
              i = new n.Rect(
                i.x + u.x,
                i.y + u.y,
                u.width,
                u.height
              );
            }
            return i.rotate(this.getRotation(r), this._getRotationPoint(r));
          },
          /**
           * @function
           * @param {Number} level
           * @param {Number} x
           * @param {Number} y
           * @returns {OpenSeadragon.Rect} Where this tile fits (in normalized coordinates).
           */
          getTileBounds: function(r, i, o) {
            var s = this.source.getNumTiles(r), u = (s.x + i % s.x) % s.x, f = (s.y + o % s.y) % s.y, p = this.source.getTileBounds(r, u, f);
            return this.getFlip() && (p.x = Math.max(0, 1 - p.x - p.width)), p.x += (i - u) / s.x, p.y += this._worldHeightCurrent / this._worldWidthCurrent * ((o - f) / s.y), p;
          },
          /**
           * @returns {OpenSeadragon.Point} This TiledImage's content size, in original pixels.
           */
          getContentSize: function() {
            return new n.Point(this.source.dimensions.x, this.source.dimensions.y);
          },
          /**
           * @returns {OpenSeadragon.Point} The TiledImage's content size, in window coordinates.
           */
          getSizeInWindowCoordinates: function() {
            var r = this.imageToWindowCoordinates(new n.Point(0, 0)), i = this.imageToWindowCoordinates(this.getContentSize());
            return new n.Point(i.x - r.x, i.y - r.y);
          },
          // private
          _viewportToImageDelta: function(r, i, o) {
            var s = o ? this._scaleSpring.current.value : this._scaleSpring.target.value;
            return new n.Point(
              r * (this.source.dimensions.x / s),
              i * (this.source.dimensions.y * this.contentAspectX / s)
            );
          },
          /**
           * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
           * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
           * @param {Number|OpenSeadragon.Point} viewerX - The X coordinate or point in viewport coordinate system.
           * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
           * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
           * @returns {OpenSeadragon.Point} A point representing the coordinates in the image.
           */
          viewportToImageCoordinates: function(r, i, o) {
            var s;
            return r instanceof n.Point ? (o = i, s = r) : s = new n.Point(r, i), s = s.rotate(-this.getRotation(o), this._getRotationPoint(o)), o ? this._viewportToImageDelta(
              s.x - this._xSpring.current.value,
              s.y - this._ySpring.current.value
            ) : this._viewportToImageDelta(
              s.x - this._xSpring.target.value,
              s.y - this._ySpring.target.value
            );
          },
          // private
          _imageToViewportDelta: function(r, i, o) {
            var s = o ? this._scaleSpring.current.value : this._scaleSpring.target.value;
            return new n.Point(
              r / this.source.dimensions.x * s,
              i / this.source.dimensions.y / this.contentAspectX * s
            );
          },
          /**
           * Translates from image coordinate system to OpenSeadragon viewer coordinate system
           * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
           * @param {Number|OpenSeadragon.Point} imageX - The X coordinate or point in image coordinate system.
           * @param {Number} [imageY] - The Y coordinate in image coordinate system.
           * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
           * @returns {OpenSeadragon.Point} A point representing the coordinates in the viewport.
           */
          imageToViewportCoordinates: function(r, i, o) {
            r instanceof n.Point && (o = i, i = r.y, r = r.x);
            var s = this._imageToViewportDelta(r, i, o);
            return o ? (s.x += this._xSpring.current.value, s.y += this._ySpring.current.value) : (s.x += this._xSpring.target.value, s.y += this._ySpring.target.value), s.rotate(this.getRotation(o), this._getRotationPoint(o));
          },
          /**
           * Translates from a rectangle which describes a portion of the image in
           * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
           * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
           * @param {Number|OpenSeadragon.Rect} imageX - The left coordinate or rectangle in image coordinate system.
           * @param {Number} [imageY] - The top coordinate in image coordinate system.
           * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
           * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
           * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
           * @returns {OpenSeadragon.Rect} A rect representing the coordinates in the viewport.
           */
          imageToViewportRectangle: function(r, i, o, s, u) {
            var f = r;
            f instanceof n.Rect ? u = i : f = new n.Rect(r, i, o, s);
            var p = this.imageToViewportCoordinates(f.getTopLeft(), u), m = this._imageToViewportDelta(f.width, f.height, u);
            return new n.Rect(
              p.x,
              p.y,
              m.x,
              m.y,
              f.degrees + this.getRotation(u)
            );
          },
          /**
           * Translates from a rectangle which describes a portion of
           * the viewport in point coordinates to image rectangle coordinates.
           * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
           * @param {Number|OpenSeadragon.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
           * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
           * @param {Number} [pointWidth] - The width in viewport coordinate system.
           * @param {Number} [pointHeight] - The height in viewport coordinate system.
           * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
           * @returns {OpenSeadragon.Rect} A rect representing the coordinates in the image.
           */
          viewportToImageRectangle: function(r, i, o, s, u) {
            var f = r;
            r instanceof n.Rect ? u = i : f = new n.Rect(r, i, o, s);
            var p = this.viewportToImageCoordinates(f.getTopLeft(), u), m = this._viewportToImageDelta(f.width, f.height, u);
            return new n.Rect(
              p.x,
              p.y,
              m.x,
              m.y,
              f.degrees - this.getRotation(u)
            );
          },
          /**
           * Convert pixel coordinates relative to the viewer element to image
           * coordinates.
           * @param {OpenSeadragon.Point} pixel
           * @returns {OpenSeadragon.Point}
           */
          viewerElementToImageCoordinates: function(r) {
            var i = this.viewport.pointFromPixel(r, !0);
            return this.viewportToImageCoordinates(i);
          },
          /**
           * Convert pixel coordinates relative to the image to
           * viewer element coordinates.
           * @param {OpenSeadragon.Point} pixel
           * @returns {OpenSeadragon.Point}
           */
          imageToViewerElementCoordinates: function(r) {
            var i = this.imageToViewportCoordinates(r);
            return this.viewport.pixelFromPoint(i, !0);
          },
          /**
           * Convert pixel coordinates relative to the window to image coordinates.
           * @param {OpenSeadragon.Point} pixel
           * @returns {OpenSeadragon.Point}
           */
          windowToImageCoordinates: function(r) {
            var i = r.minus(
              t.getElementPosition(this.viewer.element)
            );
            return this.viewerElementToImageCoordinates(i);
          },
          /**
           * Convert image coordinates to pixel coordinates relative to the window.
           * @param {OpenSeadragon.Point} pixel
           * @returns {OpenSeadragon.Point}
           */
          imageToWindowCoordinates: function(r) {
            var i = this.imageToViewerElementCoordinates(r);
            return i.plus(
              t.getElementPosition(this.viewer.element)
            );
          },
          // private
          // Convert rectangle in viewport coordinates to this tiled image point
          // coordinates (x in [0, 1] and y in [0, aspectRatio])
          _viewportToTiledImageRectangle: function(r) {
            var i = this._scaleSpring.current.value;
            return r = r.rotate(-this.getRotation(!0), this._getRotationPoint(!0)), new n.Rect(
              (r.x - this._xSpring.current.value) / i,
              (r.y - this._ySpring.current.value) / i,
              r.width / i,
              r.height / i,
              r.degrees
            );
          },
          /**
           * Convert a viewport zoom to an image zoom.
           * Image zoom: ratio of the original image size to displayed image size.
           * 1 means original image size, 0.5 half size...
           * Viewport zoom: ratio of the displayed image's width to viewport's width.
           * 1 means identical width, 2 means image's width is twice the viewport's width...
           * @function
           * @param {Number} viewportZoom The viewport zoom
           * @returns {Number} imageZoom The image zoom
           */
          viewportToImageZoom: function(r) {
            var i = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
            return i * r;
          },
          /**
           * Convert an image zoom to a viewport zoom.
           * Image zoom: ratio of the original image size to displayed image size.
           * 1 means original image size, 0.5 half size...
           * Viewport zoom: ratio of the displayed image's width to viewport's width.
           * 1 means identical width, 2 means image's width is twice the viewport's width...
           * Note: not accurate with multi-image.
           * @function
           * @param {Number} imageZoom The image zoom
           * @returns {Number} viewportZoom The viewport zoom
           */
          imageToViewportZoom: function(r) {
            var i = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
            return r / i;
          },
          /**
           * Sets the TiledImage's position in the world.
           * @param {OpenSeadragon.Point} position - The new position, in viewport coordinates.
           * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
           * @fires OpenSeadragon.TiledImage.event:bounds-change
           */
          setPosition: function(r, i) {
            var o = this._xSpring.target.value === r.x && this._ySpring.target.value === r.y;
            if (i) {
              if (o && this._xSpring.current.value === r.x && this._ySpring.current.value === r.y)
                return;
              this._xSpring.resetTo(r.x), this._ySpring.resetTo(r.y), this._needsDraw = !0, this._needsUpdate = !0;
            } else {
              if (o)
                return;
              this._xSpring.springTo(r.x), this._ySpring.springTo(r.y), this._needsDraw = !0, this._needsUpdate = !0;
            }
            o || this._raiseBoundsChange();
          },
          /**
           * Sets the TiledImage's width in the world, adjusting the height to match based on aspect ratio.
           * @param {Number} width - The new width, in viewport coordinates.
           * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
           * @fires OpenSeadragon.TiledImage.event:bounds-change
           */
          setWidth: function(r, i) {
            this._setScale(r, i);
          },
          /**
           * Sets the TiledImage's height in the world, adjusting the width to match based on aspect ratio.
           * @param {Number} height - The new height, in viewport coordinates.
           * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
           * @fires OpenSeadragon.TiledImage.event:bounds-change
           */
          setHeight: function(r, i) {
            this._setScale(r / this.normHeight, i);
          },
          /**
           * Sets an array of polygons to crop the TiledImage during draw tiles.
           * The render function will use the default non-zero winding rule.
           * @param {OpenSeadragon.Point[][]} polygons - represented in an array of point object in image coordinates.
           * Example format: [
           *  [{x: 197, y:172}, {x: 226, y:172}, {x: 226, y:198}, {x: 197, y:198}], // First polygon
           *  [{x: 328, y:200}, {x: 330, y:199}, {x: 332, y:201}, {x: 329, y:202}]  // Second polygon
           *  [{x: 321, y:201}, {x: 356, y:205}, {x: 341, y:250}] // Third polygon
           * ]
           */
          setCroppingPolygons: function(r) {
            var i = function(s) {
              return s instanceof n.Point || typeof s.x == "number" && typeof s.y == "number";
            }, o = function(s) {
              return s.map(function(u) {
                try {
                  if (i(u))
                    return { x: u.x, y: u.y };
                  throw new Error();
                } catch {
                  throw new Error("A Provided cropping polygon point is not supported");
                }
              });
            };
            try {
              if (!n.isArray(r))
                throw new Error("Provided cropping polygon is not an array");
              this._croppingPolygons = r.map(function(s) {
                return o(s);
              }), this._needsDraw = !0;
            } catch (s) {
              n.console.error("[TiledImage.setCroppingPolygons] Cropping polygon format not supported"), n.console.error(s), this.resetCroppingPolygons();
            }
          },
          /**
           * Resets the cropping polygons, thus next render will remove all cropping
           * polygon effects.
           */
          resetCroppingPolygons: function() {
            this._croppingPolygons = null, this._needsDraw = !0;
          },
          /**
           * Positions and scales the TiledImage to fit in the specified bounds.
           * Note: this method fires OpenSeadragon.TiledImage.event:bounds-change
           * twice
           * @param {OpenSeadragon.Rect} bounds The bounds to fit the image into.
           * @param {OpenSeadragon.Placement} [anchor=OpenSeadragon.Placement.CENTER]
           * How to anchor the image in the bounds.
           * @param {Boolean} [immediately=false] Whether to animate to the new size
           * or snap immediately.
           * @fires OpenSeadragon.TiledImage.event:bounds-change
           */
          fitBounds: function(r, i, o) {
            i = i || n.Placement.CENTER;
            var s = n.Placement.properties[i], u = this.contentAspectX, f = 0, p = 0, m = 1, v = 1;
            if (this._clip && (u = this._clip.getAspectRatio(), m = this._clip.width / this.source.dimensions.x, v = this._clip.height / this.source.dimensions.y, r.getAspectRatio() > u ? (f = this._clip.x / this._clip.height * r.height, p = this._clip.y / this._clip.height * r.height) : (f = this._clip.x / this._clip.width * r.width, p = this._clip.y / this._clip.width * r.width)), r.getAspectRatio() > u) {
              var y = r.height / v, S = 0;
              s.isHorizontallyCentered ? S = (r.width - r.height * u) / 2 : s.isRight && (S = r.width - r.height * u), this.setPosition(
                new n.Point(r.x - f + S, r.y - p),
                o
              ), this.setHeight(y, o);
            } else {
              var E = r.width / m, w = 0;
              s.isVerticallyCentered ? w = (r.height - r.width / u) / 2 : s.isBottom && (w = r.height - r.width / u), this.setPosition(
                new n.Point(r.x - f, r.y - p + w),
                o
              ), this.setWidth(E, o);
            }
          },
          /**
           * @returns {OpenSeadragon.Rect|null} The TiledImage's current clip rectangle,
           * in image pixels, or null if none.
           */
          getClip: function() {
            return this._clip ? this._clip.clone() : null;
          },
          /**
           * @param {OpenSeadragon.Rect|null} newClip - An area, in image pixels, to clip to
           * (portions of the image outside of this area will not be visible). Only works on
           * browsers that support the HTML5 canvas.
           * @fires OpenSeadragon.TiledImage.event:clip-change
           */
          setClip: function(r) {
            n.console.assert(
              !r || r instanceof n.Rect,
              "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null"
            ), r instanceof n.Rect ? this._clip = r.clone() : this._clip = null, this._needsUpdate = !0, this._needsDraw = !0, this.raiseEvent("clip-change");
          },
          /**
           * @returns {Boolean} Whether the TiledImage should be flipped before rendering.
           */
          getFlip: function() {
            return this.flipped;
          },
          /**
           * @param {Boolean} flip Whether the TiledImage should be flipped before rendering.
           * @fires OpenSeadragon.TiledImage.event:bounds-change
           */
          setFlip: function(r) {
            this.flipped = r;
          },
          get flipped() {
            return this._flipped;
          },
          set flipped(r) {
            let i = this._flipped !== !!r;
            this._flipped = !!r, i && (this.update(!0), this._needsDraw = !0, this._raiseBoundsChange());
          },
          get wrapHorizontal() {
            return this._wrapHorizontal;
          },
          set wrapHorizontal(r) {
            let i = this._wrapHorizontal !== !!r;
            this._wrapHorizontal = !!r, this._initialized && i && (this.update(!0), this._needsDraw = !0);
          },
          get wrapVertical() {
            return this._wrapVertical;
          },
          set wrapVertical(r) {
            let i = this._wrapVertical !== !!r;
            this._wrapVertical = !!r, this._initialized && i && (this.update(!0), this._needsDraw = !0);
          },
          get debugMode() {
            return this._debugMode;
          },
          set debugMode(r) {
            this._debugMode = !!r, this._needsDraw = !0;
          },
          /**
           * @returns {Number} The TiledImage's current opacity.
           */
          getOpacity: function() {
            return this.opacity;
          },
          /**
           * @param {Number} opacity Opacity the tiled image should be drawn at.
           * @fires OpenSeadragon.TiledImage.event:opacity-change
           */
          setOpacity: function(r) {
            this.opacity = r;
          },
          get opacity() {
            return this._opacity;
          },
          set opacity(r) {
            r !== this.opacity && (this._opacity = r, this._needsDraw = !0, this.raiseEvent("opacity-change", {
              opacity: this.opacity
            }));
          },
          /**
           * @returns {Boolean} whether the tiledImage can load its tiles even when it has zero opacity.
           */
          getPreload: function() {
            return this._preload;
          },
          /**
           * Set true to load even when hidden. Set false to block loading when hidden.
           */
          setPreload: function(r) {
            this._preload = !!r, this._needsDraw = !0;
          },
          /**
           * Get the rotation of this tiled image in degrees.
           * @param {Boolean} [current=false] True for current rotation, false for target.
           * @returns {Number} the rotation of this tiled image in degrees.
           */
          getRotation: function(r) {
            return r ? this._degreesSpring.current.value : this._degreesSpring.target.value;
          },
          /**
           * Set the current rotation of this tiled image in degrees.
           * @param {Number} degrees the rotation in degrees.
           * @param {Boolean} [immediately=false] Whether to animate to the new angle
           * or rotate immediately.
           * @fires OpenSeadragon.TiledImage.event:bounds-change
           */
          setRotation: function(r, i) {
            this._degreesSpring.target.value === r && this._degreesSpring.isAtTargetValue() || (i ? this._degreesSpring.resetTo(r) : this._degreesSpring.springTo(r), this._needsDraw = !0, this._needsUpdate = !0, this._raiseBoundsChange());
          },
          /**
           * Get the region of this tiled image that falls within the viewport.
           * @returns {OpenSeadragon.Rect} the region of this tiled image that falls within the viewport.
           * Returns false for images with opacity==0 unless preload==true
           */
          getDrawArea: function() {
            if (this._opacity === 0 && !this._preload)
              return !1;
            var r = this._viewportToTiledImageRectangle(
              this.viewport.getBoundsWithMargins(!0)
            );
            if (!this.wrapHorizontal && !this.wrapVertical) {
              var i = this._viewportToTiledImageRectangle(
                this.getClippedBounds(!0)
              );
              r = r.intersection(i);
            }
            return r;
          },
          /**
           *
           * @returns {Array} Array of Tiles that make up the current view
           */
          getTilesToDraw: function() {
            let r = this._tilesToDraw.flat();
            return this._updateTilesInViewport(r), r = this._tilesToDraw.flat(), r.forEach((i) => {
              i.tile.beingDrawn = !0;
            }), this._lastDrawn = r, r;
          },
          /**
           * Get the point around which this tiled image is rotated
           * @private
           * @param {Boolean} current True for current rotation point, false for target.
           * @returns {OpenSeadragon.Point}
           */
          _getRotationPoint: function(r) {
            return this.getBoundsNoRotate(r).getCenter();
          },
          get compositeOperation() {
            return this._compositeOperation;
          },
          set compositeOperation(r) {
            r !== this._compositeOperation && (this._compositeOperation = r, this._needsDraw = !0, this.raiseEvent("composite-operation-change", {
              compositeOperation: this._compositeOperation
            }));
          },
          /**
           * @returns {String} The TiledImage's current compositeOperation.
           */
          getCompositeOperation: function() {
            return this._compositeOperation;
          },
          /**
           * @param {String} compositeOperation the tiled image should be drawn with this globalCompositeOperation.
           * @fires OpenSeadragon.TiledImage.event:composite-operation-change
           */
          setCompositeOperation: function(r) {
            this.compositeOperation = r;
          },
          /**
           * Update headers to include when making AJAX requests.
           *
           * Unless `propagate` is set to false (which is likely only useful in rare circumstances),
           * the updated headers are propagated to all tiles and queued image loader jobs.
           *
           * Note that the rules for merging headers still apply, i.e. headers returned by
           * {@link OpenSeadragon.TileSource#getTileAjaxHeaders} take precedence over
           * the headers here in the tiled image (`TiledImage.ajaxHeaders`).
           *
           * @function
           * @param {Object} ajaxHeaders Updated AJAX headers, which will be merged over any headers specified in {@link OpenSeadragon.Options}.
           * @param {Boolean} [propagate=true] Whether to propagate updated headers to existing tiles and queued image loader jobs.
           */
          setAjaxHeaders: function(r, i) {
            if (r === null && (r = {}), !n.isPlainObject(r)) {
              console.error("[TiledImage.setAjaxHeaders] Ignoring invalid headers, must be a plain object");
              return;
            }
            this._ownAjaxHeaders = r, this._updateAjaxHeaders(i);
          },
          /**
           * Update headers to include when making AJAX requests.
           *
           * This function has the same effect as calling {@link OpenSeadragon.TiledImage#setAjaxHeaders},
           * except that the headers for this tiled image do not change. This is especially useful
           * for propagating updated headers from {@link OpenSeadragon.TileSource#getTileAjaxHeaders}
           * to existing tiles.
           *
           * @private
           * @function
           * @param {Boolean} [propagate=true] Whether to propagate updated headers to existing tiles and queued image loader jobs.
           */
          _updateAjaxHeaders: function(r) {
            if (r === void 0 && (r = !0), n.isPlainObject(this.viewer.ajaxHeaders) ? this.ajaxHeaders = n.extend({}, this.viewer.ajaxHeaders, this._ownAjaxHeaders) : this.ajaxHeaders = this._ownAjaxHeaders, r) {
              var i, o, s, u;
              for (var f in this.tilesMatrix) {
                i = this.source.getNumTiles(f);
                for (var p in this.tilesMatrix[f]) {
                  o = (i.x + p % i.x) % i.x;
                  for (var m in this.tilesMatrix[f][p])
                    if (s = (i.y + m % i.y) % i.y, u = this.tilesMatrix[f][p][m], u.loadWithAjax = this.loadTilesWithAjax, u.loadWithAjax) {
                      var v = this.source.getTileAjaxHeaders(f, o, s);
                      u.ajaxHeaders = n.extend({}, this.ajaxHeaders, v);
                    } else
                      u.ajaxHeaders = null;
                }
              }
              for (var y = 0; y < this._imageLoader.jobQueue.length; y++) {
                var S = this._imageLoader.jobQueue[y];
                S.loadWithAjax = S.tile.loadWithAjax, S.ajaxHeaders = S.tile.loadWithAjax ? S.tile.ajaxHeaders : null;
              }
            }
          },
          // private
          _setScale: function(r, i) {
            var o = this._scaleSpring.target.value === r;
            if (i) {
              if (o && this._scaleSpring.current.value === r)
                return;
              this._scaleSpring.resetTo(r), this._updateForScale(), this._needsDraw = !0, this._needsUpdate = !0;
            } else {
              if (o)
                return;
              this._scaleSpring.springTo(r), this._updateForScale(), this._needsDraw = !0, this._needsUpdate = !0;
            }
            o || this._raiseBoundsChange();
          },
          // private
          _updateForScale: function() {
            this._worldWidthTarget = this._scaleSpring.target.value, this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value, this._worldWidthCurrent = this._scaleSpring.current.value, this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
          },
          // private
          _raiseBoundsChange: function() {
            this.raiseEvent("bounds-change");
          },
          // private
          _isBottomItem: function() {
            return this.viewer.world.getItemAt(0) === this;
          },
          // private
          _getLevelsInterval: function() {
            var r = Math.max(
              this.source.minLevel,
              Math.floor(Math.log(this.minZoomImageRatio) / Math.log(2))
            ), i = this.viewport.deltaPixelsFromPointsNoRotate(
              this.source.getPixelRatio(0),
              !0
            ).x * this._scaleSpring.current.value, o = Math.min(
              Math.abs(this.source.maxLevel),
              Math.abs(Math.floor(
                Math.log(i / this.minPixelRatio) / Math.log(2)
              ))
            );
            return o = Math.max(o, this.source.minLevel || 0), r = Math.min(r, o), {
              lowestLevel: r,
              highestLevel: o
            };
          },
          // returns boolean flag of whether the image should be marked as fully loaded
          _updateLevelsForViewport: function() {
            var r = this._getLevelsInterval(), i = r.lowestLevel, o = r.highestLevel, s = [], u = this.getDrawArea(), f = n.now();
            if (this._lastDrawn.forEach((N) => {
              N.tile.beingDrawn = !1;
            }), this._tilesToDraw = [], this._tilesLoading = 0, this.loadingCoverage = {}, !u)
              return this._needsDraw = !1, this._fullyLoaded;
            var p = new Array(o - i + 1);
            for (let N = 0, k = o; k >= i; k--, N++)
              p[N] = k;
            for (let N = o + 1; N <= this.source.maxLevel; N++) {
              var m = this.tilesMatrix[N] && this.tilesMatrix[N][0] && this.tilesMatrix[N][0][0];
              if (m && m.isBottomMost && m.isRightMost && m.loaded) {
                p.push(N);
                break;
              }
            }
            let v = !1;
            for (let N = 0; N < p.length; N++) {
              let k = p[N];
              var y = this.viewport.deltaPixelsFromPointsNoRotate(
                this.source.getPixelRatio(k),
                !0
              ).x * this._scaleSpring.current.value;
              if (N === p.length - 1 || y >= this.minPixelRatio)
                v = !0;
              else if (!v)
                continue;
              var S = this.viewport.deltaPixelsFromPointsNoRotate(
                this.source.getPixelRatio(k),
                !1
              ).x * this._scaleSpring.current.value, E = this.viewport.deltaPixelsFromPointsNoRotate(
                this.source.getPixelRatio(
                  Math.max(
                    this.source.getClosestLevel(),
                    0
                  )
                ),
                !1
              ).x * this._scaleSpring.current.value, w = this.immediateRender ? 1 : E, _ = Math.min(1, (y - 0.5) / 0.5), O = w / Math.abs(
                w - S
              ), D = this._updateLevel(
                k,
                _,
                O,
                u,
                f,
                s
              );
              s = D.bestTiles;
              var P = D.updatedTiles.filter((U) => U.loaded), M = /* @__PURE__ */ (function(U, H, Y) {
                return function(z) {
                  return {
                    tile: z,
                    level: U,
                    levelOpacity: H,
                    currentTime: Y
                  };
                };
              })(k, _, f);
              if (this._tilesToDraw[k] = P.map(M), this._providesCoverage(this.coverage, k))
                break;
            }
            return s && s.length > 0 ? (s.forEach(function(N) {
              N && !N.context2D && this._loadTile(N, f);
            }, this), this._needsDraw = !0, !1) : this._tilesLoading === 0;
          },
          /**
           * Update all tiles that contribute to the current view
           * @private
           *
           */
          _updateTilesInViewport: function(r) {
            let i = n.now(), o = this;
            this._tilesLoading = 0, this._wasBlending = this._isBlending, this._isBlending = !1, this.loadingCoverage = {};
            let s = r.length ? r[0].level : 0;
            if (!this.getDrawArea())
              return;
            function f(m) {
              let v = m.tile;
              if (v && v.loaded) {
                let y = o._blendTile(
                  v,
                  v.x,
                  v.y,
                  m.level,
                  m.levelOpacity,
                  i,
                  s
                );
                o._isBlending = o._isBlending || y, o._needsDraw = o._needsDraw || y || o._wasBlending;
              }
            }
            let p = 0;
            for (let m = 0; m < r.length; m++) {
              let v = r[m];
              f(v), this._providesCoverage(this.coverage, v.level) && (p = Math.max(p, v.level));
            }
            if (p > 0)
              for (let m in this._tilesToDraw)
                m < p && delete this._tilesToDraw[m];
          },
          /**
           * Updates the opacity of a tile according to the time it has been on screen
           * to perform a fade-in.
           * Updates coverage once a tile is fully opaque.
           * Returns whether the fade-in has completed.
           * @private
           *
           * @param {OpenSeadragon.Tile} tile
           * @param {Number} x
           * @param {Number} y
           * @param {Number} level
           * @param {Number} levelOpacity
           * @param {Number} currentTime
           * @param {Boolean} lowestLevel
           * @returns {Boolean} true if blending did not yet finish
           */
          _blendTile: function(r, i, o, s, u, f, p) {
            let m = 1e3 * this.blendTime, v, y;
            return r.blendStart || (r.blendStart = f), v = f - r.blendStart, y = m ? Math.min(1, v / m) : 1, s === p && (y = 1, v = m), this.alwaysBlend && (y *= u), r.opacity = y, y === 1 && (this._setCoverage(this.coverage, s, i, o, !0), this._hasOpaqueTile = !0), v < m;
          },
          /**
           * Updates all tiles at a given resolution level.
           * @private
           * @param {Number} level
           * @param {Number} levelOpacity
           * @param {Number} levelVisibility
           * @param {OpenSeadragon.Rect} drawArea
           * @param {Number} currentTime
           * @param {OpenSeadragon.Tile[]} best Array of the current best tiles
           * @returns {Object} Dictionary {bestTiles: OpenSeadragon.Tile - the current "best" tiles to draw, updatedTiles: OpenSeadragon.Tile) - the updated tiles}.
           */
          _updateLevel: function(r, i, o, s, u, f) {
            var p = s.getBoundingBox().getTopLeft(), m = s.getBoundingBox().getBottomRight();
            this.viewer && this.viewer.raiseEvent("update-level", {
              tiledImage: this,
              havedrawn: !0,
              // deprecated, kept for backwards compatibility
              level: r,
              opacity: i,
              visibility: o,
              drawArea: s,
              topleft: p,
              bottomright: m,
              currenttime: u,
              best: f
            }), this._resetCoverage(this.coverage, r), this._resetCoverage(this.loadingCoverage, r);
            var v = this._getCornerTiles(r, p, m), y = v.topLeft, S = v.bottomRight, E = this.source.getNumTiles(r), w = this.viewport.pixelFromPoint(this.viewport.getCenter());
            this.getFlip() && (S.x += 1, this.wrapHorizontal || (S.x = Math.min(S.x, E.x - 1)));
            for (var _ = Math.max(0, (S.x - y.x) * (S.y - y.y)), O = new Array(_), D = 0, P = y.x; P <= S.x; P++)
              for (var M = y.y; M <= S.y; M++) {
                var N;
                if (this.getFlip()) {
                  var k = (E.x + P % E.x) % E.x;
                  N = P + E.x - k - k - 1;
                } else
                  N = P;
                if (s.intersection(this.getTileBounds(r, N, M)) !== null) {
                  var U = this._updateTile(
                    N,
                    M,
                    r,
                    o,
                    w,
                    E,
                    u,
                    f
                  );
                  f = U.bestTiles, O[D] = U.tile, D += 1;
                }
              }
            return {
              bestTiles: f,
              updatedTiles: O
            };
          },
          /**
           * @private
           * @param {OpenSeadragon.Tile} tile
           * @param {Boolean} overlap
           * @param {OpenSeadragon.Viewport} viewport
           * @param {OpenSeadragon.Point} viewportCenter
           * @param {Number} levelVisibility
           */
          _positionTile: function(r, i, o, s, u) {
            var f = r.bounds.getTopLeft();
            f.x *= this._scaleSpring.current.value, f.y *= this._scaleSpring.current.value, f.x += this._xSpring.current.value, f.y += this._ySpring.current.value;
            var p = r.bounds.getSize();
            p.x *= this._scaleSpring.current.value, p.y *= this._scaleSpring.current.value, r.positionedBounds.x = f.x, r.positionedBounds.y = f.y, r.positionedBounds.width = p.x, r.positionedBounds.height = p.y;
            var m = o.pixelFromPointNoRotate(f, !0), v = o.pixelFromPointNoRotate(f, !1), y = o.deltaPixelsFromPointsNoRotate(p, !0), S = o.deltaPixelsFromPointsNoRotate(p, !1), E = v.plus(S.divide(2)), w = s.squaredDistanceTo(E);
            this.viewer.drawer.minimumOverlapRequired(this) && (i || (y = y.plus(new n.Point(1, 1))), r.isRightMost && this.wrapHorizontal && (y.x += 0.75), r.isBottomMost && this.wrapVertical && (y.y += 0.75)), r.position = m, r.size = y, r.squaredDistance = w, r.visibility = u;
          },
          /**
           * Update a single tile at a particular resolution level.
           * @private
           * @param {Number} x
           * @param {Number} y
           * @param {Number} level
           * @param {Number} levelVisibility
           * @param {OpenSeadragon.Point} viewportCenter
           * @param {Number} numberOfTiles
           * @param {Number} currentTime
           * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
           * @returns {Object} Dictionary {bestTiles: OpenSeadragon.Tile[] - the current best tiles, tile: OpenSeadragon.Tile the current tile}
           */
          _updateTile: function(r, i, o, s, u, f, p, m) {
            var v = this._getTile(
              r,
              i,
              o,
              p,
              f
            );
            this.viewer && this.viewer.raiseEvent("update-tile", {
              tiledImage: this,
              tile: v
            }), this._setCoverage(this.coverage, o, r, i, !1);
            var y = v.loaded || v.loading || this._isCovered(this.loadingCoverage, o, r, i);
            if (this._setCoverage(this.loadingCoverage, o, r, i, y), !v.exists)
              return {
                bestTiles: m,
                tile: v
              };
            if (v.loaded && v.opacity === 1 && this._setCoverage(this.coverage, o, r, i, !0), this._positionTile(
              v,
              this.source.tileOverlap,
              this.viewport,
              u,
              s
            ), !v.loaded)
              if (v.context2D)
                this._setTileLoaded(v);
              else {
                var S = this._tileCache.getImageRecord(v.cacheKey);
                S && this._setTileLoaded(v, S.getData());
              }
            return v.loading ? this._tilesLoading++ : y || (m = this._compareTiles(m, v, this.maxTilesPerFrame)), {
              bestTiles: m,
              tile: v
            };
          },
          // private
          _getCornerTiles: function(r, i, o) {
            var s, u;
            this.wrapHorizontal ? (s = n.positiveModulo(i.x, 1), u = n.positiveModulo(o.x, 1)) : (s = Math.max(0, i.x), u = Math.min(1, o.x));
            var f, p, m = 1 / this.source.aspectRatio;
            this.wrapVertical ? (f = n.positiveModulo(i.y, m), p = n.positiveModulo(o.y, m)) : (f = Math.max(0, i.y), p = Math.min(m, o.y));
            var v = this.source.getTileAtPoint(r, new n.Point(s, f)), y = this.source.getTileAtPoint(r, new n.Point(u, p)), S = this.source.getNumTiles(r);
            return this.wrapHorizontal && (v.x += S.x * Math.floor(i.x), y.x += S.x * Math.floor(o.x)), this.wrapVertical && (v.y += S.y * Math.floor(i.y / m), y.y += S.y * Math.floor(o.y / m)), {
              topLeft: v,
              bottomRight: y
            };
          },
          /**
           * Obtains a tile at the given location.
           * @private
           * @param {Number} x
           * @param {Number} y
           * @param {Number} level
           * @param {Number} time
           * @param {Number} numTiles
           * @returns {OpenSeadragon.Tile}
           */
          _getTile: function(r, i, o, s, u) {
            var f, p, m, v, y, S, E, w, _, O, D = this.tilesMatrix, P = this.source;
            return D[o] || (D[o] = {}), D[o][r] || (D[o][r] = {}), (!D[o][r][i] || !D[o][r][i].flipped != !this.flipped) && (f = (u.x + r % u.x) % u.x, p = (u.y + i % u.y) % u.y, m = this.getTileBounds(o, r, i), v = P.getTileBounds(o, f, p, !0), y = P.tileExists(o, f, p), S = P.getTileUrl(o, f, p), E = P.getTilePostData(o, f, p), this.loadTilesWithAjax ? (w = P.getTileAjaxHeaders(o, f, p), n.isPlainObject(this.ajaxHeaders) && (w = n.extend({}, this.ajaxHeaders, w))) : w = null, _ = P.getContext2D ? P.getContext2D(o, f, p) : void 0, O = new n.Tile(
              o,
              r,
              i,
              m,
              y,
              S,
              _,
              this.loadTilesWithAjax,
              w,
              v,
              E,
              P.getTileHashKey(o, f, p, S, w, E)
            ), this.getFlip() ? f === 0 && (O.isRightMost = !0) : f === u.x - 1 && (O.isRightMost = !0), p === u.y - 1 && (O.isBottomMost = !0), O.flipped = this.flipped, D[o][r][i] = O), O = D[o][r][i], O.lastTouchTime = s, O;
          },
          /**
           * Dispatch a job to the ImageLoader to load the Image for a Tile.
           * @private
           * @param {OpenSeadragon.Tile} tile
           * @param {Number} time
           */
          _loadTile: function(r, i) {
            var o = this;
            r.loading = !0, this._imageLoader.addJob({
              src: r.getUrl(),
              tile: r,
              source: this.source,
              postData: r.postData,
              loadWithAjax: r.loadWithAjax,
              ajaxHeaders: r.ajaxHeaders,
              crossOriginPolicy: this.crossOriginPolicy,
              ajaxWithCredentials: this.ajaxWithCredentials,
              callback: function(s, u, f) {
                o._onTileLoad(r, i, s, u, f);
              },
              abort: function() {
                r.loading = !1;
              }
            });
          },
          /**
           * Callback fired when a Tile's Image finished downloading.
           * @private
           * @param {OpenSeadragon.Tile} tile
           * @param {Number} time
           * @param {*} data image data
           * @param {String} errorMsg
           * @param {XMLHttpRequest} tileRequest
           */
          _onTileLoad: function(r, i, o, s, u) {
            if (o)
              r.exists = !0;
            else {
              n.console.error("Tile %s failed to load: %s - error: %s", r, r.getUrl(), s), this.viewer.raiseEvent("tile-load-failed", {
                tile: r,
                tiledImage: this,
                time: i,
                message: s,
                tileRequest: u
              }), r.loading = !1, r.exists = !1;
              return;
            }
            if (i < this.lastResetTime) {
              n.console.warn("Ignoring tile %s loaded before reset: %s", r, r.getUrl()), r.loading = !1;
              return;
            }
            var f = this, p = function() {
              var m = f.source, v = m.getClosestLevel();
              f._setTileLoaded(r, o, v, u);
            };
            p();
          },
          /**
           * @private
           * @param {OpenSeadragon.Tile} tile
           * @param {*} data image data, the data sent to ImageJob.prototype.finish(), by default an Image object
           * @param {Number|undefined} cutoff
           * @param {XMLHttpRequest|undefined} tileRequest
           */
          _setTileLoaded: function(r, i, o, s) {
            var u = 0, f = !1, p = this;
            function m() {
              return f && n.console.error("Event 'tile-loaded' argument getCompletionCallback must be called synchronously. Its return value should be called asynchronously."), u++, v;
            }
            function v() {
              u--, u === 0 && (r.loading = !1, r.loaded = !0, r.hasTransparency = p.source.hasTransparency(
                r.context2D,
                r.getUrl(),
                r.ajaxHeaders,
                r.postData
              ), r.context2D || p._tileCache.cacheTile({
                data: i,
                tile: r,
                cutoff: o,
                tiledImage: p
              }), p.viewer.raiseEvent("tile-ready", {
                tile: r,
                tiledImage: p,
                tileRequest: s
              }), p._needsDraw = !0);
            }
            var y = m();
            this.viewer.raiseEvent("tile-loaded", {
              tile: r,
              tiledImage: this,
              tileRequest: s,
              get image() {
                return n.console.error("[tile-loaded] event 'image' has been deprecated. Use 'data' property instead."), i;
              },
              data: i,
              getCompletionCallback: m
            }), f = !0, y();
          },
          /**
           * Determines the 'best tiles' from the given 'last best' tiles and the
           * tile in question.
           * @private
           *
           * @param {OpenSeadragon.Tile[]} previousBest The best tiles so far.
           * @param {OpenSeadragon.Tile} tile The new tile to consider.
           * @param {Number} maxNTiles The max number of best tiles.
           * @returns {OpenSeadragon.Tile[]} The new best tiles.
           */
          _compareTiles: function(r, i, o) {
            return r ? (r.push(i), this._sortTiles(r), r.length > o && r.pop(), r) : [i];
          },
          /**
           * Sorts tiles in an array according to distance and visibility.
           * @private
           *
           * @param {OpenSeadragon.Tile[]} tiles The tiles.
           */
          _sortTiles: function(r) {
            r.sort(function(i, o) {
              return i === null ? 1 : o === null ? -1 : i.visibility === o.visibility ? i.squaredDistance - o.squaredDistance : o.visibility - i.visibility;
            });
          },
          /**
           * Returns true if the given tile provides coverage to lower-level tiles of
           * lower resolution representing the same content. If neither x nor y is
           * given, returns true if the entire visible level provides coverage.
           *
           * Note that out-of-bounds tiles provide coverage in this sense, since
           * there's no content that they would need to cover. Tiles at non-existent
           * levels that are within the image bounds, however, do not.
           * @private
           *
           * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
           * @param {Number} level - The resolution level of the tile.
           * @param {Number} x - The X position of the tile.
           * @param {Number} y - The Y position of the tile.
           * @returns {Boolean}
           */
          _providesCoverage: function(r, i, o, s) {
            var u, f, p, m;
            if (!r[i])
              return !1;
            if (o === void 0 || s === void 0) {
              u = r[i];
              for (p in u)
                if (Object.prototype.hasOwnProperty.call(u, p)) {
                  f = u[p];
                  for (m in f)
                    if (Object.prototype.hasOwnProperty.call(f, m) && !f[m])
                      return !1;
                }
              return !0;
            }
            return r[i][o] === void 0 || r[i][o][s] === void 0 || r[i][o][s] === !0;
          },
          /**
           * Returns true if the given tile is completely covered by higher-level
           * tiles of higher resolution representing the same content. If neither x
           * nor y is given, returns true if the entire visible level is covered.
           * @private
           *
           * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
           * @param {Number} level - The resolution level of the tile.
           * @param {Number} x - The X position of the tile.
           * @param {Number} y - The Y position of the tile.
           * @returns {Boolean}
           */
          _isCovered: function(r, i, o, s) {
            return o === void 0 || s === void 0 ? this._providesCoverage(r, i + 1) : this._providesCoverage(r, i + 1, 2 * o, 2 * s) && this._providesCoverage(r, i + 1, 2 * o, 2 * s + 1) && this._providesCoverage(r, i + 1, 2 * o + 1, 2 * s) && this._providesCoverage(r, i + 1, 2 * o + 1, 2 * s + 1);
          },
          /**
           * Sets whether the given tile provides coverage or not.
           * @private
           *
           * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
           * @param {Number} level - The resolution level of the tile.
           * @param {Number} x - The X position of the tile.
           * @param {Number} y - The Y position of the tile.
           * @param {Boolean} covers - Whether the tile provides coverage.
           */
          _setCoverage: function(r, i, o, s, u) {
            if (!r[i]) {
              n.console.warn(
                "Setting coverage for a tile before its level's coverage has been reset: %s",
                i
              );
              return;
            }
            r[i][o] || (r[i][o] = {}), r[i][o][s] = u;
          },
          /**
           * Resets coverage information for the given level. This should be called
           * after every draw routine. Note that at the beginning of the next draw
           * routine, coverage for every visible tile should be explicitly set.
           * @private
           *
           * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
           * @param {Number} level - The resolution level of tiles to completely reset.
           */
          _resetCoverage: function(r, i) {
            r[i] = {};
          }
        }
      );
    })(t), (function(n) {
      var r = function(o) {
        n.console.assert(o, "[TileCache.cacheTile] options is required"), n.console.assert(o.tile, "[TileCache.cacheTile] options.tile is required"), n.console.assert(o.tiledImage, "[TileCache.cacheTile] options.tiledImage is required"), this.tile = o.tile, this.tiledImage = o.tiledImage;
      }, i = function(o) {
        n.console.assert(o, "[ImageRecord] options is required"), n.console.assert(o.data, "[ImageRecord] options.data is required"), this._tiles = [], o.create.apply(null, [this, o.data, o.ownerTile]), this._destroyImplementation = o.destroy.bind(null, this), this.getImage = o.getImage.bind(null, this), this.getData = o.getData.bind(null, this), this.getRenderedContext = o.getRenderedContext.bind(null, this);
      };
      i.prototype = {
        destroy: function() {
          this._destroyImplementation(), this._tiles = null;
        },
        addTile: function(o) {
          n.console.assert(o, "[ImageRecord.addTile] tile is required"), this._tiles.push(o);
        },
        removeTile: function(o) {
          for (var s = 0; s < this._tiles.length; s++)
            if (this._tiles[s] === o) {
              this._tiles.splice(s, 1);
              return;
            }
          n.console.warn("[ImageRecord.removeTile] trying to remove unknown tile", o);
        },
        getTileCount: function() {
          return this._tiles.length;
        }
      }, n.TileCache = function(o) {
        o = o || {}, this._maxImageCacheCount = o.maxImageCacheCount || n.DEFAULT_SETTINGS.maxImageCacheCount, this._tilesLoaded = [], this._imagesLoaded = [], this._imagesLoadedCount = 0;
      }, n.TileCache.prototype = {
        /**
         * @returns {Number} The total number of tiles that have been loaded by
         * this TileCache.
         */
        numTilesLoaded: function() {
          return this._tilesLoaded.length;
        },
        /**
         * Caches the specified tile, removing an old tile if necessary to stay under the
         * maxImageCacheCount specified on construction. Note that if multiple tiles reference
         * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
         * the number of images below that number. Note, as well, that even the number of images
         * may temporarily surpass that number, but should eventually come back down to the max specified.
         * @param {Object} options - Tile info.
         * @param {OpenSeadragon.Tile} options.tile - The tile to cache.
         * @param {String} options.tile.cacheKey - The unique key used to identify this tile in the cache.
         * @param {Image} options.image - The image of the tile to cache.
         * @param {OpenSeadragon.TiledImage} options.tiledImage - The TiledImage that owns that tile.
         * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
         * function will release an old tile. The cutoff option specifies a tile level at or below which
         * tiles will not be released.
         */
        cacheTile: function(o) {
          n.console.assert(o, "[TileCache.cacheTile] options is required"), n.console.assert(o.tile, "[TileCache.cacheTile] options.tile is required"), n.console.assert(o.tile.cacheKey, "[TileCache.cacheTile] options.tile.cacheKey is required"), n.console.assert(o.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");
          var s = o.cutoff || 0, u = this._tilesLoaded.length, f = this._imagesLoaded[o.tile.cacheKey];
          if (f || (o.data || (n.console.error("[TileCache.cacheTile] options.image was renamed to options.data. '.image' attribute has been deprecated and will be removed in the future."), o.data = o.image), n.console.assert(o.data, "[TileCache.cacheTile] options.data is required to create an ImageRecord"), f = this._imagesLoaded[o.tile.cacheKey] = new i({
            data: o.data,
            ownerTile: o.tile,
            create: o.tiledImage.source.createTileCache,
            destroy: o.tiledImage.source.destroyTileCache,
            getImage: o.tiledImage.source.getTileCacheDataAsImage,
            getData: o.tiledImage.source.getTileCacheData,
            getRenderedContext: o.tiledImage.source.getTileCacheDataAsContext2D
          }), this._imagesLoadedCount++), f.addTile(o.tile), o.tile.cacheImageRecord = f, this._imagesLoadedCount > this._maxImageCacheCount) {
            for (var p = null, m = -1, v = null, y, S, E, w, _, O, D = this._tilesLoaded.length - 1; D >= 0; D--)
              if (O = this._tilesLoaded[D], y = O.tile, !(y.level <= s || y.beingDrawn)) {
                if (!p) {
                  p = y, m = D, v = O;
                  continue;
                }
                w = y.lastTouchTime, S = p.lastTouchTime, _ = y.level, E = p.level, (w < S || w === S && _ > E) && (p = y, m = D, v = O);
              }
            p && m >= 0 && (this._unloadTile(v), u = m);
          }
          this._tilesLoaded[u] = new r({
            tile: o.tile,
            tiledImage: o.tiledImage
          });
        },
        /**
         * Clears all tiles associated with the specified tiledImage.
         * @param {OpenSeadragon.TiledImage} tiledImage
         */
        clearTilesFor: function(o) {
          n.console.assert(o, "[TileCache.clearTilesFor] tiledImage is required");
          for (var s, u = 0; u < this._tilesLoaded.length; ++u)
            s = this._tilesLoaded[u], s.tiledImage === o && (this._unloadTile(s), this._tilesLoaded.splice(u, 1), u--);
        },
        // private
        getImageRecord: function(o) {
          return n.console.assert(o, "[TileCache.getImageRecord] cacheKey is required"), this._imagesLoaded[o];
        },
        // private
        _unloadTile: function(o) {
          n.console.assert(o, "[TileCache._unloadTile] tileRecord is required");
          var s = o.tile, u = o.tiledImage;
          let f = s.getCanvasContext && s.getCanvasContext();
          s.unload(), s.cacheImageRecord = null;
          var p = this._imagesLoaded[s.cacheKey];
          p && (p.removeTile(s), p.getTileCount() || (p.destroy(), delete this._imagesLoaded[s.cacheKey], this._imagesLoadedCount--, f && (f.canvas.width = 0, f.canvas.height = 0, u.viewer.raiseEvent("image-unloaded", {
            context2D: f,
            tile: s
          }))), u.viewer.raiseEvent("tile-unloaded", {
            tile: s,
            tiledImage: u
          }));
        }
      };
    })(t), (function(n) {
      n.World = function(r) {
        var i = this;
        n.console.assert(r.viewer, "[World] options.viewer is required"), n.EventSource.call(this), this.viewer = r.viewer, this._items = [], this._needsDraw = !1, this._autoRefigureSizes = !0, this._needsSizesFigured = !1, this._delegatedFigureSizes = function(o) {
          i._autoRefigureSizes ? i._figureSizes() : i._needsSizesFigured = !0;
        }, this._figureSizes();
      }, n.extend(
        n.World.prototype,
        n.EventSource.prototype,
        /** @lends OpenSeadragon.World.prototype */
        {
          /**
           * Add the specified item.
           * @param {OpenSeadragon.TiledImage} item - The item to add.
           * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
           * @fires OpenSeadragon.World.event:add-item
           * @fires OpenSeadragon.World.event:metrics-change
           */
          addItem: function(r, i) {
            if (n.console.assert(r, "[World.addItem] item is required"), n.console.assert(r instanceof n.TiledImage, "[World.addItem] only TiledImages supported at this time"), i = i || {}, i.index !== void 0) {
              var o = Math.max(0, Math.min(this._items.length, i.index));
              this._items.splice(o, 0, r);
            } else
              this._items.push(r);
            this._autoRefigureSizes ? this._figureSizes() : this._needsSizesFigured = !0, this._needsDraw = !0, r.addHandler("bounds-change", this._delegatedFigureSizes), r.addHandler("clip-change", this._delegatedFigureSizes), this.raiseEvent("add-item", {
              item: r
            });
          },
          /**
           * Get the item at the specified index.
           * @param {Number} index - The item's index.
           * @returns {OpenSeadragon.TiledImage} The item at the specified index.
           */
          getItemAt: function(r) {
            return n.console.assert(r !== void 0, "[World.getItemAt] index is required"), this._items[r];
          },
          /**
           * Get the index of the given item or -1 if not present.
           * @param {OpenSeadragon.TiledImage} item - The item.
           * @returns {Number} The index of the item or -1 if not present.
           */
          getIndexOfItem: function(r) {
            return n.console.assert(r, "[World.getIndexOfItem] item is required"), n.indexOf(this._items, r);
          },
          /**
           * @returns {Number} The number of items used.
           */
          getItemCount: function() {
            return this._items.length;
          },
          /**
           * Change the index of a item so that it appears over or under others.
           * @param {OpenSeadragon.TiledImage} item - The item to move.
           * @param {Number} index - The new index.
           * @fires OpenSeadragon.World.event:item-index-change
           */
          setItemIndex: function(r, i) {
            n.console.assert(r, "[World.setItemIndex] item is required"), n.console.assert(i !== void 0, "[World.setItemIndex] index is required");
            var o = this.getIndexOfItem(r);
            if (i >= this._items.length)
              throw new Error("Index bigger than number of layers.");
            i === o || o === -1 || (this._items.splice(o, 1), this._items.splice(i, 0, r), this._needsDraw = !0, this.raiseEvent("item-index-change", {
              item: r,
              previousIndex: o,
              newIndex: i
            }));
          },
          /**
           * Remove an item.
           * @param {OpenSeadragon.TiledImage} item - The item to remove.
           * @fires OpenSeadragon.World.event:remove-item
           * @fires OpenSeadragon.World.event:metrics-change
           */
          removeItem: function(r) {
            n.console.assert(r, "[World.removeItem] item is required");
            var i = n.indexOf(this._items, r);
            i !== -1 && (r.removeHandler("bounds-change", this._delegatedFigureSizes), r.removeHandler("clip-change", this._delegatedFigureSizes), r.destroy(), this._items.splice(i, 1), this._figureSizes(), this._needsDraw = !0, this._raiseRemoveItem(r));
          },
          /**
           * Remove all items.
           * @fires OpenSeadragon.World.event:remove-item
           * @fires OpenSeadragon.World.event:metrics-change
           */
          removeAll: function() {
            this.viewer._cancelPendingImages();
            var r, i;
            for (i = 0; i < this._items.length; i++)
              r = this._items[i], r.removeHandler("bounds-change", this._delegatedFigureSizes), r.removeHandler("clip-change", this._delegatedFigureSizes), r.destroy();
            var o = this._items;
            for (this._items = [], this._figureSizes(), this._needsDraw = !0, i = 0; i < o.length; i++)
              r = o[i], this._raiseRemoveItem(r);
          },
          /**
           * Clears all tiles and triggers updates for all items.
           */
          resetItems: function() {
            for (var r = 0; r < this._items.length; r++)
              this._items[r].reset();
          },
          /**
           * Updates (i.e. animates bounds of) all items.
           * @function
           * @param viewportChanged Whether the viewport changed, which indicates that
           * all TiledImages need to be updated.
           */
          update: function(r) {
            for (var i = !1, o = 0; o < this._items.length; o++)
              i = this._items[o].update(r) || i;
            return i;
          },
          /**
           * Draws all items.
           */
          draw: function() {
            this.viewer.drawer.draw(this._items), this._needsDraw = !1, this._items.forEach((r) => {
              this._needsDraw = r.setDrawn() || this._needsDraw;
            });
          },
          /**
           * @returns {Boolean} true if any items need updating.
           */
          needsDraw: function() {
            for (var r = 0; r < this._items.length; r++)
              if (this._items[r].needsDraw())
                return !0;
            return this._needsDraw;
          },
          /**
           * @returns {OpenSeadragon.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
           */
          getHomeBounds: function() {
            return this._homeBounds.clone();
          },
          /**
           * To facilitate zoom constraints, we keep track of the pixel density of the
           * densest item in the World (i.e. the item whose content size to viewport size
           * ratio is the highest) and save it as this "content factor".
           * @returns {Number} the number of content units per viewport unit.
           */
          getContentFactor: function() {
            return this._contentFactor;
          },
          /**
           * As a performance optimization, setting this flag to false allows the bounds-change event handler
           * on tiledImages to skip calculations on the world bounds. If a lot of images are going to be positioned in
           * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
           * or the system may behave oddly.
           * @param {Boolean} [value] The value to which to set the flag.
           */
          setAutoRefigureSizes: function(r) {
            this._autoRefigureSizes = r, r & this._needsSizesFigured && (this._figureSizes(), this._needsSizesFigured = !1);
          },
          /**
           * Arranges all of the TiledImages with the specified settings.
           * @param {Object} options - Specifies how to arrange.
           * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
           * @param {String} [options.layout] - See collectionLayout in {@link OpenSeadragon.Options}.
           * @param {Number} [options.rows] - See collectionRows in {@link OpenSeadragon.Options}.
           * @param {Number} [options.columns] - See collectionColumns in {@link OpenSeadragon.Options}.
           * @param {Number} [options.tileSize] - See collectionTileSize in {@link OpenSeadragon.Options}.
           * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link OpenSeadragon.Options}.
           * @fires OpenSeadragon.World.event:metrics-change
           */
          arrange: function(r) {
            r = r || {};
            var i = r.immediately || !1, o = r.layout || n.DEFAULT_SETTINGS.collectionLayout, s = r.rows || n.DEFAULT_SETTINGS.collectionRows, u = r.columns || n.DEFAULT_SETTINGS.collectionColumns, f = r.tileSize || n.DEFAULT_SETTINGS.collectionTileSize, p = r.tileMargin || n.DEFAULT_SETTINGS.collectionTileMargin, m = f + p, v;
            !r.rows && u ? v = u : v = Math.ceil(this._items.length / s);
            var y = 0, S = 0, E, w, _, O, D;
            this.setAutoRefigureSizes(!1);
            for (var P = 0; P < this._items.length; P++)
              P && P % v === 0 && (o === "horizontal" ? (S += m, y = 0) : (y += m, S = 0)), E = this._items[P], w = E.getBounds(), w.width > w.height ? _ = f : _ = f * (w.width / w.height), O = _ * (w.height / w.width), D = new n.Point(
                y + (f - _) / 2,
                S + (f - O) / 2
              ), E.setPosition(D, i), E.setWidth(_, i), o === "horizontal" ? y += m : S += m;
            this.setAutoRefigureSizes(!0);
          },
          // private
          _figureSizes: function() {
            var r = this._homeBounds ? this._homeBounds.clone() : null, i = this._contentSize ? this._contentSize.clone() : null, o = this._contentFactor || 0;
            if (!this._items.length)
              this._homeBounds = new n.Rect(0, 0, 1, 1), this._contentSize = new n.Point(1, 1), this._contentFactor = 1;
            else {
              var s = this._items[0], u = s.getBounds();
              this._contentFactor = s.getContentSize().x / u.width;
              for (var f = s.getClippedBounds().getBoundingBox(), p = f.x, m = f.y, v = f.x + f.width, y = f.y + f.height, S = 1; S < this._items.length; S++)
                s = this._items[S], u = s.getBounds(), this._contentFactor = Math.max(
                  this._contentFactor,
                  s.getContentSize().x / u.width
                ), f = s.getClippedBounds().getBoundingBox(), p = Math.min(p, f.x), m = Math.min(m, f.y), v = Math.max(v, f.x + f.width), y = Math.max(y, f.y + f.height);
              this._homeBounds = new n.Rect(p, m, v - p, y - m), this._contentSize = new n.Point(
                this._homeBounds.width * this._contentFactor,
                this._homeBounds.height * this._contentFactor
              );
            }
            (this._contentFactor !== o || !this._homeBounds.equals(r) || !this._contentSize.equals(i)) && this.raiseEvent("metrics-change", {});
          },
          // private
          _raiseRemoveItem: function(r) {
            this.raiseEvent("remove-item", { item: r });
          }
        }
      );
    })(t);
  })(eA)), eA.exports;
}
var Aft = Oft();
const Eu = /* @__PURE__ */ Hn(Aft);
class Dft {
  /**
   * constructor - sets up the Canvas overlay container
   */
  constructor(t, n) {
    this.viewer = t, this.ref = n, this.containerWidth = 0, this.containerHeight = 0, this.imgAspectRatio = 1;
  }
  /** */
  get canvas() {
    return this.canvasDiv.firstElementChild;
  }
  /** */
  get canvasDiv() {
    return this.ref.current;
  }
  /** */
  get context2d() {
    return this.canvas.getContext("2d");
  }
  /** */
  clear() {
    this.context2d && this.context2d.clearRect(0, 0, this.containerWidth, this.containerHeight);
  }
  /**
   * resize - resizes the added Canvas overlay.
   */
  resize() {
    this.containerWidth !== this.viewer.container.clientWidth && (this.containerWidth = this.viewer.container.clientWidth, this.canvasDiv.setAttribute("width", this.containerWidth), this.canvas.setAttribute("width", this.containerWidth)), this.containerHeight !== this.viewer.container.clientHeight && (this.containerHeight = this.viewer.container.clientHeight, this.canvasDiv.setAttribute("height", this.containerHeight), this.canvas.setAttribute("height", this.containerHeight)), this.viewportOrigin = new Eu.Point(0, 0);
    const t = this.viewer.viewport.getBoundsNoRotateWithMargins(!0);
    this.viewportOrigin.x = t.x, this.viewportOrigin.y = t.y * this.imgAspectRatio, this.viewportWidth = t.width, this.viewportHeight = t.height * this.imgAspectRatio;
    const n = this.viewer.world.getItemAt(0);
    n && (this.imgWidth = n.source.dimensions.x, this.imgHeight = n.source.dimensions.y, this.imgAspectRatio = this.imgWidth / this.imgHeight);
  }
  /**
   * canvasUpdate - sets up the dimensions for the canvas update to mimick image
   * 0 dimensions. Then call provided update function.
   * @param {Function} update
   */
  canvasUpdate(t) {
    if (!this.context2d) return;
    const n = this.viewer.viewport.getZoom(!0), r = this.viewer.world.getItemAt(0);
    if (!r) return;
    const i = r.viewportToImageZoom(n), o = (this.viewportOrigin.x / this.imgWidth - this.viewportOrigin.x) / this.viewportWidth * this.containerWidth, s = (this.viewportOrigin.y / this.imgHeight - this.viewportOrigin.y) / this.viewportHeight * this.containerHeight;
    this.clearBeforeRedraw && this.clear(), this.context2d.translate(o, s), this.context2d.scale(i, i);
    const u = this.viewer.viewport.getCenter();
    this.viewer.viewport.getFlip() && (this.context2d.translate(u.x * 2, 0), this.context2d.scale(-1, 1));
    const p = this.viewer.viewport.getRotation();
    p !== 0 && (this.context2d.translate(u.x, u.y), this.context2d.rotate(p * Math.PI / 180), this.context2d.translate(-1 * u.x, -1 * u.y)), t(), this.context2d.setTransform(1, 0, 0, 1, 0, 0);
  }
}
class ife {
  /** */
  constructor({
    resource: t,
    palette: n,
    zoomRatio: r,
    offset: i,
    selected: o,
    hovered: s
  }) {
    this.resource = t, this.palette = n, this.zoomRatio = r, this.offset = i, this.selected = o, this.hovered = s;
  }
  /** */
  toContext(t) {
    this.context = t, this.resource.svgSelector ? this.svgContext() : this.resource.fragmentSelector && this.fragmentContext();
  }
  /** */
  get svgString() {
    return this.resource.svgSelector.value;
  }
  /** */
  svgContext() {
    let t;
    this.hovered ? t = this.palette.hovered : this.selected ? t = this.palette.selected : t = this.palette.default, t.globalAlpha !== 0 && [...this.svgPaths].forEach((n) => {
      this.context.save(), this.context.translate(this.offset.x, this.offset.y);
      const r = new Path2D(n.attributes.d.nodeValue);
      this.context.strokeStyle = this.color, n.attributes["stroke-dasharray"] && this.context.setLineDash(n.attributes["stroke-dasharray"].nodeValue.split(","));
      const i = {
        fill: "fillStyle",
        stroke: "strokeStyle",
        "stroke-dashoffset": "lineDashOffset",
        "stroke-linecap": "lineCap",
        "stroke-linejoin": "lineJoin",
        "stroke-miterlimit": "miterlimit",
        "stroke-width": "lineWidth"
      };
      Object.keys(i).forEach((o) => {
        n.attributes[o] && (this.context[i[o]] = n.attributes[o].nodeValue);
      }), this.context.lineWidth /= this.zoomRatio, (this.selected || this.hovered) && (this.context.strokeStyle = t.strokeStyle || t.fillStyle), n.attributes["stroke-opacity"] ? this.context.globalAlpha = t.globalAlpha * n.attributes["stroke-opacity"].nodeValue : this.context.globalAlpha = t.globalAlpha, this.context.stroke(r), n.attributes.fill && n.attributes.fill.nodeValue !== "none" && (n.attributes["fill-opacity"] ? this.context.globalAlpha = t.globalAlpha * n.attributes["fill-opacity"].nodeValue : this.context.globalAlpha = t.globalAlpha, this.context.fill(r)), this.context.restore();
    });
  }
  /** */
  fragmentContext() {
    const t = this.resource.fragmentSelector;
    t[0] += this.offset.x, t[1] += this.offset.y;
    let n;
    this.selected ? n = this.palette.selected : this.hovered ? n = this.palette.hovered : n = this.palette.default, this.context.save(), Object.keys(n).forEach((r) => {
      this.context[r] = n[r];
    }), n.globalAlpha !== 0 && (n.fillStyle ? this.context.fillRect(...t) : (this.context.lineWidth = 1 / this.zoomRatio, this.context.strokeRect(...t)), this.context.restore());
  }
  /** */
  get svgPaths() {
    return new DOMParser().parseFromString(this.svgString, "text/xml").getElementsByTagName("path");
  }
}
function tJ(e, t, n, r, i) {
  const [o, s] = e.canvasToWorldCoordinates(r.id), u = i.x - o, f = i.y - s;
  if (n.svgSelector) {
    const p = t.context2d, { svgPaths: m } = new ife({ resource: n });
    return [...m].some((v) => p.isPointInPath(new Path2D(v.attributes.d.nodeValue), u, f));
  }
  if (n.fragmentSelector) {
    const [p, m, v, y] = n.fragmentSelector;
    return p <= u && u <= p + v && m <= f && f <= m + y;
  }
  return !1;
}
function ofe({
  annotations: e = [],
  canvasWorld: t,
  deselectAnnotation: n = () => {
  },
  drawAnnotations: r = !0,
  drawSearchAnnotations: i = !0,
  highlightAllAnnotations: o = !1,
  hoverAnnotation: s = () => {
  },
  hoveredAnnotationIds: u = [],
  palette: f = {},
  searchAnnotations: p = [],
  selectAnnotation: m = () => {
  },
  selectedAnnotationId: v = null,
  viewer: y = null,
  windowId: S
}) {
  const E = an(), w = Ui(() => new Dft(y, E), [E, y]), _ = Yn((Y) => {
    v === Y ? n(S, Y) : m(S, Y);
  }, [v, n, m, S]), O = Yn((Y, z) => {
    const V = w.context2d, F = y.viewport.getZoom(!0) / y.viewport.getMaxZoom();
    Y.forEach((X) => {
      X.resources.forEach((oe) => {
        if (!t.canvasIds.includes(oe.targetId)) return;
        const re = t.offsetByCanvas(oe.targetId);
        new ife({
          hovered: u.includes(oe.id),
          offset: re,
          palette: {
            ...z,
            default: {
              ...z.default,
              ...!o && z.hidden
            }
          },
          resource: oe,
          selected: v === oe.id,
          zoomRatio: F
        }).toContext(V);
      });
    });
  }, [w, y, t, o, u, v]), D = Yn(() => {
    i && O(p, f.search), r && O(e, f.annotations);
  }, [e, O, r, i, f, p]), P = Yn(() => {
    w && (w.clear(), w.resize(), w.canvasUpdate(D));
  }, [w, D]), M = Yn((Y, z) => {
    const V = [...e, ...p];
    return vn(V.map((X) => X.resources)).filter((X) => Y.id !== X.targetId ? !1 : tJ(t, w, X, Y, z));
  }, [e, t, w, p]), N = Yn((Y) => {
    const { position: z, eventSource: { viewport: V } } = Y, F = V.pointFromPixel(z), X = t.canvasAtPoint(F);
    if (!X) return;
    const [
      oe,
      re,
      Z,
      ee
      // eslint-disable-line no-unused-vars
    ] = t.canvasToWorldCoordinates(X.id), J = M(X, F);
    if (J.length > 0 && (Y.preventDefaultAction = !0), J.length === 1)
      _(J[0].id);
    else if (J.length > 0) {
      const le = (ae) => {
        const ie = Math.PI / 180;
        return (he) => {
          let pe = 0;
          for (let me = 0; me < 360; me += 1) {
            const Ee = Math.cos(me * ie) * ae + F.x, Ie = Math.sin(me * ie) * ae + F.y;
            tJ(t, w, he, X, { x: Ee, y: Ie }) && (pe += 1);
          }
          return { anno: he, score: pe };
        };
      };
      let be = [], ne = 1;
      for (be = KQ(J.map(le(ne)), "score"); ne < Math.max(Z, ee) && be[0].score === be[1].score; )
        ne *= 2, be = KQ(J.map(le(ne)), "score");
      _(be[0].anno.id);
    }
  }, [M, t, w, _]), k = kF(Yn((Y) => {
    if (e.length === 0 && p.length === 0) return;
    const { position: z } = Y, V = y.viewport.pointFromPixel(z), F = t.canvasAtPoint(V);
    if (!F) {
      s(S, []);
      return;
    }
    const X = M(F, V);
    Cft(u, X.map((oe) => oe.id)).length > 0 && s(S, X.map((oe) => oe.id));
  }, [
    e,
    M,
    t,
    s,
    u,
    p,
    y,
    S
  ]), 10), U = Yn(() => {
    k.cancel(), s(S, []);
  }, [s, k, S]), H = Yn(() => {
    P();
  }, [P]);
  return ln(() => {
    if (y)
      return y.addHandler("canvas-click", N), y.addHandler("canvas-exit", U), y.addHandler("mouse-move", k), y.addHandler("update-viewport", H), () => {
        y.removeHandler("canvas-click", N), y.removeHandler("canvas-exit", U), y.removeHandler("mouse-move", k), y.removeHandler("update-viewport", H);
      };
  }, [N, U, k, H, y]), ln(() => {
    y && y.forceRedraw();
  }, [
    e,
    r,
    i,
    o,
    u,
    p,
    v,
    y
  ]), ln(() => {
    E.current && (u.length > 0 ? E.current.style.cursor = "pointer" : E.current.style.cursor = "");
  }, [u, E]), y ? Pd.createPortal(
    /* @__PURE__ */ T.jsx(
      "div",
      {
        ref: E,
        style: {
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%"
        },
        children: /* @__PURE__ */ T.jsx("canvas", {})
      }
    ),
    y.canvas
  ) : null;
}
ofe.propTypes = {
  annotations: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  canvasWorld: c.instanceOf(OD).isRequired,
  deselectAnnotation: c.func,
  drawAnnotations: c.bool,
  drawSearchAnnotations: c.bool,
  highlightAllAnnotations: c.bool,
  hoverAnnotation: c.func,
  hoveredAnnotationIds: c.arrayOf(c.string),
  palette: c.object,
  // eslint-disable-line react/forbid-prop-types
  searchAnnotations: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  selectAnnotation: c.func,
  selectedAnnotationId: c.string,
  viewer: c.object,
  // eslint-disable-line react/forbid-prop-types
  windowId: c.string.isRequired
};
const Ift = ye("div")({
  alignItems: "center",
  display: "flex",
  width: "100%"
}), Pft = ye("audio")({
  width: "100%"
});
function afe({ audioOptions: e = {}, audioResources: t = [], captions: n = [] }) {
  return /* @__PURE__ */ T.jsx(Ift, { children: /* @__PURE__ */ T.jsxs(Pft, { ...e, children: [
    t.map((r) => /* @__PURE__ */ T.jsx(L2, { children: /* @__PURE__ */ T.jsx("source", { src: r.id, type: r.getFormat() }) }, r.id)),
    n.map((r) => /* @__PURE__ */ T.jsx(L2, { children: /* @__PURE__ */ T.jsx("track", { src: r.id, label: r.getDefaultLabel(), srcLang: r.getProperty("language") }) }, r.id))
  ] }) });
}
afe.propTypes = {
  audioOptions: c.object,
  // eslint-disable-line react/forbid-prop-types
  audioResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  captions: c.arrayOf(c.object)
  // eslint-disable-line react/forbid-prop-types
};
const Nft = ({ ...e }) => /* @__PURE__ */ T.jsx("div", { className: Nt("background-plugin-area"), style: { display: "none" }, children: /* @__PURE__ */ T.jsx(Ki, { targetName: "BackgroundPluginArea", ...e }) });
function Mft(e) {
  return /* @__PURE__ */ T.jsxs(Ha, { viewBox: "0 0 60 55", ...e, children: [
    /* @__PURE__ */ T.jsx("rect", { width: "18", height: "55" }),
    /* @__PURE__ */ T.jsx("rect", { width: "18", height: "55", transform: "translate(42)" }),
    /* @__PURE__ */ T.jsx("rect", { width: "18", height: "34", transform: "translate(21)" })
  ] });
}
function sfe({ variant: e = "default", ...t }) {
  const { t: n } = Ct();
  return /* @__PURE__ */ T.jsxs(yP, { alignItems: "center", ...t, children: [
    e === "wide" && /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(St, { align: "center", component: "p", variant: "h3", children: n("mirador") }) }),
    /* @__PURE__ */ T.jsx(St, { align: "center", children: /* @__PURE__ */ T.jsx(
      ey,
      {
        component: "a",
        href: "https://projectmirador.org",
        target: "_blank",
        rel: "noopener",
        size: "large",
        children: /* @__PURE__ */ T.jsx(Mft, { "aria-label": n("aboutMirador"), titleAccess: n("aboutMirador"), fontSize: "large" })
      }
    ) })
  ] });
}
sfe.propTypes = {
  variant: c.oneOf(["default", "wide"])
};
const jft = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.2-.64-1.67-.08-.1-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9m5.5 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m-3-4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9M5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5m6-4c0 .83-.67 1.5-1.5 1.5S8 8.33 8 7.5 8.67 6 9.5 6s1.5.67 1.5 1.5"
}), "PaletteSharp"), xP = ye(cU, { name: "WorkspaceDialog", slot: "root" })(({ theme: e, variant: t }) => ({
  "& .MuiDialogTitle-root": e.unstable_sx({ typography: "h2" }),
  ...t === "menu" && {
    "& .MuiDialogContent-root": {
      padding: 0
    }
  }
})), Lft = ye(jft, { name: "ThemeIcon", slot: "icon" })(({ theme: e }) => ({
  color: "#BDBDBD"
}));
function lfe({
  handleClose: e,
  open: t = !1,
  selectedTheme: n,
  setSelectedTheme: r,
  themeIds: i = []
}) {
  const { t: o } = Ct(), s = Yn((u) => {
    r(u), e();
  }, [e, r]);
  return /* @__PURE__ */ T.jsxs(xP, { onClose: e, open: t, variant: "menu", children: [
    /* @__PURE__ */ T.jsx(uU, { children: o("changeTheme") }),
    /* @__PURE__ */ T.jsx(Dhe, { children: /* @__PURE__ */ T.jsx(tA, { autoFocusItem: !0, children: i.map((u) => /* @__PURE__ */ T.jsxs(
      JE,
      {
        className: "listitem",
        onClick: () => s(u),
        selected: u === n,
        value: u,
        children: [
          /* @__PURE__ */ T.jsx(Ihe, { children: /* @__PURE__ */ T.jsx(Lft, { ownerState: { value: u } }) }),
          /* @__PURE__ */ T.jsx(Phe, { children: o(u) })
        ]
      },
      u
    )) }) })
  ] });
}
lfe.propTypes = {
  handleClose: c.func.isRequired,
  open: c.bool,
  selectedTheme: c.string.isRequired,
  setSelectedTheme: c.func.isRequired,
  themeIds: c.arrayOf(c.string)
};
function cfe({ error: e = null, removeError: t = () => {
} }) {
  const { t: n } = Ct(), r = !fg(e);
  return e ? /* @__PURE__ */ T.jsxs(
    D_,
    {
      "aria-labelledby": "error-dialog-title",
      id: "error-dialog",
      onClose: () => t(e.id),
      open: r,
      children: [
        /* @__PURE__ */ T.jsx(_g, { id: "error-dialog-title", children: n("errorDialogTitle") }),
        /* @__PURE__ */ T.jsxs(eP, { children: [
          /* @__PURE__ */ T.jsx(Nhe, { variant: "body2", noWrap: !0, color: "inherit", children: `${e.message}` }),
          /* @__PURE__ */ T.jsx(dU, { children: /* @__PURE__ */ T.jsx(hi, { onClick: () => t(e.id), variant: "contained", children: n("errorDialogConfirm") }) })
        ] })
      ]
    }
  ) : null;
}
cfe.propTypes = {
  error: c.shape({
    id: c.string,
    message: c.string
  }),
  removeError: c.func
};
const kft = ye("div", { name: "GalleryView", slot: "thumbnail" })(({ ownerState: e, theme: t }) => ({
  "&:focus": {
    outline: "none"
  },
  "&:hover": {
    backgroundColor: t.palette.action.hover
  },
  border: "2px solid transparent",
  ...e.selected && {
    borderColor: t.palette.primary.main
  },
  ...!e.selected && e.searchAnnotationsCount > 0 && {
    borderColor: t.palette.action.selected
  },
  cursor: "pointer",
  display: "inline-block",
  margin: t.spacing(1, 0.5),
  maxHeight: e.config.height + 45,
  minWidth: "60px",
  overflow: "hidden",
  padding: t.spacing(0.5),
  position: "relative",
  width: "min-content"
})), zft = ye("div", { name: "GalleryView", slot: "chipArea" })(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(0.25),
  position: "absolute",
  right: 0,
  top: 0
})), nJ = ye(kx, { name: "GalleryView", slot: "chip" })(({ theme: e }) => ({
  backgroundColor: e.palette.annotations.chipBackground,
  opacity: 0.875,
  textAlign: "right"
}));
function ufe({
  canvas: e,
  selected: t = !1,
  setCanvas: n,
  focusOnCanvas: r,
  annotationsCount: i = void 0,
  requestCanvasAnnotations: o = () => {
  },
  searchAnnotationsCount: s = 0,
  config: u = { height: 100, width: null }
}) {
  const f = an(), [p, m] = Bn(!1);
  ln(() => {
    var w;
    t && ((w = f.current) == null || w.scrollIntoView(!0));
  }, []);
  const v = () => {
    t ? r() : n(e.id);
  }, y = (w) => {
    const _ = {
      enter: "Enter",
      space: " "
    }, O = {
      enter: 13,
      space: 32
    };
    w.key === _.enter || w.which === O.enter || w.key === _.space || w.which === O.space ? r() : n(e.id);
  }, S = (w, { isIntersecting: _ }) => {
    !_ || i === void 0 || i > 0 || p || (m(!0), o());
  }, E = {
    annotationsCount: i,
    canvas: e,
    config: u,
    searchAnnotationsCount: s,
    selected: t
  };
  return /* @__PURE__ */ T.jsx(eTe, { onChange: S, children: /* @__PURE__ */ T.jsx(
    kft,
    {
      ownerState: E,
      className: t ? "selected" : "",
      onClick: v,
      onKeyUp: y,
      ref: f,
      role: "button",
      tabIndex: 0,
      children: /* @__PURE__ */ T.jsx(
        jx,
        {
          resource: e,
          labelled: !0,
          variant: "outside",
          maxHeight: u.height,
          maxWidth: u.width,
          children: /* @__PURE__ */ T.jsxs(zft, { children: [
            s > 0 && /* @__PURE__ */ T.jsx(
              nJ,
              {
                icon: /* @__PURE__ */ T.jsx(CI, { fontSize: "small" }),
                label: s,
                size: "small"
              }
            ),
            i > 0 && /* @__PURE__ */ T.jsx(
              nJ,
              {
                icon: /* @__PURE__ */ T.jsx(ZW, { fontSize: "small" }),
                label: i,
                size: "small"
              }
            )
          ] })
        }
      )
    },
    e.id || e.index
  ) });
}
ufe.propTypes = {
  annotationsCount: c.number,
  canvas: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  config: c.shape({
    height: c.number,
    width: c.number
  }),
  focusOnCanvas: c.func.isRequired,
  requestCanvasAnnotations: c.func,
  searchAnnotationsCount: c.number,
  selected: c.bool,
  setCanvas: c.func.isRequired
};
const Bft = (e, { canvas: t, windowId: n }) => {
  const r = Vl(e, { windowId: n }), i = ED(
    e,
    { windowId: n }
  ), o = vn(i.map((u) => u.resources)).filter((u) => u.targetId === t.id), s = ox(e, { content: "annotations", windowId: n }).length > 0;
  return {
    annotationsCount: s ? Y1(
      e,
      { canvasId: t.id }
    ).reduce(
      (f, p) => f + p.resources.filter((m) => m.targetId === t.id).length,
      0
    ) : void 0,
    config: Dn(e).galleryView,
    searchAnnotationsCount: o.length,
    selected: r && r.id === t.id
  };
}, Vft = (e, { canvas: t, id: n, windowId: r }) => ({
  focusOnCanvas: () => e(M3(r, "single")),
  requestCanvasAnnotations: () => e(k3(r, t.id)),
  setCanvas: (...i) => e(Iu(r, ...i))
}), Uft = wt(
  At(Bft, Vft)
  // further HOC go here
), Fft = Uft(ufe), Wft = ye(Ei, { name: "GalleryView", slot: "root" })(({ theme: e }) => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowX: "hidden",
  overflowY: "scroll",
  padding: "50px 0 50px 20px",
  width: "100%"
}));
function dfe({ canvases: e, viewingDirection: t = "", windowId: n }) {
  const r = t === "right-to-left" ? "rtl" : "ltr";
  return /* @__PURE__ */ T.jsx(
    Wft,
    {
      component: "section",
      "aria-label": "gallery section",
      dir: r,
      square: !0,
      elevation: 0,
      id: `${n}-gallery`,
      children: e.map((i) => /* @__PURE__ */ T.jsx(
        Fft,
        {
          windowId: n,
          canvas: i
        },
        i.id
      ))
    }
  );
}
dfe.propTypes = {
  canvases: c.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  viewingDirection: c.string,
  windowId: c.string.isRequired
};
const Hft = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M4.01 2 4 22h16V8l-6-6zM13 9V3.5L18.5 9z"
}), "InsertDriveFileSharp");
function qft(e) {
  return new Promise((t, n) => {
    const r = new FileReader();
    r.addEventListener("load", () => {
      const i = new Image();
      i.addEventListener("load", () => {
        t({
          height: i.height,
          name: e.name,
          type: e.type,
          url: r.result,
          width: i.width
        });
      }), i.src = r.result;
    }), r.readAsDataURL(e);
  });
}
const rJ = (e, t, n) => {
  const { onDrop: r } = n;
  if (e.urls && e.urls.forEach((i) => {
    const o = new URL(i), s = o.searchParams.get("manifest"), u = o.searchParams.get("canvas");
    s && r({ canvasId: u, manifestId: s }, n, t);
  }), e.files) {
    const o = e.files.filter((f) => f.type === "application/json").map((f) => new Promise((p, m) => {
      const v = new FileReader();
      v.addEventListener("load", () => {
        const y = v.result, S = zs();
        y && r({ manifestId: S, manifestJson: y }, n, t), p();
      }), v.readAsText(f);
    })), s = e.files.filter(({ type: f }) => f.startsWith("image/"));
    let u;
    if (s.length > 0) {
      const f = zs(), p = s.map((m) => qft(m));
      u = Promise.all(p).then((m) => {
        const v = {
          "@context": "http://iiif.io/api/presentation/3/context.json",
          id: f,
          items: m.map(({
            name: S,
            type: E,
            width: w,
            height: _,
            url: O
          }, D) => ({
            height: _,
            id: `${f}/canvas/${D}`,
            items: [
              {
                id: `${f}/canvas/${D}/1`,
                items: [{
                  body: {
                    format: E,
                    id: O,
                    type: "Image"
                  },
                  height: _,
                  id: `${f}/canvas/${D}/1/image`,
                  motivation: "painting",
                  target: `${f}/canvas/${D}/1`,
                  type: "Annotation",
                  width: w
                }],
                type: "AnnotationPage"
              }
            ],
            label: S,
            type: "Canvas",
            width: w
          })),
          label: m[0].name,
          type: "Manifest"
        }, y = zs();
        v && r({ manifestId: y, manifestJson: v }, n, t);
      });
    }
    return Promise.all([...o, u]);
  }
}, $H = (e) => {
  const { children: t, onDrop: n } = e, [{ canDrop: r, isOver: i }, o] = BI({
    accept: [xW, bW],
    collect: (f) => ({
      canDrop: f.canDrop(),
      isOver: f.isOver()
    }),
    /** */
    drop(f, p) {
      n && rJ(f, p, e);
    }
  }), s = (f) => {
    if (!(!window.safari || !n || !f.dataTransfer) && f.dataTransfer.types.includes("Files") && f.dataTransfer.types.includes("text/uri-list")) {
      const p = f.dataTransfer.getData("text/uri-list");
      if (!p) return;
      rJ({ urls: [p] }, null, e);
    }
  }, u = r && i;
  return /* @__PURE__ */ T.jsxs("div", { ref: o, onDrop: s, style: { height: "100%", width: "100%" }, children: [
    t,
    /* @__PURE__ */ T.jsx(cI, { open: u, style: { zIndex: 9999 }, children: /* @__PURE__ */ T.jsx(Hft, { style: { color: Rne[400], fontSize: 256 } }) })
  ] });
};
$H.propTypes = {
  children: c.node.isRequired,
  onDrop: c.func.isRequired
};
const $ft = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "CheckSharp");
function ffe({ handleClick: e, languages: t }) {
  return /* @__PURE__ */ T.jsx(T.Fragment, { children: t.map((n) => /* @__PURE__ */ T.jsxs(
    qo,
    {
      lang: n.locale,
      onClick: () => {
        e(n.locale);
      },
      children: [
        /* @__PURE__ */ T.jsx(Bv, { children: n.current && /* @__PURE__ */ T.jsx($ft, {}) }),
        /* @__PURE__ */ T.jsx(dp, { primaryTypographyProps: { variant: "body1" }, children: n.label })
      ]
    },
    n.locale
  )) });
}
ffe.propTypes = {
  handleClick: c.func.isRequired,
  languages: c.arrayOf(
    c.shape({
      current: c.bool.isRequired,
      label: c.string.isRequired,
      locale: c.string.isRequired
    })
  ).isRequired
};
function pfe({
  addResourcesOpen: e,
  addResource: t,
  onSubmit: n = () => {
  },
  onCancel: r = null
}) {
  const { t: i } = Ct(), [o, s] = Bn(""), u = () => {
    r(), s("");
  }, f = (m) => {
    m.preventDefault(), s(m.target.value);
  }, p = (m) => {
    m.preventDefault(), t(o), n(), s("");
  };
  return e ? /* @__PURE__ */ T.jsx("form", { onSubmit: p, children: /* @__PURE__ */ T.jsxs(pr, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ T.jsx(pr, { item: !0, xs: 12, sm: 8, md: 9, children: /* @__PURE__ */ T.jsx(
      EI,
      {
        autoFocus: !0,
        fullWidth: !0,
        value: o,
        id: "manifestURL",
        type: "text",
        onChange: f,
        variant: "filled",
        label: i("addManifestUrl"),
        helperText: i("addManifestUrlHelp"),
        InputLabelProps: {
          shrink: !0
        },
        InputProps: {
          style: { typography: "body1" }
        }
      }
    ) }),
    /* @__PURE__ */ T.jsxs(
      pr,
      {
        item: !0,
        xs: 12,
        sm: 4,
        md: 3,
        sx: {
          textAlign: { sm: "inherit", xs: "right" }
        },
        children: [
          r && /* @__PURE__ */ T.jsx(hi, { onClick: u, children: i("cancel") }),
          /* @__PURE__ */ T.jsx(hi, { id: "fetchBtn", type: "submit", variant: "contained", color: "primary", children: i("fetchManifest") })
        ]
      }
    )
  ] }) }) : null;
}
pfe.propTypes = {
  addResource: c.func.isRequired,
  addResourcesOpen: c.bool.isRequired,
  onCancel: c.func,
  onSubmit: c.func
};
const iJ = ye(Hd, { name: "ManifestListItem", slot: "root" })(({ ownerState: e, theme: t }) => ({
  "&:hover,&:focus-within": {
    backgroundColor: t.palette.action.hover,
    borderLeftColor: e != null && e.active ? t.palette.primary.main : t.palette.action.hover
  },
  borderLeft: "4px solid",
  borderLeftColor: e != null && e.active ? t.palette.primary.main : "transparent",
  paddingLeft: t.spacing(2),
  paddingRight: t.spacing(2),
  [t.breakpoints.up("sm")]: {
    paddingLeft: t.spacing(3),
    paddingRight: t.spacing(3)
  }
})), Gft = ye(wI, { name: "ManifestListItem", slot: "thumbnail" })(({ theme: e }) => ({
  maxWidth: "100%",
  objectFit: "contain"
})), Yft = ye(wI, { name: "ManifestListItem", slot: "logo" })(({ theme: e }) => ({
  height: "2.5rem",
  maxWidth: "100%",
  objectFit: "contain",
  paddingRight: 1
})), Xft = () => /* @__PURE__ */ T.jsxs(Ri, { container: !0, className: Nt("manifest-list-item"), spacing: 2, children: [
  /* @__PURE__ */ T.jsx(Ri, { xs: 3, sm: 2, children: /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "rectangular", height: 80, width: 120 }) }),
  /* @__PURE__ */ T.jsx(Ri, { xs: 9, sm: 6, children: /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "text" }) }),
  /* @__PURE__ */ T.jsxs(Ri, { xs: 8, sm: 2, children: [
    /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "text" }),
    /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "text" })
  ] }),
  /* @__PURE__ */ T.jsx(Ri, { xs: 4, sm: 2, children: /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "rectangular", height: 60, width: 60 }) })
] });
function hfe({
  fetchManifest: e,
  isFetching: t = !1,
  addWindow: n,
  handleClose: r = () => {
  },
  active: i = !1,
  buttonRef: o = void 0,
  manifestId: s,
  ready: u = !1,
  title: f = null,
  thumbnail: p = null,
  manifestLogo: m = null,
  size: v = 0,
  provider: y = null,
  error: S = null,
  isCollection: E = !1,
  isMultipart: w = !1
}) {
  const { t: _ } = Ct();
  ln(() => {
    !u && !S && !t && y !== "file" && e(s);
  }, [s, y, e, u, S, t]);
  const O = arguments[0], D = () => {
    n({ manifestId: s }), r();
  };
  return S ? /* @__PURE__ */ T.jsx(
    iJ,
    {
      ownerState: O,
      divider: !0,
      selected: i,
      className: i ? "active" : "",
      "data-manifestid": s,
      children: /* @__PURE__ */ T.jsx(oce, { manifestId: s })
    }
  ) : /* @__PURE__ */ T.jsx(
    iJ,
    {
      divider: !0,
      selected: i,
      className: i ? "active" : "",
      "data-manifestid": s,
      "data-active": i,
      children: u ? /* @__PURE__ */ T.jsxs(Ri, { container: !0, className: Nt("manifest-list-item"), spacing: 2, children: [
        /* @__PURE__ */ T.jsx(Ri, { xs: 12, sm: 6, children: /* @__PURE__ */ T.jsx(
          Ws,
          {
            ref: o,
            className: Nt("manifest-list-item-title"),
            style: { width: "100%" },
            onClick: D,
            children: /* @__PURE__ */ T.jsxs(
              Ri,
              {
                container: !0,
                spacing: 2,
                sx: {
                  textAlign: "left",
                  textTransform: "initial"
                },
                component: "span",
                children: [
                  /* @__PURE__ */ T.jsx(Ri, { xs: 4, sm: 3, component: "span", children: p ? /* @__PURE__ */ T.jsx(
                    Gft,
                    {
                      className: [Nt("manifest-list-item-thumb")],
                      src: [p],
                      alt: "",
                      height: "80",
                      unloader: /* @__PURE__ */ T.jsx(
                        pi,
                        {
                          variant: "rectangular",
                          animation: !1,
                          sx: { bgcolor: "grey[300]" },
                          height: 80,
                          width: 120
                        }
                      )
                    }
                  ) : /* @__PURE__ */ T.jsx(pi, { sx: { bgcolor: "grey[300]" }, variant: "rectangular", height: 80, width: 120 }) }),
                  /* @__PURE__ */ T.jsxs(Ri, { xs: 8, sm: 9, component: "span", children: [
                    E && /* @__PURE__ */ T.jsx(St, { component: "div", variant: "overline", children: _(w ? "multipartCollection" : "collection") }),
                    /* @__PURE__ */ T.jsx(St, { component: "span", variant: "h6", children: f || s })
                  ] })
                ]
              }
            )
          }
        ) }),
        /* @__PURE__ */ T.jsxs(Ri, { xs: 8, sm: 4, children: [
          /* @__PURE__ */ T.jsx(St, { className: Nt("manifest-list-item-provider"), children: y }),
          /* @__PURE__ */ T.jsx(St, { children: _("numItems", { count: v, number: v }) })
        ] }),
        /* @__PURE__ */ T.jsx(Ri, { xs: 4, sm: 2, children: m && /* @__PURE__ */ T.jsx(
          Yft,
          {
            src: [m],
            alt: "",
            role: "presentation",
            unloader: /* @__PURE__ */ T.jsx(
              pi,
              {
                variant: "rectangular",
                animation: !1,
                sx: { bgcolor: "grey[300]" },
                height: 60,
                width: 60
              }
            )
          }
        ) })
      ] }) : /* @__PURE__ */ T.jsx(Xft, {})
    }
  );
}
hfe.propTypes = {
  active: c.bool,
  addWindow: c.func.isRequired,
  buttonRef: c.elementType,
  error: c.oneOfType([
    c.string,
    c.bool,
    c.oneOf([null])
    // for null
  ]),
  fetchManifest: c.func.isRequired,
  handleClose: c.func,
  isCollection: c.bool,
  isFetching: c.bool,
  isMultipart: c.bool,
  manifestId: c.string.isRequired,
  manifestLogo: c.string,
  provider: c.string,
  ready: c.bool,
  size: c.number,
  thumbnail: c.string,
  title: c.string
};
function gfe({
  title: e = "",
  windowId: t
}) {
  const { t: n } = Ct();
  return /* @__PURE__ */ T.jsx(
    Yde,
    {
      windowId: `${t}-preview`,
      label: n("previewWindowTitle", { title: e }),
      ariaLabel: !1
    }
  );
}
gfe.propTypes = {
  title: c.string,
  windowId: c.string.isRequired
};
const Zft = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLessSharp"), mfe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMoreSharp");
function vfe({
  children: e,
  icon: t = null,
  label: n,
  ...r
}) {
  const [i, o] = Bn(!1), s = Yn(() => {
    o(!i);
  }, [i, o]);
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(qo, { onClick: s, divider: i, ...r, children: [
      t && /* @__PURE__ */ T.jsx(Bv, { children: t }),
      /* @__PURE__ */ T.jsx(dp, { primaryTypographyProps: { variant: "body1" }, children: n }),
      i ? /* @__PURE__ */ T.jsx(Zft, {}) : /* @__PURE__ */ T.jsx(mfe, {})
    ] }),
    i && e
  ] });
}
vfe.propTypes = {
  children: c.element.isRequired,
  icon: c.element,
  label: c.string.isRequired
};
const Kft = (e, { windowId: t }) => ({
  annotations: Y1(e, { windowId: t }),
  canvasWorld: D3(e, { windowId: t }),
  drawAnnotations: Dn(e).window.forceDrawAnnotations || ox(e, { content: "annotations", windowId: t }).length > 0,
  drawSearchAnnotations: Dn(e).window.forceDrawAnnotations || ox(e, { content: "search", windowId: t }).length > 0,
  highlightAllAnnotations: Wn(e, { windowId: t }).highlightAllAnnotations,
  hoveredAnnotationIds: Wn(e, { windowId: t }).hoveredAnnotationIds,
  palette: r3(e).palette,
  searchAnnotations: ED(
    e,
    { windowId: t }
  ),
  selectedAnnotationId: X1(e, { windowId: t })
}), Qft = {
  deselectAnnotation: B3,
  hoverAnnotation: V3,
  selectAnnotation: Kv
}, Jft = wt(
  At(Kft, Qft),
  Tt("AnnotationsOverlay")
), ept = Jft(ofe), tpt = {
  /** */
  get(e) {
    return this.refs[e];
  },
  refs: {},
  /** */
  set(e, t) {
    this.refs[e] = t;
  }
}, yfe = hg(void 0);
function bfe({
  children: e = void 0,
  Container: t = "div",
  osdConfig: n = {},
  viewerConfig: r = {},
  onUpdateViewport: i = () => {
  },
  setViewer: o = () => {
  },
  style: s = {},
  ...u
}) {
  var P, M;
  const f = uo(), p = an(), [m, v] = Bn(!1), y = an(void 0), S = an(!1), [, E] = ahe((N) => N + 1, 0), w = kF(Yn((N) => {
    var k;
    (k = y.current) == null || k.raiseEvent("mouse-move", N);
  }, [y]), 10), _ = Yn((N) => {
    const { viewport: k } = N.eventSource;
    S.current && i({
      bounds: k.getBounds(),
      flip: k.getFlip(),
      rotation: k.getRotation(),
      x: Math.round(k.centerSpringX.target.value),
      y: Math.round(k.centerSpringY.target.value),
      zoom: k.zoomSpring.target.value
    });
  }, [i, S]), O = Yn(({ viewport: N }) => {
    S.current || (S.current = !0, r.x != null && r.y != null && N.panTo(new Eu.Point(r.x, r.y), !0), r.zoom != null && N.zoomTo(r.zoom, new Eu.Point(r.x, r.y), !0), r.rotation != null && r.rotation !== N.getRotation() && N.setRotation(r.rotation), r.flip != null && (r.flip || !1) !== N.getFlip() && N.setFlip(r.flip), !r.x && !r.y && !r.zoom && (r.bounds ? N.fitBounds(new Eu.Rect(...r.bounds), !0) : N.goHome(!0)));
  }, [S, r]);
  ln(() => {
    const N = y.current;
    if (!N) return;
    const { viewport: k } = N;
    if (!S.current) {
      O(N);
      return;
    }
    if (r.x != null && r.y != null && (Math.round(r.x) !== Math.round(k.centerSpringX.target.value) || Math.round(r.y) !== Math.round(k.centerSpringY.target.value)) && k.panTo(new Eu.Point(r.x, r.y), !1), r.zoom != null && r.zoom !== k.zoomSpring.target.value && k.zoomTo(r.zoom, new Eu.Point(r.x, r.y), !1), r.rotation != null && r.rotation !== k.getRotation() && k.setRotation(r.rotation), r.flip != null && (r.flip || !1) !== k.getFlip() && k.setFlip(r.flip), r.bounds && !r.x && !r.y && !r.zoom) {
      const U = new Eu.Rect(...r.bounds);
      U.equals(k.getBounds()) && k.fitBounds(U, !1);
    }
  }, [S, O, r, y]), ln(() => {
    const N = Eu({
      element: p.current,
      ...n
    });
    N.addHandler("canvas-drag", () => {
      v(!0);
    }), N.addHandler("canvas-drag-end", () => {
      v(!1);
    }), N.addHandler("canvas-double-click", ({ position: k, shift: U }) => {
      if (!n.zoomPerDoubleClick) return;
      const H = N.viewport.getZoom(), Y = U ? 1 / n.zoomPerDoubleClick : n.zoomPerDoubleClick;
      N.viewport.zoomTo(H * Y, N.viewport.pointFromPixel(k), !1);
    }), N.addHandler("animation-finish", _), N.innerTracker.moveHandler = w, y.current = N, o(N), N.addOnceHandler("tile-loaded", () => {
      S.current = !1, O(N);
    }), E();
  }, [p]), ln(() => () => {
    var k;
    const N = y.current;
    N && (((k = N.innerTracker) == null ? void 0 : k.moveHandler) === w && (N.innerTracker.moveHandler = () => {
    }), N.removeAllHandlers(), N.destroy(), y.current = void 0, o(null));
  }, []);
  const { t: D } = Ct();
  return ln(() => {
    var k, U;
    const N = (U = (k = y == null ? void 0 : y.current) == null ? void 0 : k.canvas) == null ? void 0 : U.firstElementChild;
    N && (N.setAttribute("role", "img"), N.setAttribute("aria-label", D("digitizedView")), N.setAttribute("aria-describedby", f));
  }, [(M = (P = y == null ? void 0 : y.current) == null ? void 0 : P.canvas) == null ? void 0 : M.firstElementChild, f, D]), /* @__PURE__ */ T.jsx(yfe.Provider, { value: y, children: /* @__PURE__ */ T.jsx(t, { id: f, ref: p, style: { ...s, cursor: m ? "grabbing" : "grab" }, ...u, children: e }) });
}
bfe.propTypes = {
  children: c.node,
  Container: c.elementType,
  onUpdateViewport: c.func,
  osdConfig: c.object,
  // eslint-disable-line react/forbid-prop-types
  setViewer: c.func,
  style: c.object,
  // eslint-disable-line react/forbid-prop-types
  viewerConfig: c.shape({
    bounds: c.arrayOf(c.number),
    flip: c.bool,
    rotation: c.number,
    x: c.number,
    y: c.number,
    zoom: c.number
  })
};
function iU({
  index: e = void 0,
  opacity: t = void 0,
  fitBounds: n = void 0,
  tileSource: r = {},
  url: i = void 0,
  zoomToWorld: o = void 0
}) {
  const s = Qi(yfe), u = an(void 0);
  return ln(() => {
    var f;
    t != null && ((f = u.current) == null || f.setOpacity(t));
  }, [t]), ln(() => {
    var f;
    n && ((f = u.current) == null || f.fitBounds(new Eu.Rect(...n)));
  }, [n]), ln(() => {
    !u.current || !(s != null && s.current) || e == null || s.current.world.setItemIndex(u.current, e);
  }, [e, s]), ln(() => {
    if (!(s != null && s.current)) return;
    const f = new Promise((m, v) => {
      var S;
      const y = i && { type: "image", url: i } || (typeof r == "string" || r instanceof String) && r || { ...r };
      (S = s.current) == null || S.addTiledImage({
        error: (E) => v(E),
        fitBounds: n ? new Eu.Rect(...n) : void 0,
        index: e,
        opacity: t,
        success: (E) => m(E),
        tileSource: y
      });
    }).then((m) => {
      o && o(), u.current = m.item;
    }), p = s.current;
    return () => f.finally(() => {
      p && u.current && p.world.removeItem(u.current);
    });
  }, [s == null ? void 0 : s.current, i]), null;
}
iU.propTypes = {
  fitBounds: c.arrayOf(c.number),
  index: c.number,
  opacity: c.number,
  tileSource: c.oneOfType([c.string, c.object]),
  url: c.string,
  zoomToWorld: c.func
};
const npt = ye("section")({
  cursor: "grab",
  flex: 1,
  position: "relative"
});
function xfe({
  children: e = null,
  label: t = null,
  windowId: n,
  osdConfig: r = {},
  viewerConfig: i = null,
  drawAnnotations: o = !1,
  infoResponses: s = [],
  canvasWorld: u,
  nonTiledImages: f = [],
  updateViewport: p,
  ...m
}) {
  const { t: v } = Ct(), y = an(), [S, E] = Bn(null), w = Yn(({
    flip: P,
    rotation: M,
    x: N,
    y: k,
    zoom: U
  }) => {
    p(n, {
      flip: P,
      rotation: M,
      x: N,
      y: k,
      zoom: U
    });
  }, [p, n]), _ = Yn((P = !0) => {
    var M;
    (M = y.current) != null && M.viewport && y.current.viewport.fitBounds(
      new Eu.Rect(...u.worldBounds()),
      P
    );
  }, [u, y]);
  ln(() => {
    tpt.set(n, y);
  }, [y, n]), ln(() => {
    y.current = S;
  }, [y, S]);
  const O = aU.map(e, (P) => jd(
    P,
    {
      zoomToWorld: _
    }
  )), D = {
    canvasWorld: u,
    drawAnnotations: o,
    infoResponses: s,
    label: t,
    nonTiledImages: f,
    osdConfig: r,
    t: v,
    updateViewport: p,
    viewerConfig: i,
    windowId: n,
    ...m
  };
  return /* @__PURE__ */ T.jsxs(
    bfe,
    {
      className: On(Nt("osd-container")),
      Container: npt,
      osdConfig: r,
      viewerConfig: i || (u.hasDimensions() ? { bounds: u.worldBounds() } : void 0),
      onUpdateViewport: w,
      setViewer: E,
      "aria-label": v("item", { label: t }),
      "aria-live": "polite",
      children: [
        s.map((P) => {
          const M = u.contentResource(P.id);
          if (!M) return null;
          const N = u.contentResourceToWorldCoordinates(M), k = u.layerIndexOfImageResource(M), U = u.layerOpacityOfImageResource(M);
          return /* @__PURE__ */ T.jsx(
            iU,
            {
              tileSource: P.json,
              fitBounds: N,
              index: k,
              opacity: U,
              zoomToWorld: _
            },
            P.id
          );
        }),
        f.map((P) => {
          const M = P.getProperty("type"), N = P.getProperty("format") || "";
          if (!(M === "Image" || M === "dctypes:Image" || N.startsWith("image/"))) return null;
          const k = u.contentResourceToWorldCoordinates(P), U = u.layerIndexOfImageResource(P), H = u.layerOpacityOfImageResource(P);
          return /* @__PURE__ */ T.jsx(
            iU,
            {
              url: P.id,
              fitBounds: k,
              index: U,
              opacity: H,
              zoomToWorld: _
            },
            P.id
          );
        }),
        o && /* @__PURE__ */ T.jsx(ept, { viewer: S, windowId: n }),
        O,
        /* @__PURE__ */ T.jsx(Ki, { targetName: "OpenSeadragonViewer", viewer: S, ...D })
      ]
    }
  );
}
xfe.propTypes = {
  canvasWorld: c.instanceOf(OD).isRequired,
  children: c.node,
  drawAnnotations: c.bool,
  infoResponses: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  label: c.string,
  nonTiledImages: c.array,
  // eslint-disable-line react/forbid-prop-types
  osdConfig: c.object,
  // eslint-disable-line react/forbid-prop-types
  updateViewport: c.func.isRequired,
  viewerConfig: c.object,
  // eslint-disable-line react/forbid-prop-types
  windowId: c.string.isRequired
};
const rpt = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7zm-4 6h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z"
}), "ListSharp");
function Sfe({
  collectionPath: e = [],
  manifestId: t = null,
  showCollectionDialog: n,
  windowId: r = null
}) {
  const { t: i } = Ct(), o = Yn(() => {
    n(t, e.slice(0, -1), r);
  }, [e, t, n, r]);
  return /* @__PURE__ */ T.jsx(pr, { container: !0, justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ T.jsxs(pr, { container: !0, direction: "column", alignItems: "center", children: [
    /* @__PURE__ */ T.jsx(St, { variant: "h4", paragraph: !0, children: /* @__PURE__ */ T.jsx("em", { children: i("noItemSelected") }) }),
    /* @__PURE__ */ T.jsx(
      hi,
      {
        "aria-label": "show collection",
        color: "primary",
        variant: "contained",
        onClick: o,
        startIcon: /* @__PURE__ */ T.jsx(rpt, {}),
        children: i("showCollection")
      }
    )
  ] }) });
}
Sfe.propTypes = {
  collectionPath: c.arrayOf(c.string),
  manifestId: c.string,
  showCollectionDialog: c.func.isRequired,
  windowId: c.string
};
const ipt = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "AddCircleOutlineSharp"), opt = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "RemoveCircleOutlineSharp");
function apt(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ T.jsx("path", { d: "M6,15H9v3h2V13H6Zm9-6V6H13v5h5V9Z" }),
    /* @__PURE__ */ T.jsx("path", { d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8,8,8,0,0,1-8,8Z" })
  ] }) });
}
const spt = ye("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
});
function wfe({
  windowId: e = "",
  updateViewport: t = () => {
  },
  viewer: n = {},
  zoomToWorld: r
}) {
  const { t: i } = Ct(), o = () => {
    t(e, {
      zoom: n.zoom * 2
    });
  }, s = () => {
    t(e, {
      zoom: n.zoom / 2
    });
  };
  return /* @__PURE__ */ T.jsxs(spt, { children: [
    /* @__PURE__ */ T.jsx(Jn, { "aria-label": i("zoomIn"), onClick: o, children: /* @__PURE__ */ T.jsx(ipt, {}) }),
    /* @__PURE__ */ T.jsx(Jn, { "aria-label": i("zoomOut"), onClick: s, children: /* @__PURE__ */ T.jsx(opt, {}) }),
    /* @__PURE__ */ T.jsx(Jn, { "aria-label": i("zoomReset"), onClick: () => r(!1), children: /* @__PURE__ */ T.jsx(apt, {}) })
  ] });
}
wfe.propTypes = {
  updateViewport: c.func,
  viewer: c.shape({
    x: c.number,
    y: c.number,
    zoom: c.number
  }),
  windowId: c.string,
  zoomToWorld: c.func.isRequired
};
const lpt = (e, { windowId: t }) => ({
  viewer: hD(e, { windowId: t })
}), cpt = { updateViewport: j3 }, upt = wt(
  At(lpt, cpt),
  Tt("ZoomControls")
), dpt = upt(wfe), fpt = ye("div")(() => ({
  overflow: "hidden",
  paddingBottom: 0.5,
  textOverflow: "ellipsis",
  unicodeBidi: "plaintext",
  whiteSpace: "nowrap",
  width: "100%"
}));
function Tfe({
  canvasCount: e,
  canvasIndex: t,
  canvasLabel: n = void 0
}) {
  const { t: r } = Ct();
  return /* @__PURE__ */ T.jsxs(fpt, { className: On(Nt("osd-info")), children: [
    /* @__PURE__ */ T.jsx(St, { display: "inline", variant: "caption", className: Nt("canvas-count"), children: r("pagination", { current: t + 1, total: e }) }),
    /* @__PURE__ */ T.jsx(St, { display: "inline", variant: "caption", className: Nt("canvas-label"), children: n && ` • ${n}` })
  ] });
}
Tfe.propTypes = {
  canvasCount: c.number.isRequired,
  canvasIndex: c.number.isRequired,
  canvasLabel: c.string
};
const ppt = (e, t) => {
  const { windowId: n } = t, r = Fa(e, { windowId: n }), i = u3(e, { windowId: n }), o = (Vl(e, { windowId: n }) || {}).id;
  return {
    canvasCount: r.length,
    canvasIndex: i,
    canvasLabel: yg(e, {
      canvasId: o,
      windowId: n
    })
  };
}, hpt = wt(
  At(ppt, null),
  Tt("ViewerInfo")
), oJ = hpt(Tfe), aJ = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m10 16.5 6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "PlayCircleOutlineSharp");
function Efe({
  hasNextCanvas: e = !1,
  hasPreviousCanvas: t = !1,
  setNextCanvas: n = () => {
  },
  setPreviousCanvas: r = () => {
  },
  viewingDirection: i = ""
}) {
  const { t: o } = Ct();
  let s = "ltr", u = {}, f = {};
  switch (i) {
    case "top-to-bottom":
      u = { transform: "rotate(270deg)" }, f = { transform: "rotate(90deg)" };
      break;
    case "bottom-to-top":
      u = { transform: "rotate(90deg)" }, f = { transform: "rotate(270deg)" };
      break;
    case "right-to-left":
      s = "rtl", u = {}, f = { transform: "rotate(180deg)" };
      break;
    default:
      u = { transform: "rotate(180deg)" }, f = {};
  }
  return /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: On(Nt("osd-navigation")),
      dir: s,
      children: [
        /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": o("previousCanvas"),
            className: Nt("previous-canvas-button"),
            disabled: !t,
            onClick: () => {
              t && r();
            },
            children: /* @__PURE__ */ T.jsx(aJ, { style: u })
          }
        ),
        /* @__PURE__ */ T.jsx(
          Jn,
          {
            "aria-label": o("nextCanvas"),
            className: Nt("next-canvas-button"),
            disabled: !e,
            onClick: () => {
              e && n();
            },
            children: /* @__PURE__ */ T.jsx(aJ, { style: f })
          }
        )
      ]
    }
  );
}
Efe.propTypes = {
  hasNextCanvas: c.bool,
  hasPreviousCanvas: c.bool,
  setNextCanvas: c.func,
  setPreviousCanvas: c.func,
  viewingDirection: c.string
};
const gpt = (e, { windowId: t }) => ({
  hasNextCanvas: !!q1(e, { windowId: t }),
  hasPreviousCanvas: !!$1(e, { windowId: t }),
  viewingDirection: Ix(e, { windowId: t })
}), mpt = (e, { windowId: t }) => ({
  setNextCanvas: (...n) => e(ID(t)),
  setPreviousCanvas: (...n) => e(PD(t))
}), vpt = wt(
  At(gpt, mpt),
  Tt("ViewerNavigation")
  // further HOC go here
), ypt = vpt(Efe), bpt = ye(Ei, { name: "WindowCanvasNavigationControls", slot: "root" })(({ theme: e }) => ({
  alignItems: "center",
  backgroundColor: _u(e.palette.background.paper, 0.5),
  bottom: 0,
  cursor: "default",
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  justifyContent: "center",
  position: "absolute",
  textAlign: "center",
  width: "100%",
  zIndex: 50
})), SP = YA(({
  showZoomControls: e = !1,
  visible: t = !0,
  windowId: n,
  zoomToWorld: r,
  ...i
}, o) => {
  const [s, u] = Hre.useElementSize(), f = {
    showZoomControls: e,
    size: u,
    visible: t,
    windowId: n,
    ...i
  }, p = u && u.width && u.width <= 253;
  return t ? /* @__PURE__ */ T.jsxs(
    bpt,
    {
      square: !0,
      className: On(
        Nt("canvas-nav"),
        p ? Nt("canvas-nav-stacked") : null
      ),
      elevation: 0,
      ref: qre(o, s),
      children: [
        /* @__PURE__ */ T.jsxs(
          yP,
          {
            direction: p ? "column" : "row",
            divider: /* @__PURE__ */ T.jsx(pA, { orientation: p ? "horizontal" : "vertical", variant: "middle", flexItem: !0 }),
            spacing: 0,
            children: [
              e && /* @__PURE__ */ T.jsx(dpt, { windowId: n, zoomToWorld: r }),
              /* @__PURE__ */ T.jsx(ypt, { windowId: n })
            ]
          }
        ),
        /* @__PURE__ */ T.jsx(oJ, { windowId: n }),
        /* @__PURE__ */ T.jsx(Ki, { targetName: "WindowCanvasNavigationControls", ...f })
      ]
    }
  ) : /* @__PURE__ */ T.jsx(St, { style: XD, component: "div", children: /* @__PURE__ */ T.jsx(oJ, { windowId: n }) });
});
SP.propTypes = {
  showZoomControls: c.bool,
  visible: c.bool,
  windowId: c.string.isRequired,
  zoomToWorld: c.func.isRequired
};
SP.defaultProps = {
  showZoomControls: !1,
  visible: !0
};
SP.displayName = "WindowCanvasNavigationControls";
const xpt = (e, { windowId: t }) => ({
  showZoomControls: n3(e),
  visible: Do(e).focusedWindowId === t
}), Spt = wt(
  At(xpt),
  Tt("WindowCanvasNavigationControls")
), _fe = Spt(SP), wpt = ye("div")(() => ({
  alignItems: "center",
  display: "flex",
  width: "100%"
})), Tpt = ye("div")(() => ({
  maxHeight: "100%",
  width: "100%"
}));
function Cfe({ textOptions: e = {}, textResources: t = [], windowId: n }) {
  return /* @__PURE__ */ T.jsx(wpt, { children: /* @__PURE__ */ T.jsxs(Tpt, { ...e, children: [
    t.map((r) => /* @__PURE__ */ T.jsx("source", { src: r.id, type: r.getFormat() }, r.id)),
    /* @__PURE__ */ T.jsx(_fe, { windowId: n })
  ] }) });
}
Cfe.propTypes = {
  textOptions: c.object,
  // eslint-disable-line react/forbid-prop-types
  textResources: c.arrayOf(c.object),
  // eslint-disable-line react/forbid-prop-types
  windowId: c.string.isRequired
};
function Rfe({
  handleClose: e,
  windowIds: t,
  focusWindow: n,
  focusedWindowId: r = null,
  titles: i = {},
  tReady: o = !1,
  ...s
}) {
  const { t: u } = Ct(), f = Qi(Eg);
  return /* @__PURE__ */ T.jsxs(
    Bx,
    {
      anchorOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      transformOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      id: "window-list-menu",
      container: f == null ? void 0 : f.current,
      onClose: e,
      ...s,
      children: [
        /* @__PURE__ */ T.jsx(ug, { role: "presentation", selected: !1, disabled: !0, tabIndex: "-1", children: u("openWindows") }),
        t.map((p, m) => /* @__PURE__ */ T.jsx(
          qo,
          {
            selected: p === r,
            onClick: (v) => {
              n(p, !0), e(v);
            },
            children: /* @__PURE__ */ T.jsx(dp, { primaryTypographyProps: { variant: "body1" }, children: i[p] || u("untitled") })
          },
          p
        ))
      ]
    }
  );
}
Rfe.propTypes = {
  container: c.shape({ current: c.instanceOf(Element) }),
  focusedWindowId: c.string,
  focusWindow: c.func.isRequired,
  handleClose: c.func.isRequired,
  titles: c.objectOf(c.string),
  tReady: c.bool,
  windowIds: c.arrayOf(c.string).isRequired
};
const Ept = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m19 18 2 1V1H7v2h12zM17 5H3v18l7-3 7 3z"
}), "BookmarksSharp"), _pt = {
  focusWindow: n_
}, Cpt = (e) => ({
  focusedWindowId: f3(e),
  titles: nte(e),
  windowIds: Xv(e)
}), Rpt = wt(
  At(Cpt, _pt),
  Tt("WindowList")
), Opt = Rpt(Rfe);
function Ofe({ disabled: e = !1, windowCount: t }) {
  const { t: n } = Ct(), [r, i] = Bn(null), o = uo(), s = () => {
    i(null);
  }, u = (f) => {
    i(f.currentTarget);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-haspopup": "true",
        "aria-label": n("listAllOpenWindows"),
        "aria-owns": r ? o : null,
        selected: !!r,
        disabled: e,
        badge: !0,
        BadgeProps: {
          badgeContent: t,
          sx: {
            ".MuiBadge-badge": {
              paddingLeft: 1.5
            }
          }
        },
        onClick: (f) => u(f),
        children: /* @__PURE__ */ T.jsx(Ept, {})
      }
    ),
    !!r && /* @__PURE__ */ T.jsx(
      Opt,
      {
        anchorEl: r,
        id: o,
        open: !!r,
        handleClose: s
      }
    )
  ] });
}
Ofe.propTypes = {
  disabled: c.bool,
  windowCount: c.number.isRequired
};
const Apt = gg(() => Promise.resolve().then(() => omt));
function Afe({ windowId: e }) {
  return /* @__PURE__ */ T.jsx(WH, { fallback: null, children: /* @__PURE__ */ T.jsx(sU, { fallback: /* @__PURE__ */ T.jsx("div", {}), children: /* @__PURE__ */ T.jsx(
    Apt,
    {
      windowId: e,
      children: /* @__PURE__ */ T.jsx(_fe, { windowId: e })
    }
  ) }) });
}
Afe.propTypes = {
  windowId: c.string.isRequired
};
var T2, sJ;
function Dpt() {
  if (sJ) return T2;
  sJ = 1;
  var e = E3(), t = Rx(), n = J1(), r = CD(), i = n(function(o, s) {
    return r(o) ? e(o, t(s, 1, r, !0)) : [];
  });
  return T2 = i, T2;
}
var Ipt = Dpt();
const lJ = /* @__PURE__ */ Hn(Ipt);
var E2, cJ;
function Ppt() {
  if (cJ) return E2;
  cJ = 1;
  var e = $U();
  function t(n, r) {
    return e(n, r);
  }
  return E2 = t, E2;
}
var Npt = Ppt();
const Mpt = /* @__PURE__ */ Hn(Npt), jpt = (e, { windowId: t }) => ({
  title: Lu(e, { windowId: t })
}), Lpt = wt(
  At(jpt, null),
  Tt("MosaicRenderPreview")
), kpt = Lpt(gfe);
var _2, uJ;
function zpt() {
  if (uJ) return _2;
  uJ = 1;
  var e = sle(), t = PU();
  function n(r, i, o) {
    var s = r == null ? 0 : r.length;
    return s ? (i = o || i === void 0 ? 1 : t(i), i = s - i, e(r, 0, i < 0 ? 0 : i)) : [];
  }
  return _2 = n, _2;
}
var Bpt = zpt();
const Vpt = /* @__PURE__ */ Hn(Bpt);
class Upt {
  /** */
  constructor(t) {
    this.layout = t;
  }
  /** */
  pathToCorner(t = Tde.TOP_RIGHT) {
    return lut(this.layout, t);
  }
  /** */
  pathToParent(t) {
    return nU(this.layout, Vpt(t));
  }
  /** */
  nodeAtPath(t) {
    return nU(this.layout, t);
  }
  /**
   * addWindows - updates the layout with new windows using an algorithm ported
   * from the react-mosaic-components examples. Will always add to the Top Right
   * https://github.com/nomcopter/react-mosaic/blob/5081df8d1528d4c3b83a72763a46a30b3048fe95/demo/ExampleApp.tsx#L119-L154
   * @param {Array} addedWindowIds [description]
   */
  addWindows(t) {
    t.forEach((n, r) => {
      const i = this.pathToCorner(), o = this.pathToParent(i), s = this.nodeAtPath(i), u = o ? Ede(o.direction) : "row";
      let f, p;
      u === "row" ? (f = s, p = t[r]) : (f = t[r], p = s);
      const m = {
        path: i,
        spec: {
          $set: {
            direction: u,
            first: f,
            second: p
          }
        }
      };
      this.layout = HA(this.layout, [m]);
    });
  }
  /**
   * removeWindows - Generate a set of "removeUpdates" to update layout binary
   * tree. Then update the layout.
   * @param  {Array} removedWindowIds
   * @param  {Object} windowPaths - a lookup table for window paths
   */
  removeWindows(t, n) {
    const r = t.map((i) => qA(this.layout, n[i]));
    this.layout = HA(this.layout, r);
  }
}
const Fpt = {
  ".mosaic": {
    height: "100%",
    width: "100%"
  },
  ".mosaic, .mosaic > *": {
    boxSizing: "border-box"
  },
  ".mosaic .mosaic-zero-state": {
    position: "absolute",
    top: 6,
    right: 6,
    bottom: 6,
    left: 6,
    width: "auto",
    height: "auto",
    zIndex: "1"
  },
  ".mosaic-root": {
    position: "absolute",
    top: 3,
    right: 3,
    bottom: 3,
    left: 3
  },
  ".mosaic-split": {
    position: "absolute",
    zIndex: "1",
    touchAction: "none"
  },
  ".mosaic-split:hover": {
    background: "black"
  },
  ".mosaic-split .mosaic-split-line": {
    position: "absolute"
  },
  ".mosaic-split.-row": {
    marginLeft: -3,
    width: 6,
    cursor: "ew-resize"
  },
  ".mosaic-split.-row .mosaic-split-line": {
    top: "0",
    bottom: "0",
    left: 3,
    right: 3
  },
  ".mosaic-split.-column": {
    marginTop: -3,
    height: 6,
    cursor: "ns-resize"
  },
  ".mosaic-split.-column .mosaic-split-line": {
    top: 3,
    bottom: 3,
    left: "0",
    right: "0"
  },
  ".mosaic-tile": {
    position: "absolute",
    margin: 3
  },
  ".mosaic-tile > *": {
    height: "100%",
    width: "100%"
  },
  ".mosaic-drop-target": {
    position: "relative"
  },
  ".mosaic-drop-target.drop-target-hover .drop-target-container": {
    display: "block"
  },
  ".mosaic-drop-target.mosaic > .drop-target-container .drop-target.left": {
    right: "calc(100% -  10px )"
  },
  ".mosaic-drop-target.mosaic > .drop-target-container .drop-target.right": {
    left: "calc(100% -  10px )"
  },
  ".mosaic-drop-target.mosaic > .drop-target-container .drop-target.bottom": {
    top: "calc(100% -  10px )"
  },
  ".mosaic-drop-target.mosaic > .drop-target-container .drop-target.top": {
    bottom: "calc(100% -  10px )"
  },
  ".mosaic-drop-target .drop-target-container": {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    display: "none"
  },
  ".mosaic-drop-target .drop-target-container.-dragging": {
    display: "block"
  },
  ".mosaic-drop-target .drop-target-container .drop-target": {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    background: "rgba(0, 0, 0, 0.2)",
    border: "2px solid black",
    opacity: "0",
    zIndex: "5"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.left": {
    right: "calc(100% -  30% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.right": {
    left: "calc(100% -  30% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.bottom": {
    top: "calc(100% -  30% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.top": {
    bottom: "calc(100% -  30% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.drop-target-hover": {
    opacity: "1"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.left": {
    right: "calc(100% -  50% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.right": {
    left: "calc(100% -  50% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.bottom": {
    top: "calc(100% -  50% )"
  },
  ".mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.top": {
    bottom: "calc(100% -  50% )"
  },
  ".mosaic-window, .mosaic-preview": {
    position: "relative",
    display: "flex",
    fallbacks: [
      {
        display: "-webkit-box"
      }
    ],
    webkitBoxOrient: "vertical",
    webkitBoxDirection: "normal",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: "0 0 1px rgba(0, 0, 0, 0.2)"
  },
  ".mosaic-window .mosaic-window-toolbar, .mosaic-preview .mosaic-window-toolbar": {
    zIndex: "4",
    display: "flex",
    fallbacks: [
      {
        display: "-webkit-box"
      }
    ],
    webkitBoxPack: "justify",
    justifyContent: "space-between",
    webkitBoxAlign: "center",
    alignItems: "center",
    flexShrink: "0",
    height: 30,
    background: "white",
    boxShadow: "0 1px 1px rgba(0, 0, 0, 0.2)"
  },
  ".mosaic-window .mosaic-window-toolbar.draggable, .mosaic-preview .mosaic-window-toolbar.draggable": {
    cursor: "move"
  },
  ".mosaic-window .mosaic-window-title, .mosaic-preview .mosaic-window-title": {
    paddingLeft: 15,
    webkitBoxFlex: "1",
    flex: "1",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    minHeight: 18
  },
  ".mosaic-window .mosaic-window-controls, .mosaic-preview .mosaic-window-controls": {
    display: "flex",
    fallbacks: [
      {
        display: "-webkit-box"
      }
    ],
    height: "100%"
  },
  ".mosaic-window .mosaic-window-controls .separator, .mosaic-preview .mosaic-window-controls .separator": {
    height: 20,
    borderLeft: "1px solid black",
    margin: "5px 4px"
  },
  ".mosaic-window .mosaic-window-body, .mosaic-preview .mosaic-window-body": {
    position: "relative",
    webkitBoxFlex: "1",
    flex: "1",
    height: "0",
    background: "white",
    zIndex: "1",
    overflow: "hidden"
  },
  ".mosaic-window .mosaic-window-additional-actions-bar, .mosaic-preview .mosaic-window-additional-actions-bar": {
    position: "absolute",
    top: 30,
    right: "0",
    bottom: "initial",
    left: "0",
    height: "0",
    overflow: "hidden",
    background: "white",
    webkitBoxPack: "end",
    justifyContent: "flex-end",
    display: "flex",
    fallbacks: [
      {
        display: "-webkit-box"
      }
    ],
    zIndex: "3"
  },
  ".mosaic-window .mosaic-window-additional-actions-bar .bp3-button, .mosaic-preview .mosaic-window-additional-actions-bar .bp3-button": {
    margin: "0"
  },
  ".mosaic-window .mosaic-window-additional-actions-bar .bp3-button:after, .mosaic-preview .mosaic-window-additional-actions-bar .bp3-button:after": {
    display: "none"
  },
  ".mosaic-window .mosaic-window-body-overlay, .mosaic-preview .mosaic-window-body-overlay": {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    opacity: "0",
    background: "white",
    display: "none",
    zIndex: "2"
  },
  ".mosaic-window.additional-controls-open .mosaic-window-additional-actions-bar, .mosaic-preview.additional-controls-open .mosaic-window-additional-actions-bar": {
    height: 30
  },
  ".mosaic-window.additional-controls-open .mosaic-window-body-overlay, .mosaic-preview.additional-controls-open .mosaic-window-body-overlay": {
    display: "block"
  },
  ".mosaic-window .mosaic-preview, .mosaic-preview .mosaic-preview": {
    height: "100%",
    width: "100%",
    position: "absolute",
    zIndex: "0",
    border: "1px solid black",
    maxHeight: 400
  },
  ".mosaic-window .mosaic-preview .mosaic-window-body, .mosaic-preview .mosaic-preview .mosaic-window-body": {
    display: "flex",
    fallbacks: [
      {
        display: "-webkit-box"
      }
    ],
    webkitBoxOrient: "vertical",
    webkitBoxDirection: "normal",
    flexDirection: "column",
    webkitBoxAlign: "center",
    alignItems: "center",
    webkitBoxPack: "center",
    justifyContent: "center"
  },
  ".mosaic-window .mosaic-preview h4, .mosaic-preview .mosaic-preview h4": {
    marginBottom: 10
  },
  ".mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.close-button:before": {
    content: "'Close'"
  },
  ".mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.split-button:before": {
    content: "'Split'"
  },
  ".mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.replace-button:before": {
    content: "'Replace'"
  },
  ".mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.expand-button:before": {
    content: "'Expand'"
  }
}, Wpt = ye(wut)({
  "& .mosaic-preview": {
    boxShadow: "none"
  },
  "& .mosaic-tile": {
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .2), 0 2px 1px -1px rgba(0, 0, 0, .2)"
  },
  "& .mosaic-window": {
    boxShadow: "none"
  },
  "& .mosaic-window-toolbar": {
    display: "none !important"
  }
}), Dfe = ({ windowId: e }) => /* @__PURE__ */ T.jsx("div", { className: "mosaic-preview", "aria-hidden": !0, children: /* @__PURE__ */ T.jsx(kpt, { windowId: e }) });
Dfe.propTypes = {
  windowId: c.string.isRequired
};
const Hpt = () => /* @__PURE__ */ T.jsx("div", {}), qpt = (e, t, n = {}) => {
  const r = A1(e), i = new Upt(e), o = lJ(t, r);
  o.length > 0 && i.addWindows(o);
  const s = lJ(r, t);
  if (s.every((u) => n[u]))
    i.removeWindows(s, n);
  else
    return tU(t);
  return i.layout;
};
function Ife({
  layout: e = void 0,
  updateWorkspaceMosaicLayout: t,
  windowIds: n = [],
  workspaceId: r
}) {
  const i = [], o = [], s = an({}), u = Qi(NI);
  ln(() => {
    const m = A1(e);
    if (!e || n.length === 0 || m.length < 2) {
      t(tU(n));
      return;
    }
    if (n.every((y) => m.includes(y)) && m.every((y) => n.includes(y)))
      return;
    const v = qpt(e, n, s.current);
    Mpt(v, e) || t(v);
  }, [e, n, s, t]);
  const f = (m, v) => n.includes(m) ? (s.current[m] = v, /* @__PURE__ */ T.jsx(
    Dut,
    {
      toolbarControls: i,
      additionalControls: o,
      path: v,
      windowId: m,
      renderPreview: Dfe,
      children: /* @__PURE__ */ T.jsx(
        $A,
        {
          windowId: m
        },
        `${m}-${r}`
      )
    }
  )) : null, p = (m) => {
    t(m);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(iF, { styles: { ...Fpt } }),
    /* @__PURE__ */ T.jsx(
      Wpt,
      {
        dragAndDropManager: u.dragDropManager,
        renderTile: f,
        initialValue: e || tU(n),
        onChange: p,
        className: On("mirador-mosaic"),
        zeroStateView: /* @__PURE__ */ T.jsx(Hpt, {})
      }
    )
  ] });
}
Ife.propTypes = {
  layout: c.oneOfType(
    [c.object, c.string]
  ),
  // eslint-disable-line react/forbid-prop-types
  updateWorkspaceMosaicLayout: c.func.isRequired,
  windowIds: c.arrayOf(c.string),
  workspaceId: c.string.isRequired
};
const $pt = (e) => ({
  layout: Do(e).layout,
  windowIds: Do(e).windowIds,
  workspaceId: Do(e).id
}), Gpt = { updateWorkspaceMosaicLayout: ene }, Ypt = wt(
  At($pt, Gpt),
  Tt("WorkspaceMosaic")
  // further HOC go here
), Xpt = Ypt(Ife), Zpt = (e) => ({
  elasticLayout: vD(e),
  workspace: Do(e)
}), Kpt = (e, t) => ({
  setWorkspaceViewportDimensions: (n) => {
    e(
      tne(n)
    );
  },
  setWorkspaceViewportPosition: (n) => {
    e(
      L3(n)
    );
  },
  updateElasticWindowLayout: (n, r) => {
    e(
      H3(n, r)
    );
  }
}), Qpt = wt(
  At(Zpt, Kpt),
  Tt("WorkspaceElastic")
  // further HOC go here
), Jpt = Qpt(rfe), Pfe = ye("div", { name: "Workspace", slot: "root" })(() => ({
  height: "100%",
  position: "relative",
  width: "100%"
})), Nfe = () => {
  const { t: e } = Ct();
  return /* @__PURE__ */ T.jsx(Pfe, { children: /* @__PURE__ */ T.jsx(
    pr,
    {
      alignItems: "center",
      container: !0,
      style: {
        height: "100%"
      },
      children: /* @__PURE__ */ T.jsx(
        pr,
        {
          xs: 12,
          item: !0,
          children: /* @__PURE__ */ T.jsx(
            St,
            {
              variant: "h1",
              component: "div",
              align: "center",
              children: e("welcome")
            }
          )
        }
      )
    }
  ) });
};
Nfe.propTypes = {};
function Mfe({
  addWindow: e = () => {
  },
  allowNewWindows: t = !0,
  maximizedWindowIds: n = [],
  windowIds: r = [],
  workspaceId: i,
  workspaceType: o
}) {
  const { t: s } = Ct(), u = ({ canvasId: m, manifestId: v, manifestJson: y }, S, E) => {
    t && e({ canvasId: m, manifest: y, manifestId: v });
  }, f = () => {
    if (n.length > 0 && n.length > 0)
      return n.map((m) => /* @__PURE__ */ T.jsx(
        $A,
        {
          windowId: m,
          className: On(Nt("workspace-maximized-window"))
        },
        `${m}-${i}`
      ));
    if (r.length === 0) return /* @__PURE__ */ T.jsx(Nfe, {});
    switch (o) {
      case "elastic":
        return /* @__PURE__ */ T.jsx(Jpt, {});
      case "mosaic":
        return /* @__PURE__ */ T.jsx(Xpt, {});
      default:
        return r.map((m) => /* @__PURE__ */ T.jsx(
          $A,
          {
            windowId: m
          },
          `${m}-${i}`
        ));
    }
  }, p = {
    allowNewWindows: t,
    maximizedWindowIds: n,
    windowIds: r,
    workspaceId: i,
    workspaceType: o
  };
  return /* @__PURE__ */ T.jsx($H, { onDrop: u, children: /* @__PURE__ */ T.jsxs(
    Pfe,
    {
      ownerState: p,
      className: On(
        Nt("workspace-viewport")
      ),
      children: [
        /* @__PURE__ */ T.jsx(St, { style: XD, component: "h1", children: s("miradorViewer") }),
        f()
      ]
    }
  ) });
}
Mfe.propTypes = {
  addWindow: c.func,
  allowNewWindows: c.bool,
  maximizedWindowIds: c.arrayOf(c.string),
  windowIds: c.arrayOf(c.string),
  workspaceId: c.string.isRequired,
  workspaceType: c.string.isRequired
};
const jfe = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "AddSharp");
function eht(e) {
  return Vt("MuiFab", e);
}
const dJ = Wt("MuiFab", ["root", "primary", "secondary", "extended", "circular", "focusVisible", "disabled", "colorInherit", "sizeSmall", "sizeMedium", "sizeLarge", "info", "error", "warning", "success"]);
var tht = {};
const nht = (e) => {
  const {
    color: t,
    variant: n,
    classes: r,
    size: i
  } = e, o = {
    root: ["root", n, `size${Ke(i)}`, t === "inherit" ? "colorInherit" : t]
  }, s = Ft(o, eht, r);
  return {
    ...r,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...s
  };
}, rht = ye(Ws, {
  name: "MuiFab",
  slot: "Root",
  shouldForwardProp: (e) => ha(e) || e === "classes",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${Ke(n.size)}`], n.color === "inherit" && t.colorInherit, t[Ke(n.size)], t[n.color]];
  }
})(Lt(({
  theme: e
}) => {
  var t, n;
  return {
    ...e.typography.button,
    minHeight: 36,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
      duration: e.transitions.duration.short
    }),
    borderRadius: "50%",
    padding: 0,
    minWidth: 0,
    width: 56,
    height: 56,
    zIndex: (e.vars || e).zIndex.fab,
    boxShadow: (e.vars || e).shadows[6],
    "&:active": {
      boxShadow: (e.vars || e).shadows[12]
    },
    color: e.vars ? e.vars.palette.text.primary : (n = (t = e.palette).getContrastText) == null ? void 0 : n.call(t, e.palette.grey[300]),
    backgroundColor: (e.vars || e).palette.grey[300],
    "&:hover": {
      backgroundColor: (e.vars || e).palette.grey.A100,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.grey[300]
      },
      textDecoration: "none"
    },
    [`&.${dJ.focusVisible}`]: {
      boxShadow: (e.vars || e).shadows[6]
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        width: 40,
        height: 40
      }
    }, {
      props: {
        size: "medium"
      },
      style: {
        width: 48,
        height: 48
      }
    }, {
      props: {
        variant: "extended"
      },
      style: {
        borderRadius: 48 / 2,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
      }
    }, {
      props: {
        variant: "extended",
        size: "small"
      },
      style: {
        width: "auto",
        padding: "0 8px",
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      }
    }, {
      props: {
        variant: "extended",
        size: "medium"
      },
      style: {
        width: "auto",
        padding: "0 16px",
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    }, {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit"
      }
    }]
  };
}), Lt(({
  theme: e
}) => ({
  variants: [...Object.entries(e.palette).filter(Jr(["dark", "contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].contrastText,
      backgroundColor: (e.vars || e).palette[t].main,
      "&:hover": {
        backgroundColor: (e.vars || e).palette[t].dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette[t].main
        }
      }
    }
  }))]
})), Lt(({
  theme: e
}) => ({
  [`&.${dJ.disabled}`]: {
    color: (e.vars || e).palette.action.disabled,
    boxShadow: (e.vars || e).shadows[0],
    backgroundColor: (e.vars || e).palette.action.disabledBackground
  }
}))), GH = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiFab"
  }), {
    children: i,
    className: o,
    color: s = "default",
    component: u = "button",
    disabled: f = !1,
    disableFocusRipple: p = !1,
    focusVisibleClassName: m,
    size: v = "large",
    variant: y = "circular",
    ...S
  } = r, E = {
    ...r,
    color: s,
    component: u,
    disabled: f,
    disableFocusRipple: p,
    size: v,
    variant: y
  }, w = nht(E);
  return /* @__PURE__ */ T.jsx(rht, {
    className: yt(w.root, o),
    component: u,
    disabled: f,
    focusRipple: !p,
    focusVisibleClassName: yt(w.focusVisible, m),
    ownerState: E,
    ref: n,
    ...S,
    classes: w,
    children: i
  });
});
tht.NODE_ENV !== "production" && (GH.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["default", "error", "info", "inherit", "primary", "secondary", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: c.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: c.string,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: c.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: c.oneOfType([c.oneOf(["circular", "extended"]), c.string])
});
const iht = { addResource: q3 }, oht = wt(
  At(null, iht),
  Tt("ManifestForm")
), aht = oht(pfe), sht = (e, { manifestId: t, provider: n }) => {
  const r = Va(e, { manifestId: t }) || {}, i = nr(e, { manifestId: t }), o = (i || { isCollection: () => !1 }).isCollection(), s = o ? i.getTotalItems() : Fa(e, { manifestId: t }).length;
  return {
    active: ZU(e).includes(t),
    error: r.error || !i && !!r.json,
    isCollection: o,
    isFetching: r.isFetching,
    isMultipart: o && V1(e, { manifestId: t }).includes("multi-part"),
    manifestLogo: o3(e, { manifestId: t }),
    provider: n || Wee(e, { manifestId: t }),
    ready: !!r.json,
    size: s,
    thumbnail: Xee(e, { manifestId: t }),
    title: Lu(e, { manifestId: t })
  };
}, lht = {
  addWindow: r_,
  fetchManifest: DD
}, cht = wt(
  At(sht, lht),
  Tt("ManifestListItem")
), uht = cht(hfe), dht = ye("div")(() => ({
  boxSizing: "border-box",
  height: "100%",
  overflowX: "hidden",
  overflowY: "auto"
})), fht = ye(Jn)(() => ({
  marginLeft: -12,
  marginRight: 20
}));
function Lfe({
  addResource: e = () => {
  },
  catalog: t = [],
  setWorkspaceAddVisibility: n,
  ...r
}) {
  const { t: i } = Ct(), [o, s] = Bn(!1), u = an(), [f, p] = Bn("100%"), m = () => {
    u.current && p(u.current.offsetWidth);
  }, v = ({ manifestId: _, manifestJson: O }, D, P) => {
    O ? e(_, O, { provider: "file" }) : e(_), S();
  }, y = () => {
    s(!1), S();
  }, S = () => {
    u.current && u.current.scrollTo({ behavior: "smooth", left: 0, top: 0 });
  }, E = t.map((_, O) => /* @__PURE__ */ Ou(
    uht,
    {
      ...O === 0 && { buttonRef: ((D) => D && D.focus()) },
      key: _.manifestId,
      manifestId: _.manifestId,
      provider: _.provider,
      handleClose: () => n(!1)
    }
  )), w = {
    addResource: e,
    catalog: t,
    setWorkspaceAddVisibility: n,
    t: i,
    ...r
  };
  return ln(() => (window.addEventListener("resize", m), m(), () => {
    window.removeEventListener("resize", m);
  }), []), /* @__PURE__ */ T.jsx($H, { onDrop: v, children: /* @__PURE__ */ T.jsxs(dht, { className: On(Nt("workspace-add")), ref: u, children: [
    t.length < 1 ? /* @__PURE__ */ T.jsx(
      pr,
      {
        alignItems: "center",
        container: !0,
        style: {
          height: "100%"
        },
        children: /* @__PURE__ */ T.jsx(
          pr,
          {
            xs: 12,
            item: !0,
            children: /* @__PURE__ */ T.jsx(
              St,
              {
                variant: "h1",
                component: "div",
                align: "center",
                children: i("emptyResourceList")
              }
            )
          }
        )
      }
    ) : /* @__PURE__ */ T.jsxs(Ei, { sx: { margin: 2 }, children: [
      /* @__PURE__ */ T.jsx(St, { style: XD, component: "h1", children: i("miradorResources") }),
      /* @__PURE__ */ T.jsx(Ki, { targetName: "WorkspaceAdd", ...w }),
      /* @__PURE__ */ T.jsx(Xd, { disablePadding: !0, children: E })
    ] }),
    /* @__PURE__ */ T.jsxs(
      GH,
      {
        variant: "extended",
        disabled: o,
        sx: (_) => ({
          bottom: _.spacing(2),
          position: "absolute",
          right: _.spacing(2)
        }),
        className: On(Nt("add-resource-button")),
        "aria-label": i("addResource"),
        color: "primary",
        onClick: () => s(!0),
        children: [
          /* @__PURE__ */ T.jsx(jfe, {}),
          i("addResource")
        ]
      }
    ),
    /* @__PURE__ */ T.jsx(
      qH,
      {
        sx: (_) => ({
          ".MuiDrawer-paper": {
            borderTop: "0",
            left: "unset",
            width: f
          },
          ...!o && {
            display: "none"
          }
        }),
        variant: "persistent",
        anchor: "bottom",
        open: o,
        ModalProps: {
          disablePortal: !0,
          hideBackdrop: !0,
          style: { position: "absolute" }
        },
        children: /* @__PURE__ */ T.jsxs(
          Ei,
          {
            sx: {
              left: "0",
              marginTop: 6,
              paddingBottom: 2,
              paddingLeft: { sm: 3, xs: 2 },
              paddingRight: { sm: 3, xs: 2 },
              paddingTop: 2,
              right: "0"
            },
            children: [
              /* @__PURE__ */ T.jsx(Yx, { position: "absolute", color: "primary", enableColorOnDark: !0, onClick: () => s(!1), children: /* @__PURE__ */ T.jsxs(ny, { variant: "dense", children: [
                /* @__PURE__ */ T.jsx(
                  fht,
                  {
                    "aria-label": i("closeAddResourceForm"),
                    color: "inherit",
                    children: /* @__PURE__ */ T.jsx(mfe, {})
                  }
                ),
                /* @__PURE__ */ T.jsx(St, { variant: "h2", noWrap: !0, color: "inherit", sx: { flexGrow: 1 }, children: i("addResource") })
              ] }) }),
              /* @__PURE__ */ T.jsx(
                aht,
                {
                  addResourcesOpen: o,
                  onSubmit: y,
                  onCancel: () => s(!1)
                }
              )
            ]
          }
        )
      }
    )
  ] }) });
}
Lfe.propTypes = {
  addResource: c.func,
  catalog: c.arrayOf(c.shape({
    manifestId: c.string.isRequired,
    provider: c.string
  })),
  setWorkspaceAddVisibility: c.func.isRequired
};
var fJ = {};
function pht(e, t, n, r, i) {
  const [o, s] = $.useState(() => i && n ? n(e).matches : r ? r(e).matches : t);
  return gs(() => {
    if (!n)
      return;
    const u = n(e), f = () => {
      s(u.matches);
    };
    return f(), u.addEventListener("change", f), () => {
      u.removeEventListener("change", f);
    };
  }, [e, n]), o;
}
const hht = {
  ...$
}, kfe = hht.useSyncExternalStore;
function ght(e, t, n, r, i) {
  const o = $.useCallback(() => t, [t]), s = $.useMemo(() => {
    if (i && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: m
      } = r(e);
      return () => m;
    }
    return o;
  }, [o, e, r, i, n]), [u, f] = $.useMemo(() => {
    if (n === null)
      return [o, () => () => {
      }];
    const m = n(e);
    return [() => m.matches, (v) => (m.addEventListener("change", v), () => {
      m.removeEventListener("change", v);
    })];
  }, [o, n, e]);
  return kfe(f, u, s);
}
function zfe(e = {}) {
  const {
    themeId: t
  } = e;
  return function(r, i = {}) {
    let o = Gne();
    o && t && (o = o[t] || o);
    const s = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: u = !1,
      matchMedia: f = s ? window.matchMedia : null,
      ssrMatchMedia: p = null,
      noSsr: m = !1
    } = are({
      name: "MuiUseMediaQuery",
      props: i,
      theme: o
    });
    fJ.NODE_ENV !== "production" && typeof r == "function" && o === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let v = typeof r == "function" ? r(o) : r;
    v = v.replace(/^@media( ?)/m, ""), v.includes("print") && console.warn(["MUI: You have provided a `print` query to the `useMediaQuery` hook.", "Using the print media query to modify print styles can lead to unexpected results.", "Consider using the `displayPrint` field in the `sx` prop instead.", "More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print."].join(`
`));
    const S = (kfe !== void 0 ? ght : pht)(v, u, f, p, m);
    return fJ.NODE_ENV !== "production" && $.useDebugValue({
      query: v,
      match: S
    }), S;
  };
}
zfe();
const mht = zfe({
  themeId: Ac
});
function vht() {
  const e = pa();
  return [...e.breakpoints.keys].reverse().reduce((n, r) => {
    const i = mht(e.breakpoints.up(r));
    return !n && i ? r : n;
  }, null) || "xs";
}
const yht = ye(GH, { name: "WorkspaceAddButton", slot: "root" })(({ theme: e }) => ({
  marginBottom: e.spacing(1)
}));
function Bfe({
  setWorkspaceAddVisibility: e,
  isWorkspaceAddVisible: t = !1,
  useExtendedFab: n
}) {
  const r = vht(), { t: i } = Ct();
  return /* @__PURE__ */ T.jsx(Bd, { title: i(t ? "closeAddResourceMenu" : "addResource"), children: /* @__PURE__ */ T.jsxs(
    yht,
    {
      size: "medium",
      color: "primary",
      id: "addBtn",
      "aria-label": t ? i("closeAddResourceMenu") : n && r !== "xs" && i("startHere") || i("addResource"),
      variant: n && r !== "xs" ? "extended" : "circular",
      onClick: () => {
        e(!t);
      },
      children: [
        t ? /* @__PURE__ */ T.jsx(m_, {}) : /* @__PURE__ */ T.jsx(jfe, {}),
        n && r !== "xs" && i("startHere")
      ]
    }
  ) });
}
Bfe.propTypes = {
  isWorkspaceAddVisible: c.bool,
  setWorkspaceAddVisibility: c.func.isRequired,
  useExtendedFab: c.bool.isRequired
};
const bht = (e) => ({
  error: tte(e)
}), xht = {
  removeError: zte
}, Sht = wt(
  At(bht, xht),
  Tt("ErrorDialog")
), wht = Sht(cfe), Tht = (e, { width: t }) => {
  const { isWorkspaceAddVisible: n } = Do(e);
  return {
    isWorkspaceAddVisible: n,
    useExtendedFab: !n && Xv(e).length === 0
  };
}, Eht = { setWorkspaceAddVisibility: ND }, _ht = wt(
  At(Tht, Eht),
  Tt("WorkspaceAddButton")
), Cht = _ht(Bfe), Rht = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "m19.44 12.99-.01.02c.04-.33.08-.67.08-1.01s-.03-.66-.07-.99l.01.02 2.44-1.92-2.43-4.22-2.87 1.16.01.01c-.52-.4-1.09-.74-1.71-1h.01L14.44 2H9.57l-.44 3.07h.01c-.62.26-1.19.6-1.71 1l.01-.01-2.88-1.17-2.44 4.22 2.44 1.92.01-.02c-.04.33-.07.65-.07.99s.03.68.08 1.01l-.01-.02-2.1 1.65-.33.26 2.43 4.2 2.88-1.15-.02-.04c.53.41 1.1.75 1.73 1.01h-.03L9.58 22h4.85s.03-.18.06-.42l.38-2.65h-.01c.62-.26 1.2-.6 1.73-1.01l-.02.04 2.88 1.15 2.43-4.2s-.14-.12-.33-.26zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5"
}), "SettingsSharp"), Oht = (e) => ({
  languages: t3(e)
}), Aht = (e, { afterSelect: t }) => ({
  handleClick: (n) => {
    e(P3({ language: n })), t && t();
  }
}), Dht = wt(
  At(Oht, Aht),
  Tt("LanguageSettings")
)(ffe);
function Iht(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "90", viewBox: "0 0 300 225", children: [
    /* @__PURE__ */ T.jsxs("defs", { children: [
      /* @__PURE__ */ T.jsxs("linearGradient", { id: "linear-gradient", x1: "0.5", y1: "1", x2: "0.5", gradientUnits: "objectBoundingBox", children: [
        /* @__PURE__ */ T.jsx("stop", { offset: "0" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.14", stopOpacity: "0.631" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "1", stopOpacity: "0" })
      ] }),
      /* @__PURE__ */ T.jsxs("linearGradient", { id: "linear-gradient-2", x1: "0.5", y1: "1", x2: "0.5", gradientUnits: "objectBoundingBox", children: [
        /* @__PURE__ */ T.jsx("stop", { offset: "0", stopColor: "#fff", stopOpacity: "0" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.23", stopColor: "#fff", stopOpacity: "0.012" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.36", stopColor: "#fff", stopOpacity: "0.039" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.47", stopColor: "#fff", stopOpacity: "0.102" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.57", stopColor: "#fff", stopOpacity: "0.18" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.67", stopColor: "#fff", stopOpacity: "0.278" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.75", stopColor: "#fff", stopOpacity: "0.412" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.83", stopColor: "#fff", stopOpacity: "0.561" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.91", stopColor: "#fff", stopOpacity: "0.741" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.98", stopColor: "#fff", stopOpacity: "0.929" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "1", stopColor: "#fff" })
      ] }),
      /* @__PURE__ */ T.jsx("clipPath", { id: "clip-elastic_icon", children: /* @__PURE__ */ T.jsx("rect", { width: "300", height: "225" }) })
    ] }),
    /* @__PURE__ */ T.jsxs("g", { id: "elastic_icon", "data-name": "elastic icon", clipPath: "url(#clip-elastic_icon)", children: [
      /* @__PURE__ */ T.jsx("rect", { width: "300", height: "225", fill: "#fff" }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_278", "data-name": "Rectangle 278", transform: "translate(232 159)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "54", height: "54", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "53", height: "53", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_8", "data-name": "Rectangle 8", transform: "translate(7 148)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "70", height: "70", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "69", height: "69", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_258", "data-name": "Rectangle 258", transform: "translate(224 6)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "70", height: "100", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "69", height: "99", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_259", "data-name": "Rectangle 259", transform: "translate(71 64)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "115", height: "75", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "114", height: "74", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_260", "data-name": "Rectangle 260", transform: "translate(99 87)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "115", height: "75", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "114", height: "74", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Group_689", "data-name": "Group 689", children: [
        /* @__PURE__ */ T.jsxs("g", { id: "Group_687", "data-name": "Group 687", transform: "translate(0 3)", children: [
          /* @__PURE__ */ T.jsx("path", { id: "checkbox", d: "M258.766,37.316v146.5H39.053V37.316Zm40.07-39.254h-300v225h300Z", transform: "translate(1.164 -1.063)", fill: "#010101", fillRule: "evenodd", opacity: "0.246" }),
          /* @__PURE__ */ T.jsxs("g", { id: "Path_821", "data-name": "Path 821", transform: "translate(40 36)", fill: "none", children: [
            /* @__PURE__ */ T.jsx("path", { d: "M0,0H220V147H0Z", stroke: "none" }),
            /* @__PURE__ */ T.jsx("path", { d: "M 2 2 L 2 145 L 218 145 L 218 2 L 172.9869689941406 2 L 2 2 M 0 0 L 172.9869689941406 0 L 220 0 L 220 147 L 0 147 L 0 0 Z", stroke: "none", fill: "#01579b" })
          ] })
        ] }),
        /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_257", "data-name": "Rectangle 257", transform: "translate(40 39)", fill: "#fff", stroke: "#01579b", strokeWidth: "2", children: [
          /* @__PURE__ */ T.jsx("rect", { width: "20", height: "147", stroke: "none" }),
          /* @__PURE__ */ T.jsx("rect", { x: "1", y: "1", width: "18", height: "145", fill: "none" })
        ] }),
        /* @__PURE__ */ T.jsxs("g", { id: "Group_688", "data-name": "Group 688", transform: "translate(-27.5 -126)", children: [
          /* @__PURE__ */ T.jsx("circle", { id: "teal_circle", "data-name": "teal circle", cx: "7.5", cy: "7.5", r: "7.5", transform: "translate(70 171)", fill: "#009688" }),
          /* @__PURE__ */ T.jsxs("g", { id: "Group_333", "data-name": "Group 333", transform: "translate(70 171)", opacity: "0.12", children: [
            /* @__PURE__ */ T.jsx("path", { id: "gradient_border_2", "data-name": "gradient border 2", d: "M3408,959.089A4.911,4.911,0,1,1,3403.09,964a4.911,4.911,0,0,1,4.911-4.911m0-.089a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z", transform: "translate(-3403 -959)", fill: "url(#linear-gradient)" }),
            /* @__PURE__ */ T.jsx("path", { id: "gradient_border_1", "data-name": "gradient border 1", d: "M3408,959.089A4.911,4.911,0,1,1,3403.09,964a4.911,4.911,0,0,1,4.911-4.911m0-.089a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z", transform: "translate(-3403 -959)", fill: "url(#linear-gradient-2)" })
          ] })
        ] })
      ] })
    ] })
  ] }) });
}
function Pht(e) {
  return /* @__PURE__ */ T.jsx(Ha, { ...e, children: /* @__PURE__ */ T.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "90", viewBox: "0 0 300 225", children: [
    /* @__PURE__ */ T.jsxs("defs", { children: [
      /* @__PURE__ */ T.jsxs("linearGradient", { id: "linear-gradient", x1: "0.5", y1: "1", x2: "0.5", gradientUnits: "objectBoundingBox", children: [
        /* @__PURE__ */ T.jsx("stop", { offset: "0" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.14", stopOpacity: "0.631" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "1", stopOpacity: "0" })
      ] }),
      /* @__PURE__ */ T.jsxs("linearGradient", { id: "linear-gradient-2", x1: "0.5", y1: "1", x2: "0.5", gradientUnits: "objectBoundingBox", children: [
        /* @__PURE__ */ T.jsx("stop", { offset: "0", stopColor: "#fff", stopOpacity: "0" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.23", stopColor: "#fff", stopOpacity: "0.012" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.36", stopColor: "#fff", stopOpacity: "0.039" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.47", stopColor: "#fff", stopOpacity: "0.102" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.57", stopColor: "#fff", stopOpacity: "0.18" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.67", stopColor: "#fff", stopOpacity: "0.278" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.75", stopColor: "#fff", stopOpacity: "0.412" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.83", stopColor: "#fff", stopOpacity: "0.561" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.91", stopColor: "#fff", stopOpacity: "0.741" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "0.98", stopColor: "#fff", stopOpacity: "0.929" }),
        /* @__PURE__ */ T.jsx("stop", { offset: "1", stopColor: "#fff" })
      ] }),
      /* @__PURE__ */ T.jsx("clipPath", { id: "clip-mosaic_icon", children: /* @__PURE__ */ T.jsx("rect", { width: "300", height: "225" }) })
    ] }),
    /* @__PURE__ */ T.jsxs("g", { id: "mosaic_icon", "data-name": "mosaic icon", clipPath: "url(#clip-mosaic_icon)", children: [
      /* @__PURE__ */ T.jsx("rect", { width: "300", height: "225", fill: "#fff" }),
      /* @__PURE__ */ T.jsx("path", { id: "checkbox", d: "M258.766,37.316v146.5H39.053V37.316Zm40.07-39.254h-300v225h300Z", transform: "translate(1.163 1.938)", fill: "#010101", fillRule: "evenodd", opacity: "0.5" }),
      /* @__PURE__ */ T.jsx("path", { id: "checkbox-2", "data-name": "checkbox", d: "M258.766,37.316v146.5H39.053V37.316Zm40.07-39.254h-300v225h300Z", transform: "translate(1.164 1.938)", fill: "#010101", fillRule: "evenodd", opacity: "0.246" }),
      /* @__PURE__ */ T.jsxs("g", { id: "Path_821", "data-name": "Path 821", transform: "translate(40 39)", fill: "none", children: [
        /* @__PURE__ */ T.jsx("path", { d: "M0,0H220V147H0Z", stroke: "none" }),
        /* @__PURE__ */ T.jsx("path", { d: "M 2 2 L 2 145 L 218 145 L 218 2 L 172.9869689941406 2 L 2 2 M 0 0 L 172.9869689941406 0 L 220 0 L 220 147 L 0 147 L 0 0 Z", stroke: "none", fill: "#01579b" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_257", "data-name": "Rectangle 257", transform: "translate(40 39)", fill: "#fff", stroke: "#01579b", strokeWidth: "2", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "20", height: "147", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "1", y: "1", width: "18", height: "145", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Group_688", "data-name": "Group 688", transform: "translate(-27.5 -126)", children: [
        /* @__PURE__ */ T.jsx("circle", { id: "teal_circle", "data-name": "teal circle", cx: "7.5", cy: "7.5", r: "7.5", transform: "translate(70 171)", fill: "#009688" }),
        /* @__PURE__ */ T.jsxs("g", { id: "Group_333", "data-name": "Group 333", transform: "translate(70 171)", opacity: "0.12", children: [
          /* @__PURE__ */ T.jsx("path", { id: "gradient_border_2", "data-name": "gradient border 2", d: "M3408,959.089A4.911,4.911,0,1,1,3403.09,964a4.911,4.911,0,0,1,4.911-4.911m0-.089a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z", transform: "translate(-3403 -959)", fill: "url(#linear-gradient)" }),
          /* @__PURE__ */ T.jsx("path", { id: "gradient_border_1", "data-name": "gradient border 1", d: "M3408,959.089A4.911,4.911,0,1,1,3403.09,964a4.911,4.911,0,0,1,4.911-4.911m0-.089a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z", transform: "translate(-3403 -959)", fill: "url(#linear-gradient-2)" })
        ] })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_270", "data-name": "Rectangle 270", transform: "translate(60 40.647)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "99", height: "72", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "98", height: "71", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_271", "data-name": "Rectangle 271", transform: "translate(159 40.647)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "99", height: "72", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "98", height: "71", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_272", "data-name": "Rectangle 272", transform: "translate(192 112.647)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "66", height: "71.45", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "65", height: "70.45", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_284", "data-name": "Rectangle 284", transform: "translate(60 112.647)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "66", height: "71.45", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "65", height: "70.45", fill: "none" })
      ] }),
      /* @__PURE__ */ T.jsxs("g", { id: "Rectangle_285", "data-name": "Rectangle 285", transform: "translate(126 112.647)", fill: "#88c6c3", stroke: "#707070", strokeWidth: "1", opacity: "0.747", children: [
        /* @__PURE__ */ T.jsx("rect", { width: "66", height: "71.45", stroke: "none" }),
        /* @__PURE__ */ T.jsx("rect", { x: "0.5", y: "0.5", width: "65", height: "70.45", fill: "none" })
      ] })
    ] })
  ] }) });
}
const pJ = ye("div")(() => ({
  display: "flex",
  flexDirection: "column"
}));
function Vfe({
  container: e = null,
  handleClose: t,
  open: n = !1,
  children: r = null,
  updateWorkspace: i,
  workspaceType: o
}) {
  const { t: s } = Ct(), u = uo(), f = (p) => {
    i({
      type: p
    }), t();
  };
  return /* @__PURE__ */ T.jsxs(
    xP,
    {
      "aria-labelledby": u,
      container: e,
      onClose: t,
      open: n,
      children: [
        /* @__PURE__ */ T.jsx(_g, { id: u, children: s("workspaceSelectionTitle") }),
        /* @__PURE__ */ T.jsxs(Cg, { children: [
          r,
          /* @__PURE__ */ T.jsxs(
            tA,
            {
              sx: {
                "&active": {
                  outline: "none"
                },
                "&focus": {
                  outline: "none"
                },
                outline: "none"
              },
              selected: o,
              autoFocusItem: !0,
              children: [
                /* @__PURE__ */ T.jsx(
                  JE,
                  {
                    sx: {
                      height: "auto",
                      overflow: "auto",
                      whiteSpace: "inherit"
                    },
                    onClick: () => f("elastic"),
                    selected: o === "elastic",
                    value: "elastic",
                    children: /* @__PURE__ */ T.jsxs(
                      X4,
                      {
                        sx: {
                          backgroundColor: "transparent",
                          borderRadius: "0",
                          boxShadow: "0 0 transparent",
                          display: "flex"
                        },
                        children: [
                          /* @__PURE__ */ T.jsx(
                            Iht,
                            {
                              sx: {
                                flexShrink: 0,
                                height: "90px",
                                width: "120px"
                              },
                              viewBox: "0 0 120 90"
                            }
                          ),
                          /* @__PURE__ */ T.jsx(pJ, { children: /* @__PURE__ */ T.jsxs(
                            Z4,
                            {
                              sx: {
                                "&.MuiCardContent-root": {
                                  "&:last-child": {
                                    paddingBottom: "12px"
                                  },
                                  paddingBottom: 0,
                                  paddingTop: 0,
                                  textAlign: "left"
                                },
                                flex: "1 0 auto"
                              },
                              children: [
                                /* @__PURE__ */ T.jsx(Zh, { sx: { paddingBottom: "6px" }, component: "p", variant: "h3", children: s("elastic") }),
                                /* @__PURE__ */ T.jsx(Zh, { variant: "body1", children: s("elasticDescription") })
                              ]
                            }
                          ) })
                        ]
                      }
                    )
                  }
                ),
                /* @__PURE__ */ T.jsx(
                  JE,
                  {
                    sx: {
                      height: "auto",
                      overflow: "auto",
                      whiteSpace: "inherit"
                    },
                    onClick: () => f("mosaic"),
                    selected: o === "mosaic",
                    value: "mosaic",
                    children: /* @__PURE__ */ T.jsxs(
                      X4,
                      {
                        sx: {
                          backgroundColor: "transparent",
                          borderRadius: "0",
                          boxShadow: "0 0 transparent",
                          display: "flex"
                        },
                        children: [
                          /* @__PURE__ */ T.jsx(
                            Pht,
                            {
                              sx: {
                                flexShrink: 0,
                                height: "90px",
                                width: "120px"
                              },
                              viewBox: "0 0 120 90"
                            }
                          ),
                          /* @__PURE__ */ T.jsx(pJ, { children: /* @__PURE__ */ T.jsxs(
                            Z4,
                            {
                              sx: {
                                "&.MuiCardContent-root": {
                                  "&:last-child": {
                                    paddingBottom: "12px"
                                  },
                                  paddingBottom: 0,
                                  paddingTop: 0,
                                  textAlign: "left"
                                },
                                flex: "1 0 auto"
                              },
                              children: [
                                /* @__PURE__ */ T.jsx(Zh, { sx: { paddingBottom: "6px" }, component: "p", variant: "h3", children: s("mosaic") }),
                                /* @__PURE__ */ T.jsx(Zh, { variant: "body1", children: s("mosaicDescription") })
                              ]
                            }
                          ) })
                        ]
                      }
                    )
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
Vfe.propTypes = {
  children: c.node,
  container: c.object,
  // eslint-disable-line react/forbid-prop-types
  handleClose: c.func.isRequired,
  open: c.bool,
  updateWorkspace: c.func.isRequired,
  workspaceType: c.string.isRequired
};
const Nht = {
  updateWorkspace: Qte
}, Mht = (e) => ({ workspaceType: F1(e) }), jht = wt(
  At(Mht, Nht),
  Tt("WorkspaceSelectionDialog")
), Lht = jht(Vfe), kht = (e, { windowId: t }) => ({
  setSelectedTheme: (n) => e(P3({ selectedTheme: n }))
}), zht = (e) => ({
  selectedTheme: Dn(e).selectedTheme,
  themeIds: i3(e)
}), Bht = wt(
  At(zht, kht),
  Tt("ChangeThemeDialog")
), Vht = Bht(lfe);
function Ufe({
  handleClose: e,
  showThemePicker: t = !1,
  isWorkspaceAddVisible: n = !1,
  tReady: r = !1,
  toggleZoomControls: i = () => {
  },
  showZoomControls: o = !1,
  ...s
}) {
  const { t: u } = Ct(), f = Qi(Eg), [p, m] = Bn(null), v = arguments[0], y = (w, _) => {
    m(w), e(_);
  }, S = () => {
    m(null);
  }, E = (w) => {
    i(!o), e(w);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(
      Bx,
      {
        container: f == null ? void 0 : f.current,
        anchorOrigin: {
          horizontal: "right",
          vertical: "top"
        },
        transformOrigin: {
          horizontal: "left",
          vertical: "top"
        },
        onClose: e,
        ...s,
        children: [
          /* @__PURE__ */ T.jsx(
            qo,
            {
              "aria-haspopup": "true",
              disabled: n,
              onClick: (w) => {
                E(w);
              },
              "aria-owns": p === "toggleZoom" ? "toggle-zoom-menu" : void 0,
              children: /* @__PURE__ */ T.jsx(St, { variant: "body1", children: u(o ? "hideZoomControls" : "showZoomControls") })
            }
          ),
          /* @__PURE__ */ T.jsx(
            qo,
            {
              "aria-haspopup": "true",
              onClick: (w) => {
                y("workspaceSelection", w);
              },
              "aria-owns": p === "workspaceSelection" ? "workspace-selection" : void 0,
              children: /* @__PURE__ */ T.jsx(St, { variant: "body1", children: u("selectWorkspaceMenu") })
            }
          ),
          /* @__PURE__ */ T.jsx(vfe, { label: u("language"), children: /* @__PURE__ */ T.jsx(Dht, { afterSelect: e }) }),
          t && /* @__PURE__ */ T.jsx(
            qo,
            {
              "aria-haspopup": "true",
              onClick: (w) => {
                y("changeTheme", w);
              },
              "aria-owns": p === "changeTheme" ? "change-theme" : void 0,
              children: /* @__PURE__ */ T.jsx(St, { variant: "body1", children: u("changeTheme") })
            }
          ),
          /* @__PURE__ */ T.jsx(Ki, { targetName: "WorkspaceMenu", ...v })
        ]
      }
    ),
    p === "changeTheme" && /* @__PURE__ */ T.jsx(
      Vht,
      {
        container: f == null ? void 0 : f.current,
        handleClose: S,
        open: p === "changeTheme"
      }
    ),
    p === "workspaceSelection" && /* @__PURE__ */ T.jsx(
      Lht,
      {
        open: p === "workspaceSelection",
        container: f == null ? void 0 : f.current,
        handleClose: S
      }
    )
  ] });
}
Ufe.propTypes = {
  handleClose: c.func.isRequired,
  isWorkspaceAddVisible: c.bool,
  showThemePicker: c.bool,
  showZoomControls: c.bool,
  toggleZoomControls: c.func,
  tReady: c.bool
};
const Uht = {
  toggleZoomControls: Jte
}, Fht = (e) => ({
  isWorkspaceAddVisible: Do(e).isWorkspaceAddVisible,
  showThemePicker: i3(e).length > 0,
  showZoomControls: n3(e)
}), Wht = wt(
  At(Fht, Uht),
  Tt("WorkspaceMenu")
), Hht = Wht(Ufe);
function qht() {
  const { t: e } = Ct(), [t, n] = Bn(null), [r, i] = Bn(!1), o = uo(), s = (f) => {
    n(f.currentTarget), i(!0);
  }, u = () => {
    n(null), i(!1);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-haspopup": "true",
        "aria-label": e("workspaceMenu"),
        "aria-owns": r ? o : void 0,
        selected: r,
        id: "menuBtn",
        onClick: s,
        children: /* @__PURE__ */ T.jsx(Rht, {})
      }
    ),
    /* @__PURE__ */ T.jsx(
      Hht,
      {
        anchorEl: t,
        id: o,
        handleClose: u,
        open: r
      }
    )
  ] });
}
const $ht = wt(
  Tt("WorkspaceMenuButton")
  // further HOC
), Ght = $ht(qht), Yht = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHorizSharp"), Xht = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2M11 16l4-4-4-4v3H1v2h10z"
}), "Input"), Zht = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 12v7H5v-7H3v9h18v-9zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAltSharp");
function Kht(e = {}) {
  const {
    autoHideDuration: t = null,
    disableWindowBlurListener: n = !1,
    onClose: r,
    open: i,
    resumeHideDuration: o
  } = e, s = eg();
  $.useEffect(() => {
    if (!i)
      return;
    function O(D) {
      D.defaultPrevented || D.key === "Escape" && (r == null || r(D, "escapeKeyDown"));
    }
    return document.addEventListener("keydown", O), () => {
      document.removeEventListener("keydown", O);
    };
  }, [i, r]);
  const u = Mr((O, D) => {
    r == null || r(O, D);
  }), f = Mr((O) => {
    !r || O == null || s.start(O, () => {
      u(null, "timeout");
    });
  });
  $.useEffect(() => (i && f(t), s.clear), [i, t, f, s]);
  const p = (O) => {
    r == null || r(O, "clickaway");
  }, m = s.clear, v = $.useCallback(() => {
    t != null && f(o ?? t * 0.5);
  }, [t, o, f]), y = (O) => (D) => {
    const P = O.onBlur;
    P == null || P(D), v();
  }, S = (O) => (D) => {
    const P = O.onFocus;
    P == null || P(D), m();
  }, E = (O) => (D) => {
    const P = O.onMouseEnter;
    P == null || P(D), m();
  }, w = (O) => (D) => {
    const P = O.onMouseLeave;
    P == null || P(D), v();
  };
  return $.useEffect(() => {
    if (!n && i)
      return window.addEventListener("focus", v), window.addEventListener("blur", m), () => {
        window.removeEventListener("focus", v), window.removeEventListener("blur", m);
      };
  }, [n, i, v, m]), {
    getRootProps: (O = {}) => {
      const D = {
        ...op(e),
        ...op(O)
      };
      return {
        // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
        // See https://github.com/mui/material-ui/issues/29080
        role: "presentation",
        ...O,
        ...D,
        onBlur: y(D),
        onFocus: S(D),
        onMouseEnter: E(D),
        onMouseLeave: w(D)
      };
    },
    onClickAway: p
  };
}
var Ffe = {};
function hJ(e) {
  return e.substring(2).toLowerCase();
}
function Qht(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function GA(e) {
  const {
    children: t,
    disableReactTree: n = !1,
    mouseEvent: r = "onClick",
    onClickAway: i,
    touchEvent: o = "onTouchEnd"
  } = e, s = $.useRef(!1), u = $.useRef(null), f = $.useRef(!1), p = $.useRef(!1);
  $.useEffect(() => (setTimeout(() => {
    f.current = !0;
  }, 0), () => {
    f.current = !1;
  }), []);
  const m = kr(Sg(t), u), v = Mr((E) => {
    const w = p.current;
    p.current = !1;
    const _ = Vi(u.current);
    if (!f.current || !u.current || "clientX" in E && Qht(E, _))
      return;
    if (s.current) {
      s.current = !1;
      return;
    }
    let O;
    E.composedPath ? O = E.composedPath().includes(u.current) : O = !_.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      E.target
    ) || u.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      E.target
    ), !O && (n || !w) && i(E);
  }), y = (E) => (w) => {
    p.current = !0;
    const _ = t.props[E];
    _ && _(w);
  }, S = {
    ref: m
  };
  return o !== !1 && (S[o] = y(o)), $.useEffect(() => {
    if (o !== !1) {
      const E = hJ(o), w = Vi(u.current), _ = () => {
        s.current = !0;
      };
      return w.addEventListener(E, v), w.addEventListener("touchmove", _), () => {
        w.removeEventListener(E, v), w.removeEventListener("touchmove", _);
      };
    }
  }, [v, o]), r !== !1 && (S[r] = y(r)), $.useEffect(() => {
    if (r !== !1) {
      const E = hJ(r), w = Vi(u.current);
      return w.addEventListener(E, v), () => {
        w.removeEventListener(E, v);
      };
    }
  }, [v, r]), /* @__PURE__ */ $.cloneElement(t, S);
}
Ffe.NODE_ENV !== "production" && (GA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: xg.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: c.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: c.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: c.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: c.oneOf(["onTouchEnd", "onTouchStart", !1])
});
Ffe.NODE_ENV !== "production" && (GA.propTypes = tF(GA.propTypes));
function Jht(e) {
  return Vt("MuiSnackbarContent", e);
}
Wt("MuiSnackbarContent", ["root", "message", "action"]);
var egt = {};
const tgt = (e) => {
  const {
    classes: t
  } = e;
  return Ft({
    root: ["root"],
    action: ["action"],
    message: ["message"]
  }, Jht, t);
}, ngt = ye(Ei, {
  name: "MuiSnackbarContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Lt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? 0.8 : 0.98, n = Ene(e.palette.background.default, t);
  return {
    ...e.typography.body2,
    color: e.vars ? e.vars.palette.SnackbarContent.color : e.palette.getContrastText(n),
    backgroundColor: e.vars ? e.vars.palette.SnackbarContent.bg : n,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    flexGrow: 1,
    [e.breakpoints.up("sm")]: {
      flexGrow: "initial",
      minWidth: 288
    }
  };
})), rgt = ye("div", {
  name: "MuiSnackbarContent",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0"
}), igt = ye("div", {
  name: "MuiSnackbarContent",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  paddingLeft: 16,
  marginRight: -8
}), Wfe = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiSnackbarContent"
  }), {
    action: i,
    className: o,
    message: s,
    role: u = "alert",
    ...f
  } = r, p = r, m = tgt(p);
  return /* @__PURE__ */ T.jsxs(ngt, {
    role: u,
    square: !0,
    elevation: 6,
    className: yt(m.root, o),
    ownerState: p,
    ref: n,
    ...f,
    children: [/* @__PURE__ */ T.jsx(rgt, {
      className: m.message,
      ownerState: p,
      children: s
    }), i ? /* @__PURE__ */ T.jsx(igt, {
      className: m.action,
      ownerState: p,
      children: i
    }) : null]
  });
});
egt.NODE_ENV !== "production" && (Wfe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The message to display.
   */
  message: c.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
function ogt(e) {
  return Vt("MuiSnackbar", e);
}
Wt("MuiSnackbar", ["root", "anchorOriginTopCenter", "anchorOriginBottomCenter", "anchorOriginTopRight", "anchorOriginBottomRight", "anchorOriginTopLeft", "anchorOriginBottomLeft"]);
var agt = {};
const sgt = (e) => {
  const {
    classes: t,
    anchorOrigin: n
  } = e, r = {
    root: ["root", `anchorOrigin${Ke(n.vertical)}${Ke(n.horizontal)}`]
  };
  return Ft(r, ogt, t);
}, lgt = ye("div", {
  name: "MuiSnackbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`anchorOrigin${Ke(n.anchorOrigin.vertical)}${Ke(n.anchorOrigin.horizontal)}`]];
  }
})(Lt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.snackbar,
  position: "fixed",
  display: "flex",
  left: 8,
  right: 8,
  justifyContent: "center",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top",
    style: {
      top: 8,
      [e.breakpoints.up("sm")]: {
        top: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical !== "top",
    style: {
      bottom: 8,
      [e.breakpoints.up("sm")]: {
        bottom: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "left",
    style: {
      justifyContent: "flex-start",
      [e.breakpoints.up("sm")]: {
        left: 24,
        right: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "right",
    style: {
      justifyContent: "flex-end",
      [e.breakpoints.up("sm")]: {
        right: 24,
        left: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "center",
    style: {
      [e.breakpoints.up("sm")]: {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
      }
    }
  }]
}))), Hfe = /* @__PURE__ */ $.forwardRef(function(t, n) {
  const r = Gt({
    props: t,
    name: "MuiSnackbar"
  }), i = pa(), o = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    action: s,
    anchorOrigin: {
      vertical: u,
      horizontal: f
    } = {
      vertical: "bottom",
      horizontal: "left"
    },
    autoHideDuration: p = null,
    children: m,
    className: v,
    ClickAwayListenerProps: y,
    ContentProps: S,
    disableWindowBlurListener: E = !1,
    message: w,
    onBlur: _,
    onClose: O,
    onFocus: D,
    onMouseEnter: P,
    onMouseLeave: M,
    open: N,
    resumeHideDuration: k,
    slots: U = {},
    slotProps: H = {},
    TransitionComponent: Y,
    transitionDuration: z = o,
    TransitionProps: {
      onEnter: V,
      onExited: F,
      ...X
    } = {},
    ...oe
  } = r, re = {
    ...r,
    anchorOrigin: {
      vertical: u,
      horizontal: f
    },
    autoHideDuration: p,
    disableWindowBlurListener: E,
    TransitionComponent: Y,
    transitionDuration: z
  }, Z = sgt(re), {
    getRootProps: ee,
    onClickAway: J
  } = Kht({
    ...re
  }), [le, be] = $.useState(!0), ne = (ve) => {
    be(!0), F && F(ve);
  }, ae = (ve, rt) => {
    be(!1), V && V(ve, rt);
  }, ie = {
    slots: {
      transition: Y,
      ...U
    },
    slotProps: {
      content: S,
      clickAwayListener: y,
      transition: X,
      ...H
    }
  }, [he, pe] = Xt("root", {
    ref: n,
    className: [Z.root, v],
    elementType: lgt,
    getSlotProps: ee,
    externalForwardedProps: {
      ...ie,
      ...oe
    },
    ownerState: re
  }), [me, {
    ownerState: Ee,
    ...Ie
  }] = Xt("clickAwayListener", {
    elementType: GA,
    externalForwardedProps: ie,
    getSlotProps: (ve) => ({
      onClickAway: (...rt) => {
        var Te;
        (Te = ve.onClickAway) == null || Te.call(ve, ...rt), J(...rt);
      }
    }),
    ownerState: re
  }), [Pe, De] = Xt("content", {
    elementType: Wfe,
    shouldForwardComponentProp: !0,
    externalForwardedProps: ie,
    additionalProps: {
      message: w,
      action: s
    },
    ownerState: re
  }), [Ye, Ue] = Xt("transition", {
    elementType: lx,
    externalForwardedProps: ie,
    getSlotProps: (ve) => ({
      onEnter: (...rt) => {
        var Te;
        (Te = ve.onEnter) == null || Te.call(ve, ...rt), ae(...rt);
      },
      onExited: (...rt) => {
        var Te;
        (Te = ve.onExited) == null || Te.call(ve, ...rt), ne(...rt);
      }
    }),
    additionalProps: {
      appear: !0,
      in: N,
      timeout: z,
      direction: u === "top" ? "down" : "up"
    },
    ownerState: re
  });
  return !N && le ? null : /* @__PURE__ */ T.jsx(me, {
    ...Ie,
    ...U.clickAwayListener && {
      ownerState: Ee
    },
    children: /* @__PURE__ */ T.jsx(he, {
      ...pe,
      children: /* @__PURE__ */ T.jsx(Ye, {
        ...Ue,
        children: m || /* @__PURE__ */ T.jsx(Pe, {
          ...De
        })
      })
    })
  });
});
agt.NODE_ENV !== "production" && (Hfe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: c.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: c.shape({
    horizontal: c.oneOf(["center", "left", "right"]).isRequired,
    vertical: c.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: c.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: c.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   * @deprecated Use `slotProps.clickAwayListener` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ClickAwayListenerProps: c.object,
  /**
   * Props applied to the [`SnackbarContent`](https://mui.com/material-ui/api/snackbar-content/) element.
   * @deprecated Use `slotProps.content` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContentProps: c.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: c.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: c.node,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * @ignore
   */
  onMouseEnter: c.func,
  /**
   * @ignore
   */
  onMouseLeave: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: c.number,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    clickAwayListener: c.oneOfType([c.func, c.shape({
      children: c.element.isRequired,
      disableReactTree: c.bool,
      mouseEvent: c.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
      onClickAway: c.func,
      touchEvent: c.oneOf(["onTouchEnd", "onTouchStart", !1])
    })]),
    content: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    clickAwayListener: c.elementType,
    content: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: c.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object
});
const cgt = Mt(/* @__PURE__ */ T.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
var C2, gJ;
function ugt() {
  return gJ || (gJ = 1, C2 = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
      n.push(e.getRangeAt(r));
    switch (t.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        t.blur();
        break;
      default:
        t = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(i) {
        e.addRange(i);
      }), t && t.focus();
    };
  }), C2;
}
var R2, mJ;
function dgt() {
  if (mJ) return R2;
  mJ = 1;
  var e = ugt(), t = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, n = "Copy to clipboard: #{key}, Enter";
  function r(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function i(o, s) {
    var u, f, p, m, v, y, S = !1;
    s || (s = {}), u = s.debug || !1;
    try {
      p = e(), m = document.createRange(), v = document.getSelection(), y = document.createElement("span"), y.textContent = o, y.ariaHidden = "true", y.style.all = "unset", y.style.position = "fixed", y.style.top = 0, y.style.clip = "rect(0, 0, 0, 0)", y.style.whiteSpace = "pre", y.style.webkitUserSelect = "text", y.style.MozUserSelect = "text", y.style.msUserSelect = "text", y.style.userSelect = "text", y.addEventListener("copy", function(w) {
        if (w.stopPropagation(), s.format)
          if (w.preventDefault(), typeof w.clipboardData > "u") {
            u && console.warn("unable to use e.clipboardData"), u && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var _ = t[s.format] || t.default;
            window.clipboardData.setData(_, o);
          } else
            w.clipboardData.clearData(), w.clipboardData.setData(s.format, o);
        s.onCopy && (w.preventDefault(), s.onCopy(w.clipboardData));
      }), document.body.appendChild(y), m.selectNodeContents(y), v.addRange(m);
      var E = document.execCommand("copy");
      if (!E)
        throw new Error("copy command was unsuccessful");
      S = !0;
    } catch (w) {
      u && console.error("unable to copy using execCommand: ", w), u && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), S = !0;
      } catch (_) {
        u && console.error("unable to copy using clipboardData: ", _), u && console.error("falling back to prompt"), f = r("message" in s ? s.message : n), window.prompt(f, o);
      }
    } finally {
      v && (typeof v.removeRange == "function" ? v.removeRange(m) : v.removeAllRanges()), y && document.body.removeChild(y), p();
    }
    return S;
  }
  return R2 = i, R2;
}
var fgt = dgt();
const pgt = /* @__PURE__ */ Hn(fgt);
function qfe({
  children: e = null,
  container: t = null,
  id: n = void 0,
  open: r = !1,
  handleClose: i,
  exportableState: o
}) {
  const { t: s } = Ct(), [u, f] = Bn(!1), p = uo(), m = Ui(() => JSON.stringify(o, null, 2), [o]), v = Yn(() => {
    pgt(m), f(!0);
  }, [m, f]);
  return u ? /* @__PURE__ */ T.jsx(
    Hfe,
    {
      anchorOrigin: {
        horizontal: "center",
        vertical: "top"
      },
      open: !0,
      autoHideDuration: 6e3,
      onClose: i,
      message: s("exportCopied"),
      action: /* @__PURE__ */ T.jsx(ey, { size: "small", "aria-label": s("dismiss"), color: "inherit", onClick: i, children: /* @__PURE__ */ T.jsx(cgt, { fontSize: "small" }) })
    }
  ) : /* @__PURE__ */ T.jsxs(
    xP,
    {
      "aria-labelledby": p,
      id: n,
      container: t,
      open: r,
      onClose: i,
      scroll: "paper",
      fullWidth: !0,
      maxWidth: "sm",
      children: [
        /* @__PURE__ */ T.jsx(_g, { id: p, children: s("downloadExport") }),
        /* @__PURE__ */ T.jsx(eP, { children: /* @__PURE__ */ T.jsxs(iI, { slotProps: { heading: { component: "h4" } }, elevation: 2, children: [
          /* @__PURE__ */ T.jsx(
            aI,
            {
              expandIcon: /* @__PURE__ */ T.jsx(sI, {}),
              children: /* @__PURE__ */ T.jsx(St, { children: s("viewWorkspaceConfiguration") })
            }
          ),
          /* @__PURE__ */ T.jsxs(oI, { sx: { overflow: "scroll" }, children: [
            e,
            /* @__PURE__ */ T.jsx("pre", { children: m })
          ] })
        ] }) }),
        /* @__PURE__ */ T.jsxs($x, { children: [
          /* @__PURE__ */ T.jsx(hi, { onClick: i, children: s("cancel") }),
          /* @__PURE__ */ T.jsx(hi, { onClick: v, variant: "contained", color: "primary", children: s("copy") })
        ] })
      ]
    }
  );
}
qfe.propTypes = {
  children: c.node,
  container: c.object,
  // eslint-disable-line react/forbid-prop-types
  exportableState: c.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  handleClose: c.func.isRequired,
  id: c.string,
  open: c.bool
};
const hgt = (e) => ({
  exportableState: kee(e)
}), ggt = wt(
  At(hgt, {}),
  Tt("WorkspaceExport")
), mgt = ggt(qfe);
function $fe({
  addError: e,
  id: t = void 0,
  importConfig: n,
  classes: r = {},
  handleClose: i,
  open: o = !1
}) {
  const { t: s } = Ct(), [u, f] = Bn(""), p = uo(), m = (y) => {
    y.preventDefault(), f(y.target.value);
  }, v = (y) => {
    try {
      const S = JSON.parse(u);
      n(S), i();
    } catch (S) {
      e(S.toString());
    }
  };
  return /* @__PURE__ */ T.jsxs(
    xP,
    {
      "aria-labelledby": p,
      id: t,
      onClose: i,
      open: o,
      fullWidth: !0,
      maxWidth: "sm",
      children: [
        /* @__PURE__ */ T.jsx(_g, { id: p, children: s("importWorkspace") }),
        /* @__PURE__ */ T.jsx(Cg, { children: /* @__PURE__ */ T.jsx(
          Mhe,
          {
            className: r.textField,
            id: "workspace-import-input",
            multiline: !0,
            onChange: m,
            minRows: 15,
            variant: "filled",
            sx: {
              "& .MuiInputBase-input": { fontFamily: "monospace" },
              width: "100%"
            },
            inputProps: { autoFocus: "autofocus" },
            helperText: s("importWorkspaceHint")
          }
        ) }),
        /* @__PURE__ */ T.jsxs(dU, { children: [
          /* @__PURE__ */ T.jsx(hi, { onClick: i, children: s("cancel") }),
          /* @__PURE__ */ T.jsx(hi, { color: "primary", onClick: v, variant: "contained", children: s("import") })
        ] })
      ]
    }
  );
}
$fe.propTypes = {
  addError: c.func.isRequired,
  classes: c.objectOf(c.string),
  handleClose: c.func.isRequired,
  id: c.string,
  importConfig: c.func.isRequired,
  open: c.bool
};
const vgt = {
  addError: kte,
  importConfig: Lte
}, ygt = wt(
  At(null, vgt),
  Tt("WorkspaceImport")
), bgt = ygt($fe);
function Gfe({
  anchorEl: e = null,
  handleClose: t,
  open: n = !1,
  ...r
}) {
  const { t: i } = Ct(), o = Qi(Eg), [s, u] = Bn(null), f = uo(), p = uo(), m = {
    anchorEl: e,
    container: o,
    handleClose: t,
    open: n,
    t: i,
    ...r
  }, v = (S) => {
    u(S), t();
  }, y = () => {
    u(null);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(
      Bx,
      {
        id: "workspace-options-menu",
        container: o == null ? void 0 : o.current,
        anchorEl: e,
        anchorOrigin: {
          horizontal: "right",
          vertical: "top"
        },
        transformOrigin: {
          horizontal: "left",
          vertical: "top"
        },
        open: n,
        onClose: t,
        children: [
          /* @__PURE__ */ T.jsxs(
            qo,
            {
              "aria-haspopup": "true",
              onClick: () => {
                v("exportWorkspace");
              },
              "aria-owns": s === "exportWorkspace" ? f : void 0,
              children: [
                /* @__PURE__ */ T.jsx(Bv, { children: /* @__PURE__ */ T.jsx(Zht, {}) }),
                /* @__PURE__ */ T.jsx(St, { variant: "body1", children: i("downloadExportWorkspace") })
              ]
            }
          ),
          /* @__PURE__ */ T.jsxs(
            qo,
            {
              "aria-haspopup": "true",
              onClick: () => {
                v("importWorkspace");
              },
              "aria-owns": s === "importWorkspace" ? p : void 0,
              children: [
                /* @__PURE__ */ T.jsx(Bv, { children: /* @__PURE__ */ T.jsx(Xht, {}) }),
                /* @__PURE__ */ T.jsx(St, { variant: "body1", children: i("importWorkspace") })
              ]
            }
          ),
          /* @__PURE__ */ T.jsx(Ki, { targetName: "WorkspaceOptionsMenu", ...m })
        ]
      }
    ),
    s === "exportWorkspace" && /* @__PURE__ */ T.jsx(
      mgt,
      {
        id: f,
        open: s === "exportWorkspace",
        container: o == null ? void 0 : o.current,
        handleClose: y
      }
    ),
    s === "importWorkspace" && /* @__PURE__ */ T.jsx(
      bgt,
      {
        id: p,
        open: s === "importWorkspace",
        container: o == null ? void 0 : o.current,
        handleClose: y
      }
    )
  ] });
}
Gfe.propTypes = {
  anchorEl: c.object,
  // eslint-disable-line react/forbid-prop-types
  handleClose: c.func.isRequired,
  open: c.bool
};
function xgt() {
  const { t: e } = Ct(), [t, n] = Bn(null), [r, i] = Bn(!1), o = (u) => {
    n(u.currentTarget), i(!0);
  }, s = () => {
    n(null), i(!1);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      Jn,
      {
        "aria-label": e("workspaceOptions"),
        onClick: o,
        selected: r,
        children: /* @__PURE__ */ T.jsx(Yht, {})
      }
    ),
    /* @__PURE__ */ T.jsx(
      Gfe,
      {
        anchorEl: t,
        handleClose: s,
        open: r
      }
    )
  ] });
}
const Sgt = wt(
  Tt("WorkspaceOptionsButton")
), wgt = Sgt(xgt), Tgt = (e) => ({
  disabled: Do(e).isWorkspaceAddVisible,
  windowCount: Xv(e).length
}), Egt = wt(
  At(Tgt, null),
  Tt("WindowListButton")
), _gt = Egt(Ofe);
function Cgt({ ...e }) {
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(_gt, {}),
    /* @__PURE__ */ T.jsx(Ght, {}),
    /* @__PURE__ */ T.jsx(wgt, {}),
    /* @__PURE__ */ T.jsx(XW, {}),
    /* @__PURE__ */ T.jsx(Ki, { targetName: "WorkspaceControlPanelButtons", ...e })
  ] });
}
const Rgt = wt(
  Tt("WorkspaceControlPanelButtons")
), Ogt = Rgt(Cgt), Agt = Tt("Branding")(sfe), Dgt = ye(Yx, { name: "WorkspaceControlPanel", slot: "root" })(({ ownerState: e, theme: t }) => ({
  display: "flex",
  height: 64,
  padding: t.spacing(1),
  paddingBottom: 0,
  position: "relative",
  [t.breakpoints.up("sm")]: {
    height: "auto",
    width: e.variant === "wide" ? "auto" : 64
  },
  ...e.variant === "wide" && {
    width: "auto"
  }
})), Igt = ye(ny, { name: "WorkspaceControlPanel", slot: "toolbar" })(({ theme: e }) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "space-between",
  [e.breakpoints.up("sm")]: {
    flexDirection: "column",
    justifyContent: "flex-start",
    minHeight: 0
  }
})), Pgt = ye("div", { name: "WorkspaceControlPanel", slot: "buttonArea" })(({ theme: e }) => ({
  [e.breakpoints.up("sm")]: {
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(2),
    marginBottom: e.spacing(1),
    marginTop: e.spacing(1)
  }
})), Ngt = ye(Agt, { name: "WorkspaceControlPanel", slot: "branding" })(({ theme: e }) => ({
  [e.breakpoints.up("xs")]: {
    display: "none"
  },
  [e.breakpoints.up("sm")]: {
    display: "flex"
  }
}));
function Yfe({ variant: e = "default", ...t }) {
  const { t: n } = Ct();
  return /* @__PURE__ */ T.jsxs(
    Dgt,
    {
      ownerState: { t: n, variant: e, ...t },
      className: On(Nt("workspace-control-panel")),
      color: "default",
      enableColorOnDark: !0,
      position: "absolute",
      component: "nav",
      "aria-label": n("workspaceNavigation"),
      children: [
        /* @__PURE__ */ T.jsxs(
          Igt,
          {
            disableGutters: !0,
            children: [
              /* @__PURE__ */ T.jsx(Cht, {}),
              /* @__PURE__ */ T.jsx(Pgt, { children: /* @__PURE__ */ T.jsx(Ogt, {}) })
            ]
          }
        ),
        /* @__PURE__ */ T.jsx(Ngt, { variant: e })
      ]
    }
  );
}
Yfe.propTypes = {
  variant: c.oneOf(["default", "wide"])
};
const Mgt = wt(
  Tt("WorkspaceControlPanel")
  // further HOC go here
), jgt = Mgt(Yfe), Lgt = (e) => ({
  allowNewWindows: Dn(e).workspace.allowNewWindows,
  maximizedWindowIds: rte(e),
  windowIds: Xv(e),
  workspaceId: Do(e).id,
  workspaceType: F1(e)
}), kgt = {
  addWindow: r_
}, zgt = wt(
  At(Lgt, kgt),
  Tt("Workspace")
  // further HOC go here
), Bgt = zgt(Mfe), Vgt = (e) => ({ catalog: Pee(e) }), Ugt = {
  addResource: q3,
  setWorkspaceAddVisibility: ND
}, Fgt = wt(
  At(Vgt, Ugt),
  Tt("WorkspaceAdd")
), Wgt = Fgt(Lfe), Hgt = Tt("BackgroundPluginArea")(Nft), qgt = ye("div", { name: "WorkspaceArea", slot: "root" })(({ theme: e }) => ({
  background: whe(e.palette.shades.light, 0.1),
  ...e.applyStyles("dark", {
    background: The(e.palette.shades.light, 0.1)
  }),
  bottom: 0,
  display: "flex",
  flexDirection: "column",
  left: 0,
  position: "absolute",
  right: 0,
  top: 0,
  [e.breakpoints.up("sm")]: {
    flexDirection: "row"
  }
})), $gt = ye("main", { name: "WorkspaceArea", slot: "viewer" })(() => ({
  flexGrow: 1,
  position: "relative"
}));
function Xfe({
  areaRef: e = null,
  controlPanelVariant: t = void 0,
  isWorkspaceAddVisible: n = !1,
  isWorkspaceControlPanelVisible: r,
  lang: i = void 0
}) {
  const { t: o } = Ct(), s = arguments[0];
  return /* @__PURE__ */ T.jsxs(qgt, { ownerState: s, children: [
    r && /* @__PURE__ */ T.jsx(jgt, { variant: t }),
    /* @__PURE__ */ T.jsxs(
      $gt,
      {
        className: Nt("viewer"),
        lang: i,
        "aria-label": o("workspace"),
        ...e ? { ref: e } : {},
        children: [
          n ? /* @__PURE__ */ T.jsx(Wgt, {}) : /* @__PURE__ */ T.jsx(Bgt, {}),
          /* @__PURE__ */ T.jsx(wht, {}),
          /* @__PURE__ */ T.jsx(Hgt, {})
        ]
      }
    )
  ] });
}
Xfe.propTypes = {
  areaRef: c.shape({ current: c.instanceOf(Element) }),
  controlPanelVariant: c.string,
  isWorkspaceAddVisible: c.bool,
  isWorkspaceControlPanelVisible: c.bool.isRequired,
  lang: c.string
};
const Ggt = (e, { windowId: t }) => ({
  audioOptions: Dn(e).audioOptions,
  audioResources: xD(e, { windowId: t }) || [],
  captions: G1(e, { windowId: t }) || []
}), Ygt = wt(
  At(Ggt, null),
  Tt("AudioViewer")
), Xgt = Ygt(afe), Zgt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xgt
}, Symbol.toStringTag, { value: "Module" })), Kgt = (e, { windowId: t }) => ({
  canvases: Fa(e, { windowId: t }),
  viewingDirection: Ix(e, { windowId: t })
}), Qgt = wt(
  At(Kgt),
  Tt("GalleryView")
  // further HOC go here
), Jgt = Qgt(dfe), emt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jgt
}, Symbol.toStringTag, { value: "Module" })), tmt = (e, { windowId: t }) => {
  const n = D3(e, { windowId: t }), r = Px(e), i = vn(n.canvases.map((o) => o.imageServiceIds));
  return {
    canvasWorld: n,
    drawAnnotations: Dn(e).window.forceDrawAnnotations || ox(e, { content: "annotations", windowId: t }).length > 0 || ox(e, { content: "search", windowId: t }).length > 0,
    infoResponses: i.map((o) => r[o]).filter((o) => o !== void 0 && o.isFetching === !1 && o.error === void 0),
    label: yg(e, {
      canvasId: (Vl(e, { windowId: t }) || {}).id,
      windowId: t
    }),
    nonTiledImages: cte(e, { windowId: t }),
    osdConfig: Dn(e).osdConfig,
    viewerConfig: hD(e, { windowId: t })
  };
}, nmt = {
  updateViewport: j3
}, rmt = wt(
  At(tmt, nmt),
  Tt("OpenSeadragonViewer")
), imt = rmt(xfe), omt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: imt
}, Symbol.toStringTag, { value: "Module" })), amt = (e, { windowId: t }) => {
  const { collectionPath: n, manifestId: r } = Wn(e, { windowId: t }) || {};
  return {
    collectionPath: n,
    manifestId: r
  };
}, smt = {
  showCollectionDialog: i_
}, lmt = wt(
  At(amt, smt),
  Tt("SelectCollection")
), cmt = lmt(Sfe), umt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cmt
}, Symbol.toStringTag, { value: "Module" })), dmt = (e, { windowId: t }) => ({
  textOptions: Dn(e).textOptions,
  textResources: yD(e, { windowId: t }) || []
}), fmt = wt(
  At(dmt, null),
  Tt("TextViewer")
  // further HOC go here
), pmt = fmt(Cfe), hmt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pmt
}, Symbol.toStringTag, { value: "Module" })), gmt = (e, { windowId: t }) => ({
  captions: G1(e, { windowId: t }) || [],
  videoOptions: Dn(e).videoOptions,
  videoResources: bD(e, { windowId: t }) || []
}), mmt = wt(
  At(gmt, null),
  Tt("VideoViewer")
), vmt = mmt(Lce), ymt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vmt
}, Symbol.toStringTag, { value: "Module" })), bmt = wt(
  Tt("WindowViewer")
  // further HOC go here
), xmt = bmt(Afe), Smt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xmt
}, Symbol.toStringTag, { value: "Module" })), wmt = (e) => ({
  controlPanelVariant: Do(e).isWorkspaceAddVisible || Xv(e).length > 0 ? void 0 : "wide",
  isWorkspaceAddVisible: Do(e).isWorkspaceAddVisible,
  isWorkspaceControlPanelVisible: Dn(e).workspaceControlPanel.enabled,
  lang: Dn(e).language
}), Tmt = wt(
  At(wmt),
  Tt("WorkspaceArea")
), Emt = Tmt(Xfe), _mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Emt
}, Symbol.toStringTag, { value: "Module" })), $mt = {
  ...f4e,
  ...p4e,
  culPlugins: Lrt
};
export {
  Zde as AccessTokenSender,
  Ce as ActionTypes,
  _ee as AnnotationFactory,
  gye as AnnotationItem,
  Eee as AnnotationList,
  mye as AnnotationPage,
  hye as AnnotationResource,
  Are as AnnotationSettings,
  ofe as AnnotationsOverlay,
  yse as App,
  vse as AppProviders,
  Gie as AttributionPanel,
  afe as AudioViewer,
  Nft as BackgroundPluginArea,
  u$e as BookViewIcon,
  sfe as Branding,
  ife as CanvasAnnotationDisplay,
  Vre as CanvasAnnotations,
  Zye as CanvasGroupings,
  Pce as CanvasIndexIcon,
  Gre as CanvasInfo,
  Oae as CanvasLayers,
  OD as CanvasWorld,
  lfe as ChangeThemeDialog,
  iy as CollapsibleSection,
  Ude as CollectionDialog,
  uie as CollectionInfo,
  Bde as CompanionArea,
  xF as CompanionWindow,
  zde as CompanionWindowFactory,
  wV as CompanionWindowRegistry,
  _v as CompanionWindowSection,
  G1e as ConnectedAnnotationSettings,
  ept as ConnectedAnnotationsOverlay,
  UFe as ConnectedAppProviders,
  aPe as ConnectedAttributionPanel,
  Xgt as ConnectedAudioViewer,
  Hgt as ConnectedBackgroundPluginArea,
  Agt as ConnectedBranding,
  eCe as ConnectedCanvasAnnotations,
  mRe as ConnectedCanvasInfo,
  h2e as ConnectedCanvasLayers,
  Vht as ConnectedChangeThemeDialog,
  iy as ConnectedCollapsibleSection,
  Pdt as ConnectedCollectionDialog,
  hAe as ConnectedCollectionInfo,
  QE as ConnectedCompanionArea,
  Zd as ConnectedCompanionWindow,
  bdt as ConnectedCompanionWindowFactory,
  x2e as ConnectedCustomPanel,
  rU as ConnectedErrorContent,
  wht as ConnectedErrorDialog,
  XW as ConnectedFullScreenButton,
  Jgt as ConnectedGalleryView,
  Fft as ConnectedGalleryViewThumbnail,
  Kdt as ConnectedIIIFAuthentication,
  jx as ConnectedIIIFThumbnail,
  Dht as ConnectedLanguageSettings,
  v2e as ConnectedLayersPanel,
  aie as ConnectedLocalePicker,
  aht as ConnectedManifestForm,
  lie as ConnectedManifestInfo,
  uht as ConnectedManifestListItem,
  oce as ConnectedManifestListItemError,
  EAe as ConnectedManifestRelatedLinks,
  Yde as ConnectedMinimalWindow,
  Jn as ConnectedMiradorMenuButton,
  kpt as ConnectedMosaicRenderPreview,
  imt as ConnectedOpenSeadragonViewer,
  Bdt as ConnectedPrimaryWindow,
  Bs as ConnectedSanitizedHtml,
  Cg as ConnectedScrollIndicatedDialogContent,
  z7 as ConnectedSearchHit,
  jNe as ConnectedSearchPanel,
  rNe as ConnectedSearchPanelControls,
  QPe as ConnectedSearchPanelNavigation,
  INe as ConnectedSearchResults,
  cmt as ConnectedSelectCollection,
  tDe as ConnectedSidebarIndexItem,
  uDe as ConnectedSidebarIndexList,
  LIe as ConnectedSidebarIndexTableOfContents,
  iDe as ConnectedSidebarIndexThumbnail,
  pmt as ConnectedTextViewer,
  fTe as ConnectedThumbnailCanvasGrouping,
  mTe as ConnectedThumbnailNavigation,
  vmt as ConnectedVideoViewer,
  oJ as ConnectedViewerInfo,
  ypt as ConnectedViewerNavigation,
  $A as ConnectedWindow,
  p2 as ConnectedWindowAuthenticationBar,
  _fe as ConnectedWindowCanvasNavigationControls,
  Opt as ConnectedWindowList,
  _gt as ConnectedWindowListButton,
  udt as ConnectedWindowSideBar,
  qCe as ConnectedWindowSideBarAnnotationsPanel,
  odt as ConnectedWindowSideBarButtons,
  UIe as ConnectedWindowSideBarCanvasPanel,
  _2e as ConnectedWindowSideBarCollectionPanel,
  OAe as ConnectedWindowSideBarInfoPanel,
  s$e as ConnectedWindowThumbnailSettings,
  Fut as ConnectedWindowTopBar,
  wce as ConnectedWindowTopBarPluginArea,
  Ece as ConnectedWindowTopBarPluginMenu,
  Lut as ConnectedWindowTopBarTitle,
  S$e as ConnectedWindowTopMenu,
  Sce as ConnectedWindowTopMenuButton,
  v$e as ConnectedWindowViewSettings,
  xmt as ConnectedWindowViewer,
  Bgt as ConnectedWorkspace,
  Wgt as ConnectedWorkspaceAdd,
  Cht as ConnectedWorkspaceAddButton,
  Emt as ConnectedWorkspaceArea,
  jgt as ConnectedWorkspaceControlPanel,
  Ogt as ConnectedWorkspaceControlPanelButtons,
  Jpt as ConnectedWorkspaceElastic,
  fft as ConnectedWorkspaceElasticWindow,
  mgt as ConnectedWorkspaceExport,
  bgt as ConnectedWorkspaceImport,
  Hht as ConnectedWorkspaceMenu,
  Ght as ConnectedWorkspaceMenuButton,
  Xpt as ConnectedWorkspaceMosaic,
  wgt as ConnectedWorkspaceOptionsButton,
  Gfe as ConnectedWorkspaceOptionsMenu,
  Lht as ConnectedWorkspaceSelectionDialog,
  dpt as ConnectedZoomControls,
  Dae as CustomPanel,
  Io as EMPTY_ARRAY,
  qs as EMPTY_OBJECT,
  kde as ErrorContent,
  cfe as ErrorDialog,
  _ce as FullScreenButton,
  pse as FullScreenContext,
  dfe as GalleryView,
  d$e as GalleryViewIcon,
  ufe as GalleryViewThumbnail,
  Jde as IIIFAuthentication,
  $H as IIIFDropTarget,
  Xde as IIIFIFrameCommunication,
  ure as IIIFThumbnail,
  v_ as LabelValueMetadata,
  ffe as LanguageSettings,
  Aae as LayersPanel,
  aie as LocalePicker,
  pfe as ManifestForm,
  sie as ManifestInfo,
  hfe as ManifestListItem,
  ice as ManifestListItemError,
  die as ManifestRelatedLinks,
  Gde as MinimalWindow,
  Ox as MiradorCanvas,
  Mft as MiradorIcon,
  Iee as MiradorManifest,
  Lx as MiradorMenuButton,
  u4e as MiradorViewer,
  Upt as MosaicLayout,
  gfe as MosaicRenderPreview,
  vfe as NestedMenu,
  Kde as NewBrowserWindow,
  tpt as OSDReferences,
  Dft as OpenSeadragonCanvasOverlay,
  xfe as OpenSeadragonViewer,
  bU as PluginContext,
  Ki as PluginHook,
  Pae as PluginProvider,
  $de as PrimaryWindow,
  apt as RestoreZoomIcon,
  Bs as SanitizedHtml,
  Cg as ScrollIndicatedDialogContent,
  zx as ScrollTo,
  roe as SearchHit,
  ooe as SearchPanel,
  eoe as SearchPanelControls,
  Jie as SearchPanelNavigation,
  ioe as SearchResults,
  Sfe as SelectCollection,
  gie as SidebarIndexItem,
  vie as SidebarIndexList,
  Hie as SidebarIndexTableOfContents,
  mie as SidebarIndexThumbnail,
  Cfe as TextViewer,
  dre as ThumbnailCanvasGrouping,
  wv as ThumbnailFactory,
  fre as ThumbnailNavigation,
  t$e as ThumbnailNavigationBottomIcon,
  n$e as ThumbnailNavigationRightIcon,
  xNe as TruncatedHit,
  Lce as VideoViewer,
  Tfe as ViewerInfo,
  Efe as ViewerNavigation,
  tfe as Window,
  Qde as WindowAuthenticationBar,
  SP as WindowCanvasNavigationControls,
  Rfe as WindowList,
  Ofe as WindowListButton,
  Cce as WindowMaxIcon,
  Rce as WindowMinIcon,
  w$e as WindowOptionsIcon,
  Lde as WindowSideBar,
  $re as WindowSideBarAnnotationsPanel,
  jde as WindowSideBarButtons,
  qie as WindowSideBarCanvasPanel,
  Iae as WindowSideBarCollectionPanel,
  fie as WindowSideBarInfoPanel,
  mce as WindowThumbnailSettings,
  Ide as WindowTopBar,
  E$e as WindowTopBarPluginArea,
  Tce as WindowTopBarPluginMenu,
  Dde as WindowTopBarTitle,
  bce as WindowTopMenu,
  xce as WindowTopMenuButton,
  vce as WindowViewSettings,
  Afe as WindowViewer,
  Mfe as Workspace,
  Lfe as WorkspaceAdd,
  Bfe as WorkspaceAddButton,
  Xfe as WorkspaceArea,
  Eg as WorkspaceContext,
  Yfe as WorkspaceControlPanel,
  Cgt as WorkspaceControlPanelButtons,
  xP as WorkspaceDialog,
  rfe as WorkspaceElastic,
  nfe as WorkspaceElasticWindow,
  qfe as WorkspaceExport,
  $fe as WorkspaceImport,
  Ufe as WorkspaceMenu,
  qht as WorkspaceMenuButton,
  Ife as WorkspaceMosaic,
  xgt as WorkspaceOptionsButton,
  Gfe as WorkspaceOptionsMenu,
  Vfe as WorkspaceSelectionDialog,
  Iht as WorkspaceTypeElasticIcon,
  Pht as WorkspaceTypeMosaicIcon,
  wfe as ZoomControls,
  ule as accessTokensReducer,
  U3 as addAuthenticationRequest,
  Ite as addCompanionWindow,
  kte as addError,
  I3 as addOrUpdateCompanionWindow,
  O2e as addPluginsToCompanionWindowsRegistry,
  q3 as addResource,
  r_ as addWindow,
  xle as annotationsReducer,
  hs as asArray,
  Sle as authReducer,
  _le as catalogReducer,
  fle as companionWindowsReducer,
  yle as configReducer,
  R2e as connectPluginsToStore,
  c4e as createPluggableStore,
  Ple as createStore,
  C2e as createTargetToPluginMapping,
  $mt as default,
  B3 as deselectAnnotation,
  wle as elasticLayoutReducer,
  ple as errorsReducer,
  Mte as expandNodes,
  Kte as fetchInfoResponse,
  DD as fetchManifest,
  bne as fetchProbeResponse,
  o_ as fetchSearch,
  Sse as filterValidPlugins,
  n_ as focusWindow,
  e_ as getAccessTokens,
  ite as getAllowedWindowViewTypes,
  wD as getAnnotationResourcesByMotivation,
  fte as getAnnotationResourcesByMotivationForCanvas,
  SD as getAnnotations,
  t_ as getAuth,
  RD as getAuthProfiles,
  xbe as getBestThumbnail,
  Yd as getCanvas,
  lte as getCanvasDescription,
  vte as getCanvasForAnnotation,
  g3 as getCanvasGrouping,
  H1 as getCanvasGroupings,
  u3 as getCanvasIndex,
  yg as getCanvasLabel,
  Cte as getCanvasLayers,
  Fa as getCanvases,
  Pee as getCatalog,
  jee as getCompanionAreaVisibility,
  ju as getCompanionWindow,
  gD as getCompanionWindowIdsForPosition,
  KU as getCompanionWindowLocale,
  k1 as getCompanionWindows,
  ox as getCompanionWindowsForContent,
  e3 as getCompanionWindowsForPosition,
  Dn as getConfig,
  uWe as getConfigFromPlugins,
  Du as getContainerId,
  Vl as getCurrentCanvas,
  D3 as getCurrentCanvasWorld,
  R3 as getDefaultSidebarVariant,
  l3 as getDestructuredMetadata,
  vD as getElasticLayout,
  Ete as getExpandedNodeIds,
  kee as getExportableState,
  f3 as getFocusedWindowId,
  Cbe as getFullScreenEnabled,
  Vee as getIiifThumbnailOpts,
  t3 as getLanguagesFromConfigWithCurrent,
  tte as getLatestError,
  A3 as getLayers,
  Ote as getLayersForVisibleCanvases,
  O3 as getLayersForWindow,
  z1 as getLocale,
  Va as getManifest,
  ete as getManifestAutocompleteService,
  Zee as getManifestDescription,
  Fee as getManifestError,
  qee as getManifestHomepage,
  Oi as getManifestLocale,
  o3 as getManifestLogo,
  Qee as getManifestMetadata,
  Wee as getManifestProviderName,
  Gee as getManifestRelated,
  Ebe as getManifestRelatedContent,
  $ee as getManifestRenderings,
  Dx as getManifestSearchService,
  a3 as getManifestSeeAlso,
  ax as getManifestStatus,
  Kee as getManifestSummary,
  Xee as getManifestThumbnail,
  Lu as getManifestTitle,
  B1 as getManifestUrl,
  nr as getManifestoInstance,
  L1 as getManifests,
  Mv as getManuallyExpandedNodeIds,
  rte as getMaximizedWindowsIds,
  Jee as getMetadataLocales,
  Ho as getMiradorCanvasWrapper,
  XU as getMiradorManifestWrapper,
  q1 as getNextCanvasGrouping,
  pte as getNextSearchId,
  _te as getNodeIdToScrollTo,
  Y1 as getPresentAnnotationsOnSelectedCanvases,
  $1 as getPreviousCanvasGrouping,
  Hee as getProviderLogo,
  cWe as getReducersFromPlugins,
  zee as getRequestsConfig,
  Yee as getRequiredStatement,
  T3 as getResourceAnnotationForSearchHit,
  mte as getResourceAnnotationLabel,
  s3 as getRights,
  dWe as getSagasFromPlugins,
  Q1 as getSearchAnnotationsForCompanionWindow,
  ED as getSearchAnnotationsForWindow,
  TD as getSearchForWindow,
  b3 as getSearchIsFetching,
  x3 as getSearchNumTotal,
  K1 as getSearchQuery,
  X1 as getSelectedAnnotationId,
  Pbe as getSelectedAnnotationsOnCanvases,
  _D as getSelectedContentSearchAnnotationIds,
  Gd as getSequence,
  V1 as getSequenceBehaviors,
  U1 as getSequenceTreeStructure,
  Ix as getSequenceViewingDirection,
  d3 as getSequenceViewingHint,
  c3 as getSequences,
  n3 as getShowZoomControlsConfig,
  Rte as getSortedLayers,
  w3 as getSortedSearchAnnotationsForCompanionWindow,
  S3 as getSortedSearchHitsForCompanionWindow,
  r3 as getTheme,
  Ax as getThemeDirection,
  i3 as getThemeIds,
  mD as getThumbnailFactory,
  QU as getThumbnailNavigationPosition,
  Bee as getThumbnailsConfig,
  hD as getViewer,
  xD as getVisibleCanvasAudioResources,
  G1 as getVisibleCanvasCaptions,
  ku as getVisibleCanvasIds,
  cte as getVisibleCanvasNonTiledResources,
  yD as getVisibleCanvasTextResources,
  bD as getVisibleCanvasVideoResources,
  Ul as getVisibleCanvases,
  C3 as getVisibleNodeIds,
  Wn as getWindow,
  fa as getWindowConfig,
  ote as getWindowDraggability,
  Xv as getWindowIds,
  ZU as getWindowManifests,
  nte as getWindowTitles,
  Nv as getWindowViewType,
  vg as getWindows,
  Do as getWorkspace,
  F1 as getWorkspaceType,
  rJ as handleDrop,
  Hte as hideCollectionDialog,
  V3 as hoverAnnotation,
  G_e as htmlRules,
  jte as importConfig,
  Lte as importMiradorState,
  vle as infoResponsesReducer,
  p3 as isFocused,
  Ele as layersReducer,
  mle as manifestsReducer,
  Bte as maximizeWindow,
  Vte as minimizeWindow,
  fo as miradorSlice,
  Cle as probeResponsesReducer,
  qft as readImageMetadata,
  one as receiveAccessToken,
  ane as receiveAccessTokenFailure,
  z3 as receiveAnnotation,
  rne as receiveAnnotationFailure,
  Xte as receiveDegradedInfoResponse,
  vne as receiveDegradedProbeResponse,
  Yte as receiveInfoResponse,
  Zte as receiveInfoResponseFailure,
  AD as receiveManifest,
  $te as receiveManifestFailure,
  mne as receiveProbeResponse,
  yne as receiveProbeResponseFailure,
  cne as receiveSearch,
  une as receiveSearchFailure,
  Pte as removeCompanionWindow,
  zte as removeError,
  Jbe as removeInfoResponse,
  Qbe as removeManifest,
  e0e as removeProbeResponse,
  hne as removeResource,
  dne as removeSearch,
  N3 as removeWindow,
  F3 as requestAccessToken,
  U2 as requestAnnotation,
  k3 as requestCanvasAnnotations,
  Gte as requestInfoResponse,
  qte as requestManifest,
  gne as requestProbeResponse,
  lne as requestSearch,
  W3 as resetAuthenticationState,
  sne as resolveAccessTokenRequest,
  MD as resolveAuthenticationRequest,
  E5e as rootReducer,
  Ile as rootSaga,
  Tle as searchesReducer,
  Kv as selectAnnotation,
  Lee as selectCompanionWindowDimensions,
  Ate as selectCurrentAuthServices,
  v3 as selectInfoResponse,
  Px as selectInfoResponses,
  ute as selectProbeResponse,
  Zv as selectProbeResponses,
  Iu as setCanvas,
  Ute as setCompanionAreaOpen,
  Kbe as setConfig,
  fne as setContentSearchCurrentAnnotation,
  ID as setNextCanvas,
  PD as setPreviousCanvas,
  Wte as setWindowThumbnailPosition,
  M3 as setWindowViewType,
  ND as setWorkspaceAddVisibility,
  tne as setWorkspaceViewportDimensions,
  L3 as setWorkspaceViewportPosition,
  Pv as settings,
  i_ as showCollectionDialog,
  gte as sortSearchAnnotationsByCanvasOrder,
  ine as toggleAnnotationDisplay,
  nne as toggleDraggingEnabled,
  Nte as toggleNode,
  Fte as toggleWindowSideBar,
  Jte as toggleZoomControls,
  Nx as updateCompanionWindow,
  P3 as updateConfig,
  H3 as updateElasticWindowLayout,
  pne as updateLayers,
  j3 as updateViewport,
  Po as updateWindow,
  Qte as updateWorkspace,
  ene as updateWorkspaceMosaicLayout,
  Xmt as useTranslation,
  DX as validatePlugin,
  d4e as viewer,
  ble as viewersReducer,
  gle as windowsReducer,
  Tt as withPlugins,
  Zmt as withTranslation,
  hle as workspaceReducer
};
//# sourceMappingURL=mirador.es.js.map
